import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  bigint: { input: any; output: any; }
  bpchar: { input: any; output: any; }
  date: { input: any; output: any; }
  float8: { input: any; output: any; }
  geography: { input: any; output: any; }
  geometry: { input: any; output: any; }
  hub_Date: { input: any; output: any; }
  hub_DateTime: { input: any; output: any; }
  hub_DateTimeTz: { input: any; output: any; }
  hub_DateTimeUtc: { input: any; output: any; }
  hub_Mixed: { input: any; output: any; }
  json: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  name: { input: any; output: any; }
  numeric: { input: any; output: any; }
  smallint: { input: any; output: any; }
  timestamp: { input: any; output: any; }
  timestamptz: { input: any; output: any; }
  uuid: { input: any; output: any; }
};

export enum AcceptRejectEnum {
  Accepted = 'Accepted',
  Rejected = 'Rejected'
}

export type Account = {
  __typename?: 'Account';
  accountId?: Maybe<Scalars['String']['output']>;
  accountName?: Maybe<Scalars['String']['output']>;
  accountType?: Maybe<Scalars['String']['output']>;
  clientAccess?: Maybe<Scalars['JSON']['output']>;
  features?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AccountUserMessagesOnProspectInput = {
  channelId: Scalars['Int']['input'];
  message: Scalars['String']['input'];
  prospectId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type AccountsWiseCampaignSummaryResponse = {
  __typename?: 'AccountsWiseCampaignSummaryResponse';
  channel?: Maybe<Scalars['String']['output']>;
  message_count: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type ApplyForContentCreatorRoleInput = {
  account_name: Scalars['String']['input'];
  channelLinks?: InputMaybe<Array<InputMaybe<ChannelLinksInput>>>;
  contentLanguagesList?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  fb_link?: InputMaybe<Scalars['String']['input']>;
  ig_link?: InputMaybe<Scalars['String']['input']>;
  intro?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone_number: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  yt_link?: InputMaybe<Scalars['String']['input']>;
};

export type AssetInput = {
  url?: InputMaybe<Scalars['String']['input']>;
};

export type BasicReelAnalyticsOutput = {
  __typename?: 'BasicReelAnalyticsOutput';
  comments: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  likes: Scalars['Int']['output'];
  locationWiseViews: DataTable;
  reelId: Scalars['Int']['output'];
  shares: Scalars['Int']['output'];
  stats?: Maybe<ReelStats>;
  thumbnailUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  views: Scalars['Int']['output'];
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type CrmItem = {
  __typename?: 'CRMItem';
  data?: Maybe<Scalars['String']['output']>;
  farmerAccountId?: Maybe<Scalars['String']['output']>;
  farmerId?: Maybe<Scalars['String']['output']>;
  farmerName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lat?: Maybe<Scalars['String']['output']>;
  lng?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type CrmItemWithData = {
  __typename?: 'CRMItemWithData';
  data?: Maybe<Scalars['JSON']['output']>;
  farmerAccountId?: Maybe<Scalars['String']['output']>;
  farmerId?: Maybe<Scalars['String']['output']>;
  farmerName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lat?: Maybe<Scalars['String']['output']>;
  lng?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type CrmItemWithDataPaginatedResponse = {
  __typename?: 'CRMItemWithDataPaginatedResponse';
  currentPage: Scalars['Int']['output'];
  items?: Maybe<Array<Maybe<CrmItemWithData>>>;
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type CrmSegment = {
  __typename?: 'CRMSegment';
  crmType: Scalars['String']['output'];
  filterData?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CampaignWiseSummaryResponse = {
  __typename?: 'CampaignWiseSummaryResponse';
  channel?: Maybe<Scalars['String']['output']>;
  message_count: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type Category = {
  __typename?: 'Category';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  sortOrder: Scalars['Int']['output'];
};

export type Channel = {
  __typename?: 'Channel';
  account_id: Scalars['String']['output'];
  banner_image_url?: Maybe<Scalars['String']['output']>;
  company_id: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  followers_count: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  logo_image_url?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type ChannelLinksInput = {
  follower_count?: InputMaybe<Scalars['Int']['input']>;
  link_url: Scalars['String']['input'];
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  /** The content of the chat message */
  content?: Maybe<Scalars['String']['output']>;
  /** The datetime when the message was created */
  createdAt: Scalars['DateTime']['output'];
  /** The data of the chat message */
  data?: Maybe<Scalars['JSON']['output']>;
  /** The ID of the chat message */
  id: Scalars['String']['output'];
  /** The type of the chat message */
  messageType: Scalars['String']['output'];
  /** Whether the chat message is pinned to HEADER or FOOTER or none */
  pinStatus?: Maybe<Scalars['String']['output']>;
  /** The reactions to the chat message */
  reactions?: Maybe<Array<Maybe<ChatReaction>>>;
  /** The read receipts for the chat message */
  readReceipts?: Maybe<Array<Maybe<ChatReadReceipt>>>;
  /** The user who sent the chat message */
  sender?: Maybe<User>;
  /** The chat thread the message belongs to */
  thread: ChatThread;
};

export type ChatParticipant = {
  __typename?: 'ChatParticipant';
  id: Scalars['String']['output'];
  /** Get the last active timestamp of the participant */
  lastActiveAt?: Maybe<Scalars['DateTime']['output']>;
  /** Get the last read timestamp of the participant */
  lastReadAt?: Maybe<Scalars['DateTime']['output']>;
  /** Check if the participant has muted the thread */
  muted: Scalars['Boolean']['output'];
  user?: Maybe<User>;
};

export type ChatReaction = {
  __typename?: 'ChatReaction';
  /** The ID of the chat reaction */
  id: Scalars['Int']['output'];
  reaction: Scalars['String']['output'];
};

export type ChatReadReceipt = {
  __typename?: 'ChatReadReceipt';
  /** The ID of the chat read receipt */
  id: Scalars['Int']['output'];
  readAt: Scalars['DateTime']['output'];
};

export type ChatThread = {
  __typename?: 'ChatThread';
  /** Whether the chat thread is archived */
  archived: Scalars['Boolean']['output'];
  /** The ID of the chat thread */
  id: Scalars['String']['output'];
  /** The last message in the chat thread */
  lastMessage?: Maybe<ChatMessage>;
  /** The messages in the chat thread */
  messages?: Maybe<Array<Maybe<ChatMessage>>>;
  /** Whether the chat thread is muted */
  muted: Scalars['Boolean']['output'];
  /** The participants in the chat thread */
  participants?: Maybe<Array<Maybe<ChatParticipant>>>;
  threadableType: Scalars['String']['output'];
  /** The title of the chat thread */
  title?: Maybe<Scalars['String']['output']>;
  /** The unread count for the chat thread */
  unreadCount: Scalars['Int']['output'];
};

export type CommandOutputDataWithValues = DefaultCommandOutputDataInterface & {
  __typename?: 'CommandOutputDataWithValues';
  status: Scalars['String']['output'];
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CompanyAcceptsOrRejectsWorkorderRequestRequestInput = {
  action: AcceptRejectEnum;
  woId: Scalars['String']['input'];
  woRequestId: Scalars['String']['input'];
};

export type CompanyAssignsFoRequestInput = {
  farmerPhone?: InputMaybe<Scalars['String']['input']>;
  prospectId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userMarketId?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanySendsConnectionRequestInput = {
  farmerPhone?: InputMaybe<Scalars['String']['input']>;
  prospectId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type CompanyWorkorderFeedbackRequestInput = {
  farminstaRating?: InputMaybe<Scalars['Float']['input']>;
  farminstaRating1?: InputMaybe<Scalars['Float']['input']>;
  farminstaRating2?: InputMaybe<Scalars['Float']['input']>;
  farminstaReview?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Float']['input']>;
  rating1?: InputMaybe<Scalars['Float']['input']>;
  rating2?: InputMaybe<Scalars['Float']['input']>;
  review?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  workorderId: Scalars['String']['input'];
};

export type CreateCrmSegmentRequestInput = {
  crmType: Scalars['String']['input'];
  filterData: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateGigFaqInput = {
  answer: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

export type CreateGigInput = {
  cost: Scalars['String']['input'];
  description: Scalars['String']['input'];
  districtId?: InputMaybe<Scalars['Int']['input']>;
  duration: Scalars['String']['input'];
  faqs?: InputMaybe<Array<InputMaybe<CreateGigFaqInput>>>;
  gigId?: InputMaybe<Scalars['String']['input']>;
  promos?: InputMaybe<Array<InputMaybe<CreateGigPromoInput>>>;
  title: Scalars['String']['input'];
  variantId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateGigPromoInput = {
  media_duration: Scalars['Int']['input'];
  media_thumbnail: Scalars['String']['input'];
  media_url: Scalars['String']['input'];
  mime_type: Scalars['String']['input'];
};

export type CreateMessageCampaignRequestInput = {
  customRecipients?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  scheduledAt: Scalars['DateTime']['input'];
  segmentIds: Array<Scalars['String']['input']>;
  templateData: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
};

export type CreateProductPopInput = {
  account_id?: InputMaybe<Scalars['String']['input']>;
  company_id?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  crop_id?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image_url?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  item_code?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Array<InputMaybe<ProductPopMediaInput>>>;
  pop_content?: InputMaybe<Scalars['String']['input']>;
  pop_url?: InputMaybe<Scalars['String']['input']>;
  product_name: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CreateServiceRequestCommandInput = {
  assets?: InputMaybe<Array<InputMaybe<AssetInput>>>;
  channel?: InputMaybe<Scalars['String']['input']>;
  created_date?: InputMaybe<Scalars['String']['input']>;
  crop: Scalars['String']['input'];
  dateOfSowing: Scalars['String']['input'];
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_source?: InputMaybe<Scalars['String']['input']>;
  farmerUserId: Scalars['String']['input'];
  isRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  requestId: Scalars['String']['input'];
};

export type CreateTrackableLinkInput = {
  goUrl: Scalars['String']['input'];
  popId?: InputMaybe<Scalars['String']['input']>;
  reelId: Scalars['Int']['input'];
  type: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type CreateWorkOrderRequestInput = {
  budget_max?: InputMaybe<Scalars['Int']['input']>;
  budget_min?: InputMaybe<Scalars['Int']['input']>;
  cost?: InputMaybe<Scalars['Float']['input']>;
  crop_id?: InputMaybe<Scalars['String']['input']>;
  crop_name?: InputMaybe<Scalars['String']['input']>;
  expected_launch?: InputMaybe<Scalars['DateTime']['input']>;
  gigId?: InputMaybe<Scalars['String']['input']>;
  gigRequests?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isOpenForInfluencers?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  no_of_influencers?: InputMaybe<Scalars['Int']['input']>;
  product_id?: InputMaybe<Scalars['Int']['input']>;
  product_name?: InputMaybe<Scalars['String']['input']>;
  stateName?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  variantId?: InputMaybe<Scalars['String']['input']>;
  variantType?: InputMaybe<Scalars['String']['input']>;
};

export type CreateWorkOrderResponse = {
  __typename?: 'CreateWorkOrderResponse';
  workOrderId: Scalars['String']['output'];
};

export type Crop = {
  __typename?: 'Crop';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type DataRow = {
  __typename?: 'DataRow';
  cells?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type DataTable = {
  __typename?: 'DataTable';
  headers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  rows?: Maybe<Array<Maybe<DataRow>>>;
};

export type DefaultCommandOutput = {
  __typename?: 'DefaultCommandOutput';
  data: DefaultCommandOutputDataInterface;
  error?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type DefaultCommandOutputData = DefaultCommandOutputDataInterface & {
  __typename?: 'DefaultCommandOutputData';
  status: Scalars['String']['output'];
};

export type DefaultCommandOutputDataInterface = {
  status: Scalars['String']['output'];
};

export type DeleteResult = {
  __typename?: 'DeleteResult';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteTestRequestsCommandInput = {
  phoneNumbers: Array<Scalars['String']['input']>;
};

export type EditInfluencerGigProfileRequestInput = {
  channelName: Scalars['String']['input'];
  costOfReel: Scalars['Float']['input'];
  costOfVideo: Scalars['Float']['input'];
  days?: InputMaybe<Scalars['Int']['input']>;
  description: Scalars['String']['input'];
  email: Scalars['String']['input'];
  fbUrl: Scalars['String']['input'];
  instaUrl: Scalars['String']['input'];
  languages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  otherUrl: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  profileImageUrl?: InputMaybe<Scalars['String']['input']>;
  reelDays: Scalars['Int']['input'];
  segments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  states?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userId: Scalars['String']['input'];
  userName: Scalars['String']['input'];
  userPhone: Scalars['String']['input'];
  videoDays: Scalars['Int']['input'];
  ytUrl: Scalars['String']['input'];
};

export type FoPlanBasedRecommendationRequestInput = {
  farmerName?: InputMaybe<Scalars['String']['input']>;
  farmerPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  foName?: InputMaybe<Scalars['String']['input']>;
  foPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  planId?: InputMaybe<Scalars['Int']['input']>;
  recommendationDataAsJSON?: InputMaybe<Scalars['String']['input']>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
  retailerPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type FarmerAcceptsConnectionRequestInput = {
  prospectId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type FarmerAcceptsVisitScheduleCommandInput = {
  farmerUserId: Scalars['String']['input'];
  fieldPartnerUserId: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
  visitScheduleId: Scalars['String']['input'];
};

export type FarmerCancelsServiceRequestCommandInput = {
  cancelRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  farmerUserId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['String']['input'];
};

export type FarmerClosesRequestCommandInput = {
  closed_at?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

export type FarmerClosesResponseCommandInput = {
  fprId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type FarmerConnectionStatusOutput = {
  __typename?: 'FarmerConnectionStatusOutput';
  connectionStatus: Scalars['String']['output'];
  farminstaId: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  prospectId: Scalars['String']['output'];
};

export type FarmerField = {
  __typename?: 'FarmerField';
  label?: Maybe<Scalars['String']['output']>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  valueType?: Maybe<Scalars['String']['output']>;
};

export type FarmerGivesFeedbackToFieldPartnerCommandInput = {
  farmerUserId: Scalars['String']['input'];
  feedback: Scalars['String']['input'];
  fieldPartnerUserId: Scalars['String']['input'];
  rating: Scalars['Int']['input'];
  requestId: Scalars['String']['input'];
};

export type FarmerLocation = {
  __typename?: 'FarmerLocation';
  districtCode: Scalars['String']['output'];
  districtName: Scalars['String']['output'];
  lat: Scalars['String']['output'];
  lng: Scalars['String']['output'];
  location?: Maybe<Scalars['String']['output']>;
  stateCode: Scalars['String']['output'];
  stateName: Scalars['String']['output'];
  talukCode: Scalars['String']['output'];
  talukName: Scalars['String']['output'];
  villageCode: Scalars['String']['output'];
  villageName: Scalars['String']['output'];
};

export type FarmerMessagesOnProspectInput = {
  channelId: Scalars['Int']['input'];
  farmerUserId: Scalars['String']['input'];
  message: Scalars['String']['input'];
  prospectId: Scalars['String']['input'];
};

export type FarmerRejectsConnectionRequestInput = {
  prospectId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type FieldPartnerCancelsAVisitCommandInput = {
  field_partner_id: Scalars['String']['input'];
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  scheduled_visit_id: Scalars['String']['input'];
};

export type FieldPartnerCloseRequestCommandInput = {
  fieldPartnerUserId: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
};

export type FieldPartnerGivesFeedbackToFarmerCommandInput = {
  farmer_id: Scalars['String']['input'];
  feedback: Scalars['String']['input'];
  field_partner_id: Scalars['String']['input'];
  id: Scalars['String']['input'];
  rating: Scalars['String']['input'];
};

export type FieldPartnerGoesOfflineInput = {
  field_partner_user_id: Scalars['String']['input'];
  phone_number?: InputMaybe<Scalars['String']['input']>;
};

export type FieldPartnerGoesOnlineInput = {
  field_partner_user_id: Scalars['String']['input'];
  phone_number?: InputMaybe<Scalars['String']['input']>;
};

export type FieldPartnerRespondsToServiceRequestCommandInput = {
  action: Scalars['String']['input'];
  fieldPartnerUserId: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
};

export type FieldPartnerSchedulesAVisitCommandInput = {
  assets?: InputMaybe<Array<InputMaybe<AssetInput>>>;
  field_partner_id: Scalars['String']['input'];
  id: Scalars['String']['input'];
  scheduled_visit_date: Scalars['String']['input'];
  scheduled_visit_id: Scalars['String']['input'];
  scheduled_visit_location: Scalars['String']['input'];
  scheduled_visit_notes: Scalars['String']['input'];
  scheduled_visit_time: Scalars['String']['input'];
};

export type FieldPartnerUpdatesHisCropsCommandInput = {
  crops?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id: Scalars['String']['input'];
};

export type FieldPartnerUpdatesHisLocationInput = {
  field_partner_user_id: Scalars['String']['input'];
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  phone_number?: InputMaybe<Scalars['String']['input']>;
};

export type FieldPartnerUpdatesHisSegmentsCommandInput = {
  id: Scalars['String']['input'];
  segments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Boolean expression to compare columns of type "Float". All fields are combined with logical 'AND'. */
export type Float_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Float']['input']>;
  _gt?: InputMaybe<Scalars['Float']['input']>;
  _gte?: InputMaybe<Scalars['Float']['input']>;
  _in?: InputMaybe<Array<Scalars['Float']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Float']['input']>;
  _lte?: InputMaybe<Scalars['Float']['input']>;
  _neq?: InputMaybe<Scalars['Float']['input']>;
  _nin?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type FormBuilder = {
  __typename?: 'FormBuilder';
  columnName?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['Int']['output']>;
  dataType?: Maybe<Scalars['String']['output']>;
  fieldSeq?: Maybe<Scalars['Int']['output']>;
  formValues?: Maybe<Array<Maybe<FormValue>>>;
  id: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  mandatory?: Maybe<Scalars['Int']['output']>;
  noOfChars?: Maybe<Scalars['Int']['output']>;
  noOfMinchars?: Maybe<Scalars['Int']['output']>;
  rules: Scalars['String']['output'];
  validationType?: Maybe<Scalars['String']['output']>;
  valueType?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
  viewConfig?: Maybe<Scalars['JSON']['output']>;
};

export type FormValue = {
  __typename?: 'FormValue';
  companyId?: Maybe<Scalars['Int']['output']>;
  dataType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type GetAccountBalanceResponse = {
  __typename?: 'GetAccountBalanceResponse';
  accountName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  transactions: DataTable;
  value: Scalars['Float']['output'];
  value_expired: Scalars['Float']['output'];
  value_expiring_tomorrow?: Maybe<Scalars['Float']['output']>;
  value_lifetime: Scalars['Float']['output'];
  value_on_hold: Scalars['Float']['output'];
};

export type GetChannelAnalyticsOutput = {
  __typename?: 'GetChannelAnalyticsOutput';
  accountId: Scalars['String']['output'];
  accountName: Scalars['String']['output'];
  channelDescription?: Maybe<Scalars['String']['output']>;
  channelId?: Maybe<Scalars['Int']['output']>;
  channelLogoImageUrl?: Maybe<Scalars['String']['output']>;
  channelName?: Maybe<Scalars['String']['output']>;
  commentsCount: Scalars['Int']['output'];
  companyId: Scalars['String']['output'];
  followerCount: Scalars['Int']['output'];
  fullyViewedCount: Scalars['Int']['output'];
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  likesCount: Scalars['Int']['output'];
  profileImageUrl: Scalars['String']['output'];
  reels: Scalars['Int']['output'];
  reelsAnalyticsOutput?: Maybe<Array<Maybe<BasicReelAnalyticsOutput>>>;
  sharesCount: Scalars['Int']['output'];
  userId: Scalars['String']['output'];
  watchTimeInMinutes: Scalars['Int']['output'];
};

export type GetChannelAnalyticsRequestInput = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};

export type GetFarmerDetailResponse = {
  __typename?: 'GetFarmerDetailResponse';
  farmerAccountId: Scalars['String']['output'];
  farmerId: Scalars['String']['output'];
  farmerLocation: FarmerLocation;
  fields?: Maybe<Array<Maybe<FarmerField>>>;
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type GetRecommendationResponse = {
  __typename?: 'GetRecommendationResponse';
  errorMessage?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<RecommendationPredictedItem>>>;
  recommendationId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type GetStateLangFromLocationQueryInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type GetStateLangQueryResponse = {
  __typename?: 'GetStateLangQueryResponse';
  lang: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type GetUserBalanceResponse = {
  __typename?: 'GetUserBalanceResponse';
  id: Scalars['String']['output'];
  transactions: DataTable;
  value: Scalars['Float']['output'];
  value_expired: Scalars['Float']['output'];
  value_lifetime: Scalars['Float']['output'];
  value_on_hold: Scalars['Float']['output'];
};

export type GlobalStatsResponse = {
  __typename?: 'GlobalStatsResponse';
  ffo_farmers: Scalars['Int']['output'];
  fo_farmers: Scalars['Int']['output'];
  influencer_farmers: Scalars['Int']['output'];
  reel_farmers: Scalars['Int']['output'];
  service_request_farmers: Scalars['Int']['output'];
  total_count: Scalars['Int']['output'];
};

export type GoLink = {
  __typename?: 'GoLink';
  fullUrl: Scalars['String']['output'];
  idAsString: Scalars['String']['output'];
};

export type InfluencerAppliesForWorkOrderInput = {
  bidPrice?: InputMaybe<Scalars['Float']['input']>;
  durationDays?: InputMaybe<Scalars['Int']['input']>;
  influencerUserId: Scalars['String']['input'];
  woId: Scalars['String']['input'];
};

export type InfluencerWorkorderFeedbackRequestInput = {
  farminstaRating?: InputMaybe<Scalars['Float']['input']>;
  farminstaRating1?: InputMaybe<Scalars['Float']['input']>;
  farminstaRating2?: InputMaybe<Scalars['Float']['input']>;
  farminstaReview?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Float']['input']>;
  rating1?: InputMaybe<Scalars['Float']['input']>;
  rating2?: InputMaybe<Scalars['Float']['input']>;
  review?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  workorderId: Scalars['String']['input'];
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type Inventory = {
  __typename?: 'Inventory';
  id: Scalars['String']['output'];
  maxStockLevel?: Maybe<Scalars['Int']['output']>;
  productId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  reorderLevel: Scalars['Int']['output'];
  reservedQuantity: Scalars['Int']['output'];
  warehouseId: Scalars['String']['output'];
};

export type InventoryDetail = {
  __typename?: 'InventoryDetail';
  availableWarehouses?: Maybe<Array<Maybe<WarehouseAvailability>>>;
  averageWarehouseUtilization: Scalars['Float']['output'];
  checkedAtCarbon: Scalars['DateTime']['output'];
  fulfillmentPercentage: Scalars['Float']['output'];
  hasShortage: Scalars['Boolean']['output'];
  lowStockWarehouses?: Maybe<Array<Maybe<WarehouseAvailability>>>;
  recentlyChecked: Scalars['Boolean']['output'];
  shortagePercentage: Scalars['Float']['output'];
  totalReservedQuantity: Scalars['Int']['output'];
  warehouseCount: Scalars['Int']['output'];
};


export type InventoryDetailRecentlyCheckedArgs = {
  minutesThreshold?: InputMaybe<Scalars['Int']['input']>;
};

export type InventoryListResponse = {
  __typename?: 'InventoryListResponse';
  averageStockLevel: Scalars['Float']['output'];
  criticalAlerts?: Maybe<Array<Maybe<LowStockAlert>>>;
  criticalAlertsCount: Scalars['Int']['output'];
  currentPageRecords: Scalars['Int']['output'];
  filtered: Scalars['Boolean']['output'];
  hasFiltersApplied: Scalars['Boolean']['output'];
  hasInventories: Scalars['Boolean']['output'];
  hasLowStockAlerts: Scalars['Boolean']['output'];
  hasMultiplePages: Scalars['Boolean']['output'];
  inventoryCount: Scalars['Int']['output'];
  lowStockAlertsCount: Scalars['Int']['output'];
  requiresAttention: Scalars['Boolean']['output'];
  stockHealthScore: Scalars['Float']['output'];
  stockHealthStatus: Scalars['String']['output'];
  totalRecords: Scalars['Int']['output'];
  urgentAlerts?: Maybe<Array<Maybe<LowStockAlert>>>;
};

export type InventoryTransferResultDto = {
  __typename?: 'InventoryTransferResultDTO';
  destinationNewQuantity: Scalars['Int']['output'];
  destinationWarehouseName?: Maybe<Scalars['String']['output']>;
  hasTransferredQuantity: Scalars['Boolean']['output'];
  productName?: Maybe<Scalars['String']['output']>;
  sourceRemainingQuantity: Scalars['Int']['output'];
  sourceWarehouseName?: Maybe<Scalars['String']['output']>;
  successful: Scalars['Boolean']['output'];
  wasSourceWarehouseEmptied: Scalars['Boolean']['output'];
};

export type KycTransaction = {
  __typename?: 'KYCTransaction';
  aadharKycName?: Maybe<Scalars['String']['output']>;
  aadharKycStatus?: Maybe<Scalars['Boolean']['output']>;
  bankKycName?: Maybe<Scalars['String']['output']>;
  bankKycStatus?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  input?: Maybe<Scalars['JSON']['output']>;
  output?: Maybe<Scalars['JSON']['output']>;
  panKycName?: Maybe<Scalars['String']['output']>;
  panKycStatus?: Maybe<Scalars['Boolean']['output']>;
  phone: Scalars['String']['output'];
};

export type LowStockAlert = {
  __typename?: 'LowStockAlert';
  hasAvailableStock: Scalars['Boolean']['output'];
  outOfStock: Scalars['Boolean']['output'];
  priorityScore: Scalars['Int']['output'];
  recommendedOrderQuantity: Scalars['Int']['output'];
  severityLevel: Scalars['String']['output'];
  shortagePercentage: Scalars['Float']['output'];
  stockLevelPercentage: Scalars['Float']['output'];
};

export type MenuStructure = {
  __typename?: 'MenuStructure';
  mainMenuItems?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  userMenuItems?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type MessagingCampaign = {
  __typename?: 'MessagingCampaign';
  campaignPublicId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  scheduledAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  templateData?: Maybe<Scalars['String']['output']>;
  templateId: Scalars['String']['output'];
};

export type MissedCallPool = {
  __typename?: 'MissedCallPool';
  id: Scalars['String']['output'];
  isReserved: Scalars['Boolean']['output'];
  linkedToPlanId?: Maybe<Scalars['Int']['output']>;
  phoneNumber: Scalars['String']['output'];
  reservedAt?: Maybe<Scalars['String']['output']>;
};

export type PandoforceUser = {
  __typename?: 'PandoforceUser';
  designation?: Maybe<Scalars['String']['output']>;
  hq?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  inputCompanyId?: Maybe<Scalars['Int']['output']>;
  marketId?: Maybe<Scalars['Int']['output']>;
  reportingUser?: Maybe<PandoforceUser>;
};

export type PfUser = {
  __typename?: 'PfUser';
  district?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  head_quarters?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  reportees?: Maybe<Array<Maybe<PfUser>>>;
  reporting_user_id?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  verified_phone_number?: Maybe<Scalars['String']['output']>;
};

export type Product = {
  __typename?: 'Product';
  accountId?: Maybe<Scalars['String']['output']>;
  compId: Scalars['Int']['output'];
  companyId?: Maybe<Scalars['String']['output']>;
  createdBy: Scalars['Int']['output'];
  createdDate: Scalars['String']['output'];
  cropId: Scalars['Int']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  fiUserId?: Maybe<Scalars['String']['output']>;
  guid: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  productId?: Maybe<Scalars['String']['output']>;
  productName: Scalars['String']['output'];
  roleId: Scalars['Int']['output'];
  shopifyLastSync?: Maybe<Scalars['String']['output']>;
  shopifyProductId?: Maybe<Scalars['String']['output']>;
  shopifyVariantId?: Maybe<Scalars['String']['output']>;
  updatedBy: Scalars['Int']['output'];
  updatedDate: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export type ProductImage = {
  __typename?: 'ProductImage';
  altText?: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
  id: Scalars['String']['output'];
  originalFilename: Scalars['String']['output'];
  productId: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type ProductPop = {
  __typename?: 'ProductPop';
  accountId: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  /** Get the crop that the product POP belongs to. */
  crop?: Maybe<Crop>;
  cropId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  itemCode?: Maybe<Scalars['String']['output']>;
  /** Get YouTube links associated with the product POP. */
  media?: Maybe<Array<Maybe<ProductPopMedia>>>;
  popContent?: Maybe<Scalars['String']['output']>;
  popUrl?: Maybe<Scalars['String']['output']>;
  productName: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  youtubeLinks?: Maybe<Array<Maybe<ProductPopMedia>>>;
};

export type ProductPopFilter = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  cropId?: InputMaybe<Scalars['ID']['input']>;
  itemCode?: InputMaybe<Scalars['String']['input']>;
  productNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
};

export type ProductPopMedia = {
  __typename?: 'ProductPopMedia';
  duration?: Maybe<Scalars['Float']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  mediaId?: Maybe<Scalars['String']['output']>;
  mediaTitle?: Maybe<Scalars['String']['output']>;
  mediaType: Scalars['String']['output'];
  /** Get the media URL (reel playback URL, YouTube URL, or uploaded URL). */
  mediaUrl?: Maybe<Scalars['String']['output']>;
  /** Get the product POP that owns the media. */
  productPop?: Maybe<ProductPop>;
  productPopId: Scalars['String']['output'];
  /** Determine if the media is a reel. */
  reel: Scalars['Boolean']['output'];
  sortOrder: Scalars['Int']['output'];
  /** Get the thumbnail URL (reel thumbnail, YouTube thumbnail, or uploaded media thumbnail). */
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** Determine if the media is an uploaded reel. */
  uploadedReel: Scalars['Boolean']['output'];
  uploadedUrl?: Maybe<Scalars['String']['output']>;
  /** Determine if the media is an uploaded video. */
  uploadedVideo: Scalars['Boolean']['output'];
  /** Determine if the media is a YouTube video. */
  youtube: Scalars['Boolean']['output'];
  youtubeUrl?: Maybe<Scalars['String']['output']>;
};

export type ProductPopMediaInput = {
  duration?: InputMaybe<Scalars['Float']['input']>;
  file_name?: InputMaybe<Scalars['String']['input']>;
  file_size?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  media_id?: InputMaybe<Scalars['ID']['input']>;
  media_title?: InputMaybe<Scalars['String']['input']>;
  media_type?: InputMaybe<Scalars['String']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  uploaded_url?: InputMaybe<Scalars['String']['input']>;
  youtube_url?: InputMaybe<Scalars['String']['input']>;
};

export type ProductPopResult = {
  __typename?: 'ProductPopResult';
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  productPop?: Maybe<ProductPop>;
  success: Scalars['Boolean']['output'];
};

export type Prospect = {
  __typename?: 'Prospect';
  id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
};

export type RecommendationPredictedItem = {
  __typename?: 'RecommendationPredictedItem';
  itemId: Scalars['String']['output'];
  metadataKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  metadataValues?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  promotionName?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  score?: Maybe<Scalars['String']['output']>;
};

export type RecommendedReelIds = {
  __typename?: 'RecommendedReelIds';
  response: Array<Scalars['String']['output']>;
};

export type Redemption = {
  __typename?: 'Redemption';
  amount: Scalars['Float']['output'];
  createdDate: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  walletEntityId?: Maybe<Scalars['String']['output']>;
  walletEntityType?: Maybe<Scalars['String']['output']>;
};

export type ReelFilter = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  cropId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ReelStats = {
  __typename?: 'ReelStats';
  avgWatchTimeMs?: Maybe<Scalars['Int']['output']>;
  playbackCount?: Maybe<Scalars['Int']['output']>;
  reach?: Maybe<Scalars['Int']['output']>;
  totalWatchTimeMs?: Maybe<Scalars['Int']['output']>;
  viewCount?: Maybe<Scalars['Int']['output']>;
};

export type RegisterCompanyRequestInput = {
  channelName: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  spocDesignation: Scalars['String']['input'];
  spocName: Scalars['String']['input'];
};

export type RegisterFreelanceFieldOfficerRequestInput = {
  costOfGroupMeeting?: InputMaybe<Scalars['Float']['input']>;
  costOfGroupMeetingForChemicalProducts?: InputMaybe<Scalars['Float']['input']>;
  costOfGroupMeetingForSeedProducts?: InputMaybe<Scalars['Float']['input']>;
  costOfMonthlyPartTime?: InputMaybe<Scalars['Float']['input']>;
  costOfProductDemo?: InputMaybe<Scalars['Float']['input']>;
  costOfProductDemoForChemicalProducts?: InputMaybe<Scalars['Float']['input']>;
  costOfProductDemoForSeedProducts?: InputMaybe<Scalars['Float']['input']>;
  costOfSalesCommission?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  districts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  experience_since: Scalars['Int']['input'];
  expertises?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  languages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  profileImageUrl?: InputMaybe<Scalars['String']['input']>;
  segments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  states?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  townName?: InputMaybe<Scalars['String']['input']>;
  travel_range: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
  userName?: InputMaybe<Scalars['String']['input']>;
  userPhone?: InputMaybe<Scalars['String']['input']>;
  villageName?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterInfluencerRequestInput = {
  channelName: Scalars['String']['input'];
  costOfReel: Scalars['Float']['input'];
  costOfVideo: Scalars['Float']['input'];
  days?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  fbUrl: Scalars['String']['input'];
  instaUrl: Scalars['String']['input'];
  languages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  otherUrl: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  profileImageUrl?: InputMaybe<Scalars['String']['input']>;
  reelDays?: InputMaybe<Scalars['Int']['input']>;
  segments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  states?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userId: Scalars['String']['input'];
  userName: Scalars['String']['input'];
  userPhone: Scalars['String']['input'];
  videoDays?: InputMaybe<Scalars['Int']['input']>;
  ytUrl: Scalars['String']['input'];
};

export type RequestOtpCommandInput = {
  countryCode: Scalars['String']['input'];
  hashKey: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type RequestOtpOutput = {
  __typename?: 'RequestOTPOutput';
  encrypted: Scalars['String']['output'];
  exists?: Maybe<Scalars['Boolean']['output']>;
  nonce: Scalars['String']['output'];
  otp: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type RetailerRegistrationCommandInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  gst?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  pincode?: InputMaybe<Scalars['String']['input']>;
  profileImageUrl?: InputMaybe<Scalars['String']['input']>;
  shopName?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type RetailerRegistrationResponse = {
  __typename?: 'RetailerRegistrationResponse';
  userId?: Maybe<Scalars['String']['output']>;
};

export type Sale = {
  __typename?: 'Sale';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  farmerId?: Maybe<Scalars['String']['output']>;
  fieldPartnerUserId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  retailerUserId?: Maybe<Scalars['String']['output']>;
  saleDate?: Maybe<Scalars['String']['output']>;
  serviceRequestRecommendationsId?: Maybe<Scalars['String']['output']>;
  shopifyOrderId?: Maybe<Scalars['String']['output']>;
  shopifyOrderNumber?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  totalAmount?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  verifiedAt?: Maybe<Scalars['String']['output']>;
  verifiedBy?: Maybe<Scalars['String']['output']>;
};

export type SaleProduct = {
  __typename?: 'SaleProduct';
  basePrice: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  sku: Scalars['String']['output'];
  status: Scalars['String']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
};

export type SaveReelCommandInput = {
  reelId: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
  watchDurationMs?: InputMaybe<Scalars['Int']['input']>;
  watchDurationPercent?: InputMaybe<Scalars['Float']['input']>;
};

export type SearchFarmerRequestInput = {
  accountId: Scalars['String']['input'];
  cropName?: InputMaybe<Scalars['String']['input']>;
  districtName?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  stateName?: InputMaybe<Scalars['String']['input']>;
  talukName?: InputMaybe<Scalars['String']['input']>;
  villageName?: InputMaybe<Scalars['String']['input']>;
};

export type SearchFarmerResponse = {
  __typename?: 'SearchFarmerResponse';
  districtName?: Maybe<Scalars['String']['output']>;
  farmerAccountId?: Maybe<Scalars['String']['output']>;
  farmerId: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  stateName?: Maybe<Scalars['String']['output']>;
  talukName?: Maybe<Scalars['String']['output']>;
  villageName?: Maybe<Scalars['String']['output']>;
};

export type SendMessageOnServiceRequestCommandInput = {
  assets?: InputMaybe<Array<InputMaybe<AssetInput>>>;
  farmer_id: Scalars['String']['input'];
  field_partner_id: Scalars['String']['input'];
  message: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
  sender_user_id: Scalars['String']['input'];
};

export type SetRoleCommandInput = {
  roleName: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type SetUserLocaleCommandInput = {
  localeName: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type ShopifyUserToken = {
  __typename?: 'ShopifyUserToken';
  accessToken: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  scope?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['String']['output'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

export type UnSaveReelCommandInput = {
  reelId: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
  watchDurationMs?: InputMaybe<Scalars['Int']['input']>;
  watchDurationPercent?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateChannelDescriptionRequestInput = {
  accountUrl?: InputMaybe<Scalars['String']['input']>;
  channelBannerImageUrl?: InputMaybe<Scalars['String']['input']>;
  channelDescription?: InputMaybe<Scalars['String']['input']>;
  channelHandle?: InputMaybe<Scalars['String']['input']>;
  channelId: Scalars['Int']['input'];
  channelLinks?: InputMaybe<Array<InputMaybe<ChannelLinksInput>>>;
  channelLogoImageUrl?: InputMaybe<Scalars['String']['input']>;
  channelName?: InputMaybe<Scalars['String']['input']>;
  contentLanguagesList?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type UpdateProductPopInput = {
  created_by?: InputMaybe<Scalars['ID']['input']>;
  crop_id?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image_url?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  item_code?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Array<InputMaybe<ProductPopMediaInput>>>;
  pop_content?: InputMaybe<Scalars['String']['input']>;
  pop_url?: InputMaybe<Scalars['String']['input']>;
  product_name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  account?: Maybe<Account>;
  account_id?: Maybe<Scalars['String']['output']>;
  company_id?: Maybe<Scalars['String']['output']>;
  contentLanguages: Array<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  last_known_location?: Maybe<UserLastKnownLocation>;
  locale?: Maybe<Scalars['String']['output']>;
  market?: Maybe<PandoforceUser>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  profile_image_url?: Maybe<Scalars['String']['output']>;
  roles: Array<Scalars['String']['output']>;
};

export type UserCreatesNewReelCategoryInput = {
  categoryId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parentId: Scalars['Int']['input'];
};

export type UserCreatesReelCommandInput = {
  allow_comments?: InputMaybe<Scalars['Boolean']['input']>;
  allow_downloads?: InputMaybe<Scalars['Boolean']['input']>;
  allow_likes?: InputMaybe<Scalars['Boolean']['input']>;
  allow_reactions?: InputMaybe<Scalars['Boolean']['input']>;
  allow_reports?: InputMaybe<Scalars['Boolean']['input']>;
  allow_shares?: InputMaybe<Scalars['Boolean']['input']>;
  category_id?: InputMaybe<Scalars['Int']['input']>;
  channelId?: InputMaybe<Scalars['Int']['input']>;
  crop_id?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  districtIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  google_places_id?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  pfManagerId?: InputMaybe<Scalars['Int']['input']>;
  pfUserId?: InputMaybe<Scalars['Int']['input']>;
  restrict_geo?: InputMaybe<Scalars['Boolean']['input']>;
  scheduled_at?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['String']['input']>;
  targeted_area?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  visibility?: InputMaybe<Scalars['String']['input']>;
};

export type UserCreatesReelCommentInput = {
  comment: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['Int']['input']>;
  reelId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UserDeletesReelCommentInput = {
  commentId: Scalars['Int']['input'];
  reelId?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};

export type UserFollowsProfileCommandInput = {
  channelId?: InputMaybe<Scalars['Int']['input']>;
  followUserId?: InputMaybe<Scalars['String']['input']>;
  reelId?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
  watchDurationMs?: InputMaybe<Scalars['Int']['input']>;
};

export type UserLastKnownLocation = {
  __typename?: 'UserLastKnownLocation';
  address: Scalars['String']['output'];
  is_active: Scalars['Boolean']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  state_name: Scalars['String']['output'];
};

export type UserLikedReelInput = {
  reelId: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};

export type UserReactedReelInput = {
  reaction: Scalars['String']['input'];
  reelId: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
  watchPercent?: InputMaybe<Scalars['Int']['input']>;
  watchTimeMs?: InputMaybe<Scalars['Int']['input']>;
};

export type UserReportsCommentCommandInput = {
  commentId: Scalars['Int']['input'];
  feedback?: InputMaybe<Scalars['String']['input']>;
  reelId: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};

export type UserReportsReelCommandInput = {
  feedback?: InputMaybe<Scalars['String']['input']>;
  reelId: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};

export type UserRequestsAccountDeletionCommandInput = {
  feedback?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type UserSharedReelInput = {
  hogPersonId?: InputMaybe<Scalars['String']['input']>;
  reelId: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
  watchPercent?: InputMaybe<Scalars['Int']['input']>;
  watchTimeMs?: InputMaybe<Scalars['Int']['input']>;
};

export type UserUnfollowsProfileCommandInput = {
  channelId?: InputMaybe<Scalars['Int']['input']>;
  followUserId?: InputMaybe<Scalars['String']['input']>;
  reelId?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
  watchDurationMs?: InputMaybe<Scalars['Int']['input']>;
};

export type UserUnreactedReelInput = {
  reaction: Scalars['String']['input'];
  reelId: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
  watchPercent?: InputMaybe<Scalars['Int']['input']>;
  watchTimeMs?: InputMaybe<Scalars['Int']['input']>;
};

export type UserUpdatesContentLanguagesInput = {
  contentLanguages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userId: Scalars['String']['input'];
};

export type UserUpdatesHisDeviceInfoInput = {
  appBuildNumber?: InputMaybe<Scalars['String']['input']>;
  appVersion?: InputMaybe<Scalars['String']['input']>;
  deviceBrand?: InputMaybe<Scalars['String']['input']>;
  deviceInstallationId: Scalars['String']['input'];
  deviceManufacturer?: InputMaybe<Scalars['String']['input']>;
  deviceModel?: InputMaybe<Scalars['String']['input']>;
  deviceName?: InputMaybe<Scalars['String']['input']>;
  deviceOs?: InputMaybe<Scalars['String']['input']>;
  deviceOsVersion?: InputMaybe<Scalars['String']['input']>;
  deviceToken?: InputMaybe<Scalars['String']['input']>;
  deviceType?: InputMaybe<Scalars['String']['input']>;
  installReferrer?: InputMaybe<Scalars['String']['input']>;
  nativePushToken?: InputMaybe<Scalars['String']['input']>;
  releaseChannel?: InputMaybe<Scalars['String']['input']>;
  runtimeVersion?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type UserUpdatesHisProfileCommandInput = {
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profileImageUrl?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type UserViewedReelInput = {
  reelId: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
  watchPercent?: InputMaybe<Scalars['Int']['input']>;
  watchTimeMs?: InputMaybe<Scalars['Int']['input']>;
};

export type ValidationError = {
  __typename?: 'ValidationError';
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type VerifyOtpCommandInput = {
  checkPandoforce?: InputMaybe<Scalars['Boolean']['input']>;
  encrypted: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  nonce: Scalars['String']['input'];
  otp: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  roleName: Scalars['String']['input'];
};

export type VerifyOtpOutput = {
  __typename?: 'VerifyOTPOutput';
  envName?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Array<Scalars['String']['output']>>;
  hubToken?: Maybe<Scalars['String']['output']>;
  hubUrl?: Maybe<Scalars['String']['output']>;
  is_verified: Scalars['Boolean']['output'];
  pfUserJSON?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type Warehouse = {
  __typename?: 'Warehouse';
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  id: Scalars['String']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  pincode: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type WarehouseAvailability = {
  __typename?: 'WarehouseAvailability';
  hasStock: Scalars['Boolean']['output'];
  needsReorder: Scalars['Boolean']['output'];
  utilizationPercentage: Scalars['Float']['output'];
};

export type WarehouseUser = {
  __typename?: 'WarehouseUser';
  assignedAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  role: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  warehouseId: Scalars['String']['output'];
};

export type WorkOrder = {
  __typename?: 'WorkOrder';
  accountId?: Maybe<Scalars['String']['output']>;
  budgetMax?: Maybe<Scalars['Int']['output']>;
  budgetMin?: Maybe<Scalars['Int']['output']>;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  crops?: Maybe<Scalars['JSON']['output']>;
  ctaId?: Maybe<Scalars['String']['output']>;
  ctaLink?: Maybe<Scalars['String']['output']>;
  ctaType?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expectedDate?: Maybe<Scalars['DateTime']['output']>;
  farminstaCostInr?: Maybe<Scalars['Float']['output']>;
  gigId?: Maybe<Scalars['String']['output']>;
  gigType: Scalars['String']['output'];
  gigVariantId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  influencerCostInr?: Maybe<Scalars['Float']['output']>;
  influencerUserId?: Maybe<Scalars['String']['output']>;
  isOpenToNewInfluencers?: Maybe<Scalars['Boolean']['output']>;
  languages?: Maybe<Scalars['JSON']['output']>;
  noOfInfluencers?: Maybe<Scalars['Int']['output']>;
  paymentStatus?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Product>;
  productName?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  requestsCount?: Maybe<Scalars['Int']['output']>;
  states?: Maybe<Scalars['JSON']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  totalCostInr?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
  variantType?: Maybe<Scalars['String']['output']>;
  workOrderPublicId?: Maybe<Scalars['String']['output']>;
  workOrderStage?: Maybe<Scalars['String']['output']>;
};

export type WorkorderClosureOutputInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

/** columns and relationships of "account_auth_key" */
export type Account_Auth_Key = {
  __typename?: 'account_auth_key';
  account_id: Scalars['String']['output'];
  auth_token: Scalars['String']['output'];
  company_id: Scalars['String']['output'];
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['bigint']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id: Scalars['String']['output'];
};

/** aggregated selection of "account_auth_key" */
export type Account_Auth_Key_Aggregate = {
  __typename?: 'account_auth_key_aggregate';
  aggregate?: Maybe<Account_Auth_Key_Aggregate_Fields>;
  nodes: Array<Account_Auth_Key>;
};

/** aggregate fields of "account_auth_key" */
export type Account_Auth_Key_Aggregate_Fields = {
  __typename?: 'account_auth_key_aggregate_fields';
  avg?: Maybe<Account_Auth_Key_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Account_Auth_Key_Max_Fields>;
  min?: Maybe<Account_Auth_Key_Min_Fields>;
  stddev?: Maybe<Account_Auth_Key_Stddev_Fields>;
  stddev_pop?: Maybe<Account_Auth_Key_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Account_Auth_Key_Stddev_Samp_Fields>;
  sum?: Maybe<Account_Auth_Key_Sum_Fields>;
  var_pop?: Maybe<Account_Auth_Key_Var_Pop_Fields>;
  var_samp?: Maybe<Account_Auth_Key_Var_Samp_Fields>;
  variance?: Maybe<Account_Auth_Key_Variance_Fields>;
};


/** aggregate fields of "account_auth_key" */
export type Account_Auth_Key_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Account_Auth_Key_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Account_Auth_Key_Avg_Fields = {
  __typename?: 'account_auth_key_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "account_auth_key". All fields are combined with a logical 'AND'. */
export type Account_Auth_Key_Bool_Exp = {
  _and?: InputMaybe<Array<Account_Auth_Key_Bool_Exp>>;
  _not?: InputMaybe<Account_Auth_Key_Bool_Exp>;
  _or?: InputMaybe<Array<Account_Auth_Key_Bool_Exp>>;
  account_id?: InputMaybe<String_Comparison_Exp>;
  auth_token?: InputMaybe<String_Comparison_Exp>;
  company_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "account_auth_key" */
export enum Account_Auth_Key_Constraint {
  /** unique or primary key constraint on columns "id" */
  AccountAuthKeyPkey = 'account_auth_key_pkey'
}

/** input type for incrementing numeric columns in table "account_auth_key" */
export type Account_Auth_Key_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "account_auth_key" */
export type Account_Auth_Key_Insert_Input = {
  account_id?: InputMaybe<Scalars['String']['input']>;
  auth_token?: InputMaybe<Scalars['String']['input']>;
  company_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Account_Auth_Key_Max_Fields = {
  __typename?: 'account_auth_key_max_fields';
  account_id?: Maybe<Scalars['String']['output']>;
  auth_token?: Maybe<Scalars['String']['output']>;
  company_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Account_Auth_Key_Min_Fields = {
  __typename?: 'account_auth_key_min_fields';
  account_id?: Maybe<Scalars['String']['output']>;
  auth_token?: Maybe<Scalars['String']['output']>;
  company_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "account_auth_key" */
export type Account_Auth_Key_Mutation_Response = {
  __typename?: 'account_auth_key_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Account_Auth_Key>;
};

/** on_conflict condition type for table "account_auth_key" */
export type Account_Auth_Key_On_Conflict = {
  constraint: Account_Auth_Key_Constraint;
  update_columns?: Array<Account_Auth_Key_Update_Column>;
  where?: InputMaybe<Account_Auth_Key_Bool_Exp>;
};

/** Ordering options when selecting data from "account_auth_key". */
export type Account_Auth_Key_Order_By = {
  account_id?: InputMaybe<Order_By>;
  auth_token?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: account_auth_key */
export type Account_Auth_Key_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "account_auth_key" */
export enum Account_Auth_Key_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AuthToken = 'auth_token',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "account_auth_key" */
export type Account_Auth_Key_Set_Input = {
  account_id?: InputMaybe<Scalars['String']['input']>;
  auth_token?: InputMaybe<Scalars['String']['input']>;
  company_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Account_Auth_Key_Stddev_Fields = {
  __typename?: 'account_auth_key_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Account_Auth_Key_Stddev_Pop_Fields = {
  __typename?: 'account_auth_key_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Account_Auth_Key_Stddev_Samp_Fields = {
  __typename?: 'account_auth_key_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "account_auth_key" */
export type Account_Auth_Key_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Account_Auth_Key_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Account_Auth_Key_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['String']['input']>;
  auth_token?: InputMaybe<Scalars['String']['input']>;
  company_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Account_Auth_Key_Sum_Fields = {
  __typename?: 'account_auth_key_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "account_auth_key" */
export enum Account_Auth_Key_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AuthToken = 'auth_token',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Account_Auth_Key_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Account_Auth_Key_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Account_Auth_Key_Set_Input>;
  /** filter the rows which have to be updated */
  where: Account_Auth_Key_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Account_Auth_Key_Var_Pop_Fields = {
  __typename?: 'account_auth_key_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Account_Auth_Key_Var_Samp_Fields = {
  __typename?: 'account_auth_key_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Account_Auth_Key_Variance_Fields = {
  __typename?: 'account_auth_key_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "account_crop" */
export type Account_Crop = {
  __typename?: 'account_crop';
  /** An object relationship */
  account: Accounts;
  account_id: Scalars['bpchar']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crop_id: Scalars['bpchar']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['bigint']['output'];
  /** An object relationship */
  master_crop: Master_Crops;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "account_crop" */
export type Account_Crop_Aggregate = {
  __typename?: 'account_crop_aggregate';
  aggregate?: Maybe<Account_Crop_Aggregate_Fields>;
  nodes: Array<Account_Crop>;
};

export type Account_Crop_Aggregate_Bool_Exp = {
  count?: InputMaybe<Account_Crop_Aggregate_Bool_Exp_Count>;
};

export type Account_Crop_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Account_Crop_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Account_Crop_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "account_crop" */
export type Account_Crop_Aggregate_Fields = {
  __typename?: 'account_crop_aggregate_fields';
  avg?: Maybe<Account_Crop_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Account_Crop_Max_Fields>;
  min?: Maybe<Account_Crop_Min_Fields>;
  stddev?: Maybe<Account_Crop_Stddev_Fields>;
  stddev_pop?: Maybe<Account_Crop_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Account_Crop_Stddev_Samp_Fields>;
  sum?: Maybe<Account_Crop_Sum_Fields>;
  var_pop?: Maybe<Account_Crop_Var_Pop_Fields>;
  var_samp?: Maybe<Account_Crop_Var_Samp_Fields>;
  variance?: Maybe<Account_Crop_Variance_Fields>;
};


/** aggregate fields of "account_crop" */
export type Account_Crop_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Account_Crop_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "account_crop" */
export type Account_Crop_Aggregate_Order_By = {
  avg?: InputMaybe<Account_Crop_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Account_Crop_Max_Order_By>;
  min?: InputMaybe<Account_Crop_Min_Order_By>;
  stddev?: InputMaybe<Account_Crop_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Account_Crop_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Account_Crop_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Account_Crop_Sum_Order_By>;
  var_pop?: InputMaybe<Account_Crop_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Account_Crop_Var_Samp_Order_By>;
  variance?: InputMaybe<Account_Crop_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "account_crop" */
export type Account_Crop_Arr_Rel_Insert_Input = {
  data: Array<Account_Crop_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Account_Crop_On_Conflict>;
};

/** aggregate avg on columns */
export type Account_Crop_Avg_Fields = {
  __typename?: 'account_crop_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "account_crop" */
export type Account_Crop_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "account_crop". All fields are combined with a logical 'AND'. */
export type Account_Crop_Bool_Exp = {
  _and?: InputMaybe<Array<Account_Crop_Bool_Exp>>;
  _not?: InputMaybe<Account_Crop_Bool_Exp>;
  _or?: InputMaybe<Array<Account_Crop_Bool_Exp>>;
  account?: InputMaybe<Accounts_Bool_Exp>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  crop_id?: InputMaybe<Bpchar_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  master_crop?: InputMaybe<Master_Crops_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "account_crop" */
export enum Account_Crop_Constraint {
  /** unique or primary key constraint on columns "id" */
  AccountCropPkey = 'account_crop_pkey'
}

/** input type for incrementing numeric columns in table "account_crop" */
export type Account_Crop_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "account_crop" */
export type Account_Crop_Insert_Input = {
  account?: InputMaybe<Accounts_Obj_Rel_Insert_Input>;
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crop_id?: InputMaybe<Scalars['bpchar']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  master_crop?: InputMaybe<Master_Crops_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Account_Crop_Max_Fields = {
  __typename?: 'account_crop_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crop_id?: Maybe<Scalars['bpchar']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "account_crop" */
export type Account_Crop_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Account_Crop_Min_Fields = {
  __typename?: 'account_crop_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crop_id?: Maybe<Scalars['bpchar']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "account_crop" */
export type Account_Crop_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "account_crop" */
export type Account_Crop_Mutation_Response = {
  __typename?: 'account_crop_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Account_Crop>;
};

/** on_conflict condition type for table "account_crop" */
export type Account_Crop_On_Conflict = {
  constraint: Account_Crop_Constraint;
  update_columns?: Array<Account_Crop_Update_Column>;
  where?: InputMaybe<Account_Crop_Bool_Exp>;
};

/** Ordering options when selecting data from "account_crop". */
export type Account_Crop_Order_By = {
  account?: InputMaybe<Accounts_Order_By>;
  account_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  master_crop?: InputMaybe<Master_Crops_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: account_crop */
export type Account_Crop_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "account_crop" */
export enum Account_Crop_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "account_crop" */
export type Account_Crop_Set_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crop_id?: InputMaybe<Scalars['bpchar']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Account_Crop_Stddev_Fields = {
  __typename?: 'account_crop_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "account_crop" */
export type Account_Crop_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Account_Crop_Stddev_Pop_Fields = {
  __typename?: 'account_crop_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "account_crop" */
export type Account_Crop_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Account_Crop_Stddev_Samp_Fields = {
  __typename?: 'account_crop_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "account_crop" */
export type Account_Crop_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "account_crop" */
export type Account_Crop_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Account_Crop_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Account_Crop_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crop_id?: InputMaybe<Scalars['bpchar']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Account_Crop_Sum_Fields = {
  __typename?: 'account_crop_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "account_crop" */
export type Account_Crop_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "account_crop" */
export enum Account_Crop_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Account_Crop_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Account_Crop_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Account_Crop_Set_Input>;
  /** filter the rows which have to be updated */
  where: Account_Crop_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Account_Crop_Var_Pop_Fields = {
  __typename?: 'account_crop_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "account_crop" */
export type Account_Crop_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Account_Crop_Var_Samp_Fields = {
  __typename?: 'account_crop_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "account_crop" */
export type Account_Crop_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Account_Crop_Variance_Fields = {
  __typename?: 'account_crop_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "account_crop" */
export type Account_Crop_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "account_segment" */
export type Account_Segment = {
  __typename?: 'account_segment';
  /** An object relationship */
  account: Accounts;
  account_id: Scalars['bpchar']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['bigint']['output'];
  /** An object relationship */
  master_segment: Master_Segments;
  segment_id: Scalars['bpchar']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "account_segment" */
export type Account_Segment_Aggregate = {
  __typename?: 'account_segment_aggregate';
  aggregate?: Maybe<Account_Segment_Aggregate_Fields>;
  nodes: Array<Account_Segment>;
};

export type Account_Segment_Aggregate_Bool_Exp = {
  count?: InputMaybe<Account_Segment_Aggregate_Bool_Exp_Count>;
};

export type Account_Segment_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Account_Segment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Account_Segment_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "account_segment" */
export type Account_Segment_Aggregate_Fields = {
  __typename?: 'account_segment_aggregate_fields';
  avg?: Maybe<Account_Segment_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Account_Segment_Max_Fields>;
  min?: Maybe<Account_Segment_Min_Fields>;
  stddev?: Maybe<Account_Segment_Stddev_Fields>;
  stddev_pop?: Maybe<Account_Segment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Account_Segment_Stddev_Samp_Fields>;
  sum?: Maybe<Account_Segment_Sum_Fields>;
  var_pop?: Maybe<Account_Segment_Var_Pop_Fields>;
  var_samp?: Maybe<Account_Segment_Var_Samp_Fields>;
  variance?: Maybe<Account_Segment_Variance_Fields>;
};


/** aggregate fields of "account_segment" */
export type Account_Segment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Account_Segment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "account_segment" */
export type Account_Segment_Aggregate_Order_By = {
  avg?: InputMaybe<Account_Segment_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Account_Segment_Max_Order_By>;
  min?: InputMaybe<Account_Segment_Min_Order_By>;
  stddev?: InputMaybe<Account_Segment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Account_Segment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Account_Segment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Account_Segment_Sum_Order_By>;
  var_pop?: InputMaybe<Account_Segment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Account_Segment_Var_Samp_Order_By>;
  variance?: InputMaybe<Account_Segment_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "account_segment" */
export type Account_Segment_Arr_Rel_Insert_Input = {
  data: Array<Account_Segment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Account_Segment_On_Conflict>;
};

/** aggregate avg on columns */
export type Account_Segment_Avg_Fields = {
  __typename?: 'account_segment_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "account_segment" */
export type Account_Segment_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "account_segment". All fields are combined with a logical 'AND'. */
export type Account_Segment_Bool_Exp = {
  _and?: InputMaybe<Array<Account_Segment_Bool_Exp>>;
  _not?: InputMaybe<Account_Segment_Bool_Exp>;
  _or?: InputMaybe<Array<Account_Segment_Bool_Exp>>;
  account?: InputMaybe<Accounts_Bool_Exp>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  master_segment?: InputMaybe<Master_Segments_Bool_Exp>;
  segment_id?: InputMaybe<Bpchar_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "account_segment" */
export enum Account_Segment_Constraint {
  /** unique or primary key constraint on columns "id" */
  AccountSegmentPkey = 'account_segment_pkey'
}

/** input type for incrementing numeric columns in table "account_segment" */
export type Account_Segment_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "account_segment" */
export type Account_Segment_Insert_Input = {
  account?: InputMaybe<Accounts_Obj_Rel_Insert_Input>;
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  master_segment?: InputMaybe<Master_Segments_Obj_Rel_Insert_Input>;
  segment_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Account_Segment_Max_Fields = {
  __typename?: 'account_segment_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  segment_id?: Maybe<Scalars['bpchar']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "account_segment" */
export type Account_Segment_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  segment_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Account_Segment_Min_Fields = {
  __typename?: 'account_segment_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  segment_id?: Maybe<Scalars['bpchar']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "account_segment" */
export type Account_Segment_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  segment_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "account_segment" */
export type Account_Segment_Mutation_Response = {
  __typename?: 'account_segment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Account_Segment>;
};

/** on_conflict condition type for table "account_segment" */
export type Account_Segment_On_Conflict = {
  constraint: Account_Segment_Constraint;
  update_columns?: Array<Account_Segment_Update_Column>;
  where?: InputMaybe<Account_Segment_Bool_Exp>;
};

/** Ordering options when selecting data from "account_segment". */
export type Account_Segment_Order_By = {
  account?: InputMaybe<Accounts_Order_By>;
  account_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  master_segment?: InputMaybe<Master_Segments_Order_By>;
  segment_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: account_segment */
export type Account_Segment_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "account_segment" */
export enum Account_Segment_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  SegmentId = 'segment_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "account_segment" */
export type Account_Segment_Set_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  segment_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Account_Segment_Stddev_Fields = {
  __typename?: 'account_segment_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "account_segment" */
export type Account_Segment_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Account_Segment_Stddev_Pop_Fields = {
  __typename?: 'account_segment_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "account_segment" */
export type Account_Segment_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Account_Segment_Stddev_Samp_Fields = {
  __typename?: 'account_segment_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "account_segment" */
export type Account_Segment_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "account_segment" */
export type Account_Segment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Account_Segment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Account_Segment_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  segment_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Account_Segment_Sum_Fields = {
  __typename?: 'account_segment_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "account_segment" */
export type Account_Segment_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "account_segment" */
export enum Account_Segment_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  SegmentId = 'segment_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Account_Segment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Account_Segment_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Account_Segment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Account_Segment_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Account_Segment_Var_Pop_Fields = {
  __typename?: 'account_segment_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "account_segment" */
export type Account_Segment_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Account_Segment_Var_Samp_Fields = {
  __typename?: 'account_segment_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "account_segment" */
export type Account_Segment_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Account_Segment_Variance_Fields = {
  __typename?: 'account_segment_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "account_segment" */
export type Account_Segment_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "account_user" */
export type Account_User = {
  __typename?: 'account_user';
  /** An object relationship */
  account: Accounts;
  account_id: Scalars['bpchar']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['bigint']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['bpchar']['output'];
};

/** aggregated selection of "account_user" */
export type Account_User_Aggregate = {
  __typename?: 'account_user_aggregate';
  aggregate?: Maybe<Account_User_Aggregate_Fields>;
  nodes: Array<Account_User>;
};

export type Account_User_Aggregate_Bool_Exp = {
  count?: InputMaybe<Account_User_Aggregate_Bool_Exp_Count>;
};

export type Account_User_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Account_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Account_User_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "account_user" */
export type Account_User_Aggregate_Fields = {
  __typename?: 'account_user_aggregate_fields';
  avg?: Maybe<Account_User_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Account_User_Max_Fields>;
  min?: Maybe<Account_User_Min_Fields>;
  stddev?: Maybe<Account_User_Stddev_Fields>;
  stddev_pop?: Maybe<Account_User_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Account_User_Stddev_Samp_Fields>;
  sum?: Maybe<Account_User_Sum_Fields>;
  var_pop?: Maybe<Account_User_Var_Pop_Fields>;
  var_samp?: Maybe<Account_User_Var_Samp_Fields>;
  variance?: Maybe<Account_User_Variance_Fields>;
};


/** aggregate fields of "account_user" */
export type Account_User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Account_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "account_user" */
export type Account_User_Aggregate_Order_By = {
  avg?: InputMaybe<Account_User_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Account_User_Max_Order_By>;
  min?: InputMaybe<Account_User_Min_Order_By>;
  stddev?: InputMaybe<Account_User_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Account_User_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Account_User_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Account_User_Sum_Order_By>;
  var_pop?: InputMaybe<Account_User_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Account_User_Var_Samp_Order_By>;
  variance?: InputMaybe<Account_User_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "account_user" */
export type Account_User_Arr_Rel_Insert_Input = {
  data: Array<Account_User_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Account_User_On_Conflict>;
};

/** aggregate avg on columns */
export type Account_User_Avg_Fields = {
  __typename?: 'account_user_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "account_user" */
export type Account_User_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "account_user". All fields are combined with a logical 'AND'. */
export type Account_User_Bool_Exp = {
  _and?: InputMaybe<Array<Account_User_Bool_Exp>>;
  _not?: InputMaybe<Account_User_Bool_Exp>;
  _or?: InputMaybe<Array<Account_User_Bool_Exp>>;
  account?: InputMaybe<Accounts_Bool_Exp>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "account_user" */
export enum Account_User_Constraint {
  /** unique or primary key constraint on columns "user_id", "account_id" */
  AccountUserAccountIdIdx = 'account_user_account_id_idx',
  /** unique or primary key constraint on columns "id" */
  AccountUserPkey = 'account_user_pkey'
}

/** input type for incrementing numeric columns in table "account_user" */
export type Account_User_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "account_user" */
export type Account_User_Insert_Input = {
  account?: InputMaybe<Accounts_Obj_Rel_Insert_Input>;
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Account_User_Max_Fields = {
  __typename?: 'account_user_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by max() on columns of table "account_user" */
export type Account_User_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Account_User_Min_Fields = {
  __typename?: 'account_user_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by min() on columns of table "account_user" */
export type Account_User_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "account_user" */
export type Account_User_Mutation_Response = {
  __typename?: 'account_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Account_User>;
};

/** on_conflict condition type for table "account_user" */
export type Account_User_On_Conflict = {
  constraint: Account_User_Constraint;
  update_columns?: Array<Account_User_Update_Column>;
  where?: InputMaybe<Account_User_Bool_Exp>;
};

/** Ordering options when selecting data from "account_user". */
export type Account_User_Order_By = {
  account?: InputMaybe<Accounts_Order_By>;
  account_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: account_user */
export type Account_User_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "account_user" */
export enum Account_User_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "account_user" */
export type Account_User_Set_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate stddev on columns */
export type Account_User_Stddev_Fields = {
  __typename?: 'account_user_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "account_user" */
export type Account_User_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Account_User_Stddev_Pop_Fields = {
  __typename?: 'account_user_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "account_user" */
export type Account_User_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Account_User_Stddev_Samp_Fields = {
  __typename?: 'account_user_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "account_user" */
export type Account_User_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "account_user" */
export type Account_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Account_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Account_User_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate sum on columns */
export type Account_User_Sum_Fields = {
  __typename?: 'account_user_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "account_user" */
export type Account_User_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "account_user" */
export enum Account_User_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Account_User_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Account_User_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Account_User_Set_Input>;
  /** filter the rows which have to be updated */
  where: Account_User_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Account_User_Var_Pop_Fields = {
  __typename?: 'account_user_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "account_user" */
export type Account_User_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Account_User_Var_Samp_Fields = {
  __typename?: 'account_user_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "account_user" */
export type Account_User_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Account_User_Variance_Fields = {
  __typename?: 'account_user_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "account_user" */
export type Account_User_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "accounts" */
export type Accounts = {
  __typename?: 'accounts';
  /** An array relationship */
  account_crops: Array<Account_Crop>;
  /** An aggregate relationship */
  account_crops_aggregate: Account_Crop_Aggregate;
  /** An array relationship */
  account_segments: Array<Account_Segment>;
  /** An aggregate relationship */
  account_segments_aggregate: Account_Segment_Aggregate;
  account_type: Scalars['String']['output'];
  /** An array relationship */
  account_users: Array<Account_User>;
  /** An aggregate relationship */
  account_users_aggregate: Account_User_Aggregate;
  admin_user_id: Scalars['bpchar']['output'];
  /** An object relationship */
  company: Companies;
  company_id: Scalars['bpchar']['output'];
  company_verified_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  field_partner_response_events: Array<Field_Partner_Response_Events>;
  /** An aggregate relationship */
  field_partner_response_events_aggregate: Field_Partner_Response_Events_Aggregate;
  /** An array relationship */
  field_partner_response_messages: Array<Field_Partner_Response_Messages>;
  /** An aggregate relationship */
  field_partner_response_messages_aggregate: Field_Partner_Response_Messages_Aggregate;
  /** An array relationship */
  field_partner_responses: Array<Field_Partner_Responses>;
  /** An aggregate relationship */
  field_partner_responses_aggregate: Field_Partner_Responses_Aggregate;
  /** An array relationship */
  field_scheduled_visits: Array<Field_Scheduled_Visits>;
  /** An aggregate relationship */
  field_scheduled_visits_aggregate: Field_Scheduled_Visits_Aggregate;
  id: Scalars['bpchar']['output'];
  /** An array relationship */
  lastKnownLocationsByUserAccountId: Array<Last_Known_Locations>;
  /** An aggregate relationship */
  lastKnownLocationsByUserAccountId_aggregate: Last_Known_Locations_Aggregate;
  logo_image_url?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pandoforce_account_id?: Maybe<Scalars['bigint']['output']>;
  pandoforce_company_id?: Maybe<Scalars['bigint']['output']>;
  pandoforce_input_company_id?: Maybe<Scalars['bigint']['output']>;
  /** An array relationship */
  service_request_dashboards: Array<Service_Request_Dashboard>;
  /** An aggregate relationship */
  service_request_dashboards_aggregate: Service_Request_Dashboard_Aggregate;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  user: Users;
  website_url?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "accounts" */
export type AccountsAccount_CropsArgs = {
  distinct_on?: InputMaybe<Array<Account_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Crop_Order_By>>;
  where?: InputMaybe<Account_Crop_Bool_Exp>;
};


/** columns and relationships of "accounts" */
export type AccountsAccount_Crops_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Crop_Order_By>>;
  where?: InputMaybe<Account_Crop_Bool_Exp>;
};


/** columns and relationships of "accounts" */
export type AccountsAccount_SegmentsArgs = {
  distinct_on?: InputMaybe<Array<Account_Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Segment_Order_By>>;
  where?: InputMaybe<Account_Segment_Bool_Exp>;
};


/** columns and relationships of "accounts" */
export type AccountsAccount_Segments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Segment_Order_By>>;
  where?: InputMaybe<Account_Segment_Bool_Exp>;
};


/** columns and relationships of "accounts" */
export type AccountsAccount_UsersArgs = {
  distinct_on?: InputMaybe<Array<Account_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_User_Order_By>>;
  where?: InputMaybe<Account_User_Bool_Exp>;
};


/** columns and relationships of "accounts" */
export type AccountsAccount_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_User_Order_By>>;
  where?: InputMaybe<Account_User_Bool_Exp>;
};


/** columns and relationships of "accounts" */
export type AccountsField_Partner_Response_EventsArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Response_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Response_Events_Order_By>>;
  where?: InputMaybe<Field_Partner_Response_Events_Bool_Exp>;
};


/** columns and relationships of "accounts" */
export type AccountsField_Partner_Response_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Response_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Response_Events_Order_By>>;
  where?: InputMaybe<Field_Partner_Response_Events_Bool_Exp>;
};


/** columns and relationships of "accounts" */
export type AccountsField_Partner_Response_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Response_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Response_Messages_Order_By>>;
  where?: InputMaybe<Field_Partner_Response_Messages_Bool_Exp>;
};


/** columns and relationships of "accounts" */
export type AccountsField_Partner_Response_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Response_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Response_Messages_Order_By>>;
  where?: InputMaybe<Field_Partner_Response_Messages_Bool_Exp>;
};


/** columns and relationships of "accounts" */
export type AccountsField_Partner_ResponsesArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Responses_Order_By>>;
  where?: InputMaybe<Field_Partner_Responses_Bool_Exp>;
};


/** columns and relationships of "accounts" */
export type AccountsField_Partner_Responses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Responses_Order_By>>;
  where?: InputMaybe<Field_Partner_Responses_Bool_Exp>;
};


/** columns and relationships of "accounts" */
export type AccountsField_Scheduled_VisitsArgs = {
  distinct_on?: InputMaybe<Array<Field_Scheduled_Visits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Scheduled_Visits_Order_By>>;
  where?: InputMaybe<Field_Scheduled_Visits_Bool_Exp>;
};


/** columns and relationships of "accounts" */
export type AccountsField_Scheduled_Visits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Scheduled_Visits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Scheduled_Visits_Order_By>>;
  where?: InputMaybe<Field_Scheduled_Visits_Bool_Exp>;
};


/** columns and relationships of "accounts" */
export type AccountsLastKnownLocationsByUserAccountIdArgs = {
  distinct_on?: InputMaybe<Array<Last_Known_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Last_Known_Locations_Order_By>>;
  where?: InputMaybe<Last_Known_Locations_Bool_Exp>;
};


/** columns and relationships of "accounts" */
export type AccountsLastKnownLocationsByUserAccountId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Last_Known_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Last_Known_Locations_Order_By>>;
  where?: InputMaybe<Last_Known_Locations_Bool_Exp>;
};


/** columns and relationships of "accounts" */
export type AccountsService_Request_DashboardsArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Dashboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Dashboard_Order_By>>;
  where?: InputMaybe<Service_Request_Dashboard_Bool_Exp>;
};


/** columns and relationships of "accounts" */
export type AccountsService_Request_Dashboards_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Dashboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Dashboard_Order_By>>;
  where?: InputMaybe<Service_Request_Dashboard_Bool_Exp>;
};

/** aggregated selection of "accounts" */
export type Accounts_Aggregate = {
  __typename?: 'accounts_aggregate';
  aggregate?: Maybe<Accounts_Aggregate_Fields>;
  nodes: Array<Accounts>;
};

export type Accounts_Aggregate_Bool_Exp = {
  count?: InputMaybe<Accounts_Aggregate_Bool_Exp_Count>;
};

export type Accounts_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Accounts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Accounts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "accounts" */
export type Accounts_Aggregate_Fields = {
  __typename?: 'accounts_aggregate_fields';
  avg?: Maybe<Accounts_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Accounts_Max_Fields>;
  min?: Maybe<Accounts_Min_Fields>;
  stddev?: Maybe<Accounts_Stddev_Fields>;
  stddev_pop?: Maybe<Accounts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Accounts_Stddev_Samp_Fields>;
  sum?: Maybe<Accounts_Sum_Fields>;
  var_pop?: Maybe<Accounts_Var_Pop_Fields>;
  var_samp?: Maybe<Accounts_Var_Samp_Fields>;
  variance?: Maybe<Accounts_Variance_Fields>;
};


/** aggregate fields of "accounts" */
export type Accounts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Accounts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "accounts" */
export type Accounts_Aggregate_Order_By = {
  avg?: InputMaybe<Accounts_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Accounts_Max_Order_By>;
  min?: InputMaybe<Accounts_Min_Order_By>;
  stddev?: InputMaybe<Accounts_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Accounts_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Accounts_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Accounts_Sum_Order_By>;
  var_pop?: InputMaybe<Accounts_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Accounts_Var_Samp_Order_By>;
  variance?: InputMaybe<Accounts_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "accounts" */
export type Accounts_Arr_Rel_Insert_Input = {
  data: Array<Accounts_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Accounts_On_Conflict>;
};

/** aggregate avg on columns */
export type Accounts_Avg_Fields = {
  __typename?: 'accounts_avg_fields';
  pandoforce_account_id?: Maybe<Scalars['Float']['output']>;
  pandoforce_company_id?: Maybe<Scalars['Float']['output']>;
  pandoforce_input_company_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "accounts" */
export type Accounts_Avg_Order_By = {
  pandoforce_account_id?: InputMaybe<Order_By>;
  pandoforce_company_id?: InputMaybe<Order_By>;
  pandoforce_input_company_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "accounts". All fields are combined with a logical 'AND'. */
export type Accounts_Bool_Exp = {
  _and?: InputMaybe<Array<Accounts_Bool_Exp>>;
  _not?: InputMaybe<Accounts_Bool_Exp>;
  _or?: InputMaybe<Array<Accounts_Bool_Exp>>;
  account_crops?: InputMaybe<Account_Crop_Bool_Exp>;
  account_crops_aggregate?: InputMaybe<Account_Crop_Aggregate_Bool_Exp>;
  account_segments?: InputMaybe<Account_Segment_Bool_Exp>;
  account_segments_aggregate?: InputMaybe<Account_Segment_Aggregate_Bool_Exp>;
  account_type?: InputMaybe<String_Comparison_Exp>;
  account_users?: InputMaybe<Account_User_Bool_Exp>;
  account_users_aggregate?: InputMaybe<Account_User_Aggregate_Bool_Exp>;
  admin_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  company?: InputMaybe<Companies_Bool_Exp>;
  company_id?: InputMaybe<Bpchar_Comparison_Exp>;
  company_verified_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  field_partner_response_events?: InputMaybe<Field_Partner_Response_Events_Bool_Exp>;
  field_partner_response_events_aggregate?: InputMaybe<Field_Partner_Response_Events_Aggregate_Bool_Exp>;
  field_partner_response_messages?: InputMaybe<Field_Partner_Response_Messages_Bool_Exp>;
  field_partner_response_messages_aggregate?: InputMaybe<Field_Partner_Response_Messages_Aggregate_Bool_Exp>;
  field_partner_responses?: InputMaybe<Field_Partner_Responses_Bool_Exp>;
  field_partner_responses_aggregate?: InputMaybe<Field_Partner_Responses_Aggregate_Bool_Exp>;
  field_scheduled_visits?: InputMaybe<Field_Scheduled_Visits_Bool_Exp>;
  field_scheduled_visits_aggregate?: InputMaybe<Field_Scheduled_Visits_Aggregate_Bool_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  lastKnownLocationsByUserAccountId?: InputMaybe<Last_Known_Locations_Bool_Exp>;
  lastKnownLocationsByUserAccountId_aggregate?: InputMaybe<Last_Known_Locations_Aggregate_Bool_Exp>;
  logo_image_url?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  pandoforce_account_id?: InputMaybe<Bigint_Comparison_Exp>;
  pandoforce_company_id?: InputMaybe<Bigint_Comparison_Exp>;
  pandoforce_input_company_id?: InputMaybe<Bigint_Comparison_Exp>;
  service_request_dashboards?: InputMaybe<Service_Request_Dashboard_Bool_Exp>;
  service_request_dashboards_aggregate?: InputMaybe<Service_Request_Dashboard_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  website_url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "accounts" */
export enum Accounts_Constraint {
  /** unique or primary key constraint on columns "id" */
  AccountsPkey = 'accounts_pkey'
}

/** input type for incrementing numeric columns in table "accounts" */
export type Accounts_Inc_Input = {
  pandoforce_account_id?: InputMaybe<Scalars['bigint']['input']>;
  pandoforce_company_id?: InputMaybe<Scalars['bigint']['input']>;
  pandoforce_input_company_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "accounts" */
export type Accounts_Insert_Input = {
  account_crops?: InputMaybe<Account_Crop_Arr_Rel_Insert_Input>;
  account_segments?: InputMaybe<Account_Segment_Arr_Rel_Insert_Input>;
  account_type?: InputMaybe<Scalars['String']['input']>;
  account_users?: InputMaybe<Account_User_Arr_Rel_Insert_Input>;
  admin_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  company?: InputMaybe<Companies_Obj_Rel_Insert_Input>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  company_verified_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  field_partner_response_events?: InputMaybe<Field_Partner_Response_Events_Arr_Rel_Insert_Input>;
  field_partner_response_messages?: InputMaybe<Field_Partner_Response_Messages_Arr_Rel_Insert_Input>;
  field_partner_responses?: InputMaybe<Field_Partner_Responses_Arr_Rel_Insert_Input>;
  field_scheduled_visits?: InputMaybe<Field_Scheduled_Visits_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  lastKnownLocationsByUserAccountId?: InputMaybe<Last_Known_Locations_Arr_Rel_Insert_Input>;
  logo_image_url?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pandoforce_account_id?: InputMaybe<Scalars['bigint']['input']>;
  pandoforce_company_id?: InputMaybe<Scalars['bigint']['input']>;
  pandoforce_input_company_id?: InputMaybe<Scalars['bigint']['input']>;
  service_request_dashboards?: InputMaybe<Service_Request_Dashboard_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  website_url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Accounts_Max_Fields = {
  __typename?: 'accounts_max_fields';
  account_type?: Maybe<Scalars['String']['output']>;
  admin_user_id?: Maybe<Scalars['bpchar']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  company_verified_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  logo_image_url?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pandoforce_account_id?: Maybe<Scalars['bigint']['output']>;
  pandoforce_company_id?: Maybe<Scalars['bigint']['output']>;
  pandoforce_input_company_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  website_url?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "accounts" */
export type Accounts_Max_Order_By = {
  account_type?: InputMaybe<Order_By>;
  admin_user_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  company_verified_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logo_image_url?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  pandoforce_account_id?: InputMaybe<Order_By>;
  pandoforce_company_id?: InputMaybe<Order_By>;
  pandoforce_input_company_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  website_url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Accounts_Min_Fields = {
  __typename?: 'accounts_min_fields';
  account_type?: Maybe<Scalars['String']['output']>;
  admin_user_id?: Maybe<Scalars['bpchar']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  company_verified_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  logo_image_url?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pandoforce_account_id?: Maybe<Scalars['bigint']['output']>;
  pandoforce_company_id?: Maybe<Scalars['bigint']['output']>;
  pandoforce_input_company_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  website_url?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "accounts" */
export type Accounts_Min_Order_By = {
  account_type?: InputMaybe<Order_By>;
  admin_user_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  company_verified_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logo_image_url?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  pandoforce_account_id?: InputMaybe<Order_By>;
  pandoforce_company_id?: InputMaybe<Order_By>;
  pandoforce_input_company_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  website_url?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "accounts" */
export type Accounts_Mutation_Response = {
  __typename?: 'accounts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Accounts>;
};

/** input type for inserting object relation for remote table "accounts" */
export type Accounts_Obj_Rel_Insert_Input = {
  data: Accounts_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Accounts_On_Conflict>;
};

/** on_conflict condition type for table "accounts" */
export type Accounts_On_Conflict = {
  constraint: Accounts_Constraint;
  update_columns?: Array<Accounts_Update_Column>;
  where?: InputMaybe<Accounts_Bool_Exp>;
};

/** Ordering options when selecting data from "accounts". */
export type Accounts_Order_By = {
  account_crops_aggregate?: InputMaybe<Account_Crop_Aggregate_Order_By>;
  account_segments_aggregate?: InputMaybe<Account_Segment_Aggregate_Order_By>;
  account_type?: InputMaybe<Order_By>;
  account_users_aggregate?: InputMaybe<Account_User_Aggregate_Order_By>;
  admin_user_id?: InputMaybe<Order_By>;
  company?: InputMaybe<Companies_Order_By>;
  company_id?: InputMaybe<Order_By>;
  company_verified_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  field_partner_response_events_aggregate?: InputMaybe<Field_Partner_Response_Events_Aggregate_Order_By>;
  field_partner_response_messages_aggregate?: InputMaybe<Field_Partner_Response_Messages_Aggregate_Order_By>;
  field_partner_responses_aggregate?: InputMaybe<Field_Partner_Responses_Aggregate_Order_By>;
  field_scheduled_visits_aggregate?: InputMaybe<Field_Scheduled_Visits_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  lastKnownLocationsByUserAccountId_aggregate?: InputMaybe<Last_Known_Locations_Aggregate_Order_By>;
  logo_image_url?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  pandoforce_account_id?: InputMaybe<Order_By>;
  pandoforce_company_id?: InputMaybe<Order_By>;
  pandoforce_input_company_id?: InputMaybe<Order_By>;
  service_request_dashboards_aggregate?: InputMaybe<Service_Request_Dashboard_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  website_url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: accounts */
export type Accounts_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** select columns of table "accounts" */
export enum Accounts_Select_Column {
  /** column name */
  AccountType = 'account_type',
  /** column name */
  AdminUserId = 'admin_user_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CompanyVerifiedAt = 'company_verified_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  LogoImageUrl = 'logo_image_url',
  /** column name */
  Name = 'name',
  /** column name */
  PandoforceAccountId = 'pandoforce_account_id',
  /** column name */
  PandoforceCompanyId = 'pandoforce_company_id',
  /** column name */
  PandoforceInputCompanyId = 'pandoforce_input_company_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WebsiteUrl = 'website_url'
}

/** input type for updating data in table "accounts" */
export type Accounts_Set_Input = {
  account_type?: InputMaybe<Scalars['String']['input']>;
  admin_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  company_verified_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  logo_image_url?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pandoforce_account_id?: InputMaybe<Scalars['bigint']['input']>;
  pandoforce_company_id?: InputMaybe<Scalars['bigint']['input']>;
  pandoforce_input_company_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  website_url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Accounts_Stddev_Fields = {
  __typename?: 'accounts_stddev_fields';
  pandoforce_account_id?: Maybe<Scalars['Float']['output']>;
  pandoforce_company_id?: Maybe<Scalars['Float']['output']>;
  pandoforce_input_company_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "accounts" */
export type Accounts_Stddev_Order_By = {
  pandoforce_account_id?: InputMaybe<Order_By>;
  pandoforce_company_id?: InputMaybe<Order_By>;
  pandoforce_input_company_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Accounts_Stddev_Pop_Fields = {
  __typename?: 'accounts_stddev_pop_fields';
  pandoforce_account_id?: Maybe<Scalars['Float']['output']>;
  pandoforce_company_id?: Maybe<Scalars['Float']['output']>;
  pandoforce_input_company_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "accounts" */
export type Accounts_Stddev_Pop_Order_By = {
  pandoforce_account_id?: InputMaybe<Order_By>;
  pandoforce_company_id?: InputMaybe<Order_By>;
  pandoforce_input_company_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Accounts_Stddev_Samp_Fields = {
  __typename?: 'accounts_stddev_samp_fields';
  pandoforce_account_id?: Maybe<Scalars['Float']['output']>;
  pandoforce_company_id?: Maybe<Scalars['Float']['output']>;
  pandoforce_input_company_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "accounts" */
export type Accounts_Stddev_Samp_Order_By = {
  pandoforce_account_id?: InputMaybe<Order_By>;
  pandoforce_company_id?: InputMaybe<Order_By>;
  pandoforce_input_company_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "accounts" */
export type Accounts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Accounts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Accounts_Stream_Cursor_Value_Input = {
  account_type?: InputMaybe<Scalars['String']['input']>;
  admin_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  company_verified_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  logo_image_url?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pandoforce_account_id?: InputMaybe<Scalars['bigint']['input']>;
  pandoforce_company_id?: InputMaybe<Scalars['bigint']['input']>;
  pandoforce_input_company_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  website_url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Accounts_Sum_Fields = {
  __typename?: 'accounts_sum_fields';
  pandoforce_account_id?: Maybe<Scalars['bigint']['output']>;
  pandoforce_company_id?: Maybe<Scalars['bigint']['output']>;
  pandoforce_input_company_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "accounts" */
export type Accounts_Sum_Order_By = {
  pandoforce_account_id?: InputMaybe<Order_By>;
  pandoforce_company_id?: InputMaybe<Order_By>;
  pandoforce_input_company_id?: InputMaybe<Order_By>;
};

/** update columns of table "accounts" */
export enum Accounts_Update_Column {
  /** column name */
  AccountType = 'account_type',
  /** column name */
  AdminUserId = 'admin_user_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CompanyVerifiedAt = 'company_verified_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  LogoImageUrl = 'logo_image_url',
  /** column name */
  Name = 'name',
  /** column name */
  PandoforceAccountId = 'pandoforce_account_id',
  /** column name */
  PandoforceCompanyId = 'pandoforce_company_id',
  /** column name */
  PandoforceInputCompanyId = 'pandoforce_input_company_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WebsiteUrl = 'website_url'
}

export type Accounts_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Accounts_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Accounts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Accounts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Accounts_Var_Pop_Fields = {
  __typename?: 'accounts_var_pop_fields';
  pandoforce_account_id?: Maybe<Scalars['Float']['output']>;
  pandoforce_company_id?: Maybe<Scalars['Float']['output']>;
  pandoforce_input_company_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "accounts" */
export type Accounts_Var_Pop_Order_By = {
  pandoforce_account_id?: InputMaybe<Order_By>;
  pandoforce_company_id?: InputMaybe<Order_By>;
  pandoforce_input_company_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Accounts_Var_Samp_Fields = {
  __typename?: 'accounts_var_samp_fields';
  pandoforce_account_id?: Maybe<Scalars['Float']['output']>;
  pandoforce_company_id?: Maybe<Scalars['Float']['output']>;
  pandoforce_input_company_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "accounts" */
export type Accounts_Var_Samp_Order_By = {
  pandoforce_account_id?: InputMaybe<Order_By>;
  pandoforce_company_id?: InputMaybe<Order_By>;
  pandoforce_input_company_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Accounts_Variance_Fields = {
  __typename?: 'accounts_variance_fields';
  pandoforce_account_id?: Maybe<Scalars['Float']['output']>;
  pandoforce_company_id?: Maybe<Scalars['Float']['output']>;
  pandoforce_input_company_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "accounts" */
export type Accounts_Variance_Order_By = {
  pandoforce_account_id?: InputMaybe<Order_By>;
  pandoforce_company_id?: InputMaybe<Order_By>;
  pandoforce_input_company_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "action_events" */
export type Action_Events = {
  __typename?: 'action_events';
  actionable_id: Scalars['String']['output'];
  actionable_type: Scalars['String']['output'];
  batch_id: Scalars['bpchar']['output'];
  changes?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  exception: Scalars['String']['output'];
  fields: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
  model_id?: Maybe<Scalars['String']['output']>;
  model_type: Scalars['String']['output'];
  name: Scalars['String']['output'];
  original?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  target_id: Scalars['String']['output'];
  target_type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id: Scalars['bpchar']['output'];
};

/** aggregated selection of "action_events" */
export type Action_Events_Aggregate = {
  __typename?: 'action_events_aggregate';
  aggregate?: Maybe<Action_Events_Aggregate_Fields>;
  nodes: Array<Action_Events>;
};

/** aggregate fields of "action_events" */
export type Action_Events_Aggregate_Fields = {
  __typename?: 'action_events_aggregate_fields';
  avg?: Maybe<Action_Events_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Action_Events_Max_Fields>;
  min?: Maybe<Action_Events_Min_Fields>;
  stddev?: Maybe<Action_Events_Stddev_Fields>;
  stddev_pop?: Maybe<Action_Events_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Action_Events_Stddev_Samp_Fields>;
  sum?: Maybe<Action_Events_Sum_Fields>;
  var_pop?: Maybe<Action_Events_Var_Pop_Fields>;
  var_samp?: Maybe<Action_Events_Var_Samp_Fields>;
  variance?: Maybe<Action_Events_Variance_Fields>;
};


/** aggregate fields of "action_events" */
export type Action_Events_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Action_Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Action_Events_Avg_Fields = {
  __typename?: 'action_events_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "action_events". All fields are combined with a logical 'AND'. */
export type Action_Events_Bool_Exp = {
  _and?: InputMaybe<Array<Action_Events_Bool_Exp>>;
  _not?: InputMaybe<Action_Events_Bool_Exp>;
  _or?: InputMaybe<Array<Action_Events_Bool_Exp>>;
  actionable_id?: InputMaybe<String_Comparison_Exp>;
  actionable_type?: InputMaybe<String_Comparison_Exp>;
  batch_id?: InputMaybe<Bpchar_Comparison_Exp>;
  changes?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  exception?: InputMaybe<String_Comparison_Exp>;
  fields?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  model_id?: InputMaybe<String_Comparison_Exp>;
  model_type?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  original?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  target_id?: InputMaybe<String_Comparison_Exp>;
  target_type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "action_events" */
export enum Action_Events_Constraint {
  /** unique or primary key constraint on columns "id" */
  ActionEventsPkey = 'action_events_pkey'
}

/** input type for incrementing numeric columns in table "action_events" */
export type Action_Events_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "action_events" */
export type Action_Events_Insert_Input = {
  actionable_id?: InputMaybe<Scalars['String']['input']>;
  actionable_type?: InputMaybe<Scalars['String']['input']>;
  batch_id?: InputMaybe<Scalars['bpchar']['input']>;
  changes?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  exception?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  model_id?: InputMaybe<Scalars['String']['input']>;
  model_type?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  original?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  target_id?: InputMaybe<Scalars['String']['input']>;
  target_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Action_Events_Max_Fields = {
  __typename?: 'action_events_max_fields';
  actionable_id?: Maybe<Scalars['String']['output']>;
  actionable_type?: Maybe<Scalars['String']['output']>;
  batch_id?: Maybe<Scalars['bpchar']['output']>;
  changes?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  exception?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  model_id?: Maybe<Scalars['String']['output']>;
  model_type?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  original?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  target_id?: Maybe<Scalars['String']['output']>;
  target_type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** aggregate min on columns */
export type Action_Events_Min_Fields = {
  __typename?: 'action_events_min_fields';
  actionable_id?: Maybe<Scalars['String']['output']>;
  actionable_type?: Maybe<Scalars['String']['output']>;
  batch_id?: Maybe<Scalars['bpchar']['output']>;
  changes?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  exception?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  model_id?: Maybe<Scalars['String']['output']>;
  model_type?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  original?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  target_id?: Maybe<Scalars['String']['output']>;
  target_type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** response of any mutation on the table "action_events" */
export type Action_Events_Mutation_Response = {
  __typename?: 'action_events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Action_Events>;
};

/** on_conflict condition type for table "action_events" */
export type Action_Events_On_Conflict = {
  constraint: Action_Events_Constraint;
  update_columns?: Array<Action_Events_Update_Column>;
  where?: InputMaybe<Action_Events_Bool_Exp>;
};

/** Ordering options when selecting data from "action_events". */
export type Action_Events_Order_By = {
  actionable_id?: InputMaybe<Order_By>;
  actionable_type?: InputMaybe<Order_By>;
  batch_id?: InputMaybe<Order_By>;
  changes?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  exception?: InputMaybe<Order_By>;
  fields?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  model_id?: InputMaybe<Order_By>;
  model_type?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  original?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  target_id?: InputMaybe<Order_By>;
  target_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: action_events */
export type Action_Events_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "action_events" */
export enum Action_Events_Select_Column {
  /** column name */
  ActionableId = 'actionable_id',
  /** column name */
  ActionableType = 'actionable_type',
  /** column name */
  BatchId = 'batch_id',
  /** column name */
  Changes = 'changes',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Exception = 'exception',
  /** column name */
  Fields = 'fields',
  /** column name */
  Id = 'id',
  /** column name */
  ModelId = 'model_id',
  /** column name */
  ModelType = 'model_type',
  /** column name */
  Name = 'name',
  /** column name */
  Original = 'original',
  /** column name */
  Status = 'status',
  /** column name */
  TargetId = 'target_id',
  /** column name */
  TargetType = 'target_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "action_events" */
export type Action_Events_Set_Input = {
  actionable_id?: InputMaybe<Scalars['String']['input']>;
  actionable_type?: InputMaybe<Scalars['String']['input']>;
  batch_id?: InputMaybe<Scalars['bpchar']['input']>;
  changes?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  exception?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  model_id?: InputMaybe<Scalars['String']['input']>;
  model_type?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  original?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  target_id?: InputMaybe<Scalars['String']['input']>;
  target_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate stddev on columns */
export type Action_Events_Stddev_Fields = {
  __typename?: 'action_events_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Action_Events_Stddev_Pop_Fields = {
  __typename?: 'action_events_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Action_Events_Stddev_Samp_Fields = {
  __typename?: 'action_events_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "action_events" */
export type Action_Events_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Action_Events_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Action_Events_Stream_Cursor_Value_Input = {
  actionable_id?: InputMaybe<Scalars['String']['input']>;
  actionable_type?: InputMaybe<Scalars['String']['input']>;
  batch_id?: InputMaybe<Scalars['bpchar']['input']>;
  changes?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  exception?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  model_id?: InputMaybe<Scalars['String']['input']>;
  model_type?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  original?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  target_id?: InputMaybe<Scalars['String']['input']>;
  target_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate sum on columns */
export type Action_Events_Sum_Fields = {
  __typename?: 'action_events_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "action_events" */
export enum Action_Events_Update_Column {
  /** column name */
  ActionableId = 'actionable_id',
  /** column name */
  ActionableType = 'actionable_type',
  /** column name */
  BatchId = 'batch_id',
  /** column name */
  Changes = 'changes',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Exception = 'exception',
  /** column name */
  Fields = 'fields',
  /** column name */
  Id = 'id',
  /** column name */
  ModelId = 'model_id',
  /** column name */
  ModelType = 'model_type',
  /** column name */
  Name = 'name',
  /** column name */
  Original = 'original',
  /** column name */
  Status = 'status',
  /** column name */
  TargetId = 'target_id',
  /** column name */
  TargetType = 'target_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Action_Events_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Action_Events_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Action_Events_Set_Input>;
  /** filter the rows which have to be updated */
  where: Action_Events_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Action_Events_Var_Pop_Fields = {
  __typename?: 'action_events_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Action_Events_Var_Samp_Fields = {
  __typename?: 'action_events_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Action_Events_Variance_Fields = {
  __typename?: 'action_events_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "balances" */
export type Balances = {
  __typename?: 'balances';
  currency: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
  payable_id: Scalars['bpchar']['output'];
  payable_type: Scalars['String']['output'];
  value: Scalars['numeric']['output'];
  value_expired: Scalars['numeric']['output'];
  value_on_hold: Scalars['numeric']['output'];
  value_pending: Scalars['numeric']['output'];
};

/** aggregated selection of "balances" */
export type Balances_Aggregate = {
  __typename?: 'balances_aggregate';
  aggregate?: Maybe<Balances_Aggregate_Fields>;
  nodes: Array<Balances>;
};

/** aggregate fields of "balances" */
export type Balances_Aggregate_Fields = {
  __typename?: 'balances_aggregate_fields';
  avg?: Maybe<Balances_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Balances_Max_Fields>;
  min?: Maybe<Balances_Min_Fields>;
  stddev?: Maybe<Balances_Stddev_Fields>;
  stddev_pop?: Maybe<Balances_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Balances_Stddev_Samp_Fields>;
  sum?: Maybe<Balances_Sum_Fields>;
  var_pop?: Maybe<Balances_Var_Pop_Fields>;
  var_samp?: Maybe<Balances_Var_Samp_Fields>;
  variance?: Maybe<Balances_Variance_Fields>;
};


/** aggregate fields of "balances" */
export type Balances_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Balances_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Balances_Avg_Fields = {
  __typename?: 'balances_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  value_expired?: Maybe<Scalars['Float']['output']>;
  value_on_hold?: Maybe<Scalars['Float']['output']>;
  value_pending?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "balances". All fields are combined with a logical 'AND'. */
export type Balances_Bool_Exp = {
  _and?: InputMaybe<Array<Balances_Bool_Exp>>;
  _not?: InputMaybe<Balances_Bool_Exp>;
  _or?: InputMaybe<Array<Balances_Bool_Exp>>;
  currency?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  payable_id?: InputMaybe<Bpchar_Comparison_Exp>;
  payable_type?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<Numeric_Comparison_Exp>;
  value_expired?: InputMaybe<Numeric_Comparison_Exp>;
  value_on_hold?: InputMaybe<Numeric_Comparison_Exp>;
  value_pending?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "balances" */
export enum Balances_Constraint {
  /** unique or primary key constraint on columns "id" */
  BalancesPkey = 'balances_pkey',
  /** unique or primary key constraint on columns "payable_id", "payable_type", "currency" */
  UniqueBalance = 'unique_balance'
}

/** input type for incrementing numeric columns in table "balances" */
export type Balances_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
  value_expired?: InputMaybe<Scalars['numeric']['input']>;
  value_on_hold?: InputMaybe<Scalars['numeric']['input']>;
  value_pending?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "balances" */
export type Balances_Insert_Input = {
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  payable_id?: InputMaybe<Scalars['bpchar']['input']>;
  payable_type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
  value_expired?: InputMaybe<Scalars['numeric']['input']>;
  value_on_hold?: InputMaybe<Scalars['numeric']['input']>;
  value_pending?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Balances_Max_Fields = {
  __typename?: 'balances_max_fields';
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  payable_id?: Maybe<Scalars['bpchar']['output']>;
  payable_type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
  value_expired?: Maybe<Scalars['numeric']['output']>;
  value_on_hold?: Maybe<Scalars['numeric']['output']>;
  value_pending?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type Balances_Min_Fields = {
  __typename?: 'balances_min_fields';
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  payable_id?: Maybe<Scalars['bpchar']['output']>;
  payable_type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
  value_expired?: Maybe<Scalars['numeric']['output']>;
  value_on_hold?: Maybe<Scalars['numeric']['output']>;
  value_pending?: Maybe<Scalars['numeric']['output']>;
};

/** response of any mutation on the table "balances" */
export type Balances_Mutation_Response = {
  __typename?: 'balances_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Balances>;
};

/** on_conflict condition type for table "balances" */
export type Balances_On_Conflict = {
  constraint: Balances_Constraint;
  update_columns?: Array<Balances_Update_Column>;
  where?: InputMaybe<Balances_Bool_Exp>;
};

/** Ordering options when selecting data from "balances". */
export type Balances_Order_By = {
  currency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payable_id?: InputMaybe<Order_By>;
  payable_type?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  value_expired?: InputMaybe<Order_By>;
  value_on_hold?: InputMaybe<Order_By>;
  value_pending?: InputMaybe<Order_By>;
};

/** primary key columns input for table: balances */
export type Balances_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "balances" */
export enum Balances_Select_Column {
  /** column name */
  Currency = 'currency',
  /** column name */
  Id = 'id',
  /** column name */
  PayableId = 'payable_id',
  /** column name */
  PayableType = 'payable_type',
  /** column name */
  Value = 'value',
  /** column name */
  ValueExpired = 'value_expired',
  /** column name */
  ValueOnHold = 'value_on_hold',
  /** column name */
  ValuePending = 'value_pending'
}

/** input type for updating data in table "balances" */
export type Balances_Set_Input = {
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  payable_id?: InputMaybe<Scalars['bpchar']['input']>;
  payable_type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
  value_expired?: InputMaybe<Scalars['numeric']['input']>;
  value_on_hold?: InputMaybe<Scalars['numeric']['input']>;
  value_pending?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Balances_Stddev_Fields = {
  __typename?: 'balances_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  value_expired?: Maybe<Scalars['Float']['output']>;
  value_on_hold?: Maybe<Scalars['Float']['output']>;
  value_pending?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Balances_Stddev_Pop_Fields = {
  __typename?: 'balances_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  value_expired?: Maybe<Scalars['Float']['output']>;
  value_on_hold?: Maybe<Scalars['Float']['output']>;
  value_pending?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Balances_Stddev_Samp_Fields = {
  __typename?: 'balances_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  value_expired?: Maybe<Scalars['Float']['output']>;
  value_on_hold?: Maybe<Scalars['Float']['output']>;
  value_pending?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "balances" */
export type Balances_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Balances_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Balances_Stream_Cursor_Value_Input = {
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  payable_id?: InputMaybe<Scalars['bpchar']['input']>;
  payable_type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
  value_expired?: InputMaybe<Scalars['numeric']['input']>;
  value_on_hold?: InputMaybe<Scalars['numeric']['input']>;
  value_pending?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Balances_Sum_Fields = {
  __typename?: 'balances_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
  value_expired?: Maybe<Scalars['numeric']['output']>;
  value_on_hold?: Maybe<Scalars['numeric']['output']>;
  value_pending?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "balances" */
export enum Balances_Update_Column {
  /** column name */
  Currency = 'currency',
  /** column name */
  Id = 'id',
  /** column name */
  PayableId = 'payable_id',
  /** column name */
  PayableType = 'payable_type',
  /** column name */
  Value = 'value',
  /** column name */
  ValueExpired = 'value_expired',
  /** column name */
  ValueOnHold = 'value_on_hold',
  /** column name */
  ValuePending = 'value_pending'
}

export type Balances_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Balances_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Balances_Set_Input>;
  /** filter the rows which have to be updated */
  where: Balances_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Balances_Var_Pop_Fields = {
  __typename?: 'balances_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  value_expired?: Maybe<Scalars['Float']['output']>;
  value_on_hold?: Maybe<Scalars['Float']['output']>;
  value_pending?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Balances_Var_Samp_Fields = {
  __typename?: 'balances_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  value_expired?: Maybe<Scalars['Float']['output']>;
  value_on_hold?: Maybe<Scalars['Float']['output']>;
  value_pending?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Balances_Variance_Fields = {
  __typename?: 'balances_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  value_expired?: Maybe<Scalars['Float']['output']>;
  value_on_hold?: Maybe<Scalars['Float']['output']>;
  value_pending?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** Boolean expression to compare columns of type "bpchar". All fields are combined with logical 'AND'. */
export type Bpchar_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bpchar']['input']>;
  _gt?: InputMaybe<Scalars['bpchar']['input']>;
  _gte?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['bpchar']['input']>;
  _in?: InputMaybe<Array<Scalars['bpchar']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['bpchar']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['bpchar']['input']>;
  _lt?: InputMaybe<Scalars['bpchar']['input']>;
  _lte?: InputMaybe<Scalars['bpchar']['input']>;
  _neq?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['bpchar']['input']>;
  _nin?: InputMaybe<Array<Scalars['bpchar']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['bpchar']['input']>;
};

/** columns and relationships of "channel_links" */
export type Channel_Links = {
  __typename?: 'channel_links';
  channel_id: Scalars['bigint']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  engagement_rate?: Maybe<Scalars['float8']['output']>;
  follower_count: Scalars['Int']['output'];
  id: Scalars['bigint']['output'];
  impressions_count?: Maybe<Scalars['Int']['output']>;
  link_data?: Maybe<Scalars['jsonb']['output']>;
  link_type?: Maybe<Scalars['String']['output']>;
  link_url: Scalars['String']['output'];
  post_count?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "channel_links" */
export type Channel_LinksLink_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "channel_links" */
export type Channel_Links_Aggregate = {
  __typename?: 'channel_links_aggregate';
  aggregate?: Maybe<Channel_Links_Aggregate_Fields>;
  nodes: Array<Channel_Links>;
};

export type Channel_Links_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Channel_Links_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Channel_Links_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Channel_Links_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Channel_Links_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Channel_Links_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Channel_Links_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Channel_Links_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Channel_Links_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Channel_Links_Aggregate_Bool_Exp_Var_Samp>;
};

export type Channel_Links_Aggregate_Bool_Exp_Avg = {
  arguments: Channel_Links_Select_Column_Channel_Links_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Channel_Links_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Channel_Links_Aggregate_Bool_Exp_Corr = {
  arguments: Channel_Links_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Channel_Links_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Channel_Links_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Channel_Links_Select_Column_Channel_Links_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Channel_Links_Select_Column_Channel_Links_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Channel_Links_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Channel_Links_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Channel_Links_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Channel_Links_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Channel_Links_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Channel_Links_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Channel_Links_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Channel_Links_Select_Column_Channel_Links_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Channel_Links_Select_Column_Channel_Links_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Channel_Links_Aggregate_Bool_Exp_Max = {
  arguments: Channel_Links_Select_Column_Channel_Links_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Channel_Links_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Channel_Links_Aggregate_Bool_Exp_Min = {
  arguments: Channel_Links_Select_Column_Channel_Links_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Channel_Links_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Channel_Links_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Channel_Links_Select_Column_Channel_Links_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Channel_Links_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Channel_Links_Aggregate_Bool_Exp_Sum = {
  arguments: Channel_Links_Select_Column_Channel_Links_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Channel_Links_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Channel_Links_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Channel_Links_Select_Column_Channel_Links_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Channel_Links_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "channel_links" */
export type Channel_Links_Aggregate_Fields = {
  __typename?: 'channel_links_aggregate_fields';
  avg?: Maybe<Channel_Links_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Channel_Links_Max_Fields>;
  min?: Maybe<Channel_Links_Min_Fields>;
  stddev?: Maybe<Channel_Links_Stddev_Fields>;
  stddev_pop?: Maybe<Channel_Links_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Channel_Links_Stddev_Samp_Fields>;
  sum?: Maybe<Channel_Links_Sum_Fields>;
  var_pop?: Maybe<Channel_Links_Var_Pop_Fields>;
  var_samp?: Maybe<Channel_Links_Var_Samp_Fields>;
  variance?: Maybe<Channel_Links_Variance_Fields>;
};


/** aggregate fields of "channel_links" */
export type Channel_Links_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Channel_Links_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "channel_links" */
export type Channel_Links_Aggregate_Order_By = {
  avg?: InputMaybe<Channel_Links_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Channel_Links_Max_Order_By>;
  min?: InputMaybe<Channel_Links_Min_Order_By>;
  stddev?: InputMaybe<Channel_Links_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Channel_Links_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Channel_Links_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Channel_Links_Sum_Order_By>;
  var_pop?: InputMaybe<Channel_Links_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Channel_Links_Var_Samp_Order_By>;
  variance?: InputMaybe<Channel_Links_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Channel_Links_Append_Input = {
  link_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "channel_links" */
export type Channel_Links_Arr_Rel_Insert_Input = {
  data: Array<Channel_Links_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Channel_Links_On_Conflict>;
};

/** aggregate avg on columns */
export type Channel_Links_Avg_Fields = {
  __typename?: 'channel_links_avg_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  engagement_rate?: Maybe<Scalars['Float']['output']>;
  follower_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  impressions_count?: Maybe<Scalars['Float']['output']>;
  post_count?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "channel_links" */
export type Channel_Links_Avg_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  engagement_rate?: InputMaybe<Order_By>;
  follower_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impressions_count?: InputMaybe<Order_By>;
  post_count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "channel_links". All fields are combined with a logical 'AND'. */
export type Channel_Links_Bool_Exp = {
  _and?: InputMaybe<Array<Channel_Links_Bool_Exp>>;
  _not?: InputMaybe<Channel_Links_Bool_Exp>;
  _or?: InputMaybe<Array<Channel_Links_Bool_Exp>>;
  channel_id?: InputMaybe<Bigint_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  engagement_rate?: InputMaybe<Float8_Comparison_Exp>;
  follower_count?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  impressions_count?: InputMaybe<Int_Comparison_Exp>;
  link_data?: InputMaybe<Jsonb_Comparison_Exp>;
  link_type?: InputMaybe<String_Comparison_Exp>;
  link_url?: InputMaybe<String_Comparison_Exp>;
  post_count?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "channel_links" */
export enum Channel_Links_Constraint {
  /** unique or primary key constraint on columns "id" */
  ChannelLinksPkey = 'channel_links_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Channel_Links_Delete_At_Path_Input = {
  link_data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Channel_Links_Delete_Elem_Input = {
  link_data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Channel_Links_Delete_Key_Input = {
  link_data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "channel_links" */
export type Channel_Links_Inc_Input = {
  channel_id?: InputMaybe<Scalars['bigint']['input']>;
  engagement_rate?: InputMaybe<Scalars['float8']['input']>;
  follower_count?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  impressions_count?: InputMaybe<Scalars['Int']['input']>;
  post_count?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "channel_links" */
export type Channel_Links_Insert_Input = {
  channel_id?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  engagement_rate?: InputMaybe<Scalars['float8']['input']>;
  follower_count?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  impressions_count?: InputMaybe<Scalars['Int']['input']>;
  link_data?: InputMaybe<Scalars['jsonb']['input']>;
  link_type?: InputMaybe<Scalars['String']['input']>;
  link_url?: InputMaybe<Scalars['String']['input']>;
  post_count?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Channel_Links_Max_Fields = {
  __typename?: 'channel_links_max_fields';
  channel_id?: Maybe<Scalars['bigint']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  engagement_rate?: Maybe<Scalars['float8']['output']>;
  follower_count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  impressions_count?: Maybe<Scalars['Int']['output']>;
  link_type?: Maybe<Scalars['String']['output']>;
  link_url?: Maybe<Scalars['String']['output']>;
  post_count?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "channel_links" */
export type Channel_Links_Max_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  engagement_rate?: InputMaybe<Order_By>;
  follower_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impressions_count?: InputMaybe<Order_By>;
  link_type?: InputMaybe<Order_By>;
  link_url?: InputMaybe<Order_By>;
  post_count?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Channel_Links_Min_Fields = {
  __typename?: 'channel_links_min_fields';
  channel_id?: Maybe<Scalars['bigint']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  engagement_rate?: Maybe<Scalars['float8']['output']>;
  follower_count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  impressions_count?: Maybe<Scalars['Int']['output']>;
  link_type?: Maybe<Scalars['String']['output']>;
  link_url?: Maybe<Scalars['String']['output']>;
  post_count?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "channel_links" */
export type Channel_Links_Min_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  engagement_rate?: InputMaybe<Order_By>;
  follower_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impressions_count?: InputMaybe<Order_By>;
  link_type?: InputMaybe<Order_By>;
  link_url?: InputMaybe<Order_By>;
  post_count?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "channel_links" */
export type Channel_Links_Mutation_Response = {
  __typename?: 'channel_links_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Channel_Links>;
};

/** on_conflict condition type for table "channel_links" */
export type Channel_Links_On_Conflict = {
  constraint: Channel_Links_Constraint;
  update_columns?: Array<Channel_Links_Update_Column>;
  where?: InputMaybe<Channel_Links_Bool_Exp>;
};

/** Ordering options when selecting data from "channel_links". */
export type Channel_Links_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  engagement_rate?: InputMaybe<Order_By>;
  follower_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impressions_count?: InputMaybe<Order_By>;
  link_data?: InputMaybe<Order_By>;
  link_type?: InputMaybe<Order_By>;
  link_url?: InputMaybe<Order_By>;
  post_count?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: channel_links */
export type Channel_Links_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Channel_Links_Prepend_Input = {
  link_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "channel_links" */
export enum Channel_Links_Select_Column {
  /** column name */
  ChannelId = 'channel_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  EngagementRate = 'engagement_rate',
  /** column name */
  FollowerCount = 'follower_count',
  /** column name */
  Id = 'id',
  /** column name */
  ImpressionsCount = 'impressions_count',
  /** column name */
  LinkData = 'link_data',
  /** column name */
  LinkType = 'link_type',
  /** column name */
  LinkUrl = 'link_url',
  /** column name */
  PostCount = 'post_count',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "channel_links_aggregate_bool_exp_avg_arguments_columns" columns of table "channel_links" */
export enum Channel_Links_Select_Column_Channel_Links_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  EngagementRate = 'engagement_rate'
}

/** select "channel_links_aggregate_bool_exp_corr_arguments_columns" columns of table "channel_links" */
export enum Channel_Links_Select_Column_Channel_Links_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  EngagementRate = 'engagement_rate'
}

/** select "channel_links_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "channel_links" */
export enum Channel_Links_Select_Column_Channel_Links_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  EngagementRate = 'engagement_rate'
}

/** select "channel_links_aggregate_bool_exp_max_arguments_columns" columns of table "channel_links" */
export enum Channel_Links_Select_Column_Channel_Links_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  EngagementRate = 'engagement_rate'
}

/** select "channel_links_aggregate_bool_exp_min_arguments_columns" columns of table "channel_links" */
export enum Channel_Links_Select_Column_Channel_Links_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  EngagementRate = 'engagement_rate'
}

/** select "channel_links_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "channel_links" */
export enum Channel_Links_Select_Column_Channel_Links_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  EngagementRate = 'engagement_rate'
}

/** select "channel_links_aggregate_bool_exp_sum_arguments_columns" columns of table "channel_links" */
export enum Channel_Links_Select_Column_Channel_Links_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  EngagementRate = 'engagement_rate'
}

/** select "channel_links_aggregate_bool_exp_var_samp_arguments_columns" columns of table "channel_links" */
export enum Channel_Links_Select_Column_Channel_Links_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  EngagementRate = 'engagement_rate'
}

/** input type for updating data in table "channel_links" */
export type Channel_Links_Set_Input = {
  channel_id?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  engagement_rate?: InputMaybe<Scalars['float8']['input']>;
  follower_count?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  impressions_count?: InputMaybe<Scalars['Int']['input']>;
  link_data?: InputMaybe<Scalars['jsonb']['input']>;
  link_type?: InputMaybe<Scalars['String']['input']>;
  link_url?: InputMaybe<Scalars['String']['input']>;
  post_count?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Channel_Links_Stddev_Fields = {
  __typename?: 'channel_links_stddev_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  engagement_rate?: Maybe<Scalars['Float']['output']>;
  follower_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  impressions_count?: Maybe<Scalars['Float']['output']>;
  post_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "channel_links" */
export type Channel_Links_Stddev_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  engagement_rate?: InputMaybe<Order_By>;
  follower_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impressions_count?: InputMaybe<Order_By>;
  post_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Channel_Links_Stddev_Pop_Fields = {
  __typename?: 'channel_links_stddev_pop_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  engagement_rate?: Maybe<Scalars['Float']['output']>;
  follower_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  impressions_count?: Maybe<Scalars['Float']['output']>;
  post_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "channel_links" */
export type Channel_Links_Stddev_Pop_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  engagement_rate?: InputMaybe<Order_By>;
  follower_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impressions_count?: InputMaybe<Order_By>;
  post_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Channel_Links_Stddev_Samp_Fields = {
  __typename?: 'channel_links_stddev_samp_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  engagement_rate?: Maybe<Scalars['Float']['output']>;
  follower_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  impressions_count?: Maybe<Scalars['Float']['output']>;
  post_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "channel_links" */
export type Channel_Links_Stddev_Samp_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  engagement_rate?: InputMaybe<Order_By>;
  follower_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impressions_count?: InputMaybe<Order_By>;
  post_count?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "channel_links" */
export type Channel_Links_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Channel_Links_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Channel_Links_Stream_Cursor_Value_Input = {
  channel_id?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  engagement_rate?: InputMaybe<Scalars['float8']['input']>;
  follower_count?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  impressions_count?: InputMaybe<Scalars['Int']['input']>;
  link_data?: InputMaybe<Scalars['jsonb']['input']>;
  link_type?: InputMaybe<Scalars['String']['input']>;
  link_url?: InputMaybe<Scalars['String']['input']>;
  post_count?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Channel_Links_Sum_Fields = {
  __typename?: 'channel_links_sum_fields';
  channel_id?: Maybe<Scalars['bigint']['output']>;
  engagement_rate?: Maybe<Scalars['float8']['output']>;
  follower_count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  impressions_count?: Maybe<Scalars['Int']['output']>;
  post_count?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "channel_links" */
export type Channel_Links_Sum_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  engagement_rate?: InputMaybe<Order_By>;
  follower_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impressions_count?: InputMaybe<Order_By>;
  post_count?: InputMaybe<Order_By>;
};

/** update columns of table "channel_links" */
export enum Channel_Links_Update_Column {
  /** column name */
  ChannelId = 'channel_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  EngagementRate = 'engagement_rate',
  /** column name */
  FollowerCount = 'follower_count',
  /** column name */
  Id = 'id',
  /** column name */
  ImpressionsCount = 'impressions_count',
  /** column name */
  LinkData = 'link_data',
  /** column name */
  LinkType = 'link_type',
  /** column name */
  LinkUrl = 'link_url',
  /** column name */
  PostCount = 'post_count',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Channel_Links_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Channel_Links_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Channel_Links_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Channel_Links_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Channel_Links_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Channel_Links_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Channel_Links_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Channel_Links_Set_Input>;
  /** filter the rows which have to be updated */
  where: Channel_Links_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Channel_Links_Var_Pop_Fields = {
  __typename?: 'channel_links_var_pop_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  engagement_rate?: Maybe<Scalars['Float']['output']>;
  follower_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  impressions_count?: Maybe<Scalars['Float']['output']>;
  post_count?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "channel_links" */
export type Channel_Links_Var_Pop_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  engagement_rate?: InputMaybe<Order_By>;
  follower_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impressions_count?: InputMaybe<Order_By>;
  post_count?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Channel_Links_Var_Samp_Fields = {
  __typename?: 'channel_links_var_samp_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  engagement_rate?: Maybe<Scalars['Float']['output']>;
  follower_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  impressions_count?: Maybe<Scalars['Float']['output']>;
  post_count?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "channel_links" */
export type Channel_Links_Var_Samp_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  engagement_rate?: InputMaybe<Order_By>;
  follower_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impressions_count?: InputMaybe<Order_By>;
  post_count?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Channel_Links_Variance_Fields = {
  __typename?: 'channel_links_variance_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  engagement_rate?: Maybe<Scalars['Float']['output']>;
  follower_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  impressions_count?: Maybe<Scalars['Float']['output']>;
  post_count?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "channel_links" */
export type Channel_Links_Variance_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  engagement_rate?: InputMaybe<Order_By>;
  follower_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impressions_count?: InputMaybe<Order_By>;
  post_count?: InputMaybe<Order_By>;
};

/** columns and relationships of "channels" */
export type Channels = {
  __typename?: 'channels';
  /** An object relationship */
  account?: Maybe<Accounts>;
  account_id: Scalars['bpchar']['output'];
  banner_image_url?: Maybe<Scalars['String']['output']>;
  channel_handle?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  channel_links: Array<Channel_Links>;
  /** An aggregate relationship */
  channel_links_aggregate: Channel_Links_Aggregate;
  company_id: Scalars['bpchar']['output'];
  content_languages?: Maybe<Scalars['jsonb']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  followers: Array<User_Follows_Channel>;
  /** An aggregate relationship */
  followers_aggregate: User_Follows_Channel_Aggregate;
  followers_count: Scalars['Int']['output'];
  id: Scalars['bigint']['output'];
  logo_image_url?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "channels" */
export type ChannelsChannel_LinksArgs = {
  distinct_on?: InputMaybe<Array<Channel_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Channel_Links_Order_By>>;
  where?: InputMaybe<Channel_Links_Bool_Exp>;
};


/** columns and relationships of "channels" */
export type ChannelsChannel_Links_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Channel_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Channel_Links_Order_By>>;
  where?: InputMaybe<Channel_Links_Bool_Exp>;
};


/** columns and relationships of "channels" */
export type ChannelsContent_LanguagesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "channels" */
export type ChannelsFollowersArgs = {
  distinct_on?: InputMaybe<Array<User_Follows_Channel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Follows_Channel_Order_By>>;
  where?: InputMaybe<User_Follows_Channel_Bool_Exp>;
};


/** columns and relationships of "channels" */
export type ChannelsFollowers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Follows_Channel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Follows_Channel_Order_By>>;
  where?: InputMaybe<User_Follows_Channel_Bool_Exp>;
};

/** aggregated selection of "channels" */
export type Channels_Aggregate = {
  __typename?: 'channels_aggregate';
  aggregate?: Maybe<Channels_Aggregate_Fields>;
  nodes: Array<Channels>;
};

/** aggregate fields of "channels" */
export type Channels_Aggregate_Fields = {
  __typename?: 'channels_aggregate_fields';
  avg?: Maybe<Channels_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Channels_Max_Fields>;
  min?: Maybe<Channels_Min_Fields>;
  stddev?: Maybe<Channels_Stddev_Fields>;
  stddev_pop?: Maybe<Channels_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Channels_Stddev_Samp_Fields>;
  sum?: Maybe<Channels_Sum_Fields>;
  var_pop?: Maybe<Channels_Var_Pop_Fields>;
  var_samp?: Maybe<Channels_Var_Samp_Fields>;
  variance?: Maybe<Channels_Variance_Fields>;
};


/** aggregate fields of "channels" */
export type Channels_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Channels_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Channels_Append_Input = {
  content_languages?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Channels_Avg_Fields = {
  __typename?: 'channels_avg_fields';
  followers_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "channels". All fields are combined with a logical 'AND'. */
export type Channels_Bool_Exp = {
  _and?: InputMaybe<Array<Channels_Bool_Exp>>;
  _not?: InputMaybe<Channels_Bool_Exp>;
  _or?: InputMaybe<Array<Channels_Bool_Exp>>;
  account?: InputMaybe<Accounts_Bool_Exp>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  banner_image_url?: InputMaybe<String_Comparison_Exp>;
  channel_handle?: InputMaybe<String_Comparison_Exp>;
  channel_links?: InputMaybe<Channel_Links_Bool_Exp>;
  channel_links_aggregate?: InputMaybe<Channel_Links_Aggregate_Bool_Exp>;
  company_id?: InputMaybe<Bpchar_Comparison_Exp>;
  content_languages?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  followers?: InputMaybe<User_Follows_Channel_Bool_Exp>;
  followers_aggregate?: InputMaybe<User_Follows_Channel_Aggregate_Bool_Exp>;
  followers_count?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  logo_image_url?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "channels" */
export enum Channels_Constraint {
  /** unique or primary key constraint on columns "id" */
  ChannelsPkey = 'channels_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Channels_Delete_At_Path_Input = {
  content_languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Channels_Delete_Elem_Input = {
  content_languages?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Channels_Delete_Key_Input = {
  content_languages?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "channels" */
export type Channels_Inc_Input = {
  followers_count?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "channels" */
export type Channels_Insert_Input = {
  account?: InputMaybe<Accounts_Obj_Rel_Insert_Input>;
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  banner_image_url?: InputMaybe<Scalars['String']['input']>;
  channel_handle?: InputMaybe<Scalars['String']['input']>;
  channel_links?: InputMaybe<Channel_Links_Arr_Rel_Insert_Input>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  content_languages?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  followers?: InputMaybe<User_Follows_Channel_Arr_Rel_Insert_Input>;
  followers_count?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  logo_image_url?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Channels_Max_Fields = {
  __typename?: 'channels_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  banner_image_url?: Maybe<Scalars['String']['output']>;
  channel_handle?: Maybe<Scalars['String']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  followers_count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  logo_image_url?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Channels_Min_Fields = {
  __typename?: 'channels_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  banner_image_url?: Maybe<Scalars['String']['output']>;
  channel_handle?: Maybe<Scalars['String']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  followers_count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  logo_image_url?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "channels" */
export type Channels_Mutation_Response = {
  __typename?: 'channels_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Channels>;
};

/** input type for inserting object relation for remote table "channels" */
export type Channels_Obj_Rel_Insert_Input = {
  data: Channels_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Channels_On_Conflict>;
};

/** on_conflict condition type for table "channels" */
export type Channels_On_Conflict = {
  constraint: Channels_Constraint;
  update_columns?: Array<Channels_Update_Column>;
  where?: InputMaybe<Channels_Bool_Exp>;
};

/** Ordering options when selecting data from "channels". */
export type Channels_Order_By = {
  account?: InputMaybe<Accounts_Order_By>;
  account_id?: InputMaybe<Order_By>;
  banner_image_url?: InputMaybe<Order_By>;
  channel_handle?: InputMaybe<Order_By>;
  channel_links_aggregate?: InputMaybe<Channel_Links_Aggregate_Order_By>;
  company_id?: InputMaybe<Order_By>;
  content_languages?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  followers_aggregate?: InputMaybe<User_Follows_Channel_Aggregate_Order_By>;
  followers_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logo_image_url?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: channels */
export type Channels_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Channels_Prepend_Input = {
  content_languages?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "channels" */
export enum Channels_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  BannerImageUrl = 'banner_image_url',
  /** column name */
  ChannelHandle = 'channel_handle',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  ContentLanguages = 'content_languages',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  FollowersCount = 'followers_count',
  /** column name */
  Id = 'id',
  /** column name */
  LogoImageUrl = 'logo_image_url',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "channels" */
export type Channels_Set_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  banner_image_url?: InputMaybe<Scalars['String']['input']>;
  channel_handle?: InputMaybe<Scalars['String']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  content_languages?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  followers_count?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  logo_image_url?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Channels_Stddev_Fields = {
  __typename?: 'channels_stddev_fields';
  followers_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Channels_Stddev_Pop_Fields = {
  __typename?: 'channels_stddev_pop_fields';
  followers_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Channels_Stddev_Samp_Fields = {
  __typename?: 'channels_stddev_samp_fields';
  followers_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "channels" */
export type Channels_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Channels_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Channels_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  banner_image_url?: InputMaybe<Scalars['String']['input']>;
  channel_handle?: InputMaybe<Scalars['String']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  content_languages?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  followers_count?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  logo_image_url?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Channels_Sum_Fields = {
  __typename?: 'channels_sum_fields';
  followers_count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "channels" */
export enum Channels_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  BannerImageUrl = 'banner_image_url',
  /** column name */
  ChannelHandle = 'channel_handle',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  ContentLanguages = 'content_languages',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  FollowersCount = 'followers_count',
  /** column name */
  Id = 'id',
  /** column name */
  LogoImageUrl = 'logo_image_url',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Channels_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Channels_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Channels_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Channels_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Channels_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Channels_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Channels_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Channels_Set_Input>;
  /** filter the rows which have to be updated */
  where: Channels_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Channels_Var_Pop_Fields = {
  __typename?: 'channels_var_pop_fields';
  followers_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Channels_Var_Samp_Fields = {
  __typename?: 'channels_var_samp_fields';
  followers_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Channels_Variance_Fields = {
  __typename?: 'channels_variance_fields';
  followers_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "chat_messages" */
export type Chat_Messages = {
  __typename?: 'chat_messages';
  /** An object relationship */
  chat_thread: Chat_Threads;
  chat_thread_id: Scalars['bpchar']['output'];
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  data?: Maybe<Scalars['json']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['bpchar']['output'];
  is_system_message: Scalars['Boolean']['output'];
  message_type: Scalars['String']['output'];
  pin_status?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  sender?: Maybe<Users>;
  sender_id?: Maybe<Scalars['bpchar']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "chat_messages" */
export type Chat_MessagesDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "chat_messages" */
export type Chat_Messages_Aggregate = {
  __typename?: 'chat_messages_aggregate';
  aggregate?: Maybe<Chat_Messages_Aggregate_Fields>;
  nodes: Array<Chat_Messages>;
};

export type Chat_Messages_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Chat_Messages_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Chat_Messages_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Chat_Messages_Aggregate_Bool_Exp_Count>;
};

export type Chat_Messages_Aggregate_Bool_Exp_Bool_And = {
  arguments: Chat_Messages_Select_Column_Chat_Messages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Chat_Messages_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Chat_Messages_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Chat_Messages_Select_Column_Chat_Messages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Chat_Messages_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Chat_Messages_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Chat_Messages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Chat_Messages_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "chat_messages" */
export type Chat_Messages_Aggregate_Fields = {
  __typename?: 'chat_messages_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Chat_Messages_Max_Fields>;
  min?: Maybe<Chat_Messages_Min_Fields>;
};


/** aggregate fields of "chat_messages" */
export type Chat_Messages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Chat_Messages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "chat_messages" */
export type Chat_Messages_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Chat_Messages_Max_Order_By>;
  min?: InputMaybe<Chat_Messages_Min_Order_By>;
};

/** input type for inserting array relation for remote table "chat_messages" */
export type Chat_Messages_Arr_Rel_Insert_Input = {
  data: Array<Chat_Messages_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Chat_Messages_On_Conflict>;
};

/** Boolean expression to filter rows from the table "chat_messages". All fields are combined with a logical 'AND'. */
export type Chat_Messages_Bool_Exp = {
  _and?: InputMaybe<Array<Chat_Messages_Bool_Exp>>;
  _not?: InputMaybe<Chat_Messages_Bool_Exp>;
  _or?: InputMaybe<Array<Chat_Messages_Bool_Exp>>;
  chat_thread?: InputMaybe<Chat_Threads_Bool_Exp>;
  chat_thread_id?: InputMaybe<Bpchar_Comparison_Exp>;
  content?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Json_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  is_system_message?: InputMaybe<Boolean_Comparison_Exp>;
  message_type?: InputMaybe<String_Comparison_Exp>;
  pin_status?: InputMaybe<String_Comparison_Exp>;
  sender?: InputMaybe<Users_Bool_Exp>;
  sender_id?: InputMaybe<Bpchar_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "chat_messages" */
export enum Chat_Messages_Constraint {
  /** unique or primary key constraint on columns "id" */
  ChatMessagesPkey = 'chat_messages_pkey'
}

/** input type for inserting data into table "chat_messages" */
export type Chat_Messages_Insert_Input = {
  chat_thread?: InputMaybe<Chat_Threads_Obj_Rel_Insert_Input>;
  chat_thread_id?: InputMaybe<Scalars['bpchar']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  is_system_message?: InputMaybe<Scalars['Boolean']['input']>;
  message_type?: InputMaybe<Scalars['String']['input']>;
  pin_status?: InputMaybe<Scalars['String']['input']>;
  sender?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  sender_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Chat_Messages_Max_Fields = {
  __typename?: 'chat_messages_max_fields';
  chat_thread_id?: Maybe<Scalars['bpchar']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  message_type?: Maybe<Scalars['String']['output']>;
  pin_status?: Maybe<Scalars['String']['output']>;
  sender_id?: Maybe<Scalars['bpchar']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "chat_messages" */
export type Chat_Messages_Max_Order_By = {
  chat_thread_id?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_type?: InputMaybe<Order_By>;
  pin_status?: InputMaybe<Order_By>;
  sender_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Chat_Messages_Min_Fields = {
  __typename?: 'chat_messages_min_fields';
  chat_thread_id?: Maybe<Scalars['bpchar']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  message_type?: Maybe<Scalars['String']['output']>;
  pin_status?: Maybe<Scalars['String']['output']>;
  sender_id?: Maybe<Scalars['bpchar']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "chat_messages" */
export type Chat_Messages_Min_Order_By = {
  chat_thread_id?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_type?: InputMaybe<Order_By>;
  pin_status?: InputMaybe<Order_By>;
  sender_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "chat_messages" */
export type Chat_Messages_Mutation_Response = {
  __typename?: 'chat_messages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Chat_Messages>;
};

/** on_conflict condition type for table "chat_messages" */
export type Chat_Messages_On_Conflict = {
  constraint: Chat_Messages_Constraint;
  update_columns?: Array<Chat_Messages_Update_Column>;
  where?: InputMaybe<Chat_Messages_Bool_Exp>;
};

/** Ordering options when selecting data from "chat_messages". */
export type Chat_Messages_Order_By = {
  chat_thread?: InputMaybe<Chat_Threads_Order_By>;
  chat_thread_id?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_system_message?: InputMaybe<Order_By>;
  message_type?: InputMaybe<Order_By>;
  pin_status?: InputMaybe<Order_By>;
  sender?: InputMaybe<Users_Order_By>;
  sender_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: chat_messages */
export type Chat_Messages_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** select columns of table "chat_messages" */
export enum Chat_Messages_Select_Column {
  /** column name */
  ChatThreadId = 'chat_thread_id',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsSystemMessage = 'is_system_message',
  /** column name */
  MessageType = 'message_type',
  /** column name */
  PinStatus = 'pin_status',
  /** column name */
  SenderId = 'sender_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "chat_messages_aggregate_bool_exp_bool_and_arguments_columns" columns of table "chat_messages" */
export enum Chat_Messages_Select_Column_Chat_Messages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsSystemMessage = 'is_system_message'
}

/** select "chat_messages_aggregate_bool_exp_bool_or_arguments_columns" columns of table "chat_messages" */
export enum Chat_Messages_Select_Column_Chat_Messages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsSystemMessage = 'is_system_message'
}

/** input type for updating data in table "chat_messages" */
export type Chat_Messages_Set_Input = {
  chat_thread_id?: InputMaybe<Scalars['bpchar']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  is_system_message?: InputMaybe<Scalars['Boolean']['input']>;
  message_type?: InputMaybe<Scalars['String']['input']>;
  pin_status?: InputMaybe<Scalars['String']['input']>;
  sender_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "chat_messages" */
export type Chat_Messages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Chat_Messages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Chat_Messages_Stream_Cursor_Value_Input = {
  chat_thread_id?: InputMaybe<Scalars['bpchar']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  is_system_message?: InputMaybe<Scalars['Boolean']['input']>;
  message_type?: InputMaybe<Scalars['String']['input']>;
  pin_status?: InputMaybe<Scalars['String']['input']>;
  sender_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "chat_messages" */
export enum Chat_Messages_Update_Column {
  /** column name */
  ChatThreadId = 'chat_thread_id',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsSystemMessage = 'is_system_message',
  /** column name */
  MessageType = 'message_type',
  /** column name */
  PinStatus = 'pin_status',
  /** column name */
  SenderId = 'sender_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Chat_Messages_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Chat_Messages_Set_Input>;
  /** filter the rows which have to be updated */
  where: Chat_Messages_Bool_Exp;
};

/** columns and relationships of "chat_participants" */
export type Chat_Participants = {
  __typename?: 'chat_participants';
  chat_thread_id: Scalars['bpchar']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['bpchar']['output'];
  last_active_at?: Maybe<Scalars['timestamptz']['output']>;
  last_read_at?: Maybe<Scalars['timestamptz']['output']>;
  muted: Scalars['Boolean']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['bpchar']['output'];
};

/** aggregated selection of "chat_participants" */
export type Chat_Participants_Aggregate = {
  __typename?: 'chat_participants_aggregate';
  aggregate?: Maybe<Chat_Participants_Aggregate_Fields>;
  nodes: Array<Chat_Participants>;
};

export type Chat_Participants_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Chat_Participants_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Chat_Participants_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Chat_Participants_Aggregate_Bool_Exp_Count>;
};

export type Chat_Participants_Aggregate_Bool_Exp_Bool_And = {
  arguments: Chat_Participants_Select_Column_Chat_Participants_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Chat_Participants_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Chat_Participants_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Chat_Participants_Select_Column_Chat_Participants_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Chat_Participants_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Chat_Participants_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Chat_Participants_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Chat_Participants_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "chat_participants" */
export type Chat_Participants_Aggregate_Fields = {
  __typename?: 'chat_participants_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Chat_Participants_Max_Fields>;
  min?: Maybe<Chat_Participants_Min_Fields>;
};


/** aggregate fields of "chat_participants" */
export type Chat_Participants_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Chat_Participants_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "chat_participants" */
export type Chat_Participants_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Chat_Participants_Max_Order_By>;
  min?: InputMaybe<Chat_Participants_Min_Order_By>;
};

/** input type for inserting array relation for remote table "chat_participants" */
export type Chat_Participants_Arr_Rel_Insert_Input = {
  data: Array<Chat_Participants_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Chat_Participants_On_Conflict>;
};

/** Boolean expression to filter rows from the table "chat_participants". All fields are combined with a logical 'AND'. */
export type Chat_Participants_Bool_Exp = {
  _and?: InputMaybe<Array<Chat_Participants_Bool_Exp>>;
  _not?: InputMaybe<Chat_Participants_Bool_Exp>;
  _or?: InputMaybe<Array<Chat_Participants_Bool_Exp>>;
  chat_thread_id?: InputMaybe<Bpchar_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  last_active_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_read_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  muted?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "chat_participants" */
export enum Chat_Participants_Constraint {
  /** unique or primary key constraint on columns "chat_thread_id", "user_id" */
  ChatParticipantsChatThreadIdUserIdUnique = 'chat_participants_chat_thread_id_user_id_unique',
  /** unique or primary key constraint on columns "id" */
  ChatParticipantsPkey = 'chat_participants_pkey'
}

/** input type for inserting data into table "chat_participants" */
export type Chat_Participants_Insert_Input = {
  chat_thread_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  last_active_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_read_at?: InputMaybe<Scalars['timestamptz']['input']>;
  muted?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Chat_Participants_Max_Fields = {
  __typename?: 'chat_participants_max_fields';
  chat_thread_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  last_active_at?: Maybe<Scalars['timestamptz']['output']>;
  last_read_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by max() on columns of table "chat_participants" */
export type Chat_Participants_Max_Order_By = {
  chat_thread_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_active_at?: InputMaybe<Order_By>;
  last_read_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Chat_Participants_Min_Fields = {
  __typename?: 'chat_participants_min_fields';
  chat_thread_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  last_active_at?: Maybe<Scalars['timestamptz']['output']>;
  last_read_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by min() on columns of table "chat_participants" */
export type Chat_Participants_Min_Order_By = {
  chat_thread_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_active_at?: InputMaybe<Order_By>;
  last_read_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "chat_participants" */
export type Chat_Participants_Mutation_Response = {
  __typename?: 'chat_participants_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Chat_Participants>;
};

/** on_conflict condition type for table "chat_participants" */
export type Chat_Participants_On_Conflict = {
  constraint: Chat_Participants_Constraint;
  update_columns?: Array<Chat_Participants_Update_Column>;
  where?: InputMaybe<Chat_Participants_Bool_Exp>;
};

/** Ordering options when selecting data from "chat_participants". */
export type Chat_Participants_Order_By = {
  chat_thread_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_active_at?: InputMaybe<Order_By>;
  last_read_at?: InputMaybe<Order_By>;
  muted?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: chat_participants */
export type Chat_Participants_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** select columns of table "chat_participants" */
export enum Chat_Participants_Select_Column {
  /** column name */
  ChatThreadId = 'chat_thread_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastActiveAt = 'last_active_at',
  /** column name */
  LastReadAt = 'last_read_at',
  /** column name */
  Muted = 'muted',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "chat_participants_aggregate_bool_exp_bool_and_arguments_columns" columns of table "chat_participants" */
export enum Chat_Participants_Select_Column_Chat_Participants_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Muted = 'muted'
}

/** select "chat_participants_aggregate_bool_exp_bool_or_arguments_columns" columns of table "chat_participants" */
export enum Chat_Participants_Select_Column_Chat_Participants_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Muted = 'muted'
}

/** input type for updating data in table "chat_participants" */
export type Chat_Participants_Set_Input = {
  chat_thread_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  last_active_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_read_at?: InputMaybe<Scalars['timestamptz']['input']>;
  muted?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** Streaming cursor of the table "chat_participants" */
export type Chat_Participants_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Chat_Participants_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Chat_Participants_Stream_Cursor_Value_Input = {
  chat_thread_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  last_active_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_read_at?: InputMaybe<Scalars['timestamptz']['input']>;
  muted?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** update columns of table "chat_participants" */
export enum Chat_Participants_Update_Column {
  /** column name */
  ChatThreadId = 'chat_thread_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastActiveAt = 'last_active_at',
  /** column name */
  LastReadAt = 'last_read_at',
  /** column name */
  Muted = 'muted',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Chat_Participants_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Chat_Participants_Set_Input>;
  /** filter the rows which have to be updated */
  where: Chat_Participants_Bool_Exp;
};

/** columns and relationships of "chat_threads" */
export type Chat_Threads = {
  __typename?: 'chat_threads';
  /** An array relationship */
  chat_participants: Array<Chat_Participants>;
  /** An aggregate relationship */
  chat_participants_aggregate: Chat_Participants_Aggregate;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  data?: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['bpchar']['output'];
  /** An array relationship */
  messages: Array<Chat_Messages>;
  /** An aggregate relationship */
  messages_aggregate: Chat_Messages_Aggregate;
  status: Scalars['String']['output'];
  threadable_id?: Maybe<Scalars['bpchar']['output']>;
  threadable_type?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "chat_threads" */
export type Chat_ThreadsChat_ParticipantsArgs = {
  distinct_on?: InputMaybe<Array<Chat_Participants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Participants_Order_By>>;
  where?: InputMaybe<Chat_Participants_Bool_Exp>;
};


/** columns and relationships of "chat_threads" */
export type Chat_ThreadsChat_Participants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Participants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Participants_Order_By>>;
  where?: InputMaybe<Chat_Participants_Bool_Exp>;
};


/** columns and relationships of "chat_threads" */
export type Chat_ThreadsDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "chat_threads" */
export type Chat_ThreadsMessagesArgs = {
  distinct_on?: InputMaybe<Array<Chat_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Messages_Order_By>>;
  where?: InputMaybe<Chat_Messages_Bool_Exp>;
};


/** columns and relationships of "chat_threads" */
export type Chat_ThreadsMessages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Messages_Order_By>>;
  where?: InputMaybe<Chat_Messages_Bool_Exp>;
};

/** aggregated selection of "chat_threads" */
export type Chat_Threads_Aggregate = {
  __typename?: 'chat_threads_aggregate';
  aggregate?: Maybe<Chat_Threads_Aggregate_Fields>;
  nodes: Array<Chat_Threads>;
};

/** aggregate fields of "chat_threads" */
export type Chat_Threads_Aggregate_Fields = {
  __typename?: 'chat_threads_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Chat_Threads_Max_Fields>;
  min?: Maybe<Chat_Threads_Min_Fields>;
};


/** aggregate fields of "chat_threads" */
export type Chat_Threads_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Chat_Threads_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Chat_Threads_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "chat_threads". All fields are combined with a logical 'AND'. */
export type Chat_Threads_Bool_Exp = {
  _and?: InputMaybe<Array<Chat_Threads_Bool_Exp>>;
  _not?: InputMaybe<Chat_Threads_Bool_Exp>;
  _or?: InputMaybe<Array<Chat_Threads_Bool_Exp>>;
  chat_participants?: InputMaybe<Chat_Participants_Bool_Exp>;
  chat_participants_aggregate?: InputMaybe<Chat_Participants_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  messages?: InputMaybe<Chat_Messages_Bool_Exp>;
  messages_aggregate?: InputMaybe<Chat_Messages_Aggregate_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  threadable_id?: InputMaybe<Bpchar_Comparison_Exp>;
  threadable_type?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "chat_threads" */
export enum Chat_Threads_Constraint {
  /** unique or primary key constraint on columns "id" */
  ChatThreadsPkey = 'chat_threads_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Chat_Threads_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Chat_Threads_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Chat_Threads_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "chat_threads" */
export type Chat_Threads_Insert_Input = {
  chat_participants?: InputMaybe<Chat_Participants_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  messages?: InputMaybe<Chat_Messages_Arr_Rel_Insert_Input>;
  status?: InputMaybe<Scalars['String']['input']>;
  threadable_id?: InputMaybe<Scalars['bpchar']['input']>;
  threadable_type?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Chat_Threads_Max_Fields = {
  __typename?: 'chat_threads_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  threadable_id?: Maybe<Scalars['bpchar']['output']>;
  threadable_type?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Chat_Threads_Min_Fields = {
  __typename?: 'chat_threads_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  threadable_id?: Maybe<Scalars['bpchar']['output']>;
  threadable_type?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "chat_threads" */
export type Chat_Threads_Mutation_Response = {
  __typename?: 'chat_threads_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Chat_Threads>;
};

/** input type for inserting object relation for remote table "chat_threads" */
export type Chat_Threads_Obj_Rel_Insert_Input = {
  data: Chat_Threads_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Chat_Threads_On_Conflict>;
};

/** on_conflict condition type for table "chat_threads" */
export type Chat_Threads_On_Conflict = {
  constraint: Chat_Threads_Constraint;
  update_columns?: Array<Chat_Threads_Update_Column>;
  where?: InputMaybe<Chat_Threads_Bool_Exp>;
};

/** Ordering options when selecting data from "chat_threads". */
export type Chat_Threads_Order_By = {
  chat_participants_aggregate?: InputMaybe<Chat_Participants_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  messages_aggregate?: InputMaybe<Chat_Messages_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  threadable_id?: InputMaybe<Order_By>;
  threadable_type?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: chat_threads */
export type Chat_Threads_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Chat_Threads_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "chat_threads" */
export enum Chat_Threads_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  ThreadableId = 'threadable_id',
  /** column name */
  ThreadableType = 'threadable_type',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "chat_threads" */
export type Chat_Threads_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  threadable_id?: InputMaybe<Scalars['bpchar']['input']>;
  threadable_type?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "chat_threads" */
export type Chat_Threads_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Chat_Threads_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Chat_Threads_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  threadable_id?: InputMaybe<Scalars['bpchar']['input']>;
  threadable_type?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "chat_threads" */
export enum Chat_Threads_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  ThreadableId = 'threadable_id',
  /** column name */
  ThreadableType = 'threadable_type',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Chat_Threads_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Chat_Threads_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Chat_Threads_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Chat_Threads_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Chat_Threads_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Chat_Threads_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Chat_Threads_Set_Input>;
  /** filter the rows which have to be updated */
  where: Chat_Threads_Bool_Exp;
};

/** columns and relationships of "companies" */
export type Companies = {
  __typename?: 'companies';
  /** An array relationship */
  accounts: Array<Accounts>;
  /** An aggregate relationship */
  accounts_aggregate: Accounts_Aggregate;
  admin_user_id: Scalars['bpchar']['output'];
  company_verified_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['bpchar']['output'];
  name: Scalars['String']['output'];
  pandoforce_company_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  user: Users;
};


/** columns and relationships of "companies" */
export type CompaniesAccountsArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Accounts_Order_By>>;
  where?: InputMaybe<Accounts_Bool_Exp>;
};


/** columns and relationships of "companies" */
export type CompaniesAccounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Accounts_Order_By>>;
  where?: InputMaybe<Accounts_Bool_Exp>;
};

/** aggregated selection of "companies" */
export type Companies_Aggregate = {
  __typename?: 'companies_aggregate';
  aggregate?: Maybe<Companies_Aggregate_Fields>;
  nodes: Array<Companies>;
};

export type Companies_Aggregate_Bool_Exp = {
  count?: InputMaybe<Companies_Aggregate_Bool_Exp_Count>;
};

export type Companies_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Companies_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Companies_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "companies" */
export type Companies_Aggregate_Fields = {
  __typename?: 'companies_aggregate_fields';
  avg?: Maybe<Companies_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Companies_Max_Fields>;
  min?: Maybe<Companies_Min_Fields>;
  stddev?: Maybe<Companies_Stddev_Fields>;
  stddev_pop?: Maybe<Companies_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Companies_Stddev_Samp_Fields>;
  sum?: Maybe<Companies_Sum_Fields>;
  var_pop?: Maybe<Companies_Var_Pop_Fields>;
  var_samp?: Maybe<Companies_Var_Samp_Fields>;
  variance?: Maybe<Companies_Variance_Fields>;
};


/** aggregate fields of "companies" */
export type Companies_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Companies_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "companies" */
export type Companies_Aggregate_Order_By = {
  avg?: InputMaybe<Companies_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Companies_Max_Order_By>;
  min?: InputMaybe<Companies_Min_Order_By>;
  stddev?: InputMaybe<Companies_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Companies_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Companies_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Companies_Sum_Order_By>;
  var_pop?: InputMaybe<Companies_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Companies_Var_Samp_Order_By>;
  variance?: InputMaybe<Companies_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "companies" */
export type Companies_Arr_Rel_Insert_Input = {
  data: Array<Companies_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Companies_On_Conflict>;
};

/** aggregate avg on columns */
export type Companies_Avg_Fields = {
  __typename?: 'companies_avg_fields';
  pandoforce_company_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "companies" */
export type Companies_Avg_Order_By = {
  pandoforce_company_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "companies". All fields are combined with a logical 'AND'. */
export type Companies_Bool_Exp = {
  _and?: InputMaybe<Array<Companies_Bool_Exp>>;
  _not?: InputMaybe<Companies_Bool_Exp>;
  _or?: InputMaybe<Array<Companies_Bool_Exp>>;
  accounts?: InputMaybe<Accounts_Bool_Exp>;
  accounts_aggregate?: InputMaybe<Accounts_Aggregate_Bool_Exp>;
  admin_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  company_verified_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  pandoforce_company_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "companies" */
export enum Companies_Constraint {
  /** unique or primary key constraint on columns "id" */
  CompaniesPkey = 'companies_pkey'
}

/** input type for incrementing numeric columns in table "companies" */
export type Companies_Inc_Input = {
  pandoforce_company_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "companies" */
export type Companies_Insert_Input = {
  accounts?: InputMaybe<Accounts_Arr_Rel_Insert_Input>;
  admin_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  company_verified_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pandoforce_company_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Companies_Max_Fields = {
  __typename?: 'companies_max_fields';
  admin_user_id?: Maybe<Scalars['bpchar']['output']>;
  company_verified_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pandoforce_company_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "companies" */
export type Companies_Max_Order_By = {
  admin_user_id?: InputMaybe<Order_By>;
  company_verified_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  pandoforce_company_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Companies_Min_Fields = {
  __typename?: 'companies_min_fields';
  admin_user_id?: Maybe<Scalars['bpchar']['output']>;
  company_verified_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pandoforce_company_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "companies" */
export type Companies_Min_Order_By = {
  admin_user_id?: InputMaybe<Order_By>;
  company_verified_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  pandoforce_company_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "companies" */
export type Companies_Mutation_Response = {
  __typename?: 'companies_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Companies>;
};

/** input type for inserting object relation for remote table "companies" */
export type Companies_Obj_Rel_Insert_Input = {
  data: Companies_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Companies_On_Conflict>;
};

/** on_conflict condition type for table "companies" */
export type Companies_On_Conflict = {
  constraint: Companies_Constraint;
  update_columns?: Array<Companies_Update_Column>;
  where?: InputMaybe<Companies_Bool_Exp>;
};

/** Ordering options when selecting data from "companies". */
export type Companies_Order_By = {
  accounts_aggregate?: InputMaybe<Accounts_Aggregate_Order_By>;
  admin_user_id?: InputMaybe<Order_By>;
  company_verified_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  pandoforce_company_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: companies */
export type Companies_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** select columns of table "companies" */
export enum Companies_Select_Column {
  /** column name */
  AdminUserId = 'admin_user_id',
  /** column name */
  CompanyVerifiedAt = 'company_verified_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PandoforceCompanyId = 'pandoforce_company_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "companies" */
export type Companies_Set_Input = {
  admin_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  company_verified_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pandoforce_company_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Companies_Stddev_Fields = {
  __typename?: 'companies_stddev_fields';
  pandoforce_company_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "companies" */
export type Companies_Stddev_Order_By = {
  pandoforce_company_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Companies_Stddev_Pop_Fields = {
  __typename?: 'companies_stddev_pop_fields';
  pandoforce_company_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "companies" */
export type Companies_Stddev_Pop_Order_By = {
  pandoforce_company_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Companies_Stddev_Samp_Fields = {
  __typename?: 'companies_stddev_samp_fields';
  pandoforce_company_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "companies" */
export type Companies_Stddev_Samp_Order_By = {
  pandoforce_company_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "companies" */
export type Companies_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Companies_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Companies_Stream_Cursor_Value_Input = {
  admin_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  company_verified_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pandoforce_company_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Companies_Sum_Fields = {
  __typename?: 'companies_sum_fields';
  pandoforce_company_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "companies" */
export type Companies_Sum_Order_By = {
  pandoforce_company_id?: InputMaybe<Order_By>;
};

/** update columns of table "companies" */
export enum Companies_Update_Column {
  /** column name */
  AdminUserId = 'admin_user_id',
  /** column name */
  CompanyVerifiedAt = 'company_verified_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PandoforceCompanyId = 'pandoforce_company_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Companies_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Companies_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Companies_Set_Input>;
  /** filter the rows which have to be updated */
  where: Companies_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Companies_Var_Pop_Fields = {
  __typename?: 'companies_var_pop_fields';
  pandoforce_company_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "companies" */
export type Companies_Var_Pop_Order_By = {
  pandoforce_company_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Companies_Var_Samp_Fields = {
  __typename?: 'companies_var_samp_fields';
  pandoforce_company_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "companies" */
export type Companies_Var_Samp_Order_By = {
  pandoforce_company_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Companies_Variance_Fields = {
  __typename?: 'companies_variance_fields';
  pandoforce_company_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "companies" */
export type Companies_Variance_Order_By = {
  pandoforce_company_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "creator_onboarding" */
export type Creator_Onboarding = {
  __typename?: 'creator_onboarding';
  account_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fb_link?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  ig_link?: Maybe<Scalars['String']['output']>;
  intro?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id: Scalars['bpchar']['output'];
  yt_link?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "creator_onboarding" */
export type Creator_Onboarding_Aggregate = {
  __typename?: 'creator_onboarding_aggregate';
  aggregate?: Maybe<Creator_Onboarding_Aggregate_Fields>;
  nodes: Array<Creator_Onboarding>;
};

/** aggregate fields of "creator_onboarding" */
export type Creator_Onboarding_Aggregate_Fields = {
  __typename?: 'creator_onboarding_aggregate_fields';
  avg?: Maybe<Creator_Onboarding_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Creator_Onboarding_Max_Fields>;
  min?: Maybe<Creator_Onboarding_Min_Fields>;
  stddev?: Maybe<Creator_Onboarding_Stddev_Fields>;
  stddev_pop?: Maybe<Creator_Onboarding_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Creator_Onboarding_Stddev_Samp_Fields>;
  sum?: Maybe<Creator_Onboarding_Sum_Fields>;
  var_pop?: Maybe<Creator_Onboarding_Var_Pop_Fields>;
  var_samp?: Maybe<Creator_Onboarding_Var_Samp_Fields>;
  variance?: Maybe<Creator_Onboarding_Variance_Fields>;
};


/** aggregate fields of "creator_onboarding" */
export type Creator_Onboarding_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Creator_Onboarding_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Creator_Onboarding_Avg_Fields = {
  __typename?: 'creator_onboarding_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "creator_onboarding". All fields are combined with a logical 'AND'. */
export type Creator_Onboarding_Bool_Exp = {
  _and?: InputMaybe<Array<Creator_Onboarding_Bool_Exp>>;
  _not?: InputMaybe<Creator_Onboarding_Bool_Exp>;
  _or?: InputMaybe<Array<Creator_Onboarding_Bool_Exp>>;
  account_name?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  fb_link?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  ig_link?: InputMaybe<String_Comparison_Exp>;
  intro?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  yt_link?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "creator_onboarding" */
export enum Creator_Onboarding_Constraint {
  /** unique or primary key constraint on columns "id" */
  CreatorOnboardingPkey = 'creator_onboarding_pkey',
  /** unique or primary key constraint on columns "user_id", "deleted_at" */
  CreatorOnboardingUserIdIdx = 'creator_onboarding_user_id_idx'
}

/** input type for incrementing numeric columns in table "creator_onboarding" */
export type Creator_Onboarding_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "creator_onboarding" */
export type Creator_Onboarding_Insert_Input = {
  account_name?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fb_link?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  ig_link?: InputMaybe<Scalars['String']['input']>;
  intro?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
  yt_link?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Creator_Onboarding_Max_Fields = {
  __typename?: 'creator_onboarding_max_fields';
  account_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fb_link?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  ig_link?: Maybe<Scalars['String']['output']>;
  intro?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
  yt_link?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Creator_Onboarding_Min_Fields = {
  __typename?: 'creator_onboarding_min_fields';
  account_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fb_link?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  ig_link?: Maybe<Scalars['String']['output']>;
  intro?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
  yt_link?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "creator_onboarding" */
export type Creator_Onboarding_Mutation_Response = {
  __typename?: 'creator_onboarding_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Creator_Onboarding>;
};

/** input type for inserting object relation for remote table "creator_onboarding" */
export type Creator_Onboarding_Obj_Rel_Insert_Input = {
  data: Creator_Onboarding_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Creator_Onboarding_On_Conflict>;
};

/** on_conflict condition type for table "creator_onboarding" */
export type Creator_Onboarding_On_Conflict = {
  constraint: Creator_Onboarding_Constraint;
  update_columns?: Array<Creator_Onboarding_Update_Column>;
  where?: InputMaybe<Creator_Onboarding_Bool_Exp>;
};

/** Ordering options when selecting data from "creator_onboarding". */
export type Creator_Onboarding_Order_By = {
  account_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  fb_link?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ig_link?: InputMaybe<Order_By>;
  intro?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  yt_link?: InputMaybe<Order_By>;
};

/** primary key columns input for table: creator_onboarding */
export type Creator_Onboarding_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "creator_onboarding" */
export enum Creator_Onboarding_Select_Column {
  /** column name */
  AccountName = 'account_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Email = 'email',
  /** column name */
  FbLink = 'fb_link',
  /** column name */
  Id = 'id',
  /** column name */
  IgLink = 'ig_link',
  /** column name */
  Intro = 'intro',
  /** column name */
  Name = 'name',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  YtLink = 'yt_link'
}

/** input type for updating data in table "creator_onboarding" */
export type Creator_Onboarding_Set_Input = {
  account_name?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fb_link?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  ig_link?: InputMaybe<Scalars['String']['input']>;
  intro?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
  yt_link?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Creator_Onboarding_Stddev_Fields = {
  __typename?: 'creator_onboarding_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Creator_Onboarding_Stddev_Pop_Fields = {
  __typename?: 'creator_onboarding_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Creator_Onboarding_Stddev_Samp_Fields = {
  __typename?: 'creator_onboarding_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "creator_onboarding" */
export type Creator_Onboarding_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Creator_Onboarding_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Creator_Onboarding_Stream_Cursor_Value_Input = {
  account_name?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fb_link?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  ig_link?: InputMaybe<Scalars['String']['input']>;
  intro?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
  yt_link?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Creator_Onboarding_Sum_Fields = {
  __typename?: 'creator_onboarding_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "creator_onboarding" */
export enum Creator_Onboarding_Update_Column {
  /** column name */
  AccountName = 'account_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Email = 'email',
  /** column name */
  FbLink = 'fb_link',
  /** column name */
  Id = 'id',
  /** column name */
  IgLink = 'ig_link',
  /** column name */
  Intro = 'intro',
  /** column name */
  Name = 'name',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  YtLink = 'yt_link'
}

export type Creator_Onboarding_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Creator_Onboarding_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Creator_Onboarding_Set_Input>;
  /** filter the rows which have to be updated */
  where: Creator_Onboarding_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Creator_Onboarding_Var_Pop_Fields = {
  __typename?: 'creator_onboarding_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Creator_Onboarding_Var_Samp_Fields = {
  __typename?: 'creator_onboarding_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Creator_Onboarding_Variance_Fields = {
  __typename?: 'creator_onboarding_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "crm_account_channel_crop_prospects" */
export type Crm_Account_Channel_Crop_Prospects = {
  __typename?: 'crm_account_channel_crop_prospects';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  channel_id?: Maybe<Scalars['bigint']['output']>;
  crop_id?: Maybe<Scalars['bpchar']['output']>;
  interaction_type?: Maybe<Scalars['String']['output']>;
  latest_interaction_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  prospect?: Maybe<Prospects>;
  prospect_id?: Maybe<Scalars['bpchar']['output']>;
  /** An object relationship */
  reel_comment?: Maybe<Reel_Comments>;
  reel_comment_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "crm_account_channel_crop_prospects" */
export type Crm_Account_Channel_Crop_Prospects_Aggregate = {
  __typename?: 'crm_account_channel_crop_prospects_aggregate';
  aggregate?: Maybe<Crm_Account_Channel_Crop_Prospects_Aggregate_Fields>;
  nodes: Array<Crm_Account_Channel_Crop_Prospects>;
};

/** aggregate fields of "crm_account_channel_crop_prospects" */
export type Crm_Account_Channel_Crop_Prospects_Aggregate_Fields = {
  __typename?: 'crm_account_channel_crop_prospects_aggregate_fields';
  avg?: Maybe<Crm_Account_Channel_Crop_Prospects_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Crm_Account_Channel_Crop_Prospects_Max_Fields>;
  min?: Maybe<Crm_Account_Channel_Crop_Prospects_Min_Fields>;
  stddev?: Maybe<Crm_Account_Channel_Crop_Prospects_Stddev_Fields>;
  stddev_pop?: Maybe<Crm_Account_Channel_Crop_Prospects_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Crm_Account_Channel_Crop_Prospects_Stddev_Samp_Fields>;
  sum?: Maybe<Crm_Account_Channel_Crop_Prospects_Sum_Fields>;
  var_pop?: Maybe<Crm_Account_Channel_Crop_Prospects_Var_Pop_Fields>;
  var_samp?: Maybe<Crm_Account_Channel_Crop_Prospects_Var_Samp_Fields>;
  variance?: Maybe<Crm_Account_Channel_Crop_Prospects_Variance_Fields>;
};


/** aggregate fields of "crm_account_channel_crop_prospects" */
export type Crm_Account_Channel_Crop_Prospects_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Crm_Account_Channel_Crop_Prospects_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Crm_Account_Channel_Crop_Prospects_Avg_Fields = {
  __typename?: 'crm_account_channel_crop_prospects_avg_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  reel_comment_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "crm_account_channel_crop_prospects". All fields are combined with a logical 'AND'. */
export type Crm_Account_Channel_Crop_Prospects_Bool_Exp = {
  _and?: InputMaybe<Array<Crm_Account_Channel_Crop_Prospects_Bool_Exp>>;
  _not?: InputMaybe<Crm_Account_Channel_Crop_Prospects_Bool_Exp>;
  _or?: InputMaybe<Array<Crm_Account_Channel_Crop_Prospects_Bool_Exp>>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  channel_id?: InputMaybe<Bigint_Comparison_Exp>;
  crop_id?: InputMaybe<Bpchar_Comparison_Exp>;
  interaction_type?: InputMaybe<String_Comparison_Exp>;
  latest_interaction_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  prospect?: InputMaybe<Prospects_Bool_Exp>;
  prospect_id?: InputMaybe<Bpchar_Comparison_Exp>;
  reel_comment?: InputMaybe<Reel_Comments_Bool_Exp>;
  reel_comment_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Crm_Account_Channel_Crop_Prospects_Max_Fields = {
  __typename?: 'crm_account_channel_crop_prospects_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  channel_id?: Maybe<Scalars['bigint']['output']>;
  crop_id?: Maybe<Scalars['bpchar']['output']>;
  interaction_type?: Maybe<Scalars['String']['output']>;
  latest_interaction_at?: Maybe<Scalars['timestamptz']['output']>;
  prospect_id?: Maybe<Scalars['bpchar']['output']>;
  reel_comment_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Crm_Account_Channel_Crop_Prospects_Min_Fields = {
  __typename?: 'crm_account_channel_crop_prospects_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  channel_id?: Maybe<Scalars['bigint']['output']>;
  crop_id?: Maybe<Scalars['bpchar']['output']>;
  interaction_type?: Maybe<Scalars['String']['output']>;
  latest_interaction_at?: Maybe<Scalars['timestamptz']['output']>;
  prospect_id?: Maybe<Scalars['bpchar']['output']>;
  reel_comment_id?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "crm_account_channel_crop_prospects". */
export type Crm_Account_Channel_Crop_Prospects_Order_By = {
  account_id?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  interaction_type?: InputMaybe<Order_By>;
  latest_interaction_at?: InputMaybe<Order_By>;
  prospect?: InputMaybe<Prospects_Order_By>;
  prospect_id?: InputMaybe<Order_By>;
  reel_comment?: InputMaybe<Reel_Comments_Order_By>;
  reel_comment_id?: InputMaybe<Order_By>;
};

/** select columns of table "crm_account_channel_crop_prospects" */
export enum Crm_Account_Channel_Crop_Prospects_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  ChannelId = 'channel_id',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  InteractionType = 'interaction_type',
  /** column name */
  LatestInteractionAt = 'latest_interaction_at',
  /** column name */
  ProspectId = 'prospect_id',
  /** column name */
  ReelCommentId = 'reel_comment_id'
}

/** aggregate stddev on columns */
export type Crm_Account_Channel_Crop_Prospects_Stddev_Fields = {
  __typename?: 'crm_account_channel_crop_prospects_stddev_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  reel_comment_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Crm_Account_Channel_Crop_Prospects_Stddev_Pop_Fields = {
  __typename?: 'crm_account_channel_crop_prospects_stddev_pop_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  reel_comment_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Crm_Account_Channel_Crop_Prospects_Stddev_Samp_Fields = {
  __typename?: 'crm_account_channel_crop_prospects_stddev_samp_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  reel_comment_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "crm_account_channel_crop_prospects" */
export type Crm_Account_Channel_Crop_Prospects_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Crm_Account_Channel_Crop_Prospects_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Crm_Account_Channel_Crop_Prospects_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  channel_id?: InputMaybe<Scalars['bigint']['input']>;
  crop_id?: InputMaybe<Scalars['bpchar']['input']>;
  interaction_type?: InputMaybe<Scalars['String']['input']>;
  latest_interaction_at?: InputMaybe<Scalars['timestamptz']['input']>;
  prospect_id?: InputMaybe<Scalars['bpchar']['input']>;
  reel_comment_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Crm_Account_Channel_Crop_Prospects_Sum_Fields = {
  __typename?: 'crm_account_channel_crop_prospects_sum_fields';
  channel_id?: Maybe<Scalars['bigint']['output']>;
  reel_comment_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Crm_Account_Channel_Crop_Prospects_Var_Pop_Fields = {
  __typename?: 'crm_account_channel_crop_prospects_var_pop_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  reel_comment_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Crm_Account_Channel_Crop_Prospects_Var_Samp_Fields = {
  __typename?: 'crm_account_channel_crop_prospects_var_samp_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  reel_comment_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Crm_Account_Channel_Crop_Prospects_Variance_Fields = {
  __typename?: 'crm_account_channel_crop_prospects_variance_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  reel_comment_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "crm_account_crop_wise_counts" */
export type Crm_Account_Crop_Wise_Counts = {
  __typename?: 'crm_account_crop_wise_counts';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  channel_id?: Maybe<Scalars['bigint']['output']>;
  crop_id?: Maybe<Scalars['bpchar']['output']>;
  crop_image_url?: Maybe<Scalars['String']['output']>;
  crop_name?: Maybe<Scalars['String']['output']>;
  latest_interaction_at?: Maybe<Scalars['timestamptz']['output']>;
  prospect_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "crm_account_crop_wise_counts" */
export type Crm_Account_Crop_Wise_Counts_Aggregate = {
  __typename?: 'crm_account_crop_wise_counts_aggregate';
  aggregate?: Maybe<Crm_Account_Crop_Wise_Counts_Aggregate_Fields>;
  nodes: Array<Crm_Account_Crop_Wise_Counts>;
};

/** aggregate fields of "crm_account_crop_wise_counts" */
export type Crm_Account_Crop_Wise_Counts_Aggregate_Fields = {
  __typename?: 'crm_account_crop_wise_counts_aggregate_fields';
  avg?: Maybe<Crm_Account_Crop_Wise_Counts_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Crm_Account_Crop_Wise_Counts_Max_Fields>;
  min?: Maybe<Crm_Account_Crop_Wise_Counts_Min_Fields>;
  stddev?: Maybe<Crm_Account_Crop_Wise_Counts_Stddev_Fields>;
  stddev_pop?: Maybe<Crm_Account_Crop_Wise_Counts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Crm_Account_Crop_Wise_Counts_Stddev_Samp_Fields>;
  sum?: Maybe<Crm_Account_Crop_Wise_Counts_Sum_Fields>;
  var_pop?: Maybe<Crm_Account_Crop_Wise_Counts_Var_Pop_Fields>;
  var_samp?: Maybe<Crm_Account_Crop_Wise_Counts_Var_Samp_Fields>;
  variance?: Maybe<Crm_Account_Crop_Wise_Counts_Variance_Fields>;
};


/** aggregate fields of "crm_account_crop_wise_counts" */
export type Crm_Account_Crop_Wise_Counts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Crm_Account_Crop_Wise_Counts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Crm_Account_Crop_Wise_Counts_Avg_Fields = {
  __typename?: 'crm_account_crop_wise_counts_avg_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  prospect_count?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "crm_account_crop_wise_counts". All fields are combined with a logical 'AND'. */
export type Crm_Account_Crop_Wise_Counts_Bool_Exp = {
  _and?: InputMaybe<Array<Crm_Account_Crop_Wise_Counts_Bool_Exp>>;
  _not?: InputMaybe<Crm_Account_Crop_Wise_Counts_Bool_Exp>;
  _or?: InputMaybe<Array<Crm_Account_Crop_Wise_Counts_Bool_Exp>>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  channel_id?: InputMaybe<Bigint_Comparison_Exp>;
  crop_id?: InputMaybe<Bpchar_Comparison_Exp>;
  crop_image_url?: InputMaybe<String_Comparison_Exp>;
  crop_name?: InputMaybe<String_Comparison_Exp>;
  latest_interaction_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  prospect_count?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Crm_Account_Crop_Wise_Counts_Max_Fields = {
  __typename?: 'crm_account_crop_wise_counts_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  channel_id?: Maybe<Scalars['bigint']['output']>;
  crop_id?: Maybe<Scalars['bpchar']['output']>;
  crop_image_url?: Maybe<Scalars['String']['output']>;
  crop_name?: Maybe<Scalars['String']['output']>;
  latest_interaction_at?: Maybe<Scalars['timestamptz']['output']>;
  prospect_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Crm_Account_Crop_Wise_Counts_Min_Fields = {
  __typename?: 'crm_account_crop_wise_counts_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  channel_id?: Maybe<Scalars['bigint']['output']>;
  crop_id?: Maybe<Scalars['bpchar']['output']>;
  crop_image_url?: Maybe<Scalars['String']['output']>;
  crop_name?: Maybe<Scalars['String']['output']>;
  latest_interaction_at?: Maybe<Scalars['timestamptz']['output']>;
  prospect_count?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "crm_account_crop_wise_counts". */
export type Crm_Account_Crop_Wise_Counts_Order_By = {
  account_id?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  crop_image_url?: InputMaybe<Order_By>;
  crop_name?: InputMaybe<Order_By>;
  latest_interaction_at?: InputMaybe<Order_By>;
  prospect_count?: InputMaybe<Order_By>;
};

/** select columns of table "crm_account_crop_wise_counts" */
export enum Crm_Account_Crop_Wise_Counts_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  ChannelId = 'channel_id',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  CropImageUrl = 'crop_image_url',
  /** column name */
  CropName = 'crop_name',
  /** column name */
  LatestInteractionAt = 'latest_interaction_at',
  /** column name */
  ProspectCount = 'prospect_count'
}

/** aggregate stddev on columns */
export type Crm_Account_Crop_Wise_Counts_Stddev_Fields = {
  __typename?: 'crm_account_crop_wise_counts_stddev_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  prospect_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Crm_Account_Crop_Wise_Counts_Stddev_Pop_Fields = {
  __typename?: 'crm_account_crop_wise_counts_stddev_pop_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  prospect_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Crm_Account_Crop_Wise_Counts_Stddev_Samp_Fields = {
  __typename?: 'crm_account_crop_wise_counts_stddev_samp_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  prospect_count?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "crm_account_crop_wise_counts" */
export type Crm_Account_Crop_Wise_Counts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Crm_Account_Crop_Wise_Counts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Crm_Account_Crop_Wise_Counts_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  channel_id?: InputMaybe<Scalars['bigint']['input']>;
  crop_id?: InputMaybe<Scalars['bpchar']['input']>;
  crop_image_url?: InputMaybe<Scalars['String']['input']>;
  crop_name?: InputMaybe<Scalars['String']['input']>;
  latest_interaction_at?: InputMaybe<Scalars['timestamptz']['input']>;
  prospect_count?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Crm_Account_Crop_Wise_Counts_Sum_Fields = {
  __typename?: 'crm_account_crop_wise_counts_sum_fields';
  channel_id?: Maybe<Scalars['bigint']['output']>;
  prospect_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Crm_Account_Crop_Wise_Counts_Var_Pop_Fields = {
  __typename?: 'crm_account_crop_wise_counts_var_pop_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  prospect_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Crm_Account_Crop_Wise_Counts_Var_Samp_Fields = {
  __typename?: 'crm_account_crop_wise_counts_var_samp_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  prospect_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Crm_Account_Crop_Wise_Counts_Variance_Fields = {
  __typename?: 'crm_account_crop_wise_counts_variance_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  prospect_count?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "crm_account_interaction_type_pending_counts" */
export type Crm_Account_Interaction_Type_Pending_Counts = {
  __typename?: 'crm_account_interaction_type_pending_counts';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  channel_id?: Maybe<Scalars['bigint']['output']>;
  crop_id?: Maybe<Scalars['bpchar']['output']>;
  interaction_type?: Maybe<Scalars['String']['output']>;
  pending_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "crm_account_interaction_type_pending_counts" */
export type Crm_Account_Interaction_Type_Pending_Counts_Aggregate = {
  __typename?: 'crm_account_interaction_type_pending_counts_aggregate';
  aggregate?: Maybe<Crm_Account_Interaction_Type_Pending_Counts_Aggregate_Fields>;
  nodes: Array<Crm_Account_Interaction_Type_Pending_Counts>;
};

/** aggregate fields of "crm_account_interaction_type_pending_counts" */
export type Crm_Account_Interaction_Type_Pending_Counts_Aggregate_Fields = {
  __typename?: 'crm_account_interaction_type_pending_counts_aggregate_fields';
  avg?: Maybe<Crm_Account_Interaction_Type_Pending_Counts_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Crm_Account_Interaction_Type_Pending_Counts_Max_Fields>;
  min?: Maybe<Crm_Account_Interaction_Type_Pending_Counts_Min_Fields>;
  stddev?: Maybe<Crm_Account_Interaction_Type_Pending_Counts_Stddev_Fields>;
  stddev_pop?: Maybe<Crm_Account_Interaction_Type_Pending_Counts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Crm_Account_Interaction_Type_Pending_Counts_Stddev_Samp_Fields>;
  sum?: Maybe<Crm_Account_Interaction_Type_Pending_Counts_Sum_Fields>;
  var_pop?: Maybe<Crm_Account_Interaction_Type_Pending_Counts_Var_Pop_Fields>;
  var_samp?: Maybe<Crm_Account_Interaction_Type_Pending_Counts_Var_Samp_Fields>;
  variance?: Maybe<Crm_Account_Interaction_Type_Pending_Counts_Variance_Fields>;
};


/** aggregate fields of "crm_account_interaction_type_pending_counts" */
export type Crm_Account_Interaction_Type_Pending_Counts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Crm_Account_Interaction_Type_Pending_Counts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Crm_Account_Interaction_Type_Pending_Counts_Avg_Fields = {
  __typename?: 'crm_account_interaction_type_pending_counts_avg_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  pending_count?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "crm_account_interaction_type_pending_counts". All fields are combined with a logical 'AND'. */
export type Crm_Account_Interaction_Type_Pending_Counts_Bool_Exp = {
  _and?: InputMaybe<Array<Crm_Account_Interaction_Type_Pending_Counts_Bool_Exp>>;
  _not?: InputMaybe<Crm_Account_Interaction_Type_Pending_Counts_Bool_Exp>;
  _or?: InputMaybe<Array<Crm_Account_Interaction_Type_Pending_Counts_Bool_Exp>>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  channel_id?: InputMaybe<Bigint_Comparison_Exp>;
  crop_id?: InputMaybe<Bpchar_Comparison_Exp>;
  interaction_type?: InputMaybe<String_Comparison_Exp>;
  pending_count?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Crm_Account_Interaction_Type_Pending_Counts_Max_Fields = {
  __typename?: 'crm_account_interaction_type_pending_counts_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  channel_id?: Maybe<Scalars['bigint']['output']>;
  crop_id?: Maybe<Scalars['bpchar']['output']>;
  interaction_type?: Maybe<Scalars['String']['output']>;
  pending_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Crm_Account_Interaction_Type_Pending_Counts_Min_Fields = {
  __typename?: 'crm_account_interaction_type_pending_counts_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  channel_id?: Maybe<Scalars['bigint']['output']>;
  crop_id?: Maybe<Scalars['bpchar']['output']>;
  interaction_type?: Maybe<Scalars['String']['output']>;
  pending_count?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "crm_account_interaction_type_pending_counts". */
export type Crm_Account_Interaction_Type_Pending_Counts_Order_By = {
  account_id?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  interaction_type?: InputMaybe<Order_By>;
  pending_count?: InputMaybe<Order_By>;
};

/** select columns of table "crm_account_interaction_type_pending_counts" */
export enum Crm_Account_Interaction_Type_Pending_Counts_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  ChannelId = 'channel_id',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  InteractionType = 'interaction_type',
  /** column name */
  PendingCount = 'pending_count'
}

/** aggregate stddev on columns */
export type Crm_Account_Interaction_Type_Pending_Counts_Stddev_Fields = {
  __typename?: 'crm_account_interaction_type_pending_counts_stddev_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  pending_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Crm_Account_Interaction_Type_Pending_Counts_Stddev_Pop_Fields = {
  __typename?: 'crm_account_interaction_type_pending_counts_stddev_pop_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  pending_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Crm_Account_Interaction_Type_Pending_Counts_Stddev_Samp_Fields = {
  __typename?: 'crm_account_interaction_type_pending_counts_stddev_samp_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  pending_count?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "crm_account_interaction_type_pending_counts" */
export type Crm_Account_Interaction_Type_Pending_Counts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Crm_Account_Interaction_Type_Pending_Counts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Crm_Account_Interaction_Type_Pending_Counts_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  channel_id?: InputMaybe<Scalars['bigint']['input']>;
  crop_id?: InputMaybe<Scalars['bpchar']['input']>;
  interaction_type?: InputMaybe<Scalars['String']['input']>;
  pending_count?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Crm_Account_Interaction_Type_Pending_Counts_Sum_Fields = {
  __typename?: 'crm_account_interaction_type_pending_counts_sum_fields';
  channel_id?: Maybe<Scalars['bigint']['output']>;
  pending_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Crm_Account_Interaction_Type_Pending_Counts_Var_Pop_Fields = {
  __typename?: 'crm_account_interaction_type_pending_counts_var_pop_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  pending_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Crm_Account_Interaction_Type_Pending_Counts_Var_Samp_Fields = {
  __typename?: 'crm_account_interaction_type_pending_counts_var_samp_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  pending_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Crm_Account_Interaction_Type_Pending_Counts_Variance_Fields = {
  __typename?: 'crm_account_interaction_type_pending_counts_variance_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  pending_count?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "crm_segments" */
export type Crm_Segments = {
  __typename?: 'crm_segments';
  account_id: Scalars['bpchar']['output'];
  company_id: Scalars['bpchar']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crm_type: Scalars['String']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  filter_data?: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['bpchar']['output'];
  matching_count?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id: Scalars['bpchar']['output'];
};


/** columns and relationships of "crm_segments" */
export type Crm_SegmentsFilter_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "crm_segments" */
export type Crm_Segments_Aggregate = {
  __typename?: 'crm_segments_aggregate';
  aggregate?: Maybe<Crm_Segments_Aggregate_Fields>;
  nodes: Array<Crm_Segments>;
};

/** aggregate fields of "crm_segments" */
export type Crm_Segments_Aggregate_Fields = {
  __typename?: 'crm_segments_aggregate_fields';
  avg?: Maybe<Crm_Segments_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Crm_Segments_Max_Fields>;
  min?: Maybe<Crm_Segments_Min_Fields>;
  stddev?: Maybe<Crm_Segments_Stddev_Fields>;
  stddev_pop?: Maybe<Crm_Segments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Crm_Segments_Stddev_Samp_Fields>;
  sum?: Maybe<Crm_Segments_Sum_Fields>;
  var_pop?: Maybe<Crm_Segments_Var_Pop_Fields>;
  var_samp?: Maybe<Crm_Segments_Var_Samp_Fields>;
  variance?: Maybe<Crm_Segments_Variance_Fields>;
};


/** aggregate fields of "crm_segments" */
export type Crm_Segments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Crm_Segments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Crm_Segments_Append_Input = {
  filter_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Crm_Segments_Avg_Fields = {
  __typename?: 'crm_segments_avg_fields';
  matching_count?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "crm_segments". All fields are combined with a logical 'AND'. */
export type Crm_Segments_Bool_Exp = {
  _and?: InputMaybe<Array<Crm_Segments_Bool_Exp>>;
  _not?: InputMaybe<Crm_Segments_Bool_Exp>;
  _or?: InputMaybe<Array<Crm_Segments_Bool_Exp>>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  company_id?: InputMaybe<Bpchar_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  crm_type?: InputMaybe<String_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  filter_data?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  matching_count?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "crm_segments" */
export enum Crm_Segments_Constraint {
  /** unique or primary key constraint on columns "id" */
  CrmSegmentsPkey = 'crm_segments_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Crm_Segments_Delete_At_Path_Input = {
  filter_data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Crm_Segments_Delete_Elem_Input = {
  filter_data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Crm_Segments_Delete_Key_Input = {
  filter_data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "crm_segments" */
export type Crm_Segments_Inc_Input = {
  matching_count?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "crm_segments" */
export type Crm_Segments_Insert_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crm_type?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  filter_data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  matching_count?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Crm_Segments_Max_Fields = {
  __typename?: 'crm_segments_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crm_type?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  matching_count?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** aggregate min on columns */
export type Crm_Segments_Min_Fields = {
  __typename?: 'crm_segments_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crm_type?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  matching_count?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** response of any mutation on the table "crm_segments" */
export type Crm_Segments_Mutation_Response = {
  __typename?: 'crm_segments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Crm_Segments>;
};

/** input type for inserting object relation for remote table "crm_segments" */
export type Crm_Segments_Obj_Rel_Insert_Input = {
  data: Crm_Segments_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Crm_Segments_On_Conflict>;
};

/** on_conflict condition type for table "crm_segments" */
export type Crm_Segments_On_Conflict = {
  constraint: Crm_Segments_Constraint;
  update_columns?: Array<Crm_Segments_Update_Column>;
  where?: InputMaybe<Crm_Segments_Bool_Exp>;
};

/** Ordering options when selecting data from "crm_segments". */
export type Crm_Segments_Order_By = {
  account_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crm_type?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  filter_data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  matching_count?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: crm_segments */
export type Crm_Segments_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Crm_Segments_Prepend_Input = {
  filter_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "crm_segments" */
export enum Crm_Segments_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CrmType = 'crm_type',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FilterData = 'filter_data',
  /** column name */
  Id = 'id',
  /** column name */
  MatchingCount = 'matching_count',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "crm_segments" */
export type Crm_Segments_Set_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crm_type?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  filter_data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  matching_count?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate stddev on columns */
export type Crm_Segments_Stddev_Fields = {
  __typename?: 'crm_segments_stddev_fields';
  matching_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Crm_Segments_Stddev_Pop_Fields = {
  __typename?: 'crm_segments_stddev_pop_fields';
  matching_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Crm_Segments_Stddev_Samp_Fields = {
  __typename?: 'crm_segments_stddev_samp_fields';
  matching_count?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "crm_segments" */
export type Crm_Segments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Crm_Segments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Crm_Segments_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crm_type?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  filter_data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  matching_count?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate sum on columns */
export type Crm_Segments_Sum_Fields = {
  __typename?: 'crm_segments_sum_fields';
  matching_count?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "crm_segments" */
export enum Crm_Segments_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CrmType = 'crm_type',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FilterData = 'filter_data',
  /** column name */
  Id = 'id',
  /** column name */
  MatchingCount = 'matching_count',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Crm_Segments_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Crm_Segments_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Crm_Segments_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Crm_Segments_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Crm_Segments_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Crm_Segments_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Crm_Segments_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Crm_Segments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Crm_Segments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Crm_Segments_Var_Pop_Fields = {
  __typename?: 'crm_segments_var_pop_fields';
  matching_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Crm_Segments_Var_Samp_Fields = {
  __typename?: 'crm_segments_var_samp_fields';
  matching_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Crm_Segments_Variance_Fields = {
  __typename?: 'crm_segments_variance_fields';
  matching_count?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "crop_user" */
export type Crop_User = {
  __typename?: 'crop_user';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crop_id: Scalars['bpchar']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['bigint']['output'];
  /** An object relationship */
  master_crop: Master_Crops;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['bpchar']['output'];
};

/** aggregated selection of "crop_user" */
export type Crop_User_Aggregate = {
  __typename?: 'crop_user_aggregate';
  aggregate?: Maybe<Crop_User_Aggregate_Fields>;
  nodes: Array<Crop_User>;
};

export type Crop_User_Aggregate_Bool_Exp = {
  count?: InputMaybe<Crop_User_Aggregate_Bool_Exp_Count>;
};

export type Crop_User_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Crop_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Crop_User_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "crop_user" */
export type Crop_User_Aggregate_Fields = {
  __typename?: 'crop_user_aggregate_fields';
  avg?: Maybe<Crop_User_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Crop_User_Max_Fields>;
  min?: Maybe<Crop_User_Min_Fields>;
  stddev?: Maybe<Crop_User_Stddev_Fields>;
  stddev_pop?: Maybe<Crop_User_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Crop_User_Stddev_Samp_Fields>;
  sum?: Maybe<Crop_User_Sum_Fields>;
  var_pop?: Maybe<Crop_User_Var_Pop_Fields>;
  var_samp?: Maybe<Crop_User_Var_Samp_Fields>;
  variance?: Maybe<Crop_User_Variance_Fields>;
};


/** aggregate fields of "crop_user" */
export type Crop_User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Crop_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "crop_user" */
export type Crop_User_Aggregate_Order_By = {
  avg?: InputMaybe<Crop_User_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Crop_User_Max_Order_By>;
  min?: InputMaybe<Crop_User_Min_Order_By>;
  stddev?: InputMaybe<Crop_User_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Crop_User_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Crop_User_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Crop_User_Sum_Order_By>;
  var_pop?: InputMaybe<Crop_User_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Crop_User_Var_Samp_Order_By>;
  variance?: InputMaybe<Crop_User_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "crop_user" */
export type Crop_User_Arr_Rel_Insert_Input = {
  data: Array<Crop_User_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Crop_User_On_Conflict>;
};

/** aggregate avg on columns */
export type Crop_User_Avg_Fields = {
  __typename?: 'crop_user_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "crop_user" */
export type Crop_User_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "crop_user". All fields are combined with a logical 'AND'. */
export type Crop_User_Bool_Exp = {
  _and?: InputMaybe<Array<Crop_User_Bool_Exp>>;
  _not?: InputMaybe<Crop_User_Bool_Exp>;
  _or?: InputMaybe<Array<Crop_User_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  crop_id?: InputMaybe<Bpchar_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  master_crop?: InputMaybe<Master_Crops_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "crop_user" */
export enum Crop_User_Constraint {
  /** unique or primary key constraint on columns "id" */
  CropUserPkey = 'crop_user_pkey'
}

/** input type for incrementing numeric columns in table "crop_user" */
export type Crop_User_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "crop_user" */
export type Crop_User_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crop_id?: InputMaybe<Scalars['bpchar']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  master_crop?: InputMaybe<Master_Crops_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Crop_User_Max_Fields = {
  __typename?: 'crop_user_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crop_id?: Maybe<Scalars['bpchar']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by max() on columns of table "crop_user" */
export type Crop_User_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Crop_User_Min_Fields = {
  __typename?: 'crop_user_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crop_id?: Maybe<Scalars['bpchar']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by min() on columns of table "crop_user" */
export type Crop_User_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "crop_user" */
export type Crop_User_Mutation_Response = {
  __typename?: 'crop_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Crop_User>;
};

/** on_conflict condition type for table "crop_user" */
export type Crop_User_On_Conflict = {
  constraint: Crop_User_Constraint;
  update_columns?: Array<Crop_User_Update_Column>;
  where?: InputMaybe<Crop_User_Bool_Exp>;
};

/** Ordering options when selecting data from "crop_user". */
export type Crop_User_Order_By = {
  created_at?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  master_crop?: InputMaybe<Master_Crops_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: crop_user */
export type Crop_User_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "crop_user" */
export enum Crop_User_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "crop_user" */
export type Crop_User_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crop_id?: InputMaybe<Scalars['bpchar']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate stddev on columns */
export type Crop_User_Stddev_Fields = {
  __typename?: 'crop_user_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "crop_user" */
export type Crop_User_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Crop_User_Stddev_Pop_Fields = {
  __typename?: 'crop_user_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "crop_user" */
export type Crop_User_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Crop_User_Stddev_Samp_Fields = {
  __typename?: 'crop_user_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "crop_user" */
export type Crop_User_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "crop_user" */
export type Crop_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Crop_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Crop_User_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crop_id?: InputMaybe<Scalars['bpchar']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate sum on columns */
export type Crop_User_Sum_Fields = {
  __typename?: 'crop_user_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "crop_user" */
export type Crop_User_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "crop_user" */
export enum Crop_User_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Crop_User_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Crop_User_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Crop_User_Set_Input>;
  /** filter the rows which have to be updated */
  where: Crop_User_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Crop_User_Var_Pop_Fields = {
  __typename?: 'crop_user_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "crop_user" */
export type Crop_User_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Crop_User_Var_Samp_Fields = {
  __typename?: 'crop_user_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "crop_user" */
export type Crop_User_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Crop_User_Variance_Fields = {
  __typename?: 'crop_user_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "crop_user" */
export type Crop_User_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

/** columns and relationships of "failed_jobs" */
export type Failed_Jobs = {
  __typename?: 'failed_jobs';
  connection: Scalars['String']['output'];
  exception: Scalars['String']['output'];
  failed_at: Scalars['timestamp']['output'];
  id: Scalars['bigint']['output'];
  payload: Scalars['String']['output'];
  queue: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

/** aggregated selection of "failed_jobs" */
export type Failed_Jobs_Aggregate = {
  __typename?: 'failed_jobs_aggregate';
  aggregate?: Maybe<Failed_Jobs_Aggregate_Fields>;
  nodes: Array<Failed_Jobs>;
};

/** aggregate fields of "failed_jobs" */
export type Failed_Jobs_Aggregate_Fields = {
  __typename?: 'failed_jobs_aggregate_fields';
  avg?: Maybe<Failed_Jobs_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Failed_Jobs_Max_Fields>;
  min?: Maybe<Failed_Jobs_Min_Fields>;
  stddev?: Maybe<Failed_Jobs_Stddev_Fields>;
  stddev_pop?: Maybe<Failed_Jobs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Failed_Jobs_Stddev_Samp_Fields>;
  sum?: Maybe<Failed_Jobs_Sum_Fields>;
  var_pop?: Maybe<Failed_Jobs_Var_Pop_Fields>;
  var_samp?: Maybe<Failed_Jobs_Var_Samp_Fields>;
  variance?: Maybe<Failed_Jobs_Variance_Fields>;
};


/** aggregate fields of "failed_jobs" */
export type Failed_Jobs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Failed_Jobs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Failed_Jobs_Avg_Fields = {
  __typename?: 'failed_jobs_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "failed_jobs". All fields are combined with a logical 'AND'. */
export type Failed_Jobs_Bool_Exp = {
  _and?: InputMaybe<Array<Failed_Jobs_Bool_Exp>>;
  _not?: InputMaybe<Failed_Jobs_Bool_Exp>;
  _or?: InputMaybe<Array<Failed_Jobs_Bool_Exp>>;
  connection?: InputMaybe<String_Comparison_Exp>;
  exception?: InputMaybe<String_Comparison_Exp>;
  failed_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  payload?: InputMaybe<String_Comparison_Exp>;
  queue?: InputMaybe<String_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "failed_jobs" */
export enum Failed_Jobs_Constraint {
  /** unique or primary key constraint on columns "id" */
  FailedJobsPkey = 'failed_jobs_pkey',
  /** unique or primary key constraint on columns "uuid" */
  FailedJobsUuidUnique = 'failed_jobs_uuid_unique'
}

/** input type for incrementing numeric columns in table "failed_jobs" */
export type Failed_Jobs_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "failed_jobs" */
export type Failed_Jobs_Insert_Input = {
  connection?: InputMaybe<Scalars['String']['input']>;
  exception?: InputMaybe<Scalars['String']['input']>;
  failed_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  payload?: InputMaybe<Scalars['String']['input']>;
  queue?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Failed_Jobs_Max_Fields = {
  __typename?: 'failed_jobs_max_fields';
  connection?: Maybe<Scalars['String']['output']>;
  exception?: Maybe<Scalars['String']['output']>;
  failed_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  payload?: Maybe<Scalars['String']['output']>;
  queue?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Failed_Jobs_Min_Fields = {
  __typename?: 'failed_jobs_min_fields';
  connection?: Maybe<Scalars['String']['output']>;
  exception?: Maybe<Scalars['String']['output']>;
  failed_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  payload?: Maybe<Scalars['String']['output']>;
  queue?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "failed_jobs" */
export type Failed_Jobs_Mutation_Response = {
  __typename?: 'failed_jobs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Failed_Jobs>;
};

/** on_conflict condition type for table "failed_jobs" */
export type Failed_Jobs_On_Conflict = {
  constraint: Failed_Jobs_Constraint;
  update_columns?: Array<Failed_Jobs_Update_Column>;
  where?: InputMaybe<Failed_Jobs_Bool_Exp>;
};

/** Ordering options when selecting data from "failed_jobs". */
export type Failed_Jobs_Order_By = {
  connection?: InputMaybe<Order_By>;
  exception?: InputMaybe<Order_By>;
  failed_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payload?: InputMaybe<Order_By>;
  queue?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: failed_jobs */
export type Failed_Jobs_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "failed_jobs" */
export enum Failed_Jobs_Select_Column {
  /** column name */
  Connection = 'connection',
  /** column name */
  Exception = 'exception',
  /** column name */
  FailedAt = 'failed_at',
  /** column name */
  Id = 'id',
  /** column name */
  Payload = 'payload',
  /** column name */
  Queue = 'queue',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "failed_jobs" */
export type Failed_Jobs_Set_Input = {
  connection?: InputMaybe<Scalars['String']['input']>;
  exception?: InputMaybe<Scalars['String']['input']>;
  failed_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  payload?: InputMaybe<Scalars['String']['input']>;
  queue?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Failed_Jobs_Stddev_Fields = {
  __typename?: 'failed_jobs_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Failed_Jobs_Stddev_Pop_Fields = {
  __typename?: 'failed_jobs_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Failed_Jobs_Stddev_Samp_Fields = {
  __typename?: 'failed_jobs_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "failed_jobs" */
export type Failed_Jobs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Failed_Jobs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Failed_Jobs_Stream_Cursor_Value_Input = {
  connection?: InputMaybe<Scalars['String']['input']>;
  exception?: InputMaybe<Scalars['String']['input']>;
  failed_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  payload?: InputMaybe<Scalars['String']['input']>;
  queue?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Failed_Jobs_Sum_Fields = {
  __typename?: 'failed_jobs_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "failed_jobs" */
export enum Failed_Jobs_Update_Column {
  /** column name */
  Connection = 'connection',
  /** column name */
  Exception = 'exception',
  /** column name */
  FailedAt = 'failed_at',
  /** column name */
  Id = 'id',
  /** column name */
  Payload = 'payload',
  /** column name */
  Queue = 'queue',
  /** column name */
  Uuid = 'uuid'
}

export type Failed_Jobs_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Failed_Jobs_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Failed_Jobs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Failed_Jobs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Failed_Jobs_Var_Pop_Fields = {
  __typename?: 'failed_jobs_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Failed_Jobs_Var_Samp_Fields = {
  __typename?: 'failed_jobs_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Failed_Jobs_Variance_Fields = {
  __typename?: 'failed_jobs_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "farmer_account_locations" */
export type Farmer_Account_Locations = {
  __typename?: 'farmer_account_locations';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  district_code?: Maybe<Scalars['String']['output']>;
  district_name?: Maybe<Scalars['String']['output']>;
  farmer_master_id: Scalars['bpchar']['output'];
  id: Scalars['bpchar']['output'];
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  location?: Maybe<Scalars['geography']['output']>;
  state_code?: Maybe<Scalars['String']['output']>;
  state_name?: Maybe<Scalars['String']['output']>;
  taluk_code?: Maybe<Scalars['String']['output']>;
  taluk_name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  village_code?: Maybe<Scalars['String']['output']>;
  village_name?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "farmer_account_locations" */
export type Farmer_Account_Locations_Aggregate = {
  __typename?: 'farmer_account_locations_aggregate';
  aggregate?: Maybe<Farmer_Account_Locations_Aggregate_Fields>;
  nodes: Array<Farmer_Account_Locations>;
};

export type Farmer_Account_Locations_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Farmer_Account_Locations_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Farmer_Account_Locations_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Farmer_Account_Locations_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Farmer_Account_Locations_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Farmer_Account_Locations_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Farmer_Account_Locations_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Farmer_Account_Locations_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Farmer_Account_Locations_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Farmer_Account_Locations_Aggregate_Bool_Exp_Var_Samp>;
};

export type Farmer_Account_Locations_Aggregate_Bool_Exp_Avg = {
  arguments: Farmer_Account_Locations_Select_Column_Farmer_Account_Locations_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farmer_Account_Locations_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Farmer_Account_Locations_Aggregate_Bool_Exp_Corr = {
  arguments: Farmer_Account_Locations_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farmer_Account_Locations_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Farmer_Account_Locations_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Farmer_Account_Locations_Select_Column_Farmer_Account_Locations_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Farmer_Account_Locations_Select_Column_Farmer_Account_Locations_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Farmer_Account_Locations_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Farmer_Account_Locations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farmer_Account_Locations_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Farmer_Account_Locations_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Farmer_Account_Locations_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farmer_Account_Locations_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Farmer_Account_Locations_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Farmer_Account_Locations_Select_Column_Farmer_Account_Locations_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Farmer_Account_Locations_Select_Column_Farmer_Account_Locations_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Farmer_Account_Locations_Aggregate_Bool_Exp_Max = {
  arguments: Farmer_Account_Locations_Select_Column_Farmer_Account_Locations_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farmer_Account_Locations_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Farmer_Account_Locations_Aggregate_Bool_Exp_Min = {
  arguments: Farmer_Account_Locations_Select_Column_Farmer_Account_Locations_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farmer_Account_Locations_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Farmer_Account_Locations_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Farmer_Account_Locations_Select_Column_Farmer_Account_Locations_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farmer_Account_Locations_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Farmer_Account_Locations_Aggregate_Bool_Exp_Sum = {
  arguments: Farmer_Account_Locations_Select_Column_Farmer_Account_Locations_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farmer_Account_Locations_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Farmer_Account_Locations_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Farmer_Account_Locations_Select_Column_Farmer_Account_Locations_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farmer_Account_Locations_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "farmer_account_locations" */
export type Farmer_Account_Locations_Aggregate_Fields = {
  __typename?: 'farmer_account_locations_aggregate_fields';
  avg?: Maybe<Farmer_Account_Locations_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Farmer_Account_Locations_Max_Fields>;
  min?: Maybe<Farmer_Account_Locations_Min_Fields>;
  stddev?: Maybe<Farmer_Account_Locations_Stddev_Fields>;
  stddev_pop?: Maybe<Farmer_Account_Locations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Farmer_Account_Locations_Stddev_Samp_Fields>;
  sum?: Maybe<Farmer_Account_Locations_Sum_Fields>;
  var_pop?: Maybe<Farmer_Account_Locations_Var_Pop_Fields>;
  var_samp?: Maybe<Farmer_Account_Locations_Var_Samp_Fields>;
  variance?: Maybe<Farmer_Account_Locations_Variance_Fields>;
};


/** aggregate fields of "farmer_account_locations" */
export type Farmer_Account_Locations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Farmer_Account_Locations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "farmer_account_locations" */
export type Farmer_Account_Locations_Aggregate_Order_By = {
  avg?: InputMaybe<Farmer_Account_Locations_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Farmer_Account_Locations_Max_Order_By>;
  min?: InputMaybe<Farmer_Account_Locations_Min_Order_By>;
  stddev?: InputMaybe<Farmer_Account_Locations_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Farmer_Account_Locations_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Farmer_Account_Locations_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Farmer_Account_Locations_Sum_Order_By>;
  var_pop?: InputMaybe<Farmer_Account_Locations_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Farmer_Account_Locations_Var_Samp_Order_By>;
  variance?: InputMaybe<Farmer_Account_Locations_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "farmer_account_locations" */
export type Farmer_Account_Locations_Arr_Rel_Insert_Input = {
  data: Array<Farmer_Account_Locations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Farmer_Account_Locations_On_Conflict>;
};

/** aggregate avg on columns */
export type Farmer_Account_Locations_Avg_Fields = {
  __typename?: 'farmer_account_locations_avg_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "farmer_account_locations" */
export type Farmer_Account_Locations_Avg_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "farmer_account_locations". All fields are combined with a logical 'AND'. */
export type Farmer_Account_Locations_Bool_Exp = {
  _and?: InputMaybe<Array<Farmer_Account_Locations_Bool_Exp>>;
  _not?: InputMaybe<Farmer_Account_Locations_Bool_Exp>;
  _or?: InputMaybe<Array<Farmer_Account_Locations_Bool_Exp>>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  district_code?: InputMaybe<String_Comparison_Exp>;
  district_name?: InputMaybe<String_Comparison_Exp>;
  farmer_master_id?: InputMaybe<Bpchar_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  lat?: InputMaybe<Float8_Comparison_Exp>;
  lng?: InputMaybe<Float8_Comparison_Exp>;
  location?: InputMaybe<Geography_Comparison_Exp>;
  state_code?: InputMaybe<String_Comparison_Exp>;
  state_name?: InputMaybe<String_Comparison_Exp>;
  taluk_code?: InputMaybe<String_Comparison_Exp>;
  taluk_name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  village_code?: InputMaybe<String_Comparison_Exp>;
  village_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "farmer_account_locations" */
export enum Farmer_Account_Locations_Constraint {
  /** unique or primary key constraint on columns "account_id", "farmer_master_id" */
  FarmerAccountLocationsFarmerMasterIdAccountIdUnique = 'farmer_account_locations_farmer_master_id_account_id_unique',
  /** unique or primary key constraint on columns "id" */
  FarmerAccountLocationsPk = 'farmer_account_locations_pk'
}

/** input type for incrementing numeric columns in table "farmer_account_locations" */
export type Farmer_Account_Locations_Inc_Input = {
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "farmer_account_locations" */
export type Farmer_Account_Locations_Insert_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  district_code?: InputMaybe<Scalars['String']['input']>;
  district_name?: InputMaybe<Scalars['String']['input']>;
  farmer_master_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  location?: InputMaybe<Scalars['geography']['input']>;
  state_code?: InputMaybe<Scalars['String']['input']>;
  state_name?: InputMaybe<Scalars['String']['input']>;
  taluk_code?: InputMaybe<Scalars['String']['input']>;
  taluk_name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  village_code?: InputMaybe<Scalars['String']['input']>;
  village_name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Farmer_Account_Locations_Max_Fields = {
  __typename?: 'farmer_account_locations_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  district_code?: Maybe<Scalars['String']['output']>;
  district_name?: Maybe<Scalars['String']['output']>;
  farmer_master_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  state_code?: Maybe<Scalars['String']['output']>;
  state_name?: Maybe<Scalars['String']['output']>;
  taluk_code?: Maybe<Scalars['String']['output']>;
  taluk_name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  village_code?: Maybe<Scalars['String']['output']>;
  village_name?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "farmer_account_locations" */
export type Farmer_Account_Locations_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  district_code?: InputMaybe<Order_By>;
  district_name?: InputMaybe<Order_By>;
  farmer_master_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  state_code?: InputMaybe<Order_By>;
  state_name?: InputMaybe<Order_By>;
  taluk_code?: InputMaybe<Order_By>;
  taluk_name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  village_code?: InputMaybe<Order_By>;
  village_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Farmer_Account_Locations_Min_Fields = {
  __typename?: 'farmer_account_locations_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  district_code?: Maybe<Scalars['String']['output']>;
  district_name?: Maybe<Scalars['String']['output']>;
  farmer_master_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  state_code?: Maybe<Scalars['String']['output']>;
  state_name?: Maybe<Scalars['String']['output']>;
  taluk_code?: Maybe<Scalars['String']['output']>;
  taluk_name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  village_code?: Maybe<Scalars['String']['output']>;
  village_name?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "farmer_account_locations" */
export type Farmer_Account_Locations_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  district_code?: InputMaybe<Order_By>;
  district_name?: InputMaybe<Order_By>;
  farmer_master_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  state_code?: InputMaybe<Order_By>;
  state_name?: InputMaybe<Order_By>;
  taluk_code?: InputMaybe<Order_By>;
  taluk_name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  village_code?: InputMaybe<Order_By>;
  village_name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "farmer_account_locations" */
export type Farmer_Account_Locations_Mutation_Response = {
  __typename?: 'farmer_account_locations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Farmer_Account_Locations>;
};

/** on_conflict condition type for table "farmer_account_locations" */
export type Farmer_Account_Locations_On_Conflict = {
  constraint: Farmer_Account_Locations_Constraint;
  update_columns?: Array<Farmer_Account_Locations_Update_Column>;
  where?: InputMaybe<Farmer_Account_Locations_Bool_Exp>;
};

/** Ordering options when selecting data from "farmer_account_locations". */
export type Farmer_Account_Locations_Order_By = {
  account_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  district_code?: InputMaybe<Order_By>;
  district_name?: InputMaybe<Order_By>;
  farmer_master_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  state_code?: InputMaybe<Order_By>;
  state_name?: InputMaybe<Order_By>;
  taluk_code?: InputMaybe<Order_By>;
  taluk_name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  village_code?: InputMaybe<Order_By>;
  village_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: farmer_account_locations */
export type Farmer_Account_Locations_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** select columns of table "farmer_account_locations" */
export enum Farmer_Account_Locations_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DistrictCode = 'district_code',
  /** column name */
  DistrictName = 'district_name',
  /** column name */
  FarmerMasterId = 'farmer_master_id',
  /** column name */
  Id = 'id',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  Location = 'location',
  /** column name */
  StateCode = 'state_code',
  /** column name */
  StateName = 'state_name',
  /** column name */
  TalukCode = 'taluk_code',
  /** column name */
  TalukName = 'taluk_name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VillageCode = 'village_code',
  /** column name */
  VillageName = 'village_name'
}

/** select "farmer_account_locations_aggregate_bool_exp_avg_arguments_columns" columns of table "farmer_account_locations" */
export enum Farmer_Account_Locations_Select_Column_Farmer_Account_Locations_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "farmer_account_locations_aggregate_bool_exp_corr_arguments_columns" columns of table "farmer_account_locations" */
export enum Farmer_Account_Locations_Select_Column_Farmer_Account_Locations_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "farmer_account_locations_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "farmer_account_locations" */
export enum Farmer_Account_Locations_Select_Column_Farmer_Account_Locations_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "farmer_account_locations_aggregate_bool_exp_max_arguments_columns" columns of table "farmer_account_locations" */
export enum Farmer_Account_Locations_Select_Column_Farmer_Account_Locations_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "farmer_account_locations_aggregate_bool_exp_min_arguments_columns" columns of table "farmer_account_locations" */
export enum Farmer_Account_Locations_Select_Column_Farmer_Account_Locations_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "farmer_account_locations_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "farmer_account_locations" */
export enum Farmer_Account_Locations_Select_Column_Farmer_Account_Locations_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "farmer_account_locations_aggregate_bool_exp_sum_arguments_columns" columns of table "farmer_account_locations" */
export enum Farmer_Account_Locations_Select_Column_Farmer_Account_Locations_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "farmer_account_locations_aggregate_bool_exp_var_samp_arguments_columns" columns of table "farmer_account_locations" */
export enum Farmer_Account_Locations_Select_Column_Farmer_Account_Locations_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** input type for updating data in table "farmer_account_locations" */
export type Farmer_Account_Locations_Set_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  district_code?: InputMaybe<Scalars['String']['input']>;
  district_name?: InputMaybe<Scalars['String']['input']>;
  farmer_master_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  location?: InputMaybe<Scalars['geography']['input']>;
  state_code?: InputMaybe<Scalars['String']['input']>;
  state_name?: InputMaybe<Scalars['String']['input']>;
  taluk_code?: InputMaybe<Scalars['String']['input']>;
  taluk_name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  village_code?: InputMaybe<Scalars['String']['input']>;
  village_name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Farmer_Account_Locations_Stddev_Fields = {
  __typename?: 'farmer_account_locations_stddev_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "farmer_account_locations" */
export type Farmer_Account_Locations_Stddev_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Farmer_Account_Locations_Stddev_Pop_Fields = {
  __typename?: 'farmer_account_locations_stddev_pop_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "farmer_account_locations" */
export type Farmer_Account_Locations_Stddev_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Farmer_Account_Locations_Stddev_Samp_Fields = {
  __typename?: 'farmer_account_locations_stddev_samp_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "farmer_account_locations" */
export type Farmer_Account_Locations_Stddev_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "farmer_account_locations" */
export type Farmer_Account_Locations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Farmer_Account_Locations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Farmer_Account_Locations_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  district_code?: InputMaybe<Scalars['String']['input']>;
  district_name?: InputMaybe<Scalars['String']['input']>;
  farmer_master_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  location?: InputMaybe<Scalars['geography']['input']>;
  state_code?: InputMaybe<Scalars['String']['input']>;
  state_name?: InputMaybe<Scalars['String']['input']>;
  taluk_code?: InputMaybe<Scalars['String']['input']>;
  taluk_name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  village_code?: InputMaybe<Scalars['String']['input']>;
  village_name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Farmer_Account_Locations_Sum_Fields = {
  __typename?: 'farmer_account_locations_sum_fields';
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "farmer_account_locations" */
export type Farmer_Account_Locations_Sum_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** update columns of table "farmer_account_locations" */
export enum Farmer_Account_Locations_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DistrictCode = 'district_code',
  /** column name */
  DistrictName = 'district_name',
  /** column name */
  FarmerMasterId = 'farmer_master_id',
  /** column name */
  Id = 'id',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  Location = 'location',
  /** column name */
  StateCode = 'state_code',
  /** column name */
  StateName = 'state_name',
  /** column name */
  TalukCode = 'taluk_code',
  /** column name */
  TalukName = 'taluk_name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VillageCode = 'village_code',
  /** column name */
  VillageName = 'village_name'
}

export type Farmer_Account_Locations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Farmer_Account_Locations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Farmer_Account_Locations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Farmer_Account_Locations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Farmer_Account_Locations_Var_Pop_Fields = {
  __typename?: 'farmer_account_locations_var_pop_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "farmer_account_locations" */
export type Farmer_Account_Locations_Var_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Farmer_Account_Locations_Var_Samp_Fields = {
  __typename?: 'farmer_account_locations_var_samp_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "farmer_account_locations" */
export type Farmer_Account_Locations_Var_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Farmer_Account_Locations_Variance_Fields = {
  __typename?: 'farmer_account_locations_variance_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "farmer_account_locations" */
export type Farmer_Account_Locations_Variance_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** columns and relationships of "farmer_accounts" */
export type Farmer_Accounts = {
  __typename?: 'farmer_accounts';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  data?: Maybe<Scalars['jsonb']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  farmer_master_id: Scalars['bpchar']['output'];
  farmer_name?: Maybe<Scalars['String']['output']>;
  farmer_phone_number?: Maybe<Scalars['String']['output']>;
  id: Scalars['bpchar']['output'];
  last_interacted_at?: Maybe<Scalars['timestamptz']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "farmer_accounts" */
export type Farmer_AccountsDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "farmer_accounts" */
export type Farmer_Accounts_Aggregate = {
  __typename?: 'farmer_accounts_aggregate';
  aggregate?: Maybe<Farmer_Accounts_Aggregate_Fields>;
  nodes: Array<Farmer_Accounts>;
};

/** aggregate fields of "farmer_accounts" */
export type Farmer_Accounts_Aggregate_Fields = {
  __typename?: 'farmer_accounts_aggregate_fields';
  avg?: Maybe<Farmer_Accounts_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Farmer_Accounts_Max_Fields>;
  min?: Maybe<Farmer_Accounts_Min_Fields>;
  stddev?: Maybe<Farmer_Accounts_Stddev_Fields>;
  stddev_pop?: Maybe<Farmer_Accounts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Farmer_Accounts_Stddev_Samp_Fields>;
  sum?: Maybe<Farmer_Accounts_Sum_Fields>;
  var_pop?: Maybe<Farmer_Accounts_Var_Pop_Fields>;
  var_samp?: Maybe<Farmer_Accounts_Var_Samp_Fields>;
  variance?: Maybe<Farmer_Accounts_Variance_Fields>;
};


/** aggregate fields of "farmer_accounts" */
export type Farmer_Accounts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Farmer_Accounts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Farmer_Accounts_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Farmer_Accounts_Avg_Fields = {
  __typename?: 'farmer_accounts_avg_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "farmer_accounts". All fields are combined with a logical 'AND'. */
export type Farmer_Accounts_Bool_Exp = {
  _and?: InputMaybe<Array<Farmer_Accounts_Bool_Exp>>;
  _not?: InputMaybe<Farmer_Accounts_Bool_Exp>;
  _or?: InputMaybe<Array<Farmer_Accounts_Bool_Exp>>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  farmer_master_id?: InputMaybe<Bpchar_Comparison_Exp>;
  farmer_name?: InputMaybe<String_Comparison_Exp>;
  farmer_phone_number?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  last_interacted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  lat?: InputMaybe<Float8_Comparison_Exp>;
  lng?: InputMaybe<Float8_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "farmer_accounts" */
export enum Farmer_Accounts_Constraint {
  /** unique or primary key constraint on columns "account_id", "farmer_master_id" */
  FarmerAccountsFarmerMasterIdAccountIdUnique = 'farmer_accounts_farmer_master_id_account_id_unique',
  /** unique or primary key constraint on columns "id" */
  FarmerAccountsPk = 'farmer_accounts_pk'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Farmer_Accounts_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Farmer_Accounts_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Farmer_Accounts_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "farmer_accounts" */
export type Farmer_Accounts_Inc_Input = {
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "farmer_accounts" */
export type Farmer_Accounts_Insert_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer_master_id?: InputMaybe<Scalars['bpchar']['input']>;
  farmer_name?: InputMaybe<Scalars['String']['input']>;
  farmer_phone_number?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  last_interacted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Farmer_Accounts_Max_Fields = {
  __typename?: 'farmer_accounts_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  farmer_master_id?: Maybe<Scalars['bpchar']['output']>;
  farmer_name?: Maybe<Scalars['String']['output']>;
  farmer_phone_number?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  last_interacted_at?: Maybe<Scalars['timestamptz']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Farmer_Accounts_Min_Fields = {
  __typename?: 'farmer_accounts_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  farmer_master_id?: Maybe<Scalars['bpchar']['output']>;
  farmer_name?: Maybe<Scalars['String']['output']>;
  farmer_phone_number?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  last_interacted_at?: Maybe<Scalars['timestamptz']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "farmer_accounts" */
export type Farmer_Accounts_Mutation_Response = {
  __typename?: 'farmer_accounts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Farmer_Accounts>;
};

/** on_conflict condition type for table "farmer_accounts" */
export type Farmer_Accounts_On_Conflict = {
  constraint: Farmer_Accounts_Constraint;
  update_columns?: Array<Farmer_Accounts_Update_Column>;
  where?: InputMaybe<Farmer_Accounts_Bool_Exp>;
};

/** Ordering options when selecting data from "farmer_accounts". */
export type Farmer_Accounts_Order_By = {
  account_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  farmer_master_id?: InputMaybe<Order_By>;
  farmer_name?: InputMaybe<Order_By>;
  farmer_phone_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_interacted_at?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: farmer_accounts */
export type Farmer_Accounts_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Farmer_Accounts_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "farmer_accounts" */
export enum Farmer_Accounts_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FarmerMasterId = 'farmer_master_id',
  /** column name */
  FarmerName = 'farmer_name',
  /** column name */
  FarmerPhoneNumber = 'farmer_phone_number',
  /** column name */
  Id = 'id',
  /** column name */
  LastInteractedAt = 'last_interacted_at',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "farmer_accounts" */
export type Farmer_Accounts_Set_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer_master_id?: InputMaybe<Scalars['bpchar']['input']>;
  farmer_name?: InputMaybe<Scalars['String']['input']>;
  farmer_phone_number?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  last_interacted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Farmer_Accounts_Stddev_Fields = {
  __typename?: 'farmer_accounts_stddev_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Farmer_Accounts_Stddev_Pop_Fields = {
  __typename?: 'farmer_accounts_stddev_pop_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Farmer_Accounts_Stddev_Samp_Fields = {
  __typename?: 'farmer_accounts_stddev_samp_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "farmer_accounts" */
export type Farmer_Accounts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Farmer_Accounts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Farmer_Accounts_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer_master_id?: InputMaybe<Scalars['bpchar']['input']>;
  farmer_name?: InputMaybe<Scalars['String']['input']>;
  farmer_phone_number?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  last_interacted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Farmer_Accounts_Sum_Fields = {
  __typename?: 'farmer_accounts_sum_fields';
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
};

/** update columns of table "farmer_accounts" */
export enum Farmer_Accounts_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FarmerMasterId = 'farmer_master_id',
  /** column name */
  FarmerName = 'farmer_name',
  /** column name */
  FarmerPhoneNumber = 'farmer_phone_number',
  /** column name */
  Id = 'id',
  /** column name */
  LastInteractedAt = 'last_interacted_at',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Farmer_Accounts_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Farmer_Accounts_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Farmer_Accounts_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Farmer_Accounts_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Farmer_Accounts_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Farmer_Accounts_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Farmer_Accounts_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Farmer_Accounts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Farmer_Accounts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Farmer_Accounts_Var_Pop_Fields = {
  __typename?: 'farmer_accounts_var_pop_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Farmer_Accounts_Var_Samp_Fields = {
  __typename?: 'farmer_accounts_var_samp_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Farmer_Accounts_Variance_Fields = {
  __typename?: 'farmer_accounts_variance_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "farmer_actions" */
export type Farmer_Actions = {
  __typename?: 'farmer_actions';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  action?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  action_fields: Array<Farmer_Fields>;
  /** An aggregate relationship */
  action_fields_aggregate: Farmer_Fields_Aggregate;
  action_id?: Maybe<Scalars['bigint']['output']>;
  app_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  data?: Maybe<Scalars['jsonb']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  event?: Maybe<Scalars['jsonb']['output']>;
  farmer_master_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "farmer_actions" */
export type Farmer_ActionsAction_FieldsArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Fields_Order_By>>;
  where?: InputMaybe<Farmer_Fields_Bool_Exp>;
};


/** columns and relationships of "farmer_actions" */
export type Farmer_ActionsAction_Fields_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Fields_Order_By>>;
  where?: InputMaybe<Farmer_Fields_Bool_Exp>;
};


/** columns and relationships of "farmer_actions" */
export type Farmer_ActionsDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "farmer_actions" */
export type Farmer_ActionsEventArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "farmer_actions" */
export type Farmer_Actions_Aggregate = {
  __typename?: 'farmer_actions_aggregate';
  aggregate?: Maybe<Farmer_Actions_Aggregate_Fields>;
  nodes: Array<Farmer_Actions>;
};

/** aggregate fields of "farmer_actions" */
export type Farmer_Actions_Aggregate_Fields = {
  __typename?: 'farmer_actions_aggregate_fields';
  avg?: Maybe<Farmer_Actions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Farmer_Actions_Max_Fields>;
  min?: Maybe<Farmer_Actions_Min_Fields>;
  stddev?: Maybe<Farmer_Actions_Stddev_Fields>;
  stddev_pop?: Maybe<Farmer_Actions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Farmer_Actions_Stddev_Samp_Fields>;
  sum?: Maybe<Farmer_Actions_Sum_Fields>;
  var_pop?: Maybe<Farmer_Actions_Var_Pop_Fields>;
  var_samp?: Maybe<Farmer_Actions_Var_Samp_Fields>;
  variance?: Maybe<Farmer_Actions_Variance_Fields>;
};


/** aggregate fields of "farmer_actions" */
export type Farmer_Actions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Farmer_Actions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Farmer_Actions_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
  event?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Farmer_Actions_Avg_Fields = {
  __typename?: 'farmer_actions_avg_fields';
  action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "farmer_actions". All fields are combined with a logical 'AND'. */
export type Farmer_Actions_Bool_Exp = {
  _and?: InputMaybe<Array<Farmer_Actions_Bool_Exp>>;
  _not?: InputMaybe<Farmer_Actions_Bool_Exp>;
  _or?: InputMaybe<Array<Farmer_Actions_Bool_Exp>>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  action?: InputMaybe<String_Comparison_Exp>;
  action_fields?: InputMaybe<Farmer_Fields_Bool_Exp>;
  action_fields_aggregate?: InputMaybe<Farmer_Fields_Aggregate_Bool_Exp>;
  action_id?: InputMaybe<Bigint_Comparison_Exp>;
  app_name?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  event?: InputMaybe<Jsonb_Comparison_Exp>;
  farmer_master_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "farmer_actions" */
export enum Farmer_Actions_Constraint {
  /** unique or primary key constraint on columns "action_id", "action" */
  FarmerActionsActionActionIdUnique = 'farmer_actions_action_action_id_unique',
  /** unique or primary key constraint on columns "id" */
  FarmerActionsPkey = 'farmer_actions_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Farmer_Actions_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']['input']>>;
  event?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Farmer_Actions_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']['input']>;
  event?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Farmer_Actions_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "farmer_actions" */
export type Farmer_Actions_Inc_Input = {
  action_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "farmer_actions" */
export type Farmer_Actions_Insert_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  action?: InputMaybe<Scalars['String']['input']>;
  action_fields?: InputMaybe<Farmer_Fields_Arr_Rel_Insert_Input>;
  action_id?: InputMaybe<Scalars['bigint']['input']>;
  app_name?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event?: InputMaybe<Scalars['jsonb']['input']>;
  farmer_master_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Farmer_Actions_Max_Fields = {
  __typename?: 'farmer_actions_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  action?: Maybe<Scalars['String']['output']>;
  action_id?: Maybe<Scalars['bigint']['output']>;
  app_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  farmer_master_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Farmer_Actions_Min_Fields = {
  __typename?: 'farmer_actions_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  action?: Maybe<Scalars['String']['output']>;
  action_id?: Maybe<Scalars['bigint']['output']>;
  app_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  farmer_master_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "farmer_actions" */
export type Farmer_Actions_Mutation_Response = {
  __typename?: 'farmer_actions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Farmer_Actions>;
};

/** on_conflict condition type for table "farmer_actions" */
export type Farmer_Actions_On_Conflict = {
  constraint: Farmer_Actions_Constraint;
  update_columns?: Array<Farmer_Actions_Update_Column>;
  where?: InputMaybe<Farmer_Actions_Bool_Exp>;
};

/** Ordering options when selecting data from "farmer_actions". */
export type Farmer_Actions_Order_By = {
  account_id?: InputMaybe<Order_By>;
  action?: InputMaybe<Order_By>;
  action_fields_aggregate?: InputMaybe<Farmer_Fields_Aggregate_Order_By>;
  action_id?: InputMaybe<Order_By>;
  app_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  event?: InputMaybe<Order_By>;
  farmer_master_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: farmer_actions */
export type Farmer_Actions_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Farmer_Actions_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
  event?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "farmer_actions" */
export enum Farmer_Actions_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Action = 'action',
  /** column name */
  ActionId = 'action_id',
  /** column name */
  AppName = 'app_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Event = 'event',
  /** column name */
  FarmerMasterId = 'farmer_master_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "farmer_actions" */
export type Farmer_Actions_Set_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  action?: InputMaybe<Scalars['String']['input']>;
  action_id?: InputMaybe<Scalars['bigint']['input']>;
  app_name?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event?: InputMaybe<Scalars['jsonb']['input']>;
  farmer_master_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Farmer_Actions_Stddev_Fields = {
  __typename?: 'farmer_actions_stddev_fields';
  action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Farmer_Actions_Stddev_Pop_Fields = {
  __typename?: 'farmer_actions_stddev_pop_fields';
  action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Farmer_Actions_Stddev_Samp_Fields = {
  __typename?: 'farmer_actions_stddev_samp_fields';
  action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "farmer_actions" */
export type Farmer_Actions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Farmer_Actions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Farmer_Actions_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  action?: InputMaybe<Scalars['String']['input']>;
  action_id?: InputMaybe<Scalars['bigint']['input']>;
  app_name?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event?: InputMaybe<Scalars['jsonb']['input']>;
  farmer_master_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Farmer_Actions_Sum_Fields = {
  __typename?: 'farmer_actions_sum_fields';
  action_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "farmer_actions" */
export enum Farmer_Actions_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Action = 'action',
  /** column name */
  ActionId = 'action_id',
  /** column name */
  AppName = 'app_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Event = 'event',
  /** column name */
  FarmerMasterId = 'farmer_master_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Farmer_Actions_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Farmer_Actions_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Farmer_Actions_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Farmer_Actions_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Farmer_Actions_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Farmer_Actions_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Farmer_Actions_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Farmer_Actions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Farmer_Actions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Farmer_Actions_Var_Pop_Fields = {
  __typename?: 'farmer_actions_var_pop_fields';
  action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Farmer_Actions_Var_Samp_Fields = {
  __typename?: 'farmer_actions_var_samp_fields';
  action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Farmer_Actions_Variance_Fields = {
  __typename?: 'farmer_actions_variance_fields';
  action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "farmer_fields" */
export type Farmer_Fields = {
  __typename?: 'farmer_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  action?: Maybe<Scalars['String']['output']>;
  action_id?: Maybe<Scalars['String']['output']>;
  app_name: Scalars['String']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  farmer_master_id: Scalars['bpchar']['output'];
  fb_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['bigint']['output'];
  label?: Maybe<Scalars['String']['output']>;
  purpose_name?: Maybe<Scalars['String']['output']>;
  submitted_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  value_type?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "farmer_fields" */
export type Farmer_Fields_Aggregate = {
  __typename?: 'farmer_fields_aggregate';
  aggregate?: Maybe<Farmer_Fields_Aggregate_Fields>;
  nodes: Array<Farmer_Fields>;
};

export type Farmer_Fields_Aggregate_Bool_Exp = {
  count?: InputMaybe<Farmer_Fields_Aggregate_Bool_Exp_Count>;
};

export type Farmer_Fields_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Farmer_Fields_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farmer_Fields_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "farmer_fields" */
export type Farmer_Fields_Aggregate_Fields = {
  __typename?: 'farmer_fields_aggregate_fields';
  avg?: Maybe<Farmer_Fields_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Farmer_Fields_Max_Fields>;
  min?: Maybe<Farmer_Fields_Min_Fields>;
  stddev?: Maybe<Farmer_Fields_Stddev_Fields>;
  stddev_pop?: Maybe<Farmer_Fields_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Farmer_Fields_Stddev_Samp_Fields>;
  sum?: Maybe<Farmer_Fields_Sum_Fields>;
  var_pop?: Maybe<Farmer_Fields_Var_Pop_Fields>;
  var_samp?: Maybe<Farmer_Fields_Var_Samp_Fields>;
  variance?: Maybe<Farmer_Fields_Variance_Fields>;
};


/** aggregate fields of "farmer_fields" */
export type Farmer_Fields_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Farmer_Fields_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "farmer_fields" */
export type Farmer_Fields_Aggregate_Order_By = {
  avg?: InputMaybe<Farmer_Fields_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Farmer_Fields_Max_Order_By>;
  min?: InputMaybe<Farmer_Fields_Min_Order_By>;
  stddev?: InputMaybe<Farmer_Fields_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Farmer_Fields_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Farmer_Fields_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Farmer_Fields_Sum_Order_By>;
  var_pop?: InputMaybe<Farmer_Fields_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Farmer_Fields_Var_Samp_Order_By>;
  variance?: InputMaybe<Farmer_Fields_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "farmer_fields" */
export type Farmer_Fields_Arr_Rel_Insert_Input = {
  data: Array<Farmer_Fields_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Farmer_Fields_On_Conflict>;
};

/** aggregate avg on columns */
export type Farmer_Fields_Avg_Fields = {
  __typename?: 'farmer_fields_avg_fields';
  fb_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "farmer_fields" */
export type Farmer_Fields_Avg_Order_By = {
  fb_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "farmer_fields". All fields are combined with a logical 'AND'. */
export type Farmer_Fields_Bool_Exp = {
  _and?: InputMaybe<Array<Farmer_Fields_Bool_Exp>>;
  _not?: InputMaybe<Farmer_Fields_Bool_Exp>;
  _or?: InputMaybe<Array<Farmer_Fields_Bool_Exp>>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  action?: InputMaybe<String_Comparison_Exp>;
  action_id?: InputMaybe<String_Comparison_Exp>;
  app_name?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  farmer_master_id?: InputMaybe<Bpchar_Comparison_Exp>;
  fb_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  purpose_name?: InputMaybe<String_Comparison_Exp>;
  submitted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
  value_type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "farmer_fields" */
export enum Farmer_Fields_Constraint {
  /** unique or primary key constraint on columns "action_id", "value_type", "fb_id", "farmer_master_id" */
  FarmerFieldsFarmerMasterIdIdx = 'farmer_fields_farmer_master_id_idx',
  /** unique or primary key constraint on columns "id" */
  FarmerFieldsPkey = 'farmer_fields_pkey'
}

/** input type for incrementing numeric columns in table "farmer_fields" */
export type Farmer_Fields_Inc_Input = {
  fb_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "farmer_fields" */
export type Farmer_Fields_Insert_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  action?: InputMaybe<Scalars['String']['input']>;
  action_id?: InputMaybe<Scalars['String']['input']>;
  app_name?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer_master_id?: InputMaybe<Scalars['bpchar']['input']>;
  fb_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  purpose_name?: InputMaybe<Scalars['String']['input']>;
  submitted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_type?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "farmer_fields_latest" */
export type Farmer_Fields_Latest = {
  __typename?: 'farmer_fields_latest';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  /** An object relationship */
  account_location?: Maybe<Farmer_Account_Locations>;
  action?: Maybe<Scalars['String']['output']>;
  action_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  farmer?: Maybe<Farmer_Master>;
  farmer_master_id?: Maybe<Scalars['bpchar']['output']>;
  fb_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  purpose_name?: Maybe<Scalars['String']['output']>;
  submitted_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  value_type?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "farmer_fields_latest" */
export type Farmer_Fields_Latest_Aggregate = {
  __typename?: 'farmer_fields_latest_aggregate';
  aggregate?: Maybe<Farmer_Fields_Latest_Aggregate_Fields>;
  nodes: Array<Farmer_Fields_Latest>;
};

/** aggregate fields of "farmer_fields_latest" */
export type Farmer_Fields_Latest_Aggregate_Fields = {
  __typename?: 'farmer_fields_latest_aggregate_fields';
  avg?: Maybe<Farmer_Fields_Latest_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Farmer_Fields_Latest_Max_Fields>;
  min?: Maybe<Farmer_Fields_Latest_Min_Fields>;
  stddev?: Maybe<Farmer_Fields_Latest_Stddev_Fields>;
  stddev_pop?: Maybe<Farmer_Fields_Latest_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Farmer_Fields_Latest_Stddev_Samp_Fields>;
  sum?: Maybe<Farmer_Fields_Latest_Sum_Fields>;
  var_pop?: Maybe<Farmer_Fields_Latest_Var_Pop_Fields>;
  var_samp?: Maybe<Farmer_Fields_Latest_Var_Samp_Fields>;
  variance?: Maybe<Farmer_Fields_Latest_Variance_Fields>;
};


/** aggregate fields of "farmer_fields_latest" */
export type Farmer_Fields_Latest_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Farmer_Fields_Latest_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Farmer_Fields_Latest_Avg_Fields = {
  __typename?: 'farmer_fields_latest_avg_fields';
  fb_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "farmer_fields_latest". All fields are combined with a logical 'AND'. */
export type Farmer_Fields_Latest_Bool_Exp = {
  _and?: InputMaybe<Array<Farmer_Fields_Latest_Bool_Exp>>;
  _not?: InputMaybe<Farmer_Fields_Latest_Bool_Exp>;
  _or?: InputMaybe<Array<Farmer_Fields_Latest_Bool_Exp>>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  account_location?: InputMaybe<Farmer_Account_Locations_Bool_Exp>;
  action?: InputMaybe<String_Comparison_Exp>;
  action_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  farmer?: InputMaybe<Farmer_Master_Bool_Exp>;
  farmer_master_id?: InputMaybe<Bpchar_Comparison_Exp>;
  fb_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  purpose_name?: InputMaybe<String_Comparison_Exp>;
  submitted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
  value_type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Farmer_Fields_Latest_Max_Fields = {
  __typename?: 'farmer_fields_latest_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  action?: Maybe<Scalars['String']['output']>;
  action_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  farmer_master_id?: Maybe<Scalars['bpchar']['output']>;
  fb_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  purpose_name?: Maybe<Scalars['String']['output']>;
  submitted_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  value_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Farmer_Fields_Latest_Min_Fields = {
  __typename?: 'farmer_fields_latest_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  action?: Maybe<Scalars['String']['output']>;
  action_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  farmer_master_id?: Maybe<Scalars['bpchar']['output']>;
  fb_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  purpose_name?: Maybe<Scalars['String']['output']>;
  submitted_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  value_type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "farmer_fields_latest". */
export type Farmer_Fields_Latest_Order_By = {
  account_id?: InputMaybe<Order_By>;
  account_location?: InputMaybe<Farmer_Account_Locations_Order_By>;
  action?: InputMaybe<Order_By>;
  action_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  farmer?: InputMaybe<Farmer_Master_Order_By>;
  farmer_master_id?: InputMaybe<Order_By>;
  fb_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  purpose_name?: InputMaybe<Order_By>;
  submitted_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  value_type?: InputMaybe<Order_By>;
};

/** select columns of table "farmer_fields_latest" */
export enum Farmer_Fields_Latest_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Action = 'action',
  /** column name */
  ActionId = 'action_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FarmerMasterId = 'farmer_master_id',
  /** column name */
  FbId = 'fb_id',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  PurposeName = 'purpose_name',
  /** column name */
  SubmittedAt = 'submitted_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value',
  /** column name */
  ValueType = 'value_type'
}

/** aggregate stddev on columns */
export type Farmer_Fields_Latest_Stddev_Fields = {
  __typename?: 'farmer_fields_latest_stddev_fields';
  fb_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Farmer_Fields_Latest_Stddev_Pop_Fields = {
  __typename?: 'farmer_fields_latest_stddev_pop_fields';
  fb_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Farmer_Fields_Latest_Stddev_Samp_Fields = {
  __typename?: 'farmer_fields_latest_stddev_samp_fields';
  fb_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "farmer_fields_latest" */
export type Farmer_Fields_Latest_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Farmer_Fields_Latest_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Farmer_Fields_Latest_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  action?: InputMaybe<Scalars['String']['input']>;
  action_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer_master_id?: InputMaybe<Scalars['bpchar']['input']>;
  fb_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  purpose_name?: InputMaybe<Scalars['String']['input']>;
  submitted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Farmer_Fields_Latest_Sum_Fields = {
  __typename?: 'farmer_fields_latest_sum_fields';
  fb_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Farmer_Fields_Latest_Var_Pop_Fields = {
  __typename?: 'farmer_fields_latest_var_pop_fields';
  fb_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Farmer_Fields_Latest_Var_Samp_Fields = {
  __typename?: 'farmer_fields_latest_var_samp_fields';
  fb_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Farmer_Fields_Latest_Variance_Fields = {
  __typename?: 'farmer_fields_latest_variance_fields';
  fb_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate max on columns */
export type Farmer_Fields_Max_Fields = {
  __typename?: 'farmer_fields_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  action?: Maybe<Scalars['String']['output']>;
  action_id?: Maybe<Scalars['String']['output']>;
  app_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  farmer_master_id?: Maybe<Scalars['bpchar']['output']>;
  fb_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  purpose_name?: Maybe<Scalars['String']['output']>;
  submitted_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  value_type?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "farmer_fields" */
export type Farmer_Fields_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  action?: InputMaybe<Order_By>;
  action_id?: InputMaybe<Order_By>;
  app_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  farmer_master_id?: InputMaybe<Order_By>;
  fb_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  purpose_name?: InputMaybe<Order_By>;
  submitted_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  value_type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Farmer_Fields_Min_Fields = {
  __typename?: 'farmer_fields_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  action?: Maybe<Scalars['String']['output']>;
  action_id?: Maybe<Scalars['String']['output']>;
  app_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  farmer_master_id?: Maybe<Scalars['bpchar']['output']>;
  fb_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  purpose_name?: Maybe<Scalars['String']['output']>;
  submitted_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  value_type?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "farmer_fields" */
export type Farmer_Fields_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  action?: InputMaybe<Order_By>;
  action_id?: InputMaybe<Order_By>;
  app_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  farmer_master_id?: InputMaybe<Order_By>;
  fb_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  purpose_name?: InputMaybe<Order_By>;
  submitted_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  value_type?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "farmer_fields" */
export type Farmer_Fields_Mutation_Response = {
  __typename?: 'farmer_fields_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Farmer_Fields>;
};

/** on_conflict condition type for table "farmer_fields" */
export type Farmer_Fields_On_Conflict = {
  constraint: Farmer_Fields_Constraint;
  update_columns?: Array<Farmer_Fields_Update_Column>;
  where?: InputMaybe<Farmer_Fields_Bool_Exp>;
};

/** Ordering options when selecting data from "farmer_fields". */
export type Farmer_Fields_Order_By = {
  account_id?: InputMaybe<Order_By>;
  action?: InputMaybe<Order_By>;
  action_id?: InputMaybe<Order_By>;
  app_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  farmer_master_id?: InputMaybe<Order_By>;
  fb_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  purpose_name?: InputMaybe<Order_By>;
  submitted_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  value_type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: farmer_fields */
export type Farmer_Fields_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "farmer_fields" */
export enum Farmer_Fields_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Action = 'action',
  /** column name */
  ActionId = 'action_id',
  /** column name */
  AppName = 'app_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FarmerMasterId = 'farmer_master_id',
  /** column name */
  FbId = 'fb_id',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  PurposeName = 'purpose_name',
  /** column name */
  SubmittedAt = 'submitted_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value',
  /** column name */
  ValueType = 'value_type'
}

/** input type for updating data in table "farmer_fields" */
export type Farmer_Fields_Set_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  action?: InputMaybe<Scalars['String']['input']>;
  action_id?: InputMaybe<Scalars['String']['input']>;
  app_name?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer_master_id?: InputMaybe<Scalars['bpchar']['input']>;
  fb_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  purpose_name?: InputMaybe<Scalars['String']['input']>;
  submitted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Farmer_Fields_Stddev_Fields = {
  __typename?: 'farmer_fields_stddev_fields';
  fb_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "farmer_fields" */
export type Farmer_Fields_Stddev_Order_By = {
  fb_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Farmer_Fields_Stddev_Pop_Fields = {
  __typename?: 'farmer_fields_stddev_pop_fields';
  fb_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "farmer_fields" */
export type Farmer_Fields_Stddev_Pop_Order_By = {
  fb_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Farmer_Fields_Stddev_Samp_Fields = {
  __typename?: 'farmer_fields_stddev_samp_fields';
  fb_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "farmer_fields" */
export type Farmer_Fields_Stddev_Samp_Order_By = {
  fb_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "farmer_fields" */
export type Farmer_Fields_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Farmer_Fields_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Farmer_Fields_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  action?: InputMaybe<Scalars['String']['input']>;
  action_id?: InputMaybe<Scalars['String']['input']>;
  app_name?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer_master_id?: InputMaybe<Scalars['bpchar']['input']>;
  fb_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  purpose_name?: InputMaybe<Scalars['String']['input']>;
  submitted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Farmer_Fields_Sum_Fields = {
  __typename?: 'farmer_fields_sum_fields';
  fb_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "farmer_fields" */
export type Farmer_Fields_Sum_Order_By = {
  fb_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "farmer_fields" */
export enum Farmer_Fields_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Action = 'action',
  /** column name */
  ActionId = 'action_id',
  /** column name */
  AppName = 'app_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FarmerMasterId = 'farmer_master_id',
  /** column name */
  FbId = 'fb_id',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  PurposeName = 'purpose_name',
  /** column name */
  SubmittedAt = 'submitted_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value',
  /** column name */
  ValueType = 'value_type'
}

export type Farmer_Fields_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Farmer_Fields_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Farmer_Fields_Set_Input>;
  /** filter the rows which have to be updated */
  where: Farmer_Fields_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Farmer_Fields_Var_Pop_Fields = {
  __typename?: 'farmer_fields_var_pop_fields';
  fb_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "farmer_fields" */
export type Farmer_Fields_Var_Pop_Order_By = {
  fb_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Farmer_Fields_Var_Samp_Fields = {
  __typename?: 'farmer_fields_var_samp_fields';
  fb_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "farmer_fields" */
export type Farmer_Fields_Var_Samp_Order_By = {
  fb_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Farmer_Fields_Variance_Fields = {
  __typename?: 'farmer_fields_variance_fields';
  fb_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "farmer_fields" */
export type Farmer_Fields_Variance_Order_By = {
  fb_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "farmer_master" */
export type Farmer_Master = {
  __typename?: 'farmer_master';
  /** An array relationship */
  account_location: Array<Farmer_Account_Locations>;
  /** An aggregate relationship */
  account_location_aggregate: Farmer_Account_Locations_Aggregate;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crm_type: Scalars['String']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['bpchar']['output'];
  name: Scalars['String']['output'];
  phone_number: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "farmer_master" */
export type Farmer_MasterAccount_LocationArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Account_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Account_Locations_Order_By>>;
  where?: InputMaybe<Farmer_Account_Locations_Bool_Exp>;
};


/** columns and relationships of "farmer_master" */
export type Farmer_MasterAccount_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Account_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Account_Locations_Order_By>>;
  where?: InputMaybe<Farmer_Account_Locations_Bool_Exp>;
};

/** aggregated selection of "farmer_master" */
export type Farmer_Master_Aggregate = {
  __typename?: 'farmer_master_aggregate';
  aggregate?: Maybe<Farmer_Master_Aggregate_Fields>;
  nodes: Array<Farmer_Master>;
};

/** aggregate fields of "farmer_master" */
export type Farmer_Master_Aggregate_Fields = {
  __typename?: 'farmer_master_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Farmer_Master_Max_Fields>;
  min?: Maybe<Farmer_Master_Min_Fields>;
};


/** aggregate fields of "farmer_master" */
export type Farmer_Master_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Farmer_Master_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "farmer_master". All fields are combined with a logical 'AND'. */
export type Farmer_Master_Bool_Exp = {
  _and?: InputMaybe<Array<Farmer_Master_Bool_Exp>>;
  _not?: InputMaybe<Farmer_Master_Bool_Exp>;
  _or?: InputMaybe<Array<Farmer_Master_Bool_Exp>>;
  account_location?: InputMaybe<Farmer_Account_Locations_Bool_Exp>;
  account_location_aggregate?: InputMaybe<Farmer_Account_Locations_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  crm_type?: InputMaybe<String_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "farmer_master" */
export enum Farmer_Master_Constraint {
  /** unique or primary key constraint on columns "phone_number" */
  FarmerMasterPhoneNumberUnique = 'farmer_master_phone_number_unique',
  /** unique or primary key constraint on columns "id" */
  FarmerMasterPkey = 'farmer_master_pkey'
}

/** input type for inserting data into table "farmer_master" */
export type Farmer_Master_Insert_Input = {
  account_location?: InputMaybe<Farmer_Account_Locations_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crm_type?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Farmer_Master_Max_Fields = {
  __typename?: 'farmer_master_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crm_type?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Farmer_Master_Min_Fields = {
  __typename?: 'farmer_master_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crm_type?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "farmer_master" */
export type Farmer_Master_Mutation_Response = {
  __typename?: 'farmer_master_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Farmer_Master>;
};

/** input type for inserting object relation for remote table "farmer_master" */
export type Farmer_Master_Obj_Rel_Insert_Input = {
  data: Farmer_Master_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Farmer_Master_On_Conflict>;
};

/** on_conflict condition type for table "farmer_master" */
export type Farmer_Master_On_Conflict = {
  constraint: Farmer_Master_Constraint;
  update_columns?: Array<Farmer_Master_Update_Column>;
  where?: InputMaybe<Farmer_Master_Bool_Exp>;
};

/** Ordering options when selecting data from "farmer_master". */
export type Farmer_Master_Order_By = {
  account_location_aggregate?: InputMaybe<Farmer_Account_Locations_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  crm_type?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: farmer_master */
export type Farmer_Master_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** select columns of table "farmer_master" */
export enum Farmer_Master_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CrmType = 'crm_type',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "farmer_master" */
export type Farmer_Master_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crm_type?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "farmer_master" */
export type Farmer_Master_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Farmer_Master_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Farmer_Master_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crm_type?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "farmer_master" */
export enum Farmer_Master_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CrmType = 'crm_type',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Farmer_Master_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Farmer_Master_Set_Input>;
  /** filter the rows which have to be updated */
  where: Farmer_Master_Bool_Exp;
};

/** columns and relationships of "farmer_nearby_field_force" */
export type Farmer_Nearby_Field_Force = {
  __typename?: 'farmer_nearby_field_force';
  id: Scalars['bpchar']['output'];
  location?: Maybe<Scalars['geography']['output']>;
  nearby_field_force: Scalars['json']['output'];
};


/** columns and relationships of "farmer_nearby_field_force" */
export type Farmer_Nearby_Field_ForceNearby_Field_ForceArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "farmer_nearby_field_force" */
export type Farmer_Nearby_Field_Force_Aggregate = {
  __typename?: 'farmer_nearby_field_force_aggregate';
  aggregate?: Maybe<Farmer_Nearby_Field_Force_Aggregate_Fields>;
  nodes: Array<Farmer_Nearby_Field_Force>;
};

/** aggregate fields of "farmer_nearby_field_force" */
export type Farmer_Nearby_Field_Force_Aggregate_Fields = {
  __typename?: 'farmer_nearby_field_force_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Farmer_Nearby_Field_Force_Max_Fields>;
  min?: Maybe<Farmer_Nearby_Field_Force_Min_Fields>;
};


/** aggregate fields of "farmer_nearby_field_force" */
export type Farmer_Nearby_Field_Force_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Farmer_Nearby_Field_Force_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "farmer_nearby_field_force". All fields are combined with a logical 'AND'. */
export type Farmer_Nearby_Field_Force_Bool_Exp = {
  _and?: InputMaybe<Array<Farmer_Nearby_Field_Force_Bool_Exp>>;
  _not?: InputMaybe<Farmer_Nearby_Field_Force_Bool_Exp>;
  _or?: InputMaybe<Array<Farmer_Nearby_Field_Force_Bool_Exp>>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  location?: InputMaybe<Geography_Comparison_Exp>;
  nearby_field_force?: InputMaybe<Json_Comparison_Exp>;
};

/** unique or primary key constraints on table "farmer_nearby_field_force" */
export enum Farmer_Nearby_Field_Force_Constraint {
  /** unique or primary key constraint on columns "id" */
  FarmerNearbyFieldForcePkey = 'farmer_nearby_field_force_pkey'
}

/** input type for inserting data into table "farmer_nearby_field_force" */
export type Farmer_Nearby_Field_Force_Insert_Input = {
  id?: InputMaybe<Scalars['bpchar']['input']>;
  location?: InputMaybe<Scalars['geography']['input']>;
  nearby_field_force?: InputMaybe<Scalars['json']['input']>;
};

/** aggregate max on columns */
export type Farmer_Nearby_Field_Force_Max_Fields = {
  __typename?: 'farmer_nearby_field_force_max_fields';
  id?: Maybe<Scalars['bpchar']['output']>;
};

/** aggregate min on columns */
export type Farmer_Nearby_Field_Force_Min_Fields = {
  __typename?: 'farmer_nearby_field_force_min_fields';
  id?: Maybe<Scalars['bpchar']['output']>;
};

/** response of any mutation on the table "farmer_nearby_field_force" */
export type Farmer_Nearby_Field_Force_Mutation_Response = {
  __typename?: 'farmer_nearby_field_force_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Farmer_Nearby_Field_Force>;
};

/** on_conflict condition type for table "farmer_nearby_field_force" */
export type Farmer_Nearby_Field_Force_On_Conflict = {
  constraint: Farmer_Nearby_Field_Force_Constraint;
  update_columns?: Array<Farmer_Nearby_Field_Force_Update_Column>;
  where?: InputMaybe<Farmer_Nearby_Field_Force_Bool_Exp>;
};

/** Ordering options when selecting data from "farmer_nearby_field_force". */
export type Farmer_Nearby_Field_Force_Order_By = {
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  nearby_field_force?: InputMaybe<Order_By>;
};

/** primary key columns input for table: farmer_nearby_field_force */
export type Farmer_Nearby_Field_Force_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** select columns of table "farmer_nearby_field_force" */
export enum Farmer_Nearby_Field_Force_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  NearbyFieldForce = 'nearby_field_force'
}

/** input type for updating data in table "farmer_nearby_field_force" */
export type Farmer_Nearby_Field_Force_Set_Input = {
  id?: InputMaybe<Scalars['bpchar']['input']>;
  location?: InputMaybe<Scalars['geography']['input']>;
  nearby_field_force?: InputMaybe<Scalars['json']['input']>;
};

/** Streaming cursor of the table "farmer_nearby_field_force" */
export type Farmer_Nearby_Field_Force_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Farmer_Nearby_Field_Force_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Farmer_Nearby_Field_Force_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bpchar']['input']>;
  location?: InputMaybe<Scalars['geography']['input']>;
  nearby_field_force?: InputMaybe<Scalars['json']['input']>;
};

/** update columns of table "farmer_nearby_field_force" */
export enum Farmer_Nearby_Field_Force_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  NearbyFieldForce = 'nearby_field_force'
}

export type Farmer_Nearby_Field_Force_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Farmer_Nearby_Field_Force_Set_Input>;
  /** filter the rows which have to be updated */
  where: Farmer_Nearby_Field_Force_Bool_Exp;
};

/** columns and relationships of "farmer_plots" */
export type Farmer_Plots = {
  __typename?: 'farmer_plots';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crop_id: Scalars['bpchar']['output'];
  crop_name: Scalars['String']['output'];
  date_of_sowing: Scalars['date']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  farmer_user_id: Scalars['bpchar']['output'];
  id: Scalars['bpchar']['output'];
  image_url?: Maybe<Scalars['String']['output']>;
  lat: Scalars['float8']['output'];
  lng: Scalars['float8']['output'];
  /** An object relationship */
  master_crop: Master_Crops;
  polygon_coordinates?: Maybe<Scalars['geography']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user: Users;
};

/** aggregated selection of "farmer_plots" */
export type Farmer_Plots_Aggregate = {
  __typename?: 'farmer_plots_aggregate';
  aggregate?: Maybe<Farmer_Plots_Aggregate_Fields>;
  nodes: Array<Farmer_Plots>;
};

export type Farmer_Plots_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Farmer_Plots_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Farmer_Plots_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Farmer_Plots_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Farmer_Plots_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Farmer_Plots_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Farmer_Plots_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Farmer_Plots_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Farmer_Plots_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Farmer_Plots_Aggregate_Bool_Exp_Var_Samp>;
};

export type Farmer_Plots_Aggregate_Bool_Exp_Avg = {
  arguments: Farmer_Plots_Select_Column_Farmer_Plots_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farmer_Plots_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Farmer_Plots_Aggregate_Bool_Exp_Corr = {
  arguments: Farmer_Plots_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farmer_Plots_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Farmer_Plots_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Farmer_Plots_Select_Column_Farmer_Plots_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Farmer_Plots_Select_Column_Farmer_Plots_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Farmer_Plots_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Farmer_Plots_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farmer_Plots_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Farmer_Plots_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Farmer_Plots_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farmer_Plots_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Farmer_Plots_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Farmer_Plots_Select_Column_Farmer_Plots_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Farmer_Plots_Select_Column_Farmer_Plots_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Farmer_Plots_Aggregate_Bool_Exp_Max = {
  arguments: Farmer_Plots_Select_Column_Farmer_Plots_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farmer_Plots_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Farmer_Plots_Aggregate_Bool_Exp_Min = {
  arguments: Farmer_Plots_Select_Column_Farmer_Plots_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farmer_Plots_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Farmer_Plots_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Farmer_Plots_Select_Column_Farmer_Plots_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farmer_Plots_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Farmer_Plots_Aggregate_Bool_Exp_Sum = {
  arguments: Farmer_Plots_Select_Column_Farmer_Plots_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farmer_Plots_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Farmer_Plots_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Farmer_Plots_Select_Column_Farmer_Plots_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farmer_Plots_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "farmer_plots" */
export type Farmer_Plots_Aggregate_Fields = {
  __typename?: 'farmer_plots_aggregate_fields';
  avg?: Maybe<Farmer_Plots_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Farmer_Plots_Max_Fields>;
  min?: Maybe<Farmer_Plots_Min_Fields>;
  stddev?: Maybe<Farmer_Plots_Stddev_Fields>;
  stddev_pop?: Maybe<Farmer_Plots_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Farmer_Plots_Stddev_Samp_Fields>;
  sum?: Maybe<Farmer_Plots_Sum_Fields>;
  var_pop?: Maybe<Farmer_Plots_Var_Pop_Fields>;
  var_samp?: Maybe<Farmer_Plots_Var_Samp_Fields>;
  variance?: Maybe<Farmer_Plots_Variance_Fields>;
};


/** aggregate fields of "farmer_plots" */
export type Farmer_Plots_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Farmer_Plots_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "farmer_plots" */
export type Farmer_Plots_Aggregate_Order_By = {
  avg?: InputMaybe<Farmer_Plots_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Farmer_Plots_Max_Order_By>;
  min?: InputMaybe<Farmer_Plots_Min_Order_By>;
  stddev?: InputMaybe<Farmer_Plots_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Farmer_Plots_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Farmer_Plots_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Farmer_Plots_Sum_Order_By>;
  var_pop?: InputMaybe<Farmer_Plots_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Farmer_Plots_Var_Samp_Order_By>;
  variance?: InputMaybe<Farmer_Plots_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "farmer_plots" */
export type Farmer_Plots_Arr_Rel_Insert_Input = {
  data: Array<Farmer_Plots_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Farmer_Plots_On_Conflict>;
};

/** aggregate avg on columns */
export type Farmer_Plots_Avg_Fields = {
  __typename?: 'farmer_plots_avg_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "farmer_plots" */
export type Farmer_Plots_Avg_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "farmer_plots". All fields are combined with a logical 'AND'. */
export type Farmer_Plots_Bool_Exp = {
  _and?: InputMaybe<Array<Farmer_Plots_Bool_Exp>>;
  _not?: InputMaybe<Farmer_Plots_Bool_Exp>;
  _or?: InputMaybe<Array<Farmer_Plots_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  crop_id?: InputMaybe<Bpchar_Comparison_Exp>;
  crop_name?: InputMaybe<String_Comparison_Exp>;
  date_of_sowing?: InputMaybe<Date_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  farmer_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  lat?: InputMaybe<Float8_Comparison_Exp>;
  lng?: InputMaybe<Float8_Comparison_Exp>;
  master_crop?: InputMaybe<Master_Crops_Bool_Exp>;
  polygon_coordinates?: InputMaybe<Geography_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "farmer_plots" */
export enum Farmer_Plots_Constraint {
  /** unique or primary key constraint on columns "id" */
  FarmerPlotsPkey = 'farmer_plots_pkey'
}

/** input type for incrementing numeric columns in table "farmer_plots" */
export type Farmer_Plots_Inc_Input = {
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "farmer_plots" */
export type Farmer_Plots_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crop_id?: InputMaybe<Scalars['bpchar']['input']>;
  crop_name?: InputMaybe<Scalars['String']['input']>;
  date_of_sowing?: InputMaybe<Scalars['date']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  image_url?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  master_crop?: InputMaybe<Master_Crops_Obj_Rel_Insert_Input>;
  polygon_coordinates?: InputMaybe<Scalars['geography']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Farmer_Plots_Max_Fields = {
  __typename?: 'farmer_plots_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crop_id?: Maybe<Scalars['bpchar']['output']>;
  crop_name?: Maybe<Scalars['String']['output']>;
  date_of_sowing?: Maybe<Scalars['date']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  farmer_user_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "farmer_plots" */
export type Farmer_Plots_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  crop_name?: InputMaybe<Order_By>;
  date_of_sowing?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  farmer_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Farmer_Plots_Min_Fields = {
  __typename?: 'farmer_plots_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crop_id?: Maybe<Scalars['bpchar']['output']>;
  crop_name?: Maybe<Scalars['String']['output']>;
  date_of_sowing?: Maybe<Scalars['date']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  farmer_user_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "farmer_plots" */
export type Farmer_Plots_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  crop_name?: InputMaybe<Order_By>;
  date_of_sowing?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  farmer_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "farmer_plots" */
export type Farmer_Plots_Mutation_Response = {
  __typename?: 'farmer_plots_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Farmer_Plots>;
};

/** on_conflict condition type for table "farmer_plots" */
export type Farmer_Plots_On_Conflict = {
  constraint: Farmer_Plots_Constraint;
  update_columns?: Array<Farmer_Plots_Update_Column>;
  where?: InputMaybe<Farmer_Plots_Bool_Exp>;
};

/** Ordering options when selecting data from "farmer_plots". */
export type Farmer_Plots_Order_By = {
  created_at?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  crop_name?: InputMaybe<Order_By>;
  date_of_sowing?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  farmer_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  master_crop?: InputMaybe<Master_Crops_Order_By>;
  polygon_coordinates?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: farmer_plots */
export type Farmer_Plots_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** select columns of table "farmer_plots" */
export enum Farmer_Plots_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  CropName = 'crop_name',
  /** column name */
  DateOfSowing = 'date_of_sowing',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FarmerUserId = 'farmer_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  PolygonCoordinates = 'polygon_coordinates',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "farmer_plots_aggregate_bool_exp_avg_arguments_columns" columns of table "farmer_plots" */
export enum Farmer_Plots_Select_Column_Farmer_Plots_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "farmer_plots_aggregate_bool_exp_corr_arguments_columns" columns of table "farmer_plots" */
export enum Farmer_Plots_Select_Column_Farmer_Plots_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "farmer_plots_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "farmer_plots" */
export enum Farmer_Plots_Select_Column_Farmer_Plots_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "farmer_plots_aggregate_bool_exp_max_arguments_columns" columns of table "farmer_plots" */
export enum Farmer_Plots_Select_Column_Farmer_Plots_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "farmer_plots_aggregate_bool_exp_min_arguments_columns" columns of table "farmer_plots" */
export enum Farmer_Plots_Select_Column_Farmer_Plots_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "farmer_plots_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "farmer_plots" */
export enum Farmer_Plots_Select_Column_Farmer_Plots_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "farmer_plots_aggregate_bool_exp_sum_arguments_columns" columns of table "farmer_plots" */
export enum Farmer_Plots_Select_Column_Farmer_Plots_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "farmer_plots_aggregate_bool_exp_var_samp_arguments_columns" columns of table "farmer_plots" */
export enum Farmer_Plots_Select_Column_Farmer_Plots_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** input type for updating data in table "farmer_plots" */
export type Farmer_Plots_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crop_id?: InputMaybe<Scalars['bpchar']['input']>;
  crop_name?: InputMaybe<Scalars['String']['input']>;
  date_of_sowing?: InputMaybe<Scalars['date']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  image_url?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  polygon_coordinates?: InputMaybe<Scalars['geography']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Farmer_Plots_Stddev_Fields = {
  __typename?: 'farmer_plots_stddev_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "farmer_plots" */
export type Farmer_Plots_Stddev_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Farmer_Plots_Stddev_Pop_Fields = {
  __typename?: 'farmer_plots_stddev_pop_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "farmer_plots" */
export type Farmer_Plots_Stddev_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Farmer_Plots_Stddev_Samp_Fields = {
  __typename?: 'farmer_plots_stddev_samp_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "farmer_plots" */
export type Farmer_Plots_Stddev_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "farmer_plots" */
export type Farmer_Plots_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Farmer_Plots_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Farmer_Plots_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crop_id?: InputMaybe<Scalars['bpchar']['input']>;
  crop_name?: InputMaybe<Scalars['String']['input']>;
  date_of_sowing?: InputMaybe<Scalars['date']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  image_url?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  polygon_coordinates?: InputMaybe<Scalars['geography']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Farmer_Plots_Sum_Fields = {
  __typename?: 'farmer_plots_sum_fields';
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "farmer_plots" */
export type Farmer_Plots_Sum_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** update columns of table "farmer_plots" */
export enum Farmer_Plots_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  CropName = 'crop_name',
  /** column name */
  DateOfSowing = 'date_of_sowing',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FarmerUserId = 'farmer_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  PolygonCoordinates = 'polygon_coordinates',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Farmer_Plots_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Farmer_Plots_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Farmer_Plots_Set_Input>;
  /** filter the rows which have to be updated */
  where: Farmer_Plots_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Farmer_Plots_Var_Pop_Fields = {
  __typename?: 'farmer_plots_var_pop_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "farmer_plots" */
export type Farmer_Plots_Var_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Farmer_Plots_Var_Samp_Fields = {
  __typename?: 'farmer_plots_var_samp_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "farmer_plots" */
export type Farmer_Plots_Var_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Farmer_Plots_Variance_Fields = {
  __typename?: 'farmer_plots_variance_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "farmer_plots" */
export type Farmer_Plots_Variance_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** columns and relationships of "farminsta_links" */
export type Farminsta_Links = {
  __typename?: 'farminsta_links';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  go_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  link_name?: Maybe<Scalars['String']['output']>;
  pop_id?: Maybe<Scalars['bpchar']['output']>;
  reel_id?: Maybe<Scalars['bigint']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id: Scalars['bpchar']['output'];
};

/** aggregated selection of "farminsta_links" */
export type Farminsta_Links_Aggregate = {
  __typename?: 'farminsta_links_aggregate';
  aggregate?: Maybe<Farminsta_Links_Aggregate_Fields>;
  nodes: Array<Farminsta_Links>;
};

/** aggregate fields of "farminsta_links" */
export type Farminsta_Links_Aggregate_Fields = {
  __typename?: 'farminsta_links_aggregate_fields';
  avg?: Maybe<Farminsta_Links_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Farminsta_Links_Max_Fields>;
  min?: Maybe<Farminsta_Links_Min_Fields>;
  stddev?: Maybe<Farminsta_Links_Stddev_Fields>;
  stddev_pop?: Maybe<Farminsta_Links_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Farminsta_Links_Stddev_Samp_Fields>;
  sum?: Maybe<Farminsta_Links_Sum_Fields>;
  var_pop?: Maybe<Farminsta_Links_Var_Pop_Fields>;
  var_samp?: Maybe<Farminsta_Links_Var_Samp_Fields>;
  variance?: Maybe<Farminsta_Links_Variance_Fields>;
};


/** aggregate fields of "farminsta_links" */
export type Farminsta_Links_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Farminsta_Links_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Farminsta_Links_Avg_Fields = {
  __typename?: 'farminsta_links_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "farminsta_links". All fields are combined with a logical 'AND'. */
export type Farminsta_Links_Bool_Exp = {
  _and?: InputMaybe<Array<Farminsta_Links_Bool_Exp>>;
  _not?: InputMaybe<Farminsta_Links_Bool_Exp>;
  _or?: InputMaybe<Array<Farminsta_Links_Bool_Exp>>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  company_id?: InputMaybe<Bpchar_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  go_url?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  link_name?: InputMaybe<String_Comparison_Exp>;
  pop_id?: InputMaybe<Bpchar_Comparison_Exp>;
  reel_id?: InputMaybe<Bigint_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "farminsta_links" */
export enum Farminsta_Links_Constraint {
  /** unique or primary key constraint on columns "id" */
  FarminstaLinksPkey = 'farminsta_links_pkey'
}

/** input type for incrementing numeric columns in table "farminsta_links" */
export type Farminsta_Links_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  reel_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "farminsta_links" */
export type Farminsta_Links_Insert_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  go_url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  link_name?: InputMaybe<Scalars['String']['input']>;
  pop_id?: InputMaybe<Scalars['bpchar']['input']>;
  reel_id?: InputMaybe<Scalars['bigint']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Farminsta_Links_Max_Fields = {
  __typename?: 'farminsta_links_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  go_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  link_name?: Maybe<Scalars['String']['output']>;
  pop_id?: Maybe<Scalars['bpchar']['output']>;
  reel_id?: Maybe<Scalars['bigint']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** aggregate min on columns */
export type Farminsta_Links_Min_Fields = {
  __typename?: 'farminsta_links_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  go_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  link_name?: Maybe<Scalars['String']['output']>;
  pop_id?: Maybe<Scalars['bpchar']['output']>;
  reel_id?: Maybe<Scalars['bigint']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** response of any mutation on the table "farminsta_links" */
export type Farminsta_Links_Mutation_Response = {
  __typename?: 'farminsta_links_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Farminsta_Links>;
};

/** on_conflict condition type for table "farminsta_links" */
export type Farminsta_Links_On_Conflict = {
  constraint: Farminsta_Links_Constraint;
  update_columns?: Array<Farminsta_Links_Update_Column>;
  where?: InputMaybe<Farminsta_Links_Bool_Exp>;
};

/** Ordering options when selecting data from "farminsta_links". */
export type Farminsta_Links_Order_By = {
  account_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  go_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  link_name?: InputMaybe<Order_By>;
  pop_id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: farminsta_links */
export type Farminsta_Links_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "farminsta_links" */
export enum Farminsta_Links_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  GoUrl = 'go_url',
  /** column name */
  Id = 'id',
  /** column name */
  LinkName = 'link_name',
  /** column name */
  PopId = 'pop_id',
  /** column name */
  ReelId = 'reel_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "farminsta_links" */
export type Farminsta_Links_Set_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  go_url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  link_name?: InputMaybe<Scalars['String']['input']>;
  pop_id?: InputMaybe<Scalars['bpchar']['input']>;
  reel_id?: InputMaybe<Scalars['bigint']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate stddev on columns */
export type Farminsta_Links_Stddev_Fields = {
  __typename?: 'farminsta_links_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Farminsta_Links_Stddev_Pop_Fields = {
  __typename?: 'farminsta_links_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Farminsta_Links_Stddev_Samp_Fields = {
  __typename?: 'farminsta_links_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "farminsta_links" */
export type Farminsta_Links_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Farminsta_Links_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Farminsta_Links_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  go_url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  link_name?: InputMaybe<Scalars['String']['input']>;
  pop_id?: InputMaybe<Scalars['bpchar']['input']>;
  reel_id?: InputMaybe<Scalars['bigint']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate sum on columns */
export type Farminsta_Links_Sum_Fields = {
  __typename?: 'farminsta_links_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  reel_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "farminsta_links" */
export enum Farminsta_Links_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  GoUrl = 'go_url',
  /** column name */
  Id = 'id',
  /** column name */
  LinkName = 'link_name',
  /** column name */
  PopId = 'pop_id',
  /** column name */
  ReelId = 'reel_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Farminsta_Links_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Farminsta_Links_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Farminsta_Links_Set_Input>;
  /** filter the rows which have to be updated */
  where: Farminsta_Links_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Farminsta_Links_Var_Pop_Fields = {
  __typename?: 'farminsta_links_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Farminsta_Links_Var_Samp_Fields = {
  __typename?: 'farminsta_links_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Farminsta_Links_Variance_Fields = {
  __typename?: 'farminsta_links_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "features" */
export type Features = {
  __typename?: 'features';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "features" */
export type Features_Aggregate = {
  __typename?: 'features_aggregate';
  aggregate?: Maybe<Features_Aggregate_Fields>;
  nodes: Array<Features>;
};

/** aggregate fields of "features" */
export type Features_Aggregate_Fields = {
  __typename?: 'features_aggregate_fields';
  avg?: Maybe<Features_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Features_Max_Fields>;
  min?: Maybe<Features_Min_Fields>;
  stddev?: Maybe<Features_Stddev_Fields>;
  stddev_pop?: Maybe<Features_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Features_Stddev_Samp_Fields>;
  sum?: Maybe<Features_Sum_Fields>;
  var_pop?: Maybe<Features_Var_Pop_Fields>;
  var_samp?: Maybe<Features_Var_Samp_Fields>;
  variance?: Maybe<Features_Variance_Fields>;
};


/** aggregate fields of "features" */
export type Features_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Features_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Features_Avg_Fields = {
  __typename?: 'features_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "features". All fields are combined with a logical 'AND'. */
export type Features_Bool_Exp = {
  _and?: InputMaybe<Array<Features_Bool_Exp>>;
  _not?: InputMaybe<Features_Bool_Exp>;
  _or?: InputMaybe<Array<Features_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  scope?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "features" */
export enum Features_Constraint {
  /** unique or primary key constraint on columns "scope", "name" */
  FeaturesNameScopeUnique = 'features_name_scope_unique',
  /** unique or primary key constraint on columns "id" */
  FeaturesPkey = 'features_pkey'
}

/** input type for incrementing numeric columns in table "features" */
export type Features_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "features" */
export type Features_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Features_Max_Fields = {
  __typename?: 'features_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Features_Min_Fields = {
  __typename?: 'features_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "features" */
export type Features_Mutation_Response = {
  __typename?: 'features_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Features>;
};

/** on_conflict condition type for table "features" */
export type Features_On_Conflict = {
  constraint: Features_Constraint;
  update_columns?: Array<Features_Update_Column>;
  where?: InputMaybe<Features_Bool_Exp>;
};

/** Ordering options when selecting data from "features". */
export type Features_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: features */
export type Features_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "features" */
export enum Features_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Scope = 'scope',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "features" */
export type Features_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Features_Stddev_Fields = {
  __typename?: 'features_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Features_Stddev_Pop_Fields = {
  __typename?: 'features_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Features_Stddev_Samp_Fields = {
  __typename?: 'features_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "features" */
export type Features_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Features_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Features_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Features_Sum_Fields = {
  __typename?: 'features_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "features" */
export enum Features_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Scope = 'scope',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

export type Features_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Features_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Features_Set_Input>;
  /** filter the rows which have to be updated */
  where: Features_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Features_Var_Pop_Fields = {
  __typename?: 'features_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Features_Var_Samp_Fields = {
  __typename?: 'features_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Features_Variance_Fields = {
  __typename?: 'features_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "dbt.channel_analytics" */
export type Fich_Farminsta_Replica_Channel_Analytics = {
  __typename?: 'fich_farminsta_replica_channel_analytics';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  account_name?: Maybe<Scalars['String']['output']>;
  active_lead_count?: Maybe<Scalars['bigint']['output']>;
  channel_id?: Maybe<Scalars['bigint']['output']>;
  closed_requests?: Maybe<Scalars['bigint']['output']>;
  crop_count?: Maybe<Scalars['bigint']['output']>;
  delayed_requests?: Maybe<Scalars['bigint']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  follower_count?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lead_count?: Maybe<Scalars['bigint']['output']>;
  logo_image_url?: Maybe<Scalars['String']['output']>;
  missed_requests?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  new_requests?: Maybe<Scalars['bigint']['output']>;
  open_requests?: Maybe<Scalars['bigint']['output']>;
  pending_lead_count?: Maybe<Scalars['bigint']['output']>;
  reel_count?: Maybe<Scalars['bigint']['output']>;
  rejected_lead_count?: Maybe<Scalars['bigint']['output']>;
  requested_lead_count?: Maybe<Scalars['bigint']['output']>;
  total_comment_count?: Maybe<Scalars['numeric']['output']>;
  total_engagement_count?: Maybe<Scalars['numeric']['output']>;
  total_playback_count?: Maybe<Scalars['numeric']['output']>;
  total_react_count?: Maybe<Scalars['numeric']['output']>;
  total_requests?: Maybe<Scalars['bigint']['output']>;
  total_share_count?: Maybe<Scalars['numeric']['output']>;
  total_view_count?: Maybe<Scalars['numeric']['output']>;
  total_watch_time_secs?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "dbt.channel_analytics" */
export type Fich_Farminsta_Replica_Channel_Analytics_Aggregate = {
  __typename?: 'fich_farminsta_replica_channel_analytics_aggregate';
  aggregate?: Maybe<Fich_Farminsta_Replica_Channel_Analytics_Aggregate_Fields>;
  nodes: Array<Fich_Farminsta_Replica_Channel_Analytics>;
};

/** aggregate fields of "dbt.channel_analytics" */
export type Fich_Farminsta_Replica_Channel_Analytics_Aggregate_Fields = {
  __typename?: 'fich_farminsta_replica_channel_analytics_aggregate_fields';
  avg?: Maybe<Fich_Farminsta_Replica_Channel_Analytics_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Fich_Farminsta_Replica_Channel_Analytics_Max_Fields>;
  min?: Maybe<Fich_Farminsta_Replica_Channel_Analytics_Min_Fields>;
  stddev?: Maybe<Fich_Farminsta_Replica_Channel_Analytics_Stddev_Fields>;
  stddev_pop?: Maybe<Fich_Farminsta_Replica_Channel_Analytics_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fich_Farminsta_Replica_Channel_Analytics_Stddev_Samp_Fields>;
  sum?: Maybe<Fich_Farminsta_Replica_Channel_Analytics_Sum_Fields>;
  var_pop?: Maybe<Fich_Farminsta_Replica_Channel_Analytics_Var_Pop_Fields>;
  var_samp?: Maybe<Fich_Farminsta_Replica_Channel_Analytics_Var_Samp_Fields>;
  variance?: Maybe<Fich_Farminsta_Replica_Channel_Analytics_Variance_Fields>;
};


/** aggregate fields of "dbt.channel_analytics" */
export type Fich_Farminsta_Replica_Channel_Analytics_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fich_Farminsta_Replica_Channel_Analytics_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Fich_Farminsta_Replica_Channel_Analytics_Avg_Fields = {
  __typename?: 'fich_farminsta_replica_channel_analytics_avg_fields';
  active_lead_count?: Maybe<Scalars['Float']['output']>;
  channel_id?: Maybe<Scalars['Float']['output']>;
  closed_requests?: Maybe<Scalars['Float']['output']>;
  crop_count?: Maybe<Scalars['Float']['output']>;
  delayed_requests?: Maybe<Scalars['Float']['output']>;
  follower_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lead_count?: Maybe<Scalars['Float']['output']>;
  missed_requests?: Maybe<Scalars['Float']['output']>;
  new_requests?: Maybe<Scalars['Float']['output']>;
  open_requests?: Maybe<Scalars['Float']['output']>;
  pending_lead_count?: Maybe<Scalars['Float']['output']>;
  reel_count?: Maybe<Scalars['Float']['output']>;
  rejected_lead_count?: Maybe<Scalars['Float']['output']>;
  requested_lead_count?: Maybe<Scalars['Float']['output']>;
  total_comment_count?: Maybe<Scalars['Float']['output']>;
  total_engagement_count?: Maybe<Scalars['Float']['output']>;
  total_playback_count?: Maybe<Scalars['Float']['output']>;
  total_react_count?: Maybe<Scalars['Float']['output']>;
  total_requests?: Maybe<Scalars['Float']['output']>;
  total_share_count?: Maybe<Scalars['Float']['output']>;
  total_view_count?: Maybe<Scalars['Float']['output']>;
  total_watch_time_secs?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "dbt.channel_analytics". All fields are combined with a logical 'AND'. */
export type Fich_Farminsta_Replica_Channel_Analytics_Bool_Exp = {
  _and?: InputMaybe<Array<Fich_Farminsta_Replica_Channel_Analytics_Bool_Exp>>;
  _not?: InputMaybe<Fich_Farminsta_Replica_Channel_Analytics_Bool_Exp>;
  _or?: InputMaybe<Array<Fich_Farminsta_Replica_Channel_Analytics_Bool_Exp>>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  account_name?: InputMaybe<String_Comparison_Exp>;
  active_lead_count?: InputMaybe<Bigint_Comparison_Exp>;
  channel_id?: InputMaybe<Bigint_Comparison_Exp>;
  closed_requests?: InputMaybe<Bigint_Comparison_Exp>;
  crop_count?: InputMaybe<Bigint_Comparison_Exp>;
  delayed_requests?: InputMaybe<Bigint_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  follower_count?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lead_count?: InputMaybe<Bigint_Comparison_Exp>;
  logo_image_url?: InputMaybe<String_Comparison_Exp>;
  missed_requests?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  new_requests?: InputMaybe<Bigint_Comparison_Exp>;
  open_requests?: InputMaybe<Bigint_Comparison_Exp>;
  pending_lead_count?: InputMaybe<Bigint_Comparison_Exp>;
  reel_count?: InputMaybe<Bigint_Comparison_Exp>;
  rejected_lead_count?: InputMaybe<Bigint_Comparison_Exp>;
  requested_lead_count?: InputMaybe<Bigint_Comparison_Exp>;
  total_comment_count?: InputMaybe<Numeric_Comparison_Exp>;
  total_engagement_count?: InputMaybe<Numeric_Comparison_Exp>;
  total_playback_count?: InputMaybe<Numeric_Comparison_Exp>;
  total_react_count?: InputMaybe<Numeric_Comparison_Exp>;
  total_requests?: InputMaybe<Bigint_Comparison_Exp>;
  total_share_count?: InputMaybe<Numeric_Comparison_Exp>;
  total_view_count?: InputMaybe<Numeric_Comparison_Exp>;
  total_watch_time_secs?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type Fich_Farminsta_Replica_Channel_Analytics_Max_Fields = {
  __typename?: 'fich_farminsta_replica_channel_analytics_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  account_name?: Maybe<Scalars['String']['output']>;
  active_lead_count?: Maybe<Scalars['bigint']['output']>;
  channel_id?: Maybe<Scalars['bigint']['output']>;
  closed_requests?: Maybe<Scalars['bigint']['output']>;
  crop_count?: Maybe<Scalars['bigint']['output']>;
  delayed_requests?: Maybe<Scalars['bigint']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  follower_count?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lead_count?: Maybe<Scalars['bigint']['output']>;
  logo_image_url?: Maybe<Scalars['String']['output']>;
  missed_requests?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  new_requests?: Maybe<Scalars['bigint']['output']>;
  open_requests?: Maybe<Scalars['bigint']['output']>;
  pending_lead_count?: Maybe<Scalars['bigint']['output']>;
  reel_count?: Maybe<Scalars['bigint']['output']>;
  rejected_lead_count?: Maybe<Scalars['bigint']['output']>;
  requested_lead_count?: Maybe<Scalars['bigint']['output']>;
  total_comment_count?: Maybe<Scalars['numeric']['output']>;
  total_engagement_count?: Maybe<Scalars['numeric']['output']>;
  total_playback_count?: Maybe<Scalars['numeric']['output']>;
  total_react_count?: Maybe<Scalars['numeric']['output']>;
  total_requests?: Maybe<Scalars['bigint']['output']>;
  total_share_count?: Maybe<Scalars['numeric']['output']>;
  total_view_count?: Maybe<Scalars['numeric']['output']>;
  total_watch_time_secs?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type Fich_Farminsta_Replica_Channel_Analytics_Min_Fields = {
  __typename?: 'fich_farminsta_replica_channel_analytics_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  account_name?: Maybe<Scalars['String']['output']>;
  active_lead_count?: Maybe<Scalars['bigint']['output']>;
  channel_id?: Maybe<Scalars['bigint']['output']>;
  closed_requests?: Maybe<Scalars['bigint']['output']>;
  crop_count?: Maybe<Scalars['bigint']['output']>;
  delayed_requests?: Maybe<Scalars['bigint']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  follower_count?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lead_count?: Maybe<Scalars['bigint']['output']>;
  logo_image_url?: Maybe<Scalars['String']['output']>;
  missed_requests?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  new_requests?: Maybe<Scalars['bigint']['output']>;
  open_requests?: Maybe<Scalars['bigint']['output']>;
  pending_lead_count?: Maybe<Scalars['bigint']['output']>;
  reel_count?: Maybe<Scalars['bigint']['output']>;
  rejected_lead_count?: Maybe<Scalars['bigint']['output']>;
  requested_lead_count?: Maybe<Scalars['bigint']['output']>;
  total_comment_count?: Maybe<Scalars['numeric']['output']>;
  total_engagement_count?: Maybe<Scalars['numeric']['output']>;
  total_playback_count?: Maybe<Scalars['numeric']['output']>;
  total_react_count?: Maybe<Scalars['numeric']['output']>;
  total_requests?: Maybe<Scalars['bigint']['output']>;
  total_share_count?: Maybe<Scalars['numeric']['output']>;
  total_view_count?: Maybe<Scalars['numeric']['output']>;
  total_watch_time_secs?: Maybe<Scalars['numeric']['output']>;
};

/** Ordering options when selecting data from "dbt.channel_analytics". */
export type Fich_Farminsta_Replica_Channel_Analytics_Order_By = {
  account_id?: InputMaybe<Order_By>;
  account_name?: InputMaybe<Order_By>;
  active_lead_count?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  closed_requests?: InputMaybe<Order_By>;
  crop_count?: InputMaybe<Order_By>;
  delayed_requests?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  follower_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lead_count?: InputMaybe<Order_By>;
  logo_image_url?: InputMaybe<Order_By>;
  missed_requests?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  new_requests?: InputMaybe<Order_By>;
  open_requests?: InputMaybe<Order_By>;
  pending_lead_count?: InputMaybe<Order_By>;
  reel_count?: InputMaybe<Order_By>;
  rejected_lead_count?: InputMaybe<Order_By>;
  requested_lead_count?: InputMaybe<Order_By>;
  total_comment_count?: InputMaybe<Order_By>;
  total_engagement_count?: InputMaybe<Order_By>;
  total_playback_count?: InputMaybe<Order_By>;
  total_react_count?: InputMaybe<Order_By>;
  total_requests?: InputMaybe<Order_By>;
  total_share_count?: InputMaybe<Order_By>;
  total_view_count?: InputMaybe<Order_By>;
  total_watch_time_secs?: InputMaybe<Order_By>;
};

/** select columns of table "dbt.channel_analytics" */
export enum Fich_Farminsta_Replica_Channel_Analytics_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AccountName = 'account_name',
  /** column name */
  ActiveLeadCount = 'active_lead_count',
  /** column name */
  ChannelId = 'channel_id',
  /** column name */
  ClosedRequests = 'closed_requests',
  /** column name */
  CropCount = 'crop_count',
  /** column name */
  DelayedRequests = 'delayed_requests',
  /** column name */
  Description = 'description',
  /** column name */
  FollowerCount = 'follower_count',
  /** column name */
  Id = 'id',
  /** column name */
  LeadCount = 'lead_count',
  /** column name */
  LogoImageUrl = 'logo_image_url',
  /** column name */
  MissedRequests = 'missed_requests',
  /** column name */
  Name = 'name',
  /** column name */
  NewRequests = 'new_requests',
  /** column name */
  OpenRequests = 'open_requests',
  /** column name */
  PendingLeadCount = 'pending_lead_count',
  /** column name */
  ReelCount = 'reel_count',
  /** column name */
  RejectedLeadCount = 'rejected_lead_count',
  /** column name */
  RequestedLeadCount = 'requested_lead_count',
  /** column name */
  TotalCommentCount = 'total_comment_count',
  /** column name */
  TotalEngagementCount = 'total_engagement_count',
  /** column name */
  TotalPlaybackCount = 'total_playback_count',
  /** column name */
  TotalReactCount = 'total_react_count',
  /** column name */
  TotalRequests = 'total_requests',
  /** column name */
  TotalShareCount = 'total_share_count',
  /** column name */
  TotalViewCount = 'total_view_count',
  /** column name */
  TotalWatchTimeSecs = 'total_watch_time_secs'
}

/** aggregate stddev on columns */
export type Fich_Farminsta_Replica_Channel_Analytics_Stddev_Fields = {
  __typename?: 'fich_farminsta_replica_channel_analytics_stddev_fields';
  active_lead_count?: Maybe<Scalars['Float']['output']>;
  channel_id?: Maybe<Scalars['Float']['output']>;
  closed_requests?: Maybe<Scalars['Float']['output']>;
  crop_count?: Maybe<Scalars['Float']['output']>;
  delayed_requests?: Maybe<Scalars['Float']['output']>;
  follower_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lead_count?: Maybe<Scalars['Float']['output']>;
  missed_requests?: Maybe<Scalars['Float']['output']>;
  new_requests?: Maybe<Scalars['Float']['output']>;
  open_requests?: Maybe<Scalars['Float']['output']>;
  pending_lead_count?: Maybe<Scalars['Float']['output']>;
  reel_count?: Maybe<Scalars['Float']['output']>;
  rejected_lead_count?: Maybe<Scalars['Float']['output']>;
  requested_lead_count?: Maybe<Scalars['Float']['output']>;
  total_comment_count?: Maybe<Scalars['Float']['output']>;
  total_engagement_count?: Maybe<Scalars['Float']['output']>;
  total_playback_count?: Maybe<Scalars['Float']['output']>;
  total_react_count?: Maybe<Scalars['Float']['output']>;
  total_requests?: Maybe<Scalars['Float']['output']>;
  total_share_count?: Maybe<Scalars['Float']['output']>;
  total_view_count?: Maybe<Scalars['Float']['output']>;
  total_watch_time_secs?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Fich_Farminsta_Replica_Channel_Analytics_Stddev_Pop_Fields = {
  __typename?: 'fich_farminsta_replica_channel_analytics_stddev_pop_fields';
  active_lead_count?: Maybe<Scalars['Float']['output']>;
  channel_id?: Maybe<Scalars['Float']['output']>;
  closed_requests?: Maybe<Scalars['Float']['output']>;
  crop_count?: Maybe<Scalars['Float']['output']>;
  delayed_requests?: Maybe<Scalars['Float']['output']>;
  follower_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lead_count?: Maybe<Scalars['Float']['output']>;
  missed_requests?: Maybe<Scalars['Float']['output']>;
  new_requests?: Maybe<Scalars['Float']['output']>;
  open_requests?: Maybe<Scalars['Float']['output']>;
  pending_lead_count?: Maybe<Scalars['Float']['output']>;
  reel_count?: Maybe<Scalars['Float']['output']>;
  rejected_lead_count?: Maybe<Scalars['Float']['output']>;
  requested_lead_count?: Maybe<Scalars['Float']['output']>;
  total_comment_count?: Maybe<Scalars['Float']['output']>;
  total_engagement_count?: Maybe<Scalars['Float']['output']>;
  total_playback_count?: Maybe<Scalars['Float']['output']>;
  total_react_count?: Maybe<Scalars['Float']['output']>;
  total_requests?: Maybe<Scalars['Float']['output']>;
  total_share_count?: Maybe<Scalars['Float']['output']>;
  total_view_count?: Maybe<Scalars['Float']['output']>;
  total_watch_time_secs?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Fich_Farminsta_Replica_Channel_Analytics_Stddev_Samp_Fields = {
  __typename?: 'fich_farminsta_replica_channel_analytics_stddev_samp_fields';
  active_lead_count?: Maybe<Scalars['Float']['output']>;
  channel_id?: Maybe<Scalars['Float']['output']>;
  closed_requests?: Maybe<Scalars['Float']['output']>;
  crop_count?: Maybe<Scalars['Float']['output']>;
  delayed_requests?: Maybe<Scalars['Float']['output']>;
  follower_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lead_count?: Maybe<Scalars['Float']['output']>;
  missed_requests?: Maybe<Scalars['Float']['output']>;
  new_requests?: Maybe<Scalars['Float']['output']>;
  open_requests?: Maybe<Scalars['Float']['output']>;
  pending_lead_count?: Maybe<Scalars['Float']['output']>;
  reel_count?: Maybe<Scalars['Float']['output']>;
  rejected_lead_count?: Maybe<Scalars['Float']['output']>;
  requested_lead_count?: Maybe<Scalars['Float']['output']>;
  total_comment_count?: Maybe<Scalars['Float']['output']>;
  total_engagement_count?: Maybe<Scalars['Float']['output']>;
  total_playback_count?: Maybe<Scalars['Float']['output']>;
  total_react_count?: Maybe<Scalars['Float']['output']>;
  total_requests?: Maybe<Scalars['Float']['output']>;
  total_share_count?: Maybe<Scalars['Float']['output']>;
  total_view_count?: Maybe<Scalars['Float']['output']>;
  total_watch_time_secs?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "fich_farminsta_replica_channel_analytics" */
export type Fich_Farminsta_Replica_Channel_Analytics_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fich_Farminsta_Replica_Channel_Analytics_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fich_Farminsta_Replica_Channel_Analytics_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  account_name?: InputMaybe<Scalars['String']['input']>;
  active_lead_count?: InputMaybe<Scalars['bigint']['input']>;
  channel_id?: InputMaybe<Scalars['bigint']['input']>;
  closed_requests?: InputMaybe<Scalars['bigint']['input']>;
  crop_count?: InputMaybe<Scalars['bigint']['input']>;
  delayed_requests?: InputMaybe<Scalars['bigint']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  follower_count?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lead_count?: InputMaybe<Scalars['bigint']['input']>;
  logo_image_url?: InputMaybe<Scalars['String']['input']>;
  missed_requests?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  new_requests?: InputMaybe<Scalars['bigint']['input']>;
  open_requests?: InputMaybe<Scalars['bigint']['input']>;
  pending_lead_count?: InputMaybe<Scalars['bigint']['input']>;
  reel_count?: InputMaybe<Scalars['bigint']['input']>;
  rejected_lead_count?: InputMaybe<Scalars['bigint']['input']>;
  requested_lead_count?: InputMaybe<Scalars['bigint']['input']>;
  total_comment_count?: InputMaybe<Scalars['numeric']['input']>;
  total_engagement_count?: InputMaybe<Scalars['numeric']['input']>;
  total_playback_count?: InputMaybe<Scalars['numeric']['input']>;
  total_react_count?: InputMaybe<Scalars['numeric']['input']>;
  total_requests?: InputMaybe<Scalars['bigint']['input']>;
  total_share_count?: InputMaybe<Scalars['numeric']['input']>;
  total_view_count?: InputMaybe<Scalars['numeric']['input']>;
  total_watch_time_secs?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Fich_Farminsta_Replica_Channel_Analytics_Sum_Fields = {
  __typename?: 'fich_farminsta_replica_channel_analytics_sum_fields';
  active_lead_count?: Maybe<Scalars['bigint']['output']>;
  channel_id?: Maybe<Scalars['bigint']['output']>;
  closed_requests?: Maybe<Scalars['bigint']['output']>;
  crop_count?: Maybe<Scalars['bigint']['output']>;
  delayed_requests?: Maybe<Scalars['bigint']['output']>;
  follower_count?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lead_count?: Maybe<Scalars['bigint']['output']>;
  missed_requests?: Maybe<Scalars['bigint']['output']>;
  new_requests?: Maybe<Scalars['bigint']['output']>;
  open_requests?: Maybe<Scalars['bigint']['output']>;
  pending_lead_count?: Maybe<Scalars['bigint']['output']>;
  reel_count?: Maybe<Scalars['bigint']['output']>;
  rejected_lead_count?: Maybe<Scalars['bigint']['output']>;
  requested_lead_count?: Maybe<Scalars['bigint']['output']>;
  total_comment_count?: Maybe<Scalars['numeric']['output']>;
  total_engagement_count?: Maybe<Scalars['numeric']['output']>;
  total_playback_count?: Maybe<Scalars['numeric']['output']>;
  total_react_count?: Maybe<Scalars['numeric']['output']>;
  total_requests?: Maybe<Scalars['bigint']['output']>;
  total_share_count?: Maybe<Scalars['numeric']['output']>;
  total_view_count?: Maybe<Scalars['numeric']['output']>;
  total_watch_time_secs?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate var_pop on columns */
export type Fich_Farminsta_Replica_Channel_Analytics_Var_Pop_Fields = {
  __typename?: 'fich_farminsta_replica_channel_analytics_var_pop_fields';
  active_lead_count?: Maybe<Scalars['Float']['output']>;
  channel_id?: Maybe<Scalars['Float']['output']>;
  closed_requests?: Maybe<Scalars['Float']['output']>;
  crop_count?: Maybe<Scalars['Float']['output']>;
  delayed_requests?: Maybe<Scalars['Float']['output']>;
  follower_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lead_count?: Maybe<Scalars['Float']['output']>;
  missed_requests?: Maybe<Scalars['Float']['output']>;
  new_requests?: Maybe<Scalars['Float']['output']>;
  open_requests?: Maybe<Scalars['Float']['output']>;
  pending_lead_count?: Maybe<Scalars['Float']['output']>;
  reel_count?: Maybe<Scalars['Float']['output']>;
  rejected_lead_count?: Maybe<Scalars['Float']['output']>;
  requested_lead_count?: Maybe<Scalars['Float']['output']>;
  total_comment_count?: Maybe<Scalars['Float']['output']>;
  total_engagement_count?: Maybe<Scalars['Float']['output']>;
  total_playback_count?: Maybe<Scalars['Float']['output']>;
  total_react_count?: Maybe<Scalars['Float']['output']>;
  total_requests?: Maybe<Scalars['Float']['output']>;
  total_share_count?: Maybe<Scalars['Float']['output']>;
  total_view_count?: Maybe<Scalars['Float']['output']>;
  total_watch_time_secs?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Fich_Farminsta_Replica_Channel_Analytics_Var_Samp_Fields = {
  __typename?: 'fich_farminsta_replica_channel_analytics_var_samp_fields';
  active_lead_count?: Maybe<Scalars['Float']['output']>;
  channel_id?: Maybe<Scalars['Float']['output']>;
  closed_requests?: Maybe<Scalars['Float']['output']>;
  crop_count?: Maybe<Scalars['Float']['output']>;
  delayed_requests?: Maybe<Scalars['Float']['output']>;
  follower_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lead_count?: Maybe<Scalars['Float']['output']>;
  missed_requests?: Maybe<Scalars['Float']['output']>;
  new_requests?: Maybe<Scalars['Float']['output']>;
  open_requests?: Maybe<Scalars['Float']['output']>;
  pending_lead_count?: Maybe<Scalars['Float']['output']>;
  reel_count?: Maybe<Scalars['Float']['output']>;
  rejected_lead_count?: Maybe<Scalars['Float']['output']>;
  requested_lead_count?: Maybe<Scalars['Float']['output']>;
  total_comment_count?: Maybe<Scalars['Float']['output']>;
  total_engagement_count?: Maybe<Scalars['Float']['output']>;
  total_playback_count?: Maybe<Scalars['Float']['output']>;
  total_react_count?: Maybe<Scalars['Float']['output']>;
  total_requests?: Maybe<Scalars['Float']['output']>;
  total_share_count?: Maybe<Scalars['Float']['output']>;
  total_view_count?: Maybe<Scalars['Float']['output']>;
  total_watch_time_secs?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Fich_Farminsta_Replica_Channel_Analytics_Variance_Fields = {
  __typename?: 'fich_farminsta_replica_channel_analytics_variance_fields';
  active_lead_count?: Maybe<Scalars['Float']['output']>;
  channel_id?: Maybe<Scalars['Float']['output']>;
  closed_requests?: Maybe<Scalars['Float']['output']>;
  crop_count?: Maybe<Scalars['Float']['output']>;
  delayed_requests?: Maybe<Scalars['Float']['output']>;
  follower_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lead_count?: Maybe<Scalars['Float']['output']>;
  missed_requests?: Maybe<Scalars['Float']['output']>;
  new_requests?: Maybe<Scalars['Float']['output']>;
  open_requests?: Maybe<Scalars['Float']['output']>;
  pending_lead_count?: Maybe<Scalars['Float']['output']>;
  reel_count?: Maybe<Scalars['Float']['output']>;
  rejected_lead_count?: Maybe<Scalars['Float']['output']>;
  requested_lead_count?: Maybe<Scalars['Float']['output']>;
  total_comment_count?: Maybe<Scalars['Float']['output']>;
  total_engagement_count?: Maybe<Scalars['Float']['output']>;
  total_playback_count?: Maybe<Scalars['Float']['output']>;
  total_react_count?: Maybe<Scalars['Float']['output']>;
  total_requests?: Maybe<Scalars['Float']['output']>;
  total_share_count?: Maybe<Scalars['Float']['output']>;
  total_view_count?: Maybe<Scalars['Float']['output']>;
  total_watch_time_secs?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "dbt.leads" */
export type Fich_Farminsta_Replica_Leads = {
  __typename?: 'fich_farminsta_replica_leads';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crop_names?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  farmer_name?: Maybe<Scalars['String']['output']>;
  farmer_phone?: Maybe<Scalars['String']['output']>;
  farmer_profile_image_url?: Maybe<Scalars['String']['output']>;
  farmer_user_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  owner_name?: Maybe<Scalars['String']['output']>;
  owner_phone?: Maybe<Scalars['String']['output']>;
  owner_profile_image_url?: Maybe<Scalars['String']['output']>;
  owner_user_id?: Maybe<Scalars['bpchar']['output']>;
  source_interaction_ts?: Maybe<Scalars['timestamptz']['output']>;
  source_interaction_type?: Maybe<Scalars['String']['output']>;
  source_name?: Maybe<Scalars['String']['output']>;
  source_reel_id?: Maybe<Scalars['bigint']['output']>;
  source_reel_interaction_id?: Maybe<Scalars['bigint']['output']>;
  source_service_request_id?: Maybe<Scalars['bpchar']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  taluk?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "dbt.leads" */
export type Fich_Farminsta_Replica_Leads_Aggregate = {
  __typename?: 'fich_farminsta_replica_leads_aggregate';
  aggregate?: Maybe<Fich_Farminsta_Replica_Leads_Aggregate_Fields>;
  nodes: Array<Fich_Farminsta_Replica_Leads>;
};

/** aggregate fields of "dbt.leads" */
export type Fich_Farminsta_Replica_Leads_Aggregate_Fields = {
  __typename?: 'fich_farminsta_replica_leads_aggregate_fields';
  avg?: Maybe<Fich_Farminsta_Replica_Leads_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Fich_Farminsta_Replica_Leads_Max_Fields>;
  min?: Maybe<Fich_Farminsta_Replica_Leads_Min_Fields>;
  stddev?: Maybe<Fich_Farminsta_Replica_Leads_Stddev_Fields>;
  stddev_pop?: Maybe<Fich_Farminsta_Replica_Leads_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fich_Farminsta_Replica_Leads_Stddev_Samp_Fields>;
  sum?: Maybe<Fich_Farminsta_Replica_Leads_Sum_Fields>;
  var_pop?: Maybe<Fich_Farminsta_Replica_Leads_Var_Pop_Fields>;
  var_samp?: Maybe<Fich_Farminsta_Replica_Leads_Var_Samp_Fields>;
  variance?: Maybe<Fich_Farminsta_Replica_Leads_Variance_Fields>;
};


/** aggregate fields of "dbt.leads" */
export type Fich_Farminsta_Replica_Leads_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fich_Farminsta_Replica_Leads_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Fich_Farminsta_Replica_Leads_Avg_Fields = {
  __typename?: 'fich_farminsta_replica_leads_avg_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  source_reel_id?: Maybe<Scalars['Float']['output']>;
  source_reel_interaction_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "dbt.leads". All fields are combined with a logical 'AND'. */
export type Fich_Farminsta_Replica_Leads_Bool_Exp = {
  _and?: InputMaybe<Array<Fich_Farminsta_Replica_Leads_Bool_Exp>>;
  _not?: InputMaybe<Fich_Farminsta_Replica_Leads_Bool_Exp>;
  _or?: InputMaybe<Array<Fich_Farminsta_Replica_Leads_Bool_Exp>>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  address?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  crop_names?: InputMaybe<String_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  district?: InputMaybe<String_Comparison_Exp>;
  farmer_name?: InputMaybe<String_Comparison_Exp>;
  farmer_phone?: InputMaybe<String_Comparison_Exp>;
  farmer_profile_image_url?: InputMaybe<String_Comparison_Exp>;
  farmer_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  lat?: InputMaybe<Float8_Comparison_Exp>;
  lng?: InputMaybe<Float8_Comparison_Exp>;
  owner_name?: InputMaybe<String_Comparison_Exp>;
  owner_phone?: InputMaybe<String_Comparison_Exp>;
  owner_profile_image_url?: InputMaybe<String_Comparison_Exp>;
  owner_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  source_interaction_ts?: InputMaybe<Timestamptz_Comparison_Exp>;
  source_interaction_type?: InputMaybe<String_Comparison_Exp>;
  source_name?: InputMaybe<String_Comparison_Exp>;
  source_reel_id?: InputMaybe<Bigint_Comparison_Exp>;
  source_reel_interaction_id?: InputMaybe<Bigint_Comparison_Exp>;
  source_service_request_id?: InputMaybe<Bpchar_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  taluk?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Fich_Farminsta_Replica_Leads_Max_Fields = {
  __typename?: 'fich_farminsta_replica_leads_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crop_names?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  farmer_name?: Maybe<Scalars['String']['output']>;
  farmer_phone?: Maybe<Scalars['String']['output']>;
  farmer_profile_image_url?: Maybe<Scalars['String']['output']>;
  farmer_user_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  owner_name?: Maybe<Scalars['String']['output']>;
  owner_phone?: Maybe<Scalars['String']['output']>;
  owner_profile_image_url?: Maybe<Scalars['String']['output']>;
  owner_user_id?: Maybe<Scalars['bpchar']['output']>;
  source_interaction_ts?: Maybe<Scalars['timestamptz']['output']>;
  source_interaction_type?: Maybe<Scalars['String']['output']>;
  source_name?: Maybe<Scalars['String']['output']>;
  source_reel_id?: Maybe<Scalars['bigint']['output']>;
  source_reel_interaction_id?: Maybe<Scalars['bigint']['output']>;
  source_service_request_id?: Maybe<Scalars['bpchar']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  taluk?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Fich_Farminsta_Replica_Leads_Min_Fields = {
  __typename?: 'fich_farminsta_replica_leads_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crop_names?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  farmer_name?: Maybe<Scalars['String']['output']>;
  farmer_phone?: Maybe<Scalars['String']['output']>;
  farmer_profile_image_url?: Maybe<Scalars['String']['output']>;
  farmer_user_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  owner_name?: Maybe<Scalars['String']['output']>;
  owner_phone?: Maybe<Scalars['String']['output']>;
  owner_profile_image_url?: Maybe<Scalars['String']['output']>;
  owner_user_id?: Maybe<Scalars['bpchar']['output']>;
  source_interaction_ts?: Maybe<Scalars['timestamptz']['output']>;
  source_interaction_type?: Maybe<Scalars['String']['output']>;
  source_name?: Maybe<Scalars['String']['output']>;
  source_reel_id?: Maybe<Scalars['bigint']['output']>;
  source_reel_interaction_id?: Maybe<Scalars['bigint']['output']>;
  source_service_request_id?: Maybe<Scalars['bpchar']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  taluk?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "dbt.leads". */
export type Fich_Farminsta_Replica_Leads_Order_By = {
  account_id?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crop_names?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  district?: InputMaybe<Order_By>;
  farmer_name?: InputMaybe<Order_By>;
  farmer_phone?: InputMaybe<Order_By>;
  farmer_profile_image_url?: InputMaybe<Order_By>;
  farmer_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  owner_name?: InputMaybe<Order_By>;
  owner_phone?: InputMaybe<Order_By>;
  owner_profile_image_url?: InputMaybe<Order_By>;
  owner_user_id?: InputMaybe<Order_By>;
  source_interaction_ts?: InputMaybe<Order_By>;
  source_interaction_type?: InputMaybe<Order_By>;
  source_name?: InputMaybe<Order_By>;
  source_reel_id?: InputMaybe<Order_By>;
  source_reel_interaction_id?: InputMaybe<Order_By>;
  source_service_request_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  taluk?: InputMaybe<Order_By>;
};

/** select columns of table "dbt.leads" */
export enum Fich_Farminsta_Replica_Leads_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Address = 'address',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CropNames = 'crop_names',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  District = 'district',
  /** column name */
  FarmerName = 'farmer_name',
  /** column name */
  FarmerPhone = 'farmer_phone',
  /** column name */
  FarmerProfileImageUrl = 'farmer_profile_image_url',
  /** column name */
  FarmerUserId = 'farmer_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  OwnerName = 'owner_name',
  /** column name */
  OwnerPhone = 'owner_phone',
  /** column name */
  OwnerProfileImageUrl = 'owner_profile_image_url',
  /** column name */
  OwnerUserId = 'owner_user_id',
  /** column name */
  SourceInteractionTs = 'source_interaction_ts',
  /** column name */
  SourceInteractionType = 'source_interaction_type',
  /** column name */
  SourceName = 'source_name',
  /** column name */
  SourceReelId = 'source_reel_id',
  /** column name */
  SourceReelInteractionId = 'source_reel_interaction_id',
  /** column name */
  SourceServiceRequestId = 'source_service_request_id',
  /** column name */
  State = 'state',
  /** column name */
  Status = 'status',
  /** column name */
  Taluk = 'taluk'
}

/** aggregate stddev on columns */
export type Fich_Farminsta_Replica_Leads_Stddev_Fields = {
  __typename?: 'fich_farminsta_replica_leads_stddev_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  source_reel_id?: Maybe<Scalars['Float']['output']>;
  source_reel_interaction_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Fich_Farminsta_Replica_Leads_Stddev_Pop_Fields = {
  __typename?: 'fich_farminsta_replica_leads_stddev_pop_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  source_reel_id?: Maybe<Scalars['Float']['output']>;
  source_reel_interaction_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Fich_Farminsta_Replica_Leads_Stddev_Samp_Fields = {
  __typename?: 'fich_farminsta_replica_leads_stddev_samp_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  source_reel_id?: Maybe<Scalars['Float']['output']>;
  source_reel_interaction_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "fich_farminsta_replica_leads" */
export type Fich_Farminsta_Replica_Leads_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fich_Farminsta_Replica_Leads_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fich_Farminsta_Replica_Leads_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crop_names?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  farmer_name?: InputMaybe<Scalars['String']['input']>;
  farmer_phone?: InputMaybe<Scalars['String']['input']>;
  farmer_profile_image_url?: InputMaybe<Scalars['String']['input']>;
  farmer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  owner_name?: InputMaybe<Scalars['String']['input']>;
  owner_phone?: InputMaybe<Scalars['String']['input']>;
  owner_profile_image_url?: InputMaybe<Scalars['String']['input']>;
  owner_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  source_interaction_ts?: InputMaybe<Scalars['timestamptz']['input']>;
  source_interaction_type?: InputMaybe<Scalars['String']['input']>;
  source_name?: InputMaybe<Scalars['String']['input']>;
  source_reel_id?: InputMaybe<Scalars['bigint']['input']>;
  source_reel_interaction_id?: InputMaybe<Scalars['bigint']['input']>;
  source_service_request_id?: InputMaybe<Scalars['bpchar']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  taluk?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Fich_Farminsta_Replica_Leads_Sum_Fields = {
  __typename?: 'fich_farminsta_replica_leads_sum_fields';
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  source_reel_id?: Maybe<Scalars['bigint']['output']>;
  source_reel_interaction_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Fich_Farminsta_Replica_Leads_Var_Pop_Fields = {
  __typename?: 'fich_farminsta_replica_leads_var_pop_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  source_reel_id?: Maybe<Scalars['Float']['output']>;
  source_reel_interaction_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Fich_Farminsta_Replica_Leads_Var_Samp_Fields = {
  __typename?: 'fich_farminsta_replica_leads_var_samp_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  source_reel_id?: Maybe<Scalars['Float']['output']>;
  source_reel_interaction_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Fich_Farminsta_Replica_Leads_Variance_Fields = {
  __typename?: 'fich_farminsta_replica_leads_variance_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  source_reel_id?: Maybe<Scalars['Float']['output']>;
  source_reel_interaction_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "dbt.reel_lead_info" */
export type Fich_Farminsta_Replica_Reel_Lead_Info = {
  __typename?: 'fich_farminsta_replica_reel_lead_info';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crop_names?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  farmer_name?: Maybe<Scalars['String']['output']>;
  farmer_phone?: Maybe<Scalars['String']['output']>;
  farmer_profile_image_url?: Maybe<Scalars['String']['output']>;
  farmer_user_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  owner_name?: Maybe<Scalars['String']['output']>;
  owner_phone?: Maybe<Scalars['String']['output']>;
  owner_profile_image_url?: Maybe<Scalars['String']['output']>;
  owner_user_id?: Maybe<Scalars['bpchar']['output']>;
  prospect_id?: Maybe<Scalars['bpchar']['output']>;
  reel_id?: Maybe<Scalars['bigint']['output']>;
  source_interaction_ts?: Maybe<Scalars['timestamptz']['output']>;
  source_interaction_type?: Maybe<Scalars['String']['output']>;
  source_name?: Maybe<Scalars['String']['output']>;
  source_reel_id?: Maybe<Scalars['bigint']['output']>;
  source_reel_interaction_id?: Maybe<Scalars['bigint']['output']>;
  source_service_request_id?: Maybe<Scalars['bpchar']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  taluk?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "dbt.reel_lead_info" */
export type Fich_Farminsta_Replica_Reel_Lead_Info_Aggregate = {
  __typename?: 'fich_farminsta_replica_reel_lead_info_aggregate';
  aggregate?: Maybe<Fich_Farminsta_Replica_Reel_Lead_Info_Aggregate_Fields>;
  nodes: Array<Fich_Farminsta_Replica_Reel_Lead_Info>;
};

/** aggregate fields of "dbt.reel_lead_info" */
export type Fich_Farminsta_Replica_Reel_Lead_Info_Aggregate_Fields = {
  __typename?: 'fich_farminsta_replica_reel_lead_info_aggregate_fields';
  avg?: Maybe<Fich_Farminsta_Replica_Reel_Lead_Info_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Fich_Farminsta_Replica_Reel_Lead_Info_Max_Fields>;
  min?: Maybe<Fich_Farminsta_Replica_Reel_Lead_Info_Min_Fields>;
  stddev?: Maybe<Fich_Farminsta_Replica_Reel_Lead_Info_Stddev_Fields>;
  stddev_pop?: Maybe<Fich_Farminsta_Replica_Reel_Lead_Info_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fich_Farminsta_Replica_Reel_Lead_Info_Stddev_Samp_Fields>;
  sum?: Maybe<Fich_Farminsta_Replica_Reel_Lead_Info_Sum_Fields>;
  var_pop?: Maybe<Fich_Farminsta_Replica_Reel_Lead_Info_Var_Pop_Fields>;
  var_samp?: Maybe<Fich_Farminsta_Replica_Reel_Lead_Info_Var_Samp_Fields>;
  variance?: Maybe<Fich_Farminsta_Replica_Reel_Lead_Info_Variance_Fields>;
};


/** aggregate fields of "dbt.reel_lead_info" */
export type Fich_Farminsta_Replica_Reel_Lead_Info_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fich_Farminsta_Replica_Reel_Lead_Info_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Fich_Farminsta_Replica_Reel_Lead_Info_Avg_Fields = {
  __typename?: 'fich_farminsta_replica_reel_lead_info_avg_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
  source_reel_id?: Maybe<Scalars['Float']['output']>;
  source_reel_interaction_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "dbt.reel_lead_info". All fields are combined with a logical 'AND'. */
export type Fich_Farminsta_Replica_Reel_Lead_Info_Bool_Exp = {
  _and?: InputMaybe<Array<Fich_Farminsta_Replica_Reel_Lead_Info_Bool_Exp>>;
  _not?: InputMaybe<Fich_Farminsta_Replica_Reel_Lead_Info_Bool_Exp>;
  _or?: InputMaybe<Array<Fich_Farminsta_Replica_Reel_Lead_Info_Bool_Exp>>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  address?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  crop_names?: InputMaybe<String_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  district?: InputMaybe<String_Comparison_Exp>;
  farmer_name?: InputMaybe<String_Comparison_Exp>;
  farmer_phone?: InputMaybe<String_Comparison_Exp>;
  farmer_profile_image_url?: InputMaybe<String_Comparison_Exp>;
  farmer_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  lat?: InputMaybe<Float8_Comparison_Exp>;
  lng?: InputMaybe<Float8_Comparison_Exp>;
  owner_name?: InputMaybe<String_Comparison_Exp>;
  owner_phone?: InputMaybe<String_Comparison_Exp>;
  owner_profile_image_url?: InputMaybe<String_Comparison_Exp>;
  owner_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  prospect_id?: InputMaybe<Bpchar_Comparison_Exp>;
  reel_id?: InputMaybe<Bigint_Comparison_Exp>;
  source_interaction_ts?: InputMaybe<Timestamptz_Comparison_Exp>;
  source_interaction_type?: InputMaybe<String_Comparison_Exp>;
  source_name?: InputMaybe<String_Comparison_Exp>;
  source_reel_id?: InputMaybe<Bigint_Comparison_Exp>;
  source_reel_interaction_id?: InputMaybe<Bigint_Comparison_Exp>;
  source_service_request_id?: InputMaybe<Bpchar_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  taluk?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Fich_Farminsta_Replica_Reel_Lead_Info_Max_Fields = {
  __typename?: 'fich_farminsta_replica_reel_lead_info_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crop_names?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  farmer_name?: Maybe<Scalars['String']['output']>;
  farmer_phone?: Maybe<Scalars['String']['output']>;
  farmer_profile_image_url?: Maybe<Scalars['String']['output']>;
  farmer_user_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  owner_name?: Maybe<Scalars['String']['output']>;
  owner_phone?: Maybe<Scalars['String']['output']>;
  owner_profile_image_url?: Maybe<Scalars['String']['output']>;
  owner_user_id?: Maybe<Scalars['bpchar']['output']>;
  prospect_id?: Maybe<Scalars['bpchar']['output']>;
  reel_id?: Maybe<Scalars['bigint']['output']>;
  source_interaction_ts?: Maybe<Scalars['timestamptz']['output']>;
  source_interaction_type?: Maybe<Scalars['String']['output']>;
  source_name?: Maybe<Scalars['String']['output']>;
  source_reel_id?: Maybe<Scalars['bigint']['output']>;
  source_reel_interaction_id?: Maybe<Scalars['bigint']['output']>;
  source_service_request_id?: Maybe<Scalars['bpchar']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  taluk?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Fich_Farminsta_Replica_Reel_Lead_Info_Min_Fields = {
  __typename?: 'fich_farminsta_replica_reel_lead_info_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crop_names?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  farmer_name?: Maybe<Scalars['String']['output']>;
  farmer_phone?: Maybe<Scalars['String']['output']>;
  farmer_profile_image_url?: Maybe<Scalars['String']['output']>;
  farmer_user_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  owner_name?: Maybe<Scalars['String']['output']>;
  owner_phone?: Maybe<Scalars['String']['output']>;
  owner_profile_image_url?: Maybe<Scalars['String']['output']>;
  owner_user_id?: Maybe<Scalars['bpchar']['output']>;
  prospect_id?: Maybe<Scalars['bpchar']['output']>;
  reel_id?: Maybe<Scalars['bigint']['output']>;
  source_interaction_ts?: Maybe<Scalars['timestamptz']['output']>;
  source_interaction_type?: Maybe<Scalars['String']['output']>;
  source_name?: Maybe<Scalars['String']['output']>;
  source_reel_id?: Maybe<Scalars['bigint']['output']>;
  source_reel_interaction_id?: Maybe<Scalars['bigint']['output']>;
  source_service_request_id?: Maybe<Scalars['bpchar']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  taluk?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "dbt.reel_lead_info". */
export type Fich_Farminsta_Replica_Reel_Lead_Info_Order_By = {
  account_id?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crop_names?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  district?: InputMaybe<Order_By>;
  farmer_name?: InputMaybe<Order_By>;
  farmer_phone?: InputMaybe<Order_By>;
  farmer_profile_image_url?: InputMaybe<Order_By>;
  farmer_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  owner_name?: InputMaybe<Order_By>;
  owner_phone?: InputMaybe<Order_By>;
  owner_profile_image_url?: InputMaybe<Order_By>;
  owner_user_id?: InputMaybe<Order_By>;
  prospect_id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
  source_interaction_ts?: InputMaybe<Order_By>;
  source_interaction_type?: InputMaybe<Order_By>;
  source_name?: InputMaybe<Order_By>;
  source_reel_id?: InputMaybe<Order_By>;
  source_reel_interaction_id?: InputMaybe<Order_By>;
  source_service_request_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  taluk?: InputMaybe<Order_By>;
};

/** select columns of table "dbt.reel_lead_info" */
export enum Fich_Farminsta_Replica_Reel_Lead_Info_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Address = 'address',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CropNames = 'crop_names',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  District = 'district',
  /** column name */
  FarmerName = 'farmer_name',
  /** column name */
  FarmerPhone = 'farmer_phone',
  /** column name */
  FarmerProfileImageUrl = 'farmer_profile_image_url',
  /** column name */
  FarmerUserId = 'farmer_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  OwnerName = 'owner_name',
  /** column name */
  OwnerPhone = 'owner_phone',
  /** column name */
  OwnerProfileImageUrl = 'owner_profile_image_url',
  /** column name */
  OwnerUserId = 'owner_user_id',
  /** column name */
  ProspectId = 'prospect_id',
  /** column name */
  ReelId = 'reel_id',
  /** column name */
  SourceInteractionTs = 'source_interaction_ts',
  /** column name */
  SourceInteractionType = 'source_interaction_type',
  /** column name */
  SourceName = 'source_name',
  /** column name */
  SourceReelId = 'source_reel_id',
  /** column name */
  SourceReelInteractionId = 'source_reel_interaction_id',
  /** column name */
  SourceServiceRequestId = 'source_service_request_id',
  /** column name */
  State = 'state',
  /** column name */
  Status = 'status',
  /** column name */
  Taluk = 'taluk'
}

/** aggregate stddev on columns */
export type Fich_Farminsta_Replica_Reel_Lead_Info_Stddev_Fields = {
  __typename?: 'fich_farminsta_replica_reel_lead_info_stddev_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
  source_reel_id?: Maybe<Scalars['Float']['output']>;
  source_reel_interaction_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Fich_Farminsta_Replica_Reel_Lead_Info_Stddev_Pop_Fields = {
  __typename?: 'fich_farminsta_replica_reel_lead_info_stddev_pop_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
  source_reel_id?: Maybe<Scalars['Float']['output']>;
  source_reel_interaction_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Fich_Farminsta_Replica_Reel_Lead_Info_Stddev_Samp_Fields = {
  __typename?: 'fich_farminsta_replica_reel_lead_info_stddev_samp_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
  source_reel_id?: Maybe<Scalars['Float']['output']>;
  source_reel_interaction_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "fich_farminsta_replica_reel_lead_info" */
export type Fich_Farminsta_Replica_Reel_Lead_Info_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fich_Farminsta_Replica_Reel_Lead_Info_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fich_Farminsta_Replica_Reel_Lead_Info_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crop_names?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  farmer_name?: InputMaybe<Scalars['String']['input']>;
  farmer_phone?: InputMaybe<Scalars['String']['input']>;
  farmer_profile_image_url?: InputMaybe<Scalars['String']['input']>;
  farmer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  owner_name?: InputMaybe<Scalars['String']['input']>;
  owner_phone?: InputMaybe<Scalars['String']['input']>;
  owner_profile_image_url?: InputMaybe<Scalars['String']['input']>;
  owner_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  prospect_id?: InputMaybe<Scalars['bpchar']['input']>;
  reel_id?: InputMaybe<Scalars['bigint']['input']>;
  source_interaction_ts?: InputMaybe<Scalars['timestamptz']['input']>;
  source_interaction_type?: InputMaybe<Scalars['String']['input']>;
  source_name?: InputMaybe<Scalars['String']['input']>;
  source_reel_id?: InputMaybe<Scalars['bigint']['input']>;
  source_reel_interaction_id?: InputMaybe<Scalars['bigint']['input']>;
  source_service_request_id?: InputMaybe<Scalars['bpchar']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  taluk?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Fich_Farminsta_Replica_Reel_Lead_Info_Sum_Fields = {
  __typename?: 'fich_farminsta_replica_reel_lead_info_sum_fields';
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  reel_id?: Maybe<Scalars['bigint']['output']>;
  source_reel_id?: Maybe<Scalars['bigint']['output']>;
  source_reel_interaction_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Fich_Farminsta_Replica_Reel_Lead_Info_Var_Pop_Fields = {
  __typename?: 'fich_farminsta_replica_reel_lead_info_var_pop_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
  source_reel_id?: Maybe<Scalars['Float']['output']>;
  source_reel_interaction_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Fich_Farminsta_Replica_Reel_Lead_Info_Var_Samp_Fields = {
  __typename?: 'fich_farminsta_replica_reel_lead_info_var_samp_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
  source_reel_id?: Maybe<Scalars['Float']['output']>;
  source_reel_interaction_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Fich_Farminsta_Replica_Reel_Lead_Info_Variance_Fields = {
  __typename?: 'fich_farminsta_replica_reel_lead_info_variance_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
  source_reel_id?: Maybe<Scalars['Float']['output']>;
  source_reel_interaction_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "dbt.reels_flat" */
export type Fich_Farminsta_Replica_Reels_Flat = {
  __typename?: 'fich_farminsta_replica_reels_flat';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  account_name?: Maybe<Scalars['String']['output']>;
  active_lead_count?: Maybe<Scalars['bigint']['output']>;
  approved_by_account_id?: Maybe<Scalars['bpchar']['output']>;
  approved_by_account_name?: Maybe<Scalars['String']['output']>;
  approved_by_profile_image_url?: Maybe<Scalars['String']['output']>;
  approved_by_user_id?: Maybe<Scalars['bpchar']['output']>;
  approved_by_user_name?: Maybe<Scalars['String']['output']>;
  avg_watch_duration_percent?: Maybe<Scalars['float8']['output']>;
  category_id?: Maybe<Scalars['bigint']['output']>;
  channel_id?: Maybe<Scalars['bigint']['output']>;
  channel_name?: Maybe<Scalars['String']['output']>;
  cloudflare_id?: Maybe<Scalars['String']['output']>;
  cloudflare_playback_url?: Maybe<Scalars['String']['output']>;
  cloudflare_preview_url?: Maybe<Scalars['String']['output']>;
  comment_count?: Maybe<Scalars['bigint']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crop_id?: Maybe<Scalars['bpchar']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration_ms?: Maybe<Scalars['bigint']['output']>;
  engagement_count?: Maybe<Scalars['bigint']['output']>;
  fo_reel_approved_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  is_fo_reel_approved?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  last_interaction_created_at?: Maybe<Scalars['timestamptz']['output']>;
  last_lead_created_at?: Maybe<Scalars['timestamptz']['output']>;
  lead_count?: Maybe<Scalars['bigint']['output']>;
  pending_lead_count?: Maybe<Scalars['bigint']['output']>;
  playback_count?: Maybe<Scalars['bigint']['output']>;
  reach?: Maybe<Scalars['bigint']['output']>;
  react_count?: Maybe<Scalars['bigint']['output']>;
  rejected_lead_count?: Maybe<Scalars['bigint']['output']>;
  requested_lead_count?: Maybe<Scalars['bigint']['output']>;
  role_id?: Maybe<Scalars['bigint']['output']>;
  s3_path?: Maybe<Scalars['String']['output']>;
  share_count?: Maybe<Scalars['bigint']['output']>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total_watch_time_secs?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  uploader_account_id?: Maybe<Scalars['bpchar']['output']>;
  uploader_account_name?: Maybe<Scalars['String']['output']>;
  uploader_profile_image_url?: Maybe<Scalars['String']['output']>;
  uploader_type?: Maybe<Scalars['String']['output']>;
  uploader_user_name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
  user_name?: Maybe<Scalars['String']['output']>;
  view_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "dbt.reels_flat" */
export type Fich_Farminsta_Replica_Reels_Flat_Aggregate = {
  __typename?: 'fich_farminsta_replica_reels_flat_aggregate';
  aggregate?: Maybe<Fich_Farminsta_Replica_Reels_Flat_Aggregate_Fields>;
  nodes: Array<Fich_Farminsta_Replica_Reels_Flat>;
};

/** aggregate fields of "dbt.reels_flat" */
export type Fich_Farminsta_Replica_Reels_Flat_Aggregate_Fields = {
  __typename?: 'fich_farminsta_replica_reels_flat_aggregate_fields';
  avg?: Maybe<Fich_Farminsta_Replica_Reels_Flat_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Fich_Farminsta_Replica_Reels_Flat_Max_Fields>;
  min?: Maybe<Fich_Farminsta_Replica_Reels_Flat_Min_Fields>;
  stddev?: Maybe<Fich_Farminsta_Replica_Reels_Flat_Stddev_Fields>;
  stddev_pop?: Maybe<Fich_Farminsta_Replica_Reels_Flat_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fich_Farminsta_Replica_Reels_Flat_Stddev_Samp_Fields>;
  sum?: Maybe<Fich_Farminsta_Replica_Reels_Flat_Sum_Fields>;
  var_pop?: Maybe<Fich_Farminsta_Replica_Reels_Flat_Var_Pop_Fields>;
  var_samp?: Maybe<Fich_Farminsta_Replica_Reels_Flat_Var_Samp_Fields>;
  variance?: Maybe<Fich_Farminsta_Replica_Reels_Flat_Variance_Fields>;
};


/** aggregate fields of "dbt.reels_flat" */
export type Fich_Farminsta_Replica_Reels_Flat_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fich_Farminsta_Replica_Reels_Flat_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Fich_Farminsta_Replica_Reels_Flat_Avg_Fields = {
  __typename?: 'fich_farminsta_replica_reels_flat_avg_fields';
  active_lead_count?: Maybe<Scalars['Float']['output']>;
  avg_watch_duration_percent?: Maybe<Scalars['Float']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  channel_id?: Maybe<Scalars['Float']['output']>;
  comment_count?: Maybe<Scalars['Float']['output']>;
  duration_ms?: Maybe<Scalars['Float']['output']>;
  engagement_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lead_count?: Maybe<Scalars['Float']['output']>;
  pending_lead_count?: Maybe<Scalars['Float']['output']>;
  playback_count?: Maybe<Scalars['Float']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
  react_count?: Maybe<Scalars['Float']['output']>;
  rejected_lead_count?: Maybe<Scalars['Float']['output']>;
  requested_lead_count?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  share_count?: Maybe<Scalars['Float']['output']>;
  total_watch_time_secs?: Maybe<Scalars['Float']['output']>;
  view_count?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "dbt.reels_flat". All fields are combined with a logical 'AND'. */
export type Fich_Farminsta_Replica_Reels_Flat_Bool_Exp = {
  _and?: InputMaybe<Array<Fich_Farminsta_Replica_Reels_Flat_Bool_Exp>>;
  _not?: InputMaybe<Fich_Farminsta_Replica_Reels_Flat_Bool_Exp>;
  _or?: InputMaybe<Array<Fich_Farminsta_Replica_Reels_Flat_Bool_Exp>>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  account_name?: InputMaybe<String_Comparison_Exp>;
  active_lead_count?: InputMaybe<Bigint_Comparison_Exp>;
  approved_by_account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  approved_by_account_name?: InputMaybe<String_Comparison_Exp>;
  approved_by_profile_image_url?: InputMaybe<String_Comparison_Exp>;
  approved_by_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  approved_by_user_name?: InputMaybe<String_Comparison_Exp>;
  avg_watch_duration_percent?: InputMaybe<Float8_Comparison_Exp>;
  category_id?: InputMaybe<Bigint_Comparison_Exp>;
  channel_id?: InputMaybe<Bigint_Comparison_Exp>;
  channel_name?: InputMaybe<String_Comparison_Exp>;
  cloudflare_id?: InputMaybe<String_Comparison_Exp>;
  cloudflare_playback_url?: InputMaybe<String_Comparison_Exp>;
  cloudflare_preview_url?: InputMaybe<String_Comparison_Exp>;
  comment_count?: InputMaybe<Bigint_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  crop_id?: InputMaybe<Bpchar_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  duration_ms?: InputMaybe<Bigint_Comparison_Exp>;
  engagement_count?: InputMaybe<Bigint_Comparison_Exp>;
  fo_reel_approved_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_fo_reel_approved?: InputMaybe<Boolean_Comparison_Exp>;
  language?: InputMaybe<String_Comparison_Exp>;
  last_interaction_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_lead_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  lead_count?: InputMaybe<Bigint_Comparison_Exp>;
  pending_lead_count?: InputMaybe<Bigint_Comparison_Exp>;
  playback_count?: InputMaybe<Bigint_Comparison_Exp>;
  reach?: InputMaybe<Bigint_Comparison_Exp>;
  react_count?: InputMaybe<Bigint_Comparison_Exp>;
  rejected_lead_count?: InputMaybe<Bigint_Comparison_Exp>;
  requested_lead_count?: InputMaybe<Bigint_Comparison_Exp>;
  role_id?: InputMaybe<Bigint_Comparison_Exp>;
  s3_path?: InputMaybe<String_Comparison_Exp>;
  share_count?: InputMaybe<Bigint_Comparison_Exp>;
  thumbnail_url?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  total_watch_time_secs?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uploader_account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  uploader_account_name?: InputMaybe<String_Comparison_Exp>;
  uploader_profile_image_url?: InputMaybe<String_Comparison_Exp>;
  uploader_type?: InputMaybe<String_Comparison_Exp>;
  uploader_user_name?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  user_name?: InputMaybe<String_Comparison_Exp>;
  view_count?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Fich_Farminsta_Replica_Reels_Flat_Max_Fields = {
  __typename?: 'fich_farminsta_replica_reels_flat_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  account_name?: Maybe<Scalars['String']['output']>;
  active_lead_count?: Maybe<Scalars['bigint']['output']>;
  approved_by_account_id?: Maybe<Scalars['bpchar']['output']>;
  approved_by_account_name?: Maybe<Scalars['String']['output']>;
  approved_by_profile_image_url?: Maybe<Scalars['String']['output']>;
  approved_by_user_id?: Maybe<Scalars['bpchar']['output']>;
  approved_by_user_name?: Maybe<Scalars['String']['output']>;
  avg_watch_duration_percent?: Maybe<Scalars['float8']['output']>;
  category_id?: Maybe<Scalars['bigint']['output']>;
  channel_id?: Maybe<Scalars['bigint']['output']>;
  channel_name?: Maybe<Scalars['String']['output']>;
  cloudflare_id?: Maybe<Scalars['String']['output']>;
  cloudflare_playback_url?: Maybe<Scalars['String']['output']>;
  cloudflare_preview_url?: Maybe<Scalars['String']['output']>;
  comment_count?: Maybe<Scalars['bigint']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crop_id?: Maybe<Scalars['bpchar']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration_ms?: Maybe<Scalars['bigint']['output']>;
  engagement_count?: Maybe<Scalars['bigint']['output']>;
  fo_reel_approved_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  last_interaction_created_at?: Maybe<Scalars['timestamptz']['output']>;
  last_lead_created_at?: Maybe<Scalars['timestamptz']['output']>;
  lead_count?: Maybe<Scalars['bigint']['output']>;
  pending_lead_count?: Maybe<Scalars['bigint']['output']>;
  playback_count?: Maybe<Scalars['bigint']['output']>;
  reach?: Maybe<Scalars['bigint']['output']>;
  react_count?: Maybe<Scalars['bigint']['output']>;
  rejected_lead_count?: Maybe<Scalars['bigint']['output']>;
  requested_lead_count?: Maybe<Scalars['bigint']['output']>;
  role_id?: Maybe<Scalars['bigint']['output']>;
  s3_path?: Maybe<Scalars['String']['output']>;
  share_count?: Maybe<Scalars['bigint']['output']>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total_watch_time_secs?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  uploader_account_id?: Maybe<Scalars['bpchar']['output']>;
  uploader_account_name?: Maybe<Scalars['String']['output']>;
  uploader_profile_image_url?: Maybe<Scalars['String']['output']>;
  uploader_type?: Maybe<Scalars['String']['output']>;
  uploader_user_name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
  user_name?: Maybe<Scalars['String']['output']>;
  view_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Fich_Farminsta_Replica_Reels_Flat_Min_Fields = {
  __typename?: 'fich_farminsta_replica_reels_flat_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  account_name?: Maybe<Scalars['String']['output']>;
  active_lead_count?: Maybe<Scalars['bigint']['output']>;
  approved_by_account_id?: Maybe<Scalars['bpchar']['output']>;
  approved_by_account_name?: Maybe<Scalars['String']['output']>;
  approved_by_profile_image_url?: Maybe<Scalars['String']['output']>;
  approved_by_user_id?: Maybe<Scalars['bpchar']['output']>;
  approved_by_user_name?: Maybe<Scalars['String']['output']>;
  avg_watch_duration_percent?: Maybe<Scalars['float8']['output']>;
  category_id?: Maybe<Scalars['bigint']['output']>;
  channel_id?: Maybe<Scalars['bigint']['output']>;
  channel_name?: Maybe<Scalars['String']['output']>;
  cloudflare_id?: Maybe<Scalars['String']['output']>;
  cloudflare_playback_url?: Maybe<Scalars['String']['output']>;
  cloudflare_preview_url?: Maybe<Scalars['String']['output']>;
  comment_count?: Maybe<Scalars['bigint']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crop_id?: Maybe<Scalars['bpchar']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration_ms?: Maybe<Scalars['bigint']['output']>;
  engagement_count?: Maybe<Scalars['bigint']['output']>;
  fo_reel_approved_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  last_interaction_created_at?: Maybe<Scalars['timestamptz']['output']>;
  last_lead_created_at?: Maybe<Scalars['timestamptz']['output']>;
  lead_count?: Maybe<Scalars['bigint']['output']>;
  pending_lead_count?: Maybe<Scalars['bigint']['output']>;
  playback_count?: Maybe<Scalars['bigint']['output']>;
  reach?: Maybe<Scalars['bigint']['output']>;
  react_count?: Maybe<Scalars['bigint']['output']>;
  rejected_lead_count?: Maybe<Scalars['bigint']['output']>;
  requested_lead_count?: Maybe<Scalars['bigint']['output']>;
  role_id?: Maybe<Scalars['bigint']['output']>;
  s3_path?: Maybe<Scalars['String']['output']>;
  share_count?: Maybe<Scalars['bigint']['output']>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total_watch_time_secs?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  uploader_account_id?: Maybe<Scalars['bpchar']['output']>;
  uploader_account_name?: Maybe<Scalars['String']['output']>;
  uploader_profile_image_url?: Maybe<Scalars['String']['output']>;
  uploader_type?: Maybe<Scalars['String']['output']>;
  uploader_user_name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
  user_name?: Maybe<Scalars['String']['output']>;
  view_count?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "dbt.reels_flat". */
export type Fich_Farminsta_Replica_Reels_Flat_Order_By = {
  account_id?: InputMaybe<Order_By>;
  account_name?: InputMaybe<Order_By>;
  active_lead_count?: InputMaybe<Order_By>;
  approved_by_account_id?: InputMaybe<Order_By>;
  approved_by_account_name?: InputMaybe<Order_By>;
  approved_by_profile_image_url?: InputMaybe<Order_By>;
  approved_by_user_id?: InputMaybe<Order_By>;
  approved_by_user_name?: InputMaybe<Order_By>;
  avg_watch_duration_percent?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  channel_name?: InputMaybe<Order_By>;
  cloudflare_id?: InputMaybe<Order_By>;
  cloudflare_playback_url?: InputMaybe<Order_By>;
  cloudflare_preview_url?: InputMaybe<Order_By>;
  comment_count?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  duration_ms?: InputMaybe<Order_By>;
  engagement_count?: InputMaybe<Order_By>;
  fo_reel_approved_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_fo_reel_approved?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  last_interaction_created_at?: InputMaybe<Order_By>;
  last_lead_created_at?: InputMaybe<Order_By>;
  lead_count?: InputMaybe<Order_By>;
  pending_lead_count?: InputMaybe<Order_By>;
  playback_count?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
  react_count?: InputMaybe<Order_By>;
  rejected_lead_count?: InputMaybe<Order_By>;
  requested_lead_count?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  s3_path?: InputMaybe<Order_By>;
  share_count?: InputMaybe<Order_By>;
  thumbnail_url?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  total_watch_time_secs?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uploader_account_id?: InputMaybe<Order_By>;
  uploader_account_name?: InputMaybe<Order_By>;
  uploader_profile_image_url?: InputMaybe<Order_By>;
  uploader_type?: InputMaybe<Order_By>;
  uploader_user_name?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_name?: InputMaybe<Order_By>;
  view_count?: InputMaybe<Order_By>;
};

/** select columns of table "dbt.reels_flat" */
export enum Fich_Farminsta_Replica_Reels_Flat_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AccountName = 'account_name',
  /** column name */
  ActiveLeadCount = 'active_lead_count',
  /** column name */
  ApprovedByAccountId = 'approved_by_account_id',
  /** column name */
  ApprovedByAccountName = 'approved_by_account_name',
  /** column name */
  ApprovedByProfileImageUrl = 'approved_by_profile_image_url',
  /** column name */
  ApprovedByUserId = 'approved_by_user_id',
  /** column name */
  ApprovedByUserName = 'approved_by_user_name',
  /** column name */
  AvgWatchDurationPercent = 'avg_watch_duration_percent',
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  ChannelId = 'channel_id',
  /** column name */
  ChannelName = 'channel_name',
  /** column name */
  CloudflareId = 'cloudflare_id',
  /** column name */
  CloudflarePlaybackUrl = 'cloudflare_playback_url',
  /** column name */
  CloudflarePreviewUrl = 'cloudflare_preview_url',
  /** column name */
  CommentCount = 'comment_count',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Description = 'description',
  /** column name */
  DurationMs = 'duration_ms',
  /** column name */
  EngagementCount = 'engagement_count',
  /** column name */
  FoReelApprovedAt = 'fo_reel_approved_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsFoReelApproved = 'is_fo_reel_approved',
  /** column name */
  Language = 'language',
  /** column name */
  LastInteractionCreatedAt = 'last_interaction_created_at',
  /** column name */
  LastLeadCreatedAt = 'last_lead_created_at',
  /** column name */
  LeadCount = 'lead_count',
  /** column name */
  PendingLeadCount = 'pending_lead_count',
  /** column name */
  PlaybackCount = 'playback_count',
  /** column name */
  Reach = 'reach',
  /** column name */
  ReactCount = 'react_count',
  /** column name */
  RejectedLeadCount = 'rejected_lead_count',
  /** column name */
  RequestedLeadCount = 'requested_lead_count',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  S3Path = 's3_path',
  /** column name */
  ShareCount = 'share_count',
  /** column name */
  ThumbnailUrl = 'thumbnail_url',
  /** column name */
  Title = 'title',
  /** column name */
  TotalWatchTimeSecs = 'total_watch_time_secs',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UploaderAccountId = 'uploader_account_id',
  /** column name */
  UploaderAccountName = 'uploader_account_name',
  /** column name */
  UploaderProfileImageUrl = 'uploader_profile_image_url',
  /** column name */
  UploaderType = 'uploader_type',
  /** column name */
  UploaderUserName = 'uploader_user_name',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserName = 'user_name',
  /** column name */
  ViewCount = 'view_count'
}

/** aggregate stddev on columns */
export type Fich_Farminsta_Replica_Reels_Flat_Stddev_Fields = {
  __typename?: 'fich_farminsta_replica_reels_flat_stddev_fields';
  active_lead_count?: Maybe<Scalars['Float']['output']>;
  avg_watch_duration_percent?: Maybe<Scalars['Float']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  channel_id?: Maybe<Scalars['Float']['output']>;
  comment_count?: Maybe<Scalars['Float']['output']>;
  duration_ms?: Maybe<Scalars['Float']['output']>;
  engagement_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lead_count?: Maybe<Scalars['Float']['output']>;
  pending_lead_count?: Maybe<Scalars['Float']['output']>;
  playback_count?: Maybe<Scalars['Float']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
  react_count?: Maybe<Scalars['Float']['output']>;
  rejected_lead_count?: Maybe<Scalars['Float']['output']>;
  requested_lead_count?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  share_count?: Maybe<Scalars['Float']['output']>;
  total_watch_time_secs?: Maybe<Scalars['Float']['output']>;
  view_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Fich_Farminsta_Replica_Reels_Flat_Stddev_Pop_Fields = {
  __typename?: 'fich_farminsta_replica_reels_flat_stddev_pop_fields';
  active_lead_count?: Maybe<Scalars['Float']['output']>;
  avg_watch_duration_percent?: Maybe<Scalars['Float']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  channel_id?: Maybe<Scalars['Float']['output']>;
  comment_count?: Maybe<Scalars['Float']['output']>;
  duration_ms?: Maybe<Scalars['Float']['output']>;
  engagement_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lead_count?: Maybe<Scalars['Float']['output']>;
  pending_lead_count?: Maybe<Scalars['Float']['output']>;
  playback_count?: Maybe<Scalars['Float']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
  react_count?: Maybe<Scalars['Float']['output']>;
  rejected_lead_count?: Maybe<Scalars['Float']['output']>;
  requested_lead_count?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  share_count?: Maybe<Scalars['Float']['output']>;
  total_watch_time_secs?: Maybe<Scalars['Float']['output']>;
  view_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Fich_Farminsta_Replica_Reels_Flat_Stddev_Samp_Fields = {
  __typename?: 'fich_farminsta_replica_reels_flat_stddev_samp_fields';
  active_lead_count?: Maybe<Scalars['Float']['output']>;
  avg_watch_duration_percent?: Maybe<Scalars['Float']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  channel_id?: Maybe<Scalars['Float']['output']>;
  comment_count?: Maybe<Scalars['Float']['output']>;
  duration_ms?: Maybe<Scalars['Float']['output']>;
  engagement_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lead_count?: Maybe<Scalars['Float']['output']>;
  pending_lead_count?: Maybe<Scalars['Float']['output']>;
  playback_count?: Maybe<Scalars['Float']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
  react_count?: Maybe<Scalars['Float']['output']>;
  rejected_lead_count?: Maybe<Scalars['Float']['output']>;
  requested_lead_count?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  share_count?: Maybe<Scalars['Float']['output']>;
  total_watch_time_secs?: Maybe<Scalars['Float']['output']>;
  view_count?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "fich_farminsta_replica_reels_flat" */
export type Fich_Farminsta_Replica_Reels_Flat_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fich_Farminsta_Replica_Reels_Flat_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fich_Farminsta_Replica_Reels_Flat_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  account_name?: InputMaybe<Scalars['String']['input']>;
  active_lead_count?: InputMaybe<Scalars['bigint']['input']>;
  approved_by_account_id?: InputMaybe<Scalars['bpchar']['input']>;
  approved_by_account_name?: InputMaybe<Scalars['String']['input']>;
  approved_by_profile_image_url?: InputMaybe<Scalars['String']['input']>;
  approved_by_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  approved_by_user_name?: InputMaybe<Scalars['String']['input']>;
  avg_watch_duration_percent?: InputMaybe<Scalars['float8']['input']>;
  category_id?: InputMaybe<Scalars['bigint']['input']>;
  channel_id?: InputMaybe<Scalars['bigint']['input']>;
  channel_name?: InputMaybe<Scalars['String']['input']>;
  cloudflare_id?: InputMaybe<Scalars['String']['input']>;
  cloudflare_playback_url?: InputMaybe<Scalars['String']['input']>;
  cloudflare_preview_url?: InputMaybe<Scalars['String']['input']>;
  comment_count?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crop_id?: InputMaybe<Scalars['bpchar']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration_ms?: InputMaybe<Scalars['bigint']['input']>;
  engagement_count?: InputMaybe<Scalars['bigint']['input']>;
  fo_reel_approved_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_fo_reel_approved?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  last_interaction_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_lead_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  lead_count?: InputMaybe<Scalars['bigint']['input']>;
  pending_lead_count?: InputMaybe<Scalars['bigint']['input']>;
  playback_count?: InputMaybe<Scalars['bigint']['input']>;
  reach?: InputMaybe<Scalars['bigint']['input']>;
  react_count?: InputMaybe<Scalars['bigint']['input']>;
  rejected_lead_count?: InputMaybe<Scalars['bigint']['input']>;
  requested_lead_count?: InputMaybe<Scalars['bigint']['input']>;
  role_id?: InputMaybe<Scalars['bigint']['input']>;
  s3_path?: InputMaybe<Scalars['String']['input']>;
  share_count?: InputMaybe<Scalars['bigint']['input']>;
  thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  total_watch_time_secs?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  uploader_account_id?: InputMaybe<Scalars['bpchar']['input']>;
  uploader_account_name?: InputMaybe<Scalars['String']['input']>;
  uploader_profile_image_url?: InputMaybe<Scalars['String']['input']>;
  uploader_type?: InputMaybe<Scalars['String']['input']>;
  uploader_user_name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
  user_name?: InputMaybe<Scalars['String']['input']>;
  view_count?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Fich_Farminsta_Replica_Reels_Flat_Sum_Fields = {
  __typename?: 'fich_farminsta_replica_reels_flat_sum_fields';
  active_lead_count?: Maybe<Scalars['bigint']['output']>;
  avg_watch_duration_percent?: Maybe<Scalars['float8']['output']>;
  category_id?: Maybe<Scalars['bigint']['output']>;
  channel_id?: Maybe<Scalars['bigint']['output']>;
  comment_count?: Maybe<Scalars['bigint']['output']>;
  duration_ms?: Maybe<Scalars['bigint']['output']>;
  engagement_count?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lead_count?: Maybe<Scalars['bigint']['output']>;
  pending_lead_count?: Maybe<Scalars['bigint']['output']>;
  playback_count?: Maybe<Scalars['bigint']['output']>;
  reach?: Maybe<Scalars['bigint']['output']>;
  react_count?: Maybe<Scalars['bigint']['output']>;
  rejected_lead_count?: Maybe<Scalars['bigint']['output']>;
  requested_lead_count?: Maybe<Scalars['bigint']['output']>;
  role_id?: Maybe<Scalars['bigint']['output']>;
  share_count?: Maybe<Scalars['bigint']['output']>;
  total_watch_time_secs?: Maybe<Scalars['numeric']['output']>;
  view_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Fich_Farminsta_Replica_Reels_Flat_Var_Pop_Fields = {
  __typename?: 'fich_farminsta_replica_reels_flat_var_pop_fields';
  active_lead_count?: Maybe<Scalars['Float']['output']>;
  avg_watch_duration_percent?: Maybe<Scalars['Float']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  channel_id?: Maybe<Scalars['Float']['output']>;
  comment_count?: Maybe<Scalars['Float']['output']>;
  duration_ms?: Maybe<Scalars['Float']['output']>;
  engagement_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lead_count?: Maybe<Scalars['Float']['output']>;
  pending_lead_count?: Maybe<Scalars['Float']['output']>;
  playback_count?: Maybe<Scalars['Float']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
  react_count?: Maybe<Scalars['Float']['output']>;
  rejected_lead_count?: Maybe<Scalars['Float']['output']>;
  requested_lead_count?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  share_count?: Maybe<Scalars['Float']['output']>;
  total_watch_time_secs?: Maybe<Scalars['Float']['output']>;
  view_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Fich_Farminsta_Replica_Reels_Flat_Var_Samp_Fields = {
  __typename?: 'fich_farminsta_replica_reels_flat_var_samp_fields';
  active_lead_count?: Maybe<Scalars['Float']['output']>;
  avg_watch_duration_percent?: Maybe<Scalars['Float']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  channel_id?: Maybe<Scalars['Float']['output']>;
  comment_count?: Maybe<Scalars['Float']['output']>;
  duration_ms?: Maybe<Scalars['Float']['output']>;
  engagement_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lead_count?: Maybe<Scalars['Float']['output']>;
  pending_lead_count?: Maybe<Scalars['Float']['output']>;
  playback_count?: Maybe<Scalars['Float']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
  react_count?: Maybe<Scalars['Float']['output']>;
  rejected_lead_count?: Maybe<Scalars['Float']['output']>;
  requested_lead_count?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  share_count?: Maybe<Scalars['Float']['output']>;
  total_watch_time_secs?: Maybe<Scalars['Float']['output']>;
  view_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Fich_Farminsta_Replica_Reels_Flat_Variance_Fields = {
  __typename?: 'fich_farminsta_replica_reels_flat_variance_fields';
  active_lead_count?: Maybe<Scalars['Float']['output']>;
  avg_watch_duration_percent?: Maybe<Scalars['Float']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  channel_id?: Maybe<Scalars['Float']['output']>;
  comment_count?: Maybe<Scalars['Float']['output']>;
  duration_ms?: Maybe<Scalars['Float']['output']>;
  engagement_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lead_count?: Maybe<Scalars['Float']['output']>;
  pending_lead_count?: Maybe<Scalars['Float']['output']>;
  playback_count?: Maybe<Scalars['Float']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
  react_count?: Maybe<Scalars['Float']['output']>;
  rejected_lead_count?: Maybe<Scalars['Float']['output']>;
  requested_lead_count?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  share_count?: Maybe<Scalars['Float']['output']>;
  total_watch_time_secs?: Maybe<Scalars['Float']['output']>;
  view_count?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "field_partner_response_events" */
export type Field_Partner_Response_Events = {
  __typename?: 'field_partner_response_events';
  /** An object relationship */
  account: Accounts;
  account_id: Scalars['bpchar']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  event_at: Scalars['timestamptz']['output'];
  event_data: Scalars['jsonb']['output'];
  event_name: Scalars['String']['output'];
  event_type: Scalars['String']['output'];
  farmer_user_id: Scalars['bpchar']['output'];
  /** An object relationship */
  field_partner_response: Field_Partner_Responses;
  field_partner_user_id: Scalars['bpchar']['output'];
  fpr_id: Scalars['bpchar']['output'];
  id: Scalars['bpchar']['output'];
  request_id: Scalars['bpchar']['output'];
  /** An object relationship */
  service_request: Service_Requests;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user: Users;
  /** An object relationship */
  userByFieldPartnerUserId: Users;
};


/** columns and relationships of "field_partner_response_events" */
export type Field_Partner_Response_EventsEvent_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "field_partner_response_events" */
export type Field_Partner_Response_Events_Aggregate = {
  __typename?: 'field_partner_response_events_aggregate';
  aggregate?: Maybe<Field_Partner_Response_Events_Aggregate_Fields>;
  nodes: Array<Field_Partner_Response_Events>;
};

export type Field_Partner_Response_Events_Aggregate_Bool_Exp = {
  count?: InputMaybe<Field_Partner_Response_Events_Aggregate_Bool_Exp_Count>;
};

export type Field_Partner_Response_Events_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Field_Partner_Response_Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Field_Partner_Response_Events_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "field_partner_response_events" */
export type Field_Partner_Response_Events_Aggregate_Fields = {
  __typename?: 'field_partner_response_events_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Field_Partner_Response_Events_Max_Fields>;
  min?: Maybe<Field_Partner_Response_Events_Min_Fields>;
};


/** aggregate fields of "field_partner_response_events" */
export type Field_Partner_Response_Events_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Field_Partner_Response_Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "field_partner_response_events" */
export type Field_Partner_Response_Events_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Field_Partner_Response_Events_Max_Order_By>;
  min?: InputMaybe<Field_Partner_Response_Events_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Field_Partner_Response_Events_Append_Input = {
  event_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "field_partner_response_events" */
export type Field_Partner_Response_Events_Arr_Rel_Insert_Input = {
  data: Array<Field_Partner_Response_Events_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Field_Partner_Response_Events_On_Conflict>;
};

/** Boolean expression to filter rows from the table "field_partner_response_events". All fields are combined with a logical 'AND'. */
export type Field_Partner_Response_Events_Bool_Exp = {
  _and?: InputMaybe<Array<Field_Partner_Response_Events_Bool_Exp>>;
  _not?: InputMaybe<Field_Partner_Response_Events_Bool_Exp>;
  _or?: InputMaybe<Array<Field_Partner_Response_Events_Bool_Exp>>;
  account?: InputMaybe<Accounts_Bool_Exp>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_data?: InputMaybe<Jsonb_Comparison_Exp>;
  event_name?: InputMaybe<String_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
  farmer_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  field_partner_response?: InputMaybe<Field_Partner_Responses_Bool_Exp>;
  field_partner_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  fpr_id?: InputMaybe<Bpchar_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  request_id?: InputMaybe<Bpchar_Comparison_Exp>;
  service_request?: InputMaybe<Service_Requests_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userByFieldPartnerUserId?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "field_partner_response_events" */
export enum Field_Partner_Response_Events_Constraint {
  /** unique or primary key constraint on columns "id" */
  FieldPartnerResponseEventsPkey = 'field_partner_response_events_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Field_Partner_Response_Events_Delete_At_Path_Input = {
  event_data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Field_Partner_Response_Events_Delete_Elem_Input = {
  event_data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Field_Partner_Response_Events_Delete_Key_Input = {
  event_data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "field_partner_response_events" */
export type Field_Partner_Response_Events_Insert_Input = {
  account?: InputMaybe<Accounts_Obj_Rel_Insert_Input>;
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_data?: InputMaybe<Scalars['jsonb']['input']>;
  event_name?: InputMaybe<Scalars['String']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  farmer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  field_partner_response?: InputMaybe<Field_Partner_Responses_Obj_Rel_Insert_Input>;
  field_partner_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  fpr_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  request_id?: InputMaybe<Scalars['bpchar']['input']>;
  service_request?: InputMaybe<Service_Requests_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userByFieldPartnerUserId?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Field_Partner_Response_Events_Max_Fields = {
  __typename?: 'field_partner_response_events_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  event_at?: Maybe<Scalars['timestamptz']['output']>;
  event_name?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  farmer_user_id?: Maybe<Scalars['bpchar']['output']>;
  field_partner_user_id?: Maybe<Scalars['bpchar']['output']>;
  fpr_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  request_id?: Maybe<Scalars['bpchar']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "field_partner_response_events" */
export type Field_Partner_Response_Events_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  event_at?: InputMaybe<Order_By>;
  event_name?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  farmer_user_id?: InputMaybe<Order_By>;
  field_partner_user_id?: InputMaybe<Order_By>;
  fpr_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Field_Partner_Response_Events_Min_Fields = {
  __typename?: 'field_partner_response_events_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  event_at?: Maybe<Scalars['timestamptz']['output']>;
  event_name?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  farmer_user_id?: Maybe<Scalars['bpchar']['output']>;
  field_partner_user_id?: Maybe<Scalars['bpchar']['output']>;
  fpr_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  request_id?: Maybe<Scalars['bpchar']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "field_partner_response_events" */
export type Field_Partner_Response_Events_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  event_at?: InputMaybe<Order_By>;
  event_name?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  farmer_user_id?: InputMaybe<Order_By>;
  field_partner_user_id?: InputMaybe<Order_By>;
  fpr_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "field_partner_response_events" */
export type Field_Partner_Response_Events_Mutation_Response = {
  __typename?: 'field_partner_response_events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Field_Partner_Response_Events>;
};

/** on_conflict condition type for table "field_partner_response_events" */
export type Field_Partner_Response_Events_On_Conflict = {
  constraint: Field_Partner_Response_Events_Constraint;
  update_columns?: Array<Field_Partner_Response_Events_Update_Column>;
  where?: InputMaybe<Field_Partner_Response_Events_Bool_Exp>;
};

/** Ordering options when selecting data from "field_partner_response_events". */
export type Field_Partner_Response_Events_Order_By = {
  account?: InputMaybe<Accounts_Order_By>;
  account_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  event_at?: InputMaybe<Order_By>;
  event_data?: InputMaybe<Order_By>;
  event_name?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  farmer_user_id?: InputMaybe<Order_By>;
  field_partner_response?: InputMaybe<Field_Partner_Responses_Order_By>;
  field_partner_user_id?: InputMaybe<Order_By>;
  fpr_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  service_request?: InputMaybe<Service_Requests_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userByFieldPartnerUserId?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: field_partner_response_events */
export type Field_Partner_Response_Events_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Field_Partner_Response_Events_Prepend_Input = {
  event_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "field_partner_response_events" */
export enum Field_Partner_Response_Events_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  EventAt = 'event_at',
  /** column name */
  EventData = 'event_data',
  /** column name */
  EventName = 'event_name',
  /** column name */
  EventType = 'event_type',
  /** column name */
  FarmerUserId = 'farmer_user_id',
  /** column name */
  FieldPartnerUserId = 'field_partner_user_id',
  /** column name */
  FprId = 'fpr_id',
  /** column name */
  Id = 'id',
  /** column name */
  RequestId = 'request_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "field_partner_response_events" */
export type Field_Partner_Response_Events_Set_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_data?: InputMaybe<Scalars['jsonb']['input']>;
  event_name?: InputMaybe<Scalars['String']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  farmer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  field_partner_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  fpr_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  request_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "field_partner_response_events" */
export type Field_Partner_Response_Events_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Field_Partner_Response_Events_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Field_Partner_Response_Events_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_data?: InputMaybe<Scalars['jsonb']['input']>;
  event_name?: InputMaybe<Scalars['String']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  farmer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  field_partner_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  fpr_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  request_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "field_partner_response_events" */
export enum Field_Partner_Response_Events_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  EventAt = 'event_at',
  /** column name */
  EventData = 'event_data',
  /** column name */
  EventName = 'event_name',
  /** column name */
  EventType = 'event_type',
  /** column name */
  FarmerUserId = 'farmer_user_id',
  /** column name */
  FieldPartnerUserId = 'field_partner_user_id',
  /** column name */
  FprId = 'fpr_id',
  /** column name */
  Id = 'id',
  /** column name */
  RequestId = 'request_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Field_Partner_Response_Events_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Field_Partner_Response_Events_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Field_Partner_Response_Events_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Field_Partner_Response_Events_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Field_Partner_Response_Events_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Field_Partner_Response_Events_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Field_Partner_Response_Events_Set_Input>;
  /** filter the rows which have to be updated */
  where: Field_Partner_Response_Events_Bool_Exp;
};

/** columns and relationships of "field_partner_response_messages" */
export type Field_Partner_Response_Messages = {
  __typename?: 'field_partner_response_messages';
  /** An object relationship */
  account: Accounts;
  account_id: Scalars['bpchar']['output'];
  assets: Scalars['jsonb']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  event_at: Scalars['timestamptz']['output'];
  farmer_user_id: Scalars['bpchar']['output'];
  /** An object relationship */
  field_partner_response: Field_Partner_Responses;
  field_partner_user_id: Scalars['bpchar']['output'];
  fpr_id: Scalars['bpchar']['output'];
  from_user_id: Scalars['bpchar']['output'];
  id: Scalars['bpchar']['output'];
  is_read: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  request_id: Scalars['bpchar']['output'];
  /** An object relationship */
  service_request: Service_Requests;
  to_user_id: Scalars['bpchar']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user: Users;
  /** An object relationship */
  userByFieldPartnerUserId: Users;
  /** An object relationship */
  userByFromUserId: Users;
  /** An object relationship */
  userByToUserId: Users;
};


/** columns and relationships of "field_partner_response_messages" */
export type Field_Partner_Response_MessagesAssetsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "field_partner_response_messages" */
export type Field_Partner_Response_Messages_Aggregate = {
  __typename?: 'field_partner_response_messages_aggregate';
  aggregate?: Maybe<Field_Partner_Response_Messages_Aggregate_Fields>;
  nodes: Array<Field_Partner_Response_Messages>;
};

export type Field_Partner_Response_Messages_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Field_Partner_Response_Messages_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Field_Partner_Response_Messages_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Field_Partner_Response_Messages_Aggregate_Bool_Exp_Count>;
};

export type Field_Partner_Response_Messages_Aggregate_Bool_Exp_Bool_And = {
  arguments: Field_Partner_Response_Messages_Select_Column_Field_Partner_Response_Messages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Field_Partner_Response_Messages_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Field_Partner_Response_Messages_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Field_Partner_Response_Messages_Select_Column_Field_Partner_Response_Messages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Field_Partner_Response_Messages_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Field_Partner_Response_Messages_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Field_Partner_Response_Messages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Field_Partner_Response_Messages_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "field_partner_response_messages" */
export type Field_Partner_Response_Messages_Aggregate_Fields = {
  __typename?: 'field_partner_response_messages_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Field_Partner_Response_Messages_Max_Fields>;
  min?: Maybe<Field_Partner_Response_Messages_Min_Fields>;
};


/** aggregate fields of "field_partner_response_messages" */
export type Field_Partner_Response_Messages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Field_Partner_Response_Messages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "field_partner_response_messages" */
export type Field_Partner_Response_Messages_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Field_Partner_Response_Messages_Max_Order_By>;
  min?: InputMaybe<Field_Partner_Response_Messages_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Field_Partner_Response_Messages_Append_Input = {
  assets?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "field_partner_response_messages" */
export type Field_Partner_Response_Messages_Arr_Rel_Insert_Input = {
  data: Array<Field_Partner_Response_Messages_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Field_Partner_Response_Messages_On_Conflict>;
};

/** Boolean expression to filter rows from the table "field_partner_response_messages". All fields are combined with a logical 'AND'. */
export type Field_Partner_Response_Messages_Bool_Exp = {
  _and?: InputMaybe<Array<Field_Partner_Response_Messages_Bool_Exp>>;
  _not?: InputMaybe<Field_Partner_Response_Messages_Bool_Exp>;
  _or?: InputMaybe<Array<Field_Partner_Response_Messages_Bool_Exp>>;
  account?: InputMaybe<Accounts_Bool_Exp>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  assets?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  farmer_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  field_partner_response?: InputMaybe<Field_Partner_Responses_Bool_Exp>;
  field_partner_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  fpr_id?: InputMaybe<Bpchar_Comparison_Exp>;
  from_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  is_read?: InputMaybe<Boolean_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  request_id?: InputMaybe<Bpchar_Comparison_Exp>;
  service_request?: InputMaybe<Service_Requests_Bool_Exp>;
  to_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userByFieldPartnerUserId?: InputMaybe<Users_Bool_Exp>;
  userByFromUserId?: InputMaybe<Users_Bool_Exp>;
  userByToUserId?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "field_partner_response_messages" */
export enum Field_Partner_Response_Messages_Constraint {
  /** unique or primary key constraint on columns "id" */
  FieldPartnerResponseMessagesPkey = 'field_partner_response_messages_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Field_Partner_Response_Messages_Delete_At_Path_Input = {
  assets?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Field_Partner_Response_Messages_Delete_Elem_Input = {
  assets?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Field_Partner_Response_Messages_Delete_Key_Input = {
  assets?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "field_partner_response_messages" */
export type Field_Partner_Response_Messages_Insert_Input = {
  account?: InputMaybe<Accounts_Obj_Rel_Insert_Input>;
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  assets?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  field_partner_response?: InputMaybe<Field_Partner_Responses_Obj_Rel_Insert_Input>;
  field_partner_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  fpr_id?: InputMaybe<Scalars['bpchar']['input']>;
  from_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  is_read?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  request_id?: InputMaybe<Scalars['bpchar']['input']>;
  service_request?: InputMaybe<Service_Requests_Obj_Rel_Insert_Input>;
  to_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userByFieldPartnerUserId?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userByFromUserId?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userByToUserId?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Field_Partner_Response_Messages_Max_Fields = {
  __typename?: 'field_partner_response_messages_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  event_at?: Maybe<Scalars['timestamptz']['output']>;
  farmer_user_id?: Maybe<Scalars['bpchar']['output']>;
  field_partner_user_id?: Maybe<Scalars['bpchar']['output']>;
  fpr_id?: Maybe<Scalars['bpchar']['output']>;
  from_user_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  request_id?: Maybe<Scalars['bpchar']['output']>;
  to_user_id?: Maybe<Scalars['bpchar']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "field_partner_response_messages" */
export type Field_Partner_Response_Messages_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  event_at?: InputMaybe<Order_By>;
  farmer_user_id?: InputMaybe<Order_By>;
  field_partner_user_id?: InputMaybe<Order_By>;
  fpr_id?: InputMaybe<Order_By>;
  from_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  to_user_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Field_Partner_Response_Messages_Min_Fields = {
  __typename?: 'field_partner_response_messages_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  event_at?: Maybe<Scalars['timestamptz']['output']>;
  farmer_user_id?: Maybe<Scalars['bpchar']['output']>;
  field_partner_user_id?: Maybe<Scalars['bpchar']['output']>;
  fpr_id?: Maybe<Scalars['bpchar']['output']>;
  from_user_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  request_id?: Maybe<Scalars['bpchar']['output']>;
  to_user_id?: Maybe<Scalars['bpchar']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "field_partner_response_messages" */
export type Field_Partner_Response_Messages_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  event_at?: InputMaybe<Order_By>;
  farmer_user_id?: InputMaybe<Order_By>;
  field_partner_user_id?: InputMaybe<Order_By>;
  fpr_id?: InputMaybe<Order_By>;
  from_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  to_user_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "field_partner_response_messages" */
export type Field_Partner_Response_Messages_Mutation_Response = {
  __typename?: 'field_partner_response_messages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Field_Partner_Response_Messages>;
};

/** on_conflict condition type for table "field_partner_response_messages" */
export type Field_Partner_Response_Messages_On_Conflict = {
  constraint: Field_Partner_Response_Messages_Constraint;
  update_columns?: Array<Field_Partner_Response_Messages_Update_Column>;
  where?: InputMaybe<Field_Partner_Response_Messages_Bool_Exp>;
};

/** Ordering options when selecting data from "field_partner_response_messages". */
export type Field_Partner_Response_Messages_Order_By = {
  account?: InputMaybe<Accounts_Order_By>;
  account_id?: InputMaybe<Order_By>;
  assets?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  event_at?: InputMaybe<Order_By>;
  farmer_user_id?: InputMaybe<Order_By>;
  field_partner_response?: InputMaybe<Field_Partner_Responses_Order_By>;
  field_partner_user_id?: InputMaybe<Order_By>;
  fpr_id?: InputMaybe<Order_By>;
  from_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_read?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  service_request?: InputMaybe<Service_Requests_Order_By>;
  to_user_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userByFieldPartnerUserId?: InputMaybe<Users_Order_By>;
  userByFromUserId?: InputMaybe<Users_Order_By>;
  userByToUserId?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: field_partner_response_messages */
export type Field_Partner_Response_Messages_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Field_Partner_Response_Messages_Prepend_Input = {
  assets?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "field_partner_response_messages" */
export enum Field_Partner_Response_Messages_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Assets = 'assets',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  EventAt = 'event_at',
  /** column name */
  FarmerUserId = 'farmer_user_id',
  /** column name */
  FieldPartnerUserId = 'field_partner_user_id',
  /** column name */
  FprId = 'fpr_id',
  /** column name */
  FromUserId = 'from_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsRead = 'is_read',
  /** column name */
  Message = 'message',
  /** column name */
  RequestId = 'request_id',
  /** column name */
  ToUserId = 'to_user_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "field_partner_response_messages_aggregate_bool_exp_bool_and_arguments_columns" columns of table "field_partner_response_messages" */
export enum Field_Partner_Response_Messages_Select_Column_Field_Partner_Response_Messages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsRead = 'is_read'
}

/** select "field_partner_response_messages_aggregate_bool_exp_bool_or_arguments_columns" columns of table "field_partner_response_messages" */
export enum Field_Partner_Response_Messages_Select_Column_Field_Partner_Response_Messages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsRead = 'is_read'
}

/** input type for updating data in table "field_partner_response_messages" */
export type Field_Partner_Response_Messages_Set_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  assets?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  field_partner_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  fpr_id?: InputMaybe<Scalars['bpchar']['input']>;
  from_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  is_read?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  request_id?: InputMaybe<Scalars['bpchar']['input']>;
  to_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "field_partner_response_messages" */
export type Field_Partner_Response_Messages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Field_Partner_Response_Messages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Field_Partner_Response_Messages_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  assets?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  field_partner_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  fpr_id?: InputMaybe<Scalars['bpchar']['input']>;
  from_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  is_read?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  request_id?: InputMaybe<Scalars['bpchar']['input']>;
  to_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "field_partner_response_messages" */
export enum Field_Partner_Response_Messages_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Assets = 'assets',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  EventAt = 'event_at',
  /** column name */
  FarmerUserId = 'farmer_user_id',
  /** column name */
  FieldPartnerUserId = 'field_partner_user_id',
  /** column name */
  FprId = 'fpr_id',
  /** column name */
  FromUserId = 'from_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsRead = 'is_read',
  /** column name */
  Message = 'message',
  /** column name */
  RequestId = 'request_id',
  /** column name */
  ToUserId = 'to_user_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Field_Partner_Response_Messages_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Field_Partner_Response_Messages_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Field_Partner_Response_Messages_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Field_Partner_Response_Messages_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Field_Partner_Response_Messages_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Field_Partner_Response_Messages_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Field_Partner_Response_Messages_Set_Input>;
  /** filter the rows which have to be updated */
  where: Field_Partner_Response_Messages_Bool_Exp;
};

/** columns and relationships of "field_partner_responses" */
export type Field_Partner_Responses = {
  __typename?: 'field_partner_responses';
  /** An object relationship */
  account: Accounts;
  account_id: Scalars['bpchar']['output'];
  /** An object relationship */
  chat_thread?: Maybe<Chat_Threads>;
  closed_at?: Maybe<Scalars['timestamptz']['output']>;
  closed_by?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  farmer_feedback?: Maybe<Scalars['String']['output']>;
  farmer_rated_at?: Maybe<Scalars['timestamptz']['output']>;
  farmer_rating?: Maybe<Scalars['Int']['output']>;
  farmer_user_id: Scalars['bpchar']['output'];
  field_partner_feedback?: Maybe<Scalars['String']['output']>;
  field_partner_rated_at?: Maybe<Scalars['timestamptz']['output']>;
  field_partner_rating?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  field_partner_response_events: Array<Field_Partner_Response_Events>;
  /** An aggregate relationship */
  field_partner_response_events_aggregate: Field_Partner_Response_Events_Aggregate;
  /** An array relationship */
  field_partner_response_messages: Array<Field_Partner_Response_Messages>;
  /** An aggregate relationship */
  field_partner_response_messages_aggregate: Field_Partner_Response_Messages_Aggregate;
  field_partner_user_id: Scalars['bpchar']['output'];
  /** An array relationship */
  field_scheduled_visits: Array<Field_Scheduled_Visits>;
  /** An aggregate relationship */
  field_scheduled_visits_aggregate: Field_Scheduled_Visits_Aggregate;
  id: Scalars['bpchar']['output'];
  is_response_closed: Scalars['Boolean']['output'];
  request_id: Scalars['bpchar']['output'];
  response_action?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  service_request: Service_Requests;
  /** An array relationship */
  service_request_recommendations: Array<Service_Request_Recommendations>;
  /** An aggregate relationship */
  service_request_recommendations_aggregate: Service_Request_Recommendations_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user: Users;
  /** An object relationship */
  userByFieldPartnerUserId: Users;
};


/** columns and relationships of "field_partner_responses" */
export type Field_Partner_ResponsesField_Partner_Response_EventsArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Response_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Response_Events_Order_By>>;
  where?: InputMaybe<Field_Partner_Response_Events_Bool_Exp>;
};


/** columns and relationships of "field_partner_responses" */
export type Field_Partner_ResponsesField_Partner_Response_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Response_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Response_Events_Order_By>>;
  where?: InputMaybe<Field_Partner_Response_Events_Bool_Exp>;
};


/** columns and relationships of "field_partner_responses" */
export type Field_Partner_ResponsesField_Partner_Response_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Response_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Response_Messages_Order_By>>;
  where?: InputMaybe<Field_Partner_Response_Messages_Bool_Exp>;
};


/** columns and relationships of "field_partner_responses" */
export type Field_Partner_ResponsesField_Partner_Response_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Response_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Response_Messages_Order_By>>;
  where?: InputMaybe<Field_Partner_Response_Messages_Bool_Exp>;
};


/** columns and relationships of "field_partner_responses" */
export type Field_Partner_ResponsesField_Scheduled_VisitsArgs = {
  distinct_on?: InputMaybe<Array<Field_Scheduled_Visits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Scheduled_Visits_Order_By>>;
  where?: InputMaybe<Field_Scheduled_Visits_Bool_Exp>;
};


/** columns and relationships of "field_partner_responses" */
export type Field_Partner_ResponsesField_Scheduled_Visits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Scheduled_Visits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Scheduled_Visits_Order_By>>;
  where?: InputMaybe<Field_Scheduled_Visits_Bool_Exp>;
};


/** columns and relationships of "field_partner_responses" */
export type Field_Partner_ResponsesService_Request_RecommendationsArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Recommendations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Recommendations_Order_By>>;
  where?: InputMaybe<Service_Request_Recommendations_Bool_Exp>;
};


/** columns and relationships of "field_partner_responses" */
export type Field_Partner_ResponsesService_Request_Recommendations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Recommendations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Recommendations_Order_By>>;
  where?: InputMaybe<Service_Request_Recommendations_Bool_Exp>;
};

/** aggregated selection of "field_partner_responses" */
export type Field_Partner_Responses_Aggregate = {
  __typename?: 'field_partner_responses_aggregate';
  aggregate?: Maybe<Field_Partner_Responses_Aggregate_Fields>;
  nodes: Array<Field_Partner_Responses>;
};

export type Field_Partner_Responses_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Field_Partner_Responses_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Field_Partner_Responses_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Field_Partner_Responses_Aggregate_Bool_Exp_Count>;
};

export type Field_Partner_Responses_Aggregate_Bool_Exp_Bool_And = {
  arguments: Field_Partner_Responses_Select_Column_Field_Partner_Responses_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Field_Partner_Responses_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Field_Partner_Responses_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Field_Partner_Responses_Select_Column_Field_Partner_Responses_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Field_Partner_Responses_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Field_Partner_Responses_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Field_Partner_Responses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Field_Partner_Responses_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "field_partner_responses" */
export type Field_Partner_Responses_Aggregate_Fields = {
  __typename?: 'field_partner_responses_aggregate_fields';
  avg?: Maybe<Field_Partner_Responses_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Field_Partner_Responses_Max_Fields>;
  min?: Maybe<Field_Partner_Responses_Min_Fields>;
  stddev?: Maybe<Field_Partner_Responses_Stddev_Fields>;
  stddev_pop?: Maybe<Field_Partner_Responses_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Field_Partner_Responses_Stddev_Samp_Fields>;
  sum?: Maybe<Field_Partner_Responses_Sum_Fields>;
  var_pop?: Maybe<Field_Partner_Responses_Var_Pop_Fields>;
  var_samp?: Maybe<Field_Partner_Responses_Var_Samp_Fields>;
  variance?: Maybe<Field_Partner_Responses_Variance_Fields>;
};


/** aggregate fields of "field_partner_responses" */
export type Field_Partner_Responses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Field_Partner_Responses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "field_partner_responses" */
export type Field_Partner_Responses_Aggregate_Order_By = {
  avg?: InputMaybe<Field_Partner_Responses_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Field_Partner_Responses_Max_Order_By>;
  min?: InputMaybe<Field_Partner_Responses_Min_Order_By>;
  stddev?: InputMaybe<Field_Partner_Responses_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Field_Partner_Responses_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Field_Partner_Responses_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Field_Partner_Responses_Sum_Order_By>;
  var_pop?: InputMaybe<Field_Partner_Responses_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Field_Partner_Responses_Var_Samp_Order_By>;
  variance?: InputMaybe<Field_Partner_Responses_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "field_partner_responses" */
export type Field_Partner_Responses_Arr_Rel_Insert_Input = {
  data: Array<Field_Partner_Responses_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Field_Partner_Responses_On_Conflict>;
};

/** aggregate avg on columns */
export type Field_Partner_Responses_Avg_Fields = {
  __typename?: 'field_partner_responses_avg_fields';
  farmer_rating?: Maybe<Scalars['Float']['output']>;
  field_partner_rating?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "field_partner_responses" */
export type Field_Partner_Responses_Avg_Order_By = {
  farmer_rating?: InputMaybe<Order_By>;
  field_partner_rating?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "field_partner_responses". All fields are combined with a logical 'AND'. */
export type Field_Partner_Responses_Bool_Exp = {
  _and?: InputMaybe<Array<Field_Partner_Responses_Bool_Exp>>;
  _not?: InputMaybe<Field_Partner_Responses_Bool_Exp>;
  _or?: InputMaybe<Array<Field_Partner_Responses_Bool_Exp>>;
  account?: InputMaybe<Accounts_Bool_Exp>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  chat_thread?: InputMaybe<Chat_Threads_Bool_Exp>;
  closed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  closed_by?: InputMaybe<Bpchar_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  farmer_feedback?: InputMaybe<String_Comparison_Exp>;
  farmer_rated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  farmer_rating?: InputMaybe<Int_Comparison_Exp>;
  farmer_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  field_partner_feedback?: InputMaybe<String_Comparison_Exp>;
  field_partner_rated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  field_partner_rating?: InputMaybe<Int_Comparison_Exp>;
  field_partner_response_events?: InputMaybe<Field_Partner_Response_Events_Bool_Exp>;
  field_partner_response_events_aggregate?: InputMaybe<Field_Partner_Response_Events_Aggregate_Bool_Exp>;
  field_partner_response_messages?: InputMaybe<Field_Partner_Response_Messages_Bool_Exp>;
  field_partner_response_messages_aggregate?: InputMaybe<Field_Partner_Response_Messages_Aggregate_Bool_Exp>;
  field_partner_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  field_scheduled_visits?: InputMaybe<Field_Scheduled_Visits_Bool_Exp>;
  field_scheduled_visits_aggregate?: InputMaybe<Field_Scheduled_Visits_Aggregate_Bool_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  is_response_closed?: InputMaybe<Boolean_Comparison_Exp>;
  request_id?: InputMaybe<Bpchar_Comparison_Exp>;
  response_action?: InputMaybe<String_Comparison_Exp>;
  service_request?: InputMaybe<Service_Requests_Bool_Exp>;
  service_request_recommendations?: InputMaybe<Service_Request_Recommendations_Bool_Exp>;
  service_request_recommendations_aggregate?: InputMaybe<Service_Request_Recommendations_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userByFieldPartnerUserId?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "field_partner_responses" */
export enum Field_Partner_Responses_Constraint {
  /** unique or primary key constraint on columns "id" */
  FieldPartnerResponsesPkey = 'field_partner_responses_pkey'
}

/** input type for incrementing numeric columns in table "field_partner_responses" */
export type Field_Partner_Responses_Inc_Input = {
  farmer_rating?: InputMaybe<Scalars['Int']['input']>;
  field_partner_rating?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "field_partner_responses" */
export type Field_Partner_Responses_Insert_Input = {
  account?: InputMaybe<Accounts_Obj_Rel_Insert_Input>;
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  chat_thread?: InputMaybe<Chat_Threads_Obj_Rel_Insert_Input>;
  closed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  closed_by?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer_feedback?: InputMaybe<Scalars['String']['input']>;
  farmer_rated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer_rating?: InputMaybe<Scalars['Int']['input']>;
  farmer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  field_partner_feedback?: InputMaybe<Scalars['String']['input']>;
  field_partner_rated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  field_partner_rating?: InputMaybe<Scalars['Int']['input']>;
  field_partner_response_events?: InputMaybe<Field_Partner_Response_Events_Arr_Rel_Insert_Input>;
  field_partner_response_messages?: InputMaybe<Field_Partner_Response_Messages_Arr_Rel_Insert_Input>;
  field_partner_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  field_scheduled_visits?: InputMaybe<Field_Scheduled_Visits_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  is_response_closed?: InputMaybe<Scalars['Boolean']['input']>;
  request_id?: InputMaybe<Scalars['bpchar']['input']>;
  response_action?: InputMaybe<Scalars['String']['input']>;
  service_request?: InputMaybe<Service_Requests_Obj_Rel_Insert_Input>;
  service_request_recommendations?: InputMaybe<Service_Request_Recommendations_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userByFieldPartnerUserId?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Field_Partner_Responses_Max_Fields = {
  __typename?: 'field_partner_responses_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  closed_at?: Maybe<Scalars['timestamptz']['output']>;
  closed_by?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  farmer_feedback?: Maybe<Scalars['String']['output']>;
  farmer_rated_at?: Maybe<Scalars['timestamptz']['output']>;
  farmer_rating?: Maybe<Scalars['Int']['output']>;
  farmer_user_id?: Maybe<Scalars['bpchar']['output']>;
  field_partner_feedback?: Maybe<Scalars['String']['output']>;
  field_partner_rated_at?: Maybe<Scalars['timestamptz']['output']>;
  field_partner_rating?: Maybe<Scalars['Int']['output']>;
  field_partner_user_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  request_id?: Maybe<Scalars['bpchar']['output']>;
  response_action?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "field_partner_responses" */
export type Field_Partner_Responses_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  closed_at?: InputMaybe<Order_By>;
  closed_by?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  farmer_feedback?: InputMaybe<Order_By>;
  farmer_rated_at?: InputMaybe<Order_By>;
  farmer_rating?: InputMaybe<Order_By>;
  farmer_user_id?: InputMaybe<Order_By>;
  field_partner_feedback?: InputMaybe<Order_By>;
  field_partner_rated_at?: InputMaybe<Order_By>;
  field_partner_rating?: InputMaybe<Order_By>;
  field_partner_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  response_action?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Field_Partner_Responses_Min_Fields = {
  __typename?: 'field_partner_responses_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  closed_at?: Maybe<Scalars['timestamptz']['output']>;
  closed_by?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  farmer_feedback?: Maybe<Scalars['String']['output']>;
  farmer_rated_at?: Maybe<Scalars['timestamptz']['output']>;
  farmer_rating?: Maybe<Scalars['Int']['output']>;
  farmer_user_id?: Maybe<Scalars['bpchar']['output']>;
  field_partner_feedback?: Maybe<Scalars['String']['output']>;
  field_partner_rated_at?: Maybe<Scalars['timestamptz']['output']>;
  field_partner_rating?: Maybe<Scalars['Int']['output']>;
  field_partner_user_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  request_id?: Maybe<Scalars['bpchar']['output']>;
  response_action?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "field_partner_responses" */
export type Field_Partner_Responses_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  closed_at?: InputMaybe<Order_By>;
  closed_by?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  farmer_feedback?: InputMaybe<Order_By>;
  farmer_rated_at?: InputMaybe<Order_By>;
  farmer_rating?: InputMaybe<Order_By>;
  farmer_user_id?: InputMaybe<Order_By>;
  field_partner_feedback?: InputMaybe<Order_By>;
  field_partner_rated_at?: InputMaybe<Order_By>;
  field_partner_rating?: InputMaybe<Order_By>;
  field_partner_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  response_action?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "field_partner_responses" */
export type Field_Partner_Responses_Mutation_Response = {
  __typename?: 'field_partner_responses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Field_Partner_Responses>;
};

/** input type for inserting object relation for remote table "field_partner_responses" */
export type Field_Partner_Responses_Obj_Rel_Insert_Input = {
  data: Field_Partner_Responses_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Field_Partner_Responses_On_Conflict>;
};

/** on_conflict condition type for table "field_partner_responses" */
export type Field_Partner_Responses_On_Conflict = {
  constraint: Field_Partner_Responses_Constraint;
  update_columns?: Array<Field_Partner_Responses_Update_Column>;
  where?: InputMaybe<Field_Partner_Responses_Bool_Exp>;
};

/** Ordering options when selecting data from "field_partner_responses". */
export type Field_Partner_Responses_Order_By = {
  account?: InputMaybe<Accounts_Order_By>;
  account_id?: InputMaybe<Order_By>;
  chat_thread?: InputMaybe<Chat_Threads_Order_By>;
  closed_at?: InputMaybe<Order_By>;
  closed_by?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  farmer_feedback?: InputMaybe<Order_By>;
  farmer_rated_at?: InputMaybe<Order_By>;
  farmer_rating?: InputMaybe<Order_By>;
  farmer_user_id?: InputMaybe<Order_By>;
  field_partner_feedback?: InputMaybe<Order_By>;
  field_partner_rated_at?: InputMaybe<Order_By>;
  field_partner_rating?: InputMaybe<Order_By>;
  field_partner_response_events_aggregate?: InputMaybe<Field_Partner_Response_Events_Aggregate_Order_By>;
  field_partner_response_messages_aggregate?: InputMaybe<Field_Partner_Response_Messages_Aggregate_Order_By>;
  field_partner_user_id?: InputMaybe<Order_By>;
  field_scheduled_visits_aggregate?: InputMaybe<Field_Scheduled_Visits_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_response_closed?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  response_action?: InputMaybe<Order_By>;
  service_request?: InputMaybe<Service_Requests_Order_By>;
  service_request_recommendations_aggregate?: InputMaybe<Service_Request_Recommendations_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userByFieldPartnerUserId?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: field_partner_responses */
export type Field_Partner_Responses_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** select columns of table "field_partner_responses" */
export enum Field_Partner_Responses_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  ClosedAt = 'closed_at',
  /** column name */
  ClosedBy = 'closed_by',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FarmerFeedback = 'farmer_feedback',
  /** column name */
  FarmerRatedAt = 'farmer_rated_at',
  /** column name */
  FarmerRating = 'farmer_rating',
  /** column name */
  FarmerUserId = 'farmer_user_id',
  /** column name */
  FieldPartnerFeedback = 'field_partner_feedback',
  /** column name */
  FieldPartnerRatedAt = 'field_partner_rated_at',
  /** column name */
  FieldPartnerRating = 'field_partner_rating',
  /** column name */
  FieldPartnerUserId = 'field_partner_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsResponseClosed = 'is_response_closed',
  /** column name */
  RequestId = 'request_id',
  /** column name */
  ResponseAction = 'response_action',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "field_partner_responses_aggregate_bool_exp_bool_and_arguments_columns" columns of table "field_partner_responses" */
export enum Field_Partner_Responses_Select_Column_Field_Partner_Responses_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsResponseClosed = 'is_response_closed'
}

/** select "field_partner_responses_aggregate_bool_exp_bool_or_arguments_columns" columns of table "field_partner_responses" */
export enum Field_Partner_Responses_Select_Column_Field_Partner_Responses_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsResponseClosed = 'is_response_closed'
}

/** input type for updating data in table "field_partner_responses" */
export type Field_Partner_Responses_Set_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  closed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  closed_by?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer_feedback?: InputMaybe<Scalars['String']['input']>;
  farmer_rated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer_rating?: InputMaybe<Scalars['Int']['input']>;
  farmer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  field_partner_feedback?: InputMaybe<Scalars['String']['input']>;
  field_partner_rated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  field_partner_rating?: InputMaybe<Scalars['Int']['input']>;
  field_partner_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  is_response_closed?: InputMaybe<Scalars['Boolean']['input']>;
  request_id?: InputMaybe<Scalars['bpchar']['input']>;
  response_action?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Field_Partner_Responses_Stddev_Fields = {
  __typename?: 'field_partner_responses_stddev_fields';
  farmer_rating?: Maybe<Scalars['Float']['output']>;
  field_partner_rating?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "field_partner_responses" */
export type Field_Partner_Responses_Stddev_Order_By = {
  farmer_rating?: InputMaybe<Order_By>;
  field_partner_rating?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Field_Partner_Responses_Stddev_Pop_Fields = {
  __typename?: 'field_partner_responses_stddev_pop_fields';
  farmer_rating?: Maybe<Scalars['Float']['output']>;
  field_partner_rating?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "field_partner_responses" */
export type Field_Partner_Responses_Stddev_Pop_Order_By = {
  farmer_rating?: InputMaybe<Order_By>;
  field_partner_rating?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Field_Partner_Responses_Stddev_Samp_Fields = {
  __typename?: 'field_partner_responses_stddev_samp_fields';
  farmer_rating?: Maybe<Scalars['Float']['output']>;
  field_partner_rating?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "field_partner_responses" */
export type Field_Partner_Responses_Stddev_Samp_Order_By = {
  farmer_rating?: InputMaybe<Order_By>;
  field_partner_rating?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "field_partner_responses" */
export type Field_Partner_Responses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Field_Partner_Responses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Field_Partner_Responses_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  closed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  closed_by?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer_feedback?: InputMaybe<Scalars['String']['input']>;
  farmer_rated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer_rating?: InputMaybe<Scalars['Int']['input']>;
  farmer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  field_partner_feedback?: InputMaybe<Scalars['String']['input']>;
  field_partner_rated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  field_partner_rating?: InputMaybe<Scalars['Int']['input']>;
  field_partner_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  is_response_closed?: InputMaybe<Scalars['Boolean']['input']>;
  request_id?: InputMaybe<Scalars['bpchar']['input']>;
  response_action?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Field_Partner_Responses_Sum_Fields = {
  __typename?: 'field_partner_responses_sum_fields';
  farmer_rating?: Maybe<Scalars['Int']['output']>;
  field_partner_rating?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "field_partner_responses" */
export type Field_Partner_Responses_Sum_Order_By = {
  farmer_rating?: InputMaybe<Order_By>;
  field_partner_rating?: InputMaybe<Order_By>;
};

/** update columns of table "field_partner_responses" */
export enum Field_Partner_Responses_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  ClosedAt = 'closed_at',
  /** column name */
  ClosedBy = 'closed_by',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FarmerFeedback = 'farmer_feedback',
  /** column name */
  FarmerRatedAt = 'farmer_rated_at',
  /** column name */
  FarmerRating = 'farmer_rating',
  /** column name */
  FarmerUserId = 'farmer_user_id',
  /** column name */
  FieldPartnerFeedback = 'field_partner_feedback',
  /** column name */
  FieldPartnerRatedAt = 'field_partner_rated_at',
  /** column name */
  FieldPartnerRating = 'field_partner_rating',
  /** column name */
  FieldPartnerUserId = 'field_partner_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsResponseClosed = 'is_response_closed',
  /** column name */
  RequestId = 'request_id',
  /** column name */
  ResponseAction = 'response_action',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Field_Partner_Responses_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Field_Partner_Responses_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Field_Partner_Responses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Field_Partner_Responses_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Field_Partner_Responses_Var_Pop_Fields = {
  __typename?: 'field_partner_responses_var_pop_fields';
  farmer_rating?: Maybe<Scalars['Float']['output']>;
  field_partner_rating?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "field_partner_responses" */
export type Field_Partner_Responses_Var_Pop_Order_By = {
  farmer_rating?: InputMaybe<Order_By>;
  field_partner_rating?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Field_Partner_Responses_Var_Samp_Fields = {
  __typename?: 'field_partner_responses_var_samp_fields';
  farmer_rating?: Maybe<Scalars['Float']['output']>;
  field_partner_rating?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "field_partner_responses" */
export type Field_Partner_Responses_Var_Samp_Order_By = {
  farmer_rating?: InputMaybe<Order_By>;
  field_partner_rating?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Field_Partner_Responses_Variance_Fields = {
  __typename?: 'field_partner_responses_variance_fields';
  farmer_rating?: Maybe<Scalars['Float']['output']>;
  field_partner_rating?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "field_partner_responses" */
export type Field_Partner_Responses_Variance_Order_By = {
  farmer_rating?: InputMaybe<Order_By>;
  field_partner_rating?: InputMaybe<Order_By>;
};

/** columns and relationships of "field_scheduled_visits" */
export type Field_Scheduled_Visits = {
  __typename?: 'field_scheduled_visits';
  /** An object relationship */
  account: Accounts;
  account_id: Scalars['bpchar']['output'];
  assets: Scalars['jsonb']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id: Scalars['bigint']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  farmer_user_id: Scalars['bpchar']['output'];
  /** An object relationship */
  field_partner_response: Field_Partner_Responses;
  field_partner_user_id: Scalars['bpchar']['output'];
  fpr_id: Scalars['bpchar']['output'];
  id: Scalars['bpchar']['output'];
  is_farmer_accepted: Scalars['Boolean']['output'];
  is_field_partner_accepted: Scalars['Boolean']['output'];
  is_visit_done: Scalars['Boolean']['output'];
  request_id: Scalars['bpchar']['output'];
  scheduled_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  service_request: Service_Requests;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user: Users;
  /** An object relationship */
  userByFieldPartnerUserId: Users;
};


/** columns and relationships of "field_scheduled_visits" */
export type Field_Scheduled_VisitsAssetsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "field_scheduled_visits" */
export type Field_Scheduled_Visits_Aggregate = {
  __typename?: 'field_scheduled_visits_aggregate';
  aggregate?: Maybe<Field_Scheduled_Visits_Aggregate_Fields>;
  nodes: Array<Field_Scheduled_Visits>;
};

export type Field_Scheduled_Visits_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Field_Scheduled_Visits_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Field_Scheduled_Visits_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Field_Scheduled_Visits_Aggregate_Bool_Exp_Count>;
};

export type Field_Scheduled_Visits_Aggregate_Bool_Exp_Bool_And = {
  arguments: Field_Scheduled_Visits_Select_Column_Field_Scheduled_Visits_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Field_Scheduled_Visits_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Field_Scheduled_Visits_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Field_Scheduled_Visits_Select_Column_Field_Scheduled_Visits_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Field_Scheduled_Visits_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Field_Scheduled_Visits_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Field_Scheduled_Visits_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Field_Scheduled_Visits_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "field_scheduled_visits" */
export type Field_Scheduled_Visits_Aggregate_Fields = {
  __typename?: 'field_scheduled_visits_aggregate_fields';
  avg?: Maybe<Field_Scheduled_Visits_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Field_Scheduled_Visits_Max_Fields>;
  min?: Maybe<Field_Scheduled_Visits_Min_Fields>;
  stddev?: Maybe<Field_Scheduled_Visits_Stddev_Fields>;
  stddev_pop?: Maybe<Field_Scheduled_Visits_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Field_Scheduled_Visits_Stddev_Samp_Fields>;
  sum?: Maybe<Field_Scheduled_Visits_Sum_Fields>;
  var_pop?: Maybe<Field_Scheduled_Visits_Var_Pop_Fields>;
  var_samp?: Maybe<Field_Scheduled_Visits_Var_Samp_Fields>;
  variance?: Maybe<Field_Scheduled_Visits_Variance_Fields>;
};


/** aggregate fields of "field_scheduled_visits" */
export type Field_Scheduled_Visits_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Field_Scheduled_Visits_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "field_scheduled_visits" */
export type Field_Scheduled_Visits_Aggregate_Order_By = {
  avg?: InputMaybe<Field_Scheduled_Visits_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Field_Scheduled_Visits_Max_Order_By>;
  min?: InputMaybe<Field_Scheduled_Visits_Min_Order_By>;
  stddev?: InputMaybe<Field_Scheduled_Visits_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Field_Scheduled_Visits_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Field_Scheduled_Visits_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Field_Scheduled_Visits_Sum_Order_By>;
  var_pop?: InputMaybe<Field_Scheduled_Visits_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Field_Scheduled_Visits_Var_Samp_Order_By>;
  variance?: InputMaybe<Field_Scheduled_Visits_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Field_Scheduled_Visits_Append_Input = {
  assets?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "field_scheduled_visits" */
export type Field_Scheduled_Visits_Arr_Rel_Insert_Input = {
  data: Array<Field_Scheduled_Visits_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Field_Scheduled_Visits_On_Conflict>;
};

/** aggregate avg on columns */
export type Field_Scheduled_Visits_Avg_Fields = {
  __typename?: 'field_scheduled_visits_avg_fields';
  created_by_user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "field_scheduled_visits" */
export type Field_Scheduled_Visits_Avg_Order_By = {
  created_by_user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "field_scheduled_visits". All fields are combined with a logical 'AND'. */
export type Field_Scheduled_Visits_Bool_Exp = {
  _and?: InputMaybe<Array<Field_Scheduled_Visits_Bool_Exp>>;
  _not?: InputMaybe<Field_Scheduled_Visits_Bool_Exp>;
  _or?: InputMaybe<Array<Field_Scheduled_Visits_Bool_Exp>>;
  account?: InputMaybe<Accounts_Bool_Exp>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  assets?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_user_id?: InputMaybe<Bigint_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  farmer_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  field_partner_response?: InputMaybe<Field_Partner_Responses_Bool_Exp>;
  field_partner_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  fpr_id?: InputMaybe<Bpchar_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  is_farmer_accepted?: InputMaybe<Boolean_Comparison_Exp>;
  is_field_partner_accepted?: InputMaybe<Boolean_Comparison_Exp>;
  is_visit_done?: InputMaybe<Boolean_Comparison_Exp>;
  request_id?: InputMaybe<Bpchar_Comparison_Exp>;
  scheduled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  service_request?: InputMaybe<Service_Requests_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userByFieldPartnerUserId?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "field_scheduled_visits" */
export enum Field_Scheduled_Visits_Constraint {
  /** unique or primary key constraint on columns "id" */
  FieldScheduledVisitsPkey = 'field_scheduled_visits_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Field_Scheduled_Visits_Delete_At_Path_Input = {
  assets?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Field_Scheduled_Visits_Delete_Elem_Input = {
  assets?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Field_Scheduled_Visits_Delete_Key_Input = {
  assets?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "field_scheduled_visits" */
export type Field_Scheduled_Visits_Inc_Input = {
  created_by_user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "field_scheduled_visits" */
export type Field_Scheduled_Visits_Insert_Input = {
  account?: InputMaybe<Accounts_Obj_Rel_Insert_Input>;
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  assets?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  field_partner_response?: InputMaybe<Field_Partner_Responses_Obj_Rel_Insert_Input>;
  field_partner_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  fpr_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  is_farmer_accepted?: InputMaybe<Scalars['Boolean']['input']>;
  is_field_partner_accepted?: InputMaybe<Scalars['Boolean']['input']>;
  is_visit_done?: InputMaybe<Scalars['Boolean']['input']>;
  request_id?: InputMaybe<Scalars['bpchar']['input']>;
  scheduled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  service_request?: InputMaybe<Service_Requests_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userByFieldPartnerUserId?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Field_Scheduled_Visits_Max_Fields = {
  __typename?: 'field_scheduled_visits_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  farmer_user_id?: Maybe<Scalars['bpchar']['output']>;
  field_partner_user_id?: Maybe<Scalars['bpchar']['output']>;
  fpr_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  request_id?: Maybe<Scalars['bpchar']['output']>;
  scheduled_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "field_scheduled_visits" */
export type Field_Scheduled_Visits_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  farmer_user_id?: InputMaybe<Order_By>;
  field_partner_user_id?: InputMaybe<Order_By>;
  fpr_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  scheduled_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Field_Scheduled_Visits_Min_Fields = {
  __typename?: 'field_scheduled_visits_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  farmer_user_id?: Maybe<Scalars['bpchar']['output']>;
  field_partner_user_id?: Maybe<Scalars['bpchar']['output']>;
  fpr_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  request_id?: Maybe<Scalars['bpchar']['output']>;
  scheduled_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "field_scheduled_visits" */
export type Field_Scheduled_Visits_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  farmer_user_id?: InputMaybe<Order_By>;
  field_partner_user_id?: InputMaybe<Order_By>;
  fpr_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  scheduled_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "field_scheduled_visits" */
export type Field_Scheduled_Visits_Mutation_Response = {
  __typename?: 'field_scheduled_visits_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Field_Scheduled_Visits>;
};

/** on_conflict condition type for table "field_scheduled_visits" */
export type Field_Scheduled_Visits_On_Conflict = {
  constraint: Field_Scheduled_Visits_Constraint;
  update_columns?: Array<Field_Scheduled_Visits_Update_Column>;
  where?: InputMaybe<Field_Scheduled_Visits_Bool_Exp>;
};

/** Ordering options when selecting data from "field_scheduled_visits". */
export type Field_Scheduled_Visits_Order_By = {
  account?: InputMaybe<Accounts_Order_By>;
  account_id?: InputMaybe<Order_By>;
  assets?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  farmer_user_id?: InputMaybe<Order_By>;
  field_partner_response?: InputMaybe<Field_Partner_Responses_Order_By>;
  field_partner_user_id?: InputMaybe<Order_By>;
  fpr_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_farmer_accepted?: InputMaybe<Order_By>;
  is_field_partner_accepted?: InputMaybe<Order_By>;
  is_visit_done?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  scheduled_at?: InputMaybe<Order_By>;
  service_request?: InputMaybe<Service_Requests_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userByFieldPartnerUserId?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: field_scheduled_visits */
export type Field_Scheduled_Visits_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Field_Scheduled_Visits_Prepend_Input = {
  assets?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "field_scheduled_visits" */
export enum Field_Scheduled_Visits_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Assets = 'assets',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FarmerUserId = 'farmer_user_id',
  /** column name */
  FieldPartnerUserId = 'field_partner_user_id',
  /** column name */
  FprId = 'fpr_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsFarmerAccepted = 'is_farmer_accepted',
  /** column name */
  IsFieldPartnerAccepted = 'is_field_partner_accepted',
  /** column name */
  IsVisitDone = 'is_visit_done',
  /** column name */
  RequestId = 'request_id',
  /** column name */
  ScheduledAt = 'scheduled_at',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "field_scheduled_visits_aggregate_bool_exp_bool_and_arguments_columns" columns of table "field_scheduled_visits" */
export enum Field_Scheduled_Visits_Select_Column_Field_Scheduled_Visits_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsFarmerAccepted = 'is_farmer_accepted',
  /** column name */
  IsFieldPartnerAccepted = 'is_field_partner_accepted',
  /** column name */
  IsVisitDone = 'is_visit_done'
}

/** select "field_scheduled_visits_aggregate_bool_exp_bool_or_arguments_columns" columns of table "field_scheduled_visits" */
export enum Field_Scheduled_Visits_Select_Column_Field_Scheduled_Visits_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsFarmerAccepted = 'is_farmer_accepted',
  /** column name */
  IsFieldPartnerAccepted = 'is_field_partner_accepted',
  /** column name */
  IsVisitDone = 'is_visit_done'
}

/** input type for updating data in table "field_scheduled_visits" */
export type Field_Scheduled_Visits_Set_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  assets?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  field_partner_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  fpr_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  is_farmer_accepted?: InputMaybe<Scalars['Boolean']['input']>;
  is_field_partner_accepted?: InputMaybe<Scalars['Boolean']['input']>;
  is_visit_done?: InputMaybe<Scalars['Boolean']['input']>;
  request_id?: InputMaybe<Scalars['bpchar']['input']>;
  scheduled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Field_Scheduled_Visits_Stddev_Fields = {
  __typename?: 'field_scheduled_visits_stddev_fields';
  created_by_user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "field_scheduled_visits" */
export type Field_Scheduled_Visits_Stddev_Order_By = {
  created_by_user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Field_Scheduled_Visits_Stddev_Pop_Fields = {
  __typename?: 'field_scheduled_visits_stddev_pop_fields';
  created_by_user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "field_scheduled_visits" */
export type Field_Scheduled_Visits_Stddev_Pop_Order_By = {
  created_by_user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Field_Scheduled_Visits_Stddev_Samp_Fields = {
  __typename?: 'field_scheduled_visits_stddev_samp_fields';
  created_by_user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "field_scheduled_visits" */
export type Field_Scheduled_Visits_Stddev_Samp_Order_By = {
  created_by_user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "field_scheduled_visits" */
export type Field_Scheduled_Visits_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Field_Scheduled_Visits_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Field_Scheduled_Visits_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  assets?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  field_partner_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  fpr_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  is_farmer_accepted?: InputMaybe<Scalars['Boolean']['input']>;
  is_field_partner_accepted?: InputMaybe<Scalars['Boolean']['input']>;
  is_visit_done?: InputMaybe<Scalars['Boolean']['input']>;
  request_id?: InputMaybe<Scalars['bpchar']['input']>;
  scheduled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Field_Scheduled_Visits_Sum_Fields = {
  __typename?: 'field_scheduled_visits_sum_fields';
  created_by_user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "field_scheduled_visits" */
export type Field_Scheduled_Visits_Sum_Order_By = {
  created_by_user_id?: InputMaybe<Order_By>;
};

/** update columns of table "field_scheduled_visits" */
export enum Field_Scheduled_Visits_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Assets = 'assets',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FarmerUserId = 'farmer_user_id',
  /** column name */
  FieldPartnerUserId = 'field_partner_user_id',
  /** column name */
  FprId = 'fpr_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsFarmerAccepted = 'is_farmer_accepted',
  /** column name */
  IsFieldPartnerAccepted = 'is_field_partner_accepted',
  /** column name */
  IsVisitDone = 'is_visit_done',
  /** column name */
  RequestId = 'request_id',
  /** column name */
  ScheduledAt = 'scheduled_at',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Field_Scheduled_Visits_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Field_Scheduled_Visits_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Field_Scheduled_Visits_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Field_Scheduled_Visits_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Field_Scheduled_Visits_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Field_Scheduled_Visits_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Field_Scheduled_Visits_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Field_Scheduled_Visits_Set_Input>;
  /** filter the rows which have to be updated */
  where: Field_Scheduled_Visits_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Field_Scheduled_Visits_Var_Pop_Fields = {
  __typename?: 'field_scheduled_visits_var_pop_fields';
  created_by_user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "field_scheduled_visits" */
export type Field_Scheduled_Visits_Var_Pop_Order_By = {
  created_by_user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Field_Scheduled_Visits_Var_Samp_Fields = {
  __typename?: 'field_scheduled_visits_var_samp_fields';
  created_by_user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "field_scheduled_visits" */
export type Field_Scheduled_Visits_Var_Samp_Order_By = {
  created_by_user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Field_Scheduled_Visits_Variance_Fields = {
  __typename?: 'field_scheduled_visits_variance_fields';
  created_by_user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "field_scheduled_visits" */
export type Field_Scheduled_Visits_Variance_Order_By = {
  created_by_user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

/** columns and relationships of "fo_reels_staging" */
export type Fo_Reels_Staging = {
  __typename?: 'fo_reels_staging';
  approved_at?: Maybe<Scalars['timestamptz']['output']>;
  approved_by?: Maybe<Scalars['bpchar']['output']>;
  /** An object relationship */
  approved_reel?: Maybe<Reels>;
  cf_data?: Maybe<Scalars['jsonb']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  event: Scalars['jsonb']['output'];
  id: Scalars['bigint']['output'];
  is_approved: Scalars['Boolean']['output'];
  pf_manager_id?: Maybe<Scalars['Int']['output']>;
  pf_user_id?: Maybe<Scalars['Int']['output']>;
  reel_id?: Maybe<Scalars['bigint']['output']>;
  status: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['bpchar']['output'];
};


/** columns and relationships of "fo_reels_staging" */
export type Fo_Reels_StagingCf_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "fo_reels_staging" */
export type Fo_Reels_StagingEventArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "fo_reels_staging" */
export type Fo_Reels_Staging_Aggregate = {
  __typename?: 'fo_reels_staging_aggregate';
  aggregate?: Maybe<Fo_Reels_Staging_Aggregate_Fields>;
  nodes: Array<Fo_Reels_Staging>;
};

/** aggregate fields of "fo_reels_staging" */
export type Fo_Reels_Staging_Aggregate_Fields = {
  __typename?: 'fo_reels_staging_aggregate_fields';
  avg?: Maybe<Fo_Reels_Staging_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Fo_Reels_Staging_Max_Fields>;
  min?: Maybe<Fo_Reels_Staging_Min_Fields>;
  stddev?: Maybe<Fo_Reels_Staging_Stddev_Fields>;
  stddev_pop?: Maybe<Fo_Reels_Staging_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fo_Reels_Staging_Stddev_Samp_Fields>;
  sum?: Maybe<Fo_Reels_Staging_Sum_Fields>;
  var_pop?: Maybe<Fo_Reels_Staging_Var_Pop_Fields>;
  var_samp?: Maybe<Fo_Reels_Staging_Var_Samp_Fields>;
  variance?: Maybe<Fo_Reels_Staging_Variance_Fields>;
};


/** aggregate fields of "fo_reels_staging" */
export type Fo_Reels_Staging_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fo_Reels_Staging_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Fo_Reels_Staging_Append_Input = {
  cf_data?: InputMaybe<Scalars['jsonb']['input']>;
  event?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Fo_Reels_Staging_Avg_Fields = {
  __typename?: 'fo_reels_staging_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  pf_manager_id?: Maybe<Scalars['Float']['output']>;
  pf_user_id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "fo_reels_staging". All fields are combined with a logical 'AND'. */
export type Fo_Reels_Staging_Bool_Exp = {
  _and?: InputMaybe<Array<Fo_Reels_Staging_Bool_Exp>>;
  _not?: InputMaybe<Fo_Reels_Staging_Bool_Exp>;
  _or?: InputMaybe<Array<Fo_Reels_Staging_Bool_Exp>>;
  approved_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  approved_by?: InputMaybe<Bpchar_Comparison_Exp>;
  approved_reel?: InputMaybe<Reels_Bool_Exp>;
  cf_data?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  event?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_approved?: InputMaybe<Boolean_Comparison_Exp>;
  pf_manager_id?: InputMaybe<Int_Comparison_Exp>;
  pf_user_id?: InputMaybe<Int_Comparison_Exp>;
  reel_id?: InputMaybe<Bigint_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "fo_reels_staging" */
export enum Fo_Reels_Staging_Constraint {
  /** unique or primary key constraint on columns "id" */
  FoReelsStagingPkey = 'fo_reels_staging_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Fo_Reels_Staging_Delete_At_Path_Input = {
  cf_data?: InputMaybe<Array<Scalars['String']['input']>>;
  event?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Fo_Reels_Staging_Delete_Elem_Input = {
  cf_data?: InputMaybe<Scalars['Int']['input']>;
  event?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Fo_Reels_Staging_Delete_Key_Input = {
  cf_data?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "fo_reels_staging" */
export type Fo_Reels_Staging_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  pf_manager_id?: InputMaybe<Scalars['Int']['input']>;
  pf_user_id?: InputMaybe<Scalars['Int']['input']>;
  reel_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "fo_reels_staging" */
export type Fo_Reels_Staging_Insert_Input = {
  approved_at?: InputMaybe<Scalars['timestamptz']['input']>;
  approved_by?: InputMaybe<Scalars['bpchar']['input']>;
  approved_reel?: InputMaybe<Reels_Obj_Rel_Insert_Input>;
  cf_data?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_approved?: InputMaybe<Scalars['Boolean']['input']>;
  pf_manager_id?: InputMaybe<Scalars['Int']['input']>;
  pf_user_id?: InputMaybe<Scalars['Int']['input']>;
  reel_id?: InputMaybe<Scalars['bigint']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Fo_Reels_Staging_Max_Fields = {
  __typename?: 'fo_reels_staging_max_fields';
  approved_at?: Maybe<Scalars['timestamptz']['output']>;
  approved_by?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  pf_manager_id?: Maybe<Scalars['Int']['output']>;
  pf_user_id?: Maybe<Scalars['Int']['output']>;
  reel_id?: Maybe<Scalars['bigint']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** aggregate min on columns */
export type Fo_Reels_Staging_Min_Fields = {
  __typename?: 'fo_reels_staging_min_fields';
  approved_at?: Maybe<Scalars['timestamptz']['output']>;
  approved_by?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  pf_manager_id?: Maybe<Scalars['Int']['output']>;
  pf_user_id?: Maybe<Scalars['Int']['output']>;
  reel_id?: Maybe<Scalars['bigint']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** response of any mutation on the table "fo_reels_staging" */
export type Fo_Reels_Staging_Mutation_Response = {
  __typename?: 'fo_reels_staging_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Fo_Reels_Staging>;
};

/** on_conflict condition type for table "fo_reels_staging" */
export type Fo_Reels_Staging_On_Conflict = {
  constraint: Fo_Reels_Staging_Constraint;
  update_columns?: Array<Fo_Reels_Staging_Update_Column>;
  where?: InputMaybe<Fo_Reels_Staging_Bool_Exp>;
};

/** Ordering options when selecting data from "fo_reels_staging". */
export type Fo_Reels_Staging_Order_By = {
  approved_at?: InputMaybe<Order_By>;
  approved_by?: InputMaybe<Order_By>;
  approved_reel?: InputMaybe<Reels_Order_By>;
  cf_data?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  event?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_approved?: InputMaybe<Order_By>;
  pf_manager_id?: InputMaybe<Order_By>;
  pf_user_id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: fo_reels_staging */
export type Fo_Reels_Staging_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Fo_Reels_Staging_Prepend_Input = {
  cf_data?: InputMaybe<Scalars['jsonb']['input']>;
  event?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "fo_reels_staging" */
export enum Fo_Reels_Staging_Select_Column {
  /** column name */
  ApprovedAt = 'approved_at',
  /** column name */
  ApprovedBy = 'approved_by',
  /** column name */
  CfData = 'cf_data',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Event = 'event',
  /** column name */
  Id = 'id',
  /** column name */
  IsApproved = 'is_approved',
  /** column name */
  PfManagerId = 'pf_manager_id',
  /** column name */
  PfUserId = 'pf_user_id',
  /** column name */
  ReelId = 'reel_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "fo_reels_staging" */
export type Fo_Reels_Staging_Set_Input = {
  approved_at?: InputMaybe<Scalars['timestamptz']['input']>;
  approved_by?: InputMaybe<Scalars['bpchar']['input']>;
  cf_data?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_approved?: InputMaybe<Scalars['Boolean']['input']>;
  pf_manager_id?: InputMaybe<Scalars['Int']['input']>;
  pf_user_id?: InputMaybe<Scalars['Int']['input']>;
  reel_id?: InputMaybe<Scalars['bigint']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate stddev on columns */
export type Fo_Reels_Staging_Stddev_Fields = {
  __typename?: 'fo_reels_staging_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  pf_manager_id?: Maybe<Scalars['Float']['output']>;
  pf_user_id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Fo_Reels_Staging_Stddev_Pop_Fields = {
  __typename?: 'fo_reels_staging_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  pf_manager_id?: Maybe<Scalars['Float']['output']>;
  pf_user_id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Fo_Reels_Staging_Stddev_Samp_Fields = {
  __typename?: 'fo_reels_staging_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  pf_manager_id?: Maybe<Scalars['Float']['output']>;
  pf_user_id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "fo_reels_staging" */
export type Fo_Reels_Staging_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fo_Reels_Staging_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fo_Reels_Staging_Stream_Cursor_Value_Input = {
  approved_at?: InputMaybe<Scalars['timestamptz']['input']>;
  approved_by?: InputMaybe<Scalars['bpchar']['input']>;
  cf_data?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_approved?: InputMaybe<Scalars['Boolean']['input']>;
  pf_manager_id?: InputMaybe<Scalars['Int']['input']>;
  pf_user_id?: InputMaybe<Scalars['Int']['input']>;
  reel_id?: InputMaybe<Scalars['bigint']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate sum on columns */
export type Fo_Reels_Staging_Sum_Fields = {
  __typename?: 'fo_reels_staging_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  pf_manager_id?: Maybe<Scalars['Int']['output']>;
  pf_user_id?: Maybe<Scalars['Int']['output']>;
  reel_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "fo_reels_staging" */
export enum Fo_Reels_Staging_Update_Column {
  /** column name */
  ApprovedAt = 'approved_at',
  /** column name */
  ApprovedBy = 'approved_by',
  /** column name */
  CfData = 'cf_data',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Event = 'event',
  /** column name */
  Id = 'id',
  /** column name */
  IsApproved = 'is_approved',
  /** column name */
  PfManagerId = 'pf_manager_id',
  /** column name */
  PfUserId = 'pf_user_id',
  /** column name */
  ReelId = 'reel_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Fo_Reels_Staging_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Fo_Reels_Staging_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Fo_Reels_Staging_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Fo_Reels_Staging_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Fo_Reels_Staging_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Fo_Reels_Staging_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Fo_Reels_Staging_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fo_Reels_Staging_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fo_Reels_Staging_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Fo_Reels_Staging_Var_Pop_Fields = {
  __typename?: 'fo_reels_staging_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  pf_manager_id?: Maybe<Scalars['Float']['output']>;
  pf_user_id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Fo_Reels_Staging_Var_Samp_Fields = {
  __typename?: 'fo_reels_staging_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  pf_manager_id?: Maybe<Scalars['Float']['output']>;
  pf_user_id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Fo_Reels_Staging_Variance_Fields = {
  __typename?: 'fo_reels_staging_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  pf_manager_id?: Maybe<Scalars['Float']['output']>;
  pf_user_id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "follows" */
export type Follows = {
  __typename?: 'follows';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  from_user_id: Scalars['bpchar']['output'];
  id: Scalars['bigint']['output'];
  to_user_id: Scalars['bpchar']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "follows" */
export type Follows_Aggregate = {
  __typename?: 'follows_aggregate';
  aggregate?: Maybe<Follows_Aggregate_Fields>;
  nodes: Array<Follows>;
};

export type Follows_Aggregate_Bool_Exp = {
  count?: InputMaybe<Follows_Aggregate_Bool_Exp_Count>;
};

export type Follows_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Follows_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Follows_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "follows" */
export type Follows_Aggregate_Fields = {
  __typename?: 'follows_aggregate_fields';
  avg?: Maybe<Follows_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Follows_Max_Fields>;
  min?: Maybe<Follows_Min_Fields>;
  stddev?: Maybe<Follows_Stddev_Fields>;
  stddev_pop?: Maybe<Follows_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Follows_Stddev_Samp_Fields>;
  sum?: Maybe<Follows_Sum_Fields>;
  var_pop?: Maybe<Follows_Var_Pop_Fields>;
  var_samp?: Maybe<Follows_Var_Samp_Fields>;
  variance?: Maybe<Follows_Variance_Fields>;
};


/** aggregate fields of "follows" */
export type Follows_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Follows_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "follows" */
export type Follows_Aggregate_Order_By = {
  avg?: InputMaybe<Follows_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Follows_Max_Order_By>;
  min?: InputMaybe<Follows_Min_Order_By>;
  stddev?: InputMaybe<Follows_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Follows_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Follows_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Follows_Sum_Order_By>;
  var_pop?: InputMaybe<Follows_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Follows_Var_Samp_Order_By>;
  variance?: InputMaybe<Follows_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "follows" */
export type Follows_Arr_Rel_Insert_Input = {
  data: Array<Follows_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Follows_On_Conflict>;
};

/** aggregate avg on columns */
export type Follows_Avg_Fields = {
  __typename?: 'follows_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "follows" */
export type Follows_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "follows". All fields are combined with a logical 'AND'. */
export type Follows_Bool_Exp = {
  _and?: InputMaybe<Array<Follows_Bool_Exp>>;
  _not?: InputMaybe<Follows_Bool_Exp>;
  _or?: InputMaybe<Array<Follows_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  from_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  to_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "follows" */
export enum Follows_Constraint {
  /** unique or primary key constraint on columns "from_user_id", "to_user_id" */
  FollowsFromUserIdToUserIdUnique = 'follows_from_user_id_to_user_id_unique',
  /** unique or primary key constraint on columns "id" */
  FollowsPkey = 'follows_pkey'
}

/** input type for incrementing numeric columns in table "follows" */
export type Follows_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "follows" */
export type Follows_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  from_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  to_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Follows_Max_Fields = {
  __typename?: 'follows_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  from_user_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  to_user_id?: Maybe<Scalars['bpchar']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "follows" */
export type Follows_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  from_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to_user_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Follows_Min_Fields = {
  __typename?: 'follows_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  from_user_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  to_user_id?: Maybe<Scalars['bpchar']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "follows" */
export type Follows_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  from_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to_user_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "follows" */
export type Follows_Mutation_Response = {
  __typename?: 'follows_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Follows>;
};

/** on_conflict condition type for table "follows" */
export type Follows_On_Conflict = {
  constraint: Follows_Constraint;
  update_columns?: Array<Follows_Update_Column>;
  where?: InputMaybe<Follows_Bool_Exp>;
};

/** Ordering options when selecting data from "follows". */
export type Follows_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  from_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to_user_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: follows */
export type Follows_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "follows" */
export enum Follows_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FromUserId = 'from_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  ToUserId = 'to_user_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "follows" */
export type Follows_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  from_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  to_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Follows_Stddev_Fields = {
  __typename?: 'follows_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "follows" */
export type Follows_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Follows_Stddev_Pop_Fields = {
  __typename?: 'follows_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "follows" */
export type Follows_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Follows_Stddev_Samp_Fields = {
  __typename?: 'follows_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "follows" */
export type Follows_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "follows" */
export type Follows_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Follows_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Follows_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  from_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  to_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Follows_Sum_Fields = {
  __typename?: 'follows_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "follows" */
export type Follows_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "follows" */
export enum Follows_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FromUserId = 'from_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  ToUserId = 'to_user_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Follows_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Follows_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Follows_Set_Input>;
  /** filter the rows which have to be updated */
  where: Follows_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Follows_Var_Pop_Fields = {
  __typename?: 'follows_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "follows" */
export type Follows_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Follows_Var_Samp_Fields = {
  __typename?: 'follows_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "follows" */
export type Follows_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Follows_Variance_Fields = {
  __typename?: 'follows_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "follows" */
export type Follows_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

export type Geography_Cast_Exp = {
  geometry?: InputMaybe<Geometry_Comparison_Exp>;
};

/** columns and relationships of "geography_columns" */
export type Geography_Columns = {
  __typename?: 'geography_columns';
  coord_dimension?: Maybe<Scalars['Int']['output']>;
  f_geography_column?: Maybe<Scalars['name']['output']>;
  f_table_catalog?: Maybe<Scalars['name']['output']>;
  f_table_name?: Maybe<Scalars['name']['output']>;
  f_table_schema?: Maybe<Scalars['name']['output']>;
  srid?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "geography_columns" */
export type Geography_Columns_Aggregate = {
  __typename?: 'geography_columns_aggregate';
  aggregate?: Maybe<Geography_Columns_Aggregate_Fields>;
  nodes: Array<Geography_Columns>;
};

/** aggregate fields of "geography_columns" */
export type Geography_Columns_Aggregate_Fields = {
  __typename?: 'geography_columns_aggregate_fields';
  avg?: Maybe<Geography_Columns_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Geography_Columns_Max_Fields>;
  min?: Maybe<Geography_Columns_Min_Fields>;
  stddev?: Maybe<Geography_Columns_Stddev_Fields>;
  stddev_pop?: Maybe<Geography_Columns_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Geography_Columns_Stddev_Samp_Fields>;
  sum?: Maybe<Geography_Columns_Sum_Fields>;
  var_pop?: Maybe<Geography_Columns_Var_Pop_Fields>;
  var_samp?: Maybe<Geography_Columns_Var_Samp_Fields>;
  variance?: Maybe<Geography_Columns_Variance_Fields>;
};


/** aggregate fields of "geography_columns" */
export type Geography_Columns_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Geography_Columns_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Geography_Columns_Avg_Fields = {
  __typename?: 'geography_columns_avg_fields';
  coord_dimension?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "geography_columns". All fields are combined with a logical 'AND'. */
export type Geography_Columns_Bool_Exp = {
  _and?: InputMaybe<Array<Geography_Columns_Bool_Exp>>;
  _not?: InputMaybe<Geography_Columns_Bool_Exp>;
  _or?: InputMaybe<Array<Geography_Columns_Bool_Exp>>;
  coord_dimension?: InputMaybe<Int_Comparison_Exp>;
  f_geography_column?: InputMaybe<Name_Comparison_Exp>;
  f_table_catalog?: InputMaybe<Name_Comparison_Exp>;
  f_table_name?: InputMaybe<Name_Comparison_Exp>;
  f_table_schema?: InputMaybe<Name_Comparison_Exp>;
  srid?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Geography_Columns_Max_Fields = {
  __typename?: 'geography_columns_max_fields';
  coord_dimension?: Maybe<Scalars['Int']['output']>;
  srid?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Geography_Columns_Min_Fields = {
  __typename?: 'geography_columns_min_fields';
  coord_dimension?: Maybe<Scalars['Int']['output']>;
  srid?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "geography_columns". */
export type Geography_Columns_Order_By = {
  coord_dimension?: InputMaybe<Order_By>;
  f_geography_column?: InputMaybe<Order_By>;
  f_table_catalog?: InputMaybe<Order_By>;
  f_table_name?: InputMaybe<Order_By>;
  f_table_schema?: InputMaybe<Order_By>;
  srid?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "geography_columns" */
export enum Geography_Columns_Select_Column {
  /** column name */
  CoordDimension = 'coord_dimension',
  /** column name */
  FGeographyColumn = 'f_geography_column',
  /** column name */
  FTableCatalog = 'f_table_catalog',
  /** column name */
  FTableName = 'f_table_name',
  /** column name */
  FTableSchema = 'f_table_schema',
  /** column name */
  Srid = 'srid',
  /** column name */
  Type = 'type'
}

/** aggregate stddev on columns */
export type Geography_Columns_Stddev_Fields = {
  __typename?: 'geography_columns_stddev_fields';
  coord_dimension?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Geography_Columns_Stddev_Pop_Fields = {
  __typename?: 'geography_columns_stddev_pop_fields';
  coord_dimension?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Geography_Columns_Stddev_Samp_Fields = {
  __typename?: 'geography_columns_stddev_samp_fields';
  coord_dimension?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "geography_columns" */
export type Geography_Columns_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Geography_Columns_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Geography_Columns_Stream_Cursor_Value_Input = {
  coord_dimension?: InputMaybe<Scalars['Int']['input']>;
  f_geography_column?: InputMaybe<Scalars['name']['input']>;
  f_table_catalog?: InputMaybe<Scalars['name']['input']>;
  f_table_name?: InputMaybe<Scalars['name']['input']>;
  f_table_schema?: InputMaybe<Scalars['name']['input']>;
  srid?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Geography_Columns_Sum_Fields = {
  __typename?: 'geography_columns_sum_fields';
  coord_dimension?: Maybe<Scalars['Int']['output']>;
  srid?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Geography_Columns_Var_Pop_Fields = {
  __typename?: 'geography_columns_var_pop_fields';
  coord_dimension?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Geography_Columns_Var_Samp_Fields = {
  __typename?: 'geography_columns_var_samp_fields';
  coord_dimension?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Geography_Columns_Variance_Fields = {
  __typename?: 'geography_columns_variance_fields';
  coord_dimension?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "geography". All fields are combined with logical 'AND'. */
export type Geography_Comparison_Exp = {
  _cast?: InputMaybe<Geography_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geography']['input']>;
  _gt?: InputMaybe<Scalars['geography']['input']>;
  _gte?: InputMaybe<Scalars['geography']['input']>;
  _in?: InputMaybe<Array<Scalars['geography']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['geography']['input']>;
  _lte?: InputMaybe<Scalars['geography']['input']>;
  _neq?: InputMaybe<Scalars['geography']['input']>;
  _nin?: InputMaybe<Array<Scalars['geography']['input']>>;
  /** is the column within a given distance from the given geography value */
  _st_d_within?: InputMaybe<St_D_Within_Geography_Input>;
  /** does the column spatially intersect the given geography value */
  _st_intersects?: InputMaybe<Scalars['geography']['input']>;
};

export type Geometry_Cast_Exp = {
  geography?: InputMaybe<Geography_Comparison_Exp>;
};

/** columns and relationships of "geometry_columns" */
export type Geometry_Columns = {
  __typename?: 'geometry_columns';
  coord_dimension?: Maybe<Scalars['Int']['output']>;
  f_geometry_column?: Maybe<Scalars['name']['output']>;
  f_table_catalog?: Maybe<Scalars['String']['output']>;
  f_table_name?: Maybe<Scalars['name']['output']>;
  f_table_schema?: Maybe<Scalars['name']['output']>;
  srid?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "geometry_columns" */
export type Geometry_Columns_Aggregate = {
  __typename?: 'geometry_columns_aggregate';
  aggregate?: Maybe<Geometry_Columns_Aggregate_Fields>;
  nodes: Array<Geometry_Columns>;
};

/** aggregate fields of "geometry_columns" */
export type Geometry_Columns_Aggregate_Fields = {
  __typename?: 'geometry_columns_aggregate_fields';
  avg?: Maybe<Geometry_Columns_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Geometry_Columns_Max_Fields>;
  min?: Maybe<Geometry_Columns_Min_Fields>;
  stddev?: Maybe<Geometry_Columns_Stddev_Fields>;
  stddev_pop?: Maybe<Geometry_Columns_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Geometry_Columns_Stddev_Samp_Fields>;
  sum?: Maybe<Geometry_Columns_Sum_Fields>;
  var_pop?: Maybe<Geometry_Columns_Var_Pop_Fields>;
  var_samp?: Maybe<Geometry_Columns_Var_Samp_Fields>;
  variance?: Maybe<Geometry_Columns_Variance_Fields>;
};


/** aggregate fields of "geometry_columns" */
export type Geometry_Columns_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Geometry_Columns_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Geometry_Columns_Avg_Fields = {
  __typename?: 'geometry_columns_avg_fields';
  coord_dimension?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "geometry_columns". All fields are combined with a logical 'AND'. */
export type Geometry_Columns_Bool_Exp = {
  _and?: InputMaybe<Array<Geometry_Columns_Bool_Exp>>;
  _not?: InputMaybe<Geometry_Columns_Bool_Exp>;
  _or?: InputMaybe<Array<Geometry_Columns_Bool_Exp>>;
  coord_dimension?: InputMaybe<Int_Comparison_Exp>;
  f_geometry_column?: InputMaybe<Name_Comparison_Exp>;
  f_table_catalog?: InputMaybe<String_Comparison_Exp>;
  f_table_name?: InputMaybe<Name_Comparison_Exp>;
  f_table_schema?: InputMaybe<Name_Comparison_Exp>;
  srid?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "geometry_columns" */
export type Geometry_Columns_Inc_Input = {
  coord_dimension?: InputMaybe<Scalars['Int']['input']>;
  srid?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "geometry_columns" */
export type Geometry_Columns_Insert_Input = {
  coord_dimension?: InputMaybe<Scalars['Int']['input']>;
  f_geometry_column?: InputMaybe<Scalars['name']['input']>;
  f_table_catalog?: InputMaybe<Scalars['String']['input']>;
  f_table_name?: InputMaybe<Scalars['name']['input']>;
  f_table_schema?: InputMaybe<Scalars['name']['input']>;
  srid?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Geometry_Columns_Max_Fields = {
  __typename?: 'geometry_columns_max_fields';
  coord_dimension?: Maybe<Scalars['Int']['output']>;
  f_table_catalog?: Maybe<Scalars['String']['output']>;
  srid?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Geometry_Columns_Min_Fields = {
  __typename?: 'geometry_columns_min_fields';
  coord_dimension?: Maybe<Scalars['Int']['output']>;
  f_table_catalog?: Maybe<Scalars['String']['output']>;
  srid?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "geometry_columns" */
export type Geometry_Columns_Mutation_Response = {
  __typename?: 'geometry_columns_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Geometry_Columns>;
};

/** Ordering options when selecting data from "geometry_columns". */
export type Geometry_Columns_Order_By = {
  coord_dimension?: InputMaybe<Order_By>;
  f_geometry_column?: InputMaybe<Order_By>;
  f_table_catalog?: InputMaybe<Order_By>;
  f_table_name?: InputMaybe<Order_By>;
  f_table_schema?: InputMaybe<Order_By>;
  srid?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "geometry_columns" */
export enum Geometry_Columns_Select_Column {
  /** column name */
  CoordDimension = 'coord_dimension',
  /** column name */
  FGeometryColumn = 'f_geometry_column',
  /** column name */
  FTableCatalog = 'f_table_catalog',
  /** column name */
  FTableName = 'f_table_name',
  /** column name */
  FTableSchema = 'f_table_schema',
  /** column name */
  Srid = 'srid',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "geometry_columns" */
export type Geometry_Columns_Set_Input = {
  coord_dimension?: InputMaybe<Scalars['Int']['input']>;
  f_geometry_column?: InputMaybe<Scalars['name']['input']>;
  f_table_catalog?: InputMaybe<Scalars['String']['input']>;
  f_table_name?: InputMaybe<Scalars['name']['input']>;
  f_table_schema?: InputMaybe<Scalars['name']['input']>;
  srid?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Geometry_Columns_Stddev_Fields = {
  __typename?: 'geometry_columns_stddev_fields';
  coord_dimension?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Geometry_Columns_Stddev_Pop_Fields = {
  __typename?: 'geometry_columns_stddev_pop_fields';
  coord_dimension?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Geometry_Columns_Stddev_Samp_Fields = {
  __typename?: 'geometry_columns_stddev_samp_fields';
  coord_dimension?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "geometry_columns" */
export type Geometry_Columns_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Geometry_Columns_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Geometry_Columns_Stream_Cursor_Value_Input = {
  coord_dimension?: InputMaybe<Scalars['Int']['input']>;
  f_geometry_column?: InputMaybe<Scalars['name']['input']>;
  f_table_catalog?: InputMaybe<Scalars['String']['input']>;
  f_table_name?: InputMaybe<Scalars['name']['input']>;
  f_table_schema?: InputMaybe<Scalars['name']['input']>;
  srid?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Geometry_Columns_Sum_Fields = {
  __typename?: 'geometry_columns_sum_fields';
  coord_dimension?: Maybe<Scalars['Int']['output']>;
  srid?: Maybe<Scalars['Int']['output']>;
};

export type Geometry_Columns_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Geometry_Columns_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Geometry_Columns_Set_Input>;
  /** filter the rows which have to be updated */
  where: Geometry_Columns_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Geometry_Columns_Var_Pop_Fields = {
  __typename?: 'geometry_columns_var_pop_fields';
  coord_dimension?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Geometry_Columns_Var_Samp_Fields = {
  __typename?: 'geometry_columns_var_samp_fields';
  coord_dimension?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Geometry_Columns_Variance_Fields = {
  __typename?: 'geometry_columns_variance_fields';
  coord_dimension?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "geometry". All fields are combined with logical 'AND'. */
export type Geometry_Comparison_Exp = {
  _cast?: InputMaybe<Geometry_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geometry']['input']>;
  _gt?: InputMaybe<Scalars['geometry']['input']>;
  _gte?: InputMaybe<Scalars['geometry']['input']>;
  _in?: InputMaybe<Array<Scalars['geometry']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['geometry']['input']>;
  _lte?: InputMaybe<Scalars['geometry']['input']>;
  _neq?: InputMaybe<Scalars['geometry']['input']>;
  _nin?: InputMaybe<Array<Scalars['geometry']['input']>>;
  /** is the column within a given 3D distance from the given geometry value */
  _st_3d_d_within?: InputMaybe<St_D_Within_Input>;
  /** does the column spatially intersect the given geometry value in 3D */
  _st_3d_intersects?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column contain the given geometry value */
  _st_contains?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column cross the given geometry value */
  _st_crosses?: InputMaybe<Scalars['geometry']['input']>;
  /** is the column within a given distance from the given geometry value */
  _st_d_within?: InputMaybe<St_D_Within_Input>;
  /** is the column equal to given geometry value (directionality is ignored) */
  _st_equals?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column spatially intersect the given geometry value */
  _st_intersects?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column 'spatially overlap' (intersect but not completely contain) the given geometry value */
  _st_overlaps?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column have atleast one point in common with the given geometry value */
  _st_touches?: InputMaybe<Scalars['geometry']['input']>;
  /** is the column contained in the given geometry value */
  _st_within?: InputMaybe<Scalars['geometry']['input']>;
};

export type Get_Reel_With_Related_Args = {
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  max_distance?: InputMaybe<Scalars['Int']['input']>;
  reelid?: InputMaybe<Scalars['Int']['input']>;
};

export type Get_Reels_Args = {
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  max_distance?: InputMaybe<Scalars['Int']['input']>;
};

/** columns and relationships of "gig_faqs" */
export type Gig_Faqs = {
  __typename?: 'gig_faqs';
  account_id: Scalars['bpchar']['output'];
  answer: Scalars['String']['output'];
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  gig_id: Scalars['bpchar']['output'];
  gig_variant_id: Scalars['bpchar']['output'];
  id: Scalars['bpchar']['output'];
  question: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id: Scalars['bpchar']['output'];
};

/** aggregated selection of "gig_faqs" */
export type Gig_Faqs_Aggregate = {
  __typename?: 'gig_faqs_aggregate';
  aggregate?: Maybe<Gig_Faqs_Aggregate_Fields>;
  nodes: Array<Gig_Faqs>;
};

export type Gig_Faqs_Aggregate_Bool_Exp = {
  count?: InputMaybe<Gig_Faqs_Aggregate_Bool_Exp_Count>;
};

export type Gig_Faqs_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Gig_Faqs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Gig_Faqs_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "gig_faqs" */
export type Gig_Faqs_Aggregate_Fields = {
  __typename?: 'gig_faqs_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Gig_Faqs_Max_Fields>;
  min?: Maybe<Gig_Faqs_Min_Fields>;
};


/** aggregate fields of "gig_faqs" */
export type Gig_Faqs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Gig_Faqs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "gig_faqs" */
export type Gig_Faqs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Gig_Faqs_Max_Order_By>;
  min?: InputMaybe<Gig_Faqs_Min_Order_By>;
};

/** input type for inserting array relation for remote table "gig_faqs" */
export type Gig_Faqs_Arr_Rel_Insert_Input = {
  data: Array<Gig_Faqs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Gig_Faqs_On_Conflict>;
};

/** Boolean expression to filter rows from the table "gig_faqs". All fields are combined with a logical 'AND'. */
export type Gig_Faqs_Bool_Exp = {
  _and?: InputMaybe<Array<Gig_Faqs_Bool_Exp>>;
  _not?: InputMaybe<Gig_Faqs_Bool_Exp>;
  _or?: InputMaybe<Array<Gig_Faqs_Bool_Exp>>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  answer?: InputMaybe<String_Comparison_Exp>;
  company_id?: InputMaybe<Bpchar_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  gig_id?: InputMaybe<Bpchar_Comparison_Exp>;
  gig_variant_id?: InputMaybe<Bpchar_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  question?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "gig_faqs" */
export enum Gig_Faqs_Constraint {
  /** unique or primary key constraint on columns "id" */
  GigFaqsPkey = 'gig_faqs_pkey'
}

/** input type for inserting data into table "gig_faqs" */
export type Gig_Faqs_Insert_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  answer?: InputMaybe<Scalars['String']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  gig_id?: InputMaybe<Scalars['bpchar']['input']>;
  gig_variant_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Gig_Faqs_Max_Fields = {
  __typename?: 'gig_faqs_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  answer?: Maybe<Scalars['String']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  gig_id?: Maybe<Scalars['bpchar']['output']>;
  gig_variant_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by max() on columns of table "gig_faqs" */
export type Gig_Faqs_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  answer?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  gig_id?: InputMaybe<Order_By>;
  gig_variant_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Gig_Faqs_Min_Fields = {
  __typename?: 'gig_faqs_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  answer?: Maybe<Scalars['String']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  gig_id?: Maybe<Scalars['bpchar']['output']>;
  gig_variant_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by min() on columns of table "gig_faqs" */
export type Gig_Faqs_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  answer?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  gig_id?: InputMaybe<Order_By>;
  gig_variant_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "gig_faqs" */
export type Gig_Faqs_Mutation_Response = {
  __typename?: 'gig_faqs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Gig_Faqs>;
};

/** on_conflict condition type for table "gig_faqs" */
export type Gig_Faqs_On_Conflict = {
  constraint: Gig_Faqs_Constraint;
  update_columns?: Array<Gig_Faqs_Update_Column>;
  where?: InputMaybe<Gig_Faqs_Bool_Exp>;
};

/** Ordering options when selecting data from "gig_faqs". */
export type Gig_Faqs_Order_By = {
  account_id?: InputMaybe<Order_By>;
  answer?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  gig_id?: InputMaybe<Order_By>;
  gig_variant_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: gig_faqs */
export type Gig_Faqs_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** select columns of table "gig_faqs" */
export enum Gig_Faqs_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Answer = 'answer',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  GigId = 'gig_id',
  /** column name */
  GigVariantId = 'gig_variant_id',
  /** column name */
  Id = 'id',
  /** column name */
  Question = 'question',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "gig_faqs" */
export type Gig_Faqs_Set_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  answer?: InputMaybe<Scalars['String']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  gig_id?: InputMaybe<Scalars['bpchar']['input']>;
  gig_variant_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** Streaming cursor of the table "gig_faqs" */
export type Gig_Faqs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gig_Faqs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gig_Faqs_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  answer?: InputMaybe<Scalars['String']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  gig_id?: InputMaybe<Scalars['bpchar']['input']>;
  gig_variant_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** update columns of table "gig_faqs" */
export enum Gig_Faqs_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Answer = 'answer',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  GigId = 'gig_id',
  /** column name */
  GigVariantId = 'gig_variant_id',
  /** column name */
  Id = 'id',
  /** column name */
  Question = 'question',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Gig_Faqs_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Gig_Faqs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Gig_Faqs_Bool_Exp;
};

/** columns and relationships of "gig_promos" */
export type Gig_Promos = {
  __typename?: 'gig_promos';
  account_id: Scalars['bpchar']['output'];
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  gig_id: Scalars['bpchar']['output'];
  id: Scalars['bpchar']['output'];
  media_duration?: Maybe<Scalars['Int']['output']>;
  media_thumbnail?: Maybe<Scalars['String']['output']>;
  media_url: Scalars['String']['output'];
  mime_type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id: Scalars['bpchar']['output'];
};

/** aggregated selection of "gig_promos" */
export type Gig_Promos_Aggregate = {
  __typename?: 'gig_promos_aggregate';
  aggregate?: Maybe<Gig_Promos_Aggregate_Fields>;
  nodes: Array<Gig_Promos>;
};

export type Gig_Promos_Aggregate_Bool_Exp = {
  count?: InputMaybe<Gig_Promos_Aggregate_Bool_Exp_Count>;
};

export type Gig_Promos_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Gig_Promos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Gig_Promos_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "gig_promos" */
export type Gig_Promos_Aggregate_Fields = {
  __typename?: 'gig_promos_aggregate_fields';
  avg?: Maybe<Gig_Promos_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Gig_Promos_Max_Fields>;
  min?: Maybe<Gig_Promos_Min_Fields>;
  stddev?: Maybe<Gig_Promos_Stddev_Fields>;
  stddev_pop?: Maybe<Gig_Promos_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Gig_Promos_Stddev_Samp_Fields>;
  sum?: Maybe<Gig_Promos_Sum_Fields>;
  var_pop?: Maybe<Gig_Promos_Var_Pop_Fields>;
  var_samp?: Maybe<Gig_Promos_Var_Samp_Fields>;
  variance?: Maybe<Gig_Promos_Variance_Fields>;
};


/** aggregate fields of "gig_promos" */
export type Gig_Promos_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Gig_Promos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "gig_promos" */
export type Gig_Promos_Aggregate_Order_By = {
  avg?: InputMaybe<Gig_Promos_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Gig_Promos_Max_Order_By>;
  min?: InputMaybe<Gig_Promos_Min_Order_By>;
  stddev?: InputMaybe<Gig_Promos_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Gig_Promos_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Gig_Promos_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Gig_Promos_Sum_Order_By>;
  var_pop?: InputMaybe<Gig_Promos_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Gig_Promos_Var_Samp_Order_By>;
  variance?: InputMaybe<Gig_Promos_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "gig_promos" */
export type Gig_Promos_Arr_Rel_Insert_Input = {
  data: Array<Gig_Promos_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Gig_Promos_On_Conflict>;
};

/** aggregate avg on columns */
export type Gig_Promos_Avg_Fields = {
  __typename?: 'gig_promos_avg_fields';
  media_duration?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "gig_promos" */
export type Gig_Promos_Avg_Order_By = {
  media_duration?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "gig_promos". All fields are combined with a logical 'AND'. */
export type Gig_Promos_Bool_Exp = {
  _and?: InputMaybe<Array<Gig_Promos_Bool_Exp>>;
  _not?: InputMaybe<Gig_Promos_Bool_Exp>;
  _or?: InputMaybe<Array<Gig_Promos_Bool_Exp>>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  company_id?: InputMaybe<Bpchar_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  gig_id?: InputMaybe<Bpchar_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  media_duration?: InputMaybe<Int_Comparison_Exp>;
  media_thumbnail?: InputMaybe<String_Comparison_Exp>;
  media_url?: InputMaybe<String_Comparison_Exp>;
  mime_type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "gig_promos" */
export enum Gig_Promos_Constraint {
  /** unique or primary key constraint on columns "id" */
  GigPromosPkey = 'gig_promos_pkey'
}

/** input type for incrementing numeric columns in table "gig_promos" */
export type Gig_Promos_Inc_Input = {
  media_duration?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "gig_promos" */
export type Gig_Promos_Insert_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  gig_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  media_duration?: InputMaybe<Scalars['Int']['input']>;
  media_thumbnail?: InputMaybe<Scalars['String']['input']>;
  media_url?: InputMaybe<Scalars['String']['input']>;
  mime_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Gig_Promos_Max_Fields = {
  __typename?: 'gig_promos_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  gig_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  media_duration?: Maybe<Scalars['Int']['output']>;
  media_thumbnail?: Maybe<Scalars['String']['output']>;
  media_url?: Maybe<Scalars['String']['output']>;
  mime_type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by max() on columns of table "gig_promos" */
export type Gig_Promos_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  gig_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_duration?: InputMaybe<Order_By>;
  media_thumbnail?: InputMaybe<Order_By>;
  media_url?: InputMaybe<Order_By>;
  mime_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Gig_Promos_Min_Fields = {
  __typename?: 'gig_promos_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  gig_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  media_duration?: Maybe<Scalars['Int']['output']>;
  media_thumbnail?: Maybe<Scalars['String']['output']>;
  media_url?: Maybe<Scalars['String']['output']>;
  mime_type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by min() on columns of table "gig_promos" */
export type Gig_Promos_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  gig_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_duration?: InputMaybe<Order_By>;
  media_thumbnail?: InputMaybe<Order_By>;
  media_url?: InputMaybe<Order_By>;
  mime_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "gig_promos" */
export type Gig_Promos_Mutation_Response = {
  __typename?: 'gig_promos_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Gig_Promos>;
};

/** on_conflict condition type for table "gig_promos" */
export type Gig_Promos_On_Conflict = {
  constraint: Gig_Promos_Constraint;
  update_columns?: Array<Gig_Promos_Update_Column>;
  where?: InputMaybe<Gig_Promos_Bool_Exp>;
};

/** Ordering options when selecting data from "gig_promos". */
export type Gig_Promos_Order_By = {
  account_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  gig_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_duration?: InputMaybe<Order_By>;
  media_thumbnail?: InputMaybe<Order_By>;
  media_url?: InputMaybe<Order_By>;
  mime_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: gig_promos */
export type Gig_Promos_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** select columns of table "gig_promos" */
export enum Gig_Promos_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  GigId = 'gig_id',
  /** column name */
  Id = 'id',
  /** column name */
  MediaDuration = 'media_duration',
  /** column name */
  MediaThumbnail = 'media_thumbnail',
  /** column name */
  MediaUrl = 'media_url',
  /** column name */
  MimeType = 'mime_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "gig_promos" */
export type Gig_Promos_Set_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  gig_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  media_duration?: InputMaybe<Scalars['Int']['input']>;
  media_thumbnail?: InputMaybe<Scalars['String']['input']>;
  media_url?: InputMaybe<Scalars['String']['input']>;
  mime_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate stddev on columns */
export type Gig_Promos_Stddev_Fields = {
  __typename?: 'gig_promos_stddev_fields';
  media_duration?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "gig_promos" */
export type Gig_Promos_Stddev_Order_By = {
  media_duration?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Gig_Promos_Stddev_Pop_Fields = {
  __typename?: 'gig_promos_stddev_pop_fields';
  media_duration?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "gig_promos" */
export type Gig_Promos_Stddev_Pop_Order_By = {
  media_duration?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Gig_Promos_Stddev_Samp_Fields = {
  __typename?: 'gig_promos_stddev_samp_fields';
  media_duration?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "gig_promos" */
export type Gig_Promos_Stddev_Samp_Order_By = {
  media_duration?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "gig_promos" */
export type Gig_Promos_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gig_Promos_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gig_Promos_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  gig_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  media_duration?: InputMaybe<Scalars['Int']['input']>;
  media_thumbnail?: InputMaybe<Scalars['String']['input']>;
  media_url?: InputMaybe<Scalars['String']['input']>;
  mime_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate sum on columns */
export type Gig_Promos_Sum_Fields = {
  __typename?: 'gig_promos_sum_fields';
  media_duration?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "gig_promos" */
export type Gig_Promos_Sum_Order_By = {
  media_duration?: InputMaybe<Order_By>;
};

/** update columns of table "gig_promos" */
export enum Gig_Promos_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  GigId = 'gig_id',
  /** column name */
  Id = 'id',
  /** column name */
  MediaDuration = 'media_duration',
  /** column name */
  MediaThumbnail = 'media_thumbnail',
  /** column name */
  MediaUrl = 'media_url',
  /** column name */
  MimeType = 'mime_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Gig_Promos_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Gig_Promos_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Gig_Promos_Set_Input>;
  /** filter the rows which have to be updated */
  where: Gig_Promos_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Gig_Promos_Var_Pop_Fields = {
  __typename?: 'gig_promos_var_pop_fields';
  media_duration?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "gig_promos" */
export type Gig_Promos_Var_Pop_Order_By = {
  media_duration?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Gig_Promos_Var_Samp_Fields = {
  __typename?: 'gig_promos_var_samp_fields';
  media_duration?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "gig_promos" */
export type Gig_Promos_Var_Samp_Order_By = {
  media_duration?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Gig_Promos_Variance_Fields = {
  __typename?: 'gig_promos_variance_fields';
  media_duration?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "gig_promos" */
export type Gig_Promos_Variance_Order_By = {
  media_duration?: InputMaybe<Order_By>;
};

/** columns and relationships of "gig_variants" */
export type Gig_Variants = {
  __typename?: 'gig_variants';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  cost: Scalars['float8']['output'];
  cost_chemical_products?: Maybe<Scalars['float8']['output']>;
  cost_seed_products?: Maybe<Scalars['float8']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration_days: Scalars['Int']['output'];
  features?: Maybe<Scalars['jsonb']['output']>;
  gig_id: Scalars['bpchar']['output'];
  id: Scalars['bpchar']['output'];
  qty: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
  variant_type: Scalars['String']['output'];
};


/** columns and relationships of "gig_variants" */
export type Gig_VariantsFeaturesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "gig_variants" */
export type Gig_Variants_Aggregate = {
  __typename?: 'gig_variants_aggregate';
  aggregate?: Maybe<Gig_Variants_Aggregate_Fields>;
  nodes: Array<Gig_Variants>;
};

export type Gig_Variants_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Gig_Variants_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Gig_Variants_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Gig_Variants_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Gig_Variants_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Gig_Variants_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Gig_Variants_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Gig_Variants_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Gig_Variants_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Gig_Variants_Aggregate_Bool_Exp_Var_Samp>;
};

export type Gig_Variants_Aggregate_Bool_Exp_Avg = {
  arguments: Gig_Variants_Select_Column_Gig_Variants_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Gig_Variants_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Gig_Variants_Aggregate_Bool_Exp_Corr = {
  arguments: Gig_Variants_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Gig_Variants_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Gig_Variants_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Gig_Variants_Select_Column_Gig_Variants_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Gig_Variants_Select_Column_Gig_Variants_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Gig_Variants_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Gig_Variants_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Gig_Variants_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Gig_Variants_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Gig_Variants_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Gig_Variants_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Gig_Variants_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Gig_Variants_Select_Column_Gig_Variants_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Gig_Variants_Select_Column_Gig_Variants_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Gig_Variants_Aggregate_Bool_Exp_Max = {
  arguments: Gig_Variants_Select_Column_Gig_Variants_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Gig_Variants_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Gig_Variants_Aggregate_Bool_Exp_Min = {
  arguments: Gig_Variants_Select_Column_Gig_Variants_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Gig_Variants_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Gig_Variants_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Gig_Variants_Select_Column_Gig_Variants_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Gig_Variants_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Gig_Variants_Aggregate_Bool_Exp_Sum = {
  arguments: Gig_Variants_Select_Column_Gig_Variants_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Gig_Variants_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Gig_Variants_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Gig_Variants_Select_Column_Gig_Variants_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Gig_Variants_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "gig_variants" */
export type Gig_Variants_Aggregate_Fields = {
  __typename?: 'gig_variants_aggregate_fields';
  avg?: Maybe<Gig_Variants_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Gig_Variants_Max_Fields>;
  min?: Maybe<Gig_Variants_Min_Fields>;
  stddev?: Maybe<Gig_Variants_Stddev_Fields>;
  stddev_pop?: Maybe<Gig_Variants_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Gig_Variants_Stddev_Samp_Fields>;
  sum?: Maybe<Gig_Variants_Sum_Fields>;
  var_pop?: Maybe<Gig_Variants_Var_Pop_Fields>;
  var_samp?: Maybe<Gig_Variants_Var_Samp_Fields>;
  variance?: Maybe<Gig_Variants_Variance_Fields>;
};


/** aggregate fields of "gig_variants" */
export type Gig_Variants_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Gig_Variants_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "gig_variants" */
export type Gig_Variants_Aggregate_Order_By = {
  avg?: InputMaybe<Gig_Variants_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Gig_Variants_Max_Order_By>;
  min?: InputMaybe<Gig_Variants_Min_Order_By>;
  stddev?: InputMaybe<Gig_Variants_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Gig_Variants_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Gig_Variants_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Gig_Variants_Sum_Order_By>;
  var_pop?: InputMaybe<Gig_Variants_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Gig_Variants_Var_Samp_Order_By>;
  variance?: InputMaybe<Gig_Variants_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Gig_Variants_Append_Input = {
  features?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "gig_variants" */
export type Gig_Variants_Arr_Rel_Insert_Input = {
  data: Array<Gig_Variants_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Gig_Variants_On_Conflict>;
};

/** aggregate avg on columns */
export type Gig_Variants_Avg_Fields = {
  __typename?: 'gig_variants_avg_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  cost_chemical_products?: Maybe<Scalars['Float']['output']>;
  cost_seed_products?: Maybe<Scalars['Float']['output']>;
  duration_days?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "gig_variants" */
export type Gig_Variants_Avg_Order_By = {
  cost?: InputMaybe<Order_By>;
  cost_chemical_products?: InputMaybe<Order_By>;
  cost_seed_products?: InputMaybe<Order_By>;
  duration_days?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "gig_variants". All fields are combined with a logical 'AND'. */
export type Gig_Variants_Bool_Exp = {
  _and?: InputMaybe<Array<Gig_Variants_Bool_Exp>>;
  _not?: InputMaybe<Gig_Variants_Bool_Exp>;
  _or?: InputMaybe<Array<Gig_Variants_Bool_Exp>>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  company_id?: InputMaybe<Bpchar_Comparison_Exp>;
  cost?: InputMaybe<Float8_Comparison_Exp>;
  cost_chemical_products?: InputMaybe<Float8_Comparison_Exp>;
  cost_seed_products?: InputMaybe<Float8_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  duration_days?: InputMaybe<Int_Comparison_Exp>;
  features?: InputMaybe<Jsonb_Comparison_Exp>;
  gig_id?: InputMaybe<Bpchar_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  qty?: InputMaybe<Int_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  variant_type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "gig_variants" */
export enum Gig_Variants_Constraint {
  /** unique or primary key constraint on columns "id" */
  GigVariantsPkey = 'gig_variants_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Gig_Variants_Delete_At_Path_Input = {
  features?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Gig_Variants_Delete_Elem_Input = {
  features?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Gig_Variants_Delete_Key_Input = {
  features?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "gig_variants" */
export type Gig_Variants_Inc_Input = {
  cost?: InputMaybe<Scalars['float8']['input']>;
  cost_chemical_products?: InputMaybe<Scalars['float8']['input']>;
  cost_seed_products?: InputMaybe<Scalars['float8']['input']>;
  duration_days?: InputMaybe<Scalars['Int']['input']>;
  qty?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "gig_variants" */
export type Gig_Variants_Insert_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  cost?: InputMaybe<Scalars['float8']['input']>;
  cost_chemical_products?: InputMaybe<Scalars['float8']['input']>;
  cost_seed_products?: InputMaybe<Scalars['float8']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration_days?: InputMaybe<Scalars['Int']['input']>;
  features?: InputMaybe<Scalars['jsonb']['input']>;
  gig_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  qty?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
  variant_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Gig_Variants_Max_Fields = {
  __typename?: 'gig_variants_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  cost?: Maybe<Scalars['float8']['output']>;
  cost_chemical_products?: Maybe<Scalars['float8']['output']>;
  cost_seed_products?: Maybe<Scalars['float8']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration_days?: Maybe<Scalars['Int']['output']>;
  gig_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
  variant_type?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "gig_variants" */
export type Gig_Variants_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  cost_chemical_products?: InputMaybe<Order_By>;
  cost_seed_products?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  duration_days?: InputMaybe<Order_By>;
  gig_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  variant_type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Gig_Variants_Min_Fields = {
  __typename?: 'gig_variants_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  cost?: Maybe<Scalars['float8']['output']>;
  cost_chemical_products?: Maybe<Scalars['float8']['output']>;
  cost_seed_products?: Maybe<Scalars['float8']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration_days?: Maybe<Scalars['Int']['output']>;
  gig_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
  variant_type?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "gig_variants" */
export type Gig_Variants_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  cost_chemical_products?: InputMaybe<Order_By>;
  cost_seed_products?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  duration_days?: InputMaybe<Order_By>;
  gig_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  variant_type?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "gig_variants" */
export type Gig_Variants_Mutation_Response = {
  __typename?: 'gig_variants_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Gig_Variants>;
};

/** input type for inserting object relation for remote table "gig_variants" */
export type Gig_Variants_Obj_Rel_Insert_Input = {
  data: Gig_Variants_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Gig_Variants_On_Conflict>;
};

/** on_conflict condition type for table "gig_variants" */
export type Gig_Variants_On_Conflict = {
  constraint: Gig_Variants_Constraint;
  update_columns?: Array<Gig_Variants_Update_Column>;
  where?: InputMaybe<Gig_Variants_Bool_Exp>;
};

/** Ordering options when selecting data from "gig_variants". */
export type Gig_Variants_Order_By = {
  account_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  cost_chemical_products?: InputMaybe<Order_By>;
  cost_seed_products?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  duration_days?: InputMaybe<Order_By>;
  features?: InputMaybe<Order_By>;
  gig_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  variant_type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: gig_variants */
export type Gig_Variants_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Gig_Variants_Prepend_Input = {
  features?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "gig_variants" */
export enum Gig_Variants_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Cost = 'cost',
  /** column name */
  CostChemicalProducts = 'cost_chemical_products',
  /** column name */
  CostSeedProducts = 'cost_seed_products',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  DurationDays = 'duration_days',
  /** column name */
  Features = 'features',
  /** column name */
  GigId = 'gig_id',
  /** column name */
  Id = 'id',
  /** column name */
  Qty = 'qty',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VariantType = 'variant_type'
}

/** select "gig_variants_aggregate_bool_exp_avg_arguments_columns" columns of table "gig_variants" */
export enum Gig_Variants_Select_Column_Gig_Variants_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Cost = 'cost',
  /** column name */
  CostChemicalProducts = 'cost_chemical_products',
  /** column name */
  CostSeedProducts = 'cost_seed_products'
}

/** select "gig_variants_aggregate_bool_exp_corr_arguments_columns" columns of table "gig_variants" */
export enum Gig_Variants_Select_Column_Gig_Variants_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Cost = 'cost',
  /** column name */
  CostChemicalProducts = 'cost_chemical_products',
  /** column name */
  CostSeedProducts = 'cost_seed_products'
}

/** select "gig_variants_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "gig_variants" */
export enum Gig_Variants_Select_Column_Gig_Variants_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Cost = 'cost',
  /** column name */
  CostChemicalProducts = 'cost_chemical_products',
  /** column name */
  CostSeedProducts = 'cost_seed_products'
}

/** select "gig_variants_aggregate_bool_exp_max_arguments_columns" columns of table "gig_variants" */
export enum Gig_Variants_Select_Column_Gig_Variants_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Cost = 'cost',
  /** column name */
  CostChemicalProducts = 'cost_chemical_products',
  /** column name */
  CostSeedProducts = 'cost_seed_products'
}

/** select "gig_variants_aggregate_bool_exp_min_arguments_columns" columns of table "gig_variants" */
export enum Gig_Variants_Select_Column_Gig_Variants_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Cost = 'cost',
  /** column name */
  CostChemicalProducts = 'cost_chemical_products',
  /** column name */
  CostSeedProducts = 'cost_seed_products'
}

/** select "gig_variants_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "gig_variants" */
export enum Gig_Variants_Select_Column_Gig_Variants_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Cost = 'cost',
  /** column name */
  CostChemicalProducts = 'cost_chemical_products',
  /** column name */
  CostSeedProducts = 'cost_seed_products'
}

/** select "gig_variants_aggregate_bool_exp_sum_arguments_columns" columns of table "gig_variants" */
export enum Gig_Variants_Select_Column_Gig_Variants_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Cost = 'cost',
  /** column name */
  CostChemicalProducts = 'cost_chemical_products',
  /** column name */
  CostSeedProducts = 'cost_seed_products'
}

/** select "gig_variants_aggregate_bool_exp_var_samp_arguments_columns" columns of table "gig_variants" */
export enum Gig_Variants_Select_Column_Gig_Variants_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Cost = 'cost',
  /** column name */
  CostChemicalProducts = 'cost_chemical_products',
  /** column name */
  CostSeedProducts = 'cost_seed_products'
}

/** input type for updating data in table "gig_variants" */
export type Gig_Variants_Set_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  cost?: InputMaybe<Scalars['float8']['input']>;
  cost_chemical_products?: InputMaybe<Scalars['float8']['input']>;
  cost_seed_products?: InputMaybe<Scalars['float8']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration_days?: InputMaybe<Scalars['Int']['input']>;
  features?: InputMaybe<Scalars['jsonb']['input']>;
  gig_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  qty?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
  variant_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Gig_Variants_Stddev_Fields = {
  __typename?: 'gig_variants_stddev_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  cost_chemical_products?: Maybe<Scalars['Float']['output']>;
  cost_seed_products?: Maybe<Scalars['Float']['output']>;
  duration_days?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "gig_variants" */
export type Gig_Variants_Stddev_Order_By = {
  cost?: InputMaybe<Order_By>;
  cost_chemical_products?: InputMaybe<Order_By>;
  cost_seed_products?: InputMaybe<Order_By>;
  duration_days?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Gig_Variants_Stddev_Pop_Fields = {
  __typename?: 'gig_variants_stddev_pop_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  cost_chemical_products?: Maybe<Scalars['Float']['output']>;
  cost_seed_products?: Maybe<Scalars['Float']['output']>;
  duration_days?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "gig_variants" */
export type Gig_Variants_Stddev_Pop_Order_By = {
  cost?: InputMaybe<Order_By>;
  cost_chemical_products?: InputMaybe<Order_By>;
  cost_seed_products?: InputMaybe<Order_By>;
  duration_days?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Gig_Variants_Stddev_Samp_Fields = {
  __typename?: 'gig_variants_stddev_samp_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  cost_chemical_products?: Maybe<Scalars['Float']['output']>;
  cost_seed_products?: Maybe<Scalars['Float']['output']>;
  duration_days?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "gig_variants" */
export type Gig_Variants_Stddev_Samp_Order_By = {
  cost?: InputMaybe<Order_By>;
  cost_chemical_products?: InputMaybe<Order_By>;
  cost_seed_products?: InputMaybe<Order_By>;
  duration_days?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "gig_variants" */
export type Gig_Variants_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gig_Variants_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gig_Variants_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  cost?: InputMaybe<Scalars['float8']['input']>;
  cost_chemical_products?: InputMaybe<Scalars['float8']['input']>;
  cost_seed_products?: InputMaybe<Scalars['float8']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration_days?: InputMaybe<Scalars['Int']['input']>;
  features?: InputMaybe<Scalars['jsonb']['input']>;
  gig_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  qty?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
  variant_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Gig_Variants_Sum_Fields = {
  __typename?: 'gig_variants_sum_fields';
  cost?: Maybe<Scalars['float8']['output']>;
  cost_chemical_products?: Maybe<Scalars['float8']['output']>;
  cost_seed_products?: Maybe<Scalars['float8']['output']>;
  duration_days?: Maybe<Scalars['Int']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "gig_variants" */
export type Gig_Variants_Sum_Order_By = {
  cost?: InputMaybe<Order_By>;
  cost_chemical_products?: InputMaybe<Order_By>;
  cost_seed_products?: InputMaybe<Order_By>;
  duration_days?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
};

/** update columns of table "gig_variants" */
export enum Gig_Variants_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Cost = 'cost',
  /** column name */
  CostChemicalProducts = 'cost_chemical_products',
  /** column name */
  CostSeedProducts = 'cost_seed_products',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  DurationDays = 'duration_days',
  /** column name */
  Features = 'features',
  /** column name */
  GigId = 'gig_id',
  /** column name */
  Id = 'id',
  /** column name */
  Qty = 'qty',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VariantType = 'variant_type'
}

export type Gig_Variants_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Gig_Variants_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Gig_Variants_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Gig_Variants_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Gig_Variants_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Gig_Variants_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Gig_Variants_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Gig_Variants_Set_Input>;
  /** filter the rows which have to be updated */
  where: Gig_Variants_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Gig_Variants_Var_Pop_Fields = {
  __typename?: 'gig_variants_var_pop_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  cost_chemical_products?: Maybe<Scalars['Float']['output']>;
  cost_seed_products?: Maybe<Scalars['Float']['output']>;
  duration_days?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "gig_variants" */
export type Gig_Variants_Var_Pop_Order_By = {
  cost?: InputMaybe<Order_By>;
  cost_chemical_products?: InputMaybe<Order_By>;
  cost_seed_products?: InputMaybe<Order_By>;
  duration_days?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Gig_Variants_Var_Samp_Fields = {
  __typename?: 'gig_variants_var_samp_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  cost_chemical_products?: Maybe<Scalars['Float']['output']>;
  cost_seed_products?: Maybe<Scalars['Float']['output']>;
  duration_days?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "gig_variants" */
export type Gig_Variants_Var_Samp_Order_By = {
  cost?: InputMaybe<Order_By>;
  cost_chemical_products?: InputMaybe<Order_By>;
  cost_seed_products?: InputMaybe<Order_By>;
  duration_days?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Gig_Variants_Variance_Fields = {
  __typename?: 'gig_variants_variance_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  cost_chemical_products?: Maybe<Scalars['Float']['output']>;
  cost_seed_products?: Maybe<Scalars['Float']['output']>;
  duration_days?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "gig_variants" */
export type Gig_Variants_Variance_Order_By = {
  cost?: InputMaybe<Order_By>;
  cost_chemical_products?: InputMaybe<Order_By>;
  cost_seed_products?: InputMaybe<Order_By>;
  duration_days?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
};

/** columns and relationships of "gigs" */
export type Gigs = {
  __typename?: 'gigs';
  /** An object relationship */
  account: Accounts;
  account_id: Scalars['bpchar']['output'];
  approval_status: Scalars['String']['output'];
  avg_rating?: Maybe<Scalars['float8']['output']>;
  avg_work_order_duration_days: Scalars['float8']['output'];
  /** An object relationship */
  channel?: Maybe<Channels>;
  channel_id?: Maybe<Scalars['bigint']['output']>;
  /** An array relationship */
  channel_links: Array<Channel_Links>;
  /** An aggregate relationship */
  channel_links_aggregate: Channel_Links_Aggregate;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  completed_work_orders: Scalars['Int']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  district?: Maybe<Gis_Districts>;
  district_id?: Maybe<Scalars['Int']['output']>;
  districts?: Maybe<Scalars['jsonb']['output']>;
  experience_since?: Maybe<Scalars['Int']['output']>;
  expertises?: Maybe<Scalars['jsonb']['output']>;
  /** An array relationship */
  faqs: Array<Gig_Faqs>;
  /** An aggregate relationship */
  faqs_aggregate: Gig_Faqs_Aggregate;
  gig_type: Scalars['String']['output'];
  id: Scalars['bpchar']['output'];
  is_verified: Scalars['Boolean']['output'];
  languages?: Maybe<Scalars['jsonb']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  metrics?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  onboarding?: Maybe<Creator_Onboarding>;
  /** An array relationship */
  promos: Array<Gig_Promos>;
  /** An aggregate relationship */
  promos_aggregate: Gig_Promos_Aggregate;
  rating: Scalars['Int']['output'];
  review_count: Scalars['Int']['output'];
  segments?: Maybe<Scalars['jsonb']['output']>;
  states?: Maybe<Scalars['jsonb']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  town_name?: Maybe<Scalars['String']['output']>;
  travel_range?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['bpchar']['output'];
  /** An array relationship */
  variants: Array<Gig_Variants>;
  /** An aggregate relationship */
  variants_aggregate: Gig_Variants_Aggregate;
  village_name?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "gigs" */
export type GigsChannel_LinksArgs = {
  distinct_on?: InputMaybe<Array<Channel_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Channel_Links_Order_By>>;
  where?: InputMaybe<Channel_Links_Bool_Exp>;
};


/** columns and relationships of "gigs" */
export type GigsChannel_Links_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Channel_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Channel_Links_Order_By>>;
  where?: InputMaybe<Channel_Links_Bool_Exp>;
};


/** columns and relationships of "gigs" */
export type GigsDistrictsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "gigs" */
export type GigsExpertisesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "gigs" */
export type GigsFaqsArgs = {
  distinct_on?: InputMaybe<Array<Gig_Faqs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gig_Faqs_Order_By>>;
  where?: InputMaybe<Gig_Faqs_Bool_Exp>;
};


/** columns and relationships of "gigs" */
export type GigsFaqs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gig_Faqs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gig_Faqs_Order_By>>;
  where?: InputMaybe<Gig_Faqs_Bool_Exp>;
};


/** columns and relationships of "gigs" */
export type GigsLanguagesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "gigs" */
export type GigsMetricsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "gigs" */
export type GigsPromosArgs = {
  distinct_on?: InputMaybe<Array<Gig_Promos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gig_Promos_Order_By>>;
  where?: InputMaybe<Gig_Promos_Bool_Exp>;
};


/** columns and relationships of "gigs" */
export type GigsPromos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gig_Promos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gig_Promos_Order_By>>;
  where?: InputMaybe<Gig_Promos_Bool_Exp>;
};


/** columns and relationships of "gigs" */
export type GigsSegmentsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "gigs" */
export type GigsStatesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "gigs" */
export type GigsVariantsArgs = {
  distinct_on?: InputMaybe<Array<Gig_Variants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gig_Variants_Order_By>>;
  where?: InputMaybe<Gig_Variants_Bool_Exp>;
};


/** columns and relationships of "gigs" */
export type GigsVariants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gig_Variants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gig_Variants_Order_By>>;
  where?: InputMaybe<Gig_Variants_Bool_Exp>;
};

/** aggregated selection of "gigs" */
export type Gigs_Aggregate = {
  __typename?: 'gigs_aggregate';
  aggregate?: Maybe<Gigs_Aggregate_Fields>;
  nodes: Array<Gigs>;
};

/** aggregate fields of "gigs" */
export type Gigs_Aggregate_Fields = {
  __typename?: 'gigs_aggregate_fields';
  avg?: Maybe<Gigs_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Gigs_Max_Fields>;
  min?: Maybe<Gigs_Min_Fields>;
  stddev?: Maybe<Gigs_Stddev_Fields>;
  stddev_pop?: Maybe<Gigs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Gigs_Stddev_Samp_Fields>;
  sum?: Maybe<Gigs_Sum_Fields>;
  var_pop?: Maybe<Gigs_Var_Pop_Fields>;
  var_samp?: Maybe<Gigs_Var_Samp_Fields>;
  variance?: Maybe<Gigs_Variance_Fields>;
};


/** aggregate fields of "gigs" */
export type Gigs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Gigs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Gigs_Append_Input = {
  districts?: InputMaybe<Scalars['jsonb']['input']>;
  expertises?: InputMaybe<Scalars['jsonb']['input']>;
  languages?: InputMaybe<Scalars['jsonb']['input']>;
  metrics?: InputMaybe<Scalars['jsonb']['input']>;
  segments?: InputMaybe<Scalars['jsonb']['input']>;
  states?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Gigs_Avg_Fields = {
  __typename?: 'gigs_avg_fields';
  avg_rating?: Maybe<Scalars['Float']['output']>;
  avg_work_order_duration_days?: Maybe<Scalars['Float']['output']>;
  channel_id?: Maybe<Scalars['Float']['output']>;
  completed_work_orders?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['Float']['output']>;
  experience_since?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  review_count?: Maybe<Scalars['Float']['output']>;
  travel_range?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "gigs". All fields are combined with a logical 'AND'. */
export type Gigs_Bool_Exp = {
  _and?: InputMaybe<Array<Gigs_Bool_Exp>>;
  _not?: InputMaybe<Gigs_Bool_Exp>;
  _or?: InputMaybe<Array<Gigs_Bool_Exp>>;
  account?: InputMaybe<Accounts_Bool_Exp>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  approval_status?: InputMaybe<String_Comparison_Exp>;
  avg_rating?: InputMaybe<Float8_Comparison_Exp>;
  avg_work_order_duration_days?: InputMaybe<Float8_Comparison_Exp>;
  channel?: InputMaybe<Channels_Bool_Exp>;
  channel_id?: InputMaybe<Bigint_Comparison_Exp>;
  channel_links?: InputMaybe<Channel_Links_Bool_Exp>;
  channel_links_aggregate?: InputMaybe<Channel_Links_Aggregate_Bool_Exp>;
  company_id?: InputMaybe<Bpchar_Comparison_Exp>;
  completed_work_orders?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  district?: InputMaybe<Gis_Districts_Bool_Exp>;
  district_id?: InputMaybe<Int_Comparison_Exp>;
  districts?: InputMaybe<Jsonb_Comparison_Exp>;
  experience_since?: InputMaybe<Int_Comparison_Exp>;
  expertises?: InputMaybe<Jsonb_Comparison_Exp>;
  faqs?: InputMaybe<Gig_Faqs_Bool_Exp>;
  faqs_aggregate?: InputMaybe<Gig_Faqs_Aggregate_Bool_Exp>;
  gig_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  languages?: InputMaybe<Jsonb_Comparison_Exp>;
  location?: InputMaybe<String_Comparison_Exp>;
  metrics?: InputMaybe<Jsonb_Comparison_Exp>;
  onboarding?: InputMaybe<Creator_Onboarding_Bool_Exp>;
  promos?: InputMaybe<Gig_Promos_Bool_Exp>;
  promos_aggregate?: InputMaybe<Gig_Promos_Aggregate_Bool_Exp>;
  rating?: InputMaybe<Int_Comparison_Exp>;
  review_count?: InputMaybe<Int_Comparison_Exp>;
  segments?: InputMaybe<Jsonb_Comparison_Exp>;
  states?: InputMaybe<Jsonb_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  town_name?: InputMaybe<String_Comparison_Exp>;
  travel_range?: InputMaybe<Float8_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  variants?: InputMaybe<Gig_Variants_Bool_Exp>;
  variants_aggregate?: InputMaybe<Gig_Variants_Aggregate_Bool_Exp>;
  village_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "gigs" */
export enum Gigs_Constraint {
  /** unique or primary key constraint on columns "id" */
  GigsPkey = 'gigs_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Gigs_Delete_At_Path_Input = {
  districts?: InputMaybe<Array<Scalars['String']['input']>>;
  expertises?: InputMaybe<Array<Scalars['String']['input']>>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  metrics?: InputMaybe<Array<Scalars['String']['input']>>;
  segments?: InputMaybe<Array<Scalars['String']['input']>>;
  states?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Gigs_Delete_Elem_Input = {
  districts?: InputMaybe<Scalars['Int']['input']>;
  expertises?: InputMaybe<Scalars['Int']['input']>;
  languages?: InputMaybe<Scalars['Int']['input']>;
  metrics?: InputMaybe<Scalars['Int']['input']>;
  segments?: InputMaybe<Scalars['Int']['input']>;
  states?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Gigs_Delete_Key_Input = {
  districts?: InputMaybe<Scalars['String']['input']>;
  expertises?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Scalars['String']['input']>;
  metrics?: InputMaybe<Scalars['String']['input']>;
  segments?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "gigs" */
export type Gigs_Inc_Input = {
  avg_rating?: InputMaybe<Scalars['float8']['input']>;
  avg_work_order_duration_days?: InputMaybe<Scalars['float8']['input']>;
  channel_id?: InputMaybe<Scalars['bigint']['input']>;
  completed_work_orders?: InputMaybe<Scalars['Int']['input']>;
  district_id?: InputMaybe<Scalars['Int']['input']>;
  experience_since?: InputMaybe<Scalars['Int']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  review_count?: InputMaybe<Scalars['Int']['input']>;
  travel_range?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "gigs" */
export type Gigs_Insert_Input = {
  account?: InputMaybe<Accounts_Obj_Rel_Insert_Input>;
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  approval_status?: InputMaybe<Scalars['String']['input']>;
  avg_rating?: InputMaybe<Scalars['float8']['input']>;
  avg_work_order_duration_days?: InputMaybe<Scalars['float8']['input']>;
  channel?: InputMaybe<Channels_Obj_Rel_Insert_Input>;
  channel_id?: InputMaybe<Scalars['bigint']['input']>;
  channel_links?: InputMaybe<Channel_Links_Arr_Rel_Insert_Input>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  completed_work_orders?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Gis_Districts_Obj_Rel_Insert_Input>;
  district_id?: InputMaybe<Scalars['Int']['input']>;
  districts?: InputMaybe<Scalars['jsonb']['input']>;
  experience_since?: InputMaybe<Scalars['Int']['input']>;
  expertises?: InputMaybe<Scalars['jsonb']['input']>;
  faqs?: InputMaybe<Gig_Faqs_Arr_Rel_Insert_Input>;
  gig_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  is_verified?: InputMaybe<Scalars['Boolean']['input']>;
  languages?: InputMaybe<Scalars['jsonb']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  metrics?: InputMaybe<Scalars['jsonb']['input']>;
  onboarding?: InputMaybe<Creator_Onboarding_Obj_Rel_Insert_Input>;
  promos?: InputMaybe<Gig_Promos_Arr_Rel_Insert_Input>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  review_count?: InputMaybe<Scalars['Int']['input']>;
  segments?: InputMaybe<Scalars['jsonb']['input']>;
  states?: InputMaybe<Scalars['jsonb']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  town_name?: InputMaybe<Scalars['String']['input']>;
  travel_range?: InputMaybe<Scalars['float8']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
  variants?: InputMaybe<Gig_Variants_Arr_Rel_Insert_Input>;
  village_name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Gigs_Max_Fields = {
  __typename?: 'gigs_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  approval_status?: Maybe<Scalars['String']['output']>;
  avg_rating?: Maybe<Scalars['float8']['output']>;
  avg_work_order_duration_days?: Maybe<Scalars['float8']['output']>;
  channel_id?: Maybe<Scalars['bigint']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  completed_work_orders?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  district_id?: Maybe<Scalars['Int']['output']>;
  experience_since?: Maybe<Scalars['Int']['output']>;
  gig_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  review_count?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  town_name?: Maybe<Scalars['String']['output']>;
  travel_range?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
  village_name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Gigs_Min_Fields = {
  __typename?: 'gigs_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  approval_status?: Maybe<Scalars['String']['output']>;
  avg_rating?: Maybe<Scalars['float8']['output']>;
  avg_work_order_duration_days?: Maybe<Scalars['float8']['output']>;
  channel_id?: Maybe<Scalars['bigint']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  completed_work_orders?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  district_id?: Maybe<Scalars['Int']['output']>;
  experience_since?: Maybe<Scalars['Int']['output']>;
  gig_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  review_count?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  town_name?: Maybe<Scalars['String']['output']>;
  travel_range?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
  village_name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "gigs" */
export type Gigs_Mutation_Response = {
  __typename?: 'gigs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Gigs>;
};

/** input type for inserting object relation for remote table "gigs" */
export type Gigs_Obj_Rel_Insert_Input = {
  data: Gigs_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Gigs_On_Conflict>;
};

/** on_conflict condition type for table "gigs" */
export type Gigs_On_Conflict = {
  constraint: Gigs_Constraint;
  update_columns?: Array<Gigs_Update_Column>;
  where?: InputMaybe<Gigs_Bool_Exp>;
};

/** Ordering options when selecting data from "gigs". */
export type Gigs_Order_By = {
  account?: InputMaybe<Accounts_Order_By>;
  account_id?: InputMaybe<Order_By>;
  approval_status?: InputMaybe<Order_By>;
  avg_rating?: InputMaybe<Order_By>;
  avg_work_order_duration_days?: InputMaybe<Order_By>;
  channel?: InputMaybe<Channels_Order_By>;
  channel_id?: InputMaybe<Order_By>;
  channel_links_aggregate?: InputMaybe<Channel_Links_Aggregate_Order_By>;
  company_id?: InputMaybe<Order_By>;
  completed_work_orders?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  district?: InputMaybe<Gis_Districts_Order_By>;
  district_id?: InputMaybe<Order_By>;
  districts?: InputMaybe<Order_By>;
  experience_since?: InputMaybe<Order_By>;
  expertises?: InputMaybe<Order_By>;
  faqs_aggregate?: InputMaybe<Gig_Faqs_Aggregate_Order_By>;
  gig_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  languages?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  metrics?: InputMaybe<Order_By>;
  onboarding?: InputMaybe<Creator_Onboarding_Order_By>;
  promos_aggregate?: InputMaybe<Gig_Promos_Aggregate_Order_By>;
  rating?: InputMaybe<Order_By>;
  review_count?: InputMaybe<Order_By>;
  segments?: InputMaybe<Order_By>;
  states?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  town_name?: InputMaybe<Order_By>;
  travel_range?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  variants_aggregate?: InputMaybe<Gig_Variants_Aggregate_Order_By>;
  village_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: gigs */
export type Gigs_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Gigs_Prepend_Input = {
  districts?: InputMaybe<Scalars['jsonb']['input']>;
  expertises?: InputMaybe<Scalars['jsonb']['input']>;
  languages?: InputMaybe<Scalars['jsonb']['input']>;
  metrics?: InputMaybe<Scalars['jsonb']['input']>;
  segments?: InputMaybe<Scalars['jsonb']['input']>;
  states?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "gigs" */
export enum Gigs_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  ApprovalStatus = 'approval_status',
  /** column name */
  AvgRating = 'avg_rating',
  /** column name */
  AvgWorkOrderDurationDays = 'avg_work_order_duration_days',
  /** column name */
  ChannelId = 'channel_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CompletedWorkOrders = 'completed_work_orders',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  Districts = 'districts',
  /** column name */
  ExperienceSince = 'experience_since',
  /** column name */
  Expertises = 'expertises',
  /** column name */
  GigType = 'gig_type',
  /** column name */
  Id = 'id',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Languages = 'languages',
  /** column name */
  Location = 'location',
  /** column name */
  Metrics = 'metrics',
  /** column name */
  Rating = 'rating',
  /** column name */
  ReviewCount = 'review_count',
  /** column name */
  Segments = 'segments',
  /** column name */
  States = 'states',
  /** column name */
  Title = 'title',
  /** column name */
  TownName = 'town_name',
  /** column name */
  TravelRange = 'travel_range',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VillageName = 'village_name'
}

/** input type for updating data in table "gigs" */
export type Gigs_Set_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  approval_status?: InputMaybe<Scalars['String']['input']>;
  avg_rating?: InputMaybe<Scalars['float8']['input']>;
  avg_work_order_duration_days?: InputMaybe<Scalars['float8']['input']>;
  channel_id?: InputMaybe<Scalars['bigint']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  completed_work_orders?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  district_id?: InputMaybe<Scalars['Int']['input']>;
  districts?: InputMaybe<Scalars['jsonb']['input']>;
  experience_since?: InputMaybe<Scalars['Int']['input']>;
  expertises?: InputMaybe<Scalars['jsonb']['input']>;
  gig_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  is_verified?: InputMaybe<Scalars['Boolean']['input']>;
  languages?: InputMaybe<Scalars['jsonb']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  metrics?: InputMaybe<Scalars['jsonb']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  review_count?: InputMaybe<Scalars['Int']['input']>;
  segments?: InputMaybe<Scalars['jsonb']['input']>;
  states?: InputMaybe<Scalars['jsonb']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  town_name?: InputMaybe<Scalars['String']['input']>;
  travel_range?: InputMaybe<Scalars['float8']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
  village_name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Gigs_Stddev_Fields = {
  __typename?: 'gigs_stddev_fields';
  avg_rating?: Maybe<Scalars['Float']['output']>;
  avg_work_order_duration_days?: Maybe<Scalars['Float']['output']>;
  channel_id?: Maybe<Scalars['Float']['output']>;
  completed_work_orders?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['Float']['output']>;
  experience_since?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  review_count?: Maybe<Scalars['Float']['output']>;
  travel_range?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Gigs_Stddev_Pop_Fields = {
  __typename?: 'gigs_stddev_pop_fields';
  avg_rating?: Maybe<Scalars['Float']['output']>;
  avg_work_order_duration_days?: Maybe<Scalars['Float']['output']>;
  channel_id?: Maybe<Scalars['Float']['output']>;
  completed_work_orders?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['Float']['output']>;
  experience_since?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  review_count?: Maybe<Scalars['Float']['output']>;
  travel_range?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Gigs_Stddev_Samp_Fields = {
  __typename?: 'gigs_stddev_samp_fields';
  avg_rating?: Maybe<Scalars['Float']['output']>;
  avg_work_order_duration_days?: Maybe<Scalars['Float']['output']>;
  channel_id?: Maybe<Scalars['Float']['output']>;
  completed_work_orders?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['Float']['output']>;
  experience_since?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  review_count?: Maybe<Scalars['Float']['output']>;
  travel_range?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "gigs" */
export type Gigs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gigs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gigs_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  approval_status?: InputMaybe<Scalars['String']['input']>;
  avg_rating?: InputMaybe<Scalars['float8']['input']>;
  avg_work_order_duration_days?: InputMaybe<Scalars['float8']['input']>;
  channel_id?: InputMaybe<Scalars['bigint']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  completed_work_orders?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  district_id?: InputMaybe<Scalars['Int']['input']>;
  districts?: InputMaybe<Scalars['jsonb']['input']>;
  experience_since?: InputMaybe<Scalars['Int']['input']>;
  expertises?: InputMaybe<Scalars['jsonb']['input']>;
  gig_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  is_verified?: InputMaybe<Scalars['Boolean']['input']>;
  languages?: InputMaybe<Scalars['jsonb']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  metrics?: InputMaybe<Scalars['jsonb']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  review_count?: InputMaybe<Scalars['Int']['input']>;
  segments?: InputMaybe<Scalars['jsonb']['input']>;
  states?: InputMaybe<Scalars['jsonb']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  town_name?: InputMaybe<Scalars['String']['input']>;
  travel_range?: InputMaybe<Scalars['float8']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
  village_name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Gigs_Sum_Fields = {
  __typename?: 'gigs_sum_fields';
  avg_rating?: Maybe<Scalars['float8']['output']>;
  avg_work_order_duration_days?: Maybe<Scalars['float8']['output']>;
  channel_id?: Maybe<Scalars['bigint']['output']>;
  completed_work_orders?: Maybe<Scalars['Int']['output']>;
  district_id?: Maybe<Scalars['Int']['output']>;
  experience_since?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  review_count?: Maybe<Scalars['Int']['output']>;
  travel_range?: Maybe<Scalars['float8']['output']>;
};

/** update columns of table "gigs" */
export enum Gigs_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  ApprovalStatus = 'approval_status',
  /** column name */
  AvgRating = 'avg_rating',
  /** column name */
  AvgWorkOrderDurationDays = 'avg_work_order_duration_days',
  /** column name */
  ChannelId = 'channel_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CompletedWorkOrders = 'completed_work_orders',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  Districts = 'districts',
  /** column name */
  ExperienceSince = 'experience_since',
  /** column name */
  Expertises = 'expertises',
  /** column name */
  GigType = 'gig_type',
  /** column name */
  Id = 'id',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Languages = 'languages',
  /** column name */
  Location = 'location',
  /** column name */
  Metrics = 'metrics',
  /** column name */
  Rating = 'rating',
  /** column name */
  ReviewCount = 'review_count',
  /** column name */
  Segments = 'segments',
  /** column name */
  States = 'states',
  /** column name */
  Title = 'title',
  /** column name */
  TownName = 'town_name',
  /** column name */
  TravelRange = 'travel_range',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VillageName = 'village_name'
}

export type Gigs_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Gigs_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Gigs_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Gigs_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Gigs_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Gigs_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Gigs_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Gigs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Gigs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Gigs_Var_Pop_Fields = {
  __typename?: 'gigs_var_pop_fields';
  avg_rating?: Maybe<Scalars['Float']['output']>;
  avg_work_order_duration_days?: Maybe<Scalars['Float']['output']>;
  channel_id?: Maybe<Scalars['Float']['output']>;
  completed_work_orders?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['Float']['output']>;
  experience_since?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  review_count?: Maybe<Scalars['Float']['output']>;
  travel_range?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Gigs_Var_Samp_Fields = {
  __typename?: 'gigs_var_samp_fields';
  avg_rating?: Maybe<Scalars['Float']['output']>;
  avg_work_order_duration_days?: Maybe<Scalars['Float']['output']>;
  channel_id?: Maybe<Scalars['Float']['output']>;
  completed_work_orders?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['Float']['output']>;
  experience_since?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  review_count?: Maybe<Scalars['Float']['output']>;
  travel_range?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Gigs_Variance_Fields = {
  __typename?: 'gigs_variance_fields';
  avg_rating?: Maybe<Scalars['Float']['output']>;
  avg_work_order_duration_days?: Maybe<Scalars['Float']['output']>;
  channel_id?: Maybe<Scalars['Float']['output']>;
  completed_work_orders?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['Float']['output']>;
  experience_since?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  review_count?: Maybe<Scalars['Float']['output']>;
  travel_range?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "gis.districts" */
export type Gis_Districts = {
  __typename?: 'gis_districts';
  district?: Maybe<Scalars['String']['output']>;
  district_code?: Maybe<Scalars['Int']['output']>;
  id: Scalars['bigint']['output'];
  remarks?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  state_code?: Maybe<Scalars['Int']['output']>;
  wkb_geometry?: Maybe<Scalars['geometry']['output']>;
};

/** aggregated selection of "gis.districts" */
export type Gis_Districts_Aggregate = {
  __typename?: 'gis_districts_aggregate';
  aggregate?: Maybe<Gis_Districts_Aggregate_Fields>;
  nodes: Array<Gis_Districts>;
};

/** aggregate fields of "gis.districts" */
export type Gis_Districts_Aggregate_Fields = {
  __typename?: 'gis_districts_aggregate_fields';
  avg?: Maybe<Gis_Districts_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Gis_Districts_Max_Fields>;
  min?: Maybe<Gis_Districts_Min_Fields>;
  stddev?: Maybe<Gis_Districts_Stddev_Fields>;
  stddev_pop?: Maybe<Gis_Districts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Gis_Districts_Stddev_Samp_Fields>;
  sum?: Maybe<Gis_Districts_Sum_Fields>;
  var_pop?: Maybe<Gis_Districts_Var_Pop_Fields>;
  var_samp?: Maybe<Gis_Districts_Var_Samp_Fields>;
  variance?: Maybe<Gis_Districts_Variance_Fields>;
};


/** aggregate fields of "gis.districts" */
export type Gis_Districts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Gis_Districts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Gis_Districts_Avg_Fields = {
  __typename?: 'gis_districts_avg_fields';
  district_code?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  state_code?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "gis.districts". All fields are combined with a logical 'AND'. */
export type Gis_Districts_Bool_Exp = {
  _and?: InputMaybe<Array<Gis_Districts_Bool_Exp>>;
  _not?: InputMaybe<Gis_Districts_Bool_Exp>;
  _or?: InputMaybe<Array<Gis_Districts_Bool_Exp>>;
  district?: InputMaybe<String_Comparison_Exp>;
  district_code?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  remarks?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  state_code?: InputMaybe<Int_Comparison_Exp>;
  wkb_geometry?: InputMaybe<Geometry_Comparison_Exp>;
};

/** unique or primary key constraints on table "gis.districts" */
export enum Gis_Districts_Constraint {
  /** unique or primary key constraint on columns "id" */
  DistrictsPk = 'districts_pk'
}

/** input type for incrementing numeric columns in table "gis.districts" */
export type Gis_Districts_Inc_Input = {
  district_code?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  state_code?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "gis.districts" */
export type Gis_Districts_Insert_Input = {
  district?: InputMaybe<Scalars['String']['input']>;
  district_code?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_code?: InputMaybe<Scalars['Int']['input']>;
  wkb_geometry?: InputMaybe<Scalars['geometry']['input']>;
};

/** aggregate max on columns */
export type Gis_Districts_Max_Fields = {
  __typename?: 'gis_districts_max_fields';
  district?: Maybe<Scalars['String']['output']>;
  district_code?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  state_code?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Gis_Districts_Min_Fields = {
  __typename?: 'gis_districts_min_fields';
  district?: Maybe<Scalars['String']['output']>;
  district_code?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  state_code?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "gis.districts" */
export type Gis_Districts_Mutation_Response = {
  __typename?: 'gis_districts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Gis_Districts>;
};

/** input type for inserting object relation for remote table "gis.districts" */
export type Gis_Districts_Obj_Rel_Insert_Input = {
  data: Gis_Districts_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Gis_Districts_On_Conflict>;
};

/** on_conflict condition type for table "gis.districts" */
export type Gis_Districts_On_Conflict = {
  constraint: Gis_Districts_Constraint;
  update_columns?: Array<Gis_Districts_Update_Column>;
  where?: InputMaybe<Gis_Districts_Bool_Exp>;
};

/** Ordering options when selecting data from "gis.districts". */
export type Gis_Districts_Order_By = {
  district?: InputMaybe<Order_By>;
  district_code?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  remarks?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  state_code?: InputMaybe<Order_By>;
  wkb_geometry?: InputMaybe<Order_By>;
};

/** primary key columns input for table: gis.districts */
export type Gis_Districts_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "gis.districts" */
export enum Gis_Districts_Select_Column {
  /** column name */
  District = 'district',
  /** column name */
  DistrictCode = 'district_code',
  /** column name */
  Id = 'id',
  /** column name */
  Remarks = 'remarks',
  /** column name */
  State = 'state',
  /** column name */
  StateCode = 'state_code',
  /** column name */
  WkbGeometry = 'wkb_geometry'
}

/** input type for updating data in table "gis.districts" */
export type Gis_Districts_Set_Input = {
  district?: InputMaybe<Scalars['String']['input']>;
  district_code?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_code?: InputMaybe<Scalars['Int']['input']>;
  wkb_geometry?: InputMaybe<Scalars['geometry']['input']>;
};

/** aggregate stddev on columns */
export type Gis_Districts_Stddev_Fields = {
  __typename?: 'gis_districts_stddev_fields';
  district_code?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  state_code?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Gis_Districts_Stddev_Pop_Fields = {
  __typename?: 'gis_districts_stddev_pop_fields';
  district_code?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  state_code?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Gis_Districts_Stddev_Samp_Fields = {
  __typename?: 'gis_districts_stddev_samp_fields';
  district_code?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  state_code?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "gis_districts" */
export type Gis_Districts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gis_Districts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gis_Districts_Stream_Cursor_Value_Input = {
  district?: InputMaybe<Scalars['String']['input']>;
  district_code?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_code?: InputMaybe<Scalars['Int']['input']>;
  wkb_geometry?: InputMaybe<Scalars['geometry']['input']>;
};

/** aggregate sum on columns */
export type Gis_Districts_Sum_Fields = {
  __typename?: 'gis_districts_sum_fields';
  district_code?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  state_code?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "gis.districts" */
export enum Gis_Districts_Update_Column {
  /** column name */
  District = 'district',
  /** column name */
  DistrictCode = 'district_code',
  /** column name */
  Id = 'id',
  /** column name */
  Remarks = 'remarks',
  /** column name */
  State = 'state',
  /** column name */
  StateCode = 'state_code',
  /** column name */
  WkbGeometry = 'wkb_geometry'
}

export type Gis_Districts_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Gis_Districts_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Gis_Districts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Gis_Districts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Gis_Districts_Var_Pop_Fields = {
  __typename?: 'gis_districts_var_pop_fields';
  district_code?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  state_code?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Gis_Districts_Var_Samp_Fields = {
  __typename?: 'gis_districts_var_samp_fields';
  district_code?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  state_code?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Gis_Districts_Variance_Fields = {
  __typename?: 'gis_districts_variance_fields';
  district_code?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  state_code?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "gis.states" */
export type Gis_States = {
  __typename?: 'gis_states';
  id: Scalars['Int']['output'];
  state?: Maybe<Scalars['String']['output']>;
  state_code?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "gis.states" */
export type Gis_States_Aggregate = {
  __typename?: 'gis_states_aggregate';
  aggregate?: Maybe<Gis_States_Aggregate_Fields>;
  nodes: Array<Gis_States>;
};

/** aggregate fields of "gis.states" */
export type Gis_States_Aggregate_Fields = {
  __typename?: 'gis_states_aggregate_fields';
  avg?: Maybe<Gis_States_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Gis_States_Max_Fields>;
  min?: Maybe<Gis_States_Min_Fields>;
  stddev?: Maybe<Gis_States_Stddev_Fields>;
  stddev_pop?: Maybe<Gis_States_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Gis_States_Stddev_Samp_Fields>;
  sum?: Maybe<Gis_States_Sum_Fields>;
  var_pop?: Maybe<Gis_States_Var_Pop_Fields>;
  var_samp?: Maybe<Gis_States_Var_Samp_Fields>;
  variance?: Maybe<Gis_States_Variance_Fields>;
};


/** aggregate fields of "gis.states" */
export type Gis_States_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Gis_States_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Gis_States_Avg_Fields = {
  __typename?: 'gis_states_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  state_code?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "gis.states". All fields are combined with a logical 'AND'. */
export type Gis_States_Bool_Exp = {
  _and?: InputMaybe<Array<Gis_States_Bool_Exp>>;
  _not?: InputMaybe<Gis_States_Bool_Exp>;
  _or?: InputMaybe<Array<Gis_States_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  state_code?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "gis.states" */
export enum Gis_States_Constraint {
  /** unique or primary key constraint on columns "id" */
  StatesPk = 'states_pk'
}

/** input type for incrementing numeric columns in table "gis.states" */
export type Gis_States_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  state_code?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "gis.states" */
export type Gis_States_Insert_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_code?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Gis_States_Max_Fields = {
  __typename?: 'gis_states_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  state_code?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Gis_States_Min_Fields = {
  __typename?: 'gis_states_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  state_code?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "gis.states" */
export type Gis_States_Mutation_Response = {
  __typename?: 'gis_states_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Gis_States>;
};

/** on_conflict condition type for table "gis.states" */
export type Gis_States_On_Conflict = {
  constraint: Gis_States_Constraint;
  update_columns?: Array<Gis_States_Update_Column>;
  where?: InputMaybe<Gis_States_Bool_Exp>;
};

/** Ordering options when selecting data from "gis.states". */
export type Gis_States_Order_By = {
  id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  state_code?: InputMaybe<Order_By>;
};

/** primary key columns input for table: gis.states */
export type Gis_States_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "gis.states" */
export enum Gis_States_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  State = 'state',
  /** column name */
  StateCode = 'state_code'
}

/** input type for updating data in table "gis.states" */
export type Gis_States_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_code?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Gis_States_Stddev_Fields = {
  __typename?: 'gis_states_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  state_code?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Gis_States_Stddev_Pop_Fields = {
  __typename?: 'gis_states_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  state_code?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Gis_States_Stddev_Samp_Fields = {
  __typename?: 'gis_states_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  state_code?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "gis_states" */
export type Gis_States_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gis_States_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gis_States_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_code?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Gis_States_Sum_Fields = {
  __typename?: 'gis_states_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  state_code?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "gis.states" */
export enum Gis_States_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  State = 'state',
  /** column name */
  StateCode = 'state_code'
}

export type Gis_States_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Gis_States_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Gis_States_Set_Input>;
  /** filter the rows which have to be updated */
  where: Gis_States_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Gis_States_Var_Pop_Fields = {
  __typename?: 'gis_states_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  state_code?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Gis_States_Var_Samp_Fields = {
  __typename?: 'gis_states_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  state_code?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Gis_States_Variance_Fields = {
  __typename?: 'gis_states_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  state_code?: Maybe<Scalars['Float']['output']>;
};

export type Hub_Account = {
  __typename?: 'hub_Account';
  accountBilling: Hub_AccountBilling;
  activated_at?: Maybe<Scalars['hub_Date']['output']>;
  company: Hub_Company;
  created_at: Scalars['hub_DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  legacy_id?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  owner: Hub_User;
  owner_user_id: Scalars['Int']['output'];
  registered_address?: Maybe<Scalars['String']['output']>;
  sector?: Maybe<Scalars['String']['output']>;
  segment?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['hub_DateTime']['output'];
};

export type Hub_AccountBilling = {
  __typename?: 'hub_AccountBilling';
  account: Hub_Account;
  account_id: Scalars['Int']['output'];
  created_at: Scalars['hub_DateTime']['output'];
  default_currency?: Maybe<Scalars['String']['output']>;
  default_discount_type?: Maybe<Hub_DiscountType>;
  default_discount_value?: Maybe<Scalars['Float']['output']>;
  gst_treatment?: Maybe<Hub_GstTreatmentType>;
  id: Scalars['Int']['output'];
  invoice_frequency?: Maybe<Hub_InvoiceFrequency>;
  invoice_prefix?: Maybe<Scalars['String']['output']>;
  invoices?: Maybe<Array<Maybe<Hub_Invoice>>>;
  subscribed_user_count?: Maybe<Scalars['Int']['output']>;
  subscriptions?: Maybe<Array<Maybe<Hub_ZohoSubscription>>>;
  tax_id?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['hub_DateTime']['output'];
  zoho_customer_id?: Maybe<Scalars['String']['output']>;
};

export enum Hub_AccountBillingColumn {
  AccountId = 'account_id',
  CreatedAt = 'created_at',
  DefaultCurrency = 'default_currency',
  DefaultDiscountType = 'default_discount_type',
  DefaultDiscountValue = 'default_discount_value',
  GstTreatment = 'gst_treatment',
  InvoiceFrequency = 'invoice_frequency',
  InvoicePrefix = 'invoice_prefix',
  TaxId = 'tax_id',
  UpdatedAt = 'updated_at'
}

/** A paginated list of AccountBilling items. */
export type Hub_AccountBillingPaginator = {
  __typename?: 'hub_AccountBillingPaginator';
  /** A list of AccountBilling items. */
  data: Array<Hub_AccountBilling>;
  /** Pagination information about the list of items. */
  paginatorInfo: Hub_PaginatorInfo;
};

export enum Hub_AccountColumn {
  ActivatedAt = 'activated_at',
  CompanyId = 'company_id',
  CreatedAt = 'created_at',
  Description = 'description',
  Id = 'id',
  Name = 'name',
  RegisteredAddress = 'registered_address',
  Sector = 'sector',
  Segment = 'segment',
  UpdatedAt = 'updated_at'
}

/** A paginated list of Account items. */
export type Hub_AccountPaginator = {
  __typename?: 'hub_AccountPaginator';
  /** A list of Account items. */
  data: Array<Hub_Account>;
  /** Pagination information about the list of items. */
  paginatorInfo: Hub_PaginatorInfo;
};

export type Hub_AccountSubscription = {
  __typename?: 'hub_AccountSubscription';
  account_id: Scalars['Int']['output'];
  company_id: Scalars['Int']['output'];
  created_at: Scalars['hub_DateTime']['output'];
  ended_at?: Maybe<Scalars['hub_Date']['output']>;
  id: Scalars['Int']['output'];
  started_at: Scalars['hub_Date']['output'];
  status: Hub_AccountSubscriptionStatus;
  updated_at: Scalars['hub_DateTime']['output'];
};

export enum Hub_AccountSubscriptionColumn {
  AccountId = 'account_id',
  CompanyId = 'company_id',
  EndedAt = 'ended_at',
  Id = 'id',
  StartedAt = 'started_at',
  Status = 'status'
}

/** A paginated list of AccountSubscription items. */
export type Hub_AccountSubscriptionPaginator = {
  __typename?: 'hub_AccountSubscriptionPaginator';
  /** A list of AccountSubscription items. */
  data: Array<Hub_AccountSubscription>;
  /** Pagination information about the list of items. */
  paginatorInfo: Hub_PaginatorInfo;
};

export enum Hub_AccountSubscriptionStatus {
  Active = 'active',
  Inactive = 'inactive'
}

export type Hub_Addons = {
  __typename?: 'hub_Addons';
  addon_code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  item_custom_fields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tax_id?: Maybe<Scalars['String']['output']>;
  tax_name?: Maybe<Scalars['String']['output']>;
  tax_percentage?: Maybe<Scalars['Float']['output']>;
  tax_type?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type Hub_BillingAddress = {
  __typename?: 'hub_BillingAddress';
  attention?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type Hub_CategoryScore = {
  __typename?: 'hub_CategoryScore';
  categoryName: Scalars['String']['output'];
  category_id?: Maybe<Scalars['Int']['output']>;
  certificatePath?: Maybe<Scalars['String']['output']>;
  score: Scalars['Float']['output'];
};

export type Hub_Company = {
  __typename?: 'hub_Company';
  accounts: Array<Hub_Account>;
  country_of_origin?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['hub_DateTime']['output'];
  id: Scalars['Int']['output'];
  legacy_id?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  sector?: Maybe<Scalars['String']['output']>;
  segment?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['hub_DateTime']['output'];
};

/** Columns in Company table */
export enum Hub_CompanyColumn {
  CountryOfOrigin = 'country_of_origin',
  CreatedAt = 'created_at',
  Id = 'id',
  Name = 'name',
  Sector = 'sector',
  Segment = 'segment'
}

/** A paginated list of Company items. */
export type Hub_CompanyPaginator = {
  __typename?: 'hub_CompanyPaginator';
  /** A list of Company items. */
  data: Array<Hub_Company>;
  /** Pagination information about the list of items. */
  paginatorInfo: Hub_PaginatorInfo;
};

export type Hub_Contactpersons = {
  __typename?: 'hub_Contactpersons';
  contactperson_id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  zcrm_contact_id?: Maybe<Scalars['String']['output']>;
};

export type Hub_CreateAccountBillingInput = {
  account_id: Scalars['Int']['input'];
  default_currency?: InputMaybe<Scalars['String']['input']>;
  default_discount_type?: InputMaybe<Hub_DiscountType>;
  default_discount_value?: InputMaybe<Scalars['Float']['input']>;
  gst_treatment?: InputMaybe<Hub_GstTreatmentType>;
  invoice_frequency?: InputMaybe<Hub_InvoiceFrequency>;
  invoice_prefix?: InputMaybe<Scalars['String']['input']>;
  subscribed_user_count?: InputMaybe<Scalars['Int']['input']>;
  tax_id?: InputMaybe<Scalars['String']['input']>;
  zoho_customer_id?: InputMaybe<Scalars['String']['input']>;
};

export type Hub_CreateAccountInput = {
  activated_at?: InputMaybe<Scalars['hub_Date']['input']>;
  company_id: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  owner_user_id: Scalars['Int']['input'];
  registered_address?: InputMaybe<Scalars['String']['input']>;
  sector?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
};

export type Hub_CreateAccountSubscriptionInput = {
  account_id: Scalars['Int']['input'];
  company_id: Scalars['Int']['input'];
  ended_at?: InputMaybe<Scalars['hub_Date']['input']>;
  started_at: Scalars['hub_Date']['input'];
  status: Hub_AccountSubscriptionStatus;
};

export type Hub_CreateCompanyInput = {
  country_of_origin?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sector?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
};

export type Hub_CreateDiscountCouponInput = {
  discount_type?: InputMaybe<Hub_DiscountType>;
  discount_value?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  valid_from?: InputMaybe<Scalars['hub_DateTimeUtc']['input']>;
  valid_till?: InputMaybe<Scalars['hub_DateTimeUtc']['input']>;
};

export type Hub_CreateInvoiceInput = {
  account_id: Scalars['Int']['input'];
  company_id: Scalars['Int']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  discount_type?: InputMaybe<Hub_DiscountType>;
  discount_value?: InputMaybe<Scalars['Float']['input']>;
  invoice_number?: InputMaybe<Scalars['String']['input']>;
  issued_at?: InputMaybe<Scalars['hub_Date']['input']>;
  payable_at?: InputMaybe<Scalars['hub_Date']['input']>;
  period_ended_at?: InputMaybe<Scalars['hub_Date']['input']>;
  period_started_at?: InputMaybe<Scalars['hub_Date']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
};

export type Hub_CreateInvoiceLineItemInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  invoice_id: Scalars['Int']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  type: Scalars['String']['input'];
};

export type Hub_CreateMarketInput = {
  area_of_operatoin?: InputMaybe<Scalars['String']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  head_quarters?: InputMaybe<Scalars['String']['input']>;
  pin?: InputMaybe<Scalars['String']['input']>;
  reporting_user_id?: InputMaybe<Scalars['Int']['input']>;
  roleid?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  verified_phone_number?: InputMaybe<Scalars['String']['input']>;
};

export type Hub_CreatePricingSlabInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  max_count?: InputMaybe<Scalars['Int']['input']>;
  min_count?: InputMaybe<Scalars['Int']['input']>;
  rate_per_item?: InputMaybe<Scalars['Float']['input']>;
};

export type Hub_CreateRoleInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  policies?: InputMaybe<Array<InputMaybe<Hub_RolePolicyInput>>>;
};

export type Hub_CreateUserInput = {
  company_id: Scalars['Int']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone_number: Scalars['String']['input'];
};

export type Hub_CurrentOverrage = {
  __typename?: 'hub_CurrentOverrage';
  additional_users?: Maybe<Scalars['Int']['output']>;
  cost_per_user?: Maybe<Scalars['Float']['output']>;
  period?: Maybe<Scalars['String']['output']>;
  total_cost?: Maybe<Scalars['Float']['output']>;
  total_users?: Maybe<Scalars['Int']['output']>;
  users_in_plan?: Maybe<Scalars['Int']['output']>;
};

export type Hub_CustomFieldHash = {
  __typename?: 'hub_CustomFieldHash';
  cf_pando_company_id?: Maybe<Scalars['String']['output']>;
  cf_pando_company_id_unformatted?: Maybe<Scalars['String']['output']>;
};

export type Hub_CustomFields = {
  __typename?: 'hub_CustomFields';
  customfield_id?: Maybe<Scalars['String']['output']>;
  data_type?: Maybe<Scalars['String']['output']>;
  edit_on_portal?: Maybe<Scalars['Boolean']['output']>;
  edit_on_store?: Maybe<Scalars['Boolean']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_dependent_field?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  search_entity?: Maybe<Scalars['String']['output']>;
  show_in_all_pdf?: Maybe<Scalars['Boolean']['output']>;
  show_in_portal?: Maybe<Scalars['Boolean']['output']>;
  show_in_store?: Maybe<Scalars['Boolean']['output']>;
  show_on_pdf?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  value_formatted?: Maybe<Scalars['String']['output']>;
};

export type Hub_Customer = {
  __typename?: 'hub_Customer';
  billing_address?: Maybe<Hub_BillingAddress>;
  channel_customer_id?: Maybe<Scalars['String']['output']>;
  channel_reference_id?: Maybe<Scalars['String']['output']>;
  company_name?: Maybe<Scalars['String']['output']>;
  custom_fields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  customer_id?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  ip_address?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  payment_terms?: Maybe<Scalars['Int']['output']>;
  payment_terms_label?: Maybe<Scalars['String']['output']>;
  salutation?: Maybe<Scalars['String']['output']>;
  shipping_address?: Maybe<Hub_ShippingAddress>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  website?: Maybe<Scalars['String']['output']>;
  zcrm_account_id?: Maybe<Scalars['String']['output']>;
  zcrm_contact_id?: Maybe<Scalars['String']['output']>;
};

export type Hub_Designation = {
  __typename?: 'hub_Designation';
  company_id?: Maybe<Scalars['Int']['output']>;
  default_role_id?: Maybe<Scalars['Int']['output']>;
  designation_id?: Maybe<Scalars['Int']['output']>;
  designation_name?: Maybe<Scalars['String']['output']>;
  geo_type_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
};

export enum Hub_DesignationColumn {
  CompanyId = 'company_id',
  DefaultRoleId = 'default_role_id',
  DesignationId = 'designation_id',
  DesignationName = 'designation_name',
  GeoTypeId = 'geo_type_id',
  Id = 'id',
  IsDeleted = 'is_deleted'
}

/** A paginated list of Designation items. */
export type Hub_DesignationPaginator = {
  __typename?: 'hub_DesignationPaginator';
  /** A list of Designation items. */
  data: Array<Hub_Designation>;
  /** Pagination information about the list of items. */
  paginatorInfo: Hub_PaginatorInfo;
};

export type Hub_DiscountCoupon = {
  __typename?: 'hub_DiscountCoupon';
  created_at: Scalars['hub_DateTime']['output'];
  discount_type?: Maybe<Hub_DiscountType>;
  discount_value?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['hub_DateTime']['output'];
  valid_from?: Maybe<Scalars['hub_DateTimeUtc']['output']>;
  valid_till?: Maybe<Scalars['hub_DateTimeUtc']['output']>;
};

export enum Hub_DiscountCouponColumn {
  CreatedAt = 'created_at',
  DiscountType = 'discount_type',
  DiscountValue = 'discount_value',
  Id = 'id',
  Name = 'name',
  UpdatedAt = 'updated_at',
  ValidFrom = 'valid_from',
  ValidTill = 'valid_till'
}

/** A paginated list of DiscountCoupon items. */
export type Hub_DiscountCouponPaginator = {
  __typename?: 'hub_DiscountCouponPaginator';
  /** A list of DiscountCoupon items. */
  data: Array<Hub_DiscountCoupon>;
  /** Pagination information about the list of items. */
  paginatorInfo: Hub_PaginatorInfo;
};

export enum Hub_DiscountType {
  Actual = 'actual',
  Percent = 'percent'
}

export enum Hub_GstTreatmentType {
  Overseas = 'overseas',
  Registered = 'registered',
  Unregistered = 'unregistered'
}

export type Hub_Invoice = {
  __typename?: 'hub_Invoice';
  account_id: Scalars['Int']['output'];
  company_id: Scalars['Int']['output'];
  created_at: Scalars['hub_DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  discount_type?: Maybe<Hub_DiscountType>;
  discount_value?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  invoice_number?: Maybe<Scalars['String']['output']>;
  issued_at?: Maybe<Scalars['hub_Date']['output']>;
  items?: Maybe<Array<Maybe<Hub_InvoiceLineItem>>>;
  payable_at?: Maybe<Scalars['hub_Date']['output']>;
  period_ended_at?: Maybe<Scalars['hub_Date']['output']>;
  period_started_at?: Maybe<Scalars['hub_Date']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  updated_at: Scalars['hub_DateTime']['output'];
};

export enum Hub_InvoiceColumn {
  AccountId = 'account_id',
  CompanyId = 'company_id',
  CreatedAt = 'created_at',
  Currency = 'currency',
  DiscountType = 'discount_type',
  DiscountValue = 'discount_value',
  Id = 'id',
  InvoiceNumber = 'invoice_number',
  IssuedAt = 'issued_at',
  PayableAt = 'payable_at',
  PeriodEndedAt = 'period_ended_at',
  PeriodStartedAt = 'period_started_at',
  Total = 'total',
  UpdatedAt = 'updated_at'
}

export enum Hub_InvoiceFrequency {
  Annual = 'annual',
  Biannual = 'biannual',
  Monthly = 'monthly',
  Quarterly = 'quarterly'
}

export type Hub_InvoiceLineItem = {
  __typename?: 'hub_InvoiceLineItem';
  created_at: Scalars['hub_DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  invoice?: Maybe<Hub_Invoice>;
  invoice_id: Scalars['Int']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
  updated_at: Scalars['hub_DateTime']['output'];
};

export enum Hub_InvoiceLineItemColumn {
  CreatedAt = 'created_at',
  Currency = 'currency',
  Description = 'description',
  Id = 'id',
  Invoice = 'invoice',
  InvoiceId = 'invoice_id',
  Quantity = 'quantity',
  Rate = 'rate',
  Type = 'type',
  UpdatedAt = 'updated_at'
}

/** A paginated list of InvoiceLineItem items. */
export type Hub_InvoiceLineItemPaginator = {
  __typename?: 'hub_InvoiceLineItemPaginator';
  /** A list of InvoiceLineItem items. */
  data: Array<Hub_InvoiceLineItem>;
  /** Pagination information about the list of items. */
  paginatorInfo: Hub_PaginatorInfo;
};

/** A paginated list of Invoice items. */
export type Hub_InvoicePaginator = {
  __typename?: 'hub_InvoicePaginator';
  /** A list of Invoice items. */
  data: Array<Hub_Invoice>;
  /** Pagination information about the list of items. */
  paginatorInfo: Hub_PaginatorInfo;
};

export type Hub_JobExperience = {
  __typename?: 'hub_JobExperience';
  account_id?: Maybe<Scalars['Int']['output']>;
  company_id?: Maybe<Scalars['Int']['output']>;
  company_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['hub_DateTimeTz']['output']>;
  deleted_at?: Maybe<Scalars['hub_DateTimeTz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  joined_at?: Maybe<Scalars['hub_DateTimeTz']['output']>;
  resigned_at?: Maybe<Scalars['hub_DateTimeTz']['output']>;
  updated_at?: Maybe<Scalars['hub_DateTimeTz']['output']>;
  user?: Maybe<Hub_User>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export enum Hub_JobExperienceColumn {
  AccountId = 'account_id',
  CompanyId = 'company_id',
  CompanyName = 'company_name',
  CreatedAt = 'created_at',
  DeletedAt = 'deleted_at',
  Description = 'description',
  Headline = 'headline',
  Id = 'id',
  JoinedAt = 'joined_at',
  ResignedAt = 'resigned_at',
  UpdatedAt = 'updated_at',
  UserId = 'user_id'
}

/** A paginated list of JobExperience items. */
export type Hub_JobExperiencePaginator = {
  __typename?: 'hub_JobExperiencePaginator';
  /** A list of JobExperience items. */
  data: Array<Hub_JobExperience>;
  /** Pagination information about the list of items. */
  paginatorInfo: Hub_PaginatorInfo;
};

export type Hub_KnowledgeScore = {
  __typename?: 'hub_KnowledgeScore';
  categories: Array<Maybe<Hub_CategoryScore>>;
  totalAchievement: Scalars['Float']['output'];
};

export type Hub_Market = {
  __typename?: 'hub_Market';
  access_token?: Maybe<Scalars['String']['output']>;
  area_of_operatoin?: Maybe<Scalars['String']['output']>;
  companyAccount?: Maybe<Hub_Account>;
  designation?: Maybe<Scalars['String']['output']>;
  designation_id?: Maybe<Scalars['Int']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  district_code?: Maybe<Scalars['String']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  employee_number?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  head_quarters?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  input_company_id?: Maybe<Scalars['Int']['output']>;
  is_blocked?: Maybe<Scalars['Boolean']['output']>;
  kgUser?: Maybe<Hub_User>;
  kg_user_id?: Maybe<Scalars['Int']['output']>;
  license_active?: Maybe<Scalars['Boolean']['output']>;
  myPendingMarkets?: Maybe<Hub_PendingMarketPaginator>;
  myTeam?: Maybe<Hub_MarketPaginator>;
  photo_url?: Maybe<Scalars['String']['output']>;
  pin?: Maybe<Scalars['String']['output']>;
  planCards?: Maybe<Hub_PlanCardPaginator>;
  reporting_user_id?: Maybe<Scalars['Int']['output']>;
  roleid?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  state_code?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  territory?: Maybe<Scalars['String']['output']>;
  territory_code?: Maybe<Scalars['String']['output']>;
  verified_phone_number?: Maybe<Scalars['String']['output']>;
};


export type Hub_MarketMyPendingMarketsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type Hub_MarketMyTeamArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type Hub_MarketPlanCardsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type Hub_MarketActivation = {
  __typename?: 'hub_MarketActivation';
  account_id?: Maybe<Scalars['Int']['output']>;
  actionUser?: Maybe<Hub_User>;
  action_user_id?: Maybe<Scalars['Int']['output']>;
  activated_at?: Maybe<Scalars['hub_DateTimeTz']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  company_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['hub_DateTimeTz']['output']>;
  deleted_at?: Maybe<Scalars['hub_DateTimeTz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  ip?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['hub_DateTimeTz']['output']>;
};

export enum Hub_MarketActivationColumn {
  AccountId = 'account_id',
  ActionUserId = 'action_user_id',
  ActivatedAt = 'activated_at',
  Comment = 'comment',
  CompanyId = 'company_id',
  CreatedAt = 'created_at',
  DeletedAt = 'deleted_at',
  Id = 'id',
  Ip = 'ip',
  UpdatedAt = 'updated_at'
}

/** A paginated list of MarketActivation items. */
export type Hub_MarketActivationPaginator = {
  __typename?: 'hub_MarketActivationPaginator';
  /** A list of MarketActivation items. */
  data: Array<Hub_MarketActivation>;
  /** Pagination information about the list of items. */
  paginatorInfo: Hub_PaginatorInfo;
};

export enum Hub_MarketColumn {
  AreaOfOperatoin = 'area_of_operatoin',
  Designation = 'designation',
  District = 'district',
  EmailAddress = 'email_address',
  EmployeeNumber = 'employee_number',
  HeadQuarters = 'head_quarters',
  Id = 'id',
  KgUserId = 'kg_user_id',
  Pin = 'pin',
  ReportingUserId = 'reporting_user_id',
  Roleid = 'roleid',
  State = 'state',
  Status = 'status',
  VerifiedPhoneNumber = 'verified_phone_number'
}

/** A paginated list of Market items. */
export type Hub_MarketPaginator = {
  __typename?: 'hub_MarketPaginator';
  /** A list of Market items. */
  data: Array<Hub_Market>;
  /** Pagination information about the list of items. */
  paginatorInfo: Hub_PaginatorInfo;
};

export type Hub_Mutation = {
  __typename?: 'hub_Mutation';
  addChargeToSubscription?: Maybe<Hub_AccountBilling>;
  assignMarketToUser?: Maybe<Hub_Market>;
  createAccount?: Maybe<Hub_Account>;
  createAccountBilling?: Maybe<Hub_AccountBilling>;
  createAccountSubscription?: Maybe<Hub_AccountSubscription>;
  createCompany?: Maybe<Hub_Company>;
  createDiscountCoupon?: Maybe<Hub_DiscountCoupon>;
  createInvoice?: Maybe<Hub_Invoice>;
  createInvoiceLineItem?: Maybe<Hub_InvoiceLineItem>;
  createMarket?: Maybe<Hub_Market>;
  createPricingSlab?: Maybe<Hub_PricingSlab>;
  createRole?: Maybe<Hub_Role>;
  createUser?: Maybe<Hub_User>;
  createUser1?: Maybe<Hub_User>;
  deactivateMarket?: Maybe<Hub_Market>;
  deleteAccount: Array<Hub_Account>;
  deleteAccountBilling: Array<Hub_AccountBilling>;
  deleteAccountSubscription: Array<Hub_AccountSubscription>;
  deleteCompany: Array<Hub_Company>;
  deleteDiscountCoupon: Array<Hub_DiscountCoupon>;
  deleteInvoice: Array<Hub_Invoice>;
  deleteInvoiceLineItem: Array<Hub_InvoiceLineItem>;
  deleteMarket: Array<Hub_Market>;
  deletePricingSlab: Array<Hub_PricingSlab>;
  deleteRole: Array<Hub_Role>;
  deleteUser: Array<Hub_User>;
  updateAccount?: Maybe<Hub_Account>;
  updateAccountBilling?: Maybe<Hub_AccountBilling>;
  updateAccountSubscription?: Maybe<Hub_AccountSubscription>;
  updateCompany?: Maybe<Hub_Company>;
  updateDiscountCoupon?: Maybe<Hub_DiscountCoupon>;
  updateInvoice?: Maybe<Hub_Invoice>;
  updateInvoiceLineItem?: Maybe<Hub_InvoiceLineItem>;
  updateMarket?: Maybe<Hub_Market>;
  updatePricingSlab?: Maybe<Hub_PricingSlab>;
  updateRole?: Maybe<Hub_Role>;
  updateUser?: Maybe<Hub_User>;
};


export type Hub_MutationAddChargeToSubscriptionArgs = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
};


export type Hub_MutationAssignMarketToUserArgs = {
  designation_id?: InputMaybe<Scalars['String']['input']>;
  district_name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employee_id?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  joiningDate?: InputMaybe<Scalars['Float']['input']>;
  kgUserId?: InputMaybe<Scalars['Int']['input']>;
  marketId: Scalars['Int']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  reporting_user_id?: InputMaybe<Scalars['String']['input']>;
  state_name?: InputMaybe<Scalars['String']['input']>;
};


export type Hub_MutationCreateAccountArgs = {
  input: Hub_CreateAccountInput;
};


export type Hub_MutationCreateAccountBillingArgs = {
  input: Hub_CreateAccountBillingInput;
};


export type Hub_MutationCreateAccountSubscriptionArgs = {
  input: Hub_CreateAccountSubscriptionInput;
};


export type Hub_MutationCreateCompanyArgs = {
  input: Hub_CreateCompanyInput;
};


export type Hub_MutationCreateDiscountCouponArgs = {
  input: Hub_CreateDiscountCouponInput;
};


export type Hub_MutationCreateInvoiceArgs = {
  input: Hub_CreateInvoiceInput;
};


export type Hub_MutationCreateInvoiceLineItemArgs = {
  input: Hub_CreateInvoiceLineItemInput;
};


export type Hub_MutationCreateMarketArgs = {
  input: Hub_CreateMarketInput;
};


export type Hub_MutationCreatePricingSlabArgs = {
  input: Hub_CreatePricingSlabInput;
};


export type Hub_MutationCreateRoleArgs = {
  input: Hub_CreateRoleInput;
};


export type Hub_MutationCreateUserArgs = {
  input: Hub_CreateUserInput;
};


export type Hub_MutationCreateUser1Args = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type Hub_MutationDeactivateMarketArgs = {
  keepLicense?: InputMaybe<Scalars['Boolean']['input']>;
  marketId: Scalars['Int']['input'];
  resignationDate?: InputMaybe<Scalars['Float']['input']>;
};


export type Hub_MutationDeleteAccountArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type Hub_MutationDeleteAccountBillingArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type Hub_MutationDeleteAccountSubscriptionArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type Hub_MutationDeleteCompanyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type Hub_MutationDeleteDiscountCouponArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type Hub_MutationDeleteInvoiceArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type Hub_MutationDeleteInvoiceLineItemArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type Hub_MutationDeleteMarketArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type Hub_MutationDeletePricingSlabArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type Hub_MutationDeleteRoleArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type Hub_MutationDeleteUserArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type Hub_MutationUpdateAccountArgs = {
  data: Hub_UpdateAccountInput;
  id: Scalars['Int']['input'];
};


export type Hub_MutationUpdateAccountBillingArgs = {
  data: Hub_UpdateAccountBillingInput;
  id: Scalars['Int']['input'];
};


export type Hub_MutationUpdateAccountSubscriptionArgs = {
  data: Hub_UpdateAccountSubscriptionInput;
  id: Scalars['Int']['input'];
};


export type Hub_MutationUpdateCompanyArgs = {
  data: Hub_UpdateCompanyInput;
  id: Scalars['Int']['input'];
};


export type Hub_MutationUpdateDiscountCouponArgs = {
  data: Hub_UpdateDiscountCouponInput;
  id: Scalars['Int']['input'];
};


export type Hub_MutationUpdateInvoiceArgs = {
  data: Hub_UpdateInvoiceInput;
  id: Scalars['Int']['input'];
};


export type Hub_MutationUpdateInvoiceLineItemArgs = {
  data: Hub_UpdateInvoiceLineItemInput;
  id: Scalars['Int']['input'];
};


export type Hub_MutationUpdateMarketArgs = {
  data: Hub_CreateMarketInput;
  id: Scalars['Int']['input'];
};


export type Hub_MutationUpdatePricingSlabArgs = {
  data: Hub_UpdatePricingSlabInput;
  id: Scalars['Int']['input'];
};


export type Hub_MutationUpdateRoleArgs = {
  data: Hub_CreateRoleInput;
  id: Scalars['Int']['input'];
};


export type Hub_MutationUpdateUserArgs = {
  data: Hub_UpdateUserInput;
  id: Scalars['Int']['input'];
};

/** Information about pagination using a fully featured paginator. */
export type Hub_PaginatorInfo = {
  __typename?: 'hub_PaginatorInfo';
  /** Number of items in the current page. */
  count: Scalars['Int']['output'];
  /** Index of the current page. */
  currentPage: Scalars['Int']['output'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']['output']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean']['output'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']['output']>;
  /** Index of the last available page. */
  lastPage: Scalars['Int']['output'];
  /** Number of items per page. */
  perPage: Scalars['Int']['output'];
  /** Number of total available items. */
  total: Scalars['Int']['output'];
};

export type Hub_PandoCompany = {
  __typename?: 'hub_PandoCompany';
  id?: Maybe<Scalars['Int']['output']>;
  is_blocked?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  organization_name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export enum Hub_PandoCompanyColumn {
  Id = 'id',
  IsBlocked = 'is_blocked',
  IsDeleted = 'is_deleted',
  OrganizationName = 'organization_name',
  Status = 'status'
}

/** A paginated list of PandoCompany items. */
export type Hub_PandoCompanyPaginator = {
  __typename?: 'hub_PandoCompanyPaginator';
  /** A list of PandoCompany items. */
  data: Array<Hub_PandoCompany>;
  /** Pagination information about the list of items. */
  paginatorInfo: Hub_PaginatorInfo;
};

export type Hub_PaymentGateways = {
  __typename?: 'hub_PaymentGateways';
  payment_gateway?: Maybe<Scalars['String']['output']>;
};

export type Hub_PendingMarket = {
  __typename?: 'hub_PendingMarket';
  form_json?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of PendingMarket items. */
export type Hub_PendingMarketPaginator = {
  __typename?: 'hub_PendingMarketPaginator';
  /** A list of PendingMarket items. */
  data: Array<Hub_PendingMarket>;
  /** Pagination information about the list of items. */
  paginatorInfo: Hub_PaginatorInfo;
};

export type Hub_Plan = {
  __typename?: 'hub_Plan';
  custom_field_hash?: Maybe<Hub_CustomFieldHash>;
  custom_fields?: Maybe<Array<Maybe<Hub_CustomFields>>>;
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  hsn_or_sac?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  plan_code?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  product_type?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  setup_fee?: Maybe<Scalars['Float']['output']>;
  setup_fee_tax_exemption_code?: Maybe<Scalars['String']['output']>;
  setup_fee_tax_exemption_id?: Maybe<Scalars['String']['output']>;
  setup_fee_tax_id?: Maybe<Scalars['String']['output']>;
  setup_fee_tax_name?: Maybe<Scalars['String']['output']>;
  setup_fee_tax_percentage?: Maybe<Scalars['String']['output']>;
  setup_fee_tax_type?: Maybe<Scalars['String']['output']>;
  tax_id?: Maybe<Scalars['String']['output']>;
  tax_name?: Maybe<Scalars['String']['output']>;
  tax_percentage?: Maybe<Scalars['Float']['output']>;
  tax_type?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type Hub_PlanCard = {
  __typename?: 'hub_PlanCard';
  activity?: Maybe<Scalars['Int']['output']>;
  activity_coins?: Maybe<Scalars['String']['output']>;
  assign_to: Scalars['Int']['output'];
  card_type: Scalars['String']['output'];
  channel_partner?: Maybe<Scalars['String']['output']>;
  channel_partner_id?: Maybe<Scalars['Int']['output']>;
  created_by?: Maybe<Scalars['Int']['output']>;
  created_date?: Maybe<Scalars['hub_DateTime']['output']>;
  creation_mode?: Maybe<Scalars['String']['output']>;
  crm_customer_name?: Maybe<Scalars['String']['output']>;
  crm_phone_number?: Maybe<Scalars['String']['output']>;
  crop_id?: Maybe<Scalars['Int']['output']>;
  crop_name?: Maybe<Scalars['String']['output']>;
  distance_travelled?: Maybe<Scalars['Float']['output']>;
  fqr_id?: Maybe<Scalars['Int']['output']>;
  fqr_primary_id?: Maybe<Scalars['Int']['output']>;
  guid: Scalars['String']['output'];
  hybrid_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  is_deleted?: Maybe<Scalars['Int']['output']>;
  kg_user_id?: Maybe<Scalars['Int']['output']>;
  land_type?: Maybe<Scalars['String']['output']>;
  lat_position?: Maybe<Scalars['Float']['output']>;
  location_name?: Maybe<Scalars['String']['output']>;
  long_position?: Maybe<Scalars['Float']['output']>;
  mobile_timestamp?: Maybe<Scalars['String']['output']>;
  mobile_timestamp2?: Maybe<Scalars['String']['output']>;
  order_number?: Maybe<Scalars['Int']['output']>;
  plan_approval_status?: Maybe<Scalars['String']['output']>;
  plan_type?: Maybe<Scalars['String']['output']>;
  planned_date?: Maybe<Scalars['String']['output']>;
  product_id?: Maybe<Scalars['Int']['output']>;
  product_name?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['hub_DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  submission_mode?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['Int']['output']>;
  updated_date?: Maybe<Scalars['hub_DateTime']['output']>;
  village_id?: Maybe<Scalars['Int']['output']>;
  village_name?: Maybe<Scalars['String']['output']>;
};

export enum Hub_PlanCardColumn {
  Id = 'id'
}

/** A paginated list of PlanCard items. */
export type Hub_PlanCardPaginator = {
  __typename?: 'hub_PlanCardPaginator';
  /** A list of PlanCard items. */
  data: Array<Hub_PlanCard>;
  /** Pagination information about the list of items. */
  paginatorInfo: Hub_PaginatorInfo;
};

export type Hub_PricingSlab = {
  __typename?: 'hub_PricingSlab';
  created_at: Scalars['hub_DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  max_count?: Maybe<Scalars['Int']['output']>;
  min_count?: Maybe<Scalars['Int']['output']>;
  rate_per_item?: Maybe<Scalars['Float']['output']>;
  updated_at: Scalars['hub_DateTime']['output'];
};

export enum Hub_PricingSlabColumn {
  CreatedAt = 'created_at',
  Currency = 'currency',
  Id = 'id',
  MaxCount = 'max_count',
  MinCount = 'min_count',
  RatePerItem = 'rate_per_item',
  UpdatedAt = 'updated_at'
}

/** A paginated list of PricingSlab items. */
export type Hub_PricingSlabPaginator = {
  __typename?: 'hub_PricingSlabPaginator';
  /** A list of PricingSlab items. */
  data: Array<Hub_PricingSlab>;
  /** Pagination information about the list of items. */
  paginatorInfo: Hub_PaginatorInfo;
};

export type Hub_Query = {
  __typename?: 'hub_Query';
  Account?: Maybe<Hub_Account>;
  AccountBilling?: Maybe<Hub_AccountBilling>;
  AccountSubscription?: Maybe<Hub_AccountSubscription>;
  Company?: Maybe<Hub_Company>;
  Designation?: Maybe<Hub_Designation>;
  DiscountCoupon?: Maybe<Hub_DiscountCoupon>;
  Invoice?: Maybe<Hub_Invoice>;
  InvoiceLineItem?: Maybe<Hub_InvoiceLineItem>;
  JobExperience?: Maybe<Hub_JobExperience>;
  Market?: Maybe<Hub_Market>;
  MarketActivation?: Maybe<Hub_MarketActivation>;
  PandoCompany?: Maybe<Hub_PandoCompany>;
  PlanCard?: Maybe<Hub_PlanCard>;
  PricingSlab?: Maybe<Hub_PricingSlab>;
  Role?: Maybe<Hub_Role>;
  User?: Maybe<Hub_User>;
  allAccountBillings?: Maybe<Hub_AccountBillingPaginator>;
  allAccountSubscriptions?: Maybe<Hub_AccountSubscriptionPaginator>;
  allAccounts?: Maybe<Hub_AccountPaginator>;
  allCompanies?: Maybe<Hub_CompanyPaginator>;
  allDesignations?: Maybe<Hub_DesignationPaginator>;
  allDiscountCoupons?: Maybe<Hub_DiscountCouponPaginator>;
  allInvoiceLineItems?: Maybe<Hub_InvoiceLineItemPaginator>;
  allInvoices?: Maybe<Hub_InvoicePaginator>;
  allJobExperiences?: Maybe<Hub_JobExperiencePaginator>;
  allMarketActivations?: Maybe<Hub_MarketActivationPaginator>;
  allMarkets?: Maybe<Hub_MarketPaginator>;
  allPandoCompanies?: Maybe<Hub_PandoCompanyPaginator>;
  allPlanCards?: Maybe<Hub_PlanCardPaginator>;
  allPricingSlabs?: Maybe<Hub_PricingSlabPaginator>;
  allRoles?: Maybe<Hub_RolePaginator>;
  allUsers?: Maybe<Hub_UserPaginator>;
  me?: Maybe<Hub_User>;
};


export type Hub_QueryAccountArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type Hub_QueryAccountBillingArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type Hub_QueryAccountSubscriptionArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type Hub_QueryCompanyArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type Hub_QueryDesignationArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type Hub_QueryDiscountCouponArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type Hub_QueryInvoiceArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type Hub_QueryInvoiceLineItemArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type Hub_QueryJobExperienceArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type Hub_QueryMarketArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type Hub_QueryMarketActivationArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type Hub_QueryPandoCompanyArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type Hub_QueryPlanCardArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type Hub_QueryPricingSlabArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type Hub_QueryRoleArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type Hub_QueryUserArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type Hub_QueryAllAccountBillingsArgs = {
  filter?: InputMaybe<Hub_QueryAllAccountBillingsFilterWhereConditions>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  orderBy?: InputMaybe<Array<Hub_QueryAllAccountBillingsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type Hub_QueryAllAccountSubscriptionsArgs = {
  filter?: InputMaybe<Hub_QueryAllAccountSubscriptionsFilterWhereConditions>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  orderBy?: InputMaybe<Array<Hub_QueryAllAccountSubscriptionsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type Hub_QueryAllAccountsArgs = {
  filter?: InputMaybe<Hub_QueryAllAccountsFilterWhereConditions>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  orderBy?: InputMaybe<Array<Hub_QueryAllAccountsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type Hub_QueryAllCompaniesArgs = {
  filter?: InputMaybe<Hub_QueryAllCompaniesFilterWhereConditions>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  orderBy?: InputMaybe<Array<Hub_QueryAllCompaniesOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type Hub_QueryAllDesignationsArgs = {
  filter?: InputMaybe<Hub_QueryAllDesignationsFilterWhereConditions>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  orderBy?: InputMaybe<Array<Hub_QueryAllDesignationsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type Hub_QueryAllDiscountCouponsArgs = {
  filter?: InputMaybe<Hub_QueryAllDiscountCouponsFilterWhereConditions>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  orderBy?: InputMaybe<Array<Hub_QueryAllDiscountCouponsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type Hub_QueryAllInvoiceLineItemsArgs = {
  filter?: InputMaybe<Hub_QueryAllInvoiceLineItemsFilterWhereConditions>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  orderBy?: InputMaybe<Array<Hub_QueryAllInvoiceLineItemsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type Hub_QueryAllInvoicesArgs = {
  filter?: InputMaybe<Hub_QueryAllInvoicesFilterWhereConditions>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  orderBy?: InputMaybe<Array<Hub_QueryAllInvoicesOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type Hub_QueryAllJobExperiencesArgs = {
  filter?: InputMaybe<Hub_QueryAllJobExperiencesFilterWhereConditions>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  orderBy?: InputMaybe<Array<Hub_QueryAllJobExperiencesOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type Hub_QueryAllMarketActivationsArgs = {
  filter?: InputMaybe<Hub_QueryAllMarketActivationsFilterWhereConditions>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  orderBy?: InputMaybe<Array<Hub_QueryAllMarketActivationsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type Hub_QueryAllMarketsArgs = {
  filter?: InputMaybe<Hub_QueryAllMarketsFilterWhereConditions>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  orderBy?: InputMaybe<Array<Hub_QueryAllMarketsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type Hub_QueryAllPandoCompaniesArgs = {
  filter?: InputMaybe<Hub_QueryAllPandoCompaniesFilterWhereConditions>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  orderBy?: InputMaybe<Array<Hub_QueryAllPandoCompaniesOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type Hub_QueryAllPlanCardsArgs = {
  filter?: InputMaybe<Hub_QueryAllPlanCardsFilterWhereConditions>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  orderBy?: InputMaybe<Array<Hub_QueryAllPlanCardsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type Hub_QueryAllPricingSlabsArgs = {
  filter?: InputMaybe<Hub_QueryAllPricingSlabsFilterWhereConditions>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  orderBy?: InputMaybe<Array<Hub_QueryAllPricingSlabsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type Hub_QueryAllRolesArgs = {
  filter?: InputMaybe<Hub_QueryAllRolesFilterWhereConditions>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  orderBy?: InputMaybe<Array<Hub_QueryAllRolesOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type Hub_QueryAllUsersArgs = {
  filter?: InputMaybe<Hub_QueryAllUsersFilterWhereConditions>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  orderBy?: InputMaybe<Array<Hub_QueryAllUsersOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** Allowed column names for Query.allAccountBillings.filter. */
export enum Hub_QueryAllAccountBillingsFilterColumn {
  Email = 'EMAIL',
  Name = 'NAME'
}

/** Dynamic WHERE conditions for the `filter` argument on the query `allAccountBillings`. */
export type Hub_QueryAllAccountBillingsFilterWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<Hub_QueryAllAccountBillingsFilterWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<Hub_QueryAllAccountBillingsFilterWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<Hub_QueryAllAccountBillingsFilterWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Hub_QueryAllAccountBillingsFilterColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<Hub_SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['hub_Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `filter` argument on the query `allAccountBillings`. */
export type Hub_QueryAllAccountBillingsFilterWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<Hub_QueryAllAccountBillingsFilterWhereConditions>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<Hub_SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Order by clause for Query.allAccountBillings.orderBy. */
export type Hub_QueryAllAccountBillingsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: Hub_AccountBillingColumn;
  /** The direction that is used for ordering. */
  order: Hub_SortOrder;
};

/** Allowed column names for Query.allAccountSubscriptions.filter. */
export enum Hub_QueryAllAccountSubscriptionsFilterColumn {
  Email = 'EMAIL',
  Name = 'NAME'
}

/** Dynamic WHERE conditions for the `filter` argument on the query `allAccountSubscriptions`. */
export type Hub_QueryAllAccountSubscriptionsFilterWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<Hub_QueryAllAccountSubscriptionsFilterWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<Hub_QueryAllAccountSubscriptionsFilterWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<Hub_QueryAllAccountSubscriptionsFilterWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Hub_QueryAllAccountSubscriptionsFilterColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<Hub_SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['hub_Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `filter` argument on the query `allAccountSubscriptions`. */
export type Hub_QueryAllAccountSubscriptionsFilterWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<Hub_QueryAllAccountSubscriptionsFilterWhereConditions>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<Hub_SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Order by clause for Query.allAccountSubscriptions.orderBy. */
export type Hub_QueryAllAccountSubscriptionsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: Hub_AccountSubscriptionColumn;
  /** The direction that is used for ordering. */
  order: Hub_SortOrder;
};

/** Allowed column names for Query.allAccounts.filter. */
export enum Hub_QueryAllAccountsFilterColumn {
  CompanyId = 'COMPANY_ID',
  Id = 'ID',
  Name = 'NAME'
}

/** Dynamic WHERE conditions for the `filter` argument on the query `allAccounts`. */
export type Hub_QueryAllAccountsFilterWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<Hub_QueryAllAccountsFilterWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<Hub_QueryAllAccountsFilterWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<Hub_QueryAllAccountsFilterWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Hub_QueryAllAccountsFilterColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<Hub_SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['hub_Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `filter` argument on the query `allAccounts`. */
export type Hub_QueryAllAccountsFilterWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<Hub_QueryAllAccountsFilterWhereConditions>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<Hub_SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Order by clause for Query.allAccounts.orderBy. */
export type Hub_QueryAllAccountsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: Hub_AccountColumn;
  /** The direction that is used for ordering. */
  order: Hub_SortOrder;
};

/** Allowed column names for Query.allCompanies.filter. */
export enum Hub_QueryAllCompaniesFilterColumn {
  Name = 'NAME'
}

/** Dynamic WHERE conditions for the `filter` argument on the query `allCompanies`. */
export type Hub_QueryAllCompaniesFilterWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<Hub_QueryAllCompaniesFilterWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<Hub_QueryAllCompaniesFilterWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<Hub_QueryAllCompaniesFilterWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Hub_QueryAllCompaniesFilterColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<Hub_SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['hub_Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `filter` argument on the query `allCompanies`. */
export type Hub_QueryAllCompaniesFilterWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<Hub_QueryAllCompaniesFilterWhereConditions>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<Hub_SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Order by clause for Query.allCompanies.orderBy. */
export type Hub_QueryAllCompaniesOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: Hub_CompanyColumn;
  /** The direction that is used for ordering. */
  order: Hub_SortOrder;
};

/** Allowed column names for Query.allDesignations.filter. */
export enum Hub_QueryAllDesignationsFilterColumn {
  CompanyId = 'COMPANY_ID',
  DesignationId = 'DESIGNATION_ID',
  DesignationName = 'DESIGNATION_NAME',
  IsDeleted = 'IS_DELETED'
}

/** Dynamic WHERE conditions for the `filter` argument on the query `allDesignations`. */
export type Hub_QueryAllDesignationsFilterWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<Hub_QueryAllDesignationsFilterWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<Hub_QueryAllDesignationsFilterWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<Hub_QueryAllDesignationsFilterWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Hub_QueryAllDesignationsFilterColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<Hub_SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['hub_Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `filter` argument on the query `allDesignations`. */
export type Hub_QueryAllDesignationsFilterWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<Hub_QueryAllDesignationsFilterWhereConditions>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<Hub_SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Order by clause for Query.allDesignations.orderBy. */
export type Hub_QueryAllDesignationsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: Hub_DesignationColumn;
  /** The direction that is used for ordering. */
  order: Hub_SortOrder;
};

/** Allowed column names for Query.allDiscountCoupons.filter. */
export enum Hub_QueryAllDiscountCouponsFilterColumn {
  Email = 'EMAIL',
  Name = 'NAME'
}

/** Dynamic WHERE conditions for the `filter` argument on the query `allDiscountCoupons`. */
export type Hub_QueryAllDiscountCouponsFilterWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<Hub_QueryAllDiscountCouponsFilterWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<Hub_QueryAllDiscountCouponsFilterWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<Hub_QueryAllDiscountCouponsFilterWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Hub_QueryAllDiscountCouponsFilterColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<Hub_SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['hub_Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `filter` argument on the query `allDiscountCoupons`. */
export type Hub_QueryAllDiscountCouponsFilterWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<Hub_QueryAllDiscountCouponsFilterWhereConditions>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<Hub_SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Order by clause for Query.allDiscountCoupons.orderBy. */
export type Hub_QueryAllDiscountCouponsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: Hub_DiscountCouponColumn;
  /** The direction that is used for ordering. */
  order: Hub_SortOrder;
};

/** Allowed column names for Query.allInvoiceLineItems.filter. */
export enum Hub_QueryAllInvoiceLineItemsFilterColumn {
  Email = 'EMAIL',
  Name = 'NAME'
}

/** Dynamic WHERE conditions for the `filter` argument on the query `allInvoiceLineItems`. */
export type Hub_QueryAllInvoiceLineItemsFilterWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<Hub_QueryAllInvoiceLineItemsFilterWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<Hub_QueryAllInvoiceLineItemsFilterWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<Hub_QueryAllInvoiceLineItemsFilterWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Hub_QueryAllInvoiceLineItemsFilterColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<Hub_SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['hub_Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `filter` argument on the query `allInvoiceLineItems`. */
export type Hub_QueryAllInvoiceLineItemsFilterWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<Hub_QueryAllInvoiceLineItemsFilterWhereConditions>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<Hub_SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Order by clause for Query.allInvoiceLineItems.orderBy. */
export type Hub_QueryAllInvoiceLineItemsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: Hub_InvoiceLineItemColumn;
  /** The direction that is used for ordering. */
  order: Hub_SortOrder;
};

/** Allowed column names for Query.allInvoices.filter. */
export enum Hub_QueryAllInvoicesFilterColumn {
  AccountId = 'ACCOUNT_ID'
}

/** Dynamic WHERE conditions for the `filter` argument on the query `allInvoices`. */
export type Hub_QueryAllInvoicesFilterWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<Hub_QueryAllInvoicesFilterWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<Hub_QueryAllInvoicesFilterWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<Hub_QueryAllInvoicesFilterWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Hub_QueryAllInvoicesFilterColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<Hub_SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['hub_Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `filter` argument on the query `allInvoices`. */
export type Hub_QueryAllInvoicesFilterWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<Hub_QueryAllInvoicesFilterWhereConditions>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<Hub_SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Order by clause for Query.allInvoices.orderBy. */
export type Hub_QueryAllInvoicesOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: Hub_InvoiceColumn;
  /** The direction that is used for ordering. */
  order: Hub_SortOrder;
};

/** Allowed column names for Query.allJobExperiences.filter. */
export enum Hub_QueryAllJobExperiencesFilterColumn {
  AccountId = 'ACCOUNT_ID',
  CompanyId = 'COMPANY_ID',
  CompanyName = 'COMPANY_NAME',
  UserId = 'USER_ID'
}

/** Dynamic WHERE conditions for the `filter` argument on the query `allJobExperiences`. */
export type Hub_QueryAllJobExperiencesFilterWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<Hub_QueryAllJobExperiencesFilterWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<Hub_QueryAllJobExperiencesFilterWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<Hub_QueryAllJobExperiencesFilterWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Hub_QueryAllJobExperiencesFilterColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<Hub_SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['hub_Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `filter` argument on the query `allJobExperiences`. */
export type Hub_QueryAllJobExperiencesFilterWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<Hub_QueryAllJobExperiencesFilterWhereConditions>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<Hub_SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Order by clause for Query.allJobExperiences.orderBy. */
export type Hub_QueryAllJobExperiencesOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: Hub_JobExperienceColumn;
  /** The direction that is used for ordering. */
  order: Hub_SortOrder;
};

/** Allowed column names for Query.allMarketActivations.filter. */
export enum Hub_QueryAllMarketActivationsFilterColumn {
  AccountId = 'ACCOUNT_ID',
  ActionUserId = 'ACTION_USER_ID',
  CompanyId = 'COMPANY_ID'
}

/** Dynamic WHERE conditions for the `filter` argument on the query `allMarketActivations`. */
export type Hub_QueryAllMarketActivationsFilterWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<Hub_QueryAllMarketActivationsFilterWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<Hub_QueryAllMarketActivationsFilterWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<Hub_QueryAllMarketActivationsFilterWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Hub_QueryAllMarketActivationsFilterColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<Hub_SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['hub_Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `filter` argument on the query `allMarketActivations`. */
export type Hub_QueryAllMarketActivationsFilterWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<Hub_QueryAllMarketActivationsFilterWhereConditions>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<Hub_SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Order by clause for Query.allMarketActivations.orderBy. */
export type Hub_QueryAllMarketActivationsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: Hub_MarketActivationColumn;
  /** The direction that is used for ordering. */
  order: Hub_SortOrder;
};

/** Allowed column names for Query.allMarkets.filter. */
export enum Hub_QueryAllMarketsFilterColumn {
  AreaOfOperatoin = 'AREA_OF_OPERATOIN',
  District = 'DISTRICT',
  EmailAddress = 'EMAIL_ADDRESS',
  FirstName = 'FIRST_NAME',
  HeadQuarters = 'HEAD_QUARTERS',
  Id = 'ID',
  InputCompanyId = 'INPUT_COMPANY_ID',
  State = 'STATE',
  Status = 'STATUS'
}

/** Dynamic WHERE conditions for the `filter` argument on the query `allMarkets`. */
export type Hub_QueryAllMarketsFilterWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<Hub_QueryAllMarketsFilterWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<Hub_QueryAllMarketsFilterWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<Hub_QueryAllMarketsFilterWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Hub_QueryAllMarketsFilterColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<Hub_SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['hub_Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `filter` argument on the query `allMarkets`. */
export type Hub_QueryAllMarketsFilterWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<Hub_QueryAllMarketsFilterWhereConditions>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<Hub_SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Order by clause for Query.allMarkets.orderBy. */
export type Hub_QueryAllMarketsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: Hub_MarketColumn;
  /** The direction that is used for ordering. */
  order: Hub_SortOrder;
};

/** Allowed column names for Query.allPandoCompanies.filter. */
export enum Hub_QueryAllPandoCompaniesFilterColumn {
  Id = 'ID',
  IsBlocked = 'IS_BLOCKED',
  IsDeleted = 'IS_DELETED',
  OrganizationName = 'ORGANIZATION_NAME',
  Status = 'STATUS'
}

/** Dynamic WHERE conditions for the `filter` argument on the query `allPandoCompanies`. */
export type Hub_QueryAllPandoCompaniesFilterWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<Hub_QueryAllPandoCompaniesFilterWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<Hub_QueryAllPandoCompaniesFilterWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<Hub_QueryAllPandoCompaniesFilterWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Hub_QueryAllPandoCompaniesFilterColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<Hub_SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['hub_Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `filter` argument on the query `allPandoCompanies`. */
export type Hub_QueryAllPandoCompaniesFilterWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<Hub_QueryAllPandoCompaniesFilterWhereConditions>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<Hub_SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Order by clause for Query.allPandoCompanies.orderBy. */
export type Hub_QueryAllPandoCompaniesOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: Hub_PandoCompanyColumn;
  /** The direction that is used for ordering. */
  order: Hub_SortOrder;
};

/** Allowed column names for Query.allPlanCards.filter. */
export enum Hub_QueryAllPlanCardsFilterColumn {
  AssignTo = 'ASSIGN_TO',
  Id = 'ID',
  KgUserId = 'KG_USER_ID'
}

/** Dynamic WHERE conditions for the `filter` argument on the query `allPlanCards`. */
export type Hub_QueryAllPlanCardsFilterWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<Hub_QueryAllPlanCardsFilterWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<Hub_QueryAllPlanCardsFilterWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<Hub_QueryAllPlanCardsFilterWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Hub_QueryAllPlanCardsFilterColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<Hub_SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['hub_Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `filter` argument on the query `allPlanCards`. */
export type Hub_QueryAllPlanCardsFilterWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<Hub_QueryAllPlanCardsFilterWhereConditions>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<Hub_SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Order by clause for Query.allPlanCards.orderBy. */
export type Hub_QueryAllPlanCardsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: Hub_PlanCardColumn;
  /** The direction that is used for ordering. */
  order: Hub_SortOrder;
};

/** Allowed column names for Query.allPricingSlabs.filter. */
export enum Hub_QueryAllPricingSlabsFilterColumn {
  Email = 'EMAIL',
  Name = 'NAME'
}

/** Dynamic WHERE conditions for the `filter` argument on the query `allPricingSlabs`. */
export type Hub_QueryAllPricingSlabsFilterWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<Hub_QueryAllPricingSlabsFilterWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<Hub_QueryAllPricingSlabsFilterWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<Hub_QueryAllPricingSlabsFilterWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Hub_QueryAllPricingSlabsFilterColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<Hub_SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['hub_Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `filter` argument on the query `allPricingSlabs`. */
export type Hub_QueryAllPricingSlabsFilterWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<Hub_QueryAllPricingSlabsFilterWhereConditions>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<Hub_SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Order by clause for Query.allPricingSlabs.orderBy. */
export type Hub_QueryAllPricingSlabsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: Hub_PricingSlabColumn;
  /** The direction that is used for ordering. */
  order: Hub_SortOrder;
};

/** Allowed column names for Query.allRoles.filter. */
export enum Hub_QueryAllRolesFilterColumn {
  Email = 'EMAIL',
  Name = 'NAME'
}

/** Dynamic WHERE conditions for the `filter` argument on the query `allRoles`. */
export type Hub_QueryAllRolesFilterWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<Hub_QueryAllRolesFilterWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<Hub_QueryAllRolesFilterWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<Hub_QueryAllRolesFilterWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Hub_QueryAllRolesFilterColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<Hub_SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['hub_Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `filter` argument on the query `allRoles`. */
export type Hub_QueryAllRolesFilterWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<Hub_QueryAllRolesFilterWhereConditions>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<Hub_SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Order by clause for Query.allRoles.orderBy. */
export type Hub_QueryAllRolesOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: Hub_RoleColumn;
  /** The direction that is used for ordering. */
  order: Hub_SortOrder;
};

/** Allowed column names for Query.allUsers.filter. */
export enum Hub_QueryAllUsersFilterColumn {
  CompanyId = 'COMPANY_ID',
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  Id = 'ID',
  LegacyId = 'LEGACY_ID',
  Name = 'NAME',
  PhoneNumber = 'PHONE_NUMBER'
}

/** Dynamic WHERE conditions for the `filter` argument on the query `allUsers`. */
export type Hub_QueryAllUsersFilterWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<Hub_QueryAllUsersFilterWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<Hub_QueryAllUsersFilterWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<Hub_QueryAllUsersFilterWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Hub_QueryAllUsersFilterColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<Hub_SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['hub_Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `filter` argument on the query `allUsers`. */
export type Hub_QueryAllUsersFilterWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<Hub_QueryAllUsersFilterWhereConditions>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<Hub_SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Order by clause for Query.allUsers.orderBy. */
export type Hub_QueryAllUsersOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: Hub_UserColumn;
  /** The direction that is used for ordering. */
  order: Hub_SortOrder;
};

export type Hub_Role = {
  __typename?: 'hub_Role';
  created_at: Scalars['hub_DateTime']['output'];
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  policies?: Maybe<Array<Maybe<Hub_RolePolicy>>>;
  updated_at: Scalars['hub_DateTime']['output'];
  users: Array<Hub_User>;
};

/** Columns in Role table */
export enum Hub_RoleColumn {
  CreatedAt = 'created_at',
  Id = 'id',
  Name = 'name',
  Policies = 'policies'
}

/** A paginated list of Role items. */
export type Hub_RolePaginator = {
  __typename?: 'hub_RolePaginator';
  /** A list of Role items. */
  data: Array<Hub_Role>;
  /** Pagination information about the list of items. */
  paginatorInfo: Hub_PaginatorInfo;
};

export type Hub_RolePolicy = {
  __typename?: 'hub_RolePolicy';
  actions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  effect?: Maybe<Hub_RolePolicyEffect>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum Hub_RolePolicyEffect {
  Allow = 'allow',
  Deny = 'deny'
}

export type Hub_RolePolicyInput = {
  actions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  effect?: InputMaybe<Hub_RolePolicyEffect>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** The available SQL operators that are used to filter query results. */
export enum Hub_SqlOperator {
  /** Whether a value is within a range of values (`BETWEEN`) */
  Between = 'BETWEEN',
  /** Equal operator (`=`) */
  Eq = 'EQ',
  /** Greater than operator (`>`) */
  Gt = 'GT',
  /** Greater than or equal operator (`>=`) */
  Gte = 'GTE',
  /** Whether a value is within a set of values (`IN`) */
  In = 'IN',
  /** Whether a value is not null (`IS NOT NULL`) */
  IsNotNull = 'IS_NOT_NULL',
  /** Whether a value is null (`IS NULL`) */
  IsNull = 'IS_NULL',
  /** Simple pattern matching (`LIKE`) */
  Like = 'LIKE',
  /** Less than operator (`<`) */
  Lt = 'LT',
  /** Less than or equal operator (`<=`) */
  Lte = 'LTE',
  /** Not equal operator (`!=`) */
  Neq = 'NEQ',
  /** Whether a value is not within a range of values (`NOT BETWEEN`) */
  NotBetween = 'NOT_BETWEEN',
  /** Whether a value is not within a set of values (`NOT IN`) */
  NotIn = 'NOT_IN',
  /** Negation of simple pattern matching (`NOT LIKE`) */
  NotLike = 'NOT_LIKE'
}

export type Hub_ShippingAddress = {
  __typename?: 'hub_ShippingAddress';
  attention?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** Directions for ordering a list of records. */
export enum Hub_SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC'
}

export type Hub_Taxes = {
  __typename?: 'hub_Taxes';
  tax_amount?: Maybe<Scalars['Float']['output']>;
  tax_id?: Maybe<Scalars['String']['output']>;
  tax_name?: Maybe<Scalars['String']['output']>;
};

export type Hub_UnbilledChargeItems = {
  __typename?: 'hub_UnbilledChargeItems';
  account_id?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  item_total?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  product_id?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  tax_id?: Maybe<Scalars['String']['output']>;
  tax_name?: Maybe<Scalars['String']['output']>;
  tax_percentage?: Maybe<Scalars['Int']['output']>;
  tax_type?: Maybe<Scalars['String']['output']>;
  unbilled_charge_item_id?: Maybe<Scalars['String']['output']>;
};

export type Hub_UpdateAccountBillingInput = {
  account_id: Scalars['Int']['input'];
  default_currency?: InputMaybe<Scalars['String']['input']>;
  default_discount_type?: InputMaybe<Hub_DiscountType>;
  default_discount_value?: InputMaybe<Scalars['Float']['input']>;
  gst_treatment?: InputMaybe<Hub_GstTreatmentType>;
  invoice_frequency?: InputMaybe<Hub_InvoiceFrequency>;
  invoice_prefix?: InputMaybe<Scalars['String']['input']>;
  subscribed_user_count?: InputMaybe<Scalars['Int']['input']>;
  tax_id?: InputMaybe<Scalars['String']['input']>;
  zoho_customer_id?: InputMaybe<Scalars['String']['input']>;
};

export type Hub_UpdateAccountInput = {
  activated_at?: InputMaybe<Scalars['hub_Date']['input']>;
  company_id: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  owner_user_id: Scalars['Int']['input'];
  registered_address?: InputMaybe<Scalars['String']['input']>;
  sector?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
};

export type Hub_UpdateAccountSubscriptionInput = {
  account_id: Scalars['Int']['input'];
  company_id: Scalars['Int']['input'];
  ended_at?: InputMaybe<Scalars['hub_Date']['input']>;
  started_at: Scalars['hub_Date']['input'];
  status: Hub_AccountSubscriptionStatus;
};

export type Hub_UpdateCompanyInput = {
  country_of_origin?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sector?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
};

export type Hub_UpdateDiscountCouponInput = {
  discount_type?: InputMaybe<Hub_DiscountType>;
  discount_value?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  valid_from?: InputMaybe<Scalars['hub_DateTimeUtc']['input']>;
  valid_till?: InputMaybe<Scalars['hub_DateTimeUtc']['input']>;
};

export type Hub_UpdateInvoiceInput = {
  account_id: Scalars['Int']['input'];
  company_id: Scalars['Int']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  discount_type?: InputMaybe<Hub_DiscountType>;
  discount_value?: InputMaybe<Scalars['Float']['input']>;
  invoice_number?: InputMaybe<Scalars['String']['input']>;
  issued_at?: InputMaybe<Scalars['hub_Date']['input']>;
  payable_at?: InputMaybe<Scalars['hub_Date']['input']>;
  period_ended_at?: InputMaybe<Scalars['hub_Date']['input']>;
  period_started_at?: InputMaybe<Scalars['hub_Date']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
};

export type Hub_UpdateInvoiceLineItemInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  invoice_id: Scalars['Int']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  type: Scalars['String']['input'];
};

export type Hub_UpdatePricingSlabInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  max_count?: InputMaybe<Scalars['Int']['input']>;
  min_count?: InputMaybe<Scalars['Int']['input']>;
  rate_per_item?: InputMaybe<Scalars['Float']['input']>;
};

export type Hub_UpdateUserInput = {
  company_id: Scalars['Int']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  legacy_id?: InputMaybe<Scalars['Int']['input']>;
  phone_number: Scalars['String']['input'];
};

export type Hub_User = {
  __typename?: 'hub_User';
  company: Hub_Company;
  company_id: Scalars['Int']['output'];
  created_at: Scalars['hub_DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  first_name: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  knowledgeScore: Hub_KnowledgeScore;
  last_name?: Maybe<Scalars['String']['output']>;
  legacy_id?: Maybe<Scalars['Int']['output']>;
  market?: Maybe<Hub_Market>;
  myPendingMarkets?: Maybe<Hub_PendingMarketPaginator>;
  myTeam?: Maybe<Hub_MarketPaginator>;
  pandoUser?: Maybe<Hub_Market>;
  phone_number: Scalars['String']['output'];
  roles: Array<Hub_Role>;
  updated_at: Scalars['hub_DateTime']['output'];
};


export type Hub_UserMyPendingMarketsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type Hub_UserMyTeamArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** Columns in User table */
export enum Hub_UserColumn {
  CompanyId = 'company_id',
  CreatedAt = 'created_at',
  Email = 'email',
  FirstName = 'first_name',
  Id = 'id',
  LastName = 'last_name',
  LegacyId = 'legacy_id',
  PhoneNumber = 'phone_number'
}

/** A paginated list of User items. */
export type Hub_UserPaginator = {
  __typename?: 'hub_UserPaginator';
  /** A list of User items. */
  data: Array<Hub_User>;
  /** Pagination information about the list of items. */
  paginatorInfo: Hub_PaginatorInfo;
};

export type Hub_ZohoSubscription = {
  __typename?: 'hub_ZohoSubscription';
  activated_at?: Maybe<Scalars['String']['output']>;
  addons?: Maybe<Array<Maybe<Hub_Addons>>>;
  allow_partial_payments?: Maybe<Scalars['Boolean']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  auto_apply_credits?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  auto_collect?: Maybe<Scalars['Boolean']['output']>;
  billing_mode?: Maybe<Scalars['String']['output']>;
  can_add_bank_account?: Maybe<Scalars['Boolean']['output']>;
  can_prorate_subscription?: Maybe<Scalars['Boolean']['output']>;
  channel_reference_id?: Maybe<Scalars['String']['output']>;
  channel_source?: Maybe<Scalars['String']['output']>;
  child_invoice_id?: Maybe<Scalars['String']['output']>;
  contactpersons?: Maybe<Array<Maybe<Hub_Contactpersons>>>;
  coupon_duration?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  created_by_id?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['String']['output']>;
  created_time?: Maybe<Scalars['String']['output']>;
  crm_owner_id?: Maybe<Scalars['String']['output']>;
  currency_code?: Maybe<Scalars['String']['output']>;
  currency_symbol?: Maybe<Scalars['String']['output']>;
  current_overrage?: Maybe<Hub_CurrentOverrage>;
  current_term_ends_at?: Maybe<Scalars['String']['output']>;
  current_term_starts_at?: Maybe<Scalars['String']['output']>;
  custom_field_hash?: Maybe<Hub_CustomFieldHash>;
  custom_fields?: Maybe<Array<Maybe<Hub_CustomFields>>>;
  customer?: Maybe<Hub_Customer>;
  customer_id?: Maybe<Scalars['String']['output']>;
  debug?: Maybe<Scalars['String']['output']>;
  end_of_term?: Maybe<Scalars['Boolean']['output']>;
  exchange_rate?: Maybe<Scalars['Int']['output']>;
  expires_at?: Maybe<Scalars['String']['output']>;
  interval?: Maybe<Scalars['Float']['output']>;
  interval_unit?: Maybe<Scalars['String']['output']>;
  is_inclusive_tax?: Maybe<Scalars['Boolean']['output']>;
  is_metered_billing?: Maybe<Scalars['Boolean']['output']>;
  items_associated?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  last_billing_at?: Maybe<Scalars['String']['output']>;
  last_modified_by_id?: Maybe<Scalars['String']['output']>;
  last_shipment_at?: Maybe<Scalars['String']['output']>;
  last_shipment_day?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  next_billing_at?: Maybe<Scalars['String']['output']>;
  next_shipment_at?: Maybe<Scalars['String']['output']>;
  next_shipment_day?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  orders_created?: Maybe<Scalars['Float']['output']>;
  orders_remaining?: Maybe<Scalars['Int']['output']>;
  payment_gateways?: Maybe<Array<Maybe<Hub_PaymentGateways>>>;
  payment_terms?: Maybe<Scalars['Int']['output']>;
  payment_terms_label?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<Hub_Plan>;
  pricebook_id?: Maybe<Scalars['String']['output']>;
  product_id?: Maybe<Scalars['String']['output']>;
  product_name?: Maybe<Scalars['String']['output']>;
  reference_id?: Maybe<Scalars['String']['output']>;
  remaining_billing_cycles?: Maybe<Scalars['Int']['output']>;
  salesperson_id?: Maybe<Scalars['String']['output']>;
  salesperson_name?: Maybe<Scalars['String']['output']>;
  shipping_interval?: Maybe<Scalars['Float']['output']>;
  shipping_interval_unit?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  sub_total?: Maybe<Scalars['Float']['output']>;
  subscription_id?: Maybe<Scalars['String']['output']>;
  subscription_number?: Maybe<Scalars['String']['output']>;
  tax_rounding?: Maybe<Scalars['String']['output']>;
  taxes?: Maybe<Array<Maybe<Hub_Taxes>>>;
  total_orders?: Maybe<Scalars['Float']['output']>;
  trial_extended_count?: Maybe<Scalars['Float']['output']>;
  unbilled_charge?: Maybe<Hub_ZohoUnbilledCharge>;
  unbilled_charge_amount?: Maybe<Scalars['Int']['output']>;
  unbilled_charge_id?: Maybe<Scalars['String']['output']>;
  updated_time?: Maybe<Scalars['String']['output']>;
  zcrm_potential_id?: Maybe<Scalars['String']['output']>;
  zcrm_potential_name?: Maybe<Scalars['String']['output']>;
};

export type Hub_ZohoUnbilledCharge = {
  __typename?: 'hub_ZohoUnbilledCharge';
  balance?: Maybe<Scalars['Float']['output']>;
  billing_address?: Maybe<Hub_BillingAddress>;
  coupons?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  created_time?: Maybe<Scalars['String']['output']>;
  currency_code?: Maybe<Scalars['String']['output']>;
  currency_symbol?: Maybe<Scalars['String']['output']>;
  custom_field_hash?: Maybe<Hub_CustomFieldHash>;
  custom_fields?: Maybe<Array<Maybe<Hub_CustomFields>>>;
  customer_custom_fields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  customer_id?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  is_inclusive_tax?: Maybe<Scalars['Boolean']['output']>;
  is_online_subscription?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  price_precision?: Maybe<Scalars['Float']['output']>;
  salesperson_id?: Maybe<Scalars['String']['output']>;
  salesperson_name?: Maybe<Scalars['String']['output']>;
  shipping_address?: Maybe<Hub_ShippingAddress>;
  status?: Maybe<Scalars['String']['output']>;
  sub_total?: Maybe<Scalars['Float']['output']>;
  subscription_id?: Maybe<Scalars['String']['output']>;
  tax_rounding?: Maybe<Scalars['String']['output']>;
  tax_total?: Maybe<Scalars['Float']['output']>;
  taxes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  total?: Maybe<Scalars['Float']['output']>;
  transaction_type?: Maybe<Scalars['String']['output']>;
  unbilled_charge_date?: Maybe<Scalars['String']['output']>;
  unbilled_charge_id?: Maybe<Scalars['String']['output']>;
  unbilled_charge_items?: Maybe<Array<Maybe<Hub_UnbilledChargeItems>>>;
  unused_credits_receivable_amount?: Maybe<Scalars['Float']['output']>;
  updated_time?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type Json_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['json']['input']>;
  _gt?: InputMaybe<Scalars['json']['input']>;
  _gte?: InputMaybe<Scalars['json']['input']>;
  _in?: InputMaybe<Array<Scalars['json']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['json']['input']>;
  _lte?: InputMaybe<Scalars['json']['input']>;
  _neq?: InputMaybe<Scalars['json']['input']>;
  _nin?: InputMaybe<Array<Scalars['json']['input']>>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** columns and relationships of "last_known_locations" */
export type Last_Known_Locations = {
  __typename?: 'last_known_locations';
  /** An object relationship */
  accountByUserAccountId?: Maybe<Accounts>;
  address?: Maybe<Scalars['String']['output']>;
  address_components?: Maybe<Scalars['json']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  distance_kms?: Maybe<Scalars['Float']['output']>;
  id: Scalars['bpchar']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  lat: Scalars['float8']['output'];
  lng: Scalars['float8']['output'];
  location?: Maybe<Scalars['geography']['output']>;
  request_account_ids?: Maybe<Scalars['jsonb']['output']>;
  request_created_at?: Maybe<Scalars['timestamptz']['output']>;
  request_farmer_id?: Maybe<Scalars['bpchar']['output']>;
  request_field_force_ids?: Maybe<Scalars['jsonb']['output']>;
  request_id?: Maybe<Scalars['bpchar']['output']>;
  role_name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  service_request?: Maybe<Service_Requests>;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
  /** An object relationship */
  userByRequestFarmerId?: Maybe<Users>;
  user_account_id?: Maybe<Scalars['bpchar']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};


/** columns and relationships of "last_known_locations" */
export type Last_Known_LocationsAddress_ComponentsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "last_known_locations" */
export type Last_Known_LocationsRequest_Account_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "last_known_locations" */
export type Last_Known_LocationsRequest_Field_Force_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "last_known_locations" */
export type Last_Known_Locations_Aggregate = {
  __typename?: 'last_known_locations_aggregate';
  aggregate?: Maybe<Last_Known_Locations_Aggregate_Fields>;
  nodes: Array<Last_Known_Locations>;
};

export type Last_Known_Locations_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Last_Known_Locations_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Last_Known_Locations_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Last_Known_Locations_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Last_Known_Locations_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Last_Known_Locations_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Last_Known_Locations_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Last_Known_Locations_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Last_Known_Locations_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Last_Known_Locations_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Last_Known_Locations_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Last_Known_Locations_Aggregate_Bool_Exp_Var_Samp>;
};

export type Last_Known_Locations_Aggregate_Bool_Exp_Avg = {
  arguments: Last_Known_Locations_Select_Column_Last_Known_Locations_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Last_Known_Locations_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Last_Known_Locations_Aggregate_Bool_Exp_Bool_And = {
  arguments: Last_Known_Locations_Select_Column_Last_Known_Locations_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Last_Known_Locations_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Last_Known_Locations_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Last_Known_Locations_Select_Column_Last_Known_Locations_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Last_Known_Locations_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Last_Known_Locations_Aggregate_Bool_Exp_Corr = {
  arguments: Last_Known_Locations_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Last_Known_Locations_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Last_Known_Locations_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Last_Known_Locations_Select_Column_Last_Known_Locations_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Last_Known_Locations_Select_Column_Last_Known_Locations_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Last_Known_Locations_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Last_Known_Locations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Last_Known_Locations_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Last_Known_Locations_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Last_Known_Locations_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Last_Known_Locations_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Last_Known_Locations_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Last_Known_Locations_Select_Column_Last_Known_Locations_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Last_Known_Locations_Select_Column_Last_Known_Locations_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Last_Known_Locations_Aggregate_Bool_Exp_Max = {
  arguments: Last_Known_Locations_Select_Column_Last_Known_Locations_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Last_Known_Locations_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Last_Known_Locations_Aggregate_Bool_Exp_Min = {
  arguments: Last_Known_Locations_Select_Column_Last_Known_Locations_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Last_Known_Locations_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Last_Known_Locations_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Last_Known_Locations_Select_Column_Last_Known_Locations_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Last_Known_Locations_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Last_Known_Locations_Aggregate_Bool_Exp_Sum = {
  arguments: Last_Known_Locations_Select_Column_Last_Known_Locations_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Last_Known_Locations_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Last_Known_Locations_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Last_Known_Locations_Select_Column_Last_Known_Locations_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Last_Known_Locations_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "last_known_locations" */
export type Last_Known_Locations_Aggregate_Fields = {
  __typename?: 'last_known_locations_aggregate_fields';
  avg?: Maybe<Last_Known_Locations_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Last_Known_Locations_Max_Fields>;
  min?: Maybe<Last_Known_Locations_Min_Fields>;
  stddev?: Maybe<Last_Known_Locations_Stddev_Fields>;
  stddev_pop?: Maybe<Last_Known_Locations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Last_Known_Locations_Stddev_Samp_Fields>;
  sum?: Maybe<Last_Known_Locations_Sum_Fields>;
  var_pop?: Maybe<Last_Known_Locations_Var_Pop_Fields>;
  var_samp?: Maybe<Last_Known_Locations_Var_Samp_Fields>;
  variance?: Maybe<Last_Known_Locations_Variance_Fields>;
};


/** aggregate fields of "last_known_locations" */
export type Last_Known_Locations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Last_Known_Locations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "last_known_locations" */
export type Last_Known_Locations_Aggregate_Order_By = {
  avg?: InputMaybe<Last_Known_Locations_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Last_Known_Locations_Max_Order_By>;
  min?: InputMaybe<Last_Known_Locations_Min_Order_By>;
  stddev?: InputMaybe<Last_Known_Locations_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Last_Known_Locations_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Last_Known_Locations_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Last_Known_Locations_Sum_Order_By>;
  var_pop?: InputMaybe<Last_Known_Locations_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Last_Known_Locations_Var_Samp_Order_By>;
  variance?: InputMaybe<Last_Known_Locations_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Last_Known_Locations_Append_Input = {
  request_account_ids?: InputMaybe<Scalars['jsonb']['input']>;
  request_field_force_ids?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "last_known_locations" */
export type Last_Known_Locations_Arr_Rel_Insert_Input = {
  data: Array<Last_Known_Locations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Last_Known_Locations_On_Conflict>;
};

/** aggregate avg on columns */
export type Last_Known_Locations_Avg_Fields = {
  __typename?: 'last_known_locations_avg_fields';
  distance_kms?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "last_known_locations" */
export type Last_Known_Locations_Avg_Order_By = {
  distance_kms?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "last_known_locations". All fields are combined with a logical 'AND'. */
export type Last_Known_Locations_Bool_Exp = {
  _and?: InputMaybe<Array<Last_Known_Locations_Bool_Exp>>;
  _not?: InputMaybe<Last_Known_Locations_Bool_Exp>;
  _or?: InputMaybe<Array<Last_Known_Locations_Bool_Exp>>;
  accountByUserAccountId?: InputMaybe<Accounts_Bool_Exp>;
  address?: InputMaybe<String_Comparison_Exp>;
  address_components?: InputMaybe<Json_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  distance_kms?: InputMaybe<Float_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  lat?: InputMaybe<Float8_Comparison_Exp>;
  lng?: InputMaybe<Float8_Comparison_Exp>;
  location?: InputMaybe<Geography_Comparison_Exp>;
  request_account_ids?: InputMaybe<Jsonb_Comparison_Exp>;
  request_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  request_farmer_id?: InputMaybe<Bpchar_Comparison_Exp>;
  request_field_force_ids?: InputMaybe<Jsonb_Comparison_Exp>;
  request_id?: InputMaybe<Bpchar_Comparison_Exp>;
  role_name?: InputMaybe<String_Comparison_Exp>;
  service_request?: InputMaybe<Service_Requests_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userByRequestFarmerId?: InputMaybe<Users_Bool_Exp>;
  user_account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "last_known_locations" */
export enum Last_Known_Locations_Constraint {
  /** unique or primary key constraint on columns "id" */
  LastKnownLocationsPkey = 'last_known_locations_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Last_Known_Locations_Delete_At_Path_Input = {
  request_account_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  request_field_force_ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Last_Known_Locations_Delete_Elem_Input = {
  request_account_ids?: InputMaybe<Scalars['Int']['input']>;
  request_field_force_ids?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Last_Known_Locations_Delete_Key_Input = {
  request_account_ids?: InputMaybe<Scalars['String']['input']>;
  request_field_force_ids?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "last_known_locations" */
export type Last_Known_Locations_Inc_Input = {
  distance_kms?: InputMaybe<Scalars['Float']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "last_known_locations" */
export type Last_Known_Locations_Insert_Input = {
  accountByUserAccountId?: InputMaybe<Accounts_Obj_Rel_Insert_Input>;
  address?: InputMaybe<Scalars['String']['input']>;
  address_components?: InputMaybe<Scalars['json']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  distance_kms?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  location?: InputMaybe<Scalars['geography']['input']>;
  request_account_ids?: InputMaybe<Scalars['jsonb']['input']>;
  request_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  request_farmer_id?: InputMaybe<Scalars['bpchar']['input']>;
  request_field_force_ids?: InputMaybe<Scalars['jsonb']['input']>;
  request_id?: InputMaybe<Scalars['bpchar']['input']>;
  role_name?: InputMaybe<Scalars['String']['input']>;
  service_request?: InputMaybe<Service_Requests_Obj_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userByRequestFarmerId?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_account_id?: InputMaybe<Scalars['bpchar']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Last_Known_Locations_Max_Fields = {
  __typename?: 'last_known_locations_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  distance_kms?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  request_created_at?: Maybe<Scalars['timestamptz']['output']>;
  request_farmer_id?: Maybe<Scalars['bpchar']['output']>;
  request_id?: Maybe<Scalars['bpchar']['output']>;
  role_name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_account_id?: Maybe<Scalars['bpchar']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by max() on columns of table "last_known_locations" */
export type Last_Known_Locations_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  distance_kms?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  request_created_at?: InputMaybe<Order_By>;
  request_farmer_id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  role_name?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_account_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Last_Known_Locations_Min_Fields = {
  __typename?: 'last_known_locations_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  distance_kms?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  request_created_at?: Maybe<Scalars['timestamptz']['output']>;
  request_farmer_id?: Maybe<Scalars['bpchar']['output']>;
  request_id?: Maybe<Scalars['bpchar']['output']>;
  role_name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_account_id?: Maybe<Scalars['bpchar']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by min() on columns of table "last_known_locations" */
export type Last_Known_Locations_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  distance_kms?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  request_created_at?: InputMaybe<Order_By>;
  request_farmer_id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  role_name?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_account_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "last_known_locations" */
export type Last_Known_Locations_Mutation_Response = {
  __typename?: 'last_known_locations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Last_Known_Locations>;
};

/** input type for inserting object relation for remote table "last_known_locations" */
export type Last_Known_Locations_Obj_Rel_Insert_Input = {
  data: Last_Known_Locations_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Last_Known_Locations_On_Conflict>;
};

/** on_conflict condition type for table "last_known_locations" */
export type Last_Known_Locations_On_Conflict = {
  constraint: Last_Known_Locations_Constraint;
  update_columns?: Array<Last_Known_Locations_Update_Column>;
  where?: InputMaybe<Last_Known_Locations_Bool_Exp>;
};

/** Ordering options when selecting data from "last_known_locations". */
export type Last_Known_Locations_Order_By = {
  accountByUserAccountId?: InputMaybe<Accounts_Order_By>;
  address?: InputMaybe<Order_By>;
  address_components?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  distance_kms?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  request_account_ids?: InputMaybe<Order_By>;
  request_created_at?: InputMaybe<Order_By>;
  request_farmer_id?: InputMaybe<Order_By>;
  request_field_force_ids?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  role_name?: InputMaybe<Order_By>;
  service_request?: InputMaybe<Service_Requests_Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userByRequestFarmerId?: InputMaybe<Users_Order_By>;
  user_account_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: last_known_locations */
export type Last_Known_Locations_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Last_Known_Locations_Prepend_Input = {
  request_account_ids?: InputMaybe<Scalars['jsonb']['input']>;
  request_field_force_ids?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "last_known_locations" */
export enum Last_Known_Locations_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AddressComponents = 'address_components',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DistanceKms = 'distance_kms',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  Location = 'location',
  /** column name */
  RequestAccountIds = 'request_account_ids',
  /** column name */
  RequestCreatedAt = 'request_created_at',
  /** column name */
  RequestFarmerId = 'request_farmer_id',
  /** column name */
  RequestFieldForceIds = 'request_field_force_ids',
  /** column name */
  RequestId = 'request_id',
  /** column name */
  RoleName = 'role_name',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserAccountId = 'user_account_id',
  /** column name */
  UserId = 'user_id'
}

/** select "last_known_locations_aggregate_bool_exp_avg_arguments_columns" columns of table "last_known_locations" */
export enum Last_Known_Locations_Select_Column_Last_Known_Locations_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "last_known_locations_aggregate_bool_exp_bool_and_arguments_columns" columns of table "last_known_locations" */
export enum Last_Known_Locations_Select_Column_Last_Known_Locations_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "last_known_locations_aggregate_bool_exp_bool_or_arguments_columns" columns of table "last_known_locations" */
export enum Last_Known_Locations_Select_Column_Last_Known_Locations_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "last_known_locations_aggregate_bool_exp_corr_arguments_columns" columns of table "last_known_locations" */
export enum Last_Known_Locations_Select_Column_Last_Known_Locations_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "last_known_locations_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "last_known_locations" */
export enum Last_Known_Locations_Select_Column_Last_Known_Locations_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "last_known_locations_aggregate_bool_exp_max_arguments_columns" columns of table "last_known_locations" */
export enum Last_Known_Locations_Select_Column_Last_Known_Locations_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "last_known_locations_aggregate_bool_exp_min_arguments_columns" columns of table "last_known_locations" */
export enum Last_Known_Locations_Select_Column_Last_Known_Locations_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "last_known_locations_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "last_known_locations" */
export enum Last_Known_Locations_Select_Column_Last_Known_Locations_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "last_known_locations_aggregate_bool_exp_sum_arguments_columns" columns of table "last_known_locations" */
export enum Last_Known_Locations_Select_Column_Last_Known_Locations_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "last_known_locations_aggregate_bool_exp_var_samp_arguments_columns" columns of table "last_known_locations" */
export enum Last_Known_Locations_Select_Column_Last_Known_Locations_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** input type for updating data in table "last_known_locations" */
export type Last_Known_Locations_Set_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  address_components?: InputMaybe<Scalars['json']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  distance_kms?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  location?: InputMaybe<Scalars['geography']['input']>;
  request_account_ids?: InputMaybe<Scalars['jsonb']['input']>;
  request_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  request_farmer_id?: InputMaybe<Scalars['bpchar']['input']>;
  request_field_force_ids?: InputMaybe<Scalars['jsonb']['input']>;
  request_id?: InputMaybe<Scalars['bpchar']['input']>;
  role_name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_account_id?: InputMaybe<Scalars['bpchar']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate stddev on columns */
export type Last_Known_Locations_Stddev_Fields = {
  __typename?: 'last_known_locations_stddev_fields';
  distance_kms?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "last_known_locations" */
export type Last_Known_Locations_Stddev_Order_By = {
  distance_kms?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Last_Known_Locations_Stddev_Pop_Fields = {
  __typename?: 'last_known_locations_stddev_pop_fields';
  distance_kms?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "last_known_locations" */
export type Last_Known_Locations_Stddev_Pop_Order_By = {
  distance_kms?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Last_Known_Locations_Stddev_Samp_Fields = {
  __typename?: 'last_known_locations_stddev_samp_fields';
  distance_kms?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "last_known_locations" */
export type Last_Known_Locations_Stddev_Samp_Order_By = {
  distance_kms?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "last_known_locations" */
export type Last_Known_Locations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Last_Known_Locations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Last_Known_Locations_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  address_components?: InputMaybe<Scalars['json']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  distance_kms?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  location?: InputMaybe<Scalars['geography']['input']>;
  request_account_ids?: InputMaybe<Scalars['jsonb']['input']>;
  request_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  request_farmer_id?: InputMaybe<Scalars['bpchar']['input']>;
  request_field_force_ids?: InputMaybe<Scalars['jsonb']['input']>;
  request_id?: InputMaybe<Scalars['bpchar']['input']>;
  role_name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_account_id?: InputMaybe<Scalars['bpchar']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate sum on columns */
export type Last_Known_Locations_Sum_Fields = {
  __typename?: 'last_known_locations_sum_fields';
  distance_kms?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "last_known_locations" */
export type Last_Known_Locations_Sum_Order_By = {
  distance_kms?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** update columns of table "last_known_locations" */
export enum Last_Known_Locations_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AddressComponents = 'address_components',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DistanceKms = 'distance_kms',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  Location = 'location',
  /** column name */
  RequestAccountIds = 'request_account_ids',
  /** column name */
  RequestCreatedAt = 'request_created_at',
  /** column name */
  RequestFarmerId = 'request_farmer_id',
  /** column name */
  RequestFieldForceIds = 'request_field_force_ids',
  /** column name */
  RequestId = 'request_id',
  /** column name */
  RoleName = 'role_name',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserAccountId = 'user_account_id',
  /** column name */
  UserId = 'user_id'
}

export type Last_Known_Locations_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Last_Known_Locations_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Last_Known_Locations_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Last_Known_Locations_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Last_Known_Locations_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Last_Known_Locations_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Last_Known_Locations_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Last_Known_Locations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Last_Known_Locations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Last_Known_Locations_Var_Pop_Fields = {
  __typename?: 'last_known_locations_var_pop_fields';
  distance_kms?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "last_known_locations" */
export type Last_Known_Locations_Var_Pop_Order_By = {
  distance_kms?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Last_Known_Locations_Var_Samp_Fields = {
  __typename?: 'last_known_locations_var_samp_fields';
  distance_kms?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "last_known_locations" */
export type Last_Known_Locations_Var_Samp_Order_By = {
  distance_kms?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Last_Known_Locations_Variance_Fields = {
  __typename?: 'last_known_locations_variance_fields';
  distance_kms?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "last_known_locations" */
export type Last_Known_Locations_Variance_Order_By = {
  distance_kms?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** columns and relationships of "master_crops" */
export type Master_Crops = {
  __typename?: 'master_crops';
  /** An array relationship */
  account_crops: Array<Account_Crop>;
  /** An aggregate relationship */
  account_crops_aggregate: Account_Crop_Aggregate;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  crop_users: Array<Crop_User>;
  /** An aggregate relationship */
  crop_users_aggregate: Crop_User_Aggregate;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  display_order: Scalars['Int']['output'];
  /** An array relationship */
  farmer_plots: Array<Farmer_Plots>;
  /** An aggregate relationship */
  farmer_plots_aggregate: Farmer_Plots_Aggregate;
  id: Scalars['bpchar']['output'];
  image_url?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** An array relationship */
  service_requests: Array<Service_Requests>;
  /** An aggregate relationship */
  service_requests_aggregate: Service_Requests_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "master_crops" */
export type Master_CropsAccount_CropsArgs = {
  distinct_on?: InputMaybe<Array<Account_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Crop_Order_By>>;
  where?: InputMaybe<Account_Crop_Bool_Exp>;
};


/** columns and relationships of "master_crops" */
export type Master_CropsAccount_Crops_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Crop_Order_By>>;
  where?: InputMaybe<Account_Crop_Bool_Exp>;
};


/** columns and relationships of "master_crops" */
export type Master_CropsCrop_UsersArgs = {
  distinct_on?: InputMaybe<Array<Crop_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crop_User_Order_By>>;
  where?: InputMaybe<Crop_User_Bool_Exp>;
};


/** columns and relationships of "master_crops" */
export type Master_CropsCrop_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crop_User_Order_By>>;
  where?: InputMaybe<Crop_User_Bool_Exp>;
};


/** columns and relationships of "master_crops" */
export type Master_CropsFarmer_PlotsArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Plots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Plots_Order_By>>;
  where?: InputMaybe<Farmer_Plots_Bool_Exp>;
};


/** columns and relationships of "master_crops" */
export type Master_CropsFarmer_Plots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Plots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Plots_Order_By>>;
  where?: InputMaybe<Farmer_Plots_Bool_Exp>;
};


/** columns and relationships of "master_crops" */
export type Master_CropsService_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Service_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Requests_Order_By>>;
  where?: InputMaybe<Service_Requests_Bool_Exp>;
};


/** columns and relationships of "master_crops" */
export type Master_CropsService_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Requests_Order_By>>;
  where?: InputMaybe<Service_Requests_Bool_Exp>;
};

/** aggregated selection of "master_crops" */
export type Master_Crops_Aggregate = {
  __typename?: 'master_crops_aggregate';
  aggregate?: Maybe<Master_Crops_Aggregate_Fields>;
  nodes: Array<Master_Crops>;
};

/** aggregate fields of "master_crops" */
export type Master_Crops_Aggregate_Fields = {
  __typename?: 'master_crops_aggregate_fields';
  avg?: Maybe<Master_Crops_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Master_Crops_Max_Fields>;
  min?: Maybe<Master_Crops_Min_Fields>;
  stddev?: Maybe<Master_Crops_Stddev_Fields>;
  stddev_pop?: Maybe<Master_Crops_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Master_Crops_Stddev_Samp_Fields>;
  sum?: Maybe<Master_Crops_Sum_Fields>;
  var_pop?: Maybe<Master_Crops_Var_Pop_Fields>;
  var_samp?: Maybe<Master_Crops_Var_Samp_Fields>;
  variance?: Maybe<Master_Crops_Variance_Fields>;
};


/** aggregate fields of "master_crops" */
export type Master_Crops_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Master_Crops_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Master_Crops_Avg_Fields = {
  __typename?: 'master_crops_avg_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "master_crops". All fields are combined with a logical 'AND'. */
export type Master_Crops_Bool_Exp = {
  _and?: InputMaybe<Array<Master_Crops_Bool_Exp>>;
  _not?: InputMaybe<Master_Crops_Bool_Exp>;
  _or?: InputMaybe<Array<Master_Crops_Bool_Exp>>;
  account_crops?: InputMaybe<Account_Crop_Bool_Exp>;
  account_crops_aggregate?: InputMaybe<Account_Crop_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  crop_users?: InputMaybe<Crop_User_Bool_Exp>;
  crop_users_aggregate?: InputMaybe<Crop_User_Aggregate_Bool_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_order?: InputMaybe<Int_Comparison_Exp>;
  farmer_plots?: InputMaybe<Farmer_Plots_Bool_Exp>;
  farmer_plots_aggregate?: InputMaybe<Farmer_Plots_Aggregate_Bool_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  service_requests?: InputMaybe<Service_Requests_Bool_Exp>;
  service_requests_aggregate?: InputMaybe<Service_Requests_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "master_crops" */
export enum Master_Crops_Constraint {
  /** unique or primary key constraint on columns "name" */
  MasterCropsNameIdx = 'master_crops_name_idx',
  /** unique or primary key constraint on columns "id" */
  MasterCropsPkey = 'master_crops_pkey'
}

/** input type for incrementing numeric columns in table "master_crops" */
export type Master_Crops_Inc_Input = {
  display_order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "master_crops" */
export type Master_Crops_Insert_Input = {
  account_crops?: InputMaybe<Account_Crop_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crop_users?: InputMaybe<Crop_User_Arr_Rel_Insert_Input>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
  farmer_plots?: InputMaybe<Farmer_Plots_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  image_url?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  service_requests?: InputMaybe<Service_Requests_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Master_Crops_Max_Fields = {
  __typename?: 'master_crops_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  display_order?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Master_Crops_Min_Fields = {
  __typename?: 'master_crops_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  display_order?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "master_crops" */
export type Master_Crops_Mutation_Response = {
  __typename?: 'master_crops_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Master_Crops>;
};

/** input type for inserting object relation for remote table "master_crops" */
export type Master_Crops_Obj_Rel_Insert_Input = {
  data: Master_Crops_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Master_Crops_On_Conflict>;
};

/** on_conflict condition type for table "master_crops" */
export type Master_Crops_On_Conflict = {
  constraint: Master_Crops_Constraint;
  update_columns?: Array<Master_Crops_Update_Column>;
  where?: InputMaybe<Master_Crops_Bool_Exp>;
};

/** Ordering options when selecting data from "master_crops". */
export type Master_Crops_Order_By = {
  account_crops_aggregate?: InputMaybe<Account_Crop_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  crop_users_aggregate?: InputMaybe<Crop_User_Aggregate_Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  display_order?: InputMaybe<Order_By>;
  farmer_plots_aggregate?: InputMaybe<Farmer_Plots_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  service_requests_aggregate?: InputMaybe<Service_Requests_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: master_crops */
export type Master_Crops_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** select columns of table "master_crops" */
export enum Master_Crops_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DisplayOrder = 'display_order',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "master_crops" */
export type Master_Crops_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  image_url?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Master_Crops_Stddev_Fields = {
  __typename?: 'master_crops_stddev_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Master_Crops_Stddev_Pop_Fields = {
  __typename?: 'master_crops_stddev_pop_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Master_Crops_Stddev_Samp_Fields = {
  __typename?: 'master_crops_stddev_samp_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "master_crops" */
export type Master_Crops_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Master_Crops_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Master_Crops_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  image_url?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Master_Crops_Sum_Fields = {
  __typename?: 'master_crops_sum_fields';
  display_order?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "master_crops" */
export enum Master_Crops_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DisplayOrder = 'display_order',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Master_Crops_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Master_Crops_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Master_Crops_Set_Input>;
  /** filter the rows which have to be updated */
  where: Master_Crops_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Master_Crops_Var_Pop_Fields = {
  __typename?: 'master_crops_var_pop_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Master_Crops_Var_Samp_Fields = {
  __typename?: 'master_crops_var_samp_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Master_Crops_Variance_Fields = {
  __typename?: 'master_crops_variance_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "master_segments" */
export type Master_Segments = {
  __typename?: 'master_segments';
  /** An array relationship */
  account_segments: Array<Account_Segment>;
  /** An aggregate relationship */
  account_segments_aggregate: Account_Segment_Aggregate;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  display_order: Scalars['Int']['output'];
  id: Scalars['bpchar']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  segment_users: Array<Segment_User>;
  /** An aggregate relationship */
  segment_users_aggregate: Segment_User_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "master_segments" */
export type Master_SegmentsAccount_SegmentsArgs = {
  distinct_on?: InputMaybe<Array<Account_Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Segment_Order_By>>;
  where?: InputMaybe<Account_Segment_Bool_Exp>;
};


/** columns and relationships of "master_segments" */
export type Master_SegmentsAccount_Segments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Segment_Order_By>>;
  where?: InputMaybe<Account_Segment_Bool_Exp>;
};


/** columns and relationships of "master_segments" */
export type Master_SegmentsSegment_UsersArgs = {
  distinct_on?: InputMaybe<Array<Segment_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Segment_User_Order_By>>;
  where?: InputMaybe<Segment_User_Bool_Exp>;
};


/** columns and relationships of "master_segments" */
export type Master_SegmentsSegment_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Segment_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Segment_User_Order_By>>;
  where?: InputMaybe<Segment_User_Bool_Exp>;
};

/** aggregated selection of "master_segments" */
export type Master_Segments_Aggregate = {
  __typename?: 'master_segments_aggregate';
  aggregate?: Maybe<Master_Segments_Aggregate_Fields>;
  nodes: Array<Master_Segments>;
};

/** aggregate fields of "master_segments" */
export type Master_Segments_Aggregate_Fields = {
  __typename?: 'master_segments_aggregate_fields';
  avg?: Maybe<Master_Segments_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Master_Segments_Max_Fields>;
  min?: Maybe<Master_Segments_Min_Fields>;
  stddev?: Maybe<Master_Segments_Stddev_Fields>;
  stddev_pop?: Maybe<Master_Segments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Master_Segments_Stddev_Samp_Fields>;
  sum?: Maybe<Master_Segments_Sum_Fields>;
  var_pop?: Maybe<Master_Segments_Var_Pop_Fields>;
  var_samp?: Maybe<Master_Segments_Var_Samp_Fields>;
  variance?: Maybe<Master_Segments_Variance_Fields>;
};


/** aggregate fields of "master_segments" */
export type Master_Segments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Master_Segments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Master_Segments_Avg_Fields = {
  __typename?: 'master_segments_avg_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "master_segments". All fields are combined with a logical 'AND'. */
export type Master_Segments_Bool_Exp = {
  _and?: InputMaybe<Array<Master_Segments_Bool_Exp>>;
  _not?: InputMaybe<Master_Segments_Bool_Exp>;
  _or?: InputMaybe<Array<Master_Segments_Bool_Exp>>;
  account_segments?: InputMaybe<Account_Segment_Bool_Exp>;
  account_segments_aggregate?: InputMaybe<Account_Segment_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_order?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  segment_users?: InputMaybe<Segment_User_Bool_Exp>;
  segment_users_aggregate?: InputMaybe<Segment_User_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "master_segments" */
export enum Master_Segments_Constraint {
  /** unique or primary key constraint on columns "id" */
  MasterSegmentsPkey = 'master_segments_pkey'
}

/** input type for incrementing numeric columns in table "master_segments" */
export type Master_Segments_Inc_Input = {
  display_order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "master_segments" */
export type Master_Segments_Insert_Input = {
  account_segments?: InputMaybe<Account_Segment_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  segment_users?: InputMaybe<Segment_User_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Master_Segments_Max_Fields = {
  __typename?: 'master_segments_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  display_order?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Master_Segments_Min_Fields = {
  __typename?: 'master_segments_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  display_order?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "master_segments" */
export type Master_Segments_Mutation_Response = {
  __typename?: 'master_segments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Master_Segments>;
};

/** input type for inserting object relation for remote table "master_segments" */
export type Master_Segments_Obj_Rel_Insert_Input = {
  data: Master_Segments_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Master_Segments_On_Conflict>;
};

/** on_conflict condition type for table "master_segments" */
export type Master_Segments_On_Conflict = {
  constraint: Master_Segments_Constraint;
  update_columns?: Array<Master_Segments_Update_Column>;
  where?: InputMaybe<Master_Segments_Bool_Exp>;
};

/** Ordering options when selecting data from "master_segments". */
export type Master_Segments_Order_By = {
  account_segments_aggregate?: InputMaybe<Account_Segment_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  display_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  segment_users_aggregate?: InputMaybe<Segment_User_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: master_segments */
export type Master_Segments_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** select columns of table "master_segments" */
export enum Master_Segments_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DisplayOrder = 'display_order',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "master_segments" */
export type Master_Segments_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Master_Segments_Stddev_Fields = {
  __typename?: 'master_segments_stddev_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Master_Segments_Stddev_Pop_Fields = {
  __typename?: 'master_segments_stddev_pop_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Master_Segments_Stddev_Samp_Fields = {
  __typename?: 'master_segments_stddev_samp_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "master_segments" */
export type Master_Segments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Master_Segments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Master_Segments_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Master_Segments_Sum_Fields = {
  __typename?: 'master_segments_sum_fields';
  display_order?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "master_segments" */
export enum Master_Segments_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DisplayOrder = 'display_order',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Master_Segments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Master_Segments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Master_Segments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Master_Segments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Master_Segments_Var_Pop_Fields = {
  __typename?: 'master_segments_var_pop_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Master_Segments_Var_Samp_Fields = {
  __typename?: 'master_segments_var_samp_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Master_Segments_Variance_Fields = {
  __typename?: 'master_segments_variance_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "messaging_campaign_recipients" */
export type Messaging_Campaign_Recipients = {
  __typename?: 'messaging_campaign_recipients';
  campaign_id: Scalars['bpchar']['output'];
  channel: Scalars['String']['output'];
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  farmer_master?: Maybe<Farmer_Master>;
  id: Scalars['bpchar']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  recipient_id?: Maybe<Scalars['bpchar']['output']>;
  recipient_type: Scalars['String']['output'];
  scheduled_at?: Maybe<Scalars['timestamptz']['output']>;
  status: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "messaging_campaign_recipients" */
export type Messaging_Campaign_Recipients_Aggregate = {
  __typename?: 'messaging_campaign_recipients_aggregate';
  aggregate?: Maybe<Messaging_Campaign_Recipients_Aggregate_Fields>;
  nodes: Array<Messaging_Campaign_Recipients>;
};

export type Messaging_Campaign_Recipients_Aggregate_Bool_Exp = {
  count?: InputMaybe<Messaging_Campaign_Recipients_Aggregate_Bool_Exp_Count>;
};

export type Messaging_Campaign_Recipients_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Messaging_Campaign_Recipients_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Messaging_Campaign_Recipients_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "messaging_campaign_recipients" */
export type Messaging_Campaign_Recipients_Aggregate_Fields = {
  __typename?: 'messaging_campaign_recipients_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Messaging_Campaign_Recipients_Max_Fields>;
  min?: Maybe<Messaging_Campaign_Recipients_Min_Fields>;
};


/** aggregate fields of "messaging_campaign_recipients" */
export type Messaging_Campaign_Recipients_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Messaging_Campaign_Recipients_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "messaging_campaign_recipients" */
export type Messaging_Campaign_Recipients_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Messaging_Campaign_Recipients_Max_Order_By>;
  min?: InputMaybe<Messaging_Campaign_Recipients_Min_Order_By>;
};

/** input type for inserting array relation for remote table "messaging_campaign_recipients" */
export type Messaging_Campaign_Recipients_Arr_Rel_Insert_Input = {
  data: Array<Messaging_Campaign_Recipients_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Messaging_Campaign_Recipients_On_Conflict>;
};

/** Boolean expression to filter rows from the table "messaging_campaign_recipients". All fields are combined with a logical 'AND'. */
export type Messaging_Campaign_Recipients_Bool_Exp = {
  _and?: InputMaybe<Array<Messaging_Campaign_Recipients_Bool_Exp>>;
  _not?: InputMaybe<Messaging_Campaign_Recipients_Bool_Exp>;
  _or?: InputMaybe<Array<Messaging_Campaign_Recipients_Bool_Exp>>;
  campaign_id?: InputMaybe<Bpchar_Comparison_Exp>;
  channel?: InputMaybe<String_Comparison_Exp>;
  content?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  farmer_master?: InputMaybe<Farmer_Master_Bool_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  recipient_id?: InputMaybe<Bpchar_Comparison_Exp>;
  recipient_type?: InputMaybe<String_Comparison_Exp>;
  scheduled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "messaging_campaign_recipients" */
export enum Messaging_Campaign_Recipients_Constraint {
  /** unique or primary key constraint on columns "id" */
  MessagingCampaignRecipientsPkey = 'messaging_campaign_recipients_pkey',
  /** unique or primary key constraint on columns "recipient_id", "recipient_type", "campaign_id" */
  UniqueCampaignRecipient = 'unique_campaign_recipient'
}

/** input type for inserting data into table "messaging_campaign_recipients" */
export type Messaging_Campaign_Recipients_Insert_Input = {
  campaign_id?: InputMaybe<Scalars['bpchar']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer_master?: InputMaybe<Farmer_Master_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  recipient_id?: InputMaybe<Scalars['bpchar']['input']>;
  recipient_type?: InputMaybe<Scalars['String']['input']>;
  scheduled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Messaging_Campaign_Recipients_Max_Fields = {
  __typename?: 'messaging_campaign_recipients_max_fields';
  campaign_id?: Maybe<Scalars['bpchar']['output']>;
  channel?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  recipient_id?: Maybe<Scalars['bpchar']['output']>;
  recipient_type?: Maybe<Scalars['String']['output']>;
  scheduled_at?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "messaging_campaign_recipients" */
export type Messaging_Campaign_Recipients_Max_Order_By = {
  campaign_id?: InputMaybe<Order_By>;
  channel?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  recipient_id?: InputMaybe<Order_By>;
  recipient_type?: InputMaybe<Order_By>;
  scheduled_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Messaging_Campaign_Recipients_Min_Fields = {
  __typename?: 'messaging_campaign_recipients_min_fields';
  campaign_id?: Maybe<Scalars['bpchar']['output']>;
  channel?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  recipient_id?: Maybe<Scalars['bpchar']['output']>;
  recipient_type?: Maybe<Scalars['String']['output']>;
  scheduled_at?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "messaging_campaign_recipients" */
export type Messaging_Campaign_Recipients_Min_Order_By = {
  campaign_id?: InputMaybe<Order_By>;
  channel?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  recipient_id?: InputMaybe<Order_By>;
  recipient_type?: InputMaybe<Order_By>;
  scheduled_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "messaging_campaign_recipients" */
export type Messaging_Campaign_Recipients_Mutation_Response = {
  __typename?: 'messaging_campaign_recipients_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Messaging_Campaign_Recipients>;
};

/** on_conflict condition type for table "messaging_campaign_recipients" */
export type Messaging_Campaign_Recipients_On_Conflict = {
  constraint: Messaging_Campaign_Recipients_Constraint;
  update_columns?: Array<Messaging_Campaign_Recipients_Update_Column>;
  where?: InputMaybe<Messaging_Campaign_Recipients_Bool_Exp>;
};

/** Ordering options when selecting data from "messaging_campaign_recipients". */
export type Messaging_Campaign_Recipients_Order_By = {
  campaign_id?: InputMaybe<Order_By>;
  channel?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  farmer_master?: InputMaybe<Farmer_Master_Order_By>;
  id?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  recipient_id?: InputMaybe<Order_By>;
  recipient_type?: InputMaybe<Order_By>;
  scheduled_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: messaging_campaign_recipients */
export type Messaging_Campaign_Recipients_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** select columns of table "messaging_campaign_recipients" */
export enum Messaging_Campaign_Recipients_Select_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  Channel = 'channel',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Phone = 'phone',
  /** column name */
  RecipientId = 'recipient_id',
  /** column name */
  RecipientType = 'recipient_type',
  /** column name */
  ScheduledAt = 'scheduled_at',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "messaging_campaign_recipients" */
export type Messaging_Campaign_Recipients_Set_Input = {
  campaign_id?: InputMaybe<Scalars['bpchar']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  recipient_id?: InputMaybe<Scalars['bpchar']['input']>;
  recipient_type?: InputMaybe<Scalars['String']['input']>;
  scheduled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "messaging_campaign_recipients" */
export type Messaging_Campaign_Recipients_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Messaging_Campaign_Recipients_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Messaging_Campaign_Recipients_Stream_Cursor_Value_Input = {
  campaign_id?: InputMaybe<Scalars['bpchar']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  recipient_id?: InputMaybe<Scalars['bpchar']['input']>;
  recipient_type?: InputMaybe<Scalars['String']['input']>;
  scheduled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "messaging_campaign_recipients" */
export enum Messaging_Campaign_Recipients_Update_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  Channel = 'channel',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Phone = 'phone',
  /** column name */
  RecipientId = 'recipient_id',
  /** column name */
  RecipientType = 'recipient_type',
  /** column name */
  ScheduledAt = 'scheduled_at',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Messaging_Campaign_Recipients_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Messaging_Campaign_Recipients_Set_Input>;
  /** filter the rows which have to be updated */
  where: Messaging_Campaign_Recipients_Bool_Exp;
};

/** columns and relationships of "messaging_campaign_segments" */
export type Messaging_Campaign_Segments = {
  __typename?: 'messaging_campaign_segments';
  campaign_id: Scalars['bpchar']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['bpchar']['output'];
  /** An object relationship */
  segment: Crm_Segments;
  segment_id: Scalars['bpchar']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "messaging_campaign_segments" */
export type Messaging_Campaign_Segments_Aggregate = {
  __typename?: 'messaging_campaign_segments_aggregate';
  aggregate?: Maybe<Messaging_Campaign_Segments_Aggregate_Fields>;
  nodes: Array<Messaging_Campaign_Segments>;
};

export type Messaging_Campaign_Segments_Aggregate_Bool_Exp = {
  count?: InputMaybe<Messaging_Campaign_Segments_Aggregate_Bool_Exp_Count>;
};

export type Messaging_Campaign_Segments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Messaging_Campaign_Segments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Messaging_Campaign_Segments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "messaging_campaign_segments" */
export type Messaging_Campaign_Segments_Aggregate_Fields = {
  __typename?: 'messaging_campaign_segments_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Messaging_Campaign_Segments_Max_Fields>;
  min?: Maybe<Messaging_Campaign_Segments_Min_Fields>;
};


/** aggregate fields of "messaging_campaign_segments" */
export type Messaging_Campaign_Segments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Messaging_Campaign_Segments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "messaging_campaign_segments" */
export type Messaging_Campaign_Segments_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Messaging_Campaign_Segments_Max_Order_By>;
  min?: InputMaybe<Messaging_Campaign_Segments_Min_Order_By>;
};

/** input type for inserting array relation for remote table "messaging_campaign_segments" */
export type Messaging_Campaign_Segments_Arr_Rel_Insert_Input = {
  data: Array<Messaging_Campaign_Segments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Messaging_Campaign_Segments_On_Conflict>;
};

/** Boolean expression to filter rows from the table "messaging_campaign_segments". All fields are combined with a logical 'AND'. */
export type Messaging_Campaign_Segments_Bool_Exp = {
  _and?: InputMaybe<Array<Messaging_Campaign_Segments_Bool_Exp>>;
  _not?: InputMaybe<Messaging_Campaign_Segments_Bool_Exp>;
  _or?: InputMaybe<Array<Messaging_Campaign_Segments_Bool_Exp>>;
  campaign_id?: InputMaybe<Bpchar_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  segment?: InputMaybe<Crm_Segments_Bool_Exp>;
  segment_id?: InputMaybe<Bpchar_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "messaging_campaign_segments" */
export enum Messaging_Campaign_Segments_Constraint {
  /** unique or primary key constraint on columns "id" */
  MessagingCampaignSegmentsPkey = 'messaging_campaign_segments_pkey'
}

/** input type for inserting data into table "messaging_campaign_segments" */
export type Messaging_Campaign_Segments_Insert_Input = {
  campaign_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  segment?: InputMaybe<Crm_Segments_Obj_Rel_Insert_Input>;
  segment_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Messaging_Campaign_Segments_Max_Fields = {
  __typename?: 'messaging_campaign_segments_max_fields';
  campaign_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  segment_id?: Maybe<Scalars['bpchar']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "messaging_campaign_segments" */
export type Messaging_Campaign_Segments_Max_Order_By = {
  campaign_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  segment_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Messaging_Campaign_Segments_Min_Fields = {
  __typename?: 'messaging_campaign_segments_min_fields';
  campaign_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  segment_id?: Maybe<Scalars['bpchar']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "messaging_campaign_segments" */
export type Messaging_Campaign_Segments_Min_Order_By = {
  campaign_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  segment_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "messaging_campaign_segments" */
export type Messaging_Campaign_Segments_Mutation_Response = {
  __typename?: 'messaging_campaign_segments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Messaging_Campaign_Segments>;
};

/** on_conflict condition type for table "messaging_campaign_segments" */
export type Messaging_Campaign_Segments_On_Conflict = {
  constraint: Messaging_Campaign_Segments_Constraint;
  update_columns?: Array<Messaging_Campaign_Segments_Update_Column>;
  where?: InputMaybe<Messaging_Campaign_Segments_Bool_Exp>;
};

/** Ordering options when selecting data from "messaging_campaign_segments". */
export type Messaging_Campaign_Segments_Order_By = {
  campaign_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  segment?: InputMaybe<Crm_Segments_Order_By>;
  segment_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: messaging_campaign_segments */
export type Messaging_Campaign_Segments_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** select columns of table "messaging_campaign_segments" */
export enum Messaging_Campaign_Segments_Select_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  SegmentId = 'segment_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "messaging_campaign_segments" */
export type Messaging_Campaign_Segments_Set_Input = {
  campaign_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  segment_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "messaging_campaign_segments" */
export type Messaging_Campaign_Segments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Messaging_Campaign_Segments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Messaging_Campaign_Segments_Stream_Cursor_Value_Input = {
  campaign_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  segment_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "messaging_campaign_segments" */
export enum Messaging_Campaign_Segments_Update_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  SegmentId = 'segment_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Messaging_Campaign_Segments_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Messaging_Campaign_Segments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Messaging_Campaign_Segments_Bool_Exp;
};

/** columns and relationships of "messaging_campaigns" */
export type Messaging_Campaigns = {
  __typename?: 'messaging_campaigns';
  account_id: Scalars['bpchar']['output'];
  campaign_public_id?: Maybe<Scalars['String']['output']>;
  company_id: Scalars['bpchar']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  custom_recipients?: Maybe<Scalars['jsonb']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  executed_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['bpchar']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  recipients: Array<Messaging_Campaign_Recipients>;
  /** An aggregate relationship */
  recipients_aggregate: Messaging_Campaign_Recipients_Aggregate;
  scheduled_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  segments: Array<Messaging_Campaign_Segments>;
  /** An aggregate relationship */
  segments_aggregate: Messaging_Campaign_Segments_Aggregate;
  status?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  template: Messaging_Templates;
  template_data?: Maybe<Scalars['jsonb']['output']>;
  template_id: Scalars['bpchar']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['bpchar']['output'];
};


/** columns and relationships of "messaging_campaigns" */
export type Messaging_CampaignsCustom_RecipientsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "messaging_campaigns" */
export type Messaging_CampaignsRecipientsArgs = {
  distinct_on?: InputMaybe<Array<Messaging_Campaign_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messaging_Campaign_Recipients_Order_By>>;
  where?: InputMaybe<Messaging_Campaign_Recipients_Bool_Exp>;
};


/** columns and relationships of "messaging_campaigns" */
export type Messaging_CampaignsRecipients_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Messaging_Campaign_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messaging_Campaign_Recipients_Order_By>>;
  where?: InputMaybe<Messaging_Campaign_Recipients_Bool_Exp>;
};


/** columns and relationships of "messaging_campaigns" */
export type Messaging_CampaignsSegmentsArgs = {
  distinct_on?: InputMaybe<Array<Messaging_Campaign_Segments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messaging_Campaign_Segments_Order_By>>;
  where?: InputMaybe<Messaging_Campaign_Segments_Bool_Exp>;
};


/** columns and relationships of "messaging_campaigns" */
export type Messaging_CampaignsSegments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Messaging_Campaign_Segments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messaging_Campaign_Segments_Order_By>>;
  where?: InputMaybe<Messaging_Campaign_Segments_Bool_Exp>;
};


/** columns and relationships of "messaging_campaigns" */
export type Messaging_CampaignsTemplate_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "messaging_campaigns" */
export type Messaging_Campaigns_Aggregate = {
  __typename?: 'messaging_campaigns_aggregate';
  aggregate?: Maybe<Messaging_Campaigns_Aggregate_Fields>;
  nodes: Array<Messaging_Campaigns>;
};

/** aggregate fields of "messaging_campaigns" */
export type Messaging_Campaigns_Aggregate_Fields = {
  __typename?: 'messaging_campaigns_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Messaging_Campaigns_Max_Fields>;
  min?: Maybe<Messaging_Campaigns_Min_Fields>;
};


/** aggregate fields of "messaging_campaigns" */
export type Messaging_Campaigns_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Messaging_Campaigns_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Messaging_Campaigns_Append_Input = {
  custom_recipients?: InputMaybe<Scalars['jsonb']['input']>;
  template_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "messaging_campaigns". All fields are combined with a logical 'AND'. */
export type Messaging_Campaigns_Bool_Exp = {
  _and?: InputMaybe<Array<Messaging_Campaigns_Bool_Exp>>;
  _not?: InputMaybe<Messaging_Campaigns_Bool_Exp>;
  _or?: InputMaybe<Array<Messaging_Campaigns_Bool_Exp>>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  campaign_public_id?: InputMaybe<String_Comparison_Exp>;
  company_id?: InputMaybe<Bpchar_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  custom_recipients?: InputMaybe<Jsonb_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  executed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  recipients?: InputMaybe<Messaging_Campaign_Recipients_Bool_Exp>;
  recipients_aggregate?: InputMaybe<Messaging_Campaign_Recipients_Aggregate_Bool_Exp>;
  scheduled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  segments?: InputMaybe<Messaging_Campaign_Segments_Bool_Exp>;
  segments_aggregate?: InputMaybe<Messaging_Campaign_Segments_Aggregate_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  template?: InputMaybe<Messaging_Templates_Bool_Exp>;
  template_data?: InputMaybe<Jsonb_Comparison_Exp>;
  template_id?: InputMaybe<Bpchar_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "messaging_campaigns" */
export enum Messaging_Campaigns_Constraint {
  /** unique or primary key constraint on columns "id" */
  MessagingCampaignsPkey = 'messaging_campaigns_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Messaging_Campaigns_Delete_At_Path_Input = {
  custom_recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  template_data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Messaging_Campaigns_Delete_Elem_Input = {
  custom_recipients?: InputMaybe<Scalars['Int']['input']>;
  template_data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Messaging_Campaigns_Delete_Key_Input = {
  custom_recipients?: InputMaybe<Scalars['String']['input']>;
  template_data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "messaging_campaigns" */
export type Messaging_Campaigns_Insert_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  campaign_public_id?: InputMaybe<Scalars['String']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  custom_recipients?: InputMaybe<Scalars['jsonb']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  executed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recipients?: InputMaybe<Messaging_Campaign_Recipients_Arr_Rel_Insert_Input>;
  scheduled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  segments?: InputMaybe<Messaging_Campaign_Segments_Arr_Rel_Insert_Input>;
  status?: InputMaybe<Scalars['String']['input']>;
  template?: InputMaybe<Messaging_Templates_Obj_Rel_Insert_Input>;
  template_data?: InputMaybe<Scalars['jsonb']['input']>;
  template_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Messaging_Campaigns_Max_Fields = {
  __typename?: 'messaging_campaigns_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  campaign_public_id?: Maybe<Scalars['String']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  executed_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  scheduled_at?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  template_id?: Maybe<Scalars['bpchar']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** aggregate min on columns */
export type Messaging_Campaigns_Min_Fields = {
  __typename?: 'messaging_campaigns_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  campaign_public_id?: Maybe<Scalars['String']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  executed_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  scheduled_at?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  template_id?: Maybe<Scalars['bpchar']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** response of any mutation on the table "messaging_campaigns" */
export type Messaging_Campaigns_Mutation_Response = {
  __typename?: 'messaging_campaigns_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Messaging_Campaigns>;
};

/** on_conflict condition type for table "messaging_campaigns" */
export type Messaging_Campaigns_On_Conflict = {
  constraint: Messaging_Campaigns_Constraint;
  update_columns?: Array<Messaging_Campaigns_Update_Column>;
  where?: InputMaybe<Messaging_Campaigns_Bool_Exp>;
};

/** Ordering options when selecting data from "messaging_campaigns". */
export type Messaging_Campaigns_Order_By = {
  account_id?: InputMaybe<Order_By>;
  campaign_public_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  custom_recipients?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  executed_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  recipients_aggregate?: InputMaybe<Messaging_Campaign_Recipients_Aggregate_Order_By>;
  scheduled_at?: InputMaybe<Order_By>;
  segments_aggregate?: InputMaybe<Messaging_Campaign_Segments_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  template?: InputMaybe<Messaging_Templates_Order_By>;
  template_data?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: messaging_campaigns */
export type Messaging_Campaigns_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Messaging_Campaigns_Prepend_Input = {
  custom_recipients?: InputMaybe<Scalars['jsonb']['input']>;
  template_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "messaging_campaigns" */
export enum Messaging_Campaigns_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CampaignPublicId = 'campaign_public_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomRecipients = 'custom_recipients',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  ExecutedAt = 'executed_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ScheduledAt = 'scheduled_at',
  /** column name */
  Status = 'status',
  /** column name */
  TemplateData = 'template_data',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "messaging_campaigns" */
export type Messaging_Campaigns_Set_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  campaign_public_id?: InputMaybe<Scalars['String']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  custom_recipients?: InputMaybe<Scalars['jsonb']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  executed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scheduled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  template_data?: InputMaybe<Scalars['jsonb']['input']>;
  template_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** Streaming cursor of the table "messaging_campaigns" */
export type Messaging_Campaigns_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Messaging_Campaigns_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Messaging_Campaigns_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  campaign_public_id?: InputMaybe<Scalars['String']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  custom_recipients?: InputMaybe<Scalars['jsonb']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  executed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scheduled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  template_data?: InputMaybe<Scalars['jsonb']['input']>;
  template_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** update columns of table "messaging_campaigns" */
export enum Messaging_Campaigns_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CampaignPublicId = 'campaign_public_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomRecipients = 'custom_recipients',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  ExecutedAt = 'executed_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ScheduledAt = 'scheduled_at',
  /** column name */
  Status = 'status',
  /** column name */
  TemplateData = 'template_data',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Messaging_Campaigns_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Messaging_Campaigns_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Messaging_Campaigns_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Messaging_Campaigns_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Messaging_Campaigns_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Messaging_Campaigns_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Messaging_Campaigns_Set_Input>;
  /** filter the rows which have to be updated */
  where: Messaging_Campaigns_Bool_Exp;
};

/** columns and relationships of "messaging_templates" */
export type Messaging_Templates = {
  __typename?: 'messaging_templates';
  account_id: Scalars['bpchar']['output'];
  channels: Scalars['jsonb']['output'];
  company_id: Scalars['bpchar']['output'];
  content: Scalars['String']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  data: Scalars['jsonb']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['bpchar']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id: Scalars['bpchar']['output'];
};


/** columns and relationships of "messaging_templates" */
export type Messaging_TemplatesChannelsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "messaging_templates" */
export type Messaging_TemplatesDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "messaging_templates" */
export type Messaging_Templates_Aggregate = {
  __typename?: 'messaging_templates_aggregate';
  aggregate?: Maybe<Messaging_Templates_Aggregate_Fields>;
  nodes: Array<Messaging_Templates>;
};

/** aggregate fields of "messaging_templates" */
export type Messaging_Templates_Aggregate_Fields = {
  __typename?: 'messaging_templates_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Messaging_Templates_Max_Fields>;
  min?: Maybe<Messaging_Templates_Min_Fields>;
};


/** aggregate fields of "messaging_templates" */
export type Messaging_Templates_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Messaging_Templates_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Messaging_Templates_Append_Input = {
  channels?: InputMaybe<Scalars['jsonb']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "messaging_templates". All fields are combined with a logical 'AND'. */
export type Messaging_Templates_Bool_Exp = {
  _and?: InputMaybe<Array<Messaging_Templates_Bool_Exp>>;
  _not?: InputMaybe<Messaging_Templates_Bool_Exp>;
  _or?: InputMaybe<Array<Messaging_Templates_Bool_Exp>>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  channels?: InputMaybe<Jsonb_Comparison_Exp>;
  company_id?: InputMaybe<Bpchar_Comparison_Exp>;
  content?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "messaging_templates" */
export enum Messaging_Templates_Constraint {
  /** unique or primary key constraint on columns "id" */
  MessagingTemplatesPkey = 'messaging_templates_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Messaging_Templates_Delete_At_Path_Input = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
  data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Messaging_Templates_Delete_Elem_Input = {
  channels?: InputMaybe<Scalars['Int']['input']>;
  data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Messaging_Templates_Delete_Key_Input = {
  channels?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "messaging_templates" */
export type Messaging_Templates_Insert_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  channels?: InputMaybe<Scalars['jsonb']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Messaging_Templates_Max_Fields = {
  __typename?: 'messaging_templates_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** aggregate min on columns */
export type Messaging_Templates_Min_Fields = {
  __typename?: 'messaging_templates_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** response of any mutation on the table "messaging_templates" */
export type Messaging_Templates_Mutation_Response = {
  __typename?: 'messaging_templates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Messaging_Templates>;
};

/** input type for inserting object relation for remote table "messaging_templates" */
export type Messaging_Templates_Obj_Rel_Insert_Input = {
  data: Messaging_Templates_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Messaging_Templates_On_Conflict>;
};

/** on_conflict condition type for table "messaging_templates" */
export type Messaging_Templates_On_Conflict = {
  constraint: Messaging_Templates_Constraint;
  update_columns?: Array<Messaging_Templates_Update_Column>;
  where?: InputMaybe<Messaging_Templates_Bool_Exp>;
};

/** Ordering options when selecting data from "messaging_templates". */
export type Messaging_Templates_Order_By = {
  account_id?: InputMaybe<Order_By>;
  channels?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: messaging_templates */
export type Messaging_Templates_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Messaging_Templates_Prepend_Input = {
  channels?: InputMaybe<Scalars['jsonb']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "messaging_templates" */
export enum Messaging_Templates_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Channels = 'channels',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "messaging_templates" */
export type Messaging_Templates_Set_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  channels?: InputMaybe<Scalars['jsonb']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** Streaming cursor of the table "messaging_templates" */
export type Messaging_Templates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Messaging_Templates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Messaging_Templates_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  channels?: InputMaybe<Scalars['jsonb']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** update columns of table "messaging_templates" */
export enum Messaging_Templates_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Channels = 'channels',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Messaging_Templates_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Messaging_Templates_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Messaging_Templates_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Messaging_Templates_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Messaging_Templates_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Messaging_Templates_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Messaging_Templates_Set_Input>;
  /** filter the rows which have to be updated */
  where: Messaging_Templates_Bool_Exp;
};

/** columns and relationships of "migrations" */
export type Migrations = {
  __typename?: 'migrations';
  batch: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  migration: Scalars['String']['output'];
};

/** aggregated selection of "migrations" */
export type Migrations_Aggregate = {
  __typename?: 'migrations_aggregate';
  aggregate?: Maybe<Migrations_Aggregate_Fields>;
  nodes: Array<Migrations>;
};

/** aggregate fields of "migrations" */
export type Migrations_Aggregate_Fields = {
  __typename?: 'migrations_aggregate_fields';
  avg?: Maybe<Migrations_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Migrations_Max_Fields>;
  min?: Maybe<Migrations_Min_Fields>;
  stddev?: Maybe<Migrations_Stddev_Fields>;
  stddev_pop?: Maybe<Migrations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Migrations_Stddev_Samp_Fields>;
  sum?: Maybe<Migrations_Sum_Fields>;
  var_pop?: Maybe<Migrations_Var_Pop_Fields>;
  var_samp?: Maybe<Migrations_Var_Samp_Fields>;
  variance?: Maybe<Migrations_Variance_Fields>;
};


/** aggregate fields of "migrations" */
export type Migrations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Migrations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Migrations_Avg_Fields = {
  __typename?: 'migrations_avg_fields';
  batch?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "migrations". All fields are combined with a logical 'AND'. */
export type Migrations_Bool_Exp = {
  _and?: InputMaybe<Array<Migrations_Bool_Exp>>;
  _not?: InputMaybe<Migrations_Bool_Exp>;
  _or?: InputMaybe<Array<Migrations_Bool_Exp>>;
  batch?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  migration?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "migrations" */
export enum Migrations_Constraint {
  /** unique or primary key constraint on columns "id" */
  MigrationsPkey = 'migrations_pkey'
}

/** input type for incrementing numeric columns in table "migrations" */
export type Migrations_Inc_Input = {
  batch?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "migrations" */
export type Migrations_Insert_Input = {
  batch?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  migration?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Migrations_Max_Fields = {
  __typename?: 'migrations_max_fields';
  batch?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  migration?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Migrations_Min_Fields = {
  __typename?: 'migrations_min_fields';
  batch?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  migration?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "migrations" */
export type Migrations_Mutation_Response = {
  __typename?: 'migrations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Migrations>;
};

/** on_conflict condition type for table "migrations" */
export type Migrations_On_Conflict = {
  constraint: Migrations_Constraint;
  update_columns?: Array<Migrations_Update_Column>;
  where?: InputMaybe<Migrations_Bool_Exp>;
};

/** Ordering options when selecting data from "migrations". */
export type Migrations_Order_By = {
  batch?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  migration?: InputMaybe<Order_By>;
};

/** primary key columns input for table: migrations */
export type Migrations_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "migrations" */
export enum Migrations_Select_Column {
  /** column name */
  Batch = 'batch',
  /** column name */
  Id = 'id',
  /** column name */
  Migration = 'migration'
}

/** input type for updating data in table "migrations" */
export type Migrations_Set_Input = {
  batch?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  migration?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Migrations_Stddev_Fields = {
  __typename?: 'migrations_stddev_fields';
  batch?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Migrations_Stddev_Pop_Fields = {
  __typename?: 'migrations_stddev_pop_fields';
  batch?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Migrations_Stddev_Samp_Fields = {
  __typename?: 'migrations_stddev_samp_fields';
  batch?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "migrations" */
export type Migrations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Migrations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Migrations_Stream_Cursor_Value_Input = {
  batch?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  migration?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Migrations_Sum_Fields = {
  __typename?: 'migrations_sum_fields';
  batch?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "migrations" */
export enum Migrations_Update_Column {
  /** column name */
  Batch = 'batch',
  /** column name */
  Id = 'id',
  /** column name */
  Migration = 'migration'
}

export type Migrations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Migrations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Migrations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Migrations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Migrations_Var_Pop_Fields = {
  __typename?: 'migrations_var_pop_fields';
  batch?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Migrations_Var_Samp_Fields = {
  __typename?: 'migrations_var_samp_fields';
  batch?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Migrations_Variance_Fields = {
  __typename?: 'migrations_variance_fields';
  batch?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "missed_call_number_pool" */
export type Missed_Call_Number_Pool = {
  __typename?: 'missed_call_number_pool';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['bigint']['output'];
  is_reserved: Scalars['Boolean']['output'];
  linked_to_plan_id?: Maybe<Scalars['bigint']['output']>;
  phone_number: Scalars['String']['output'];
  reserved_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "missed_call_number_pool" */
export type Missed_Call_Number_Pool_Aggregate = {
  __typename?: 'missed_call_number_pool_aggregate';
  aggregate?: Maybe<Missed_Call_Number_Pool_Aggregate_Fields>;
  nodes: Array<Missed_Call_Number_Pool>;
};

/** aggregate fields of "missed_call_number_pool" */
export type Missed_Call_Number_Pool_Aggregate_Fields = {
  __typename?: 'missed_call_number_pool_aggregate_fields';
  avg?: Maybe<Missed_Call_Number_Pool_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Missed_Call_Number_Pool_Max_Fields>;
  min?: Maybe<Missed_Call_Number_Pool_Min_Fields>;
  stddev?: Maybe<Missed_Call_Number_Pool_Stddev_Fields>;
  stddev_pop?: Maybe<Missed_Call_Number_Pool_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Missed_Call_Number_Pool_Stddev_Samp_Fields>;
  sum?: Maybe<Missed_Call_Number_Pool_Sum_Fields>;
  var_pop?: Maybe<Missed_Call_Number_Pool_Var_Pop_Fields>;
  var_samp?: Maybe<Missed_Call_Number_Pool_Var_Samp_Fields>;
  variance?: Maybe<Missed_Call_Number_Pool_Variance_Fields>;
};


/** aggregate fields of "missed_call_number_pool" */
export type Missed_Call_Number_Pool_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Missed_Call_Number_Pool_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Missed_Call_Number_Pool_Avg_Fields = {
  __typename?: 'missed_call_number_pool_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  linked_to_plan_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "missed_call_number_pool". All fields are combined with a logical 'AND'. */
export type Missed_Call_Number_Pool_Bool_Exp = {
  _and?: InputMaybe<Array<Missed_Call_Number_Pool_Bool_Exp>>;
  _not?: InputMaybe<Missed_Call_Number_Pool_Bool_Exp>;
  _or?: InputMaybe<Array<Missed_Call_Number_Pool_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_reserved?: InputMaybe<Boolean_Comparison_Exp>;
  linked_to_plan_id?: InputMaybe<Bigint_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  reserved_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "missed_call_number_pool" */
export enum Missed_Call_Number_Pool_Constraint {
  /** unique or primary key constraint on columns "id" */
  MissedCallNumberPoolPkey = 'missed_call_number_pool_pkey'
}

/** input type for incrementing numeric columns in table "missed_call_number_pool" */
export type Missed_Call_Number_Pool_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  linked_to_plan_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "missed_call_number_pool" */
export type Missed_Call_Number_Pool_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_reserved?: InputMaybe<Scalars['Boolean']['input']>;
  linked_to_plan_id?: InputMaybe<Scalars['bigint']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  reserved_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Missed_Call_Number_Pool_Max_Fields = {
  __typename?: 'missed_call_number_pool_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  linked_to_plan_id?: Maybe<Scalars['bigint']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  reserved_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Missed_Call_Number_Pool_Min_Fields = {
  __typename?: 'missed_call_number_pool_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  linked_to_plan_id?: Maybe<Scalars['bigint']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  reserved_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "missed_call_number_pool" */
export type Missed_Call_Number_Pool_Mutation_Response = {
  __typename?: 'missed_call_number_pool_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Missed_Call_Number_Pool>;
};

/** on_conflict condition type for table "missed_call_number_pool" */
export type Missed_Call_Number_Pool_On_Conflict = {
  constraint: Missed_Call_Number_Pool_Constraint;
  update_columns?: Array<Missed_Call_Number_Pool_Update_Column>;
  where?: InputMaybe<Missed_Call_Number_Pool_Bool_Exp>;
};

/** Ordering options when selecting data from "missed_call_number_pool". */
export type Missed_Call_Number_Pool_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_reserved?: InputMaybe<Order_By>;
  linked_to_plan_id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  reserved_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: missed_call_number_pool */
export type Missed_Call_Number_Pool_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "missed_call_number_pool" */
export enum Missed_Call_Number_Pool_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsReserved = 'is_reserved',
  /** column name */
  LinkedToPlanId = 'linked_to_plan_id',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  ReservedAt = 'reserved_at',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "missed_call_number_pool" */
export type Missed_Call_Number_Pool_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_reserved?: InputMaybe<Scalars['Boolean']['input']>;
  linked_to_plan_id?: InputMaybe<Scalars['bigint']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  reserved_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Missed_Call_Number_Pool_Stddev_Fields = {
  __typename?: 'missed_call_number_pool_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  linked_to_plan_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Missed_Call_Number_Pool_Stddev_Pop_Fields = {
  __typename?: 'missed_call_number_pool_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  linked_to_plan_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Missed_Call_Number_Pool_Stddev_Samp_Fields = {
  __typename?: 'missed_call_number_pool_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  linked_to_plan_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "missed_call_number_pool" */
export type Missed_Call_Number_Pool_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Missed_Call_Number_Pool_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Missed_Call_Number_Pool_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_reserved?: InputMaybe<Scalars['Boolean']['input']>;
  linked_to_plan_id?: InputMaybe<Scalars['bigint']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  reserved_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Missed_Call_Number_Pool_Sum_Fields = {
  __typename?: 'missed_call_number_pool_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  linked_to_plan_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "missed_call_number_pool" */
export enum Missed_Call_Number_Pool_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsReserved = 'is_reserved',
  /** column name */
  LinkedToPlanId = 'linked_to_plan_id',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  ReservedAt = 'reserved_at',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Missed_Call_Number_Pool_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Missed_Call_Number_Pool_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Missed_Call_Number_Pool_Set_Input>;
  /** filter the rows which have to be updated */
  where: Missed_Call_Number_Pool_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Missed_Call_Number_Pool_Var_Pop_Fields = {
  __typename?: 'missed_call_number_pool_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  linked_to_plan_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Missed_Call_Number_Pool_Var_Samp_Fields = {
  __typename?: 'missed_call_number_pool_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  linked_to_plan_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Missed_Call_Number_Pool_Variance_Fields = {
  __typename?: 'missed_call_number_pool_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  linked_to_plan_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "missed_calls" */
export type Missed_Calls = {
  __typename?: 'missed_calls';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  from_phone_number?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  plan_id?: Maybe<Scalars['bigint']['output']>;
  pool_id?: Maybe<Scalars['bigint']['output']>;
  to_phone_number?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "missed_calls" */
export type Missed_Calls_Aggregate = {
  __typename?: 'missed_calls_aggregate';
  aggregate?: Maybe<Missed_Calls_Aggregate_Fields>;
  nodes: Array<Missed_Calls>;
};

/** aggregate fields of "missed_calls" */
export type Missed_Calls_Aggregate_Fields = {
  __typename?: 'missed_calls_aggregate_fields';
  avg?: Maybe<Missed_Calls_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Missed_Calls_Max_Fields>;
  min?: Maybe<Missed_Calls_Min_Fields>;
  stddev?: Maybe<Missed_Calls_Stddev_Fields>;
  stddev_pop?: Maybe<Missed_Calls_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Missed_Calls_Stddev_Samp_Fields>;
  sum?: Maybe<Missed_Calls_Sum_Fields>;
  var_pop?: Maybe<Missed_Calls_Var_Pop_Fields>;
  var_samp?: Maybe<Missed_Calls_Var_Samp_Fields>;
  variance?: Maybe<Missed_Calls_Variance_Fields>;
};


/** aggregate fields of "missed_calls" */
export type Missed_Calls_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Missed_Calls_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Missed_Calls_Avg_Fields = {
  __typename?: 'missed_calls_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  plan_id?: Maybe<Scalars['Float']['output']>;
  pool_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "missed_calls". All fields are combined with a logical 'AND'. */
export type Missed_Calls_Bool_Exp = {
  _and?: InputMaybe<Array<Missed_Calls_Bool_Exp>>;
  _not?: InputMaybe<Missed_Calls_Bool_Exp>;
  _or?: InputMaybe<Array<Missed_Calls_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  from_phone_number?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  plan_id?: InputMaybe<Bigint_Comparison_Exp>;
  pool_id?: InputMaybe<Bigint_Comparison_Exp>;
  to_phone_number?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "missed_calls" */
export enum Missed_Calls_Constraint {
  /** unique or primary key constraint on columns "id" */
  MissedCallsPkey = 'missed_calls_pkey'
}

/** input type for incrementing numeric columns in table "missed_calls" */
export type Missed_Calls_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  plan_id?: InputMaybe<Scalars['bigint']['input']>;
  pool_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "missed_calls" */
export type Missed_Calls_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  from_phone_number?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  plan_id?: InputMaybe<Scalars['bigint']['input']>;
  pool_id?: InputMaybe<Scalars['bigint']['input']>;
  to_phone_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Missed_Calls_Max_Fields = {
  __typename?: 'missed_calls_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  from_phone_number?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  plan_id?: Maybe<Scalars['bigint']['output']>;
  pool_id?: Maybe<Scalars['bigint']['output']>;
  to_phone_number?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Missed_Calls_Min_Fields = {
  __typename?: 'missed_calls_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  from_phone_number?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  plan_id?: Maybe<Scalars['bigint']['output']>;
  pool_id?: Maybe<Scalars['bigint']['output']>;
  to_phone_number?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "missed_calls" */
export type Missed_Calls_Mutation_Response = {
  __typename?: 'missed_calls_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Missed_Calls>;
};

/** on_conflict condition type for table "missed_calls" */
export type Missed_Calls_On_Conflict = {
  constraint: Missed_Calls_Constraint;
  update_columns?: Array<Missed_Calls_Update_Column>;
  where?: InputMaybe<Missed_Calls_Bool_Exp>;
};

/** Ordering options when selecting data from "missed_calls". */
export type Missed_Calls_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  from_phone_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plan_id?: InputMaybe<Order_By>;
  pool_id?: InputMaybe<Order_By>;
  to_phone_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: missed_calls */
export type Missed_Calls_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "missed_calls" */
export enum Missed_Calls_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FromPhoneNumber = 'from_phone_number',
  /** column name */
  Id = 'id',
  /** column name */
  PlanId = 'plan_id',
  /** column name */
  PoolId = 'pool_id',
  /** column name */
  ToPhoneNumber = 'to_phone_number',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "missed_calls" */
export type Missed_Calls_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  from_phone_number?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  plan_id?: InputMaybe<Scalars['bigint']['input']>;
  pool_id?: InputMaybe<Scalars['bigint']['input']>;
  to_phone_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Missed_Calls_Stddev_Fields = {
  __typename?: 'missed_calls_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  plan_id?: Maybe<Scalars['Float']['output']>;
  pool_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Missed_Calls_Stddev_Pop_Fields = {
  __typename?: 'missed_calls_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  plan_id?: Maybe<Scalars['Float']['output']>;
  pool_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Missed_Calls_Stddev_Samp_Fields = {
  __typename?: 'missed_calls_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  plan_id?: Maybe<Scalars['Float']['output']>;
  pool_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "missed_calls" */
export type Missed_Calls_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Missed_Calls_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Missed_Calls_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  from_phone_number?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  plan_id?: InputMaybe<Scalars['bigint']['input']>;
  pool_id?: InputMaybe<Scalars['bigint']['input']>;
  to_phone_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Missed_Calls_Sum_Fields = {
  __typename?: 'missed_calls_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  plan_id?: Maybe<Scalars['bigint']['output']>;
  pool_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "missed_calls" */
export enum Missed_Calls_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FromPhoneNumber = 'from_phone_number',
  /** column name */
  Id = 'id',
  /** column name */
  PlanId = 'plan_id',
  /** column name */
  PoolId = 'pool_id',
  /** column name */
  ToPhoneNumber = 'to_phone_number',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Missed_Calls_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Missed_Calls_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Missed_Calls_Set_Input>;
  /** filter the rows which have to be updated */
  where: Missed_Calls_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Missed_Calls_Var_Pop_Fields = {
  __typename?: 'missed_calls_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  plan_id?: Maybe<Scalars['Float']['output']>;
  pool_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Missed_Calls_Var_Samp_Fields = {
  __typename?: 'missed_calls_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  plan_id?: Maybe<Scalars['Float']['output']>;
  pool_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Missed_Calls_Variance_Fields = {
  __typename?: 'missed_calls_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  plan_id?: Maybe<Scalars['Float']['output']>;
  pool_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "model_has_permissions" */
export type Model_Has_Permissions = {
  __typename?: 'model_has_permissions';
  model_id: Scalars['String']['output'];
  model_type: Scalars['String']['output'];
  /** An object relationship */
  permission: Permissions;
  permission_id: Scalars['bigint']['output'];
};

/** aggregated selection of "model_has_permissions" */
export type Model_Has_Permissions_Aggregate = {
  __typename?: 'model_has_permissions_aggregate';
  aggregate?: Maybe<Model_Has_Permissions_Aggregate_Fields>;
  nodes: Array<Model_Has_Permissions>;
};

export type Model_Has_Permissions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Model_Has_Permissions_Aggregate_Bool_Exp_Count>;
};

export type Model_Has_Permissions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Model_Has_Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Model_Has_Permissions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "model_has_permissions" */
export type Model_Has_Permissions_Aggregate_Fields = {
  __typename?: 'model_has_permissions_aggregate_fields';
  avg?: Maybe<Model_Has_Permissions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Model_Has_Permissions_Max_Fields>;
  min?: Maybe<Model_Has_Permissions_Min_Fields>;
  stddev?: Maybe<Model_Has_Permissions_Stddev_Fields>;
  stddev_pop?: Maybe<Model_Has_Permissions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Model_Has_Permissions_Stddev_Samp_Fields>;
  sum?: Maybe<Model_Has_Permissions_Sum_Fields>;
  var_pop?: Maybe<Model_Has_Permissions_Var_Pop_Fields>;
  var_samp?: Maybe<Model_Has_Permissions_Var_Samp_Fields>;
  variance?: Maybe<Model_Has_Permissions_Variance_Fields>;
};


/** aggregate fields of "model_has_permissions" */
export type Model_Has_Permissions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Model_Has_Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "model_has_permissions" */
export type Model_Has_Permissions_Aggregate_Order_By = {
  avg?: InputMaybe<Model_Has_Permissions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Model_Has_Permissions_Max_Order_By>;
  min?: InputMaybe<Model_Has_Permissions_Min_Order_By>;
  stddev?: InputMaybe<Model_Has_Permissions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Model_Has_Permissions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Model_Has_Permissions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Model_Has_Permissions_Sum_Order_By>;
  var_pop?: InputMaybe<Model_Has_Permissions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Model_Has_Permissions_Var_Samp_Order_By>;
  variance?: InputMaybe<Model_Has_Permissions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "model_has_permissions" */
export type Model_Has_Permissions_Arr_Rel_Insert_Input = {
  data: Array<Model_Has_Permissions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Model_Has_Permissions_On_Conflict>;
};

/** aggregate avg on columns */
export type Model_Has_Permissions_Avg_Fields = {
  __typename?: 'model_has_permissions_avg_fields';
  permission_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "model_has_permissions" */
export type Model_Has_Permissions_Avg_Order_By = {
  permission_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "model_has_permissions". All fields are combined with a logical 'AND'. */
export type Model_Has_Permissions_Bool_Exp = {
  _and?: InputMaybe<Array<Model_Has_Permissions_Bool_Exp>>;
  _not?: InputMaybe<Model_Has_Permissions_Bool_Exp>;
  _or?: InputMaybe<Array<Model_Has_Permissions_Bool_Exp>>;
  model_id?: InputMaybe<String_Comparison_Exp>;
  model_type?: InputMaybe<String_Comparison_Exp>;
  permission?: InputMaybe<Permissions_Bool_Exp>;
  permission_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "model_has_permissions" */
export enum Model_Has_Permissions_Constraint {
  /** unique or primary key constraint on columns "permission_id", "model_type", "model_id" */
  ModelHasPermissionsPkey = 'model_has_permissions_pkey'
}

/** input type for incrementing numeric columns in table "model_has_permissions" */
export type Model_Has_Permissions_Inc_Input = {
  permission_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "model_has_permissions" */
export type Model_Has_Permissions_Insert_Input = {
  model_id?: InputMaybe<Scalars['String']['input']>;
  model_type?: InputMaybe<Scalars['String']['input']>;
  permission?: InputMaybe<Permissions_Obj_Rel_Insert_Input>;
  permission_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Model_Has_Permissions_Max_Fields = {
  __typename?: 'model_has_permissions_max_fields';
  model_id?: Maybe<Scalars['String']['output']>;
  model_type?: Maybe<Scalars['String']['output']>;
  permission_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "model_has_permissions" */
export type Model_Has_Permissions_Max_Order_By = {
  model_id?: InputMaybe<Order_By>;
  model_type?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Model_Has_Permissions_Min_Fields = {
  __typename?: 'model_has_permissions_min_fields';
  model_id?: Maybe<Scalars['String']['output']>;
  model_type?: Maybe<Scalars['String']['output']>;
  permission_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "model_has_permissions" */
export type Model_Has_Permissions_Min_Order_By = {
  model_id?: InputMaybe<Order_By>;
  model_type?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "model_has_permissions" */
export type Model_Has_Permissions_Mutation_Response = {
  __typename?: 'model_has_permissions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Model_Has_Permissions>;
};

/** on_conflict condition type for table "model_has_permissions" */
export type Model_Has_Permissions_On_Conflict = {
  constraint: Model_Has_Permissions_Constraint;
  update_columns?: Array<Model_Has_Permissions_Update_Column>;
  where?: InputMaybe<Model_Has_Permissions_Bool_Exp>;
};

/** Ordering options when selecting data from "model_has_permissions". */
export type Model_Has_Permissions_Order_By = {
  model_id?: InputMaybe<Order_By>;
  model_type?: InputMaybe<Order_By>;
  permission?: InputMaybe<Permissions_Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: model_has_permissions */
export type Model_Has_Permissions_Pk_Columns_Input = {
  model_id: Scalars['String']['input'];
  model_type: Scalars['String']['input'];
  permission_id: Scalars['bigint']['input'];
};

/** select columns of table "model_has_permissions" */
export enum Model_Has_Permissions_Select_Column {
  /** column name */
  ModelId = 'model_id',
  /** column name */
  ModelType = 'model_type',
  /** column name */
  PermissionId = 'permission_id'
}

/** input type for updating data in table "model_has_permissions" */
export type Model_Has_Permissions_Set_Input = {
  model_id?: InputMaybe<Scalars['String']['input']>;
  model_type?: InputMaybe<Scalars['String']['input']>;
  permission_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Model_Has_Permissions_Stddev_Fields = {
  __typename?: 'model_has_permissions_stddev_fields';
  permission_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "model_has_permissions" */
export type Model_Has_Permissions_Stddev_Order_By = {
  permission_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Model_Has_Permissions_Stddev_Pop_Fields = {
  __typename?: 'model_has_permissions_stddev_pop_fields';
  permission_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "model_has_permissions" */
export type Model_Has_Permissions_Stddev_Pop_Order_By = {
  permission_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Model_Has_Permissions_Stddev_Samp_Fields = {
  __typename?: 'model_has_permissions_stddev_samp_fields';
  permission_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "model_has_permissions" */
export type Model_Has_Permissions_Stddev_Samp_Order_By = {
  permission_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "model_has_permissions" */
export type Model_Has_Permissions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Model_Has_Permissions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Model_Has_Permissions_Stream_Cursor_Value_Input = {
  model_id?: InputMaybe<Scalars['String']['input']>;
  model_type?: InputMaybe<Scalars['String']['input']>;
  permission_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Model_Has_Permissions_Sum_Fields = {
  __typename?: 'model_has_permissions_sum_fields';
  permission_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "model_has_permissions" */
export type Model_Has_Permissions_Sum_Order_By = {
  permission_id?: InputMaybe<Order_By>;
};

/** update columns of table "model_has_permissions" */
export enum Model_Has_Permissions_Update_Column {
  /** column name */
  ModelId = 'model_id',
  /** column name */
  ModelType = 'model_type',
  /** column name */
  PermissionId = 'permission_id'
}

export type Model_Has_Permissions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Model_Has_Permissions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Model_Has_Permissions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Model_Has_Permissions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Model_Has_Permissions_Var_Pop_Fields = {
  __typename?: 'model_has_permissions_var_pop_fields';
  permission_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "model_has_permissions" */
export type Model_Has_Permissions_Var_Pop_Order_By = {
  permission_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Model_Has_Permissions_Var_Samp_Fields = {
  __typename?: 'model_has_permissions_var_samp_fields';
  permission_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "model_has_permissions" */
export type Model_Has_Permissions_Var_Samp_Order_By = {
  permission_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Model_Has_Permissions_Variance_Fields = {
  __typename?: 'model_has_permissions_variance_fields';
  permission_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "model_has_permissions" */
export type Model_Has_Permissions_Variance_Order_By = {
  permission_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "model_has_roles" */
export type Model_Has_Roles = {
  __typename?: 'model_has_roles';
  model_id: Scalars['String']['output'];
  model_type: Scalars['String']['output'];
  /** An object relationship */
  role: Roles;
  role_id: Scalars['bigint']['output'];
  /** An object relationship */
  user: Users;
};

/** aggregated selection of "model_has_roles" */
export type Model_Has_Roles_Aggregate = {
  __typename?: 'model_has_roles_aggregate';
  aggregate?: Maybe<Model_Has_Roles_Aggregate_Fields>;
  nodes: Array<Model_Has_Roles>;
};

export type Model_Has_Roles_Aggregate_Bool_Exp = {
  count?: InputMaybe<Model_Has_Roles_Aggregate_Bool_Exp_Count>;
};

export type Model_Has_Roles_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Model_Has_Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Model_Has_Roles_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "model_has_roles" */
export type Model_Has_Roles_Aggregate_Fields = {
  __typename?: 'model_has_roles_aggregate_fields';
  avg?: Maybe<Model_Has_Roles_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Model_Has_Roles_Max_Fields>;
  min?: Maybe<Model_Has_Roles_Min_Fields>;
  stddev?: Maybe<Model_Has_Roles_Stddev_Fields>;
  stddev_pop?: Maybe<Model_Has_Roles_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Model_Has_Roles_Stddev_Samp_Fields>;
  sum?: Maybe<Model_Has_Roles_Sum_Fields>;
  var_pop?: Maybe<Model_Has_Roles_Var_Pop_Fields>;
  var_samp?: Maybe<Model_Has_Roles_Var_Samp_Fields>;
  variance?: Maybe<Model_Has_Roles_Variance_Fields>;
};


/** aggregate fields of "model_has_roles" */
export type Model_Has_Roles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Model_Has_Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "model_has_roles" */
export type Model_Has_Roles_Aggregate_Order_By = {
  avg?: InputMaybe<Model_Has_Roles_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Model_Has_Roles_Max_Order_By>;
  min?: InputMaybe<Model_Has_Roles_Min_Order_By>;
  stddev?: InputMaybe<Model_Has_Roles_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Model_Has_Roles_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Model_Has_Roles_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Model_Has_Roles_Sum_Order_By>;
  var_pop?: InputMaybe<Model_Has_Roles_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Model_Has_Roles_Var_Samp_Order_By>;
  variance?: InputMaybe<Model_Has_Roles_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "model_has_roles" */
export type Model_Has_Roles_Arr_Rel_Insert_Input = {
  data: Array<Model_Has_Roles_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Model_Has_Roles_On_Conflict>;
};

/** aggregate avg on columns */
export type Model_Has_Roles_Avg_Fields = {
  __typename?: 'model_has_roles_avg_fields';
  role_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "model_has_roles" */
export type Model_Has_Roles_Avg_Order_By = {
  role_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "model_has_roles". All fields are combined with a logical 'AND'. */
export type Model_Has_Roles_Bool_Exp = {
  _and?: InputMaybe<Array<Model_Has_Roles_Bool_Exp>>;
  _not?: InputMaybe<Model_Has_Roles_Bool_Exp>;
  _or?: InputMaybe<Array<Model_Has_Roles_Bool_Exp>>;
  model_id?: InputMaybe<String_Comparison_Exp>;
  model_type?: InputMaybe<String_Comparison_Exp>;
  role?: InputMaybe<Roles_Bool_Exp>;
  role_id?: InputMaybe<Bigint_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "model_has_roles" */
export enum Model_Has_Roles_Constraint {
  /** unique or primary key constraint on columns "model_type", "role_id", "model_id" */
  ModelHasRolesPkey = 'model_has_roles_pkey'
}

/** input type for incrementing numeric columns in table "model_has_roles" */
export type Model_Has_Roles_Inc_Input = {
  role_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "model_has_roles" */
export type Model_Has_Roles_Insert_Input = {
  model_id?: InputMaybe<Scalars['String']['input']>;
  model_type?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Roles_Obj_Rel_Insert_Input>;
  role_id?: InputMaybe<Scalars['bigint']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Model_Has_Roles_Max_Fields = {
  __typename?: 'model_has_roles_max_fields';
  model_id?: Maybe<Scalars['String']['output']>;
  model_type?: Maybe<Scalars['String']['output']>;
  role_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "model_has_roles" */
export type Model_Has_Roles_Max_Order_By = {
  model_id?: InputMaybe<Order_By>;
  model_type?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Model_Has_Roles_Min_Fields = {
  __typename?: 'model_has_roles_min_fields';
  model_id?: Maybe<Scalars['String']['output']>;
  model_type?: Maybe<Scalars['String']['output']>;
  role_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "model_has_roles" */
export type Model_Has_Roles_Min_Order_By = {
  model_id?: InputMaybe<Order_By>;
  model_type?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "model_has_roles" */
export type Model_Has_Roles_Mutation_Response = {
  __typename?: 'model_has_roles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Model_Has_Roles>;
};

/** on_conflict condition type for table "model_has_roles" */
export type Model_Has_Roles_On_Conflict = {
  constraint: Model_Has_Roles_Constraint;
  update_columns?: Array<Model_Has_Roles_Update_Column>;
  where?: InputMaybe<Model_Has_Roles_Bool_Exp>;
};

/** Ordering options when selecting data from "model_has_roles". */
export type Model_Has_Roles_Order_By = {
  model_id?: InputMaybe<Order_By>;
  model_type?: InputMaybe<Order_By>;
  role?: InputMaybe<Roles_Order_By>;
  role_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: model_has_roles */
export type Model_Has_Roles_Pk_Columns_Input = {
  model_id: Scalars['String']['input'];
  model_type: Scalars['String']['input'];
  role_id: Scalars['bigint']['input'];
};

/** select columns of table "model_has_roles" */
export enum Model_Has_Roles_Select_Column {
  /** column name */
  ModelId = 'model_id',
  /** column name */
  ModelType = 'model_type',
  /** column name */
  RoleId = 'role_id'
}

/** input type for updating data in table "model_has_roles" */
export type Model_Has_Roles_Set_Input = {
  model_id?: InputMaybe<Scalars['String']['input']>;
  model_type?: InputMaybe<Scalars['String']['input']>;
  role_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Model_Has_Roles_Stddev_Fields = {
  __typename?: 'model_has_roles_stddev_fields';
  role_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "model_has_roles" */
export type Model_Has_Roles_Stddev_Order_By = {
  role_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Model_Has_Roles_Stddev_Pop_Fields = {
  __typename?: 'model_has_roles_stddev_pop_fields';
  role_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "model_has_roles" */
export type Model_Has_Roles_Stddev_Pop_Order_By = {
  role_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Model_Has_Roles_Stddev_Samp_Fields = {
  __typename?: 'model_has_roles_stddev_samp_fields';
  role_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "model_has_roles" */
export type Model_Has_Roles_Stddev_Samp_Order_By = {
  role_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "model_has_roles" */
export type Model_Has_Roles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Model_Has_Roles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Model_Has_Roles_Stream_Cursor_Value_Input = {
  model_id?: InputMaybe<Scalars['String']['input']>;
  model_type?: InputMaybe<Scalars['String']['input']>;
  role_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Model_Has_Roles_Sum_Fields = {
  __typename?: 'model_has_roles_sum_fields';
  role_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "model_has_roles" */
export type Model_Has_Roles_Sum_Order_By = {
  role_id?: InputMaybe<Order_By>;
};

/** update columns of table "model_has_roles" */
export enum Model_Has_Roles_Update_Column {
  /** column name */
  ModelId = 'model_id',
  /** column name */
  ModelType = 'model_type',
  /** column name */
  RoleId = 'role_id'
}

export type Model_Has_Roles_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Model_Has_Roles_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Model_Has_Roles_Set_Input>;
  /** filter the rows which have to be updated */
  where: Model_Has_Roles_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Model_Has_Roles_Var_Pop_Fields = {
  __typename?: 'model_has_roles_var_pop_fields';
  role_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "model_has_roles" */
export type Model_Has_Roles_Var_Pop_Order_By = {
  role_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Model_Has_Roles_Var_Samp_Fields = {
  __typename?: 'model_has_roles_var_samp_fields';
  role_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "model_has_roles" */
export type Model_Has_Roles_Var_Samp_Order_By = {
  role_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Model_Has_Roles_Variance_Fields = {
  __typename?: 'model_has_roles_variance_fields';
  role_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "model_has_roles" */
export type Model_Has_Roles_Variance_Order_By = {
  role_id?: InputMaybe<Order_By>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  accountUserMessagesOnProspect: DefaultCommandOutput;
  /** Add a participant to a thread. */
  addChatParticipant: ChatParticipant;
  /** Add a reaction to a chat message. */
  addChatReaction: ChatReaction;
  appLogout: DefaultCommandOutput;
  applyForContentCreator: DefaultCommandOutput;
  /** Archive a chat thread. */
  archiveChatThread: Scalars['Boolean']['output'];
  askFarminstaSimple: Scalars['String']['output'];
  assignWarehouseManager: WarehouseUser;
  cfUploadData: Array<Scalars['String']['output']>;
  changeWarehouseUserRole: WarehouseUser;
  companyAcceptsOrRejectsWorkorderRequest: DefaultCommandOutput;
  companyAssignsFO?: Maybe<Prospect>;
  companySendsConnectionRequest?: Maybe<Prospect>;
  companyWorkorderFeedback: DefaultCommandOutput;
  createCRMSegment: CrmSegment;
  createCategory: Category;
  /** Create a new chat thread. */
  createChatThread: ChatThread;
  createGig: DefaultCommandOutput;
  createLeadByFO: DefaultCommandOutput;
  createMessageCampaign: MessagingCampaign;
  createProduct: SaleProduct;
  createProductPop: ProductPopResult;
  createReel: DefaultCommandOutput;
  createReelCategory: DefaultCommandOutput;
  createReelComment: DefaultCommandOutput;
  createSale: Sale;
  createShopifyUserAccount?: Maybe<ShopifyUserToken>;
  /** Creates a trackable link */
  createTrackableLink: GoLink;
  createWarehouse: Warehouse;
  createWorkOrder: CreateWorkOrderResponse;
  deleteAllProductImages: Scalars['Boolean']['output'];
  deleteCategory: Scalars['Boolean']['output'];
  /** Delete a chat message. */
  deleteChatMessage: Scalars['Boolean']['output'];
  deleteProduct: Scalars['Boolean']['output'];
  deleteProductImage: Scalars['Boolean']['output'];
  deleteProductPop: DeleteResult;
  deleteReelComment: DefaultCommandOutput;
  deleteTestRequests: DefaultCommandOutput;
  /** delete data from the table: "account_auth_key" */
  delete_account_auth_key?: Maybe<Account_Auth_Key_Mutation_Response>;
  /** delete single row from the table: "account_auth_key" */
  delete_account_auth_key_by_pk?: Maybe<Account_Auth_Key>;
  /** delete data from the table: "account_crop" */
  delete_account_crop?: Maybe<Account_Crop_Mutation_Response>;
  /** delete single row from the table: "account_crop" */
  delete_account_crop_by_pk?: Maybe<Account_Crop>;
  /** delete data from the table: "account_segment" */
  delete_account_segment?: Maybe<Account_Segment_Mutation_Response>;
  /** delete single row from the table: "account_segment" */
  delete_account_segment_by_pk?: Maybe<Account_Segment>;
  /** delete data from the table: "account_user" */
  delete_account_user?: Maybe<Account_User_Mutation_Response>;
  /** delete single row from the table: "account_user" */
  delete_account_user_by_pk?: Maybe<Account_User>;
  /** delete data from the table: "accounts" */
  delete_accounts?: Maybe<Accounts_Mutation_Response>;
  /** delete single row from the table: "accounts" */
  delete_accounts_by_pk?: Maybe<Accounts>;
  /** delete data from the table: "action_events" */
  delete_action_events?: Maybe<Action_Events_Mutation_Response>;
  /** delete single row from the table: "action_events" */
  delete_action_events_by_pk?: Maybe<Action_Events>;
  /** delete data from the table: "balances" */
  delete_balances?: Maybe<Balances_Mutation_Response>;
  /** delete single row from the table: "balances" */
  delete_balances_by_pk?: Maybe<Balances>;
  /** delete data from the table: "channel_links" */
  delete_channel_links?: Maybe<Channel_Links_Mutation_Response>;
  /** delete single row from the table: "channel_links" */
  delete_channel_links_by_pk?: Maybe<Channel_Links>;
  /** delete data from the table: "channels" */
  delete_channels?: Maybe<Channels_Mutation_Response>;
  /** delete single row from the table: "channels" */
  delete_channels_by_pk?: Maybe<Channels>;
  /** delete data from the table: "chat_messages" */
  delete_chat_messages?: Maybe<Chat_Messages_Mutation_Response>;
  /** delete single row from the table: "chat_messages" */
  delete_chat_messages_by_pk?: Maybe<Chat_Messages>;
  /** delete data from the table: "chat_participants" */
  delete_chat_participants?: Maybe<Chat_Participants_Mutation_Response>;
  /** delete single row from the table: "chat_participants" */
  delete_chat_participants_by_pk?: Maybe<Chat_Participants>;
  /** delete data from the table: "chat_threads" */
  delete_chat_threads?: Maybe<Chat_Threads_Mutation_Response>;
  /** delete single row from the table: "chat_threads" */
  delete_chat_threads_by_pk?: Maybe<Chat_Threads>;
  /** delete data from the table: "companies" */
  delete_companies?: Maybe<Companies_Mutation_Response>;
  /** delete single row from the table: "companies" */
  delete_companies_by_pk?: Maybe<Companies>;
  /** delete data from the table: "creator_onboarding" */
  delete_creator_onboarding?: Maybe<Creator_Onboarding_Mutation_Response>;
  /** delete single row from the table: "creator_onboarding" */
  delete_creator_onboarding_by_pk?: Maybe<Creator_Onboarding>;
  /** delete data from the table: "crm_segments" */
  delete_crm_segments?: Maybe<Crm_Segments_Mutation_Response>;
  /** delete single row from the table: "crm_segments" */
  delete_crm_segments_by_pk?: Maybe<Crm_Segments>;
  /** delete data from the table: "crop_user" */
  delete_crop_user?: Maybe<Crop_User_Mutation_Response>;
  /** delete single row from the table: "crop_user" */
  delete_crop_user_by_pk?: Maybe<Crop_User>;
  /** delete data from the table: "failed_jobs" */
  delete_failed_jobs?: Maybe<Failed_Jobs_Mutation_Response>;
  /** delete single row from the table: "failed_jobs" */
  delete_failed_jobs_by_pk?: Maybe<Failed_Jobs>;
  /** delete data from the table: "farmer_account_locations" */
  delete_farmer_account_locations?: Maybe<Farmer_Account_Locations_Mutation_Response>;
  /** delete single row from the table: "farmer_account_locations" */
  delete_farmer_account_locations_by_pk?: Maybe<Farmer_Account_Locations>;
  /** delete data from the table: "farmer_accounts" */
  delete_farmer_accounts?: Maybe<Farmer_Accounts_Mutation_Response>;
  /** delete single row from the table: "farmer_accounts" */
  delete_farmer_accounts_by_pk?: Maybe<Farmer_Accounts>;
  /** delete data from the table: "farmer_actions" */
  delete_farmer_actions?: Maybe<Farmer_Actions_Mutation_Response>;
  /** delete single row from the table: "farmer_actions" */
  delete_farmer_actions_by_pk?: Maybe<Farmer_Actions>;
  /** delete data from the table: "farmer_fields" */
  delete_farmer_fields?: Maybe<Farmer_Fields_Mutation_Response>;
  /** delete single row from the table: "farmer_fields" */
  delete_farmer_fields_by_pk?: Maybe<Farmer_Fields>;
  /** delete data from the table: "farmer_master" */
  delete_farmer_master?: Maybe<Farmer_Master_Mutation_Response>;
  /** delete single row from the table: "farmer_master" */
  delete_farmer_master_by_pk?: Maybe<Farmer_Master>;
  /** delete data from the table: "farmer_nearby_field_force" */
  delete_farmer_nearby_field_force?: Maybe<Farmer_Nearby_Field_Force_Mutation_Response>;
  /** delete single row from the table: "farmer_nearby_field_force" */
  delete_farmer_nearby_field_force_by_pk?: Maybe<Farmer_Nearby_Field_Force>;
  /** delete data from the table: "farmer_plots" */
  delete_farmer_plots?: Maybe<Farmer_Plots_Mutation_Response>;
  /** delete single row from the table: "farmer_plots" */
  delete_farmer_plots_by_pk?: Maybe<Farmer_Plots>;
  /** delete data from the table: "farminsta_links" */
  delete_farminsta_links?: Maybe<Farminsta_Links_Mutation_Response>;
  /** delete single row from the table: "farminsta_links" */
  delete_farminsta_links_by_pk?: Maybe<Farminsta_Links>;
  /** delete data from the table: "features" */
  delete_features?: Maybe<Features_Mutation_Response>;
  /** delete single row from the table: "features" */
  delete_features_by_pk?: Maybe<Features>;
  /** delete data from the table: "field_partner_response_events" */
  delete_field_partner_response_events?: Maybe<Field_Partner_Response_Events_Mutation_Response>;
  /** delete single row from the table: "field_partner_response_events" */
  delete_field_partner_response_events_by_pk?: Maybe<Field_Partner_Response_Events>;
  /** delete data from the table: "field_partner_response_messages" */
  delete_field_partner_response_messages?: Maybe<Field_Partner_Response_Messages_Mutation_Response>;
  /** delete single row from the table: "field_partner_response_messages" */
  delete_field_partner_response_messages_by_pk?: Maybe<Field_Partner_Response_Messages>;
  /** delete data from the table: "field_partner_responses" */
  delete_field_partner_responses?: Maybe<Field_Partner_Responses_Mutation_Response>;
  /** delete single row from the table: "field_partner_responses" */
  delete_field_partner_responses_by_pk?: Maybe<Field_Partner_Responses>;
  /** delete data from the table: "field_scheduled_visits" */
  delete_field_scheduled_visits?: Maybe<Field_Scheduled_Visits_Mutation_Response>;
  /** delete single row from the table: "field_scheduled_visits" */
  delete_field_scheduled_visits_by_pk?: Maybe<Field_Scheduled_Visits>;
  /** delete data from the table: "fo_reels_staging" */
  delete_fo_reels_staging?: Maybe<Fo_Reels_Staging_Mutation_Response>;
  /** delete single row from the table: "fo_reels_staging" */
  delete_fo_reels_staging_by_pk?: Maybe<Fo_Reels_Staging>;
  /** delete data from the table: "follows" */
  delete_follows?: Maybe<Follows_Mutation_Response>;
  /** delete single row from the table: "follows" */
  delete_follows_by_pk?: Maybe<Follows>;
  /** delete data from the table: "geometry_columns" */
  delete_geometry_columns?: Maybe<Geometry_Columns_Mutation_Response>;
  /** delete data from the table: "gig_faqs" */
  delete_gig_faqs?: Maybe<Gig_Faqs_Mutation_Response>;
  /** delete single row from the table: "gig_faqs" */
  delete_gig_faqs_by_pk?: Maybe<Gig_Faqs>;
  /** delete data from the table: "gig_promos" */
  delete_gig_promos?: Maybe<Gig_Promos_Mutation_Response>;
  /** delete single row from the table: "gig_promos" */
  delete_gig_promos_by_pk?: Maybe<Gig_Promos>;
  /** delete data from the table: "gig_variants" */
  delete_gig_variants?: Maybe<Gig_Variants_Mutation_Response>;
  /** delete single row from the table: "gig_variants" */
  delete_gig_variants_by_pk?: Maybe<Gig_Variants>;
  /** delete data from the table: "gigs" */
  delete_gigs?: Maybe<Gigs_Mutation_Response>;
  /** delete single row from the table: "gigs" */
  delete_gigs_by_pk?: Maybe<Gigs>;
  /** delete data from the table: "gis.districts" */
  delete_gis_districts?: Maybe<Gis_Districts_Mutation_Response>;
  /** delete single row from the table: "gis.districts" */
  delete_gis_districts_by_pk?: Maybe<Gis_Districts>;
  /** delete data from the table: "gis.states" */
  delete_gis_states?: Maybe<Gis_States_Mutation_Response>;
  /** delete single row from the table: "gis.states" */
  delete_gis_states_by_pk?: Maybe<Gis_States>;
  /** delete data from the table: "last_known_locations" */
  delete_last_known_locations?: Maybe<Last_Known_Locations_Mutation_Response>;
  /** delete single row from the table: "last_known_locations" */
  delete_last_known_locations_by_pk?: Maybe<Last_Known_Locations>;
  /** delete data from the table: "master_crops" */
  delete_master_crops?: Maybe<Master_Crops_Mutation_Response>;
  /** delete single row from the table: "master_crops" */
  delete_master_crops_by_pk?: Maybe<Master_Crops>;
  /** delete data from the table: "master_segments" */
  delete_master_segments?: Maybe<Master_Segments_Mutation_Response>;
  /** delete single row from the table: "master_segments" */
  delete_master_segments_by_pk?: Maybe<Master_Segments>;
  /** delete data from the table: "messaging_campaign_recipients" */
  delete_messaging_campaign_recipients?: Maybe<Messaging_Campaign_Recipients_Mutation_Response>;
  /** delete single row from the table: "messaging_campaign_recipients" */
  delete_messaging_campaign_recipients_by_pk?: Maybe<Messaging_Campaign_Recipients>;
  /** delete data from the table: "messaging_campaign_segments" */
  delete_messaging_campaign_segments?: Maybe<Messaging_Campaign_Segments_Mutation_Response>;
  /** delete single row from the table: "messaging_campaign_segments" */
  delete_messaging_campaign_segments_by_pk?: Maybe<Messaging_Campaign_Segments>;
  /** delete data from the table: "messaging_campaigns" */
  delete_messaging_campaigns?: Maybe<Messaging_Campaigns_Mutation_Response>;
  /** delete single row from the table: "messaging_campaigns" */
  delete_messaging_campaigns_by_pk?: Maybe<Messaging_Campaigns>;
  /** delete data from the table: "messaging_templates" */
  delete_messaging_templates?: Maybe<Messaging_Templates_Mutation_Response>;
  /** delete single row from the table: "messaging_templates" */
  delete_messaging_templates_by_pk?: Maybe<Messaging_Templates>;
  /** delete data from the table: "migrations" */
  delete_migrations?: Maybe<Migrations_Mutation_Response>;
  /** delete single row from the table: "migrations" */
  delete_migrations_by_pk?: Maybe<Migrations>;
  /** delete data from the table: "missed_call_number_pool" */
  delete_missed_call_number_pool?: Maybe<Missed_Call_Number_Pool_Mutation_Response>;
  /** delete single row from the table: "missed_call_number_pool" */
  delete_missed_call_number_pool_by_pk?: Maybe<Missed_Call_Number_Pool>;
  /** delete data from the table: "missed_calls" */
  delete_missed_calls?: Maybe<Missed_Calls_Mutation_Response>;
  /** delete single row from the table: "missed_calls" */
  delete_missed_calls_by_pk?: Maybe<Missed_Calls>;
  /** delete data from the table: "model_has_permissions" */
  delete_model_has_permissions?: Maybe<Model_Has_Permissions_Mutation_Response>;
  /** delete single row from the table: "model_has_permissions" */
  delete_model_has_permissions_by_pk?: Maybe<Model_Has_Permissions>;
  /** delete data from the table: "model_has_roles" */
  delete_model_has_roles?: Maybe<Model_Has_Roles_Mutation_Response>;
  /** delete single row from the table: "model_has_roles" */
  delete_model_has_roles_by_pk?: Maybe<Model_Has_Roles>;
  /** delete data from the table: "notifications" */
  delete_notifications?: Maybe<Notifications_Mutation_Response>;
  /** delete single row from the table: "notifications" */
  delete_notifications_by_pk?: Maybe<Notifications>;
  /** delete data from the table: "nova_field_attachments" */
  delete_nova_field_attachments?: Maybe<Nova_Field_Attachments_Mutation_Response>;
  /** delete single row from the table: "nova_field_attachments" */
  delete_nova_field_attachments_by_pk?: Maybe<Nova_Field_Attachments>;
  /** delete data from the table: "nova_notifications" */
  delete_nova_notifications?: Maybe<Nova_Notifications_Mutation_Response>;
  /** delete single row from the table: "nova_notifications" */
  delete_nova_notifications_by_pk?: Maybe<Nova_Notifications>;
  /** delete data from the table: "nova_pending_field_attachments" */
  delete_nova_pending_field_attachments?: Maybe<Nova_Pending_Field_Attachments_Mutation_Response>;
  /** delete single row from the table: "nova_pending_field_attachments" */
  delete_nova_pending_field_attachments_by_pk?: Maybe<Nova_Pending_Field_Attachments>;
  /** delete data from the table: "nova_twofa" */
  delete_nova_twofa?: Maybe<Nova_Twofa_Mutation_Response>;
  /** delete single row from the table: "nova_twofa" */
  delete_nova_twofa_by_pk?: Maybe<Nova_Twofa>;
  /** delete data from the table: "pairing_codes" */
  delete_pairing_codes?: Maybe<Pairing_Codes_Mutation_Response>;
  /** delete single row from the table: "pairing_codes" */
  delete_pairing_codes_by_pk?: Maybe<Pairing_Codes>;
  /** delete data from the table: "password_reset_tokens" */
  delete_password_reset_tokens?: Maybe<Password_Reset_Tokens_Mutation_Response>;
  /** delete single row from the table: "password_reset_tokens" */
  delete_password_reset_tokens_by_pk?: Maybe<Password_Reset_Tokens>;
  /** delete data from the table: "permissions" */
  delete_permissions?: Maybe<Permissions_Mutation_Response>;
  /** delete single row from the table: "permissions" */
  delete_permissions_by_pk?: Maybe<Permissions>;
  /** delete data from the table: "personal_access_tokens" */
  delete_personal_access_tokens?: Maybe<Personal_Access_Tokens_Mutation_Response>;
  /** delete single row from the table: "personal_access_tokens" */
  delete_personal_access_tokens_by_pk?: Maybe<Personal_Access_Tokens>;
  /** delete data from the table: "personal_dashboard" */
  delete_personal_dashboard?: Maybe<Personal_Dashboard_Mutation_Response>;
  /** delete single row from the table: "personal_dashboard" */
  delete_personal_dashboard_by_pk?: Maybe<Personal_Dashboard>;
  /** delete data from the table: "runpando_pro.products" */
  delete_pf_products?: Maybe<Pf_Products_Mutation_Response>;
  /** delete single row from the table: "runpando_pro.products" */
  delete_pf_products_by_pk?: Maybe<Pf_Products>;
  /** delete data from the table: "runpando_pro.user_travellog" */
  delete_pf_user_travellog?: Maybe<Pf_User_Travellog_Mutation_Response>;
  /** delete single row from the table: "runpando_pro.user_travellog" */
  delete_pf_user_travellog_by_pk?: Maybe<Pf_User_Travellog>;
  /** delete data from the table: "product_pop_media" */
  delete_product_pop_media?: Maybe<Product_Pop_Media_Mutation_Response>;
  /** delete single row from the table: "product_pop_media" */
  delete_product_pop_media_by_pk?: Maybe<Product_Pop_Media>;
  /** delete data from the table: "product_pops" */
  delete_product_pops?: Maybe<Product_Pops_Mutation_Response>;
  /** delete single row from the table: "product_pops" */
  delete_product_pops_by_pk?: Maybe<Product_Pops>;
  /** delete data from the table: "prospect_crops" */
  delete_prospect_crops?: Maybe<Prospect_Crops_Mutation_Response>;
  /** delete single row from the table: "prospect_crops" */
  delete_prospect_crops_by_pk?: Maybe<Prospect_Crops>;
  /** delete data from the table: "prospect_messages" */
  delete_prospect_messages?: Maybe<Prospect_Messages_Mutation_Response>;
  /** delete single row from the table: "prospect_messages" */
  delete_prospect_messages_by_pk?: Maybe<Prospect_Messages>;
  /** delete data from the table: "prospect_user" */
  delete_prospect_user?: Maybe<Prospect_User_Mutation_Response>;
  /** delete single row from the table: "prospect_user" */
  delete_prospect_user_by_pk?: Maybe<Prospect_User>;
  /** delete data from the table: "prospects" */
  delete_prospects?: Maybe<Prospects_Mutation_Response>;
  /** delete single row from the table: "prospects" */
  delete_prospects_by_pk?: Maybe<Prospects>;
  /** delete data from the table: "reel_category" */
  delete_reel_category?: Maybe<Reel_Category_Mutation_Response>;
  /** delete single row from the table: "reel_category" */
  delete_reel_category_by_pk?: Maybe<Reel_Category>;
  /** delete data from the table: "reel_comments" */
  delete_reel_comments?: Maybe<Reel_Comments_Mutation_Response>;
  /** delete single row from the table: "reel_comments" */
  delete_reel_comments_by_pk?: Maybe<Reel_Comments>;
  /** delete data from the table: "reel_interactions" */
  delete_reel_interactions?: Maybe<Reel_Interactions_Mutation_Response>;
  /** delete single row from the table: "reel_interactions" */
  delete_reel_interactions_by_pk?: Maybe<Reel_Interactions>;
  /** delete data from the table: "reel_stats" */
  delete_reel_stats?: Maybe<Reel_Stats_Mutation_Response>;
  /** delete single row from the table: "reel_stats" */
  delete_reel_stats_by_pk?: Maybe<Reel_Stats>;
  /** delete data from the table: "reel_user_reports" */
  delete_reel_user_reports?: Maybe<Reel_User_Reports_Mutation_Response>;
  /** delete single row from the table: "reel_user_reports" */
  delete_reel_user_reports_by_pk?: Maybe<Reel_User_Reports>;
  /** delete data from the table: "reels" */
  delete_reels?: Maybe<Reels_Mutation_Response>;
  /** delete single row from the table: "reels" */
  delete_reels_by_pk?: Maybe<Reels>;
  /** delete data from the table: "reels_with_distance" */
  delete_reels_with_distance?: Maybe<Reels_With_Distance_Mutation_Response>;
  /** delete data from the table: "retailer_establishments" */
  delete_retailer_establishments?: Maybe<Retailer_Establishments_Mutation_Response>;
  /** delete single row from the table: "retailer_establishments" */
  delete_retailer_establishments_by_pk?: Maybe<Retailer_Establishments>;
  /** delete data from the table: "retailers" */
  delete_retailers?: Maybe<Retailers_Mutation_Response>;
  /** delete single row from the table: "retailers" */
  delete_retailers_by_pk?: Maybe<Retailers>;
  /** delete data from the table: "role_has_permissions" */
  delete_role_has_permissions?: Maybe<Role_Has_Permissions_Mutation_Response>;
  /** delete single row from the table: "role_has_permissions" */
  delete_role_has_permissions_by_pk?: Maybe<Role_Has_Permissions>;
  /** delete data from the table: "roles" */
  delete_roles?: Maybe<Roles_Mutation_Response>;
  /** delete single row from the table: "roles" */
  delete_roles_by_pk?: Maybe<Roles>;
  /** delete data from the table: "runpando_pro.all_state_data" */
  delete_runpando_pro_all_state_data?: Maybe<Runpando_Pro_All_State_Data_Mutation_Response>;
  /** delete single row from the table: "runpando_pro.all_state_data" */
  delete_runpando_pro_all_state_data_by_pk?: Maybe<Runpando_Pro_All_State_Data>;
  /** delete data from the table: "runpando_pro.users" */
  delete_runpando_pro_users?: Maybe<Runpando_Pro_Users_Mutation_Response>;
  /** delete single row from the table: "runpando_pro.users" */
  delete_runpando_pro_users_by_pk?: Maybe<Runpando_Pro_Users>;
  /** delete data from the table: "runpando_pro.users_locations" */
  delete_runpando_pro_users_locations?: Maybe<Runpando_Pro_Users_Locations_Mutation_Response>;
  /** delete single row from the table: "runpando_pro.users_locations" */
  delete_runpando_pro_users_locations_by_pk?: Maybe<Runpando_Pro_Users_Locations>;
  /** delete data from the table: "sale_items" */
  delete_sale_items?: Maybe<Sale_Items_Mutation_Response>;
  /** delete single row from the table: "sale_items" */
  delete_sale_items_by_pk?: Maybe<Sale_Items>;
  /** delete data from the table: "sale_payments" */
  delete_sale_payments?: Maybe<Sale_Payments_Mutation_Response>;
  /** delete single row from the table: "sale_payments" */
  delete_sale_payments_by_pk?: Maybe<Sale_Payments>;
  /** delete data from the table: "sale_proof_events" */
  delete_sale_proof_events?: Maybe<Sale_Proof_Events_Mutation_Response>;
  /** delete single row from the table: "sale_proof_events" */
  delete_sale_proof_events_by_pk?: Maybe<Sale_Proof_Events>;
  /** delete data from the table: "sale_proof_types" */
  delete_sale_proof_types?: Maybe<Sale_Proof_Types_Mutation_Response>;
  /** delete single row from the table: "sale_proof_types" */
  delete_sale_proof_types_by_pk?: Maybe<Sale_Proof_Types>;
  /** delete data from the table: "sale_proofs" */
  delete_sale_proofs?: Maybe<Sale_Proofs_Mutation_Response>;
  /** delete single row from the table: "sale_proofs" */
  delete_sale_proofs_by_pk?: Maybe<Sale_Proofs>;
  /** delete data from the table: "sales" */
  delete_sales?: Maybe<Sales_Mutation_Response>;
  /** delete single row from the table: "sales" */
  delete_sales_by_pk?: Maybe<Sales>;
  /** delete data from the table: "saved_reels" */
  delete_saved_reels?: Maybe<Saved_Reels_Mutation_Response>;
  /** delete single row from the table: "saved_reels" */
  delete_saved_reels_by_pk?: Maybe<Saved_Reels>;
  /** delete data from the table: "segment_user" */
  delete_segment_user?: Maybe<Segment_User_Mutation_Response>;
  /** delete single row from the table: "segment_user" */
  delete_segment_user_by_pk?: Maybe<Segment_User>;
  /** delete data from the table: "service_request_dashboard" */
  delete_service_request_dashboard?: Maybe<Service_Request_Dashboard_Mutation_Response>;
  /** delete single row from the table: "service_request_dashboard" */
  delete_service_request_dashboard_by_pk?: Maybe<Service_Request_Dashboard>;
  /** delete data from the table: "service_request_recommendations" */
  delete_service_request_recommendations?: Maybe<Service_Request_Recommendations_Mutation_Response>;
  /** delete single row from the table: "service_request_recommendations" */
  delete_service_request_recommendations_by_pk?: Maybe<Service_Request_Recommendations>;
  /** delete data from the table: "service_request_retailer" */
  delete_service_request_retailer?: Maybe<Service_Request_Retailer_Mutation_Response>;
  /** delete single row from the table: "service_request_retailer" */
  delete_service_request_retailer_by_pk?: Maybe<Service_Request_Retailer>;
  /** delete data from the table: "service_requests" */
  delete_service_requests?: Maybe<Service_Requests_Mutation_Response>;
  /** delete single row from the table: "service_requests" */
  delete_service_requests_by_pk?: Maybe<Service_Requests>;
  /** delete data from the table: "snapshots" */
  delete_snapshots?: Maybe<Snapshots_Mutation_Response>;
  /** delete single row from the table: "snapshots" */
  delete_snapshots_by_pk?: Maybe<Snapshots>;
  /** delete data from the table: "spatial_ref_sys" */
  delete_spatial_ref_sys?: Maybe<Spatial_Ref_Sys_Mutation_Response>;
  /** delete single row from the table: "spatial_ref_sys" */
  delete_spatial_ref_sys_by_pk?: Maybe<Spatial_Ref_Sys>;
  /** delete data from the table: "stored_events" */
  delete_stored_events?: Maybe<Stored_Events_Mutation_Response>;
  /** delete single row from the table: "stored_events" */
  delete_stored_events_by_pk?: Maybe<Stored_Events>;
  /** delete data from the table: "taggables" */
  delete_taggables?: Maybe<Taggables_Mutation_Response>;
  /** delete single row from the table: "taggables" */
  delete_taggables_by_pk?: Maybe<Taggables>;
  /** delete data from the table: "tags" */
  delete_tags?: Maybe<Tags_Mutation_Response>;
  /** delete single row from the table: "tags" */
  delete_tags_by_pk?: Maybe<Tags>;
  /** delete data from the table: "user_device" */
  delete_user_device?: Maybe<User_Device_Mutation_Response>;
  /** delete single row from the table: "user_device" */
  delete_user_device_by_pk?: Maybe<User_Device>;
  /** delete data from the table: "user_feedbacks" */
  delete_user_feedbacks?: Maybe<User_Feedbacks_Mutation_Response>;
  /** delete single row from the table: "user_feedbacks" */
  delete_user_feedbacks_by_pk?: Maybe<User_Feedbacks>;
  /** delete data from the table: "user_follows_channel" */
  delete_user_follows_channel?: Maybe<User_Follows_Channel_Mutation_Response>;
  /** delete single row from the table: "user_follows_channel" */
  delete_user_follows_channel_by_pk?: Maybe<User_Follows_Channel>;
  /** delete data from the table: "user_location_logs" */
  delete_user_location_logs?: Maybe<User_Location_Logs_Mutation_Response>;
  /** delete single row from the table: "user_location_logs" */
  delete_user_location_logs_by_pk?: Maybe<User_Location_Logs>;
  /** delete data from the table: "users" */
  delete_users?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<Users>;
  /** delete data from the table: "wallets" */
  delete_wallets?: Maybe<Wallets_Mutation_Response>;
  /** delete single row from the table: "wallets" */
  delete_wallets_by_pk?: Maybe<Wallets>;
  /** delete data from the table: "whatsauth_logins" */
  delete_whatsauth_logins?: Maybe<Whatsauth_Logins_Mutation_Response>;
  /** delete single row from the table: "whatsauth_logins" */
  delete_whatsauth_logins_by_pk?: Maybe<Whatsauth_Logins>;
  /** delete data from the table: "work_order_checklist_items" */
  delete_work_order_checklist_items?: Maybe<Work_Order_Checklist_Items_Mutation_Response>;
  /** delete single row from the table: "work_order_checklist_items" */
  delete_work_order_checklist_items_by_pk?: Maybe<Work_Order_Checklist_Items>;
  /** delete data from the table: "work_order_messages" */
  delete_work_order_messages?: Maybe<Work_Order_Messages_Mutation_Response>;
  /** delete single row from the table: "work_order_messages" */
  delete_work_order_messages_by_pk?: Maybe<Work_Order_Messages>;
  /** delete data from the table: "work_order_outputs" */
  delete_work_order_outputs?: Maybe<Work_Order_Outputs_Mutation_Response>;
  /** delete single row from the table: "work_order_outputs" */
  delete_work_order_outputs_by_pk?: Maybe<Work_Order_Outputs>;
  /** delete data from the table: "work_order_requests" */
  delete_work_order_requests?: Maybe<Work_Order_Requests_Mutation_Response>;
  /** delete single row from the table: "work_order_requests" */
  delete_work_order_requests_by_pk?: Maybe<Work_Order_Requests>;
  /** delete data from the table: "work_order_reviews" */
  delete_work_order_reviews?: Maybe<Work_Order_Reviews_Mutation_Response>;
  /** delete single row from the table: "work_order_reviews" */
  delete_work_order_reviews_by_pk?: Maybe<Work_Order_Reviews>;
  /** delete data from the table: "work_orders" */
  delete_work_orders?: Maybe<Work_Orders_Mutation_Response>;
  /** delete single row from the table: "work_orders" */
  delete_work_orders_by_pk?: Maybe<Work_Orders>;
  editInfluencerGigProfile: DefaultCommandOutput;
  farmerAcceptsConnection: DefaultCommandOutput;
  farmerAcceptsVisitSchedule: DefaultCommandOutput;
  farmerCancelsServiceRequest: DefaultCommandOutput;
  farmerClosesResponse: DefaultCommandOutput;
  farmerClosesServiceRequest: DefaultCommandOutput;
  farmerCreatesServiceRequest: DefaultCommandOutput;
  farmerMessagesOnProspect: DefaultCommandOutput;
  farmerRatesAndReviewsServiceRequest: DefaultCommandOutput;
  farmerRejectsConnection: DefaultCommandOutput;
  ffWentOffline: DefaultCommandOutput;
  ffWentOnline: DefaultCommandOutput;
  fieldPartnerCancelsAVisit: DefaultCommandOutput;
  fieldPartnerClosesRequest: DefaultCommandOutput;
  fieldPartnerRatesAndReviewsFarmer: DefaultCommandOutput;
  fieldPartnerRespondsToRequest: DefaultCommandOutput;
  fieldPartnerSchedulesAVisit: DefaultCommandOutput;
  fieldPartnerUpdatesHisCrops: DefaultCommandOutput;
  fieldPartnerUpdatesHisSegments: DefaultCommandOutput;
  foCreateReel: DefaultCommandOutput;
  foCreatesFarmer: User;
  foPlanBasedRecommendation: Scalars['String']['output'];
  forceDeleteProduct: Scalars['Boolean']['output'];
  hub_?: Maybe<Hub_Mutation>;
  influencerAppliesForWorkOrder: DefaultCommandOutput;
  influencerRejectsWorkOrder?: Maybe<WorkOrder>;
  influencerWorkorderFeedback: DefaultCommandOutput;
  initiateWorkorderClosure: Scalars['JSON']['output'];
  /** insert data into the table: "account_auth_key" */
  insert_account_auth_key?: Maybe<Account_Auth_Key_Mutation_Response>;
  /** insert a single row into the table: "account_auth_key" */
  insert_account_auth_key_one?: Maybe<Account_Auth_Key>;
  /** insert data into the table: "account_crop" */
  insert_account_crop?: Maybe<Account_Crop_Mutation_Response>;
  /** insert a single row into the table: "account_crop" */
  insert_account_crop_one?: Maybe<Account_Crop>;
  /** insert data into the table: "account_segment" */
  insert_account_segment?: Maybe<Account_Segment_Mutation_Response>;
  /** insert a single row into the table: "account_segment" */
  insert_account_segment_one?: Maybe<Account_Segment>;
  /** insert data into the table: "account_user" */
  insert_account_user?: Maybe<Account_User_Mutation_Response>;
  /** insert a single row into the table: "account_user" */
  insert_account_user_one?: Maybe<Account_User>;
  /** insert data into the table: "accounts" */
  insert_accounts?: Maybe<Accounts_Mutation_Response>;
  /** insert a single row into the table: "accounts" */
  insert_accounts_one?: Maybe<Accounts>;
  /** insert data into the table: "action_events" */
  insert_action_events?: Maybe<Action_Events_Mutation_Response>;
  /** insert a single row into the table: "action_events" */
  insert_action_events_one?: Maybe<Action_Events>;
  /** insert data into the table: "balances" */
  insert_balances?: Maybe<Balances_Mutation_Response>;
  /** insert a single row into the table: "balances" */
  insert_balances_one?: Maybe<Balances>;
  /** insert data into the table: "channel_links" */
  insert_channel_links?: Maybe<Channel_Links_Mutation_Response>;
  /** insert a single row into the table: "channel_links" */
  insert_channel_links_one?: Maybe<Channel_Links>;
  /** insert data into the table: "channels" */
  insert_channels?: Maybe<Channels_Mutation_Response>;
  /** insert a single row into the table: "channels" */
  insert_channels_one?: Maybe<Channels>;
  /** insert data into the table: "chat_messages" */
  insert_chat_messages?: Maybe<Chat_Messages_Mutation_Response>;
  /** insert a single row into the table: "chat_messages" */
  insert_chat_messages_one?: Maybe<Chat_Messages>;
  /** insert data into the table: "chat_participants" */
  insert_chat_participants?: Maybe<Chat_Participants_Mutation_Response>;
  /** insert a single row into the table: "chat_participants" */
  insert_chat_participants_one?: Maybe<Chat_Participants>;
  /** insert data into the table: "chat_threads" */
  insert_chat_threads?: Maybe<Chat_Threads_Mutation_Response>;
  /** insert a single row into the table: "chat_threads" */
  insert_chat_threads_one?: Maybe<Chat_Threads>;
  /** insert data into the table: "companies" */
  insert_companies?: Maybe<Companies_Mutation_Response>;
  /** insert a single row into the table: "companies" */
  insert_companies_one?: Maybe<Companies>;
  /** insert data into the table: "creator_onboarding" */
  insert_creator_onboarding?: Maybe<Creator_Onboarding_Mutation_Response>;
  /** insert a single row into the table: "creator_onboarding" */
  insert_creator_onboarding_one?: Maybe<Creator_Onboarding>;
  /** insert data into the table: "crm_segments" */
  insert_crm_segments?: Maybe<Crm_Segments_Mutation_Response>;
  /** insert a single row into the table: "crm_segments" */
  insert_crm_segments_one?: Maybe<Crm_Segments>;
  /** insert data into the table: "crop_user" */
  insert_crop_user?: Maybe<Crop_User_Mutation_Response>;
  /** insert a single row into the table: "crop_user" */
  insert_crop_user_one?: Maybe<Crop_User>;
  /** insert data into the table: "failed_jobs" */
  insert_failed_jobs?: Maybe<Failed_Jobs_Mutation_Response>;
  /** insert a single row into the table: "failed_jobs" */
  insert_failed_jobs_one?: Maybe<Failed_Jobs>;
  /** insert data into the table: "farmer_account_locations" */
  insert_farmer_account_locations?: Maybe<Farmer_Account_Locations_Mutation_Response>;
  /** insert a single row into the table: "farmer_account_locations" */
  insert_farmer_account_locations_one?: Maybe<Farmer_Account_Locations>;
  /** insert data into the table: "farmer_accounts" */
  insert_farmer_accounts?: Maybe<Farmer_Accounts_Mutation_Response>;
  /** insert a single row into the table: "farmer_accounts" */
  insert_farmer_accounts_one?: Maybe<Farmer_Accounts>;
  /** insert data into the table: "farmer_actions" */
  insert_farmer_actions?: Maybe<Farmer_Actions_Mutation_Response>;
  /** insert a single row into the table: "farmer_actions" */
  insert_farmer_actions_one?: Maybe<Farmer_Actions>;
  /** insert data into the table: "farmer_fields" */
  insert_farmer_fields?: Maybe<Farmer_Fields_Mutation_Response>;
  /** insert a single row into the table: "farmer_fields" */
  insert_farmer_fields_one?: Maybe<Farmer_Fields>;
  /** insert data into the table: "farmer_master" */
  insert_farmer_master?: Maybe<Farmer_Master_Mutation_Response>;
  /** insert a single row into the table: "farmer_master" */
  insert_farmer_master_one?: Maybe<Farmer_Master>;
  /** insert data into the table: "farmer_nearby_field_force" */
  insert_farmer_nearby_field_force?: Maybe<Farmer_Nearby_Field_Force_Mutation_Response>;
  /** insert a single row into the table: "farmer_nearby_field_force" */
  insert_farmer_nearby_field_force_one?: Maybe<Farmer_Nearby_Field_Force>;
  /** insert data into the table: "farmer_plots" */
  insert_farmer_plots?: Maybe<Farmer_Plots_Mutation_Response>;
  /** insert a single row into the table: "farmer_plots" */
  insert_farmer_plots_one?: Maybe<Farmer_Plots>;
  /** insert data into the table: "farminsta_links" */
  insert_farminsta_links?: Maybe<Farminsta_Links_Mutation_Response>;
  /** insert a single row into the table: "farminsta_links" */
  insert_farminsta_links_one?: Maybe<Farminsta_Links>;
  /** insert data into the table: "features" */
  insert_features?: Maybe<Features_Mutation_Response>;
  /** insert a single row into the table: "features" */
  insert_features_one?: Maybe<Features>;
  /** insert data into the table: "field_partner_response_events" */
  insert_field_partner_response_events?: Maybe<Field_Partner_Response_Events_Mutation_Response>;
  /** insert a single row into the table: "field_partner_response_events" */
  insert_field_partner_response_events_one?: Maybe<Field_Partner_Response_Events>;
  /** insert data into the table: "field_partner_response_messages" */
  insert_field_partner_response_messages?: Maybe<Field_Partner_Response_Messages_Mutation_Response>;
  /** insert a single row into the table: "field_partner_response_messages" */
  insert_field_partner_response_messages_one?: Maybe<Field_Partner_Response_Messages>;
  /** insert data into the table: "field_partner_responses" */
  insert_field_partner_responses?: Maybe<Field_Partner_Responses_Mutation_Response>;
  /** insert a single row into the table: "field_partner_responses" */
  insert_field_partner_responses_one?: Maybe<Field_Partner_Responses>;
  /** insert data into the table: "field_scheduled_visits" */
  insert_field_scheduled_visits?: Maybe<Field_Scheduled_Visits_Mutation_Response>;
  /** insert a single row into the table: "field_scheduled_visits" */
  insert_field_scheduled_visits_one?: Maybe<Field_Scheduled_Visits>;
  /** insert data into the table: "fo_reels_staging" */
  insert_fo_reels_staging?: Maybe<Fo_Reels_Staging_Mutation_Response>;
  /** insert a single row into the table: "fo_reels_staging" */
  insert_fo_reels_staging_one?: Maybe<Fo_Reels_Staging>;
  /** insert data into the table: "follows" */
  insert_follows?: Maybe<Follows_Mutation_Response>;
  /** insert a single row into the table: "follows" */
  insert_follows_one?: Maybe<Follows>;
  /** insert data into the table: "geometry_columns" */
  insert_geometry_columns?: Maybe<Geometry_Columns_Mutation_Response>;
  /** insert a single row into the table: "geometry_columns" */
  insert_geometry_columns_one?: Maybe<Geometry_Columns>;
  /** insert data into the table: "gig_faqs" */
  insert_gig_faqs?: Maybe<Gig_Faqs_Mutation_Response>;
  /** insert a single row into the table: "gig_faqs" */
  insert_gig_faqs_one?: Maybe<Gig_Faqs>;
  /** insert data into the table: "gig_promos" */
  insert_gig_promos?: Maybe<Gig_Promos_Mutation_Response>;
  /** insert a single row into the table: "gig_promos" */
  insert_gig_promos_one?: Maybe<Gig_Promos>;
  /** insert data into the table: "gig_variants" */
  insert_gig_variants?: Maybe<Gig_Variants_Mutation_Response>;
  /** insert a single row into the table: "gig_variants" */
  insert_gig_variants_one?: Maybe<Gig_Variants>;
  /** insert data into the table: "gigs" */
  insert_gigs?: Maybe<Gigs_Mutation_Response>;
  /** insert a single row into the table: "gigs" */
  insert_gigs_one?: Maybe<Gigs>;
  /** insert data into the table: "gis.districts" */
  insert_gis_districts?: Maybe<Gis_Districts_Mutation_Response>;
  /** insert a single row into the table: "gis.districts" */
  insert_gis_districts_one?: Maybe<Gis_Districts>;
  /** insert data into the table: "gis.states" */
  insert_gis_states?: Maybe<Gis_States_Mutation_Response>;
  /** insert a single row into the table: "gis.states" */
  insert_gis_states_one?: Maybe<Gis_States>;
  /** insert data into the table: "last_known_locations" */
  insert_last_known_locations?: Maybe<Last_Known_Locations_Mutation_Response>;
  /** insert a single row into the table: "last_known_locations" */
  insert_last_known_locations_one?: Maybe<Last_Known_Locations>;
  /** insert data into the table: "master_crops" */
  insert_master_crops?: Maybe<Master_Crops_Mutation_Response>;
  /** insert a single row into the table: "master_crops" */
  insert_master_crops_one?: Maybe<Master_Crops>;
  /** insert data into the table: "master_segments" */
  insert_master_segments?: Maybe<Master_Segments_Mutation_Response>;
  /** insert a single row into the table: "master_segments" */
  insert_master_segments_one?: Maybe<Master_Segments>;
  /** insert data into the table: "messaging_campaign_recipients" */
  insert_messaging_campaign_recipients?: Maybe<Messaging_Campaign_Recipients_Mutation_Response>;
  /** insert a single row into the table: "messaging_campaign_recipients" */
  insert_messaging_campaign_recipients_one?: Maybe<Messaging_Campaign_Recipients>;
  /** insert data into the table: "messaging_campaign_segments" */
  insert_messaging_campaign_segments?: Maybe<Messaging_Campaign_Segments_Mutation_Response>;
  /** insert a single row into the table: "messaging_campaign_segments" */
  insert_messaging_campaign_segments_one?: Maybe<Messaging_Campaign_Segments>;
  /** insert data into the table: "messaging_campaigns" */
  insert_messaging_campaigns?: Maybe<Messaging_Campaigns_Mutation_Response>;
  /** insert a single row into the table: "messaging_campaigns" */
  insert_messaging_campaigns_one?: Maybe<Messaging_Campaigns>;
  /** insert data into the table: "messaging_templates" */
  insert_messaging_templates?: Maybe<Messaging_Templates_Mutation_Response>;
  /** insert a single row into the table: "messaging_templates" */
  insert_messaging_templates_one?: Maybe<Messaging_Templates>;
  /** insert data into the table: "migrations" */
  insert_migrations?: Maybe<Migrations_Mutation_Response>;
  /** insert a single row into the table: "migrations" */
  insert_migrations_one?: Maybe<Migrations>;
  /** insert data into the table: "missed_call_number_pool" */
  insert_missed_call_number_pool?: Maybe<Missed_Call_Number_Pool_Mutation_Response>;
  /** insert a single row into the table: "missed_call_number_pool" */
  insert_missed_call_number_pool_one?: Maybe<Missed_Call_Number_Pool>;
  /** insert data into the table: "missed_calls" */
  insert_missed_calls?: Maybe<Missed_Calls_Mutation_Response>;
  /** insert a single row into the table: "missed_calls" */
  insert_missed_calls_one?: Maybe<Missed_Calls>;
  /** insert data into the table: "model_has_permissions" */
  insert_model_has_permissions?: Maybe<Model_Has_Permissions_Mutation_Response>;
  /** insert a single row into the table: "model_has_permissions" */
  insert_model_has_permissions_one?: Maybe<Model_Has_Permissions>;
  /** insert data into the table: "model_has_roles" */
  insert_model_has_roles?: Maybe<Model_Has_Roles_Mutation_Response>;
  /** insert a single row into the table: "model_has_roles" */
  insert_model_has_roles_one?: Maybe<Model_Has_Roles>;
  /** insert data into the table: "notifications" */
  insert_notifications?: Maybe<Notifications_Mutation_Response>;
  /** insert a single row into the table: "notifications" */
  insert_notifications_one?: Maybe<Notifications>;
  /** insert data into the table: "nova_field_attachments" */
  insert_nova_field_attachments?: Maybe<Nova_Field_Attachments_Mutation_Response>;
  /** insert a single row into the table: "nova_field_attachments" */
  insert_nova_field_attachments_one?: Maybe<Nova_Field_Attachments>;
  /** insert data into the table: "nova_notifications" */
  insert_nova_notifications?: Maybe<Nova_Notifications_Mutation_Response>;
  /** insert a single row into the table: "nova_notifications" */
  insert_nova_notifications_one?: Maybe<Nova_Notifications>;
  /** insert data into the table: "nova_pending_field_attachments" */
  insert_nova_pending_field_attachments?: Maybe<Nova_Pending_Field_Attachments_Mutation_Response>;
  /** insert a single row into the table: "nova_pending_field_attachments" */
  insert_nova_pending_field_attachments_one?: Maybe<Nova_Pending_Field_Attachments>;
  /** insert data into the table: "nova_twofa" */
  insert_nova_twofa?: Maybe<Nova_Twofa_Mutation_Response>;
  /** insert a single row into the table: "nova_twofa" */
  insert_nova_twofa_one?: Maybe<Nova_Twofa>;
  /** insert data into the table: "pairing_codes" */
  insert_pairing_codes?: Maybe<Pairing_Codes_Mutation_Response>;
  /** insert a single row into the table: "pairing_codes" */
  insert_pairing_codes_one?: Maybe<Pairing_Codes>;
  /** insert data into the table: "password_reset_tokens" */
  insert_password_reset_tokens?: Maybe<Password_Reset_Tokens_Mutation_Response>;
  /** insert a single row into the table: "password_reset_tokens" */
  insert_password_reset_tokens_one?: Maybe<Password_Reset_Tokens>;
  /** insert data into the table: "permissions" */
  insert_permissions?: Maybe<Permissions_Mutation_Response>;
  /** insert a single row into the table: "permissions" */
  insert_permissions_one?: Maybe<Permissions>;
  /** insert data into the table: "personal_access_tokens" */
  insert_personal_access_tokens?: Maybe<Personal_Access_Tokens_Mutation_Response>;
  /** insert a single row into the table: "personal_access_tokens" */
  insert_personal_access_tokens_one?: Maybe<Personal_Access_Tokens>;
  /** insert data into the table: "personal_dashboard" */
  insert_personal_dashboard?: Maybe<Personal_Dashboard_Mutation_Response>;
  /** insert a single row into the table: "personal_dashboard" */
  insert_personal_dashboard_one?: Maybe<Personal_Dashboard>;
  /** insert data into the table: "runpando_pro.products" */
  insert_pf_products?: Maybe<Pf_Products_Mutation_Response>;
  /** insert a single row into the table: "runpando_pro.products" */
  insert_pf_products_one?: Maybe<Pf_Products>;
  /** insert data into the table: "runpando_pro.user_travellog" */
  insert_pf_user_travellog?: Maybe<Pf_User_Travellog_Mutation_Response>;
  /** insert a single row into the table: "runpando_pro.user_travellog" */
  insert_pf_user_travellog_one?: Maybe<Pf_User_Travellog>;
  /** insert data into the table: "product_pop_media" */
  insert_product_pop_media?: Maybe<Product_Pop_Media_Mutation_Response>;
  /** insert a single row into the table: "product_pop_media" */
  insert_product_pop_media_one?: Maybe<Product_Pop_Media>;
  /** insert data into the table: "product_pops" */
  insert_product_pops?: Maybe<Product_Pops_Mutation_Response>;
  /** insert a single row into the table: "product_pops" */
  insert_product_pops_one?: Maybe<Product_Pops>;
  /** insert data into the table: "prospect_crops" */
  insert_prospect_crops?: Maybe<Prospect_Crops_Mutation_Response>;
  /** insert a single row into the table: "prospect_crops" */
  insert_prospect_crops_one?: Maybe<Prospect_Crops>;
  /** insert data into the table: "prospect_messages" */
  insert_prospect_messages?: Maybe<Prospect_Messages_Mutation_Response>;
  /** insert a single row into the table: "prospect_messages" */
  insert_prospect_messages_one?: Maybe<Prospect_Messages>;
  /** insert data into the table: "prospect_user" */
  insert_prospect_user?: Maybe<Prospect_User_Mutation_Response>;
  /** insert a single row into the table: "prospect_user" */
  insert_prospect_user_one?: Maybe<Prospect_User>;
  /** insert data into the table: "prospects" */
  insert_prospects?: Maybe<Prospects_Mutation_Response>;
  /** insert a single row into the table: "prospects" */
  insert_prospects_one?: Maybe<Prospects>;
  /** insert data into the table: "reel_category" */
  insert_reel_category?: Maybe<Reel_Category_Mutation_Response>;
  /** insert a single row into the table: "reel_category" */
  insert_reel_category_one?: Maybe<Reel_Category>;
  /** insert data into the table: "reel_comments" */
  insert_reel_comments?: Maybe<Reel_Comments_Mutation_Response>;
  /** insert a single row into the table: "reel_comments" */
  insert_reel_comments_one?: Maybe<Reel_Comments>;
  /** insert data into the table: "reel_interactions" */
  insert_reel_interactions?: Maybe<Reel_Interactions_Mutation_Response>;
  /** insert a single row into the table: "reel_interactions" */
  insert_reel_interactions_one?: Maybe<Reel_Interactions>;
  /** insert data into the table: "reel_stats" */
  insert_reel_stats?: Maybe<Reel_Stats_Mutation_Response>;
  /** insert a single row into the table: "reel_stats" */
  insert_reel_stats_one?: Maybe<Reel_Stats>;
  /** insert data into the table: "reel_user_reports" */
  insert_reel_user_reports?: Maybe<Reel_User_Reports_Mutation_Response>;
  /** insert a single row into the table: "reel_user_reports" */
  insert_reel_user_reports_one?: Maybe<Reel_User_Reports>;
  /** insert data into the table: "reels" */
  insert_reels?: Maybe<Reels_Mutation_Response>;
  /** insert a single row into the table: "reels" */
  insert_reels_one?: Maybe<Reels>;
  /** insert data into the table: "reels_with_distance" */
  insert_reels_with_distance?: Maybe<Reels_With_Distance_Mutation_Response>;
  /** insert a single row into the table: "reels_with_distance" */
  insert_reels_with_distance_one?: Maybe<Reels_With_Distance>;
  /** insert data into the table: "retailer_establishments" */
  insert_retailer_establishments?: Maybe<Retailer_Establishments_Mutation_Response>;
  /** insert a single row into the table: "retailer_establishments" */
  insert_retailer_establishments_one?: Maybe<Retailer_Establishments>;
  /** insert data into the table: "retailers" */
  insert_retailers?: Maybe<Retailers_Mutation_Response>;
  /** insert a single row into the table: "retailers" */
  insert_retailers_one?: Maybe<Retailers>;
  /** insert data into the table: "role_has_permissions" */
  insert_role_has_permissions?: Maybe<Role_Has_Permissions_Mutation_Response>;
  /** insert a single row into the table: "role_has_permissions" */
  insert_role_has_permissions_one?: Maybe<Role_Has_Permissions>;
  /** insert data into the table: "roles" */
  insert_roles?: Maybe<Roles_Mutation_Response>;
  /** insert a single row into the table: "roles" */
  insert_roles_one?: Maybe<Roles>;
  /** insert data into the table: "runpando_pro.all_state_data" */
  insert_runpando_pro_all_state_data?: Maybe<Runpando_Pro_All_State_Data_Mutation_Response>;
  /** insert a single row into the table: "runpando_pro.all_state_data" */
  insert_runpando_pro_all_state_data_one?: Maybe<Runpando_Pro_All_State_Data>;
  /** insert data into the table: "runpando_pro.users" */
  insert_runpando_pro_users?: Maybe<Runpando_Pro_Users_Mutation_Response>;
  /** insert data into the table: "runpando_pro.users_locations" */
  insert_runpando_pro_users_locations?: Maybe<Runpando_Pro_Users_Locations_Mutation_Response>;
  /** insert a single row into the table: "runpando_pro.users_locations" */
  insert_runpando_pro_users_locations_one?: Maybe<Runpando_Pro_Users_Locations>;
  /** insert a single row into the table: "runpando_pro.users" */
  insert_runpando_pro_users_one?: Maybe<Runpando_Pro_Users>;
  /** insert data into the table: "sale_items" */
  insert_sale_items?: Maybe<Sale_Items_Mutation_Response>;
  /** insert a single row into the table: "sale_items" */
  insert_sale_items_one?: Maybe<Sale_Items>;
  /** insert data into the table: "sale_payments" */
  insert_sale_payments?: Maybe<Sale_Payments_Mutation_Response>;
  /** insert a single row into the table: "sale_payments" */
  insert_sale_payments_one?: Maybe<Sale_Payments>;
  /** insert data into the table: "sale_proof_events" */
  insert_sale_proof_events?: Maybe<Sale_Proof_Events_Mutation_Response>;
  /** insert a single row into the table: "sale_proof_events" */
  insert_sale_proof_events_one?: Maybe<Sale_Proof_Events>;
  /** insert data into the table: "sale_proof_types" */
  insert_sale_proof_types?: Maybe<Sale_Proof_Types_Mutation_Response>;
  /** insert a single row into the table: "sale_proof_types" */
  insert_sale_proof_types_one?: Maybe<Sale_Proof_Types>;
  /** insert data into the table: "sale_proofs" */
  insert_sale_proofs?: Maybe<Sale_Proofs_Mutation_Response>;
  /** insert a single row into the table: "sale_proofs" */
  insert_sale_proofs_one?: Maybe<Sale_Proofs>;
  /** insert data into the table: "sales" */
  insert_sales?: Maybe<Sales_Mutation_Response>;
  /** insert a single row into the table: "sales" */
  insert_sales_one?: Maybe<Sales>;
  /** insert data into the table: "saved_reels" */
  insert_saved_reels?: Maybe<Saved_Reels_Mutation_Response>;
  /** insert a single row into the table: "saved_reels" */
  insert_saved_reels_one?: Maybe<Saved_Reels>;
  /** insert data into the table: "segment_user" */
  insert_segment_user?: Maybe<Segment_User_Mutation_Response>;
  /** insert a single row into the table: "segment_user" */
  insert_segment_user_one?: Maybe<Segment_User>;
  /** insert data into the table: "service_request_dashboard" */
  insert_service_request_dashboard?: Maybe<Service_Request_Dashboard_Mutation_Response>;
  /** insert a single row into the table: "service_request_dashboard" */
  insert_service_request_dashboard_one?: Maybe<Service_Request_Dashboard>;
  /** insert data into the table: "service_request_recommendations" */
  insert_service_request_recommendations?: Maybe<Service_Request_Recommendations_Mutation_Response>;
  /** insert a single row into the table: "service_request_recommendations" */
  insert_service_request_recommendations_one?: Maybe<Service_Request_Recommendations>;
  /** insert data into the table: "service_request_retailer" */
  insert_service_request_retailer?: Maybe<Service_Request_Retailer_Mutation_Response>;
  /** insert a single row into the table: "service_request_retailer" */
  insert_service_request_retailer_one?: Maybe<Service_Request_Retailer>;
  /** insert data into the table: "service_requests" */
  insert_service_requests?: Maybe<Service_Requests_Mutation_Response>;
  /** insert a single row into the table: "service_requests" */
  insert_service_requests_one?: Maybe<Service_Requests>;
  /** insert data into the table: "snapshots" */
  insert_snapshots?: Maybe<Snapshots_Mutation_Response>;
  /** insert a single row into the table: "snapshots" */
  insert_snapshots_one?: Maybe<Snapshots>;
  /** insert data into the table: "spatial_ref_sys" */
  insert_spatial_ref_sys?: Maybe<Spatial_Ref_Sys_Mutation_Response>;
  /** insert a single row into the table: "spatial_ref_sys" */
  insert_spatial_ref_sys_one?: Maybe<Spatial_Ref_Sys>;
  /** insert data into the table: "stored_events" */
  insert_stored_events?: Maybe<Stored_Events_Mutation_Response>;
  /** insert a single row into the table: "stored_events" */
  insert_stored_events_one?: Maybe<Stored_Events>;
  /** insert data into the table: "taggables" */
  insert_taggables?: Maybe<Taggables_Mutation_Response>;
  /** insert a single row into the table: "taggables" */
  insert_taggables_one?: Maybe<Taggables>;
  /** insert data into the table: "tags" */
  insert_tags?: Maybe<Tags_Mutation_Response>;
  /** insert a single row into the table: "tags" */
  insert_tags_one?: Maybe<Tags>;
  /** insert data into the table: "user_device" */
  insert_user_device?: Maybe<User_Device_Mutation_Response>;
  /** insert a single row into the table: "user_device" */
  insert_user_device_one?: Maybe<User_Device>;
  /** insert data into the table: "user_feedbacks" */
  insert_user_feedbacks?: Maybe<User_Feedbacks_Mutation_Response>;
  /** insert a single row into the table: "user_feedbacks" */
  insert_user_feedbacks_one?: Maybe<User_Feedbacks>;
  /** insert data into the table: "user_follows_channel" */
  insert_user_follows_channel?: Maybe<User_Follows_Channel_Mutation_Response>;
  /** insert a single row into the table: "user_follows_channel" */
  insert_user_follows_channel_one?: Maybe<User_Follows_Channel>;
  /** insert data into the table: "user_location_logs" */
  insert_user_location_logs?: Maybe<User_Location_Logs_Mutation_Response>;
  /** insert a single row into the table: "user_location_logs" */
  insert_user_location_logs_one?: Maybe<User_Location_Logs>;
  /** insert data into the table: "users" */
  insert_users?: Maybe<Users_Mutation_Response>;
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<Users>;
  /** insert data into the table: "wallets" */
  insert_wallets?: Maybe<Wallets_Mutation_Response>;
  /** insert a single row into the table: "wallets" */
  insert_wallets_one?: Maybe<Wallets>;
  /** insert data into the table: "whatsauth_logins" */
  insert_whatsauth_logins?: Maybe<Whatsauth_Logins_Mutation_Response>;
  /** insert a single row into the table: "whatsauth_logins" */
  insert_whatsauth_logins_one?: Maybe<Whatsauth_Logins>;
  /** insert data into the table: "work_order_checklist_items" */
  insert_work_order_checklist_items?: Maybe<Work_Order_Checklist_Items_Mutation_Response>;
  /** insert a single row into the table: "work_order_checklist_items" */
  insert_work_order_checklist_items_one?: Maybe<Work_Order_Checklist_Items>;
  /** insert data into the table: "work_order_messages" */
  insert_work_order_messages?: Maybe<Work_Order_Messages_Mutation_Response>;
  /** insert a single row into the table: "work_order_messages" */
  insert_work_order_messages_one?: Maybe<Work_Order_Messages>;
  /** insert data into the table: "work_order_outputs" */
  insert_work_order_outputs?: Maybe<Work_Order_Outputs_Mutation_Response>;
  /** insert a single row into the table: "work_order_outputs" */
  insert_work_order_outputs_one?: Maybe<Work_Order_Outputs>;
  /** insert data into the table: "work_order_requests" */
  insert_work_order_requests?: Maybe<Work_Order_Requests_Mutation_Response>;
  /** insert a single row into the table: "work_order_requests" */
  insert_work_order_requests_one?: Maybe<Work_Order_Requests>;
  /** insert data into the table: "work_order_reviews" */
  insert_work_order_reviews?: Maybe<Work_Order_Reviews_Mutation_Response>;
  /** insert a single row into the table: "work_order_reviews" */
  insert_work_order_reviews_one?: Maybe<Work_Order_Reviews>;
  /** insert data into the table: "work_orders" */
  insert_work_orders?: Maybe<Work_Orders_Mutation_Response>;
  /** insert a single row into the table: "work_orders" */
  insert_work_orders_one?: Maybe<Work_Orders>;
  managerApprovesFoReel: DefaultCommandOutput;
  managerRejectsFoReel: DefaultCommandOutput;
  /** Mark a chat message as read by the current user. */
  markChatMessageAsRead: ChatReadReceipt;
  /** Mark all messages in a chat thread as read by the current user. */
  markChatThreadAsRead: Scalars['Int']['output'];
  onRequestKYC: KycTransaction;
  /** delete data from the table: "runpando_pro.crops" */
  pf_delete_fcm_crops?: Maybe<Pf_Fcm_Crops_Mutation_Response>;
  /** delete single row from the table: "runpando_pro.crops" */
  pf_delete_fcm_crops_by_pk?: Maybe<Pf_Fcm_Crops>;
  /** delete data from the table: "runpando_pro.products" */
  pf_delete_fcm_products?: Maybe<Pf_Fcm_Products_Mutation_Response>;
  /** delete single row from the table: "runpando_pro.products" */
  pf_delete_fcm_products_by_pk?: Maybe<Pf_Fcm_Products>;
  /** delete data from the table: "runpando_pro.plan_cards" */
  pf_delete_plan_cards?: Maybe<Pf_Plan_Cards_Mutation_Response>;
  /** delete single row from the table: "runpando_pro.plan_cards" */
  pf_delete_plan_cards_by_pk?: Maybe<Pf_Plan_Cards>;
  /** delete data from the table: "runpando_pro.activity_coins_feedback" */
  pf_delete_runpando_pro_activity_coins_feedback?: Maybe<Pf_Runpando_Pro_Activity_Coins_Feedback_Mutation_Response>;
  /** delete single row from the table: "runpando_pro.activity_coins_feedback" */
  pf_delete_runpando_pro_activity_coins_feedback_by_pk?: Maybe<Pf_Runpando_Pro_Activity_Coins_Feedback>;
  /** delete data from the table: "runpando_pro.all_state_data" */
  pf_delete_runpando_pro_all_state_data?: Maybe<Pf_Runpando_Pro_All_State_Data_Mutation_Response>;
  /** delete single row from the table: "runpando_pro.all_state_data" */
  pf_delete_runpando_pro_all_state_data_by_pk?: Maybe<Pf_Runpando_Pro_All_State_Data>;
  /** delete data from the table: "runpando_pro.campaign_card_activities" */
  pf_delete_runpando_pro_campaign_card_activities?: Maybe<Pf_Runpando_Pro_Campaign_Card_Activities_Mutation_Response>;
  /** delete single row from the table: "runpando_pro.campaign_card_activities" */
  pf_delete_runpando_pro_campaign_card_activities_by_pk?: Maybe<Pf_Runpando_Pro_Campaign_Card_Activities>;
  /** delete data from the table: "runpando_pro.channel_card_images" */
  pf_delete_runpando_pro_channel_card_images?: Maybe<Pf_Runpando_Pro_Channel_Card_Images_Mutation_Response>;
  /** delete single row from the table: "runpando_pro.channel_card_images" */
  pf_delete_runpando_pro_channel_card_images_by_pk?: Maybe<Pf_Runpando_Pro_Channel_Card_Images>;
  /** delete data from the table: "runpando_pro.users_locations" */
  pf_delete_runpando_pro_users_locations?: Maybe<Pf_Runpando_Pro_Users_Locations_Mutation_Response>;
  /** delete single row from the table: "runpando_pro.users_locations" */
  pf_delete_runpando_pro_users_locations_by_pk?: Maybe<Pf_Runpando_Pro_Users_Locations>;
  /** delete data from the table: "runpando_pro.users" */
  pf_delete_users?: Maybe<Pf_Users_Mutation_Response>;
  /** delete single row from the table: "runpando_pro.users" */
  pf_delete_users_by_pk?: Maybe<Pf_Users>;
  /** insert data into the table: "runpando_pro.crops" */
  pf_insert_fcm_crops?: Maybe<Pf_Fcm_Crops_Mutation_Response>;
  /** insert a single row into the table: "runpando_pro.crops" */
  pf_insert_fcm_crops_one?: Maybe<Pf_Fcm_Crops>;
  /** insert data into the table: "runpando_pro.products" */
  pf_insert_fcm_products?: Maybe<Pf_Fcm_Products_Mutation_Response>;
  /** insert a single row into the table: "runpando_pro.products" */
  pf_insert_fcm_products_one?: Maybe<Pf_Fcm_Products>;
  /** insert data into the table: "runpando_pro.plan_cards" */
  pf_insert_plan_cards?: Maybe<Pf_Plan_Cards_Mutation_Response>;
  /** insert a single row into the table: "runpando_pro.plan_cards" */
  pf_insert_plan_cards_one?: Maybe<Pf_Plan_Cards>;
  /** insert data into the table: "runpando_pro.activity_coins_feedback" */
  pf_insert_runpando_pro_activity_coins_feedback?: Maybe<Pf_Runpando_Pro_Activity_Coins_Feedback_Mutation_Response>;
  /** insert a single row into the table: "runpando_pro.activity_coins_feedback" */
  pf_insert_runpando_pro_activity_coins_feedback_one?: Maybe<Pf_Runpando_Pro_Activity_Coins_Feedback>;
  /** insert data into the table: "runpando_pro.all_state_data" */
  pf_insert_runpando_pro_all_state_data?: Maybe<Pf_Runpando_Pro_All_State_Data_Mutation_Response>;
  /** insert a single row into the table: "runpando_pro.all_state_data" */
  pf_insert_runpando_pro_all_state_data_one?: Maybe<Pf_Runpando_Pro_All_State_Data>;
  /** insert data into the table: "runpando_pro.campaign_card_activities" */
  pf_insert_runpando_pro_campaign_card_activities?: Maybe<Pf_Runpando_Pro_Campaign_Card_Activities_Mutation_Response>;
  /** insert a single row into the table: "runpando_pro.campaign_card_activities" */
  pf_insert_runpando_pro_campaign_card_activities_one?: Maybe<Pf_Runpando_Pro_Campaign_Card_Activities>;
  /** insert data into the table: "runpando_pro.channel_card_images" */
  pf_insert_runpando_pro_channel_card_images?: Maybe<Pf_Runpando_Pro_Channel_Card_Images_Mutation_Response>;
  /** insert a single row into the table: "runpando_pro.channel_card_images" */
  pf_insert_runpando_pro_channel_card_images_one?: Maybe<Pf_Runpando_Pro_Channel_Card_Images>;
  /** insert data into the table: "runpando_pro.users_locations" */
  pf_insert_runpando_pro_users_locations?: Maybe<Pf_Runpando_Pro_Users_Locations_Mutation_Response>;
  /** insert a single row into the table: "runpando_pro.users_locations" */
  pf_insert_runpando_pro_users_locations_one?: Maybe<Pf_Runpando_Pro_Users_Locations>;
  /** insert data into the table: "runpando_pro.users" */
  pf_insert_users?: Maybe<Pf_Users_Mutation_Response>;
  /** insert a single row into the table: "runpando_pro.users" */
  pf_insert_users_one?: Maybe<Pf_Users>;
  /** update data of the table: "runpando_pro.crops" */
  pf_update_fcm_crops?: Maybe<Pf_Fcm_Crops_Mutation_Response>;
  /** update single row of the table: "runpando_pro.crops" */
  pf_update_fcm_crops_by_pk?: Maybe<Pf_Fcm_Crops>;
  /** update multiples rows of table: "runpando_pro.crops" */
  pf_update_fcm_crops_many?: Maybe<Array<Maybe<Pf_Fcm_Crops_Mutation_Response>>>;
  /** update data of the table: "runpando_pro.products" */
  pf_update_fcm_products?: Maybe<Pf_Fcm_Products_Mutation_Response>;
  /** update single row of the table: "runpando_pro.products" */
  pf_update_fcm_products_by_pk?: Maybe<Pf_Fcm_Products>;
  /** update multiples rows of table: "runpando_pro.products" */
  pf_update_fcm_products_many?: Maybe<Array<Maybe<Pf_Fcm_Products_Mutation_Response>>>;
  /** update data of the table: "runpando_pro.plan_cards" */
  pf_update_plan_cards?: Maybe<Pf_Plan_Cards_Mutation_Response>;
  /** update single row of the table: "runpando_pro.plan_cards" */
  pf_update_plan_cards_by_pk?: Maybe<Pf_Plan_Cards>;
  /** update multiples rows of table: "runpando_pro.plan_cards" */
  pf_update_plan_cards_many?: Maybe<Array<Maybe<Pf_Plan_Cards_Mutation_Response>>>;
  /** update data of the table: "runpando_pro.activity_coins_feedback" */
  pf_update_runpando_pro_activity_coins_feedback?: Maybe<Pf_Runpando_Pro_Activity_Coins_Feedback_Mutation_Response>;
  /** update single row of the table: "runpando_pro.activity_coins_feedback" */
  pf_update_runpando_pro_activity_coins_feedback_by_pk?: Maybe<Pf_Runpando_Pro_Activity_Coins_Feedback>;
  /** update multiples rows of table: "runpando_pro.activity_coins_feedback" */
  pf_update_runpando_pro_activity_coins_feedback_many?: Maybe<Array<Maybe<Pf_Runpando_Pro_Activity_Coins_Feedback_Mutation_Response>>>;
  /** update data of the table: "runpando_pro.all_state_data" */
  pf_update_runpando_pro_all_state_data?: Maybe<Pf_Runpando_Pro_All_State_Data_Mutation_Response>;
  /** update single row of the table: "runpando_pro.all_state_data" */
  pf_update_runpando_pro_all_state_data_by_pk?: Maybe<Pf_Runpando_Pro_All_State_Data>;
  /** update multiples rows of table: "runpando_pro.all_state_data" */
  pf_update_runpando_pro_all_state_data_many?: Maybe<Array<Maybe<Pf_Runpando_Pro_All_State_Data_Mutation_Response>>>;
  /** update data of the table: "runpando_pro.campaign_card_activities" */
  pf_update_runpando_pro_campaign_card_activities?: Maybe<Pf_Runpando_Pro_Campaign_Card_Activities_Mutation_Response>;
  /** update single row of the table: "runpando_pro.campaign_card_activities" */
  pf_update_runpando_pro_campaign_card_activities_by_pk?: Maybe<Pf_Runpando_Pro_Campaign_Card_Activities>;
  /** update multiples rows of table: "runpando_pro.campaign_card_activities" */
  pf_update_runpando_pro_campaign_card_activities_many?: Maybe<Array<Maybe<Pf_Runpando_Pro_Campaign_Card_Activities_Mutation_Response>>>;
  /** update data of the table: "runpando_pro.channel_card_images" */
  pf_update_runpando_pro_channel_card_images?: Maybe<Pf_Runpando_Pro_Channel_Card_Images_Mutation_Response>;
  /** update single row of the table: "runpando_pro.channel_card_images" */
  pf_update_runpando_pro_channel_card_images_by_pk?: Maybe<Pf_Runpando_Pro_Channel_Card_Images>;
  /** update multiples rows of table: "runpando_pro.channel_card_images" */
  pf_update_runpando_pro_channel_card_images_many?: Maybe<Array<Maybe<Pf_Runpando_Pro_Channel_Card_Images_Mutation_Response>>>;
  /** update data of the table: "runpando_pro.users_locations" */
  pf_update_runpando_pro_users_locations?: Maybe<Pf_Runpando_Pro_Users_Locations_Mutation_Response>;
  /** update single row of the table: "runpando_pro.users_locations" */
  pf_update_runpando_pro_users_locations_by_pk?: Maybe<Pf_Runpando_Pro_Users_Locations>;
  /** update multiples rows of table: "runpando_pro.users_locations" */
  pf_update_runpando_pro_users_locations_many?: Maybe<Array<Maybe<Pf_Runpando_Pro_Users_Locations_Mutation_Response>>>;
  /** update data of the table: "runpando_pro.users" */
  pf_update_users?: Maybe<Pf_Users_Mutation_Response>;
  /** update single row of the table: "runpando_pro.users" */
  pf_update_users_by_pk?: Maybe<Pf_Users>;
  /** update multiples rows of table: "runpando_pro.users" */
  pf_update_users_many?: Maybe<Array<Maybe<Pf_Users_Mutation_Response>>>;
  registerFreeTrial: VerifyOtpOutput;
  registerFreelanceFieldOfficer: DefaultCommandOutput;
  registerInfluencer: DefaultCommandOutput;
  registerRetailer: RetailerRegistrationResponse;
  releaseMissedCallNumberToPool: DefaultCommandOutput;
  /** Remove a participant from a thread. */
  removeChatParticipant: Scalars['Boolean']['output'];
  /** Remove a reaction from a chat message. */
  removeChatReaction: Scalars['Boolean']['output'];
  removeWarehouseUser: Scalars['Boolean']['output'];
  reorderProductImages?: Maybe<Array<Maybe<ProductImage>>>;
  requestOtpCommand: RequestOtpOutput;
  requestRedemption: Redemption;
  reserveMissedCallNumber?: Maybe<MissedCallPool>;
  restoreProduct: SaleProduct;
  s3UploadData: Array<Scalars['String']['output']>;
  saveReel: DefaultCommandOutput;
  /** Send a data message to a chat thread. */
  sendChatDataMessage: ChatMessage;
  /** Send a text message to a chat thread. */
  sendChatTextMessage: ChatMessage;
  sendMessageOnProspect: ChatMessage;
  sendMessageOnServiceRequest: DefaultCommandOutput;
  sendMessageOnServiceRequestFPR: ChatMessage;
  sendMessageOnWorkOrder: ChatMessage;
  /** Set a chat thread as muted or unmuted for the current user. */
  setChatThreadMuted: Scalars['Boolean']['output'];
  setContentLanguages: DefaultCommandOutput;
  setFieldForceLocation: DefaultCommandOutput;
  setRoleCommand: DefaultCommandOutput;
  superAdminAcceptsOnboarding: DefaultCommandOutput;
  superAdminRejectsOnboarding: DefaultCommandOutput;
  transferInventory: InventoryTransferResultDto;
  unSaveReel: DefaultCommandOutput;
  updateCategory: Category;
  updateChannelDetails?: Maybe<Channel>;
  updateInventory: Inventory;
  /** Updates the crops associated with the current user. */
  updateMyCrops: Scalars['String']['output'];
  updateProduct: SaleProduct;
  updateProductImage: ProductImage;
  updateProductPop: ProductPopResult;
  /** Update the chat presence of a user in a thread. */
  updateUserChatPresence: Scalars['Boolean']['output'];
  updateWarehouse: Warehouse;
  /** update data of the table: "account_auth_key" */
  update_account_auth_key?: Maybe<Account_Auth_Key_Mutation_Response>;
  /** update single row of the table: "account_auth_key" */
  update_account_auth_key_by_pk?: Maybe<Account_Auth_Key>;
  /** update multiples rows of table: "account_auth_key" */
  update_account_auth_key_many?: Maybe<Array<Maybe<Account_Auth_Key_Mutation_Response>>>;
  /** update data of the table: "account_crop" */
  update_account_crop?: Maybe<Account_Crop_Mutation_Response>;
  /** update single row of the table: "account_crop" */
  update_account_crop_by_pk?: Maybe<Account_Crop>;
  /** update multiples rows of table: "account_crop" */
  update_account_crop_many?: Maybe<Array<Maybe<Account_Crop_Mutation_Response>>>;
  /** update data of the table: "account_segment" */
  update_account_segment?: Maybe<Account_Segment_Mutation_Response>;
  /** update single row of the table: "account_segment" */
  update_account_segment_by_pk?: Maybe<Account_Segment>;
  /** update multiples rows of table: "account_segment" */
  update_account_segment_many?: Maybe<Array<Maybe<Account_Segment_Mutation_Response>>>;
  /** update data of the table: "account_user" */
  update_account_user?: Maybe<Account_User_Mutation_Response>;
  /** update single row of the table: "account_user" */
  update_account_user_by_pk?: Maybe<Account_User>;
  /** update multiples rows of table: "account_user" */
  update_account_user_many?: Maybe<Array<Maybe<Account_User_Mutation_Response>>>;
  /** update data of the table: "accounts" */
  update_accounts?: Maybe<Accounts_Mutation_Response>;
  /** update single row of the table: "accounts" */
  update_accounts_by_pk?: Maybe<Accounts>;
  /** update multiples rows of table: "accounts" */
  update_accounts_many?: Maybe<Array<Maybe<Accounts_Mutation_Response>>>;
  /** update data of the table: "action_events" */
  update_action_events?: Maybe<Action_Events_Mutation_Response>;
  /** update single row of the table: "action_events" */
  update_action_events_by_pk?: Maybe<Action_Events>;
  /** update multiples rows of table: "action_events" */
  update_action_events_many?: Maybe<Array<Maybe<Action_Events_Mutation_Response>>>;
  /** update data of the table: "balances" */
  update_balances?: Maybe<Balances_Mutation_Response>;
  /** update single row of the table: "balances" */
  update_balances_by_pk?: Maybe<Balances>;
  /** update multiples rows of table: "balances" */
  update_balances_many?: Maybe<Array<Maybe<Balances_Mutation_Response>>>;
  /** update data of the table: "channel_links" */
  update_channel_links?: Maybe<Channel_Links_Mutation_Response>;
  /** update single row of the table: "channel_links" */
  update_channel_links_by_pk?: Maybe<Channel_Links>;
  /** update multiples rows of table: "channel_links" */
  update_channel_links_many?: Maybe<Array<Maybe<Channel_Links_Mutation_Response>>>;
  /** update data of the table: "channels" */
  update_channels?: Maybe<Channels_Mutation_Response>;
  /** update single row of the table: "channels" */
  update_channels_by_pk?: Maybe<Channels>;
  /** update multiples rows of table: "channels" */
  update_channels_many?: Maybe<Array<Maybe<Channels_Mutation_Response>>>;
  /** update data of the table: "chat_messages" */
  update_chat_messages?: Maybe<Chat_Messages_Mutation_Response>;
  /** update single row of the table: "chat_messages" */
  update_chat_messages_by_pk?: Maybe<Chat_Messages>;
  /** update multiples rows of table: "chat_messages" */
  update_chat_messages_many?: Maybe<Array<Maybe<Chat_Messages_Mutation_Response>>>;
  /** update data of the table: "chat_participants" */
  update_chat_participants?: Maybe<Chat_Participants_Mutation_Response>;
  /** update single row of the table: "chat_participants" */
  update_chat_participants_by_pk?: Maybe<Chat_Participants>;
  /** update multiples rows of table: "chat_participants" */
  update_chat_participants_many?: Maybe<Array<Maybe<Chat_Participants_Mutation_Response>>>;
  /** update data of the table: "chat_threads" */
  update_chat_threads?: Maybe<Chat_Threads_Mutation_Response>;
  /** update single row of the table: "chat_threads" */
  update_chat_threads_by_pk?: Maybe<Chat_Threads>;
  /** update multiples rows of table: "chat_threads" */
  update_chat_threads_many?: Maybe<Array<Maybe<Chat_Threads_Mutation_Response>>>;
  /** update data of the table: "companies" */
  update_companies?: Maybe<Companies_Mutation_Response>;
  /** update single row of the table: "companies" */
  update_companies_by_pk?: Maybe<Companies>;
  /** update multiples rows of table: "companies" */
  update_companies_many?: Maybe<Array<Maybe<Companies_Mutation_Response>>>;
  /** update data of the table: "creator_onboarding" */
  update_creator_onboarding?: Maybe<Creator_Onboarding_Mutation_Response>;
  /** update single row of the table: "creator_onboarding" */
  update_creator_onboarding_by_pk?: Maybe<Creator_Onboarding>;
  /** update multiples rows of table: "creator_onboarding" */
  update_creator_onboarding_many?: Maybe<Array<Maybe<Creator_Onboarding_Mutation_Response>>>;
  /** update data of the table: "crm_segments" */
  update_crm_segments?: Maybe<Crm_Segments_Mutation_Response>;
  /** update single row of the table: "crm_segments" */
  update_crm_segments_by_pk?: Maybe<Crm_Segments>;
  /** update multiples rows of table: "crm_segments" */
  update_crm_segments_many?: Maybe<Array<Maybe<Crm_Segments_Mutation_Response>>>;
  /** update data of the table: "crop_user" */
  update_crop_user?: Maybe<Crop_User_Mutation_Response>;
  /** update single row of the table: "crop_user" */
  update_crop_user_by_pk?: Maybe<Crop_User>;
  /** update multiples rows of table: "crop_user" */
  update_crop_user_many?: Maybe<Array<Maybe<Crop_User_Mutation_Response>>>;
  /** update data of the table: "failed_jobs" */
  update_failed_jobs?: Maybe<Failed_Jobs_Mutation_Response>;
  /** update single row of the table: "failed_jobs" */
  update_failed_jobs_by_pk?: Maybe<Failed_Jobs>;
  /** update multiples rows of table: "failed_jobs" */
  update_failed_jobs_many?: Maybe<Array<Maybe<Failed_Jobs_Mutation_Response>>>;
  /** update data of the table: "farmer_account_locations" */
  update_farmer_account_locations?: Maybe<Farmer_Account_Locations_Mutation_Response>;
  /** update single row of the table: "farmer_account_locations" */
  update_farmer_account_locations_by_pk?: Maybe<Farmer_Account_Locations>;
  /** update multiples rows of table: "farmer_account_locations" */
  update_farmer_account_locations_many?: Maybe<Array<Maybe<Farmer_Account_Locations_Mutation_Response>>>;
  /** update data of the table: "farmer_accounts" */
  update_farmer_accounts?: Maybe<Farmer_Accounts_Mutation_Response>;
  /** update single row of the table: "farmer_accounts" */
  update_farmer_accounts_by_pk?: Maybe<Farmer_Accounts>;
  /** update multiples rows of table: "farmer_accounts" */
  update_farmer_accounts_many?: Maybe<Array<Maybe<Farmer_Accounts_Mutation_Response>>>;
  /** update data of the table: "farmer_actions" */
  update_farmer_actions?: Maybe<Farmer_Actions_Mutation_Response>;
  /** update single row of the table: "farmer_actions" */
  update_farmer_actions_by_pk?: Maybe<Farmer_Actions>;
  /** update multiples rows of table: "farmer_actions" */
  update_farmer_actions_many?: Maybe<Array<Maybe<Farmer_Actions_Mutation_Response>>>;
  /** update data of the table: "farmer_fields" */
  update_farmer_fields?: Maybe<Farmer_Fields_Mutation_Response>;
  /** update single row of the table: "farmer_fields" */
  update_farmer_fields_by_pk?: Maybe<Farmer_Fields>;
  /** update multiples rows of table: "farmer_fields" */
  update_farmer_fields_many?: Maybe<Array<Maybe<Farmer_Fields_Mutation_Response>>>;
  /** update data of the table: "farmer_master" */
  update_farmer_master?: Maybe<Farmer_Master_Mutation_Response>;
  /** update single row of the table: "farmer_master" */
  update_farmer_master_by_pk?: Maybe<Farmer_Master>;
  /** update multiples rows of table: "farmer_master" */
  update_farmer_master_many?: Maybe<Array<Maybe<Farmer_Master_Mutation_Response>>>;
  /** update data of the table: "farmer_nearby_field_force" */
  update_farmer_nearby_field_force?: Maybe<Farmer_Nearby_Field_Force_Mutation_Response>;
  /** update single row of the table: "farmer_nearby_field_force" */
  update_farmer_nearby_field_force_by_pk?: Maybe<Farmer_Nearby_Field_Force>;
  /** update multiples rows of table: "farmer_nearby_field_force" */
  update_farmer_nearby_field_force_many?: Maybe<Array<Maybe<Farmer_Nearby_Field_Force_Mutation_Response>>>;
  /** update data of the table: "farmer_plots" */
  update_farmer_plots?: Maybe<Farmer_Plots_Mutation_Response>;
  /** update single row of the table: "farmer_plots" */
  update_farmer_plots_by_pk?: Maybe<Farmer_Plots>;
  /** update multiples rows of table: "farmer_plots" */
  update_farmer_plots_many?: Maybe<Array<Maybe<Farmer_Plots_Mutation_Response>>>;
  /** update data of the table: "farminsta_links" */
  update_farminsta_links?: Maybe<Farminsta_Links_Mutation_Response>;
  /** update single row of the table: "farminsta_links" */
  update_farminsta_links_by_pk?: Maybe<Farminsta_Links>;
  /** update multiples rows of table: "farminsta_links" */
  update_farminsta_links_many?: Maybe<Array<Maybe<Farminsta_Links_Mutation_Response>>>;
  /** update data of the table: "features" */
  update_features?: Maybe<Features_Mutation_Response>;
  /** update single row of the table: "features" */
  update_features_by_pk?: Maybe<Features>;
  /** update multiples rows of table: "features" */
  update_features_many?: Maybe<Array<Maybe<Features_Mutation_Response>>>;
  /** update data of the table: "field_partner_response_events" */
  update_field_partner_response_events?: Maybe<Field_Partner_Response_Events_Mutation_Response>;
  /** update single row of the table: "field_partner_response_events" */
  update_field_partner_response_events_by_pk?: Maybe<Field_Partner_Response_Events>;
  /** update multiples rows of table: "field_partner_response_events" */
  update_field_partner_response_events_many?: Maybe<Array<Maybe<Field_Partner_Response_Events_Mutation_Response>>>;
  /** update data of the table: "field_partner_response_messages" */
  update_field_partner_response_messages?: Maybe<Field_Partner_Response_Messages_Mutation_Response>;
  /** update single row of the table: "field_partner_response_messages" */
  update_field_partner_response_messages_by_pk?: Maybe<Field_Partner_Response_Messages>;
  /** update multiples rows of table: "field_partner_response_messages" */
  update_field_partner_response_messages_many?: Maybe<Array<Maybe<Field_Partner_Response_Messages_Mutation_Response>>>;
  /** update data of the table: "field_partner_responses" */
  update_field_partner_responses?: Maybe<Field_Partner_Responses_Mutation_Response>;
  /** update single row of the table: "field_partner_responses" */
  update_field_partner_responses_by_pk?: Maybe<Field_Partner_Responses>;
  /** update multiples rows of table: "field_partner_responses" */
  update_field_partner_responses_many?: Maybe<Array<Maybe<Field_Partner_Responses_Mutation_Response>>>;
  /** update data of the table: "field_scheduled_visits" */
  update_field_scheduled_visits?: Maybe<Field_Scheduled_Visits_Mutation_Response>;
  /** update single row of the table: "field_scheduled_visits" */
  update_field_scheduled_visits_by_pk?: Maybe<Field_Scheduled_Visits>;
  /** update multiples rows of table: "field_scheduled_visits" */
  update_field_scheduled_visits_many?: Maybe<Array<Maybe<Field_Scheduled_Visits_Mutation_Response>>>;
  /** update data of the table: "fo_reels_staging" */
  update_fo_reels_staging?: Maybe<Fo_Reels_Staging_Mutation_Response>;
  /** update single row of the table: "fo_reels_staging" */
  update_fo_reels_staging_by_pk?: Maybe<Fo_Reels_Staging>;
  /** update multiples rows of table: "fo_reels_staging" */
  update_fo_reels_staging_many?: Maybe<Array<Maybe<Fo_Reels_Staging_Mutation_Response>>>;
  /** update data of the table: "follows" */
  update_follows?: Maybe<Follows_Mutation_Response>;
  /** update single row of the table: "follows" */
  update_follows_by_pk?: Maybe<Follows>;
  /** update multiples rows of table: "follows" */
  update_follows_many?: Maybe<Array<Maybe<Follows_Mutation_Response>>>;
  /** update data of the table: "geometry_columns" */
  update_geometry_columns?: Maybe<Geometry_Columns_Mutation_Response>;
  /** update multiples rows of table: "geometry_columns" */
  update_geometry_columns_many?: Maybe<Array<Maybe<Geometry_Columns_Mutation_Response>>>;
  /** update data of the table: "gig_faqs" */
  update_gig_faqs?: Maybe<Gig_Faqs_Mutation_Response>;
  /** update single row of the table: "gig_faqs" */
  update_gig_faqs_by_pk?: Maybe<Gig_Faqs>;
  /** update multiples rows of table: "gig_faqs" */
  update_gig_faqs_many?: Maybe<Array<Maybe<Gig_Faqs_Mutation_Response>>>;
  /** update data of the table: "gig_promos" */
  update_gig_promos?: Maybe<Gig_Promos_Mutation_Response>;
  /** update single row of the table: "gig_promos" */
  update_gig_promos_by_pk?: Maybe<Gig_Promos>;
  /** update multiples rows of table: "gig_promos" */
  update_gig_promos_many?: Maybe<Array<Maybe<Gig_Promos_Mutation_Response>>>;
  /** update data of the table: "gig_variants" */
  update_gig_variants?: Maybe<Gig_Variants_Mutation_Response>;
  /** update single row of the table: "gig_variants" */
  update_gig_variants_by_pk?: Maybe<Gig_Variants>;
  /** update multiples rows of table: "gig_variants" */
  update_gig_variants_many?: Maybe<Array<Maybe<Gig_Variants_Mutation_Response>>>;
  /** update data of the table: "gigs" */
  update_gigs?: Maybe<Gigs_Mutation_Response>;
  /** update single row of the table: "gigs" */
  update_gigs_by_pk?: Maybe<Gigs>;
  /** update multiples rows of table: "gigs" */
  update_gigs_many?: Maybe<Array<Maybe<Gigs_Mutation_Response>>>;
  /** update data of the table: "gis.districts" */
  update_gis_districts?: Maybe<Gis_Districts_Mutation_Response>;
  /** update single row of the table: "gis.districts" */
  update_gis_districts_by_pk?: Maybe<Gis_Districts>;
  /** update multiples rows of table: "gis.districts" */
  update_gis_districts_many?: Maybe<Array<Maybe<Gis_Districts_Mutation_Response>>>;
  /** update data of the table: "gis.states" */
  update_gis_states?: Maybe<Gis_States_Mutation_Response>;
  /** update single row of the table: "gis.states" */
  update_gis_states_by_pk?: Maybe<Gis_States>;
  /** update multiples rows of table: "gis.states" */
  update_gis_states_many?: Maybe<Array<Maybe<Gis_States_Mutation_Response>>>;
  /** update data of the table: "last_known_locations" */
  update_last_known_locations?: Maybe<Last_Known_Locations_Mutation_Response>;
  /** update single row of the table: "last_known_locations" */
  update_last_known_locations_by_pk?: Maybe<Last_Known_Locations>;
  /** update multiples rows of table: "last_known_locations" */
  update_last_known_locations_many?: Maybe<Array<Maybe<Last_Known_Locations_Mutation_Response>>>;
  /** update data of the table: "master_crops" */
  update_master_crops?: Maybe<Master_Crops_Mutation_Response>;
  /** update single row of the table: "master_crops" */
  update_master_crops_by_pk?: Maybe<Master_Crops>;
  /** update multiples rows of table: "master_crops" */
  update_master_crops_many?: Maybe<Array<Maybe<Master_Crops_Mutation_Response>>>;
  /** update data of the table: "master_segments" */
  update_master_segments?: Maybe<Master_Segments_Mutation_Response>;
  /** update single row of the table: "master_segments" */
  update_master_segments_by_pk?: Maybe<Master_Segments>;
  /** update multiples rows of table: "master_segments" */
  update_master_segments_many?: Maybe<Array<Maybe<Master_Segments_Mutation_Response>>>;
  /** update data of the table: "messaging_campaign_recipients" */
  update_messaging_campaign_recipients?: Maybe<Messaging_Campaign_Recipients_Mutation_Response>;
  /** update single row of the table: "messaging_campaign_recipients" */
  update_messaging_campaign_recipients_by_pk?: Maybe<Messaging_Campaign_Recipients>;
  /** update multiples rows of table: "messaging_campaign_recipients" */
  update_messaging_campaign_recipients_many?: Maybe<Array<Maybe<Messaging_Campaign_Recipients_Mutation_Response>>>;
  /** update data of the table: "messaging_campaign_segments" */
  update_messaging_campaign_segments?: Maybe<Messaging_Campaign_Segments_Mutation_Response>;
  /** update single row of the table: "messaging_campaign_segments" */
  update_messaging_campaign_segments_by_pk?: Maybe<Messaging_Campaign_Segments>;
  /** update multiples rows of table: "messaging_campaign_segments" */
  update_messaging_campaign_segments_many?: Maybe<Array<Maybe<Messaging_Campaign_Segments_Mutation_Response>>>;
  /** update data of the table: "messaging_campaigns" */
  update_messaging_campaigns?: Maybe<Messaging_Campaigns_Mutation_Response>;
  /** update single row of the table: "messaging_campaigns" */
  update_messaging_campaigns_by_pk?: Maybe<Messaging_Campaigns>;
  /** update multiples rows of table: "messaging_campaigns" */
  update_messaging_campaigns_many?: Maybe<Array<Maybe<Messaging_Campaigns_Mutation_Response>>>;
  /** update data of the table: "messaging_templates" */
  update_messaging_templates?: Maybe<Messaging_Templates_Mutation_Response>;
  /** update single row of the table: "messaging_templates" */
  update_messaging_templates_by_pk?: Maybe<Messaging_Templates>;
  /** update multiples rows of table: "messaging_templates" */
  update_messaging_templates_many?: Maybe<Array<Maybe<Messaging_Templates_Mutation_Response>>>;
  /** update data of the table: "migrations" */
  update_migrations?: Maybe<Migrations_Mutation_Response>;
  /** update single row of the table: "migrations" */
  update_migrations_by_pk?: Maybe<Migrations>;
  /** update multiples rows of table: "migrations" */
  update_migrations_many?: Maybe<Array<Maybe<Migrations_Mutation_Response>>>;
  /** update data of the table: "missed_call_number_pool" */
  update_missed_call_number_pool?: Maybe<Missed_Call_Number_Pool_Mutation_Response>;
  /** update single row of the table: "missed_call_number_pool" */
  update_missed_call_number_pool_by_pk?: Maybe<Missed_Call_Number_Pool>;
  /** update multiples rows of table: "missed_call_number_pool" */
  update_missed_call_number_pool_many?: Maybe<Array<Maybe<Missed_Call_Number_Pool_Mutation_Response>>>;
  /** update data of the table: "missed_calls" */
  update_missed_calls?: Maybe<Missed_Calls_Mutation_Response>;
  /** update single row of the table: "missed_calls" */
  update_missed_calls_by_pk?: Maybe<Missed_Calls>;
  /** update multiples rows of table: "missed_calls" */
  update_missed_calls_many?: Maybe<Array<Maybe<Missed_Calls_Mutation_Response>>>;
  /** update data of the table: "model_has_permissions" */
  update_model_has_permissions?: Maybe<Model_Has_Permissions_Mutation_Response>;
  /** update single row of the table: "model_has_permissions" */
  update_model_has_permissions_by_pk?: Maybe<Model_Has_Permissions>;
  /** update multiples rows of table: "model_has_permissions" */
  update_model_has_permissions_many?: Maybe<Array<Maybe<Model_Has_Permissions_Mutation_Response>>>;
  /** update data of the table: "model_has_roles" */
  update_model_has_roles?: Maybe<Model_Has_Roles_Mutation_Response>;
  /** update single row of the table: "model_has_roles" */
  update_model_has_roles_by_pk?: Maybe<Model_Has_Roles>;
  /** update multiples rows of table: "model_has_roles" */
  update_model_has_roles_many?: Maybe<Array<Maybe<Model_Has_Roles_Mutation_Response>>>;
  /** update data of the table: "notifications" */
  update_notifications?: Maybe<Notifications_Mutation_Response>;
  /** update single row of the table: "notifications" */
  update_notifications_by_pk?: Maybe<Notifications>;
  /** update multiples rows of table: "notifications" */
  update_notifications_many?: Maybe<Array<Maybe<Notifications_Mutation_Response>>>;
  /** update data of the table: "nova_field_attachments" */
  update_nova_field_attachments?: Maybe<Nova_Field_Attachments_Mutation_Response>;
  /** update single row of the table: "nova_field_attachments" */
  update_nova_field_attachments_by_pk?: Maybe<Nova_Field_Attachments>;
  /** update multiples rows of table: "nova_field_attachments" */
  update_nova_field_attachments_many?: Maybe<Array<Maybe<Nova_Field_Attachments_Mutation_Response>>>;
  /** update data of the table: "nova_notifications" */
  update_nova_notifications?: Maybe<Nova_Notifications_Mutation_Response>;
  /** update single row of the table: "nova_notifications" */
  update_nova_notifications_by_pk?: Maybe<Nova_Notifications>;
  /** update multiples rows of table: "nova_notifications" */
  update_nova_notifications_many?: Maybe<Array<Maybe<Nova_Notifications_Mutation_Response>>>;
  /** update data of the table: "nova_pending_field_attachments" */
  update_nova_pending_field_attachments?: Maybe<Nova_Pending_Field_Attachments_Mutation_Response>;
  /** update single row of the table: "nova_pending_field_attachments" */
  update_nova_pending_field_attachments_by_pk?: Maybe<Nova_Pending_Field_Attachments>;
  /** update multiples rows of table: "nova_pending_field_attachments" */
  update_nova_pending_field_attachments_many?: Maybe<Array<Maybe<Nova_Pending_Field_Attachments_Mutation_Response>>>;
  /** update data of the table: "nova_twofa" */
  update_nova_twofa?: Maybe<Nova_Twofa_Mutation_Response>;
  /** update single row of the table: "nova_twofa" */
  update_nova_twofa_by_pk?: Maybe<Nova_Twofa>;
  /** update multiples rows of table: "nova_twofa" */
  update_nova_twofa_many?: Maybe<Array<Maybe<Nova_Twofa_Mutation_Response>>>;
  /** update data of the table: "pairing_codes" */
  update_pairing_codes?: Maybe<Pairing_Codes_Mutation_Response>;
  /** update single row of the table: "pairing_codes" */
  update_pairing_codes_by_pk?: Maybe<Pairing_Codes>;
  /** update multiples rows of table: "pairing_codes" */
  update_pairing_codes_many?: Maybe<Array<Maybe<Pairing_Codes_Mutation_Response>>>;
  /** update data of the table: "password_reset_tokens" */
  update_password_reset_tokens?: Maybe<Password_Reset_Tokens_Mutation_Response>;
  /** update single row of the table: "password_reset_tokens" */
  update_password_reset_tokens_by_pk?: Maybe<Password_Reset_Tokens>;
  /** update multiples rows of table: "password_reset_tokens" */
  update_password_reset_tokens_many?: Maybe<Array<Maybe<Password_Reset_Tokens_Mutation_Response>>>;
  /** update data of the table: "permissions" */
  update_permissions?: Maybe<Permissions_Mutation_Response>;
  /** update single row of the table: "permissions" */
  update_permissions_by_pk?: Maybe<Permissions>;
  /** update multiples rows of table: "permissions" */
  update_permissions_many?: Maybe<Array<Maybe<Permissions_Mutation_Response>>>;
  /** update data of the table: "personal_access_tokens" */
  update_personal_access_tokens?: Maybe<Personal_Access_Tokens_Mutation_Response>;
  /** update single row of the table: "personal_access_tokens" */
  update_personal_access_tokens_by_pk?: Maybe<Personal_Access_Tokens>;
  /** update multiples rows of table: "personal_access_tokens" */
  update_personal_access_tokens_many?: Maybe<Array<Maybe<Personal_Access_Tokens_Mutation_Response>>>;
  /** update data of the table: "personal_dashboard" */
  update_personal_dashboard?: Maybe<Personal_Dashboard_Mutation_Response>;
  /** update single row of the table: "personal_dashboard" */
  update_personal_dashboard_by_pk?: Maybe<Personal_Dashboard>;
  /** update multiples rows of table: "personal_dashboard" */
  update_personal_dashboard_many?: Maybe<Array<Maybe<Personal_Dashboard_Mutation_Response>>>;
  /** update data of the table: "runpando_pro.products" */
  update_pf_products?: Maybe<Pf_Products_Mutation_Response>;
  /** update single row of the table: "runpando_pro.products" */
  update_pf_products_by_pk?: Maybe<Pf_Products>;
  /** update multiples rows of table: "runpando_pro.products" */
  update_pf_products_many?: Maybe<Array<Maybe<Pf_Products_Mutation_Response>>>;
  /** update data of the table: "runpando_pro.user_travellog" */
  update_pf_user_travellog?: Maybe<Pf_User_Travellog_Mutation_Response>;
  /** update single row of the table: "runpando_pro.user_travellog" */
  update_pf_user_travellog_by_pk?: Maybe<Pf_User_Travellog>;
  /** update multiples rows of table: "runpando_pro.user_travellog" */
  update_pf_user_travellog_many?: Maybe<Array<Maybe<Pf_User_Travellog_Mutation_Response>>>;
  /** update data of the table: "product_pop_media" */
  update_product_pop_media?: Maybe<Product_Pop_Media_Mutation_Response>;
  /** update single row of the table: "product_pop_media" */
  update_product_pop_media_by_pk?: Maybe<Product_Pop_Media>;
  /** update multiples rows of table: "product_pop_media" */
  update_product_pop_media_many?: Maybe<Array<Maybe<Product_Pop_Media_Mutation_Response>>>;
  /** update data of the table: "product_pops" */
  update_product_pops?: Maybe<Product_Pops_Mutation_Response>;
  /** update single row of the table: "product_pops" */
  update_product_pops_by_pk?: Maybe<Product_Pops>;
  /** update multiples rows of table: "product_pops" */
  update_product_pops_many?: Maybe<Array<Maybe<Product_Pops_Mutation_Response>>>;
  /** update data of the table: "prospect_crops" */
  update_prospect_crops?: Maybe<Prospect_Crops_Mutation_Response>;
  /** update single row of the table: "prospect_crops" */
  update_prospect_crops_by_pk?: Maybe<Prospect_Crops>;
  /** update multiples rows of table: "prospect_crops" */
  update_prospect_crops_many?: Maybe<Array<Maybe<Prospect_Crops_Mutation_Response>>>;
  /** update data of the table: "prospect_messages" */
  update_prospect_messages?: Maybe<Prospect_Messages_Mutation_Response>;
  /** update single row of the table: "prospect_messages" */
  update_prospect_messages_by_pk?: Maybe<Prospect_Messages>;
  /** update multiples rows of table: "prospect_messages" */
  update_prospect_messages_many?: Maybe<Array<Maybe<Prospect_Messages_Mutation_Response>>>;
  /** update data of the table: "prospect_user" */
  update_prospect_user?: Maybe<Prospect_User_Mutation_Response>;
  /** update single row of the table: "prospect_user" */
  update_prospect_user_by_pk?: Maybe<Prospect_User>;
  /** update multiples rows of table: "prospect_user" */
  update_prospect_user_many?: Maybe<Array<Maybe<Prospect_User_Mutation_Response>>>;
  /** update data of the table: "prospects" */
  update_prospects?: Maybe<Prospects_Mutation_Response>;
  /** update single row of the table: "prospects" */
  update_prospects_by_pk?: Maybe<Prospects>;
  /** update multiples rows of table: "prospects" */
  update_prospects_many?: Maybe<Array<Maybe<Prospects_Mutation_Response>>>;
  /** update data of the table: "reel_category" */
  update_reel_category?: Maybe<Reel_Category_Mutation_Response>;
  /** update single row of the table: "reel_category" */
  update_reel_category_by_pk?: Maybe<Reel_Category>;
  /** update multiples rows of table: "reel_category" */
  update_reel_category_many?: Maybe<Array<Maybe<Reel_Category_Mutation_Response>>>;
  /** update data of the table: "reel_comments" */
  update_reel_comments?: Maybe<Reel_Comments_Mutation_Response>;
  /** update single row of the table: "reel_comments" */
  update_reel_comments_by_pk?: Maybe<Reel_Comments>;
  /** update multiples rows of table: "reel_comments" */
  update_reel_comments_many?: Maybe<Array<Maybe<Reel_Comments_Mutation_Response>>>;
  /** update data of the table: "reel_interactions" */
  update_reel_interactions?: Maybe<Reel_Interactions_Mutation_Response>;
  /** update single row of the table: "reel_interactions" */
  update_reel_interactions_by_pk?: Maybe<Reel_Interactions>;
  /** update multiples rows of table: "reel_interactions" */
  update_reel_interactions_many?: Maybe<Array<Maybe<Reel_Interactions_Mutation_Response>>>;
  /** update data of the table: "reel_stats" */
  update_reel_stats?: Maybe<Reel_Stats_Mutation_Response>;
  /** update single row of the table: "reel_stats" */
  update_reel_stats_by_pk?: Maybe<Reel_Stats>;
  /** update multiples rows of table: "reel_stats" */
  update_reel_stats_many?: Maybe<Array<Maybe<Reel_Stats_Mutation_Response>>>;
  /** update data of the table: "reel_user_reports" */
  update_reel_user_reports?: Maybe<Reel_User_Reports_Mutation_Response>;
  /** update single row of the table: "reel_user_reports" */
  update_reel_user_reports_by_pk?: Maybe<Reel_User_Reports>;
  /** update multiples rows of table: "reel_user_reports" */
  update_reel_user_reports_many?: Maybe<Array<Maybe<Reel_User_Reports_Mutation_Response>>>;
  /** update data of the table: "reels" */
  update_reels?: Maybe<Reels_Mutation_Response>;
  /** update single row of the table: "reels" */
  update_reels_by_pk?: Maybe<Reels>;
  /** update multiples rows of table: "reels" */
  update_reels_many?: Maybe<Array<Maybe<Reels_Mutation_Response>>>;
  /** update data of the table: "reels_with_distance" */
  update_reels_with_distance?: Maybe<Reels_With_Distance_Mutation_Response>;
  /** update multiples rows of table: "reels_with_distance" */
  update_reels_with_distance_many?: Maybe<Array<Maybe<Reels_With_Distance_Mutation_Response>>>;
  /** update data of the table: "retailer_establishments" */
  update_retailer_establishments?: Maybe<Retailer_Establishments_Mutation_Response>;
  /** update single row of the table: "retailer_establishments" */
  update_retailer_establishments_by_pk?: Maybe<Retailer_Establishments>;
  /** update multiples rows of table: "retailer_establishments" */
  update_retailer_establishments_many?: Maybe<Array<Maybe<Retailer_Establishments_Mutation_Response>>>;
  /** update data of the table: "retailers" */
  update_retailers?: Maybe<Retailers_Mutation_Response>;
  /** update single row of the table: "retailers" */
  update_retailers_by_pk?: Maybe<Retailers>;
  /** update multiples rows of table: "retailers" */
  update_retailers_many?: Maybe<Array<Maybe<Retailers_Mutation_Response>>>;
  /** update data of the table: "role_has_permissions" */
  update_role_has_permissions?: Maybe<Role_Has_Permissions_Mutation_Response>;
  /** update single row of the table: "role_has_permissions" */
  update_role_has_permissions_by_pk?: Maybe<Role_Has_Permissions>;
  /** update multiples rows of table: "role_has_permissions" */
  update_role_has_permissions_many?: Maybe<Array<Maybe<Role_Has_Permissions_Mutation_Response>>>;
  /** update data of the table: "roles" */
  update_roles?: Maybe<Roles_Mutation_Response>;
  /** update single row of the table: "roles" */
  update_roles_by_pk?: Maybe<Roles>;
  /** update multiples rows of table: "roles" */
  update_roles_many?: Maybe<Array<Maybe<Roles_Mutation_Response>>>;
  /** update data of the table: "runpando_pro.all_state_data" */
  update_runpando_pro_all_state_data?: Maybe<Runpando_Pro_All_State_Data_Mutation_Response>;
  /** update single row of the table: "runpando_pro.all_state_data" */
  update_runpando_pro_all_state_data_by_pk?: Maybe<Runpando_Pro_All_State_Data>;
  /** update multiples rows of table: "runpando_pro.all_state_data" */
  update_runpando_pro_all_state_data_many?: Maybe<Array<Maybe<Runpando_Pro_All_State_Data_Mutation_Response>>>;
  /** update data of the table: "runpando_pro.users" */
  update_runpando_pro_users?: Maybe<Runpando_Pro_Users_Mutation_Response>;
  /** update single row of the table: "runpando_pro.users" */
  update_runpando_pro_users_by_pk?: Maybe<Runpando_Pro_Users>;
  /** update data of the table: "runpando_pro.users_locations" */
  update_runpando_pro_users_locations?: Maybe<Runpando_Pro_Users_Locations_Mutation_Response>;
  /** update single row of the table: "runpando_pro.users_locations" */
  update_runpando_pro_users_locations_by_pk?: Maybe<Runpando_Pro_Users_Locations>;
  /** update multiples rows of table: "runpando_pro.users_locations" */
  update_runpando_pro_users_locations_many?: Maybe<Array<Maybe<Runpando_Pro_Users_Locations_Mutation_Response>>>;
  /** update multiples rows of table: "runpando_pro.users" */
  update_runpando_pro_users_many?: Maybe<Array<Maybe<Runpando_Pro_Users_Mutation_Response>>>;
  /** update data of the table: "sale_items" */
  update_sale_items?: Maybe<Sale_Items_Mutation_Response>;
  /** update single row of the table: "sale_items" */
  update_sale_items_by_pk?: Maybe<Sale_Items>;
  /** update multiples rows of table: "sale_items" */
  update_sale_items_many?: Maybe<Array<Maybe<Sale_Items_Mutation_Response>>>;
  /** update data of the table: "sale_payments" */
  update_sale_payments?: Maybe<Sale_Payments_Mutation_Response>;
  /** update single row of the table: "sale_payments" */
  update_sale_payments_by_pk?: Maybe<Sale_Payments>;
  /** update multiples rows of table: "sale_payments" */
  update_sale_payments_many?: Maybe<Array<Maybe<Sale_Payments_Mutation_Response>>>;
  /** update data of the table: "sale_proof_events" */
  update_sale_proof_events?: Maybe<Sale_Proof_Events_Mutation_Response>;
  /** update single row of the table: "sale_proof_events" */
  update_sale_proof_events_by_pk?: Maybe<Sale_Proof_Events>;
  /** update multiples rows of table: "sale_proof_events" */
  update_sale_proof_events_many?: Maybe<Array<Maybe<Sale_Proof_Events_Mutation_Response>>>;
  /** update data of the table: "sale_proof_types" */
  update_sale_proof_types?: Maybe<Sale_Proof_Types_Mutation_Response>;
  /** update single row of the table: "sale_proof_types" */
  update_sale_proof_types_by_pk?: Maybe<Sale_Proof_Types>;
  /** update multiples rows of table: "sale_proof_types" */
  update_sale_proof_types_many?: Maybe<Array<Maybe<Sale_Proof_Types_Mutation_Response>>>;
  /** update data of the table: "sale_proofs" */
  update_sale_proofs?: Maybe<Sale_Proofs_Mutation_Response>;
  /** update single row of the table: "sale_proofs" */
  update_sale_proofs_by_pk?: Maybe<Sale_Proofs>;
  /** update multiples rows of table: "sale_proofs" */
  update_sale_proofs_many?: Maybe<Array<Maybe<Sale_Proofs_Mutation_Response>>>;
  /** update data of the table: "sales" */
  update_sales?: Maybe<Sales_Mutation_Response>;
  /** update single row of the table: "sales" */
  update_sales_by_pk?: Maybe<Sales>;
  /** update multiples rows of table: "sales" */
  update_sales_many?: Maybe<Array<Maybe<Sales_Mutation_Response>>>;
  /** update data of the table: "saved_reels" */
  update_saved_reels?: Maybe<Saved_Reels_Mutation_Response>;
  /** update single row of the table: "saved_reels" */
  update_saved_reels_by_pk?: Maybe<Saved_Reels>;
  /** update multiples rows of table: "saved_reels" */
  update_saved_reels_many?: Maybe<Array<Maybe<Saved_Reels_Mutation_Response>>>;
  /** update data of the table: "segment_user" */
  update_segment_user?: Maybe<Segment_User_Mutation_Response>;
  /** update single row of the table: "segment_user" */
  update_segment_user_by_pk?: Maybe<Segment_User>;
  /** update multiples rows of table: "segment_user" */
  update_segment_user_many?: Maybe<Array<Maybe<Segment_User_Mutation_Response>>>;
  /** update data of the table: "service_request_dashboard" */
  update_service_request_dashboard?: Maybe<Service_Request_Dashboard_Mutation_Response>;
  /** update single row of the table: "service_request_dashboard" */
  update_service_request_dashboard_by_pk?: Maybe<Service_Request_Dashboard>;
  /** update multiples rows of table: "service_request_dashboard" */
  update_service_request_dashboard_many?: Maybe<Array<Maybe<Service_Request_Dashboard_Mutation_Response>>>;
  /** update data of the table: "service_request_recommendations" */
  update_service_request_recommendations?: Maybe<Service_Request_Recommendations_Mutation_Response>;
  /** update single row of the table: "service_request_recommendations" */
  update_service_request_recommendations_by_pk?: Maybe<Service_Request_Recommendations>;
  /** update multiples rows of table: "service_request_recommendations" */
  update_service_request_recommendations_many?: Maybe<Array<Maybe<Service_Request_Recommendations_Mutation_Response>>>;
  /** update data of the table: "service_request_retailer" */
  update_service_request_retailer?: Maybe<Service_Request_Retailer_Mutation_Response>;
  /** update single row of the table: "service_request_retailer" */
  update_service_request_retailer_by_pk?: Maybe<Service_Request_Retailer>;
  /** update multiples rows of table: "service_request_retailer" */
  update_service_request_retailer_many?: Maybe<Array<Maybe<Service_Request_Retailer_Mutation_Response>>>;
  /** update data of the table: "service_requests" */
  update_service_requests?: Maybe<Service_Requests_Mutation_Response>;
  /** update single row of the table: "service_requests" */
  update_service_requests_by_pk?: Maybe<Service_Requests>;
  /** update multiples rows of table: "service_requests" */
  update_service_requests_many?: Maybe<Array<Maybe<Service_Requests_Mutation_Response>>>;
  /** update data of the table: "snapshots" */
  update_snapshots?: Maybe<Snapshots_Mutation_Response>;
  /** update single row of the table: "snapshots" */
  update_snapshots_by_pk?: Maybe<Snapshots>;
  /** update multiples rows of table: "snapshots" */
  update_snapshots_many?: Maybe<Array<Maybe<Snapshots_Mutation_Response>>>;
  /** update data of the table: "spatial_ref_sys" */
  update_spatial_ref_sys?: Maybe<Spatial_Ref_Sys_Mutation_Response>;
  /** update single row of the table: "spatial_ref_sys" */
  update_spatial_ref_sys_by_pk?: Maybe<Spatial_Ref_Sys>;
  /** update multiples rows of table: "spatial_ref_sys" */
  update_spatial_ref_sys_many?: Maybe<Array<Maybe<Spatial_Ref_Sys_Mutation_Response>>>;
  /** update data of the table: "stored_events" */
  update_stored_events?: Maybe<Stored_Events_Mutation_Response>;
  /** update single row of the table: "stored_events" */
  update_stored_events_by_pk?: Maybe<Stored_Events>;
  /** update multiples rows of table: "stored_events" */
  update_stored_events_many?: Maybe<Array<Maybe<Stored_Events_Mutation_Response>>>;
  /** update data of the table: "taggables" */
  update_taggables?: Maybe<Taggables_Mutation_Response>;
  /** update single row of the table: "taggables" */
  update_taggables_by_pk?: Maybe<Taggables>;
  /** update multiples rows of table: "taggables" */
  update_taggables_many?: Maybe<Array<Maybe<Taggables_Mutation_Response>>>;
  /** update data of the table: "tags" */
  update_tags?: Maybe<Tags_Mutation_Response>;
  /** update single row of the table: "tags" */
  update_tags_by_pk?: Maybe<Tags>;
  /** update multiples rows of table: "tags" */
  update_tags_many?: Maybe<Array<Maybe<Tags_Mutation_Response>>>;
  /** update data of the table: "user_device" */
  update_user_device?: Maybe<User_Device_Mutation_Response>;
  /** update single row of the table: "user_device" */
  update_user_device_by_pk?: Maybe<User_Device>;
  /** update multiples rows of table: "user_device" */
  update_user_device_many?: Maybe<Array<Maybe<User_Device_Mutation_Response>>>;
  /** update data of the table: "user_feedbacks" */
  update_user_feedbacks?: Maybe<User_Feedbacks_Mutation_Response>;
  /** update single row of the table: "user_feedbacks" */
  update_user_feedbacks_by_pk?: Maybe<User_Feedbacks>;
  /** update multiples rows of table: "user_feedbacks" */
  update_user_feedbacks_many?: Maybe<Array<Maybe<User_Feedbacks_Mutation_Response>>>;
  /** update data of the table: "user_follows_channel" */
  update_user_follows_channel?: Maybe<User_Follows_Channel_Mutation_Response>;
  /** update single row of the table: "user_follows_channel" */
  update_user_follows_channel_by_pk?: Maybe<User_Follows_Channel>;
  /** update multiples rows of table: "user_follows_channel" */
  update_user_follows_channel_many?: Maybe<Array<Maybe<User_Follows_Channel_Mutation_Response>>>;
  /** update data of the table: "user_location_logs" */
  update_user_location_logs?: Maybe<User_Location_Logs_Mutation_Response>;
  /** update single row of the table: "user_location_logs" */
  update_user_location_logs_by_pk?: Maybe<User_Location_Logs>;
  /** update multiples rows of table: "user_location_logs" */
  update_user_location_logs_many?: Maybe<Array<Maybe<User_Location_Logs_Mutation_Response>>>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
  /** update multiples rows of table: "users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
  /** update data of the table: "wallets" */
  update_wallets?: Maybe<Wallets_Mutation_Response>;
  /** update single row of the table: "wallets" */
  update_wallets_by_pk?: Maybe<Wallets>;
  /** update multiples rows of table: "wallets" */
  update_wallets_many?: Maybe<Array<Maybe<Wallets_Mutation_Response>>>;
  /** update data of the table: "whatsauth_logins" */
  update_whatsauth_logins?: Maybe<Whatsauth_Logins_Mutation_Response>;
  /** update single row of the table: "whatsauth_logins" */
  update_whatsauth_logins_by_pk?: Maybe<Whatsauth_Logins>;
  /** update multiples rows of table: "whatsauth_logins" */
  update_whatsauth_logins_many?: Maybe<Array<Maybe<Whatsauth_Logins_Mutation_Response>>>;
  /** update data of the table: "work_order_checklist_items" */
  update_work_order_checklist_items?: Maybe<Work_Order_Checklist_Items_Mutation_Response>;
  /** update single row of the table: "work_order_checklist_items" */
  update_work_order_checklist_items_by_pk?: Maybe<Work_Order_Checklist_Items>;
  /** update multiples rows of table: "work_order_checklist_items" */
  update_work_order_checklist_items_many?: Maybe<Array<Maybe<Work_Order_Checklist_Items_Mutation_Response>>>;
  /** update data of the table: "work_order_messages" */
  update_work_order_messages?: Maybe<Work_Order_Messages_Mutation_Response>;
  /** update single row of the table: "work_order_messages" */
  update_work_order_messages_by_pk?: Maybe<Work_Order_Messages>;
  /** update multiples rows of table: "work_order_messages" */
  update_work_order_messages_many?: Maybe<Array<Maybe<Work_Order_Messages_Mutation_Response>>>;
  /** update data of the table: "work_order_outputs" */
  update_work_order_outputs?: Maybe<Work_Order_Outputs_Mutation_Response>;
  /** update single row of the table: "work_order_outputs" */
  update_work_order_outputs_by_pk?: Maybe<Work_Order_Outputs>;
  /** update multiples rows of table: "work_order_outputs" */
  update_work_order_outputs_many?: Maybe<Array<Maybe<Work_Order_Outputs_Mutation_Response>>>;
  /** update data of the table: "work_order_requests" */
  update_work_order_requests?: Maybe<Work_Order_Requests_Mutation_Response>;
  /** update single row of the table: "work_order_requests" */
  update_work_order_requests_by_pk?: Maybe<Work_Order_Requests>;
  /** update multiples rows of table: "work_order_requests" */
  update_work_order_requests_many?: Maybe<Array<Maybe<Work_Order_Requests_Mutation_Response>>>;
  /** update data of the table: "work_order_reviews" */
  update_work_order_reviews?: Maybe<Work_Order_Reviews_Mutation_Response>;
  /** update single row of the table: "work_order_reviews" */
  update_work_order_reviews_by_pk?: Maybe<Work_Order_Reviews>;
  /** update multiples rows of table: "work_order_reviews" */
  update_work_order_reviews_many?: Maybe<Array<Maybe<Work_Order_Reviews_Mutation_Response>>>;
  /** update data of the table: "work_orders" */
  update_work_orders?: Maybe<Work_Orders_Mutation_Response>;
  /** update single row of the table: "work_orders" */
  update_work_orders_by_pk?: Maybe<Work_Orders>;
  /** update multiples rows of table: "work_orders" */
  update_work_orders_many?: Maybe<Array<Maybe<Work_Orders_Mutation_Response>>>;
  uploadMultipleProductImages?: Maybe<Array<Maybe<ProductImage>>>;
  uploadProductImage: ProductImage;
  userFollowsProfileCommand: DefaultCommandOutput;
  userLikedReel: DefaultCommandOutput;
  userReactedReel: DefaultCommandOutput;
  userReportsComment: DefaultCommandOutput;
  userReportsReel: DefaultCommandOutput;
  userRequestsAccountDeletion: DefaultCommandOutput;
  userSetHisLocale: DefaultCommandOutput;
  userSharedReel: DefaultCommandOutput;
  userUnfollowsProfileCommand: DefaultCommandOutput;
  userUnreactedReel: DefaultCommandOutput;
  userUpdatesHisDeviceInfo: DefaultCommandOutput;
  userUpdatesHisProfile: DefaultCommandOutput;
  userViewedReel: DefaultCommandOutput;
  verifyOtpCommand: VerifyOtpOutput;
};


/** mutation root */
export type Mutation_RootAccountUserMessagesOnProspectArgs = {
  request: AccountUserMessagesOnProspectInput;
};


/** mutation root */
export type Mutation_RootAddChatParticipantArgs = {
  threadId: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootAddChatReactionArgs = {
  messageId: Scalars['Int']['input'];
  reaction: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootAppLogoutArgs = {
  installationId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootApplyForContentCreatorArgs = {
  request: ApplyForContentCreatorRoleInput;
};


/** mutation root */
export type Mutation_RootArchiveChatThreadArgs = {
  threadId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootAskFarminstaSimpleArgs = {
  question: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootAssignWarehouseManagerArgs = {
  role?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  warehouseId: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootCfUploadDataArgs = {
  expiresInSeconds?: InputMaybe<Scalars['Int']['input']>;
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootChangeWarehouseUserRoleArgs = {
  role: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  warehouseId: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootCompanyAcceptsOrRejectsWorkorderRequestArgs = {
  request: CompanyAcceptsOrRejectsWorkorderRequestRequestInput;
};


/** mutation root */
export type Mutation_RootCompanyAssignsFoArgs = {
  request: CompanyAssignsFoRequestInput;
};


/** mutation root */
export type Mutation_RootCompanySendsConnectionRequestArgs = {
  request: CompanySendsConnectionRequestInput;
};


/** mutation root */
export type Mutation_RootCompanyWorkorderFeedbackArgs = {
  request: CompanyWorkorderFeedbackRequestInput;
};


/** mutation root */
export type Mutation_RootCreateCrmSegmentArgs = {
  dto: CreateCrmSegmentRequestInput;
};


/** mutation root */
export type Mutation_RootCreateCategoryArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};


/** mutation root */
export type Mutation_RootCreateChatThreadArgs = {
  participantIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootCreateGigArgs = {
  request: CreateGigInput;
};


/** mutation root */
export type Mutation_RootCreateLeadByFoArgs = {
  accountId: Scalars['String']['input'];
  farmerUserId: Scalars['String']['input'];
  foUserId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootCreateMessageCampaignArgs = {
  dto: CreateMessageCampaignRequestInput;
};


/** mutation root */
export type Mutation_RootCreateProductArgs = {
  basePrice: Scalars['Float']['input'];
  categoryIds?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dimensions?: InputMaybe<Scalars['JSON']['input']>;
  metaData?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  sku: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};


/** mutation root */
export type Mutation_RootCreateProductPopArgs = {
  input: CreateProductPopInput;
};


/** mutation root */
export type Mutation_RootCreateReelArgs = {
  command: UserCreatesReelCommandInput;
};


/** mutation root */
export type Mutation_RootCreateReelCategoryArgs = {
  command: UserCreatesNewReelCategoryInput;
};


/** mutation root */
export type Mutation_RootCreateReelCommentArgs = {
  command: UserCreatesReelCommentInput;
};


/** mutation root */
export type Mutation_RootCreateSaleArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootCreateShopifyUserAccountArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootCreateTrackableLinkArgs = {
  input: CreateTrackableLinkInput;
};


/** mutation root */
export type Mutation_RootCreateWarehouseArgs = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  contactInfo?: InputMaybe<Scalars['JSON']['input']>;
  country: Scalars['String']['input'];
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  managerId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pincode: Scalars['String']['input'];
  state: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootCreateWorkOrderArgs = {
  request: CreateWorkOrderRequestInput;
};


/** mutation root */
export type Mutation_RootDeleteAllProductImagesArgs = {
  productId: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDeleteCategoryArgs = {
  childAction?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  productAction?: InputMaybe<Scalars['String']['input']>;
  reassignToCategoryId?: InputMaybe<Scalars['Int']['input']>;
};


/** mutation root */
export type Mutation_RootDeleteChatMessageArgs = {
  messageId: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDeleteProductArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDeleteProductImageArgs = {
  imageId: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDeleteProductPopArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteReelCommentArgs = {
  command: UserDeletesReelCommentInput;
};


/** mutation root */
export type Mutation_RootDeleteTestRequestsArgs = {
  command: DeleteTestRequestsCommandInput;
};


/** mutation root */
export type Mutation_RootDelete_Account_Auth_KeyArgs = {
  where: Account_Auth_Key_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Account_Auth_Key_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Account_CropArgs = {
  where: Account_Crop_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Account_Crop_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Account_SegmentArgs = {
  where: Account_Segment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Account_Segment_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Account_UserArgs = {
  where: Account_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Account_User_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_AccountsArgs = {
  where: Accounts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Accounts_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Action_EventsArgs = {
  where: Action_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Action_Events_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_BalancesArgs = {
  where: Balances_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Balances_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Channel_LinksArgs = {
  where: Channel_Links_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Channel_Links_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ChannelsArgs = {
  where: Channels_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Channels_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Chat_MessagesArgs = {
  where: Chat_Messages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Chat_Messages_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Chat_ParticipantsArgs = {
  where: Chat_Participants_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Chat_Participants_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Chat_ThreadsArgs = {
  where: Chat_Threads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Chat_Threads_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CompaniesArgs = {
  where: Companies_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Companies_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Creator_OnboardingArgs = {
  where: Creator_Onboarding_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Creator_Onboarding_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Crm_SegmentsArgs = {
  where: Crm_Segments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Crm_Segments_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Crop_UserArgs = {
  where: Crop_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Crop_User_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Failed_JobsArgs = {
  where: Failed_Jobs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Failed_Jobs_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Farmer_Account_LocationsArgs = {
  where: Farmer_Account_Locations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Farmer_Account_Locations_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Farmer_AccountsArgs = {
  where: Farmer_Accounts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Farmer_Accounts_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Farmer_ActionsArgs = {
  where: Farmer_Actions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Farmer_Actions_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Farmer_FieldsArgs = {
  where: Farmer_Fields_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Farmer_Fields_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Farmer_MasterArgs = {
  where: Farmer_Master_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Farmer_Master_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Farmer_Nearby_Field_ForceArgs = {
  where: Farmer_Nearby_Field_Force_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Farmer_Nearby_Field_Force_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Farmer_PlotsArgs = {
  where: Farmer_Plots_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Farmer_Plots_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Farminsta_LinksArgs = {
  where: Farminsta_Links_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Farminsta_Links_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_FeaturesArgs = {
  where: Features_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Features_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Field_Partner_Response_EventsArgs = {
  where: Field_Partner_Response_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Field_Partner_Response_Events_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Field_Partner_Response_MessagesArgs = {
  where: Field_Partner_Response_Messages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Field_Partner_Response_Messages_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Field_Partner_ResponsesArgs = {
  where: Field_Partner_Responses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Field_Partner_Responses_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Field_Scheduled_VisitsArgs = {
  where: Field_Scheduled_Visits_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Field_Scheduled_Visits_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Fo_Reels_StagingArgs = {
  where: Fo_Reels_Staging_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Fo_Reels_Staging_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_FollowsArgs = {
  where: Follows_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Follows_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Geometry_ColumnsArgs = {
  where: Geometry_Columns_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Gig_FaqsArgs = {
  where: Gig_Faqs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Gig_Faqs_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Gig_PromosArgs = {
  where: Gig_Promos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Gig_Promos_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Gig_VariantsArgs = {
  where: Gig_Variants_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Gig_Variants_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_GigsArgs = {
  where: Gigs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Gigs_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Gis_DistrictsArgs = {
  where: Gis_Districts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Gis_Districts_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Gis_StatesArgs = {
  where: Gis_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Gis_States_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Last_Known_LocationsArgs = {
  where: Last_Known_Locations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Last_Known_Locations_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Master_CropsArgs = {
  where: Master_Crops_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Master_Crops_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Master_SegmentsArgs = {
  where: Master_Segments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Master_Segments_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Messaging_Campaign_RecipientsArgs = {
  where: Messaging_Campaign_Recipients_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Messaging_Campaign_Recipients_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Messaging_Campaign_SegmentsArgs = {
  where: Messaging_Campaign_Segments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Messaging_Campaign_Segments_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Messaging_CampaignsArgs = {
  where: Messaging_Campaigns_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Messaging_Campaigns_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Messaging_TemplatesArgs = {
  where: Messaging_Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Messaging_Templates_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_MigrationsArgs = {
  where: Migrations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Migrations_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Missed_Call_Number_PoolArgs = {
  where: Missed_Call_Number_Pool_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Missed_Call_Number_Pool_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Missed_CallsArgs = {
  where: Missed_Calls_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Missed_Calls_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Model_Has_PermissionsArgs = {
  where: Model_Has_Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Model_Has_Permissions_By_PkArgs = {
  model_id: Scalars['String']['input'];
  model_type: Scalars['String']['input'];
  permission_id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Model_Has_RolesArgs = {
  where: Model_Has_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Model_Has_Roles_By_PkArgs = {
  model_id: Scalars['String']['input'];
  model_type: Scalars['String']['input'];
  role_id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_NotificationsArgs = {
  where: Notifications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notifications_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Nova_Field_AttachmentsArgs = {
  where: Nova_Field_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Nova_Field_Attachments_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Nova_NotificationsArgs = {
  where: Nova_Notifications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Nova_Notifications_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Nova_Pending_Field_AttachmentsArgs = {
  where: Nova_Pending_Field_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Nova_Pending_Field_Attachments_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Nova_TwofaArgs = {
  where: Nova_Twofa_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Nova_Twofa_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Pairing_CodesArgs = {
  where: Pairing_Codes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pairing_Codes_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Password_Reset_TokensArgs = {
  where: Password_Reset_Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Password_Reset_Tokens_By_PkArgs = {
  email: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PermissionsArgs = {
  where: Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Permissions_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Personal_Access_TokensArgs = {
  where: Personal_Access_Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Personal_Access_Tokens_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Personal_DashboardArgs = {
  where: Personal_Dashboard_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Personal_Dashboard_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Pf_ProductsArgs = {
  where: Pf_Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pf_Products_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Pf_User_TravellogArgs = {
  where: Pf_User_Travellog_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pf_User_Travellog_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Product_Pop_MediaArgs = {
  where: Product_Pop_Media_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Pop_Media_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Product_PopsArgs = {
  where: Product_Pops_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Pops_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Prospect_CropsArgs = {
  where: Prospect_Crops_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Prospect_Crops_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Prospect_MessagesArgs = {
  where: Prospect_Messages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Prospect_Messages_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Prospect_UserArgs = {
  where: Prospect_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Prospect_User_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProspectsArgs = {
  where: Prospects_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Prospects_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Reel_CategoryArgs = {
  where: Reel_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Reel_Category_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Reel_CommentsArgs = {
  where: Reel_Comments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Reel_Comments_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Reel_InteractionsArgs = {
  where: Reel_Interactions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Reel_Interactions_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Reel_StatsArgs = {
  where: Reel_Stats_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Reel_Stats_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Reel_User_ReportsArgs = {
  where: Reel_User_Reports_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Reel_User_Reports_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ReelsArgs = {
  where: Reels_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Reels_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Reels_With_DistanceArgs = {
  where: Reels_With_Distance_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Retailer_EstablishmentsArgs = {
  where: Retailer_Establishments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Retailer_Establishments_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_RetailersArgs = {
  where: Retailers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Retailers_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Role_Has_PermissionsArgs = {
  where: Role_Has_Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Role_Has_Permissions_By_PkArgs = {
  permission_id: Scalars['bigint']['input'];
  role_id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_RolesArgs = {
  where: Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Roles_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Runpando_Pro_All_State_DataArgs = {
  where: Runpando_Pro_All_State_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Runpando_Pro_All_State_Data_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Runpando_Pro_UsersArgs = {
  where: Runpando_Pro_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Runpando_Pro_Users_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Runpando_Pro_Users_LocationsArgs = {
  where: Runpando_Pro_Users_Locations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Runpando_Pro_Users_Locations_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Sale_ItemsArgs = {
  where: Sale_Items_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sale_Items_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Sale_PaymentsArgs = {
  where: Sale_Payments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sale_Payments_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Sale_Proof_EventsArgs = {
  where: Sale_Proof_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sale_Proof_Events_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Sale_Proof_TypesArgs = {
  where: Sale_Proof_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sale_Proof_Types_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Sale_ProofsArgs = {
  where: Sale_Proofs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sale_Proofs_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_SalesArgs = {
  where: Sales_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sales_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Saved_ReelsArgs = {
  where: Saved_Reels_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Saved_Reels_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Segment_UserArgs = {
  where: Segment_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Segment_User_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Service_Request_DashboardArgs = {
  where: Service_Request_Dashboard_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Service_Request_Dashboard_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Service_Request_RecommendationsArgs = {
  where: Service_Request_Recommendations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Service_Request_Recommendations_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Service_Request_RetailerArgs = {
  where: Service_Request_Retailer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Service_Request_Retailer_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Service_RequestsArgs = {
  where: Service_Requests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Service_Requests_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_SnapshotsArgs = {
  where: Snapshots_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Snapshots_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Spatial_Ref_SysArgs = {
  where: Spatial_Ref_Sys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Spatial_Ref_Sys_By_PkArgs = {
  srid: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Stored_EventsArgs = {
  where: Stored_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Stored_Events_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TaggablesArgs = {
  where: Taggables_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Taggables_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TagsArgs = {
  where: Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tags_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_DeviceArgs = {
  where: User_Device_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Device_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_FeedbacksArgs = {
  where: User_Feedbacks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Feedbacks_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_Follows_ChannelArgs = {
  where: User_Follows_Channel_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Follows_Channel_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_Location_LogsArgs = {
  where: User_Location_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Location_Logs_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_WalletsArgs = {
  where: Wallets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Wallets_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Whatsauth_LoginsArgs = {
  where: Whatsauth_Logins_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Whatsauth_Logins_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Work_Order_Checklist_ItemsArgs = {
  where: Work_Order_Checklist_Items_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Work_Order_Checklist_Items_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Work_Order_MessagesArgs = {
  where: Work_Order_Messages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Work_Order_Messages_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Work_Order_OutputsArgs = {
  where: Work_Order_Outputs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Work_Order_Outputs_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Work_Order_RequestsArgs = {
  where: Work_Order_Requests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Work_Order_Requests_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Work_Order_ReviewsArgs = {
  where: Work_Order_Reviews_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Work_Order_Reviews_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Work_OrdersArgs = {
  where: Work_Orders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Work_Orders_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootEditInfluencerGigProfileArgs = {
  request: EditInfluencerGigProfileRequestInput;
};


/** mutation root */
export type Mutation_RootFarmerAcceptsConnectionArgs = {
  request: FarmerAcceptsConnectionRequestInput;
};


/** mutation root */
export type Mutation_RootFarmerAcceptsVisitScheduleArgs = {
  command: FarmerAcceptsVisitScheduleCommandInput;
};


/** mutation root */
export type Mutation_RootFarmerCancelsServiceRequestArgs = {
  command: FarmerCancelsServiceRequestCommandInput;
};


/** mutation root */
export type Mutation_RootFarmerClosesResponseArgs = {
  command: FarmerClosesResponseCommandInput;
};


/** mutation root */
export type Mutation_RootFarmerClosesServiceRequestArgs = {
  command: FarmerClosesRequestCommandInput;
};


/** mutation root */
export type Mutation_RootFarmerCreatesServiceRequestArgs = {
  command: CreateServiceRequestCommandInput;
};


/** mutation root */
export type Mutation_RootFarmerMessagesOnProspectArgs = {
  request: FarmerMessagesOnProspectInput;
};


/** mutation root */
export type Mutation_RootFarmerRatesAndReviewsServiceRequestArgs = {
  command: FarmerGivesFeedbackToFieldPartnerCommandInput;
};


/** mutation root */
export type Mutation_RootFarmerRejectsConnectionArgs = {
  request: FarmerRejectsConnectionRequestInput;
};


/** mutation root */
export type Mutation_RootFfWentOfflineArgs = {
  command: FieldPartnerGoesOfflineInput;
};


/** mutation root */
export type Mutation_RootFfWentOnlineArgs = {
  command: FieldPartnerGoesOnlineInput;
};


/** mutation root */
export type Mutation_RootFieldPartnerCancelsAVisitArgs = {
  command: FieldPartnerCancelsAVisitCommandInput;
};


/** mutation root */
export type Mutation_RootFieldPartnerClosesRequestArgs = {
  command: FieldPartnerCloseRequestCommandInput;
};


/** mutation root */
export type Mutation_RootFieldPartnerRatesAndReviewsFarmerArgs = {
  command: FieldPartnerGivesFeedbackToFarmerCommandInput;
};


/** mutation root */
export type Mutation_RootFieldPartnerRespondsToRequestArgs = {
  command: FieldPartnerRespondsToServiceRequestCommandInput;
};


/** mutation root */
export type Mutation_RootFieldPartnerSchedulesAVisitArgs = {
  command: FieldPartnerSchedulesAVisitCommandInput;
};


/** mutation root */
export type Mutation_RootFieldPartnerUpdatesHisCropsArgs = {
  command: FieldPartnerUpdatesHisCropsCommandInput;
};


/** mutation root */
export type Mutation_RootFieldPartnerUpdatesHisSegmentsArgs = {
  command: FieldPartnerUpdatesHisSegmentsCommandInput;
};


/** mutation root */
export type Mutation_RootFoCreateReelArgs = {
  command: UserCreatesReelCommandInput;
};


/** mutation root */
export type Mutation_RootFoCreatesFarmerArgs = {
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootFoPlanBasedRecommendationArgs = {
  command: FoPlanBasedRecommendationRequestInput;
};


/** mutation root */
export type Mutation_RootForceDeleteProductArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootInfluencerAppliesForWorkOrderArgs = {
  request: InfluencerAppliesForWorkOrderInput;
};


/** mutation root */
export type Mutation_RootInfluencerRejectsWorkOrderArgs = {
  woId: Scalars['String']['input'];
  worId?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootInfluencerWorkorderFeedbackArgs = {
  request: InfluencerWorkorderFeedbackRequestInput;
};


/** mutation root */
export type Mutation_RootInitiateWorkorderClosureArgs = {
  output: WorkorderClosureOutputInput;
  reason: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  workOrderId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootInsert_Account_Auth_KeyArgs = {
  objects: Array<Account_Auth_Key_Insert_Input>;
  on_conflict?: InputMaybe<Account_Auth_Key_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Account_Auth_Key_OneArgs = {
  object: Account_Auth_Key_Insert_Input;
  on_conflict?: InputMaybe<Account_Auth_Key_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Account_CropArgs = {
  objects: Array<Account_Crop_Insert_Input>;
  on_conflict?: InputMaybe<Account_Crop_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Account_Crop_OneArgs = {
  object: Account_Crop_Insert_Input;
  on_conflict?: InputMaybe<Account_Crop_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Account_SegmentArgs = {
  objects: Array<Account_Segment_Insert_Input>;
  on_conflict?: InputMaybe<Account_Segment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Account_Segment_OneArgs = {
  object: Account_Segment_Insert_Input;
  on_conflict?: InputMaybe<Account_Segment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Account_UserArgs = {
  objects: Array<Account_User_Insert_Input>;
  on_conflict?: InputMaybe<Account_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Account_User_OneArgs = {
  object: Account_User_Insert_Input;
  on_conflict?: InputMaybe<Account_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AccountsArgs = {
  objects: Array<Accounts_Insert_Input>;
  on_conflict?: InputMaybe<Accounts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Accounts_OneArgs = {
  object: Accounts_Insert_Input;
  on_conflict?: InputMaybe<Accounts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Action_EventsArgs = {
  objects: Array<Action_Events_Insert_Input>;
  on_conflict?: InputMaybe<Action_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Action_Events_OneArgs = {
  object: Action_Events_Insert_Input;
  on_conflict?: InputMaybe<Action_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BalancesArgs = {
  objects: Array<Balances_Insert_Input>;
  on_conflict?: InputMaybe<Balances_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Balances_OneArgs = {
  object: Balances_Insert_Input;
  on_conflict?: InputMaybe<Balances_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Channel_LinksArgs = {
  objects: Array<Channel_Links_Insert_Input>;
  on_conflict?: InputMaybe<Channel_Links_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Channel_Links_OneArgs = {
  object: Channel_Links_Insert_Input;
  on_conflict?: InputMaybe<Channel_Links_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ChannelsArgs = {
  objects: Array<Channels_Insert_Input>;
  on_conflict?: InputMaybe<Channels_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Channels_OneArgs = {
  object: Channels_Insert_Input;
  on_conflict?: InputMaybe<Channels_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Chat_MessagesArgs = {
  objects: Array<Chat_Messages_Insert_Input>;
  on_conflict?: InputMaybe<Chat_Messages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Chat_Messages_OneArgs = {
  object: Chat_Messages_Insert_Input;
  on_conflict?: InputMaybe<Chat_Messages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Chat_ParticipantsArgs = {
  objects: Array<Chat_Participants_Insert_Input>;
  on_conflict?: InputMaybe<Chat_Participants_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Chat_Participants_OneArgs = {
  object: Chat_Participants_Insert_Input;
  on_conflict?: InputMaybe<Chat_Participants_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Chat_ThreadsArgs = {
  objects: Array<Chat_Threads_Insert_Input>;
  on_conflict?: InputMaybe<Chat_Threads_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Chat_Threads_OneArgs = {
  object: Chat_Threads_Insert_Input;
  on_conflict?: InputMaybe<Chat_Threads_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CompaniesArgs = {
  objects: Array<Companies_Insert_Input>;
  on_conflict?: InputMaybe<Companies_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Companies_OneArgs = {
  object: Companies_Insert_Input;
  on_conflict?: InputMaybe<Companies_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Creator_OnboardingArgs = {
  objects: Array<Creator_Onboarding_Insert_Input>;
  on_conflict?: InputMaybe<Creator_Onboarding_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Creator_Onboarding_OneArgs = {
  object: Creator_Onboarding_Insert_Input;
  on_conflict?: InputMaybe<Creator_Onboarding_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crm_SegmentsArgs = {
  objects: Array<Crm_Segments_Insert_Input>;
  on_conflict?: InputMaybe<Crm_Segments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crm_Segments_OneArgs = {
  object: Crm_Segments_Insert_Input;
  on_conflict?: InputMaybe<Crm_Segments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_UserArgs = {
  objects: Array<Crop_User_Insert_Input>;
  on_conflict?: InputMaybe<Crop_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_User_OneArgs = {
  object: Crop_User_Insert_Input;
  on_conflict?: InputMaybe<Crop_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Failed_JobsArgs = {
  objects: Array<Failed_Jobs_Insert_Input>;
  on_conflict?: InputMaybe<Failed_Jobs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Failed_Jobs_OneArgs = {
  object: Failed_Jobs_Insert_Input;
  on_conflict?: InputMaybe<Failed_Jobs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Farmer_Account_LocationsArgs = {
  objects: Array<Farmer_Account_Locations_Insert_Input>;
  on_conflict?: InputMaybe<Farmer_Account_Locations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Farmer_Account_Locations_OneArgs = {
  object: Farmer_Account_Locations_Insert_Input;
  on_conflict?: InputMaybe<Farmer_Account_Locations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Farmer_AccountsArgs = {
  objects: Array<Farmer_Accounts_Insert_Input>;
  on_conflict?: InputMaybe<Farmer_Accounts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Farmer_Accounts_OneArgs = {
  object: Farmer_Accounts_Insert_Input;
  on_conflict?: InputMaybe<Farmer_Accounts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Farmer_ActionsArgs = {
  objects: Array<Farmer_Actions_Insert_Input>;
  on_conflict?: InputMaybe<Farmer_Actions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Farmer_Actions_OneArgs = {
  object: Farmer_Actions_Insert_Input;
  on_conflict?: InputMaybe<Farmer_Actions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Farmer_FieldsArgs = {
  objects: Array<Farmer_Fields_Insert_Input>;
  on_conflict?: InputMaybe<Farmer_Fields_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Farmer_Fields_OneArgs = {
  object: Farmer_Fields_Insert_Input;
  on_conflict?: InputMaybe<Farmer_Fields_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Farmer_MasterArgs = {
  objects: Array<Farmer_Master_Insert_Input>;
  on_conflict?: InputMaybe<Farmer_Master_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Farmer_Master_OneArgs = {
  object: Farmer_Master_Insert_Input;
  on_conflict?: InputMaybe<Farmer_Master_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Farmer_Nearby_Field_ForceArgs = {
  objects: Array<Farmer_Nearby_Field_Force_Insert_Input>;
  on_conflict?: InputMaybe<Farmer_Nearby_Field_Force_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Farmer_Nearby_Field_Force_OneArgs = {
  object: Farmer_Nearby_Field_Force_Insert_Input;
  on_conflict?: InputMaybe<Farmer_Nearby_Field_Force_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Farmer_PlotsArgs = {
  objects: Array<Farmer_Plots_Insert_Input>;
  on_conflict?: InputMaybe<Farmer_Plots_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Farmer_Plots_OneArgs = {
  object: Farmer_Plots_Insert_Input;
  on_conflict?: InputMaybe<Farmer_Plots_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Farminsta_LinksArgs = {
  objects: Array<Farminsta_Links_Insert_Input>;
  on_conflict?: InputMaybe<Farminsta_Links_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Farminsta_Links_OneArgs = {
  object: Farminsta_Links_Insert_Input;
  on_conflict?: InputMaybe<Farminsta_Links_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FeaturesArgs = {
  objects: Array<Features_Insert_Input>;
  on_conflict?: InputMaybe<Features_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Features_OneArgs = {
  object: Features_Insert_Input;
  on_conflict?: InputMaybe<Features_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Field_Partner_Response_EventsArgs = {
  objects: Array<Field_Partner_Response_Events_Insert_Input>;
  on_conflict?: InputMaybe<Field_Partner_Response_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Field_Partner_Response_Events_OneArgs = {
  object: Field_Partner_Response_Events_Insert_Input;
  on_conflict?: InputMaybe<Field_Partner_Response_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Field_Partner_Response_MessagesArgs = {
  objects: Array<Field_Partner_Response_Messages_Insert_Input>;
  on_conflict?: InputMaybe<Field_Partner_Response_Messages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Field_Partner_Response_Messages_OneArgs = {
  object: Field_Partner_Response_Messages_Insert_Input;
  on_conflict?: InputMaybe<Field_Partner_Response_Messages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Field_Partner_ResponsesArgs = {
  objects: Array<Field_Partner_Responses_Insert_Input>;
  on_conflict?: InputMaybe<Field_Partner_Responses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Field_Partner_Responses_OneArgs = {
  object: Field_Partner_Responses_Insert_Input;
  on_conflict?: InputMaybe<Field_Partner_Responses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Field_Scheduled_VisitsArgs = {
  objects: Array<Field_Scheduled_Visits_Insert_Input>;
  on_conflict?: InputMaybe<Field_Scheduled_Visits_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Field_Scheduled_Visits_OneArgs = {
  object: Field_Scheduled_Visits_Insert_Input;
  on_conflict?: InputMaybe<Field_Scheduled_Visits_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fo_Reels_StagingArgs = {
  objects: Array<Fo_Reels_Staging_Insert_Input>;
  on_conflict?: InputMaybe<Fo_Reels_Staging_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fo_Reels_Staging_OneArgs = {
  object: Fo_Reels_Staging_Insert_Input;
  on_conflict?: InputMaybe<Fo_Reels_Staging_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FollowsArgs = {
  objects: Array<Follows_Insert_Input>;
  on_conflict?: InputMaybe<Follows_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Follows_OneArgs = {
  object: Follows_Insert_Input;
  on_conflict?: InputMaybe<Follows_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Geometry_ColumnsArgs = {
  objects: Array<Geometry_Columns_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Geometry_Columns_OneArgs = {
  object: Geometry_Columns_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Gig_FaqsArgs = {
  objects: Array<Gig_Faqs_Insert_Input>;
  on_conflict?: InputMaybe<Gig_Faqs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gig_Faqs_OneArgs = {
  object: Gig_Faqs_Insert_Input;
  on_conflict?: InputMaybe<Gig_Faqs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gig_PromosArgs = {
  objects: Array<Gig_Promos_Insert_Input>;
  on_conflict?: InputMaybe<Gig_Promos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gig_Promos_OneArgs = {
  object: Gig_Promos_Insert_Input;
  on_conflict?: InputMaybe<Gig_Promos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gig_VariantsArgs = {
  objects: Array<Gig_Variants_Insert_Input>;
  on_conflict?: InputMaybe<Gig_Variants_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gig_Variants_OneArgs = {
  object: Gig_Variants_Insert_Input;
  on_conflict?: InputMaybe<Gig_Variants_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GigsArgs = {
  objects: Array<Gigs_Insert_Input>;
  on_conflict?: InputMaybe<Gigs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gigs_OneArgs = {
  object: Gigs_Insert_Input;
  on_conflict?: InputMaybe<Gigs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gis_DistrictsArgs = {
  objects: Array<Gis_Districts_Insert_Input>;
  on_conflict?: InputMaybe<Gis_Districts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gis_Districts_OneArgs = {
  object: Gis_Districts_Insert_Input;
  on_conflict?: InputMaybe<Gis_Districts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gis_StatesArgs = {
  objects: Array<Gis_States_Insert_Input>;
  on_conflict?: InputMaybe<Gis_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gis_States_OneArgs = {
  object: Gis_States_Insert_Input;
  on_conflict?: InputMaybe<Gis_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Last_Known_LocationsArgs = {
  objects: Array<Last_Known_Locations_Insert_Input>;
  on_conflict?: InputMaybe<Last_Known_Locations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Last_Known_Locations_OneArgs = {
  object: Last_Known_Locations_Insert_Input;
  on_conflict?: InputMaybe<Last_Known_Locations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Master_CropsArgs = {
  objects: Array<Master_Crops_Insert_Input>;
  on_conflict?: InputMaybe<Master_Crops_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Master_Crops_OneArgs = {
  object: Master_Crops_Insert_Input;
  on_conflict?: InputMaybe<Master_Crops_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Master_SegmentsArgs = {
  objects: Array<Master_Segments_Insert_Input>;
  on_conflict?: InputMaybe<Master_Segments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Master_Segments_OneArgs = {
  object: Master_Segments_Insert_Input;
  on_conflict?: InputMaybe<Master_Segments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Messaging_Campaign_RecipientsArgs = {
  objects: Array<Messaging_Campaign_Recipients_Insert_Input>;
  on_conflict?: InputMaybe<Messaging_Campaign_Recipients_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Messaging_Campaign_Recipients_OneArgs = {
  object: Messaging_Campaign_Recipients_Insert_Input;
  on_conflict?: InputMaybe<Messaging_Campaign_Recipients_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Messaging_Campaign_SegmentsArgs = {
  objects: Array<Messaging_Campaign_Segments_Insert_Input>;
  on_conflict?: InputMaybe<Messaging_Campaign_Segments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Messaging_Campaign_Segments_OneArgs = {
  object: Messaging_Campaign_Segments_Insert_Input;
  on_conflict?: InputMaybe<Messaging_Campaign_Segments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Messaging_CampaignsArgs = {
  objects: Array<Messaging_Campaigns_Insert_Input>;
  on_conflict?: InputMaybe<Messaging_Campaigns_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Messaging_Campaigns_OneArgs = {
  object: Messaging_Campaigns_Insert_Input;
  on_conflict?: InputMaybe<Messaging_Campaigns_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Messaging_TemplatesArgs = {
  objects: Array<Messaging_Templates_Insert_Input>;
  on_conflict?: InputMaybe<Messaging_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Messaging_Templates_OneArgs = {
  object: Messaging_Templates_Insert_Input;
  on_conflict?: InputMaybe<Messaging_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MigrationsArgs = {
  objects: Array<Migrations_Insert_Input>;
  on_conflict?: InputMaybe<Migrations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Migrations_OneArgs = {
  object: Migrations_Insert_Input;
  on_conflict?: InputMaybe<Migrations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Missed_Call_Number_PoolArgs = {
  objects: Array<Missed_Call_Number_Pool_Insert_Input>;
  on_conflict?: InputMaybe<Missed_Call_Number_Pool_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Missed_Call_Number_Pool_OneArgs = {
  object: Missed_Call_Number_Pool_Insert_Input;
  on_conflict?: InputMaybe<Missed_Call_Number_Pool_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Missed_CallsArgs = {
  objects: Array<Missed_Calls_Insert_Input>;
  on_conflict?: InputMaybe<Missed_Calls_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Missed_Calls_OneArgs = {
  object: Missed_Calls_Insert_Input;
  on_conflict?: InputMaybe<Missed_Calls_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Model_Has_PermissionsArgs = {
  objects: Array<Model_Has_Permissions_Insert_Input>;
  on_conflict?: InputMaybe<Model_Has_Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Model_Has_Permissions_OneArgs = {
  object: Model_Has_Permissions_Insert_Input;
  on_conflict?: InputMaybe<Model_Has_Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Model_Has_RolesArgs = {
  objects: Array<Model_Has_Roles_Insert_Input>;
  on_conflict?: InputMaybe<Model_Has_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Model_Has_Roles_OneArgs = {
  object: Model_Has_Roles_Insert_Input;
  on_conflict?: InputMaybe<Model_Has_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_NotificationsArgs = {
  objects: Array<Notifications_Insert_Input>;
  on_conflict?: InputMaybe<Notifications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notifications_OneArgs = {
  object: Notifications_Insert_Input;
  on_conflict?: InputMaybe<Notifications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nova_Field_AttachmentsArgs = {
  objects: Array<Nova_Field_Attachments_Insert_Input>;
  on_conflict?: InputMaybe<Nova_Field_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nova_Field_Attachments_OneArgs = {
  object: Nova_Field_Attachments_Insert_Input;
  on_conflict?: InputMaybe<Nova_Field_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nova_NotificationsArgs = {
  objects: Array<Nova_Notifications_Insert_Input>;
  on_conflict?: InputMaybe<Nova_Notifications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nova_Notifications_OneArgs = {
  object: Nova_Notifications_Insert_Input;
  on_conflict?: InputMaybe<Nova_Notifications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nova_Pending_Field_AttachmentsArgs = {
  objects: Array<Nova_Pending_Field_Attachments_Insert_Input>;
  on_conflict?: InputMaybe<Nova_Pending_Field_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nova_Pending_Field_Attachments_OneArgs = {
  object: Nova_Pending_Field_Attachments_Insert_Input;
  on_conflict?: InputMaybe<Nova_Pending_Field_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nova_TwofaArgs = {
  objects: Array<Nova_Twofa_Insert_Input>;
  on_conflict?: InputMaybe<Nova_Twofa_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nova_Twofa_OneArgs = {
  object: Nova_Twofa_Insert_Input;
  on_conflict?: InputMaybe<Nova_Twofa_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pairing_CodesArgs = {
  objects: Array<Pairing_Codes_Insert_Input>;
  on_conflict?: InputMaybe<Pairing_Codes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pairing_Codes_OneArgs = {
  object: Pairing_Codes_Insert_Input;
  on_conflict?: InputMaybe<Pairing_Codes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Password_Reset_TokensArgs = {
  objects: Array<Password_Reset_Tokens_Insert_Input>;
  on_conflict?: InputMaybe<Password_Reset_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Password_Reset_Tokens_OneArgs = {
  object: Password_Reset_Tokens_Insert_Input;
  on_conflict?: InputMaybe<Password_Reset_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PermissionsArgs = {
  objects: Array<Permissions_Insert_Input>;
  on_conflict?: InputMaybe<Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Permissions_OneArgs = {
  object: Permissions_Insert_Input;
  on_conflict?: InputMaybe<Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Personal_Access_TokensArgs = {
  objects: Array<Personal_Access_Tokens_Insert_Input>;
  on_conflict?: InputMaybe<Personal_Access_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Personal_Access_Tokens_OneArgs = {
  object: Personal_Access_Tokens_Insert_Input;
  on_conflict?: InputMaybe<Personal_Access_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Personal_DashboardArgs = {
  objects: Array<Personal_Dashboard_Insert_Input>;
  on_conflict?: InputMaybe<Personal_Dashboard_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Personal_Dashboard_OneArgs = {
  object: Personal_Dashboard_Insert_Input;
  on_conflict?: InputMaybe<Personal_Dashboard_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pf_ProductsArgs = {
  objects: Array<Pf_Products_Insert_Input>;
  on_conflict?: InputMaybe<Pf_Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pf_Products_OneArgs = {
  object: Pf_Products_Insert_Input;
  on_conflict?: InputMaybe<Pf_Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pf_User_TravellogArgs = {
  objects: Array<Pf_User_Travellog_Insert_Input>;
  on_conflict?: InputMaybe<Pf_User_Travellog_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pf_User_Travellog_OneArgs = {
  object: Pf_User_Travellog_Insert_Input;
  on_conflict?: InputMaybe<Pf_User_Travellog_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Pop_MediaArgs = {
  objects: Array<Product_Pop_Media_Insert_Input>;
  on_conflict?: InputMaybe<Product_Pop_Media_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Pop_Media_OneArgs = {
  object: Product_Pop_Media_Insert_Input;
  on_conflict?: InputMaybe<Product_Pop_Media_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_PopsArgs = {
  objects: Array<Product_Pops_Insert_Input>;
  on_conflict?: InputMaybe<Product_Pops_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Pops_OneArgs = {
  object: Product_Pops_Insert_Input;
  on_conflict?: InputMaybe<Product_Pops_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Prospect_CropsArgs = {
  objects: Array<Prospect_Crops_Insert_Input>;
  on_conflict?: InputMaybe<Prospect_Crops_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Prospect_Crops_OneArgs = {
  object: Prospect_Crops_Insert_Input;
  on_conflict?: InputMaybe<Prospect_Crops_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Prospect_MessagesArgs = {
  objects: Array<Prospect_Messages_Insert_Input>;
  on_conflict?: InputMaybe<Prospect_Messages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Prospect_Messages_OneArgs = {
  object: Prospect_Messages_Insert_Input;
  on_conflict?: InputMaybe<Prospect_Messages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Prospect_UserArgs = {
  objects: Array<Prospect_User_Insert_Input>;
  on_conflict?: InputMaybe<Prospect_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Prospect_User_OneArgs = {
  object: Prospect_User_Insert_Input;
  on_conflict?: InputMaybe<Prospect_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProspectsArgs = {
  objects: Array<Prospects_Insert_Input>;
  on_conflict?: InputMaybe<Prospects_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Prospects_OneArgs = {
  object: Prospects_Insert_Input;
  on_conflict?: InputMaybe<Prospects_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reel_CategoryArgs = {
  objects: Array<Reel_Category_Insert_Input>;
  on_conflict?: InputMaybe<Reel_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reel_Category_OneArgs = {
  object: Reel_Category_Insert_Input;
  on_conflict?: InputMaybe<Reel_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reel_CommentsArgs = {
  objects: Array<Reel_Comments_Insert_Input>;
  on_conflict?: InputMaybe<Reel_Comments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reel_Comments_OneArgs = {
  object: Reel_Comments_Insert_Input;
  on_conflict?: InputMaybe<Reel_Comments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reel_InteractionsArgs = {
  objects: Array<Reel_Interactions_Insert_Input>;
  on_conflict?: InputMaybe<Reel_Interactions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reel_Interactions_OneArgs = {
  object: Reel_Interactions_Insert_Input;
  on_conflict?: InputMaybe<Reel_Interactions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reel_StatsArgs = {
  objects: Array<Reel_Stats_Insert_Input>;
  on_conflict?: InputMaybe<Reel_Stats_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reel_Stats_OneArgs = {
  object: Reel_Stats_Insert_Input;
  on_conflict?: InputMaybe<Reel_Stats_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reel_User_ReportsArgs = {
  objects: Array<Reel_User_Reports_Insert_Input>;
  on_conflict?: InputMaybe<Reel_User_Reports_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reel_User_Reports_OneArgs = {
  object: Reel_User_Reports_Insert_Input;
  on_conflict?: InputMaybe<Reel_User_Reports_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReelsArgs = {
  objects: Array<Reels_Insert_Input>;
  on_conflict?: InputMaybe<Reels_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reels_OneArgs = {
  object: Reels_Insert_Input;
  on_conflict?: InputMaybe<Reels_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reels_With_DistanceArgs = {
  objects: Array<Reels_With_Distance_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Reels_With_Distance_OneArgs = {
  object: Reels_With_Distance_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Retailer_EstablishmentsArgs = {
  objects: Array<Retailer_Establishments_Insert_Input>;
  on_conflict?: InputMaybe<Retailer_Establishments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Retailer_Establishments_OneArgs = {
  object: Retailer_Establishments_Insert_Input;
  on_conflict?: InputMaybe<Retailer_Establishments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RetailersArgs = {
  objects: Array<Retailers_Insert_Input>;
  on_conflict?: InputMaybe<Retailers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Retailers_OneArgs = {
  object: Retailers_Insert_Input;
  on_conflict?: InputMaybe<Retailers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Role_Has_PermissionsArgs = {
  objects: Array<Role_Has_Permissions_Insert_Input>;
  on_conflict?: InputMaybe<Role_Has_Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Role_Has_Permissions_OneArgs = {
  object: Role_Has_Permissions_Insert_Input;
  on_conflict?: InputMaybe<Role_Has_Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RolesArgs = {
  objects: Array<Roles_Insert_Input>;
  on_conflict?: InputMaybe<Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Roles_OneArgs = {
  object: Roles_Insert_Input;
  on_conflict?: InputMaybe<Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Runpando_Pro_All_State_DataArgs = {
  objects: Array<Runpando_Pro_All_State_Data_Insert_Input>;
  on_conflict?: InputMaybe<Runpando_Pro_All_State_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Runpando_Pro_All_State_Data_OneArgs = {
  object: Runpando_Pro_All_State_Data_Insert_Input;
  on_conflict?: InputMaybe<Runpando_Pro_All_State_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Runpando_Pro_UsersArgs = {
  objects: Array<Runpando_Pro_Users_Insert_Input>;
  on_conflict?: InputMaybe<Runpando_Pro_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Runpando_Pro_Users_LocationsArgs = {
  objects: Array<Runpando_Pro_Users_Locations_Insert_Input>;
  on_conflict?: InputMaybe<Runpando_Pro_Users_Locations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Runpando_Pro_Users_Locations_OneArgs = {
  object: Runpando_Pro_Users_Locations_Insert_Input;
  on_conflict?: InputMaybe<Runpando_Pro_Users_Locations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Runpando_Pro_Users_OneArgs = {
  object: Runpando_Pro_Users_Insert_Input;
  on_conflict?: InputMaybe<Runpando_Pro_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sale_ItemsArgs = {
  objects: Array<Sale_Items_Insert_Input>;
  on_conflict?: InputMaybe<Sale_Items_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sale_Items_OneArgs = {
  object: Sale_Items_Insert_Input;
  on_conflict?: InputMaybe<Sale_Items_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sale_PaymentsArgs = {
  objects: Array<Sale_Payments_Insert_Input>;
  on_conflict?: InputMaybe<Sale_Payments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sale_Payments_OneArgs = {
  object: Sale_Payments_Insert_Input;
  on_conflict?: InputMaybe<Sale_Payments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sale_Proof_EventsArgs = {
  objects: Array<Sale_Proof_Events_Insert_Input>;
  on_conflict?: InputMaybe<Sale_Proof_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sale_Proof_Events_OneArgs = {
  object: Sale_Proof_Events_Insert_Input;
  on_conflict?: InputMaybe<Sale_Proof_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sale_Proof_TypesArgs = {
  objects: Array<Sale_Proof_Types_Insert_Input>;
  on_conflict?: InputMaybe<Sale_Proof_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sale_Proof_Types_OneArgs = {
  object: Sale_Proof_Types_Insert_Input;
  on_conflict?: InputMaybe<Sale_Proof_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sale_ProofsArgs = {
  objects: Array<Sale_Proofs_Insert_Input>;
  on_conflict?: InputMaybe<Sale_Proofs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sale_Proofs_OneArgs = {
  object: Sale_Proofs_Insert_Input;
  on_conflict?: InputMaybe<Sale_Proofs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SalesArgs = {
  objects: Array<Sales_Insert_Input>;
  on_conflict?: InputMaybe<Sales_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sales_OneArgs = {
  object: Sales_Insert_Input;
  on_conflict?: InputMaybe<Sales_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Saved_ReelsArgs = {
  objects: Array<Saved_Reels_Insert_Input>;
  on_conflict?: InputMaybe<Saved_Reels_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Saved_Reels_OneArgs = {
  object: Saved_Reels_Insert_Input;
  on_conflict?: InputMaybe<Saved_Reels_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Segment_UserArgs = {
  objects: Array<Segment_User_Insert_Input>;
  on_conflict?: InputMaybe<Segment_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Segment_User_OneArgs = {
  object: Segment_User_Insert_Input;
  on_conflict?: InputMaybe<Segment_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Service_Request_DashboardArgs = {
  objects: Array<Service_Request_Dashboard_Insert_Input>;
  on_conflict?: InputMaybe<Service_Request_Dashboard_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Service_Request_Dashboard_OneArgs = {
  object: Service_Request_Dashboard_Insert_Input;
  on_conflict?: InputMaybe<Service_Request_Dashboard_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Service_Request_RecommendationsArgs = {
  objects: Array<Service_Request_Recommendations_Insert_Input>;
  on_conflict?: InputMaybe<Service_Request_Recommendations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Service_Request_Recommendations_OneArgs = {
  object: Service_Request_Recommendations_Insert_Input;
  on_conflict?: InputMaybe<Service_Request_Recommendations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Service_Request_RetailerArgs = {
  objects: Array<Service_Request_Retailer_Insert_Input>;
  on_conflict?: InputMaybe<Service_Request_Retailer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Service_Request_Retailer_OneArgs = {
  object: Service_Request_Retailer_Insert_Input;
  on_conflict?: InputMaybe<Service_Request_Retailer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Service_RequestsArgs = {
  objects: Array<Service_Requests_Insert_Input>;
  on_conflict?: InputMaybe<Service_Requests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Service_Requests_OneArgs = {
  object: Service_Requests_Insert_Input;
  on_conflict?: InputMaybe<Service_Requests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SnapshotsArgs = {
  objects: Array<Snapshots_Insert_Input>;
  on_conflict?: InputMaybe<Snapshots_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Snapshots_OneArgs = {
  object: Snapshots_Insert_Input;
  on_conflict?: InputMaybe<Snapshots_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Spatial_Ref_SysArgs = {
  objects: Array<Spatial_Ref_Sys_Insert_Input>;
  on_conflict?: InputMaybe<Spatial_Ref_Sys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Spatial_Ref_Sys_OneArgs = {
  object: Spatial_Ref_Sys_Insert_Input;
  on_conflict?: InputMaybe<Spatial_Ref_Sys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Stored_EventsArgs = {
  objects: Array<Stored_Events_Insert_Input>;
  on_conflict?: InputMaybe<Stored_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Stored_Events_OneArgs = {
  object: Stored_Events_Insert_Input;
  on_conflict?: InputMaybe<Stored_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TaggablesArgs = {
  objects: Array<Taggables_Insert_Input>;
  on_conflict?: InputMaybe<Taggables_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Taggables_OneArgs = {
  object: Taggables_Insert_Input;
  on_conflict?: InputMaybe<Taggables_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TagsArgs = {
  objects: Array<Tags_Insert_Input>;
  on_conflict?: InputMaybe<Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tags_OneArgs = {
  object: Tags_Insert_Input;
  on_conflict?: InputMaybe<Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_DeviceArgs = {
  objects: Array<User_Device_Insert_Input>;
  on_conflict?: InputMaybe<User_Device_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Device_OneArgs = {
  object: User_Device_Insert_Input;
  on_conflict?: InputMaybe<User_Device_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_FeedbacksArgs = {
  objects: Array<User_Feedbacks_Insert_Input>;
  on_conflict?: InputMaybe<User_Feedbacks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Feedbacks_OneArgs = {
  object: User_Feedbacks_Insert_Input;
  on_conflict?: InputMaybe<User_Feedbacks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Follows_ChannelArgs = {
  objects: Array<User_Follows_Channel_Insert_Input>;
  on_conflict?: InputMaybe<User_Follows_Channel_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Follows_Channel_OneArgs = {
  object: User_Follows_Channel_Insert_Input;
  on_conflict?: InputMaybe<User_Follows_Channel_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Location_LogsArgs = {
  objects: Array<User_Location_Logs_Insert_Input>;
  on_conflict?: InputMaybe<User_Location_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Location_Logs_OneArgs = {
  object: User_Location_Logs_Insert_Input;
  on_conflict?: InputMaybe<User_Location_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_OneArgs = {
  object: Users_Insert_Input;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_WalletsArgs = {
  objects: Array<Wallets_Insert_Input>;
  on_conflict?: InputMaybe<Wallets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Wallets_OneArgs = {
  object: Wallets_Insert_Input;
  on_conflict?: InputMaybe<Wallets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Whatsauth_LoginsArgs = {
  objects: Array<Whatsauth_Logins_Insert_Input>;
  on_conflict?: InputMaybe<Whatsauth_Logins_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Whatsauth_Logins_OneArgs = {
  object: Whatsauth_Logins_Insert_Input;
  on_conflict?: InputMaybe<Whatsauth_Logins_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Work_Order_Checklist_ItemsArgs = {
  objects: Array<Work_Order_Checklist_Items_Insert_Input>;
  on_conflict?: InputMaybe<Work_Order_Checklist_Items_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Work_Order_Checklist_Items_OneArgs = {
  object: Work_Order_Checklist_Items_Insert_Input;
  on_conflict?: InputMaybe<Work_Order_Checklist_Items_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Work_Order_MessagesArgs = {
  objects: Array<Work_Order_Messages_Insert_Input>;
  on_conflict?: InputMaybe<Work_Order_Messages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Work_Order_Messages_OneArgs = {
  object: Work_Order_Messages_Insert_Input;
  on_conflict?: InputMaybe<Work_Order_Messages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Work_Order_OutputsArgs = {
  objects: Array<Work_Order_Outputs_Insert_Input>;
  on_conflict?: InputMaybe<Work_Order_Outputs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Work_Order_Outputs_OneArgs = {
  object: Work_Order_Outputs_Insert_Input;
  on_conflict?: InputMaybe<Work_Order_Outputs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Work_Order_RequestsArgs = {
  objects: Array<Work_Order_Requests_Insert_Input>;
  on_conflict?: InputMaybe<Work_Order_Requests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Work_Order_Requests_OneArgs = {
  object: Work_Order_Requests_Insert_Input;
  on_conflict?: InputMaybe<Work_Order_Requests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Work_Order_ReviewsArgs = {
  objects: Array<Work_Order_Reviews_Insert_Input>;
  on_conflict?: InputMaybe<Work_Order_Reviews_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Work_Order_Reviews_OneArgs = {
  object: Work_Order_Reviews_Insert_Input;
  on_conflict?: InputMaybe<Work_Order_Reviews_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Work_OrdersArgs = {
  objects: Array<Work_Orders_Insert_Input>;
  on_conflict?: InputMaybe<Work_Orders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Work_Orders_OneArgs = {
  object: Work_Orders_Insert_Input;
  on_conflict?: InputMaybe<Work_Orders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootManagerApprovesFoReelArgs = {
  foReelStagingId: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootManagerRejectsFoReelArgs = {
  foReelStagingId: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootMarkChatMessageAsReadArgs = {
  messageId: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootMarkChatThreadAsReadArgs = {
  threadId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootOnRequestKycArgs = {
  aadhar?: InputMaybe<Scalars['Boolean']['input']>;
  bank?: InputMaybe<Scalars['Boolean']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
  pan?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPf_Delete_Fcm_CropsArgs = {
  where: Pf_Fcm_Crops_Bool_Exp;
};


/** mutation root */
export type Mutation_RootPf_Delete_Fcm_Crops_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootPf_Delete_Fcm_ProductsArgs = {
  where: Pf_Fcm_Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootPf_Delete_Fcm_Products_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootPf_Delete_Plan_CardsArgs = {
  where: Pf_Plan_Cards_Bool_Exp;
};


/** mutation root */
export type Mutation_RootPf_Delete_Plan_Cards_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootPf_Delete_Runpando_Pro_Activity_Coins_FeedbackArgs = {
  where: Pf_Runpando_Pro_Activity_Coins_Feedback_Bool_Exp;
};


/** mutation root */
export type Mutation_RootPf_Delete_Runpando_Pro_Activity_Coins_Feedback_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootPf_Delete_Runpando_Pro_All_State_DataArgs = {
  where: Pf_Runpando_Pro_All_State_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootPf_Delete_Runpando_Pro_All_State_Data_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootPf_Delete_Runpando_Pro_Campaign_Card_ActivitiesArgs = {
  where: Pf_Runpando_Pro_Campaign_Card_Activities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootPf_Delete_Runpando_Pro_Campaign_Card_Activities_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootPf_Delete_Runpando_Pro_Channel_Card_ImagesArgs = {
  where: Pf_Runpando_Pro_Channel_Card_Images_Bool_Exp;
};


/** mutation root */
export type Mutation_RootPf_Delete_Runpando_Pro_Channel_Card_Images_By_PkArgs = {
  channel_card_image_id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootPf_Delete_Runpando_Pro_Users_LocationsArgs = {
  where: Pf_Runpando_Pro_Users_Locations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootPf_Delete_Runpando_Pro_Users_Locations_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootPf_Delete_UsersArgs = {
  where: Pf_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootPf_Delete_Users_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootPf_Insert_Fcm_CropsArgs = {
  objects: Array<Pf_Fcm_Crops_Insert_Input>;
  on_conflict?: InputMaybe<Pf_Fcm_Crops_On_Conflict>;
};


/** mutation root */
export type Mutation_RootPf_Insert_Fcm_Crops_OneArgs = {
  object: Pf_Fcm_Crops_Insert_Input;
  on_conflict?: InputMaybe<Pf_Fcm_Crops_On_Conflict>;
};


/** mutation root */
export type Mutation_RootPf_Insert_Fcm_ProductsArgs = {
  objects: Array<Pf_Fcm_Products_Insert_Input>;
  on_conflict?: InputMaybe<Pf_Fcm_Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootPf_Insert_Fcm_Products_OneArgs = {
  object: Pf_Fcm_Products_Insert_Input;
  on_conflict?: InputMaybe<Pf_Fcm_Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootPf_Insert_Plan_CardsArgs = {
  objects: Array<Pf_Plan_Cards_Insert_Input>;
  on_conflict?: InputMaybe<Pf_Plan_Cards_On_Conflict>;
};


/** mutation root */
export type Mutation_RootPf_Insert_Plan_Cards_OneArgs = {
  object: Pf_Plan_Cards_Insert_Input;
  on_conflict?: InputMaybe<Pf_Plan_Cards_On_Conflict>;
};


/** mutation root */
export type Mutation_RootPf_Insert_Runpando_Pro_Activity_Coins_FeedbackArgs = {
  objects: Array<Pf_Runpando_Pro_Activity_Coins_Feedback_Insert_Input>;
  on_conflict?: InputMaybe<Pf_Runpando_Pro_Activity_Coins_Feedback_On_Conflict>;
};


/** mutation root */
export type Mutation_RootPf_Insert_Runpando_Pro_Activity_Coins_Feedback_OneArgs = {
  object: Pf_Runpando_Pro_Activity_Coins_Feedback_Insert_Input;
  on_conflict?: InputMaybe<Pf_Runpando_Pro_Activity_Coins_Feedback_On_Conflict>;
};


/** mutation root */
export type Mutation_RootPf_Insert_Runpando_Pro_All_State_DataArgs = {
  objects: Array<Pf_Runpando_Pro_All_State_Data_Insert_Input>;
  on_conflict?: InputMaybe<Pf_Runpando_Pro_All_State_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootPf_Insert_Runpando_Pro_All_State_Data_OneArgs = {
  object: Pf_Runpando_Pro_All_State_Data_Insert_Input;
  on_conflict?: InputMaybe<Pf_Runpando_Pro_All_State_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootPf_Insert_Runpando_Pro_Campaign_Card_ActivitiesArgs = {
  objects: Array<Pf_Runpando_Pro_Campaign_Card_Activities_Insert_Input>;
  on_conflict?: InputMaybe<Pf_Runpando_Pro_Campaign_Card_Activities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootPf_Insert_Runpando_Pro_Campaign_Card_Activities_OneArgs = {
  object: Pf_Runpando_Pro_Campaign_Card_Activities_Insert_Input;
  on_conflict?: InputMaybe<Pf_Runpando_Pro_Campaign_Card_Activities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootPf_Insert_Runpando_Pro_Channel_Card_ImagesArgs = {
  objects: Array<Pf_Runpando_Pro_Channel_Card_Images_Insert_Input>;
  on_conflict?: InputMaybe<Pf_Runpando_Pro_Channel_Card_Images_On_Conflict>;
};


/** mutation root */
export type Mutation_RootPf_Insert_Runpando_Pro_Channel_Card_Images_OneArgs = {
  object: Pf_Runpando_Pro_Channel_Card_Images_Insert_Input;
  on_conflict?: InputMaybe<Pf_Runpando_Pro_Channel_Card_Images_On_Conflict>;
};


/** mutation root */
export type Mutation_RootPf_Insert_Runpando_Pro_Users_LocationsArgs = {
  objects: Array<Pf_Runpando_Pro_Users_Locations_Insert_Input>;
  on_conflict?: InputMaybe<Pf_Runpando_Pro_Users_Locations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootPf_Insert_Runpando_Pro_Users_Locations_OneArgs = {
  object: Pf_Runpando_Pro_Users_Locations_Insert_Input;
  on_conflict?: InputMaybe<Pf_Runpando_Pro_Users_Locations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootPf_Insert_UsersArgs = {
  objects: Array<Pf_Users_Insert_Input>;
  on_conflict?: InputMaybe<Pf_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootPf_Insert_Users_OneArgs = {
  object: Pf_Users_Insert_Input;
  on_conflict?: InputMaybe<Pf_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootPf_Update_Fcm_CropsArgs = {
  _inc?: InputMaybe<Pf_Fcm_Crops_Inc_Input>;
  _set?: InputMaybe<Pf_Fcm_Crops_Set_Input>;
  where: Pf_Fcm_Crops_Bool_Exp;
};


/** mutation root */
export type Mutation_RootPf_Update_Fcm_Crops_By_PkArgs = {
  _inc?: InputMaybe<Pf_Fcm_Crops_Inc_Input>;
  _set?: InputMaybe<Pf_Fcm_Crops_Set_Input>;
  pk_columns: Pf_Fcm_Crops_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootPf_Update_Fcm_Crops_ManyArgs = {
  updates: Array<Pf_Fcm_Crops_Updates>;
};


/** mutation root */
export type Mutation_RootPf_Update_Fcm_ProductsArgs = {
  _inc?: InputMaybe<Pf_Fcm_Products_Inc_Input>;
  _set?: InputMaybe<Pf_Fcm_Products_Set_Input>;
  where: Pf_Fcm_Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootPf_Update_Fcm_Products_By_PkArgs = {
  _inc?: InputMaybe<Pf_Fcm_Products_Inc_Input>;
  _set?: InputMaybe<Pf_Fcm_Products_Set_Input>;
  pk_columns: Pf_Fcm_Products_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootPf_Update_Fcm_Products_ManyArgs = {
  updates: Array<Pf_Fcm_Products_Updates>;
};


/** mutation root */
export type Mutation_RootPf_Update_Plan_CardsArgs = {
  _inc?: InputMaybe<Pf_Plan_Cards_Inc_Input>;
  _set?: InputMaybe<Pf_Plan_Cards_Set_Input>;
  where: Pf_Plan_Cards_Bool_Exp;
};


/** mutation root */
export type Mutation_RootPf_Update_Plan_Cards_By_PkArgs = {
  _inc?: InputMaybe<Pf_Plan_Cards_Inc_Input>;
  _set?: InputMaybe<Pf_Plan_Cards_Set_Input>;
  pk_columns: Pf_Plan_Cards_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootPf_Update_Plan_Cards_ManyArgs = {
  updates: Array<Pf_Plan_Cards_Updates>;
};


/** mutation root */
export type Mutation_RootPf_Update_Runpando_Pro_Activity_Coins_FeedbackArgs = {
  _inc?: InputMaybe<Pf_Runpando_Pro_Activity_Coins_Feedback_Inc_Input>;
  _set?: InputMaybe<Pf_Runpando_Pro_Activity_Coins_Feedback_Set_Input>;
  where: Pf_Runpando_Pro_Activity_Coins_Feedback_Bool_Exp;
};


/** mutation root */
export type Mutation_RootPf_Update_Runpando_Pro_Activity_Coins_Feedback_By_PkArgs = {
  _inc?: InputMaybe<Pf_Runpando_Pro_Activity_Coins_Feedback_Inc_Input>;
  _set?: InputMaybe<Pf_Runpando_Pro_Activity_Coins_Feedback_Set_Input>;
  pk_columns: Pf_Runpando_Pro_Activity_Coins_Feedback_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootPf_Update_Runpando_Pro_Activity_Coins_Feedback_ManyArgs = {
  updates: Array<Pf_Runpando_Pro_Activity_Coins_Feedback_Updates>;
};


/** mutation root */
export type Mutation_RootPf_Update_Runpando_Pro_All_State_DataArgs = {
  _inc?: InputMaybe<Pf_Runpando_Pro_All_State_Data_Inc_Input>;
  _set?: InputMaybe<Pf_Runpando_Pro_All_State_Data_Set_Input>;
  where: Pf_Runpando_Pro_All_State_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootPf_Update_Runpando_Pro_All_State_Data_By_PkArgs = {
  _inc?: InputMaybe<Pf_Runpando_Pro_All_State_Data_Inc_Input>;
  _set?: InputMaybe<Pf_Runpando_Pro_All_State_Data_Set_Input>;
  pk_columns: Pf_Runpando_Pro_All_State_Data_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootPf_Update_Runpando_Pro_All_State_Data_ManyArgs = {
  updates: Array<Pf_Runpando_Pro_All_State_Data_Updates>;
};


/** mutation root */
export type Mutation_RootPf_Update_Runpando_Pro_Campaign_Card_ActivitiesArgs = {
  _inc?: InputMaybe<Pf_Runpando_Pro_Campaign_Card_Activities_Inc_Input>;
  _set?: InputMaybe<Pf_Runpando_Pro_Campaign_Card_Activities_Set_Input>;
  where: Pf_Runpando_Pro_Campaign_Card_Activities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootPf_Update_Runpando_Pro_Campaign_Card_Activities_By_PkArgs = {
  _inc?: InputMaybe<Pf_Runpando_Pro_Campaign_Card_Activities_Inc_Input>;
  _set?: InputMaybe<Pf_Runpando_Pro_Campaign_Card_Activities_Set_Input>;
  pk_columns: Pf_Runpando_Pro_Campaign_Card_Activities_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootPf_Update_Runpando_Pro_Campaign_Card_Activities_ManyArgs = {
  updates: Array<Pf_Runpando_Pro_Campaign_Card_Activities_Updates>;
};


/** mutation root */
export type Mutation_RootPf_Update_Runpando_Pro_Channel_Card_ImagesArgs = {
  _inc?: InputMaybe<Pf_Runpando_Pro_Channel_Card_Images_Inc_Input>;
  _set?: InputMaybe<Pf_Runpando_Pro_Channel_Card_Images_Set_Input>;
  where: Pf_Runpando_Pro_Channel_Card_Images_Bool_Exp;
};


/** mutation root */
export type Mutation_RootPf_Update_Runpando_Pro_Channel_Card_Images_By_PkArgs = {
  _inc?: InputMaybe<Pf_Runpando_Pro_Channel_Card_Images_Inc_Input>;
  _set?: InputMaybe<Pf_Runpando_Pro_Channel_Card_Images_Set_Input>;
  pk_columns: Pf_Runpando_Pro_Channel_Card_Images_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootPf_Update_Runpando_Pro_Channel_Card_Images_ManyArgs = {
  updates: Array<Pf_Runpando_Pro_Channel_Card_Images_Updates>;
};


/** mutation root */
export type Mutation_RootPf_Update_Runpando_Pro_Users_LocationsArgs = {
  _inc?: InputMaybe<Pf_Runpando_Pro_Users_Locations_Inc_Input>;
  _set?: InputMaybe<Pf_Runpando_Pro_Users_Locations_Set_Input>;
  where: Pf_Runpando_Pro_Users_Locations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootPf_Update_Runpando_Pro_Users_Locations_By_PkArgs = {
  _inc?: InputMaybe<Pf_Runpando_Pro_Users_Locations_Inc_Input>;
  _set?: InputMaybe<Pf_Runpando_Pro_Users_Locations_Set_Input>;
  pk_columns: Pf_Runpando_Pro_Users_Locations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootPf_Update_Runpando_Pro_Users_Locations_ManyArgs = {
  updates: Array<Pf_Runpando_Pro_Users_Locations_Updates>;
};


/** mutation root */
export type Mutation_RootPf_Update_UsersArgs = {
  _inc?: InputMaybe<Pf_Users_Inc_Input>;
  _set?: InputMaybe<Pf_Users_Set_Input>;
  where: Pf_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootPf_Update_Users_By_PkArgs = {
  _inc?: InputMaybe<Pf_Users_Inc_Input>;
  _set?: InputMaybe<Pf_Users_Set_Input>;
  pk_columns: Pf_Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootPf_Update_Users_ManyArgs = {
  updates: Array<Pf_Users_Updates>;
};


/** mutation root */
export type Mutation_RootRegisterFreeTrialArgs = {
  request: RegisterCompanyRequestInput;
};


/** mutation root */
export type Mutation_RootRegisterFreelanceFieldOfficerArgs = {
  request: RegisterFreelanceFieldOfficerRequestInput;
};


/** mutation root */
export type Mutation_RootRegisterInfluencerArgs = {
  request: RegisterInfluencerRequestInput;
};


/** mutation root */
export type Mutation_RootRegisterRetailerArgs = {
  command: RetailerRegistrationCommandInput;
};


/** mutation root */
export type Mutation_RootReleaseMissedCallNumberToPoolArgs = {
  phoneNumber: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootRemoveChatParticipantArgs = {
  threadId: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootRemoveChatReactionArgs = {
  messageId: Scalars['Int']['input'];
  reaction?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootRemoveWarehouseUserArgs = {
  userId: Scalars['String']['input'];
  warehouseId: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootReorderProductImagesArgs = {
  imageIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productId: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootRequestOtpCommandArgs = {
  command: RequestOtpCommandInput;
};


/** mutation root */
export type Mutation_RootRequestRedemptionArgs = {
  amount: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootReserveMissedCallNumberArgs = {
  plan_id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootRestoreProductArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootS3UploadDataArgs = {
  expiresInSeconds?: InputMaybe<Scalars['Int']['input']>;
  key: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootSaveReelArgs = {
  command: SaveReelCommandInput;
};


/** mutation root */
export type Mutation_RootSendChatDataMessageArgs = {
  content?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  messageId: Scalars['String']['input'];
  messageType?: InputMaybe<Scalars['String']['input']>;
  threadId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootSendChatTextMessageArgs = {
  content?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  messageId: Scalars['String']['input'];
  threadId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootSendMessageOnProspectArgs = {
  prospectId: Scalars['String']['input'];
  textMessage: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootSendMessageOnServiceRequestArgs = {
  command: SendMessageOnServiceRequestCommandInput;
};


/** mutation root */
export type Mutation_RootSendMessageOnServiceRequestFprArgs = {
  fprId: Scalars['String']['input'];
  textMessage: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootSendMessageOnWorkOrderArgs = {
  textMessage: Scalars['String']['input'];
  workOrderRequestId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootSetChatThreadMutedArgs = {
  muted: Scalars['Boolean']['input'];
  threadId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootSetContentLanguagesArgs = {
  command: UserUpdatesContentLanguagesInput;
};


/** mutation root */
export type Mutation_RootSetFieldForceLocationArgs = {
  command: FieldPartnerUpdatesHisLocationInput;
};


/** mutation root */
export type Mutation_RootSetRoleCommandArgs = {
  command: SetRoleCommandInput;
};


/** mutation root */
export type Mutation_RootSuperAdminAcceptsOnboardingArgs = {
  onboardingId: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootSuperAdminRejectsOnboardingArgs = {
  onboardingId: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootTransferInventoryArgs = {
  destinationWarehouseId: Scalars['Int']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  productId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  sourceWarehouseId: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootUnSaveReelArgs = {
  command: UnSaveReelCommandInput;
};


/** mutation root */
export type Mutation_RootUpdateCategoryArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};


/** mutation root */
export type Mutation_RootUpdateChannelDetailsArgs = {
  request: UpdateChannelDescriptionRequestInput;
};


/** mutation root */
export type Mutation_RootUpdateInventoryArgs = {
  inventoryId: Scalars['Int']['input'];
  maxStockLevel?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  reorderLevel?: InputMaybe<Scalars['Int']['input']>;
  reservedQuantity?: InputMaybe<Scalars['Int']['input']>;
};


/** mutation root */
export type Mutation_RootUpdateMyCropsArgs = {
  cropIds: Array<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootUpdateProductArgs = {
  basePrice?: InputMaybe<Scalars['Float']['input']>;
  categoryIds?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dimensions?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['Int']['input'];
  metaData?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};


/** mutation root */
export type Mutation_RootUpdateProductImageArgs = {
  altText?: InputMaybe<Scalars['String']['input']>;
  imageId: Scalars['Int']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};


/** mutation root */
export type Mutation_RootUpdateProductPopArgs = {
  id: Scalars['String']['input'];
  input: UpdateProductPopInput;
};


/** mutation root */
export type Mutation_RootUpdateUserChatPresenceArgs = {
  threadId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootUpdateWarehouseArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contactInfo?: InputMaybe<Scalars['JSON']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pincode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootUpdate_Account_Auth_KeyArgs = {
  _inc?: InputMaybe<Account_Auth_Key_Inc_Input>;
  _set?: InputMaybe<Account_Auth_Key_Set_Input>;
  where: Account_Auth_Key_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Account_Auth_Key_By_PkArgs = {
  _inc?: InputMaybe<Account_Auth_Key_Inc_Input>;
  _set?: InputMaybe<Account_Auth_Key_Set_Input>;
  pk_columns: Account_Auth_Key_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Account_Auth_Key_ManyArgs = {
  updates: Array<Account_Auth_Key_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Account_CropArgs = {
  _inc?: InputMaybe<Account_Crop_Inc_Input>;
  _set?: InputMaybe<Account_Crop_Set_Input>;
  where: Account_Crop_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Account_Crop_By_PkArgs = {
  _inc?: InputMaybe<Account_Crop_Inc_Input>;
  _set?: InputMaybe<Account_Crop_Set_Input>;
  pk_columns: Account_Crop_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Account_Crop_ManyArgs = {
  updates: Array<Account_Crop_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Account_SegmentArgs = {
  _inc?: InputMaybe<Account_Segment_Inc_Input>;
  _set?: InputMaybe<Account_Segment_Set_Input>;
  where: Account_Segment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Account_Segment_By_PkArgs = {
  _inc?: InputMaybe<Account_Segment_Inc_Input>;
  _set?: InputMaybe<Account_Segment_Set_Input>;
  pk_columns: Account_Segment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Account_Segment_ManyArgs = {
  updates: Array<Account_Segment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Account_UserArgs = {
  _inc?: InputMaybe<Account_User_Inc_Input>;
  _set?: InputMaybe<Account_User_Set_Input>;
  where: Account_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Account_User_By_PkArgs = {
  _inc?: InputMaybe<Account_User_Inc_Input>;
  _set?: InputMaybe<Account_User_Set_Input>;
  pk_columns: Account_User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Account_User_ManyArgs = {
  updates: Array<Account_User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AccountsArgs = {
  _inc?: InputMaybe<Accounts_Inc_Input>;
  _set?: InputMaybe<Accounts_Set_Input>;
  where: Accounts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Accounts_By_PkArgs = {
  _inc?: InputMaybe<Accounts_Inc_Input>;
  _set?: InputMaybe<Accounts_Set_Input>;
  pk_columns: Accounts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Accounts_ManyArgs = {
  updates: Array<Accounts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Action_EventsArgs = {
  _inc?: InputMaybe<Action_Events_Inc_Input>;
  _set?: InputMaybe<Action_Events_Set_Input>;
  where: Action_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Action_Events_By_PkArgs = {
  _inc?: InputMaybe<Action_Events_Inc_Input>;
  _set?: InputMaybe<Action_Events_Set_Input>;
  pk_columns: Action_Events_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Action_Events_ManyArgs = {
  updates: Array<Action_Events_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_BalancesArgs = {
  _inc?: InputMaybe<Balances_Inc_Input>;
  _set?: InputMaybe<Balances_Set_Input>;
  where: Balances_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Balances_By_PkArgs = {
  _inc?: InputMaybe<Balances_Inc_Input>;
  _set?: InputMaybe<Balances_Set_Input>;
  pk_columns: Balances_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Balances_ManyArgs = {
  updates: Array<Balances_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Channel_LinksArgs = {
  _append?: InputMaybe<Channel_Links_Append_Input>;
  _delete_at_path?: InputMaybe<Channel_Links_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Channel_Links_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Channel_Links_Delete_Key_Input>;
  _inc?: InputMaybe<Channel_Links_Inc_Input>;
  _prepend?: InputMaybe<Channel_Links_Prepend_Input>;
  _set?: InputMaybe<Channel_Links_Set_Input>;
  where: Channel_Links_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Channel_Links_By_PkArgs = {
  _append?: InputMaybe<Channel_Links_Append_Input>;
  _delete_at_path?: InputMaybe<Channel_Links_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Channel_Links_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Channel_Links_Delete_Key_Input>;
  _inc?: InputMaybe<Channel_Links_Inc_Input>;
  _prepend?: InputMaybe<Channel_Links_Prepend_Input>;
  _set?: InputMaybe<Channel_Links_Set_Input>;
  pk_columns: Channel_Links_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Channel_Links_ManyArgs = {
  updates: Array<Channel_Links_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ChannelsArgs = {
  _append?: InputMaybe<Channels_Append_Input>;
  _delete_at_path?: InputMaybe<Channels_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Channels_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Channels_Delete_Key_Input>;
  _inc?: InputMaybe<Channels_Inc_Input>;
  _prepend?: InputMaybe<Channels_Prepend_Input>;
  _set?: InputMaybe<Channels_Set_Input>;
  where: Channels_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Channels_By_PkArgs = {
  _append?: InputMaybe<Channels_Append_Input>;
  _delete_at_path?: InputMaybe<Channels_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Channels_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Channels_Delete_Key_Input>;
  _inc?: InputMaybe<Channels_Inc_Input>;
  _prepend?: InputMaybe<Channels_Prepend_Input>;
  _set?: InputMaybe<Channels_Set_Input>;
  pk_columns: Channels_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Channels_ManyArgs = {
  updates: Array<Channels_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_MessagesArgs = {
  _set?: InputMaybe<Chat_Messages_Set_Input>;
  where: Chat_Messages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_Messages_By_PkArgs = {
  _set?: InputMaybe<Chat_Messages_Set_Input>;
  pk_columns: Chat_Messages_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_Messages_ManyArgs = {
  updates: Array<Chat_Messages_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_ParticipantsArgs = {
  _set?: InputMaybe<Chat_Participants_Set_Input>;
  where: Chat_Participants_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_Participants_By_PkArgs = {
  _set?: InputMaybe<Chat_Participants_Set_Input>;
  pk_columns: Chat_Participants_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_Participants_ManyArgs = {
  updates: Array<Chat_Participants_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_ThreadsArgs = {
  _append?: InputMaybe<Chat_Threads_Append_Input>;
  _delete_at_path?: InputMaybe<Chat_Threads_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Chat_Threads_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Chat_Threads_Delete_Key_Input>;
  _prepend?: InputMaybe<Chat_Threads_Prepend_Input>;
  _set?: InputMaybe<Chat_Threads_Set_Input>;
  where: Chat_Threads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_Threads_By_PkArgs = {
  _append?: InputMaybe<Chat_Threads_Append_Input>;
  _delete_at_path?: InputMaybe<Chat_Threads_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Chat_Threads_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Chat_Threads_Delete_Key_Input>;
  _prepend?: InputMaybe<Chat_Threads_Prepend_Input>;
  _set?: InputMaybe<Chat_Threads_Set_Input>;
  pk_columns: Chat_Threads_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_Threads_ManyArgs = {
  updates: Array<Chat_Threads_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CompaniesArgs = {
  _inc?: InputMaybe<Companies_Inc_Input>;
  _set?: InputMaybe<Companies_Set_Input>;
  where: Companies_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Companies_By_PkArgs = {
  _inc?: InputMaybe<Companies_Inc_Input>;
  _set?: InputMaybe<Companies_Set_Input>;
  pk_columns: Companies_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Companies_ManyArgs = {
  updates: Array<Companies_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Creator_OnboardingArgs = {
  _inc?: InputMaybe<Creator_Onboarding_Inc_Input>;
  _set?: InputMaybe<Creator_Onboarding_Set_Input>;
  where: Creator_Onboarding_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Creator_Onboarding_By_PkArgs = {
  _inc?: InputMaybe<Creator_Onboarding_Inc_Input>;
  _set?: InputMaybe<Creator_Onboarding_Set_Input>;
  pk_columns: Creator_Onboarding_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Creator_Onboarding_ManyArgs = {
  updates: Array<Creator_Onboarding_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Crm_SegmentsArgs = {
  _append?: InputMaybe<Crm_Segments_Append_Input>;
  _delete_at_path?: InputMaybe<Crm_Segments_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Crm_Segments_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Crm_Segments_Delete_Key_Input>;
  _inc?: InputMaybe<Crm_Segments_Inc_Input>;
  _prepend?: InputMaybe<Crm_Segments_Prepend_Input>;
  _set?: InputMaybe<Crm_Segments_Set_Input>;
  where: Crm_Segments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Crm_Segments_By_PkArgs = {
  _append?: InputMaybe<Crm_Segments_Append_Input>;
  _delete_at_path?: InputMaybe<Crm_Segments_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Crm_Segments_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Crm_Segments_Delete_Key_Input>;
  _inc?: InputMaybe<Crm_Segments_Inc_Input>;
  _prepend?: InputMaybe<Crm_Segments_Prepend_Input>;
  _set?: InputMaybe<Crm_Segments_Set_Input>;
  pk_columns: Crm_Segments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Crm_Segments_ManyArgs = {
  updates: Array<Crm_Segments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_UserArgs = {
  _inc?: InputMaybe<Crop_User_Inc_Input>;
  _set?: InputMaybe<Crop_User_Set_Input>;
  where: Crop_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_User_By_PkArgs = {
  _inc?: InputMaybe<Crop_User_Inc_Input>;
  _set?: InputMaybe<Crop_User_Set_Input>;
  pk_columns: Crop_User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_User_ManyArgs = {
  updates: Array<Crop_User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Failed_JobsArgs = {
  _inc?: InputMaybe<Failed_Jobs_Inc_Input>;
  _set?: InputMaybe<Failed_Jobs_Set_Input>;
  where: Failed_Jobs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Failed_Jobs_By_PkArgs = {
  _inc?: InputMaybe<Failed_Jobs_Inc_Input>;
  _set?: InputMaybe<Failed_Jobs_Set_Input>;
  pk_columns: Failed_Jobs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Failed_Jobs_ManyArgs = {
  updates: Array<Failed_Jobs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Farmer_Account_LocationsArgs = {
  _inc?: InputMaybe<Farmer_Account_Locations_Inc_Input>;
  _set?: InputMaybe<Farmer_Account_Locations_Set_Input>;
  where: Farmer_Account_Locations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Farmer_Account_Locations_By_PkArgs = {
  _inc?: InputMaybe<Farmer_Account_Locations_Inc_Input>;
  _set?: InputMaybe<Farmer_Account_Locations_Set_Input>;
  pk_columns: Farmer_Account_Locations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Farmer_Account_Locations_ManyArgs = {
  updates: Array<Farmer_Account_Locations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Farmer_AccountsArgs = {
  _append?: InputMaybe<Farmer_Accounts_Append_Input>;
  _delete_at_path?: InputMaybe<Farmer_Accounts_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Farmer_Accounts_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Farmer_Accounts_Delete_Key_Input>;
  _inc?: InputMaybe<Farmer_Accounts_Inc_Input>;
  _prepend?: InputMaybe<Farmer_Accounts_Prepend_Input>;
  _set?: InputMaybe<Farmer_Accounts_Set_Input>;
  where: Farmer_Accounts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Farmer_Accounts_By_PkArgs = {
  _append?: InputMaybe<Farmer_Accounts_Append_Input>;
  _delete_at_path?: InputMaybe<Farmer_Accounts_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Farmer_Accounts_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Farmer_Accounts_Delete_Key_Input>;
  _inc?: InputMaybe<Farmer_Accounts_Inc_Input>;
  _prepend?: InputMaybe<Farmer_Accounts_Prepend_Input>;
  _set?: InputMaybe<Farmer_Accounts_Set_Input>;
  pk_columns: Farmer_Accounts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Farmer_Accounts_ManyArgs = {
  updates: Array<Farmer_Accounts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Farmer_ActionsArgs = {
  _append?: InputMaybe<Farmer_Actions_Append_Input>;
  _delete_at_path?: InputMaybe<Farmer_Actions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Farmer_Actions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Farmer_Actions_Delete_Key_Input>;
  _inc?: InputMaybe<Farmer_Actions_Inc_Input>;
  _prepend?: InputMaybe<Farmer_Actions_Prepend_Input>;
  _set?: InputMaybe<Farmer_Actions_Set_Input>;
  where: Farmer_Actions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Farmer_Actions_By_PkArgs = {
  _append?: InputMaybe<Farmer_Actions_Append_Input>;
  _delete_at_path?: InputMaybe<Farmer_Actions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Farmer_Actions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Farmer_Actions_Delete_Key_Input>;
  _inc?: InputMaybe<Farmer_Actions_Inc_Input>;
  _prepend?: InputMaybe<Farmer_Actions_Prepend_Input>;
  _set?: InputMaybe<Farmer_Actions_Set_Input>;
  pk_columns: Farmer_Actions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Farmer_Actions_ManyArgs = {
  updates: Array<Farmer_Actions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Farmer_FieldsArgs = {
  _inc?: InputMaybe<Farmer_Fields_Inc_Input>;
  _set?: InputMaybe<Farmer_Fields_Set_Input>;
  where: Farmer_Fields_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Farmer_Fields_By_PkArgs = {
  _inc?: InputMaybe<Farmer_Fields_Inc_Input>;
  _set?: InputMaybe<Farmer_Fields_Set_Input>;
  pk_columns: Farmer_Fields_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Farmer_Fields_ManyArgs = {
  updates: Array<Farmer_Fields_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Farmer_MasterArgs = {
  _set?: InputMaybe<Farmer_Master_Set_Input>;
  where: Farmer_Master_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Farmer_Master_By_PkArgs = {
  _set?: InputMaybe<Farmer_Master_Set_Input>;
  pk_columns: Farmer_Master_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Farmer_Master_ManyArgs = {
  updates: Array<Farmer_Master_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Farmer_Nearby_Field_ForceArgs = {
  _set?: InputMaybe<Farmer_Nearby_Field_Force_Set_Input>;
  where: Farmer_Nearby_Field_Force_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Farmer_Nearby_Field_Force_By_PkArgs = {
  _set?: InputMaybe<Farmer_Nearby_Field_Force_Set_Input>;
  pk_columns: Farmer_Nearby_Field_Force_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Farmer_Nearby_Field_Force_ManyArgs = {
  updates: Array<Farmer_Nearby_Field_Force_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Farmer_PlotsArgs = {
  _inc?: InputMaybe<Farmer_Plots_Inc_Input>;
  _set?: InputMaybe<Farmer_Plots_Set_Input>;
  where: Farmer_Plots_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Farmer_Plots_By_PkArgs = {
  _inc?: InputMaybe<Farmer_Plots_Inc_Input>;
  _set?: InputMaybe<Farmer_Plots_Set_Input>;
  pk_columns: Farmer_Plots_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Farmer_Plots_ManyArgs = {
  updates: Array<Farmer_Plots_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Farminsta_LinksArgs = {
  _inc?: InputMaybe<Farminsta_Links_Inc_Input>;
  _set?: InputMaybe<Farminsta_Links_Set_Input>;
  where: Farminsta_Links_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Farminsta_Links_By_PkArgs = {
  _inc?: InputMaybe<Farminsta_Links_Inc_Input>;
  _set?: InputMaybe<Farminsta_Links_Set_Input>;
  pk_columns: Farminsta_Links_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Farminsta_Links_ManyArgs = {
  updates: Array<Farminsta_Links_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FeaturesArgs = {
  _inc?: InputMaybe<Features_Inc_Input>;
  _set?: InputMaybe<Features_Set_Input>;
  where: Features_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Features_By_PkArgs = {
  _inc?: InputMaybe<Features_Inc_Input>;
  _set?: InputMaybe<Features_Set_Input>;
  pk_columns: Features_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Features_ManyArgs = {
  updates: Array<Features_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Field_Partner_Response_EventsArgs = {
  _append?: InputMaybe<Field_Partner_Response_Events_Append_Input>;
  _delete_at_path?: InputMaybe<Field_Partner_Response_Events_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Field_Partner_Response_Events_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Field_Partner_Response_Events_Delete_Key_Input>;
  _prepend?: InputMaybe<Field_Partner_Response_Events_Prepend_Input>;
  _set?: InputMaybe<Field_Partner_Response_Events_Set_Input>;
  where: Field_Partner_Response_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Field_Partner_Response_Events_By_PkArgs = {
  _append?: InputMaybe<Field_Partner_Response_Events_Append_Input>;
  _delete_at_path?: InputMaybe<Field_Partner_Response_Events_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Field_Partner_Response_Events_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Field_Partner_Response_Events_Delete_Key_Input>;
  _prepend?: InputMaybe<Field_Partner_Response_Events_Prepend_Input>;
  _set?: InputMaybe<Field_Partner_Response_Events_Set_Input>;
  pk_columns: Field_Partner_Response_Events_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Field_Partner_Response_Events_ManyArgs = {
  updates: Array<Field_Partner_Response_Events_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Field_Partner_Response_MessagesArgs = {
  _append?: InputMaybe<Field_Partner_Response_Messages_Append_Input>;
  _delete_at_path?: InputMaybe<Field_Partner_Response_Messages_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Field_Partner_Response_Messages_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Field_Partner_Response_Messages_Delete_Key_Input>;
  _prepend?: InputMaybe<Field_Partner_Response_Messages_Prepend_Input>;
  _set?: InputMaybe<Field_Partner_Response_Messages_Set_Input>;
  where: Field_Partner_Response_Messages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Field_Partner_Response_Messages_By_PkArgs = {
  _append?: InputMaybe<Field_Partner_Response_Messages_Append_Input>;
  _delete_at_path?: InputMaybe<Field_Partner_Response_Messages_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Field_Partner_Response_Messages_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Field_Partner_Response_Messages_Delete_Key_Input>;
  _prepend?: InputMaybe<Field_Partner_Response_Messages_Prepend_Input>;
  _set?: InputMaybe<Field_Partner_Response_Messages_Set_Input>;
  pk_columns: Field_Partner_Response_Messages_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Field_Partner_Response_Messages_ManyArgs = {
  updates: Array<Field_Partner_Response_Messages_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Field_Partner_ResponsesArgs = {
  _inc?: InputMaybe<Field_Partner_Responses_Inc_Input>;
  _set?: InputMaybe<Field_Partner_Responses_Set_Input>;
  where: Field_Partner_Responses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Field_Partner_Responses_By_PkArgs = {
  _inc?: InputMaybe<Field_Partner_Responses_Inc_Input>;
  _set?: InputMaybe<Field_Partner_Responses_Set_Input>;
  pk_columns: Field_Partner_Responses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Field_Partner_Responses_ManyArgs = {
  updates: Array<Field_Partner_Responses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Field_Scheduled_VisitsArgs = {
  _append?: InputMaybe<Field_Scheduled_Visits_Append_Input>;
  _delete_at_path?: InputMaybe<Field_Scheduled_Visits_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Field_Scheduled_Visits_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Field_Scheduled_Visits_Delete_Key_Input>;
  _inc?: InputMaybe<Field_Scheduled_Visits_Inc_Input>;
  _prepend?: InputMaybe<Field_Scheduled_Visits_Prepend_Input>;
  _set?: InputMaybe<Field_Scheduled_Visits_Set_Input>;
  where: Field_Scheduled_Visits_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Field_Scheduled_Visits_By_PkArgs = {
  _append?: InputMaybe<Field_Scheduled_Visits_Append_Input>;
  _delete_at_path?: InputMaybe<Field_Scheduled_Visits_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Field_Scheduled_Visits_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Field_Scheduled_Visits_Delete_Key_Input>;
  _inc?: InputMaybe<Field_Scheduled_Visits_Inc_Input>;
  _prepend?: InputMaybe<Field_Scheduled_Visits_Prepend_Input>;
  _set?: InputMaybe<Field_Scheduled_Visits_Set_Input>;
  pk_columns: Field_Scheduled_Visits_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Field_Scheduled_Visits_ManyArgs = {
  updates: Array<Field_Scheduled_Visits_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Fo_Reels_StagingArgs = {
  _append?: InputMaybe<Fo_Reels_Staging_Append_Input>;
  _delete_at_path?: InputMaybe<Fo_Reels_Staging_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Fo_Reels_Staging_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Fo_Reels_Staging_Delete_Key_Input>;
  _inc?: InputMaybe<Fo_Reels_Staging_Inc_Input>;
  _prepend?: InputMaybe<Fo_Reels_Staging_Prepend_Input>;
  _set?: InputMaybe<Fo_Reels_Staging_Set_Input>;
  where: Fo_Reels_Staging_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Fo_Reels_Staging_By_PkArgs = {
  _append?: InputMaybe<Fo_Reels_Staging_Append_Input>;
  _delete_at_path?: InputMaybe<Fo_Reels_Staging_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Fo_Reels_Staging_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Fo_Reels_Staging_Delete_Key_Input>;
  _inc?: InputMaybe<Fo_Reels_Staging_Inc_Input>;
  _prepend?: InputMaybe<Fo_Reels_Staging_Prepend_Input>;
  _set?: InputMaybe<Fo_Reels_Staging_Set_Input>;
  pk_columns: Fo_Reels_Staging_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Fo_Reels_Staging_ManyArgs = {
  updates: Array<Fo_Reels_Staging_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FollowsArgs = {
  _inc?: InputMaybe<Follows_Inc_Input>;
  _set?: InputMaybe<Follows_Set_Input>;
  where: Follows_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Follows_By_PkArgs = {
  _inc?: InputMaybe<Follows_Inc_Input>;
  _set?: InputMaybe<Follows_Set_Input>;
  pk_columns: Follows_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Follows_ManyArgs = {
  updates: Array<Follows_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Geometry_ColumnsArgs = {
  _inc?: InputMaybe<Geometry_Columns_Inc_Input>;
  _set?: InputMaybe<Geometry_Columns_Set_Input>;
  where: Geometry_Columns_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Geometry_Columns_ManyArgs = {
  updates: Array<Geometry_Columns_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Gig_FaqsArgs = {
  _set?: InputMaybe<Gig_Faqs_Set_Input>;
  where: Gig_Faqs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Gig_Faqs_By_PkArgs = {
  _set?: InputMaybe<Gig_Faqs_Set_Input>;
  pk_columns: Gig_Faqs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Gig_Faqs_ManyArgs = {
  updates: Array<Gig_Faqs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Gig_PromosArgs = {
  _inc?: InputMaybe<Gig_Promos_Inc_Input>;
  _set?: InputMaybe<Gig_Promos_Set_Input>;
  where: Gig_Promos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Gig_Promos_By_PkArgs = {
  _inc?: InputMaybe<Gig_Promos_Inc_Input>;
  _set?: InputMaybe<Gig_Promos_Set_Input>;
  pk_columns: Gig_Promos_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Gig_Promos_ManyArgs = {
  updates: Array<Gig_Promos_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Gig_VariantsArgs = {
  _append?: InputMaybe<Gig_Variants_Append_Input>;
  _delete_at_path?: InputMaybe<Gig_Variants_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Gig_Variants_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Gig_Variants_Delete_Key_Input>;
  _inc?: InputMaybe<Gig_Variants_Inc_Input>;
  _prepend?: InputMaybe<Gig_Variants_Prepend_Input>;
  _set?: InputMaybe<Gig_Variants_Set_Input>;
  where: Gig_Variants_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Gig_Variants_By_PkArgs = {
  _append?: InputMaybe<Gig_Variants_Append_Input>;
  _delete_at_path?: InputMaybe<Gig_Variants_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Gig_Variants_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Gig_Variants_Delete_Key_Input>;
  _inc?: InputMaybe<Gig_Variants_Inc_Input>;
  _prepend?: InputMaybe<Gig_Variants_Prepend_Input>;
  _set?: InputMaybe<Gig_Variants_Set_Input>;
  pk_columns: Gig_Variants_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Gig_Variants_ManyArgs = {
  updates: Array<Gig_Variants_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_GigsArgs = {
  _append?: InputMaybe<Gigs_Append_Input>;
  _delete_at_path?: InputMaybe<Gigs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Gigs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Gigs_Delete_Key_Input>;
  _inc?: InputMaybe<Gigs_Inc_Input>;
  _prepend?: InputMaybe<Gigs_Prepend_Input>;
  _set?: InputMaybe<Gigs_Set_Input>;
  where: Gigs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Gigs_By_PkArgs = {
  _append?: InputMaybe<Gigs_Append_Input>;
  _delete_at_path?: InputMaybe<Gigs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Gigs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Gigs_Delete_Key_Input>;
  _inc?: InputMaybe<Gigs_Inc_Input>;
  _prepend?: InputMaybe<Gigs_Prepend_Input>;
  _set?: InputMaybe<Gigs_Set_Input>;
  pk_columns: Gigs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Gigs_ManyArgs = {
  updates: Array<Gigs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Gis_DistrictsArgs = {
  _inc?: InputMaybe<Gis_Districts_Inc_Input>;
  _set?: InputMaybe<Gis_Districts_Set_Input>;
  where: Gis_Districts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Gis_Districts_By_PkArgs = {
  _inc?: InputMaybe<Gis_Districts_Inc_Input>;
  _set?: InputMaybe<Gis_Districts_Set_Input>;
  pk_columns: Gis_Districts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Gis_Districts_ManyArgs = {
  updates: Array<Gis_Districts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Gis_StatesArgs = {
  _inc?: InputMaybe<Gis_States_Inc_Input>;
  _set?: InputMaybe<Gis_States_Set_Input>;
  where: Gis_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Gis_States_By_PkArgs = {
  _inc?: InputMaybe<Gis_States_Inc_Input>;
  _set?: InputMaybe<Gis_States_Set_Input>;
  pk_columns: Gis_States_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Gis_States_ManyArgs = {
  updates: Array<Gis_States_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Last_Known_LocationsArgs = {
  _append?: InputMaybe<Last_Known_Locations_Append_Input>;
  _delete_at_path?: InputMaybe<Last_Known_Locations_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Last_Known_Locations_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Last_Known_Locations_Delete_Key_Input>;
  _inc?: InputMaybe<Last_Known_Locations_Inc_Input>;
  _prepend?: InputMaybe<Last_Known_Locations_Prepend_Input>;
  _set?: InputMaybe<Last_Known_Locations_Set_Input>;
  where: Last_Known_Locations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Last_Known_Locations_By_PkArgs = {
  _append?: InputMaybe<Last_Known_Locations_Append_Input>;
  _delete_at_path?: InputMaybe<Last_Known_Locations_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Last_Known_Locations_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Last_Known_Locations_Delete_Key_Input>;
  _inc?: InputMaybe<Last_Known_Locations_Inc_Input>;
  _prepend?: InputMaybe<Last_Known_Locations_Prepend_Input>;
  _set?: InputMaybe<Last_Known_Locations_Set_Input>;
  pk_columns: Last_Known_Locations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Last_Known_Locations_ManyArgs = {
  updates: Array<Last_Known_Locations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Master_CropsArgs = {
  _inc?: InputMaybe<Master_Crops_Inc_Input>;
  _set?: InputMaybe<Master_Crops_Set_Input>;
  where: Master_Crops_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Master_Crops_By_PkArgs = {
  _inc?: InputMaybe<Master_Crops_Inc_Input>;
  _set?: InputMaybe<Master_Crops_Set_Input>;
  pk_columns: Master_Crops_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Master_Crops_ManyArgs = {
  updates: Array<Master_Crops_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Master_SegmentsArgs = {
  _inc?: InputMaybe<Master_Segments_Inc_Input>;
  _set?: InputMaybe<Master_Segments_Set_Input>;
  where: Master_Segments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Master_Segments_By_PkArgs = {
  _inc?: InputMaybe<Master_Segments_Inc_Input>;
  _set?: InputMaybe<Master_Segments_Set_Input>;
  pk_columns: Master_Segments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Master_Segments_ManyArgs = {
  updates: Array<Master_Segments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Messaging_Campaign_RecipientsArgs = {
  _set?: InputMaybe<Messaging_Campaign_Recipients_Set_Input>;
  where: Messaging_Campaign_Recipients_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Messaging_Campaign_Recipients_By_PkArgs = {
  _set?: InputMaybe<Messaging_Campaign_Recipients_Set_Input>;
  pk_columns: Messaging_Campaign_Recipients_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Messaging_Campaign_Recipients_ManyArgs = {
  updates: Array<Messaging_Campaign_Recipients_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Messaging_Campaign_SegmentsArgs = {
  _set?: InputMaybe<Messaging_Campaign_Segments_Set_Input>;
  where: Messaging_Campaign_Segments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Messaging_Campaign_Segments_By_PkArgs = {
  _set?: InputMaybe<Messaging_Campaign_Segments_Set_Input>;
  pk_columns: Messaging_Campaign_Segments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Messaging_Campaign_Segments_ManyArgs = {
  updates: Array<Messaging_Campaign_Segments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Messaging_CampaignsArgs = {
  _append?: InputMaybe<Messaging_Campaigns_Append_Input>;
  _delete_at_path?: InputMaybe<Messaging_Campaigns_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Messaging_Campaigns_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Messaging_Campaigns_Delete_Key_Input>;
  _prepend?: InputMaybe<Messaging_Campaigns_Prepend_Input>;
  _set?: InputMaybe<Messaging_Campaigns_Set_Input>;
  where: Messaging_Campaigns_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Messaging_Campaigns_By_PkArgs = {
  _append?: InputMaybe<Messaging_Campaigns_Append_Input>;
  _delete_at_path?: InputMaybe<Messaging_Campaigns_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Messaging_Campaigns_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Messaging_Campaigns_Delete_Key_Input>;
  _prepend?: InputMaybe<Messaging_Campaigns_Prepend_Input>;
  _set?: InputMaybe<Messaging_Campaigns_Set_Input>;
  pk_columns: Messaging_Campaigns_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Messaging_Campaigns_ManyArgs = {
  updates: Array<Messaging_Campaigns_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Messaging_TemplatesArgs = {
  _append?: InputMaybe<Messaging_Templates_Append_Input>;
  _delete_at_path?: InputMaybe<Messaging_Templates_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Messaging_Templates_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Messaging_Templates_Delete_Key_Input>;
  _prepend?: InputMaybe<Messaging_Templates_Prepend_Input>;
  _set?: InputMaybe<Messaging_Templates_Set_Input>;
  where: Messaging_Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Messaging_Templates_By_PkArgs = {
  _append?: InputMaybe<Messaging_Templates_Append_Input>;
  _delete_at_path?: InputMaybe<Messaging_Templates_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Messaging_Templates_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Messaging_Templates_Delete_Key_Input>;
  _prepend?: InputMaybe<Messaging_Templates_Prepend_Input>;
  _set?: InputMaybe<Messaging_Templates_Set_Input>;
  pk_columns: Messaging_Templates_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Messaging_Templates_ManyArgs = {
  updates: Array<Messaging_Templates_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MigrationsArgs = {
  _inc?: InputMaybe<Migrations_Inc_Input>;
  _set?: InputMaybe<Migrations_Set_Input>;
  where: Migrations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Migrations_By_PkArgs = {
  _inc?: InputMaybe<Migrations_Inc_Input>;
  _set?: InputMaybe<Migrations_Set_Input>;
  pk_columns: Migrations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Migrations_ManyArgs = {
  updates: Array<Migrations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Missed_Call_Number_PoolArgs = {
  _inc?: InputMaybe<Missed_Call_Number_Pool_Inc_Input>;
  _set?: InputMaybe<Missed_Call_Number_Pool_Set_Input>;
  where: Missed_Call_Number_Pool_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Missed_Call_Number_Pool_By_PkArgs = {
  _inc?: InputMaybe<Missed_Call_Number_Pool_Inc_Input>;
  _set?: InputMaybe<Missed_Call_Number_Pool_Set_Input>;
  pk_columns: Missed_Call_Number_Pool_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Missed_Call_Number_Pool_ManyArgs = {
  updates: Array<Missed_Call_Number_Pool_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Missed_CallsArgs = {
  _inc?: InputMaybe<Missed_Calls_Inc_Input>;
  _set?: InputMaybe<Missed_Calls_Set_Input>;
  where: Missed_Calls_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Missed_Calls_By_PkArgs = {
  _inc?: InputMaybe<Missed_Calls_Inc_Input>;
  _set?: InputMaybe<Missed_Calls_Set_Input>;
  pk_columns: Missed_Calls_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Missed_Calls_ManyArgs = {
  updates: Array<Missed_Calls_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Model_Has_PermissionsArgs = {
  _inc?: InputMaybe<Model_Has_Permissions_Inc_Input>;
  _set?: InputMaybe<Model_Has_Permissions_Set_Input>;
  where: Model_Has_Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Model_Has_Permissions_By_PkArgs = {
  _inc?: InputMaybe<Model_Has_Permissions_Inc_Input>;
  _set?: InputMaybe<Model_Has_Permissions_Set_Input>;
  pk_columns: Model_Has_Permissions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Model_Has_Permissions_ManyArgs = {
  updates: Array<Model_Has_Permissions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Model_Has_RolesArgs = {
  _inc?: InputMaybe<Model_Has_Roles_Inc_Input>;
  _set?: InputMaybe<Model_Has_Roles_Set_Input>;
  where: Model_Has_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Model_Has_Roles_By_PkArgs = {
  _inc?: InputMaybe<Model_Has_Roles_Inc_Input>;
  _set?: InputMaybe<Model_Has_Roles_Set_Input>;
  pk_columns: Model_Has_Roles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Model_Has_Roles_ManyArgs = {
  updates: Array<Model_Has_Roles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_NotificationsArgs = {
  _set?: InputMaybe<Notifications_Set_Input>;
  where: Notifications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notifications_By_PkArgs = {
  _set?: InputMaybe<Notifications_Set_Input>;
  pk_columns: Notifications_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notifications_ManyArgs = {
  updates: Array<Notifications_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Nova_Field_AttachmentsArgs = {
  _inc?: InputMaybe<Nova_Field_Attachments_Inc_Input>;
  _set?: InputMaybe<Nova_Field_Attachments_Set_Input>;
  where: Nova_Field_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Nova_Field_Attachments_By_PkArgs = {
  _inc?: InputMaybe<Nova_Field_Attachments_Inc_Input>;
  _set?: InputMaybe<Nova_Field_Attachments_Set_Input>;
  pk_columns: Nova_Field_Attachments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Nova_Field_Attachments_ManyArgs = {
  updates: Array<Nova_Field_Attachments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Nova_NotificationsArgs = {
  _set?: InputMaybe<Nova_Notifications_Set_Input>;
  where: Nova_Notifications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Nova_Notifications_By_PkArgs = {
  _set?: InputMaybe<Nova_Notifications_Set_Input>;
  pk_columns: Nova_Notifications_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Nova_Notifications_ManyArgs = {
  updates: Array<Nova_Notifications_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Nova_Pending_Field_AttachmentsArgs = {
  _inc?: InputMaybe<Nova_Pending_Field_Attachments_Inc_Input>;
  _set?: InputMaybe<Nova_Pending_Field_Attachments_Set_Input>;
  where: Nova_Pending_Field_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Nova_Pending_Field_Attachments_By_PkArgs = {
  _inc?: InputMaybe<Nova_Pending_Field_Attachments_Inc_Input>;
  _set?: InputMaybe<Nova_Pending_Field_Attachments_Set_Input>;
  pk_columns: Nova_Pending_Field_Attachments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Nova_Pending_Field_Attachments_ManyArgs = {
  updates: Array<Nova_Pending_Field_Attachments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Nova_TwofaArgs = {
  _inc?: InputMaybe<Nova_Twofa_Inc_Input>;
  _set?: InputMaybe<Nova_Twofa_Set_Input>;
  where: Nova_Twofa_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Nova_Twofa_By_PkArgs = {
  _inc?: InputMaybe<Nova_Twofa_Inc_Input>;
  _set?: InputMaybe<Nova_Twofa_Set_Input>;
  pk_columns: Nova_Twofa_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Nova_Twofa_ManyArgs = {
  updates: Array<Nova_Twofa_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pairing_CodesArgs = {
  _set?: InputMaybe<Pairing_Codes_Set_Input>;
  where: Pairing_Codes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pairing_Codes_By_PkArgs = {
  _set?: InputMaybe<Pairing_Codes_Set_Input>;
  pk_columns: Pairing_Codes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pairing_Codes_ManyArgs = {
  updates: Array<Pairing_Codes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Password_Reset_TokensArgs = {
  _set?: InputMaybe<Password_Reset_Tokens_Set_Input>;
  where: Password_Reset_Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Password_Reset_Tokens_By_PkArgs = {
  _set?: InputMaybe<Password_Reset_Tokens_Set_Input>;
  pk_columns: Password_Reset_Tokens_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Password_Reset_Tokens_ManyArgs = {
  updates: Array<Password_Reset_Tokens_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PermissionsArgs = {
  _inc?: InputMaybe<Permissions_Inc_Input>;
  _set?: InputMaybe<Permissions_Set_Input>;
  where: Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Permissions_By_PkArgs = {
  _inc?: InputMaybe<Permissions_Inc_Input>;
  _set?: InputMaybe<Permissions_Set_Input>;
  pk_columns: Permissions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Permissions_ManyArgs = {
  updates: Array<Permissions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Personal_Access_TokensArgs = {
  _inc?: InputMaybe<Personal_Access_Tokens_Inc_Input>;
  _set?: InputMaybe<Personal_Access_Tokens_Set_Input>;
  where: Personal_Access_Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Personal_Access_Tokens_By_PkArgs = {
  _inc?: InputMaybe<Personal_Access_Tokens_Inc_Input>;
  _set?: InputMaybe<Personal_Access_Tokens_Set_Input>;
  pk_columns: Personal_Access_Tokens_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Personal_Access_Tokens_ManyArgs = {
  updates: Array<Personal_Access_Tokens_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Personal_DashboardArgs = {
  _inc?: InputMaybe<Personal_Dashboard_Inc_Input>;
  _set?: InputMaybe<Personal_Dashboard_Set_Input>;
  where: Personal_Dashboard_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Personal_Dashboard_By_PkArgs = {
  _inc?: InputMaybe<Personal_Dashboard_Inc_Input>;
  _set?: InputMaybe<Personal_Dashboard_Set_Input>;
  pk_columns: Personal_Dashboard_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Personal_Dashboard_ManyArgs = {
  updates: Array<Personal_Dashboard_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pf_ProductsArgs = {
  _inc?: InputMaybe<Pf_Products_Inc_Input>;
  _set?: InputMaybe<Pf_Products_Set_Input>;
  where: Pf_Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pf_Products_By_PkArgs = {
  _inc?: InputMaybe<Pf_Products_Inc_Input>;
  _set?: InputMaybe<Pf_Products_Set_Input>;
  pk_columns: Pf_Products_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pf_Products_ManyArgs = {
  updates: Array<Pf_Products_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pf_User_TravellogArgs = {
  _inc?: InputMaybe<Pf_User_Travellog_Inc_Input>;
  _set?: InputMaybe<Pf_User_Travellog_Set_Input>;
  where: Pf_User_Travellog_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pf_User_Travellog_By_PkArgs = {
  _inc?: InputMaybe<Pf_User_Travellog_Inc_Input>;
  _set?: InputMaybe<Pf_User_Travellog_Set_Input>;
  pk_columns: Pf_User_Travellog_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pf_User_Travellog_ManyArgs = {
  updates: Array<Pf_User_Travellog_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Pop_MediaArgs = {
  _inc?: InputMaybe<Product_Pop_Media_Inc_Input>;
  _set?: InputMaybe<Product_Pop_Media_Set_Input>;
  where: Product_Pop_Media_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Pop_Media_By_PkArgs = {
  _inc?: InputMaybe<Product_Pop_Media_Inc_Input>;
  _set?: InputMaybe<Product_Pop_Media_Set_Input>;
  pk_columns: Product_Pop_Media_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Pop_Media_ManyArgs = {
  updates: Array<Product_Pop_Media_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_PopsArgs = {
  _set?: InputMaybe<Product_Pops_Set_Input>;
  where: Product_Pops_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Pops_By_PkArgs = {
  _set?: InputMaybe<Product_Pops_Set_Input>;
  pk_columns: Product_Pops_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Pops_ManyArgs = {
  updates: Array<Product_Pops_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Prospect_CropsArgs = {
  _inc?: InputMaybe<Prospect_Crops_Inc_Input>;
  _set?: InputMaybe<Prospect_Crops_Set_Input>;
  where: Prospect_Crops_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Prospect_Crops_By_PkArgs = {
  _inc?: InputMaybe<Prospect_Crops_Inc_Input>;
  _set?: InputMaybe<Prospect_Crops_Set_Input>;
  pk_columns: Prospect_Crops_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Prospect_Crops_ManyArgs = {
  updates: Array<Prospect_Crops_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Prospect_MessagesArgs = {
  _inc?: InputMaybe<Prospect_Messages_Inc_Input>;
  _set?: InputMaybe<Prospect_Messages_Set_Input>;
  where: Prospect_Messages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Prospect_Messages_By_PkArgs = {
  _inc?: InputMaybe<Prospect_Messages_Inc_Input>;
  _set?: InputMaybe<Prospect_Messages_Set_Input>;
  pk_columns: Prospect_Messages_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Prospect_Messages_ManyArgs = {
  updates: Array<Prospect_Messages_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Prospect_UserArgs = {
  _inc?: InputMaybe<Prospect_User_Inc_Input>;
  _set?: InputMaybe<Prospect_User_Set_Input>;
  where: Prospect_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Prospect_User_By_PkArgs = {
  _inc?: InputMaybe<Prospect_User_Inc_Input>;
  _set?: InputMaybe<Prospect_User_Set_Input>;
  pk_columns: Prospect_User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Prospect_User_ManyArgs = {
  updates: Array<Prospect_User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProspectsArgs = {
  _inc?: InputMaybe<Prospects_Inc_Input>;
  _set?: InputMaybe<Prospects_Set_Input>;
  where: Prospects_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Prospects_By_PkArgs = {
  _inc?: InputMaybe<Prospects_Inc_Input>;
  _set?: InputMaybe<Prospects_Set_Input>;
  pk_columns: Prospects_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Prospects_ManyArgs = {
  updates: Array<Prospects_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Reel_CategoryArgs = {
  _inc?: InputMaybe<Reel_Category_Inc_Input>;
  _set?: InputMaybe<Reel_Category_Set_Input>;
  where: Reel_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Reel_Category_By_PkArgs = {
  _inc?: InputMaybe<Reel_Category_Inc_Input>;
  _set?: InputMaybe<Reel_Category_Set_Input>;
  pk_columns: Reel_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Reel_Category_ManyArgs = {
  updates: Array<Reel_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Reel_CommentsArgs = {
  _inc?: InputMaybe<Reel_Comments_Inc_Input>;
  _set?: InputMaybe<Reel_Comments_Set_Input>;
  where: Reel_Comments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Reel_Comments_By_PkArgs = {
  _inc?: InputMaybe<Reel_Comments_Inc_Input>;
  _set?: InputMaybe<Reel_Comments_Set_Input>;
  pk_columns: Reel_Comments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Reel_Comments_ManyArgs = {
  updates: Array<Reel_Comments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Reel_InteractionsArgs = {
  _inc?: InputMaybe<Reel_Interactions_Inc_Input>;
  _set?: InputMaybe<Reel_Interactions_Set_Input>;
  where: Reel_Interactions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Reel_Interactions_By_PkArgs = {
  _inc?: InputMaybe<Reel_Interactions_Inc_Input>;
  _set?: InputMaybe<Reel_Interactions_Set_Input>;
  pk_columns: Reel_Interactions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Reel_Interactions_ManyArgs = {
  updates: Array<Reel_Interactions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Reel_StatsArgs = {
  _inc?: InputMaybe<Reel_Stats_Inc_Input>;
  _set?: InputMaybe<Reel_Stats_Set_Input>;
  where: Reel_Stats_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Reel_Stats_By_PkArgs = {
  _inc?: InputMaybe<Reel_Stats_Inc_Input>;
  _set?: InputMaybe<Reel_Stats_Set_Input>;
  pk_columns: Reel_Stats_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Reel_Stats_ManyArgs = {
  updates: Array<Reel_Stats_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Reel_User_ReportsArgs = {
  _inc?: InputMaybe<Reel_User_Reports_Inc_Input>;
  _set?: InputMaybe<Reel_User_Reports_Set_Input>;
  where: Reel_User_Reports_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Reel_User_Reports_By_PkArgs = {
  _inc?: InputMaybe<Reel_User_Reports_Inc_Input>;
  _set?: InputMaybe<Reel_User_Reports_Set_Input>;
  pk_columns: Reel_User_Reports_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Reel_User_Reports_ManyArgs = {
  updates: Array<Reel_User_Reports_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ReelsArgs = {
  _append?: InputMaybe<Reels_Append_Input>;
  _delete_at_path?: InputMaybe<Reels_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Reels_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Reels_Delete_Key_Input>;
  _inc?: InputMaybe<Reels_Inc_Input>;
  _prepend?: InputMaybe<Reels_Prepend_Input>;
  _set?: InputMaybe<Reels_Set_Input>;
  where: Reels_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Reels_By_PkArgs = {
  _append?: InputMaybe<Reels_Append_Input>;
  _delete_at_path?: InputMaybe<Reels_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Reels_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Reels_Delete_Key_Input>;
  _inc?: InputMaybe<Reels_Inc_Input>;
  _prepend?: InputMaybe<Reels_Prepend_Input>;
  _set?: InputMaybe<Reels_Set_Input>;
  pk_columns: Reels_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Reels_ManyArgs = {
  updates: Array<Reels_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Reels_With_DistanceArgs = {
  _inc?: InputMaybe<Reels_With_Distance_Inc_Input>;
  _set?: InputMaybe<Reels_With_Distance_Set_Input>;
  where: Reels_With_Distance_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Reels_With_Distance_ManyArgs = {
  updates: Array<Reels_With_Distance_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Retailer_EstablishmentsArgs = {
  _append?: InputMaybe<Retailer_Establishments_Append_Input>;
  _delete_at_path?: InputMaybe<Retailer_Establishments_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Retailer_Establishments_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Retailer_Establishments_Delete_Key_Input>;
  _inc?: InputMaybe<Retailer_Establishments_Inc_Input>;
  _prepend?: InputMaybe<Retailer_Establishments_Prepend_Input>;
  _set?: InputMaybe<Retailer_Establishments_Set_Input>;
  where: Retailer_Establishments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Retailer_Establishments_By_PkArgs = {
  _append?: InputMaybe<Retailer_Establishments_Append_Input>;
  _delete_at_path?: InputMaybe<Retailer_Establishments_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Retailer_Establishments_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Retailer_Establishments_Delete_Key_Input>;
  _inc?: InputMaybe<Retailer_Establishments_Inc_Input>;
  _prepend?: InputMaybe<Retailer_Establishments_Prepend_Input>;
  _set?: InputMaybe<Retailer_Establishments_Set_Input>;
  pk_columns: Retailer_Establishments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Retailer_Establishments_ManyArgs = {
  updates: Array<Retailer_Establishments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RetailersArgs = {
  _set?: InputMaybe<Retailers_Set_Input>;
  where: Retailers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Retailers_By_PkArgs = {
  _set?: InputMaybe<Retailers_Set_Input>;
  pk_columns: Retailers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Retailers_ManyArgs = {
  updates: Array<Retailers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Role_Has_PermissionsArgs = {
  _inc?: InputMaybe<Role_Has_Permissions_Inc_Input>;
  _set?: InputMaybe<Role_Has_Permissions_Set_Input>;
  where: Role_Has_Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Role_Has_Permissions_By_PkArgs = {
  _inc?: InputMaybe<Role_Has_Permissions_Inc_Input>;
  _set?: InputMaybe<Role_Has_Permissions_Set_Input>;
  pk_columns: Role_Has_Permissions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Role_Has_Permissions_ManyArgs = {
  updates: Array<Role_Has_Permissions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RolesArgs = {
  _inc?: InputMaybe<Roles_Inc_Input>;
  _set?: InputMaybe<Roles_Set_Input>;
  where: Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Roles_By_PkArgs = {
  _inc?: InputMaybe<Roles_Inc_Input>;
  _set?: InputMaybe<Roles_Set_Input>;
  pk_columns: Roles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Roles_ManyArgs = {
  updates: Array<Roles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Runpando_Pro_All_State_DataArgs = {
  _inc?: InputMaybe<Runpando_Pro_All_State_Data_Inc_Input>;
  _set?: InputMaybe<Runpando_Pro_All_State_Data_Set_Input>;
  where: Runpando_Pro_All_State_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Runpando_Pro_All_State_Data_By_PkArgs = {
  _inc?: InputMaybe<Runpando_Pro_All_State_Data_Inc_Input>;
  _set?: InputMaybe<Runpando_Pro_All_State_Data_Set_Input>;
  pk_columns: Runpando_Pro_All_State_Data_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Runpando_Pro_All_State_Data_ManyArgs = {
  updates: Array<Runpando_Pro_All_State_Data_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Runpando_Pro_UsersArgs = {
  _inc?: InputMaybe<Runpando_Pro_Users_Inc_Input>;
  _set?: InputMaybe<Runpando_Pro_Users_Set_Input>;
  where: Runpando_Pro_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Runpando_Pro_Users_By_PkArgs = {
  _inc?: InputMaybe<Runpando_Pro_Users_Inc_Input>;
  _set?: InputMaybe<Runpando_Pro_Users_Set_Input>;
  pk_columns: Runpando_Pro_Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Runpando_Pro_Users_LocationsArgs = {
  _inc?: InputMaybe<Runpando_Pro_Users_Locations_Inc_Input>;
  _set?: InputMaybe<Runpando_Pro_Users_Locations_Set_Input>;
  where: Runpando_Pro_Users_Locations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Runpando_Pro_Users_Locations_By_PkArgs = {
  _inc?: InputMaybe<Runpando_Pro_Users_Locations_Inc_Input>;
  _set?: InputMaybe<Runpando_Pro_Users_Locations_Set_Input>;
  pk_columns: Runpando_Pro_Users_Locations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Runpando_Pro_Users_Locations_ManyArgs = {
  updates: Array<Runpando_Pro_Users_Locations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Runpando_Pro_Users_ManyArgs = {
  updates: Array<Runpando_Pro_Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sale_ItemsArgs = {
  _inc?: InputMaybe<Sale_Items_Inc_Input>;
  _set?: InputMaybe<Sale_Items_Set_Input>;
  where: Sale_Items_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sale_Items_By_PkArgs = {
  _inc?: InputMaybe<Sale_Items_Inc_Input>;
  _set?: InputMaybe<Sale_Items_Set_Input>;
  pk_columns: Sale_Items_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sale_Items_ManyArgs = {
  updates: Array<Sale_Items_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sale_PaymentsArgs = {
  _inc?: InputMaybe<Sale_Payments_Inc_Input>;
  _set?: InputMaybe<Sale_Payments_Set_Input>;
  where: Sale_Payments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sale_Payments_By_PkArgs = {
  _inc?: InputMaybe<Sale_Payments_Inc_Input>;
  _set?: InputMaybe<Sale_Payments_Set_Input>;
  pk_columns: Sale_Payments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sale_Payments_ManyArgs = {
  updates: Array<Sale_Payments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sale_Proof_EventsArgs = {
  _set?: InputMaybe<Sale_Proof_Events_Set_Input>;
  where: Sale_Proof_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sale_Proof_Events_By_PkArgs = {
  _set?: InputMaybe<Sale_Proof_Events_Set_Input>;
  pk_columns: Sale_Proof_Events_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sale_Proof_Events_ManyArgs = {
  updates: Array<Sale_Proof_Events_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sale_Proof_TypesArgs = {
  _set?: InputMaybe<Sale_Proof_Types_Set_Input>;
  where: Sale_Proof_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sale_Proof_Types_By_PkArgs = {
  _set?: InputMaybe<Sale_Proof_Types_Set_Input>;
  pk_columns: Sale_Proof_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sale_Proof_Types_ManyArgs = {
  updates: Array<Sale_Proof_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sale_ProofsArgs = {
  _append?: InputMaybe<Sale_Proofs_Append_Input>;
  _delete_at_path?: InputMaybe<Sale_Proofs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Sale_Proofs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Sale_Proofs_Delete_Key_Input>;
  _inc?: InputMaybe<Sale_Proofs_Inc_Input>;
  _prepend?: InputMaybe<Sale_Proofs_Prepend_Input>;
  _set?: InputMaybe<Sale_Proofs_Set_Input>;
  where: Sale_Proofs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sale_Proofs_By_PkArgs = {
  _append?: InputMaybe<Sale_Proofs_Append_Input>;
  _delete_at_path?: InputMaybe<Sale_Proofs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Sale_Proofs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Sale_Proofs_Delete_Key_Input>;
  _inc?: InputMaybe<Sale_Proofs_Inc_Input>;
  _prepend?: InputMaybe<Sale_Proofs_Prepend_Input>;
  _set?: InputMaybe<Sale_Proofs_Set_Input>;
  pk_columns: Sale_Proofs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sale_Proofs_ManyArgs = {
  updates: Array<Sale_Proofs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SalesArgs = {
  _append?: InputMaybe<Sales_Append_Input>;
  _delete_at_path?: InputMaybe<Sales_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Sales_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Sales_Delete_Key_Input>;
  _inc?: InputMaybe<Sales_Inc_Input>;
  _prepend?: InputMaybe<Sales_Prepend_Input>;
  _set?: InputMaybe<Sales_Set_Input>;
  where: Sales_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sales_By_PkArgs = {
  _append?: InputMaybe<Sales_Append_Input>;
  _delete_at_path?: InputMaybe<Sales_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Sales_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Sales_Delete_Key_Input>;
  _inc?: InputMaybe<Sales_Inc_Input>;
  _prepend?: InputMaybe<Sales_Prepend_Input>;
  _set?: InputMaybe<Sales_Set_Input>;
  pk_columns: Sales_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sales_ManyArgs = {
  updates: Array<Sales_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Saved_ReelsArgs = {
  _append?: InputMaybe<Saved_Reels_Append_Input>;
  _delete_at_path?: InputMaybe<Saved_Reels_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Saved_Reels_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Saved_Reels_Delete_Key_Input>;
  _inc?: InputMaybe<Saved_Reels_Inc_Input>;
  _prepend?: InputMaybe<Saved_Reels_Prepend_Input>;
  _set?: InputMaybe<Saved_Reels_Set_Input>;
  where: Saved_Reels_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Saved_Reels_By_PkArgs = {
  _append?: InputMaybe<Saved_Reels_Append_Input>;
  _delete_at_path?: InputMaybe<Saved_Reels_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Saved_Reels_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Saved_Reels_Delete_Key_Input>;
  _inc?: InputMaybe<Saved_Reels_Inc_Input>;
  _prepend?: InputMaybe<Saved_Reels_Prepend_Input>;
  _set?: InputMaybe<Saved_Reels_Set_Input>;
  pk_columns: Saved_Reels_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Saved_Reels_ManyArgs = {
  updates: Array<Saved_Reels_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Segment_UserArgs = {
  _inc?: InputMaybe<Segment_User_Inc_Input>;
  _set?: InputMaybe<Segment_User_Set_Input>;
  where: Segment_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Segment_User_By_PkArgs = {
  _inc?: InputMaybe<Segment_User_Inc_Input>;
  _set?: InputMaybe<Segment_User_Set_Input>;
  pk_columns: Segment_User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Segment_User_ManyArgs = {
  updates: Array<Segment_User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Service_Request_DashboardArgs = {
  _inc?: InputMaybe<Service_Request_Dashboard_Inc_Input>;
  _set?: InputMaybe<Service_Request_Dashboard_Set_Input>;
  where: Service_Request_Dashboard_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Service_Request_Dashboard_By_PkArgs = {
  _inc?: InputMaybe<Service_Request_Dashboard_Inc_Input>;
  _set?: InputMaybe<Service_Request_Dashboard_Set_Input>;
  pk_columns: Service_Request_Dashboard_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Service_Request_Dashboard_ManyArgs = {
  updates: Array<Service_Request_Dashboard_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Service_Request_RecommendationsArgs = {
  _set?: InputMaybe<Service_Request_Recommendations_Set_Input>;
  where: Service_Request_Recommendations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Service_Request_Recommendations_By_PkArgs = {
  _set?: InputMaybe<Service_Request_Recommendations_Set_Input>;
  pk_columns: Service_Request_Recommendations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Service_Request_Recommendations_ManyArgs = {
  updates: Array<Service_Request_Recommendations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Service_Request_RetailerArgs = {
  _inc?: InputMaybe<Service_Request_Retailer_Inc_Input>;
  _set?: InputMaybe<Service_Request_Retailer_Set_Input>;
  where: Service_Request_Retailer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Service_Request_Retailer_By_PkArgs = {
  _inc?: InputMaybe<Service_Request_Retailer_Inc_Input>;
  _set?: InputMaybe<Service_Request_Retailer_Set_Input>;
  pk_columns: Service_Request_Retailer_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Service_Request_Retailer_ManyArgs = {
  updates: Array<Service_Request_Retailer_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Service_RequestsArgs = {
  _append?: InputMaybe<Service_Requests_Append_Input>;
  _delete_at_path?: InputMaybe<Service_Requests_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Service_Requests_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Service_Requests_Delete_Key_Input>;
  _inc?: InputMaybe<Service_Requests_Inc_Input>;
  _prepend?: InputMaybe<Service_Requests_Prepend_Input>;
  _set?: InputMaybe<Service_Requests_Set_Input>;
  where: Service_Requests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Service_Requests_By_PkArgs = {
  _append?: InputMaybe<Service_Requests_Append_Input>;
  _delete_at_path?: InputMaybe<Service_Requests_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Service_Requests_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Service_Requests_Delete_Key_Input>;
  _inc?: InputMaybe<Service_Requests_Inc_Input>;
  _prepend?: InputMaybe<Service_Requests_Prepend_Input>;
  _set?: InputMaybe<Service_Requests_Set_Input>;
  pk_columns: Service_Requests_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Service_Requests_ManyArgs = {
  updates: Array<Service_Requests_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SnapshotsArgs = {
  _append?: InputMaybe<Snapshots_Append_Input>;
  _delete_at_path?: InputMaybe<Snapshots_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Snapshots_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Snapshots_Delete_Key_Input>;
  _inc?: InputMaybe<Snapshots_Inc_Input>;
  _prepend?: InputMaybe<Snapshots_Prepend_Input>;
  _set?: InputMaybe<Snapshots_Set_Input>;
  where: Snapshots_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Snapshots_By_PkArgs = {
  _append?: InputMaybe<Snapshots_Append_Input>;
  _delete_at_path?: InputMaybe<Snapshots_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Snapshots_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Snapshots_Delete_Key_Input>;
  _inc?: InputMaybe<Snapshots_Inc_Input>;
  _prepend?: InputMaybe<Snapshots_Prepend_Input>;
  _set?: InputMaybe<Snapshots_Set_Input>;
  pk_columns: Snapshots_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Snapshots_ManyArgs = {
  updates: Array<Snapshots_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Spatial_Ref_SysArgs = {
  _inc?: InputMaybe<Spatial_Ref_Sys_Inc_Input>;
  _set?: InputMaybe<Spatial_Ref_Sys_Set_Input>;
  where: Spatial_Ref_Sys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Spatial_Ref_Sys_By_PkArgs = {
  _inc?: InputMaybe<Spatial_Ref_Sys_Inc_Input>;
  _set?: InputMaybe<Spatial_Ref_Sys_Set_Input>;
  pk_columns: Spatial_Ref_Sys_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Spatial_Ref_Sys_ManyArgs = {
  updates: Array<Spatial_Ref_Sys_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Stored_EventsArgs = {
  _append?: InputMaybe<Stored_Events_Append_Input>;
  _delete_at_path?: InputMaybe<Stored_Events_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Stored_Events_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Stored_Events_Delete_Key_Input>;
  _inc?: InputMaybe<Stored_Events_Inc_Input>;
  _prepend?: InputMaybe<Stored_Events_Prepend_Input>;
  _set?: InputMaybe<Stored_Events_Set_Input>;
  where: Stored_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Stored_Events_By_PkArgs = {
  _append?: InputMaybe<Stored_Events_Append_Input>;
  _delete_at_path?: InputMaybe<Stored_Events_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Stored_Events_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Stored_Events_Delete_Key_Input>;
  _inc?: InputMaybe<Stored_Events_Inc_Input>;
  _prepend?: InputMaybe<Stored_Events_Prepend_Input>;
  _set?: InputMaybe<Stored_Events_Set_Input>;
  pk_columns: Stored_Events_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Stored_Events_ManyArgs = {
  updates: Array<Stored_Events_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TaggablesArgs = {
  _inc?: InputMaybe<Taggables_Inc_Input>;
  _set?: InputMaybe<Taggables_Set_Input>;
  where: Taggables_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Taggables_By_PkArgs = {
  _inc?: InputMaybe<Taggables_Inc_Input>;
  _set?: InputMaybe<Taggables_Set_Input>;
  pk_columns: Taggables_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Taggables_ManyArgs = {
  updates: Array<Taggables_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TagsArgs = {
  _inc?: InputMaybe<Tags_Inc_Input>;
  _set?: InputMaybe<Tags_Set_Input>;
  where: Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tags_By_PkArgs = {
  _inc?: InputMaybe<Tags_Inc_Input>;
  _set?: InputMaybe<Tags_Set_Input>;
  pk_columns: Tags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tags_ManyArgs = {
  updates: Array<Tags_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_DeviceArgs = {
  _inc?: InputMaybe<User_Device_Inc_Input>;
  _set?: InputMaybe<User_Device_Set_Input>;
  where: User_Device_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Device_By_PkArgs = {
  _inc?: InputMaybe<User_Device_Inc_Input>;
  _set?: InputMaybe<User_Device_Set_Input>;
  pk_columns: User_Device_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Device_ManyArgs = {
  updates: Array<User_Device_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_FeedbacksArgs = {
  _inc?: InputMaybe<User_Feedbacks_Inc_Input>;
  _set?: InputMaybe<User_Feedbacks_Set_Input>;
  where: User_Feedbacks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Feedbacks_By_PkArgs = {
  _inc?: InputMaybe<User_Feedbacks_Inc_Input>;
  _set?: InputMaybe<User_Feedbacks_Set_Input>;
  pk_columns: User_Feedbacks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Feedbacks_ManyArgs = {
  updates: Array<User_Feedbacks_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Follows_ChannelArgs = {
  _inc?: InputMaybe<User_Follows_Channel_Inc_Input>;
  _set?: InputMaybe<User_Follows_Channel_Set_Input>;
  where: User_Follows_Channel_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Follows_Channel_By_PkArgs = {
  _inc?: InputMaybe<User_Follows_Channel_Inc_Input>;
  _set?: InputMaybe<User_Follows_Channel_Set_Input>;
  pk_columns: User_Follows_Channel_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Follows_Channel_ManyArgs = {
  updates: Array<User_Follows_Channel_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Location_LogsArgs = {
  _inc?: InputMaybe<User_Location_Logs_Inc_Input>;
  _set?: InputMaybe<User_Location_Logs_Set_Input>;
  where: User_Location_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Location_Logs_By_PkArgs = {
  _inc?: InputMaybe<User_Location_Logs_Inc_Input>;
  _set?: InputMaybe<User_Location_Logs_Set_Input>;
  pk_columns: User_Location_Logs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Location_Logs_ManyArgs = {
  updates: Array<User_Location_Logs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _append?: InputMaybe<Users_Append_Input>;
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  _inc?: InputMaybe<Users_Inc_Input>;
  _prepend?: InputMaybe<Users_Prepend_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _append?: InputMaybe<Users_Append_Input>;
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  _inc?: InputMaybe<Users_Inc_Input>;
  _prepend?: InputMaybe<Users_Prepend_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_WalletsArgs = {
  _inc?: InputMaybe<Wallets_Inc_Input>;
  _set?: InputMaybe<Wallets_Set_Input>;
  where: Wallets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Wallets_By_PkArgs = {
  _inc?: InputMaybe<Wallets_Inc_Input>;
  _set?: InputMaybe<Wallets_Set_Input>;
  pk_columns: Wallets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Wallets_ManyArgs = {
  updates: Array<Wallets_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsauth_LoginsArgs = {
  _inc?: InputMaybe<Whatsauth_Logins_Inc_Input>;
  _set?: InputMaybe<Whatsauth_Logins_Set_Input>;
  where: Whatsauth_Logins_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsauth_Logins_By_PkArgs = {
  _inc?: InputMaybe<Whatsauth_Logins_Inc_Input>;
  _set?: InputMaybe<Whatsauth_Logins_Set_Input>;
  pk_columns: Whatsauth_Logins_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsauth_Logins_ManyArgs = {
  updates: Array<Whatsauth_Logins_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Work_Order_Checklist_ItemsArgs = {
  _append?: InputMaybe<Work_Order_Checklist_Items_Append_Input>;
  _delete_at_path?: InputMaybe<Work_Order_Checklist_Items_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Work_Order_Checklist_Items_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Work_Order_Checklist_Items_Delete_Key_Input>;
  _prepend?: InputMaybe<Work_Order_Checklist_Items_Prepend_Input>;
  _set?: InputMaybe<Work_Order_Checklist_Items_Set_Input>;
  where: Work_Order_Checklist_Items_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Work_Order_Checklist_Items_By_PkArgs = {
  _append?: InputMaybe<Work_Order_Checklist_Items_Append_Input>;
  _delete_at_path?: InputMaybe<Work_Order_Checklist_Items_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Work_Order_Checklist_Items_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Work_Order_Checklist_Items_Delete_Key_Input>;
  _prepend?: InputMaybe<Work_Order_Checklist_Items_Prepend_Input>;
  _set?: InputMaybe<Work_Order_Checklist_Items_Set_Input>;
  pk_columns: Work_Order_Checklist_Items_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Work_Order_Checklist_Items_ManyArgs = {
  updates: Array<Work_Order_Checklist_Items_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Work_Order_MessagesArgs = {
  _append?: InputMaybe<Work_Order_Messages_Append_Input>;
  _delete_at_path?: InputMaybe<Work_Order_Messages_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Work_Order_Messages_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Work_Order_Messages_Delete_Key_Input>;
  _prepend?: InputMaybe<Work_Order_Messages_Prepend_Input>;
  _set?: InputMaybe<Work_Order_Messages_Set_Input>;
  where: Work_Order_Messages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Work_Order_Messages_By_PkArgs = {
  _append?: InputMaybe<Work_Order_Messages_Append_Input>;
  _delete_at_path?: InputMaybe<Work_Order_Messages_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Work_Order_Messages_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Work_Order_Messages_Delete_Key_Input>;
  _prepend?: InputMaybe<Work_Order_Messages_Prepend_Input>;
  _set?: InputMaybe<Work_Order_Messages_Set_Input>;
  pk_columns: Work_Order_Messages_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Work_Order_Messages_ManyArgs = {
  updates: Array<Work_Order_Messages_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Work_Order_OutputsArgs = {
  _append?: InputMaybe<Work_Order_Outputs_Append_Input>;
  _delete_at_path?: InputMaybe<Work_Order_Outputs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Work_Order_Outputs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Work_Order_Outputs_Delete_Key_Input>;
  _inc?: InputMaybe<Work_Order_Outputs_Inc_Input>;
  _prepend?: InputMaybe<Work_Order_Outputs_Prepend_Input>;
  _set?: InputMaybe<Work_Order_Outputs_Set_Input>;
  where: Work_Order_Outputs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Work_Order_Outputs_By_PkArgs = {
  _append?: InputMaybe<Work_Order_Outputs_Append_Input>;
  _delete_at_path?: InputMaybe<Work_Order_Outputs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Work_Order_Outputs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Work_Order_Outputs_Delete_Key_Input>;
  _inc?: InputMaybe<Work_Order_Outputs_Inc_Input>;
  _prepend?: InputMaybe<Work_Order_Outputs_Prepend_Input>;
  _set?: InputMaybe<Work_Order_Outputs_Set_Input>;
  pk_columns: Work_Order_Outputs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Work_Order_Outputs_ManyArgs = {
  updates: Array<Work_Order_Outputs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Work_Order_RequestsArgs = {
  _inc?: InputMaybe<Work_Order_Requests_Inc_Input>;
  _set?: InputMaybe<Work_Order_Requests_Set_Input>;
  where: Work_Order_Requests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Work_Order_Requests_By_PkArgs = {
  _inc?: InputMaybe<Work_Order_Requests_Inc_Input>;
  _set?: InputMaybe<Work_Order_Requests_Set_Input>;
  pk_columns: Work_Order_Requests_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Work_Order_Requests_ManyArgs = {
  updates: Array<Work_Order_Requests_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Work_Order_ReviewsArgs = {
  _inc?: InputMaybe<Work_Order_Reviews_Inc_Input>;
  _set?: InputMaybe<Work_Order_Reviews_Set_Input>;
  where: Work_Order_Reviews_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Work_Order_Reviews_By_PkArgs = {
  _inc?: InputMaybe<Work_Order_Reviews_Inc_Input>;
  _set?: InputMaybe<Work_Order_Reviews_Set_Input>;
  pk_columns: Work_Order_Reviews_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Work_Order_Reviews_ManyArgs = {
  updates: Array<Work_Order_Reviews_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Work_OrdersArgs = {
  _append?: InputMaybe<Work_Orders_Append_Input>;
  _delete_at_path?: InputMaybe<Work_Orders_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Work_Orders_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Work_Orders_Delete_Key_Input>;
  _inc?: InputMaybe<Work_Orders_Inc_Input>;
  _prepend?: InputMaybe<Work_Orders_Prepend_Input>;
  _set?: InputMaybe<Work_Orders_Set_Input>;
  where: Work_Orders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Work_Orders_By_PkArgs = {
  _append?: InputMaybe<Work_Orders_Append_Input>;
  _delete_at_path?: InputMaybe<Work_Orders_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Work_Orders_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Work_Orders_Delete_Key_Input>;
  _inc?: InputMaybe<Work_Orders_Inc_Input>;
  _prepend?: InputMaybe<Work_Orders_Prepend_Input>;
  _set?: InputMaybe<Work_Orders_Set_Input>;
  pk_columns: Work_Orders_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Work_Orders_ManyArgs = {
  updates: Array<Work_Orders_Updates>;
};


/** mutation root */
export type Mutation_RootUploadMultipleProductImagesArgs = {
  altTexts?: InputMaybe<Scalars['JSON']['input']>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productId: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootUploadProductImageArgs = {
  altText?: InputMaybe<Scalars['String']['input']>;
  image: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};


/** mutation root */
export type Mutation_RootUserFollowsProfileCommandArgs = {
  command: UserFollowsProfileCommandInput;
};


/** mutation root */
export type Mutation_RootUserLikedReelArgs = {
  command: UserLikedReelInput;
};


/** mutation root */
export type Mutation_RootUserReactedReelArgs = {
  command: UserReactedReelInput;
};


/** mutation root */
export type Mutation_RootUserReportsCommentArgs = {
  command: UserReportsCommentCommandInput;
};


/** mutation root */
export type Mutation_RootUserReportsReelArgs = {
  command: UserReportsReelCommandInput;
};


/** mutation root */
export type Mutation_RootUserRequestsAccountDeletionArgs = {
  command: UserRequestsAccountDeletionCommandInput;
};


/** mutation root */
export type Mutation_RootUserSetHisLocaleArgs = {
  command: SetUserLocaleCommandInput;
};


/** mutation root */
export type Mutation_RootUserSharedReelArgs = {
  command: UserSharedReelInput;
};


/** mutation root */
export type Mutation_RootUserUnfollowsProfileCommandArgs = {
  command: UserUnfollowsProfileCommandInput;
};


/** mutation root */
export type Mutation_RootUserUnreactedReelArgs = {
  command: UserUnreactedReelInput;
};


/** mutation root */
export type Mutation_RootUserUpdatesHisDeviceInfoArgs = {
  command: UserUpdatesHisDeviceInfoInput;
};


/** mutation root */
export type Mutation_RootUserUpdatesHisProfileArgs = {
  command: UserUpdatesHisProfileCommandInput;
};


/** mutation root */
export type Mutation_RootUserViewedReelArgs = {
  command: UserViewedReelInput;
};


/** mutation root */
export type Mutation_RootVerifyOtpCommandArgs = {
  command: VerifyOtpCommandInput;
};

/** Boolean expression to compare columns of type "name". All fields are combined with logical 'AND'. */
export type Name_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['name']['input']>;
  _gt?: InputMaybe<Scalars['name']['input']>;
  _gte?: InputMaybe<Scalars['name']['input']>;
  _in?: InputMaybe<Array<Scalars['name']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['name']['input']>;
  _lte?: InputMaybe<Scalars['name']['input']>;
  _neq?: InputMaybe<Scalars['name']['input']>;
  _nin?: InputMaybe<Array<Scalars['name']['input']>>;
};

/** columns and relationships of "notifications" */
export type Notifications = {
  __typename?: 'notifications';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  data: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  notifiable_id: Scalars['bpchar']['output'];
  notifiable_type: Scalars['String']['output'];
  read_at?: Maybe<Scalars['timestamp']['output']>;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregated selection of "notifications" */
export type Notifications_Aggregate = {
  __typename?: 'notifications_aggregate';
  aggregate?: Maybe<Notifications_Aggregate_Fields>;
  nodes: Array<Notifications>;
};

/** aggregate fields of "notifications" */
export type Notifications_Aggregate_Fields = {
  __typename?: 'notifications_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Notifications_Max_Fields>;
  min?: Maybe<Notifications_Min_Fields>;
};


/** aggregate fields of "notifications" */
export type Notifications_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notifications_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "notifications". All fields are combined with a logical 'AND'. */
export type Notifications_Bool_Exp = {
  _and?: InputMaybe<Array<Notifications_Bool_Exp>>;
  _not?: InputMaybe<Notifications_Bool_Exp>;
  _or?: InputMaybe<Array<Notifications_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  data?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  notifiable_id?: InputMaybe<Bpchar_Comparison_Exp>;
  notifiable_type?: InputMaybe<String_Comparison_Exp>;
  read_at?: InputMaybe<Timestamp_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "notifications" */
export enum Notifications_Constraint {
  /** unique or primary key constraint on columns "id" */
  NotificationsPkey = 'notifications_pkey'
}

/** input type for inserting data into table "notifications" */
export type Notifications_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  notifiable_id?: InputMaybe<Scalars['bpchar']['input']>;
  notifiable_type?: InputMaybe<Scalars['String']['input']>;
  read_at?: InputMaybe<Scalars['timestamp']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Notifications_Max_Fields = {
  __typename?: 'notifications_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  notifiable_id?: Maybe<Scalars['bpchar']['output']>;
  notifiable_type?: Maybe<Scalars['String']['output']>;
  read_at?: Maybe<Scalars['timestamp']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Notifications_Min_Fields = {
  __typename?: 'notifications_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  notifiable_id?: Maybe<Scalars['bpchar']['output']>;
  notifiable_type?: Maybe<Scalars['String']['output']>;
  read_at?: Maybe<Scalars['timestamp']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "notifications" */
export type Notifications_Mutation_Response = {
  __typename?: 'notifications_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Notifications>;
};

/** on_conflict condition type for table "notifications" */
export type Notifications_On_Conflict = {
  constraint: Notifications_Constraint;
  update_columns?: Array<Notifications_Update_Column>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};

/** Ordering options when selecting data from "notifications". */
export type Notifications_Order_By = {
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notifiable_id?: InputMaybe<Order_By>;
  notifiable_type?: InputMaybe<Order_By>;
  read_at?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notifications */
export type Notifications_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "notifications" */
export enum Notifications_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  NotifiableId = 'notifiable_id',
  /** column name */
  NotifiableType = 'notifiable_type',
  /** column name */
  ReadAt = 'read_at',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "notifications" */
export type Notifications_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  notifiable_id?: InputMaybe<Scalars['bpchar']['input']>;
  notifiable_type?: InputMaybe<Scalars['String']['input']>;
  read_at?: InputMaybe<Scalars['timestamp']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "notifications" */
export type Notifications_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notifications_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notifications_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  notifiable_id?: InputMaybe<Scalars['bpchar']['input']>;
  notifiable_type?: InputMaybe<Scalars['String']['input']>;
  read_at?: InputMaybe<Scalars['timestamp']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "notifications" */
export enum Notifications_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  NotifiableId = 'notifiable_id',
  /** column name */
  NotifiableType = 'notifiable_type',
  /** column name */
  ReadAt = 'read_at',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Notifications_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notifications_Set_Input>;
  /** filter the rows which have to be updated */
  where: Notifications_Bool_Exp;
};

/** columns and relationships of "nova_field_attachments" */
export type Nova_Field_Attachments = {
  __typename?: 'nova_field_attachments';
  attachable_id: Scalars['bigint']['output'];
  attachable_type: Scalars['String']['output'];
  attachment: Scalars['String']['output'];
  created_at?: Maybe<Scalars['timestamp']['output']>;
  disk: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  url: Scalars['String']['output'];
};

/** aggregated selection of "nova_field_attachments" */
export type Nova_Field_Attachments_Aggregate = {
  __typename?: 'nova_field_attachments_aggregate';
  aggregate?: Maybe<Nova_Field_Attachments_Aggregate_Fields>;
  nodes: Array<Nova_Field_Attachments>;
};

/** aggregate fields of "nova_field_attachments" */
export type Nova_Field_Attachments_Aggregate_Fields = {
  __typename?: 'nova_field_attachments_aggregate_fields';
  avg?: Maybe<Nova_Field_Attachments_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Nova_Field_Attachments_Max_Fields>;
  min?: Maybe<Nova_Field_Attachments_Min_Fields>;
  stddev?: Maybe<Nova_Field_Attachments_Stddev_Fields>;
  stddev_pop?: Maybe<Nova_Field_Attachments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Nova_Field_Attachments_Stddev_Samp_Fields>;
  sum?: Maybe<Nova_Field_Attachments_Sum_Fields>;
  var_pop?: Maybe<Nova_Field_Attachments_Var_Pop_Fields>;
  var_samp?: Maybe<Nova_Field_Attachments_Var_Samp_Fields>;
  variance?: Maybe<Nova_Field_Attachments_Variance_Fields>;
};


/** aggregate fields of "nova_field_attachments" */
export type Nova_Field_Attachments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Nova_Field_Attachments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Nova_Field_Attachments_Avg_Fields = {
  __typename?: 'nova_field_attachments_avg_fields';
  attachable_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "nova_field_attachments". All fields are combined with a logical 'AND'. */
export type Nova_Field_Attachments_Bool_Exp = {
  _and?: InputMaybe<Array<Nova_Field_Attachments_Bool_Exp>>;
  _not?: InputMaybe<Nova_Field_Attachments_Bool_Exp>;
  _or?: InputMaybe<Array<Nova_Field_Attachments_Bool_Exp>>;
  attachable_id?: InputMaybe<Bigint_Comparison_Exp>;
  attachable_type?: InputMaybe<String_Comparison_Exp>;
  attachment?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  disk?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "nova_field_attachments" */
export enum Nova_Field_Attachments_Constraint {
  /** unique or primary key constraint on columns "id" */
  NovaFieldAttachmentsPkey = 'nova_field_attachments_pkey'
}

/** input type for incrementing numeric columns in table "nova_field_attachments" */
export type Nova_Field_Attachments_Inc_Input = {
  attachable_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "nova_field_attachments" */
export type Nova_Field_Attachments_Insert_Input = {
  attachable_id?: InputMaybe<Scalars['bigint']['input']>;
  attachable_type?: InputMaybe<Scalars['String']['input']>;
  attachment?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  disk?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Nova_Field_Attachments_Max_Fields = {
  __typename?: 'nova_field_attachments_max_fields';
  attachable_id?: Maybe<Scalars['bigint']['output']>;
  attachable_type?: Maybe<Scalars['String']['output']>;
  attachment?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  disk?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Nova_Field_Attachments_Min_Fields = {
  __typename?: 'nova_field_attachments_min_fields';
  attachable_id?: Maybe<Scalars['bigint']['output']>;
  attachable_type?: Maybe<Scalars['String']['output']>;
  attachment?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  disk?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "nova_field_attachments" */
export type Nova_Field_Attachments_Mutation_Response = {
  __typename?: 'nova_field_attachments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Nova_Field_Attachments>;
};

/** on_conflict condition type for table "nova_field_attachments" */
export type Nova_Field_Attachments_On_Conflict = {
  constraint: Nova_Field_Attachments_Constraint;
  update_columns?: Array<Nova_Field_Attachments_Update_Column>;
  where?: InputMaybe<Nova_Field_Attachments_Bool_Exp>;
};

/** Ordering options when selecting data from "nova_field_attachments". */
export type Nova_Field_Attachments_Order_By = {
  attachable_id?: InputMaybe<Order_By>;
  attachable_type?: InputMaybe<Order_By>;
  attachment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  disk?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: nova_field_attachments */
export type Nova_Field_Attachments_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "nova_field_attachments" */
export enum Nova_Field_Attachments_Select_Column {
  /** column name */
  AttachableId = 'attachable_id',
  /** column name */
  AttachableType = 'attachable_type',
  /** column name */
  Attachment = 'attachment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Disk = 'disk',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "nova_field_attachments" */
export type Nova_Field_Attachments_Set_Input = {
  attachable_id?: InputMaybe<Scalars['bigint']['input']>;
  attachable_type?: InputMaybe<Scalars['String']['input']>;
  attachment?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  disk?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Nova_Field_Attachments_Stddev_Fields = {
  __typename?: 'nova_field_attachments_stddev_fields';
  attachable_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Nova_Field_Attachments_Stddev_Pop_Fields = {
  __typename?: 'nova_field_attachments_stddev_pop_fields';
  attachable_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Nova_Field_Attachments_Stddev_Samp_Fields = {
  __typename?: 'nova_field_attachments_stddev_samp_fields';
  attachable_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "nova_field_attachments" */
export type Nova_Field_Attachments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Nova_Field_Attachments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Nova_Field_Attachments_Stream_Cursor_Value_Input = {
  attachable_id?: InputMaybe<Scalars['bigint']['input']>;
  attachable_type?: InputMaybe<Scalars['String']['input']>;
  attachment?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  disk?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Nova_Field_Attachments_Sum_Fields = {
  __typename?: 'nova_field_attachments_sum_fields';
  attachable_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "nova_field_attachments" */
export enum Nova_Field_Attachments_Update_Column {
  /** column name */
  AttachableId = 'attachable_id',
  /** column name */
  AttachableType = 'attachable_type',
  /** column name */
  Attachment = 'attachment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Disk = 'disk',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url'
}

export type Nova_Field_Attachments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Nova_Field_Attachments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Nova_Field_Attachments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Nova_Field_Attachments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Nova_Field_Attachments_Var_Pop_Fields = {
  __typename?: 'nova_field_attachments_var_pop_fields';
  attachable_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Nova_Field_Attachments_Var_Samp_Fields = {
  __typename?: 'nova_field_attachments_var_samp_fields';
  attachable_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Nova_Field_Attachments_Variance_Fields = {
  __typename?: 'nova_field_attachments_variance_fields';
  attachable_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "nova_notifications" */
export type Nova_Notifications = {
  __typename?: 'nova_notifications';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  data: Scalars['String']['output'];
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  notifiable_id: Scalars['String']['output'];
  notifiable_type: Scalars['String']['output'];
  read_at?: Maybe<Scalars['timestamp']['output']>;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregated selection of "nova_notifications" */
export type Nova_Notifications_Aggregate = {
  __typename?: 'nova_notifications_aggregate';
  aggregate?: Maybe<Nova_Notifications_Aggregate_Fields>;
  nodes: Array<Nova_Notifications>;
};

/** aggregate fields of "nova_notifications" */
export type Nova_Notifications_Aggregate_Fields = {
  __typename?: 'nova_notifications_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Nova_Notifications_Max_Fields>;
  min?: Maybe<Nova_Notifications_Min_Fields>;
};


/** aggregate fields of "nova_notifications" */
export type Nova_Notifications_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Nova_Notifications_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "nova_notifications". All fields are combined with a logical 'AND'. */
export type Nova_Notifications_Bool_Exp = {
  _and?: InputMaybe<Array<Nova_Notifications_Bool_Exp>>;
  _not?: InputMaybe<Nova_Notifications_Bool_Exp>;
  _or?: InputMaybe<Array<Nova_Notifications_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  data?: InputMaybe<String_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  notifiable_id?: InputMaybe<String_Comparison_Exp>;
  notifiable_type?: InputMaybe<String_Comparison_Exp>;
  read_at?: InputMaybe<Timestamp_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "nova_notifications" */
export enum Nova_Notifications_Constraint {
  /** unique or primary key constraint on columns "id" */
  NovaNotificationsPkey = 'nova_notifications_pkey'
}

/** input type for inserting data into table "nova_notifications" */
export type Nova_Notifications_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  notifiable_id?: InputMaybe<Scalars['String']['input']>;
  notifiable_type?: InputMaybe<Scalars['String']['input']>;
  read_at?: InputMaybe<Scalars['timestamp']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Nova_Notifications_Max_Fields = {
  __typename?: 'nova_notifications_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  notifiable_id?: Maybe<Scalars['String']['output']>;
  notifiable_type?: Maybe<Scalars['String']['output']>;
  read_at?: Maybe<Scalars['timestamp']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Nova_Notifications_Min_Fields = {
  __typename?: 'nova_notifications_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  notifiable_id?: Maybe<Scalars['String']['output']>;
  notifiable_type?: Maybe<Scalars['String']['output']>;
  read_at?: Maybe<Scalars['timestamp']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "nova_notifications" */
export type Nova_Notifications_Mutation_Response = {
  __typename?: 'nova_notifications_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Nova_Notifications>;
};

/** on_conflict condition type for table "nova_notifications" */
export type Nova_Notifications_On_Conflict = {
  constraint: Nova_Notifications_Constraint;
  update_columns?: Array<Nova_Notifications_Update_Column>;
  where?: InputMaybe<Nova_Notifications_Bool_Exp>;
};

/** Ordering options when selecting data from "nova_notifications". */
export type Nova_Notifications_Order_By = {
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notifiable_id?: InputMaybe<Order_By>;
  notifiable_type?: InputMaybe<Order_By>;
  read_at?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: nova_notifications */
export type Nova_Notifications_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "nova_notifications" */
export enum Nova_Notifications_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  NotifiableId = 'notifiable_id',
  /** column name */
  NotifiableType = 'notifiable_type',
  /** column name */
  ReadAt = 'read_at',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "nova_notifications" */
export type Nova_Notifications_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  notifiable_id?: InputMaybe<Scalars['String']['input']>;
  notifiable_type?: InputMaybe<Scalars['String']['input']>;
  read_at?: InputMaybe<Scalars['timestamp']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "nova_notifications" */
export type Nova_Notifications_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Nova_Notifications_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Nova_Notifications_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  notifiable_id?: InputMaybe<Scalars['String']['input']>;
  notifiable_type?: InputMaybe<Scalars['String']['input']>;
  read_at?: InputMaybe<Scalars['timestamp']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "nova_notifications" */
export enum Nova_Notifications_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  NotifiableId = 'notifiable_id',
  /** column name */
  NotifiableType = 'notifiable_type',
  /** column name */
  ReadAt = 'read_at',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Nova_Notifications_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Nova_Notifications_Set_Input>;
  /** filter the rows which have to be updated */
  where: Nova_Notifications_Bool_Exp;
};

/** columns and relationships of "nova_pending_field_attachments" */
export type Nova_Pending_Field_Attachments = {
  __typename?: 'nova_pending_field_attachments';
  attachment: Scalars['String']['output'];
  created_at?: Maybe<Scalars['timestamp']['output']>;
  disk: Scalars['String']['output'];
  draft_id: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregated selection of "nova_pending_field_attachments" */
export type Nova_Pending_Field_Attachments_Aggregate = {
  __typename?: 'nova_pending_field_attachments_aggregate';
  aggregate?: Maybe<Nova_Pending_Field_Attachments_Aggregate_Fields>;
  nodes: Array<Nova_Pending_Field_Attachments>;
};

/** aggregate fields of "nova_pending_field_attachments" */
export type Nova_Pending_Field_Attachments_Aggregate_Fields = {
  __typename?: 'nova_pending_field_attachments_aggregate_fields';
  avg?: Maybe<Nova_Pending_Field_Attachments_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Nova_Pending_Field_Attachments_Max_Fields>;
  min?: Maybe<Nova_Pending_Field_Attachments_Min_Fields>;
  stddev?: Maybe<Nova_Pending_Field_Attachments_Stddev_Fields>;
  stddev_pop?: Maybe<Nova_Pending_Field_Attachments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Nova_Pending_Field_Attachments_Stddev_Samp_Fields>;
  sum?: Maybe<Nova_Pending_Field_Attachments_Sum_Fields>;
  var_pop?: Maybe<Nova_Pending_Field_Attachments_Var_Pop_Fields>;
  var_samp?: Maybe<Nova_Pending_Field_Attachments_Var_Samp_Fields>;
  variance?: Maybe<Nova_Pending_Field_Attachments_Variance_Fields>;
};


/** aggregate fields of "nova_pending_field_attachments" */
export type Nova_Pending_Field_Attachments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Nova_Pending_Field_Attachments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Nova_Pending_Field_Attachments_Avg_Fields = {
  __typename?: 'nova_pending_field_attachments_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "nova_pending_field_attachments". All fields are combined with a logical 'AND'. */
export type Nova_Pending_Field_Attachments_Bool_Exp = {
  _and?: InputMaybe<Array<Nova_Pending_Field_Attachments_Bool_Exp>>;
  _not?: InputMaybe<Nova_Pending_Field_Attachments_Bool_Exp>;
  _or?: InputMaybe<Array<Nova_Pending_Field_Attachments_Bool_Exp>>;
  attachment?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  disk?: InputMaybe<String_Comparison_Exp>;
  draft_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "nova_pending_field_attachments" */
export enum Nova_Pending_Field_Attachments_Constraint {
  /** unique or primary key constraint on columns "id" */
  NovaPendingFieldAttachmentsPkey = 'nova_pending_field_attachments_pkey'
}

/** input type for incrementing numeric columns in table "nova_pending_field_attachments" */
export type Nova_Pending_Field_Attachments_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "nova_pending_field_attachments" */
export type Nova_Pending_Field_Attachments_Insert_Input = {
  attachment?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  disk?: InputMaybe<Scalars['String']['input']>;
  draft_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Nova_Pending_Field_Attachments_Max_Fields = {
  __typename?: 'nova_pending_field_attachments_max_fields';
  attachment?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  disk?: Maybe<Scalars['String']['output']>;
  draft_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Nova_Pending_Field_Attachments_Min_Fields = {
  __typename?: 'nova_pending_field_attachments_min_fields';
  attachment?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  disk?: Maybe<Scalars['String']['output']>;
  draft_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "nova_pending_field_attachments" */
export type Nova_Pending_Field_Attachments_Mutation_Response = {
  __typename?: 'nova_pending_field_attachments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Nova_Pending_Field_Attachments>;
};

/** on_conflict condition type for table "nova_pending_field_attachments" */
export type Nova_Pending_Field_Attachments_On_Conflict = {
  constraint: Nova_Pending_Field_Attachments_Constraint;
  update_columns?: Array<Nova_Pending_Field_Attachments_Update_Column>;
  where?: InputMaybe<Nova_Pending_Field_Attachments_Bool_Exp>;
};

/** Ordering options when selecting data from "nova_pending_field_attachments". */
export type Nova_Pending_Field_Attachments_Order_By = {
  attachment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  disk?: InputMaybe<Order_By>;
  draft_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: nova_pending_field_attachments */
export type Nova_Pending_Field_Attachments_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "nova_pending_field_attachments" */
export enum Nova_Pending_Field_Attachments_Select_Column {
  /** column name */
  Attachment = 'attachment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Disk = 'disk',
  /** column name */
  DraftId = 'draft_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "nova_pending_field_attachments" */
export type Nova_Pending_Field_Attachments_Set_Input = {
  attachment?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  disk?: InputMaybe<Scalars['String']['input']>;
  draft_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Nova_Pending_Field_Attachments_Stddev_Fields = {
  __typename?: 'nova_pending_field_attachments_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Nova_Pending_Field_Attachments_Stddev_Pop_Fields = {
  __typename?: 'nova_pending_field_attachments_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Nova_Pending_Field_Attachments_Stddev_Samp_Fields = {
  __typename?: 'nova_pending_field_attachments_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "nova_pending_field_attachments" */
export type Nova_Pending_Field_Attachments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Nova_Pending_Field_Attachments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Nova_Pending_Field_Attachments_Stream_Cursor_Value_Input = {
  attachment?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  disk?: InputMaybe<Scalars['String']['input']>;
  draft_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Nova_Pending_Field_Attachments_Sum_Fields = {
  __typename?: 'nova_pending_field_attachments_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "nova_pending_field_attachments" */
export enum Nova_Pending_Field_Attachments_Update_Column {
  /** column name */
  Attachment = 'attachment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Disk = 'disk',
  /** column name */
  DraftId = 'draft_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Nova_Pending_Field_Attachments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Nova_Pending_Field_Attachments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Nova_Pending_Field_Attachments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Nova_Pending_Field_Attachments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Nova_Pending_Field_Attachments_Var_Pop_Fields = {
  __typename?: 'nova_pending_field_attachments_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Nova_Pending_Field_Attachments_Var_Samp_Fields = {
  __typename?: 'nova_pending_field_attachments_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Nova_Pending_Field_Attachments_Variance_Fields = {
  __typename?: 'nova_pending_field_attachments_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "nova_twofa" */
export type Nova_Twofa = {
  __typename?: 'nova_twofa';
  confirmed: Scalars['Boolean']['output'];
  created_at?: Maybe<Scalars['timestamp']['output']>;
  google2fa_enable: Scalars['Boolean']['output'];
  google2fa_secret?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  recovery?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['bpchar']['output'];
};

/** aggregated selection of "nova_twofa" */
export type Nova_Twofa_Aggregate = {
  __typename?: 'nova_twofa_aggregate';
  aggregate?: Maybe<Nova_Twofa_Aggregate_Fields>;
  nodes: Array<Nova_Twofa>;
};

export type Nova_Twofa_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Nova_Twofa_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Nova_Twofa_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Nova_Twofa_Aggregate_Bool_Exp_Count>;
};

export type Nova_Twofa_Aggregate_Bool_Exp_Bool_And = {
  arguments: Nova_Twofa_Select_Column_Nova_Twofa_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Nova_Twofa_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Nova_Twofa_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Nova_Twofa_Select_Column_Nova_Twofa_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Nova_Twofa_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Nova_Twofa_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Nova_Twofa_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Nova_Twofa_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "nova_twofa" */
export type Nova_Twofa_Aggregate_Fields = {
  __typename?: 'nova_twofa_aggregate_fields';
  avg?: Maybe<Nova_Twofa_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Nova_Twofa_Max_Fields>;
  min?: Maybe<Nova_Twofa_Min_Fields>;
  stddev?: Maybe<Nova_Twofa_Stddev_Fields>;
  stddev_pop?: Maybe<Nova_Twofa_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Nova_Twofa_Stddev_Samp_Fields>;
  sum?: Maybe<Nova_Twofa_Sum_Fields>;
  var_pop?: Maybe<Nova_Twofa_Var_Pop_Fields>;
  var_samp?: Maybe<Nova_Twofa_Var_Samp_Fields>;
  variance?: Maybe<Nova_Twofa_Variance_Fields>;
};


/** aggregate fields of "nova_twofa" */
export type Nova_Twofa_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Nova_Twofa_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "nova_twofa" */
export type Nova_Twofa_Aggregate_Order_By = {
  avg?: InputMaybe<Nova_Twofa_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Nova_Twofa_Max_Order_By>;
  min?: InputMaybe<Nova_Twofa_Min_Order_By>;
  stddev?: InputMaybe<Nova_Twofa_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Nova_Twofa_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Nova_Twofa_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Nova_Twofa_Sum_Order_By>;
  var_pop?: InputMaybe<Nova_Twofa_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Nova_Twofa_Var_Samp_Order_By>;
  variance?: InputMaybe<Nova_Twofa_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "nova_twofa" */
export type Nova_Twofa_Arr_Rel_Insert_Input = {
  data: Array<Nova_Twofa_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Nova_Twofa_On_Conflict>;
};

/** aggregate avg on columns */
export type Nova_Twofa_Avg_Fields = {
  __typename?: 'nova_twofa_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "nova_twofa" */
export type Nova_Twofa_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "nova_twofa". All fields are combined with a logical 'AND'. */
export type Nova_Twofa_Bool_Exp = {
  _and?: InputMaybe<Array<Nova_Twofa_Bool_Exp>>;
  _not?: InputMaybe<Nova_Twofa_Bool_Exp>;
  _or?: InputMaybe<Array<Nova_Twofa_Bool_Exp>>;
  confirmed?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  google2fa_enable?: InputMaybe<Boolean_Comparison_Exp>;
  google2fa_secret?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  recovery?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "nova_twofa" */
export enum Nova_Twofa_Constraint {
  /** unique or primary key constraint on columns "id" */
  NovaTwofaPkey = 'nova_twofa_pkey'
}

/** input type for incrementing numeric columns in table "nova_twofa" */
export type Nova_Twofa_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "nova_twofa" */
export type Nova_Twofa_Insert_Input = {
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  google2fa_enable?: InputMaybe<Scalars['Boolean']['input']>;
  google2fa_secret?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  recovery?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Nova_Twofa_Max_Fields = {
  __typename?: 'nova_twofa_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  google2fa_secret?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  recovery?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by max() on columns of table "nova_twofa" */
export type Nova_Twofa_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  google2fa_secret?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  recovery?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Nova_Twofa_Min_Fields = {
  __typename?: 'nova_twofa_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  google2fa_secret?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  recovery?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by min() on columns of table "nova_twofa" */
export type Nova_Twofa_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  google2fa_secret?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  recovery?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "nova_twofa" */
export type Nova_Twofa_Mutation_Response = {
  __typename?: 'nova_twofa_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Nova_Twofa>;
};

/** on_conflict condition type for table "nova_twofa" */
export type Nova_Twofa_On_Conflict = {
  constraint: Nova_Twofa_Constraint;
  update_columns?: Array<Nova_Twofa_Update_Column>;
  where?: InputMaybe<Nova_Twofa_Bool_Exp>;
};

/** Ordering options when selecting data from "nova_twofa". */
export type Nova_Twofa_Order_By = {
  confirmed?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  google2fa_enable?: InputMaybe<Order_By>;
  google2fa_secret?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  recovery?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: nova_twofa */
export type Nova_Twofa_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "nova_twofa" */
export enum Nova_Twofa_Select_Column {
  /** column name */
  Confirmed = 'confirmed',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Google2faEnable = 'google2fa_enable',
  /** column name */
  Google2faSecret = 'google2fa_secret',
  /** column name */
  Id = 'id',
  /** column name */
  Recovery = 'recovery',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "nova_twofa_aggregate_bool_exp_bool_and_arguments_columns" columns of table "nova_twofa" */
export enum Nova_Twofa_Select_Column_Nova_Twofa_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Confirmed = 'confirmed',
  /** column name */
  Google2faEnable = 'google2fa_enable'
}

/** select "nova_twofa_aggregate_bool_exp_bool_or_arguments_columns" columns of table "nova_twofa" */
export enum Nova_Twofa_Select_Column_Nova_Twofa_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Confirmed = 'confirmed',
  /** column name */
  Google2faEnable = 'google2fa_enable'
}

/** input type for updating data in table "nova_twofa" */
export type Nova_Twofa_Set_Input = {
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  google2fa_enable?: InputMaybe<Scalars['Boolean']['input']>;
  google2fa_secret?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  recovery?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate stddev on columns */
export type Nova_Twofa_Stddev_Fields = {
  __typename?: 'nova_twofa_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "nova_twofa" */
export type Nova_Twofa_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Nova_Twofa_Stddev_Pop_Fields = {
  __typename?: 'nova_twofa_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "nova_twofa" */
export type Nova_Twofa_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Nova_Twofa_Stddev_Samp_Fields = {
  __typename?: 'nova_twofa_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "nova_twofa" */
export type Nova_Twofa_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "nova_twofa" */
export type Nova_Twofa_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Nova_Twofa_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Nova_Twofa_Stream_Cursor_Value_Input = {
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  google2fa_enable?: InputMaybe<Scalars['Boolean']['input']>;
  google2fa_secret?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  recovery?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate sum on columns */
export type Nova_Twofa_Sum_Fields = {
  __typename?: 'nova_twofa_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "nova_twofa" */
export type Nova_Twofa_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "nova_twofa" */
export enum Nova_Twofa_Update_Column {
  /** column name */
  Confirmed = 'confirmed',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Google2faEnable = 'google2fa_enable',
  /** column name */
  Google2faSecret = 'google2fa_secret',
  /** column name */
  Id = 'id',
  /** column name */
  Recovery = 'recovery',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Nova_Twofa_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Nova_Twofa_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Nova_Twofa_Set_Input>;
  /** filter the rows which have to be updated */
  where: Nova_Twofa_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Nova_Twofa_Var_Pop_Fields = {
  __typename?: 'nova_twofa_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "nova_twofa" */
export type Nova_Twofa_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Nova_Twofa_Var_Samp_Fields = {
  __typename?: 'nova_twofa_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "nova_twofa" */
export type Nova_Twofa_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Nova_Twofa_Variance_Fields = {
  __typename?: 'nova_twofa_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "nova_twofa" */
export type Nova_Twofa_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "pairing_codes" */
export type Pairing_Codes = {
  __typename?: 'pairing_codes';
  account_id: Scalars['bpchar']['output'];
  account_user_id: Scalars['bpchar']['output'];
  code_creator_user_id: Scalars['bpchar']['output'];
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  farmer_user_id: Scalars['bpchar']['output'];
  field_partner_user_id: Scalars['bpchar']['output'];
  id: Scalars['bpchar']['output'];
  pairing_code: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregated selection of "pairing_codes" */
export type Pairing_Codes_Aggregate = {
  __typename?: 'pairing_codes_aggregate';
  aggregate?: Maybe<Pairing_Codes_Aggregate_Fields>;
  nodes: Array<Pairing_Codes>;
};

/** aggregate fields of "pairing_codes" */
export type Pairing_Codes_Aggregate_Fields = {
  __typename?: 'pairing_codes_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Pairing_Codes_Max_Fields>;
  min?: Maybe<Pairing_Codes_Min_Fields>;
};


/** aggregate fields of "pairing_codes" */
export type Pairing_Codes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pairing_Codes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "pairing_codes". All fields are combined with a logical 'AND'. */
export type Pairing_Codes_Bool_Exp = {
  _and?: InputMaybe<Array<Pairing_Codes_Bool_Exp>>;
  _not?: InputMaybe<Pairing_Codes_Bool_Exp>;
  _or?: InputMaybe<Array<Pairing_Codes_Bool_Exp>>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  account_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  code_creator_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  farmer_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  field_partner_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  pairing_code?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "pairing_codes" */
export enum Pairing_Codes_Constraint {
  /** unique or primary key constraint on columns "pairing_code" */
  PairingCodesPairingCodeUnique = 'pairing_codes_pairing_code_unique',
  /** unique or primary key constraint on columns "id" */
  PairingCodesPk = 'pairing_codes_pk'
}

/** input type for inserting data into table "pairing_codes" */
export type Pairing_Codes_Insert_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  account_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  code_creator_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  farmer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  field_partner_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  pairing_code?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Pairing_Codes_Max_Fields = {
  __typename?: 'pairing_codes_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  account_user_id?: Maybe<Scalars['bpchar']['output']>;
  code_creator_user_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  farmer_user_id?: Maybe<Scalars['bpchar']['output']>;
  field_partner_user_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  pairing_code?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Pairing_Codes_Min_Fields = {
  __typename?: 'pairing_codes_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  account_user_id?: Maybe<Scalars['bpchar']['output']>;
  code_creator_user_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  farmer_user_id?: Maybe<Scalars['bpchar']['output']>;
  field_partner_user_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  pairing_code?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "pairing_codes" */
export type Pairing_Codes_Mutation_Response = {
  __typename?: 'pairing_codes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Pairing_Codes>;
};

/** on_conflict condition type for table "pairing_codes" */
export type Pairing_Codes_On_Conflict = {
  constraint: Pairing_Codes_Constraint;
  update_columns?: Array<Pairing_Codes_Update_Column>;
  where?: InputMaybe<Pairing_Codes_Bool_Exp>;
};

/** Ordering options when selecting data from "pairing_codes". */
export type Pairing_Codes_Order_By = {
  account_id?: InputMaybe<Order_By>;
  account_user_id?: InputMaybe<Order_By>;
  code_creator_user_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  farmer_user_id?: InputMaybe<Order_By>;
  field_partner_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pairing_code?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pairing_codes */
export type Pairing_Codes_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** select columns of table "pairing_codes" */
export enum Pairing_Codes_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AccountUserId = 'account_user_id',
  /** column name */
  CodeCreatorUserId = 'code_creator_user_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FarmerUserId = 'farmer_user_id',
  /** column name */
  FieldPartnerUserId = 'field_partner_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  PairingCode = 'pairing_code',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "pairing_codes" */
export type Pairing_Codes_Set_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  account_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  code_creator_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  farmer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  field_partner_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  pairing_code?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "pairing_codes" */
export type Pairing_Codes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pairing_Codes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pairing_Codes_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  account_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  code_creator_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  farmer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  field_partner_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  pairing_code?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "pairing_codes" */
export enum Pairing_Codes_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AccountUserId = 'account_user_id',
  /** column name */
  CodeCreatorUserId = 'code_creator_user_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FarmerUserId = 'farmer_user_id',
  /** column name */
  FieldPartnerUserId = 'field_partner_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  PairingCode = 'pairing_code',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Pairing_Codes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pairing_Codes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pairing_Codes_Bool_Exp;
};

/** columns and relationships of "password_reset_tokens" */
export type Password_Reset_Tokens = {
  __typename?: 'password_reset_tokens';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  email: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

/** aggregated selection of "password_reset_tokens" */
export type Password_Reset_Tokens_Aggregate = {
  __typename?: 'password_reset_tokens_aggregate';
  aggregate?: Maybe<Password_Reset_Tokens_Aggregate_Fields>;
  nodes: Array<Password_Reset_Tokens>;
};

/** aggregate fields of "password_reset_tokens" */
export type Password_Reset_Tokens_Aggregate_Fields = {
  __typename?: 'password_reset_tokens_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Password_Reset_Tokens_Max_Fields>;
  min?: Maybe<Password_Reset_Tokens_Min_Fields>;
};


/** aggregate fields of "password_reset_tokens" */
export type Password_Reset_Tokens_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Password_Reset_Tokens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "password_reset_tokens". All fields are combined with a logical 'AND'. */
export type Password_Reset_Tokens_Bool_Exp = {
  _and?: InputMaybe<Array<Password_Reset_Tokens_Bool_Exp>>;
  _not?: InputMaybe<Password_Reset_Tokens_Bool_Exp>;
  _or?: InputMaybe<Array<Password_Reset_Tokens_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  token?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "password_reset_tokens" */
export enum Password_Reset_Tokens_Constraint {
  /** unique or primary key constraint on columns "email" */
  PasswordResetTokensPkey = 'password_reset_tokens_pkey'
}

/** input type for inserting data into table "password_reset_tokens" */
export type Password_Reset_Tokens_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Password_Reset_Tokens_Max_Fields = {
  __typename?: 'password_reset_tokens_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Password_Reset_Tokens_Min_Fields = {
  __typename?: 'password_reset_tokens_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "password_reset_tokens" */
export type Password_Reset_Tokens_Mutation_Response = {
  __typename?: 'password_reset_tokens_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Password_Reset_Tokens>;
};

/** on_conflict condition type for table "password_reset_tokens" */
export type Password_Reset_Tokens_On_Conflict = {
  constraint: Password_Reset_Tokens_Constraint;
  update_columns?: Array<Password_Reset_Tokens_Update_Column>;
  where?: InputMaybe<Password_Reset_Tokens_Bool_Exp>;
};

/** Ordering options when selecting data from "password_reset_tokens". */
export type Password_Reset_Tokens_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
};

/** primary key columns input for table: password_reset_tokens */
export type Password_Reset_Tokens_Pk_Columns_Input = {
  email: Scalars['String']['input'];
};

/** select columns of table "password_reset_tokens" */
export enum Password_Reset_Tokens_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Token = 'token'
}

/** input type for updating data in table "password_reset_tokens" */
export type Password_Reset_Tokens_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "password_reset_tokens" */
export type Password_Reset_Tokens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Password_Reset_Tokens_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Password_Reset_Tokens_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "password_reset_tokens" */
export enum Password_Reset_Tokens_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Token = 'token'
}

export type Password_Reset_Tokens_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Password_Reset_Tokens_Set_Input>;
  /** filter the rows which have to be updated */
  where: Password_Reset_Tokens_Bool_Exp;
};

/** columns and relationships of "permissions" */
export type Permissions = {
  __typename?: 'permissions';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  guard_name: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
  /** An array relationship */
  model_has_permissions: Array<Model_Has_Permissions>;
  /** An aggregate relationship */
  model_has_permissions_aggregate: Model_Has_Permissions_Aggregate;
  name: Scalars['String']['output'];
  /** An array relationship */
  role_has_permissions: Array<Role_Has_Permissions>;
  /** An aggregate relationship */
  role_has_permissions_aggregate: Role_Has_Permissions_Aggregate;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};


/** columns and relationships of "permissions" */
export type PermissionsModel_Has_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Model_Has_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Has_Permissions_Order_By>>;
  where?: InputMaybe<Model_Has_Permissions_Bool_Exp>;
};


/** columns and relationships of "permissions" */
export type PermissionsModel_Has_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Model_Has_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Has_Permissions_Order_By>>;
  where?: InputMaybe<Model_Has_Permissions_Bool_Exp>;
};


/** columns and relationships of "permissions" */
export type PermissionsRole_Has_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Role_Has_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_Has_Permissions_Order_By>>;
  where?: InputMaybe<Role_Has_Permissions_Bool_Exp>;
};


/** columns and relationships of "permissions" */
export type PermissionsRole_Has_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_Has_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_Has_Permissions_Order_By>>;
  where?: InputMaybe<Role_Has_Permissions_Bool_Exp>;
};

/** aggregated selection of "permissions" */
export type Permissions_Aggregate = {
  __typename?: 'permissions_aggregate';
  aggregate?: Maybe<Permissions_Aggregate_Fields>;
  nodes: Array<Permissions>;
};

/** aggregate fields of "permissions" */
export type Permissions_Aggregate_Fields = {
  __typename?: 'permissions_aggregate_fields';
  avg?: Maybe<Permissions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Permissions_Max_Fields>;
  min?: Maybe<Permissions_Min_Fields>;
  stddev?: Maybe<Permissions_Stddev_Fields>;
  stddev_pop?: Maybe<Permissions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Permissions_Stddev_Samp_Fields>;
  sum?: Maybe<Permissions_Sum_Fields>;
  var_pop?: Maybe<Permissions_Var_Pop_Fields>;
  var_samp?: Maybe<Permissions_Var_Samp_Fields>;
  variance?: Maybe<Permissions_Variance_Fields>;
};


/** aggregate fields of "permissions" */
export type Permissions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Permissions_Avg_Fields = {
  __typename?: 'permissions_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "permissions". All fields are combined with a logical 'AND'. */
export type Permissions_Bool_Exp = {
  _and?: InputMaybe<Array<Permissions_Bool_Exp>>;
  _not?: InputMaybe<Permissions_Bool_Exp>;
  _or?: InputMaybe<Array<Permissions_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  guard_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  model_has_permissions?: InputMaybe<Model_Has_Permissions_Bool_Exp>;
  model_has_permissions_aggregate?: InputMaybe<Model_Has_Permissions_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  role_has_permissions?: InputMaybe<Role_Has_Permissions_Bool_Exp>;
  role_has_permissions_aggregate?: InputMaybe<Role_Has_Permissions_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "permissions" */
export enum Permissions_Constraint {
  /** unique or primary key constraint on columns "name", "guard_name" */
  PermissionsNameGuardNameUnique = 'permissions_name_guard_name_unique',
  /** unique or primary key constraint on columns "id" */
  PermissionsPkey = 'permissions_pkey'
}

/** input type for incrementing numeric columns in table "permissions" */
export type Permissions_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "permissions" */
export type Permissions_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  guard_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  model_has_permissions?: InputMaybe<Model_Has_Permissions_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  role_has_permissions?: InputMaybe<Role_Has_Permissions_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Permissions_Max_Fields = {
  __typename?: 'permissions_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  guard_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Permissions_Min_Fields = {
  __typename?: 'permissions_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  guard_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "permissions" */
export type Permissions_Mutation_Response = {
  __typename?: 'permissions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Permissions>;
};

/** input type for inserting object relation for remote table "permissions" */
export type Permissions_Obj_Rel_Insert_Input = {
  data: Permissions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Permissions_On_Conflict>;
};

/** on_conflict condition type for table "permissions" */
export type Permissions_On_Conflict = {
  constraint: Permissions_Constraint;
  update_columns?: Array<Permissions_Update_Column>;
  where?: InputMaybe<Permissions_Bool_Exp>;
};

/** Ordering options when selecting data from "permissions". */
export type Permissions_Order_By = {
  created_at?: InputMaybe<Order_By>;
  guard_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  model_has_permissions_aggregate?: InputMaybe<Model_Has_Permissions_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  role_has_permissions_aggregate?: InputMaybe<Role_Has_Permissions_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: permissions */
export type Permissions_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "permissions" */
export enum Permissions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GuardName = 'guard_name',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "permissions" */
export type Permissions_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  guard_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Permissions_Stddev_Fields = {
  __typename?: 'permissions_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Permissions_Stddev_Pop_Fields = {
  __typename?: 'permissions_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Permissions_Stddev_Samp_Fields = {
  __typename?: 'permissions_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "permissions" */
export type Permissions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Permissions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Permissions_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  guard_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Permissions_Sum_Fields = {
  __typename?: 'permissions_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "permissions" */
export enum Permissions_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GuardName = 'guard_name',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Permissions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Permissions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Permissions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Permissions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Permissions_Var_Pop_Fields = {
  __typename?: 'permissions_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Permissions_Var_Samp_Fields = {
  __typename?: 'permissions_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Permissions_Variance_Fields = {
  __typename?: 'permissions_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "personal_access_tokens" */
export type Personal_Access_Tokens = {
  __typename?: 'personal_access_tokens';
  abilities?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  expires_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['bigint']['output'];
  last_used_at?: Maybe<Scalars['timestamp']['output']>;
  name: Scalars['String']['output'];
  token: Scalars['String']['output'];
  tokenable_id: Scalars['bigint']['output'];
  tokenable_type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregated selection of "personal_access_tokens" */
export type Personal_Access_Tokens_Aggregate = {
  __typename?: 'personal_access_tokens_aggregate';
  aggregate?: Maybe<Personal_Access_Tokens_Aggregate_Fields>;
  nodes: Array<Personal_Access_Tokens>;
};

/** aggregate fields of "personal_access_tokens" */
export type Personal_Access_Tokens_Aggregate_Fields = {
  __typename?: 'personal_access_tokens_aggregate_fields';
  avg?: Maybe<Personal_Access_Tokens_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Personal_Access_Tokens_Max_Fields>;
  min?: Maybe<Personal_Access_Tokens_Min_Fields>;
  stddev?: Maybe<Personal_Access_Tokens_Stddev_Fields>;
  stddev_pop?: Maybe<Personal_Access_Tokens_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Personal_Access_Tokens_Stddev_Samp_Fields>;
  sum?: Maybe<Personal_Access_Tokens_Sum_Fields>;
  var_pop?: Maybe<Personal_Access_Tokens_Var_Pop_Fields>;
  var_samp?: Maybe<Personal_Access_Tokens_Var_Samp_Fields>;
  variance?: Maybe<Personal_Access_Tokens_Variance_Fields>;
};


/** aggregate fields of "personal_access_tokens" */
export type Personal_Access_Tokens_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Personal_Access_Tokens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Personal_Access_Tokens_Avg_Fields = {
  __typename?: 'personal_access_tokens_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  tokenable_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "personal_access_tokens". All fields are combined with a logical 'AND'. */
export type Personal_Access_Tokens_Bool_Exp = {
  _and?: InputMaybe<Array<Personal_Access_Tokens_Bool_Exp>>;
  _not?: InputMaybe<Personal_Access_Tokens_Bool_Exp>;
  _or?: InputMaybe<Array<Personal_Access_Tokens_Bool_Exp>>;
  abilities?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  expires_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  last_used_at?: InputMaybe<Timestamp_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  token?: InputMaybe<String_Comparison_Exp>;
  tokenable_id?: InputMaybe<Bigint_Comparison_Exp>;
  tokenable_type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "personal_access_tokens" */
export enum Personal_Access_Tokens_Constraint {
  /** unique or primary key constraint on columns "id" */
  PersonalAccessTokensPkey = 'personal_access_tokens_pkey',
  /** unique or primary key constraint on columns "token" */
  PersonalAccessTokensTokenUnique = 'personal_access_tokens_token_unique'
}

/** input type for incrementing numeric columns in table "personal_access_tokens" */
export type Personal_Access_Tokens_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  tokenable_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "personal_access_tokens" */
export type Personal_Access_Tokens_Insert_Input = {
  abilities?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  expires_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_used_at?: InputMaybe<Scalars['timestamp']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  tokenable_id?: InputMaybe<Scalars['bigint']['input']>;
  tokenable_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Personal_Access_Tokens_Max_Fields = {
  __typename?: 'personal_access_tokens_max_fields';
  abilities?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  expires_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_used_at?: Maybe<Scalars['timestamp']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  tokenable_id?: Maybe<Scalars['bigint']['output']>;
  tokenable_type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Personal_Access_Tokens_Min_Fields = {
  __typename?: 'personal_access_tokens_min_fields';
  abilities?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  expires_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_used_at?: Maybe<Scalars['timestamp']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  tokenable_id?: Maybe<Scalars['bigint']['output']>;
  tokenable_type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "personal_access_tokens" */
export type Personal_Access_Tokens_Mutation_Response = {
  __typename?: 'personal_access_tokens_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Personal_Access_Tokens>;
};

/** on_conflict condition type for table "personal_access_tokens" */
export type Personal_Access_Tokens_On_Conflict = {
  constraint: Personal_Access_Tokens_Constraint;
  update_columns?: Array<Personal_Access_Tokens_Update_Column>;
  where?: InputMaybe<Personal_Access_Tokens_Bool_Exp>;
};

/** Ordering options when selecting data from "personal_access_tokens". */
export type Personal_Access_Tokens_Order_By = {
  abilities?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_used_at?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  tokenable_id?: InputMaybe<Order_By>;
  tokenable_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: personal_access_tokens */
export type Personal_Access_Tokens_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "personal_access_tokens" */
export enum Personal_Access_Tokens_Select_Column {
  /** column name */
  Abilities = 'abilities',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastUsedAt = 'last_used_at',
  /** column name */
  Name = 'name',
  /** column name */
  Token = 'token',
  /** column name */
  TokenableId = 'tokenable_id',
  /** column name */
  TokenableType = 'tokenable_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "personal_access_tokens" */
export type Personal_Access_Tokens_Set_Input = {
  abilities?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  expires_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_used_at?: InputMaybe<Scalars['timestamp']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  tokenable_id?: InputMaybe<Scalars['bigint']['input']>;
  tokenable_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Personal_Access_Tokens_Stddev_Fields = {
  __typename?: 'personal_access_tokens_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  tokenable_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Personal_Access_Tokens_Stddev_Pop_Fields = {
  __typename?: 'personal_access_tokens_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  tokenable_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Personal_Access_Tokens_Stddev_Samp_Fields = {
  __typename?: 'personal_access_tokens_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  tokenable_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "personal_access_tokens" */
export type Personal_Access_Tokens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Personal_Access_Tokens_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Personal_Access_Tokens_Stream_Cursor_Value_Input = {
  abilities?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  expires_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_used_at?: InputMaybe<Scalars['timestamp']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  tokenable_id?: InputMaybe<Scalars['bigint']['input']>;
  tokenable_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Personal_Access_Tokens_Sum_Fields = {
  __typename?: 'personal_access_tokens_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  tokenable_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "personal_access_tokens" */
export enum Personal_Access_Tokens_Update_Column {
  /** column name */
  Abilities = 'abilities',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastUsedAt = 'last_used_at',
  /** column name */
  Name = 'name',
  /** column name */
  Token = 'token',
  /** column name */
  TokenableId = 'tokenable_id',
  /** column name */
  TokenableType = 'tokenable_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Personal_Access_Tokens_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Personal_Access_Tokens_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Personal_Access_Tokens_Set_Input>;
  /** filter the rows which have to be updated */
  where: Personal_Access_Tokens_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Personal_Access_Tokens_Var_Pop_Fields = {
  __typename?: 'personal_access_tokens_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  tokenable_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Personal_Access_Tokens_Var_Samp_Fields = {
  __typename?: 'personal_access_tokens_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  tokenable_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Personal_Access_Tokens_Variance_Fields = {
  __typename?: 'personal_access_tokens_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  tokenable_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "personal_dashboard" */
export type Personal_Dashboard = {
  __typename?: 'personal_dashboard';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  farmer_closed: Scalars['Int']['output'];
  farmer_in_progress: Scalars['Int']['output'];
  farmer_total_requests: Scalars['Int']['output'];
  ff_accepted_requests: Scalars['Int']['output'];
  ff_completed_on_time_requests: Scalars['Int']['output'];
  ff_completed_requests: Scalars['Int']['output'];
  ff_rejected_requests: Scalars['Int']['output'];
  id: Scalars['bpchar']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id: Scalars['bpchar']['output'];
};

/** aggregated selection of "personal_dashboard" */
export type Personal_Dashboard_Aggregate = {
  __typename?: 'personal_dashboard_aggregate';
  aggregate?: Maybe<Personal_Dashboard_Aggregate_Fields>;
  nodes: Array<Personal_Dashboard>;
};

/** aggregate fields of "personal_dashboard" */
export type Personal_Dashboard_Aggregate_Fields = {
  __typename?: 'personal_dashboard_aggregate_fields';
  avg?: Maybe<Personal_Dashboard_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Personal_Dashboard_Max_Fields>;
  min?: Maybe<Personal_Dashboard_Min_Fields>;
  stddev?: Maybe<Personal_Dashboard_Stddev_Fields>;
  stddev_pop?: Maybe<Personal_Dashboard_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Personal_Dashboard_Stddev_Samp_Fields>;
  sum?: Maybe<Personal_Dashboard_Sum_Fields>;
  var_pop?: Maybe<Personal_Dashboard_Var_Pop_Fields>;
  var_samp?: Maybe<Personal_Dashboard_Var_Samp_Fields>;
  variance?: Maybe<Personal_Dashboard_Variance_Fields>;
};


/** aggregate fields of "personal_dashboard" */
export type Personal_Dashboard_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Personal_Dashboard_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Personal_Dashboard_Avg_Fields = {
  __typename?: 'personal_dashboard_avg_fields';
  farmer_closed?: Maybe<Scalars['Float']['output']>;
  farmer_in_progress?: Maybe<Scalars['Float']['output']>;
  farmer_total_requests?: Maybe<Scalars['Float']['output']>;
  ff_accepted_requests?: Maybe<Scalars['Float']['output']>;
  ff_completed_on_time_requests?: Maybe<Scalars['Float']['output']>;
  ff_completed_requests?: Maybe<Scalars['Float']['output']>;
  ff_rejected_requests?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "personal_dashboard". All fields are combined with a logical 'AND'. */
export type Personal_Dashboard_Bool_Exp = {
  _and?: InputMaybe<Array<Personal_Dashboard_Bool_Exp>>;
  _not?: InputMaybe<Personal_Dashboard_Bool_Exp>;
  _or?: InputMaybe<Array<Personal_Dashboard_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  farmer_closed?: InputMaybe<Int_Comparison_Exp>;
  farmer_in_progress?: InputMaybe<Int_Comparison_Exp>;
  farmer_total_requests?: InputMaybe<Int_Comparison_Exp>;
  ff_accepted_requests?: InputMaybe<Int_Comparison_Exp>;
  ff_completed_on_time_requests?: InputMaybe<Int_Comparison_Exp>;
  ff_completed_requests?: InputMaybe<Int_Comparison_Exp>;
  ff_rejected_requests?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "personal_dashboard" */
export enum Personal_Dashboard_Constraint {
  /** unique or primary key constraint on columns "id" */
  PersonalDashboardPkey = 'personal_dashboard_pkey'
}

/** input type for incrementing numeric columns in table "personal_dashboard" */
export type Personal_Dashboard_Inc_Input = {
  farmer_closed?: InputMaybe<Scalars['Int']['input']>;
  farmer_in_progress?: InputMaybe<Scalars['Int']['input']>;
  farmer_total_requests?: InputMaybe<Scalars['Int']['input']>;
  ff_accepted_requests?: InputMaybe<Scalars['Int']['input']>;
  ff_completed_on_time_requests?: InputMaybe<Scalars['Int']['input']>;
  ff_completed_requests?: InputMaybe<Scalars['Int']['input']>;
  ff_rejected_requests?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "personal_dashboard" */
export type Personal_Dashboard_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer_closed?: InputMaybe<Scalars['Int']['input']>;
  farmer_in_progress?: InputMaybe<Scalars['Int']['input']>;
  farmer_total_requests?: InputMaybe<Scalars['Int']['input']>;
  ff_accepted_requests?: InputMaybe<Scalars['Int']['input']>;
  ff_completed_on_time_requests?: InputMaybe<Scalars['Int']['input']>;
  ff_completed_requests?: InputMaybe<Scalars['Int']['input']>;
  ff_rejected_requests?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Personal_Dashboard_Max_Fields = {
  __typename?: 'personal_dashboard_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  farmer_closed?: Maybe<Scalars['Int']['output']>;
  farmer_in_progress?: Maybe<Scalars['Int']['output']>;
  farmer_total_requests?: Maybe<Scalars['Int']['output']>;
  ff_accepted_requests?: Maybe<Scalars['Int']['output']>;
  ff_completed_on_time_requests?: Maybe<Scalars['Int']['output']>;
  ff_completed_requests?: Maybe<Scalars['Int']['output']>;
  ff_rejected_requests?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** aggregate min on columns */
export type Personal_Dashboard_Min_Fields = {
  __typename?: 'personal_dashboard_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  farmer_closed?: Maybe<Scalars['Int']['output']>;
  farmer_in_progress?: Maybe<Scalars['Int']['output']>;
  farmer_total_requests?: Maybe<Scalars['Int']['output']>;
  ff_accepted_requests?: Maybe<Scalars['Int']['output']>;
  ff_completed_on_time_requests?: Maybe<Scalars['Int']['output']>;
  ff_completed_requests?: Maybe<Scalars['Int']['output']>;
  ff_rejected_requests?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** response of any mutation on the table "personal_dashboard" */
export type Personal_Dashboard_Mutation_Response = {
  __typename?: 'personal_dashboard_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Personal_Dashboard>;
};

/** on_conflict condition type for table "personal_dashboard" */
export type Personal_Dashboard_On_Conflict = {
  constraint: Personal_Dashboard_Constraint;
  update_columns?: Array<Personal_Dashboard_Update_Column>;
  where?: InputMaybe<Personal_Dashboard_Bool_Exp>;
};

/** Ordering options when selecting data from "personal_dashboard". */
export type Personal_Dashboard_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  farmer_closed?: InputMaybe<Order_By>;
  farmer_in_progress?: InputMaybe<Order_By>;
  farmer_total_requests?: InputMaybe<Order_By>;
  ff_accepted_requests?: InputMaybe<Order_By>;
  ff_completed_on_time_requests?: InputMaybe<Order_By>;
  ff_completed_requests?: InputMaybe<Order_By>;
  ff_rejected_requests?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: personal_dashboard */
export type Personal_Dashboard_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** select columns of table "personal_dashboard" */
export enum Personal_Dashboard_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FarmerClosed = 'farmer_closed',
  /** column name */
  FarmerInProgress = 'farmer_in_progress',
  /** column name */
  FarmerTotalRequests = 'farmer_total_requests',
  /** column name */
  FfAcceptedRequests = 'ff_accepted_requests',
  /** column name */
  FfCompletedOnTimeRequests = 'ff_completed_on_time_requests',
  /** column name */
  FfCompletedRequests = 'ff_completed_requests',
  /** column name */
  FfRejectedRequests = 'ff_rejected_requests',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "personal_dashboard" */
export type Personal_Dashboard_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer_closed?: InputMaybe<Scalars['Int']['input']>;
  farmer_in_progress?: InputMaybe<Scalars['Int']['input']>;
  farmer_total_requests?: InputMaybe<Scalars['Int']['input']>;
  ff_accepted_requests?: InputMaybe<Scalars['Int']['input']>;
  ff_completed_on_time_requests?: InputMaybe<Scalars['Int']['input']>;
  ff_completed_requests?: InputMaybe<Scalars['Int']['input']>;
  ff_rejected_requests?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate stddev on columns */
export type Personal_Dashboard_Stddev_Fields = {
  __typename?: 'personal_dashboard_stddev_fields';
  farmer_closed?: Maybe<Scalars['Float']['output']>;
  farmer_in_progress?: Maybe<Scalars['Float']['output']>;
  farmer_total_requests?: Maybe<Scalars['Float']['output']>;
  ff_accepted_requests?: Maybe<Scalars['Float']['output']>;
  ff_completed_on_time_requests?: Maybe<Scalars['Float']['output']>;
  ff_completed_requests?: Maybe<Scalars['Float']['output']>;
  ff_rejected_requests?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Personal_Dashboard_Stddev_Pop_Fields = {
  __typename?: 'personal_dashboard_stddev_pop_fields';
  farmer_closed?: Maybe<Scalars['Float']['output']>;
  farmer_in_progress?: Maybe<Scalars['Float']['output']>;
  farmer_total_requests?: Maybe<Scalars['Float']['output']>;
  ff_accepted_requests?: Maybe<Scalars['Float']['output']>;
  ff_completed_on_time_requests?: Maybe<Scalars['Float']['output']>;
  ff_completed_requests?: Maybe<Scalars['Float']['output']>;
  ff_rejected_requests?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Personal_Dashboard_Stddev_Samp_Fields = {
  __typename?: 'personal_dashboard_stddev_samp_fields';
  farmer_closed?: Maybe<Scalars['Float']['output']>;
  farmer_in_progress?: Maybe<Scalars['Float']['output']>;
  farmer_total_requests?: Maybe<Scalars['Float']['output']>;
  ff_accepted_requests?: Maybe<Scalars['Float']['output']>;
  ff_completed_on_time_requests?: Maybe<Scalars['Float']['output']>;
  ff_completed_requests?: Maybe<Scalars['Float']['output']>;
  ff_rejected_requests?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "personal_dashboard" */
export type Personal_Dashboard_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Personal_Dashboard_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Personal_Dashboard_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer_closed?: InputMaybe<Scalars['Int']['input']>;
  farmer_in_progress?: InputMaybe<Scalars['Int']['input']>;
  farmer_total_requests?: InputMaybe<Scalars['Int']['input']>;
  ff_accepted_requests?: InputMaybe<Scalars['Int']['input']>;
  ff_completed_on_time_requests?: InputMaybe<Scalars['Int']['input']>;
  ff_completed_requests?: InputMaybe<Scalars['Int']['input']>;
  ff_rejected_requests?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate sum on columns */
export type Personal_Dashboard_Sum_Fields = {
  __typename?: 'personal_dashboard_sum_fields';
  farmer_closed?: Maybe<Scalars['Int']['output']>;
  farmer_in_progress?: Maybe<Scalars['Int']['output']>;
  farmer_total_requests?: Maybe<Scalars['Int']['output']>;
  ff_accepted_requests?: Maybe<Scalars['Int']['output']>;
  ff_completed_on_time_requests?: Maybe<Scalars['Int']['output']>;
  ff_completed_requests?: Maybe<Scalars['Int']['output']>;
  ff_rejected_requests?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "personal_dashboard" */
export enum Personal_Dashboard_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FarmerClosed = 'farmer_closed',
  /** column name */
  FarmerInProgress = 'farmer_in_progress',
  /** column name */
  FarmerTotalRequests = 'farmer_total_requests',
  /** column name */
  FfAcceptedRequests = 'ff_accepted_requests',
  /** column name */
  FfCompletedOnTimeRequests = 'ff_completed_on_time_requests',
  /** column name */
  FfCompletedRequests = 'ff_completed_requests',
  /** column name */
  FfRejectedRequests = 'ff_rejected_requests',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Personal_Dashboard_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Personal_Dashboard_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Personal_Dashboard_Set_Input>;
  /** filter the rows which have to be updated */
  where: Personal_Dashboard_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Personal_Dashboard_Var_Pop_Fields = {
  __typename?: 'personal_dashboard_var_pop_fields';
  farmer_closed?: Maybe<Scalars['Float']['output']>;
  farmer_in_progress?: Maybe<Scalars['Float']['output']>;
  farmer_total_requests?: Maybe<Scalars['Float']['output']>;
  ff_accepted_requests?: Maybe<Scalars['Float']['output']>;
  ff_completed_on_time_requests?: Maybe<Scalars['Float']['output']>;
  ff_completed_requests?: Maybe<Scalars['Float']['output']>;
  ff_rejected_requests?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Personal_Dashboard_Var_Samp_Fields = {
  __typename?: 'personal_dashboard_var_samp_fields';
  farmer_closed?: Maybe<Scalars['Float']['output']>;
  farmer_in_progress?: Maybe<Scalars['Float']['output']>;
  farmer_total_requests?: Maybe<Scalars['Float']['output']>;
  ff_accepted_requests?: Maybe<Scalars['Float']['output']>;
  ff_completed_on_time_requests?: Maybe<Scalars['Float']['output']>;
  ff_completed_requests?: Maybe<Scalars['Float']['output']>;
  ff_rejected_requests?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Personal_Dashboard_Variance_Fields = {
  __typename?: 'personal_dashboard_variance_fields';
  farmer_closed?: Maybe<Scalars['Float']['output']>;
  farmer_in_progress?: Maybe<Scalars['Float']['output']>;
  farmer_total_requests?: Maybe<Scalars['Float']['output']>;
  ff_accepted_requests?: Maybe<Scalars['Float']['output']>;
  ff_completed_on_time_requests?: Maybe<Scalars['Float']['output']>;
  ff_completed_requests?: Maybe<Scalars['Float']['output']>;
  ff_rejected_requests?: Maybe<Scalars['Float']['output']>;
};

/** ordering argument of a cursor */
export enum Pf_Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** columns and relationships of "runpando_pro.crops" */
export type Pf_Fcm_Crops = {
  __typename?: 'pf_fcm_crops';
  comp_id: Scalars['bigint']['output'];
  created_by: Scalars['bigint']['output'];
  created_date: Scalars['timestamptz']['output'];
  crop_name: Scalars['String']['output'];
  guid: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
  /** 1 is deleted, 0 is active */
  is_deleted: Scalars['Boolean']['output'];
  role_id: Scalars['smallint']['output'];
  segment_name?: Maybe<Scalars['String']['output']>;
  updated_by: Scalars['bigint']['output'];
  updated_date: Scalars['timestamptz']['output'];
  user_id: Scalars['bigint']['output'];
};

/** aggregated selection of "runpando_pro.crops" */
export type Pf_Fcm_Crops_Aggregate = {
  __typename?: 'pf_fcm_crops_aggregate';
  aggregate?: Maybe<Pf_Fcm_Crops_Aggregate_Fields>;
  nodes: Array<Pf_Fcm_Crops>;
};

/** aggregate fields of "runpando_pro.crops" */
export type Pf_Fcm_Crops_Aggregate_Fields = {
  __typename?: 'pf_fcm_crops_aggregate_fields';
  avg?: Maybe<Pf_Fcm_Crops_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pf_Fcm_Crops_Max_Fields>;
  min?: Maybe<Pf_Fcm_Crops_Min_Fields>;
  stddev?: Maybe<Pf_Fcm_Crops_Stddev_Fields>;
  stddev_pop?: Maybe<Pf_Fcm_Crops_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pf_Fcm_Crops_Stddev_Samp_Fields>;
  sum?: Maybe<Pf_Fcm_Crops_Sum_Fields>;
  var_pop?: Maybe<Pf_Fcm_Crops_Var_Pop_Fields>;
  var_samp?: Maybe<Pf_Fcm_Crops_Var_Samp_Fields>;
  variance?: Maybe<Pf_Fcm_Crops_Variance_Fields>;
};


/** aggregate fields of "runpando_pro.crops" */
export type Pf_Fcm_Crops_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pf_Fcm_Crops_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Pf_Fcm_Crops_Avg_Fields = {
  __typename?: 'pf_fcm_crops_avg_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "runpando_pro.crops". All fields are combined with a logical 'AND'. */
export type Pf_Fcm_Crops_Bool_Exp = {
  _and?: InputMaybe<Array<Pf_Fcm_Crops_Bool_Exp>>;
  _not?: InputMaybe<Pf_Fcm_Crops_Bool_Exp>;
  _or?: InputMaybe<Array<Pf_Fcm_Crops_Bool_Exp>>;
  comp_id?: InputMaybe<Bigint_Comparison_Exp>;
  created_by?: InputMaybe<Bigint_Comparison_Exp>;
  created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  crop_name?: InputMaybe<String_Comparison_Exp>;
  guid?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  role_id?: InputMaybe<Smallint_Comparison_Exp>;
  segment_name?: InputMaybe<String_Comparison_Exp>;
  updated_by?: InputMaybe<Bigint_Comparison_Exp>;
  updated_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "runpando_pro.crops" */
export enum Pf_Fcm_Crops_Constraint {
  /** unique or primary key constraint on columns "guid" */
  Idx_630879Guid = 'idx_630879_guid',
  /** unique or primary key constraint on columns "id" */
  Idx_630879Primary = 'idx_630879_primary'
}

/** input type for incrementing numeric columns in table "runpando_pro.crops" */
export type Pf_Fcm_Crops_Inc_Input = {
  comp_id?: InputMaybe<Scalars['bigint']['input']>;
  created_by?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  role_id?: InputMaybe<Scalars['smallint']['input']>;
  updated_by?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "runpando_pro.crops" */
export type Pf_Fcm_Crops_Insert_Input = {
  comp_id?: InputMaybe<Scalars['bigint']['input']>;
  created_by?: InputMaybe<Scalars['bigint']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  crop_name?: InputMaybe<Scalars['String']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  /** 1 is deleted, 0 is active */
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  role_id?: InputMaybe<Scalars['smallint']['input']>;
  segment_name?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['bigint']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Pf_Fcm_Crops_Max_Fields = {
  __typename?: 'pf_fcm_crops_max_fields';
  comp_id?: Maybe<Scalars['bigint']['output']>;
  created_by?: Maybe<Scalars['bigint']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  crop_name?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  role_id?: Maybe<Scalars['smallint']['output']>;
  segment_name?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['bigint']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Pf_Fcm_Crops_Min_Fields = {
  __typename?: 'pf_fcm_crops_min_fields';
  comp_id?: Maybe<Scalars['bigint']['output']>;
  created_by?: Maybe<Scalars['bigint']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  crop_name?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  role_id?: Maybe<Scalars['smallint']['output']>;
  segment_name?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['bigint']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "runpando_pro.crops" */
export type Pf_Fcm_Crops_Mutation_Response = {
  __typename?: 'pf_fcm_crops_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Pf_Fcm_Crops>;
};

/** on_conflict condition type for table "runpando_pro.crops" */
export type Pf_Fcm_Crops_On_Conflict = {
  constraint: Pf_Fcm_Crops_Constraint;
  update_columns?: Array<Pf_Fcm_Crops_Update_Column>;
  where?: InputMaybe<Pf_Fcm_Crops_Bool_Exp>;
};

/** Ordering options when selecting data from "runpando_pro.crops". */
export type Pf_Fcm_Crops_Order_By = {
  comp_id?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  crop_name?: InputMaybe<Order_By>;
  guid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  segment_name?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: runpando_pro.crops */
export type Pf_Fcm_Crops_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "runpando_pro.crops" */
export enum Pf_Fcm_Crops_Select_Column {
  /** column name */
  CompId = 'comp_id',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CreatedDate = 'created_date',
  /** column name */
  CropName = 'crop_name',
  /** column name */
  Guid = 'guid',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  SegmentName = 'segment_name',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  UpdatedDate = 'updated_date',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "runpando_pro.crops" */
export type Pf_Fcm_Crops_Set_Input = {
  comp_id?: InputMaybe<Scalars['bigint']['input']>;
  created_by?: InputMaybe<Scalars['bigint']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  crop_name?: InputMaybe<Scalars['String']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  /** 1 is deleted, 0 is active */
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  role_id?: InputMaybe<Scalars['smallint']['input']>;
  segment_name?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['bigint']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Pf_Fcm_Crops_Stddev_Fields = {
  __typename?: 'pf_fcm_crops_stddev_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Pf_Fcm_Crops_Stddev_Pop_Fields = {
  __typename?: 'pf_fcm_crops_stddev_pop_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Pf_Fcm_Crops_Stddev_Samp_Fields = {
  __typename?: 'pf_fcm_crops_stddev_samp_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "fcm_crops" */
export type Pf_Fcm_Crops_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pf_Fcm_Crops_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Pf_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pf_Fcm_Crops_Stream_Cursor_Value_Input = {
  comp_id?: InputMaybe<Scalars['bigint']['input']>;
  created_by?: InputMaybe<Scalars['bigint']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  crop_name?: InputMaybe<Scalars['String']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  /** 1 is deleted, 0 is active */
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  role_id?: InputMaybe<Scalars['smallint']['input']>;
  segment_name?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['bigint']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Pf_Fcm_Crops_Sum_Fields = {
  __typename?: 'pf_fcm_crops_sum_fields';
  comp_id?: Maybe<Scalars['bigint']['output']>;
  created_by?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  role_id?: Maybe<Scalars['smallint']['output']>;
  updated_by?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "runpando_pro.crops" */
export enum Pf_Fcm_Crops_Update_Column {
  /** column name */
  CompId = 'comp_id',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CreatedDate = 'created_date',
  /** column name */
  CropName = 'crop_name',
  /** column name */
  Guid = 'guid',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  SegmentName = 'segment_name',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  UpdatedDate = 'updated_date',
  /** column name */
  UserId = 'user_id'
}

export type Pf_Fcm_Crops_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pf_Fcm_Crops_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pf_Fcm_Crops_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pf_Fcm_Crops_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pf_Fcm_Crops_Var_Pop_Fields = {
  __typename?: 'pf_fcm_crops_var_pop_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Pf_Fcm_Crops_Var_Samp_Fields = {
  __typename?: 'pf_fcm_crops_var_samp_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Pf_Fcm_Crops_Variance_Fields = {
  __typename?: 'pf_fcm_crops_variance_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "runpando_pro.products" */
export type Pf_Fcm_Products = {
  __typename?: 'pf_fcm_products';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  comp_id: Scalars['bigint']['output'];
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_by: Scalars['bigint']['output'];
  created_date: Scalars['timestamptz']['output'];
  crop_id: Scalars['bigint']['output'];
  data?: Maybe<Scalars['json']['output']>;
  fi_user_id?: Maybe<Scalars['bpchar']['output']>;
  guid: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
  /** 1 is deleted, 0 is active */
  is_deleted: Scalars['Boolean']['output'];
  product_id?: Maybe<Scalars['bpchar']['output']>;
  product_name: Scalars['String']['output'];
  role_id: Scalars['smallint']['output'];
  shopify_last_sync?: Maybe<Scalars['timestamptz']['output']>;
  shopify_product_id?: Maybe<Scalars['String']['output']>;
  shopify_variant_id?: Maybe<Scalars['String']['output']>;
  updated_by: Scalars['bigint']['output'];
  updated_date: Scalars['timestamptz']['output'];
  user_id: Scalars['bigint']['output'];
};


/** columns and relationships of "runpando_pro.products" */
export type Pf_Fcm_ProductsDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "runpando_pro.products" */
export type Pf_Fcm_Products_Aggregate = {
  __typename?: 'pf_fcm_products_aggregate';
  aggregate?: Maybe<Pf_Fcm_Products_Aggregate_Fields>;
  nodes: Array<Pf_Fcm_Products>;
};

/** aggregate fields of "runpando_pro.products" */
export type Pf_Fcm_Products_Aggregate_Fields = {
  __typename?: 'pf_fcm_products_aggregate_fields';
  avg?: Maybe<Pf_Fcm_Products_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pf_Fcm_Products_Max_Fields>;
  min?: Maybe<Pf_Fcm_Products_Min_Fields>;
  stddev?: Maybe<Pf_Fcm_Products_Stddev_Fields>;
  stddev_pop?: Maybe<Pf_Fcm_Products_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pf_Fcm_Products_Stddev_Samp_Fields>;
  sum?: Maybe<Pf_Fcm_Products_Sum_Fields>;
  var_pop?: Maybe<Pf_Fcm_Products_Var_Pop_Fields>;
  var_samp?: Maybe<Pf_Fcm_Products_Var_Samp_Fields>;
  variance?: Maybe<Pf_Fcm_Products_Variance_Fields>;
};


/** aggregate fields of "runpando_pro.products" */
export type Pf_Fcm_Products_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pf_Fcm_Products_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Pf_Fcm_Products_Avg_Fields = {
  __typename?: 'pf_fcm_products_avg_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  crop_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "runpando_pro.products". All fields are combined with a logical 'AND'. */
export type Pf_Fcm_Products_Bool_Exp = {
  _and?: InputMaybe<Array<Pf_Fcm_Products_Bool_Exp>>;
  _not?: InputMaybe<Pf_Fcm_Products_Bool_Exp>;
  _or?: InputMaybe<Array<Pf_Fcm_Products_Bool_Exp>>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  comp_id?: InputMaybe<Bigint_Comparison_Exp>;
  company_id?: InputMaybe<Bpchar_Comparison_Exp>;
  created_by?: InputMaybe<Bigint_Comparison_Exp>;
  created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  crop_id?: InputMaybe<Bigint_Comparison_Exp>;
  data?: InputMaybe<Json_Comparison_Exp>;
  fi_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  guid?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  product_id?: InputMaybe<Bpchar_Comparison_Exp>;
  product_name?: InputMaybe<String_Comparison_Exp>;
  role_id?: InputMaybe<Smallint_Comparison_Exp>;
  shopify_last_sync?: InputMaybe<Timestamptz_Comparison_Exp>;
  shopify_product_id?: InputMaybe<String_Comparison_Exp>;
  shopify_variant_id?: InputMaybe<String_Comparison_Exp>;
  updated_by?: InputMaybe<Bigint_Comparison_Exp>;
  updated_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "runpando_pro.products" */
export enum Pf_Fcm_Products_Constraint {
  /** unique or primary key constraint on columns "id" */
  Idx_631571Primary = 'idx_631571_primary',
  /** unique or primary key constraint on columns "product_id" */
  RunpandoProProductsProductIdUnique = 'runpando_pro_products_product_id_unique'
}

/** input type for incrementing numeric columns in table "runpando_pro.products" */
export type Pf_Fcm_Products_Inc_Input = {
  comp_id?: InputMaybe<Scalars['bigint']['input']>;
  created_by?: InputMaybe<Scalars['bigint']['input']>;
  crop_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  role_id?: InputMaybe<Scalars['smallint']['input']>;
  updated_by?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "runpando_pro.products" */
export type Pf_Fcm_Products_Insert_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  comp_id?: InputMaybe<Scalars['bigint']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_by?: InputMaybe<Scalars['bigint']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  crop_id?: InputMaybe<Scalars['bigint']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  fi_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  /** 1 is deleted, 0 is active */
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  product_id?: InputMaybe<Scalars['bpchar']['input']>;
  product_name?: InputMaybe<Scalars['String']['input']>;
  role_id?: InputMaybe<Scalars['smallint']['input']>;
  shopify_last_sync?: InputMaybe<Scalars['timestamptz']['input']>;
  shopify_product_id?: InputMaybe<Scalars['String']['input']>;
  shopify_variant_id?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['bigint']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Pf_Fcm_Products_Max_Fields = {
  __typename?: 'pf_fcm_products_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  comp_id?: Maybe<Scalars['bigint']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_by?: Maybe<Scalars['bigint']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  crop_id?: Maybe<Scalars['bigint']['output']>;
  fi_user_id?: Maybe<Scalars['bpchar']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  product_id?: Maybe<Scalars['bpchar']['output']>;
  product_name?: Maybe<Scalars['String']['output']>;
  role_id?: Maybe<Scalars['smallint']['output']>;
  shopify_last_sync?: Maybe<Scalars['timestamptz']['output']>;
  shopify_product_id?: Maybe<Scalars['String']['output']>;
  shopify_variant_id?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['bigint']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Pf_Fcm_Products_Min_Fields = {
  __typename?: 'pf_fcm_products_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  comp_id?: Maybe<Scalars['bigint']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_by?: Maybe<Scalars['bigint']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  crop_id?: Maybe<Scalars['bigint']['output']>;
  fi_user_id?: Maybe<Scalars['bpchar']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  product_id?: Maybe<Scalars['bpchar']['output']>;
  product_name?: Maybe<Scalars['String']['output']>;
  role_id?: Maybe<Scalars['smallint']['output']>;
  shopify_last_sync?: Maybe<Scalars['timestamptz']['output']>;
  shopify_product_id?: Maybe<Scalars['String']['output']>;
  shopify_variant_id?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['bigint']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "runpando_pro.products" */
export type Pf_Fcm_Products_Mutation_Response = {
  __typename?: 'pf_fcm_products_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Pf_Fcm_Products>;
};

/** on_conflict condition type for table "runpando_pro.products" */
export type Pf_Fcm_Products_On_Conflict = {
  constraint: Pf_Fcm_Products_Constraint;
  update_columns?: Array<Pf_Fcm_Products_Update_Column>;
  where?: InputMaybe<Pf_Fcm_Products_Bool_Exp>;
};

/** Ordering options when selecting data from "runpando_pro.products". */
export type Pf_Fcm_Products_Order_By = {
  account_id?: InputMaybe<Order_By>;
  comp_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  fi_user_id?: InputMaybe<Order_By>;
  guid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  product_name?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  shopify_last_sync?: InputMaybe<Order_By>;
  shopify_product_id?: InputMaybe<Order_By>;
  shopify_variant_id?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: runpando_pro.products */
export type Pf_Fcm_Products_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "runpando_pro.products" */
export enum Pf_Fcm_Products_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CompId = 'comp_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CreatedDate = 'created_date',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Data = 'data',
  /** column name */
  FiUserId = 'fi_user_id',
  /** column name */
  Guid = 'guid',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  ProductName = 'product_name',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  ShopifyLastSync = 'shopify_last_sync',
  /** column name */
  ShopifyProductId = 'shopify_product_id',
  /** column name */
  ShopifyVariantId = 'shopify_variant_id',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  UpdatedDate = 'updated_date',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "runpando_pro.products" */
export type Pf_Fcm_Products_Set_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  comp_id?: InputMaybe<Scalars['bigint']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_by?: InputMaybe<Scalars['bigint']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  crop_id?: InputMaybe<Scalars['bigint']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  fi_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  /** 1 is deleted, 0 is active */
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  product_id?: InputMaybe<Scalars['bpchar']['input']>;
  product_name?: InputMaybe<Scalars['String']['input']>;
  role_id?: InputMaybe<Scalars['smallint']['input']>;
  shopify_last_sync?: InputMaybe<Scalars['timestamptz']['input']>;
  shopify_product_id?: InputMaybe<Scalars['String']['input']>;
  shopify_variant_id?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['bigint']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Pf_Fcm_Products_Stddev_Fields = {
  __typename?: 'pf_fcm_products_stddev_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  crop_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Pf_Fcm_Products_Stddev_Pop_Fields = {
  __typename?: 'pf_fcm_products_stddev_pop_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  crop_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Pf_Fcm_Products_Stddev_Samp_Fields = {
  __typename?: 'pf_fcm_products_stddev_samp_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  crop_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "fcm_products" */
export type Pf_Fcm_Products_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pf_Fcm_Products_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Pf_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pf_Fcm_Products_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  comp_id?: InputMaybe<Scalars['bigint']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_by?: InputMaybe<Scalars['bigint']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  crop_id?: InputMaybe<Scalars['bigint']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  fi_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  /** 1 is deleted, 0 is active */
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  product_id?: InputMaybe<Scalars['bpchar']['input']>;
  product_name?: InputMaybe<Scalars['String']['input']>;
  role_id?: InputMaybe<Scalars['smallint']['input']>;
  shopify_last_sync?: InputMaybe<Scalars['timestamptz']['input']>;
  shopify_product_id?: InputMaybe<Scalars['String']['input']>;
  shopify_variant_id?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['bigint']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Pf_Fcm_Products_Sum_Fields = {
  __typename?: 'pf_fcm_products_sum_fields';
  comp_id?: Maybe<Scalars['bigint']['output']>;
  created_by?: Maybe<Scalars['bigint']['output']>;
  crop_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  role_id?: Maybe<Scalars['smallint']['output']>;
  updated_by?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "runpando_pro.products" */
export enum Pf_Fcm_Products_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CompId = 'comp_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CreatedDate = 'created_date',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Data = 'data',
  /** column name */
  FiUserId = 'fi_user_id',
  /** column name */
  Guid = 'guid',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  ProductName = 'product_name',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  ShopifyLastSync = 'shopify_last_sync',
  /** column name */
  ShopifyProductId = 'shopify_product_id',
  /** column name */
  ShopifyVariantId = 'shopify_variant_id',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  UpdatedDate = 'updated_date',
  /** column name */
  UserId = 'user_id'
}

export type Pf_Fcm_Products_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pf_Fcm_Products_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pf_Fcm_Products_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pf_Fcm_Products_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pf_Fcm_Products_Var_Pop_Fields = {
  __typename?: 'pf_fcm_products_var_pop_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  crop_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Pf_Fcm_Products_Var_Samp_Fields = {
  __typename?: 'pf_fcm_products_var_samp_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  crop_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Pf_Fcm_Products_Variance_Fields = {
  __typename?: 'pf_fcm_products_variance_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  crop_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "runpando_pro.plan_cards" */
export type Pf_Plan_Cards = {
  __typename?: 'pf_plan_cards';
  activity: Scalars['bigint']['output'];
  activity_coins?: Maybe<Scalars['String']['output']>;
  assign_to: Scalars['bigint']['output'];
  card_type?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  cca?: Maybe<Pf_Runpando_Pro_Campaign_Card_Activities>;
  /** An array relationship */
  channel_images: Array<Pf_Runpando_Pro_Channel_Card_Images>;
  /** An aggregate relationship */
  channel_images_aggregate: Pf_Runpando_Pro_Channel_Card_Images_Aggregate;
  channel_partner?: Maybe<Scalars['String']['output']>;
  channel_partner_id: Scalars['bigint']['output'];
  created_by: Scalars['bigint']['output'];
  created_date: Scalars['timestamptz']['output'];
  creation_mode?: Maybe<Scalars['String']['output']>;
  crm_customer_name?: Maybe<Scalars['String']['output']>;
  crm_phone_number?: Maybe<Scalars['String']['output']>;
  crop_id?: Maybe<Scalars['bigint']['output']>;
  crop_name?: Maybe<Scalars['String']['output']>;
  distance_travelled?: Maybe<Scalars['numeric']['output']>;
  fqr_id: Scalars['String']['output'];
  fqr_primary_id?: Maybe<Scalars['bigint']['output']>;
  guid: Scalars['String']['output'];
  hybrid_id: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
  is_deleted: Scalars['bigint']['output'];
  is_plan_moved?: Maybe<Scalars['String']['output']>;
  kg_user_id?: Maybe<Scalars['numeric']['output']>;
  land_type?: Maybe<Scalars['String']['output']>;
  lat_position?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  location?: Maybe<Pf_Runpando_Pro_All_State_Data>;
  location_id?: Maybe<Scalars['bigint']['output']>;
  location_json?: Maybe<Scalars['json']['output']>;
  location_name?: Maybe<Scalars['String']['output']>;
  long_position?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  manager_feedback?: Maybe<Pf_Runpando_Pro_Activity_Coins_Feedback>;
  manager_review?: Maybe<Scalars['float8']['output']>;
  mobile_timestamp: Scalars['String']['output'];
  mobile_timestamp2?: Maybe<Scalars['String']['output']>;
  order_number: Scalars['bigint']['output'];
  /** An object relationship */
  pfuser?: Maybe<Pf_Users>;
  plan_approval_status?: Maybe<Scalars['String']['output']>;
  plan_type?: Maybe<Scalars['String']['output']>;
  planned_date?: Maybe<Scalars['String']['output']>;
  product_id?: Maybe<Scalars['bigint']['output']>;
  product_name?: Maybe<Scalars['String']['output']>;
  season_value_1?: Maybe<Scalars['String']['output']>;
  season_value_2?: Maybe<Scalars['String']['output']>;
  season_value_3?: Maybe<Scalars['String']['output']>;
  season_value_4?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  submission_mode?: Maybe<Scalars['String']['output']>;
  submitted_users?: Maybe<Scalars['String']['output']>;
  submitted_users_phone?: Maybe<Scalars['String']['output']>;
  updated_by: Scalars['bigint']['output'];
  updated_date: Scalars['timestamptz']['output'];
  updated_date_dt?: Maybe<Scalars['date']['output']>;
  user?: Maybe<Users>;
  village_id: Scalars['bigint']['output'];
  village_name?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "runpando_pro.plan_cards" */
export type Pf_Plan_CardsChannel_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Pf_Runpando_Pro_Channel_Card_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Runpando_Pro_Channel_Card_Images_Order_By>>;
  where?: InputMaybe<Pf_Runpando_Pro_Channel_Card_Images_Bool_Exp>;
};


/** columns and relationships of "runpando_pro.plan_cards" */
export type Pf_Plan_CardsChannel_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pf_Runpando_Pro_Channel_Card_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Runpando_Pro_Channel_Card_Images_Order_By>>;
  where?: InputMaybe<Pf_Runpando_Pro_Channel_Card_Images_Bool_Exp>;
};


/** columns and relationships of "runpando_pro.plan_cards" */
export type Pf_Plan_CardsLocation_JsonArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "runpando_pro.plan_cards" */
export type Pf_Plan_Cards_Aggregate = {
  __typename?: 'pf_plan_cards_aggregate';
  aggregate?: Maybe<Pf_Plan_Cards_Aggregate_Fields>;
  nodes: Array<Pf_Plan_Cards>;
};

/** aggregate fields of "runpando_pro.plan_cards" */
export type Pf_Plan_Cards_Aggregate_Fields = {
  __typename?: 'pf_plan_cards_aggregate_fields';
  avg?: Maybe<Pf_Plan_Cards_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pf_Plan_Cards_Max_Fields>;
  min?: Maybe<Pf_Plan_Cards_Min_Fields>;
  stddev?: Maybe<Pf_Plan_Cards_Stddev_Fields>;
  stddev_pop?: Maybe<Pf_Plan_Cards_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pf_Plan_Cards_Stddev_Samp_Fields>;
  sum?: Maybe<Pf_Plan_Cards_Sum_Fields>;
  var_pop?: Maybe<Pf_Plan_Cards_Var_Pop_Fields>;
  var_samp?: Maybe<Pf_Plan_Cards_Var_Samp_Fields>;
  variance?: Maybe<Pf_Plan_Cards_Variance_Fields>;
};


/** aggregate fields of "runpando_pro.plan_cards" */
export type Pf_Plan_Cards_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pf_Plan_Cards_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Pf_Plan_Cards_Avg_Fields = {
  __typename?: 'pf_plan_cards_avg_fields';
  activity?: Maybe<Scalars['Float']['output']>;
  assign_to?: Maybe<Scalars['Float']['output']>;
  channel_partner_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  crop_id?: Maybe<Scalars['Float']['output']>;
  distance_travelled?: Maybe<Scalars['Float']['output']>;
  fqr_primary_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  is_deleted?: Maybe<Scalars['Float']['output']>;
  kg_user_id?: Maybe<Scalars['Float']['output']>;
  lat_position?: Maybe<Scalars['Float']['output']>;
  location_id?: Maybe<Scalars['Float']['output']>;
  long_position?: Maybe<Scalars['Float']['output']>;
  manager_review?: Maybe<Scalars['Float']['output']>;
  order_number?: Maybe<Scalars['Float']['output']>;
  product_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
  village_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "runpando_pro.plan_cards". All fields are combined with a logical 'AND'. */
export type Pf_Plan_Cards_Bool_Exp = {
  _and?: InputMaybe<Array<Pf_Plan_Cards_Bool_Exp>>;
  _not?: InputMaybe<Pf_Plan_Cards_Bool_Exp>;
  _or?: InputMaybe<Array<Pf_Plan_Cards_Bool_Exp>>;
  activity?: InputMaybe<Bigint_Comparison_Exp>;
  activity_coins?: InputMaybe<String_Comparison_Exp>;
  assign_to?: InputMaybe<Bigint_Comparison_Exp>;
  card_type?: InputMaybe<String_Comparison_Exp>;
  cca?: InputMaybe<Pf_Runpando_Pro_Campaign_Card_Activities_Bool_Exp>;
  channel_images?: InputMaybe<Pf_Runpando_Pro_Channel_Card_Images_Bool_Exp>;
  channel_images_aggregate?: InputMaybe<Runpando_Pro_Channel_Card_Images_Aggregate_Bool_Exp>;
  channel_partner?: InputMaybe<String_Comparison_Exp>;
  channel_partner_id?: InputMaybe<Bigint_Comparison_Exp>;
  created_by?: InputMaybe<Bigint_Comparison_Exp>;
  created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_mode?: InputMaybe<String_Comparison_Exp>;
  crm_customer_name?: InputMaybe<String_Comparison_Exp>;
  crm_phone_number?: InputMaybe<String_Comparison_Exp>;
  crop_id?: InputMaybe<Bigint_Comparison_Exp>;
  crop_name?: InputMaybe<String_Comparison_Exp>;
  distance_travelled?: InputMaybe<Numeric_Comparison_Exp>;
  fqr_id?: InputMaybe<String_Comparison_Exp>;
  fqr_primary_id?: InputMaybe<Bigint_Comparison_Exp>;
  guid?: InputMaybe<String_Comparison_Exp>;
  hybrid_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_deleted?: InputMaybe<Bigint_Comparison_Exp>;
  is_plan_moved?: InputMaybe<String_Comparison_Exp>;
  kg_user_id?: InputMaybe<Numeric_Comparison_Exp>;
  land_type?: InputMaybe<String_Comparison_Exp>;
  lat_position?: InputMaybe<Numeric_Comparison_Exp>;
  location?: InputMaybe<Pf_Runpando_Pro_All_State_Data_Bool_Exp>;
  location_id?: InputMaybe<Bigint_Comparison_Exp>;
  location_json?: InputMaybe<Json_Comparison_Exp>;
  location_name?: InputMaybe<String_Comparison_Exp>;
  long_position?: InputMaybe<Numeric_Comparison_Exp>;
  manager_feedback?: InputMaybe<Pf_Runpando_Pro_Activity_Coins_Feedback_Bool_Exp>;
  manager_review?: InputMaybe<Float8_Comparison_Exp>;
  mobile_timestamp?: InputMaybe<String_Comparison_Exp>;
  mobile_timestamp2?: InputMaybe<String_Comparison_Exp>;
  order_number?: InputMaybe<Bigint_Comparison_Exp>;
  pfuser?: InputMaybe<Pf_Users_Bool_Exp>;
  plan_approval_status?: InputMaybe<String_Comparison_Exp>;
  plan_type?: InputMaybe<String_Comparison_Exp>;
  planned_date?: InputMaybe<String_Comparison_Exp>;
  product_id?: InputMaybe<Bigint_Comparison_Exp>;
  product_name?: InputMaybe<String_Comparison_Exp>;
  season_value_1?: InputMaybe<String_Comparison_Exp>;
  season_value_2?: InputMaybe<String_Comparison_Exp>;
  season_value_3?: InputMaybe<String_Comparison_Exp>;
  season_value_4?: InputMaybe<String_Comparison_Exp>;
  start_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  submission_mode?: InputMaybe<String_Comparison_Exp>;
  submitted_users?: InputMaybe<String_Comparison_Exp>;
  submitted_users_phone?: InputMaybe<String_Comparison_Exp>;
  updated_by?: InputMaybe<Bigint_Comparison_Exp>;
  updated_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_date_dt?: InputMaybe<Date_Comparison_Exp>;
  village_id?: InputMaybe<Bigint_Comparison_Exp>;
  village_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "runpando_pro.plan_cards" */
export enum Pf_Plan_Cards_Constraint {
  /** unique or primary key constraint on columns "assign_to", "mobile_timestamp" */
  Idx_631552AssignToMstmp = 'idx_631552_assign_to_mstmp',
  /** unique or primary key constraint on columns "id" */
  Idx_631552Primary = 'idx_631552_primary'
}

/** input type for incrementing numeric columns in table "runpando_pro.plan_cards" */
export type Pf_Plan_Cards_Inc_Input = {
  activity?: InputMaybe<Scalars['bigint']['input']>;
  assign_to?: InputMaybe<Scalars['bigint']['input']>;
  channel_partner_id?: InputMaybe<Scalars['bigint']['input']>;
  created_by?: InputMaybe<Scalars['bigint']['input']>;
  crop_id?: InputMaybe<Scalars['bigint']['input']>;
  distance_travelled?: InputMaybe<Scalars['numeric']['input']>;
  fqr_primary_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_deleted?: InputMaybe<Scalars['bigint']['input']>;
  kg_user_id?: InputMaybe<Scalars['numeric']['input']>;
  lat_position?: InputMaybe<Scalars['numeric']['input']>;
  location_id?: InputMaybe<Scalars['bigint']['input']>;
  long_position?: InputMaybe<Scalars['numeric']['input']>;
  manager_review?: InputMaybe<Scalars['float8']['input']>;
  order_number?: InputMaybe<Scalars['bigint']['input']>;
  product_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_by?: InputMaybe<Scalars['bigint']['input']>;
  village_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "runpando_pro.plan_cards" */
export type Pf_Plan_Cards_Insert_Input = {
  activity?: InputMaybe<Scalars['bigint']['input']>;
  activity_coins?: InputMaybe<Scalars['String']['input']>;
  assign_to?: InputMaybe<Scalars['bigint']['input']>;
  card_type?: InputMaybe<Scalars['String']['input']>;
  cca?: InputMaybe<Pf_Runpando_Pro_Campaign_Card_Activities_Obj_Rel_Insert_Input>;
  channel_images?: InputMaybe<Pf_Runpando_Pro_Channel_Card_Images_Arr_Rel_Insert_Input>;
  channel_partner?: InputMaybe<Scalars['String']['input']>;
  channel_partner_id?: InputMaybe<Scalars['bigint']['input']>;
  created_by?: InputMaybe<Scalars['bigint']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  creation_mode?: InputMaybe<Scalars['String']['input']>;
  crm_customer_name?: InputMaybe<Scalars['String']['input']>;
  crm_phone_number?: InputMaybe<Scalars['String']['input']>;
  crop_id?: InputMaybe<Scalars['bigint']['input']>;
  crop_name?: InputMaybe<Scalars['String']['input']>;
  distance_travelled?: InputMaybe<Scalars['numeric']['input']>;
  fqr_id?: InputMaybe<Scalars['String']['input']>;
  fqr_primary_id?: InputMaybe<Scalars['bigint']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  hybrid_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_deleted?: InputMaybe<Scalars['bigint']['input']>;
  is_plan_moved?: InputMaybe<Scalars['String']['input']>;
  kg_user_id?: InputMaybe<Scalars['numeric']['input']>;
  land_type?: InputMaybe<Scalars['String']['input']>;
  lat_position?: InputMaybe<Scalars['numeric']['input']>;
  location?: InputMaybe<Pf_Runpando_Pro_All_State_Data_Obj_Rel_Insert_Input>;
  location_id?: InputMaybe<Scalars['bigint']['input']>;
  location_json?: InputMaybe<Scalars['json']['input']>;
  location_name?: InputMaybe<Scalars['String']['input']>;
  long_position?: InputMaybe<Scalars['numeric']['input']>;
  manager_feedback?: InputMaybe<Pf_Runpando_Pro_Activity_Coins_Feedback_Obj_Rel_Insert_Input>;
  manager_review?: InputMaybe<Scalars['float8']['input']>;
  mobile_timestamp?: InputMaybe<Scalars['String']['input']>;
  mobile_timestamp2?: InputMaybe<Scalars['String']['input']>;
  order_number?: InputMaybe<Scalars['bigint']['input']>;
  pfuser?: InputMaybe<Pf_Users_Obj_Rel_Insert_Input>;
  plan_approval_status?: InputMaybe<Scalars['String']['input']>;
  plan_type?: InputMaybe<Scalars['String']['input']>;
  planned_date?: InputMaybe<Scalars['String']['input']>;
  product_id?: InputMaybe<Scalars['bigint']['input']>;
  product_name?: InputMaybe<Scalars['String']['input']>;
  season_value_1?: InputMaybe<Scalars['String']['input']>;
  season_value_2?: InputMaybe<Scalars['String']['input']>;
  season_value_3?: InputMaybe<Scalars['String']['input']>;
  season_value_4?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  submission_mode?: InputMaybe<Scalars['String']['input']>;
  submitted_users?: InputMaybe<Scalars['String']['input']>;
  submitted_users_phone?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['bigint']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_date_dt?: InputMaybe<Scalars['date']['input']>;
  village_id?: InputMaybe<Scalars['bigint']['input']>;
  village_name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Pf_Plan_Cards_Max_Fields = {
  __typename?: 'pf_plan_cards_max_fields';
  activity?: Maybe<Scalars['bigint']['output']>;
  activity_coins?: Maybe<Scalars['String']['output']>;
  assign_to?: Maybe<Scalars['bigint']['output']>;
  card_type?: Maybe<Scalars['String']['output']>;
  channel_partner?: Maybe<Scalars['String']['output']>;
  channel_partner_id?: Maybe<Scalars['bigint']['output']>;
  created_by?: Maybe<Scalars['bigint']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  creation_mode?: Maybe<Scalars['String']['output']>;
  crm_customer_name?: Maybe<Scalars['String']['output']>;
  crm_phone_number?: Maybe<Scalars['String']['output']>;
  crop_id?: Maybe<Scalars['bigint']['output']>;
  crop_name?: Maybe<Scalars['String']['output']>;
  distance_travelled?: Maybe<Scalars['numeric']['output']>;
  fqr_id?: Maybe<Scalars['String']['output']>;
  fqr_primary_id?: Maybe<Scalars['bigint']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  hybrid_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  is_deleted?: Maybe<Scalars['bigint']['output']>;
  is_plan_moved?: Maybe<Scalars['String']['output']>;
  kg_user_id?: Maybe<Scalars['numeric']['output']>;
  land_type?: Maybe<Scalars['String']['output']>;
  lat_position?: Maybe<Scalars['numeric']['output']>;
  location_id?: Maybe<Scalars['bigint']['output']>;
  location_name?: Maybe<Scalars['String']['output']>;
  long_position?: Maybe<Scalars['numeric']['output']>;
  manager_review?: Maybe<Scalars['float8']['output']>;
  mobile_timestamp?: Maybe<Scalars['String']['output']>;
  mobile_timestamp2?: Maybe<Scalars['String']['output']>;
  order_number?: Maybe<Scalars['bigint']['output']>;
  plan_approval_status?: Maybe<Scalars['String']['output']>;
  plan_type?: Maybe<Scalars['String']['output']>;
  planned_date?: Maybe<Scalars['String']['output']>;
  product_id?: Maybe<Scalars['bigint']['output']>;
  product_name?: Maybe<Scalars['String']['output']>;
  season_value_1?: Maybe<Scalars['String']['output']>;
  season_value_2?: Maybe<Scalars['String']['output']>;
  season_value_3?: Maybe<Scalars['String']['output']>;
  season_value_4?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  submission_mode?: Maybe<Scalars['String']['output']>;
  submitted_users?: Maybe<Scalars['String']['output']>;
  submitted_users_phone?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['bigint']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
  updated_date_dt?: Maybe<Scalars['date']['output']>;
  village_id?: Maybe<Scalars['bigint']['output']>;
  village_name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Pf_Plan_Cards_Min_Fields = {
  __typename?: 'pf_plan_cards_min_fields';
  activity?: Maybe<Scalars['bigint']['output']>;
  activity_coins?: Maybe<Scalars['String']['output']>;
  assign_to?: Maybe<Scalars['bigint']['output']>;
  card_type?: Maybe<Scalars['String']['output']>;
  channel_partner?: Maybe<Scalars['String']['output']>;
  channel_partner_id?: Maybe<Scalars['bigint']['output']>;
  created_by?: Maybe<Scalars['bigint']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  creation_mode?: Maybe<Scalars['String']['output']>;
  crm_customer_name?: Maybe<Scalars['String']['output']>;
  crm_phone_number?: Maybe<Scalars['String']['output']>;
  crop_id?: Maybe<Scalars['bigint']['output']>;
  crop_name?: Maybe<Scalars['String']['output']>;
  distance_travelled?: Maybe<Scalars['numeric']['output']>;
  fqr_id?: Maybe<Scalars['String']['output']>;
  fqr_primary_id?: Maybe<Scalars['bigint']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  hybrid_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  is_deleted?: Maybe<Scalars['bigint']['output']>;
  is_plan_moved?: Maybe<Scalars['String']['output']>;
  kg_user_id?: Maybe<Scalars['numeric']['output']>;
  land_type?: Maybe<Scalars['String']['output']>;
  lat_position?: Maybe<Scalars['numeric']['output']>;
  location_id?: Maybe<Scalars['bigint']['output']>;
  location_name?: Maybe<Scalars['String']['output']>;
  long_position?: Maybe<Scalars['numeric']['output']>;
  manager_review?: Maybe<Scalars['float8']['output']>;
  mobile_timestamp?: Maybe<Scalars['String']['output']>;
  mobile_timestamp2?: Maybe<Scalars['String']['output']>;
  order_number?: Maybe<Scalars['bigint']['output']>;
  plan_approval_status?: Maybe<Scalars['String']['output']>;
  plan_type?: Maybe<Scalars['String']['output']>;
  planned_date?: Maybe<Scalars['String']['output']>;
  product_id?: Maybe<Scalars['bigint']['output']>;
  product_name?: Maybe<Scalars['String']['output']>;
  season_value_1?: Maybe<Scalars['String']['output']>;
  season_value_2?: Maybe<Scalars['String']['output']>;
  season_value_3?: Maybe<Scalars['String']['output']>;
  season_value_4?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  submission_mode?: Maybe<Scalars['String']['output']>;
  submitted_users?: Maybe<Scalars['String']['output']>;
  submitted_users_phone?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['bigint']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
  updated_date_dt?: Maybe<Scalars['date']['output']>;
  village_id?: Maybe<Scalars['bigint']['output']>;
  village_name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "runpando_pro.plan_cards" */
export type Pf_Plan_Cards_Mutation_Response = {
  __typename?: 'pf_plan_cards_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Pf_Plan_Cards>;
};

/** on_conflict condition type for table "runpando_pro.plan_cards" */
export type Pf_Plan_Cards_On_Conflict = {
  constraint: Pf_Plan_Cards_Constraint;
  update_columns?: Array<Pf_Plan_Cards_Update_Column>;
  where?: InputMaybe<Pf_Plan_Cards_Bool_Exp>;
};

/** Ordering options when selecting data from "runpando_pro.plan_cards". */
export type Pf_Plan_Cards_Order_By = {
  activity?: InputMaybe<Order_By>;
  activity_coins?: InputMaybe<Order_By>;
  assign_to?: InputMaybe<Order_By>;
  card_type?: InputMaybe<Order_By>;
  cca?: InputMaybe<Pf_Runpando_Pro_Campaign_Card_Activities_Order_By>;
  channel_images_aggregate?: InputMaybe<Pf_Runpando_Pro_Channel_Card_Images_Aggregate_Order_By>;
  channel_partner?: InputMaybe<Order_By>;
  channel_partner_id?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  creation_mode?: InputMaybe<Order_By>;
  crm_customer_name?: InputMaybe<Order_By>;
  crm_phone_number?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  crop_name?: InputMaybe<Order_By>;
  distance_travelled?: InputMaybe<Order_By>;
  fqr_id?: InputMaybe<Order_By>;
  fqr_primary_id?: InputMaybe<Order_By>;
  guid?: InputMaybe<Order_By>;
  hybrid_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  is_plan_moved?: InputMaybe<Order_By>;
  kg_user_id?: InputMaybe<Order_By>;
  land_type?: InputMaybe<Order_By>;
  lat_position?: InputMaybe<Order_By>;
  location?: InputMaybe<Pf_Runpando_Pro_All_State_Data_Order_By>;
  location_id?: InputMaybe<Order_By>;
  location_json?: InputMaybe<Order_By>;
  location_name?: InputMaybe<Order_By>;
  long_position?: InputMaybe<Order_By>;
  manager_feedback?: InputMaybe<Pf_Runpando_Pro_Activity_Coins_Feedback_Order_By>;
  manager_review?: InputMaybe<Order_By>;
  mobile_timestamp?: InputMaybe<Order_By>;
  mobile_timestamp2?: InputMaybe<Order_By>;
  order_number?: InputMaybe<Order_By>;
  pfuser?: InputMaybe<Pf_Users_Order_By>;
  plan_approval_status?: InputMaybe<Order_By>;
  plan_type?: InputMaybe<Order_By>;
  planned_date?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  product_name?: InputMaybe<Order_By>;
  season_value_1?: InputMaybe<Order_By>;
  season_value_2?: InputMaybe<Order_By>;
  season_value_3?: InputMaybe<Order_By>;
  season_value_4?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  submission_mode?: InputMaybe<Order_By>;
  submitted_users?: InputMaybe<Order_By>;
  submitted_users_phone?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
  updated_date_dt?: InputMaybe<Order_By>;
  village_id?: InputMaybe<Order_By>;
  village_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: runpando_pro.plan_cards */
export type Pf_Plan_Cards_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "runpando_pro.plan_cards" */
export enum Pf_Plan_Cards_Select_Column {
  /** column name */
  Activity = 'activity',
  /** column name */
  ActivityCoins = 'activity_coins',
  /** column name */
  AssignTo = 'assign_to',
  /** column name */
  CardType = 'card_type',
  /** column name */
  ChannelPartner = 'channel_partner',
  /** column name */
  ChannelPartnerId = 'channel_partner_id',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CreatedDate = 'created_date',
  /** column name */
  CreationMode = 'creation_mode',
  /** column name */
  CrmCustomerName = 'crm_customer_name',
  /** column name */
  CrmPhoneNumber = 'crm_phone_number',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  CropName = 'crop_name',
  /** column name */
  DistanceTravelled = 'distance_travelled',
  /** column name */
  FqrId = 'fqr_id',
  /** column name */
  FqrPrimaryId = 'fqr_primary_id',
  /** column name */
  Guid = 'guid',
  /** column name */
  HybridId = 'hybrid_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsPlanMoved = 'is_plan_moved',
  /** column name */
  KgUserId = 'kg_user_id',
  /** column name */
  LandType = 'land_type',
  /** column name */
  LatPosition = 'lat_position',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  LocationJson = 'location_json',
  /** column name */
  LocationName = 'location_name',
  /** column name */
  LongPosition = 'long_position',
  /** column name */
  ManagerReview = 'manager_review',
  /** column name */
  MobileTimestamp = 'mobile_timestamp',
  /** column name */
  MobileTimestamp2 = 'mobile_timestamp2',
  /** column name */
  OrderNumber = 'order_number',
  /** column name */
  PlanApprovalStatus = 'plan_approval_status',
  /** column name */
  PlanType = 'plan_type',
  /** column name */
  PlannedDate = 'planned_date',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  ProductName = 'product_name',
  /** column name */
  SeasonValue_1 = 'season_value_1',
  /** column name */
  SeasonValue_2 = 'season_value_2',
  /** column name */
  SeasonValue_3 = 'season_value_3',
  /** column name */
  SeasonValue_4 = 'season_value_4',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Status = 'status',
  /** column name */
  SubmissionMode = 'submission_mode',
  /** column name */
  SubmittedUsers = 'submitted_users',
  /** column name */
  SubmittedUsersPhone = 'submitted_users_phone',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  UpdatedDate = 'updated_date',
  /** column name */
  UpdatedDateDt = 'updated_date_dt',
  /** column name */
  VillageId = 'village_id',
  /** column name */
  VillageName = 'village_name'
}

/** input type for updating data in table "runpando_pro.plan_cards" */
export type Pf_Plan_Cards_Set_Input = {
  activity?: InputMaybe<Scalars['bigint']['input']>;
  activity_coins?: InputMaybe<Scalars['String']['input']>;
  assign_to?: InputMaybe<Scalars['bigint']['input']>;
  card_type?: InputMaybe<Scalars['String']['input']>;
  channel_partner?: InputMaybe<Scalars['String']['input']>;
  channel_partner_id?: InputMaybe<Scalars['bigint']['input']>;
  created_by?: InputMaybe<Scalars['bigint']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  creation_mode?: InputMaybe<Scalars['String']['input']>;
  crm_customer_name?: InputMaybe<Scalars['String']['input']>;
  crm_phone_number?: InputMaybe<Scalars['String']['input']>;
  crop_id?: InputMaybe<Scalars['bigint']['input']>;
  crop_name?: InputMaybe<Scalars['String']['input']>;
  distance_travelled?: InputMaybe<Scalars['numeric']['input']>;
  fqr_id?: InputMaybe<Scalars['String']['input']>;
  fqr_primary_id?: InputMaybe<Scalars['bigint']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  hybrid_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_deleted?: InputMaybe<Scalars['bigint']['input']>;
  is_plan_moved?: InputMaybe<Scalars['String']['input']>;
  kg_user_id?: InputMaybe<Scalars['numeric']['input']>;
  land_type?: InputMaybe<Scalars['String']['input']>;
  lat_position?: InputMaybe<Scalars['numeric']['input']>;
  location_id?: InputMaybe<Scalars['bigint']['input']>;
  location_json?: InputMaybe<Scalars['json']['input']>;
  location_name?: InputMaybe<Scalars['String']['input']>;
  long_position?: InputMaybe<Scalars['numeric']['input']>;
  manager_review?: InputMaybe<Scalars['float8']['input']>;
  mobile_timestamp?: InputMaybe<Scalars['String']['input']>;
  mobile_timestamp2?: InputMaybe<Scalars['String']['input']>;
  order_number?: InputMaybe<Scalars['bigint']['input']>;
  plan_approval_status?: InputMaybe<Scalars['String']['input']>;
  plan_type?: InputMaybe<Scalars['String']['input']>;
  planned_date?: InputMaybe<Scalars['String']['input']>;
  product_id?: InputMaybe<Scalars['bigint']['input']>;
  product_name?: InputMaybe<Scalars['String']['input']>;
  season_value_1?: InputMaybe<Scalars['String']['input']>;
  season_value_2?: InputMaybe<Scalars['String']['input']>;
  season_value_3?: InputMaybe<Scalars['String']['input']>;
  season_value_4?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  submission_mode?: InputMaybe<Scalars['String']['input']>;
  submitted_users?: InputMaybe<Scalars['String']['input']>;
  submitted_users_phone?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['bigint']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_date_dt?: InputMaybe<Scalars['date']['input']>;
  village_id?: InputMaybe<Scalars['bigint']['input']>;
  village_name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Pf_Plan_Cards_Stddev_Fields = {
  __typename?: 'pf_plan_cards_stddev_fields';
  activity?: Maybe<Scalars['Float']['output']>;
  assign_to?: Maybe<Scalars['Float']['output']>;
  channel_partner_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  crop_id?: Maybe<Scalars['Float']['output']>;
  distance_travelled?: Maybe<Scalars['Float']['output']>;
  fqr_primary_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  is_deleted?: Maybe<Scalars['Float']['output']>;
  kg_user_id?: Maybe<Scalars['Float']['output']>;
  lat_position?: Maybe<Scalars['Float']['output']>;
  location_id?: Maybe<Scalars['Float']['output']>;
  long_position?: Maybe<Scalars['Float']['output']>;
  manager_review?: Maybe<Scalars['Float']['output']>;
  order_number?: Maybe<Scalars['Float']['output']>;
  product_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
  village_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Pf_Plan_Cards_Stddev_Pop_Fields = {
  __typename?: 'pf_plan_cards_stddev_pop_fields';
  activity?: Maybe<Scalars['Float']['output']>;
  assign_to?: Maybe<Scalars['Float']['output']>;
  channel_partner_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  crop_id?: Maybe<Scalars['Float']['output']>;
  distance_travelled?: Maybe<Scalars['Float']['output']>;
  fqr_primary_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  is_deleted?: Maybe<Scalars['Float']['output']>;
  kg_user_id?: Maybe<Scalars['Float']['output']>;
  lat_position?: Maybe<Scalars['Float']['output']>;
  location_id?: Maybe<Scalars['Float']['output']>;
  long_position?: Maybe<Scalars['Float']['output']>;
  manager_review?: Maybe<Scalars['Float']['output']>;
  order_number?: Maybe<Scalars['Float']['output']>;
  product_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
  village_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Pf_Plan_Cards_Stddev_Samp_Fields = {
  __typename?: 'pf_plan_cards_stddev_samp_fields';
  activity?: Maybe<Scalars['Float']['output']>;
  assign_to?: Maybe<Scalars['Float']['output']>;
  channel_partner_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  crop_id?: Maybe<Scalars['Float']['output']>;
  distance_travelled?: Maybe<Scalars['Float']['output']>;
  fqr_primary_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  is_deleted?: Maybe<Scalars['Float']['output']>;
  kg_user_id?: Maybe<Scalars['Float']['output']>;
  lat_position?: Maybe<Scalars['Float']['output']>;
  location_id?: Maybe<Scalars['Float']['output']>;
  long_position?: Maybe<Scalars['Float']['output']>;
  manager_review?: Maybe<Scalars['Float']['output']>;
  order_number?: Maybe<Scalars['Float']['output']>;
  product_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
  village_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "plan_cards" */
export type Pf_Plan_Cards_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pf_Plan_Cards_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Pf_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pf_Plan_Cards_Stream_Cursor_Value_Input = {
  activity?: InputMaybe<Scalars['bigint']['input']>;
  activity_coins?: InputMaybe<Scalars['String']['input']>;
  assign_to?: InputMaybe<Scalars['bigint']['input']>;
  card_type?: InputMaybe<Scalars['String']['input']>;
  channel_partner?: InputMaybe<Scalars['String']['input']>;
  channel_partner_id?: InputMaybe<Scalars['bigint']['input']>;
  created_by?: InputMaybe<Scalars['bigint']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  creation_mode?: InputMaybe<Scalars['String']['input']>;
  crm_customer_name?: InputMaybe<Scalars['String']['input']>;
  crm_phone_number?: InputMaybe<Scalars['String']['input']>;
  crop_id?: InputMaybe<Scalars['bigint']['input']>;
  crop_name?: InputMaybe<Scalars['String']['input']>;
  distance_travelled?: InputMaybe<Scalars['numeric']['input']>;
  fqr_id?: InputMaybe<Scalars['String']['input']>;
  fqr_primary_id?: InputMaybe<Scalars['bigint']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  hybrid_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_deleted?: InputMaybe<Scalars['bigint']['input']>;
  is_plan_moved?: InputMaybe<Scalars['String']['input']>;
  kg_user_id?: InputMaybe<Scalars['numeric']['input']>;
  land_type?: InputMaybe<Scalars['String']['input']>;
  lat_position?: InputMaybe<Scalars['numeric']['input']>;
  location_id?: InputMaybe<Scalars['bigint']['input']>;
  location_json?: InputMaybe<Scalars['json']['input']>;
  location_name?: InputMaybe<Scalars['String']['input']>;
  long_position?: InputMaybe<Scalars['numeric']['input']>;
  manager_review?: InputMaybe<Scalars['float8']['input']>;
  mobile_timestamp?: InputMaybe<Scalars['String']['input']>;
  mobile_timestamp2?: InputMaybe<Scalars['String']['input']>;
  order_number?: InputMaybe<Scalars['bigint']['input']>;
  plan_approval_status?: InputMaybe<Scalars['String']['input']>;
  plan_type?: InputMaybe<Scalars['String']['input']>;
  planned_date?: InputMaybe<Scalars['String']['input']>;
  product_id?: InputMaybe<Scalars['bigint']['input']>;
  product_name?: InputMaybe<Scalars['String']['input']>;
  season_value_1?: InputMaybe<Scalars['String']['input']>;
  season_value_2?: InputMaybe<Scalars['String']['input']>;
  season_value_3?: InputMaybe<Scalars['String']['input']>;
  season_value_4?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  submission_mode?: InputMaybe<Scalars['String']['input']>;
  submitted_users?: InputMaybe<Scalars['String']['input']>;
  submitted_users_phone?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['bigint']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_date_dt?: InputMaybe<Scalars['date']['input']>;
  village_id?: InputMaybe<Scalars['bigint']['input']>;
  village_name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Pf_Plan_Cards_Sum_Fields = {
  __typename?: 'pf_plan_cards_sum_fields';
  activity?: Maybe<Scalars['bigint']['output']>;
  assign_to?: Maybe<Scalars['bigint']['output']>;
  channel_partner_id?: Maybe<Scalars['bigint']['output']>;
  created_by?: Maybe<Scalars['bigint']['output']>;
  crop_id?: Maybe<Scalars['bigint']['output']>;
  distance_travelled?: Maybe<Scalars['numeric']['output']>;
  fqr_primary_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  is_deleted?: Maybe<Scalars['bigint']['output']>;
  kg_user_id?: Maybe<Scalars['numeric']['output']>;
  lat_position?: Maybe<Scalars['numeric']['output']>;
  location_id?: Maybe<Scalars['bigint']['output']>;
  long_position?: Maybe<Scalars['numeric']['output']>;
  manager_review?: Maybe<Scalars['float8']['output']>;
  order_number?: Maybe<Scalars['bigint']['output']>;
  product_id?: Maybe<Scalars['bigint']['output']>;
  updated_by?: Maybe<Scalars['bigint']['output']>;
  village_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "runpando_pro.plan_cards" */
export enum Pf_Plan_Cards_Update_Column {
  /** column name */
  Activity = 'activity',
  /** column name */
  ActivityCoins = 'activity_coins',
  /** column name */
  AssignTo = 'assign_to',
  /** column name */
  CardType = 'card_type',
  /** column name */
  ChannelPartner = 'channel_partner',
  /** column name */
  ChannelPartnerId = 'channel_partner_id',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CreatedDate = 'created_date',
  /** column name */
  CreationMode = 'creation_mode',
  /** column name */
  CrmCustomerName = 'crm_customer_name',
  /** column name */
  CrmPhoneNumber = 'crm_phone_number',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  CropName = 'crop_name',
  /** column name */
  DistanceTravelled = 'distance_travelled',
  /** column name */
  FqrId = 'fqr_id',
  /** column name */
  FqrPrimaryId = 'fqr_primary_id',
  /** column name */
  Guid = 'guid',
  /** column name */
  HybridId = 'hybrid_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsPlanMoved = 'is_plan_moved',
  /** column name */
  KgUserId = 'kg_user_id',
  /** column name */
  LandType = 'land_type',
  /** column name */
  LatPosition = 'lat_position',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  LocationJson = 'location_json',
  /** column name */
  LocationName = 'location_name',
  /** column name */
  LongPosition = 'long_position',
  /** column name */
  ManagerReview = 'manager_review',
  /** column name */
  MobileTimestamp = 'mobile_timestamp',
  /** column name */
  MobileTimestamp2 = 'mobile_timestamp2',
  /** column name */
  OrderNumber = 'order_number',
  /** column name */
  PlanApprovalStatus = 'plan_approval_status',
  /** column name */
  PlanType = 'plan_type',
  /** column name */
  PlannedDate = 'planned_date',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  ProductName = 'product_name',
  /** column name */
  SeasonValue_1 = 'season_value_1',
  /** column name */
  SeasonValue_2 = 'season_value_2',
  /** column name */
  SeasonValue_3 = 'season_value_3',
  /** column name */
  SeasonValue_4 = 'season_value_4',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Status = 'status',
  /** column name */
  SubmissionMode = 'submission_mode',
  /** column name */
  SubmittedUsers = 'submitted_users',
  /** column name */
  SubmittedUsersPhone = 'submitted_users_phone',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  UpdatedDate = 'updated_date',
  /** column name */
  UpdatedDateDt = 'updated_date_dt',
  /** column name */
  VillageId = 'village_id',
  /** column name */
  VillageName = 'village_name'
}

export type Pf_Plan_Cards_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pf_Plan_Cards_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pf_Plan_Cards_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pf_Plan_Cards_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pf_Plan_Cards_Var_Pop_Fields = {
  __typename?: 'pf_plan_cards_var_pop_fields';
  activity?: Maybe<Scalars['Float']['output']>;
  assign_to?: Maybe<Scalars['Float']['output']>;
  channel_partner_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  crop_id?: Maybe<Scalars['Float']['output']>;
  distance_travelled?: Maybe<Scalars['Float']['output']>;
  fqr_primary_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  is_deleted?: Maybe<Scalars['Float']['output']>;
  kg_user_id?: Maybe<Scalars['Float']['output']>;
  lat_position?: Maybe<Scalars['Float']['output']>;
  location_id?: Maybe<Scalars['Float']['output']>;
  long_position?: Maybe<Scalars['Float']['output']>;
  manager_review?: Maybe<Scalars['Float']['output']>;
  order_number?: Maybe<Scalars['Float']['output']>;
  product_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
  village_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Pf_Plan_Cards_Var_Samp_Fields = {
  __typename?: 'pf_plan_cards_var_samp_fields';
  activity?: Maybe<Scalars['Float']['output']>;
  assign_to?: Maybe<Scalars['Float']['output']>;
  channel_partner_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  crop_id?: Maybe<Scalars['Float']['output']>;
  distance_travelled?: Maybe<Scalars['Float']['output']>;
  fqr_primary_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  is_deleted?: Maybe<Scalars['Float']['output']>;
  kg_user_id?: Maybe<Scalars['Float']['output']>;
  lat_position?: Maybe<Scalars['Float']['output']>;
  location_id?: Maybe<Scalars['Float']['output']>;
  long_position?: Maybe<Scalars['Float']['output']>;
  manager_review?: Maybe<Scalars['Float']['output']>;
  order_number?: Maybe<Scalars['Float']['output']>;
  product_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
  village_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Pf_Plan_Cards_Variance_Fields = {
  __typename?: 'pf_plan_cards_variance_fields';
  activity?: Maybe<Scalars['Float']['output']>;
  assign_to?: Maybe<Scalars['Float']['output']>;
  channel_partner_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  crop_id?: Maybe<Scalars['Float']['output']>;
  distance_travelled?: Maybe<Scalars['Float']['output']>;
  fqr_primary_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  is_deleted?: Maybe<Scalars['Float']['output']>;
  kg_user_id?: Maybe<Scalars['Float']['output']>;
  lat_position?: Maybe<Scalars['Float']['output']>;
  location_id?: Maybe<Scalars['Float']['output']>;
  long_position?: Maybe<Scalars['Float']['output']>;
  manager_review?: Maybe<Scalars['Float']['output']>;
  order_number?: Maybe<Scalars['Float']['output']>;
  product_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
  village_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "runpando_pro.products" */
export type Pf_Products = {
  __typename?: 'pf_products';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  comp_id: Scalars['bigint']['output'];
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_by: Scalars['bigint']['output'];
  created_date: Scalars['timestamptz']['output'];
  crop_id: Scalars['bigint']['output'];
  data?: Maybe<Scalars['json']['output']>;
  fi_user_id?: Maybe<Scalars['bpchar']['output']>;
  guid: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
  /** 1 is deleted, 0 is active */
  is_deleted: Scalars['Boolean']['output'];
  product_id?: Maybe<Scalars['bpchar']['output']>;
  product_name: Scalars['String']['output'];
  role_id: Scalars['smallint']['output'];
  shopify_last_sync?: Maybe<Scalars['timestamptz']['output']>;
  shopify_product_id?: Maybe<Scalars['String']['output']>;
  shopify_variant_id?: Maybe<Scalars['String']['output']>;
  updated_by: Scalars['bigint']['output'];
  updated_date: Scalars['timestamptz']['output'];
  user_id: Scalars['bigint']['output'];
  /** An array relationship */
  work_orders: Array<Work_Orders>;
  /** An aggregate relationship */
  work_orders_aggregate: Work_Orders_Aggregate;
};


/** columns and relationships of "runpando_pro.products" */
export type Pf_ProductsDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "runpando_pro.products" */
export type Pf_ProductsWork_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Work_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Work_Orders_Order_By>>;
  where?: InputMaybe<Work_Orders_Bool_Exp>;
};


/** columns and relationships of "runpando_pro.products" */
export type Pf_ProductsWork_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Work_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Work_Orders_Order_By>>;
  where?: InputMaybe<Work_Orders_Bool_Exp>;
};

/** aggregated selection of "runpando_pro.products" */
export type Pf_Products_Aggregate = {
  __typename?: 'pf_products_aggregate';
  aggregate?: Maybe<Pf_Products_Aggregate_Fields>;
  nodes: Array<Pf_Products>;
};

/** aggregate fields of "runpando_pro.products" */
export type Pf_Products_Aggregate_Fields = {
  __typename?: 'pf_products_aggregate_fields';
  avg?: Maybe<Pf_Products_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pf_Products_Max_Fields>;
  min?: Maybe<Pf_Products_Min_Fields>;
  stddev?: Maybe<Pf_Products_Stddev_Fields>;
  stddev_pop?: Maybe<Pf_Products_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pf_Products_Stddev_Samp_Fields>;
  sum?: Maybe<Pf_Products_Sum_Fields>;
  var_pop?: Maybe<Pf_Products_Var_Pop_Fields>;
  var_samp?: Maybe<Pf_Products_Var_Samp_Fields>;
  variance?: Maybe<Pf_Products_Variance_Fields>;
};


/** aggregate fields of "runpando_pro.products" */
export type Pf_Products_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pf_Products_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Pf_Products_Avg_Fields = {
  __typename?: 'pf_products_avg_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  crop_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "runpando_pro.products". All fields are combined with a logical 'AND'. */
export type Pf_Products_Bool_Exp = {
  _and?: InputMaybe<Array<Pf_Products_Bool_Exp>>;
  _not?: InputMaybe<Pf_Products_Bool_Exp>;
  _or?: InputMaybe<Array<Pf_Products_Bool_Exp>>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  comp_id?: InputMaybe<Bigint_Comparison_Exp>;
  company_id?: InputMaybe<Bpchar_Comparison_Exp>;
  created_by?: InputMaybe<Bigint_Comparison_Exp>;
  created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  crop_id?: InputMaybe<Bigint_Comparison_Exp>;
  data?: InputMaybe<Json_Comparison_Exp>;
  fi_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  guid?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  product_id?: InputMaybe<Bpchar_Comparison_Exp>;
  product_name?: InputMaybe<String_Comparison_Exp>;
  role_id?: InputMaybe<Smallint_Comparison_Exp>;
  shopify_last_sync?: InputMaybe<Timestamptz_Comparison_Exp>;
  shopify_product_id?: InputMaybe<String_Comparison_Exp>;
  shopify_variant_id?: InputMaybe<String_Comparison_Exp>;
  updated_by?: InputMaybe<Bigint_Comparison_Exp>;
  updated_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
  work_orders?: InputMaybe<Work_Orders_Bool_Exp>;
  work_orders_aggregate?: InputMaybe<Work_Orders_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "runpando_pro.products" */
export enum Pf_Products_Constraint {
  /** unique or primary key constraint on columns "id" */
  Idx_631571Primary = 'idx_631571_primary',
  /** unique or primary key constraint on columns "product_id" */
  RunpandoProProductsProductIdUnique = 'runpando_pro_products_product_id_unique'
}

/** input type for incrementing numeric columns in table "runpando_pro.products" */
export type Pf_Products_Inc_Input = {
  comp_id?: InputMaybe<Scalars['bigint']['input']>;
  created_by?: InputMaybe<Scalars['bigint']['input']>;
  crop_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  role_id?: InputMaybe<Scalars['smallint']['input']>;
  updated_by?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "runpando_pro.products" */
export type Pf_Products_Insert_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  comp_id?: InputMaybe<Scalars['bigint']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_by?: InputMaybe<Scalars['bigint']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  crop_id?: InputMaybe<Scalars['bigint']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  fi_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  /** 1 is deleted, 0 is active */
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  product_id?: InputMaybe<Scalars['bpchar']['input']>;
  product_name?: InputMaybe<Scalars['String']['input']>;
  role_id?: InputMaybe<Scalars['smallint']['input']>;
  shopify_last_sync?: InputMaybe<Scalars['timestamptz']['input']>;
  shopify_product_id?: InputMaybe<Scalars['String']['input']>;
  shopify_variant_id?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['bigint']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  work_orders?: InputMaybe<Work_Orders_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Pf_Products_Max_Fields = {
  __typename?: 'pf_products_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  comp_id?: Maybe<Scalars['bigint']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_by?: Maybe<Scalars['bigint']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  crop_id?: Maybe<Scalars['bigint']['output']>;
  fi_user_id?: Maybe<Scalars['bpchar']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  product_id?: Maybe<Scalars['bpchar']['output']>;
  product_name?: Maybe<Scalars['String']['output']>;
  role_id?: Maybe<Scalars['smallint']['output']>;
  shopify_last_sync?: Maybe<Scalars['timestamptz']['output']>;
  shopify_product_id?: Maybe<Scalars['String']['output']>;
  shopify_variant_id?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['bigint']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Pf_Products_Min_Fields = {
  __typename?: 'pf_products_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  comp_id?: Maybe<Scalars['bigint']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_by?: Maybe<Scalars['bigint']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  crop_id?: Maybe<Scalars['bigint']['output']>;
  fi_user_id?: Maybe<Scalars['bpchar']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  product_id?: Maybe<Scalars['bpchar']['output']>;
  product_name?: Maybe<Scalars['String']['output']>;
  role_id?: Maybe<Scalars['smallint']['output']>;
  shopify_last_sync?: Maybe<Scalars['timestamptz']['output']>;
  shopify_product_id?: Maybe<Scalars['String']['output']>;
  shopify_variant_id?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['bigint']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "runpando_pro.products" */
export type Pf_Products_Mutation_Response = {
  __typename?: 'pf_products_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Pf_Products>;
};

/** input type for inserting object relation for remote table "runpando_pro.products" */
export type Pf_Products_Obj_Rel_Insert_Input = {
  data: Pf_Products_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Pf_Products_On_Conflict>;
};

/** on_conflict condition type for table "runpando_pro.products" */
export type Pf_Products_On_Conflict = {
  constraint: Pf_Products_Constraint;
  update_columns?: Array<Pf_Products_Update_Column>;
  where?: InputMaybe<Pf_Products_Bool_Exp>;
};

/** Ordering options when selecting data from "runpando_pro.products". */
export type Pf_Products_Order_By = {
  account_id?: InputMaybe<Order_By>;
  comp_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  fi_user_id?: InputMaybe<Order_By>;
  guid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  product_name?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  shopify_last_sync?: InputMaybe<Order_By>;
  shopify_product_id?: InputMaybe<Order_By>;
  shopify_variant_id?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  work_orders_aggregate?: InputMaybe<Work_Orders_Aggregate_Order_By>;
};

/** primary key columns input for table: runpando_pro.products */
export type Pf_Products_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "runpando_pro.products" */
export enum Pf_Products_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CompId = 'comp_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CreatedDate = 'created_date',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Data = 'data',
  /** column name */
  FiUserId = 'fi_user_id',
  /** column name */
  Guid = 'guid',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  ProductName = 'product_name',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  ShopifyLastSync = 'shopify_last_sync',
  /** column name */
  ShopifyProductId = 'shopify_product_id',
  /** column name */
  ShopifyVariantId = 'shopify_variant_id',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  UpdatedDate = 'updated_date',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "runpando_pro.products" */
export type Pf_Products_Set_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  comp_id?: InputMaybe<Scalars['bigint']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_by?: InputMaybe<Scalars['bigint']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  crop_id?: InputMaybe<Scalars['bigint']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  fi_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  /** 1 is deleted, 0 is active */
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  product_id?: InputMaybe<Scalars['bpchar']['input']>;
  product_name?: InputMaybe<Scalars['String']['input']>;
  role_id?: InputMaybe<Scalars['smallint']['input']>;
  shopify_last_sync?: InputMaybe<Scalars['timestamptz']['input']>;
  shopify_product_id?: InputMaybe<Scalars['String']['input']>;
  shopify_variant_id?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['bigint']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Pf_Products_Stddev_Fields = {
  __typename?: 'pf_products_stddev_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  crop_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Pf_Products_Stddev_Pop_Fields = {
  __typename?: 'pf_products_stddev_pop_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  crop_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Pf_Products_Stddev_Samp_Fields = {
  __typename?: 'pf_products_stddev_samp_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  crop_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "pf_products" */
export type Pf_Products_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pf_Products_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pf_Products_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  comp_id?: InputMaybe<Scalars['bigint']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_by?: InputMaybe<Scalars['bigint']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  crop_id?: InputMaybe<Scalars['bigint']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  fi_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  /** 1 is deleted, 0 is active */
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  product_id?: InputMaybe<Scalars['bpchar']['input']>;
  product_name?: InputMaybe<Scalars['String']['input']>;
  role_id?: InputMaybe<Scalars['smallint']['input']>;
  shopify_last_sync?: InputMaybe<Scalars['timestamptz']['input']>;
  shopify_product_id?: InputMaybe<Scalars['String']['input']>;
  shopify_variant_id?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['bigint']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Pf_Products_Sum_Fields = {
  __typename?: 'pf_products_sum_fields';
  comp_id?: Maybe<Scalars['bigint']['output']>;
  created_by?: Maybe<Scalars['bigint']['output']>;
  crop_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  role_id?: Maybe<Scalars['smallint']['output']>;
  updated_by?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "runpando_pro.products" */
export enum Pf_Products_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CompId = 'comp_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CreatedDate = 'created_date',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Data = 'data',
  /** column name */
  FiUserId = 'fi_user_id',
  /** column name */
  Guid = 'guid',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  ProductName = 'product_name',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  ShopifyLastSync = 'shopify_last_sync',
  /** column name */
  ShopifyProductId = 'shopify_product_id',
  /** column name */
  ShopifyVariantId = 'shopify_variant_id',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  UpdatedDate = 'updated_date',
  /** column name */
  UserId = 'user_id'
}

export type Pf_Products_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pf_Products_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pf_Products_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pf_Products_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pf_Products_Var_Pop_Fields = {
  __typename?: 'pf_products_var_pop_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  crop_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Pf_Products_Var_Samp_Fields = {
  __typename?: 'pf_products_var_samp_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  crop_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Pf_Products_Variance_Fields = {
  __typename?: 'pf_products_variance_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  crop_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "runpando_pro.activity_coins_feedback" */
export type Pf_Runpando_Pro_Activity_Coins_Feedback = {
  __typename?: 'pf_runpando_pro_activity_coins_feedback';
  comp_id: Scalars['bigint']['output'];
  created_date: Scalars['timestamptz']['output'];
  feedback?: Maybe<Scalars['String']['output']>;
  feedback_coins?: Maybe<Scalars['String']['output']>;
  feedback_comments?: Maybe<Scalars['String']['output']>;
  fieldfore_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  manager_id: Scalars['bigint']['output'];
  plan_card_id: Scalars['bigint']['output'];
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "runpando_pro.activity_coins_feedback" */
export type Pf_Runpando_Pro_Activity_Coins_Feedback_Aggregate = {
  __typename?: 'pf_runpando_pro_activity_coins_feedback_aggregate';
  aggregate?: Maybe<Pf_Runpando_Pro_Activity_Coins_Feedback_Aggregate_Fields>;
  nodes: Array<Pf_Runpando_Pro_Activity_Coins_Feedback>;
};

/** aggregate fields of "runpando_pro.activity_coins_feedback" */
export type Pf_Runpando_Pro_Activity_Coins_Feedback_Aggregate_Fields = {
  __typename?: 'pf_runpando_pro_activity_coins_feedback_aggregate_fields';
  avg?: Maybe<Pf_Runpando_Pro_Activity_Coins_Feedback_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pf_Runpando_Pro_Activity_Coins_Feedback_Max_Fields>;
  min?: Maybe<Pf_Runpando_Pro_Activity_Coins_Feedback_Min_Fields>;
  stddev?: Maybe<Pf_Runpando_Pro_Activity_Coins_Feedback_Stddev_Fields>;
  stddev_pop?: Maybe<Pf_Runpando_Pro_Activity_Coins_Feedback_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pf_Runpando_Pro_Activity_Coins_Feedback_Stddev_Samp_Fields>;
  sum?: Maybe<Pf_Runpando_Pro_Activity_Coins_Feedback_Sum_Fields>;
  var_pop?: Maybe<Pf_Runpando_Pro_Activity_Coins_Feedback_Var_Pop_Fields>;
  var_samp?: Maybe<Pf_Runpando_Pro_Activity_Coins_Feedback_Var_Samp_Fields>;
  variance?: Maybe<Pf_Runpando_Pro_Activity_Coins_Feedback_Variance_Fields>;
};


/** aggregate fields of "runpando_pro.activity_coins_feedback" */
export type Pf_Runpando_Pro_Activity_Coins_Feedback_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pf_Runpando_Pro_Activity_Coins_Feedback_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Pf_Runpando_Pro_Activity_Coins_Feedback_Avg_Fields = {
  __typename?: 'pf_runpando_pro_activity_coins_feedback_avg_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  fieldfore_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  manager_id?: Maybe<Scalars['Float']['output']>;
  plan_card_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "runpando_pro.activity_coins_feedback". All fields are combined with a logical 'AND'. */
export type Pf_Runpando_Pro_Activity_Coins_Feedback_Bool_Exp = {
  _and?: InputMaybe<Array<Pf_Runpando_Pro_Activity_Coins_Feedback_Bool_Exp>>;
  _not?: InputMaybe<Pf_Runpando_Pro_Activity_Coins_Feedback_Bool_Exp>;
  _or?: InputMaybe<Array<Pf_Runpando_Pro_Activity_Coins_Feedback_Bool_Exp>>;
  comp_id?: InputMaybe<Bigint_Comparison_Exp>;
  created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  feedback?: InputMaybe<String_Comparison_Exp>;
  feedback_coins?: InputMaybe<String_Comparison_Exp>;
  feedback_comments?: InputMaybe<String_Comparison_Exp>;
  fieldfore_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  manager_id?: InputMaybe<Bigint_Comparison_Exp>;
  plan_card_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_date?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "runpando_pro.activity_coins_feedback" */
export enum Pf_Runpando_Pro_Activity_Coins_Feedback_Constraint {
  /** unique or primary key constraint on columns "id" */
  Idx_630610Primary = 'idx_630610_primary'
}

/** input type for incrementing numeric columns in table "runpando_pro.activity_coins_feedback" */
export type Pf_Runpando_Pro_Activity_Coins_Feedback_Inc_Input = {
  comp_id?: InputMaybe<Scalars['bigint']['input']>;
  fieldfore_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  manager_id?: InputMaybe<Scalars['bigint']['input']>;
  plan_card_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "runpando_pro.activity_coins_feedback" */
export type Pf_Runpando_Pro_Activity_Coins_Feedback_Insert_Input = {
  comp_id?: InputMaybe<Scalars['bigint']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  feedback_coins?: InputMaybe<Scalars['String']['input']>;
  feedback_comments?: InputMaybe<Scalars['String']['input']>;
  fieldfore_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  manager_id?: InputMaybe<Scalars['bigint']['input']>;
  plan_card_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Pf_Runpando_Pro_Activity_Coins_Feedback_Max_Fields = {
  __typename?: 'pf_runpando_pro_activity_coins_feedback_max_fields';
  comp_id?: Maybe<Scalars['bigint']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  feedback?: Maybe<Scalars['String']['output']>;
  feedback_coins?: Maybe<Scalars['String']['output']>;
  feedback_comments?: Maybe<Scalars['String']['output']>;
  fieldfore_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  manager_id?: Maybe<Scalars['bigint']['output']>;
  plan_card_id?: Maybe<Scalars['bigint']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Pf_Runpando_Pro_Activity_Coins_Feedback_Min_Fields = {
  __typename?: 'pf_runpando_pro_activity_coins_feedback_min_fields';
  comp_id?: Maybe<Scalars['bigint']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  feedback?: Maybe<Scalars['String']['output']>;
  feedback_coins?: Maybe<Scalars['String']['output']>;
  feedback_comments?: Maybe<Scalars['String']['output']>;
  fieldfore_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  manager_id?: Maybe<Scalars['bigint']['output']>;
  plan_card_id?: Maybe<Scalars['bigint']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "runpando_pro.activity_coins_feedback" */
export type Pf_Runpando_Pro_Activity_Coins_Feedback_Mutation_Response = {
  __typename?: 'pf_runpando_pro_activity_coins_feedback_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Pf_Runpando_Pro_Activity_Coins_Feedback>;
};

/** input type for inserting object relation for remote table "runpando_pro.activity_coins_feedback" */
export type Pf_Runpando_Pro_Activity_Coins_Feedback_Obj_Rel_Insert_Input = {
  data: Pf_Runpando_Pro_Activity_Coins_Feedback_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Pf_Runpando_Pro_Activity_Coins_Feedback_On_Conflict>;
};

/** on_conflict condition type for table "runpando_pro.activity_coins_feedback" */
export type Pf_Runpando_Pro_Activity_Coins_Feedback_On_Conflict = {
  constraint: Pf_Runpando_Pro_Activity_Coins_Feedback_Constraint;
  update_columns?: Array<Pf_Runpando_Pro_Activity_Coins_Feedback_Update_Column>;
  where?: InputMaybe<Pf_Runpando_Pro_Activity_Coins_Feedback_Bool_Exp>;
};

/** Ordering options when selecting data from "runpando_pro.activity_coins_feedback". */
export type Pf_Runpando_Pro_Activity_Coins_Feedback_Order_By = {
  comp_id?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  feedback?: InputMaybe<Order_By>;
  feedback_coins?: InputMaybe<Order_By>;
  feedback_comments?: InputMaybe<Order_By>;
  fieldfore_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  manager_id?: InputMaybe<Order_By>;
  plan_card_id?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
};

/** primary key columns input for table: runpando_pro.activity_coins_feedback */
export type Pf_Runpando_Pro_Activity_Coins_Feedback_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "runpando_pro.activity_coins_feedback" */
export enum Pf_Runpando_Pro_Activity_Coins_Feedback_Select_Column {
  /** column name */
  CompId = 'comp_id',
  /** column name */
  CreatedDate = 'created_date',
  /** column name */
  Feedback = 'feedback',
  /** column name */
  FeedbackCoins = 'feedback_coins',
  /** column name */
  FeedbackComments = 'feedback_comments',
  /** column name */
  FieldforeId = 'fieldfore_id',
  /** column name */
  Id = 'id',
  /** column name */
  ManagerId = 'manager_id',
  /** column name */
  PlanCardId = 'plan_card_id',
  /** column name */
  UpdatedDate = 'updated_date'
}

/** input type for updating data in table "runpando_pro.activity_coins_feedback" */
export type Pf_Runpando_Pro_Activity_Coins_Feedback_Set_Input = {
  comp_id?: InputMaybe<Scalars['bigint']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  feedback_coins?: InputMaybe<Scalars['String']['input']>;
  feedback_comments?: InputMaybe<Scalars['String']['input']>;
  fieldfore_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  manager_id?: InputMaybe<Scalars['bigint']['input']>;
  plan_card_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Pf_Runpando_Pro_Activity_Coins_Feedback_Stddev_Fields = {
  __typename?: 'pf_runpando_pro_activity_coins_feedback_stddev_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  fieldfore_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  manager_id?: Maybe<Scalars['Float']['output']>;
  plan_card_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Pf_Runpando_Pro_Activity_Coins_Feedback_Stddev_Pop_Fields = {
  __typename?: 'pf_runpando_pro_activity_coins_feedback_stddev_pop_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  fieldfore_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  manager_id?: Maybe<Scalars['Float']['output']>;
  plan_card_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Pf_Runpando_Pro_Activity_Coins_Feedback_Stddev_Samp_Fields = {
  __typename?: 'pf_runpando_pro_activity_coins_feedback_stddev_samp_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  fieldfore_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  manager_id?: Maybe<Scalars['Float']['output']>;
  plan_card_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "runpando_pro_activity_coins_feedback" */
export type Pf_Runpando_Pro_Activity_Coins_Feedback_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pf_Runpando_Pro_Activity_Coins_Feedback_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Pf_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pf_Runpando_Pro_Activity_Coins_Feedback_Stream_Cursor_Value_Input = {
  comp_id?: InputMaybe<Scalars['bigint']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  feedback_coins?: InputMaybe<Scalars['String']['input']>;
  feedback_comments?: InputMaybe<Scalars['String']['input']>;
  fieldfore_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  manager_id?: InputMaybe<Scalars['bigint']['input']>;
  plan_card_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Pf_Runpando_Pro_Activity_Coins_Feedback_Sum_Fields = {
  __typename?: 'pf_runpando_pro_activity_coins_feedback_sum_fields';
  comp_id?: Maybe<Scalars['bigint']['output']>;
  fieldfore_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  manager_id?: Maybe<Scalars['bigint']['output']>;
  plan_card_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "runpando_pro.activity_coins_feedback" */
export enum Pf_Runpando_Pro_Activity_Coins_Feedback_Update_Column {
  /** column name */
  CompId = 'comp_id',
  /** column name */
  CreatedDate = 'created_date',
  /** column name */
  Feedback = 'feedback',
  /** column name */
  FeedbackCoins = 'feedback_coins',
  /** column name */
  FeedbackComments = 'feedback_comments',
  /** column name */
  FieldforeId = 'fieldfore_id',
  /** column name */
  Id = 'id',
  /** column name */
  ManagerId = 'manager_id',
  /** column name */
  PlanCardId = 'plan_card_id',
  /** column name */
  UpdatedDate = 'updated_date'
}

export type Pf_Runpando_Pro_Activity_Coins_Feedback_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pf_Runpando_Pro_Activity_Coins_Feedback_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pf_Runpando_Pro_Activity_Coins_Feedback_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pf_Runpando_Pro_Activity_Coins_Feedback_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pf_Runpando_Pro_Activity_Coins_Feedback_Var_Pop_Fields = {
  __typename?: 'pf_runpando_pro_activity_coins_feedback_var_pop_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  fieldfore_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  manager_id?: Maybe<Scalars['Float']['output']>;
  plan_card_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Pf_Runpando_Pro_Activity_Coins_Feedback_Var_Samp_Fields = {
  __typename?: 'pf_runpando_pro_activity_coins_feedback_var_samp_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  fieldfore_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  manager_id?: Maybe<Scalars['Float']['output']>;
  plan_card_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Pf_Runpando_Pro_Activity_Coins_Feedback_Variance_Fields = {
  __typename?: 'pf_runpando_pro_activity_coins_feedback_variance_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  fieldfore_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  manager_id?: Maybe<Scalars['Float']['output']>;
  plan_card_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "runpando_pro.all_state_data" */
export type Pf_Runpando_Pro_All_State_Data = {
  __typename?: 'pf_runpando_pro_all_state_data';
  comp_id?: Maybe<Scalars['bigint']['output']>;
  district_name?: Maybe<Scalars['String']['output']>;
  district_std?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  source?: Maybe<Scalars['String']['output']>;
  state_name?: Maybe<Scalars['String']['output']>;
  state_std?: Maybe<Scalars['String']['output']>;
  taluk_name?: Maybe<Scalars['String']['output']>;
  taluk_std?: Maybe<Scalars['String']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  users_locations: Array<Pf_Runpando_Pro_Users_Locations>;
  /** An aggregate relationship */
  users_locations_aggregate: Pf_Runpando_Pro_Users_Locations_Aggregate;
  village_name?: Maybe<Scalars['String']['output']>;
  village_std?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "runpando_pro.all_state_data" */
export type Pf_Runpando_Pro_All_State_DataUsers_LocationsArgs = {
  distinct_on?: InputMaybe<Array<Pf_Runpando_Pro_Users_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Runpando_Pro_Users_Locations_Order_By>>;
  where?: InputMaybe<Pf_Runpando_Pro_Users_Locations_Bool_Exp>;
};


/** columns and relationships of "runpando_pro.all_state_data" */
export type Pf_Runpando_Pro_All_State_DataUsers_Locations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pf_Runpando_Pro_Users_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Runpando_Pro_Users_Locations_Order_By>>;
  where?: InputMaybe<Pf_Runpando_Pro_Users_Locations_Bool_Exp>;
};

/** aggregated selection of "runpando_pro.all_state_data" */
export type Pf_Runpando_Pro_All_State_Data_Aggregate = {
  __typename?: 'pf_runpando_pro_all_state_data_aggregate';
  aggregate?: Maybe<Pf_Runpando_Pro_All_State_Data_Aggregate_Fields>;
  nodes: Array<Pf_Runpando_Pro_All_State_Data>;
};

/** aggregate fields of "runpando_pro.all_state_data" */
export type Pf_Runpando_Pro_All_State_Data_Aggregate_Fields = {
  __typename?: 'pf_runpando_pro_all_state_data_aggregate_fields';
  avg?: Maybe<Pf_Runpando_Pro_All_State_Data_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pf_Runpando_Pro_All_State_Data_Max_Fields>;
  min?: Maybe<Pf_Runpando_Pro_All_State_Data_Min_Fields>;
  stddev?: Maybe<Pf_Runpando_Pro_All_State_Data_Stddev_Fields>;
  stddev_pop?: Maybe<Pf_Runpando_Pro_All_State_Data_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pf_Runpando_Pro_All_State_Data_Stddev_Samp_Fields>;
  sum?: Maybe<Pf_Runpando_Pro_All_State_Data_Sum_Fields>;
  var_pop?: Maybe<Pf_Runpando_Pro_All_State_Data_Var_Pop_Fields>;
  var_samp?: Maybe<Pf_Runpando_Pro_All_State_Data_Var_Samp_Fields>;
  variance?: Maybe<Pf_Runpando_Pro_All_State_Data_Variance_Fields>;
};


/** aggregate fields of "runpando_pro.all_state_data" */
export type Pf_Runpando_Pro_All_State_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pf_Runpando_Pro_All_State_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Pf_Runpando_Pro_All_State_Data_Avg_Fields = {
  __typename?: 'pf_runpando_pro_all_state_data_avg_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "runpando_pro.all_state_data". All fields are combined with a logical 'AND'. */
export type Pf_Runpando_Pro_All_State_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Pf_Runpando_Pro_All_State_Data_Bool_Exp>>;
  _not?: InputMaybe<Pf_Runpando_Pro_All_State_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Pf_Runpando_Pro_All_State_Data_Bool_Exp>>;
  comp_id?: InputMaybe<Bigint_Comparison_Exp>;
  district_name?: InputMaybe<String_Comparison_Exp>;
  district_std?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  state_name?: InputMaybe<String_Comparison_Exp>;
  state_std?: InputMaybe<String_Comparison_Exp>;
  taluk_name?: InputMaybe<String_Comparison_Exp>;
  taluk_std?: InputMaybe<String_Comparison_Exp>;
  updated_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  users_locations?: InputMaybe<Pf_Runpando_Pro_Users_Locations_Bool_Exp>;
  users_locations_aggregate?: InputMaybe<Runpando_Pro_Users_Locations_Aggregate_Bool_Exp>;
  village_name?: InputMaybe<String_Comparison_Exp>;
  village_std?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "runpando_pro.all_state_data" */
export enum Pf_Runpando_Pro_All_State_Data_Constraint {
  /** unique or primary key constraint on columns "id" */
  Idx_630643Primary = 'idx_630643_primary'
}

/** input type for incrementing numeric columns in table "runpando_pro.all_state_data" */
export type Pf_Runpando_Pro_All_State_Data_Inc_Input = {
  comp_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "runpando_pro.all_state_data" */
export type Pf_Runpando_Pro_All_State_Data_Insert_Input = {
  comp_id?: InputMaybe<Scalars['bigint']['input']>;
  district_name?: InputMaybe<Scalars['String']['input']>;
  district_std?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  state_name?: InputMaybe<Scalars['String']['input']>;
  state_std?: InputMaybe<Scalars['String']['input']>;
  taluk_name?: InputMaybe<Scalars['String']['input']>;
  taluk_std?: InputMaybe<Scalars['String']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  users_locations?: InputMaybe<Pf_Runpando_Pro_Users_Locations_Arr_Rel_Insert_Input>;
  village_name?: InputMaybe<Scalars['String']['input']>;
  village_std?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Pf_Runpando_Pro_All_State_Data_Max_Fields = {
  __typename?: 'pf_runpando_pro_all_state_data_max_fields';
  comp_id?: Maybe<Scalars['bigint']['output']>;
  district_name?: Maybe<Scalars['String']['output']>;
  district_std?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  state_name?: Maybe<Scalars['String']['output']>;
  state_std?: Maybe<Scalars['String']['output']>;
  taluk_name?: Maybe<Scalars['String']['output']>;
  taluk_std?: Maybe<Scalars['String']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
  village_name?: Maybe<Scalars['String']['output']>;
  village_std?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Pf_Runpando_Pro_All_State_Data_Min_Fields = {
  __typename?: 'pf_runpando_pro_all_state_data_min_fields';
  comp_id?: Maybe<Scalars['bigint']['output']>;
  district_name?: Maybe<Scalars['String']['output']>;
  district_std?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  state_name?: Maybe<Scalars['String']['output']>;
  state_std?: Maybe<Scalars['String']['output']>;
  taluk_name?: Maybe<Scalars['String']['output']>;
  taluk_std?: Maybe<Scalars['String']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
  village_name?: Maybe<Scalars['String']['output']>;
  village_std?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "runpando_pro.all_state_data" */
export type Pf_Runpando_Pro_All_State_Data_Mutation_Response = {
  __typename?: 'pf_runpando_pro_all_state_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Pf_Runpando_Pro_All_State_Data>;
};

/** input type for inserting object relation for remote table "runpando_pro.all_state_data" */
export type Pf_Runpando_Pro_All_State_Data_Obj_Rel_Insert_Input = {
  data: Pf_Runpando_Pro_All_State_Data_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Pf_Runpando_Pro_All_State_Data_On_Conflict>;
};

/** on_conflict condition type for table "runpando_pro.all_state_data" */
export type Pf_Runpando_Pro_All_State_Data_On_Conflict = {
  constraint: Pf_Runpando_Pro_All_State_Data_Constraint;
  update_columns?: Array<Pf_Runpando_Pro_All_State_Data_Update_Column>;
  where?: InputMaybe<Pf_Runpando_Pro_All_State_Data_Bool_Exp>;
};

/** Ordering options when selecting data from "runpando_pro.all_state_data". */
export type Pf_Runpando_Pro_All_State_Data_Order_By = {
  comp_id?: InputMaybe<Order_By>;
  district_name?: InputMaybe<Order_By>;
  district_std?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  state_name?: InputMaybe<Order_By>;
  state_std?: InputMaybe<Order_By>;
  taluk_name?: InputMaybe<Order_By>;
  taluk_std?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
  users_locations_aggregate?: InputMaybe<Pf_Runpando_Pro_Users_Locations_Aggregate_Order_By>;
  village_name?: InputMaybe<Order_By>;
  village_std?: InputMaybe<Order_By>;
};

/** primary key columns input for table: runpando_pro.all_state_data */
export type Pf_Runpando_Pro_All_State_Data_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "runpando_pro.all_state_data" */
export enum Pf_Runpando_Pro_All_State_Data_Select_Column {
  /** column name */
  CompId = 'comp_id',
  /** column name */
  DistrictName = 'district_name',
  /** column name */
  DistrictStd = 'district_std',
  /** column name */
  Id = 'id',
  /** column name */
  Source = 'source',
  /** column name */
  StateName = 'state_name',
  /** column name */
  StateStd = 'state_std',
  /** column name */
  TalukName = 'taluk_name',
  /** column name */
  TalukStd = 'taluk_std',
  /** column name */
  UpdatedDate = 'updated_date',
  /** column name */
  VillageName = 'village_name',
  /** column name */
  VillageStd = 'village_std'
}

/** input type for updating data in table "runpando_pro.all_state_data" */
export type Pf_Runpando_Pro_All_State_Data_Set_Input = {
  comp_id?: InputMaybe<Scalars['bigint']['input']>;
  district_name?: InputMaybe<Scalars['String']['input']>;
  district_std?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  state_name?: InputMaybe<Scalars['String']['input']>;
  state_std?: InputMaybe<Scalars['String']['input']>;
  taluk_name?: InputMaybe<Scalars['String']['input']>;
  taluk_std?: InputMaybe<Scalars['String']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  village_name?: InputMaybe<Scalars['String']['input']>;
  village_std?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Pf_Runpando_Pro_All_State_Data_Stddev_Fields = {
  __typename?: 'pf_runpando_pro_all_state_data_stddev_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Pf_Runpando_Pro_All_State_Data_Stddev_Pop_Fields = {
  __typename?: 'pf_runpando_pro_all_state_data_stddev_pop_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Pf_Runpando_Pro_All_State_Data_Stddev_Samp_Fields = {
  __typename?: 'pf_runpando_pro_all_state_data_stddev_samp_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "runpando_pro_all_state_data" */
export type Pf_Runpando_Pro_All_State_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pf_Runpando_Pro_All_State_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Pf_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pf_Runpando_Pro_All_State_Data_Stream_Cursor_Value_Input = {
  comp_id?: InputMaybe<Scalars['bigint']['input']>;
  district_name?: InputMaybe<Scalars['String']['input']>;
  district_std?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  state_name?: InputMaybe<Scalars['String']['input']>;
  state_std?: InputMaybe<Scalars['String']['input']>;
  taluk_name?: InputMaybe<Scalars['String']['input']>;
  taluk_std?: InputMaybe<Scalars['String']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  village_name?: InputMaybe<Scalars['String']['input']>;
  village_std?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Pf_Runpando_Pro_All_State_Data_Sum_Fields = {
  __typename?: 'pf_runpando_pro_all_state_data_sum_fields';
  comp_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "runpando_pro.all_state_data" */
export enum Pf_Runpando_Pro_All_State_Data_Update_Column {
  /** column name */
  CompId = 'comp_id',
  /** column name */
  DistrictName = 'district_name',
  /** column name */
  DistrictStd = 'district_std',
  /** column name */
  Id = 'id',
  /** column name */
  Source = 'source',
  /** column name */
  StateName = 'state_name',
  /** column name */
  StateStd = 'state_std',
  /** column name */
  TalukName = 'taluk_name',
  /** column name */
  TalukStd = 'taluk_std',
  /** column name */
  UpdatedDate = 'updated_date',
  /** column name */
  VillageName = 'village_name',
  /** column name */
  VillageStd = 'village_std'
}

export type Pf_Runpando_Pro_All_State_Data_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pf_Runpando_Pro_All_State_Data_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pf_Runpando_Pro_All_State_Data_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pf_Runpando_Pro_All_State_Data_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pf_Runpando_Pro_All_State_Data_Var_Pop_Fields = {
  __typename?: 'pf_runpando_pro_all_state_data_var_pop_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Pf_Runpando_Pro_All_State_Data_Var_Samp_Fields = {
  __typename?: 'pf_runpando_pro_all_state_data_var_samp_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Pf_Runpando_Pro_All_State_Data_Variance_Fields = {
  __typename?: 'pf_runpando_pro_all_state_data_variance_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "runpando_pro.campaign_card_activities" */
export type Pf_Runpando_Pro_Campaign_Card_Activities = {
  __typename?: 'pf_runpando_pro_campaign_card_activities';
  contacted_person_name?: Maybe<Scalars['String']['output']>;
  contacted_person_phone?: Maybe<Scalars['String']['output']>;
  created_by: Scalars['bigint']['output'];
  created_date: Scalars['timestamptz']['output'];
  feedback?: Maybe<Scalars['String']['output']>;
  guid: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
  mobile_timestamp: Scalars['String']['output'];
  mobile_timestamp2?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  no_of_dealers?: Maybe<Scalars['String']['output']>;
  no_of_farmers?: Maybe<Scalars['String']['output']>;
  no_of_female_farmers?: Maybe<Scalars['String']['output']>;
  no_of_retailers?: Maybe<Scalars['String']['output']>;
  no_of_villages?: Maybe<Scalars['String']['output']>;
  picture1?: Maybe<Scalars['String']['output']>;
  picture1_uri?: Maybe<Scalars['String']['output']>;
  picture2?: Maybe<Scalars['String']['output']>;
  picture2_uri?: Maybe<Scalars['String']['output']>;
  picture3?: Maybe<Scalars['String']['output']>;
  picture3_uri?: Maybe<Scalars['String']['output']>;
  picture4?: Maybe<Scalars['String']['output']>;
  picture4_uri?: Maybe<Scalars['String']['output']>;
  plan_card_id: Scalars['bigint']['output'];
  purpose?: Maybe<Scalars['String']['output']>;
  sec_2_field_1?: Maybe<Scalars['String']['output']>;
  sec_2_field_2?: Maybe<Scalars['String']['output']>;
  sec_2_field_3?: Maybe<Scalars['String']['output']>;
  sec_2_field_4?: Maybe<Scalars['String']['output']>;
  sec_3_field_1?: Maybe<Scalars['String']['output']>;
  sec_3_field_2?: Maybe<Scalars['String']['output']>;
  sec_3_field_3?: Maybe<Scalars['String']['output']>;
  sec_3_field_4?: Maybe<Scalars['String']['output']>;
  sec_3_field_5?: Maybe<Scalars['String']['output']>;
  sec_4_field_1?: Maybe<Scalars['String']['output']>;
  sec_4_field_2?: Maybe<Scalars['String']['output']>;
  sec_4_field_3?: Maybe<Scalars['String']['output']>;
  sec_4_field_4?: Maybe<Scalars['String']['output']>;
  sms_template_campaign?: Maybe<Scalars['String']['output']>;
  sub_activity_id?: Maybe<Scalars['bigint']['output']>;
  updated_by: Scalars['bigint']['output'];
  updated_date: Scalars['timestamptz']['output'];
  userid: Scalars['bigint']['output'];
};

/** aggregated selection of "runpando_pro.campaign_card_activities" */
export type Pf_Runpando_Pro_Campaign_Card_Activities_Aggregate = {
  __typename?: 'pf_runpando_pro_campaign_card_activities_aggregate';
  aggregate?: Maybe<Pf_Runpando_Pro_Campaign_Card_Activities_Aggregate_Fields>;
  nodes: Array<Pf_Runpando_Pro_Campaign_Card_Activities>;
};

/** aggregate fields of "runpando_pro.campaign_card_activities" */
export type Pf_Runpando_Pro_Campaign_Card_Activities_Aggregate_Fields = {
  __typename?: 'pf_runpando_pro_campaign_card_activities_aggregate_fields';
  avg?: Maybe<Pf_Runpando_Pro_Campaign_Card_Activities_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pf_Runpando_Pro_Campaign_Card_Activities_Max_Fields>;
  min?: Maybe<Pf_Runpando_Pro_Campaign_Card_Activities_Min_Fields>;
  stddev?: Maybe<Pf_Runpando_Pro_Campaign_Card_Activities_Stddev_Fields>;
  stddev_pop?: Maybe<Pf_Runpando_Pro_Campaign_Card_Activities_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pf_Runpando_Pro_Campaign_Card_Activities_Stddev_Samp_Fields>;
  sum?: Maybe<Pf_Runpando_Pro_Campaign_Card_Activities_Sum_Fields>;
  var_pop?: Maybe<Pf_Runpando_Pro_Campaign_Card_Activities_Var_Pop_Fields>;
  var_samp?: Maybe<Pf_Runpando_Pro_Campaign_Card_Activities_Var_Samp_Fields>;
  variance?: Maybe<Pf_Runpando_Pro_Campaign_Card_Activities_Variance_Fields>;
};


/** aggregate fields of "runpando_pro.campaign_card_activities" */
export type Pf_Runpando_Pro_Campaign_Card_Activities_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pf_Runpando_Pro_Campaign_Card_Activities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Pf_Runpando_Pro_Campaign_Card_Activities_Avg_Fields = {
  __typename?: 'pf_runpando_pro_campaign_card_activities_avg_fields';
  created_by?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  plan_card_id?: Maybe<Scalars['Float']['output']>;
  sub_activity_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
  userid?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "runpando_pro.campaign_card_activities". All fields are combined with a logical 'AND'. */
export type Pf_Runpando_Pro_Campaign_Card_Activities_Bool_Exp = {
  _and?: InputMaybe<Array<Pf_Runpando_Pro_Campaign_Card_Activities_Bool_Exp>>;
  _not?: InputMaybe<Pf_Runpando_Pro_Campaign_Card_Activities_Bool_Exp>;
  _or?: InputMaybe<Array<Pf_Runpando_Pro_Campaign_Card_Activities_Bool_Exp>>;
  contacted_person_name?: InputMaybe<String_Comparison_Exp>;
  contacted_person_phone?: InputMaybe<String_Comparison_Exp>;
  created_by?: InputMaybe<Bigint_Comparison_Exp>;
  created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  feedback?: InputMaybe<String_Comparison_Exp>;
  guid?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  mobile_timestamp?: InputMaybe<String_Comparison_Exp>;
  mobile_timestamp2?: InputMaybe<String_Comparison_Exp>;
  mode?: InputMaybe<String_Comparison_Exp>;
  no_of_dealers?: InputMaybe<String_Comparison_Exp>;
  no_of_farmers?: InputMaybe<String_Comparison_Exp>;
  no_of_female_farmers?: InputMaybe<String_Comparison_Exp>;
  no_of_retailers?: InputMaybe<String_Comparison_Exp>;
  no_of_villages?: InputMaybe<String_Comparison_Exp>;
  picture1?: InputMaybe<String_Comparison_Exp>;
  picture1_uri?: InputMaybe<String_Comparison_Exp>;
  picture2?: InputMaybe<String_Comparison_Exp>;
  picture2_uri?: InputMaybe<String_Comparison_Exp>;
  picture3?: InputMaybe<String_Comparison_Exp>;
  picture3_uri?: InputMaybe<String_Comparison_Exp>;
  picture4?: InputMaybe<String_Comparison_Exp>;
  picture4_uri?: InputMaybe<String_Comparison_Exp>;
  plan_card_id?: InputMaybe<Bigint_Comparison_Exp>;
  purpose?: InputMaybe<String_Comparison_Exp>;
  sec_2_field_1?: InputMaybe<String_Comparison_Exp>;
  sec_2_field_2?: InputMaybe<String_Comparison_Exp>;
  sec_2_field_3?: InputMaybe<String_Comparison_Exp>;
  sec_2_field_4?: InputMaybe<String_Comparison_Exp>;
  sec_3_field_1?: InputMaybe<String_Comparison_Exp>;
  sec_3_field_2?: InputMaybe<String_Comparison_Exp>;
  sec_3_field_3?: InputMaybe<String_Comparison_Exp>;
  sec_3_field_4?: InputMaybe<String_Comparison_Exp>;
  sec_3_field_5?: InputMaybe<String_Comparison_Exp>;
  sec_4_field_1?: InputMaybe<String_Comparison_Exp>;
  sec_4_field_2?: InputMaybe<String_Comparison_Exp>;
  sec_4_field_3?: InputMaybe<String_Comparison_Exp>;
  sec_4_field_4?: InputMaybe<String_Comparison_Exp>;
  sms_template_campaign?: InputMaybe<String_Comparison_Exp>;
  sub_activity_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_by?: InputMaybe<Bigint_Comparison_Exp>;
  updated_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  userid?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "runpando_pro.campaign_card_activities" */
export enum Pf_Runpando_Pro_Campaign_Card_Activities_Constraint {
  /** unique or primary key constraint on columns "guid" */
  Idx_630708Guid = 'idx_630708_guid',
  /** unique or primary key constraint on columns "id" */
  Idx_630708Primary = 'idx_630708_primary',
  /** unique or primary key constraint on columns "userid", "mobile_timestamp" */
  Idx_630708UserIdMstmp = 'idx_630708_user_id_mstmp'
}

/** input type for incrementing numeric columns in table "runpando_pro.campaign_card_activities" */
export type Pf_Runpando_Pro_Campaign_Card_Activities_Inc_Input = {
  created_by?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  plan_card_id?: InputMaybe<Scalars['bigint']['input']>;
  sub_activity_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_by?: InputMaybe<Scalars['bigint']['input']>;
  userid?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "runpando_pro.campaign_card_activities" */
export type Pf_Runpando_Pro_Campaign_Card_Activities_Insert_Input = {
  contacted_person_name?: InputMaybe<Scalars['String']['input']>;
  contacted_person_phone?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['bigint']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  mobile_timestamp?: InputMaybe<Scalars['String']['input']>;
  mobile_timestamp2?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  no_of_dealers?: InputMaybe<Scalars['String']['input']>;
  no_of_farmers?: InputMaybe<Scalars['String']['input']>;
  no_of_female_farmers?: InputMaybe<Scalars['String']['input']>;
  no_of_retailers?: InputMaybe<Scalars['String']['input']>;
  no_of_villages?: InputMaybe<Scalars['String']['input']>;
  picture1?: InputMaybe<Scalars['String']['input']>;
  picture1_uri?: InputMaybe<Scalars['String']['input']>;
  picture2?: InputMaybe<Scalars['String']['input']>;
  picture2_uri?: InputMaybe<Scalars['String']['input']>;
  picture3?: InputMaybe<Scalars['String']['input']>;
  picture3_uri?: InputMaybe<Scalars['String']['input']>;
  picture4?: InputMaybe<Scalars['String']['input']>;
  picture4_uri?: InputMaybe<Scalars['String']['input']>;
  plan_card_id?: InputMaybe<Scalars['bigint']['input']>;
  purpose?: InputMaybe<Scalars['String']['input']>;
  sec_2_field_1?: InputMaybe<Scalars['String']['input']>;
  sec_2_field_2?: InputMaybe<Scalars['String']['input']>;
  sec_2_field_3?: InputMaybe<Scalars['String']['input']>;
  sec_2_field_4?: InputMaybe<Scalars['String']['input']>;
  sec_3_field_1?: InputMaybe<Scalars['String']['input']>;
  sec_3_field_2?: InputMaybe<Scalars['String']['input']>;
  sec_3_field_3?: InputMaybe<Scalars['String']['input']>;
  sec_3_field_4?: InputMaybe<Scalars['String']['input']>;
  sec_3_field_5?: InputMaybe<Scalars['String']['input']>;
  sec_4_field_1?: InputMaybe<Scalars['String']['input']>;
  sec_4_field_2?: InputMaybe<Scalars['String']['input']>;
  sec_4_field_3?: InputMaybe<Scalars['String']['input']>;
  sec_4_field_4?: InputMaybe<Scalars['String']['input']>;
  sms_template_campaign?: InputMaybe<Scalars['String']['input']>;
  sub_activity_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_by?: InputMaybe<Scalars['bigint']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  userid?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Pf_Runpando_Pro_Campaign_Card_Activities_Max_Fields = {
  __typename?: 'pf_runpando_pro_campaign_card_activities_max_fields';
  contacted_person_name?: Maybe<Scalars['String']['output']>;
  contacted_person_phone?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['bigint']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  feedback?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  mobile_timestamp?: Maybe<Scalars['String']['output']>;
  mobile_timestamp2?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  no_of_dealers?: Maybe<Scalars['String']['output']>;
  no_of_farmers?: Maybe<Scalars['String']['output']>;
  no_of_female_farmers?: Maybe<Scalars['String']['output']>;
  no_of_retailers?: Maybe<Scalars['String']['output']>;
  no_of_villages?: Maybe<Scalars['String']['output']>;
  picture1?: Maybe<Scalars['String']['output']>;
  picture1_uri?: Maybe<Scalars['String']['output']>;
  picture2?: Maybe<Scalars['String']['output']>;
  picture2_uri?: Maybe<Scalars['String']['output']>;
  picture3?: Maybe<Scalars['String']['output']>;
  picture3_uri?: Maybe<Scalars['String']['output']>;
  picture4?: Maybe<Scalars['String']['output']>;
  picture4_uri?: Maybe<Scalars['String']['output']>;
  plan_card_id?: Maybe<Scalars['bigint']['output']>;
  purpose?: Maybe<Scalars['String']['output']>;
  sec_2_field_1?: Maybe<Scalars['String']['output']>;
  sec_2_field_2?: Maybe<Scalars['String']['output']>;
  sec_2_field_3?: Maybe<Scalars['String']['output']>;
  sec_2_field_4?: Maybe<Scalars['String']['output']>;
  sec_3_field_1?: Maybe<Scalars['String']['output']>;
  sec_3_field_2?: Maybe<Scalars['String']['output']>;
  sec_3_field_3?: Maybe<Scalars['String']['output']>;
  sec_3_field_4?: Maybe<Scalars['String']['output']>;
  sec_3_field_5?: Maybe<Scalars['String']['output']>;
  sec_4_field_1?: Maybe<Scalars['String']['output']>;
  sec_4_field_2?: Maybe<Scalars['String']['output']>;
  sec_4_field_3?: Maybe<Scalars['String']['output']>;
  sec_4_field_4?: Maybe<Scalars['String']['output']>;
  sms_template_campaign?: Maybe<Scalars['String']['output']>;
  sub_activity_id?: Maybe<Scalars['bigint']['output']>;
  updated_by?: Maybe<Scalars['bigint']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
  userid?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Pf_Runpando_Pro_Campaign_Card_Activities_Min_Fields = {
  __typename?: 'pf_runpando_pro_campaign_card_activities_min_fields';
  contacted_person_name?: Maybe<Scalars['String']['output']>;
  contacted_person_phone?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['bigint']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  feedback?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  mobile_timestamp?: Maybe<Scalars['String']['output']>;
  mobile_timestamp2?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  no_of_dealers?: Maybe<Scalars['String']['output']>;
  no_of_farmers?: Maybe<Scalars['String']['output']>;
  no_of_female_farmers?: Maybe<Scalars['String']['output']>;
  no_of_retailers?: Maybe<Scalars['String']['output']>;
  no_of_villages?: Maybe<Scalars['String']['output']>;
  picture1?: Maybe<Scalars['String']['output']>;
  picture1_uri?: Maybe<Scalars['String']['output']>;
  picture2?: Maybe<Scalars['String']['output']>;
  picture2_uri?: Maybe<Scalars['String']['output']>;
  picture3?: Maybe<Scalars['String']['output']>;
  picture3_uri?: Maybe<Scalars['String']['output']>;
  picture4?: Maybe<Scalars['String']['output']>;
  picture4_uri?: Maybe<Scalars['String']['output']>;
  plan_card_id?: Maybe<Scalars['bigint']['output']>;
  purpose?: Maybe<Scalars['String']['output']>;
  sec_2_field_1?: Maybe<Scalars['String']['output']>;
  sec_2_field_2?: Maybe<Scalars['String']['output']>;
  sec_2_field_3?: Maybe<Scalars['String']['output']>;
  sec_2_field_4?: Maybe<Scalars['String']['output']>;
  sec_3_field_1?: Maybe<Scalars['String']['output']>;
  sec_3_field_2?: Maybe<Scalars['String']['output']>;
  sec_3_field_3?: Maybe<Scalars['String']['output']>;
  sec_3_field_4?: Maybe<Scalars['String']['output']>;
  sec_3_field_5?: Maybe<Scalars['String']['output']>;
  sec_4_field_1?: Maybe<Scalars['String']['output']>;
  sec_4_field_2?: Maybe<Scalars['String']['output']>;
  sec_4_field_3?: Maybe<Scalars['String']['output']>;
  sec_4_field_4?: Maybe<Scalars['String']['output']>;
  sms_template_campaign?: Maybe<Scalars['String']['output']>;
  sub_activity_id?: Maybe<Scalars['bigint']['output']>;
  updated_by?: Maybe<Scalars['bigint']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
  userid?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "runpando_pro.campaign_card_activities" */
export type Pf_Runpando_Pro_Campaign_Card_Activities_Mutation_Response = {
  __typename?: 'pf_runpando_pro_campaign_card_activities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Pf_Runpando_Pro_Campaign_Card_Activities>;
};

/** input type for inserting object relation for remote table "runpando_pro.campaign_card_activities" */
export type Pf_Runpando_Pro_Campaign_Card_Activities_Obj_Rel_Insert_Input = {
  data: Pf_Runpando_Pro_Campaign_Card_Activities_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Pf_Runpando_Pro_Campaign_Card_Activities_On_Conflict>;
};

/** on_conflict condition type for table "runpando_pro.campaign_card_activities" */
export type Pf_Runpando_Pro_Campaign_Card_Activities_On_Conflict = {
  constraint: Pf_Runpando_Pro_Campaign_Card_Activities_Constraint;
  update_columns?: Array<Pf_Runpando_Pro_Campaign_Card_Activities_Update_Column>;
  where?: InputMaybe<Pf_Runpando_Pro_Campaign_Card_Activities_Bool_Exp>;
};

/** Ordering options when selecting data from "runpando_pro.campaign_card_activities". */
export type Pf_Runpando_Pro_Campaign_Card_Activities_Order_By = {
  contacted_person_name?: InputMaybe<Order_By>;
  contacted_person_phone?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  feedback?: InputMaybe<Order_By>;
  guid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mobile_timestamp?: InputMaybe<Order_By>;
  mobile_timestamp2?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  no_of_dealers?: InputMaybe<Order_By>;
  no_of_farmers?: InputMaybe<Order_By>;
  no_of_female_farmers?: InputMaybe<Order_By>;
  no_of_retailers?: InputMaybe<Order_By>;
  no_of_villages?: InputMaybe<Order_By>;
  picture1?: InputMaybe<Order_By>;
  picture1_uri?: InputMaybe<Order_By>;
  picture2?: InputMaybe<Order_By>;
  picture2_uri?: InputMaybe<Order_By>;
  picture3?: InputMaybe<Order_By>;
  picture3_uri?: InputMaybe<Order_By>;
  picture4?: InputMaybe<Order_By>;
  picture4_uri?: InputMaybe<Order_By>;
  plan_card_id?: InputMaybe<Order_By>;
  purpose?: InputMaybe<Order_By>;
  sec_2_field_1?: InputMaybe<Order_By>;
  sec_2_field_2?: InputMaybe<Order_By>;
  sec_2_field_3?: InputMaybe<Order_By>;
  sec_2_field_4?: InputMaybe<Order_By>;
  sec_3_field_1?: InputMaybe<Order_By>;
  sec_3_field_2?: InputMaybe<Order_By>;
  sec_3_field_3?: InputMaybe<Order_By>;
  sec_3_field_4?: InputMaybe<Order_By>;
  sec_3_field_5?: InputMaybe<Order_By>;
  sec_4_field_1?: InputMaybe<Order_By>;
  sec_4_field_2?: InputMaybe<Order_By>;
  sec_4_field_3?: InputMaybe<Order_By>;
  sec_4_field_4?: InputMaybe<Order_By>;
  sms_template_campaign?: InputMaybe<Order_By>;
  sub_activity_id?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
  userid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: runpando_pro.campaign_card_activities */
export type Pf_Runpando_Pro_Campaign_Card_Activities_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "runpando_pro.campaign_card_activities" */
export enum Pf_Runpando_Pro_Campaign_Card_Activities_Select_Column {
  /** column name */
  ContactedPersonName = 'contacted_person_name',
  /** column name */
  ContactedPersonPhone = 'contacted_person_phone',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CreatedDate = 'created_date',
  /** column name */
  Feedback = 'feedback',
  /** column name */
  Guid = 'guid',
  /** column name */
  Id = 'id',
  /** column name */
  MobileTimestamp = 'mobile_timestamp',
  /** column name */
  MobileTimestamp2 = 'mobile_timestamp2',
  /** column name */
  Mode = 'mode',
  /** column name */
  NoOfDealers = 'no_of_dealers',
  /** column name */
  NoOfFarmers = 'no_of_farmers',
  /** column name */
  NoOfFemaleFarmers = 'no_of_female_farmers',
  /** column name */
  NoOfRetailers = 'no_of_retailers',
  /** column name */
  NoOfVillages = 'no_of_villages',
  /** column name */
  Picture1 = 'picture1',
  /** column name */
  Picture1Uri = 'picture1_uri',
  /** column name */
  Picture2 = 'picture2',
  /** column name */
  Picture2Uri = 'picture2_uri',
  /** column name */
  Picture3 = 'picture3',
  /** column name */
  Picture3Uri = 'picture3_uri',
  /** column name */
  Picture4 = 'picture4',
  /** column name */
  Picture4Uri = 'picture4_uri',
  /** column name */
  PlanCardId = 'plan_card_id',
  /** column name */
  Purpose = 'purpose',
  /** column name */
  Sec_2Field_1 = 'sec_2_field_1',
  /** column name */
  Sec_2Field_2 = 'sec_2_field_2',
  /** column name */
  Sec_2Field_3 = 'sec_2_field_3',
  /** column name */
  Sec_2Field_4 = 'sec_2_field_4',
  /** column name */
  Sec_3Field_1 = 'sec_3_field_1',
  /** column name */
  Sec_3Field_2 = 'sec_3_field_2',
  /** column name */
  Sec_3Field_3 = 'sec_3_field_3',
  /** column name */
  Sec_3Field_4 = 'sec_3_field_4',
  /** column name */
  Sec_3Field_5 = 'sec_3_field_5',
  /** column name */
  Sec_4Field_1 = 'sec_4_field_1',
  /** column name */
  Sec_4Field_2 = 'sec_4_field_2',
  /** column name */
  Sec_4Field_3 = 'sec_4_field_3',
  /** column name */
  Sec_4Field_4 = 'sec_4_field_4',
  /** column name */
  SmsTemplateCampaign = 'sms_template_campaign',
  /** column name */
  SubActivityId = 'sub_activity_id',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  UpdatedDate = 'updated_date',
  /** column name */
  Userid = 'userid'
}

/** input type for updating data in table "runpando_pro.campaign_card_activities" */
export type Pf_Runpando_Pro_Campaign_Card_Activities_Set_Input = {
  contacted_person_name?: InputMaybe<Scalars['String']['input']>;
  contacted_person_phone?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['bigint']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  mobile_timestamp?: InputMaybe<Scalars['String']['input']>;
  mobile_timestamp2?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  no_of_dealers?: InputMaybe<Scalars['String']['input']>;
  no_of_farmers?: InputMaybe<Scalars['String']['input']>;
  no_of_female_farmers?: InputMaybe<Scalars['String']['input']>;
  no_of_retailers?: InputMaybe<Scalars['String']['input']>;
  no_of_villages?: InputMaybe<Scalars['String']['input']>;
  picture1?: InputMaybe<Scalars['String']['input']>;
  picture1_uri?: InputMaybe<Scalars['String']['input']>;
  picture2?: InputMaybe<Scalars['String']['input']>;
  picture2_uri?: InputMaybe<Scalars['String']['input']>;
  picture3?: InputMaybe<Scalars['String']['input']>;
  picture3_uri?: InputMaybe<Scalars['String']['input']>;
  picture4?: InputMaybe<Scalars['String']['input']>;
  picture4_uri?: InputMaybe<Scalars['String']['input']>;
  plan_card_id?: InputMaybe<Scalars['bigint']['input']>;
  purpose?: InputMaybe<Scalars['String']['input']>;
  sec_2_field_1?: InputMaybe<Scalars['String']['input']>;
  sec_2_field_2?: InputMaybe<Scalars['String']['input']>;
  sec_2_field_3?: InputMaybe<Scalars['String']['input']>;
  sec_2_field_4?: InputMaybe<Scalars['String']['input']>;
  sec_3_field_1?: InputMaybe<Scalars['String']['input']>;
  sec_3_field_2?: InputMaybe<Scalars['String']['input']>;
  sec_3_field_3?: InputMaybe<Scalars['String']['input']>;
  sec_3_field_4?: InputMaybe<Scalars['String']['input']>;
  sec_3_field_5?: InputMaybe<Scalars['String']['input']>;
  sec_4_field_1?: InputMaybe<Scalars['String']['input']>;
  sec_4_field_2?: InputMaybe<Scalars['String']['input']>;
  sec_4_field_3?: InputMaybe<Scalars['String']['input']>;
  sec_4_field_4?: InputMaybe<Scalars['String']['input']>;
  sms_template_campaign?: InputMaybe<Scalars['String']['input']>;
  sub_activity_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_by?: InputMaybe<Scalars['bigint']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  userid?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Pf_Runpando_Pro_Campaign_Card_Activities_Stddev_Fields = {
  __typename?: 'pf_runpando_pro_campaign_card_activities_stddev_fields';
  created_by?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  plan_card_id?: Maybe<Scalars['Float']['output']>;
  sub_activity_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
  userid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Pf_Runpando_Pro_Campaign_Card_Activities_Stddev_Pop_Fields = {
  __typename?: 'pf_runpando_pro_campaign_card_activities_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  plan_card_id?: Maybe<Scalars['Float']['output']>;
  sub_activity_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
  userid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Pf_Runpando_Pro_Campaign_Card_Activities_Stddev_Samp_Fields = {
  __typename?: 'pf_runpando_pro_campaign_card_activities_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  plan_card_id?: Maybe<Scalars['Float']['output']>;
  sub_activity_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
  userid?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "runpando_pro_campaign_card_activities" */
export type Pf_Runpando_Pro_Campaign_Card_Activities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pf_Runpando_Pro_Campaign_Card_Activities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Pf_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pf_Runpando_Pro_Campaign_Card_Activities_Stream_Cursor_Value_Input = {
  contacted_person_name?: InputMaybe<Scalars['String']['input']>;
  contacted_person_phone?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['bigint']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  mobile_timestamp?: InputMaybe<Scalars['String']['input']>;
  mobile_timestamp2?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  no_of_dealers?: InputMaybe<Scalars['String']['input']>;
  no_of_farmers?: InputMaybe<Scalars['String']['input']>;
  no_of_female_farmers?: InputMaybe<Scalars['String']['input']>;
  no_of_retailers?: InputMaybe<Scalars['String']['input']>;
  no_of_villages?: InputMaybe<Scalars['String']['input']>;
  picture1?: InputMaybe<Scalars['String']['input']>;
  picture1_uri?: InputMaybe<Scalars['String']['input']>;
  picture2?: InputMaybe<Scalars['String']['input']>;
  picture2_uri?: InputMaybe<Scalars['String']['input']>;
  picture3?: InputMaybe<Scalars['String']['input']>;
  picture3_uri?: InputMaybe<Scalars['String']['input']>;
  picture4?: InputMaybe<Scalars['String']['input']>;
  picture4_uri?: InputMaybe<Scalars['String']['input']>;
  plan_card_id?: InputMaybe<Scalars['bigint']['input']>;
  purpose?: InputMaybe<Scalars['String']['input']>;
  sec_2_field_1?: InputMaybe<Scalars['String']['input']>;
  sec_2_field_2?: InputMaybe<Scalars['String']['input']>;
  sec_2_field_3?: InputMaybe<Scalars['String']['input']>;
  sec_2_field_4?: InputMaybe<Scalars['String']['input']>;
  sec_3_field_1?: InputMaybe<Scalars['String']['input']>;
  sec_3_field_2?: InputMaybe<Scalars['String']['input']>;
  sec_3_field_3?: InputMaybe<Scalars['String']['input']>;
  sec_3_field_4?: InputMaybe<Scalars['String']['input']>;
  sec_3_field_5?: InputMaybe<Scalars['String']['input']>;
  sec_4_field_1?: InputMaybe<Scalars['String']['input']>;
  sec_4_field_2?: InputMaybe<Scalars['String']['input']>;
  sec_4_field_3?: InputMaybe<Scalars['String']['input']>;
  sec_4_field_4?: InputMaybe<Scalars['String']['input']>;
  sms_template_campaign?: InputMaybe<Scalars['String']['input']>;
  sub_activity_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_by?: InputMaybe<Scalars['bigint']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  userid?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Pf_Runpando_Pro_Campaign_Card_Activities_Sum_Fields = {
  __typename?: 'pf_runpando_pro_campaign_card_activities_sum_fields';
  created_by?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  plan_card_id?: Maybe<Scalars['bigint']['output']>;
  sub_activity_id?: Maybe<Scalars['bigint']['output']>;
  updated_by?: Maybe<Scalars['bigint']['output']>;
  userid?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "runpando_pro.campaign_card_activities" */
export enum Pf_Runpando_Pro_Campaign_Card_Activities_Update_Column {
  /** column name */
  ContactedPersonName = 'contacted_person_name',
  /** column name */
  ContactedPersonPhone = 'contacted_person_phone',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CreatedDate = 'created_date',
  /** column name */
  Feedback = 'feedback',
  /** column name */
  Guid = 'guid',
  /** column name */
  Id = 'id',
  /** column name */
  MobileTimestamp = 'mobile_timestamp',
  /** column name */
  MobileTimestamp2 = 'mobile_timestamp2',
  /** column name */
  Mode = 'mode',
  /** column name */
  NoOfDealers = 'no_of_dealers',
  /** column name */
  NoOfFarmers = 'no_of_farmers',
  /** column name */
  NoOfFemaleFarmers = 'no_of_female_farmers',
  /** column name */
  NoOfRetailers = 'no_of_retailers',
  /** column name */
  NoOfVillages = 'no_of_villages',
  /** column name */
  Picture1 = 'picture1',
  /** column name */
  Picture1Uri = 'picture1_uri',
  /** column name */
  Picture2 = 'picture2',
  /** column name */
  Picture2Uri = 'picture2_uri',
  /** column name */
  Picture3 = 'picture3',
  /** column name */
  Picture3Uri = 'picture3_uri',
  /** column name */
  Picture4 = 'picture4',
  /** column name */
  Picture4Uri = 'picture4_uri',
  /** column name */
  PlanCardId = 'plan_card_id',
  /** column name */
  Purpose = 'purpose',
  /** column name */
  Sec_2Field_1 = 'sec_2_field_1',
  /** column name */
  Sec_2Field_2 = 'sec_2_field_2',
  /** column name */
  Sec_2Field_3 = 'sec_2_field_3',
  /** column name */
  Sec_2Field_4 = 'sec_2_field_4',
  /** column name */
  Sec_3Field_1 = 'sec_3_field_1',
  /** column name */
  Sec_3Field_2 = 'sec_3_field_2',
  /** column name */
  Sec_3Field_3 = 'sec_3_field_3',
  /** column name */
  Sec_3Field_4 = 'sec_3_field_4',
  /** column name */
  Sec_3Field_5 = 'sec_3_field_5',
  /** column name */
  Sec_4Field_1 = 'sec_4_field_1',
  /** column name */
  Sec_4Field_2 = 'sec_4_field_2',
  /** column name */
  Sec_4Field_3 = 'sec_4_field_3',
  /** column name */
  Sec_4Field_4 = 'sec_4_field_4',
  /** column name */
  SmsTemplateCampaign = 'sms_template_campaign',
  /** column name */
  SubActivityId = 'sub_activity_id',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  UpdatedDate = 'updated_date',
  /** column name */
  Userid = 'userid'
}

export type Pf_Runpando_Pro_Campaign_Card_Activities_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pf_Runpando_Pro_Campaign_Card_Activities_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pf_Runpando_Pro_Campaign_Card_Activities_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pf_Runpando_Pro_Campaign_Card_Activities_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pf_Runpando_Pro_Campaign_Card_Activities_Var_Pop_Fields = {
  __typename?: 'pf_runpando_pro_campaign_card_activities_var_pop_fields';
  created_by?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  plan_card_id?: Maybe<Scalars['Float']['output']>;
  sub_activity_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
  userid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Pf_Runpando_Pro_Campaign_Card_Activities_Var_Samp_Fields = {
  __typename?: 'pf_runpando_pro_campaign_card_activities_var_samp_fields';
  created_by?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  plan_card_id?: Maybe<Scalars['Float']['output']>;
  sub_activity_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
  userid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Pf_Runpando_Pro_Campaign_Card_Activities_Variance_Fields = {
  __typename?: 'pf_runpando_pro_campaign_card_activities_variance_fields';
  created_by?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  plan_card_id?: Maybe<Scalars['Float']['output']>;
  sub_activity_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
  userid?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "runpando_pro.channel_card_images" */
export type Pf_Runpando_Pro_Channel_Card_Images = {
  __typename?: 'pf_runpando_pro_channel_card_images';
  channel_card_activity_id?: Maybe<Scalars['bigint']['output']>;
  channel_card_image_id: Scalars['bigint']['output'];
  created_by: Scalars['bigint']['output'];
  created_date: Scalars['timestamptz']['output'];
  image_name?: Maybe<Scalars['String']['output']>;
  image_path?: Maybe<Scalars['String']['output']>;
  plan_card_id: Scalars['bigint']['output'];
  updated_by: Scalars['bigint']['output'];
  updated_date: Scalars['timestamptz']['output'];
};

/** aggregated selection of "runpando_pro.channel_card_images" */
export type Pf_Runpando_Pro_Channel_Card_Images_Aggregate = {
  __typename?: 'pf_runpando_pro_channel_card_images_aggregate';
  aggregate?: Maybe<Pf_Runpando_Pro_Channel_Card_Images_Aggregate_Fields>;
  nodes: Array<Pf_Runpando_Pro_Channel_Card_Images>;
};

/** aggregate fields of "runpando_pro.channel_card_images" */
export type Pf_Runpando_Pro_Channel_Card_Images_Aggregate_Fields = {
  __typename?: 'pf_runpando_pro_channel_card_images_aggregate_fields';
  avg?: Maybe<Pf_Runpando_Pro_Channel_Card_Images_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pf_Runpando_Pro_Channel_Card_Images_Max_Fields>;
  min?: Maybe<Pf_Runpando_Pro_Channel_Card_Images_Min_Fields>;
  stddev?: Maybe<Pf_Runpando_Pro_Channel_Card_Images_Stddev_Fields>;
  stddev_pop?: Maybe<Pf_Runpando_Pro_Channel_Card_Images_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pf_Runpando_Pro_Channel_Card_Images_Stddev_Samp_Fields>;
  sum?: Maybe<Pf_Runpando_Pro_Channel_Card_Images_Sum_Fields>;
  var_pop?: Maybe<Pf_Runpando_Pro_Channel_Card_Images_Var_Pop_Fields>;
  var_samp?: Maybe<Pf_Runpando_Pro_Channel_Card_Images_Var_Samp_Fields>;
  variance?: Maybe<Pf_Runpando_Pro_Channel_Card_Images_Variance_Fields>;
};


/** aggregate fields of "runpando_pro.channel_card_images" */
export type Pf_Runpando_Pro_Channel_Card_Images_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pf_Runpando_Pro_Channel_Card_Images_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "runpando_pro.channel_card_images" */
export type Pf_Runpando_Pro_Channel_Card_Images_Aggregate_Order_By = {
  avg?: InputMaybe<Pf_Runpando_Pro_Channel_Card_Images_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pf_Runpando_Pro_Channel_Card_Images_Max_Order_By>;
  min?: InputMaybe<Pf_Runpando_Pro_Channel_Card_Images_Min_Order_By>;
  stddev?: InputMaybe<Pf_Runpando_Pro_Channel_Card_Images_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Pf_Runpando_Pro_Channel_Card_Images_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Pf_Runpando_Pro_Channel_Card_Images_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Pf_Runpando_Pro_Channel_Card_Images_Sum_Order_By>;
  var_pop?: InputMaybe<Pf_Runpando_Pro_Channel_Card_Images_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Pf_Runpando_Pro_Channel_Card_Images_Var_Samp_Order_By>;
  variance?: InputMaybe<Pf_Runpando_Pro_Channel_Card_Images_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "runpando_pro.channel_card_images" */
export type Pf_Runpando_Pro_Channel_Card_Images_Arr_Rel_Insert_Input = {
  data: Array<Pf_Runpando_Pro_Channel_Card_Images_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Pf_Runpando_Pro_Channel_Card_Images_On_Conflict>;
};

/** aggregate avg on columns */
export type Pf_Runpando_Pro_Channel_Card_Images_Avg_Fields = {
  __typename?: 'pf_runpando_pro_channel_card_images_avg_fields';
  channel_card_activity_id?: Maybe<Scalars['Float']['output']>;
  channel_card_image_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  plan_card_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "runpando_pro.channel_card_images" */
export type Pf_Runpando_Pro_Channel_Card_Images_Avg_Order_By = {
  channel_card_activity_id?: InputMaybe<Order_By>;
  channel_card_image_id?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  plan_card_id?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "runpando_pro.channel_card_images". All fields are combined with a logical 'AND'. */
export type Pf_Runpando_Pro_Channel_Card_Images_Bool_Exp = {
  _and?: InputMaybe<Array<Pf_Runpando_Pro_Channel_Card_Images_Bool_Exp>>;
  _not?: InputMaybe<Pf_Runpando_Pro_Channel_Card_Images_Bool_Exp>;
  _or?: InputMaybe<Array<Pf_Runpando_Pro_Channel_Card_Images_Bool_Exp>>;
  channel_card_activity_id?: InputMaybe<Bigint_Comparison_Exp>;
  channel_card_image_id?: InputMaybe<Bigint_Comparison_Exp>;
  created_by?: InputMaybe<Bigint_Comparison_Exp>;
  created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  image_name?: InputMaybe<String_Comparison_Exp>;
  image_path?: InputMaybe<String_Comparison_Exp>;
  plan_card_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_by?: InputMaybe<Bigint_Comparison_Exp>;
  updated_date?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "runpando_pro.channel_card_images" */
export enum Pf_Runpando_Pro_Channel_Card_Images_Constraint {
  /** unique or primary key constraint on columns "channel_card_image_id" */
  Idx_630728Primary = 'idx_630728_primary'
}

/** input type for incrementing numeric columns in table "runpando_pro.channel_card_images" */
export type Pf_Runpando_Pro_Channel_Card_Images_Inc_Input = {
  channel_card_activity_id?: InputMaybe<Scalars['bigint']['input']>;
  channel_card_image_id?: InputMaybe<Scalars['bigint']['input']>;
  created_by?: InputMaybe<Scalars['bigint']['input']>;
  plan_card_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_by?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "runpando_pro.channel_card_images" */
export type Pf_Runpando_Pro_Channel_Card_Images_Insert_Input = {
  channel_card_activity_id?: InputMaybe<Scalars['bigint']['input']>;
  channel_card_image_id?: InputMaybe<Scalars['bigint']['input']>;
  created_by?: InputMaybe<Scalars['bigint']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  image_name?: InputMaybe<Scalars['String']['input']>;
  image_path?: InputMaybe<Scalars['String']['input']>;
  plan_card_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_by?: InputMaybe<Scalars['bigint']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Pf_Runpando_Pro_Channel_Card_Images_Max_Fields = {
  __typename?: 'pf_runpando_pro_channel_card_images_max_fields';
  channel_card_activity_id?: Maybe<Scalars['bigint']['output']>;
  channel_card_image_id?: Maybe<Scalars['bigint']['output']>;
  created_by?: Maybe<Scalars['bigint']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  image_name?: Maybe<Scalars['String']['output']>;
  image_path?: Maybe<Scalars['String']['output']>;
  plan_card_id?: Maybe<Scalars['bigint']['output']>;
  updated_by?: Maybe<Scalars['bigint']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "runpando_pro.channel_card_images" */
export type Pf_Runpando_Pro_Channel_Card_Images_Max_Order_By = {
  channel_card_activity_id?: InputMaybe<Order_By>;
  channel_card_image_id?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  image_name?: InputMaybe<Order_By>;
  image_path?: InputMaybe<Order_By>;
  plan_card_id?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Pf_Runpando_Pro_Channel_Card_Images_Min_Fields = {
  __typename?: 'pf_runpando_pro_channel_card_images_min_fields';
  channel_card_activity_id?: Maybe<Scalars['bigint']['output']>;
  channel_card_image_id?: Maybe<Scalars['bigint']['output']>;
  created_by?: Maybe<Scalars['bigint']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  image_name?: Maybe<Scalars['String']['output']>;
  image_path?: Maybe<Scalars['String']['output']>;
  plan_card_id?: Maybe<Scalars['bigint']['output']>;
  updated_by?: Maybe<Scalars['bigint']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "runpando_pro.channel_card_images" */
export type Pf_Runpando_Pro_Channel_Card_Images_Min_Order_By = {
  channel_card_activity_id?: InputMaybe<Order_By>;
  channel_card_image_id?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  image_name?: InputMaybe<Order_By>;
  image_path?: InputMaybe<Order_By>;
  plan_card_id?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "runpando_pro.channel_card_images" */
export type Pf_Runpando_Pro_Channel_Card_Images_Mutation_Response = {
  __typename?: 'pf_runpando_pro_channel_card_images_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Pf_Runpando_Pro_Channel_Card_Images>;
};

/** on_conflict condition type for table "runpando_pro.channel_card_images" */
export type Pf_Runpando_Pro_Channel_Card_Images_On_Conflict = {
  constraint: Pf_Runpando_Pro_Channel_Card_Images_Constraint;
  update_columns?: Array<Pf_Runpando_Pro_Channel_Card_Images_Update_Column>;
  where?: InputMaybe<Pf_Runpando_Pro_Channel_Card_Images_Bool_Exp>;
};

/** Ordering options when selecting data from "runpando_pro.channel_card_images". */
export type Pf_Runpando_Pro_Channel_Card_Images_Order_By = {
  channel_card_activity_id?: InputMaybe<Order_By>;
  channel_card_image_id?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  image_name?: InputMaybe<Order_By>;
  image_path?: InputMaybe<Order_By>;
  plan_card_id?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
};

/** primary key columns input for table: runpando_pro.channel_card_images */
export type Pf_Runpando_Pro_Channel_Card_Images_Pk_Columns_Input = {
  channel_card_image_id: Scalars['bigint']['input'];
};

/** select columns of table "runpando_pro.channel_card_images" */
export enum Pf_Runpando_Pro_Channel_Card_Images_Select_Column {
  /** column name */
  ChannelCardActivityId = 'channel_card_activity_id',
  /** column name */
  ChannelCardImageId = 'channel_card_image_id',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CreatedDate = 'created_date',
  /** column name */
  ImageName = 'image_name',
  /** column name */
  ImagePath = 'image_path',
  /** column name */
  PlanCardId = 'plan_card_id',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  UpdatedDate = 'updated_date'
}

/** input type for updating data in table "runpando_pro.channel_card_images" */
export type Pf_Runpando_Pro_Channel_Card_Images_Set_Input = {
  channel_card_activity_id?: InputMaybe<Scalars['bigint']['input']>;
  channel_card_image_id?: InputMaybe<Scalars['bigint']['input']>;
  created_by?: InputMaybe<Scalars['bigint']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  image_name?: InputMaybe<Scalars['String']['input']>;
  image_path?: InputMaybe<Scalars['String']['input']>;
  plan_card_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_by?: InputMaybe<Scalars['bigint']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Pf_Runpando_Pro_Channel_Card_Images_Stddev_Fields = {
  __typename?: 'pf_runpando_pro_channel_card_images_stddev_fields';
  channel_card_activity_id?: Maybe<Scalars['Float']['output']>;
  channel_card_image_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  plan_card_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "runpando_pro.channel_card_images" */
export type Pf_Runpando_Pro_Channel_Card_Images_Stddev_Order_By = {
  channel_card_activity_id?: InputMaybe<Order_By>;
  channel_card_image_id?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  plan_card_id?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Pf_Runpando_Pro_Channel_Card_Images_Stddev_Pop_Fields = {
  __typename?: 'pf_runpando_pro_channel_card_images_stddev_pop_fields';
  channel_card_activity_id?: Maybe<Scalars['Float']['output']>;
  channel_card_image_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  plan_card_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "runpando_pro.channel_card_images" */
export type Pf_Runpando_Pro_Channel_Card_Images_Stddev_Pop_Order_By = {
  channel_card_activity_id?: InputMaybe<Order_By>;
  channel_card_image_id?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  plan_card_id?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Pf_Runpando_Pro_Channel_Card_Images_Stddev_Samp_Fields = {
  __typename?: 'pf_runpando_pro_channel_card_images_stddev_samp_fields';
  channel_card_activity_id?: Maybe<Scalars['Float']['output']>;
  channel_card_image_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  plan_card_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "runpando_pro.channel_card_images" */
export type Pf_Runpando_Pro_Channel_Card_Images_Stddev_Samp_Order_By = {
  channel_card_activity_id?: InputMaybe<Order_By>;
  channel_card_image_id?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  plan_card_id?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "runpando_pro_channel_card_images" */
export type Pf_Runpando_Pro_Channel_Card_Images_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pf_Runpando_Pro_Channel_Card_Images_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Pf_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pf_Runpando_Pro_Channel_Card_Images_Stream_Cursor_Value_Input = {
  channel_card_activity_id?: InputMaybe<Scalars['bigint']['input']>;
  channel_card_image_id?: InputMaybe<Scalars['bigint']['input']>;
  created_by?: InputMaybe<Scalars['bigint']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  image_name?: InputMaybe<Scalars['String']['input']>;
  image_path?: InputMaybe<Scalars['String']['input']>;
  plan_card_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_by?: InputMaybe<Scalars['bigint']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Pf_Runpando_Pro_Channel_Card_Images_Sum_Fields = {
  __typename?: 'pf_runpando_pro_channel_card_images_sum_fields';
  channel_card_activity_id?: Maybe<Scalars['bigint']['output']>;
  channel_card_image_id?: Maybe<Scalars['bigint']['output']>;
  created_by?: Maybe<Scalars['bigint']['output']>;
  plan_card_id?: Maybe<Scalars['bigint']['output']>;
  updated_by?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "runpando_pro.channel_card_images" */
export type Pf_Runpando_Pro_Channel_Card_Images_Sum_Order_By = {
  channel_card_activity_id?: InputMaybe<Order_By>;
  channel_card_image_id?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  plan_card_id?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** update columns of table "runpando_pro.channel_card_images" */
export enum Pf_Runpando_Pro_Channel_Card_Images_Update_Column {
  /** column name */
  ChannelCardActivityId = 'channel_card_activity_id',
  /** column name */
  ChannelCardImageId = 'channel_card_image_id',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CreatedDate = 'created_date',
  /** column name */
  ImageName = 'image_name',
  /** column name */
  ImagePath = 'image_path',
  /** column name */
  PlanCardId = 'plan_card_id',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  UpdatedDate = 'updated_date'
}

export type Pf_Runpando_Pro_Channel_Card_Images_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pf_Runpando_Pro_Channel_Card_Images_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pf_Runpando_Pro_Channel_Card_Images_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pf_Runpando_Pro_Channel_Card_Images_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pf_Runpando_Pro_Channel_Card_Images_Var_Pop_Fields = {
  __typename?: 'pf_runpando_pro_channel_card_images_var_pop_fields';
  channel_card_activity_id?: Maybe<Scalars['Float']['output']>;
  channel_card_image_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  plan_card_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "runpando_pro.channel_card_images" */
export type Pf_Runpando_Pro_Channel_Card_Images_Var_Pop_Order_By = {
  channel_card_activity_id?: InputMaybe<Order_By>;
  channel_card_image_id?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  plan_card_id?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Pf_Runpando_Pro_Channel_Card_Images_Var_Samp_Fields = {
  __typename?: 'pf_runpando_pro_channel_card_images_var_samp_fields';
  channel_card_activity_id?: Maybe<Scalars['Float']['output']>;
  channel_card_image_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  plan_card_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "runpando_pro.channel_card_images" */
export type Pf_Runpando_Pro_Channel_Card_Images_Var_Samp_Order_By = {
  channel_card_activity_id?: InputMaybe<Order_By>;
  channel_card_image_id?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  plan_card_id?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Pf_Runpando_Pro_Channel_Card_Images_Variance_Fields = {
  __typename?: 'pf_runpando_pro_channel_card_images_variance_fields';
  channel_card_activity_id?: Maybe<Scalars['Float']['output']>;
  channel_card_image_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  plan_card_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "runpando_pro.channel_card_images" */
export type Pf_Runpando_Pro_Channel_Card_Images_Variance_Order_By = {
  channel_card_activity_id?: InputMaybe<Order_By>;
  channel_card_image_id?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  plan_card_id?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** columns and relationships of "runpando_pro.users_locations" */
export type Pf_Runpando_Pro_Users_Locations = {
  __typename?: 'pf_runpando_pro_users_locations';
  activity_id?: Maybe<Scalars['String']['output']>;
  comp_id?: Maybe<Scalars['bigint']['output']>;
  created_date?: Maybe<Scalars['date']['output']>;
  id: Scalars['bigint']['output'];
  is_active?: Maybe<Scalars['bigint']['output']>;
  is_deleted?: Maybe<Scalars['bigint']['output']>;
  location_id?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  market?: Maybe<Pf_Users>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "runpando_pro.users_locations" */
export type Pf_Runpando_Pro_Users_Locations_Aggregate = {
  __typename?: 'pf_runpando_pro_users_locations_aggregate';
  aggregate?: Maybe<Pf_Runpando_Pro_Users_Locations_Aggregate_Fields>;
  nodes: Array<Pf_Runpando_Pro_Users_Locations>;
};

/** aggregate fields of "runpando_pro.users_locations" */
export type Pf_Runpando_Pro_Users_Locations_Aggregate_Fields = {
  __typename?: 'pf_runpando_pro_users_locations_aggregate_fields';
  avg?: Maybe<Pf_Runpando_Pro_Users_Locations_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pf_Runpando_Pro_Users_Locations_Max_Fields>;
  min?: Maybe<Pf_Runpando_Pro_Users_Locations_Min_Fields>;
  stddev?: Maybe<Pf_Runpando_Pro_Users_Locations_Stddev_Fields>;
  stddev_pop?: Maybe<Pf_Runpando_Pro_Users_Locations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pf_Runpando_Pro_Users_Locations_Stddev_Samp_Fields>;
  sum?: Maybe<Pf_Runpando_Pro_Users_Locations_Sum_Fields>;
  var_pop?: Maybe<Pf_Runpando_Pro_Users_Locations_Var_Pop_Fields>;
  var_samp?: Maybe<Pf_Runpando_Pro_Users_Locations_Var_Samp_Fields>;
  variance?: Maybe<Pf_Runpando_Pro_Users_Locations_Variance_Fields>;
};


/** aggregate fields of "runpando_pro.users_locations" */
export type Pf_Runpando_Pro_Users_Locations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pf_Runpando_Pro_Users_Locations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "runpando_pro.users_locations" */
export type Pf_Runpando_Pro_Users_Locations_Aggregate_Order_By = {
  avg?: InputMaybe<Pf_Runpando_Pro_Users_Locations_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pf_Runpando_Pro_Users_Locations_Max_Order_By>;
  min?: InputMaybe<Pf_Runpando_Pro_Users_Locations_Min_Order_By>;
  stddev?: InputMaybe<Pf_Runpando_Pro_Users_Locations_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Pf_Runpando_Pro_Users_Locations_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Pf_Runpando_Pro_Users_Locations_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Pf_Runpando_Pro_Users_Locations_Sum_Order_By>;
  var_pop?: InputMaybe<Pf_Runpando_Pro_Users_Locations_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Pf_Runpando_Pro_Users_Locations_Var_Samp_Order_By>;
  variance?: InputMaybe<Pf_Runpando_Pro_Users_Locations_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "runpando_pro.users_locations" */
export type Pf_Runpando_Pro_Users_Locations_Arr_Rel_Insert_Input = {
  data: Array<Pf_Runpando_Pro_Users_Locations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Pf_Runpando_Pro_Users_Locations_On_Conflict>;
};

/** aggregate avg on columns */
export type Pf_Runpando_Pro_Users_Locations_Avg_Fields = {
  __typename?: 'pf_runpando_pro_users_locations_avg_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  is_active?: Maybe<Scalars['Float']['output']>;
  is_deleted?: Maybe<Scalars['Float']['output']>;
  location_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "runpando_pro.users_locations" */
export type Pf_Runpando_Pro_Users_Locations_Avg_Order_By = {
  comp_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "runpando_pro.users_locations". All fields are combined with a logical 'AND'. */
export type Pf_Runpando_Pro_Users_Locations_Bool_Exp = {
  _and?: InputMaybe<Array<Pf_Runpando_Pro_Users_Locations_Bool_Exp>>;
  _not?: InputMaybe<Pf_Runpando_Pro_Users_Locations_Bool_Exp>;
  _or?: InputMaybe<Array<Pf_Runpando_Pro_Users_Locations_Bool_Exp>>;
  activity_id?: InputMaybe<String_Comparison_Exp>;
  comp_id?: InputMaybe<Bigint_Comparison_Exp>;
  created_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Bigint_Comparison_Exp>;
  is_deleted?: InputMaybe<Bigint_Comparison_Exp>;
  location_id?: InputMaybe<Bigint_Comparison_Exp>;
  market?: InputMaybe<Pf_Users_Bool_Exp>;
  updated_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "runpando_pro.users_locations" */
export enum Pf_Runpando_Pro_Users_Locations_Constraint {
  /** unique or primary key constraint on columns "id" */
  Idx_632067Primary = 'idx_632067_primary',
  /** unique or primary key constraint on columns "user_id", "location_id" */
  Idx_632067UsersLocationsUserIdIdx = 'idx_632067_users_locations_user_id_idx'
}

/** input type for incrementing numeric columns in table "runpando_pro.users_locations" */
export type Pf_Runpando_Pro_Users_Locations_Inc_Input = {
  comp_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_active?: InputMaybe<Scalars['bigint']['input']>;
  is_deleted?: InputMaybe<Scalars['bigint']['input']>;
  location_id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "runpando_pro.users_locations" */
export type Pf_Runpando_Pro_Users_Locations_Insert_Input = {
  activity_id?: InputMaybe<Scalars['String']['input']>;
  comp_id?: InputMaybe<Scalars['bigint']['input']>;
  created_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_active?: InputMaybe<Scalars['bigint']['input']>;
  is_deleted?: InputMaybe<Scalars['bigint']['input']>;
  location_id?: InputMaybe<Scalars['bigint']['input']>;
  market?: InputMaybe<Pf_Users_Obj_Rel_Insert_Input>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Pf_Runpando_Pro_Users_Locations_Max_Fields = {
  __typename?: 'pf_runpando_pro_users_locations_max_fields';
  activity_id?: Maybe<Scalars['String']['output']>;
  comp_id?: Maybe<Scalars['bigint']['output']>;
  created_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  is_active?: Maybe<Scalars['bigint']['output']>;
  is_deleted?: Maybe<Scalars['bigint']['output']>;
  location_id?: Maybe<Scalars['bigint']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "runpando_pro.users_locations" */
export type Pf_Runpando_Pro_Users_Locations_Max_Order_By = {
  activity_id?: InputMaybe<Order_By>;
  comp_id?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Pf_Runpando_Pro_Users_Locations_Min_Fields = {
  __typename?: 'pf_runpando_pro_users_locations_min_fields';
  activity_id?: Maybe<Scalars['String']['output']>;
  comp_id?: Maybe<Scalars['bigint']['output']>;
  created_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  is_active?: Maybe<Scalars['bigint']['output']>;
  is_deleted?: Maybe<Scalars['bigint']['output']>;
  location_id?: Maybe<Scalars['bigint']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "runpando_pro.users_locations" */
export type Pf_Runpando_Pro_Users_Locations_Min_Order_By = {
  activity_id?: InputMaybe<Order_By>;
  comp_id?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "runpando_pro.users_locations" */
export type Pf_Runpando_Pro_Users_Locations_Mutation_Response = {
  __typename?: 'pf_runpando_pro_users_locations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Pf_Runpando_Pro_Users_Locations>;
};

/** on_conflict condition type for table "runpando_pro.users_locations" */
export type Pf_Runpando_Pro_Users_Locations_On_Conflict = {
  constraint: Pf_Runpando_Pro_Users_Locations_Constraint;
  update_columns?: Array<Pf_Runpando_Pro_Users_Locations_Update_Column>;
  where?: InputMaybe<Pf_Runpando_Pro_Users_Locations_Bool_Exp>;
};

/** Ordering options when selecting data from "runpando_pro.users_locations". */
export type Pf_Runpando_Pro_Users_Locations_Order_By = {
  activity_id?: InputMaybe<Order_By>;
  comp_id?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  market?: InputMaybe<Pf_Users_Order_By>;
  updated_date?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: runpando_pro.users_locations */
export type Pf_Runpando_Pro_Users_Locations_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "runpando_pro.users_locations" */
export enum Pf_Runpando_Pro_Users_Locations_Select_Column {
  /** column name */
  ActivityId = 'activity_id',
  /** column name */
  CompId = 'comp_id',
  /** column name */
  CreatedDate = 'created_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  UpdatedDate = 'updated_date',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "runpando_pro.users_locations" */
export type Pf_Runpando_Pro_Users_Locations_Set_Input = {
  activity_id?: InputMaybe<Scalars['String']['input']>;
  comp_id?: InputMaybe<Scalars['bigint']['input']>;
  created_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_active?: InputMaybe<Scalars['bigint']['input']>;
  is_deleted?: InputMaybe<Scalars['bigint']['input']>;
  location_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Pf_Runpando_Pro_Users_Locations_Stddev_Fields = {
  __typename?: 'pf_runpando_pro_users_locations_stddev_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  is_active?: Maybe<Scalars['Float']['output']>;
  is_deleted?: Maybe<Scalars['Float']['output']>;
  location_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "runpando_pro.users_locations" */
export type Pf_Runpando_Pro_Users_Locations_Stddev_Order_By = {
  comp_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Pf_Runpando_Pro_Users_Locations_Stddev_Pop_Fields = {
  __typename?: 'pf_runpando_pro_users_locations_stddev_pop_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  is_active?: Maybe<Scalars['Float']['output']>;
  is_deleted?: Maybe<Scalars['Float']['output']>;
  location_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "runpando_pro.users_locations" */
export type Pf_Runpando_Pro_Users_Locations_Stddev_Pop_Order_By = {
  comp_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Pf_Runpando_Pro_Users_Locations_Stddev_Samp_Fields = {
  __typename?: 'pf_runpando_pro_users_locations_stddev_samp_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  is_active?: Maybe<Scalars['Float']['output']>;
  is_deleted?: Maybe<Scalars['Float']['output']>;
  location_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "runpando_pro.users_locations" */
export type Pf_Runpando_Pro_Users_Locations_Stddev_Samp_Order_By = {
  comp_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "runpando_pro_users_locations" */
export type Pf_Runpando_Pro_Users_Locations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pf_Runpando_Pro_Users_Locations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Pf_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pf_Runpando_Pro_Users_Locations_Stream_Cursor_Value_Input = {
  activity_id?: InputMaybe<Scalars['String']['input']>;
  comp_id?: InputMaybe<Scalars['bigint']['input']>;
  created_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_active?: InputMaybe<Scalars['bigint']['input']>;
  is_deleted?: InputMaybe<Scalars['bigint']['input']>;
  location_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Pf_Runpando_Pro_Users_Locations_Sum_Fields = {
  __typename?: 'pf_runpando_pro_users_locations_sum_fields';
  comp_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  is_active?: Maybe<Scalars['bigint']['output']>;
  is_deleted?: Maybe<Scalars['bigint']['output']>;
  location_id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "runpando_pro.users_locations" */
export type Pf_Runpando_Pro_Users_Locations_Sum_Order_By = {
  comp_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "runpando_pro.users_locations" */
export enum Pf_Runpando_Pro_Users_Locations_Update_Column {
  /** column name */
  ActivityId = 'activity_id',
  /** column name */
  CompId = 'comp_id',
  /** column name */
  CreatedDate = 'created_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  UpdatedDate = 'updated_date',
  /** column name */
  UserId = 'user_id'
}

export type Pf_Runpando_Pro_Users_Locations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pf_Runpando_Pro_Users_Locations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pf_Runpando_Pro_Users_Locations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pf_Runpando_Pro_Users_Locations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pf_Runpando_Pro_Users_Locations_Var_Pop_Fields = {
  __typename?: 'pf_runpando_pro_users_locations_var_pop_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  is_active?: Maybe<Scalars['Float']['output']>;
  is_deleted?: Maybe<Scalars['Float']['output']>;
  location_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "runpando_pro.users_locations" */
export type Pf_Runpando_Pro_Users_Locations_Var_Pop_Order_By = {
  comp_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Pf_Runpando_Pro_Users_Locations_Var_Samp_Fields = {
  __typename?: 'pf_runpando_pro_users_locations_var_samp_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  is_active?: Maybe<Scalars['Float']['output']>;
  is_deleted?: Maybe<Scalars['Float']['output']>;
  location_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "runpando_pro.users_locations" */
export type Pf_Runpando_Pro_Users_Locations_Var_Samp_Order_By = {
  comp_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Pf_Runpando_Pro_Users_Locations_Variance_Fields = {
  __typename?: 'pf_runpando_pro_users_locations_variance_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  is_active?: Maybe<Scalars['Float']['output']>;
  is_deleted?: Maybe<Scalars['Float']['output']>;
  location_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "runpando_pro.users_locations" */
export type Pf_Runpando_Pro_Users_Locations_Variance_Order_By = {
  comp_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "runpando_pro.user_travellog" */
export type Pf_User_Travellog = {
  __typename?: 'pf_user_travellog';
  date_time?: Maybe<Scalars['timestamptz']['output']>;
  distance_travelled?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['bigint']['output'];
  latitude_position: Scalars['numeric']['output'];
  location_name?: Maybe<Scalars['String']['output']>;
  longitude_position: Scalars['numeric']['output'];
  mobile_timestamp: Scalars['String']['output'];
  mode?: Maybe<Scalars['String']['output']>;
  order_number: Scalars['bigint']['output'];
  start_time?: Maybe<Scalars['timestamptz']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['bigint']['output'];
};

/** aggregated selection of "runpando_pro.user_travellog" */
export type Pf_User_Travellog_Aggregate = {
  __typename?: 'pf_user_travellog_aggregate';
  aggregate?: Maybe<Pf_User_Travellog_Aggregate_Fields>;
  nodes: Array<Pf_User_Travellog>;
};

/** aggregate fields of "runpando_pro.user_travellog" */
export type Pf_User_Travellog_Aggregate_Fields = {
  __typename?: 'pf_user_travellog_aggregate_fields';
  avg?: Maybe<Pf_User_Travellog_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pf_User_Travellog_Max_Fields>;
  min?: Maybe<Pf_User_Travellog_Min_Fields>;
  stddev?: Maybe<Pf_User_Travellog_Stddev_Fields>;
  stddev_pop?: Maybe<Pf_User_Travellog_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pf_User_Travellog_Stddev_Samp_Fields>;
  sum?: Maybe<Pf_User_Travellog_Sum_Fields>;
  var_pop?: Maybe<Pf_User_Travellog_Var_Pop_Fields>;
  var_samp?: Maybe<Pf_User_Travellog_Var_Samp_Fields>;
  variance?: Maybe<Pf_User_Travellog_Variance_Fields>;
};


/** aggregate fields of "runpando_pro.user_travellog" */
export type Pf_User_Travellog_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pf_User_Travellog_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Pf_User_Travellog_Avg_Fields = {
  __typename?: 'pf_user_travellog_avg_fields';
  distance_travelled?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  latitude_position?: Maybe<Scalars['Float']['output']>;
  longitude_position?: Maybe<Scalars['Float']['output']>;
  order_number?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "runpando_pro.user_travellog". All fields are combined with a logical 'AND'. */
export type Pf_User_Travellog_Bool_Exp = {
  _and?: InputMaybe<Array<Pf_User_Travellog_Bool_Exp>>;
  _not?: InputMaybe<Pf_User_Travellog_Bool_Exp>;
  _or?: InputMaybe<Array<Pf_User_Travellog_Bool_Exp>>;
  date_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  distance_travelled?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  latitude_position?: InputMaybe<Numeric_Comparison_Exp>;
  location_name?: InputMaybe<String_Comparison_Exp>;
  longitude_position?: InputMaybe<Numeric_Comparison_Exp>;
  mobile_timestamp?: InputMaybe<String_Comparison_Exp>;
  mode?: InputMaybe<String_Comparison_Exp>;
  order_number?: InputMaybe<Bigint_Comparison_Exp>;
  start_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "runpando_pro.user_travellog" */
export enum Pf_User_Travellog_Constraint {
  /** unique or primary key constraint on columns "id" */
  Idx_632127Primary = 'idx_632127_primary'
}

/** input type for incrementing numeric columns in table "runpando_pro.user_travellog" */
export type Pf_User_Travellog_Inc_Input = {
  distance_travelled?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  latitude_position?: InputMaybe<Scalars['numeric']['input']>;
  longitude_position?: InputMaybe<Scalars['numeric']['input']>;
  order_number?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "runpando_pro.user_travellog" */
export type Pf_User_Travellog_Insert_Input = {
  date_time?: InputMaybe<Scalars['timestamptz']['input']>;
  distance_travelled?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  latitude_position?: InputMaybe<Scalars['numeric']['input']>;
  location_name?: InputMaybe<Scalars['String']['input']>;
  longitude_position?: InputMaybe<Scalars['numeric']['input']>;
  mobile_timestamp?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  order_number?: InputMaybe<Scalars['bigint']['input']>;
  start_time?: InputMaybe<Scalars['timestamptz']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Pf_User_Travellog_Max_Fields = {
  __typename?: 'pf_user_travellog_max_fields';
  date_time?: Maybe<Scalars['timestamptz']['output']>;
  distance_travelled?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  latitude_position?: Maybe<Scalars['numeric']['output']>;
  location_name?: Maybe<Scalars['String']['output']>;
  longitude_position?: Maybe<Scalars['numeric']['output']>;
  mobile_timestamp?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  order_number?: Maybe<Scalars['bigint']['output']>;
  start_time?: Maybe<Scalars['timestamptz']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Pf_User_Travellog_Min_Fields = {
  __typename?: 'pf_user_travellog_min_fields';
  date_time?: Maybe<Scalars['timestamptz']['output']>;
  distance_travelled?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  latitude_position?: Maybe<Scalars['numeric']['output']>;
  location_name?: Maybe<Scalars['String']['output']>;
  longitude_position?: Maybe<Scalars['numeric']['output']>;
  mobile_timestamp?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  order_number?: Maybe<Scalars['bigint']['output']>;
  start_time?: Maybe<Scalars['timestamptz']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "runpando_pro.user_travellog" */
export type Pf_User_Travellog_Mutation_Response = {
  __typename?: 'pf_user_travellog_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Pf_User_Travellog>;
};

/** on_conflict condition type for table "runpando_pro.user_travellog" */
export type Pf_User_Travellog_On_Conflict = {
  constraint: Pf_User_Travellog_Constraint;
  update_columns?: Array<Pf_User_Travellog_Update_Column>;
  where?: InputMaybe<Pf_User_Travellog_Bool_Exp>;
};

/** Ordering options when selecting data from "runpando_pro.user_travellog". */
export type Pf_User_Travellog_Order_By = {
  date_time?: InputMaybe<Order_By>;
  distance_travelled?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latitude_position?: InputMaybe<Order_By>;
  location_name?: InputMaybe<Order_By>;
  longitude_position?: InputMaybe<Order_By>;
  mobile_timestamp?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  order_number?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: runpando_pro.user_travellog */
export type Pf_User_Travellog_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "runpando_pro.user_travellog" */
export enum Pf_User_Travellog_Select_Column {
  /** column name */
  DateTime = 'date_time',
  /** column name */
  DistanceTravelled = 'distance_travelled',
  /** column name */
  Id = 'id',
  /** column name */
  LatitudePosition = 'latitude_position',
  /** column name */
  LocationName = 'location_name',
  /** column name */
  LongitudePosition = 'longitude_position',
  /** column name */
  MobileTimestamp = 'mobile_timestamp',
  /** column name */
  Mode = 'mode',
  /** column name */
  OrderNumber = 'order_number',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "runpando_pro.user_travellog" */
export type Pf_User_Travellog_Set_Input = {
  date_time?: InputMaybe<Scalars['timestamptz']['input']>;
  distance_travelled?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  latitude_position?: InputMaybe<Scalars['numeric']['input']>;
  location_name?: InputMaybe<Scalars['String']['input']>;
  longitude_position?: InputMaybe<Scalars['numeric']['input']>;
  mobile_timestamp?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  order_number?: InputMaybe<Scalars['bigint']['input']>;
  start_time?: InputMaybe<Scalars['timestamptz']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Pf_User_Travellog_Stddev_Fields = {
  __typename?: 'pf_user_travellog_stddev_fields';
  distance_travelled?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  latitude_position?: Maybe<Scalars['Float']['output']>;
  longitude_position?: Maybe<Scalars['Float']['output']>;
  order_number?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Pf_User_Travellog_Stddev_Pop_Fields = {
  __typename?: 'pf_user_travellog_stddev_pop_fields';
  distance_travelled?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  latitude_position?: Maybe<Scalars['Float']['output']>;
  longitude_position?: Maybe<Scalars['Float']['output']>;
  order_number?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Pf_User_Travellog_Stddev_Samp_Fields = {
  __typename?: 'pf_user_travellog_stddev_samp_fields';
  distance_travelled?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  latitude_position?: Maybe<Scalars['Float']['output']>;
  longitude_position?: Maybe<Scalars['Float']['output']>;
  order_number?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "pf_user_travellog" */
export type Pf_User_Travellog_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pf_User_Travellog_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pf_User_Travellog_Stream_Cursor_Value_Input = {
  date_time?: InputMaybe<Scalars['timestamptz']['input']>;
  distance_travelled?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  latitude_position?: InputMaybe<Scalars['numeric']['input']>;
  location_name?: InputMaybe<Scalars['String']['input']>;
  longitude_position?: InputMaybe<Scalars['numeric']['input']>;
  mobile_timestamp?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  order_number?: InputMaybe<Scalars['bigint']['input']>;
  start_time?: InputMaybe<Scalars['timestamptz']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Pf_User_Travellog_Sum_Fields = {
  __typename?: 'pf_user_travellog_sum_fields';
  distance_travelled?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  latitude_position?: Maybe<Scalars['numeric']['output']>;
  longitude_position?: Maybe<Scalars['numeric']['output']>;
  order_number?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "runpando_pro.user_travellog" */
export enum Pf_User_Travellog_Update_Column {
  /** column name */
  DateTime = 'date_time',
  /** column name */
  DistanceTravelled = 'distance_travelled',
  /** column name */
  Id = 'id',
  /** column name */
  LatitudePosition = 'latitude_position',
  /** column name */
  LocationName = 'location_name',
  /** column name */
  LongitudePosition = 'longitude_position',
  /** column name */
  MobileTimestamp = 'mobile_timestamp',
  /** column name */
  Mode = 'mode',
  /** column name */
  OrderNumber = 'order_number',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id'
}

export type Pf_User_Travellog_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pf_User_Travellog_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pf_User_Travellog_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pf_User_Travellog_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pf_User_Travellog_Var_Pop_Fields = {
  __typename?: 'pf_user_travellog_var_pop_fields';
  distance_travelled?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  latitude_position?: Maybe<Scalars['Float']['output']>;
  longitude_position?: Maybe<Scalars['Float']['output']>;
  order_number?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Pf_User_Travellog_Var_Samp_Fields = {
  __typename?: 'pf_user_travellog_var_samp_fields';
  distance_travelled?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  latitude_position?: Maybe<Scalars['Float']['output']>;
  longitude_position?: Maybe<Scalars['Float']['output']>;
  order_number?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Pf_User_Travellog_Variance_Fields = {
  __typename?: 'pf_user_travellog_variance_fields';
  distance_travelled?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  latitude_position?: Maybe<Scalars['Float']['output']>;
  longitude_position?: Maybe<Scalars['Float']['output']>;
  order_number?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "runpando_pro.users" */
export type Pf_Users = {
  __typename?: 'pf_users';
  access_token?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['bigint']['output']>;
  app_language_id?: Maybe<Scalars['bigint']['output']>;
  area_of_operatoin?: Maybe<Scalars['String']['output']>;
  auth_key?: Maybe<Scalars['String']['output']>;
  business_group?: Maybe<Scalars['String']['output']>;
  business_group_code?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_by: Scalars['bigint']['output'];
  created_date: Scalars['timestamptz']['output'];
  designation?: Maybe<Scalars['String']['output']>;
  designation_id?: Maybe<Scalars['bigint']['output']>;
  device_identifier?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  district_code?: Maybe<Scalars['String']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  employee_number?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  geography_id?: Maybe<Scalars['bigint']['output']>;
  guid: Scalars['String']['output'];
  hashkey?: Maybe<Scalars['String']['output']>;
  head_quarters?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  input_company_id: Scalars['bigint']['output'];
  ip_address?: Maybe<Scalars['String']['output']>;
  is_blocked: Scalars['bigint']['output'];
  is_deleted: Scalars['bigint']['output'];
  is_login: Scalars['smallint']['output'];
  is_login_api: Scalars['smallint']['output'];
  is_notification_on?: Maybe<Scalars['smallint']['output']>;
  is_otp_verified?: Maybe<Scalars['String']['output']>;
  kg_user_id?: Maybe<Scalars['numeric']['output']>;
  knowledge_tab?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  license_active?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  manager_name?: Maybe<Scalars['String']['output']>;
  marker_id?: Maybe<Scalars['bigint']['output']>;
  market_error?: Maybe<Scalars['String']['output']>;
  mobile_validation?: Maybe<Scalars['String']['output']>;
  otp?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  photo_path?: Maybe<Scalars['String']['output']>;
  pin?: Maybe<Scalars['String']['output']>;
  reporting_structure?: Maybe<Scalars['String']['output']>;
  reporting_user_id: Scalars['bigint']['output'];
  retailer_card_language_id?: Maybe<Scalars['bigint']['output']>;
  roleid: Scalars['bigint']['output'];
  session_id?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  state_code?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  territory?: Maybe<Scalars['String']['output']>;
  territory_code?: Maybe<Scalars['String']['output']>;
  updated_by: Scalars['bigint']['output'];
  updated_date: Scalars['timestamptz']['output'];
  updated_time?: Maybe<Scalars['timestamptz']['output']>;
  upl_region?: Maybe<Scalars['String']['output']>;
  upl_region_code?: Maybe<Scalars['String']['output']>;
  user_type?: Maybe<Scalars['String']['output']>;
  verified_phone_number?: Maybe<Scalars['String']['output']>;
  zone?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "runpando_pro.users" */
export type Pf_Users_Aggregate = {
  __typename?: 'pf_users_aggregate';
  aggregate?: Maybe<Pf_Users_Aggregate_Fields>;
  nodes: Array<Pf_Users>;
};

/** aggregate fields of "runpando_pro.users" */
export type Pf_Users_Aggregate_Fields = {
  __typename?: 'pf_users_aggregate_fields';
  avg?: Maybe<Pf_Users_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pf_Users_Max_Fields>;
  min?: Maybe<Pf_Users_Min_Fields>;
  stddev?: Maybe<Pf_Users_Stddev_Fields>;
  stddev_pop?: Maybe<Pf_Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pf_Users_Stddev_Samp_Fields>;
  sum?: Maybe<Pf_Users_Sum_Fields>;
  var_pop?: Maybe<Pf_Users_Var_Pop_Fields>;
  var_samp?: Maybe<Pf_Users_Var_Samp_Fields>;
  variance?: Maybe<Pf_Users_Variance_Fields>;
};


/** aggregate fields of "runpando_pro.users" */
export type Pf_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pf_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Pf_Users_Avg_Fields = {
  __typename?: 'pf_users_avg_fields';
  age?: Maybe<Scalars['Float']['output']>;
  app_language_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  designation_id?: Maybe<Scalars['Float']['output']>;
  geography_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  input_company_id?: Maybe<Scalars['Float']['output']>;
  is_blocked?: Maybe<Scalars['Float']['output']>;
  is_deleted?: Maybe<Scalars['Float']['output']>;
  is_login?: Maybe<Scalars['Float']['output']>;
  is_login_api?: Maybe<Scalars['Float']['output']>;
  is_notification_on?: Maybe<Scalars['Float']['output']>;
  kg_user_id?: Maybe<Scalars['Float']['output']>;
  marker_id?: Maybe<Scalars['Float']['output']>;
  reporting_user_id?: Maybe<Scalars['Float']['output']>;
  retailer_card_language_id?: Maybe<Scalars['Float']['output']>;
  roleid?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "runpando_pro.users". All fields are combined with a logical 'AND'. */
export type Pf_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Pf_Users_Bool_Exp>>;
  _not?: InputMaybe<Pf_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Pf_Users_Bool_Exp>>;
  access_token?: InputMaybe<String_Comparison_Exp>;
  age?: InputMaybe<Bigint_Comparison_Exp>;
  app_language_id?: InputMaybe<Bigint_Comparison_Exp>;
  area_of_operatoin?: InputMaybe<String_Comparison_Exp>;
  auth_key?: InputMaybe<String_Comparison_Exp>;
  business_group?: InputMaybe<String_Comparison_Exp>;
  business_group_code?: InputMaybe<String_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_by?: InputMaybe<Bigint_Comparison_Exp>;
  created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  designation?: InputMaybe<String_Comparison_Exp>;
  designation_id?: InputMaybe<Bigint_Comparison_Exp>;
  device_identifier?: InputMaybe<String_Comparison_Exp>;
  district?: InputMaybe<String_Comparison_Exp>;
  district_code?: InputMaybe<String_Comparison_Exp>;
  email_address?: InputMaybe<String_Comparison_Exp>;
  employee_number?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  geography_id?: InputMaybe<Bigint_Comparison_Exp>;
  guid?: InputMaybe<String_Comparison_Exp>;
  hashkey?: InputMaybe<String_Comparison_Exp>;
  head_quarters?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  input_company_id?: InputMaybe<Bigint_Comparison_Exp>;
  ip_address?: InputMaybe<String_Comparison_Exp>;
  is_blocked?: InputMaybe<Bigint_Comparison_Exp>;
  is_deleted?: InputMaybe<Bigint_Comparison_Exp>;
  is_login?: InputMaybe<Smallint_Comparison_Exp>;
  is_login_api?: InputMaybe<Smallint_Comparison_Exp>;
  is_notification_on?: InputMaybe<Smallint_Comparison_Exp>;
  is_otp_verified?: InputMaybe<String_Comparison_Exp>;
  kg_user_id?: InputMaybe<Numeric_Comparison_Exp>;
  knowledge_tab?: InputMaybe<String_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  license_active?: InputMaybe<Boolean_Comparison_Exp>;
  location?: InputMaybe<String_Comparison_Exp>;
  manager_name?: InputMaybe<String_Comparison_Exp>;
  marker_id?: InputMaybe<Bigint_Comparison_Exp>;
  market_error?: InputMaybe<String_Comparison_Exp>;
  mobile_validation?: InputMaybe<String_Comparison_Exp>;
  otp?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<String_Comparison_Exp>;
  photo_path?: InputMaybe<String_Comparison_Exp>;
  pin?: InputMaybe<String_Comparison_Exp>;
  reporting_structure?: InputMaybe<String_Comparison_Exp>;
  reporting_user_id?: InputMaybe<Bigint_Comparison_Exp>;
  retailer_card_language_id?: InputMaybe<Bigint_Comparison_Exp>;
  roleid?: InputMaybe<Bigint_Comparison_Exp>;
  session_id?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  state_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  territory?: InputMaybe<String_Comparison_Exp>;
  territory_code?: InputMaybe<String_Comparison_Exp>;
  updated_by?: InputMaybe<Bigint_Comparison_Exp>;
  updated_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  upl_region?: InputMaybe<String_Comparison_Exp>;
  upl_region_code?: InputMaybe<String_Comparison_Exp>;
  user_type?: InputMaybe<String_Comparison_Exp>;
  verified_phone_number?: InputMaybe<String_Comparison_Exp>;
  zone?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "runpando_pro.users" */
export enum Pf_Users_Constraint {
  /** unique or primary key constraint on columns "access_token" */
  Idx_632048AccessToken_2 = 'idx_632048_access_token_2',
  /** unique or primary key constraint on columns "id" */
  Idx_632048Primary = 'idx_632048_primary',
  /** unique or primary key constraint on columns "verified_phone_number" */
  Idx_632048VerifiedPhoneNumber = 'idx_632048_verified_phone_number'
}

/** input type for incrementing numeric columns in table "runpando_pro.users" */
export type Pf_Users_Inc_Input = {
  age?: InputMaybe<Scalars['bigint']['input']>;
  app_language_id?: InputMaybe<Scalars['bigint']['input']>;
  created_by?: InputMaybe<Scalars['bigint']['input']>;
  designation_id?: InputMaybe<Scalars['bigint']['input']>;
  geography_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  input_company_id?: InputMaybe<Scalars['bigint']['input']>;
  is_blocked?: InputMaybe<Scalars['bigint']['input']>;
  is_deleted?: InputMaybe<Scalars['bigint']['input']>;
  is_login?: InputMaybe<Scalars['smallint']['input']>;
  is_login_api?: InputMaybe<Scalars['smallint']['input']>;
  is_notification_on?: InputMaybe<Scalars['smallint']['input']>;
  kg_user_id?: InputMaybe<Scalars['numeric']['input']>;
  marker_id?: InputMaybe<Scalars['bigint']['input']>;
  reporting_user_id?: InputMaybe<Scalars['bigint']['input']>;
  retailer_card_language_id?: InputMaybe<Scalars['bigint']['input']>;
  roleid?: InputMaybe<Scalars['bigint']['input']>;
  updated_by?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "runpando_pro.users" */
export type Pf_Users_Insert_Input = {
  access_token?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['bigint']['input']>;
  app_language_id?: InputMaybe<Scalars['bigint']['input']>;
  area_of_operatoin?: InputMaybe<Scalars['String']['input']>;
  auth_key?: InputMaybe<Scalars['String']['input']>;
  business_group?: InputMaybe<Scalars['String']['input']>;
  business_group_code?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['bigint']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  designation_id?: InputMaybe<Scalars['bigint']['input']>;
  device_identifier?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  district_code?: InputMaybe<Scalars['String']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  employee_number?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  geography_id?: InputMaybe<Scalars['bigint']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  hashkey?: InputMaybe<Scalars['String']['input']>;
  head_quarters?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  input_company_id?: InputMaybe<Scalars['bigint']['input']>;
  ip_address?: InputMaybe<Scalars['String']['input']>;
  is_blocked?: InputMaybe<Scalars['bigint']['input']>;
  is_deleted?: InputMaybe<Scalars['bigint']['input']>;
  is_login?: InputMaybe<Scalars['smallint']['input']>;
  is_login_api?: InputMaybe<Scalars['smallint']['input']>;
  is_notification_on?: InputMaybe<Scalars['smallint']['input']>;
  is_otp_verified?: InputMaybe<Scalars['String']['input']>;
  kg_user_id?: InputMaybe<Scalars['numeric']['input']>;
  knowledge_tab?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  license_active?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  manager_name?: InputMaybe<Scalars['String']['input']>;
  marker_id?: InputMaybe<Scalars['bigint']['input']>;
  market_error?: InputMaybe<Scalars['String']['input']>;
  mobile_validation?: InputMaybe<Scalars['String']['input']>;
  otp?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  photo_path?: InputMaybe<Scalars['String']['input']>;
  pin?: InputMaybe<Scalars['String']['input']>;
  reporting_structure?: InputMaybe<Scalars['String']['input']>;
  reporting_user_id?: InputMaybe<Scalars['bigint']['input']>;
  retailer_card_language_id?: InputMaybe<Scalars['bigint']['input']>;
  roleid?: InputMaybe<Scalars['bigint']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_code?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  territory?: InputMaybe<Scalars['String']['input']>;
  territory_code?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['bigint']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_time?: InputMaybe<Scalars['timestamptz']['input']>;
  upl_region?: InputMaybe<Scalars['String']['input']>;
  upl_region_code?: InputMaybe<Scalars['String']['input']>;
  user_type?: InputMaybe<Scalars['String']['input']>;
  verified_phone_number?: InputMaybe<Scalars['String']['input']>;
  zone?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Pf_Users_Max_Fields = {
  __typename?: 'pf_users_max_fields';
  access_token?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['bigint']['output']>;
  app_language_id?: Maybe<Scalars['bigint']['output']>;
  area_of_operatoin?: Maybe<Scalars['String']['output']>;
  auth_key?: Maybe<Scalars['String']['output']>;
  business_group?: Maybe<Scalars['String']['output']>;
  business_group_code?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['bigint']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  designation?: Maybe<Scalars['String']['output']>;
  designation_id?: Maybe<Scalars['bigint']['output']>;
  device_identifier?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  district_code?: Maybe<Scalars['String']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  employee_number?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  geography_id?: Maybe<Scalars['bigint']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  hashkey?: Maybe<Scalars['String']['output']>;
  head_quarters?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  input_company_id?: Maybe<Scalars['bigint']['output']>;
  ip_address?: Maybe<Scalars['String']['output']>;
  is_blocked?: Maybe<Scalars['bigint']['output']>;
  is_deleted?: Maybe<Scalars['bigint']['output']>;
  is_login?: Maybe<Scalars['smallint']['output']>;
  is_login_api?: Maybe<Scalars['smallint']['output']>;
  is_notification_on?: Maybe<Scalars['smallint']['output']>;
  is_otp_verified?: Maybe<Scalars['String']['output']>;
  kg_user_id?: Maybe<Scalars['numeric']['output']>;
  knowledge_tab?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  manager_name?: Maybe<Scalars['String']['output']>;
  marker_id?: Maybe<Scalars['bigint']['output']>;
  market_error?: Maybe<Scalars['String']['output']>;
  mobile_validation?: Maybe<Scalars['String']['output']>;
  otp?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  photo_path?: Maybe<Scalars['String']['output']>;
  pin?: Maybe<Scalars['String']['output']>;
  reporting_structure?: Maybe<Scalars['String']['output']>;
  reporting_user_id?: Maybe<Scalars['bigint']['output']>;
  retailer_card_language_id?: Maybe<Scalars['bigint']['output']>;
  roleid?: Maybe<Scalars['bigint']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  state_code?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  territory?: Maybe<Scalars['String']['output']>;
  territory_code?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['bigint']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
  updated_time?: Maybe<Scalars['timestamptz']['output']>;
  upl_region?: Maybe<Scalars['String']['output']>;
  upl_region_code?: Maybe<Scalars['String']['output']>;
  user_type?: Maybe<Scalars['String']['output']>;
  verified_phone_number?: Maybe<Scalars['String']['output']>;
  zone?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Pf_Users_Min_Fields = {
  __typename?: 'pf_users_min_fields';
  access_token?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['bigint']['output']>;
  app_language_id?: Maybe<Scalars['bigint']['output']>;
  area_of_operatoin?: Maybe<Scalars['String']['output']>;
  auth_key?: Maybe<Scalars['String']['output']>;
  business_group?: Maybe<Scalars['String']['output']>;
  business_group_code?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['bigint']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  designation?: Maybe<Scalars['String']['output']>;
  designation_id?: Maybe<Scalars['bigint']['output']>;
  device_identifier?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  district_code?: Maybe<Scalars['String']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  employee_number?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  geography_id?: Maybe<Scalars['bigint']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  hashkey?: Maybe<Scalars['String']['output']>;
  head_quarters?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  input_company_id?: Maybe<Scalars['bigint']['output']>;
  ip_address?: Maybe<Scalars['String']['output']>;
  is_blocked?: Maybe<Scalars['bigint']['output']>;
  is_deleted?: Maybe<Scalars['bigint']['output']>;
  is_login?: Maybe<Scalars['smallint']['output']>;
  is_login_api?: Maybe<Scalars['smallint']['output']>;
  is_notification_on?: Maybe<Scalars['smallint']['output']>;
  is_otp_verified?: Maybe<Scalars['String']['output']>;
  kg_user_id?: Maybe<Scalars['numeric']['output']>;
  knowledge_tab?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  manager_name?: Maybe<Scalars['String']['output']>;
  marker_id?: Maybe<Scalars['bigint']['output']>;
  market_error?: Maybe<Scalars['String']['output']>;
  mobile_validation?: Maybe<Scalars['String']['output']>;
  otp?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  photo_path?: Maybe<Scalars['String']['output']>;
  pin?: Maybe<Scalars['String']['output']>;
  reporting_structure?: Maybe<Scalars['String']['output']>;
  reporting_user_id?: Maybe<Scalars['bigint']['output']>;
  retailer_card_language_id?: Maybe<Scalars['bigint']['output']>;
  roleid?: Maybe<Scalars['bigint']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  state_code?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  territory?: Maybe<Scalars['String']['output']>;
  territory_code?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['bigint']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
  updated_time?: Maybe<Scalars['timestamptz']['output']>;
  upl_region?: Maybe<Scalars['String']['output']>;
  upl_region_code?: Maybe<Scalars['String']['output']>;
  user_type?: Maybe<Scalars['String']['output']>;
  verified_phone_number?: Maybe<Scalars['String']['output']>;
  zone?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "runpando_pro.users" */
export type Pf_Users_Mutation_Response = {
  __typename?: 'pf_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Pf_Users>;
};

/** input type for inserting object relation for remote table "runpando_pro.users" */
export type Pf_Users_Obj_Rel_Insert_Input = {
  data: Pf_Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Pf_Users_On_Conflict>;
};

/** on_conflict condition type for table "runpando_pro.users" */
export type Pf_Users_On_Conflict = {
  constraint: Pf_Users_Constraint;
  update_columns?: Array<Pf_Users_Update_Column>;
  where?: InputMaybe<Pf_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "runpando_pro.users". */
export type Pf_Users_Order_By = {
  access_token?: InputMaybe<Order_By>;
  age?: InputMaybe<Order_By>;
  app_language_id?: InputMaybe<Order_By>;
  area_of_operatoin?: InputMaybe<Order_By>;
  auth_key?: InputMaybe<Order_By>;
  business_group?: InputMaybe<Order_By>;
  business_group_code?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  designation?: InputMaybe<Order_By>;
  designation_id?: InputMaybe<Order_By>;
  device_identifier?: InputMaybe<Order_By>;
  district?: InputMaybe<Order_By>;
  district_code?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  employee_number?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  geography_id?: InputMaybe<Order_By>;
  guid?: InputMaybe<Order_By>;
  hashkey?: InputMaybe<Order_By>;
  head_quarters?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  input_company_id?: InputMaybe<Order_By>;
  ip_address?: InputMaybe<Order_By>;
  is_blocked?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  is_login?: InputMaybe<Order_By>;
  is_login_api?: InputMaybe<Order_By>;
  is_notification_on?: InputMaybe<Order_By>;
  is_otp_verified?: InputMaybe<Order_By>;
  kg_user_id?: InputMaybe<Order_By>;
  knowledge_tab?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  license_active?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  manager_name?: InputMaybe<Order_By>;
  marker_id?: InputMaybe<Order_By>;
  market_error?: InputMaybe<Order_By>;
  mobile_validation?: InputMaybe<Order_By>;
  otp?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  photo?: InputMaybe<Order_By>;
  photo_path?: InputMaybe<Order_By>;
  pin?: InputMaybe<Order_By>;
  reporting_structure?: InputMaybe<Order_By>;
  reporting_user_id?: InputMaybe<Order_By>;
  retailer_card_language_id?: InputMaybe<Order_By>;
  roleid?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  state_code?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  territory?: InputMaybe<Order_By>;
  territory_code?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
  updated_time?: InputMaybe<Order_By>;
  upl_region?: InputMaybe<Order_By>;
  upl_region_code?: InputMaybe<Order_By>;
  user_type?: InputMaybe<Order_By>;
  verified_phone_number?: InputMaybe<Order_By>;
  zone?: InputMaybe<Order_By>;
};

/** primary key columns input for table: runpando_pro.users */
export type Pf_Users_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "runpando_pro.users" */
export enum Pf_Users_Select_Column {
  /** column name */
  AccessToken = 'access_token',
  /** column name */
  Age = 'age',
  /** column name */
  AppLanguageId = 'app_language_id',
  /** column name */
  AreaOfOperatoin = 'area_of_operatoin',
  /** column name */
  AuthKey = 'auth_key',
  /** column name */
  BusinessGroup = 'business_group',
  /** column name */
  BusinessGroupCode = 'business_group_code',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CreatedDate = 'created_date',
  /** column name */
  Designation = 'designation',
  /** column name */
  DesignationId = 'designation_id',
  /** column name */
  DeviceIdentifier = 'device_identifier',
  /** column name */
  District = 'district',
  /** column name */
  DistrictCode = 'district_code',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  EmployeeNumber = 'employee_number',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  GeographyId = 'geography_id',
  /** column name */
  Guid = 'guid',
  /** column name */
  Hashkey = 'hashkey',
  /** column name */
  HeadQuarters = 'head_quarters',
  /** column name */
  Id = 'id',
  /** column name */
  InputCompanyId = 'input_company_id',
  /** column name */
  IpAddress = 'ip_address',
  /** column name */
  IsBlocked = 'is_blocked',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsLogin = 'is_login',
  /** column name */
  IsLoginApi = 'is_login_api',
  /** column name */
  IsNotificationOn = 'is_notification_on',
  /** column name */
  IsOtpVerified = 'is_otp_verified',
  /** column name */
  KgUserId = 'kg_user_id',
  /** column name */
  KnowledgeTab = 'knowledge_tab',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LicenseActive = 'license_active',
  /** column name */
  Location = 'location',
  /** column name */
  ManagerName = 'manager_name',
  /** column name */
  MarkerId = 'marker_id',
  /** column name */
  MarketError = 'market_error',
  /** column name */
  MobileValidation = 'mobile_validation',
  /** column name */
  Otp = 'otp',
  /** column name */
  Password = 'password',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  Photo = 'photo',
  /** column name */
  PhotoPath = 'photo_path',
  /** column name */
  Pin = 'pin',
  /** column name */
  ReportingStructure = 'reporting_structure',
  /** column name */
  ReportingUserId = 'reporting_user_id',
  /** column name */
  RetailerCardLanguageId = 'retailer_card_language_id',
  /** column name */
  Roleid = 'roleid',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  State = 'state',
  /** column name */
  StateCode = 'state_code',
  /** column name */
  Status = 'status',
  /** column name */
  Territory = 'territory',
  /** column name */
  TerritoryCode = 'territory_code',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  UpdatedDate = 'updated_date',
  /** column name */
  UpdatedTime = 'updated_time',
  /** column name */
  UplRegion = 'upl_region',
  /** column name */
  UplRegionCode = 'upl_region_code',
  /** column name */
  UserType = 'user_type',
  /** column name */
  VerifiedPhoneNumber = 'verified_phone_number',
  /** column name */
  Zone = 'zone'
}

/** input type for updating data in table "runpando_pro.users" */
export type Pf_Users_Set_Input = {
  access_token?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['bigint']['input']>;
  app_language_id?: InputMaybe<Scalars['bigint']['input']>;
  area_of_operatoin?: InputMaybe<Scalars['String']['input']>;
  auth_key?: InputMaybe<Scalars['String']['input']>;
  business_group?: InputMaybe<Scalars['String']['input']>;
  business_group_code?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['bigint']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  designation_id?: InputMaybe<Scalars['bigint']['input']>;
  device_identifier?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  district_code?: InputMaybe<Scalars['String']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  employee_number?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  geography_id?: InputMaybe<Scalars['bigint']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  hashkey?: InputMaybe<Scalars['String']['input']>;
  head_quarters?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  input_company_id?: InputMaybe<Scalars['bigint']['input']>;
  ip_address?: InputMaybe<Scalars['String']['input']>;
  is_blocked?: InputMaybe<Scalars['bigint']['input']>;
  is_deleted?: InputMaybe<Scalars['bigint']['input']>;
  is_login?: InputMaybe<Scalars['smallint']['input']>;
  is_login_api?: InputMaybe<Scalars['smallint']['input']>;
  is_notification_on?: InputMaybe<Scalars['smallint']['input']>;
  is_otp_verified?: InputMaybe<Scalars['String']['input']>;
  kg_user_id?: InputMaybe<Scalars['numeric']['input']>;
  knowledge_tab?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  license_active?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  manager_name?: InputMaybe<Scalars['String']['input']>;
  marker_id?: InputMaybe<Scalars['bigint']['input']>;
  market_error?: InputMaybe<Scalars['String']['input']>;
  mobile_validation?: InputMaybe<Scalars['String']['input']>;
  otp?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  photo_path?: InputMaybe<Scalars['String']['input']>;
  pin?: InputMaybe<Scalars['String']['input']>;
  reporting_structure?: InputMaybe<Scalars['String']['input']>;
  reporting_user_id?: InputMaybe<Scalars['bigint']['input']>;
  retailer_card_language_id?: InputMaybe<Scalars['bigint']['input']>;
  roleid?: InputMaybe<Scalars['bigint']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_code?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  territory?: InputMaybe<Scalars['String']['input']>;
  territory_code?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['bigint']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_time?: InputMaybe<Scalars['timestamptz']['input']>;
  upl_region?: InputMaybe<Scalars['String']['input']>;
  upl_region_code?: InputMaybe<Scalars['String']['input']>;
  user_type?: InputMaybe<Scalars['String']['input']>;
  verified_phone_number?: InputMaybe<Scalars['String']['input']>;
  zone?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Pf_Users_Stddev_Fields = {
  __typename?: 'pf_users_stddev_fields';
  age?: Maybe<Scalars['Float']['output']>;
  app_language_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  designation_id?: Maybe<Scalars['Float']['output']>;
  geography_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  input_company_id?: Maybe<Scalars['Float']['output']>;
  is_blocked?: Maybe<Scalars['Float']['output']>;
  is_deleted?: Maybe<Scalars['Float']['output']>;
  is_login?: Maybe<Scalars['Float']['output']>;
  is_login_api?: Maybe<Scalars['Float']['output']>;
  is_notification_on?: Maybe<Scalars['Float']['output']>;
  kg_user_id?: Maybe<Scalars['Float']['output']>;
  marker_id?: Maybe<Scalars['Float']['output']>;
  reporting_user_id?: Maybe<Scalars['Float']['output']>;
  retailer_card_language_id?: Maybe<Scalars['Float']['output']>;
  roleid?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Pf_Users_Stddev_Pop_Fields = {
  __typename?: 'pf_users_stddev_pop_fields';
  age?: Maybe<Scalars['Float']['output']>;
  app_language_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  designation_id?: Maybe<Scalars['Float']['output']>;
  geography_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  input_company_id?: Maybe<Scalars['Float']['output']>;
  is_blocked?: Maybe<Scalars['Float']['output']>;
  is_deleted?: Maybe<Scalars['Float']['output']>;
  is_login?: Maybe<Scalars['Float']['output']>;
  is_login_api?: Maybe<Scalars['Float']['output']>;
  is_notification_on?: Maybe<Scalars['Float']['output']>;
  kg_user_id?: Maybe<Scalars['Float']['output']>;
  marker_id?: Maybe<Scalars['Float']['output']>;
  reporting_user_id?: Maybe<Scalars['Float']['output']>;
  retailer_card_language_id?: Maybe<Scalars['Float']['output']>;
  roleid?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Pf_Users_Stddev_Samp_Fields = {
  __typename?: 'pf_users_stddev_samp_fields';
  age?: Maybe<Scalars['Float']['output']>;
  app_language_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  designation_id?: Maybe<Scalars['Float']['output']>;
  geography_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  input_company_id?: Maybe<Scalars['Float']['output']>;
  is_blocked?: Maybe<Scalars['Float']['output']>;
  is_deleted?: Maybe<Scalars['Float']['output']>;
  is_login?: Maybe<Scalars['Float']['output']>;
  is_login_api?: Maybe<Scalars['Float']['output']>;
  is_notification_on?: Maybe<Scalars['Float']['output']>;
  kg_user_id?: Maybe<Scalars['Float']['output']>;
  marker_id?: Maybe<Scalars['Float']['output']>;
  reporting_user_id?: Maybe<Scalars['Float']['output']>;
  retailer_card_language_id?: Maybe<Scalars['Float']['output']>;
  roleid?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "users" */
export type Pf_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pf_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Pf_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pf_Users_Stream_Cursor_Value_Input = {
  access_token?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['bigint']['input']>;
  app_language_id?: InputMaybe<Scalars['bigint']['input']>;
  area_of_operatoin?: InputMaybe<Scalars['String']['input']>;
  auth_key?: InputMaybe<Scalars['String']['input']>;
  business_group?: InputMaybe<Scalars['String']['input']>;
  business_group_code?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['bigint']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  designation_id?: InputMaybe<Scalars['bigint']['input']>;
  device_identifier?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  district_code?: InputMaybe<Scalars['String']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  employee_number?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  geography_id?: InputMaybe<Scalars['bigint']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  hashkey?: InputMaybe<Scalars['String']['input']>;
  head_quarters?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  input_company_id?: InputMaybe<Scalars['bigint']['input']>;
  ip_address?: InputMaybe<Scalars['String']['input']>;
  is_blocked?: InputMaybe<Scalars['bigint']['input']>;
  is_deleted?: InputMaybe<Scalars['bigint']['input']>;
  is_login?: InputMaybe<Scalars['smallint']['input']>;
  is_login_api?: InputMaybe<Scalars['smallint']['input']>;
  is_notification_on?: InputMaybe<Scalars['smallint']['input']>;
  is_otp_verified?: InputMaybe<Scalars['String']['input']>;
  kg_user_id?: InputMaybe<Scalars['numeric']['input']>;
  knowledge_tab?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  license_active?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  manager_name?: InputMaybe<Scalars['String']['input']>;
  marker_id?: InputMaybe<Scalars['bigint']['input']>;
  market_error?: InputMaybe<Scalars['String']['input']>;
  mobile_validation?: InputMaybe<Scalars['String']['input']>;
  otp?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  photo_path?: InputMaybe<Scalars['String']['input']>;
  pin?: InputMaybe<Scalars['String']['input']>;
  reporting_structure?: InputMaybe<Scalars['String']['input']>;
  reporting_user_id?: InputMaybe<Scalars['bigint']['input']>;
  retailer_card_language_id?: InputMaybe<Scalars['bigint']['input']>;
  roleid?: InputMaybe<Scalars['bigint']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_code?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  territory?: InputMaybe<Scalars['String']['input']>;
  territory_code?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['bigint']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_time?: InputMaybe<Scalars['timestamptz']['input']>;
  upl_region?: InputMaybe<Scalars['String']['input']>;
  upl_region_code?: InputMaybe<Scalars['String']['input']>;
  user_type?: InputMaybe<Scalars['String']['input']>;
  verified_phone_number?: InputMaybe<Scalars['String']['input']>;
  zone?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Pf_Users_Sum_Fields = {
  __typename?: 'pf_users_sum_fields';
  age?: Maybe<Scalars['bigint']['output']>;
  app_language_id?: Maybe<Scalars['bigint']['output']>;
  created_by?: Maybe<Scalars['bigint']['output']>;
  designation_id?: Maybe<Scalars['bigint']['output']>;
  geography_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  input_company_id?: Maybe<Scalars['bigint']['output']>;
  is_blocked?: Maybe<Scalars['bigint']['output']>;
  is_deleted?: Maybe<Scalars['bigint']['output']>;
  is_login?: Maybe<Scalars['smallint']['output']>;
  is_login_api?: Maybe<Scalars['smallint']['output']>;
  is_notification_on?: Maybe<Scalars['smallint']['output']>;
  kg_user_id?: Maybe<Scalars['numeric']['output']>;
  marker_id?: Maybe<Scalars['bigint']['output']>;
  reporting_user_id?: Maybe<Scalars['bigint']['output']>;
  retailer_card_language_id?: Maybe<Scalars['bigint']['output']>;
  roleid?: Maybe<Scalars['bigint']['output']>;
  updated_by?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "runpando_pro.users" */
export enum Pf_Users_Update_Column {
  /** column name */
  AccessToken = 'access_token',
  /** column name */
  Age = 'age',
  /** column name */
  AppLanguageId = 'app_language_id',
  /** column name */
  AreaOfOperatoin = 'area_of_operatoin',
  /** column name */
  AuthKey = 'auth_key',
  /** column name */
  BusinessGroup = 'business_group',
  /** column name */
  BusinessGroupCode = 'business_group_code',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CreatedDate = 'created_date',
  /** column name */
  Designation = 'designation',
  /** column name */
  DesignationId = 'designation_id',
  /** column name */
  DeviceIdentifier = 'device_identifier',
  /** column name */
  District = 'district',
  /** column name */
  DistrictCode = 'district_code',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  EmployeeNumber = 'employee_number',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  GeographyId = 'geography_id',
  /** column name */
  Guid = 'guid',
  /** column name */
  Hashkey = 'hashkey',
  /** column name */
  HeadQuarters = 'head_quarters',
  /** column name */
  Id = 'id',
  /** column name */
  InputCompanyId = 'input_company_id',
  /** column name */
  IpAddress = 'ip_address',
  /** column name */
  IsBlocked = 'is_blocked',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsLogin = 'is_login',
  /** column name */
  IsLoginApi = 'is_login_api',
  /** column name */
  IsNotificationOn = 'is_notification_on',
  /** column name */
  IsOtpVerified = 'is_otp_verified',
  /** column name */
  KgUserId = 'kg_user_id',
  /** column name */
  KnowledgeTab = 'knowledge_tab',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LicenseActive = 'license_active',
  /** column name */
  Location = 'location',
  /** column name */
  ManagerName = 'manager_name',
  /** column name */
  MarkerId = 'marker_id',
  /** column name */
  MarketError = 'market_error',
  /** column name */
  MobileValidation = 'mobile_validation',
  /** column name */
  Otp = 'otp',
  /** column name */
  Password = 'password',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  Photo = 'photo',
  /** column name */
  PhotoPath = 'photo_path',
  /** column name */
  Pin = 'pin',
  /** column name */
  ReportingStructure = 'reporting_structure',
  /** column name */
  ReportingUserId = 'reporting_user_id',
  /** column name */
  RetailerCardLanguageId = 'retailer_card_language_id',
  /** column name */
  Roleid = 'roleid',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  State = 'state',
  /** column name */
  StateCode = 'state_code',
  /** column name */
  Status = 'status',
  /** column name */
  Territory = 'territory',
  /** column name */
  TerritoryCode = 'territory_code',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  UpdatedDate = 'updated_date',
  /** column name */
  UpdatedTime = 'updated_time',
  /** column name */
  UplRegion = 'upl_region',
  /** column name */
  UplRegionCode = 'upl_region_code',
  /** column name */
  UserType = 'user_type',
  /** column name */
  VerifiedPhoneNumber = 'verified_phone_number',
  /** column name */
  Zone = 'zone'
}

export type Pf_Users_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pf_Users_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pf_Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pf_Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pf_Users_Var_Pop_Fields = {
  __typename?: 'pf_users_var_pop_fields';
  age?: Maybe<Scalars['Float']['output']>;
  app_language_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  designation_id?: Maybe<Scalars['Float']['output']>;
  geography_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  input_company_id?: Maybe<Scalars['Float']['output']>;
  is_blocked?: Maybe<Scalars['Float']['output']>;
  is_deleted?: Maybe<Scalars['Float']['output']>;
  is_login?: Maybe<Scalars['Float']['output']>;
  is_login_api?: Maybe<Scalars['Float']['output']>;
  is_notification_on?: Maybe<Scalars['Float']['output']>;
  kg_user_id?: Maybe<Scalars['Float']['output']>;
  marker_id?: Maybe<Scalars['Float']['output']>;
  reporting_user_id?: Maybe<Scalars['Float']['output']>;
  retailer_card_language_id?: Maybe<Scalars['Float']['output']>;
  roleid?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Pf_Users_Var_Samp_Fields = {
  __typename?: 'pf_users_var_samp_fields';
  age?: Maybe<Scalars['Float']['output']>;
  app_language_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  designation_id?: Maybe<Scalars['Float']['output']>;
  geography_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  input_company_id?: Maybe<Scalars['Float']['output']>;
  is_blocked?: Maybe<Scalars['Float']['output']>;
  is_deleted?: Maybe<Scalars['Float']['output']>;
  is_login?: Maybe<Scalars['Float']['output']>;
  is_login_api?: Maybe<Scalars['Float']['output']>;
  is_notification_on?: Maybe<Scalars['Float']['output']>;
  kg_user_id?: Maybe<Scalars['Float']['output']>;
  marker_id?: Maybe<Scalars['Float']['output']>;
  reporting_user_id?: Maybe<Scalars['Float']['output']>;
  retailer_card_language_id?: Maybe<Scalars['Float']['output']>;
  roleid?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Pf_Users_Variance_Fields = {
  __typename?: 'pf_users_variance_fields';
  age?: Maybe<Scalars['Float']['output']>;
  app_language_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  designation_id?: Maybe<Scalars['Float']['output']>;
  geography_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  input_company_id?: Maybe<Scalars['Float']['output']>;
  is_blocked?: Maybe<Scalars['Float']['output']>;
  is_deleted?: Maybe<Scalars['Float']['output']>;
  is_login?: Maybe<Scalars['Float']['output']>;
  is_login_api?: Maybe<Scalars['Float']['output']>;
  is_notification_on?: Maybe<Scalars['Float']['output']>;
  kg_user_id?: Maybe<Scalars['Float']['output']>;
  marker_id?: Maybe<Scalars['Float']['output']>;
  reporting_user_id?: Maybe<Scalars['Float']['output']>;
  retailer_card_language_id?: Maybe<Scalars['Float']['output']>;
  roleid?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "product_pop_media" */
export type Product_Pop_Media = {
  __typename?: 'product_pop_media';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  duration?: Maybe<Scalars['numeric']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  file_size?: Maybe<Scalars['Int']['output']>;
  id: Scalars['bpchar']['output'];
  media_id?: Maybe<Scalars['String']['output']>;
  media_title?: Maybe<Scalars['String']['output']>;
  media_type: Scalars['String']['output'];
  product_pop_id: Scalars['bpchar']['output'];
  sort_order?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  uploaded_url?: Maybe<Scalars['String']['output']>;
  youtube_url?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "product_pop_media" */
export type Product_Pop_Media_Aggregate = {
  __typename?: 'product_pop_media_aggregate';
  aggregate?: Maybe<Product_Pop_Media_Aggregate_Fields>;
  nodes: Array<Product_Pop_Media>;
};

/** aggregate fields of "product_pop_media" */
export type Product_Pop_Media_Aggregate_Fields = {
  __typename?: 'product_pop_media_aggregate_fields';
  avg?: Maybe<Product_Pop_Media_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Product_Pop_Media_Max_Fields>;
  min?: Maybe<Product_Pop_Media_Min_Fields>;
  stddev?: Maybe<Product_Pop_Media_Stddev_Fields>;
  stddev_pop?: Maybe<Product_Pop_Media_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Product_Pop_Media_Stddev_Samp_Fields>;
  sum?: Maybe<Product_Pop_Media_Sum_Fields>;
  var_pop?: Maybe<Product_Pop_Media_Var_Pop_Fields>;
  var_samp?: Maybe<Product_Pop_Media_Var_Samp_Fields>;
  variance?: Maybe<Product_Pop_Media_Variance_Fields>;
};


/** aggregate fields of "product_pop_media" */
export type Product_Pop_Media_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Pop_Media_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Product_Pop_Media_Avg_Fields = {
  __typename?: 'product_pop_media_avg_fields';
  duration?: Maybe<Scalars['Float']['output']>;
  file_size?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "product_pop_media". All fields are combined with a logical 'AND'. */
export type Product_Pop_Media_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Pop_Media_Bool_Exp>>;
  _not?: InputMaybe<Product_Pop_Media_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Pop_Media_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  duration?: InputMaybe<Numeric_Comparison_Exp>;
  file_name?: InputMaybe<String_Comparison_Exp>;
  file_size?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  media_id?: InputMaybe<String_Comparison_Exp>;
  media_title?: InputMaybe<String_Comparison_Exp>;
  media_type?: InputMaybe<String_Comparison_Exp>;
  product_pop_id?: InputMaybe<Bpchar_Comparison_Exp>;
  sort_order?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  uploaded_url?: InputMaybe<String_Comparison_Exp>;
  youtube_url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_pop_media" */
export enum Product_Pop_Media_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductPopMediaPkey = 'product_pop_media_pkey'
}

/** input type for incrementing numeric columns in table "product_pop_media" */
export type Product_Pop_Media_Inc_Input = {
  duration?: InputMaybe<Scalars['numeric']['input']>;
  file_size?: InputMaybe<Scalars['Int']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "product_pop_media" */
export type Product_Pop_Media_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  duration?: InputMaybe<Scalars['numeric']['input']>;
  file_name?: InputMaybe<Scalars['String']['input']>;
  file_size?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  media_id?: InputMaybe<Scalars['String']['input']>;
  media_title?: InputMaybe<Scalars['String']['input']>;
  media_type?: InputMaybe<Scalars['String']['input']>;
  product_pop_id?: InputMaybe<Scalars['bpchar']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  uploaded_url?: InputMaybe<Scalars['String']['input']>;
  youtube_url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Product_Pop_Media_Max_Fields = {
  __typename?: 'product_pop_media_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  duration?: Maybe<Scalars['numeric']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  file_size?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  media_id?: Maybe<Scalars['String']['output']>;
  media_title?: Maybe<Scalars['String']['output']>;
  media_type?: Maybe<Scalars['String']['output']>;
  product_pop_id?: Maybe<Scalars['bpchar']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  uploaded_url?: Maybe<Scalars['String']['output']>;
  youtube_url?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Product_Pop_Media_Min_Fields = {
  __typename?: 'product_pop_media_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  duration?: Maybe<Scalars['numeric']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  file_size?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  media_id?: Maybe<Scalars['String']['output']>;
  media_title?: Maybe<Scalars['String']['output']>;
  media_type?: Maybe<Scalars['String']['output']>;
  product_pop_id?: Maybe<Scalars['bpchar']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  uploaded_url?: Maybe<Scalars['String']['output']>;
  youtube_url?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "product_pop_media" */
export type Product_Pop_Media_Mutation_Response = {
  __typename?: 'product_pop_media_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Pop_Media>;
};

/** on_conflict condition type for table "product_pop_media" */
export type Product_Pop_Media_On_Conflict = {
  constraint: Product_Pop_Media_Constraint;
  update_columns?: Array<Product_Pop_Media_Update_Column>;
  where?: InputMaybe<Product_Pop_Media_Bool_Exp>;
};

/** Ordering options when selecting data from "product_pop_media". */
export type Product_Pop_Media_Order_By = {
  created_at?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  file_size?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  media_title?: InputMaybe<Order_By>;
  media_type?: InputMaybe<Order_By>;
  product_pop_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uploaded_url?: InputMaybe<Order_By>;
  youtube_url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_pop_media */
export type Product_Pop_Media_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** select columns of table "product_pop_media" */
export enum Product_Pop_Media_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Duration = 'duration',
  /** column name */
  FileName = 'file_name',
  /** column name */
  FileSize = 'file_size',
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  MediaTitle = 'media_title',
  /** column name */
  MediaType = 'media_type',
  /** column name */
  ProductPopId = 'product_pop_id',
  /** column name */
  SortOrder = 'sort_order',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UploadedUrl = 'uploaded_url',
  /** column name */
  YoutubeUrl = 'youtube_url'
}

/** input type for updating data in table "product_pop_media" */
export type Product_Pop_Media_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  duration?: InputMaybe<Scalars['numeric']['input']>;
  file_name?: InputMaybe<Scalars['String']['input']>;
  file_size?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  media_id?: InputMaybe<Scalars['String']['input']>;
  media_title?: InputMaybe<Scalars['String']['input']>;
  media_type?: InputMaybe<Scalars['String']['input']>;
  product_pop_id?: InputMaybe<Scalars['bpchar']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  uploaded_url?: InputMaybe<Scalars['String']['input']>;
  youtube_url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Product_Pop_Media_Stddev_Fields = {
  __typename?: 'product_pop_media_stddev_fields';
  duration?: Maybe<Scalars['Float']['output']>;
  file_size?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Product_Pop_Media_Stddev_Pop_Fields = {
  __typename?: 'product_pop_media_stddev_pop_fields';
  duration?: Maybe<Scalars['Float']['output']>;
  file_size?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Product_Pop_Media_Stddev_Samp_Fields = {
  __typename?: 'product_pop_media_stddev_samp_fields';
  duration?: Maybe<Scalars['Float']['output']>;
  file_size?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "product_pop_media" */
export type Product_Pop_Media_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Pop_Media_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Pop_Media_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  duration?: InputMaybe<Scalars['numeric']['input']>;
  file_name?: InputMaybe<Scalars['String']['input']>;
  file_size?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  media_id?: InputMaybe<Scalars['String']['input']>;
  media_title?: InputMaybe<Scalars['String']['input']>;
  media_type?: InputMaybe<Scalars['String']['input']>;
  product_pop_id?: InputMaybe<Scalars['bpchar']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  uploaded_url?: InputMaybe<Scalars['String']['input']>;
  youtube_url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Product_Pop_Media_Sum_Fields = {
  __typename?: 'product_pop_media_sum_fields';
  duration?: Maybe<Scalars['numeric']['output']>;
  file_size?: Maybe<Scalars['Int']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "product_pop_media" */
export enum Product_Pop_Media_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Duration = 'duration',
  /** column name */
  FileName = 'file_name',
  /** column name */
  FileSize = 'file_size',
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  MediaTitle = 'media_title',
  /** column name */
  MediaType = 'media_type',
  /** column name */
  ProductPopId = 'product_pop_id',
  /** column name */
  SortOrder = 'sort_order',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UploadedUrl = 'uploaded_url',
  /** column name */
  YoutubeUrl = 'youtube_url'
}

export type Product_Pop_Media_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Pop_Media_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Pop_Media_Set_Input>;
  /** filter the rows which have to be updated */
  where: Product_Pop_Media_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_Pop_Media_Var_Pop_Fields = {
  __typename?: 'product_pop_media_var_pop_fields';
  duration?: Maybe<Scalars['Float']['output']>;
  file_size?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Product_Pop_Media_Var_Samp_Fields = {
  __typename?: 'product_pop_media_var_samp_fields';
  duration?: Maybe<Scalars['Float']['output']>;
  file_size?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Product_Pop_Media_Variance_Fields = {
  __typename?: 'product_pop_media_variance_fields';
  duration?: Maybe<Scalars['Float']['output']>;
  file_size?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "product_pops" */
export type Product_Pops = {
  __typename?: 'product_pops';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['bpchar']['output']>;
  crop_id?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['bpchar']['output'];
  image_url?: Maybe<Scalars['json']['output']>;
  item_code?: Maybe<Scalars['String']['output']>;
  pop_content?: Maybe<Scalars['String']['output']>;
  pop_url?: Maybe<Scalars['String']['output']>;
  product_name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};


/** columns and relationships of "product_pops" */
export type Product_PopsImage_UrlArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "product_pops" */
export type Product_Pops_Aggregate = {
  __typename?: 'product_pops_aggregate';
  aggregate?: Maybe<Product_Pops_Aggregate_Fields>;
  nodes: Array<Product_Pops>;
};

/** aggregate fields of "product_pops" */
export type Product_Pops_Aggregate_Fields = {
  __typename?: 'product_pops_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Product_Pops_Max_Fields>;
  min?: Maybe<Product_Pops_Min_Fields>;
};


/** aggregate fields of "product_pops" */
export type Product_Pops_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Pops_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "product_pops". All fields are combined with a logical 'AND'. */
export type Product_Pops_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Pops_Bool_Exp>>;
  _not?: InputMaybe<Product_Pops_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Pops_Bool_Exp>>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  company_id?: InputMaybe<Bpchar_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<Bpchar_Comparison_Exp>;
  crop_id?: InputMaybe<String_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  image_url?: InputMaybe<Json_Comparison_Exp>;
  item_code?: InputMaybe<String_Comparison_Exp>;
  pop_content?: InputMaybe<String_Comparison_Exp>;
  pop_url?: InputMaybe<String_Comparison_Exp>;
  product_name?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_pops" */
export enum Product_Pops_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductPopsPkey = 'product_pops_pkey',
  /** unique or primary key constraint on columns "slug" */
  ProductPopsSlugUnique = 'product_pops_slug_unique'
}

/** input type for inserting data into table "product_pops" */
export type Product_Pops_Insert_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['bpchar']['input']>;
  crop_id?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  image_url?: InputMaybe<Scalars['json']['input']>;
  item_code?: InputMaybe<Scalars['String']['input']>;
  pop_content?: InputMaybe<Scalars['String']['input']>;
  pop_url?: InputMaybe<Scalars['String']['input']>;
  product_name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Product_Pops_Max_Fields = {
  __typename?: 'product_pops_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['bpchar']['output']>;
  crop_id?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  item_code?: Maybe<Scalars['String']['output']>;
  pop_content?: Maybe<Scalars['String']['output']>;
  pop_url?: Maybe<Scalars['String']['output']>;
  product_name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Product_Pops_Min_Fields = {
  __typename?: 'product_pops_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['bpchar']['output']>;
  crop_id?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  item_code?: Maybe<Scalars['String']['output']>;
  pop_content?: Maybe<Scalars['String']['output']>;
  pop_url?: Maybe<Scalars['String']['output']>;
  product_name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "product_pops" */
export type Product_Pops_Mutation_Response = {
  __typename?: 'product_pops_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Pops>;
};

/** on_conflict condition type for table "product_pops" */
export type Product_Pops_On_Conflict = {
  constraint: Product_Pops_Constraint;
  update_columns?: Array<Product_Pops_Update_Column>;
  where?: InputMaybe<Product_Pops_Bool_Exp>;
};

/** Ordering options when selecting data from "product_pops". */
export type Product_Pops_Order_By = {
  account_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  item_code?: InputMaybe<Order_By>;
  pop_content?: InputMaybe<Order_By>;
  pop_url?: InputMaybe<Order_By>;
  product_name?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_pops */
export type Product_Pops_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** select columns of table "product_pops" */
export enum Product_Pops_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  ItemCode = 'item_code',
  /** column name */
  PopContent = 'pop_content',
  /** column name */
  PopUrl = 'pop_url',
  /** column name */
  ProductName = 'product_name',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "product_pops" */
export type Product_Pops_Set_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['bpchar']['input']>;
  crop_id?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  image_url?: InputMaybe<Scalars['json']['input']>;
  item_code?: InputMaybe<Scalars['String']['input']>;
  pop_content?: InputMaybe<Scalars['String']['input']>;
  pop_url?: InputMaybe<Scalars['String']['input']>;
  product_name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "product_pops" */
export type Product_Pops_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Pops_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Pops_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['bpchar']['input']>;
  crop_id?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  image_url?: InputMaybe<Scalars['json']['input']>;
  item_code?: InputMaybe<Scalars['String']['input']>;
  pop_content?: InputMaybe<Scalars['String']['input']>;
  pop_url?: InputMaybe<Scalars['String']['input']>;
  product_name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "product_pops" */
export enum Product_Pops_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  ItemCode = 'item_code',
  /** column name */
  PopContent = 'pop_content',
  /** column name */
  PopUrl = 'pop_url',
  /** column name */
  ProductName = 'product_name',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Product_Pops_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Pops_Set_Input>;
  /** filter the rows which have to be updated */
  where: Product_Pops_Bool_Exp;
};

/** columns and relationships of "prospect_crops" */
export type Prospect_Crops = {
  __typename?: 'prospect_crops';
  account_id: Scalars['bpchar']['output'];
  company_id: Scalars['bpchar']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  crop: Master_Crops;
  crop_id: Scalars['bpchar']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['bigint']['output'];
  /** An object relationship */
  prospect?: Maybe<Prospects>;
  prospect_id?: Maybe<Scalars['bpchar']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "prospect_crops" */
export type Prospect_Crops_Aggregate = {
  __typename?: 'prospect_crops_aggregate';
  aggregate?: Maybe<Prospect_Crops_Aggregate_Fields>;
  nodes: Array<Prospect_Crops>;
};

/** aggregate fields of "prospect_crops" */
export type Prospect_Crops_Aggregate_Fields = {
  __typename?: 'prospect_crops_aggregate_fields';
  avg?: Maybe<Prospect_Crops_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Prospect_Crops_Max_Fields>;
  min?: Maybe<Prospect_Crops_Min_Fields>;
  stddev?: Maybe<Prospect_Crops_Stddev_Fields>;
  stddev_pop?: Maybe<Prospect_Crops_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Prospect_Crops_Stddev_Samp_Fields>;
  sum?: Maybe<Prospect_Crops_Sum_Fields>;
  var_pop?: Maybe<Prospect_Crops_Var_Pop_Fields>;
  var_samp?: Maybe<Prospect_Crops_Var_Samp_Fields>;
  variance?: Maybe<Prospect_Crops_Variance_Fields>;
};


/** aggregate fields of "prospect_crops" */
export type Prospect_Crops_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Prospect_Crops_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Prospect_Crops_Avg_Fields = {
  __typename?: 'prospect_crops_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "prospect_crops". All fields are combined with a logical 'AND'. */
export type Prospect_Crops_Bool_Exp = {
  _and?: InputMaybe<Array<Prospect_Crops_Bool_Exp>>;
  _not?: InputMaybe<Prospect_Crops_Bool_Exp>;
  _or?: InputMaybe<Array<Prospect_Crops_Bool_Exp>>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  company_id?: InputMaybe<Bpchar_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  crop?: InputMaybe<Master_Crops_Bool_Exp>;
  crop_id?: InputMaybe<Bpchar_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  prospect?: InputMaybe<Prospects_Bool_Exp>;
  prospect_id?: InputMaybe<Bpchar_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "prospect_crops" */
export enum Prospect_Crops_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProspectCropsPkey = 'prospect_crops_pkey'
}

/** input type for incrementing numeric columns in table "prospect_crops" */
export type Prospect_Crops_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "prospect_crops" */
export type Prospect_Crops_Insert_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crop?: InputMaybe<Master_Crops_Obj_Rel_Insert_Input>;
  crop_id?: InputMaybe<Scalars['bpchar']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  prospect?: InputMaybe<Prospects_Obj_Rel_Insert_Input>;
  prospect_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Prospect_Crops_Max_Fields = {
  __typename?: 'prospect_crops_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crop_id?: Maybe<Scalars['bpchar']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  prospect_id?: Maybe<Scalars['bpchar']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Prospect_Crops_Min_Fields = {
  __typename?: 'prospect_crops_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crop_id?: Maybe<Scalars['bpchar']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  prospect_id?: Maybe<Scalars['bpchar']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "prospect_crops" */
export type Prospect_Crops_Mutation_Response = {
  __typename?: 'prospect_crops_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Prospect_Crops>;
};

/** on_conflict condition type for table "prospect_crops" */
export type Prospect_Crops_On_Conflict = {
  constraint: Prospect_Crops_Constraint;
  update_columns?: Array<Prospect_Crops_Update_Column>;
  where?: InputMaybe<Prospect_Crops_Bool_Exp>;
};

/** Ordering options when selecting data from "prospect_crops". */
export type Prospect_Crops_Order_By = {
  account_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crop?: InputMaybe<Master_Crops_Order_By>;
  crop_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  prospect?: InputMaybe<Prospects_Order_By>;
  prospect_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: prospect_crops */
export type Prospect_Crops_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "prospect_crops" */
export enum Prospect_Crops_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ProspectId = 'prospect_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "prospect_crops" */
export type Prospect_Crops_Set_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crop_id?: InputMaybe<Scalars['bpchar']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  prospect_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Prospect_Crops_Stddev_Fields = {
  __typename?: 'prospect_crops_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Prospect_Crops_Stddev_Pop_Fields = {
  __typename?: 'prospect_crops_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Prospect_Crops_Stddev_Samp_Fields = {
  __typename?: 'prospect_crops_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "prospect_crops" */
export type Prospect_Crops_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Prospect_Crops_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Prospect_Crops_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crop_id?: InputMaybe<Scalars['bpchar']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  prospect_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Prospect_Crops_Sum_Fields = {
  __typename?: 'prospect_crops_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "prospect_crops" */
export enum Prospect_Crops_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ProspectId = 'prospect_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Prospect_Crops_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Prospect_Crops_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Prospect_Crops_Set_Input>;
  /** filter the rows which have to be updated */
  where: Prospect_Crops_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Prospect_Crops_Var_Pop_Fields = {
  __typename?: 'prospect_crops_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Prospect_Crops_Var_Samp_Fields = {
  __typename?: 'prospect_crops_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Prospect_Crops_Variance_Fields = {
  __typename?: 'prospect_crops_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "prospect_messages" */
export type Prospect_Messages = {
  __typename?: 'prospect_messages';
  account_id: Scalars['bpchar']['output'];
  channel_id?: Maybe<Scalars['bigint']['output']>;
  company_id: Scalars['bpchar']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  from_user_id: Scalars['bpchar']['output'];
  id: Scalars['bigint']['output'];
  message: Scalars['String']['output'];
  /** An object relationship */
  prospect_channel?: Maybe<Channels>;
  prospect_id?: Maybe<Scalars['bpchar']['output']>;
  to_user_id: Scalars['bpchar']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "prospect_messages" */
export type Prospect_Messages_Aggregate = {
  __typename?: 'prospect_messages_aggregate';
  aggregate?: Maybe<Prospect_Messages_Aggregate_Fields>;
  nodes: Array<Prospect_Messages>;
};

export type Prospect_Messages_Aggregate_Bool_Exp = {
  count?: InputMaybe<Prospect_Messages_Aggregate_Bool_Exp_Count>;
};

export type Prospect_Messages_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Prospect_Messages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Prospect_Messages_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "prospect_messages" */
export type Prospect_Messages_Aggregate_Fields = {
  __typename?: 'prospect_messages_aggregate_fields';
  avg?: Maybe<Prospect_Messages_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Prospect_Messages_Max_Fields>;
  min?: Maybe<Prospect_Messages_Min_Fields>;
  stddev?: Maybe<Prospect_Messages_Stddev_Fields>;
  stddev_pop?: Maybe<Prospect_Messages_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Prospect_Messages_Stddev_Samp_Fields>;
  sum?: Maybe<Prospect_Messages_Sum_Fields>;
  var_pop?: Maybe<Prospect_Messages_Var_Pop_Fields>;
  var_samp?: Maybe<Prospect_Messages_Var_Samp_Fields>;
  variance?: Maybe<Prospect_Messages_Variance_Fields>;
};


/** aggregate fields of "prospect_messages" */
export type Prospect_Messages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Prospect_Messages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "prospect_messages" */
export type Prospect_Messages_Aggregate_Order_By = {
  avg?: InputMaybe<Prospect_Messages_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Prospect_Messages_Max_Order_By>;
  min?: InputMaybe<Prospect_Messages_Min_Order_By>;
  stddev?: InputMaybe<Prospect_Messages_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Prospect_Messages_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Prospect_Messages_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Prospect_Messages_Sum_Order_By>;
  var_pop?: InputMaybe<Prospect_Messages_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Prospect_Messages_Var_Samp_Order_By>;
  variance?: InputMaybe<Prospect_Messages_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "prospect_messages" */
export type Prospect_Messages_Arr_Rel_Insert_Input = {
  data: Array<Prospect_Messages_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Prospect_Messages_On_Conflict>;
};

/** aggregate avg on columns */
export type Prospect_Messages_Avg_Fields = {
  __typename?: 'prospect_messages_avg_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "prospect_messages" */
export type Prospect_Messages_Avg_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "prospect_messages". All fields are combined with a logical 'AND'. */
export type Prospect_Messages_Bool_Exp = {
  _and?: InputMaybe<Array<Prospect_Messages_Bool_Exp>>;
  _not?: InputMaybe<Prospect_Messages_Bool_Exp>;
  _or?: InputMaybe<Array<Prospect_Messages_Bool_Exp>>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  channel_id?: InputMaybe<Bigint_Comparison_Exp>;
  company_id?: InputMaybe<Bpchar_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  from_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  prospect_channel?: InputMaybe<Channels_Bool_Exp>;
  prospect_id?: InputMaybe<Bpchar_Comparison_Exp>;
  to_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "prospect_messages" */
export enum Prospect_Messages_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProspectMessagesPkey = 'prospect_messages_pkey'
}

/** input type for incrementing numeric columns in table "prospect_messages" */
export type Prospect_Messages_Inc_Input = {
  channel_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "prospect_messages" */
export type Prospect_Messages_Insert_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  channel_id?: InputMaybe<Scalars['bigint']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  from_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  prospect_channel?: InputMaybe<Channels_Obj_Rel_Insert_Input>;
  prospect_id?: InputMaybe<Scalars['bpchar']['input']>;
  to_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Prospect_Messages_Max_Fields = {
  __typename?: 'prospect_messages_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  channel_id?: Maybe<Scalars['bigint']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  from_user_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  prospect_id?: Maybe<Scalars['bpchar']['output']>;
  to_user_id?: Maybe<Scalars['bpchar']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "prospect_messages" */
export type Prospect_Messages_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  from_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  prospect_id?: InputMaybe<Order_By>;
  to_user_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Prospect_Messages_Min_Fields = {
  __typename?: 'prospect_messages_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  channel_id?: Maybe<Scalars['bigint']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  from_user_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  prospect_id?: Maybe<Scalars['bpchar']['output']>;
  to_user_id?: Maybe<Scalars['bpchar']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "prospect_messages" */
export type Prospect_Messages_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  from_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  prospect_id?: InputMaybe<Order_By>;
  to_user_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "prospect_messages" */
export type Prospect_Messages_Mutation_Response = {
  __typename?: 'prospect_messages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Prospect_Messages>;
};

/** on_conflict condition type for table "prospect_messages" */
export type Prospect_Messages_On_Conflict = {
  constraint: Prospect_Messages_Constraint;
  update_columns?: Array<Prospect_Messages_Update_Column>;
  where?: InputMaybe<Prospect_Messages_Bool_Exp>;
};

/** Ordering options when selecting data from "prospect_messages". */
export type Prospect_Messages_Order_By = {
  account_id?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  from_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  prospect_channel?: InputMaybe<Channels_Order_By>;
  prospect_id?: InputMaybe<Order_By>;
  to_user_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: prospect_messages */
export type Prospect_Messages_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "prospect_messages" */
export enum Prospect_Messages_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  ChannelId = 'channel_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FromUserId = 'from_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  ProspectId = 'prospect_id',
  /** column name */
  ToUserId = 'to_user_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "prospect_messages" */
export type Prospect_Messages_Set_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  channel_id?: InputMaybe<Scalars['bigint']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  from_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  prospect_id?: InputMaybe<Scalars['bpchar']['input']>;
  to_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Prospect_Messages_Stddev_Fields = {
  __typename?: 'prospect_messages_stddev_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "prospect_messages" */
export type Prospect_Messages_Stddev_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Prospect_Messages_Stddev_Pop_Fields = {
  __typename?: 'prospect_messages_stddev_pop_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "prospect_messages" */
export type Prospect_Messages_Stddev_Pop_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Prospect_Messages_Stddev_Samp_Fields = {
  __typename?: 'prospect_messages_stddev_samp_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "prospect_messages" */
export type Prospect_Messages_Stddev_Samp_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "prospect_messages" */
export type Prospect_Messages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Prospect_Messages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Prospect_Messages_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  channel_id?: InputMaybe<Scalars['bigint']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  from_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  prospect_id?: InputMaybe<Scalars['bpchar']['input']>;
  to_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Prospect_Messages_Sum_Fields = {
  __typename?: 'prospect_messages_sum_fields';
  channel_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "prospect_messages" */
export type Prospect_Messages_Sum_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "prospect_messages" */
export enum Prospect_Messages_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  ChannelId = 'channel_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FromUserId = 'from_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  ProspectId = 'prospect_id',
  /** column name */
  ToUserId = 'to_user_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Prospect_Messages_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Prospect_Messages_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Prospect_Messages_Set_Input>;
  /** filter the rows which have to be updated */
  where: Prospect_Messages_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Prospect_Messages_Var_Pop_Fields = {
  __typename?: 'prospect_messages_var_pop_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "prospect_messages" */
export type Prospect_Messages_Var_Pop_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Prospect_Messages_Var_Samp_Fields = {
  __typename?: 'prospect_messages_var_samp_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "prospect_messages" */
export type Prospect_Messages_Var_Samp_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Prospect_Messages_Variance_Fields = {
  __typename?: 'prospect_messages_variance_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "prospect_messages" */
export type Prospect_Messages_Variance_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "prospect_user" */
export type Prospect_User = {
  __typename?: 'prospect_user';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  fp_user_id: Scalars['bpchar']['output'];
  id: Scalars['bigint']['output'];
  /** An object relationship */
  prospect?: Maybe<Prospects>;
  prospect_id?: Maybe<Scalars['bpchar']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "prospect_user" */
export type Prospect_User_Aggregate = {
  __typename?: 'prospect_user_aggregate';
  aggregate?: Maybe<Prospect_User_Aggregate_Fields>;
  nodes: Array<Prospect_User>;
};

/** aggregate fields of "prospect_user" */
export type Prospect_User_Aggregate_Fields = {
  __typename?: 'prospect_user_aggregate_fields';
  avg?: Maybe<Prospect_User_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Prospect_User_Max_Fields>;
  min?: Maybe<Prospect_User_Min_Fields>;
  stddev?: Maybe<Prospect_User_Stddev_Fields>;
  stddev_pop?: Maybe<Prospect_User_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Prospect_User_Stddev_Samp_Fields>;
  sum?: Maybe<Prospect_User_Sum_Fields>;
  var_pop?: Maybe<Prospect_User_Var_Pop_Fields>;
  var_samp?: Maybe<Prospect_User_Var_Samp_Fields>;
  variance?: Maybe<Prospect_User_Variance_Fields>;
};


/** aggregate fields of "prospect_user" */
export type Prospect_User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Prospect_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Prospect_User_Avg_Fields = {
  __typename?: 'prospect_user_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "prospect_user". All fields are combined with a logical 'AND'. */
export type Prospect_User_Bool_Exp = {
  _and?: InputMaybe<Array<Prospect_User_Bool_Exp>>;
  _not?: InputMaybe<Prospect_User_Bool_Exp>;
  _or?: InputMaybe<Array<Prospect_User_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fp_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  prospect?: InputMaybe<Prospects_Bool_Exp>;
  prospect_id?: InputMaybe<Bpchar_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "prospect_user" */
export enum Prospect_User_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProspectUserPkey = 'prospect_user_pkey'
}

/** input type for incrementing numeric columns in table "prospect_user" */
export type Prospect_User_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "prospect_user" */
export type Prospect_User_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fp_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  prospect?: InputMaybe<Prospects_Obj_Rel_Insert_Input>;
  prospect_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Prospect_User_Max_Fields = {
  __typename?: 'prospect_user_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  fp_user_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  prospect_id?: Maybe<Scalars['bpchar']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Prospect_User_Min_Fields = {
  __typename?: 'prospect_user_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  fp_user_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  prospect_id?: Maybe<Scalars['bpchar']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "prospect_user" */
export type Prospect_User_Mutation_Response = {
  __typename?: 'prospect_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Prospect_User>;
};

/** on_conflict condition type for table "prospect_user" */
export type Prospect_User_On_Conflict = {
  constraint: Prospect_User_Constraint;
  update_columns?: Array<Prospect_User_Update_Column>;
  where?: InputMaybe<Prospect_User_Bool_Exp>;
};

/** Ordering options when selecting data from "prospect_user". */
export type Prospect_User_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  fp_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  prospect?: InputMaybe<Prospects_Order_By>;
  prospect_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: prospect_user */
export type Prospect_User_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "prospect_user" */
export enum Prospect_User_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FpUserId = 'fp_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  ProspectId = 'prospect_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "prospect_user" */
export type Prospect_User_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fp_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  prospect_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Prospect_User_Stddev_Fields = {
  __typename?: 'prospect_user_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Prospect_User_Stddev_Pop_Fields = {
  __typename?: 'prospect_user_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Prospect_User_Stddev_Samp_Fields = {
  __typename?: 'prospect_user_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "prospect_user" */
export type Prospect_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Prospect_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Prospect_User_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fp_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  prospect_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Prospect_User_Sum_Fields = {
  __typename?: 'prospect_user_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "prospect_user" */
export enum Prospect_User_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FpUserId = 'fp_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  ProspectId = 'prospect_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Prospect_User_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Prospect_User_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Prospect_User_Set_Input>;
  /** filter the rows which have to be updated */
  where: Prospect_User_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Prospect_User_Var_Pop_Fields = {
  __typename?: 'prospect_user_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Prospect_User_Var_Samp_Fields = {
  __typename?: 'prospect_user_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Prospect_User_Variance_Fields = {
  __typename?: 'prospect_user_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "prospects" */
export type Prospects = {
  __typename?: 'prospects';
  account_id: Scalars['bpchar']['output'];
  /** An object relationship */
  chat_thread?: Maybe<Chat_Threads>;
  company_id: Scalars['bpchar']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crop_id?: Maybe<Scalars['bpchar']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  farmer_location?: Maybe<Last_Known_Locations>;
  farmer_user_id: Scalars['bpchar']['output'];
  id: Scalars['bpchar']['output'];
  owner_user_id?: Maybe<Scalars['bpchar']['output']>;
  /** An object relationship */
  prospects_account: Accounts;
  /** An object relationship */
  prospects_crop?: Maybe<Master_Crops>;
  /** An object relationship */
  prospects_farmer_user: Users;
  /** An object relationship */
  prospects_owner?: Maybe<Users>;
  /** An array relationship */
  prospects_prospect_messages: Array<Prospect_Messages>;
  /** An aggregate relationship */
  prospects_prospect_messages_aggregate: Prospect_Messages_Aggregate;
  /** An object relationship */
  prospects_reel?: Maybe<Reels>;
  /** An object relationship */
  prospects_reel_comment?: Maybe<Reel_Comments>;
  source_interaction_ts?: Maybe<Scalars['timestamptz']['output']>;
  source_interaction_type?: Maybe<Scalars['String']['output']>;
  source_name?: Maybe<Scalars['String']['output']>;
  source_reel_comment_id?: Maybe<Scalars['bigint']['output']>;
  source_reel_id?: Maybe<Scalars['bigint']['output']>;
  source_reel_interaction_id?: Maybe<Scalars['bigint']['output']>;
  source_service_request_id?: Maybe<Scalars['bpchar']['output']>;
  status: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "prospects" */
export type ProspectsProspects_Prospect_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Prospect_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospect_Messages_Order_By>>;
  where?: InputMaybe<Prospect_Messages_Bool_Exp>;
};


/** columns and relationships of "prospects" */
export type ProspectsProspects_Prospect_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prospect_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospect_Messages_Order_By>>;
  where?: InputMaybe<Prospect_Messages_Bool_Exp>;
};

/** aggregated selection of "prospects" */
export type Prospects_Aggregate = {
  __typename?: 'prospects_aggregate';
  aggregate?: Maybe<Prospects_Aggregate_Fields>;
  nodes: Array<Prospects>;
};

/** aggregate fields of "prospects" */
export type Prospects_Aggregate_Fields = {
  __typename?: 'prospects_aggregate_fields';
  avg?: Maybe<Prospects_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Prospects_Max_Fields>;
  min?: Maybe<Prospects_Min_Fields>;
  stddev?: Maybe<Prospects_Stddev_Fields>;
  stddev_pop?: Maybe<Prospects_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Prospects_Stddev_Samp_Fields>;
  sum?: Maybe<Prospects_Sum_Fields>;
  var_pop?: Maybe<Prospects_Var_Pop_Fields>;
  var_samp?: Maybe<Prospects_Var_Samp_Fields>;
  variance?: Maybe<Prospects_Variance_Fields>;
};


/** aggregate fields of "prospects" */
export type Prospects_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Prospects_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Prospects_Avg_Fields = {
  __typename?: 'prospects_avg_fields';
  source_reel_comment_id?: Maybe<Scalars['Float']['output']>;
  source_reel_id?: Maybe<Scalars['Float']['output']>;
  source_reel_interaction_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "prospects". All fields are combined with a logical 'AND'. */
export type Prospects_Bool_Exp = {
  _and?: InputMaybe<Array<Prospects_Bool_Exp>>;
  _not?: InputMaybe<Prospects_Bool_Exp>;
  _or?: InputMaybe<Array<Prospects_Bool_Exp>>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  chat_thread?: InputMaybe<Chat_Threads_Bool_Exp>;
  company_id?: InputMaybe<Bpchar_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  crop_id?: InputMaybe<Bpchar_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  farmer_location?: InputMaybe<Last_Known_Locations_Bool_Exp>;
  farmer_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  owner_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  prospects_account?: InputMaybe<Accounts_Bool_Exp>;
  prospects_crop?: InputMaybe<Master_Crops_Bool_Exp>;
  prospects_farmer_user?: InputMaybe<Users_Bool_Exp>;
  prospects_owner?: InputMaybe<Users_Bool_Exp>;
  prospects_prospect_messages?: InputMaybe<Prospect_Messages_Bool_Exp>;
  prospects_prospect_messages_aggregate?: InputMaybe<Prospect_Messages_Aggregate_Bool_Exp>;
  prospects_reel?: InputMaybe<Reels_Bool_Exp>;
  prospects_reel_comment?: InputMaybe<Reel_Comments_Bool_Exp>;
  source_interaction_ts?: InputMaybe<Timestamptz_Comparison_Exp>;
  source_interaction_type?: InputMaybe<String_Comparison_Exp>;
  source_name?: InputMaybe<String_Comparison_Exp>;
  source_reel_comment_id?: InputMaybe<Bigint_Comparison_Exp>;
  source_reel_id?: InputMaybe<Bigint_Comparison_Exp>;
  source_reel_interaction_id?: InputMaybe<Bigint_Comparison_Exp>;
  source_service_request_id?: InputMaybe<Bpchar_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "prospects" */
export enum Prospects_Constraint {
  /** unique or primary key constraint on columns "account_id", "farmer_user_id" */
  ProspectsAccountIdFarmerUserIdUnique = 'prospects_account_id_farmer_user_id_unique',
  /** unique or primary key constraint on columns "id" */
  ProspectsPkey = 'prospects_pkey',
  /** unique or primary key constraint on columns "id" */
  ProspectsUlidUnique = 'prospects_ulid_unique'
}

/** input type for incrementing numeric columns in table "prospects" */
export type Prospects_Inc_Input = {
  source_reel_comment_id?: InputMaybe<Scalars['bigint']['input']>;
  source_reel_id?: InputMaybe<Scalars['bigint']['input']>;
  source_reel_interaction_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "prospects" */
export type Prospects_Insert_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  chat_thread?: InputMaybe<Chat_Threads_Obj_Rel_Insert_Input>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crop_id?: InputMaybe<Scalars['bpchar']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer_location?: InputMaybe<Last_Known_Locations_Obj_Rel_Insert_Input>;
  farmer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  owner_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  prospects_account?: InputMaybe<Accounts_Obj_Rel_Insert_Input>;
  prospects_crop?: InputMaybe<Master_Crops_Obj_Rel_Insert_Input>;
  prospects_farmer_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  prospects_owner?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  prospects_prospect_messages?: InputMaybe<Prospect_Messages_Arr_Rel_Insert_Input>;
  prospects_reel?: InputMaybe<Reels_Obj_Rel_Insert_Input>;
  prospects_reel_comment?: InputMaybe<Reel_Comments_Obj_Rel_Insert_Input>;
  source_interaction_ts?: InputMaybe<Scalars['timestamptz']['input']>;
  source_interaction_type?: InputMaybe<Scalars['String']['input']>;
  source_name?: InputMaybe<Scalars['String']['input']>;
  source_reel_comment_id?: InputMaybe<Scalars['bigint']['input']>;
  source_reel_id?: InputMaybe<Scalars['bigint']['input']>;
  source_reel_interaction_id?: InputMaybe<Scalars['bigint']['input']>;
  source_service_request_id?: InputMaybe<Scalars['bpchar']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Prospects_Max_Fields = {
  __typename?: 'prospects_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crop_id?: Maybe<Scalars['bpchar']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  farmer_user_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  owner_user_id?: Maybe<Scalars['bpchar']['output']>;
  source_interaction_ts?: Maybe<Scalars['timestamptz']['output']>;
  source_interaction_type?: Maybe<Scalars['String']['output']>;
  source_name?: Maybe<Scalars['String']['output']>;
  source_reel_comment_id?: Maybe<Scalars['bigint']['output']>;
  source_reel_id?: Maybe<Scalars['bigint']['output']>;
  source_reel_interaction_id?: Maybe<Scalars['bigint']['output']>;
  source_service_request_id?: Maybe<Scalars['bpchar']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Prospects_Min_Fields = {
  __typename?: 'prospects_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crop_id?: Maybe<Scalars['bpchar']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  farmer_user_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  owner_user_id?: Maybe<Scalars['bpchar']['output']>;
  source_interaction_ts?: Maybe<Scalars['timestamptz']['output']>;
  source_interaction_type?: Maybe<Scalars['String']['output']>;
  source_name?: Maybe<Scalars['String']['output']>;
  source_reel_comment_id?: Maybe<Scalars['bigint']['output']>;
  source_reel_id?: Maybe<Scalars['bigint']['output']>;
  source_reel_interaction_id?: Maybe<Scalars['bigint']['output']>;
  source_service_request_id?: Maybe<Scalars['bpchar']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "prospects" */
export type Prospects_Mutation_Response = {
  __typename?: 'prospects_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Prospects>;
};

/** input type for inserting object relation for remote table "prospects" */
export type Prospects_Obj_Rel_Insert_Input = {
  data: Prospects_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Prospects_On_Conflict>;
};

/** on_conflict condition type for table "prospects" */
export type Prospects_On_Conflict = {
  constraint: Prospects_Constraint;
  update_columns?: Array<Prospects_Update_Column>;
  where?: InputMaybe<Prospects_Bool_Exp>;
};

/** Ordering options when selecting data from "prospects". */
export type Prospects_Order_By = {
  account_id?: InputMaybe<Order_By>;
  chat_thread?: InputMaybe<Chat_Threads_Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  farmer_location?: InputMaybe<Last_Known_Locations_Order_By>;
  farmer_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner_user_id?: InputMaybe<Order_By>;
  prospects_account?: InputMaybe<Accounts_Order_By>;
  prospects_crop?: InputMaybe<Master_Crops_Order_By>;
  prospects_farmer_user?: InputMaybe<Users_Order_By>;
  prospects_owner?: InputMaybe<Users_Order_By>;
  prospects_prospect_messages_aggregate?: InputMaybe<Prospect_Messages_Aggregate_Order_By>;
  prospects_reel?: InputMaybe<Reels_Order_By>;
  prospects_reel_comment?: InputMaybe<Reel_Comments_Order_By>;
  source_interaction_ts?: InputMaybe<Order_By>;
  source_interaction_type?: InputMaybe<Order_By>;
  source_name?: InputMaybe<Order_By>;
  source_reel_comment_id?: InputMaybe<Order_By>;
  source_reel_id?: InputMaybe<Order_By>;
  source_reel_interaction_id?: InputMaybe<Order_By>;
  source_service_request_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: prospects */
export type Prospects_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** select columns of table "prospects" */
export enum Prospects_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FarmerUserId = 'farmer_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  OwnerUserId = 'owner_user_id',
  /** column name */
  SourceInteractionTs = 'source_interaction_ts',
  /** column name */
  SourceInteractionType = 'source_interaction_type',
  /** column name */
  SourceName = 'source_name',
  /** column name */
  SourceReelCommentId = 'source_reel_comment_id',
  /** column name */
  SourceReelId = 'source_reel_id',
  /** column name */
  SourceReelInteractionId = 'source_reel_interaction_id',
  /** column name */
  SourceServiceRequestId = 'source_service_request_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "prospects" */
export type Prospects_Set_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crop_id?: InputMaybe<Scalars['bpchar']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  owner_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  source_interaction_ts?: InputMaybe<Scalars['timestamptz']['input']>;
  source_interaction_type?: InputMaybe<Scalars['String']['input']>;
  source_name?: InputMaybe<Scalars['String']['input']>;
  source_reel_comment_id?: InputMaybe<Scalars['bigint']['input']>;
  source_reel_id?: InputMaybe<Scalars['bigint']['input']>;
  source_reel_interaction_id?: InputMaybe<Scalars['bigint']['input']>;
  source_service_request_id?: InputMaybe<Scalars['bpchar']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Prospects_Stddev_Fields = {
  __typename?: 'prospects_stddev_fields';
  source_reel_comment_id?: Maybe<Scalars['Float']['output']>;
  source_reel_id?: Maybe<Scalars['Float']['output']>;
  source_reel_interaction_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Prospects_Stddev_Pop_Fields = {
  __typename?: 'prospects_stddev_pop_fields';
  source_reel_comment_id?: Maybe<Scalars['Float']['output']>;
  source_reel_id?: Maybe<Scalars['Float']['output']>;
  source_reel_interaction_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Prospects_Stddev_Samp_Fields = {
  __typename?: 'prospects_stddev_samp_fields';
  source_reel_comment_id?: Maybe<Scalars['Float']['output']>;
  source_reel_id?: Maybe<Scalars['Float']['output']>;
  source_reel_interaction_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "prospects" */
export type Prospects_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Prospects_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Prospects_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crop_id?: InputMaybe<Scalars['bpchar']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  owner_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  source_interaction_ts?: InputMaybe<Scalars['timestamptz']['input']>;
  source_interaction_type?: InputMaybe<Scalars['String']['input']>;
  source_name?: InputMaybe<Scalars['String']['input']>;
  source_reel_comment_id?: InputMaybe<Scalars['bigint']['input']>;
  source_reel_id?: InputMaybe<Scalars['bigint']['input']>;
  source_reel_interaction_id?: InputMaybe<Scalars['bigint']['input']>;
  source_service_request_id?: InputMaybe<Scalars['bpchar']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Prospects_Sum_Fields = {
  __typename?: 'prospects_sum_fields';
  source_reel_comment_id?: Maybe<Scalars['bigint']['output']>;
  source_reel_id?: Maybe<Scalars['bigint']['output']>;
  source_reel_interaction_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "prospects" */
export enum Prospects_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FarmerUserId = 'farmer_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  OwnerUserId = 'owner_user_id',
  /** column name */
  SourceInteractionTs = 'source_interaction_ts',
  /** column name */
  SourceInteractionType = 'source_interaction_type',
  /** column name */
  SourceName = 'source_name',
  /** column name */
  SourceReelCommentId = 'source_reel_comment_id',
  /** column name */
  SourceReelId = 'source_reel_id',
  /** column name */
  SourceReelInteractionId = 'source_reel_interaction_id',
  /** column name */
  SourceServiceRequestId = 'source_service_request_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Prospects_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Prospects_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Prospects_Set_Input>;
  /** filter the rows which have to be updated */
  where: Prospects_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Prospects_Var_Pop_Fields = {
  __typename?: 'prospects_var_pop_fields';
  source_reel_comment_id?: Maybe<Scalars['Float']['output']>;
  source_reel_id?: Maybe<Scalars['Float']['output']>;
  source_reel_interaction_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Prospects_Var_Samp_Fields = {
  __typename?: 'prospects_var_samp_fields';
  source_reel_comment_id?: Maybe<Scalars['Float']['output']>;
  source_reel_id?: Maybe<Scalars['Float']['output']>;
  source_reel_interaction_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Prospects_Variance_Fields = {
  __typename?: 'prospects_variance_fields';
  source_reel_comment_id?: Maybe<Scalars['Float']['output']>;
  source_reel_id?: Maybe<Scalars['Float']['output']>;
  source_reel_interaction_id?: Maybe<Scalars['Float']['output']>;
};

export type Query_Root = {
  __typename?: 'query_root';
  accountBalances: GetAccountBalanceResponse;
  /** fetch data from the table: "account_auth_key" */
  account_auth_key: Array<Account_Auth_Key>;
  /** fetch aggregated fields from the table: "account_auth_key" */
  account_auth_key_aggregate: Account_Auth_Key_Aggregate;
  /** fetch data from the table: "account_auth_key" using primary key columns */
  account_auth_key_by_pk?: Maybe<Account_Auth_Key>;
  /** fetch data from the table: "account_crop" */
  account_crop: Array<Account_Crop>;
  /** fetch aggregated fields from the table: "account_crop" */
  account_crop_aggregate: Account_Crop_Aggregate;
  /** fetch data from the table: "account_crop" using primary key columns */
  account_crop_by_pk?: Maybe<Account_Crop>;
  /** fetch data from the table: "account_segment" */
  account_segment: Array<Account_Segment>;
  /** fetch aggregated fields from the table: "account_segment" */
  account_segment_aggregate: Account_Segment_Aggregate;
  /** fetch data from the table: "account_segment" using primary key columns */
  account_segment_by_pk?: Maybe<Account_Segment>;
  /** fetch data from the table: "account_user" */
  account_user: Array<Account_User>;
  /** fetch aggregated fields from the table: "account_user" */
  account_user_aggregate: Account_User_Aggregate;
  /** fetch data from the table: "account_user" using primary key columns */
  account_user_by_pk?: Maybe<Account_User>;
  /** An array relationship */
  accounts: Array<Accounts>;
  accountsWiseCampaignSummary?: Maybe<Array<Maybe<AccountsWiseCampaignSummaryResponse>>>;
  /** An aggregate relationship */
  accounts_aggregate: Accounts_Aggregate;
  /** fetch data from the table: "accounts" using primary key columns */
  accounts_by_pk?: Maybe<Accounts>;
  /** fetch data from the table: "action_events" */
  action_events: Array<Action_Events>;
  /** fetch aggregated fields from the table: "action_events" */
  action_events_aggregate: Action_Events_Aggregate;
  /** fetch data from the table: "action_events" using primary key columns */
  action_events_by_pk?: Maybe<Action_Events>;
  availableReels?: Maybe<Scalars['JSON']['output']>;
  /** fetch data from the table: "balances" */
  balances: Array<Balances>;
  /** fetch aggregated fields from the table: "balances" */
  balances_aggregate: Balances_Aggregate;
  /** fetch data from the table: "balances" using primary key columns */
  balances_by_pk?: Maybe<Balances>;
  cRMItems?: Maybe<Array<Maybe<CrmItem>>>;
  cRMSchema?: Maybe<Array<Maybe<FormBuilder>>>;
  campaignWiseSummary?: Maybe<Array<Maybe<CampaignWiseSummaryResponse>>>;
  categories?: Maybe<Array<Maybe<Category>>>;
  category?: Maybe<Category>;
  categoryTree?: Maybe<Array<Maybe<Category>>>;
  channelAnalytics: GetChannelAnalyticsOutput;
  /** An array relationship */
  channel_links: Array<Channel_Links>;
  /** An aggregate relationship */
  channel_links_aggregate: Channel_Links_Aggregate;
  /** fetch data from the table: "channel_links" using primary key columns */
  channel_links_by_pk?: Maybe<Channel_Links>;
  /** fetch data from the table: "channels" */
  channels: Array<Channels>;
  /** fetch aggregated fields from the table: "channels" */
  channels_aggregate: Channels_Aggregate;
  /** fetch data from the table: "channels" using primary key columns */
  channels_by_pk?: Maybe<Channels>;
  /** Get the messages of a chat thread with pagination. */
  chatThreadMessages: Array<ChatMessage>;
  /** Get the participants of a chat thread. */
  chatThreadParticipants?: Maybe<Array<Maybe<ChatParticipant>>>;
  /** Get the number of unread messages in a chat thread for the current user. */
  chatUnreadCount: Scalars['Int']['output'];
  /** fetch data from the table: "chat_messages" */
  chat_messages: Array<Chat_Messages>;
  /** fetch aggregated fields from the table: "chat_messages" */
  chat_messages_aggregate: Chat_Messages_Aggregate;
  /** fetch data from the table: "chat_messages" using primary key columns */
  chat_messages_by_pk?: Maybe<Chat_Messages>;
  /** An array relationship */
  chat_participants: Array<Chat_Participants>;
  /** An aggregate relationship */
  chat_participants_aggregate: Chat_Participants_Aggregate;
  /** fetch data from the table: "chat_participants" using primary key columns */
  chat_participants_by_pk?: Maybe<Chat_Participants>;
  /** fetch data from the table: "chat_threads" */
  chat_threads: Array<Chat_Threads>;
  /** fetch aggregated fields from the table: "chat_threads" */
  chat_threads_aggregate: Chat_Threads_Aggregate;
  /** fetch data from the table: "chat_threads" using primary key columns */
  chat_threads_by_pk?: Maybe<Chat_Threads>;
  checkStockAvailability: InventoryDetail;
  /** An array relationship */
  companies: Array<Companies>;
  /** An aggregate relationship */
  companies_aggregate: Companies_Aggregate;
  /** fetch data from the table: "companies" using primary key columns */
  companies_by_pk?: Maybe<Companies>;
  consoleMenuLayout: MenuStructure;
  /** fetch data from the table: "creator_onboarding" */
  creator_onboarding: Array<Creator_Onboarding>;
  /** fetch aggregated fields from the table: "creator_onboarding" */
  creator_onboarding_aggregate: Creator_Onboarding_Aggregate;
  /** fetch data from the table: "creator_onboarding" using primary key columns */
  creator_onboarding_by_pk?: Maybe<Creator_Onboarding>;
  /** fetch data from the table: "crm_account_channel_crop_prospects" */
  crm_account_channel_crop_prospects: Array<Crm_Account_Channel_Crop_Prospects>;
  /** fetch aggregated fields from the table: "crm_account_channel_crop_prospects" */
  crm_account_channel_crop_prospects_aggregate: Crm_Account_Channel_Crop_Prospects_Aggregate;
  /** fetch data from the table: "crm_account_crop_wise_counts" */
  crm_account_crop_wise_counts: Array<Crm_Account_Crop_Wise_Counts>;
  /** fetch aggregated fields from the table: "crm_account_crop_wise_counts" */
  crm_account_crop_wise_counts_aggregate: Crm_Account_Crop_Wise_Counts_Aggregate;
  /** fetch data from the table: "crm_account_interaction_type_pending_counts" */
  crm_account_interaction_type_pending_counts: Array<Crm_Account_Interaction_Type_Pending_Counts>;
  /** fetch aggregated fields from the table: "crm_account_interaction_type_pending_counts" */
  crm_account_interaction_type_pending_counts_aggregate: Crm_Account_Interaction_Type_Pending_Counts_Aggregate;
  /** fetch data from the table: "crm_segments" */
  crm_segments: Array<Crm_Segments>;
  /** fetch aggregated fields from the table: "crm_segments" */
  crm_segments_aggregate: Crm_Segments_Aggregate;
  /** fetch data from the table: "crm_segments" using primary key columns */
  crm_segments_by_pk?: Maybe<Crm_Segments>;
  /** fetch data from the table: "crop_user" */
  crop_user: Array<Crop_User>;
  /** fetch aggregated fields from the table: "crop_user" */
  crop_user_aggregate: Crop_User_Aggregate;
  /** fetch data from the table: "crop_user" using primary key columns */
  crop_user_by_pk?: Maybe<Crop_User>;
  extractPhoneNumbersFromImage: DefaultCommandOutput;
  /** fetch data from the table: "failed_jobs" */
  failed_jobs: Array<Failed_Jobs>;
  /** fetch aggregated fields from the table: "failed_jobs" */
  failed_jobs_aggregate: Failed_Jobs_Aggregate;
  /** fetch data from the table: "failed_jobs" using primary key columns */
  failed_jobs_by_pk?: Maybe<Failed_Jobs>;
  farmerAccountWiseStatus: Array<FarmerConnectionStatusOutput>;
  farmerDetail: GetFarmerDetailResponse;
  /** Executes a GraphQL query to retrieve and format farmer search results based on the provided search criteria. */
  farmerSearchOutPut: Array<SearchFarmerResponse>;
  /** fetch data from the table: "farmer_account_locations" */
  farmer_account_locations: Array<Farmer_Account_Locations>;
  /** fetch aggregated fields from the table: "farmer_account_locations" */
  farmer_account_locations_aggregate: Farmer_Account_Locations_Aggregate;
  /** fetch data from the table: "farmer_account_locations" using primary key columns */
  farmer_account_locations_by_pk?: Maybe<Farmer_Account_Locations>;
  /** fetch data from the table: "farmer_accounts" */
  farmer_accounts: Array<Farmer_Accounts>;
  /** fetch aggregated fields from the table: "farmer_accounts" */
  farmer_accounts_aggregate: Farmer_Accounts_Aggregate;
  /** fetch data from the table: "farmer_accounts" using primary key columns */
  farmer_accounts_by_pk?: Maybe<Farmer_Accounts>;
  /** fetch data from the table: "farmer_actions" */
  farmer_actions: Array<Farmer_Actions>;
  /** fetch aggregated fields from the table: "farmer_actions" */
  farmer_actions_aggregate: Farmer_Actions_Aggregate;
  /** fetch data from the table: "farmer_actions" using primary key columns */
  farmer_actions_by_pk?: Maybe<Farmer_Actions>;
  /** fetch data from the table: "farmer_fields" */
  farmer_fields: Array<Farmer_Fields>;
  /** fetch aggregated fields from the table: "farmer_fields" */
  farmer_fields_aggregate: Farmer_Fields_Aggregate;
  /** fetch data from the table: "farmer_fields" using primary key columns */
  farmer_fields_by_pk?: Maybe<Farmer_Fields>;
  /** fetch data from the table: "farmer_fields_latest" */
  farmer_fields_latest: Array<Farmer_Fields_Latest>;
  /** fetch aggregated fields from the table: "farmer_fields_latest" */
  farmer_fields_latest_aggregate: Farmer_Fields_Latest_Aggregate;
  /** fetch data from the table: "farmer_master" */
  farmer_master: Array<Farmer_Master>;
  /** fetch aggregated fields from the table: "farmer_master" */
  farmer_master_aggregate: Farmer_Master_Aggregate;
  /** fetch data from the table: "farmer_master" using primary key columns */
  farmer_master_by_pk?: Maybe<Farmer_Master>;
  /** fetch data from the table: "farmer_nearby_field_force" */
  farmer_nearby_field_force: Array<Farmer_Nearby_Field_Force>;
  /** fetch aggregated fields from the table: "farmer_nearby_field_force" */
  farmer_nearby_field_force_aggregate: Farmer_Nearby_Field_Force_Aggregate;
  /** fetch data from the table: "farmer_nearby_field_force" using primary key columns */
  farmer_nearby_field_force_by_pk?: Maybe<Farmer_Nearby_Field_Force>;
  /** An array relationship */
  farmer_plots: Array<Farmer_Plots>;
  /** An aggregate relationship */
  farmer_plots_aggregate: Farmer_Plots_Aggregate;
  /** fetch data from the table: "farmer_plots" using primary key columns */
  farmer_plots_by_pk?: Maybe<Farmer_Plots>;
  /** fetch data from the table: "farminsta_links" */
  farminsta_links: Array<Farminsta_Links>;
  /** fetch aggregated fields from the table: "farminsta_links" */
  farminsta_links_aggregate: Farminsta_Links_Aggregate;
  /** fetch data from the table: "farminsta_links" using primary key columns */
  farminsta_links_by_pk?: Maybe<Farminsta_Links>;
  /** fetch data from the table: "features" */
  features: Array<Features>;
  /** fetch aggregated fields from the table: "features" */
  features_aggregate: Features_Aggregate;
  /** fetch data from the table: "features" using primary key columns */
  features_by_pk?: Maybe<Features>;
  /** fetch data from the table: "dbt.channel_analytics" */
  fich_farminsta_replica_channel_analytics: Array<Fich_Farminsta_Replica_Channel_Analytics>;
  /** fetch aggregated fields from the table: "dbt.channel_analytics" */
  fich_farminsta_replica_channel_analytics_aggregate: Fich_Farminsta_Replica_Channel_Analytics_Aggregate;
  /** fetch data from the table: "dbt.leads" */
  fich_farminsta_replica_leads: Array<Fich_Farminsta_Replica_Leads>;
  /** fetch aggregated fields from the table: "dbt.leads" */
  fich_farminsta_replica_leads_aggregate: Fich_Farminsta_Replica_Leads_Aggregate;
  /** fetch data from the table: "dbt.reel_lead_info" */
  fich_farminsta_replica_reel_lead_info: Array<Fich_Farminsta_Replica_Reel_Lead_Info>;
  /** fetch aggregated fields from the table: "dbt.reel_lead_info" */
  fich_farminsta_replica_reel_lead_info_aggregate: Fich_Farminsta_Replica_Reel_Lead_Info_Aggregate;
  /** fetch data from the table: "dbt.reels_flat" */
  fich_farminsta_replica_reels_flat: Array<Fich_Farminsta_Replica_Reels_Flat>;
  /** fetch aggregated fields from the table: "dbt.reels_flat" */
  fich_farminsta_replica_reels_flat_aggregate: Fich_Farminsta_Replica_Reels_Flat_Aggregate;
  /** An array relationship */
  field_partner_response_events: Array<Field_Partner_Response_Events>;
  /** An aggregate relationship */
  field_partner_response_events_aggregate: Field_Partner_Response_Events_Aggregate;
  /** fetch data from the table: "field_partner_response_events" using primary key columns */
  field_partner_response_events_by_pk?: Maybe<Field_Partner_Response_Events>;
  /** An array relationship */
  field_partner_response_messages: Array<Field_Partner_Response_Messages>;
  /** An aggregate relationship */
  field_partner_response_messages_aggregate: Field_Partner_Response_Messages_Aggregate;
  /** fetch data from the table: "field_partner_response_messages" using primary key columns */
  field_partner_response_messages_by_pk?: Maybe<Field_Partner_Response_Messages>;
  /** An array relationship */
  field_partner_responses: Array<Field_Partner_Responses>;
  /** An aggregate relationship */
  field_partner_responses_aggregate: Field_Partner_Responses_Aggregate;
  /** fetch data from the table: "field_partner_responses" using primary key columns */
  field_partner_responses_by_pk?: Maybe<Field_Partner_Responses>;
  /** An array relationship */
  field_scheduled_visits: Array<Field_Scheduled_Visits>;
  /** An aggregate relationship */
  field_scheduled_visits_aggregate: Field_Scheduled_Visits_Aggregate;
  /** fetch data from the table: "field_scheduled_visits" using primary key columns */
  field_scheduled_visits_by_pk?: Maybe<Field_Scheduled_Visits>;
  /** fetch data from the table: "fo_reels_staging" */
  fo_reels_staging: Array<Fo_Reels_Staging>;
  /** fetch aggregated fields from the table: "fo_reels_staging" */
  fo_reels_staging_aggregate: Fo_Reels_Staging_Aggregate;
  /** fetch data from the table: "fo_reels_staging" using primary key columns */
  fo_reels_staging_by_pk?: Maybe<Fo_Reels_Staging>;
  /** fetch data from the table: "follows" */
  follows: Array<Follows>;
  /** fetch aggregated fields from the table: "follows" */
  follows_aggregate: Follows_Aggregate;
  /** fetch data from the table: "follows" using primary key columns */
  follows_by_pk?: Maybe<Follows>;
  /** fetch data from the table: "geography_columns" */
  geography_columns: Array<Geography_Columns>;
  /** fetch aggregated fields from the table: "geography_columns" */
  geography_columns_aggregate: Geography_Columns_Aggregate;
  /** fetch data from the table: "geometry_columns" */
  geometry_columns: Array<Geometry_Columns>;
  /** fetch aggregated fields from the table: "geometry_columns" */
  geometry_columns_aggregate: Geometry_Columns_Aggregate;
  /** getReelRecommendations */
  getReelRecommendations?: Maybe<RecommendedReelIds>;
  /** getReelRecommendationsByChannel */
  getReelRecommendationsByChannel?: Maybe<RecommendedReelIds>;
  /** execute function "get_reel_with_related" which returns "reels_with_distance" */
  get_reel_with_related: Array<Reels_With_Distance>;
  /** execute function "get_reel_with_related" and query aggregates on result of table type "reels_with_distance" */
  get_reel_with_related_aggregate: Reels_With_Distance_Aggregate;
  /** execute function "get_reels" which returns "reels_with_distance" */
  get_reels: Array<Reels_With_Distance>;
  /** execute function "get_reels" and query aggregates on result of table type "reels_with_distance" */
  get_reels_aggregate: Reels_With_Distance_Aggregate;
  /** fetch data from the table: "gig_faqs" */
  gig_faqs: Array<Gig_Faqs>;
  /** fetch aggregated fields from the table: "gig_faqs" */
  gig_faqs_aggregate: Gig_Faqs_Aggregate;
  /** fetch data from the table: "gig_faqs" using primary key columns */
  gig_faqs_by_pk?: Maybe<Gig_Faqs>;
  /** fetch data from the table: "gig_promos" */
  gig_promos: Array<Gig_Promos>;
  /** fetch aggregated fields from the table: "gig_promos" */
  gig_promos_aggregate: Gig_Promos_Aggregate;
  /** fetch data from the table: "gig_promos" using primary key columns */
  gig_promos_by_pk?: Maybe<Gig_Promos>;
  /** fetch data from the table: "gig_variants" */
  gig_variants: Array<Gig_Variants>;
  /** fetch aggregated fields from the table: "gig_variants" */
  gig_variants_aggregate: Gig_Variants_Aggregate;
  /** fetch data from the table: "gig_variants" using primary key columns */
  gig_variants_by_pk?: Maybe<Gig_Variants>;
  /** fetch data from the table: "gigs" */
  gigs: Array<Gigs>;
  /** fetch aggregated fields from the table: "gigs" */
  gigs_aggregate: Gigs_Aggregate;
  /** fetch data from the table: "gigs" using primary key columns */
  gigs_by_pk?: Maybe<Gigs>;
  /** fetch data from the table: "gis.districts" */
  gis_districts: Array<Gis_Districts>;
  /** fetch aggregated fields from the table: "gis.districts" */
  gis_districts_aggregate: Gis_Districts_Aggregate;
  /** fetch data from the table: "gis.districts" using primary key columns */
  gis_districts_by_pk?: Maybe<Gis_Districts>;
  /** fetch data from the table: "gis.states" */
  gis_states: Array<Gis_States>;
  /** fetch aggregated fields from the table: "gis.states" */
  gis_states_aggregate: Gis_States_Aggregate;
  /** fetch data from the table: "gis.states" using primary key columns */
  gis_states_by_pk?: Maybe<Gis_States>;
  globalStats: GlobalStatsResponse;
  hub_?: Maybe<Hub_Query>;
  inventory: InventoryListResponse;
  kYCStatus?: Maybe<KycTransaction>;
  /** An array relationship */
  last_known_locations: Array<Last_Known_Locations>;
  /** An aggregate relationship */
  last_known_locations_aggregate: Last_Known_Locations_Aggregate;
  /** fetch data from the table: "last_known_locations" using primary key columns */
  last_known_locations_by_pk?: Maybe<Last_Known_Locations>;
  /** fetch data from the table: "master_crops" */
  master_crops: Array<Master_Crops>;
  /** fetch aggregated fields from the table: "master_crops" */
  master_crops_aggregate: Master_Crops_Aggregate;
  /** fetch data from the table: "master_crops" using primary key columns */
  master_crops_by_pk?: Maybe<Master_Crops>;
  /** fetch data from the table: "master_segments" */
  master_segments: Array<Master_Segments>;
  /** fetch aggregated fields from the table: "master_segments" */
  master_segments_aggregate: Master_Segments_Aggregate;
  /** fetch data from the table: "master_segments" using primary key columns */
  master_segments_by_pk?: Maybe<Master_Segments>;
  me: User;
  /** fetch data from the table: "messaging_campaign_recipients" */
  messaging_campaign_recipients: Array<Messaging_Campaign_Recipients>;
  /** fetch aggregated fields from the table: "messaging_campaign_recipients" */
  messaging_campaign_recipients_aggregate: Messaging_Campaign_Recipients_Aggregate;
  /** fetch data from the table: "messaging_campaign_recipients" using primary key columns */
  messaging_campaign_recipients_by_pk?: Maybe<Messaging_Campaign_Recipients>;
  /** fetch data from the table: "messaging_campaign_segments" */
  messaging_campaign_segments: Array<Messaging_Campaign_Segments>;
  /** fetch aggregated fields from the table: "messaging_campaign_segments" */
  messaging_campaign_segments_aggregate: Messaging_Campaign_Segments_Aggregate;
  /** fetch data from the table: "messaging_campaign_segments" using primary key columns */
  messaging_campaign_segments_by_pk?: Maybe<Messaging_Campaign_Segments>;
  /** fetch data from the table: "messaging_campaigns" */
  messaging_campaigns: Array<Messaging_Campaigns>;
  /** fetch aggregated fields from the table: "messaging_campaigns" */
  messaging_campaigns_aggregate: Messaging_Campaigns_Aggregate;
  /** fetch data from the table: "messaging_campaigns" using primary key columns */
  messaging_campaigns_by_pk?: Maybe<Messaging_Campaigns>;
  /** fetch data from the table: "messaging_templates" */
  messaging_templates: Array<Messaging_Templates>;
  /** fetch aggregated fields from the table: "messaging_templates" */
  messaging_templates_aggregate: Messaging_Templates_Aggregate;
  /** fetch data from the table: "messaging_templates" using primary key columns */
  messaging_templates_by_pk?: Maybe<Messaging_Templates>;
  /** fetch data from the table: "migrations" */
  migrations: Array<Migrations>;
  /** fetch aggregated fields from the table: "migrations" */
  migrations_aggregate: Migrations_Aggregate;
  /** fetch data from the table: "migrations" using primary key columns */
  migrations_by_pk?: Maybe<Migrations>;
  /** fetch data from the table: "missed_call_number_pool" */
  missed_call_number_pool: Array<Missed_Call_Number_Pool>;
  /** fetch aggregated fields from the table: "missed_call_number_pool" */
  missed_call_number_pool_aggregate: Missed_Call_Number_Pool_Aggregate;
  /** fetch data from the table: "missed_call_number_pool" using primary key columns */
  missed_call_number_pool_by_pk?: Maybe<Missed_Call_Number_Pool>;
  /** fetch data from the table: "missed_calls" */
  missed_calls: Array<Missed_Calls>;
  /** fetch aggregated fields from the table: "missed_calls" */
  missed_calls_aggregate: Missed_Calls_Aggregate;
  /** fetch data from the table: "missed_calls" using primary key columns */
  missed_calls_by_pk?: Maybe<Missed_Calls>;
  /** An array relationship */
  model_has_permissions: Array<Model_Has_Permissions>;
  /** An aggregate relationship */
  model_has_permissions_aggregate: Model_Has_Permissions_Aggregate;
  /** fetch data from the table: "model_has_permissions" using primary key columns */
  model_has_permissions_by_pk?: Maybe<Model_Has_Permissions>;
  /** An array relationship */
  model_has_roles: Array<Model_Has_Roles>;
  /** An aggregate relationship */
  model_has_roles_aggregate: Model_Has_Roles_Aggregate;
  /** fetch data from the table: "model_has_roles" using primary key columns */
  model_has_roles_by_pk?: Maybe<Model_Has_Roles>;
  myRedemptions: Array<Redemption>;
  myReportingHierarchy: PfUser;
  myWarehouses?: Maybe<Array<Maybe<Warehouse>>>;
  /** fetch data from the table: "notifications" */
  notifications: Array<Notifications>;
  /** fetch aggregated fields from the table: "notifications" */
  notifications_aggregate: Notifications_Aggregate;
  /** fetch data from the table: "notifications" using primary key columns */
  notifications_by_pk?: Maybe<Notifications>;
  /** fetch data from the table: "nova_field_attachments" */
  nova_field_attachments: Array<Nova_Field_Attachments>;
  /** fetch aggregated fields from the table: "nova_field_attachments" */
  nova_field_attachments_aggregate: Nova_Field_Attachments_Aggregate;
  /** fetch data from the table: "nova_field_attachments" using primary key columns */
  nova_field_attachments_by_pk?: Maybe<Nova_Field_Attachments>;
  /** fetch data from the table: "nova_notifications" */
  nova_notifications: Array<Nova_Notifications>;
  /** fetch aggregated fields from the table: "nova_notifications" */
  nova_notifications_aggregate: Nova_Notifications_Aggregate;
  /** fetch data from the table: "nova_notifications" using primary key columns */
  nova_notifications_by_pk?: Maybe<Nova_Notifications>;
  /** fetch data from the table: "nova_pending_field_attachments" */
  nova_pending_field_attachments: Array<Nova_Pending_Field_Attachments>;
  /** fetch aggregated fields from the table: "nova_pending_field_attachments" */
  nova_pending_field_attachments_aggregate: Nova_Pending_Field_Attachments_Aggregate;
  /** fetch data from the table: "nova_pending_field_attachments" using primary key columns */
  nova_pending_field_attachments_by_pk?: Maybe<Nova_Pending_Field_Attachments>;
  /** fetch data from the table: "nova_twofa" */
  nova_twofa: Array<Nova_Twofa>;
  /** fetch aggregated fields from the table: "nova_twofa" */
  nova_twofa_aggregate: Nova_Twofa_Aggregate;
  /** fetch data from the table: "nova_twofa" using primary key columns */
  nova_twofa_by_pk?: Maybe<Nova_Twofa>;
  /** fetch data from the table: "pairing_codes" */
  pairing_codes: Array<Pairing_Codes>;
  /** fetch aggregated fields from the table: "pairing_codes" */
  pairing_codes_aggregate: Pairing_Codes_Aggregate;
  /** fetch data from the table: "pairing_codes" using primary key columns */
  pairing_codes_by_pk?: Maybe<Pairing_Codes>;
  /** fetch data from the table: "password_reset_tokens" */
  password_reset_tokens: Array<Password_Reset_Tokens>;
  /** fetch aggregated fields from the table: "password_reset_tokens" */
  password_reset_tokens_aggregate: Password_Reset_Tokens_Aggregate;
  /** fetch data from the table: "password_reset_tokens" using primary key columns */
  password_reset_tokens_by_pk?: Maybe<Password_Reset_Tokens>;
  /** fetch data from the table: "permissions" */
  permissions: Array<Permissions>;
  /** fetch aggregated fields from the table: "permissions" */
  permissions_aggregate: Permissions_Aggregate;
  /** fetch data from the table: "permissions" using primary key columns */
  permissions_by_pk?: Maybe<Permissions>;
  /** fetch data from the table: "personal_access_tokens" */
  personal_access_tokens: Array<Personal_Access_Tokens>;
  /** fetch aggregated fields from the table: "personal_access_tokens" */
  personal_access_tokens_aggregate: Personal_Access_Tokens_Aggregate;
  /** fetch data from the table: "personal_access_tokens" using primary key columns */
  personal_access_tokens_by_pk?: Maybe<Personal_Access_Tokens>;
  /** fetch data from the table: "personal_dashboard" */
  personal_dashboard: Array<Personal_Dashboard>;
  /** fetch aggregated fields from the table: "personal_dashboard" */
  personal_dashboard_aggregate: Personal_Dashboard_Aggregate;
  /** fetch data from the table: "personal_dashboard" using primary key columns */
  personal_dashboard_by_pk?: Maybe<Personal_Dashboard>;
  personalizedReelRecommendations: GetRecommendationResponse;
  /** fetch data from the table: "runpando_pro.crops" */
  pf_fcm_crops: Array<Pf_Fcm_Crops>;
  /** fetch aggregated fields from the table: "runpando_pro.crops" */
  pf_fcm_crops_aggregate: Pf_Fcm_Crops_Aggregate;
  /** fetch data from the table: "runpando_pro.crops" using primary key columns */
  pf_fcm_crops_by_pk?: Maybe<Pf_Fcm_Crops>;
  /** fetch data from the table: "runpando_pro.products" */
  pf_fcm_products: Array<Pf_Fcm_Products>;
  /** fetch aggregated fields from the table: "runpando_pro.products" */
  pf_fcm_products_aggregate: Pf_Fcm_Products_Aggregate;
  /** fetch data from the table: "runpando_pro.products" using primary key columns */
  pf_fcm_products_by_pk?: Maybe<Pf_Fcm_Products>;
  /** fetch data from the table: "runpando_pro.plan_cards" */
  pf_plan_cards: Array<Pf_Plan_Cards>;
  pf_plan_cards_aggregate: Pf_Plan_Cards_Aggregate;
  /** fetch data from the table: "runpando_pro.plan_cards" using primary key columns */
  pf_plan_cards_by_pk?: Maybe<Pf_Plan_Cards>;
  /** fetch data from the table: "runpando_pro.products" */
  pf_products: Array<Pf_Products>;
  /** fetch aggregated fields from the table: "runpando_pro.products" */
  pf_products_aggregate: Pf_Products_Aggregate;
  /** fetch data from the table: "runpando_pro.products" using primary key columns */
  pf_products_by_pk?: Maybe<Pf_Products>;
  /** fetch data from the table: "runpando_pro.activity_coins_feedback" */
  pf_runpando_pro_activity_coins_feedback: Array<Pf_Runpando_Pro_Activity_Coins_Feedback>;
  /** fetch aggregated fields from the table: "runpando_pro.activity_coins_feedback" */
  pf_runpando_pro_activity_coins_feedback_aggregate: Pf_Runpando_Pro_Activity_Coins_Feedback_Aggregate;
  /** fetch data from the table: "runpando_pro.activity_coins_feedback" using primary key columns */
  pf_runpando_pro_activity_coins_feedback_by_pk?: Maybe<Pf_Runpando_Pro_Activity_Coins_Feedback>;
  /** fetch data from the table: "runpando_pro.all_state_data" */
  pf_runpando_pro_all_state_data: Array<Pf_Runpando_Pro_All_State_Data>;
  /** fetch aggregated fields from the table: "runpando_pro.all_state_data" */
  pf_runpando_pro_all_state_data_aggregate: Pf_Runpando_Pro_All_State_Data_Aggregate;
  /** fetch data from the table: "runpando_pro.all_state_data" using primary key columns */
  pf_runpando_pro_all_state_data_by_pk?: Maybe<Pf_Runpando_Pro_All_State_Data>;
  /** fetch data from the table: "runpando_pro.campaign_card_activities" */
  pf_runpando_pro_campaign_card_activities: Array<Pf_Runpando_Pro_Campaign_Card_Activities>;
  /** fetch aggregated fields from the table: "runpando_pro.campaign_card_activities" */
  pf_runpando_pro_campaign_card_activities_aggregate: Pf_Runpando_Pro_Campaign_Card_Activities_Aggregate;
  /** fetch data from the table: "runpando_pro.campaign_card_activities" using primary key columns */
  pf_runpando_pro_campaign_card_activities_by_pk?: Maybe<Pf_Runpando_Pro_Campaign_Card_Activities>;
  /** fetch data from the table: "runpando_pro.channel_card_images" */
  pf_runpando_pro_channel_card_images: Array<Pf_Runpando_Pro_Channel_Card_Images>;
  /** fetch aggregated fields from the table: "runpando_pro.channel_card_images" */
  pf_runpando_pro_channel_card_images_aggregate: Pf_Runpando_Pro_Channel_Card_Images_Aggregate;
  /** fetch data from the table: "runpando_pro.channel_card_images" using primary key columns */
  pf_runpando_pro_channel_card_images_by_pk?: Maybe<Pf_Runpando_Pro_Channel_Card_Images>;
  /** fetch data from the table: "runpando_pro.users_locations" */
  pf_runpando_pro_users_locations: Array<Pf_Runpando_Pro_Users_Locations>;
  /** fetch aggregated fields from the table: "runpando_pro.users_locations" */
  pf_runpando_pro_users_locations_aggregate: Pf_Runpando_Pro_Users_Locations_Aggregate;
  /** fetch data from the table: "runpando_pro.users_locations" using primary key columns */
  pf_runpando_pro_users_locations_by_pk?: Maybe<Pf_Runpando_Pro_Users_Locations>;
  /** fetch data from the table: "runpando_pro.user_travellog" */
  pf_user_travellog: Array<Pf_User_Travellog>;
  /** fetch aggregated fields from the table: "runpando_pro.user_travellog" */
  pf_user_travellog_aggregate: Pf_User_Travellog_Aggregate;
  /** fetch data from the table: "runpando_pro.user_travellog" using primary key columns */
  pf_user_travellog_by_pk?: Maybe<Pf_User_Travellog>;
  /** fetch data from the table: "runpando_pro.users" */
  pf_users: Array<Pf_Users>;
  /** fetch aggregated fields from the table: "runpando_pro.users" */
  pf_users_aggregate: Pf_Users_Aggregate;
  /** fetch data from the table: "runpando_pro.users" using primary key columns */
  pf_users_by_pk?: Maybe<Pf_Users>;
  product?: Maybe<SaleProduct>;
  productBySku?: Maybe<SaleProduct>;
  productPop?: Maybe<ProductPop>;
  productPops?: Maybe<Scalars['JSON']['output']>;
  /** fetch data from the table: "product_pop_media" */
  product_pop_media: Array<Product_Pop_Media>;
  /** fetch aggregated fields from the table: "product_pop_media" */
  product_pop_media_aggregate: Product_Pop_Media_Aggregate;
  /** fetch data from the table: "product_pop_media" using primary key columns */
  product_pop_media_by_pk?: Maybe<Product_Pop_Media>;
  /** fetch data from the table: "product_pops" */
  product_pops: Array<Product_Pops>;
  /** fetch aggregated fields from the table: "product_pops" */
  product_pops_aggregate: Product_Pops_Aggregate;
  /** fetch data from the table: "product_pops" using primary key columns */
  product_pops_by_pk?: Maybe<Product_Pops>;
  products?: Maybe<Array<Maybe<Product>>>;
  /** fetch data from the table: "prospect_crops" */
  prospect_crops: Array<Prospect_Crops>;
  /** fetch aggregated fields from the table: "prospect_crops" */
  prospect_crops_aggregate: Prospect_Crops_Aggregate;
  /** fetch data from the table: "prospect_crops" using primary key columns */
  prospect_crops_by_pk?: Maybe<Prospect_Crops>;
  /** fetch data from the table: "prospect_messages" */
  prospect_messages: Array<Prospect_Messages>;
  /** fetch aggregated fields from the table: "prospect_messages" */
  prospect_messages_aggregate: Prospect_Messages_Aggregate;
  /** fetch data from the table: "prospect_messages" using primary key columns */
  prospect_messages_by_pk?: Maybe<Prospect_Messages>;
  /** fetch data from the table: "prospect_user" */
  prospect_user: Array<Prospect_User>;
  /** fetch aggregated fields from the table: "prospect_user" */
  prospect_user_aggregate: Prospect_User_Aggregate;
  /** fetch data from the table: "prospect_user" using primary key columns */
  prospect_user_by_pk?: Maybe<Prospect_User>;
  /** fetch data from the table: "prospects" */
  prospects: Array<Prospects>;
  /** fetch aggregated fields from the table: "prospects" */
  prospects_aggregate: Prospects_Aggregate;
  /** fetch data from the table: "prospects" using primary key columns */
  prospects_by_pk?: Maybe<Prospects>;
  /** fetch data from the table: "reel_category" */
  reel_category: Array<Reel_Category>;
  /** fetch aggregated fields from the table: "reel_category" */
  reel_category_aggregate: Reel_Category_Aggregate;
  /** fetch data from the table: "reel_category" using primary key columns */
  reel_category_by_pk?: Maybe<Reel_Category>;
  /** An array relationship */
  reel_comments: Array<Reel_Comments>;
  /** An aggregate relationship */
  reel_comments_aggregate: Reel_Comments_Aggregate;
  /** fetch data from the table: "reel_comments" using primary key columns */
  reel_comments_by_pk?: Maybe<Reel_Comments>;
  /** fetch data from the table: "reel_interactions" */
  reel_interactions: Array<Reel_Interactions>;
  /** fetch aggregated fields from the table: "reel_interactions" */
  reel_interactions_aggregate: Reel_Interactions_Aggregate;
  /** fetch data from the table: "reel_interactions" using primary key columns */
  reel_interactions_by_pk?: Maybe<Reel_Interactions>;
  /** fetch data from the table: "reel_stats" */
  reel_stats: Array<Reel_Stats>;
  /** fetch aggregated fields from the table: "reel_stats" */
  reel_stats_aggregate: Reel_Stats_Aggregate;
  /** fetch data from the table: "reel_stats" using primary key columns */
  reel_stats_by_pk?: Maybe<Reel_Stats>;
  /** fetch data from the table: "reel_user_reports" */
  reel_user_reports: Array<Reel_User_Reports>;
  /** fetch aggregated fields from the table: "reel_user_reports" */
  reel_user_reports_aggregate: Reel_User_Reports_Aggregate;
  /** fetch data from the table: "reel_user_reports" using primary key columns */
  reel_user_reports_by_pk?: Maybe<Reel_User_Reports>;
  /** An array relationship */
  reels: Array<Reels>;
  /** An aggregate relationship */
  reels_aggregate: Reels_Aggregate;
  /** fetch data from the table: "reels" using primary key columns */
  reels_by_pk?: Maybe<Reels>;
  /** fetch data from the table: "reels_with_distance" */
  reels_with_distance: Array<Reels_With_Distance>;
  /** fetch aggregated fields from the table: "reels_with_distance" */
  reels_with_distance_aggregate: Reels_With_Distance_Aggregate;
  /** fetch data from the table: "retailer_establishments" */
  retailer_establishments: Array<Retailer_Establishments>;
  /** fetch aggregated fields from the table: "retailer_establishments" */
  retailer_establishments_aggregate: Retailer_Establishments_Aggregate;
  /** fetch data from the table: "retailer_establishments" using primary key columns */
  retailer_establishments_by_pk?: Maybe<Retailer_Establishments>;
  /** fetch data from the table: "retailers" */
  retailers: Array<Retailers>;
  /** fetch aggregated fields from the table: "retailers" */
  retailers_aggregate: Retailers_Aggregate;
  /** fetch data from the table: "retailers" using primary key columns */
  retailers_by_pk?: Maybe<Retailers>;
  /** An array relationship */
  role_has_permissions: Array<Role_Has_Permissions>;
  /** An aggregate relationship */
  role_has_permissions_aggregate: Role_Has_Permissions_Aggregate;
  /** fetch data from the table: "role_has_permissions" using primary key columns */
  role_has_permissions_by_pk?: Maybe<Role_Has_Permissions>;
  /** fetch data from the table: "roles" */
  roles: Array<Roles>;
  /** fetch aggregated fields from the table: "roles" */
  roles_aggregate: Roles_Aggregate;
  /** fetch data from the table: "roles" using primary key columns */
  roles_by_pk?: Maybe<Roles>;
  /** fetch data from the table: "runpando_pro.all_state_data" */
  runpando_pro_all_state_data: Array<Runpando_Pro_All_State_Data>;
  /** fetch aggregated fields from the table: "runpando_pro.all_state_data" */
  runpando_pro_all_state_data_aggregate: Runpando_Pro_All_State_Data_Aggregate;
  /** fetch data from the table: "runpando_pro.all_state_data" using primary key columns */
  runpando_pro_all_state_data_by_pk?: Maybe<Runpando_Pro_All_State_Data>;
  /** fetch data from the table: "runpando_pro.users" */
  runpando_pro_users: Array<Runpando_Pro_Users>;
  /** fetch aggregated fields from the table: "runpando_pro.users" */
  runpando_pro_users_aggregate: Runpando_Pro_Users_Aggregate;
  /** fetch data from the table: "runpando_pro.users" using primary key columns */
  runpando_pro_users_by_pk?: Maybe<Runpando_Pro_Users>;
  /** fetch data from the table: "runpando_pro.users_locations" */
  runpando_pro_users_locations: Array<Runpando_Pro_Users_Locations>;
  /** fetch aggregated fields from the table: "runpando_pro.users_locations" */
  runpando_pro_users_locations_aggregate: Runpando_Pro_Users_Locations_Aggregate;
  /** fetch data from the table: "runpando_pro.users_locations" using primary key columns */
  runpando_pro_users_locations_by_pk?: Maybe<Runpando_Pro_Users_Locations>;
  /** An array relationship */
  sale_items: Array<Sale_Items>;
  /** An aggregate relationship */
  sale_items_aggregate: Sale_Items_Aggregate;
  /** fetch data from the table: "sale_items" using primary key columns */
  sale_items_by_pk?: Maybe<Sale_Items>;
  /** fetch data from the table: "sale_payments" */
  sale_payments: Array<Sale_Payments>;
  /** fetch aggregated fields from the table: "sale_payments" */
  sale_payments_aggregate: Sale_Payments_Aggregate;
  /** fetch data from the table: "sale_payments" using primary key columns */
  sale_payments_by_pk?: Maybe<Sale_Payments>;
  /** fetch data from the table: "sale_proof_events" */
  sale_proof_events: Array<Sale_Proof_Events>;
  /** fetch aggregated fields from the table: "sale_proof_events" */
  sale_proof_events_aggregate: Sale_Proof_Events_Aggregate;
  /** fetch data from the table: "sale_proof_events" using primary key columns */
  sale_proof_events_by_pk?: Maybe<Sale_Proof_Events>;
  /** fetch data from the table: "sale_proof_types" */
  sale_proof_types: Array<Sale_Proof_Types>;
  /** fetch aggregated fields from the table: "sale_proof_types" */
  sale_proof_types_aggregate: Sale_Proof_Types_Aggregate;
  /** fetch data from the table: "sale_proof_types" using primary key columns */
  sale_proof_types_by_pk?: Maybe<Sale_Proof_Types>;
  /** An array relationship */
  sale_proofs: Array<Sale_Proofs>;
  /** An aggregate relationship */
  sale_proofs_aggregate: Sale_Proofs_Aggregate;
  /** fetch data from the table: "sale_proofs" using primary key columns */
  sale_proofs_by_pk?: Maybe<Sale_Proofs>;
  /** fetch data from the table: "sales" */
  sales: Array<Sales>;
  /** fetch aggregated fields from the table: "sales" */
  sales_aggregate: Sales_Aggregate;
  /** fetch data from the table: "sales" using primary key columns */
  sales_by_pk?: Maybe<Sales>;
  /** fetch data from the table: "saved_reels" */
  saved_reels: Array<Saved_Reels>;
  /** fetch aggregated fields from the table: "saved_reels" */
  saved_reels_aggregate: Saved_Reels_Aggregate;
  /** fetch data from the table: "saved_reels" using primary key columns */
  saved_reels_by_pk?: Maybe<Saved_Reels>;
  searchCRMItems: CrmItemWithDataPaginatedResponse;
  searchChatThreadMessages: Array<ChatMessage>;
  /** execute function "search_field_force_near_farmer" which returns "last_known_locations" */
  search_field_force_near_farmer: Array<Last_Known_Locations>;
  /** execute function "search_field_force_near_farmer" and query aggregates on result of table type "last_known_locations" */
  search_field_force_near_farmer_aggregate: Last_Known_Locations_Aggregate;
  /** fetch data from the table: "segment_user" */
  segment_user: Array<Segment_User>;
  /** fetch aggregated fields from the table: "segment_user" */
  segment_user_aggregate: Segment_User_Aggregate;
  /** fetch data from the table: "segment_user" using primary key columns */
  segment_user_by_pk?: Maybe<Segment_User>;
  /** fetch data from the table: "service_request_dashboard" */
  service_request_dashboard: Array<Service_Request_Dashboard>;
  /** fetch aggregated fields from the table: "service_request_dashboard" */
  service_request_dashboard_aggregate: Service_Request_Dashboard_Aggregate;
  /** fetch data from the table: "service_request_dashboard" using primary key columns */
  service_request_dashboard_by_pk?: Maybe<Service_Request_Dashboard>;
  /** An array relationship */
  service_request_recommendations: Array<Service_Request_Recommendations>;
  /** An aggregate relationship */
  service_request_recommendations_aggregate: Service_Request_Recommendations_Aggregate;
  /** fetch data from the table: "service_request_recommendations" using primary key columns */
  service_request_recommendations_by_pk?: Maybe<Service_Request_Recommendations>;
  /** fetch data from the table: "service_request_retailer" */
  service_request_retailer: Array<Service_Request_Retailer>;
  /** fetch aggregated fields from the table: "service_request_retailer" */
  service_request_retailer_aggregate: Service_Request_Retailer_Aggregate;
  /** fetch data from the table: "service_request_retailer" using primary key columns */
  service_request_retailer_by_pk?: Maybe<Service_Request_Retailer>;
  /** An array relationship */
  service_requests: Array<Service_Requests>;
  /** An aggregate relationship */
  service_requests_aggregate: Service_Requests_Aggregate;
  /** fetch data from the table: "service_requests" using primary key columns */
  service_requests_by_pk?: Maybe<Service_Requests>;
  /** fetch data from the table: "snapshots" */
  snapshots: Array<Snapshots>;
  /** fetch aggregated fields from the table: "snapshots" */
  snapshots_aggregate: Snapshots_Aggregate;
  /** fetch data from the table: "snapshots" using primary key columns */
  snapshots_by_pk?: Maybe<Snapshots>;
  /** fetch data from the table: "spatial_ref_sys" */
  spatial_ref_sys: Array<Spatial_Ref_Sys>;
  /** fetch aggregated fields from the table: "spatial_ref_sys" */
  spatial_ref_sys_aggregate: Spatial_Ref_Sys_Aggregate;
  /** fetch data from the table: "spatial_ref_sys" using primary key columns */
  spatial_ref_sys_by_pk?: Maybe<Spatial_Ref_Sys>;
  stateLangFromLocation: GetStateLangQueryResponse;
  /** fetch data from the table: "stored_events" */
  stored_events: Array<Stored_Events>;
  /** fetch aggregated fields from the table: "stored_events" */
  stored_events_aggregate: Stored_Events_Aggregate;
  /** fetch data from the table: "stored_events" using primary key columns */
  stored_events_by_pk?: Maybe<Stored_Events>;
  /** fetch data from the table: "taggables" */
  taggables: Array<Taggables>;
  /** fetch aggregated fields from the table: "taggables" */
  taggables_aggregate: Taggables_Aggregate;
  /** fetch data from the table: "taggables" using primary key columns */
  taggables_by_pk?: Maybe<Taggables>;
  /** fetch data from the table: "tags" */
  tags: Array<Tags>;
  /** fetch aggregated fields from the table: "tags" */
  tags_aggregate: Tags_Aggregate;
  /** fetch data from the table: "tags" using primary key columns */
  tags_by_pk?: Maybe<Tags>;
  threadsByIds: Array<ChatThread>;
  /** Returns the users wallet balance */
  userBalances: GetUserBalanceResponse;
  userChatThreads: Array<ChatThread>;
  /** fetch data from the table: "user_device" */
  user_device: Array<User_Device>;
  /** fetch aggregated fields from the table: "user_device" */
  user_device_aggregate: User_Device_Aggregate;
  /** fetch data from the table: "user_device" using primary key columns */
  user_device_by_pk?: Maybe<User_Device>;
  /** An array relationship */
  user_feedbacks: Array<User_Feedbacks>;
  /** An aggregate relationship */
  user_feedbacks_aggregate: User_Feedbacks_Aggregate;
  /** fetch data from the table: "user_feedbacks" using primary key columns */
  user_feedbacks_by_pk?: Maybe<User_Feedbacks>;
  /** fetch data from the table: "user_follows_channel" */
  user_follows_channel: Array<User_Follows_Channel>;
  /** fetch aggregated fields from the table: "user_follows_channel" */
  user_follows_channel_aggregate: User_Follows_Channel_Aggregate;
  /** fetch data from the table: "user_follows_channel" using primary key columns */
  user_follows_channel_by_pk?: Maybe<User_Follows_Channel>;
  /** An array relationship */
  user_location_logs: Array<User_Location_Logs>;
  /** An aggregate relationship */
  user_location_logs_aggregate: User_Location_Logs_Aggregate;
  /** fetch data from the table: "user_location_logs" using primary key columns */
  user_location_logs_by_pk?: Maybe<User_Location_Logs>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table: "wallets" */
  wallets: Array<Wallets>;
  /** fetch aggregated fields from the table: "wallets" */
  wallets_aggregate: Wallets_Aggregate;
  /** fetch data from the table: "wallets" using primary key columns */
  wallets_by_pk?: Maybe<Wallets>;
  warehouse?: Maybe<Warehouse>;
  warehouses?: Maybe<Array<Maybe<Warehouse>>>;
  warehousesNearLocation?: Maybe<Array<Maybe<Warehouse>>>;
  /** fetch data from the table: "whatsauth_logins" */
  whatsauth_logins: Array<Whatsauth_Logins>;
  /** fetch aggregated fields from the table: "whatsauth_logins" */
  whatsauth_logins_aggregate: Whatsauth_Logins_Aggregate;
  /** fetch data from the table: "whatsauth_logins" using primary key columns */
  whatsauth_logins_by_pk?: Maybe<Whatsauth_Logins>;
  /** fetch data from the table: "work_order_checklist_items" */
  work_order_checklist_items: Array<Work_Order_Checklist_Items>;
  /** fetch aggregated fields from the table: "work_order_checklist_items" */
  work_order_checklist_items_aggregate: Work_Order_Checklist_Items_Aggregate;
  /** fetch data from the table: "work_order_checklist_items" using primary key columns */
  work_order_checklist_items_by_pk?: Maybe<Work_Order_Checklist_Items>;
  /** fetch data from the table: "work_order_messages" */
  work_order_messages: Array<Work_Order_Messages>;
  /** fetch aggregated fields from the table: "work_order_messages" */
  work_order_messages_aggregate: Work_Order_Messages_Aggregate;
  /** fetch data from the table: "work_order_messages" using primary key columns */
  work_order_messages_by_pk?: Maybe<Work_Order_Messages>;
  /** fetch data from the table: "work_order_outputs" */
  work_order_outputs: Array<Work_Order_Outputs>;
  /** fetch aggregated fields from the table: "work_order_outputs" */
  work_order_outputs_aggregate: Work_Order_Outputs_Aggregate;
  /** fetch data from the table: "work_order_outputs" using primary key columns */
  work_order_outputs_by_pk?: Maybe<Work_Order_Outputs>;
  /** fetch data from the table: "work_order_requests" */
  work_order_requests: Array<Work_Order_Requests>;
  /** fetch aggregated fields from the table: "work_order_requests" */
  work_order_requests_aggregate: Work_Order_Requests_Aggregate;
  /** fetch data from the table: "work_order_requests" using primary key columns */
  work_order_requests_by_pk?: Maybe<Work_Order_Requests>;
  /** fetch data from the table: "work_order_reviews" */
  work_order_reviews: Array<Work_Order_Reviews>;
  /** fetch aggregated fields from the table: "work_order_reviews" */
  work_order_reviews_aggregate: Work_Order_Reviews_Aggregate;
  /** fetch data from the table: "work_order_reviews" using primary key columns */
  work_order_reviews_by_pk?: Maybe<Work_Order_Reviews>;
  /** An array relationship */
  work_orders: Array<Work_Orders>;
  /** An aggregate relationship */
  work_orders_aggregate: Work_Orders_Aggregate;
  /** fetch data from the table: "work_orders" using primary key columns */
  work_orders_by_pk?: Maybe<Work_Orders>;
};


export type Query_RootAccountBalancesArgs = {
  accountId: Scalars['String']['input'];
};


export type Query_RootAccount_Auth_KeyArgs = {
  distinct_on?: InputMaybe<Array<Account_Auth_Key_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Auth_Key_Order_By>>;
  where?: InputMaybe<Account_Auth_Key_Bool_Exp>;
};


export type Query_RootAccount_Auth_Key_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Auth_Key_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Auth_Key_Order_By>>;
  where?: InputMaybe<Account_Auth_Key_Bool_Exp>;
};


export type Query_RootAccount_Auth_Key_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootAccount_CropArgs = {
  distinct_on?: InputMaybe<Array<Account_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Crop_Order_By>>;
  where?: InputMaybe<Account_Crop_Bool_Exp>;
};


export type Query_RootAccount_Crop_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Crop_Order_By>>;
  where?: InputMaybe<Account_Crop_Bool_Exp>;
};


export type Query_RootAccount_Crop_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootAccount_SegmentArgs = {
  distinct_on?: InputMaybe<Array<Account_Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Segment_Order_By>>;
  where?: InputMaybe<Account_Segment_Bool_Exp>;
};


export type Query_RootAccount_Segment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Segment_Order_By>>;
  where?: InputMaybe<Account_Segment_Bool_Exp>;
};


export type Query_RootAccount_Segment_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootAccount_UserArgs = {
  distinct_on?: InputMaybe<Array<Account_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_User_Order_By>>;
  where?: InputMaybe<Account_User_Bool_Exp>;
};


export type Query_RootAccount_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_User_Order_By>>;
  where?: InputMaybe<Account_User_Bool_Exp>;
};


export type Query_RootAccount_User_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootAccountsArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Accounts_Order_By>>;
  where?: InputMaybe<Accounts_Bool_Exp>;
};


export type Query_RootAccountsWiseCampaignSummaryArgs = {
  account_id: Scalars['String']['input'];
};


export type Query_RootAccounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Accounts_Order_By>>;
  where?: InputMaybe<Accounts_Bool_Exp>;
};


export type Query_RootAccounts_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootAction_EventsArgs = {
  distinct_on?: InputMaybe<Array<Action_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Events_Order_By>>;
  where?: InputMaybe<Action_Events_Bool_Exp>;
};


export type Query_RootAction_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Action_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Events_Order_By>>;
  where?: InputMaybe<Action_Events_Bool_Exp>;
};


export type Query_RootAction_Events_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootAvailableReelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ReelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type Query_RootBalancesArgs = {
  distinct_on?: InputMaybe<Array<Balances_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Balances_Order_By>>;
  where?: InputMaybe<Balances_Bool_Exp>;
};


export type Query_RootBalances_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Balances_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Balances_Order_By>>;
  where?: InputMaybe<Balances_Bool_Exp>;
};


export type Query_RootBalances_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootCRmItemsArgs = {
  accountId: Scalars['String']['input'];
  dir?: InputMaybe<Scalars['String']['input']>;
  filtersJson: Scalars['String']['input'];
  order_by?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type Query_RootCRmSchemaArgs = {
  accountId: Scalars['String']['input'];
};


export type Query_RootCampaignWiseSummaryArgs = {
  account_id: Scalars['String']['input'];
  campaign_id: Scalars['String']['input'];
};


export type Query_RootCategoriesArgs = {
  asTree?: InputMaybe<Scalars['Boolean']['input']>;
  hasProducts?: InputMaybe<Scalars['Boolean']['input']>;
  includeChildren?: InputMaybe<Scalars['Boolean']['input']>;
  includeProductCount?: InputMaybe<Scalars['Boolean']['input']>;
  includeProducts?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  maxDepth?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
};


export type Query_RootCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootCategoryTreeArgs = {
  maxDepth?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
};


export type Query_RootChannelAnalyticsArgs = {
  request: GetChannelAnalyticsRequestInput;
};


export type Query_RootChannel_LinksArgs = {
  distinct_on?: InputMaybe<Array<Channel_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Channel_Links_Order_By>>;
  where?: InputMaybe<Channel_Links_Bool_Exp>;
};


export type Query_RootChannel_Links_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Channel_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Channel_Links_Order_By>>;
  where?: InputMaybe<Channel_Links_Bool_Exp>;
};


export type Query_RootChannel_Links_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootChannelsArgs = {
  distinct_on?: InputMaybe<Array<Channels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Channels_Order_By>>;
  where?: InputMaybe<Channels_Bool_Exp>;
};


export type Query_RootChannels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Channels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Channels_Order_By>>;
  where?: InputMaybe<Channels_Bool_Exp>;
};


export type Query_RootChannels_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootChatThreadMessagesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  threadId: Scalars['String']['input'];
};


export type Query_RootChatThreadParticipantsArgs = {
  threadId: Scalars['String']['input'];
};


export type Query_RootChatUnreadCountArgs = {
  threadId: Scalars['String']['input'];
};


export type Query_RootChat_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Chat_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Messages_Order_By>>;
  where?: InputMaybe<Chat_Messages_Bool_Exp>;
};


export type Query_RootChat_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Messages_Order_By>>;
  where?: InputMaybe<Chat_Messages_Bool_Exp>;
};


export type Query_RootChat_Messages_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootChat_ParticipantsArgs = {
  distinct_on?: InputMaybe<Array<Chat_Participants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Participants_Order_By>>;
  where?: InputMaybe<Chat_Participants_Bool_Exp>;
};


export type Query_RootChat_Participants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Participants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Participants_Order_By>>;
  where?: InputMaybe<Chat_Participants_Bool_Exp>;
};


export type Query_RootChat_Participants_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootChat_ThreadsArgs = {
  distinct_on?: InputMaybe<Array<Chat_Threads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Threads_Order_By>>;
  where?: InputMaybe<Chat_Threads_Bool_Exp>;
};


export type Query_RootChat_Threads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Threads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Threads_Order_By>>;
  where?: InputMaybe<Chat_Threads_Bool_Exp>;
};


export type Query_RootChat_Threads_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootCheckStockAvailabilityArgs = {
  productId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
  warehouseIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Query_RootCompaniesArgs = {
  distinct_on?: InputMaybe<Array<Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Companies_Order_By>>;
  where?: InputMaybe<Companies_Bool_Exp>;
};


export type Query_RootCompanies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Companies_Order_By>>;
  where?: InputMaybe<Companies_Bool_Exp>;
};


export type Query_RootCompanies_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootCreator_OnboardingArgs = {
  distinct_on?: InputMaybe<Array<Creator_Onboarding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Creator_Onboarding_Order_By>>;
  where?: InputMaybe<Creator_Onboarding_Bool_Exp>;
};


export type Query_RootCreator_Onboarding_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Creator_Onboarding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Creator_Onboarding_Order_By>>;
  where?: InputMaybe<Creator_Onboarding_Bool_Exp>;
};


export type Query_RootCreator_Onboarding_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootCrm_Account_Channel_Crop_ProspectsArgs = {
  distinct_on?: InputMaybe<Array<Crm_Account_Channel_Crop_Prospects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Account_Channel_Crop_Prospects_Order_By>>;
  where?: InputMaybe<Crm_Account_Channel_Crop_Prospects_Bool_Exp>;
};


export type Query_RootCrm_Account_Channel_Crop_Prospects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crm_Account_Channel_Crop_Prospects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Account_Channel_Crop_Prospects_Order_By>>;
  where?: InputMaybe<Crm_Account_Channel_Crop_Prospects_Bool_Exp>;
};


export type Query_RootCrm_Account_Crop_Wise_CountsArgs = {
  distinct_on?: InputMaybe<Array<Crm_Account_Crop_Wise_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Account_Crop_Wise_Counts_Order_By>>;
  where?: InputMaybe<Crm_Account_Crop_Wise_Counts_Bool_Exp>;
};


export type Query_RootCrm_Account_Crop_Wise_Counts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crm_Account_Crop_Wise_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Account_Crop_Wise_Counts_Order_By>>;
  where?: InputMaybe<Crm_Account_Crop_Wise_Counts_Bool_Exp>;
};


export type Query_RootCrm_Account_Interaction_Type_Pending_CountsArgs = {
  distinct_on?: InputMaybe<Array<Crm_Account_Interaction_Type_Pending_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Account_Interaction_Type_Pending_Counts_Order_By>>;
  where?: InputMaybe<Crm_Account_Interaction_Type_Pending_Counts_Bool_Exp>;
};


export type Query_RootCrm_Account_Interaction_Type_Pending_Counts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crm_Account_Interaction_Type_Pending_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Account_Interaction_Type_Pending_Counts_Order_By>>;
  where?: InputMaybe<Crm_Account_Interaction_Type_Pending_Counts_Bool_Exp>;
};


export type Query_RootCrm_SegmentsArgs = {
  distinct_on?: InputMaybe<Array<Crm_Segments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Segments_Order_By>>;
  where?: InputMaybe<Crm_Segments_Bool_Exp>;
};


export type Query_RootCrm_Segments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crm_Segments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Segments_Order_By>>;
  where?: InputMaybe<Crm_Segments_Bool_Exp>;
};


export type Query_RootCrm_Segments_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootCrop_UserArgs = {
  distinct_on?: InputMaybe<Array<Crop_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crop_User_Order_By>>;
  where?: InputMaybe<Crop_User_Bool_Exp>;
};


export type Query_RootCrop_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crop_User_Order_By>>;
  where?: InputMaybe<Crop_User_Bool_Exp>;
};


export type Query_RootCrop_User_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootExtractPhoneNumbersFromImageArgs = {
  imageUrl: Scalars['String']['input'];
};


export type Query_RootFailed_JobsArgs = {
  distinct_on?: InputMaybe<Array<Failed_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Failed_Jobs_Order_By>>;
  where?: InputMaybe<Failed_Jobs_Bool_Exp>;
};


export type Query_RootFailed_Jobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Failed_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Failed_Jobs_Order_By>>;
  where?: InputMaybe<Failed_Jobs_Bool_Exp>;
};


export type Query_RootFailed_Jobs_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootFarmerAccountWiseStatusArgs = {
  accountId: Scalars['String']['input'];
  numbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Query_RootFarmerDetailArgs = {
  accountId: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};


export type Query_RootFarmerSearchOutPutArgs = {
  request: SearchFarmerRequestInput;
};


export type Query_RootFarmer_Account_LocationsArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Account_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Account_Locations_Order_By>>;
  where?: InputMaybe<Farmer_Account_Locations_Bool_Exp>;
};


export type Query_RootFarmer_Account_Locations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Account_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Account_Locations_Order_By>>;
  where?: InputMaybe<Farmer_Account_Locations_Bool_Exp>;
};


export type Query_RootFarmer_Account_Locations_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootFarmer_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Accounts_Order_By>>;
  where?: InputMaybe<Farmer_Accounts_Bool_Exp>;
};


export type Query_RootFarmer_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Accounts_Order_By>>;
  where?: InputMaybe<Farmer_Accounts_Bool_Exp>;
};


export type Query_RootFarmer_Accounts_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootFarmer_ActionsArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Actions_Order_By>>;
  where?: InputMaybe<Farmer_Actions_Bool_Exp>;
};


export type Query_RootFarmer_Actions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Actions_Order_By>>;
  where?: InputMaybe<Farmer_Actions_Bool_Exp>;
};


export type Query_RootFarmer_Actions_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootFarmer_FieldsArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Fields_Order_By>>;
  where?: InputMaybe<Farmer_Fields_Bool_Exp>;
};


export type Query_RootFarmer_Fields_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Fields_Order_By>>;
  where?: InputMaybe<Farmer_Fields_Bool_Exp>;
};


export type Query_RootFarmer_Fields_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootFarmer_Fields_LatestArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Fields_Latest_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Fields_Latest_Order_By>>;
  where?: InputMaybe<Farmer_Fields_Latest_Bool_Exp>;
};


export type Query_RootFarmer_Fields_Latest_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Fields_Latest_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Fields_Latest_Order_By>>;
  where?: InputMaybe<Farmer_Fields_Latest_Bool_Exp>;
};


export type Query_RootFarmer_MasterArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Master_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Master_Order_By>>;
  where?: InputMaybe<Farmer_Master_Bool_Exp>;
};


export type Query_RootFarmer_Master_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Master_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Master_Order_By>>;
  where?: InputMaybe<Farmer_Master_Bool_Exp>;
};


export type Query_RootFarmer_Master_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootFarmer_Nearby_Field_ForceArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Nearby_Field_Force_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Nearby_Field_Force_Order_By>>;
  where?: InputMaybe<Farmer_Nearby_Field_Force_Bool_Exp>;
};


export type Query_RootFarmer_Nearby_Field_Force_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Nearby_Field_Force_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Nearby_Field_Force_Order_By>>;
  where?: InputMaybe<Farmer_Nearby_Field_Force_Bool_Exp>;
};


export type Query_RootFarmer_Nearby_Field_Force_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootFarmer_PlotsArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Plots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Plots_Order_By>>;
  where?: InputMaybe<Farmer_Plots_Bool_Exp>;
};


export type Query_RootFarmer_Plots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Plots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Plots_Order_By>>;
  where?: InputMaybe<Farmer_Plots_Bool_Exp>;
};


export type Query_RootFarmer_Plots_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootFarminsta_LinksArgs = {
  distinct_on?: InputMaybe<Array<Farminsta_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farminsta_Links_Order_By>>;
  where?: InputMaybe<Farminsta_Links_Bool_Exp>;
};


export type Query_RootFarminsta_Links_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farminsta_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farminsta_Links_Order_By>>;
  where?: InputMaybe<Farminsta_Links_Bool_Exp>;
};


export type Query_RootFarminsta_Links_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootFeaturesArgs = {
  distinct_on?: InputMaybe<Array<Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Features_Order_By>>;
  where?: InputMaybe<Features_Bool_Exp>;
};


export type Query_RootFeatures_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Features_Order_By>>;
  where?: InputMaybe<Features_Bool_Exp>;
};


export type Query_RootFeatures_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootFich_Farminsta_Replica_Channel_AnalyticsArgs = {
  distinct_on?: InputMaybe<Array<Fich_Farminsta_Replica_Channel_Analytics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fich_Farminsta_Replica_Channel_Analytics_Order_By>>;
  where?: InputMaybe<Fich_Farminsta_Replica_Channel_Analytics_Bool_Exp>;
};


export type Query_RootFich_Farminsta_Replica_Channel_Analytics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fich_Farminsta_Replica_Channel_Analytics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fich_Farminsta_Replica_Channel_Analytics_Order_By>>;
  where?: InputMaybe<Fich_Farminsta_Replica_Channel_Analytics_Bool_Exp>;
};


export type Query_RootFich_Farminsta_Replica_LeadsArgs = {
  distinct_on?: InputMaybe<Array<Fich_Farminsta_Replica_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fich_Farminsta_Replica_Leads_Order_By>>;
  where?: InputMaybe<Fich_Farminsta_Replica_Leads_Bool_Exp>;
};


export type Query_RootFich_Farminsta_Replica_Leads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fich_Farminsta_Replica_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fich_Farminsta_Replica_Leads_Order_By>>;
  where?: InputMaybe<Fich_Farminsta_Replica_Leads_Bool_Exp>;
};


export type Query_RootFich_Farminsta_Replica_Reel_Lead_InfoArgs = {
  distinct_on?: InputMaybe<Array<Fich_Farminsta_Replica_Reel_Lead_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fich_Farminsta_Replica_Reel_Lead_Info_Order_By>>;
  where?: InputMaybe<Fich_Farminsta_Replica_Reel_Lead_Info_Bool_Exp>;
};


export type Query_RootFich_Farminsta_Replica_Reel_Lead_Info_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fich_Farminsta_Replica_Reel_Lead_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fich_Farminsta_Replica_Reel_Lead_Info_Order_By>>;
  where?: InputMaybe<Fich_Farminsta_Replica_Reel_Lead_Info_Bool_Exp>;
};


export type Query_RootFich_Farminsta_Replica_Reels_FlatArgs = {
  distinct_on?: InputMaybe<Array<Fich_Farminsta_Replica_Reels_Flat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fich_Farminsta_Replica_Reels_Flat_Order_By>>;
  where?: InputMaybe<Fich_Farminsta_Replica_Reels_Flat_Bool_Exp>;
};


export type Query_RootFich_Farminsta_Replica_Reels_Flat_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fich_Farminsta_Replica_Reels_Flat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fich_Farminsta_Replica_Reels_Flat_Order_By>>;
  where?: InputMaybe<Fich_Farminsta_Replica_Reels_Flat_Bool_Exp>;
};


export type Query_RootField_Partner_Response_EventsArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Response_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Response_Events_Order_By>>;
  where?: InputMaybe<Field_Partner_Response_Events_Bool_Exp>;
};


export type Query_RootField_Partner_Response_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Response_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Response_Events_Order_By>>;
  where?: InputMaybe<Field_Partner_Response_Events_Bool_Exp>;
};


export type Query_RootField_Partner_Response_Events_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootField_Partner_Response_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Response_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Response_Messages_Order_By>>;
  where?: InputMaybe<Field_Partner_Response_Messages_Bool_Exp>;
};


export type Query_RootField_Partner_Response_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Response_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Response_Messages_Order_By>>;
  where?: InputMaybe<Field_Partner_Response_Messages_Bool_Exp>;
};


export type Query_RootField_Partner_Response_Messages_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootField_Partner_ResponsesArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Responses_Order_By>>;
  where?: InputMaybe<Field_Partner_Responses_Bool_Exp>;
};


export type Query_RootField_Partner_Responses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Responses_Order_By>>;
  where?: InputMaybe<Field_Partner_Responses_Bool_Exp>;
};


export type Query_RootField_Partner_Responses_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootField_Scheduled_VisitsArgs = {
  distinct_on?: InputMaybe<Array<Field_Scheduled_Visits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Scheduled_Visits_Order_By>>;
  where?: InputMaybe<Field_Scheduled_Visits_Bool_Exp>;
};


export type Query_RootField_Scheduled_Visits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Scheduled_Visits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Scheduled_Visits_Order_By>>;
  where?: InputMaybe<Field_Scheduled_Visits_Bool_Exp>;
};


export type Query_RootField_Scheduled_Visits_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootFo_Reels_StagingArgs = {
  distinct_on?: InputMaybe<Array<Fo_Reels_Staging_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fo_Reels_Staging_Order_By>>;
  where?: InputMaybe<Fo_Reels_Staging_Bool_Exp>;
};


export type Query_RootFo_Reels_Staging_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fo_Reels_Staging_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fo_Reels_Staging_Order_By>>;
  where?: InputMaybe<Fo_Reels_Staging_Bool_Exp>;
};


export type Query_RootFo_Reels_Staging_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootFollowsArgs = {
  distinct_on?: InputMaybe<Array<Follows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Follows_Order_By>>;
  where?: InputMaybe<Follows_Bool_Exp>;
};


export type Query_RootFollows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Follows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Follows_Order_By>>;
  where?: InputMaybe<Follows_Bool_Exp>;
};


export type Query_RootFollows_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootGeography_ColumnsArgs = {
  distinct_on?: InputMaybe<Array<Geography_Columns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Geography_Columns_Order_By>>;
  where?: InputMaybe<Geography_Columns_Bool_Exp>;
};


export type Query_RootGeography_Columns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Geography_Columns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Geography_Columns_Order_By>>;
  where?: InputMaybe<Geography_Columns_Bool_Exp>;
};


export type Query_RootGeometry_ColumnsArgs = {
  distinct_on?: InputMaybe<Array<Geometry_Columns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Geometry_Columns_Order_By>>;
  where?: InputMaybe<Geometry_Columns_Bool_Exp>;
};


export type Query_RootGeometry_Columns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Geometry_Columns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Geometry_Columns_Order_By>>;
  where?: InputMaybe<Geometry_Columns_Bool_Exp>;
};


export type Query_RootGetReelRecommendationsArgs = {
  userId: Scalars['String']['input'];
};


export type Query_RootGetReelRecommendationsByChannelArgs = {
  channelIdString: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type Query_RootGet_Reel_With_RelatedArgs = {
  args: Get_Reel_With_Related_Args;
  distinct_on?: InputMaybe<Array<Reels_With_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reels_With_Distance_Order_By>>;
  where?: InputMaybe<Reels_With_Distance_Bool_Exp>;
};


export type Query_RootGet_Reel_With_Related_AggregateArgs = {
  args: Get_Reel_With_Related_Args;
  distinct_on?: InputMaybe<Array<Reels_With_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reels_With_Distance_Order_By>>;
  where?: InputMaybe<Reels_With_Distance_Bool_Exp>;
};


export type Query_RootGet_ReelsArgs = {
  args: Get_Reels_Args;
  distinct_on?: InputMaybe<Array<Reels_With_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reels_With_Distance_Order_By>>;
  where?: InputMaybe<Reels_With_Distance_Bool_Exp>;
};


export type Query_RootGet_Reels_AggregateArgs = {
  args: Get_Reels_Args;
  distinct_on?: InputMaybe<Array<Reels_With_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reels_With_Distance_Order_By>>;
  where?: InputMaybe<Reels_With_Distance_Bool_Exp>;
};


export type Query_RootGig_FaqsArgs = {
  distinct_on?: InputMaybe<Array<Gig_Faqs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gig_Faqs_Order_By>>;
  where?: InputMaybe<Gig_Faqs_Bool_Exp>;
};


export type Query_RootGig_Faqs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gig_Faqs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gig_Faqs_Order_By>>;
  where?: InputMaybe<Gig_Faqs_Bool_Exp>;
};


export type Query_RootGig_Faqs_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootGig_PromosArgs = {
  distinct_on?: InputMaybe<Array<Gig_Promos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gig_Promos_Order_By>>;
  where?: InputMaybe<Gig_Promos_Bool_Exp>;
};


export type Query_RootGig_Promos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gig_Promos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gig_Promos_Order_By>>;
  where?: InputMaybe<Gig_Promos_Bool_Exp>;
};


export type Query_RootGig_Promos_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootGig_VariantsArgs = {
  distinct_on?: InputMaybe<Array<Gig_Variants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gig_Variants_Order_By>>;
  where?: InputMaybe<Gig_Variants_Bool_Exp>;
};


export type Query_RootGig_Variants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gig_Variants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gig_Variants_Order_By>>;
  where?: InputMaybe<Gig_Variants_Bool_Exp>;
};


export type Query_RootGig_Variants_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootGigsArgs = {
  distinct_on?: InputMaybe<Array<Gigs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gigs_Order_By>>;
  where?: InputMaybe<Gigs_Bool_Exp>;
};


export type Query_RootGigs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gigs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gigs_Order_By>>;
  where?: InputMaybe<Gigs_Bool_Exp>;
};


export type Query_RootGigs_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootGis_DistrictsArgs = {
  distinct_on?: InputMaybe<Array<Gis_Districts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gis_Districts_Order_By>>;
  where?: InputMaybe<Gis_Districts_Bool_Exp>;
};


export type Query_RootGis_Districts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gis_Districts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gis_Districts_Order_By>>;
  where?: InputMaybe<Gis_Districts_Bool_Exp>;
};


export type Query_RootGis_Districts_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootGis_StatesArgs = {
  distinct_on?: InputMaybe<Array<Gis_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gis_States_Order_By>>;
  where?: InputMaybe<Gis_States_Bool_Exp>;
};


export type Query_RootGis_States_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gis_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gis_States_Order_By>>;
  where?: InputMaybe<Gis_States_Bool_Exp>;
};


export type Query_RootGis_States_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootGlobalStatsArgs = {
  accountId: Scalars['String']['input'];
};


export type Query_RootInventoryArgs = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  includeMovements?: InputMaybe<Scalars['Boolean']['input']>;
  maxQuantity?: InputMaybe<Scalars['Int']['input']>;
  minQuantity?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  stockStatus?: InputMaybe<Scalars['String']['input']>;
  warehouseIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Query_RootKYcStatusArgs = {
  userId: Scalars['String']['input'];
};


export type Query_RootLast_Known_LocationsArgs = {
  distinct_on?: InputMaybe<Array<Last_Known_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Last_Known_Locations_Order_By>>;
  where?: InputMaybe<Last_Known_Locations_Bool_Exp>;
};


export type Query_RootLast_Known_Locations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Last_Known_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Last_Known_Locations_Order_By>>;
  where?: InputMaybe<Last_Known_Locations_Bool_Exp>;
};


export type Query_RootLast_Known_Locations_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootMaster_CropsArgs = {
  distinct_on?: InputMaybe<Array<Master_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Crops_Order_By>>;
  where?: InputMaybe<Master_Crops_Bool_Exp>;
};


export type Query_RootMaster_Crops_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Master_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Crops_Order_By>>;
  where?: InputMaybe<Master_Crops_Bool_Exp>;
};


export type Query_RootMaster_Crops_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootMaster_SegmentsArgs = {
  distinct_on?: InputMaybe<Array<Master_Segments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Segments_Order_By>>;
  where?: InputMaybe<Master_Segments_Bool_Exp>;
};


export type Query_RootMaster_Segments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Master_Segments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Segments_Order_By>>;
  where?: InputMaybe<Master_Segments_Bool_Exp>;
};


export type Query_RootMaster_Segments_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootMessaging_Campaign_RecipientsArgs = {
  distinct_on?: InputMaybe<Array<Messaging_Campaign_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messaging_Campaign_Recipients_Order_By>>;
  where?: InputMaybe<Messaging_Campaign_Recipients_Bool_Exp>;
};


export type Query_RootMessaging_Campaign_Recipients_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Messaging_Campaign_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messaging_Campaign_Recipients_Order_By>>;
  where?: InputMaybe<Messaging_Campaign_Recipients_Bool_Exp>;
};


export type Query_RootMessaging_Campaign_Recipients_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootMessaging_Campaign_SegmentsArgs = {
  distinct_on?: InputMaybe<Array<Messaging_Campaign_Segments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messaging_Campaign_Segments_Order_By>>;
  where?: InputMaybe<Messaging_Campaign_Segments_Bool_Exp>;
};


export type Query_RootMessaging_Campaign_Segments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Messaging_Campaign_Segments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messaging_Campaign_Segments_Order_By>>;
  where?: InputMaybe<Messaging_Campaign_Segments_Bool_Exp>;
};


export type Query_RootMessaging_Campaign_Segments_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootMessaging_CampaignsArgs = {
  distinct_on?: InputMaybe<Array<Messaging_Campaigns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messaging_Campaigns_Order_By>>;
  where?: InputMaybe<Messaging_Campaigns_Bool_Exp>;
};


export type Query_RootMessaging_Campaigns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Messaging_Campaigns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messaging_Campaigns_Order_By>>;
  where?: InputMaybe<Messaging_Campaigns_Bool_Exp>;
};


export type Query_RootMessaging_Campaigns_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootMessaging_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Messaging_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messaging_Templates_Order_By>>;
  where?: InputMaybe<Messaging_Templates_Bool_Exp>;
};


export type Query_RootMessaging_Templates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Messaging_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messaging_Templates_Order_By>>;
  where?: InputMaybe<Messaging_Templates_Bool_Exp>;
};


export type Query_RootMessaging_Templates_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootMigrationsArgs = {
  distinct_on?: InputMaybe<Array<Migrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Migrations_Order_By>>;
  where?: InputMaybe<Migrations_Bool_Exp>;
};


export type Query_RootMigrations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Migrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Migrations_Order_By>>;
  where?: InputMaybe<Migrations_Bool_Exp>;
};


export type Query_RootMigrations_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootMissed_Call_Number_PoolArgs = {
  distinct_on?: InputMaybe<Array<Missed_Call_Number_Pool_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Missed_Call_Number_Pool_Order_By>>;
  where?: InputMaybe<Missed_Call_Number_Pool_Bool_Exp>;
};


export type Query_RootMissed_Call_Number_Pool_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Missed_Call_Number_Pool_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Missed_Call_Number_Pool_Order_By>>;
  where?: InputMaybe<Missed_Call_Number_Pool_Bool_Exp>;
};


export type Query_RootMissed_Call_Number_Pool_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootMissed_CallsArgs = {
  distinct_on?: InputMaybe<Array<Missed_Calls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Missed_Calls_Order_By>>;
  where?: InputMaybe<Missed_Calls_Bool_Exp>;
};


export type Query_RootMissed_Calls_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Missed_Calls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Missed_Calls_Order_By>>;
  where?: InputMaybe<Missed_Calls_Bool_Exp>;
};


export type Query_RootMissed_Calls_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootModel_Has_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Model_Has_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Has_Permissions_Order_By>>;
  where?: InputMaybe<Model_Has_Permissions_Bool_Exp>;
};


export type Query_RootModel_Has_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Model_Has_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Has_Permissions_Order_By>>;
  where?: InputMaybe<Model_Has_Permissions_Bool_Exp>;
};


export type Query_RootModel_Has_Permissions_By_PkArgs = {
  model_id: Scalars['String']['input'];
  model_type: Scalars['String']['input'];
  permission_id: Scalars['bigint']['input'];
};


export type Query_RootModel_Has_RolesArgs = {
  distinct_on?: InputMaybe<Array<Model_Has_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Has_Roles_Order_By>>;
  where?: InputMaybe<Model_Has_Roles_Bool_Exp>;
};


export type Query_RootModel_Has_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Model_Has_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Has_Roles_Order_By>>;
  where?: InputMaybe<Model_Has_Roles_Bool_Exp>;
};


export type Query_RootModel_Has_Roles_By_PkArgs = {
  model_id: Scalars['String']['input'];
  model_type: Scalars['String']['input'];
  role_id: Scalars['bigint']['input'];
};


export type Query_RootMyRedemptionsArgs = {
  userId: Scalars['String']['input'];
};


export type Query_RootNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Query_RootNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Query_RootNotifications_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootNova_Field_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Nova_Field_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nova_Field_Attachments_Order_By>>;
  where?: InputMaybe<Nova_Field_Attachments_Bool_Exp>;
};


export type Query_RootNova_Field_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nova_Field_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nova_Field_Attachments_Order_By>>;
  where?: InputMaybe<Nova_Field_Attachments_Bool_Exp>;
};


export type Query_RootNova_Field_Attachments_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootNova_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Nova_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nova_Notifications_Order_By>>;
  where?: InputMaybe<Nova_Notifications_Bool_Exp>;
};


export type Query_RootNova_Notifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nova_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nova_Notifications_Order_By>>;
  where?: InputMaybe<Nova_Notifications_Bool_Exp>;
};


export type Query_RootNova_Notifications_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootNova_Pending_Field_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Nova_Pending_Field_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nova_Pending_Field_Attachments_Order_By>>;
  where?: InputMaybe<Nova_Pending_Field_Attachments_Bool_Exp>;
};


export type Query_RootNova_Pending_Field_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nova_Pending_Field_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nova_Pending_Field_Attachments_Order_By>>;
  where?: InputMaybe<Nova_Pending_Field_Attachments_Bool_Exp>;
};


export type Query_RootNova_Pending_Field_Attachments_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootNova_TwofaArgs = {
  distinct_on?: InputMaybe<Array<Nova_Twofa_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nova_Twofa_Order_By>>;
  where?: InputMaybe<Nova_Twofa_Bool_Exp>;
};


export type Query_RootNova_Twofa_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nova_Twofa_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nova_Twofa_Order_By>>;
  where?: InputMaybe<Nova_Twofa_Bool_Exp>;
};


export type Query_RootNova_Twofa_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootPairing_CodesArgs = {
  distinct_on?: InputMaybe<Array<Pairing_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pairing_Codes_Order_By>>;
  where?: InputMaybe<Pairing_Codes_Bool_Exp>;
};


export type Query_RootPairing_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pairing_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pairing_Codes_Order_By>>;
  where?: InputMaybe<Pairing_Codes_Bool_Exp>;
};


export type Query_RootPairing_Codes_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootPassword_Reset_TokensArgs = {
  distinct_on?: InputMaybe<Array<Password_Reset_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Password_Reset_Tokens_Order_By>>;
  where?: InputMaybe<Password_Reset_Tokens_Bool_Exp>;
};


export type Query_RootPassword_Reset_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Password_Reset_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Password_Reset_Tokens_Order_By>>;
  where?: InputMaybe<Password_Reset_Tokens_Bool_Exp>;
};


export type Query_RootPassword_Reset_Tokens_By_PkArgs = {
  email: Scalars['String']['input'];
};


export type Query_RootPermissionsArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissions_Order_By>>;
  where?: InputMaybe<Permissions_Bool_Exp>;
};


export type Query_RootPermissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissions_Order_By>>;
  where?: InputMaybe<Permissions_Bool_Exp>;
};


export type Query_RootPermissions_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootPersonal_Access_TokensArgs = {
  distinct_on?: InputMaybe<Array<Personal_Access_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Personal_Access_Tokens_Order_By>>;
  where?: InputMaybe<Personal_Access_Tokens_Bool_Exp>;
};


export type Query_RootPersonal_Access_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Personal_Access_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Personal_Access_Tokens_Order_By>>;
  where?: InputMaybe<Personal_Access_Tokens_Bool_Exp>;
};


export type Query_RootPersonal_Access_Tokens_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootPersonal_DashboardArgs = {
  distinct_on?: InputMaybe<Array<Personal_Dashboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Personal_Dashboard_Order_By>>;
  where?: InputMaybe<Personal_Dashboard_Bool_Exp>;
};


export type Query_RootPersonal_Dashboard_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Personal_Dashboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Personal_Dashboard_Order_By>>;
  where?: InputMaybe<Personal_Dashboard_Bool_Exp>;
};


export type Query_RootPersonal_Dashboard_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootPersonalizedReelRecommendationsArgs = {
  reelId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootPf_Fcm_CropsArgs = {
  distinct_on?: InputMaybe<Array<Pf_Fcm_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Fcm_Crops_Order_By>>;
  where?: InputMaybe<Pf_Fcm_Crops_Bool_Exp>;
};


export type Query_RootPf_Fcm_Crops_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pf_Fcm_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Fcm_Crops_Order_By>>;
  where?: InputMaybe<Pf_Fcm_Crops_Bool_Exp>;
};


export type Query_RootPf_Fcm_Crops_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootPf_Fcm_ProductsArgs = {
  distinct_on?: InputMaybe<Array<Pf_Fcm_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Fcm_Products_Order_By>>;
  where?: InputMaybe<Pf_Fcm_Products_Bool_Exp>;
};


export type Query_RootPf_Fcm_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pf_Fcm_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Fcm_Products_Order_By>>;
  where?: InputMaybe<Pf_Fcm_Products_Bool_Exp>;
};


export type Query_RootPf_Fcm_Products_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootPf_Plan_CardsArgs = {
  distinct_on?: InputMaybe<Array<Pf_Plan_Cards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Plan_Cards_Order_By>>;
  where?: InputMaybe<Pf_Plan_Cards_Bool_Exp>;
};


export type Query_RootPf_Plan_Cards_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pf_Plan_Cards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Plan_Cards_Order_By>>;
  where?: InputMaybe<Pf_Plan_Cards_Bool_Exp>;
};


export type Query_RootPf_Plan_Cards_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootPf_ProductsArgs = {
  distinct_on?: InputMaybe<Array<Pf_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Products_Order_By>>;
  where?: InputMaybe<Pf_Products_Bool_Exp>;
};


export type Query_RootPf_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pf_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Products_Order_By>>;
  where?: InputMaybe<Pf_Products_Bool_Exp>;
};


export type Query_RootPf_Products_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootPf_Runpando_Pro_Activity_Coins_FeedbackArgs = {
  distinct_on?: InputMaybe<Array<Pf_Runpando_Pro_Activity_Coins_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Runpando_Pro_Activity_Coins_Feedback_Order_By>>;
  where?: InputMaybe<Pf_Runpando_Pro_Activity_Coins_Feedback_Bool_Exp>;
};


export type Query_RootPf_Runpando_Pro_Activity_Coins_Feedback_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pf_Runpando_Pro_Activity_Coins_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Runpando_Pro_Activity_Coins_Feedback_Order_By>>;
  where?: InputMaybe<Pf_Runpando_Pro_Activity_Coins_Feedback_Bool_Exp>;
};


export type Query_RootPf_Runpando_Pro_Activity_Coins_Feedback_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootPf_Runpando_Pro_All_State_DataArgs = {
  distinct_on?: InputMaybe<Array<Pf_Runpando_Pro_All_State_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Runpando_Pro_All_State_Data_Order_By>>;
  where?: InputMaybe<Pf_Runpando_Pro_All_State_Data_Bool_Exp>;
};


export type Query_RootPf_Runpando_Pro_All_State_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pf_Runpando_Pro_All_State_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Runpando_Pro_All_State_Data_Order_By>>;
  where?: InputMaybe<Pf_Runpando_Pro_All_State_Data_Bool_Exp>;
};


export type Query_RootPf_Runpando_Pro_All_State_Data_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootPf_Runpando_Pro_Campaign_Card_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<Pf_Runpando_Pro_Campaign_Card_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Runpando_Pro_Campaign_Card_Activities_Order_By>>;
  where?: InputMaybe<Pf_Runpando_Pro_Campaign_Card_Activities_Bool_Exp>;
};


export type Query_RootPf_Runpando_Pro_Campaign_Card_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pf_Runpando_Pro_Campaign_Card_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Runpando_Pro_Campaign_Card_Activities_Order_By>>;
  where?: InputMaybe<Pf_Runpando_Pro_Campaign_Card_Activities_Bool_Exp>;
};


export type Query_RootPf_Runpando_Pro_Campaign_Card_Activities_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootPf_Runpando_Pro_Channel_Card_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Pf_Runpando_Pro_Channel_Card_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Runpando_Pro_Channel_Card_Images_Order_By>>;
  where?: InputMaybe<Pf_Runpando_Pro_Channel_Card_Images_Bool_Exp>;
};


export type Query_RootPf_Runpando_Pro_Channel_Card_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pf_Runpando_Pro_Channel_Card_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Runpando_Pro_Channel_Card_Images_Order_By>>;
  where?: InputMaybe<Pf_Runpando_Pro_Channel_Card_Images_Bool_Exp>;
};


export type Query_RootPf_Runpando_Pro_Channel_Card_Images_By_PkArgs = {
  channel_card_image_id: Scalars['bigint']['input'];
};


export type Query_RootPf_Runpando_Pro_Users_LocationsArgs = {
  distinct_on?: InputMaybe<Array<Pf_Runpando_Pro_Users_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Runpando_Pro_Users_Locations_Order_By>>;
  where?: InputMaybe<Pf_Runpando_Pro_Users_Locations_Bool_Exp>;
};


export type Query_RootPf_Runpando_Pro_Users_Locations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pf_Runpando_Pro_Users_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Runpando_Pro_Users_Locations_Order_By>>;
  where?: InputMaybe<Pf_Runpando_Pro_Users_Locations_Bool_Exp>;
};


export type Query_RootPf_Runpando_Pro_Users_Locations_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootPf_User_TravellogArgs = {
  distinct_on?: InputMaybe<Array<Pf_User_Travellog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_User_Travellog_Order_By>>;
  where?: InputMaybe<Pf_User_Travellog_Bool_Exp>;
};


export type Query_RootPf_User_Travellog_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pf_User_Travellog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_User_Travellog_Order_By>>;
  where?: InputMaybe<Pf_User_Travellog_Bool_Exp>;
};


export type Query_RootPf_User_Travellog_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootPf_UsersArgs = {
  distinct_on?: InputMaybe<Array<Pf_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Users_Order_By>>;
  where?: InputMaybe<Pf_Users_Bool_Exp>;
};


export type Query_RootPf_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pf_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Users_Order_By>>;
  where?: InputMaybe<Pf_Users_Bool_Exp>;
};


export type Query_RootPf_Users_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootProductArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootProductBySkuArgs = {
  sku: Scalars['String']['input'];
};


export type Query_RootProductPopArgs = {
  slug: Scalars['String']['input'];
};


export type Query_RootProductPopsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductPopFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type Query_RootProduct_Pop_MediaArgs = {
  distinct_on?: InputMaybe<Array<Product_Pop_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Pop_Media_Order_By>>;
  where?: InputMaybe<Product_Pop_Media_Bool_Exp>;
};


export type Query_RootProduct_Pop_Media_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Pop_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Pop_Media_Order_By>>;
  where?: InputMaybe<Product_Pop_Media_Bool_Exp>;
};


export type Query_RootProduct_Pop_Media_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootProduct_PopsArgs = {
  distinct_on?: InputMaybe<Array<Product_Pops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Pops_Order_By>>;
  where?: InputMaybe<Product_Pops_Bool_Exp>;
};


export type Query_RootProduct_Pops_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Pops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Pops_Order_By>>;
  where?: InputMaybe<Product_Pops_Bool_Exp>;
};


export type Query_RootProduct_Pops_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootProductsArgs = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inStock?: InputMaybe<Scalars['Boolean']['input']>;
  maxPrice?: InputMaybe<Scalars['Float']['input']>;
  minPrice?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  warehouseId?: InputMaybe<Scalars['Int']['input']>;
};


export type Query_RootProspect_CropsArgs = {
  distinct_on?: InputMaybe<Array<Prospect_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospect_Crops_Order_By>>;
  where?: InputMaybe<Prospect_Crops_Bool_Exp>;
};


export type Query_RootProspect_Crops_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prospect_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospect_Crops_Order_By>>;
  where?: InputMaybe<Prospect_Crops_Bool_Exp>;
};


export type Query_RootProspect_Crops_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootProspect_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Prospect_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospect_Messages_Order_By>>;
  where?: InputMaybe<Prospect_Messages_Bool_Exp>;
};


export type Query_RootProspect_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prospect_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospect_Messages_Order_By>>;
  where?: InputMaybe<Prospect_Messages_Bool_Exp>;
};


export type Query_RootProspect_Messages_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootProspect_UserArgs = {
  distinct_on?: InputMaybe<Array<Prospect_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospect_User_Order_By>>;
  where?: InputMaybe<Prospect_User_Bool_Exp>;
};


export type Query_RootProspect_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prospect_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospect_User_Order_By>>;
  where?: InputMaybe<Prospect_User_Bool_Exp>;
};


export type Query_RootProspect_User_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootProspectsArgs = {
  distinct_on?: InputMaybe<Array<Prospects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospects_Order_By>>;
  where?: InputMaybe<Prospects_Bool_Exp>;
};


export type Query_RootProspects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prospects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospects_Order_By>>;
  where?: InputMaybe<Prospects_Bool_Exp>;
};


export type Query_RootProspects_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootReel_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Reel_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_Category_Order_By>>;
  where?: InputMaybe<Reel_Category_Bool_Exp>;
};


export type Query_RootReel_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reel_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_Category_Order_By>>;
  where?: InputMaybe<Reel_Category_Bool_Exp>;
};


export type Query_RootReel_Category_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootReel_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Reel_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_Comments_Order_By>>;
  where?: InputMaybe<Reel_Comments_Bool_Exp>;
};


export type Query_RootReel_Comments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reel_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_Comments_Order_By>>;
  where?: InputMaybe<Reel_Comments_Bool_Exp>;
};


export type Query_RootReel_Comments_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootReel_InteractionsArgs = {
  distinct_on?: InputMaybe<Array<Reel_Interactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_Interactions_Order_By>>;
  where?: InputMaybe<Reel_Interactions_Bool_Exp>;
};


export type Query_RootReel_Interactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reel_Interactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_Interactions_Order_By>>;
  where?: InputMaybe<Reel_Interactions_Bool_Exp>;
};


export type Query_RootReel_Interactions_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootReel_StatsArgs = {
  distinct_on?: InputMaybe<Array<Reel_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_Stats_Order_By>>;
  where?: InputMaybe<Reel_Stats_Bool_Exp>;
};


export type Query_RootReel_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reel_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_Stats_Order_By>>;
  where?: InputMaybe<Reel_Stats_Bool_Exp>;
};


export type Query_RootReel_Stats_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootReel_User_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Reel_User_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_User_Reports_Order_By>>;
  where?: InputMaybe<Reel_User_Reports_Bool_Exp>;
};


export type Query_RootReel_User_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reel_User_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_User_Reports_Order_By>>;
  where?: InputMaybe<Reel_User_Reports_Bool_Exp>;
};


export type Query_RootReel_User_Reports_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootReelsArgs = {
  distinct_on?: InputMaybe<Array<Reels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reels_Order_By>>;
  where?: InputMaybe<Reels_Bool_Exp>;
};


export type Query_RootReels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reels_Order_By>>;
  where?: InputMaybe<Reels_Bool_Exp>;
};


export type Query_RootReels_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootReels_With_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Reels_With_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reels_With_Distance_Order_By>>;
  where?: InputMaybe<Reels_With_Distance_Bool_Exp>;
};


export type Query_RootReels_With_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reels_With_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reels_With_Distance_Order_By>>;
  where?: InputMaybe<Reels_With_Distance_Bool_Exp>;
};


export type Query_RootRetailer_EstablishmentsArgs = {
  distinct_on?: InputMaybe<Array<Retailer_Establishments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Retailer_Establishments_Order_By>>;
  where?: InputMaybe<Retailer_Establishments_Bool_Exp>;
};


export type Query_RootRetailer_Establishments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Retailer_Establishments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Retailer_Establishments_Order_By>>;
  where?: InputMaybe<Retailer_Establishments_Bool_Exp>;
};


export type Query_RootRetailer_Establishments_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootRetailersArgs = {
  distinct_on?: InputMaybe<Array<Retailers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Retailers_Order_By>>;
  where?: InputMaybe<Retailers_Bool_Exp>;
};


export type Query_RootRetailers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Retailers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Retailers_Order_By>>;
  where?: InputMaybe<Retailers_Bool_Exp>;
};


export type Query_RootRetailers_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootRole_Has_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Role_Has_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_Has_Permissions_Order_By>>;
  where?: InputMaybe<Role_Has_Permissions_Bool_Exp>;
};


export type Query_RootRole_Has_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_Has_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_Has_Permissions_Order_By>>;
  where?: InputMaybe<Role_Has_Permissions_Bool_Exp>;
};


export type Query_RootRole_Has_Permissions_By_PkArgs = {
  permission_id: Scalars['bigint']['input'];
  role_id: Scalars['bigint']['input'];
};


export type Query_RootRolesArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Query_RootRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Query_RootRoles_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootRunpando_Pro_All_State_DataArgs = {
  distinct_on?: InputMaybe<Array<Runpando_Pro_All_State_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Runpando_Pro_All_State_Data_Order_By>>;
  where?: InputMaybe<Runpando_Pro_All_State_Data_Bool_Exp>;
};


export type Query_RootRunpando_Pro_All_State_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Runpando_Pro_All_State_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Runpando_Pro_All_State_Data_Order_By>>;
  where?: InputMaybe<Runpando_Pro_All_State_Data_Bool_Exp>;
};


export type Query_RootRunpando_Pro_All_State_Data_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootRunpando_Pro_UsersArgs = {
  distinct_on?: InputMaybe<Array<Runpando_Pro_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Runpando_Pro_Users_Order_By>>;
  where?: InputMaybe<Runpando_Pro_Users_Bool_Exp>;
};


export type Query_RootRunpando_Pro_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Runpando_Pro_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Runpando_Pro_Users_Order_By>>;
  where?: InputMaybe<Runpando_Pro_Users_Bool_Exp>;
};


export type Query_RootRunpando_Pro_Users_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootRunpando_Pro_Users_LocationsArgs = {
  distinct_on?: InputMaybe<Array<Runpando_Pro_Users_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Runpando_Pro_Users_Locations_Order_By>>;
  where?: InputMaybe<Runpando_Pro_Users_Locations_Bool_Exp>;
};


export type Query_RootRunpando_Pro_Users_Locations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Runpando_Pro_Users_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Runpando_Pro_Users_Locations_Order_By>>;
  where?: InputMaybe<Runpando_Pro_Users_Locations_Bool_Exp>;
};


export type Query_RootRunpando_Pro_Users_Locations_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootSale_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Sale_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sale_Items_Order_By>>;
  where?: InputMaybe<Sale_Items_Bool_Exp>;
};


export type Query_RootSale_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sale_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sale_Items_Order_By>>;
  where?: InputMaybe<Sale_Items_Bool_Exp>;
};


export type Query_RootSale_Items_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootSale_PaymentsArgs = {
  distinct_on?: InputMaybe<Array<Sale_Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sale_Payments_Order_By>>;
  where?: InputMaybe<Sale_Payments_Bool_Exp>;
};


export type Query_RootSale_Payments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sale_Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sale_Payments_Order_By>>;
  where?: InputMaybe<Sale_Payments_Bool_Exp>;
};


export type Query_RootSale_Payments_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootSale_Proof_EventsArgs = {
  distinct_on?: InputMaybe<Array<Sale_Proof_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sale_Proof_Events_Order_By>>;
  where?: InputMaybe<Sale_Proof_Events_Bool_Exp>;
};


export type Query_RootSale_Proof_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sale_Proof_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sale_Proof_Events_Order_By>>;
  where?: InputMaybe<Sale_Proof_Events_Bool_Exp>;
};


export type Query_RootSale_Proof_Events_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootSale_Proof_TypesArgs = {
  distinct_on?: InputMaybe<Array<Sale_Proof_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sale_Proof_Types_Order_By>>;
  where?: InputMaybe<Sale_Proof_Types_Bool_Exp>;
};


export type Query_RootSale_Proof_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sale_Proof_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sale_Proof_Types_Order_By>>;
  where?: InputMaybe<Sale_Proof_Types_Bool_Exp>;
};


export type Query_RootSale_Proof_Types_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootSale_ProofsArgs = {
  distinct_on?: InputMaybe<Array<Sale_Proofs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sale_Proofs_Order_By>>;
  where?: InputMaybe<Sale_Proofs_Bool_Exp>;
};


export type Query_RootSale_Proofs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sale_Proofs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sale_Proofs_Order_By>>;
  where?: InputMaybe<Sale_Proofs_Bool_Exp>;
};


export type Query_RootSale_Proofs_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootSalesArgs = {
  distinct_on?: InputMaybe<Array<Sales_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sales_Order_By>>;
  where?: InputMaybe<Sales_Bool_Exp>;
};


export type Query_RootSales_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sales_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sales_Order_By>>;
  where?: InputMaybe<Sales_Bool_Exp>;
};


export type Query_RootSales_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootSaved_ReelsArgs = {
  distinct_on?: InputMaybe<Array<Saved_Reels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Saved_Reels_Order_By>>;
  where?: InputMaybe<Saved_Reels_Bool_Exp>;
};


export type Query_RootSaved_Reels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Saved_Reels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Saved_Reels_Order_By>>;
  where?: InputMaybe<Saved_Reels_Bool_Exp>;
};


export type Query_RootSaved_Reels_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootSearchCrmItemsArgs = {
  accountId: Scalars['String']['input'];
  db?: InputMaybe<Scalars['String']['input']>;
  dir?: InputMaybe<Scalars['String']['input']>;
  filtersJson: Scalars['String']['input'];
  order_by?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type Query_RootSearchChatThreadMessagesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  term: Scalars['String']['input'];
  threadId: Scalars['String']['input'];
};


export type Query_RootSearch_Field_Force_Near_FarmerArgs = {
  args: Search_Field_Force_Near_Farmer_Args;
  distinct_on?: InputMaybe<Array<Last_Known_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Last_Known_Locations_Order_By>>;
  where?: InputMaybe<Last_Known_Locations_Bool_Exp>;
};


export type Query_RootSearch_Field_Force_Near_Farmer_AggregateArgs = {
  args: Search_Field_Force_Near_Farmer_Args;
  distinct_on?: InputMaybe<Array<Last_Known_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Last_Known_Locations_Order_By>>;
  where?: InputMaybe<Last_Known_Locations_Bool_Exp>;
};


export type Query_RootSegment_UserArgs = {
  distinct_on?: InputMaybe<Array<Segment_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Segment_User_Order_By>>;
  where?: InputMaybe<Segment_User_Bool_Exp>;
};


export type Query_RootSegment_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Segment_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Segment_User_Order_By>>;
  where?: InputMaybe<Segment_User_Bool_Exp>;
};


export type Query_RootSegment_User_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootService_Request_DashboardArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Dashboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Dashboard_Order_By>>;
  where?: InputMaybe<Service_Request_Dashboard_Bool_Exp>;
};


export type Query_RootService_Request_Dashboard_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Dashboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Dashboard_Order_By>>;
  where?: InputMaybe<Service_Request_Dashboard_Bool_Exp>;
};


export type Query_RootService_Request_Dashboard_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootService_Request_RecommendationsArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Recommendations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Recommendations_Order_By>>;
  where?: InputMaybe<Service_Request_Recommendations_Bool_Exp>;
};


export type Query_RootService_Request_Recommendations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Recommendations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Recommendations_Order_By>>;
  where?: InputMaybe<Service_Request_Recommendations_Bool_Exp>;
};


export type Query_RootService_Request_Recommendations_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootService_Request_RetailerArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Retailer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Retailer_Order_By>>;
  where?: InputMaybe<Service_Request_Retailer_Bool_Exp>;
};


export type Query_RootService_Request_Retailer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Retailer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Retailer_Order_By>>;
  where?: InputMaybe<Service_Request_Retailer_Bool_Exp>;
};


export type Query_RootService_Request_Retailer_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootService_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Service_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Requests_Order_By>>;
  where?: InputMaybe<Service_Requests_Bool_Exp>;
};


export type Query_RootService_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Requests_Order_By>>;
  where?: InputMaybe<Service_Requests_Bool_Exp>;
};


export type Query_RootService_Requests_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootSnapshotsArgs = {
  distinct_on?: InputMaybe<Array<Snapshots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Snapshots_Order_By>>;
  where?: InputMaybe<Snapshots_Bool_Exp>;
};


export type Query_RootSnapshots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Snapshots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Snapshots_Order_By>>;
  where?: InputMaybe<Snapshots_Bool_Exp>;
};


export type Query_RootSnapshots_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootSpatial_Ref_SysArgs = {
  distinct_on?: InputMaybe<Array<Spatial_Ref_Sys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spatial_Ref_Sys_Order_By>>;
  where?: InputMaybe<Spatial_Ref_Sys_Bool_Exp>;
};


export type Query_RootSpatial_Ref_Sys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spatial_Ref_Sys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spatial_Ref_Sys_Order_By>>;
  where?: InputMaybe<Spatial_Ref_Sys_Bool_Exp>;
};


export type Query_RootSpatial_Ref_Sys_By_PkArgs = {
  srid: Scalars['Int']['input'];
};


export type Query_RootStateLangFromLocationArgs = {
  request: GetStateLangFromLocationQueryInput;
};


export type Query_RootStored_EventsArgs = {
  distinct_on?: InputMaybe<Array<Stored_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Stored_Events_Order_By>>;
  where?: InputMaybe<Stored_Events_Bool_Exp>;
};


export type Query_RootStored_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stored_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Stored_Events_Order_By>>;
  where?: InputMaybe<Stored_Events_Bool_Exp>;
};


export type Query_RootStored_Events_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootTaggablesArgs = {
  distinct_on?: InputMaybe<Array<Taggables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taggables_Order_By>>;
  where?: InputMaybe<Taggables_Bool_Exp>;
};


export type Query_RootTaggables_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Taggables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taggables_Order_By>>;
  where?: InputMaybe<Taggables_Bool_Exp>;
};


export type Query_RootTaggables_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootTagsArgs = {
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Query_RootTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Query_RootTags_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootThreadsByIdsArgs = {
  threadIds: Array<Scalars['String']['input']>;
};


export type Query_RootUserBalancesArgs = {
  userId: Scalars['String']['input'];
};


export type Query_RootUserChatThreadsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type Query_RootUser_DeviceArgs = {
  distinct_on?: InputMaybe<Array<User_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Device_Order_By>>;
  where?: InputMaybe<User_Device_Bool_Exp>;
};


export type Query_RootUser_Device_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Device_Order_By>>;
  where?: InputMaybe<User_Device_Bool_Exp>;
};


export type Query_RootUser_Device_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUser_FeedbacksArgs = {
  distinct_on?: InputMaybe<Array<User_Feedbacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Feedbacks_Order_By>>;
  where?: InputMaybe<User_Feedbacks_Bool_Exp>;
};


export type Query_RootUser_Feedbacks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Feedbacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Feedbacks_Order_By>>;
  where?: InputMaybe<User_Feedbacks_Bool_Exp>;
};


export type Query_RootUser_Feedbacks_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootUser_Follows_ChannelArgs = {
  distinct_on?: InputMaybe<Array<User_Follows_Channel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Follows_Channel_Order_By>>;
  where?: InputMaybe<User_Follows_Channel_Bool_Exp>;
};


export type Query_RootUser_Follows_Channel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Follows_Channel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Follows_Channel_Order_By>>;
  where?: InputMaybe<User_Follows_Channel_Bool_Exp>;
};


export type Query_RootUser_Follows_Channel_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUser_Location_LogsArgs = {
  distinct_on?: InputMaybe<Array<User_Location_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Location_Logs_Order_By>>;
  where?: InputMaybe<User_Location_Logs_Bool_Exp>;
};


export type Query_RootUser_Location_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Location_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Location_Logs_Order_By>>;
  where?: InputMaybe<User_Location_Logs_Bool_Exp>;
};


export type Query_RootUser_Location_Logs_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootWalletsArgs = {
  distinct_on?: InputMaybe<Array<Wallets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallets_Order_By>>;
  where?: InputMaybe<Wallets_Bool_Exp>;
};


export type Query_RootWallets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wallets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallets_Order_By>>;
  where?: InputMaybe<Wallets_Bool_Exp>;
};


export type Query_RootWallets_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootWarehouseArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootWarehousesArgs = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  hasCoordinates?: InputMaybe<Scalars['Boolean']['input']>;
  hasLowStock?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  managerId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  paginate?: InputMaybe<Scalars['Boolean']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  pincode?: InputMaybe<Scalars['String']['input']>;
  radiusKm?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootWarehousesNearLocationArgs = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  radiusKm?: InputMaybe<Scalars['Float']['input']>;
};


export type Query_RootWhatsauth_LoginsArgs = {
  distinct_on?: InputMaybe<Array<Whatsauth_Logins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsauth_Logins_Order_By>>;
  where?: InputMaybe<Whatsauth_Logins_Bool_Exp>;
};


export type Query_RootWhatsauth_Logins_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Whatsauth_Logins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsauth_Logins_Order_By>>;
  where?: InputMaybe<Whatsauth_Logins_Bool_Exp>;
};


export type Query_RootWhatsauth_Logins_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootWork_Order_Checklist_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Work_Order_Checklist_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Work_Order_Checklist_Items_Order_By>>;
  where?: InputMaybe<Work_Order_Checklist_Items_Bool_Exp>;
};


export type Query_RootWork_Order_Checklist_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Work_Order_Checklist_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Work_Order_Checklist_Items_Order_By>>;
  where?: InputMaybe<Work_Order_Checklist_Items_Bool_Exp>;
};


export type Query_RootWork_Order_Checklist_Items_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootWork_Order_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Work_Order_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Work_Order_Messages_Order_By>>;
  where?: InputMaybe<Work_Order_Messages_Bool_Exp>;
};


export type Query_RootWork_Order_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Work_Order_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Work_Order_Messages_Order_By>>;
  where?: InputMaybe<Work_Order_Messages_Bool_Exp>;
};


export type Query_RootWork_Order_Messages_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootWork_Order_OutputsArgs = {
  distinct_on?: InputMaybe<Array<Work_Order_Outputs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Work_Order_Outputs_Order_By>>;
  where?: InputMaybe<Work_Order_Outputs_Bool_Exp>;
};


export type Query_RootWork_Order_Outputs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Work_Order_Outputs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Work_Order_Outputs_Order_By>>;
  where?: InputMaybe<Work_Order_Outputs_Bool_Exp>;
};


export type Query_RootWork_Order_Outputs_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootWork_Order_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Work_Order_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Work_Order_Requests_Order_By>>;
  where?: InputMaybe<Work_Order_Requests_Bool_Exp>;
};


export type Query_RootWork_Order_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Work_Order_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Work_Order_Requests_Order_By>>;
  where?: InputMaybe<Work_Order_Requests_Bool_Exp>;
};


export type Query_RootWork_Order_Requests_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootWork_Order_ReviewsArgs = {
  distinct_on?: InputMaybe<Array<Work_Order_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Work_Order_Reviews_Order_By>>;
  where?: InputMaybe<Work_Order_Reviews_Bool_Exp>;
};


export type Query_RootWork_Order_Reviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Work_Order_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Work_Order_Reviews_Order_By>>;
  where?: InputMaybe<Work_Order_Reviews_Bool_Exp>;
};


export type Query_RootWork_Order_Reviews_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootWork_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Work_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Work_Orders_Order_By>>;
  where?: InputMaybe<Work_Orders_Bool_Exp>;
};


export type Query_RootWork_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Work_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Work_Orders_Order_By>>;
  where?: InputMaybe<Work_Orders_Bool_Exp>;
};


export type Query_RootWork_Orders_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};

/** columns and relationships of "reel_category" */
export type Reel_Category = {
  __typename?: 'reel_category';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  order_column?: Maybe<Scalars['Int']['output']>;
  parent_id?: Maybe<Scalars['bigint']['output']>;
  /** An array relationship */
  reel_categories: Array<Reel_Category>;
  /** An aggregate relationship */
  reel_categories_aggregate: Reel_Category_Aggregate;
  /** An object relationship */
  reel_category?: Maybe<Reel_Category>;
  /** An array relationship */
  reels: Array<Reels>;
  /** An aggregate relationship */
  reels_aggregate: Reels_Aggregate;
  slug?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};


/** columns and relationships of "reel_category" */
export type Reel_CategoryReel_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Reel_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_Category_Order_By>>;
  where?: InputMaybe<Reel_Category_Bool_Exp>;
};


/** columns and relationships of "reel_category" */
export type Reel_CategoryReel_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reel_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_Category_Order_By>>;
  where?: InputMaybe<Reel_Category_Bool_Exp>;
};


/** columns and relationships of "reel_category" */
export type Reel_CategoryReelsArgs = {
  distinct_on?: InputMaybe<Array<Reels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reels_Order_By>>;
  where?: InputMaybe<Reels_Bool_Exp>;
};


/** columns and relationships of "reel_category" */
export type Reel_CategoryReels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reels_Order_By>>;
  where?: InputMaybe<Reels_Bool_Exp>;
};

/** aggregated selection of "reel_category" */
export type Reel_Category_Aggregate = {
  __typename?: 'reel_category_aggregate';
  aggregate?: Maybe<Reel_Category_Aggregate_Fields>;
  nodes: Array<Reel_Category>;
};

export type Reel_Category_Aggregate_Bool_Exp = {
  count?: InputMaybe<Reel_Category_Aggregate_Bool_Exp_Count>;
};

export type Reel_Category_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Reel_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reel_Category_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "reel_category" */
export type Reel_Category_Aggregate_Fields = {
  __typename?: 'reel_category_aggregate_fields';
  avg?: Maybe<Reel_Category_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Reel_Category_Max_Fields>;
  min?: Maybe<Reel_Category_Min_Fields>;
  stddev?: Maybe<Reel_Category_Stddev_Fields>;
  stddev_pop?: Maybe<Reel_Category_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Reel_Category_Stddev_Samp_Fields>;
  sum?: Maybe<Reel_Category_Sum_Fields>;
  var_pop?: Maybe<Reel_Category_Var_Pop_Fields>;
  var_samp?: Maybe<Reel_Category_Var_Samp_Fields>;
  variance?: Maybe<Reel_Category_Variance_Fields>;
};


/** aggregate fields of "reel_category" */
export type Reel_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Reel_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "reel_category" */
export type Reel_Category_Aggregate_Order_By = {
  avg?: InputMaybe<Reel_Category_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Reel_Category_Max_Order_By>;
  min?: InputMaybe<Reel_Category_Min_Order_By>;
  stddev?: InputMaybe<Reel_Category_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Reel_Category_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Reel_Category_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Reel_Category_Sum_Order_By>;
  var_pop?: InputMaybe<Reel_Category_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Reel_Category_Var_Samp_Order_By>;
  variance?: InputMaybe<Reel_Category_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "reel_category" */
export type Reel_Category_Arr_Rel_Insert_Input = {
  data: Array<Reel_Category_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Reel_Category_On_Conflict>;
};

/** aggregate avg on columns */
export type Reel_Category_Avg_Fields = {
  __typename?: 'reel_category_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order_column?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "reel_category" */
export type Reel_Category_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  order_column?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "reel_category". All fields are combined with a logical 'AND'. */
export type Reel_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Reel_Category_Bool_Exp>>;
  _not?: InputMaybe<Reel_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Reel_Category_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order_column?: InputMaybe<Int_Comparison_Exp>;
  parent_id?: InputMaybe<Bigint_Comparison_Exp>;
  reel_categories?: InputMaybe<Reel_Category_Bool_Exp>;
  reel_categories_aggregate?: InputMaybe<Reel_Category_Aggregate_Bool_Exp>;
  reel_category?: InputMaybe<Reel_Category_Bool_Exp>;
  reels?: InputMaybe<Reels_Bool_Exp>;
  reels_aggregate?: InputMaybe<Reels_Aggregate_Bool_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "reel_category" */
export enum Reel_Category_Constraint {
  /** unique or primary key constraint on columns "id" */
  ReelCategoryPkey = 'reel_category_pkey'
}

/** input type for incrementing numeric columns in table "reel_category" */
export type Reel_Category_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  order_column?: InputMaybe<Scalars['Int']['input']>;
  parent_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "reel_category" */
export type Reel_Category_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_column?: InputMaybe<Scalars['Int']['input']>;
  parent_id?: InputMaybe<Scalars['bigint']['input']>;
  reel_categories?: InputMaybe<Reel_Category_Arr_Rel_Insert_Input>;
  reel_category?: InputMaybe<Reel_Category_Obj_Rel_Insert_Input>;
  reels?: InputMaybe<Reels_Arr_Rel_Insert_Input>;
  slug?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Reel_Category_Max_Fields = {
  __typename?: 'reel_category_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order_column?: Maybe<Scalars['Int']['output']>;
  parent_id?: Maybe<Scalars['bigint']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "reel_category" */
export type Reel_Category_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_column?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Reel_Category_Min_Fields = {
  __typename?: 'reel_category_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order_column?: Maybe<Scalars['Int']['output']>;
  parent_id?: Maybe<Scalars['bigint']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "reel_category" */
export type Reel_Category_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_column?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "reel_category" */
export type Reel_Category_Mutation_Response = {
  __typename?: 'reel_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Reel_Category>;
};

/** input type for inserting object relation for remote table "reel_category" */
export type Reel_Category_Obj_Rel_Insert_Input = {
  data: Reel_Category_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Reel_Category_On_Conflict>;
};

/** on_conflict condition type for table "reel_category" */
export type Reel_Category_On_Conflict = {
  constraint: Reel_Category_Constraint;
  update_columns?: Array<Reel_Category_Update_Column>;
  where?: InputMaybe<Reel_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "reel_category". */
export type Reel_Category_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_column?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  reel_categories_aggregate?: InputMaybe<Reel_Category_Aggregate_Order_By>;
  reel_category?: InputMaybe<Reel_Category_Order_By>;
  reels_aggregate?: InputMaybe<Reels_Aggregate_Order_By>;
  slug?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: reel_category */
export type Reel_Category_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "reel_category" */
export enum Reel_Category_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrderColumn = 'order_column',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  Slug = 'slug',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "reel_category" */
export type Reel_Category_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_column?: InputMaybe<Scalars['Int']['input']>;
  parent_id?: InputMaybe<Scalars['bigint']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Reel_Category_Stddev_Fields = {
  __typename?: 'reel_category_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order_column?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "reel_category" */
export type Reel_Category_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  order_column?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Reel_Category_Stddev_Pop_Fields = {
  __typename?: 'reel_category_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order_column?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "reel_category" */
export type Reel_Category_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  order_column?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Reel_Category_Stddev_Samp_Fields = {
  __typename?: 'reel_category_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order_column?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "reel_category" */
export type Reel_Category_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  order_column?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "reel_category" */
export type Reel_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Reel_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Reel_Category_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_column?: InputMaybe<Scalars['Int']['input']>;
  parent_id?: InputMaybe<Scalars['bigint']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Reel_Category_Sum_Fields = {
  __typename?: 'reel_category_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  order_column?: Maybe<Scalars['Int']['output']>;
  parent_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "reel_category" */
export type Reel_Category_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  order_column?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
};

/** update columns of table "reel_category" */
export enum Reel_Category_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrderColumn = 'order_column',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  Slug = 'slug',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Reel_Category_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Reel_Category_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Reel_Category_Set_Input>;
  /** filter the rows which have to be updated */
  where: Reel_Category_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Reel_Category_Var_Pop_Fields = {
  __typename?: 'reel_category_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order_column?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "reel_category" */
export type Reel_Category_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  order_column?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Reel_Category_Var_Samp_Fields = {
  __typename?: 'reel_category_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order_column?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "reel_category" */
export type Reel_Category_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  order_column?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Reel_Category_Variance_Fields = {
  __typename?: 'reel_category_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order_column?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "reel_category" */
export type Reel_Category_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  order_column?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "reel_comments" */
export type Reel_Comments = {
  __typename?: 'reel_comments';
  comment: Scalars['String']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['bigint']['output'];
  parent_id?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  reel: Reels;
  reel_id: Scalars['bigint']['output'];
  /** An array relationship */
  reports: Array<Reel_User_Reports>;
  /** An aggregate relationship */
  reports_aggregate: Reel_User_Reports_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['bpchar']['output'];
};


/** columns and relationships of "reel_comments" */
export type Reel_CommentsReportsArgs = {
  distinct_on?: InputMaybe<Array<Reel_User_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_User_Reports_Order_By>>;
  where?: InputMaybe<Reel_User_Reports_Bool_Exp>;
};


/** columns and relationships of "reel_comments" */
export type Reel_CommentsReports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reel_User_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_User_Reports_Order_By>>;
  where?: InputMaybe<Reel_User_Reports_Bool_Exp>;
};

/** aggregated selection of "reel_comments" */
export type Reel_Comments_Aggregate = {
  __typename?: 'reel_comments_aggregate';
  aggregate?: Maybe<Reel_Comments_Aggregate_Fields>;
  nodes: Array<Reel_Comments>;
};

export type Reel_Comments_Aggregate_Bool_Exp = {
  count?: InputMaybe<Reel_Comments_Aggregate_Bool_Exp_Count>;
};

export type Reel_Comments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Reel_Comments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reel_Comments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "reel_comments" */
export type Reel_Comments_Aggregate_Fields = {
  __typename?: 'reel_comments_aggregate_fields';
  avg?: Maybe<Reel_Comments_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Reel_Comments_Max_Fields>;
  min?: Maybe<Reel_Comments_Min_Fields>;
  stddev?: Maybe<Reel_Comments_Stddev_Fields>;
  stddev_pop?: Maybe<Reel_Comments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Reel_Comments_Stddev_Samp_Fields>;
  sum?: Maybe<Reel_Comments_Sum_Fields>;
  var_pop?: Maybe<Reel_Comments_Var_Pop_Fields>;
  var_samp?: Maybe<Reel_Comments_Var_Samp_Fields>;
  variance?: Maybe<Reel_Comments_Variance_Fields>;
};


/** aggregate fields of "reel_comments" */
export type Reel_Comments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Reel_Comments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "reel_comments" */
export type Reel_Comments_Aggregate_Order_By = {
  avg?: InputMaybe<Reel_Comments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Reel_Comments_Max_Order_By>;
  min?: InputMaybe<Reel_Comments_Min_Order_By>;
  stddev?: InputMaybe<Reel_Comments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Reel_Comments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Reel_Comments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Reel_Comments_Sum_Order_By>;
  var_pop?: InputMaybe<Reel_Comments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Reel_Comments_Var_Samp_Order_By>;
  variance?: InputMaybe<Reel_Comments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "reel_comments" */
export type Reel_Comments_Arr_Rel_Insert_Input = {
  data: Array<Reel_Comments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Reel_Comments_On_Conflict>;
};

/** aggregate avg on columns */
export type Reel_Comments_Avg_Fields = {
  __typename?: 'reel_comments_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "reel_comments" */
export type Reel_Comments_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "reel_comments". All fields are combined with a logical 'AND'. */
export type Reel_Comments_Bool_Exp = {
  _and?: InputMaybe<Array<Reel_Comments_Bool_Exp>>;
  _not?: InputMaybe<Reel_Comments_Bool_Exp>;
  _or?: InputMaybe<Array<Reel_Comments_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  parent_id?: InputMaybe<Bigint_Comparison_Exp>;
  reel?: InputMaybe<Reels_Bool_Exp>;
  reel_id?: InputMaybe<Bigint_Comparison_Exp>;
  reports?: InputMaybe<Reel_User_Reports_Bool_Exp>;
  reports_aggregate?: InputMaybe<Reel_User_Reports_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "reel_comments" */
export enum Reel_Comments_Constraint {
  /** unique or primary key constraint on columns "id" */
  ReelCommentsPkey = 'reel_comments_pkey'
}

/** input type for incrementing numeric columns in table "reel_comments" */
export type Reel_Comments_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  parent_id?: InputMaybe<Scalars['bigint']['input']>;
  reel_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "reel_comments" */
export type Reel_Comments_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  parent_id?: InputMaybe<Scalars['bigint']['input']>;
  reel?: InputMaybe<Reels_Obj_Rel_Insert_Input>;
  reel_id?: InputMaybe<Scalars['bigint']['input']>;
  reports?: InputMaybe<Reel_User_Reports_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Reel_Comments_Max_Fields = {
  __typename?: 'reel_comments_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  parent_id?: Maybe<Scalars['bigint']['output']>;
  reel_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by max() on columns of table "reel_comments" */
export type Reel_Comments_Max_Order_By = {
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Reel_Comments_Min_Fields = {
  __typename?: 'reel_comments_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  parent_id?: Maybe<Scalars['bigint']['output']>;
  reel_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by min() on columns of table "reel_comments" */
export type Reel_Comments_Min_Order_By = {
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "reel_comments" */
export type Reel_Comments_Mutation_Response = {
  __typename?: 'reel_comments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Reel_Comments>;
};

/** input type for inserting object relation for remote table "reel_comments" */
export type Reel_Comments_Obj_Rel_Insert_Input = {
  data: Reel_Comments_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Reel_Comments_On_Conflict>;
};

/** on_conflict condition type for table "reel_comments" */
export type Reel_Comments_On_Conflict = {
  constraint: Reel_Comments_Constraint;
  update_columns?: Array<Reel_Comments_Update_Column>;
  where?: InputMaybe<Reel_Comments_Bool_Exp>;
};

/** Ordering options when selecting data from "reel_comments". */
export type Reel_Comments_Order_By = {
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  reel?: InputMaybe<Reels_Order_By>;
  reel_id?: InputMaybe<Order_By>;
  reports_aggregate?: InputMaybe<Reel_User_Reports_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: reel_comments */
export type Reel_Comments_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "reel_comments" */
export enum Reel_Comments_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  ReelId = 'reel_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "reel_comments" */
export type Reel_Comments_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  parent_id?: InputMaybe<Scalars['bigint']['input']>;
  reel_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate stddev on columns */
export type Reel_Comments_Stddev_Fields = {
  __typename?: 'reel_comments_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "reel_comments" */
export type Reel_Comments_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Reel_Comments_Stddev_Pop_Fields = {
  __typename?: 'reel_comments_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "reel_comments" */
export type Reel_Comments_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Reel_Comments_Stddev_Samp_Fields = {
  __typename?: 'reel_comments_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "reel_comments" */
export type Reel_Comments_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "reel_comments" */
export type Reel_Comments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Reel_Comments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Reel_Comments_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  parent_id?: InputMaybe<Scalars['bigint']['input']>;
  reel_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate sum on columns */
export type Reel_Comments_Sum_Fields = {
  __typename?: 'reel_comments_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  parent_id?: Maybe<Scalars['bigint']['output']>;
  reel_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "reel_comments" */
export type Reel_Comments_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
};

/** update columns of table "reel_comments" */
export enum Reel_Comments_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  ReelId = 'reel_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Reel_Comments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Reel_Comments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Reel_Comments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Reel_Comments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Reel_Comments_Var_Pop_Fields = {
  __typename?: 'reel_comments_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "reel_comments" */
export type Reel_Comments_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Reel_Comments_Var_Samp_Fields = {
  __typename?: 'reel_comments_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "reel_comments" */
export type Reel_Comments_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Reel_Comments_Variance_Fields = {
  __typename?: 'reel_comments_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "reel_comments" */
export type Reel_Comments_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "reel_interactions" */
export type Reel_Interactions = {
  __typename?: 'reel_interactions';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['bigint']['output'];
  interaction_type?: Maybe<Scalars['String']['output']>;
  interaction_value?: Maybe<Scalars['String']['output']>;
  reel_id: Scalars['bigint']['output'];
  /** An object relationship */
  reel_interactions_reel: Reels;
  /** An object relationship */
  reel_interactions_user?: Maybe<Users>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** aggregated selection of "reel_interactions" */
export type Reel_Interactions_Aggregate = {
  __typename?: 'reel_interactions_aggregate';
  aggregate?: Maybe<Reel_Interactions_Aggregate_Fields>;
  nodes: Array<Reel_Interactions>;
};

export type Reel_Interactions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Reel_Interactions_Aggregate_Bool_Exp_Count>;
};

export type Reel_Interactions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Reel_Interactions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reel_Interactions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "reel_interactions" */
export type Reel_Interactions_Aggregate_Fields = {
  __typename?: 'reel_interactions_aggregate_fields';
  avg?: Maybe<Reel_Interactions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Reel_Interactions_Max_Fields>;
  min?: Maybe<Reel_Interactions_Min_Fields>;
  stddev?: Maybe<Reel_Interactions_Stddev_Fields>;
  stddev_pop?: Maybe<Reel_Interactions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Reel_Interactions_Stddev_Samp_Fields>;
  sum?: Maybe<Reel_Interactions_Sum_Fields>;
  var_pop?: Maybe<Reel_Interactions_Var_Pop_Fields>;
  var_samp?: Maybe<Reel_Interactions_Var_Samp_Fields>;
  variance?: Maybe<Reel_Interactions_Variance_Fields>;
};


/** aggregate fields of "reel_interactions" */
export type Reel_Interactions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Reel_Interactions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "reel_interactions" */
export type Reel_Interactions_Aggregate_Order_By = {
  avg?: InputMaybe<Reel_Interactions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Reel_Interactions_Max_Order_By>;
  min?: InputMaybe<Reel_Interactions_Min_Order_By>;
  stddev?: InputMaybe<Reel_Interactions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Reel_Interactions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Reel_Interactions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Reel_Interactions_Sum_Order_By>;
  var_pop?: InputMaybe<Reel_Interactions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Reel_Interactions_Var_Samp_Order_By>;
  variance?: InputMaybe<Reel_Interactions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "reel_interactions" */
export type Reel_Interactions_Arr_Rel_Insert_Input = {
  data: Array<Reel_Interactions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Reel_Interactions_On_Conflict>;
};

/** aggregate avg on columns */
export type Reel_Interactions_Avg_Fields = {
  __typename?: 'reel_interactions_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "reel_interactions" */
export type Reel_Interactions_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "reel_interactions". All fields are combined with a logical 'AND'. */
export type Reel_Interactions_Bool_Exp = {
  _and?: InputMaybe<Array<Reel_Interactions_Bool_Exp>>;
  _not?: InputMaybe<Reel_Interactions_Bool_Exp>;
  _or?: InputMaybe<Array<Reel_Interactions_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  interaction_type?: InputMaybe<String_Comparison_Exp>;
  interaction_value?: InputMaybe<String_Comparison_Exp>;
  reel_id?: InputMaybe<Bigint_Comparison_Exp>;
  reel_interactions_reel?: InputMaybe<Reels_Bool_Exp>;
  reel_interactions_user?: InputMaybe<Users_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "reel_interactions" */
export enum Reel_Interactions_Constraint {
  /** unique or primary key constraint on columns "id" */
  ReelInteractionsPkey = 'reel_interactions_pkey'
}

/** input type for incrementing numeric columns in table "reel_interactions" */
export type Reel_Interactions_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  reel_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "reel_interactions" */
export type Reel_Interactions_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  interaction_type?: InputMaybe<Scalars['String']['input']>;
  interaction_value?: InputMaybe<Scalars['String']['input']>;
  reel_id?: InputMaybe<Scalars['bigint']['input']>;
  reel_interactions_reel?: InputMaybe<Reels_Obj_Rel_Insert_Input>;
  reel_interactions_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Reel_Interactions_Max_Fields = {
  __typename?: 'reel_interactions_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  interaction_type?: Maybe<Scalars['String']['output']>;
  interaction_value?: Maybe<Scalars['String']['output']>;
  reel_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by max() on columns of table "reel_interactions" */
export type Reel_Interactions_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interaction_type?: InputMaybe<Order_By>;
  interaction_value?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Reel_Interactions_Min_Fields = {
  __typename?: 'reel_interactions_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  interaction_type?: Maybe<Scalars['String']['output']>;
  interaction_value?: Maybe<Scalars['String']['output']>;
  reel_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by min() on columns of table "reel_interactions" */
export type Reel_Interactions_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interaction_type?: InputMaybe<Order_By>;
  interaction_value?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "reel_interactions" */
export type Reel_Interactions_Mutation_Response = {
  __typename?: 'reel_interactions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Reel_Interactions>;
};

/** on_conflict condition type for table "reel_interactions" */
export type Reel_Interactions_On_Conflict = {
  constraint: Reel_Interactions_Constraint;
  update_columns?: Array<Reel_Interactions_Update_Column>;
  where?: InputMaybe<Reel_Interactions_Bool_Exp>;
};

/** Ordering options when selecting data from "reel_interactions". */
export type Reel_Interactions_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interaction_type?: InputMaybe<Order_By>;
  interaction_value?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
  reel_interactions_reel?: InputMaybe<Reels_Order_By>;
  reel_interactions_user?: InputMaybe<Users_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: reel_interactions */
export type Reel_Interactions_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "reel_interactions" */
export enum Reel_Interactions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  InteractionType = 'interaction_type',
  /** column name */
  InteractionValue = 'interaction_value',
  /** column name */
  ReelId = 'reel_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "reel_interactions" */
export type Reel_Interactions_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  interaction_type?: InputMaybe<Scalars['String']['input']>;
  interaction_value?: InputMaybe<Scalars['String']['input']>;
  reel_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate stddev on columns */
export type Reel_Interactions_Stddev_Fields = {
  __typename?: 'reel_interactions_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "reel_interactions" */
export type Reel_Interactions_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Reel_Interactions_Stddev_Pop_Fields = {
  __typename?: 'reel_interactions_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "reel_interactions" */
export type Reel_Interactions_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Reel_Interactions_Stddev_Samp_Fields = {
  __typename?: 'reel_interactions_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "reel_interactions" */
export type Reel_Interactions_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "reel_interactions" */
export type Reel_Interactions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Reel_Interactions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Reel_Interactions_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  interaction_type?: InputMaybe<Scalars['String']['input']>;
  interaction_value?: InputMaybe<Scalars['String']['input']>;
  reel_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate sum on columns */
export type Reel_Interactions_Sum_Fields = {
  __typename?: 'reel_interactions_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  reel_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "reel_interactions" */
export type Reel_Interactions_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
};

/** update columns of table "reel_interactions" */
export enum Reel_Interactions_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  InteractionType = 'interaction_type',
  /** column name */
  InteractionValue = 'interaction_value',
  /** column name */
  ReelId = 'reel_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Reel_Interactions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Reel_Interactions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Reel_Interactions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Reel_Interactions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Reel_Interactions_Var_Pop_Fields = {
  __typename?: 'reel_interactions_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "reel_interactions" */
export type Reel_Interactions_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Reel_Interactions_Var_Samp_Fields = {
  __typename?: 'reel_interactions_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "reel_interactions" */
export type Reel_Interactions_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Reel_Interactions_Variance_Fields = {
  __typename?: 'reel_interactions_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "reel_interactions" */
export type Reel_Interactions_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "reel_stats" */
export type Reel_Stats = {
  __typename?: 'reel_stats';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  avg_watch_time_ms?: Maybe<Scalars['float8']['output']>;
  channel_id?: Maybe<Scalars['bigint']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['bigint']['output'];
  latest_at?: Maybe<Scalars['timestamptz']['output']>;
  oldest_at?: Maybe<Scalars['timestamptz']['output']>;
  playback_count?: Maybe<Scalars['bigint']['output']>;
  reach?: Maybe<Scalars['bigint']['output']>;
  reel_id: Scalars['bigint']['output'];
  total_watch_time_ms?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  view_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "reel_stats" */
export type Reel_Stats_Aggregate = {
  __typename?: 'reel_stats_aggregate';
  aggregate?: Maybe<Reel_Stats_Aggregate_Fields>;
  nodes: Array<Reel_Stats>;
};

export type Reel_Stats_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Reel_Stats_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Reel_Stats_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Reel_Stats_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Reel_Stats_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Reel_Stats_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Reel_Stats_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Reel_Stats_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Reel_Stats_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Reel_Stats_Aggregate_Bool_Exp_Var_Samp>;
};

export type Reel_Stats_Aggregate_Bool_Exp_Avg = {
  arguments: Reel_Stats_Select_Column_Reel_Stats_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reel_Stats_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Reel_Stats_Aggregate_Bool_Exp_Corr = {
  arguments: Reel_Stats_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reel_Stats_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Reel_Stats_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Reel_Stats_Select_Column_Reel_Stats_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Reel_Stats_Select_Column_Reel_Stats_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Reel_Stats_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Reel_Stats_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reel_Stats_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Reel_Stats_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Reel_Stats_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reel_Stats_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Reel_Stats_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Reel_Stats_Select_Column_Reel_Stats_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Reel_Stats_Select_Column_Reel_Stats_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Reel_Stats_Aggregate_Bool_Exp_Max = {
  arguments: Reel_Stats_Select_Column_Reel_Stats_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reel_Stats_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Reel_Stats_Aggregate_Bool_Exp_Min = {
  arguments: Reel_Stats_Select_Column_Reel_Stats_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reel_Stats_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Reel_Stats_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Reel_Stats_Select_Column_Reel_Stats_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reel_Stats_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Reel_Stats_Aggregate_Bool_Exp_Sum = {
  arguments: Reel_Stats_Select_Column_Reel_Stats_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reel_Stats_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Reel_Stats_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Reel_Stats_Select_Column_Reel_Stats_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reel_Stats_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "reel_stats" */
export type Reel_Stats_Aggregate_Fields = {
  __typename?: 'reel_stats_aggregate_fields';
  avg?: Maybe<Reel_Stats_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Reel_Stats_Max_Fields>;
  min?: Maybe<Reel_Stats_Min_Fields>;
  stddev?: Maybe<Reel_Stats_Stddev_Fields>;
  stddev_pop?: Maybe<Reel_Stats_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Reel_Stats_Stddev_Samp_Fields>;
  sum?: Maybe<Reel_Stats_Sum_Fields>;
  var_pop?: Maybe<Reel_Stats_Var_Pop_Fields>;
  var_samp?: Maybe<Reel_Stats_Var_Samp_Fields>;
  variance?: Maybe<Reel_Stats_Variance_Fields>;
};


/** aggregate fields of "reel_stats" */
export type Reel_Stats_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Reel_Stats_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "reel_stats" */
export type Reel_Stats_Aggregate_Order_By = {
  avg?: InputMaybe<Reel_Stats_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Reel_Stats_Max_Order_By>;
  min?: InputMaybe<Reel_Stats_Min_Order_By>;
  stddev?: InputMaybe<Reel_Stats_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Reel_Stats_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Reel_Stats_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Reel_Stats_Sum_Order_By>;
  var_pop?: InputMaybe<Reel_Stats_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Reel_Stats_Var_Samp_Order_By>;
  variance?: InputMaybe<Reel_Stats_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "reel_stats" */
export type Reel_Stats_Arr_Rel_Insert_Input = {
  data: Array<Reel_Stats_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Reel_Stats_On_Conflict>;
};

/** aggregate avg on columns */
export type Reel_Stats_Avg_Fields = {
  __typename?: 'reel_stats_avg_fields';
  avg_watch_time_ms?: Maybe<Scalars['Float']['output']>;
  channel_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  playback_count?: Maybe<Scalars['Float']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
  total_watch_time_ms?: Maybe<Scalars['Float']['output']>;
  view_count?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "reel_stats" */
export type Reel_Stats_Avg_Order_By = {
  avg_watch_time_ms?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  playback_count?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
  total_watch_time_ms?: InputMaybe<Order_By>;
  view_count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "reel_stats". All fields are combined with a logical 'AND'. */
export type Reel_Stats_Bool_Exp = {
  _and?: InputMaybe<Array<Reel_Stats_Bool_Exp>>;
  _not?: InputMaybe<Reel_Stats_Bool_Exp>;
  _or?: InputMaybe<Array<Reel_Stats_Bool_Exp>>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  avg_watch_time_ms?: InputMaybe<Float8_Comparison_Exp>;
  channel_id?: InputMaybe<Bigint_Comparison_Exp>;
  company_id?: InputMaybe<Bpchar_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  latest_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  oldest_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  playback_count?: InputMaybe<Bigint_Comparison_Exp>;
  reach?: InputMaybe<Bigint_Comparison_Exp>;
  reel_id?: InputMaybe<Bigint_Comparison_Exp>;
  total_watch_time_ms?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  view_count?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "reel_stats" */
export enum Reel_Stats_Constraint {
  /** unique or primary key constraint on columns "id" */
  ReelStatsPkey = 'reel_stats_pkey'
}

/** input type for incrementing numeric columns in table "reel_stats" */
export type Reel_Stats_Inc_Input = {
  avg_watch_time_ms?: InputMaybe<Scalars['float8']['input']>;
  channel_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  playback_count?: InputMaybe<Scalars['bigint']['input']>;
  reach?: InputMaybe<Scalars['bigint']['input']>;
  reel_id?: InputMaybe<Scalars['bigint']['input']>;
  total_watch_time_ms?: InputMaybe<Scalars['bigint']['input']>;
  view_count?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "reel_stats" */
export type Reel_Stats_Insert_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  avg_watch_time_ms?: InputMaybe<Scalars['float8']['input']>;
  channel_id?: InputMaybe<Scalars['bigint']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  latest_at?: InputMaybe<Scalars['timestamptz']['input']>;
  oldest_at?: InputMaybe<Scalars['timestamptz']['input']>;
  playback_count?: InputMaybe<Scalars['bigint']['input']>;
  reach?: InputMaybe<Scalars['bigint']['input']>;
  reel_id?: InputMaybe<Scalars['bigint']['input']>;
  total_watch_time_ms?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  view_count?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Reel_Stats_Max_Fields = {
  __typename?: 'reel_stats_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  avg_watch_time_ms?: Maybe<Scalars['float8']['output']>;
  channel_id?: Maybe<Scalars['bigint']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  latest_at?: Maybe<Scalars['timestamptz']['output']>;
  oldest_at?: Maybe<Scalars['timestamptz']['output']>;
  playback_count?: Maybe<Scalars['bigint']['output']>;
  reach?: Maybe<Scalars['bigint']['output']>;
  reel_id?: Maybe<Scalars['bigint']['output']>;
  total_watch_time_ms?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  view_count?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "reel_stats" */
export type Reel_Stats_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  avg_watch_time_ms?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latest_at?: InputMaybe<Order_By>;
  oldest_at?: InputMaybe<Order_By>;
  playback_count?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
  total_watch_time_ms?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  view_count?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Reel_Stats_Min_Fields = {
  __typename?: 'reel_stats_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  avg_watch_time_ms?: Maybe<Scalars['float8']['output']>;
  channel_id?: Maybe<Scalars['bigint']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  latest_at?: Maybe<Scalars['timestamptz']['output']>;
  oldest_at?: Maybe<Scalars['timestamptz']['output']>;
  playback_count?: Maybe<Scalars['bigint']['output']>;
  reach?: Maybe<Scalars['bigint']['output']>;
  reel_id?: Maybe<Scalars['bigint']['output']>;
  total_watch_time_ms?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  view_count?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "reel_stats" */
export type Reel_Stats_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  avg_watch_time_ms?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latest_at?: InputMaybe<Order_By>;
  oldest_at?: InputMaybe<Order_By>;
  playback_count?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
  total_watch_time_ms?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  view_count?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "reel_stats" */
export type Reel_Stats_Mutation_Response = {
  __typename?: 'reel_stats_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Reel_Stats>;
};

/** on_conflict condition type for table "reel_stats" */
export type Reel_Stats_On_Conflict = {
  constraint: Reel_Stats_Constraint;
  update_columns?: Array<Reel_Stats_Update_Column>;
  where?: InputMaybe<Reel_Stats_Bool_Exp>;
};

/** Ordering options when selecting data from "reel_stats". */
export type Reel_Stats_Order_By = {
  account_id?: InputMaybe<Order_By>;
  avg_watch_time_ms?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latest_at?: InputMaybe<Order_By>;
  oldest_at?: InputMaybe<Order_By>;
  playback_count?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
  total_watch_time_ms?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  view_count?: InputMaybe<Order_By>;
};

/** primary key columns input for table: reel_stats */
export type Reel_Stats_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "reel_stats" */
export enum Reel_Stats_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AvgWatchTimeMs = 'avg_watch_time_ms',
  /** column name */
  ChannelId = 'channel_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LatestAt = 'latest_at',
  /** column name */
  OldestAt = 'oldest_at',
  /** column name */
  PlaybackCount = 'playback_count',
  /** column name */
  Reach = 'reach',
  /** column name */
  ReelId = 'reel_id',
  /** column name */
  TotalWatchTimeMs = 'total_watch_time_ms',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ViewCount = 'view_count'
}

/** select "reel_stats_aggregate_bool_exp_avg_arguments_columns" columns of table "reel_stats" */
export enum Reel_Stats_Select_Column_Reel_Stats_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  AvgWatchTimeMs = 'avg_watch_time_ms'
}

/** select "reel_stats_aggregate_bool_exp_corr_arguments_columns" columns of table "reel_stats" */
export enum Reel_Stats_Select_Column_Reel_Stats_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  AvgWatchTimeMs = 'avg_watch_time_ms'
}

/** select "reel_stats_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "reel_stats" */
export enum Reel_Stats_Select_Column_Reel_Stats_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  AvgWatchTimeMs = 'avg_watch_time_ms'
}

/** select "reel_stats_aggregate_bool_exp_max_arguments_columns" columns of table "reel_stats" */
export enum Reel_Stats_Select_Column_Reel_Stats_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  AvgWatchTimeMs = 'avg_watch_time_ms'
}

/** select "reel_stats_aggregate_bool_exp_min_arguments_columns" columns of table "reel_stats" */
export enum Reel_Stats_Select_Column_Reel_Stats_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  AvgWatchTimeMs = 'avg_watch_time_ms'
}

/** select "reel_stats_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "reel_stats" */
export enum Reel_Stats_Select_Column_Reel_Stats_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  AvgWatchTimeMs = 'avg_watch_time_ms'
}

/** select "reel_stats_aggregate_bool_exp_sum_arguments_columns" columns of table "reel_stats" */
export enum Reel_Stats_Select_Column_Reel_Stats_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  AvgWatchTimeMs = 'avg_watch_time_ms'
}

/** select "reel_stats_aggregate_bool_exp_var_samp_arguments_columns" columns of table "reel_stats" */
export enum Reel_Stats_Select_Column_Reel_Stats_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  AvgWatchTimeMs = 'avg_watch_time_ms'
}

/** input type for updating data in table "reel_stats" */
export type Reel_Stats_Set_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  avg_watch_time_ms?: InputMaybe<Scalars['float8']['input']>;
  channel_id?: InputMaybe<Scalars['bigint']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  latest_at?: InputMaybe<Scalars['timestamptz']['input']>;
  oldest_at?: InputMaybe<Scalars['timestamptz']['input']>;
  playback_count?: InputMaybe<Scalars['bigint']['input']>;
  reach?: InputMaybe<Scalars['bigint']['input']>;
  reel_id?: InputMaybe<Scalars['bigint']['input']>;
  total_watch_time_ms?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  view_count?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Reel_Stats_Stddev_Fields = {
  __typename?: 'reel_stats_stddev_fields';
  avg_watch_time_ms?: Maybe<Scalars['Float']['output']>;
  channel_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  playback_count?: Maybe<Scalars['Float']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
  total_watch_time_ms?: Maybe<Scalars['Float']['output']>;
  view_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "reel_stats" */
export type Reel_Stats_Stddev_Order_By = {
  avg_watch_time_ms?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  playback_count?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
  total_watch_time_ms?: InputMaybe<Order_By>;
  view_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Reel_Stats_Stddev_Pop_Fields = {
  __typename?: 'reel_stats_stddev_pop_fields';
  avg_watch_time_ms?: Maybe<Scalars['Float']['output']>;
  channel_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  playback_count?: Maybe<Scalars['Float']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
  total_watch_time_ms?: Maybe<Scalars['Float']['output']>;
  view_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "reel_stats" */
export type Reel_Stats_Stddev_Pop_Order_By = {
  avg_watch_time_ms?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  playback_count?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
  total_watch_time_ms?: InputMaybe<Order_By>;
  view_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Reel_Stats_Stddev_Samp_Fields = {
  __typename?: 'reel_stats_stddev_samp_fields';
  avg_watch_time_ms?: Maybe<Scalars['Float']['output']>;
  channel_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  playback_count?: Maybe<Scalars['Float']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
  total_watch_time_ms?: Maybe<Scalars['Float']['output']>;
  view_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "reel_stats" */
export type Reel_Stats_Stddev_Samp_Order_By = {
  avg_watch_time_ms?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  playback_count?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
  total_watch_time_ms?: InputMaybe<Order_By>;
  view_count?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "reel_stats" */
export type Reel_Stats_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Reel_Stats_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Reel_Stats_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  avg_watch_time_ms?: InputMaybe<Scalars['float8']['input']>;
  channel_id?: InputMaybe<Scalars['bigint']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  latest_at?: InputMaybe<Scalars['timestamptz']['input']>;
  oldest_at?: InputMaybe<Scalars['timestamptz']['input']>;
  playback_count?: InputMaybe<Scalars['bigint']['input']>;
  reach?: InputMaybe<Scalars['bigint']['input']>;
  reel_id?: InputMaybe<Scalars['bigint']['input']>;
  total_watch_time_ms?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  view_count?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Reel_Stats_Sum_Fields = {
  __typename?: 'reel_stats_sum_fields';
  avg_watch_time_ms?: Maybe<Scalars['float8']['output']>;
  channel_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  playback_count?: Maybe<Scalars['bigint']['output']>;
  reach?: Maybe<Scalars['bigint']['output']>;
  reel_id?: Maybe<Scalars['bigint']['output']>;
  total_watch_time_ms?: Maybe<Scalars['bigint']['output']>;
  view_count?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "reel_stats" */
export type Reel_Stats_Sum_Order_By = {
  avg_watch_time_ms?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  playback_count?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
  total_watch_time_ms?: InputMaybe<Order_By>;
  view_count?: InputMaybe<Order_By>;
};

/** update columns of table "reel_stats" */
export enum Reel_Stats_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AvgWatchTimeMs = 'avg_watch_time_ms',
  /** column name */
  ChannelId = 'channel_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LatestAt = 'latest_at',
  /** column name */
  OldestAt = 'oldest_at',
  /** column name */
  PlaybackCount = 'playback_count',
  /** column name */
  Reach = 'reach',
  /** column name */
  ReelId = 'reel_id',
  /** column name */
  TotalWatchTimeMs = 'total_watch_time_ms',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ViewCount = 'view_count'
}

export type Reel_Stats_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Reel_Stats_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Reel_Stats_Set_Input>;
  /** filter the rows which have to be updated */
  where: Reel_Stats_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Reel_Stats_Var_Pop_Fields = {
  __typename?: 'reel_stats_var_pop_fields';
  avg_watch_time_ms?: Maybe<Scalars['Float']['output']>;
  channel_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  playback_count?: Maybe<Scalars['Float']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
  total_watch_time_ms?: Maybe<Scalars['Float']['output']>;
  view_count?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "reel_stats" */
export type Reel_Stats_Var_Pop_Order_By = {
  avg_watch_time_ms?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  playback_count?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
  total_watch_time_ms?: InputMaybe<Order_By>;
  view_count?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Reel_Stats_Var_Samp_Fields = {
  __typename?: 'reel_stats_var_samp_fields';
  avg_watch_time_ms?: Maybe<Scalars['Float']['output']>;
  channel_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  playback_count?: Maybe<Scalars['Float']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
  total_watch_time_ms?: Maybe<Scalars['Float']['output']>;
  view_count?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "reel_stats" */
export type Reel_Stats_Var_Samp_Order_By = {
  avg_watch_time_ms?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  playback_count?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
  total_watch_time_ms?: InputMaybe<Order_By>;
  view_count?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Reel_Stats_Variance_Fields = {
  __typename?: 'reel_stats_variance_fields';
  avg_watch_time_ms?: Maybe<Scalars['Float']['output']>;
  channel_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  playback_count?: Maybe<Scalars['Float']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
  total_watch_time_ms?: Maybe<Scalars['Float']['output']>;
  view_count?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "reel_stats" */
export type Reel_Stats_Variance_Order_By = {
  avg_watch_time_ms?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  playback_count?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
  total_watch_time_ms?: InputMaybe<Order_By>;
  view_count?: InputMaybe<Order_By>;
};

/** columns and relationships of "reel_user_reports" */
export type Reel_User_Reports = {
  __typename?: 'reel_user_reports';
  comment_id: Scalars['Int']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  feedback?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  reel_id: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id: Scalars['String']['output'];
};

/** aggregated selection of "reel_user_reports" */
export type Reel_User_Reports_Aggregate = {
  __typename?: 'reel_user_reports_aggregate';
  aggregate?: Maybe<Reel_User_Reports_Aggregate_Fields>;
  nodes: Array<Reel_User_Reports>;
};

export type Reel_User_Reports_Aggregate_Bool_Exp = {
  count?: InputMaybe<Reel_User_Reports_Aggregate_Bool_Exp_Count>;
};

export type Reel_User_Reports_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Reel_User_Reports_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reel_User_Reports_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "reel_user_reports" */
export type Reel_User_Reports_Aggregate_Fields = {
  __typename?: 'reel_user_reports_aggregate_fields';
  avg?: Maybe<Reel_User_Reports_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Reel_User_Reports_Max_Fields>;
  min?: Maybe<Reel_User_Reports_Min_Fields>;
  stddev?: Maybe<Reel_User_Reports_Stddev_Fields>;
  stddev_pop?: Maybe<Reel_User_Reports_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Reel_User_Reports_Stddev_Samp_Fields>;
  sum?: Maybe<Reel_User_Reports_Sum_Fields>;
  var_pop?: Maybe<Reel_User_Reports_Var_Pop_Fields>;
  var_samp?: Maybe<Reel_User_Reports_Var_Samp_Fields>;
  variance?: Maybe<Reel_User_Reports_Variance_Fields>;
};


/** aggregate fields of "reel_user_reports" */
export type Reel_User_Reports_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Reel_User_Reports_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "reel_user_reports" */
export type Reel_User_Reports_Aggregate_Order_By = {
  avg?: InputMaybe<Reel_User_Reports_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Reel_User_Reports_Max_Order_By>;
  min?: InputMaybe<Reel_User_Reports_Min_Order_By>;
  stddev?: InputMaybe<Reel_User_Reports_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Reel_User_Reports_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Reel_User_Reports_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Reel_User_Reports_Sum_Order_By>;
  var_pop?: InputMaybe<Reel_User_Reports_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Reel_User_Reports_Var_Samp_Order_By>;
  variance?: InputMaybe<Reel_User_Reports_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "reel_user_reports" */
export type Reel_User_Reports_Arr_Rel_Insert_Input = {
  data: Array<Reel_User_Reports_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Reel_User_Reports_On_Conflict>;
};

/** aggregate avg on columns */
export type Reel_User_Reports_Avg_Fields = {
  __typename?: 'reel_user_reports_avg_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "reel_user_reports" */
export type Reel_User_Reports_Avg_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "reel_user_reports". All fields are combined with a logical 'AND'. */
export type Reel_User_Reports_Bool_Exp = {
  _and?: InputMaybe<Array<Reel_User_Reports_Bool_Exp>>;
  _not?: InputMaybe<Reel_User_Reports_Bool_Exp>;
  _or?: InputMaybe<Array<Reel_User_Reports_Bool_Exp>>;
  comment_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  feedback?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  reel_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "reel_user_reports" */
export enum Reel_User_Reports_Constraint {
  /** unique or primary key constraint on columns "id" */
  ReelUserReportsPkey = 'reel_user_reports_pkey'
}

/** input type for incrementing numeric columns in table "reel_user_reports" */
export type Reel_User_Reports_Inc_Input = {
  comment_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  reel_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "reel_user_reports" */
export type Reel_User_Reports_Insert_Input = {
  comment_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  reel_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Reel_User_Reports_Max_Fields = {
  __typename?: 'reel_user_reports_max_fields';
  comment_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  feedback?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  reel_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "reel_user_reports" */
export type Reel_User_Reports_Max_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  feedback?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Reel_User_Reports_Min_Fields = {
  __typename?: 'reel_user_reports_min_fields';
  comment_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  feedback?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  reel_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "reel_user_reports" */
export type Reel_User_Reports_Min_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  feedback?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "reel_user_reports" */
export type Reel_User_Reports_Mutation_Response = {
  __typename?: 'reel_user_reports_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Reel_User_Reports>;
};

/** on_conflict condition type for table "reel_user_reports" */
export type Reel_User_Reports_On_Conflict = {
  constraint: Reel_User_Reports_Constraint;
  update_columns?: Array<Reel_User_Reports_Update_Column>;
  where?: InputMaybe<Reel_User_Reports_Bool_Exp>;
};

/** Ordering options when selecting data from "reel_user_reports". */
export type Reel_User_Reports_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  feedback?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: reel_user_reports */
export type Reel_User_Reports_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "reel_user_reports" */
export enum Reel_User_Reports_Select_Column {
  /** column name */
  CommentId = 'comment_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Feedback = 'feedback',
  /** column name */
  Id = 'id',
  /** column name */
  ReelId = 'reel_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "reel_user_reports" */
export type Reel_User_Reports_Set_Input = {
  comment_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  reel_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Reel_User_Reports_Stddev_Fields = {
  __typename?: 'reel_user_reports_stddev_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "reel_user_reports" */
export type Reel_User_Reports_Stddev_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Reel_User_Reports_Stddev_Pop_Fields = {
  __typename?: 'reel_user_reports_stddev_pop_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "reel_user_reports" */
export type Reel_User_Reports_Stddev_Pop_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Reel_User_Reports_Stddev_Samp_Fields = {
  __typename?: 'reel_user_reports_stddev_samp_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "reel_user_reports" */
export type Reel_User_Reports_Stddev_Samp_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "reel_user_reports" */
export type Reel_User_Reports_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Reel_User_Reports_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Reel_User_Reports_Stream_Cursor_Value_Input = {
  comment_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  reel_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Reel_User_Reports_Sum_Fields = {
  __typename?: 'reel_user_reports_sum_fields';
  comment_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  reel_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "reel_user_reports" */
export type Reel_User_Reports_Sum_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
};

/** update columns of table "reel_user_reports" */
export enum Reel_User_Reports_Update_Column {
  /** column name */
  CommentId = 'comment_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Feedback = 'feedback',
  /** column name */
  Id = 'id',
  /** column name */
  ReelId = 'reel_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Reel_User_Reports_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Reel_User_Reports_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Reel_User_Reports_Set_Input>;
  /** filter the rows which have to be updated */
  where: Reel_User_Reports_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Reel_User_Reports_Var_Pop_Fields = {
  __typename?: 'reel_user_reports_var_pop_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "reel_user_reports" */
export type Reel_User_Reports_Var_Pop_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Reel_User_Reports_Var_Samp_Fields = {
  __typename?: 'reel_user_reports_var_samp_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "reel_user_reports" */
export type Reel_User_Reports_Var_Samp_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Reel_User_Reports_Variance_Fields = {
  __typename?: 'reel_user_reports_variance_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "reel_user_reports" */
export type Reel_User_Reports_Variance_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "reels" */
export type Reels = {
  __typename?: 'reels';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  allow_comments: Scalars['Boolean']['output'];
  allow_downloads: Scalars['Boolean']['output'];
  allow_likes: Scalars['Boolean']['output'];
  allow_reactions: Scalars['Boolean']['output'];
  allow_reports: Scalars['Boolean']['output'];
  allow_shares: Scalars['Boolean']['output'];
  category_id?: Maybe<Scalars['bigint']['output']>;
  channel_id?: Maybe<Scalars['bigint']['output']>;
  cloudflare_id?: Maybe<Scalars['String']['output']>;
  cloudflare_playback_url?: Maybe<Scalars['String']['output']>;
  cloudflare_preview_url?: Maybe<Scalars['String']['output']>;
  cloudflare_thumbnail_url?: Maybe<Scalars['String']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crop_id?: Maybe<Scalars['bpchar']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  districts_json?: Maybe<Scalars['jsonb']['output']>;
  duration_ms?: Maybe<Scalars['bigint']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  file_size?: Maybe<Scalars['String']['output']>;
  google_places_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  language?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  likes?: Maybe<Scalars['Int']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  location?: Maybe<Scalars['geography']['output']>;
  reactions?: Maybe<Scalars['json']['output']>;
  reactions_count?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  reel_category?: Maybe<Reel_Category>;
  /** An array relationship */
  reel_comments: Array<Reel_Comments>;
  /** An aggregate relationship */
  reel_comments_aggregate: Reel_Comments_Aggregate;
  /** An object relationship */
  reels_channel?: Maybe<Channels>;
  /** An array relationship */
  reels_reel_interactions: Array<Reel_Interactions>;
  /** An aggregate relationship */
  reels_reel_interactions_aggregate: Reel_Interactions_Aggregate;
  /** An array relationship */
  reels_reel_stats: Array<Reel_Stats>;
  /** An aggregate relationship */
  reels_reel_stats_aggregate: Reel_Stats_Aggregate;
  /** An array relationship */
  reels_saved_reels: Array<Saved_Reels>;
  /** An aggregate relationship */
  reels_saved_reels_aggregate: Saved_Reels_Aggregate;
  /** An array relationship */
  reels_taggables: Array<Taggables>;
  /** An aggregate relationship */
  reels_taggables_aggregate: Taggables_Aggregate;
  /** An object relationship */
  reels_user?: Maybe<Users>;
  restrict_geo: Scalars['Boolean']['output'];
  s3_path?: Maybe<Scalars['String']['output']>;
  scheduled_at?: Maybe<Scalars['timestamp']['output']>;
  shares?: Maybe<Scalars['Int']['output']>;
  targeted_area?: Maybe<Scalars['String']['output']>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total_watch_time_secs: Scalars['bigint']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "reels" */
export type ReelsDistricts_JsonArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "reels" */
export type ReelsReactionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "reels" */
export type ReelsReel_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Reel_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_Comments_Order_By>>;
  where?: InputMaybe<Reel_Comments_Bool_Exp>;
};


/** columns and relationships of "reels" */
export type ReelsReel_Comments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reel_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_Comments_Order_By>>;
  where?: InputMaybe<Reel_Comments_Bool_Exp>;
};


/** columns and relationships of "reels" */
export type ReelsReels_Reel_InteractionsArgs = {
  distinct_on?: InputMaybe<Array<Reel_Interactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_Interactions_Order_By>>;
  where?: InputMaybe<Reel_Interactions_Bool_Exp>;
};


/** columns and relationships of "reels" */
export type ReelsReels_Reel_Interactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reel_Interactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_Interactions_Order_By>>;
  where?: InputMaybe<Reel_Interactions_Bool_Exp>;
};


/** columns and relationships of "reels" */
export type ReelsReels_Reel_StatsArgs = {
  distinct_on?: InputMaybe<Array<Reel_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_Stats_Order_By>>;
  where?: InputMaybe<Reel_Stats_Bool_Exp>;
};


/** columns and relationships of "reels" */
export type ReelsReels_Reel_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reel_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_Stats_Order_By>>;
  where?: InputMaybe<Reel_Stats_Bool_Exp>;
};


/** columns and relationships of "reels" */
export type ReelsReels_Saved_ReelsArgs = {
  distinct_on?: InputMaybe<Array<Saved_Reels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Saved_Reels_Order_By>>;
  where?: InputMaybe<Saved_Reels_Bool_Exp>;
};


/** columns and relationships of "reels" */
export type ReelsReels_Saved_Reels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Saved_Reels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Saved_Reels_Order_By>>;
  where?: InputMaybe<Saved_Reels_Bool_Exp>;
};


/** columns and relationships of "reels" */
export type ReelsReels_TaggablesArgs = {
  distinct_on?: InputMaybe<Array<Taggables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taggables_Order_By>>;
  where?: InputMaybe<Taggables_Bool_Exp>;
};


/** columns and relationships of "reels" */
export type ReelsReels_Taggables_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Taggables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taggables_Order_By>>;
  where?: InputMaybe<Taggables_Bool_Exp>;
};

/** aggregated selection of "reels" */
export type Reels_Aggregate = {
  __typename?: 'reels_aggregate';
  aggregate?: Maybe<Reels_Aggregate_Fields>;
  nodes: Array<Reels>;
};

export type Reels_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Reels_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Reels_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Reels_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Reels_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Reels_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Reels_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Reels_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Reels_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Reels_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Reels_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Reels_Aggregate_Bool_Exp_Var_Samp>;
};

export type Reels_Aggregate_Bool_Exp_Avg = {
  arguments: Reels_Select_Column_Reels_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reels_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Reels_Aggregate_Bool_Exp_Bool_And = {
  arguments: Reels_Select_Column_Reels_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reels_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Reels_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Reels_Select_Column_Reels_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reels_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Reels_Aggregate_Bool_Exp_Corr = {
  arguments: Reels_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reels_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Reels_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Reels_Select_Column_Reels_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Reels_Select_Column_Reels_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Reels_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Reels_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reels_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Reels_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Reels_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reels_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Reels_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Reels_Select_Column_Reels_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Reels_Select_Column_Reels_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Reels_Aggregate_Bool_Exp_Max = {
  arguments: Reels_Select_Column_Reels_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reels_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Reels_Aggregate_Bool_Exp_Min = {
  arguments: Reels_Select_Column_Reels_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reels_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Reels_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Reels_Select_Column_Reels_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reels_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Reels_Aggregate_Bool_Exp_Sum = {
  arguments: Reels_Select_Column_Reels_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reels_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Reels_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Reels_Select_Column_Reels_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reels_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "reels" */
export type Reels_Aggregate_Fields = {
  __typename?: 'reels_aggregate_fields';
  avg?: Maybe<Reels_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Reels_Max_Fields>;
  min?: Maybe<Reels_Min_Fields>;
  stddev?: Maybe<Reels_Stddev_Fields>;
  stddev_pop?: Maybe<Reels_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Reels_Stddev_Samp_Fields>;
  sum?: Maybe<Reels_Sum_Fields>;
  var_pop?: Maybe<Reels_Var_Pop_Fields>;
  var_samp?: Maybe<Reels_Var_Samp_Fields>;
  variance?: Maybe<Reels_Variance_Fields>;
};


/** aggregate fields of "reels" */
export type Reels_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Reels_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "reels" */
export type Reels_Aggregate_Order_By = {
  avg?: InputMaybe<Reels_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Reels_Max_Order_By>;
  min?: InputMaybe<Reels_Min_Order_By>;
  stddev?: InputMaybe<Reels_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Reels_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Reels_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Reels_Sum_Order_By>;
  var_pop?: InputMaybe<Reels_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Reels_Var_Samp_Order_By>;
  variance?: InputMaybe<Reels_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Reels_Append_Input = {
  districts_json?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "reels" */
export type Reels_Arr_Rel_Insert_Input = {
  data: Array<Reels_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Reels_On_Conflict>;
};

/** aggregate avg on columns */
export type Reels_Avg_Fields = {
  __typename?: 'reels_avg_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  channel_id?: Maybe<Scalars['Float']['output']>;
  duration_ms?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  likes?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  reactions_count?: Maybe<Scalars['Float']['output']>;
  shares?: Maybe<Scalars['Float']['output']>;
  total_watch_time_secs?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "reels" */
export type Reels_Avg_Order_By = {
  category_id?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  duration_ms?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  likes?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  reactions_count?: InputMaybe<Order_By>;
  shares?: InputMaybe<Order_By>;
  total_watch_time_secs?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "reels". All fields are combined with a logical 'AND'. */
export type Reels_Bool_Exp = {
  _and?: InputMaybe<Array<Reels_Bool_Exp>>;
  _not?: InputMaybe<Reels_Bool_Exp>;
  _or?: InputMaybe<Array<Reels_Bool_Exp>>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  allow_comments?: InputMaybe<Boolean_Comparison_Exp>;
  allow_downloads?: InputMaybe<Boolean_Comparison_Exp>;
  allow_likes?: InputMaybe<Boolean_Comparison_Exp>;
  allow_reactions?: InputMaybe<Boolean_Comparison_Exp>;
  allow_reports?: InputMaybe<Boolean_Comparison_Exp>;
  allow_shares?: InputMaybe<Boolean_Comparison_Exp>;
  category_id?: InputMaybe<Bigint_Comparison_Exp>;
  channel_id?: InputMaybe<Bigint_Comparison_Exp>;
  cloudflare_id?: InputMaybe<String_Comparison_Exp>;
  cloudflare_playback_url?: InputMaybe<String_Comparison_Exp>;
  cloudflare_preview_url?: InputMaybe<String_Comparison_Exp>;
  cloudflare_thumbnail_url?: InputMaybe<String_Comparison_Exp>;
  company_id?: InputMaybe<Bpchar_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  crop_id?: InputMaybe<Bpchar_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  districts_json?: InputMaybe<Jsonb_Comparison_Exp>;
  duration_ms?: InputMaybe<Bigint_Comparison_Exp>;
  file_name?: InputMaybe<String_Comparison_Exp>;
  file_size?: InputMaybe<String_Comparison_Exp>;
  google_places_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  language?: InputMaybe<String_Comparison_Exp>;
  lat?: InputMaybe<Float8_Comparison_Exp>;
  likes?: InputMaybe<Int_Comparison_Exp>;
  lng?: InputMaybe<Float8_Comparison_Exp>;
  location?: InputMaybe<Geography_Comparison_Exp>;
  reactions?: InputMaybe<Json_Comparison_Exp>;
  reactions_count?: InputMaybe<Int_Comparison_Exp>;
  reel_category?: InputMaybe<Reel_Category_Bool_Exp>;
  reel_comments?: InputMaybe<Reel_Comments_Bool_Exp>;
  reel_comments_aggregate?: InputMaybe<Reel_Comments_Aggregate_Bool_Exp>;
  reels_channel?: InputMaybe<Channels_Bool_Exp>;
  reels_reel_interactions?: InputMaybe<Reel_Interactions_Bool_Exp>;
  reels_reel_interactions_aggregate?: InputMaybe<Reel_Interactions_Aggregate_Bool_Exp>;
  reels_reel_stats?: InputMaybe<Reel_Stats_Bool_Exp>;
  reels_reel_stats_aggregate?: InputMaybe<Reel_Stats_Aggregate_Bool_Exp>;
  reels_saved_reels?: InputMaybe<Saved_Reels_Bool_Exp>;
  reels_saved_reels_aggregate?: InputMaybe<Saved_Reels_Aggregate_Bool_Exp>;
  reels_taggables?: InputMaybe<Taggables_Bool_Exp>;
  reels_taggables_aggregate?: InputMaybe<Taggables_Aggregate_Bool_Exp>;
  reels_user?: InputMaybe<Users_Bool_Exp>;
  restrict_geo?: InputMaybe<Boolean_Comparison_Exp>;
  s3_path?: InputMaybe<String_Comparison_Exp>;
  scheduled_at?: InputMaybe<Timestamp_Comparison_Exp>;
  shares?: InputMaybe<Int_Comparison_Exp>;
  targeted_area?: InputMaybe<String_Comparison_Exp>;
  thumbnail_url?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  total_watch_time_secs?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  views?: InputMaybe<Int_Comparison_Exp>;
  visibility?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "reels" */
export enum Reels_Constraint {
  /** unique or primary key constraint on columns "id" */
  ReelsPkey = 'reels_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Reels_Delete_At_Path_Input = {
  districts_json?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Reels_Delete_Elem_Input = {
  districts_json?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Reels_Delete_Key_Input = {
  districts_json?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "reels" */
export type Reels_Inc_Input = {
  category_id?: InputMaybe<Scalars['bigint']['input']>;
  channel_id?: InputMaybe<Scalars['bigint']['input']>;
  duration_ms?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  likes?: InputMaybe<Scalars['Int']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  reactions_count?: InputMaybe<Scalars['Int']['input']>;
  shares?: InputMaybe<Scalars['Int']['input']>;
  total_watch_time_secs?: InputMaybe<Scalars['bigint']['input']>;
  views?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "reels" */
export type Reels_Insert_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  allow_comments?: InputMaybe<Scalars['Boolean']['input']>;
  allow_downloads?: InputMaybe<Scalars['Boolean']['input']>;
  allow_likes?: InputMaybe<Scalars['Boolean']['input']>;
  allow_reactions?: InputMaybe<Scalars['Boolean']['input']>;
  allow_reports?: InputMaybe<Scalars['Boolean']['input']>;
  allow_shares?: InputMaybe<Scalars['Boolean']['input']>;
  category_id?: InputMaybe<Scalars['bigint']['input']>;
  channel_id?: InputMaybe<Scalars['bigint']['input']>;
  cloudflare_id?: InputMaybe<Scalars['String']['input']>;
  cloudflare_playback_url?: InputMaybe<Scalars['String']['input']>;
  cloudflare_preview_url?: InputMaybe<Scalars['String']['input']>;
  cloudflare_thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crop_id?: InputMaybe<Scalars['bpchar']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  districts_json?: InputMaybe<Scalars['jsonb']['input']>;
  duration_ms?: InputMaybe<Scalars['bigint']['input']>;
  file_name?: InputMaybe<Scalars['String']['input']>;
  file_size?: InputMaybe<Scalars['String']['input']>;
  google_places_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  likes?: InputMaybe<Scalars['Int']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  location?: InputMaybe<Scalars['geography']['input']>;
  reactions?: InputMaybe<Scalars['json']['input']>;
  reactions_count?: InputMaybe<Scalars['Int']['input']>;
  reel_category?: InputMaybe<Reel_Category_Obj_Rel_Insert_Input>;
  reel_comments?: InputMaybe<Reel_Comments_Arr_Rel_Insert_Input>;
  reels_channel?: InputMaybe<Channels_Obj_Rel_Insert_Input>;
  reels_reel_interactions?: InputMaybe<Reel_Interactions_Arr_Rel_Insert_Input>;
  reels_reel_stats?: InputMaybe<Reel_Stats_Arr_Rel_Insert_Input>;
  reels_saved_reels?: InputMaybe<Saved_Reels_Arr_Rel_Insert_Input>;
  reels_taggables?: InputMaybe<Taggables_Arr_Rel_Insert_Input>;
  reels_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  restrict_geo?: InputMaybe<Scalars['Boolean']['input']>;
  s3_path?: InputMaybe<Scalars['String']['input']>;
  scheduled_at?: InputMaybe<Scalars['timestamp']['input']>;
  shares?: InputMaybe<Scalars['Int']['input']>;
  targeted_area?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  total_watch_time_secs?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
  views?: InputMaybe<Scalars['Int']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Reels_Max_Fields = {
  __typename?: 'reels_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  category_id?: Maybe<Scalars['bigint']['output']>;
  channel_id?: Maybe<Scalars['bigint']['output']>;
  cloudflare_id?: Maybe<Scalars['String']['output']>;
  cloudflare_playback_url?: Maybe<Scalars['String']['output']>;
  cloudflare_preview_url?: Maybe<Scalars['String']['output']>;
  cloudflare_thumbnail_url?: Maybe<Scalars['String']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crop_id?: Maybe<Scalars['bpchar']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration_ms?: Maybe<Scalars['bigint']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  file_size?: Maybe<Scalars['String']['output']>;
  google_places_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  likes?: Maybe<Scalars['Int']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  reactions_count?: Maybe<Scalars['Int']['output']>;
  s3_path?: Maybe<Scalars['String']['output']>;
  scheduled_at?: Maybe<Scalars['timestamp']['output']>;
  shares?: Maybe<Scalars['Int']['output']>;
  targeted_area?: Maybe<Scalars['String']['output']>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total_watch_time_secs?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "reels" */
export type Reels_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  cloudflare_id?: InputMaybe<Order_By>;
  cloudflare_playback_url?: InputMaybe<Order_By>;
  cloudflare_preview_url?: InputMaybe<Order_By>;
  cloudflare_thumbnail_url?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  duration_ms?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  file_size?: InputMaybe<Order_By>;
  google_places_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  likes?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  reactions_count?: InputMaybe<Order_By>;
  s3_path?: InputMaybe<Order_By>;
  scheduled_at?: InputMaybe<Order_By>;
  shares?: InputMaybe<Order_By>;
  targeted_area?: InputMaybe<Order_By>;
  thumbnail_url?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  total_watch_time_secs?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
  visibility?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Reels_Min_Fields = {
  __typename?: 'reels_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  category_id?: Maybe<Scalars['bigint']['output']>;
  channel_id?: Maybe<Scalars['bigint']['output']>;
  cloudflare_id?: Maybe<Scalars['String']['output']>;
  cloudflare_playback_url?: Maybe<Scalars['String']['output']>;
  cloudflare_preview_url?: Maybe<Scalars['String']['output']>;
  cloudflare_thumbnail_url?: Maybe<Scalars['String']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crop_id?: Maybe<Scalars['bpchar']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration_ms?: Maybe<Scalars['bigint']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  file_size?: Maybe<Scalars['String']['output']>;
  google_places_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  likes?: Maybe<Scalars['Int']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  reactions_count?: Maybe<Scalars['Int']['output']>;
  s3_path?: Maybe<Scalars['String']['output']>;
  scheduled_at?: Maybe<Scalars['timestamp']['output']>;
  shares?: Maybe<Scalars['Int']['output']>;
  targeted_area?: Maybe<Scalars['String']['output']>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total_watch_time_secs?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "reels" */
export type Reels_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  cloudflare_id?: InputMaybe<Order_By>;
  cloudflare_playback_url?: InputMaybe<Order_By>;
  cloudflare_preview_url?: InputMaybe<Order_By>;
  cloudflare_thumbnail_url?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  duration_ms?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  file_size?: InputMaybe<Order_By>;
  google_places_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  likes?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  reactions_count?: InputMaybe<Order_By>;
  s3_path?: InputMaybe<Order_By>;
  scheduled_at?: InputMaybe<Order_By>;
  shares?: InputMaybe<Order_By>;
  targeted_area?: InputMaybe<Order_By>;
  thumbnail_url?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  total_watch_time_secs?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
  visibility?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "reels" */
export type Reels_Mutation_Response = {
  __typename?: 'reels_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Reels>;
};

/** input type for inserting object relation for remote table "reels" */
export type Reels_Obj_Rel_Insert_Input = {
  data: Reels_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Reels_On_Conflict>;
};

/** on_conflict condition type for table "reels" */
export type Reels_On_Conflict = {
  constraint: Reels_Constraint;
  update_columns?: Array<Reels_Update_Column>;
  where?: InputMaybe<Reels_Bool_Exp>;
};

/** Ordering options when selecting data from "reels". */
export type Reels_Order_By = {
  account_id?: InputMaybe<Order_By>;
  allow_comments?: InputMaybe<Order_By>;
  allow_downloads?: InputMaybe<Order_By>;
  allow_likes?: InputMaybe<Order_By>;
  allow_reactions?: InputMaybe<Order_By>;
  allow_reports?: InputMaybe<Order_By>;
  allow_shares?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  cloudflare_id?: InputMaybe<Order_By>;
  cloudflare_playback_url?: InputMaybe<Order_By>;
  cloudflare_preview_url?: InputMaybe<Order_By>;
  cloudflare_thumbnail_url?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  districts_json?: InputMaybe<Order_By>;
  duration_ms?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  file_size?: InputMaybe<Order_By>;
  google_places_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  likes?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  reactions?: InputMaybe<Order_By>;
  reactions_count?: InputMaybe<Order_By>;
  reel_category?: InputMaybe<Reel_Category_Order_By>;
  reel_comments_aggregate?: InputMaybe<Reel_Comments_Aggregate_Order_By>;
  reels_channel?: InputMaybe<Channels_Order_By>;
  reels_reel_interactions_aggregate?: InputMaybe<Reel_Interactions_Aggregate_Order_By>;
  reels_reel_stats_aggregate?: InputMaybe<Reel_Stats_Aggregate_Order_By>;
  reels_saved_reels_aggregate?: InputMaybe<Saved_Reels_Aggregate_Order_By>;
  reels_taggables_aggregate?: InputMaybe<Taggables_Aggregate_Order_By>;
  reels_user?: InputMaybe<Users_Order_By>;
  restrict_geo?: InputMaybe<Order_By>;
  s3_path?: InputMaybe<Order_By>;
  scheduled_at?: InputMaybe<Order_By>;
  shares?: InputMaybe<Order_By>;
  targeted_area?: InputMaybe<Order_By>;
  thumbnail_url?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  total_watch_time_secs?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
  visibility?: InputMaybe<Order_By>;
};

/** primary key columns input for table: reels */
export type Reels_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Reels_Prepend_Input = {
  districts_json?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "reels" */
export enum Reels_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AllowComments = 'allow_comments',
  /** column name */
  AllowDownloads = 'allow_downloads',
  /** column name */
  AllowLikes = 'allow_likes',
  /** column name */
  AllowReactions = 'allow_reactions',
  /** column name */
  AllowReports = 'allow_reports',
  /** column name */
  AllowShares = 'allow_shares',
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  ChannelId = 'channel_id',
  /** column name */
  CloudflareId = 'cloudflare_id',
  /** column name */
  CloudflarePlaybackUrl = 'cloudflare_playback_url',
  /** column name */
  CloudflarePreviewUrl = 'cloudflare_preview_url',
  /** column name */
  CloudflareThumbnailUrl = 'cloudflare_thumbnail_url',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  DistrictsJson = 'districts_json',
  /** column name */
  DurationMs = 'duration_ms',
  /** column name */
  FileName = 'file_name',
  /** column name */
  FileSize = 'file_size',
  /** column name */
  GooglePlacesId = 'google_places_id',
  /** column name */
  Id = 'id',
  /** column name */
  Language = 'language',
  /** column name */
  Lat = 'lat',
  /** column name */
  Likes = 'likes',
  /** column name */
  Lng = 'lng',
  /** column name */
  Location = 'location',
  /** column name */
  Reactions = 'reactions',
  /** column name */
  ReactionsCount = 'reactions_count',
  /** column name */
  RestrictGeo = 'restrict_geo',
  /** column name */
  S3Path = 's3_path',
  /** column name */
  ScheduledAt = 'scheduled_at',
  /** column name */
  Shares = 'shares',
  /** column name */
  TargetedArea = 'targeted_area',
  /** column name */
  ThumbnailUrl = 'thumbnail_url',
  /** column name */
  Title = 'title',
  /** column name */
  TotalWatchTimeSecs = 'total_watch_time_secs',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Views = 'views',
  /** column name */
  Visibility = 'visibility'
}

/** select "reels_aggregate_bool_exp_avg_arguments_columns" columns of table "reels" */
export enum Reels_Select_Column_Reels_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "reels_aggregate_bool_exp_bool_and_arguments_columns" columns of table "reels" */
export enum Reels_Select_Column_Reels_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AllowComments = 'allow_comments',
  /** column name */
  AllowDownloads = 'allow_downloads',
  /** column name */
  AllowLikes = 'allow_likes',
  /** column name */
  AllowReactions = 'allow_reactions',
  /** column name */
  AllowReports = 'allow_reports',
  /** column name */
  AllowShares = 'allow_shares',
  /** column name */
  RestrictGeo = 'restrict_geo'
}

/** select "reels_aggregate_bool_exp_bool_or_arguments_columns" columns of table "reels" */
export enum Reels_Select_Column_Reels_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AllowComments = 'allow_comments',
  /** column name */
  AllowDownloads = 'allow_downloads',
  /** column name */
  AllowLikes = 'allow_likes',
  /** column name */
  AllowReactions = 'allow_reactions',
  /** column name */
  AllowReports = 'allow_reports',
  /** column name */
  AllowShares = 'allow_shares',
  /** column name */
  RestrictGeo = 'restrict_geo'
}

/** select "reels_aggregate_bool_exp_corr_arguments_columns" columns of table "reels" */
export enum Reels_Select_Column_Reels_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "reels_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "reels" */
export enum Reels_Select_Column_Reels_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "reels_aggregate_bool_exp_max_arguments_columns" columns of table "reels" */
export enum Reels_Select_Column_Reels_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "reels_aggregate_bool_exp_min_arguments_columns" columns of table "reels" */
export enum Reels_Select_Column_Reels_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "reels_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "reels" */
export enum Reels_Select_Column_Reels_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "reels_aggregate_bool_exp_sum_arguments_columns" columns of table "reels" */
export enum Reels_Select_Column_Reels_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "reels_aggregate_bool_exp_var_samp_arguments_columns" columns of table "reels" */
export enum Reels_Select_Column_Reels_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** input type for updating data in table "reels" */
export type Reels_Set_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  allow_comments?: InputMaybe<Scalars['Boolean']['input']>;
  allow_downloads?: InputMaybe<Scalars['Boolean']['input']>;
  allow_likes?: InputMaybe<Scalars['Boolean']['input']>;
  allow_reactions?: InputMaybe<Scalars['Boolean']['input']>;
  allow_reports?: InputMaybe<Scalars['Boolean']['input']>;
  allow_shares?: InputMaybe<Scalars['Boolean']['input']>;
  category_id?: InputMaybe<Scalars['bigint']['input']>;
  channel_id?: InputMaybe<Scalars['bigint']['input']>;
  cloudflare_id?: InputMaybe<Scalars['String']['input']>;
  cloudflare_playback_url?: InputMaybe<Scalars['String']['input']>;
  cloudflare_preview_url?: InputMaybe<Scalars['String']['input']>;
  cloudflare_thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crop_id?: InputMaybe<Scalars['bpchar']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  districts_json?: InputMaybe<Scalars['jsonb']['input']>;
  duration_ms?: InputMaybe<Scalars['bigint']['input']>;
  file_name?: InputMaybe<Scalars['String']['input']>;
  file_size?: InputMaybe<Scalars['String']['input']>;
  google_places_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  likes?: InputMaybe<Scalars['Int']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  location?: InputMaybe<Scalars['geography']['input']>;
  reactions?: InputMaybe<Scalars['json']['input']>;
  reactions_count?: InputMaybe<Scalars['Int']['input']>;
  restrict_geo?: InputMaybe<Scalars['Boolean']['input']>;
  s3_path?: InputMaybe<Scalars['String']['input']>;
  scheduled_at?: InputMaybe<Scalars['timestamp']['input']>;
  shares?: InputMaybe<Scalars['Int']['input']>;
  targeted_area?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  total_watch_time_secs?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
  views?: InputMaybe<Scalars['Int']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Reels_Stddev_Fields = {
  __typename?: 'reels_stddev_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  channel_id?: Maybe<Scalars['Float']['output']>;
  duration_ms?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  likes?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  reactions_count?: Maybe<Scalars['Float']['output']>;
  shares?: Maybe<Scalars['Float']['output']>;
  total_watch_time_secs?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "reels" */
export type Reels_Stddev_Order_By = {
  category_id?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  duration_ms?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  likes?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  reactions_count?: InputMaybe<Order_By>;
  shares?: InputMaybe<Order_By>;
  total_watch_time_secs?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Reels_Stddev_Pop_Fields = {
  __typename?: 'reels_stddev_pop_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  channel_id?: Maybe<Scalars['Float']['output']>;
  duration_ms?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  likes?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  reactions_count?: Maybe<Scalars['Float']['output']>;
  shares?: Maybe<Scalars['Float']['output']>;
  total_watch_time_secs?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "reels" */
export type Reels_Stddev_Pop_Order_By = {
  category_id?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  duration_ms?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  likes?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  reactions_count?: InputMaybe<Order_By>;
  shares?: InputMaybe<Order_By>;
  total_watch_time_secs?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Reels_Stddev_Samp_Fields = {
  __typename?: 'reels_stddev_samp_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  channel_id?: Maybe<Scalars['Float']['output']>;
  duration_ms?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  likes?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  reactions_count?: Maybe<Scalars['Float']['output']>;
  shares?: Maybe<Scalars['Float']['output']>;
  total_watch_time_secs?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "reels" */
export type Reels_Stddev_Samp_Order_By = {
  category_id?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  duration_ms?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  likes?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  reactions_count?: InputMaybe<Order_By>;
  shares?: InputMaybe<Order_By>;
  total_watch_time_secs?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "reels" */
export type Reels_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Reels_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Reels_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  allow_comments?: InputMaybe<Scalars['Boolean']['input']>;
  allow_downloads?: InputMaybe<Scalars['Boolean']['input']>;
  allow_likes?: InputMaybe<Scalars['Boolean']['input']>;
  allow_reactions?: InputMaybe<Scalars['Boolean']['input']>;
  allow_reports?: InputMaybe<Scalars['Boolean']['input']>;
  allow_shares?: InputMaybe<Scalars['Boolean']['input']>;
  category_id?: InputMaybe<Scalars['bigint']['input']>;
  channel_id?: InputMaybe<Scalars['bigint']['input']>;
  cloudflare_id?: InputMaybe<Scalars['String']['input']>;
  cloudflare_playback_url?: InputMaybe<Scalars['String']['input']>;
  cloudflare_preview_url?: InputMaybe<Scalars['String']['input']>;
  cloudflare_thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crop_id?: InputMaybe<Scalars['bpchar']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  districts_json?: InputMaybe<Scalars['jsonb']['input']>;
  duration_ms?: InputMaybe<Scalars['bigint']['input']>;
  file_name?: InputMaybe<Scalars['String']['input']>;
  file_size?: InputMaybe<Scalars['String']['input']>;
  google_places_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  likes?: InputMaybe<Scalars['Int']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  location?: InputMaybe<Scalars['geography']['input']>;
  reactions?: InputMaybe<Scalars['json']['input']>;
  reactions_count?: InputMaybe<Scalars['Int']['input']>;
  restrict_geo?: InputMaybe<Scalars['Boolean']['input']>;
  s3_path?: InputMaybe<Scalars['String']['input']>;
  scheduled_at?: InputMaybe<Scalars['timestamp']['input']>;
  shares?: InputMaybe<Scalars['Int']['input']>;
  targeted_area?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  total_watch_time_secs?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
  views?: InputMaybe<Scalars['Int']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Reels_Sum_Fields = {
  __typename?: 'reels_sum_fields';
  category_id?: Maybe<Scalars['bigint']['output']>;
  channel_id?: Maybe<Scalars['bigint']['output']>;
  duration_ms?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  likes?: Maybe<Scalars['Int']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  reactions_count?: Maybe<Scalars['Int']['output']>;
  shares?: Maybe<Scalars['Int']['output']>;
  total_watch_time_secs?: Maybe<Scalars['bigint']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "reels" */
export type Reels_Sum_Order_By = {
  category_id?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  duration_ms?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  likes?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  reactions_count?: InputMaybe<Order_By>;
  shares?: InputMaybe<Order_By>;
  total_watch_time_secs?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** update columns of table "reels" */
export enum Reels_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AllowComments = 'allow_comments',
  /** column name */
  AllowDownloads = 'allow_downloads',
  /** column name */
  AllowLikes = 'allow_likes',
  /** column name */
  AllowReactions = 'allow_reactions',
  /** column name */
  AllowReports = 'allow_reports',
  /** column name */
  AllowShares = 'allow_shares',
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  ChannelId = 'channel_id',
  /** column name */
  CloudflareId = 'cloudflare_id',
  /** column name */
  CloudflarePlaybackUrl = 'cloudflare_playback_url',
  /** column name */
  CloudflarePreviewUrl = 'cloudflare_preview_url',
  /** column name */
  CloudflareThumbnailUrl = 'cloudflare_thumbnail_url',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  DistrictsJson = 'districts_json',
  /** column name */
  DurationMs = 'duration_ms',
  /** column name */
  FileName = 'file_name',
  /** column name */
  FileSize = 'file_size',
  /** column name */
  GooglePlacesId = 'google_places_id',
  /** column name */
  Id = 'id',
  /** column name */
  Language = 'language',
  /** column name */
  Lat = 'lat',
  /** column name */
  Likes = 'likes',
  /** column name */
  Lng = 'lng',
  /** column name */
  Location = 'location',
  /** column name */
  Reactions = 'reactions',
  /** column name */
  ReactionsCount = 'reactions_count',
  /** column name */
  RestrictGeo = 'restrict_geo',
  /** column name */
  S3Path = 's3_path',
  /** column name */
  ScheduledAt = 'scheduled_at',
  /** column name */
  Shares = 'shares',
  /** column name */
  TargetedArea = 'targeted_area',
  /** column name */
  ThumbnailUrl = 'thumbnail_url',
  /** column name */
  Title = 'title',
  /** column name */
  TotalWatchTimeSecs = 'total_watch_time_secs',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Views = 'views',
  /** column name */
  Visibility = 'visibility'
}

export type Reels_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Reels_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Reels_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Reels_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Reels_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Reels_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Reels_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Reels_Set_Input>;
  /** filter the rows which have to be updated */
  where: Reels_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Reels_Var_Pop_Fields = {
  __typename?: 'reels_var_pop_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  channel_id?: Maybe<Scalars['Float']['output']>;
  duration_ms?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  likes?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  reactions_count?: Maybe<Scalars['Float']['output']>;
  shares?: Maybe<Scalars['Float']['output']>;
  total_watch_time_secs?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "reels" */
export type Reels_Var_Pop_Order_By = {
  category_id?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  duration_ms?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  likes?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  reactions_count?: InputMaybe<Order_By>;
  shares?: InputMaybe<Order_By>;
  total_watch_time_secs?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Reels_Var_Samp_Fields = {
  __typename?: 'reels_var_samp_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  channel_id?: Maybe<Scalars['Float']['output']>;
  duration_ms?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  likes?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  reactions_count?: Maybe<Scalars['Float']['output']>;
  shares?: Maybe<Scalars['Float']['output']>;
  total_watch_time_secs?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "reels" */
export type Reels_Var_Samp_Order_By = {
  category_id?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  duration_ms?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  likes?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  reactions_count?: InputMaybe<Order_By>;
  shares?: InputMaybe<Order_By>;
  total_watch_time_secs?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Reels_Variance_Fields = {
  __typename?: 'reels_variance_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  channel_id?: Maybe<Scalars['Float']['output']>;
  duration_ms?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  likes?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  reactions_count?: Maybe<Scalars['Float']['output']>;
  shares?: Maybe<Scalars['Float']['output']>;
  total_watch_time_secs?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "reels" */
export type Reels_Variance_Order_By = {
  category_id?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  duration_ms?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  likes?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  reactions_count?: InputMaybe<Order_By>;
  shares?: InputMaybe<Order_By>;
  total_watch_time_secs?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** columns and relationships of "reels_with_distance" */
export type Reels_With_Distance = {
  __typename?: 'reels_with_distance';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  allow_comments?: Maybe<Scalars['Boolean']['output']>;
  allow_downloads?: Maybe<Scalars['Boolean']['output']>;
  allow_likes?: Maybe<Scalars['Boolean']['output']>;
  allow_reactions?: Maybe<Scalars['Boolean']['output']>;
  allow_reports?: Maybe<Scalars['Boolean']['output']>;
  allow_shares?: Maybe<Scalars['Boolean']['output']>;
  category_id?: Maybe<Scalars['bigint']['output']>;
  cloudflare_id?: Maybe<Scalars['String']['output']>;
  cloudflare_playback_url?: Maybe<Scalars['String']['output']>;
  cloudflare_preview_url?: Maybe<Scalars['String']['output']>;
  cloudflare_thumbnail_url?: Maybe<Scalars['String']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['float8']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  file_size?: Maybe<Scalars['String']['output']>;
  google_places_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  likes?: Maybe<Scalars['Int']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  location?: Maybe<Scalars['geometry']['output']>;
  reactions?: Maybe<Scalars['json']['output']>;
  reactions_count?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  reel_comments: Array<Reel_Comments>;
  /** An aggregate relationship */
  reel_comments_aggregate: Reel_Comments_Aggregate;
  /** An array relationship */
  reels_reel_interactions: Array<Reel_Interactions>;
  /** An aggregate relationship */
  reels_reel_interactions_aggregate: Reel_Interactions_Aggregate;
  /** An array relationship */
  reels_taggables: Array<Taggables>;
  /** An aggregate relationship */
  reels_taggables_aggregate: Taggables_Aggregate;
  /** An object relationship */
  reels_user?: Maybe<Users>;
  s3_path?: Maybe<Scalars['String']['output']>;
  shares?: Maybe<Scalars['Int']['output']>;
  targeted_area?: Maybe<Scalars['String']['output']>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "reels_with_distance" */
export type Reels_With_DistanceReactionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "reels_with_distance" */
export type Reels_With_DistanceReel_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Reel_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_Comments_Order_By>>;
  where?: InputMaybe<Reel_Comments_Bool_Exp>;
};


/** columns and relationships of "reels_with_distance" */
export type Reels_With_DistanceReel_Comments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reel_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_Comments_Order_By>>;
  where?: InputMaybe<Reel_Comments_Bool_Exp>;
};


/** columns and relationships of "reels_with_distance" */
export type Reels_With_DistanceReels_Reel_InteractionsArgs = {
  distinct_on?: InputMaybe<Array<Reel_Interactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_Interactions_Order_By>>;
  where?: InputMaybe<Reel_Interactions_Bool_Exp>;
};


/** columns and relationships of "reels_with_distance" */
export type Reels_With_DistanceReels_Reel_Interactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reel_Interactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_Interactions_Order_By>>;
  where?: InputMaybe<Reel_Interactions_Bool_Exp>;
};


/** columns and relationships of "reels_with_distance" */
export type Reels_With_DistanceReels_TaggablesArgs = {
  distinct_on?: InputMaybe<Array<Taggables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taggables_Order_By>>;
  where?: InputMaybe<Taggables_Bool_Exp>;
};


/** columns and relationships of "reels_with_distance" */
export type Reels_With_DistanceReels_Taggables_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Taggables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taggables_Order_By>>;
  where?: InputMaybe<Taggables_Bool_Exp>;
};

export type Reels_With_Distance_Aggregate = {
  __typename?: 'reels_with_distance_aggregate';
  aggregate?: Maybe<Reels_With_Distance_Aggregate_Fields>;
  nodes: Array<Reels_With_Distance>;
};

/** aggregate fields of "reels_with_distance" */
export type Reels_With_Distance_Aggregate_Fields = {
  __typename?: 'reels_with_distance_aggregate_fields';
  avg?: Maybe<Reels_With_Distance_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Reels_With_Distance_Max_Fields>;
  min?: Maybe<Reels_With_Distance_Min_Fields>;
  stddev?: Maybe<Reels_With_Distance_Stddev_Fields>;
  stddev_pop?: Maybe<Reels_With_Distance_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Reels_With_Distance_Stddev_Samp_Fields>;
  sum?: Maybe<Reels_With_Distance_Sum_Fields>;
  var_pop?: Maybe<Reels_With_Distance_Var_Pop_Fields>;
  var_samp?: Maybe<Reels_With_Distance_Var_Samp_Fields>;
  variance?: Maybe<Reels_With_Distance_Variance_Fields>;
};


/** aggregate fields of "reels_with_distance" */
export type Reels_With_Distance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Reels_With_Distance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Reels_With_Distance_Avg_Fields = {
  __typename?: 'reels_with_distance_avg_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  likes?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  reactions_count?: Maybe<Scalars['Float']['output']>;
  shares?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "reels_with_distance". All fields are combined with a logical 'AND'. */
export type Reels_With_Distance_Bool_Exp = {
  _and?: InputMaybe<Array<Reels_With_Distance_Bool_Exp>>;
  _not?: InputMaybe<Reels_With_Distance_Bool_Exp>;
  _or?: InputMaybe<Array<Reels_With_Distance_Bool_Exp>>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  allow_comments?: InputMaybe<Boolean_Comparison_Exp>;
  allow_downloads?: InputMaybe<Boolean_Comparison_Exp>;
  allow_likes?: InputMaybe<Boolean_Comparison_Exp>;
  allow_reactions?: InputMaybe<Boolean_Comparison_Exp>;
  allow_reports?: InputMaybe<Boolean_Comparison_Exp>;
  allow_shares?: InputMaybe<Boolean_Comparison_Exp>;
  category_id?: InputMaybe<Bigint_Comparison_Exp>;
  cloudflare_id?: InputMaybe<String_Comparison_Exp>;
  cloudflare_playback_url?: InputMaybe<String_Comparison_Exp>;
  cloudflare_preview_url?: InputMaybe<String_Comparison_Exp>;
  cloudflare_thumbnail_url?: InputMaybe<String_Comparison_Exp>;
  company_id?: InputMaybe<Bpchar_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  distance?: InputMaybe<Float8_Comparison_Exp>;
  file_name?: InputMaybe<String_Comparison_Exp>;
  file_size?: InputMaybe<String_Comparison_Exp>;
  google_places_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  language?: InputMaybe<String_Comparison_Exp>;
  lat?: InputMaybe<Float8_Comparison_Exp>;
  likes?: InputMaybe<Int_Comparison_Exp>;
  lng?: InputMaybe<Float8_Comparison_Exp>;
  location?: InputMaybe<Geometry_Comparison_Exp>;
  reactions?: InputMaybe<Json_Comparison_Exp>;
  reactions_count?: InputMaybe<Int_Comparison_Exp>;
  reel_comments?: InputMaybe<Reel_Comments_Bool_Exp>;
  reel_comments_aggregate?: InputMaybe<Reel_Comments_Aggregate_Bool_Exp>;
  reels_reel_interactions?: InputMaybe<Reel_Interactions_Bool_Exp>;
  reels_reel_interactions_aggregate?: InputMaybe<Reel_Interactions_Aggregate_Bool_Exp>;
  reels_taggables?: InputMaybe<Taggables_Bool_Exp>;
  reels_taggables_aggregate?: InputMaybe<Taggables_Aggregate_Bool_Exp>;
  reels_user?: InputMaybe<Users_Bool_Exp>;
  s3_path?: InputMaybe<String_Comparison_Exp>;
  shares?: InputMaybe<Int_Comparison_Exp>;
  targeted_area?: InputMaybe<String_Comparison_Exp>;
  thumbnail_url?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  views?: InputMaybe<Int_Comparison_Exp>;
  visibility?: InputMaybe<String_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "reels_with_distance" */
export type Reels_With_Distance_Inc_Input = {
  category_id?: InputMaybe<Scalars['bigint']['input']>;
  distance?: InputMaybe<Scalars['float8']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  likes?: InputMaybe<Scalars['Int']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  reactions_count?: InputMaybe<Scalars['Int']['input']>;
  shares?: InputMaybe<Scalars['Int']['input']>;
  views?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "reels_with_distance" */
export type Reels_With_Distance_Insert_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  allow_comments?: InputMaybe<Scalars['Boolean']['input']>;
  allow_downloads?: InputMaybe<Scalars['Boolean']['input']>;
  allow_likes?: InputMaybe<Scalars['Boolean']['input']>;
  allow_reactions?: InputMaybe<Scalars['Boolean']['input']>;
  allow_reports?: InputMaybe<Scalars['Boolean']['input']>;
  allow_shares?: InputMaybe<Scalars['Boolean']['input']>;
  category_id?: InputMaybe<Scalars['bigint']['input']>;
  cloudflare_id?: InputMaybe<Scalars['String']['input']>;
  cloudflare_playback_url?: InputMaybe<Scalars['String']['input']>;
  cloudflare_preview_url?: InputMaybe<Scalars['String']['input']>;
  cloudflare_thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  distance?: InputMaybe<Scalars['float8']['input']>;
  file_name?: InputMaybe<Scalars['String']['input']>;
  file_size?: InputMaybe<Scalars['String']['input']>;
  google_places_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  likes?: InputMaybe<Scalars['Int']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  location?: InputMaybe<Scalars['geometry']['input']>;
  reactions?: InputMaybe<Scalars['json']['input']>;
  reactions_count?: InputMaybe<Scalars['Int']['input']>;
  reel_comments?: InputMaybe<Reel_Comments_Arr_Rel_Insert_Input>;
  reels_reel_interactions?: InputMaybe<Reel_Interactions_Arr_Rel_Insert_Input>;
  reels_taggables?: InputMaybe<Taggables_Arr_Rel_Insert_Input>;
  reels_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  s3_path?: InputMaybe<Scalars['String']['input']>;
  shares?: InputMaybe<Scalars['Int']['input']>;
  targeted_area?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
  views?: InputMaybe<Scalars['Int']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Reels_With_Distance_Max_Fields = {
  __typename?: 'reels_with_distance_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  category_id?: Maybe<Scalars['bigint']['output']>;
  cloudflare_id?: Maybe<Scalars['String']['output']>;
  cloudflare_playback_url?: Maybe<Scalars['String']['output']>;
  cloudflare_preview_url?: Maybe<Scalars['String']['output']>;
  cloudflare_thumbnail_url?: Maybe<Scalars['String']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['float8']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  file_size?: Maybe<Scalars['String']['output']>;
  google_places_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  likes?: Maybe<Scalars['Int']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  reactions_count?: Maybe<Scalars['Int']['output']>;
  s3_path?: Maybe<Scalars['String']['output']>;
  shares?: Maybe<Scalars['Int']['output']>;
  targeted_area?: Maybe<Scalars['String']['output']>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Reels_With_Distance_Min_Fields = {
  __typename?: 'reels_with_distance_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  category_id?: Maybe<Scalars['bigint']['output']>;
  cloudflare_id?: Maybe<Scalars['String']['output']>;
  cloudflare_playback_url?: Maybe<Scalars['String']['output']>;
  cloudflare_preview_url?: Maybe<Scalars['String']['output']>;
  cloudflare_thumbnail_url?: Maybe<Scalars['String']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['float8']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  file_size?: Maybe<Scalars['String']['output']>;
  google_places_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  likes?: Maybe<Scalars['Int']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  reactions_count?: Maybe<Scalars['Int']['output']>;
  s3_path?: Maybe<Scalars['String']['output']>;
  shares?: Maybe<Scalars['Int']['output']>;
  targeted_area?: Maybe<Scalars['String']['output']>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "reels_with_distance" */
export type Reels_With_Distance_Mutation_Response = {
  __typename?: 'reels_with_distance_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Reels_With_Distance>;
};

/** Ordering options when selecting data from "reels_with_distance". */
export type Reels_With_Distance_Order_By = {
  account_id?: InputMaybe<Order_By>;
  allow_comments?: InputMaybe<Order_By>;
  allow_downloads?: InputMaybe<Order_By>;
  allow_likes?: InputMaybe<Order_By>;
  allow_reactions?: InputMaybe<Order_By>;
  allow_reports?: InputMaybe<Order_By>;
  allow_shares?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  cloudflare_id?: InputMaybe<Order_By>;
  cloudflare_playback_url?: InputMaybe<Order_By>;
  cloudflare_preview_url?: InputMaybe<Order_By>;
  cloudflare_thumbnail_url?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  distance?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  file_size?: InputMaybe<Order_By>;
  google_places_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  likes?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  reactions?: InputMaybe<Order_By>;
  reactions_count?: InputMaybe<Order_By>;
  reel_comments_aggregate?: InputMaybe<Reel_Comments_Aggregate_Order_By>;
  reels_reel_interactions_aggregate?: InputMaybe<Reel_Interactions_Aggregate_Order_By>;
  reels_taggables_aggregate?: InputMaybe<Taggables_Aggregate_Order_By>;
  reels_user?: InputMaybe<Users_Order_By>;
  s3_path?: InputMaybe<Order_By>;
  shares?: InputMaybe<Order_By>;
  targeted_area?: InputMaybe<Order_By>;
  thumbnail_url?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
  visibility?: InputMaybe<Order_By>;
};

/** select columns of table "reels_with_distance" */
export enum Reels_With_Distance_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AllowComments = 'allow_comments',
  /** column name */
  AllowDownloads = 'allow_downloads',
  /** column name */
  AllowLikes = 'allow_likes',
  /** column name */
  AllowReactions = 'allow_reactions',
  /** column name */
  AllowReports = 'allow_reports',
  /** column name */
  AllowShares = 'allow_shares',
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CloudflareId = 'cloudflare_id',
  /** column name */
  CloudflarePlaybackUrl = 'cloudflare_playback_url',
  /** column name */
  CloudflarePreviewUrl = 'cloudflare_preview_url',
  /** column name */
  CloudflareThumbnailUrl = 'cloudflare_thumbnail_url',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  Distance = 'distance',
  /** column name */
  FileName = 'file_name',
  /** column name */
  FileSize = 'file_size',
  /** column name */
  GooglePlacesId = 'google_places_id',
  /** column name */
  Id = 'id',
  /** column name */
  Language = 'language',
  /** column name */
  Lat = 'lat',
  /** column name */
  Likes = 'likes',
  /** column name */
  Lng = 'lng',
  /** column name */
  Location = 'location',
  /** column name */
  Reactions = 'reactions',
  /** column name */
  ReactionsCount = 'reactions_count',
  /** column name */
  S3Path = 's3_path',
  /** column name */
  Shares = 'shares',
  /** column name */
  TargetedArea = 'targeted_area',
  /** column name */
  ThumbnailUrl = 'thumbnail_url',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Views = 'views',
  /** column name */
  Visibility = 'visibility'
}

/** input type for updating data in table "reels_with_distance" */
export type Reels_With_Distance_Set_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  allow_comments?: InputMaybe<Scalars['Boolean']['input']>;
  allow_downloads?: InputMaybe<Scalars['Boolean']['input']>;
  allow_likes?: InputMaybe<Scalars['Boolean']['input']>;
  allow_reactions?: InputMaybe<Scalars['Boolean']['input']>;
  allow_reports?: InputMaybe<Scalars['Boolean']['input']>;
  allow_shares?: InputMaybe<Scalars['Boolean']['input']>;
  category_id?: InputMaybe<Scalars['bigint']['input']>;
  cloudflare_id?: InputMaybe<Scalars['String']['input']>;
  cloudflare_playback_url?: InputMaybe<Scalars['String']['input']>;
  cloudflare_preview_url?: InputMaybe<Scalars['String']['input']>;
  cloudflare_thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  distance?: InputMaybe<Scalars['float8']['input']>;
  file_name?: InputMaybe<Scalars['String']['input']>;
  file_size?: InputMaybe<Scalars['String']['input']>;
  google_places_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  likes?: InputMaybe<Scalars['Int']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  location?: InputMaybe<Scalars['geometry']['input']>;
  reactions?: InputMaybe<Scalars['json']['input']>;
  reactions_count?: InputMaybe<Scalars['Int']['input']>;
  s3_path?: InputMaybe<Scalars['String']['input']>;
  shares?: InputMaybe<Scalars['Int']['input']>;
  targeted_area?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
  views?: InputMaybe<Scalars['Int']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Reels_With_Distance_Stddev_Fields = {
  __typename?: 'reels_with_distance_stddev_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  likes?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  reactions_count?: Maybe<Scalars['Float']['output']>;
  shares?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Reels_With_Distance_Stddev_Pop_Fields = {
  __typename?: 'reels_with_distance_stddev_pop_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  likes?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  reactions_count?: Maybe<Scalars['Float']['output']>;
  shares?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Reels_With_Distance_Stddev_Samp_Fields = {
  __typename?: 'reels_with_distance_stddev_samp_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  likes?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  reactions_count?: Maybe<Scalars['Float']['output']>;
  shares?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "reels_with_distance" */
export type Reels_With_Distance_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Reels_With_Distance_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Reels_With_Distance_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  allow_comments?: InputMaybe<Scalars['Boolean']['input']>;
  allow_downloads?: InputMaybe<Scalars['Boolean']['input']>;
  allow_likes?: InputMaybe<Scalars['Boolean']['input']>;
  allow_reactions?: InputMaybe<Scalars['Boolean']['input']>;
  allow_reports?: InputMaybe<Scalars['Boolean']['input']>;
  allow_shares?: InputMaybe<Scalars['Boolean']['input']>;
  category_id?: InputMaybe<Scalars['bigint']['input']>;
  cloudflare_id?: InputMaybe<Scalars['String']['input']>;
  cloudflare_playback_url?: InputMaybe<Scalars['String']['input']>;
  cloudflare_preview_url?: InputMaybe<Scalars['String']['input']>;
  cloudflare_thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  distance?: InputMaybe<Scalars['float8']['input']>;
  file_name?: InputMaybe<Scalars['String']['input']>;
  file_size?: InputMaybe<Scalars['String']['input']>;
  google_places_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  likes?: InputMaybe<Scalars['Int']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  location?: InputMaybe<Scalars['geometry']['input']>;
  reactions?: InputMaybe<Scalars['json']['input']>;
  reactions_count?: InputMaybe<Scalars['Int']['input']>;
  s3_path?: InputMaybe<Scalars['String']['input']>;
  shares?: InputMaybe<Scalars['Int']['input']>;
  targeted_area?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
  views?: InputMaybe<Scalars['Int']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Reels_With_Distance_Sum_Fields = {
  __typename?: 'reels_with_distance_sum_fields';
  category_id?: Maybe<Scalars['bigint']['output']>;
  distance?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  likes?: Maybe<Scalars['Int']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  reactions_count?: Maybe<Scalars['Int']['output']>;
  shares?: Maybe<Scalars['Int']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
};

export type Reels_With_Distance_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Reels_With_Distance_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Reels_With_Distance_Set_Input>;
  /** filter the rows which have to be updated */
  where: Reels_With_Distance_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Reels_With_Distance_Var_Pop_Fields = {
  __typename?: 'reels_with_distance_var_pop_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  likes?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  reactions_count?: Maybe<Scalars['Float']['output']>;
  shares?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Reels_With_Distance_Var_Samp_Fields = {
  __typename?: 'reels_with_distance_var_samp_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  likes?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  reactions_count?: Maybe<Scalars['Float']['output']>;
  shares?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Reels_With_Distance_Variance_Fields = {
  __typename?: 'reels_with_distance_variance_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  likes?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  reactions_count?: Maybe<Scalars['Float']['output']>;
  shares?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "retailer_establishments" */
export type Retailer_Establishments = {
  __typename?: 'retailer_establishments';
  address?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  gstn?: Maybe<Scalars['String']['output']>;
  id: Scalars['bpchar']['output'];
  languages?: Maybe<Scalars['jsonb']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  organization_name?: Maybe<Scalars['String']['output']>;
  pin_code?: Maybe<Scalars['String']['output']>;
  retailer_id?: Maybe<Scalars['bpchar']['output']>;
  shop_name?: Maybe<Scalars['String']['output']>;
  shop_owner_name?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "retailer_establishments" */
export type Retailer_EstablishmentsLanguagesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "retailer_establishments" */
export type Retailer_Establishments_Aggregate = {
  __typename?: 'retailer_establishments_aggregate';
  aggregate?: Maybe<Retailer_Establishments_Aggregate_Fields>;
  nodes: Array<Retailer_Establishments>;
};

/** aggregate fields of "retailer_establishments" */
export type Retailer_Establishments_Aggregate_Fields = {
  __typename?: 'retailer_establishments_aggregate_fields';
  avg?: Maybe<Retailer_Establishments_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Retailer_Establishments_Max_Fields>;
  min?: Maybe<Retailer_Establishments_Min_Fields>;
  stddev?: Maybe<Retailer_Establishments_Stddev_Fields>;
  stddev_pop?: Maybe<Retailer_Establishments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Retailer_Establishments_Stddev_Samp_Fields>;
  sum?: Maybe<Retailer_Establishments_Sum_Fields>;
  var_pop?: Maybe<Retailer_Establishments_Var_Pop_Fields>;
  var_samp?: Maybe<Retailer_Establishments_Var_Samp_Fields>;
  variance?: Maybe<Retailer_Establishments_Variance_Fields>;
};


/** aggregate fields of "retailer_establishments" */
export type Retailer_Establishments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Retailer_Establishments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Retailer_Establishments_Append_Input = {
  languages?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Retailer_Establishments_Avg_Fields = {
  __typename?: 'retailer_establishments_avg_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "retailer_establishments". All fields are combined with a logical 'AND'. */
export type Retailer_Establishments_Bool_Exp = {
  _and?: InputMaybe<Array<Retailer_Establishments_Bool_Exp>>;
  _not?: InputMaybe<Retailer_Establishments_Bool_Exp>;
  _or?: InputMaybe<Array<Retailer_Establishments_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  district?: InputMaybe<String_Comparison_Exp>;
  gstn?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  languages?: InputMaybe<Jsonb_Comparison_Exp>;
  lat?: InputMaybe<Float8_Comparison_Exp>;
  lng?: InputMaybe<Float8_Comparison_Exp>;
  organization_name?: InputMaybe<String_Comparison_Exp>;
  pin_code?: InputMaybe<String_Comparison_Exp>;
  retailer_id?: InputMaybe<Bpchar_Comparison_Exp>;
  shop_name?: InputMaybe<String_Comparison_Exp>;
  shop_owner_name?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "retailer_establishments" */
export enum Retailer_Establishments_Constraint {
  /** unique or primary key constraint on columns "id" */
  RetailerEstablishmentsPkey = 'retailer_establishments_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Retailer_Establishments_Delete_At_Path_Input = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Retailer_Establishments_Delete_Elem_Input = {
  languages?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Retailer_Establishments_Delete_Key_Input = {
  languages?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "retailer_establishments" */
export type Retailer_Establishments_Inc_Input = {
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "retailer_establishments" */
export type Retailer_Establishments_Insert_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  gstn?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  languages?: InputMaybe<Scalars['jsonb']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  organization_name?: InputMaybe<Scalars['String']['input']>;
  pin_code?: InputMaybe<Scalars['String']['input']>;
  retailer_id?: InputMaybe<Scalars['bpchar']['input']>;
  shop_name?: InputMaybe<Scalars['String']['input']>;
  shop_owner_name?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Retailer_Establishments_Max_Fields = {
  __typename?: 'retailer_establishments_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  gstn?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  organization_name?: Maybe<Scalars['String']['output']>;
  pin_code?: Maybe<Scalars['String']['output']>;
  retailer_id?: Maybe<Scalars['bpchar']['output']>;
  shop_name?: Maybe<Scalars['String']['output']>;
  shop_owner_name?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Retailer_Establishments_Min_Fields = {
  __typename?: 'retailer_establishments_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  gstn?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  organization_name?: Maybe<Scalars['String']['output']>;
  pin_code?: Maybe<Scalars['String']['output']>;
  retailer_id?: Maybe<Scalars['bpchar']['output']>;
  shop_name?: Maybe<Scalars['String']['output']>;
  shop_owner_name?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "retailer_establishments" */
export type Retailer_Establishments_Mutation_Response = {
  __typename?: 'retailer_establishments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Retailer_Establishments>;
};

/** input type for inserting object relation for remote table "retailer_establishments" */
export type Retailer_Establishments_Obj_Rel_Insert_Input = {
  data: Retailer_Establishments_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Retailer_Establishments_On_Conflict>;
};

/** on_conflict condition type for table "retailer_establishments" */
export type Retailer_Establishments_On_Conflict = {
  constraint: Retailer_Establishments_Constraint;
  update_columns?: Array<Retailer_Establishments_Update_Column>;
  where?: InputMaybe<Retailer_Establishments_Bool_Exp>;
};

/** Ordering options when selecting data from "retailer_establishments". */
export type Retailer_Establishments_Order_By = {
  address?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  district?: InputMaybe<Order_By>;
  gstn?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  languages?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  organization_name?: InputMaybe<Order_By>;
  pin_code?: InputMaybe<Order_By>;
  retailer_id?: InputMaybe<Order_By>;
  shop_name?: InputMaybe<Order_By>;
  shop_owner_name?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: retailer_establishments */
export type Retailer_Establishments_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Retailer_Establishments_Prepend_Input = {
  languages?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "retailer_establishments" */
export enum Retailer_Establishments_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  District = 'district',
  /** column name */
  Gstn = 'gstn',
  /** column name */
  Id = 'id',
  /** column name */
  Languages = 'languages',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  OrganizationName = 'organization_name',
  /** column name */
  PinCode = 'pin_code',
  /** column name */
  RetailerId = 'retailer_id',
  /** column name */
  ShopName = 'shop_name',
  /** column name */
  ShopOwnerName = 'shop_owner_name',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "retailer_establishments" */
export type Retailer_Establishments_Set_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  gstn?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  languages?: InputMaybe<Scalars['jsonb']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  organization_name?: InputMaybe<Scalars['String']['input']>;
  pin_code?: InputMaybe<Scalars['String']['input']>;
  retailer_id?: InputMaybe<Scalars['bpchar']['input']>;
  shop_name?: InputMaybe<Scalars['String']['input']>;
  shop_owner_name?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Retailer_Establishments_Stddev_Fields = {
  __typename?: 'retailer_establishments_stddev_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Retailer_Establishments_Stddev_Pop_Fields = {
  __typename?: 'retailer_establishments_stddev_pop_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Retailer_Establishments_Stddev_Samp_Fields = {
  __typename?: 'retailer_establishments_stddev_samp_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "retailer_establishments" */
export type Retailer_Establishments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Retailer_Establishments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Retailer_Establishments_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  gstn?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  languages?: InputMaybe<Scalars['jsonb']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  organization_name?: InputMaybe<Scalars['String']['input']>;
  pin_code?: InputMaybe<Scalars['String']['input']>;
  retailer_id?: InputMaybe<Scalars['bpchar']['input']>;
  shop_name?: InputMaybe<Scalars['String']['input']>;
  shop_owner_name?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Retailer_Establishments_Sum_Fields = {
  __typename?: 'retailer_establishments_sum_fields';
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
};

/** update columns of table "retailer_establishments" */
export enum Retailer_Establishments_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  District = 'district',
  /** column name */
  Gstn = 'gstn',
  /** column name */
  Id = 'id',
  /** column name */
  Languages = 'languages',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  OrganizationName = 'organization_name',
  /** column name */
  PinCode = 'pin_code',
  /** column name */
  RetailerId = 'retailer_id',
  /** column name */
  ShopName = 'shop_name',
  /** column name */
  ShopOwnerName = 'shop_owner_name',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Retailer_Establishments_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Retailer_Establishments_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Retailer_Establishments_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Retailer_Establishments_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Retailer_Establishments_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Retailer_Establishments_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Retailer_Establishments_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Retailer_Establishments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Retailer_Establishments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Retailer_Establishments_Var_Pop_Fields = {
  __typename?: 'retailer_establishments_var_pop_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Retailer_Establishments_Var_Samp_Fields = {
  __typename?: 'retailer_establishments_var_samp_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Retailer_Establishments_Variance_Fields = {
  __typename?: 'retailer_establishments_variance_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "retailers" */
export type Retailers = {
  __typename?: 'retailers';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  default_establishment?: Maybe<Retailer_Establishments>;
  default_establishment_id?: Maybe<Scalars['bpchar']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['bpchar']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  service_request_recommendations: Array<Service_Request_Recommendations>;
  /** An aggregate relationship */
  service_request_recommendations_aggregate: Service_Request_Recommendations_Aggregate;
  /** An array relationship */
  service_request_retailers: Array<Service_Request_Retailer>;
  /** An aggregate relationship */
  service_request_retailers_aggregate: Service_Request_Retailer_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};


/** columns and relationships of "retailers" */
export type RetailersService_Request_RecommendationsArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Recommendations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Recommendations_Order_By>>;
  where?: InputMaybe<Service_Request_Recommendations_Bool_Exp>;
};


/** columns and relationships of "retailers" */
export type RetailersService_Request_Recommendations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Recommendations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Recommendations_Order_By>>;
  where?: InputMaybe<Service_Request_Recommendations_Bool_Exp>;
};


/** columns and relationships of "retailers" */
export type RetailersService_Request_RetailersArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Retailer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Retailer_Order_By>>;
  where?: InputMaybe<Service_Request_Retailer_Bool_Exp>;
};


/** columns and relationships of "retailers" */
export type RetailersService_Request_Retailers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Retailer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Retailer_Order_By>>;
  where?: InputMaybe<Service_Request_Retailer_Bool_Exp>;
};

/** aggregated selection of "retailers" */
export type Retailers_Aggregate = {
  __typename?: 'retailers_aggregate';
  aggregate?: Maybe<Retailers_Aggregate_Fields>;
  nodes: Array<Retailers>;
};

/** aggregate fields of "retailers" */
export type Retailers_Aggregate_Fields = {
  __typename?: 'retailers_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Retailers_Max_Fields>;
  min?: Maybe<Retailers_Min_Fields>;
};


/** aggregate fields of "retailers" */
export type Retailers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Retailers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "retailers". All fields are combined with a logical 'AND'. */
export type Retailers_Bool_Exp = {
  _and?: InputMaybe<Array<Retailers_Bool_Exp>>;
  _not?: InputMaybe<Retailers_Bool_Exp>;
  _or?: InputMaybe<Array<Retailers_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  default_establishment?: InputMaybe<Retailer_Establishments_Bool_Exp>;
  default_establishment_id?: InputMaybe<Bpchar_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  service_request_recommendations?: InputMaybe<Service_Request_Recommendations_Bool_Exp>;
  service_request_recommendations_aggregate?: InputMaybe<Service_Request_Recommendations_Aggregate_Bool_Exp>;
  service_request_retailers?: InputMaybe<Service_Request_Retailer_Bool_Exp>;
  service_request_retailers_aggregate?: InputMaybe<Service_Request_Retailer_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "retailers" */
export enum Retailers_Constraint {
  /** unique or primary key constraint on columns "id" */
  RetailersPkey = 'retailers_pkey'
}

/** input type for inserting data into table "retailers" */
export type Retailers_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  default_establishment?: InputMaybe<Retailer_Establishments_Obj_Rel_Insert_Input>;
  default_establishment_id?: InputMaybe<Scalars['bpchar']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  service_request_recommendations?: InputMaybe<Service_Request_Recommendations_Arr_Rel_Insert_Input>;
  service_request_retailers?: InputMaybe<Service_Request_Retailer_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Retailers_Max_Fields = {
  __typename?: 'retailers_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  default_establishment_id?: Maybe<Scalars['bpchar']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** aggregate min on columns */
export type Retailers_Min_Fields = {
  __typename?: 'retailers_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  default_establishment_id?: Maybe<Scalars['bpchar']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** response of any mutation on the table "retailers" */
export type Retailers_Mutation_Response = {
  __typename?: 'retailers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Retailers>;
};

/** input type for inserting object relation for remote table "retailers" */
export type Retailers_Obj_Rel_Insert_Input = {
  data: Retailers_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Retailers_On_Conflict>;
};

/** on_conflict condition type for table "retailers" */
export type Retailers_On_Conflict = {
  constraint: Retailers_Constraint;
  update_columns?: Array<Retailers_Update_Column>;
  where?: InputMaybe<Retailers_Bool_Exp>;
};

/** Ordering options when selecting data from "retailers". */
export type Retailers_Order_By = {
  created_at?: InputMaybe<Order_By>;
  default_establishment?: InputMaybe<Retailer_Establishments_Order_By>;
  default_establishment_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  service_request_recommendations_aggregate?: InputMaybe<Service_Request_Recommendations_Aggregate_Order_By>;
  service_request_retailers_aggregate?: InputMaybe<Service_Request_Retailer_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: retailers */
export type Retailers_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** select columns of table "retailers" */
export enum Retailers_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DefaultEstablishmentId = 'default_establishment_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "retailers" */
export type Retailers_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  default_establishment_id?: InputMaybe<Scalars['bpchar']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** Streaming cursor of the table "retailers" */
export type Retailers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Retailers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Retailers_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  default_establishment_id?: InputMaybe<Scalars['bpchar']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** update columns of table "retailers" */
export enum Retailers_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DefaultEstablishmentId = 'default_establishment_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Retailers_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Retailers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Retailers_Bool_Exp;
};

/** columns and relationships of "role_has_permissions" */
export type Role_Has_Permissions = {
  __typename?: 'role_has_permissions';
  /** An object relationship */
  permission: Permissions;
  permission_id: Scalars['bigint']['output'];
  /** An object relationship */
  role: Roles;
  role_id: Scalars['bigint']['output'];
};

/** aggregated selection of "role_has_permissions" */
export type Role_Has_Permissions_Aggregate = {
  __typename?: 'role_has_permissions_aggregate';
  aggregate?: Maybe<Role_Has_Permissions_Aggregate_Fields>;
  nodes: Array<Role_Has_Permissions>;
};

export type Role_Has_Permissions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Role_Has_Permissions_Aggregate_Bool_Exp_Count>;
};

export type Role_Has_Permissions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Role_Has_Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Role_Has_Permissions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "role_has_permissions" */
export type Role_Has_Permissions_Aggregate_Fields = {
  __typename?: 'role_has_permissions_aggregate_fields';
  avg?: Maybe<Role_Has_Permissions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Role_Has_Permissions_Max_Fields>;
  min?: Maybe<Role_Has_Permissions_Min_Fields>;
  stddev?: Maybe<Role_Has_Permissions_Stddev_Fields>;
  stddev_pop?: Maybe<Role_Has_Permissions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Role_Has_Permissions_Stddev_Samp_Fields>;
  sum?: Maybe<Role_Has_Permissions_Sum_Fields>;
  var_pop?: Maybe<Role_Has_Permissions_Var_Pop_Fields>;
  var_samp?: Maybe<Role_Has_Permissions_Var_Samp_Fields>;
  variance?: Maybe<Role_Has_Permissions_Variance_Fields>;
};


/** aggregate fields of "role_has_permissions" */
export type Role_Has_Permissions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Role_Has_Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "role_has_permissions" */
export type Role_Has_Permissions_Aggregate_Order_By = {
  avg?: InputMaybe<Role_Has_Permissions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Role_Has_Permissions_Max_Order_By>;
  min?: InputMaybe<Role_Has_Permissions_Min_Order_By>;
  stddev?: InputMaybe<Role_Has_Permissions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Role_Has_Permissions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Role_Has_Permissions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Role_Has_Permissions_Sum_Order_By>;
  var_pop?: InputMaybe<Role_Has_Permissions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Role_Has_Permissions_Var_Samp_Order_By>;
  variance?: InputMaybe<Role_Has_Permissions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "role_has_permissions" */
export type Role_Has_Permissions_Arr_Rel_Insert_Input = {
  data: Array<Role_Has_Permissions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Role_Has_Permissions_On_Conflict>;
};

/** aggregate avg on columns */
export type Role_Has_Permissions_Avg_Fields = {
  __typename?: 'role_has_permissions_avg_fields';
  permission_id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "role_has_permissions" */
export type Role_Has_Permissions_Avg_Order_By = {
  permission_id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "role_has_permissions". All fields are combined with a logical 'AND'. */
export type Role_Has_Permissions_Bool_Exp = {
  _and?: InputMaybe<Array<Role_Has_Permissions_Bool_Exp>>;
  _not?: InputMaybe<Role_Has_Permissions_Bool_Exp>;
  _or?: InputMaybe<Array<Role_Has_Permissions_Bool_Exp>>;
  permission?: InputMaybe<Permissions_Bool_Exp>;
  permission_id?: InputMaybe<Bigint_Comparison_Exp>;
  role?: InputMaybe<Roles_Bool_Exp>;
  role_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "role_has_permissions" */
export enum Role_Has_Permissions_Constraint {
  /** unique or primary key constraint on columns "permission_id", "role_id" */
  RoleHasPermissionsPkey = 'role_has_permissions_pkey'
}

/** input type for incrementing numeric columns in table "role_has_permissions" */
export type Role_Has_Permissions_Inc_Input = {
  permission_id?: InputMaybe<Scalars['bigint']['input']>;
  role_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "role_has_permissions" */
export type Role_Has_Permissions_Insert_Input = {
  permission?: InputMaybe<Permissions_Obj_Rel_Insert_Input>;
  permission_id?: InputMaybe<Scalars['bigint']['input']>;
  role?: InputMaybe<Roles_Obj_Rel_Insert_Input>;
  role_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Role_Has_Permissions_Max_Fields = {
  __typename?: 'role_has_permissions_max_fields';
  permission_id?: Maybe<Scalars['bigint']['output']>;
  role_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "role_has_permissions" */
export type Role_Has_Permissions_Max_Order_By = {
  permission_id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Role_Has_Permissions_Min_Fields = {
  __typename?: 'role_has_permissions_min_fields';
  permission_id?: Maybe<Scalars['bigint']['output']>;
  role_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "role_has_permissions" */
export type Role_Has_Permissions_Min_Order_By = {
  permission_id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "role_has_permissions" */
export type Role_Has_Permissions_Mutation_Response = {
  __typename?: 'role_has_permissions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Role_Has_Permissions>;
};

/** on_conflict condition type for table "role_has_permissions" */
export type Role_Has_Permissions_On_Conflict = {
  constraint: Role_Has_Permissions_Constraint;
  update_columns?: Array<Role_Has_Permissions_Update_Column>;
  where?: InputMaybe<Role_Has_Permissions_Bool_Exp>;
};

/** Ordering options when selecting data from "role_has_permissions". */
export type Role_Has_Permissions_Order_By = {
  permission?: InputMaybe<Permissions_Order_By>;
  permission_id?: InputMaybe<Order_By>;
  role?: InputMaybe<Roles_Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: role_has_permissions */
export type Role_Has_Permissions_Pk_Columns_Input = {
  permission_id: Scalars['bigint']['input'];
  role_id: Scalars['bigint']['input'];
};

/** select columns of table "role_has_permissions" */
export enum Role_Has_Permissions_Select_Column {
  /** column name */
  PermissionId = 'permission_id',
  /** column name */
  RoleId = 'role_id'
}

/** input type for updating data in table "role_has_permissions" */
export type Role_Has_Permissions_Set_Input = {
  permission_id?: InputMaybe<Scalars['bigint']['input']>;
  role_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Role_Has_Permissions_Stddev_Fields = {
  __typename?: 'role_has_permissions_stddev_fields';
  permission_id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "role_has_permissions" */
export type Role_Has_Permissions_Stddev_Order_By = {
  permission_id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Role_Has_Permissions_Stddev_Pop_Fields = {
  __typename?: 'role_has_permissions_stddev_pop_fields';
  permission_id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "role_has_permissions" */
export type Role_Has_Permissions_Stddev_Pop_Order_By = {
  permission_id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Role_Has_Permissions_Stddev_Samp_Fields = {
  __typename?: 'role_has_permissions_stddev_samp_fields';
  permission_id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "role_has_permissions" */
export type Role_Has_Permissions_Stddev_Samp_Order_By = {
  permission_id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "role_has_permissions" */
export type Role_Has_Permissions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Role_Has_Permissions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Role_Has_Permissions_Stream_Cursor_Value_Input = {
  permission_id?: InputMaybe<Scalars['bigint']['input']>;
  role_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Role_Has_Permissions_Sum_Fields = {
  __typename?: 'role_has_permissions_sum_fields';
  permission_id?: Maybe<Scalars['bigint']['output']>;
  role_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "role_has_permissions" */
export type Role_Has_Permissions_Sum_Order_By = {
  permission_id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** update columns of table "role_has_permissions" */
export enum Role_Has_Permissions_Update_Column {
  /** column name */
  PermissionId = 'permission_id',
  /** column name */
  RoleId = 'role_id'
}

export type Role_Has_Permissions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Role_Has_Permissions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Role_Has_Permissions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Role_Has_Permissions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Role_Has_Permissions_Var_Pop_Fields = {
  __typename?: 'role_has_permissions_var_pop_fields';
  permission_id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "role_has_permissions" */
export type Role_Has_Permissions_Var_Pop_Order_By = {
  permission_id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Role_Has_Permissions_Var_Samp_Fields = {
  __typename?: 'role_has_permissions_var_samp_fields';
  permission_id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "role_has_permissions" */
export type Role_Has_Permissions_Var_Samp_Order_By = {
  permission_id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Role_Has_Permissions_Variance_Fields = {
  __typename?: 'role_has_permissions_variance_fields';
  permission_id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "role_has_permissions" */
export type Role_Has_Permissions_Variance_Order_By = {
  permission_id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "roles" */
export type Roles = {
  __typename?: 'roles';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  guard_name: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
  /** An array relationship */
  model_has_roles: Array<Model_Has_Roles>;
  /** An aggregate relationship */
  model_has_roles_aggregate: Model_Has_Roles_Aggregate;
  name: Scalars['String']['output'];
  /** An array relationship */
  role_has_permissions: Array<Role_Has_Permissions>;
  /** An aggregate relationship */
  role_has_permissions_aggregate: Role_Has_Permissions_Aggregate;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};


/** columns and relationships of "roles" */
export type RolesModel_Has_RolesArgs = {
  distinct_on?: InputMaybe<Array<Model_Has_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Has_Roles_Order_By>>;
  where?: InputMaybe<Model_Has_Roles_Bool_Exp>;
};


/** columns and relationships of "roles" */
export type RolesModel_Has_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Model_Has_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Has_Roles_Order_By>>;
  where?: InputMaybe<Model_Has_Roles_Bool_Exp>;
};


/** columns and relationships of "roles" */
export type RolesRole_Has_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Role_Has_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_Has_Permissions_Order_By>>;
  where?: InputMaybe<Role_Has_Permissions_Bool_Exp>;
};


/** columns and relationships of "roles" */
export type RolesRole_Has_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_Has_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_Has_Permissions_Order_By>>;
  where?: InputMaybe<Role_Has_Permissions_Bool_Exp>;
};

/** aggregated selection of "roles" */
export type Roles_Aggregate = {
  __typename?: 'roles_aggregate';
  aggregate?: Maybe<Roles_Aggregate_Fields>;
  nodes: Array<Roles>;
};

/** aggregate fields of "roles" */
export type Roles_Aggregate_Fields = {
  __typename?: 'roles_aggregate_fields';
  avg?: Maybe<Roles_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Roles_Max_Fields>;
  min?: Maybe<Roles_Min_Fields>;
  stddev?: Maybe<Roles_Stddev_Fields>;
  stddev_pop?: Maybe<Roles_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Roles_Stddev_Samp_Fields>;
  sum?: Maybe<Roles_Sum_Fields>;
  var_pop?: Maybe<Roles_Var_Pop_Fields>;
  var_samp?: Maybe<Roles_Var_Samp_Fields>;
  variance?: Maybe<Roles_Variance_Fields>;
};


/** aggregate fields of "roles" */
export type Roles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Roles_Avg_Fields = {
  __typename?: 'roles_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "roles". All fields are combined with a logical 'AND'. */
export type Roles_Bool_Exp = {
  _and?: InputMaybe<Array<Roles_Bool_Exp>>;
  _not?: InputMaybe<Roles_Bool_Exp>;
  _or?: InputMaybe<Array<Roles_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  guard_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  model_has_roles?: InputMaybe<Model_Has_Roles_Bool_Exp>;
  model_has_roles_aggregate?: InputMaybe<Model_Has_Roles_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  role_has_permissions?: InputMaybe<Role_Has_Permissions_Bool_Exp>;
  role_has_permissions_aggregate?: InputMaybe<Role_Has_Permissions_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "roles" */
export enum Roles_Constraint {
  /** unique or primary key constraint on columns "name", "guard_name" */
  RolesNameGuardNameUnique = 'roles_name_guard_name_unique',
  /** unique or primary key constraint on columns "id" */
  RolesPkey = 'roles_pkey'
}

/** input type for incrementing numeric columns in table "roles" */
export type Roles_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "roles" */
export type Roles_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  guard_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  model_has_roles?: InputMaybe<Model_Has_Roles_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  role_has_permissions?: InputMaybe<Role_Has_Permissions_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Roles_Max_Fields = {
  __typename?: 'roles_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  guard_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Roles_Min_Fields = {
  __typename?: 'roles_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  guard_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "roles" */
export type Roles_Mutation_Response = {
  __typename?: 'roles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Roles>;
};

/** input type for inserting object relation for remote table "roles" */
export type Roles_Obj_Rel_Insert_Input = {
  data: Roles_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Roles_On_Conflict>;
};

/** on_conflict condition type for table "roles" */
export type Roles_On_Conflict = {
  constraint: Roles_Constraint;
  update_columns?: Array<Roles_Update_Column>;
  where?: InputMaybe<Roles_Bool_Exp>;
};

/** Ordering options when selecting data from "roles". */
export type Roles_Order_By = {
  created_at?: InputMaybe<Order_By>;
  guard_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  model_has_roles_aggregate?: InputMaybe<Model_Has_Roles_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  role_has_permissions_aggregate?: InputMaybe<Role_Has_Permissions_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: roles */
export type Roles_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "roles" */
export enum Roles_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GuardName = 'guard_name',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "roles" */
export type Roles_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  guard_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Roles_Stddev_Fields = {
  __typename?: 'roles_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Roles_Stddev_Pop_Fields = {
  __typename?: 'roles_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Roles_Stddev_Samp_Fields = {
  __typename?: 'roles_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "roles" */
export type Roles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Roles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Roles_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  guard_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Roles_Sum_Fields = {
  __typename?: 'roles_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "roles" */
export enum Roles_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GuardName = 'guard_name',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Roles_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Roles_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Roles_Set_Input>;
  /** filter the rows which have to be updated */
  where: Roles_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Roles_Var_Pop_Fields = {
  __typename?: 'roles_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Roles_Var_Samp_Fields = {
  __typename?: 'roles_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Roles_Variance_Fields = {
  __typename?: 'roles_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "runpando_pro.all_state_data" */
export type Runpando_Pro_All_State_Data = {
  __typename?: 'runpando_pro_all_state_data';
  comp_id?: Maybe<Scalars['bigint']['output']>;
  district_name?: Maybe<Scalars['String']['output']>;
  district_std?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  source?: Maybe<Scalars['String']['output']>;
  state_name?: Maybe<Scalars['String']['output']>;
  state_std?: Maybe<Scalars['String']['output']>;
  taluk_name?: Maybe<Scalars['String']['output']>;
  taluk_std?: Maybe<Scalars['String']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
  village_name?: Maybe<Scalars['String']['output']>;
  village_std?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "runpando_pro.all_state_data" */
export type Runpando_Pro_All_State_Data_Aggregate = {
  __typename?: 'runpando_pro_all_state_data_aggregate';
  aggregate?: Maybe<Runpando_Pro_All_State_Data_Aggregate_Fields>;
  nodes: Array<Runpando_Pro_All_State_Data>;
};

/** aggregate fields of "runpando_pro.all_state_data" */
export type Runpando_Pro_All_State_Data_Aggregate_Fields = {
  __typename?: 'runpando_pro_all_state_data_aggregate_fields';
  avg?: Maybe<Runpando_Pro_All_State_Data_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Runpando_Pro_All_State_Data_Max_Fields>;
  min?: Maybe<Runpando_Pro_All_State_Data_Min_Fields>;
  stddev?: Maybe<Runpando_Pro_All_State_Data_Stddev_Fields>;
  stddev_pop?: Maybe<Runpando_Pro_All_State_Data_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Runpando_Pro_All_State_Data_Stddev_Samp_Fields>;
  sum?: Maybe<Runpando_Pro_All_State_Data_Sum_Fields>;
  var_pop?: Maybe<Runpando_Pro_All_State_Data_Var_Pop_Fields>;
  var_samp?: Maybe<Runpando_Pro_All_State_Data_Var_Samp_Fields>;
  variance?: Maybe<Runpando_Pro_All_State_Data_Variance_Fields>;
};


/** aggregate fields of "runpando_pro.all_state_data" */
export type Runpando_Pro_All_State_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Runpando_Pro_All_State_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Runpando_Pro_All_State_Data_Avg_Fields = {
  __typename?: 'runpando_pro_all_state_data_avg_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "runpando_pro.all_state_data". All fields are combined with a logical 'AND'. */
export type Runpando_Pro_All_State_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Runpando_Pro_All_State_Data_Bool_Exp>>;
  _not?: InputMaybe<Runpando_Pro_All_State_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Runpando_Pro_All_State_Data_Bool_Exp>>;
  comp_id?: InputMaybe<Bigint_Comparison_Exp>;
  district_name?: InputMaybe<String_Comparison_Exp>;
  district_std?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  state_name?: InputMaybe<String_Comparison_Exp>;
  state_std?: InputMaybe<String_Comparison_Exp>;
  taluk_name?: InputMaybe<String_Comparison_Exp>;
  taluk_std?: InputMaybe<String_Comparison_Exp>;
  updated_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  village_name?: InputMaybe<String_Comparison_Exp>;
  village_std?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "runpando_pro.all_state_data" */
export enum Runpando_Pro_All_State_Data_Constraint {
  /** unique or primary key constraint on columns "id" */
  Idx_630643Primary = 'idx_630643_primary'
}

/** input type for incrementing numeric columns in table "runpando_pro.all_state_data" */
export type Runpando_Pro_All_State_Data_Inc_Input = {
  comp_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "runpando_pro.all_state_data" */
export type Runpando_Pro_All_State_Data_Insert_Input = {
  comp_id?: InputMaybe<Scalars['bigint']['input']>;
  district_name?: InputMaybe<Scalars['String']['input']>;
  district_std?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  state_name?: InputMaybe<Scalars['String']['input']>;
  state_std?: InputMaybe<Scalars['String']['input']>;
  taluk_name?: InputMaybe<Scalars['String']['input']>;
  taluk_std?: InputMaybe<Scalars['String']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  village_name?: InputMaybe<Scalars['String']['input']>;
  village_std?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Runpando_Pro_All_State_Data_Max_Fields = {
  __typename?: 'runpando_pro_all_state_data_max_fields';
  comp_id?: Maybe<Scalars['bigint']['output']>;
  district_name?: Maybe<Scalars['String']['output']>;
  district_std?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  state_name?: Maybe<Scalars['String']['output']>;
  state_std?: Maybe<Scalars['String']['output']>;
  taluk_name?: Maybe<Scalars['String']['output']>;
  taluk_std?: Maybe<Scalars['String']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
  village_name?: Maybe<Scalars['String']['output']>;
  village_std?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Runpando_Pro_All_State_Data_Min_Fields = {
  __typename?: 'runpando_pro_all_state_data_min_fields';
  comp_id?: Maybe<Scalars['bigint']['output']>;
  district_name?: Maybe<Scalars['String']['output']>;
  district_std?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  state_name?: Maybe<Scalars['String']['output']>;
  state_std?: Maybe<Scalars['String']['output']>;
  taluk_name?: Maybe<Scalars['String']['output']>;
  taluk_std?: Maybe<Scalars['String']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
  village_name?: Maybe<Scalars['String']['output']>;
  village_std?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "runpando_pro.all_state_data" */
export type Runpando_Pro_All_State_Data_Mutation_Response = {
  __typename?: 'runpando_pro_all_state_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Runpando_Pro_All_State_Data>;
};

/** on_conflict condition type for table "runpando_pro.all_state_data" */
export type Runpando_Pro_All_State_Data_On_Conflict = {
  constraint: Runpando_Pro_All_State_Data_Constraint;
  update_columns?: Array<Runpando_Pro_All_State_Data_Update_Column>;
  where?: InputMaybe<Runpando_Pro_All_State_Data_Bool_Exp>;
};

/** Ordering options when selecting data from "runpando_pro.all_state_data". */
export type Runpando_Pro_All_State_Data_Order_By = {
  comp_id?: InputMaybe<Order_By>;
  district_name?: InputMaybe<Order_By>;
  district_std?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  state_name?: InputMaybe<Order_By>;
  state_std?: InputMaybe<Order_By>;
  taluk_name?: InputMaybe<Order_By>;
  taluk_std?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
  village_name?: InputMaybe<Order_By>;
  village_std?: InputMaybe<Order_By>;
};

/** primary key columns input for table: runpando_pro.all_state_data */
export type Runpando_Pro_All_State_Data_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "runpando_pro.all_state_data" */
export enum Runpando_Pro_All_State_Data_Select_Column {
  /** column name */
  CompId = 'comp_id',
  /** column name */
  DistrictName = 'district_name',
  /** column name */
  DistrictStd = 'district_std',
  /** column name */
  Id = 'id',
  /** column name */
  Source = 'source',
  /** column name */
  StateName = 'state_name',
  /** column name */
  StateStd = 'state_std',
  /** column name */
  TalukName = 'taluk_name',
  /** column name */
  TalukStd = 'taluk_std',
  /** column name */
  UpdatedDate = 'updated_date',
  /** column name */
  VillageName = 'village_name',
  /** column name */
  VillageStd = 'village_std'
}

/** input type for updating data in table "runpando_pro.all_state_data" */
export type Runpando_Pro_All_State_Data_Set_Input = {
  comp_id?: InputMaybe<Scalars['bigint']['input']>;
  district_name?: InputMaybe<Scalars['String']['input']>;
  district_std?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  state_name?: InputMaybe<Scalars['String']['input']>;
  state_std?: InputMaybe<Scalars['String']['input']>;
  taluk_name?: InputMaybe<Scalars['String']['input']>;
  taluk_std?: InputMaybe<Scalars['String']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  village_name?: InputMaybe<Scalars['String']['input']>;
  village_std?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Runpando_Pro_All_State_Data_Stddev_Fields = {
  __typename?: 'runpando_pro_all_state_data_stddev_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Runpando_Pro_All_State_Data_Stddev_Pop_Fields = {
  __typename?: 'runpando_pro_all_state_data_stddev_pop_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Runpando_Pro_All_State_Data_Stddev_Samp_Fields = {
  __typename?: 'runpando_pro_all_state_data_stddev_samp_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "runpando_pro_all_state_data" */
export type Runpando_Pro_All_State_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Runpando_Pro_All_State_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Runpando_Pro_All_State_Data_Stream_Cursor_Value_Input = {
  comp_id?: InputMaybe<Scalars['bigint']['input']>;
  district_name?: InputMaybe<Scalars['String']['input']>;
  district_std?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  state_name?: InputMaybe<Scalars['String']['input']>;
  state_std?: InputMaybe<Scalars['String']['input']>;
  taluk_name?: InputMaybe<Scalars['String']['input']>;
  taluk_std?: InputMaybe<Scalars['String']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  village_name?: InputMaybe<Scalars['String']['input']>;
  village_std?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Runpando_Pro_All_State_Data_Sum_Fields = {
  __typename?: 'runpando_pro_all_state_data_sum_fields';
  comp_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "runpando_pro.all_state_data" */
export enum Runpando_Pro_All_State_Data_Update_Column {
  /** column name */
  CompId = 'comp_id',
  /** column name */
  DistrictName = 'district_name',
  /** column name */
  DistrictStd = 'district_std',
  /** column name */
  Id = 'id',
  /** column name */
  Source = 'source',
  /** column name */
  StateName = 'state_name',
  /** column name */
  StateStd = 'state_std',
  /** column name */
  TalukName = 'taluk_name',
  /** column name */
  TalukStd = 'taluk_std',
  /** column name */
  UpdatedDate = 'updated_date',
  /** column name */
  VillageName = 'village_name',
  /** column name */
  VillageStd = 'village_std'
}

export type Runpando_Pro_All_State_Data_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Runpando_Pro_All_State_Data_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Runpando_Pro_All_State_Data_Set_Input>;
  /** filter the rows which have to be updated */
  where: Runpando_Pro_All_State_Data_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Runpando_Pro_All_State_Data_Var_Pop_Fields = {
  __typename?: 'runpando_pro_all_state_data_var_pop_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Runpando_Pro_All_State_Data_Var_Samp_Fields = {
  __typename?: 'runpando_pro_all_state_data_var_samp_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Runpando_Pro_All_State_Data_Variance_Fields = {
  __typename?: 'runpando_pro_all_state_data_variance_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type Runpando_Pro_Channel_Card_Images_Aggregate_Bool_Exp = {
  count?: InputMaybe<Runpando_Pro_Channel_Card_Images_Aggregate_Bool_Exp_Count>;
};

export type Runpando_Pro_Channel_Card_Images_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Pf_Runpando_Pro_Channel_Card_Images_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Pf_Runpando_Pro_Channel_Card_Images_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** columns and relationships of "runpando_pro.users" */
export type Runpando_Pro_Users = {
  __typename?: 'runpando_pro_users';
  access_token?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['bigint']['output']>;
  app_language_id?: Maybe<Scalars['bigint']['output']>;
  area_of_operatoin?: Maybe<Scalars['String']['output']>;
  auth_key?: Maybe<Scalars['String']['output']>;
  business_group?: Maybe<Scalars['String']['output']>;
  business_group_code?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_by: Scalars['bigint']['output'];
  created_date: Scalars['timestamptz']['output'];
  designation?: Maybe<Scalars['String']['output']>;
  designation_id?: Maybe<Scalars['bigint']['output']>;
  device_identifier?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  district_code?: Maybe<Scalars['String']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  employee_number?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  geography_id?: Maybe<Scalars['bigint']['output']>;
  guid: Scalars['String']['output'];
  hashkey?: Maybe<Scalars['String']['output']>;
  head_quarters?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  input_company_id: Scalars['bigint']['output'];
  ip_address?: Maybe<Scalars['String']['output']>;
  is_blocked: Scalars['bigint']['output'];
  is_deleted: Scalars['bigint']['output'];
  is_login: Scalars['smallint']['output'];
  is_login_api: Scalars['smallint']['output'];
  is_notification_on?: Maybe<Scalars['smallint']['output']>;
  is_otp_verified?: Maybe<Scalars['String']['output']>;
  kg_user_id?: Maybe<Scalars['numeric']['output']>;
  knowledge_tab?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  license_active?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  manager_name?: Maybe<Scalars['String']['output']>;
  marker_id?: Maybe<Scalars['bigint']['output']>;
  market_error?: Maybe<Scalars['String']['output']>;
  mobile_validation?: Maybe<Scalars['String']['output']>;
  otp?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  photo_path?: Maybe<Scalars['String']['output']>;
  pin?: Maybe<Scalars['String']['output']>;
  reporting_structure?: Maybe<Scalars['String']['output']>;
  reporting_user_id: Scalars['bigint']['output'];
  retailer_card_language_id?: Maybe<Scalars['bigint']['output']>;
  roleid: Scalars['bigint']['output'];
  session_id?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  state_code?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  territory?: Maybe<Scalars['String']['output']>;
  territory_code?: Maybe<Scalars['String']['output']>;
  updated_by: Scalars['bigint']['output'];
  updated_date: Scalars['timestamptz']['output'];
  updated_time?: Maybe<Scalars['timestamptz']['output']>;
  upl_region?: Maybe<Scalars['String']['output']>;
  upl_region_code?: Maybe<Scalars['String']['output']>;
  user_type?: Maybe<Scalars['String']['output']>;
  verified_phone_number?: Maybe<Scalars['String']['output']>;
  zone?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "runpando_pro.users" */
export type Runpando_Pro_Users_Aggregate = {
  __typename?: 'runpando_pro_users_aggregate';
  aggregate?: Maybe<Runpando_Pro_Users_Aggregate_Fields>;
  nodes: Array<Runpando_Pro_Users>;
};

/** aggregate fields of "runpando_pro.users" */
export type Runpando_Pro_Users_Aggregate_Fields = {
  __typename?: 'runpando_pro_users_aggregate_fields';
  avg?: Maybe<Runpando_Pro_Users_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Runpando_Pro_Users_Max_Fields>;
  min?: Maybe<Runpando_Pro_Users_Min_Fields>;
  stddev?: Maybe<Runpando_Pro_Users_Stddev_Fields>;
  stddev_pop?: Maybe<Runpando_Pro_Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Runpando_Pro_Users_Stddev_Samp_Fields>;
  sum?: Maybe<Runpando_Pro_Users_Sum_Fields>;
  var_pop?: Maybe<Runpando_Pro_Users_Var_Pop_Fields>;
  var_samp?: Maybe<Runpando_Pro_Users_Var_Samp_Fields>;
  variance?: Maybe<Runpando_Pro_Users_Variance_Fields>;
};


/** aggregate fields of "runpando_pro.users" */
export type Runpando_Pro_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Runpando_Pro_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Runpando_Pro_Users_Avg_Fields = {
  __typename?: 'runpando_pro_users_avg_fields';
  age?: Maybe<Scalars['Float']['output']>;
  app_language_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  designation_id?: Maybe<Scalars['Float']['output']>;
  geography_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  input_company_id?: Maybe<Scalars['Float']['output']>;
  is_blocked?: Maybe<Scalars['Float']['output']>;
  is_deleted?: Maybe<Scalars['Float']['output']>;
  is_login?: Maybe<Scalars['Float']['output']>;
  is_login_api?: Maybe<Scalars['Float']['output']>;
  is_notification_on?: Maybe<Scalars['Float']['output']>;
  kg_user_id?: Maybe<Scalars['Float']['output']>;
  marker_id?: Maybe<Scalars['Float']['output']>;
  reporting_user_id?: Maybe<Scalars['Float']['output']>;
  retailer_card_language_id?: Maybe<Scalars['Float']['output']>;
  roleid?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "runpando_pro.users". All fields are combined with a logical 'AND'. */
export type Runpando_Pro_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Runpando_Pro_Users_Bool_Exp>>;
  _not?: InputMaybe<Runpando_Pro_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Runpando_Pro_Users_Bool_Exp>>;
  access_token?: InputMaybe<String_Comparison_Exp>;
  age?: InputMaybe<Bigint_Comparison_Exp>;
  app_language_id?: InputMaybe<Bigint_Comparison_Exp>;
  area_of_operatoin?: InputMaybe<String_Comparison_Exp>;
  auth_key?: InputMaybe<String_Comparison_Exp>;
  business_group?: InputMaybe<String_Comparison_Exp>;
  business_group_code?: InputMaybe<String_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_by?: InputMaybe<Bigint_Comparison_Exp>;
  created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  designation?: InputMaybe<String_Comparison_Exp>;
  designation_id?: InputMaybe<Bigint_Comparison_Exp>;
  device_identifier?: InputMaybe<String_Comparison_Exp>;
  district?: InputMaybe<String_Comparison_Exp>;
  district_code?: InputMaybe<String_Comparison_Exp>;
  email_address?: InputMaybe<String_Comparison_Exp>;
  employee_number?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  geography_id?: InputMaybe<Bigint_Comparison_Exp>;
  guid?: InputMaybe<String_Comparison_Exp>;
  hashkey?: InputMaybe<String_Comparison_Exp>;
  head_quarters?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  input_company_id?: InputMaybe<Bigint_Comparison_Exp>;
  ip_address?: InputMaybe<String_Comparison_Exp>;
  is_blocked?: InputMaybe<Bigint_Comparison_Exp>;
  is_deleted?: InputMaybe<Bigint_Comparison_Exp>;
  is_login?: InputMaybe<Smallint_Comparison_Exp>;
  is_login_api?: InputMaybe<Smallint_Comparison_Exp>;
  is_notification_on?: InputMaybe<Smallint_Comparison_Exp>;
  is_otp_verified?: InputMaybe<String_Comparison_Exp>;
  kg_user_id?: InputMaybe<Numeric_Comparison_Exp>;
  knowledge_tab?: InputMaybe<String_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  license_active?: InputMaybe<Boolean_Comparison_Exp>;
  location?: InputMaybe<String_Comparison_Exp>;
  manager_name?: InputMaybe<String_Comparison_Exp>;
  marker_id?: InputMaybe<Bigint_Comparison_Exp>;
  market_error?: InputMaybe<String_Comparison_Exp>;
  mobile_validation?: InputMaybe<String_Comparison_Exp>;
  otp?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<String_Comparison_Exp>;
  photo_path?: InputMaybe<String_Comparison_Exp>;
  pin?: InputMaybe<String_Comparison_Exp>;
  reporting_structure?: InputMaybe<String_Comparison_Exp>;
  reporting_user_id?: InputMaybe<Bigint_Comparison_Exp>;
  retailer_card_language_id?: InputMaybe<Bigint_Comparison_Exp>;
  roleid?: InputMaybe<Bigint_Comparison_Exp>;
  session_id?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  state_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  territory?: InputMaybe<String_Comparison_Exp>;
  territory_code?: InputMaybe<String_Comparison_Exp>;
  updated_by?: InputMaybe<Bigint_Comparison_Exp>;
  updated_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  upl_region?: InputMaybe<String_Comparison_Exp>;
  upl_region_code?: InputMaybe<String_Comparison_Exp>;
  user_type?: InputMaybe<String_Comparison_Exp>;
  verified_phone_number?: InputMaybe<String_Comparison_Exp>;
  zone?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "runpando_pro.users" */
export enum Runpando_Pro_Users_Constraint {
  /** unique or primary key constraint on columns "access_token" */
  Idx_632048AccessToken_2 = 'idx_632048_access_token_2',
  /** unique or primary key constraint on columns "id" */
  Idx_632048Primary = 'idx_632048_primary',
  /** unique or primary key constraint on columns "verified_phone_number" */
  Idx_632048VerifiedPhoneNumber = 'idx_632048_verified_phone_number'
}

/** input type for incrementing numeric columns in table "runpando_pro.users" */
export type Runpando_Pro_Users_Inc_Input = {
  age?: InputMaybe<Scalars['bigint']['input']>;
  app_language_id?: InputMaybe<Scalars['bigint']['input']>;
  created_by?: InputMaybe<Scalars['bigint']['input']>;
  designation_id?: InputMaybe<Scalars['bigint']['input']>;
  geography_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  input_company_id?: InputMaybe<Scalars['bigint']['input']>;
  is_blocked?: InputMaybe<Scalars['bigint']['input']>;
  is_deleted?: InputMaybe<Scalars['bigint']['input']>;
  is_login?: InputMaybe<Scalars['smallint']['input']>;
  is_login_api?: InputMaybe<Scalars['smallint']['input']>;
  is_notification_on?: InputMaybe<Scalars['smallint']['input']>;
  kg_user_id?: InputMaybe<Scalars['numeric']['input']>;
  marker_id?: InputMaybe<Scalars['bigint']['input']>;
  reporting_user_id?: InputMaybe<Scalars['bigint']['input']>;
  retailer_card_language_id?: InputMaybe<Scalars['bigint']['input']>;
  roleid?: InputMaybe<Scalars['bigint']['input']>;
  updated_by?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "runpando_pro.users" */
export type Runpando_Pro_Users_Insert_Input = {
  access_token?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['bigint']['input']>;
  app_language_id?: InputMaybe<Scalars['bigint']['input']>;
  area_of_operatoin?: InputMaybe<Scalars['String']['input']>;
  auth_key?: InputMaybe<Scalars['String']['input']>;
  business_group?: InputMaybe<Scalars['String']['input']>;
  business_group_code?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['bigint']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  designation_id?: InputMaybe<Scalars['bigint']['input']>;
  device_identifier?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  district_code?: InputMaybe<Scalars['String']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  employee_number?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  geography_id?: InputMaybe<Scalars['bigint']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  hashkey?: InputMaybe<Scalars['String']['input']>;
  head_quarters?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  input_company_id?: InputMaybe<Scalars['bigint']['input']>;
  ip_address?: InputMaybe<Scalars['String']['input']>;
  is_blocked?: InputMaybe<Scalars['bigint']['input']>;
  is_deleted?: InputMaybe<Scalars['bigint']['input']>;
  is_login?: InputMaybe<Scalars['smallint']['input']>;
  is_login_api?: InputMaybe<Scalars['smallint']['input']>;
  is_notification_on?: InputMaybe<Scalars['smallint']['input']>;
  is_otp_verified?: InputMaybe<Scalars['String']['input']>;
  kg_user_id?: InputMaybe<Scalars['numeric']['input']>;
  knowledge_tab?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  license_active?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  manager_name?: InputMaybe<Scalars['String']['input']>;
  marker_id?: InputMaybe<Scalars['bigint']['input']>;
  market_error?: InputMaybe<Scalars['String']['input']>;
  mobile_validation?: InputMaybe<Scalars['String']['input']>;
  otp?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  photo_path?: InputMaybe<Scalars['String']['input']>;
  pin?: InputMaybe<Scalars['String']['input']>;
  reporting_structure?: InputMaybe<Scalars['String']['input']>;
  reporting_user_id?: InputMaybe<Scalars['bigint']['input']>;
  retailer_card_language_id?: InputMaybe<Scalars['bigint']['input']>;
  roleid?: InputMaybe<Scalars['bigint']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_code?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  territory?: InputMaybe<Scalars['String']['input']>;
  territory_code?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['bigint']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_time?: InputMaybe<Scalars['timestamptz']['input']>;
  upl_region?: InputMaybe<Scalars['String']['input']>;
  upl_region_code?: InputMaybe<Scalars['String']['input']>;
  user_type?: InputMaybe<Scalars['String']['input']>;
  verified_phone_number?: InputMaybe<Scalars['String']['input']>;
  zone?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "runpando_pro.users_locations" */
export type Runpando_Pro_Users_Locations = {
  __typename?: 'runpando_pro_users_locations';
  activity_id?: Maybe<Scalars['String']['output']>;
  comp_id?: Maybe<Scalars['bigint']['output']>;
  created_date?: Maybe<Scalars['date']['output']>;
  id: Scalars['bigint']['output'];
  is_active?: Maybe<Scalars['bigint']['output']>;
  is_deleted?: Maybe<Scalars['bigint']['output']>;
  location_id?: Maybe<Scalars['bigint']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "runpando_pro.users_locations" */
export type Runpando_Pro_Users_Locations_Aggregate = {
  __typename?: 'runpando_pro_users_locations_aggregate';
  aggregate?: Maybe<Runpando_Pro_Users_Locations_Aggregate_Fields>;
  nodes: Array<Runpando_Pro_Users_Locations>;
};

export type Runpando_Pro_Users_Locations_Aggregate_Bool_Exp = {
  count?: InputMaybe<Runpando_Pro_Users_Locations_Aggregate_Bool_Exp_Count>;
};

export type Runpando_Pro_Users_Locations_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Pf_Runpando_Pro_Users_Locations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Pf_Runpando_Pro_Users_Locations_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "runpando_pro.users_locations" */
export type Runpando_Pro_Users_Locations_Aggregate_Fields = {
  __typename?: 'runpando_pro_users_locations_aggregate_fields';
  avg?: Maybe<Runpando_Pro_Users_Locations_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Runpando_Pro_Users_Locations_Max_Fields>;
  min?: Maybe<Runpando_Pro_Users_Locations_Min_Fields>;
  stddev?: Maybe<Runpando_Pro_Users_Locations_Stddev_Fields>;
  stddev_pop?: Maybe<Runpando_Pro_Users_Locations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Runpando_Pro_Users_Locations_Stddev_Samp_Fields>;
  sum?: Maybe<Runpando_Pro_Users_Locations_Sum_Fields>;
  var_pop?: Maybe<Runpando_Pro_Users_Locations_Var_Pop_Fields>;
  var_samp?: Maybe<Runpando_Pro_Users_Locations_Var_Samp_Fields>;
  variance?: Maybe<Runpando_Pro_Users_Locations_Variance_Fields>;
};


/** aggregate fields of "runpando_pro.users_locations" */
export type Runpando_Pro_Users_Locations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Runpando_Pro_Users_Locations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Runpando_Pro_Users_Locations_Avg_Fields = {
  __typename?: 'runpando_pro_users_locations_avg_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  is_active?: Maybe<Scalars['Float']['output']>;
  is_deleted?: Maybe<Scalars['Float']['output']>;
  location_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "runpando_pro.users_locations". All fields are combined with a logical 'AND'. */
export type Runpando_Pro_Users_Locations_Bool_Exp = {
  _and?: InputMaybe<Array<Runpando_Pro_Users_Locations_Bool_Exp>>;
  _not?: InputMaybe<Runpando_Pro_Users_Locations_Bool_Exp>;
  _or?: InputMaybe<Array<Runpando_Pro_Users_Locations_Bool_Exp>>;
  activity_id?: InputMaybe<String_Comparison_Exp>;
  comp_id?: InputMaybe<Bigint_Comparison_Exp>;
  created_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Bigint_Comparison_Exp>;
  is_deleted?: InputMaybe<Bigint_Comparison_Exp>;
  location_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "runpando_pro.users_locations" */
export enum Runpando_Pro_Users_Locations_Constraint {
  /** unique or primary key constraint on columns "id" */
  Idx_632067Primary = 'idx_632067_primary',
  /** unique or primary key constraint on columns "user_id", "location_id" */
  Idx_632067UsersLocationsUserIdIdx = 'idx_632067_users_locations_user_id_idx'
}

/** input type for incrementing numeric columns in table "runpando_pro.users_locations" */
export type Runpando_Pro_Users_Locations_Inc_Input = {
  comp_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_active?: InputMaybe<Scalars['bigint']['input']>;
  is_deleted?: InputMaybe<Scalars['bigint']['input']>;
  location_id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "runpando_pro.users_locations" */
export type Runpando_Pro_Users_Locations_Insert_Input = {
  activity_id?: InputMaybe<Scalars['String']['input']>;
  comp_id?: InputMaybe<Scalars['bigint']['input']>;
  created_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_active?: InputMaybe<Scalars['bigint']['input']>;
  is_deleted?: InputMaybe<Scalars['bigint']['input']>;
  location_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Runpando_Pro_Users_Locations_Max_Fields = {
  __typename?: 'runpando_pro_users_locations_max_fields';
  activity_id?: Maybe<Scalars['String']['output']>;
  comp_id?: Maybe<Scalars['bigint']['output']>;
  created_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  is_active?: Maybe<Scalars['bigint']['output']>;
  is_deleted?: Maybe<Scalars['bigint']['output']>;
  location_id?: Maybe<Scalars['bigint']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Runpando_Pro_Users_Locations_Min_Fields = {
  __typename?: 'runpando_pro_users_locations_min_fields';
  activity_id?: Maybe<Scalars['String']['output']>;
  comp_id?: Maybe<Scalars['bigint']['output']>;
  created_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  is_active?: Maybe<Scalars['bigint']['output']>;
  is_deleted?: Maybe<Scalars['bigint']['output']>;
  location_id?: Maybe<Scalars['bigint']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "runpando_pro.users_locations" */
export type Runpando_Pro_Users_Locations_Mutation_Response = {
  __typename?: 'runpando_pro_users_locations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Runpando_Pro_Users_Locations>;
};

/** on_conflict condition type for table "runpando_pro.users_locations" */
export type Runpando_Pro_Users_Locations_On_Conflict = {
  constraint: Runpando_Pro_Users_Locations_Constraint;
  update_columns?: Array<Runpando_Pro_Users_Locations_Update_Column>;
  where?: InputMaybe<Runpando_Pro_Users_Locations_Bool_Exp>;
};

/** Ordering options when selecting data from "runpando_pro.users_locations". */
export type Runpando_Pro_Users_Locations_Order_By = {
  activity_id?: InputMaybe<Order_By>;
  comp_id?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: runpando_pro.users_locations */
export type Runpando_Pro_Users_Locations_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "runpando_pro.users_locations" */
export enum Runpando_Pro_Users_Locations_Select_Column {
  /** column name */
  ActivityId = 'activity_id',
  /** column name */
  CompId = 'comp_id',
  /** column name */
  CreatedDate = 'created_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  UpdatedDate = 'updated_date',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "runpando_pro.users_locations" */
export type Runpando_Pro_Users_Locations_Set_Input = {
  activity_id?: InputMaybe<Scalars['String']['input']>;
  comp_id?: InputMaybe<Scalars['bigint']['input']>;
  created_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_active?: InputMaybe<Scalars['bigint']['input']>;
  is_deleted?: InputMaybe<Scalars['bigint']['input']>;
  location_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Runpando_Pro_Users_Locations_Stddev_Fields = {
  __typename?: 'runpando_pro_users_locations_stddev_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  is_active?: Maybe<Scalars['Float']['output']>;
  is_deleted?: Maybe<Scalars['Float']['output']>;
  location_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Runpando_Pro_Users_Locations_Stddev_Pop_Fields = {
  __typename?: 'runpando_pro_users_locations_stddev_pop_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  is_active?: Maybe<Scalars['Float']['output']>;
  is_deleted?: Maybe<Scalars['Float']['output']>;
  location_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Runpando_Pro_Users_Locations_Stddev_Samp_Fields = {
  __typename?: 'runpando_pro_users_locations_stddev_samp_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  is_active?: Maybe<Scalars['Float']['output']>;
  is_deleted?: Maybe<Scalars['Float']['output']>;
  location_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "runpando_pro_users_locations" */
export type Runpando_Pro_Users_Locations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Runpando_Pro_Users_Locations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Runpando_Pro_Users_Locations_Stream_Cursor_Value_Input = {
  activity_id?: InputMaybe<Scalars['String']['input']>;
  comp_id?: InputMaybe<Scalars['bigint']['input']>;
  created_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_active?: InputMaybe<Scalars['bigint']['input']>;
  is_deleted?: InputMaybe<Scalars['bigint']['input']>;
  location_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Runpando_Pro_Users_Locations_Sum_Fields = {
  __typename?: 'runpando_pro_users_locations_sum_fields';
  comp_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  is_active?: Maybe<Scalars['bigint']['output']>;
  is_deleted?: Maybe<Scalars['bigint']['output']>;
  location_id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "runpando_pro.users_locations" */
export enum Runpando_Pro_Users_Locations_Update_Column {
  /** column name */
  ActivityId = 'activity_id',
  /** column name */
  CompId = 'comp_id',
  /** column name */
  CreatedDate = 'created_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  UpdatedDate = 'updated_date',
  /** column name */
  UserId = 'user_id'
}

export type Runpando_Pro_Users_Locations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Runpando_Pro_Users_Locations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Runpando_Pro_Users_Locations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Runpando_Pro_Users_Locations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Runpando_Pro_Users_Locations_Var_Pop_Fields = {
  __typename?: 'runpando_pro_users_locations_var_pop_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  is_active?: Maybe<Scalars['Float']['output']>;
  is_deleted?: Maybe<Scalars['Float']['output']>;
  location_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Runpando_Pro_Users_Locations_Var_Samp_Fields = {
  __typename?: 'runpando_pro_users_locations_var_samp_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  is_active?: Maybe<Scalars['Float']['output']>;
  is_deleted?: Maybe<Scalars['Float']['output']>;
  location_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Runpando_Pro_Users_Locations_Variance_Fields = {
  __typename?: 'runpando_pro_users_locations_variance_fields';
  comp_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  is_active?: Maybe<Scalars['Float']['output']>;
  is_deleted?: Maybe<Scalars['Float']['output']>;
  location_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate max on columns */
export type Runpando_Pro_Users_Max_Fields = {
  __typename?: 'runpando_pro_users_max_fields';
  access_token?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['bigint']['output']>;
  app_language_id?: Maybe<Scalars['bigint']['output']>;
  area_of_operatoin?: Maybe<Scalars['String']['output']>;
  auth_key?: Maybe<Scalars['String']['output']>;
  business_group?: Maybe<Scalars['String']['output']>;
  business_group_code?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['bigint']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  designation?: Maybe<Scalars['String']['output']>;
  designation_id?: Maybe<Scalars['bigint']['output']>;
  device_identifier?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  district_code?: Maybe<Scalars['String']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  employee_number?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  geography_id?: Maybe<Scalars['bigint']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  hashkey?: Maybe<Scalars['String']['output']>;
  head_quarters?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  input_company_id?: Maybe<Scalars['bigint']['output']>;
  ip_address?: Maybe<Scalars['String']['output']>;
  is_blocked?: Maybe<Scalars['bigint']['output']>;
  is_deleted?: Maybe<Scalars['bigint']['output']>;
  is_login?: Maybe<Scalars['smallint']['output']>;
  is_login_api?: Maybe<Scalars['smallint']['output']>;
  is_notification_on?: Maybe<Scalars['smallint']['output']>;
  is_otp_verified?: Maybe<Scalars['String']['output']>;
  kg_user_id?: Maybe<Scalars['numeric']['output']>;
  knowledge_tab?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  manager_name?: Maybe<Scalars['String']['output']>;
  marker_id?: Maybe<Scalars['bigint']['output']>;
  market_error?: Maybe<Scalars['String']['output']>;
  mobile_validation?: Maybe<Scalars['String']['output']>;
  otp?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  photo_path?: Maybe<Scalars['String']['output']>;
  pin?: Maybe<Scalars['String']['output']>;
  reporting_structure?: Maybe<Scalars['String']['output']>;
  reporting_user_id?: Maybe<Scalars['bigint']['output']>;
  retailer_card_language_id?: Maybe<Scalars['bigint']['output']>;
  roleid?: Maybe<Scalars['bigint']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  state_code?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  territory?: Maybe<Scalars['String']['output']>;
  territory_code?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['bigint']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
  updated_time?: Maybe<Scalars['timestamptz']['output']>;
  upl_region?: Maybe<Scalars['String']['output']>;
  upl_region_code?: Maybe<Scalars['String']['output']>;
  user_type?: Maybe<Scalars['String']['output']>;
  verified_phone_number?: Maybe<Scalars['String']['output']>;
  zone?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Runpando_Pro_Users_Min_Fields = {
  __typename?: 'runpando_pro_users_min_fields';
  access_token?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['bigint']['output']>;
  app_language_id?: Maybe<Scalars['bigint']['output']>;
  area_of_operatoin?: Maybe<Scalars['String']['output']>;
  auth_key?: Maybe<Scalars['String']['output']>;
  business_group?: Maybe<Scalars['String']['output']>;
  business_group_code?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['bigint']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  designation?: Maybe<Scalars['String']['output']>;
  designation_id?: Maybe<Scalars['bigint']['output']>;
  device_identifier?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  district_code?: Maybe<Scalars['String']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  employee_number?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  geography_id?: Maybe<Scalars['bigint']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  hashkey?: Maybe<Scalars['String']['output']>;
  head_quarters?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  input_company_id?: Maybe<Scalars['bigint']['output']>;
  ip_address?: Maybe<Scalars['String']['output']>;
  is_blocked?: Maybe<Scalars['bigint']['output']>;
  is_deleted?: Maybe<Scalars['bigint']['output']>;
  is_login?: Maybe<Scalars['smallint']['output']>;
  is_login_api?: Maybe<Scalars['smallint']['output']>;
  is_notification_on?: Maybe<Scalars['smallint']['output']>;
  is_otp_verified?: Maybe<Scalars['String']['output']>;
  kg_user_id?: Maybe<Scalars['numeric']['output']>;
  knowledge_tab?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  manager_name?: Maybe<Scalars['String']['output']>;
  marker_id?: Maybe<Scalars['bigint']['output']>;
  market_error?: Maybe<Scalars['String']['output']>;
  mobile_validation?: Maybe<Scalars['String']['output']>;
  otp?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  photo_path?: Maybe<Scalars['String']['output']>;
  pin?: Maybe<Scalars['String']['output']>;
  reporting_structure?: Maybe<Scalars['String']['output']>;
  reporting_user_id?: Maybe<Scalars['bigint']['output']>;
  retailer_card_language_id?: Maybe<Scalars['bigint']['output']>;
  roleid?: Maybe<Scalars['bigint']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  state_code?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  territory?: Maybe<Scalars['String']['output']>;
  territory_code?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['bigint']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
  updated_time?: Maybe<Scalars['timestamptz']['output']>;
  upl_region?: Maybe<Scalars['String']['output']>;
  upl_region_code?: Maybe<Scalars['String']['output']>;
  user_type?: Maybe<Scalars['String']['output']>;
  verified_phone_number?: Maybe<Scalars['String']['output']>;
  zone?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "runpando_pro.users" */
export type Runpando_Pro_Users_Mutation_Response = {
  __typename?: 'runpando_pro_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Runpando_Pro_Users>;
};

/** input type for inserting object relation for remote table "runpando_pro.users" */
export type Runpando_Pro_Users_Obj_Rel_Insert_Input = {
  data: Runpando_Pro_Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Runpando_Pro_Users_On_Conflict>;
};

/** on_conflict condition type for table "runpando_pro.users" */
export type Runpando_Pro_Users_On_Conflict = {
  constraint: Runpando_Pro_Users_Constraint;
  update_columns?: Array<Runpando_Pro_Users_Update_Column>;
  where?: InputMaybe<Runpando_Pro_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "runpando_pro.users". */
export type Runpando_Pro_Users_Order_By = {
  access_token?: InputMaybe<Order_By>;
  age?: InputMaybe<Order_By>;
  app_language_id?: InputMaybe<Order_By>;
  area_of_operatoin?: InputMaybe<Order_By>;
  auth_key?: InputMaybe<Order_By>;
  business_group?: InputMaybe<Order_By>;
  business_group_code?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  designation?: InputMaybe<Order_By>;
  designation_id?: InputMaybe<Order_By>;
  device_identifier?: InputMaybe<Order_By>;
  district?: InputMaybe<Order_By>;
  district_code?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  employee_number?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  geography_id?: InputMaybe<Order_By>;
  guid?: InputMaybe<Order_By>;
  hashkey?: InputMaybe<Order_By>;
  head_quarters?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  input_company_id?: InputMaybe<Order_By>;
  ip_address?: InputMaybe<Order_By>;
  is_blocked?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  is_login?: InputMaybe<Order_By>;
  is_login_api?: InputMaybe<Order_By>;
  is_notification_on?: InputMaybe<Order_By>;
  is_otp_verified?: InputMaybe<Order_By>;
  kg_user_id?: InputMaybe<Order_By>;
  knowledge_tab?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  license_active?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  manager_name?: InputMaybe<Order_By>;
  marker_id?: InputMaybe<Order_By>;
  market_error?: InputMaybe<Order_By>;
  mobile_validation?: InputMaybe<Order_By>;
  otp?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  photo?: InputMaybe<Order_By>;
  photo_path?: InputMaybe<Order_By>;
  pin?: InputMaybe<Order_By>;
  reporting_structure?: InputMaybe<Order_By>;
  reporting_user_id?: InputMaybe<Order_By>;
  retailer_card_language_id?: InputMaybe<Order_By>;
  roleid?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  state_code?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  territory?: InputMaybe<Order_By>;
  territory_code?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
  updated_time?: InputMaybe<Order_By>;
  upl_region?: InputMaybe<Order_By>;
  upl_region_code?: InputMaybe<Order_By>;
  user_type?: InputMaybe<Order_By>;
  verified_phone_number?: InputMaybe<Order_By>;
  zone?: InputMaybe<Order_By>;
};

/** primary key columns input for table: runpando_pro.users */
export type Runpando_Pro_Users_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "runpando_pro.users" */
export enum Runpando_Pro_Users_Select_Column {
  /** column name */
  AccessToken = 'access_token',
  /** column name */
  Age = 'age',
  /** column name */
  AppLanguageId = 'app_language_id',
  /** column name */
  AreaOfOperatoin = 'area_of_operatoin',
  /** column name */
  AuthKey = 'auth_key',
  /** column name */
  BusinessGroup = 'business_group',
  /** column name */
  BusinessGroupCode = 'business_group_code',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CreatedDate = 'created_date',
  /** column name */
  Designation = 'designation',
  /** column name */
  DesignationId = 'designation_id',
  /** column name */
  DeviceIdentifier = 'device_identifier',
  /** column name */
  District = 'district',
  /** column name */
  DistrictCode = 'district_code',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  EmployeeNumber = 'employee_number',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  GeographyId = 'geography_id',
  /** column name */
  Guid = 'guid',
  /** column name */
  Hashkey = 'hashkey',
  /** column name */
  HeadQuarters = 'head_quarters',
  /** column name */
  Id = 'id',
  /** column name */
  InputCompanyId = 'input_company_id',
  /** column name */
  IpAddress = 'ip_address',
  /** column name */
  IsBlocked = 'is_blocked',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsLogin = 'is_login',
  /** column name */
  IsLoginApi = 'is_login_api',
  /** column name */
  IsNotificationOn = 'is_notification_on',
  /** column name */
  IsOtpVerified = 'is_otp_verified',
  /** column name */
  KgUserId = 'kg_user_id',
  /** column name */
  KnowledgeTab = 'knowledge_tab',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LicenseActive = 'license_active',
  /** column name */
  Location = 'location',
  /** column name */
  ManagerName = 'manager_name',
  /** column name */
  MarkerId = 'marker_id',
  /** column name */
  MarketError = 'market_error',
  /** column name */
  MobileValidation = 'mobile_validation',
  /** column name */
  Otp = 'otp',
  /** column name */
  Password = 'password',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  Photo = 'photo',
  /** column name */
  PhotoPath = 'photo_path',
  /** column name */
  Pin = 'pin',
  /** column name */
  ReportingStructure = 'reporting_structure',
  /** column name */
  ReportingUserId = 'reporting_user_id',
  /** column name */
  RetailerCardLanguageId = 'retailer_card_language_id',
  /** column name */
  Roleid = 'roleid',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  State = 'state',
  /** column name */
  StateCode = 'state_code',
  /** column name */
  Status = 'status',
  /** column name */
  Territory = 'territory',
  /** column name */
  TerritoryCode = 'territory_code',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  UpdatedDate = 'updated_date',
  /** column name */
  UpdatedTime = 'updated_time',
  /** column name */
  UplRegion = 'upl_region',
  /** column name */
  UplRegionCode = 'upl_region_code',
  /** column name */
  UserType = 'user_type',
  /** column name */
  VerifiedPhoneNumber = 'verified_phone_number',
  /** column name */
  Zone = 'zone'
}

/** input type for updating data in table "runpando_pro.users" */
export type Runpando_Pro_Users_Set_Input = {
  access_token?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['bigint']['input']>;
  app_language_id?: InputMaybe<Scalars['bigint']['input']>;
  area_of_operatoin?: InputMaybe<Scalars['String']['input']>;
  auth_key?: InputMaybe<Scalars['String']['input']>;
  business_group?: InputMaybe<Scalars['String']['input']>;
  business_group_code?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['bigint']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  designation_id?: InputMaybe<Scalars['bigint']['input']>;
  device_identifier?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  district_code?: InputMaybe<Scalars['String']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  employee_number?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  geography_id?: InputMaybe<Scalars['bigint']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  hashkey?: InputMaybe<Scalars['String']['input']>;
  head_quarters?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  input_company_id?: InputMaybe<Scalars['bigint']['input']>;
  ip_address?: InputMaybe<Scalars['String']['input']>;
  is_blocked?: InputMaybe<Scalars['bigint']['input']>;
  is_deleted?: InputMaybe<Scalars['bigint']['input']>;
  is_login?: InputMaybe<Scalars['smallint']['input']>;
  is_login_api?: InputMaybe<Scalars['smallint']['input']>;
  is_notification_on?: InputMaybe<Scalars['smallint']['input']>;
  is_otp_verified?: InputMaybe<Scalars['String']['input']>;
  kg_user_id?: InputMaybe<Scalars['numeric']['input']>;
  knowledge_tab?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  license_active?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  manager_name?: InputMaybe<Scalars['String']['input']>;
  marker_id?: InputMaybe<Scalars['bigint']['input']>;
  market_error?: InputMaybe<Scalars['String']['input']>;
  mobile_validation?: InputMaybe<Scalars['String']['input']>;
  otp?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  photo_path?: InputMaybe<Scalars['String']['input']>;
  pin?: InputMaybe<Scalars['String']['input']>;
  reporting_structure?: InputMaybe<Scalars['String']['input']>;
  reporting_user_id?: InputMaybe<Scalars['bigint']['input']>;
  retailer_card_language_id?: InputMaybe<Scalars['bigint']['input']>;
  roleid?: InputMaybe<Scalars['bigint']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_code?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  territory?: InputMaybe<Scalars['String']['input']>;
  territory_code?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['bigint']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_time?: InputMaybe<Scalars['timestamptz']['input']>;
  upl_region?: InputMaybe<Scalars['String']['input']>;
  upl_region_code?: InputMaybe<Scalars['String']['input']>;
  user_type?: InputMaybe<Scalars['String']['input']>;
  verified_phone_number?: InputMaybe<Scalars['String']['input']>;
  zone?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Runpando_Pro_Users_Stddev_Fields = {
  __typename?: 'runpando_pro_users_stddev_fields';
  age?: Maybe<Scalars['Float']['output']>;
  app_language_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  designation_id?: Maybe<Scalars['Float']['output']>;
  geography_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  input_company_id?: Maybe<Scalars['Float']['output']>;
  is_blocked?: Maybe<Scalars['Float']['output']>;
  is_deleted?: Maybe<Scalars['Float']['output']>;
  is_login?: Maybe<Scalars['Float']['output']>;
  is_login_api?: Maybe<Scalars['Float']['output']>;
  is_notification_on?: Maybe<Scalars['Float']['output']>;
  kg_user_id?: Maybe<Scalars['Float']['output']>;
  marker_id?: Maybe<Scalars['Float']['output']>;
  reporting_user_id?: Maybe<Scalars['Float']['output']>;
  retailer_card_language_id?: Maybe<Scalars['Float']['output']>;
  roleid?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Runpando_Pro_Users_Stddev_Pop_Fields = {
  __typename?: 'runpando_pro_users_stddev_pop_fields';
  age?: Maybe<Scalars['Float']['output']>;
  app_language_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  designation_id?: Maybe<Scalars['Float']['output']>;
  geography_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  input_company_id?: Maybe<Scalars['Float']['output']>;
  is_blocked?: Maybe<Scalars['Float']['output']>;
  is_deleted?: Maybe<Scalars['Float']['output']>;
  is_login?: Maybe<Scalars['Float']['output']>;
  is_login_api?: Maybe<Scalars['Float']['output']>;
  is_notification_on?: Maybe<Scalars['Float']['output']>;
  kg_user_id?: Maybe<Scalars['Float']['output']>;
  marker_id?: Maybe<Scalars['Float']['output']>;
  reporting_user_id?: Maybe<Scalars['Float']['output']>;
  retailer_card_language_id?: Maybe<Scalars['Float']['output']>;
  roleid?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Runpando_Pro_Users_Stddev_Samp_Fields = {
  __typename?: 'runpando_pro_users_stddev_samp_fields';
  age?: Maybe<Scalars['Float']['output']>;
  app_language_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  designation_id?: Maybe<Scalars['Float']['output']>;
  geography_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  input_company_id?: Maybe<Scalars['Float']['output']>;
  is_blocked?: Maybe<Scalars['Float']['output']>;
  is_deleted?: Maybe<Scalars['Float']['output']>;
  is_login?: Maybe<Scalars['Float']['output']>;
  is_login_api?: Maybe<Scalars['Float']['output']>;
  is_notification_on?: Maybe<Scalars['Float']['output']>;
  kg_user_id?: Maybe<Scalars['Float']['output']>;
  marker_id?: Maybe<Scalars['Float']['output']>;
  reporting_user_id?: Maybe<Scalars['Float']['output']>;
  retailer_card_language_id?: Maybe<Scalars['Float']['output']>;
  roleid?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "runpando_pro_users" */
export type Runpando_Pro_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Runpando_Pro_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Runpando_Pro_Users_Stream_Cursor_Value_Input = {
  access_token?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['bigint']['input']>;
  app_language_id?: InputMaybe<Scalars['bigint']['input']>;
  area_of_operatoin?: InputMaybe<Scalars['String']['input']>;
  auth_key?: InputMaybe<Scalars['String']['input']>;
  business_group?: InputMaybe<Scalars['String']['input']>;
  business_group_code?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['bigint']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  designation_id?: InputMaybe<Scalars['bigint']['input']>;
  device_identifier?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  district_code?: InputMaybe<Scalars['String']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  employee_number?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  geography_id?: InputMaybe<Scalars['bigint']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  hashkey?: InputMaybe<Scalars['String']['input']>;
  head_quarters?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  input_company_id?: InputMaybe<Scalars['bigint']['input']>;
  ip_address?: InputMaybe<Scalars['String']['input']>;
  is_blocked?: InputMaybe<Scalars['bigint']['input']>;
  is_deleted?: InputMaybe<Scalars['bigint']['input']>;
  is_login?: InputMaybe<Scalars['smallint']['input']>;
  is_login_api?: InputMaybe<Scalars['smallint']['input']>;
  is_notification_on?: InputMaybe<Scalars['smallint']['input']>;
  is_otp_verified?: InputMaybe<Scalars['String']['input']>;
  kg_user_id?: InputMaybe<Scalars['numeric']['input']>;
  knowledge_tab?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  license_active?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  manager_name?: InputMaybe<Scalars['String']['input']>;
  marker_id?: InputMaybe<Scalars['bigint']['input']>;
  market_error?: InputMaybe<Scalars['String']['input']>;
  mobile_validation?: InputMaybe<Scalars['String']['input']>;
  otp?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  photo_path?: InputMaybe<Scalars['String']['input']>;
  pin?: InputMaybe<Scalars['String']['input']>;
  reporting_structure?: InputMaybe<Scalars['String']['input']>;
  reporting_user_id?: InputMaybe<Scalars['bigint']['input']>;
  retailer_card_language_id?: InputMaybe<Scalars['bigint']['input']>;
  roleid?: InputMaybe<Scalars['bigint']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_code?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  territory?: InputMaybe<Scalars['String']['input']>;
  territory_code?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['bigint']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_time?: InputMaybe<Scalars['timestamptz']['input']>;
  upl_region?: InputMaybe<Scalars['String']['input']>;
  upl_region_code?: InputMaybe<Scalars['String']['input']>;
  user_type?: InputMaybe<Scalars['String']['input']>;
  verified_phone_number?: InputMaybe<Scalars['String']['input']>;
  zone?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Runpando_Pro_Users_Sum_Fields = {
  __typename?: 'runpando_pro_users_sum_fields';
  age?: Maybe<Scalars['bigint']['output']>;
  app_language_id?: Maybe<Scalars['bigint']['output']>;
  created_by?: Maybe<Scalars['bigint']['output']>;
  designation_id?: Maybe<Scalars['bigint']['output']>;
  geography_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  input_company_id?: Maybe<Scalars['bigint']['output']>;
  is_blocked?: Maybe<Scalars['bigint']['output']>;
  is_deleted?: Maybe<Scalars['bigint']['output']>;
  is_login?: Maybe<Scalars['smallint']['output']>;
  is_login_api?: Maybe<Scalars['smallint']['output']>;
  is_notification_on?: Maybe<Scalars['smallint']['output']>;
  kg_user_id?: Maybe<Scalars['numeric']['output']>;
  marker_id?: Maybe<Scalars['bigint']['output']>;
  reporting_user_id?: Maybe<Scalars['bigint']['output']>;
  retailer_card_language_id?: Maybe<Scalars['bigint']['output']>;
  roleid?: Maybe<Scalars['bigint']['output']>;
  updated_by?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "runpando_pro.users" */
export enum Runpando_Pro_Users_Update_Column {
  /** column name */
  AccessToken = 'access_token',
  /** column name */
  Age = 'age',
  /** column name */
  AppLanguageId = 'app_language_id',
  /** column name */
  AreaOfOperatoin = 'area_of_operatoin',
  /** column name */
  AuthKey = 'auth_key',
  /** column name */
  BusinessGroup = 'business_group',
  /** column name */
  BusinessGroupCode = 'business_group_code',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CreatedDate = 'created_date',
  /** column name */
  Designation = 'designation',
  /** column name */
  DesignationId = 'designation_id',
  /** column name */
  DeviceIdentifier = 'device_identifier',
  /** column name */
  District = 'district',
  /** column name */
  DistrictCode = 'district_code',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  EmployeeNumber = 'employee_number',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  GeographyId = 'geography_id',
  /** column name */
  Guid = 'guid',
  /** column name */
  Hashkey = 'hashkey',
  /** column name */
  HeadQuarters = 'head_quarters',
  /** column name */
  Id = 'id',
  /** column name */
  InputCompanyId = 'input_company_id',
  /** column name */
  IpAddress = 'ip_address',
  /** column name */
  IsBlocked = 'is_blocked',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsLogin = 'is_login',
  /** column name */
  IsLoginApi = 'is_login_api',
  /** column name */
  IsNotificationOn = 'is_notification_on',
  /** column name */
  IsOtpVerified = 'is_otp_verified',
  /** column name */
  KgUserId = 'kg_user_id',
  /** column name */
  KnowledgeTab = 'knowledge_tab',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LicenseActive = 'license_active',
  /** column name */
  Location = 'location',
  /** column name */
  ManagerName = 'manager_name',
  /** column name */
  MarkerId = 'marker_id',
  /** column name */
  MarketError = 'market_error',
  /** column name */
  MobileValidation = 'mobile_validation',
  /** column name */
  Otp = 'otp',
  /** column name */
  Password = 'password',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  Photo = 'photo',
  /** column name */
  PhotoPath = 'photo_path',
  /** column name */
  Pin = 'pin',
  /** column name */
  ReportingStructure = 'reporting_structure',
  /** column name */
  ReportingUserId = 'reporting_user_id',
  /** column name */
  RetailerCardLanguageId = 'retailer_card_language_id',
  /** column name */
  Roleid = 'roleid',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  State = 'state',
  /** column name */
  StateCode = 'state_code',
  /** column name */
  Status = 'status',
  /** column name */
  Territory = 'territory',
  /** column name */
  TerritoryCode = 'territory_code',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  UpdatedDate = 'updated_date',
  /** column name */
  UpdatedTime = 'updated_time',
  /** column name */
  UplRegion = 'upl_region',
  /** column name */
  UplRegionCode = 'upl_region_code',
  /** column name */
  UserType = 'user_type',
  /** column name */
  VerifiedPhoneNumber = 'verified_phone_number',
  /** column name */
  Zone = 'zone'
}

export type Runpando_Pro_Users_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Runpando_Pro_Users_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Runpando_Pro_Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Runpando_Pro_Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Runpando_Pro_Users_Var_Pop_Fields = {
  __typename?: 'runpando_pro_users_var_pop_fields';
  age?: Maybe<Scalars['Float']['output']>;
  app_language_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  designation_id?: Maybe<Scalars['Float']['output']>;
  geography_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  input_company_id?: Maybe<Scalars['Float']['output']>;
  is_blocked?: Maybe<Scalars['Float']['output']>;
  is_deleted?: Maybe<Scalars['Float']['output']>;
  is_login?: Maybe<Scalars['Float']['output']>;
  is_login_api?: Maybe<Scalars['Float']['output']>;
  is_notification_on?: Maybe<Scalars['Float']['output']>;
  kg_user_id?: Maybe<Scalars['Float']['output']>;
  marker_id?: Maybe<Scalars['Float']['output']>;
  reporting_user_id?: Maybe<Scalars['Float']['output']>;
  retailer_card_language_id?: Maybe<Scalars['Float']['output']>;
  roleid?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Runpando_Pro_Users_Var_Samp_Fields = {
  __typename?: 'runpando_pro_users_var_samp_fields';
  age?: Maybe<Scalars['Float']['output']>;
  app_language_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  designation_id?: Maybe<Scalars['Float']['output']>;
  geography_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  input_company_id?: Maybe<Scalars['Float']['output']>;
  is_blocked?: Maybe<Scalars['Float']['output']>;
  is_deleted?: Maybe<Scalars['Float']['output']>;
  is_login?: Maybe<Scalars['Float']['output']>;
  is_login_api?: Maybe<Scalars['Float']['output']>;
  is_notification_on?: Maybe<Scalars['Float']['output']>;
  kg_user_id?: Maybe<Scalars['Float']['output']>;
  marker_id?: Maybe<Scalars['Float']['output']>;
  reporting_user_id?: Maybe<Scalars['Float']['output']>;
  retailer_card_language_id?: Maybe<Scalars['Float']['output']>;
  roleid?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Runpando_Pro_Users_Variance_Fields = {
  __typename?: 'runpando_pro_users_variance_fields';
  age?: Maybe<Scalars['Float']['output']>;
  app_language_id?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['Float']['output']>;
  designation_id?: Maybe<Scalars['Float']['output']>;
  geography_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  input_company_id?: Maybe<Scalars['Float']['output']>;
  is_blocked?: Maybe<Scalars['Float']['output']>;
  is_deleted?: Maybe<Scalars['Float']['output']>;
  is_login?: Maybe<Scalars['Float']['output']>;
  is_login_api?: Maybe<Scalars['Float']['output']>;
  is_notification_on?: Maybe<Scalars['Float']['output']>;
  kg_user_id?: Maybe<Scalars['Float']['output']>;
  marker_id?: Maybe<Scalars['Float']['output']>;
  reporting_user_id?: Maybe<Scalars['Float']['output']>;
  retailer_card_language_id?: Maybe<Scalars['Float']['output']>;
  roleid?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "sale_items" */
export type Sale_Items = {
  __typename?: 'sale_items';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['bpchar']['output'];
  /** An object relationship */
  product: Pf_Products;
  product_id: Scalars['bpchar']['output'];
  quantity: Scalars['numeric']['output'];
  /** An object relationship */
  sale: Sales;
  sale_id: Scalars['bpchar']['output'];
  total_price: Scalars['numeric']['output'];
  unit_price: Scalars['numeric']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "sale_items" */
export type Sale_Items_Aggregate = {
  __typename?: 'sale_items_aggregate';
  aggregate?: Maybe<Sale_Items_Aggregate_Fields>;
  nodes: Array<Sale_Items>;
};

export type Sale_Items_Aggregate_Bool_Exp = {
  count?: InputMaybe<Sale_Items_Aggregate_Bool_Exp_Count>;
};

export type Sale_Items_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Sale_Items_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Sale_Items_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "sale_items" */
export type Sale_Items_Aggregate_Fields = {
  __typename?: 'sale_items_aggregate_fields';
  avg?: Maybe<Sale_Items_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Sale_Items_Max_Fields>;
  min?: Maybe<Sale_Items_Min_Fields>;
  stddev?: Maybe<Sale_Items_Stddev_Fields>;
  stddev_pop?: Maybe<Sale_Items_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sale_Items_Stddev_Samp_Fields>;
  sum?: Maybe<Sale_Items_Sum_Fields>;
  var_pop?: Maybe<Sale_Items_Var_Pop_Fields>;
  var_samp?: Maybe<Sale_Items_Var_Samp_Fields>;
  variance?: Maybe<Sale_Items_Variance_Fields>;
};


/** aggregate fields of "sale_items" */
export type Sale_Items_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sale_Items_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "sale_items" */
export type Sale_Items_Aggregate_Order_By = {
  avg?: InputMaybe<Sale_Items_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sale_Items_Max_Order_By>;
  min?: InputMaybe<Sale_Items_Min_Order_By>;
  stddev?: InputMaybe<Sale_Items_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Sale_Items_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Sale_Items_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Sale_Items_Sum_Order_By>;
  var_pop?: InputMaybe<Sale_Items_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Sale_Items_Var_Samp_Order_By>;
  variance?: InputMaybe<Sale_Items_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "sale_items" */
export type Sale_Items_Arr_Rel_Insert_Input = {
  data: Array<Sale_Items_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Sale_Items_On_Conflict>;
};

/** aggregate avg on columns */
export type Sale_Items_Avg_Fields = {
  __typename?: 'sale_items_avg_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
  total_price?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "sale_items" */
export type Sale_Items_Avg_Order_By = {
  quantity?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "sale_items". All fields are combined with a logical 'AND'. */
export type Sale_Items_Bool_Exp = {
  _and?: InputMaybe<Array<Sale_Items_Bool_Exp>>;
  _not?: InputMaybe<Sale_Items_Bool_Exp>;
  _or?: InputMaybe<Array<Sale_Items_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  product?: InputMaybe<Pf_Products_Bool_Exp>;
  product_id?: InputMaybe<Bpchar_Comparison_Exp>;
  quantity?: InputMaybe<Numeric_Comparison_Exp>;
  sale?: InputMaybe<Sales_Bool_Exp>;
  sale_id?: InputMaybe<Bpchar_Comparison_Exp>;
  total_price?: InputMaybe<Numeric_Comparison_Exp>;
  unit_price?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "sale_items" */
export enum Sale_Items_Constraint {
  /** unique or primary key constraint on columns "id" */
  SaleItemsPkey = 'sale_items_pkey'
}

/** input type for incrementing numeric columns in table "sale_items" */
export type Sale_Items_Inc_Input = {
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  total_price?: InputMaybe<Scalars['numeric']['input']>;
  unit_price?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "sale_items" */
export type Sale_Items_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  product?: InputMaybe<Pf_Products_Obj_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['bpchar']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  sale?: InputMaybe<Sales_Obj_Rel_Insert_Input>;
  sale_id?: InputMaybe<Scalars['bpchar']['input']>;
  total_price?: InputMaybe<Scalars['numeric']['input']>;
  unit_price?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Sale_Items_Max_Fields = {
  __typename?: 'sale_items_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  product_id?: Maybe<Scalars['bpchar']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
  sale_id?: Maybe<Scalars['bpchar']['output']>;
  total_price?: Maybe<Scalars['numeric']['output']>;
  unit_price?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "sale_items" */
export type Sale_Items_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sale_id?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Sale_Items_Min_Fields = {
  __typename?: 'sale_items_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  product_id?: Maybe<Scalars['bpchar']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
  sale_id?: Maybe<Scalars['bpchar']['output']>;
  total_price?: Maybe<Scalars['numeric']['output']>;
  unit_price?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "sale_items" */
export type Sale_Items_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sale_id?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "sale_items" */
export type Sale_Items_Mutation_Response = {
  __typename?: 'sale_items_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Sale_Items>;
};

/** on_conflict condition type for table "sale_items" */
export type Sale_Items_On_Conflict = {
  constraint: Sale_Items_Constraint;
  update_columns?: Array<Sale_Items_Update_Column>;
  where?: InputMaybe<Sale_Items_Bool_Exp>;
};

/** Ordering options when selecting data from "sale_items". */
export type Sale_Items_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product?: InputMaybe<Pf_Products_Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sale?: InputMaybe<Sales_Order_By>;
  sale_id?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sale_items */
export type Sale_Items_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** select columns of table "sale_items" */
export enum Sale_Items_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  SaleId = 'sale_id',
  /** column name */
  TotalPrice = 'total_price',
  /** column name */
  UnitPrice = 'unit_price',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "sale_items" */
export type Sale_Items_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  product_id?: InputMaybe<Scalars['bpchar']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  sale_id?: InputMaybe<Scalars['bpchar']['input']>;
  total_price?: InputMaybe<Scalars['numeric']['input']>;
  unit_price?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Sale_Items_Stddev_Fields = {
  __typename?: 'sale_items_stddev_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
  total_price?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "sale_items" */
export type Sale_Items_Stddev_Order_By = {
  quantity?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Sale_Items_Stddev_Pop_Fields = {
  __typename?: 'sale_items_stddev_pop_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
  total_price?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "sale_items" */
export type Sale_Items_Stddev_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Sale_Items_Stddev_Samp_Fields = {
  __typename?: 'sale_items_stddev_samp_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
  total_price?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "sale_items" */
export type Sale_Items_Stddev_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "sale_items" */
export type Sale_Items_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sale_Items_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sale_Items_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  product_id?: InputMaybe<Scalars['bpchar']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  sale_id?: InputMaybe<Scalars['bpchar']['input']>;
  total_price?: InputMaybe<Scalars['numeric']['input']>;
  unit_price?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Sale_Items_Sum_Fields = {
  __typename?: 'sale_items_sum_fields';
  quantity?: Maybe<Scalars['numeric']['output']>;
  total_price?: Maybe<Scalars['numeric']['output']>;
  unit_price?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "sale_items" */
export type Sale_Items_Sum_Order_By = {
  quantity?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** update columns of table "sale_items" */
export enum Sale_Items_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  SaleId = 'sale_id',
  /** column name */
  TotalPrice = 'total_price',
  /** column name */
  UnitPrice = 'unit_price',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Sale_Items_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sale_Items_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sale_Items_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sale_Items_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Sale_Items_Var_Pop_Fields = {
  __typename?: 'sale_items_var_pop_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
  total_price?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "sale_items" */
export type Sale_Items_Var_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Sale_Items_Var_Samp_Fields = {
  __typename?: 'sale_items_var_samp_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
  total_price?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "sale_items" */
export type Sale_Items_Var_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Sale_Items_Variance_Fields = {
  __typename?: 'sale_items_variance_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
  total_price?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "sale_items" */
export type Sale_Items_Variance_Order_By = {
  quantity?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** columns and relationships of "sale_payments" */
export type Sale_Payments = {
  __typename?: 'sale_payments';
  amount: Scalars['numeric']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['bpchar']['output'];
  payment_date: Scalars['timestamptz']['output'];
  payment_method_id: Scalars['bpchar']['output'];
  payment_proof?: Maybe<Scalars['String']['output']>;
  sale_id: Scalars['bpchar']['output'];
  transaction_reference?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "sale_payments" */
export type Sale_Payments_Aggregate = {
  __typename?: 'sale_payments_aggregate';
  aggregate?: Maybe<Sale_Payments_Aggregate_Fields>;
  nodes: Array<Sale_Payments>;
};

/** aggregate fields of "sale_payments" */
export type Sale_Payments_Aggregate_Fields = {
  __typename?: 'sale_payments_aggregate_fields';
  avg?: Maybe<Sale_Payments_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Sale_Payments_Max_Fields>;
  min?: Maybe<Sale_Payments_Min_Fields>;
  stddev?: Maybe<Sale_Payments_Stddev_Fields>;
  stddev_pop?: Maybe<Sale_Payments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sale_Payments_Stddev_Samp_Fields>;
  sum?: Maybe<Sale_Payments_Sum_Fields>;
  var_pop?: Maybe<Sale_Payments_Var_Pop_Fields>;
  var_samp?: Maybe<Sale_Payments_Var_Samp_Fields>;
  variance?: Maybe<Sale_Payments_Variance_Fields>;
};


/** aggregate fields of "sale_payments" */
export type Sale_Payments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sale_Payments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Sale_Payments_Avg_Fields = {
  __typename?: 'sale_payments_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "sale_payments". All fields are combined with a logical 'AND'. */
export type Sale_Payments_Bool_Exp = {
  _and?: InputMaybe<Array<Sale_Payments_Bool_Exp>>;
  _not?: InputMaybe<Sale_Payments_Bool_Exp>;
  _or?: InputMaybe<Array<Sale_Payments_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  payment_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  payment_method_id?: InputMaybe<Bpchar_Comparison_Exp>;
  payment_proof?: InputMaybe<String_Comparison_Exp>;
  sale_id?: InputMaybe<Bpchar_Comparison_Exp>;
  transaction_reference?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "sale_payments" */
export enum Sale_Payments_Constraint {
  /** unique or primary key constraint on columns "id" */
  SalePaymentsPkey = 'sale_payments_pkey'
}

/** input type for incrementing numeric columns in table "sale_payments" */
export type Sale_Payments_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "sale_payments" */
export type Sale_Payments_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  payment_date?: InputMaybe<Scalars['timestamptz']['input']>;
  payment_method_id?: InputMaybe<Scalars['bpchar']['input']>;
  payment_proof?: InputMaybe<Scalars['String']['input']>;
  sale_id?: InputMaybe<Scalars['bpchar']['input']>;
  transaction_reference?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Sale_Payments_Max_Fields = {
  __typename?: 'sale_payments_max_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  payment_date?: Maybe<Scalars['timestamptz']['output']>;
  payment_method_id?: Maybe<Scalars['bpchar']['output']>;
  payment_proof?: Maybe<Scalars['String']['output']>;
  sale_id?: Maybe<Scalars['bpchar']['output']>;
  transaction_reference?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Sale_Payments_Min_Fields = {
  __typename?: 'sale_payments_min_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  payment_date?: Maybe<Scalars['timestamptz']['output']>;
  payment_method_id?: Maybe<Scalars['bpchar']['output']>;
  payment_proof?: Maybe<Scalars['String']['output']>;
  sale_id?: Maybe<Scalars['bpchar']['output']>;
  transaction_reference?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "sale_payments" */
export type Sale_Payments_Mutation_Response = {
  __typename?: 'sale_payments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Sale_Payments>;
};

/** on_conflict condition type for table "sale_payments" */
export type Sale_Payments_On_Conflict = {
  constraint: Sale_Payments_Constraint;
  update_columns?: Array<Sale_Payments_Update_Column>;
  where?: InputMaybe<Sale_Payments_Bool_Exp>;
};

/** Ordering options when selecting data from "sale_payments". */
export type Sale_Payments_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_date?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  payment_proof?: InputMaybe<Order_By>;
  sale_id?: InputMaybe<Order_By>;
  transaction_reference?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sale_payments */
export type Sale_Payments_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** select columns of table "sale_payments" */
export enum Sale_Payments_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentDate = 'payment_date',
  /** column name */
  PaymentMethodId = 'payment_method_id',
  /** column name */
  PaymentProof = 'payment_proof',
  /** column name */
  SaleId = 'sale_id',
  /** column name */
  TransactionReference = 'transaction_reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "sale_payments" */
export type Sale_Payments_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  payment_date?: InputMaybe<Scalars['timestamptz']['input']>;
  payment_method_id?: InputMaybe<Scalars['bpchar']['input']>;
  payment_proof?: InputMaybe<Scalars['String']['input']>;
  sale_id?: InputMaybe<Scalars['bpchar']['input']>;
  transaction_reference?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Sale_Payments_Stddev_Fields = {
  __typename?: 'sale_payments_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Sale_Payments_Stddev_Pop_Fields = {
  __typename?: 'sale_payments_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Sale_Payments_Stddev_Samp_Fields = {
  __typename?: 'sale_payments_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "sale_payments" */
export type Sale_Payments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sale_Payments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sale_Payments_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  payment_date?: InputMaybe<Scalars['timestamptz']['input']>;
  payment_method_id?: InputMaybe<Scalars['bpchar']['input']>;
  payment_proof?: InputMaybe<Scalars['String']['input']>;
  sale_id?: InputMaybe<Scalars['bpchar']['input']>;
  transaction_reference?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Sale_Payments_Sum_Fields = {
  __typename?: 'sale_payments_sum_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "sale_payments" */
export enum Sale_Payments_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentDate = 'payment_date',
  /** column name */
  PaymentMethodId = 'payment_method_id',
  /** column name */
  PaymentProof = 'payment_proof',
  /** column name */
  SaleId = 'sale_id',
  /** column name */
  TransactionReference = 'transaction_reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Sale_Payments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sale_Payments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sale_Payments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sale_Payments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Sale_Payments_Var_Pop_Fields = {
  __typename?: 'sale_payments_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Sale_Payments_Var_Samp_Fields = {
  __typename?: 'sale_payments_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Sale_Payments_Variance_Fields = {
  __typename?: 'sale_payments_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "sale_proof_events" */
export type Sale_Proof_Events = {
  __typename?: 'sale_proof_events';
  action: Scalars['String']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['bpchar']['output'];
  sale_proof_id: Scalars['bpchar']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id: Scalars['bpchar']['output'];
};

/** aggregated selection of "sale_proof_events" */
export type Sale_Proof_Events_Aggregate = {
  __typename?: 'sale_proof_events_aggregate';
  aggregate?: Maybe<Sale_Proof_Events_Aggregate_Fields>;
  nodes: Array<Sale_Proof_Events>;
};

/** aggregate fields of "sale_proof_events" */
export type Sale_Proof_Events_Aggregate_Fields = {
  __typename?: 'sale_proof_events_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Sale_Proof_Events_Max_Fields>;
  min?: Maybe<Sale_Proof_Events_Min_Fields>;
};


/** aggregate fields of "sale_proof_events" */
export type Sale_Proof_Events_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sale_Proof_Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "sale_proof_events". All fields are combined with a logical 'AND'. */
export type Sale_Proof_Events_Bool_Exp = {
  _and?: InputMaybe<Array<Sale_Proof_Events_Bool_Exp>>;
  _not?: InputMaybe<Sale_Proof_Events_Bool_Exp>;
  _or?: InputMaybe<Array<Sale_Proof_Events_Bool_Exp>>;
  action?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  sale_proof_id?: InputMaybe<Bpchar_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "sale_proof_events" */
export enum Sale_Proof_Events_Constraint {
  /** unique or primary key constraint on columns "id" */
  SaleProofEventsPkey = 'sale_proof_events_pkey'
}

/** input type for inserting data into table "sale_proof_events" */
export type Sale_Proof_Events_Insert_Input = {
  action?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  sale_proof_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Sale_Proof_Events_Max_Fields = {
  __typename?: 'sale_proof_events_max_fields';
  action?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  sale_proof_id?: Maybe<Scalars['bpchar']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** aggregate min on columns */
export type Sale_Proof_Events_Min_Fields = {
  __typename?: 'sale_proof_events_min_fields';
  action?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  sale_proof_id?: Maybe<Scalars['bpchar']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** response of any mutation on the table "sale_proof_events" */
export type Sale_Proof_Events_Mutation_Response = {
  __typename?: 'sale_proof_events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Sale_Proof_Events>;
};

/** on_conflict condition type for table "sale_proof_events" */
export type Sale_Proof_Events_On_Conflict = {
  constraint: Sale_Proof_Events_Constraint;
  update_columns?: Array<Sale_Proof_Events_Update_Column>;
  where?: InputMaybe<Sale_Proof_Events_Bool_Exp>;
};

/** Ordering options when selecting data from "sale_proof_events". */
export type Sale_Proof_Events_Order_By = {
  action?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sale_proof_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sale_proof_events */
export type Sale_Proof_Events_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** select columns of table "sale_proof_events" */
export enum Sale_Proof_Events_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  SaleProofId = 'sale_proof_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "sale_proof_events" */
export type Sale_Proof_Events_Set_Input = {
  action?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  sale_proof_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** Streaming cursor of the table "sale_proof_events" */
export type Sale_Proof_Events_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sale_Proof_Events_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sale_Proof_Events_Stream_Cursor_Value_Input = {
  action?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  sale_proof_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** update columns of table "sale_proof_events" */
export enum Sale_Proof_Events_Update_Column {
  /** column name */
  Action = 'action',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  SaleProofId = 'sale_proof_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Sale_Proof_Events_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sale_Proof_Events_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sale_Proof_Events_Bool_Exp;
};

/** columns and relationships of "sale_proof_types" */
export type Sale_Proof_Types = {
  __typename?: 'sale_proof_types';
  active: Scalars['Boolean']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  file_type: Scalars['String']['output'];
  id: Scalars['bpchar']['output'];
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "sale_proof_types" */
export type Sale_Proof_Types_Aggregate = {
  __typename?: 'sale_proof_types_aggregate';
  aggregate?: Maybe<Sale_Proof_Types_Aggregate_Fields>;
  nodes: Array<Sale_Proof_Types>;
};

/** aggregate fields of "sale_proof_types" */
export type Sale_Proof_Types_Aggregate_Fields = {
  __typename?: 'sale_proof_types_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Sale_Proof_Types_Max_Fields>;
  min?: Maybe<Sale_Proof_Types_Min_Fields>;
};


/** aggregate fields of "sale_proof_types" */
export type Sale_Proof_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sale_Proof_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "sale_proof_types". All fields are combined with a logical 'AND'. */
export type Sale_Proof_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Sale_Proof_Types_Bool_Exp>>;
  _not?: InputMaybe<Sale_Proof_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Sale_Proof_Types_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  file_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  required?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "sale_proof_types" */
export enum Sale_Proof_Types_Constraint {
  /** unique or primary key constraint on columns "id" */
  SaleProofTypesPkey = 'sale_proof_types_pkey'
}

/** input type for inserting data into table "sale_proof_types" */
export type Sale_Proof_Types_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  file_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Sale_Proof_Types_Max_Fields = {
  __typename?: 'sale_proof_types_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  file_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Sale_Proof_Types_Min_Fields = {
  __typename?: 'sale_proof_types_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  file_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "sale_proof_types" */
export type Sale_Proof_Types_Mutation_Response = {
  __typename?: 'sale_proof_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Sale_Proof_Types>;
};

/** input type for inserting object relation for remote table "sale_proof_types" */
export type Sale_Proof_Types_Obj_Rel_Insert_Input = {
  data: Sale_Proof_Types_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Sale_Proof_Types_On_Conflict>;
};

/** on_conflict condition type for table "sale_proof_types" */
export type Sale_Proof_Types_On_Conflict = {
  constraint: Sale_Proof_Types_Constraint;
  update_columns?: Array<Sale_Proof_Types_Update_Column>;
  where?: InputMaybe<Sale_Proof_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "sale_proof_types". */
export type Sale_Proof_Types_Order_By = {
  active?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  file_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  required?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sale_proof_types */
export type Sale_Proof_Types_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** select columns of table "sale_proof_types" */
export enum Sale_Proof_Types_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  FileType = 'file_type',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Required = 'required',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "sale_proof_types" */
export type Sale_Proof_Types_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  file_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "sale_proof_types" */
export type Sale_Proof_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sale_Proof_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sale_Proof_Types_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  file_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "sale_proof_types" */
export enum Sale_Proof_Types_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  FileType = 'file_type',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Required = 'required',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Sale_Proof_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sale_Proof_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sale_Proof_Types_Bool_Exp;
};

/** columns and relationships of "sale_proofs" */
export type Sale_Proofs = {
  __typename?: 'sale_proofs';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  data?: Maybe<Scalars['jsonb']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  file_path?: Maybe<Scalars['String']['output']>;
  id: Scalars['bpchar']['output'];
  latitude?: Maybe<Scalars['numeric']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  proof_type_id: Scalars['bpchar']['output'];
  rejection_reason?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  sale: Sales;
  sale_id: Scalars['bpchar']['output'];
  /** An object relationship */
  sale_proof_type: Sale_Proof_Types;
  status: Scalars['String']['output'];
  text_value?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  uploaded_by?: Maybe<Scalars['bpchar']['output']>;
};


/** columns and relationships of "sale_proofs" */
export type Sale_ProofsDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "sale_proofs" */
export type Sale_Proofs_Aggregate = {
  __typename?: 'sale_proofs_aggregate';
  aggregate?: Maybe<Sale_Proofs_Aggregate_Fields>;
  nodes: Array<Sale_Proofs>;
};

export type Sale_Proofs_Aggregate_Bool_Exp = {
  count?: InputMaybe<Sale_Proofs_Aggregate_Bool_Exp_Count>;
};

export type Sale_Proofs_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Sale_Proofs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Sale_Proofs_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "sale_proofs" */
export type Sale_Proofs_Aggregate_Fields = {
  __typename?: 'sale_proofs_aggregate_fields';
  avg?: Maybe<Sale_Proofs_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Sale_Proofs_Max_Fields>;
  min?: Maybe<Sale_Proofs_Min_Fields>;
  stddev?: Maybe<Sale_Proofs_Stddev_Fields>;
  stddev_pop?: Maybe<Sale_Proofs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sale_Proofs_Stddev_Samp_Fields>;
  sum?: Maybe<Sale_Proofs_Sum_Fields>;
  var_pop?: Maybe<Sale_Proofs_Var_Pop_Fields>;
  var_samp?: Maybe<Sale_Proofs_Var_Samp_Fields>;
  variance?: Maybe<Sale_Proofs_Variance_Fields>;
};


/** aggregate fields of "sale_proofs" */
export type Sale_Proofs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sale_Proofs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "sale_proofs" */
export type Sale_Proofs_Aggregate_Order_By = {
  avg?: InputMaybe<Sale_Proofs_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sale_Proofs_Max_Order_By>;
  min?: InputMaybe<Sale_Proofs_Min_Order_By>;
  stddev?: InputMaybe<Sale_Proofs_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Sale_Proofs_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Sale_Proofs_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Sale_Proofs_Sum_Order_By>;
  var_pop?: InputMaybe<Sale_Proofs_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Sale_Proofs_Var_Samp_Order_By>;
  variance?: InputMaybe<Sale_Proofs_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Sale_Proofs_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "sale_proofs" */
export type Sale_Proofs_Arr_Rel_Insert_Input = {
  data: Array<Sale_Proofs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Sale_Proofs_On_Conflict>;
};

/** aggregate avg on columns */
export type Sale_Proofs_Avg_Fields = {
  __typename?: 'sale_proofs_avg_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "sale_proofs" */
export type Sale_Proofs_Avg_Order_By = {
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "sale_proofs". All fields are combined with a logical 'AND'. */
export type Sale_Proofs_Bool_Exp = {
  _and?: InputMaybe<Array<Sale_Proofs_Bool_Exp>>;
  _not?: InputMaybe<Sale_Proofs_Bool_Exp>;
  _or?: InputMaybe<Array<Sale_Proofs_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  file_path?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  latitude?: InputMaybe<Numeric_Comparison_Exp>;
  longitude?: InputMaybe<Numeric_Comparison_Exp>;
  proof_type_id?: InputMaybe<Bpchar_Comparison_Exp>;
  rejection_reason?: InputMaybe<String_Comparison_Exp>;
  sale?: InputMaybe<Sales_Bool_Exp>;
  sale_id?: InputMaybe<Bpchar_Comparison_Exp>;
  sale_proof_type?: InputMaybe<Sale_Proof_Types_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  text_value?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uploaded_by?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "sale_proofs" */
export enum Sale_Proofs_Constraint {
  /** unique or primary key constraint on columns "id" */
  SaleProofsPkey = 'sale_proofs_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Sale_Proofs_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Sale_Proofs_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Sale_Proofs_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "sale_proofs" */
export type Sale_Proofs_Inc_Input = {
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "sale_proofs" */
export type Sale_Proofs_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  file_path?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  proof_type_id?: InputMaybe<Scalars['bpchar']['input']>;
  rejection_reason?: InputMaybe<Scalars['String']['input']>;
  sale?: InputMaybe<Sales_Obj_Rel_Insert_Input>;
  sale_id?: InputMaybe<Scalars['bpchar']['input']>;
  sale_proof_type?: InputMaybe<Sale_Proof_Types_Obj_Rel_Insert_Input>;
  status?: InputMaybe<Scalars['String']['input']>;
  text_value?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  uploaded_by?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Sale_Proofs_Max_Fields = {
  __typename?: 'sale_proofs_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  file_path?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  latitude?: Maybe<Scalars['numeric']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  proof_type_id?: Maybe<Scalars['bpchar']['output']>;
  rejection_reason?: Maybe<Scalars['String']['output']>;
  sale_id?: Maybe<Scalars['bpchar']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  text_value?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  uploaded_by?: Maybe<Scalars['bpchar']['output']>;
};

/** order by max() on columns of table "sale_proofs" */
export type Sale_Proofs_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  file_path?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  proof_type_id?: InputMaybe<Order_By>;
  rejection_reason?: InputMaybe<Order_By>;
  sale_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  text_value?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uploaded_by?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Sale_Proofs_Min_Fields = {
  __typename?: 'sale_proofs_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  file_path?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  latitude?: Maybe<Scalars['numeric']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  proof_type_id?: Maybe<Scalars['bpchar']['output']>;
  rejection_reason?: Maybe<Scalars['String']['output']>;
  sale_id?: Maybe<Scalars['bpchar']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  text_value?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  uploaded_by?: Maybe<Scalars['bpchar']['output']>;
};

/** order by min() on columns of table "sale_proofs" */
export type Sale_Proofs_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  file_path?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  proof_type_id?: InputMaybe<Order_By>;
  rejection_reason?: InputMaybe<Order_By>;
  sale_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  text_value?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uploaded_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "sale_proofs" */
export type Sale_Proofs_Mutation_Response = {
  __typename?: 'sale_proofs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Sale_Proofs>;
};

/** on_conflict condition type for table "sale_proofs" */
export type Sale_Proofs_On_Conflict = {
  constraint: Sale_Proofs_Constraint;
  update_columns?: Array<Sale_Proofs_Update_Column>;
  where?: InputMaybe<Sale_Proofs_Bool_Exp>;
};

/** Ordering options when selecting data from "sale_proofs". */
export type Sale_Proofs_Order_By = {
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  file_path?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  proof_type_id?: InputMaybe<Order_By>;
  rejection_reason?: InputMaybe<Order_By>;
  sale?: InputMaybe<Sales_Order_By>;
  sale_id?: InputMaybe<Order_By>;
  sale_proof_type?: InputMaybe<Sale_Proof_Types_Order_By>;
  status?: InputMaybe<Order_By>;
  text_value?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uploaded_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sale_proofs */
export type Sale_Proofs_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Sale_Proofs_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "sale_proofs" */
export enum Sale_Proofs_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FilePath = 'file_path',
  /** column name */
  Id = 'id',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  ProofTypeId = 'proof_type_id',
  /** column name */
  RejectionReason = 'rejection_reason',
  /** column name */
  SaleId = 'sale_id',
  /** column name */
  Status = 'status',
  /** column name */
  TextValue = 'text_value',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UploadedBy = 'uploaded_by'
}

/** input type for updating data in table "sale_proofs" */
export type Sale_Proofs_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  file_path?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  proof_type_id?: InputMaybe<Scalars['bpchar']['input']>;
  rejection_reason?: InputMaybe<Scalars['String']['input']>;
  sale_id?: InputMaybe<Scalars['bpchar']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  text_value?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  uploaded_by?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate stddev on columns */
export type Sale_Proofs_Stddev_Fields = {
  __typename?: 'sale_proofs_stddev_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "sale_proofs" */
export type Sale_Proofs_Stddev_Order_By = {
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Sale_Proofs_Stddev_Pop_Fields = {
  __typename?: 'sale_proofs_stddev_pop_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "sale_proofs" */
export type Sale_Proofs_Stddev_Pop_Order_By = {
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Sale_Proofs_Stddev_Samp_Fields = {
  __typename?: 'sale_proofs_stddev_samp_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "sale_proofs" */
export type Sale_Proofs_Stddev_Samp_Order_By = {
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "sale_proofs" */
export type Sale_Proofs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sale_Proofs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sale_Proofs_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  file_path?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  proof_type_id?: InputMaybe<Scalars['bpchar']['input']>;
  rejection_reason?: InputMaybe<Scalars['String']['input']>;
  sale_id?: InputMaybe<Scalars['bpchar']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  text_value?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  uploaded_by?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate sum on columns */
export type Sale_Proofs_Sum_Fields = {
  __typename?: 'sale_proofs_sum_fields';
  latitude?: Maybe<Scalars['numeric']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "sale_proofs" */
export type Sale_Proofs_Sum_Order_By = {
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** update columns of table "sale_proofs" */
export enum Sale_Proofs_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FilePath = 'file_path',
  /** column name */
  Id = 'id',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  ProofTypeId = 'proof_type_id',
  /** column name */
  RejectionReason = 'rejection_reason',
  /** column name */
  SaleId = 'sale_id',
  /** column name */
  Status = 'status',
  /** column name */
  TextValue = 'text_value',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UploadedBy = 'uploaded_by'
}

export type Sale_Proofs_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Sale_Proofs_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Sale_Proofs_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Sale_Proofs_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Sale_Proofs_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sale_Proofs_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Sale_Proofs_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sale_Proofs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sale_Proofs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Sale_Proofs_Var_Pop_Fields = {
  __typename?: 'sale_proofs_var_pop_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "sale_proofs" */
export type Sale_Proofs_Var_Pop_Order_By = {
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Sale_Proofs_Var_Samp_Fields = {
  __typename?: 'sale_proofs_var_samp_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "sale_proofs" */
export type Sale_Proofs_Var_Samp_Order_By = {
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Sale_Proofs_Variance_Fields = {
  __typename?: 'sale_proofs_variance_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "sale_proofs" */
export type Sale_Proofs_Variance_Order_By = {
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** columns and relationships of "sales" */
export type Sales = {
  __typename?: 'sales';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  data?: Maybe<Scalars['jsonb']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  farmer_id?: Maybe<Scalars['bpchar']['output']>;
  /** An object relationship */
  farmer_user?: Maybe<Users>;
  field_partner_user_id?: Maybe<Scalars['bpchar']['output']>;
  /** An object relationship */
  fp_user?: Maybe<Users>;
  id: Scalars['bpchar']['output'];
  invoice_number?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['numeric']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  product?: Maybe<Pf_Products>;
  rejection_reason?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  retailer_user?: Maybe<Users>;
  retailer_user_id?: Maybe<Scalars['bpchar']['output']>;
  sale_date?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  sale_items: Array<Sale_Items>;
  /** An aggregate relationship */
  sale_items_aggregate: Sale_Items_Aggregate;
  /** An array relationship */
  sale_proofs: Array<Sale_Proofs>;
  /** An aggregate relationship */
  sale_proofs_aggregate: Sale_Proofs_Aggregate;
  service_request_recommendations_id?: Maybe<Scalars['bpchar']['output']>;
  shopify_order_id?: Maybe<Scalars['String']['output']>;
  shopify_order_number?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  total_amount?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  verified_at?: Maybe<Scalars['timestamptz']['output']>;
  verified_by?: Maybe<Scalars['bpchar']['output']>;
  /** An object relationship */
  verified_by_user?: Maybe<Users>;
};


/** columns and relationships of "sales" */
export type SalesDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "sales" */
export type SalesSale_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Sale_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sale_Items_Order_By>>;
  where?: InputMaybe<Sale_Items_Bool_Exp>;
};


/** columns and relationships of "sales" */
export type SalesSale_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sale_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sale_Items_Order_By>>;
  where?: InputMaybe<Sale_Items_Bool_Exp>;
};


/** columns and relationships of "sales" */
export type SalesSale_ProofsArgs = {
  distinct_on?: InputMaybe<Array<Sale_Proofs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sale_Proofs_Order_By>>;
  where?: InputMaybe<Sale_Proofs_Bool_Exp>;
};


/** columns and relationships of "sales" */
export type SalesSale_Proofs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sale_Proofs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sale_Proofs_Order_By>>;
  where?: InputMaybe<Sale_Proofs_Bool_Exp>;
};

/** aggregated selection of "sales" */
export type Sales_Aggregate = {
  __typename?: 'sales_aggregate';
  aggregate?: Maybe<Sales_Aggregate_Fields>;
  nodes: Array<Sales>;
};

/** aggregate fields of "sales" */
export type Sales_Aggregate_Fields = {
  __typename?: 'sales_aggregate_fields';
  avg?: Maybe<Sales_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Sales_Max_Fields>;
  min?: Maybe<Sales_Min_Fields>;
  stddev?: Maybe<Sales_Stddev_Fields>;
  stddev_pop?: Maybe<Sales_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sales_Stddev_Samp_Fields>;
  sum?: Maybe<Sales_Sum_Fields>;
  var_pop?: Maybe<Sales_Var_Pop_Fields>;
  var_samp?: Maybe<Sales_Var_Samp_Fields>;
  variance?: Maybe<Sales_Variance_Fields>;
};


/** aggregate fields of "sales" */
export type Sales_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sales_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Sales_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Sales_Avg_Fields = {
  __typename?: 'sales_avg_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "sales". All fields are combined with a logical 'AND'. */
export type Sales_Bool_Exp = {
  _and?: InputMaybe<Array<Sales_Bool_Exp>>;
  _not?: InputMaybe<Sales_Bool_Exp>;
  _or?: InputMaybe<Array<Sales_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  farmer_id?: InputMaybe<Bpchar_Comparison_Exp>;
  farmer_user?: InputMaybe<Users_Bool_Exp>;
  field_partner_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  fp_user?: InputMaybe<Users_Bool_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  invoice_number?: InputMaybe<String_Comparison_Exp>;
  latitude?: InputMaybe<Numeric_Comparison_Exp>;
  longitude?: InputMaybe<Numeric_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  product?: InputMaybe<Pf_Products_Bool_Exp>;
  rejection_reason?: InputMaybe<String_Comparison_Exp>;
  retailer_user?: InputMaybe<Users_Bool_Exp>;
  retailer_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  sale_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  sale_items?: InputMaybe<Sale_Items_Bool_Exp>;
  sale_items_aggregate?: InputMaybe<Sale_Items_Aggregate_Bool_Exp>;
  sale_proofs?: InputMaybe<Sale_Proofs_Bool_Exp>;
  sale_proofs_aggregate?: InputMaybe<Sale_Proofs_Aggregate_Bool_Exp>;
  service_request_recommendations_id?: InputMaybe<Bpchar_Comparison_Exp>;
  shopify_order_id?: InputMaybe<String_Comparison_Exp>;
  shopify_order_number?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  total_amount?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  verified_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  verified_by?: InputMaybe<Bpchar_Comparison_Exp>;
  verified_by_user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "sales" */
export enum Sales_Constraint {
  /** unique or primary key constraint on columns "invoice_number" */
  SalesInvoiceNumberUnique = 'sales_invoice_number_unique',
  /** unique or primary key constraint on columns "id" */
  SalesPkey = 'sales_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Sales_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Sales_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Sales_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "sales" */
export type Sales_Inc_Input = {
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  total_amount?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "sales" */
export type Sales_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer_id?: InputMaybe<Scalars['bpchar']['input']>;
  farmer_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  field_partner_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  fp_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  invoice_number?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Pf_Products_Obj_Rel_Insert_Input>;
  rejection_reason?: InputMaybe<Scalars['String']['input']>;
  retailer_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  retailer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  sale_date?: InputMaybe<Scalars['timestamptz']['input']>;
  sale_items?: InputMaybe<Sale_Items_Arr_Rel_Insert_Input>;
  sale_proofs?: InputMaybe<Sale_Proofs_Arr_Rel_Insert_Input>;
  service_request_recommendations_id?: InputMaybe<Scalars['bpchar']['input']>;
  shopify_order_id?: InputMaybe<Scalars['String']['input']>;
  shopify_order_number?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  total_amount?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  verified_at?: InputMaybe<Scalars['timestamptz']['input']>;
  verified_by?: InputMaybe<Scalars['bpchar']['input']>;
  verified_by_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Sales_Max_Fields = {
  __typename?: 'sales_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  farmer_id?: Maybe<Scalars['bpchar']['output']>;
  field_partner_user_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  invoice_number?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['numeric']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  rejection_reason?: Maybe<Scalars['String']['output']>;
  retailer_user_id?: Maybe<Scalars['bpchar']['output']>;
  sale_date?: Maybe<Scalars['timestamptz']['output']>;
  service_request_recommendations_id?: Maybe<Scalars['bpchar']['output']>;
  shopify_order_id?: Maybe<Scalars['String']['output']>;
  shopify_order_number?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  verified_at?: Maybe<Scalars['timestamptz']['output']>;
  verified_by?: Maybe<Scalars['bpchar']['output']>;
};

/** aggregate min on columns */
export type Sales_Min_Fields = {
  __typename?: 'sales_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  farmer_id?: Maybe<Scalars['bpchar']['output']>;
  field_partner_user_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  invoice_number?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['numeric']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  rejection_reason?: Maybe<Scalars['String']['output']>;
  retailer_user_id?: Maybe<Scalars['bpchar']['output']>;
  sale_date?: Maybe<Scalars['timestamptz']['output']>;
  service_request_recommendations_id?: Maybe<Scalars['bpchar']['output']>;
  shopify_order_id?: Maybe<Scalars['String']['output']>;
  shopify_order_number?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  verified_at?: Maybe<Scalars['timestamptz']['output']>;
  verified_by?: Maybe<Scalars['bpchar']['output']>;
};

/** response of any mutation on the table "sales" */
export type Sales_Mutation_Response = {
  __typename?: 'sales_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Sales>;
};

/** input type for inserting object relation for remote table "sales" */
export type Sales_Obj_Rel_Insert_Input = {
  data: Sales_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Sales_On_Conflict>;
};

/** on_conflict condition type for table "sales" */
export type Sales_On_Conflict = {
  constraint: Sales_Constraint;
  update_columns?: Array<Sales_Update_Column>;
  where?: InputMaybe<Sales_Bool_Exp>;
};

/** Ordering options when selecting data from "sales". */
export type Sales_Order_By = {
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  farmer_user?: InputMaybe<Users_Order_By>;
  field_partner_user_id?: InputMaybe<Order_By>;
  fp_user?: InputMaybe<Users_Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_number?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  product?: InputMaybe<Pf_Products_Order_By>;
  rejection_reason?: InputMaybe<Order_By>;
  retailer_user?: InputMaybe<Users_Order_By>;
  retailer_user_id?: InputMaybe<Order_By>;
  sale_date?: InputMaybe<Order_By>;
  sale_items_aggregate?: InputMaybe<Sale_Items_Aggregate_Order_By>;
  sale_proofs_aggregate?: InputMaybe<Sale_Proofs_Aggregate_Order_By>;
  service_request_recommendations_id?: InputMaybe<Order_By>;
  shopify_order_id?: InputMaybe<Order_By>;
  shopify_order_number?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  verified_at?: InputMaybe<Order_By>;
  verified_by?: InputMaybe<Order_By>;
  verified_by_user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: sales */
export type Sales_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Sales_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "sales" */
export enum Sales_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FarmerId = 'farmer_id',
  /** column name */
  FieldPartnerUserId = 'field_partner_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceNumber = 'invoice_number',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Notes = 'notes',
  /** column name */
  RejectionReason = 'rejection_reason',
  /** column name */
  RetailerUserId = 'retailer_user_id',
  /** column name */
  SaleDate = 'sale_date',
  /** column name */
  ServiceRequestRecommendationsId = 'service_request_recommendations_id',
  /** column name */
  ShopifyOrderId = 'shopify_order_id',
  /** column name */
  ShopifyOrderNumber = 'shopify_order_number',
  /** column name */
  Status = 'status',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VerifiedAt = 'verified_at',
  /** column name */
  VerifiedBy = 'verified_by'
}

/** input type for updating data in table "sales" */
export type Sales_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer_id?: InputMaybe<Scalars['bpchar']['input']>;
  field_partner_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  invoice_number?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  rejection_reason?: InputMaybe<Scalars['String']['input']>;
  retailer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  sale_date?: InputMaybe<Scalars['timestamptz']['input']>;
  service_request_recommendations_id?: InputMaybe<Scalars['bpchar']['input']>;
  shopify_order_id?: InputMaybe<Scalars['String']['input']>;
  shopify_order_number?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  total_amount?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  verified_at?: InputMaybe<Scalars['timestamptz']['input']>;
  verified_by?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate stddev on columns */
export type Sales_Stddev_Fields = {
  __typename?: 'sales_stddev_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Sales_Stddev_Pop_Fields = {
  __typename?: 'sales_stddev_pop_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Sales_Stddev_Samp_Fields = {
  __typename?: 'sales_stddev_samp_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "sales" */
export type Sales_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sales_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sales_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer_id?: InputMaybe<Scalars['bpchar']['input']>;
  field_partner_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  invoice_number?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  rejection_reason?: InputMaybe<Scalars['String']['input']>;
  retailer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  sale_date?: InputMaybe<Scalars['timestamptz']['input']>;
  service_request_recommendations_id?: InputMaybe<Scalars['bpchar']['input']>;
  shopify_order_id?: InputMaybe<Scalars['String']['input']>;
  shopify_order_number?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  total_amount?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  verified_at?: InputMaybe<Scalars['timestamptz']['input']>;
  verified_by?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate sum on columns */
export type Sales_Sum_Fields = {
  __typename?: 'sales_sum_fields';
  latitude?: Maybe<Scalars['numeric']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  total_amount?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "sales" */
export enum Sales_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FarmerId = 'farmer_id',
  /** column name */
  FieldPartnerUserId = 'field_partner_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceNumber = 'invoice_number',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Notes = 'notes',
  /** column name */
  RejectionReason = 'rejection_reason',
  /** column name */
  RetailerUserId = 'retailer_user_id',
  /** column name */
  SaleDate = 'sale_date',
  /** column name */
  ServiceRequestRecommendationsId = 'service_request_recommendations_id',
  /** column name */
  ShopifyOrderId = 'shopify_order_id',
  /** column name */
  ShopifyOrderNumber = 'shopify_order_number',
  /** column name */
  Status = 'status',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VerifiedAt = 'verified_at',
  /** column name */
  VerifiedBy = 'verified_by'
}

export type Sales_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Sales_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Sales_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Sales_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Sales_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sales_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Sales_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sales_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sales_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Sales_Var_Pop_Fields = {
  __typename?: 'sales_var_pop_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Sales_Var_Samp_Fields = {
  __typename?: 'sales_var_samp_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Sales_Variance_Fields = {
  __typename?: 'sales_variance_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "saved_reels" */
export type Saved_Reels = {
  __typename?: 'saved_reels';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  extras?: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['bigint']['output'];
  /** An object relationship */
  reel: Reels;
  reel_id: Scalars['bigint']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id: Scalars['bpchar']['output'];
};


/** columns and relationships of "saved_reels" */
export type Saved_ReelsExtrasArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "saved_reels" */
export type Saved_Reels_Aggregate = {
  __typename?: 'saved_reels_aggregate';
  aggregate?: Maybe<Saved_Reels_Aggregate_Fields>;
  nodes: Array<Saved_Reels>;
};

export type Saved_Reels_Aggregate_Bool_Exp = {
  count?: InputMaybe<Saved_Reels_Aggregate_Bool_Exp_Count>;
};

export type Saved_Reels_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Saved_Reels_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Saved_Reels_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "saved_reels" */
export type Saved_Reels_Aggregate_Fields = {
  __typename?: 'saved_reels_aggregate_fields';
  avg?: Maybe<Saved_Reels_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Saved_Reels_Max_Fields>;
  min?: Maybe<Saved_Reels_Min_Fields>;
  stddev?: Maybe<Saved_Reels_Stddev_Fields>;
  stddev_pop?: Maybe<Saved_Reels_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Saved_Reels_Stddev_Samp_Fields>;
  sum?: Maybe<Saved_Reels_Sum_Fields>;
  var_pop?: Maybe<Saved_Reels_Var_Pop_Fields>;
  var_samp?: Maybe<Saved_Reels_Var_Samp_Fields>;
  variance?: Maybe<Saved_Reels_Variance_Fields>;
};


/** aggregate fields of "saved_reels" */
export type Saved_Reels_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Saved_Reels_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "saved_reels" */
export type Saved_Reels_Aggregate_Order_By = {
  avg?: InputMaybe<Saved_Reels_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Saved_Reels_Max_Order_By>;
  min?: InputMaybe<Saved_Reels_Min_Order_By>;
  stddev?: InputMaybe<Saved_Reels_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Saved_Reels_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Saved_Reels_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Saved_Reels_Sum_Order_By>;
  var_pop?: InputMaybe<Saved_Reels_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Saved_Reels_Var_Samp_Order_By>;
  variance?: InputMaybe<Saved_Reels_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Saved_Reels_Append_Input = {
  extras?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "saved_reels" */
export type Saved_Reels_Arr_Rel_Insert_Input = {
  data: Array<Saved_Reels_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Saved_Reels_On_Conflict>;
};

/** aggregate avg on columns */
export type Saved_Reels_Avg_Fields = {
  __typename?: 'saved_reels_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "saved_reels" */
export type Saved_Reels_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "saved_reels". All fields are combined with a logical 'AND'. */
export type Saved_Reels_Bool_Exp = {
  _and?: InputMaybe<Array<Saved_Reels_Bool_Exp>>;
  _not?: InputMaybe<Saved_Reels_Bool_Exp>;
  _or?: InputMaybe<Array<Saved_Reels_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  extras?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  reel?: InputMaybe<Reels_Bool_Exp>;
  reel_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "saved_reels" */
export enum Saved_Reels_Constraint {
  /** unique or primary key constraint on columns "id" */
  SavedReelsPkey = 'saved_reels_pkey',
  /** unique or primary key constraint on columns "user_id", "reel_id" */
  UserReelUniq = 'user_reel_uniq'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Saved_Reels_Delete_At_Path_Input = {
  extras?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Saved_Reels_Delete_Elem_Input = {
  extras?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Saved_Reels_Delete_Key_Input = {
  extras?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "saved_reels" */
export type Saved_Reels_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  reel_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "saved_reels" */
export type Saved_Reels_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  extras?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  reel?: InputMaybe<Reels_Obj_Rel_Insert_Input>;
  reel_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Saved_Reels_Max_Fields = {
  __typename?: 'saved_reels_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  reel_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by max() on columns of table "saved_reels" */
export type Saved_Reels_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Saved_Reels_Min_Fields = {
  __typename?: 'saved_reels_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  reel_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by min() on columns of table "saved_reels" */
export type Saved_Reels_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "saved_reels" */
export type Saved_Reels_Mutation_Response = {
  __typename?: 'saved_reels_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Saved_Reels>;
};

/** on_conflict condition type for table "saved_reels" */
export type Saved_Reels_On_Conflict = {
  constraint: Saved_Reels_Constraint;
  update_columns?: Array<Saved_Reels_Update_Column>;
  where?: InputMaybe<Saved_Reels_Bool_Exp>;
};

/** Ordering options when selecting data from "saved_reels". */
export type Saved_Reels_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  extras?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reel?: InputMaybe<Reels_Order_By>;
  reel_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: saved_reels */
export type Saved_Reels_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Saved_Reels_Prepend_Input = {
  extras?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "saved_reels" */
export enum Saved_Reels_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Extras = 'extras',
  /** column name */
  Id = 'id',
  /** column name */
  ReelId = 'reel_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "saved_reels" */
export type Saved_Reels_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  extras?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  reel_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate stddev on columns */
export type Saved_Reels_Stddev_Fields = {
  __typename?: 'saved_reels_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "saved_reels" */
export type Saved_Reels_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Saved_Reels_Stddev_Pop_Fields = {
  __typename?: 'saved_reels_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "saved_reels" */
export type Saved_Reels_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Saved_Reels_Stddev_Samp_Fields = {
  __typename?: 'saved_reels_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "saved_reels" */
export type Saved_Reels_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "saved_reels" */
export type Saved_Reels_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Saved_Reels_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Saved_Reels_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  extras?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  reel_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate sum on columns */
export type Saved_Reels_Sum_Fields = {
  __typename?: 'saved_reels_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  reel_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "saved_reels" */
export type Saved_Reels_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
};

/** update columns of table "saved_reels" */
export enum Saved_Reels_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Extras = 'extras',
  /** column name */
  Id = 'id',
  /** column name */
  ReelId = 'reel_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Saved_Reels_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Saved_Reels_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Saved_Reels_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Saved_Reels_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Saved_Reels_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Saved_Reels_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Saved_Reels_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Saved_Reels_Set_Input>;
  /** filter the rows which have to be updated */
  where: Saved_Reels_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Saved_Reels_Var_Pop_Fields = {
  __typename?: 'saved_reels_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "saved_reels" */
export type Saved_Reels_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Saved_Reels_Var_Samp_Fields = {
  __typename?: 'saved_reels_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "saved_reels" */
export type Saved_Reels_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Saved_Reels_Variance_Fields = {
  __typename?: 'saved_reels_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "saved_reels" */
export type Saved_Reels_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
};

export type Search_Field_Force_Near_Farmer_Args = {
  distance_kms?: InputMaybe<Scalars['Int']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
};

/** columns and relationships of "segment_user" */
export type Segment_User = {
  __typename?: 'segment_user';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['bigint']['output'];
  /** An object relationship */
  master_segment: Master_Segments;
  segment_id: Scalars['bpchar']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['bpchar']['output'];
};

/** aggregated selection of "segment_user" */
export type Segment_User_Aggregate = {
  __typename?: 'segment_user_aggregate';
  aggregate?: Maybe<Segment_User_Aggregate_Fields>;
  nodes: Array<Segment_User>;
};

export type Segment_User_Aggregate_Bool_Exp = {
  count?: InputMaybe<Segment_User_Aggregate_Bool_Exp_Count>;
};

export type Segment_User_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Segment_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Segment_User_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "segment_user" */
export type Segment_User_Aggregate_Fields = {
  __typename?: 'segment_user_aggregate_fields';
  avg?: Maybe<Segment_User_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Segment_User_Max_Fields>;
  min?: Maybe<Segment_User_Min_Fields>;
  stddev?: Maybe<Segment_User_Stddev_Fields>;
  stddev_pop?: Maybe<Segment_User_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Segment_User_Stddev_Samp_Fields>;
  sum?: Maybe<Segment_User_Sum_Fields>;
  var_pop?: Maybe<Segment_User_Var_Pop_Fields>;
  var_samp?: Maybe<Segment_User_Var_Samp_Fields>;
  variance?: Maybe<Segment_User_Variance_Fields>;
};


/** aggregate fields of "segment_user" */
export type Segment_User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Segment_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "segment_user" */
export type Segment_User_Aggregate_Order_By = {
  avg?: InputMaybe<Segment_User_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Segment_User_Max_Order_By>;
  min?: InputMaybe<Segment_User_Min_Order_By>;
  stddev?: InputMaybe<Segment_User_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Segment_User_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Segment_User_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Segment_User_Sum_Order_By>;
  var_pop?: InputMaybe<Segment_User_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Segment_User_Var_Samp_Order_By>;
  variance?: InputMaybe<Segment_User_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "segment_user" */
export type Segment_User_Arr_Rel_Insert_Input = {
  data: Array<Segment_User_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Segment_User_On_Conflict>;
};

/** aggregate avg on columns */
export type Segment_User_Avg_Fields = {
  __typename?: 'segment_user_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "segment_user" */
export type Segment_User_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "segment_user". All fields are combined with a logical 'AND'. */
export type Segment_User_Bool_Exp = {
  _and?: InputMaybe<Array<Segment_User_Bool_Exp>>;
  _not?: InputMaybe<Segment_User_Bool_Exp>;
  _or?: InputMaybe<Array<Segment_User_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  master_segment?: InputMaybe<Master_Segments_Bool_Exp>;
  segment_id?: InputMaybe<Bpchar_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "segment_user" */
export enum Segment_User_Constraint {
  /** unique or primary key constraint on columns "id" */
  SegmentUserPkey = 'segment_user_pkey'
}

/** input type for incrementing numeric columns in table "segment_user" */
export type Segment_User_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "segment_user" */
export type Segment_User_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  master_segment?: InputMaybe<Master_Segments_Obj_Rel_Insert_Input>;
  segment_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Segment_User_Max_Fields = {
  __typename?: 'segment_user_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  segment_id?: Maybe<Scalars['bpchar']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by max() on columns of table "segment_user" */
export type Segment_User_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  segment_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Segment_User_Min_Fields = {
  __typename?: 'segment_user_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  segment_id?: Maybe<Scalars['bpchar']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by min() on columns of table "segment_user" */
export type Segment_User_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  segment_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "segment_user" */
export type Segment_User_Mutation_Response = {
  __typename?: 'segment_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Segment_User>;
};

/** on_conflict condition type for table "segment_user" */
export type Segment_User_On_Conflict = {
  constraint: Segment_User_Constraint;
  update_columns?: Array<Segment_User_Update_Column>;
  where?: InputMaybe<Segment_User_Bool_Exp>;
};

/** Ordering options when selecting data from "segment_user". */
export type Segment_User_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  master_segment?: InputMaybe<Master_Segments_Order_By>;
  segment_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: segment_user */
export type Segment_User_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "segment_user" */
export enum Segment_User_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  SegmentId = 'segment_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "segment_user" */
export type Segment_User_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  segment_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate stddev on columns */
export type Segment_User_Stddev_Fields = {
  __typename?: 'segment_user_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "segment_user" */
export type Segment_User_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Segment_User_Stddev_Pop_Fields = {
  __typename?: 'segment_user_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "segment_user" */
export type Segment_User_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Segment_User_Stddev_Samp_Fields = {
  __typename?: 'segment_user_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "segment_user" */
export type Segment_User_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "segment_user" */
export type Segment_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Segment_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Segment_User_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  segment_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate sum on columns */
export type Segment_User_Sum_Fields = {
  __typename?: 'segment_user_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "segment_user" */
export type Segment_User_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "segment_user" */
export enum Segment_User_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  SegmentId = 'segment_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Segment_User_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Segment_User_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Segment_User_Set_Input>;
  /** filter the rows which have to be updated */
  where: Segment_User_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Segment_User_Var_Pop_Fields = {
  __typename?: 'segment_user_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "segment_user" */
export type Segment_User_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Segment_User_Var_Samp_Fields = {
  __typename?: 'segment_user_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "segment_user" */
export type Segment_User_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Segment_User_Variance_Fields = {
  __typename?: 'segment_user_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "segment_user" */
export type Segment_User_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "service_request_dashboard" */
export type Service_Request_Dashboard = {
  __typename?: 'service_request_dashboard';
  /** An object relationship */
  account: Accounts;
  account_id: Scalars['bpchar']['output'];
  active_requests: Scalars['Int']['output'];
  assigned_requests: Scalars['Int']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  farmer_happiness_green: Scalars['float8']['output'];
  farmer_happiness_red: Scalars['float8']['output'];
  farmer_happiness_yellow: Scalars['float8']['output'];
  id: Scalars['bpchar']['output'];
  live_field_partners: Scalars['Int']['output'];
  missed_requests: Scalars['Int']['output'];
  out_of_range_requests: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "service_request_dashboard" */
export type Service_Request_Dashboard_Aggregate = {
  __typename?: 'service_request_dashboard_aggregate';
  aggregate?: Maybe<Service_Request_Dashboard_Aggregate_Fields>;
  nodes: Array<Service_Request_Dashboard>;
};

export type Service_Request_Dashboard_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Service_Request_Dashboard_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Service_Request_Dashboard_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Service_Request_Dashboard_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Service_Request_Dashboard_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Service_Request_Dashboard_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Service_Request_Dashboard_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Service_Request_Dashboard_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Service_Request_Dashboard_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Service_Request_Dashboard_Aggregate_Bool_Exp_Var_Samp>;
};

export type Service_Request_Dashboard_Aggregate_Bool_Exp_Avg = {
  arguments: Service_Request_Dashboard_Select_Column_Service_Request_Dashboard_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Service_Request_Dashboard_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Service_Request_Dashboard_Aggregate_Bool_Exp_Corr = {
  arguments: Service_Request_Dashboard_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Service_Request_Dashboard_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Service_Request_Dashboard_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Service_Request_Dashboard_Select_Column_Service_Request_Dashboard_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Service_Request_Dashboard_Select_Column_Service_Request_Dashboard_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Service_Request_Dashboard_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Service_Request_Dashboard_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Service_Request_Dashboard_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Service_Request_Dashboard_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Service_Request_Dashboard_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Service_Request_Dashboard_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Service_Request_Dashboard_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Service_Request_Dashboard_Select_Column_Service_Request_Dashboard_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Service_Request_Dashboard_Select_Column_Service_Request_Dashboard_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Service_Request_Dashboard_Aggregate_Bool_Exp_Max = {
  arguments: Service_Request_Dashboard_Select_Column_Service_Request_Dashboard_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Service_Request_Dashboard_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Service_Request_Dashboard_Aggregate_Bool_Exp_Min = {
  arguments: Service_Request_Dashboard_Select_Column_Service_Request_Dashboard_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Service_Request_Dashboard_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Service_Request_Dashboard_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Service_Request_Dashboard_Select_Column_Service_Request_Dashboard_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Service_Request_Dashboard_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Service_Request_Dashboard_Aggregate_Bool_Exp_Sum = {
  arguments: Service_Request_Dashboard_Select_Column_Service_Request_Dashboard_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Service_Request_Dashboard_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Service_Request_Dashboard_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Service_Request_Dashboard_Select_Column_Service_Request_Dashboard_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Service_Request_Dashboard_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "service_request_dashboard" */
export type Service_Request_Dashboard_Aggregate_Fields = {
  __typename?: 'service_request_dashboard_aggregate_fields';
  avg?: Maybe<Service_Request_Dashboard_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Service_Request_Dashboard_Max_Fields>;
  min?: Maybe<Service_Request_Dashboard_Min_Fields>;
  stddev?: Maybe<Service_Request_Dashboard_Stddev_Fields>;
  stddev_pop?: Maybe<Service_Request_Dashboard_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Service_Request_Dashboard_Stddev_Samp_Fields>;
  sum?: Maybe<Service_Request_Dashboard_Sum_Fields>;
  var_pop?: Maybe<Service_Request_Dashboard_Var_Pop_Fields>;
  var_samp?: Maybe<Service_Request_Dashboard_Var_Samp_Fields>;
  variance?: Maybe<Service_Request_Dashboard_Variance_Fields>;
};


/** aggregate fields of "service_request_dashboard" */
export type Service_Request_Dashboard_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Service_Request_Dashboard_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "service_request_dashboard" */
export type Service_Request_Dashboard_Aggregate_Order_By = {
  avg?: InputMaybe<Service_Request_Dashboard_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Service_Request_Dashboard_Max_Order_By>;
  min?: InputMaybe<Service_Request_Dashboard_Min_Order_By>;
  stddev?: InputMaybe<Service_Request_Dashboard_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Service_Request_Dashboard_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Service_Request_Dashboard_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Service_Request_Dashboard_Sum_Order_By>;
  var_pop?: InputMaybe<Service_Request_Dashboard_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Service_Request_Dashboard_Var_Samp_Order_By>;
  variance?: InputMaybe<Service_Request_Dashboard_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "service_request_dashboard" */
export type Service_Request_Dashboard_Arr_Rel_Insert_Input = {
  data: Array<Service_Request_Dashboard_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Service_Request_Dashboard_On_Conflict>;
};

/** aggregate avg on columns */
export type Service_Request_Dashboard_Avg_Fields = {
  __typename?: 'service_request_dashboard_avg_fields';
  active_requests?: Maybe<Scalars['Float']['output']>;
  assigned_requests?: Maybe<Scalars['Float']['output']>;
  farmer_happiness_green?: Maybe<Scalars['Float']['output']>;
  farmer_happiness_red?: Maybe<Scalars['Float']['output']>;
  farmer_happiness_yellow?: Maybe<Scalars['Float']['output']>;
  live_field_partners?: Maybe<Scalars['Float']['output']>;
  missed_requests?: Maybe<Scalars['Float']['output']>;
  out_of_range_requests?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "service_request_dashboard" */
export type Service_Request_Dashboard_Avg_Order_By = {
  active_requests?: InputMaybe<Order_By>;
  assigned_requests?: InputMaybe<Order_By>;
  farmer_happiness_green?: InputMaybe<Order_By>;
  farmer_happiness_red?: InputMaybe<Order_By>;
  farmer_happiness_yellow?: InputMaybe<Order_By>;
  live_field_partners?: InputMaybe<Order_By>;
  missed_requests?: InputMaybe<Order_By>;
  out_of_range_requests?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "service_request_dashboard". All fields are combined with a logical 'AND'. */
export type Service_Request_Dashboard_Bool_Exp = {
  _and?: InputMaybe<Array<Service_Request_Dashboard_Bool_Exp>>;
  _not?: InputMaybe<Service_Request_Dashboard_Bool_Exp>;
  _or?: InputMaybe<Array<Service_Request_Dashboard_Bool_Exp>>;
  account?: InputMaybe<Accounts_Bool_Exp>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  active_requests?: InputMaybe<Int_Comparison_Exp>;
  assigned_requests?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  farmer_happiness_green?: InputMaybe<Float8_Comparison_Exp>;
  farmer_happiness_red?: InputMaybe<Float8_Comparison_Exp>;
  farmer_happiness_yellow?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  live_field_partners?: InputMaybe<Int_Comparison_Exp>;
  missed_requests?: InputMaybe<Int_Comparison_Exp>;
  out_of_range_requests?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "service_request_dashboard" */
export enum Service_Request_Dashboard_Constraint {
  /** unique or primary key constraint on columns "id" */
  ServiceRequestDashboardPkey = 'service_request_dashboard_pkey'
}

/** input type for incrementing numeric columns in table "service_request_dashboard" */
export type Service_Request_Dashboard_Inc_Input = {
  active_requests?: InputMaybe<Scalars['Int']['input']>;
  assigned_requests?: InputMaybe<Scalars['Int']['input']>;
  farmer_happiness_green?: InputMaybe<Scalars['float8']['input']>;
  farmer_happiness_red?: InputMaybe<Scalars['float8']['input']>;
  farmer_happiness_yellow?: InputMaybe<Scalars['float8']['input']>;
  live_field_partners?: InputMaybe<Scalars['Int']['input']>;
  missed_requests?: InputMaybe<Scalars['Int']['input']>;
  out_of_range_requests?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "service_request_dashboard" */
export type Service_Request_Dashboard_Insert_Input = {
  account?: InputMaybe<Accounts_Obj_Rel_Insert_Input>;
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  active_requests?: InputMaybe<Scalars['Int']['input']>;
  assigned_requests?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer_happiness_green?: InputMaybe<Scalars['float8']['input']>;
  farmer_happiness_red?: InputMaybe<Scalars['float8']['input']>;
  farmer_happiness_yellow?: InputMaybe<Scalars['float8']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  live_field_partners?: InputMaybe<Scalars['Int']['input']>;
  missed_requests?: InputMaybe<Scalars['Int']['input']>;
  out_of_range_requests?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Service_Request_Dashboard_Max_Fields = {
  __typename?: 'service_request_dashboard_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  active_requests?: Maybe<Scalars['Int']['output']>;
  assigned_requests?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  farmer_happiness_green?: Maybe<Scalars['float8']['output']>;
  farmer_happiness_red?: Maybe<Scalars['float8']['output']>;
  farmer_happiness_yellow?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  live_field_partners?: Maybe<Scalars['Int']['output']>;
  missed_requests?: Maybe<Scalars['Int']['output']>;
  out_of_range_requests?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "service_request_dashboard" */
export type Service_Request_Dashboard_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  active_requests?: InputMaybe<Order_By>;
  assigned_requests?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  farmer_happiness_green?: InputMaybe<Order_By>;
  farmer_happiness_red?: InputMaybe<Order_By>;
  farmer_happiness_yellow?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  live_field_partners?: InputMaybe<Order_By>;
  missed_requests?: InputMaybe<Order_By>;
  out_of_range_requests?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Service_Request_Dashboard_Min_Fields = {
  __typename?: 'service_request_dashboard_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  active_requests?: Maybe<Scalars['Int']['output']>;
  assigned_requests?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  farmer_happiness_green?: Maybe<Scalars['float8']['output']>;
  farmer_happiness_red?: Maybe<Scalars['float8']['output']>;
  farmer_happiness_yellow?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  live_field_partners?: Maybe<Scalars['Int']['output']>;
  missed_requests?: Maybe<Scalars['Int']['output']>;
  out_of_range_requests?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "service_request_dashboard" */
export type Service_Request_Dashboard_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  active_requests?: InputMaybe<Order_By>;
  assigned_requests?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  farmer_happiness_green?: InputMaybe<Order_By>;
  farmer_happiness_red?: InputMaybe<Order_By>;
  farmer_happiness_yellow?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  live_field_partners?: InputMaybe<Order_By>;
  missed_requests?: InputMaybe<Order_By>;
  out_of_range_requests?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "service_request_dashboard" */
export type Service_Request_Dashboard_Mutation_Response = {
  __typename?: 'service_request_dashboard_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Service_Request_Dashboard>;
};

/** on_conflict condition type for table "service_request_dashboard" */
export type Service_Request_Dashboard_On_Conflict = {
  constraint: Service_Request_Dashboard_Constraint;
  update_columns?: Array<Service_Request_Dashboard_Update_Column>;
  where?: InputMaybe<Service_Request_Dashboard_Bool_Exp>;
};

/** Ordering options when selecting data from "service_request_dashboard". */
export type Service_Request_Dashboard_Order_By = {
  account?: InputMaybe<Accounts_Order_By>;
  account_id?: InputMaybe<Order_By>;
  active_requests?: InputMaybe<Order_By>;
  assigned_requests?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  farmer_happiness_green?: InputMaybe<Order_By>;
  farmer_happiness_red?: InputMaybe<Order_By>;
  farmer_happiness_yellow?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  live_field_partners?: InputMaybe<Order_By>;
  missed_requests?: InputMaybe<Order_By>;
  out_of_range_requests?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: service_request_dashboard */
export type Service_Request_Dashboard_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** select columns of table "service_request_dashboard" */
export enum Service_Request_Dashboard_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  ActiveRequests = 'active_requests',
  /** column name */
  AssignedRequests = 'assigned_requests',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FarmerHappinessGreen = 'farmer_happiness_green',
  /** column name */
  FarmerHappinessRed = 'farmer_happiness_red',
  /** column name */
  FarmerHappinessYellow = 'farmer_happiness_yellow',
  /** column name */
  Id = 'id',
  /** column name */
  LiveFieldPartners = 'live_field_partners',
  /** column name */
  MissedRequests = 'missed_requests',
  /** column name */
  OutOfRangeRequests = 'out_of_range_requests',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "service_request_dashboard_aggregate_bool_exp_avg_arguments_columns" columns of table "service_request_dashboard" */
export enum Service_Request_Dashboard_Select_Column_Service_Request_Dashboard_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  FarmerHappinessGreen = 'farmer_happiness_green',
  /** column name */
  FarmerHappinessRed = 'farmer_happiness_red',
  /** column name */
  FarmerHappinessYellow = 'farmer_happiness_yellow'
}

/** select "service_request_dashboard_aggregate_bool_exp_corr_arguments_columns" columns of table "service_request_dashboard" */
export enum Service_Request_Dashboard_Select_Column_Service_Request_Dashboard_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  FarmerHappinessGreen = 'farmer_happiness_green',
  /** column name */
  FarmerHappinessRed = 'farmer_happiness_red',
  /** column name */
  FarmerHappinessYellow = 'farmer_happiness_yellow'
}

/** select "service_request_dashboard_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "service_request_dashboard" */
export enum Service_Request_Dashboard_Select_Column_Service_Request_Dashboard_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  FarmerHappinessGreen = 'farmer_happiness_green',
  /** column name */
  FarmerHappinessRed = 'farmer_happiness_red',
  /** column name */
  FarmerHappinessYellow = 'farmer_happiness_yellow'
}

/** select "service_request_dashboard_aggregate_bool_exp_max_arguments_columns" columns of table "service_request_dashboard" */
export enum Service_Request_Dashboard_Select_Column_Service_Request_Dashboard_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  FarmerHappinessGreen = 'farmer_happiness_green',
  /** column name */
  FarmerHappinessRed = 'farmer_happiness_red',
  /** column name */
  FarmerHappinessYellow = 'farmer_happiness_yellow'
}

/** select "service_request_dashboard_aggregate_bool_exp_min_arguments_columns" columns of table "service_request_dashboard" */
export enum Service_Request_Dashboard_Select_Column_Service_Request_Dashboard_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  FarmerHappinessGreen = 'farmer_happiness_green',
  /** column name */
  FarmerHappinessRed = 'farmer_happiness_red',
  /** column name */
  FarmerHappinessYellow = 'farmer_happiness_yellow'
}

/** select "service_request_dashboard_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "service_request_dashboard" */
export enum Service_Request_Dashboard_Select_Column_Service_Request_Dashboard_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  FarmerHappinessGreen = 'farmer_happiness_green',
  /** column name */
  FarmerHappinessRed = 'farmer_happiness_red',
  /** column name */
  FarmerHappinessYellow = 'farmer_happiness_yellow'
}

/** select "service_request_dashboard_aggregate_bool_exp_sum_arguments_columns" columns of table "service_request_dashboard" */
export enum Service_Request_Dashboard_Select_Column_Service_Request_Dashboard_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  FarmerHappinessGreen = 'farmer_happiness_green',
  /** column name */
  FarmerHappinessRed = 'farmer_happiness_red',
  /** column name */
  FarmerHappinessYellow = 'farmer_happiness_yellow'
}

/** select "service_request_dashboard_aggregate_bool_exp_var_samp_arguments_columns" columns of table "service_request_dashboard" */
export enum Service_Request_Dashboard_Select_Column_Service_Request_Dashboard_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  FarmerHappinessGreen = 'farmer_happiness_green',
  /** column name */
  FarmerHappinessRed = 'farmer_happiness_red',
  /** column name */
  FarmerHappinessYellow = 'farmer_happiness_yellow'
}

/** input type for updating data in table "service_request_dashboard" */
export type Service_Request_Dashboard_Set_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  active_requests?: InputMaybe<Scalars['Int']['input']>;
  assigned_requests?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer_happiness_green?: InputMaybe<Scalars['float8']['input']>;
  farmer_happiness_red?: InputMaybe<Scalars['float8']['input']>;
  farmer_happiness_yellow?: InputMaybe<Scalars['float8']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  live_field_partners?: InputMaybe<Scalars['Int']['input']>;
  missed_requests?: InputMaybe<Scalars['Int']['input']>;
  out_of_range_requests?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Service_Request_Dashboard_Stddev_Fields = {
  __typename?: 'service_request_dashboard_stddev_fields';
  active_requests?: Maybe<Scalars['Float']['output']>;
  assigned_requests?: Maybe<Scalars['Float']['output']>;
  farmer_happiness_green?: Maybe<Scalars['Float']['output']>;
  farmer_happiness_red?: Maybe<Scalars['Float']['output']>;
  farmer_happiness_yellow?: Maybe<Scalars['Float']['output']>;
  live_field_partners?: Maybe<Scalars['Float']['output']>;
  missed_requests?: Maybe<Scalars['Float']['output']>;
  out_of_range_requests?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "service_request_dashboard" */
export type Service_Request_Dashboard_Stddev_Order_By = {
  active_requests?: InputMaybe<Order_By>;
  assigned_requests?: InputMaybe<Order_By>;
  farmer_happiness_green?: InputMaybe<Order_By>;
  farmer_happiness_red?: InputMaybe<Order_By>;
  farmer_happiness_yellow?: InputMaybe<Order_By>;
  live_field_partners?: InputMaybe<Order_By>;
  missed_requests?: InputMaybe<Order_By>;
  out_of_range_requests?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Service_Request_Dashboard_Stddev_Pop_Fields = {
  __typename?: 'service_request_dashboard_stddev_pop_fields';
  active_requests?: Maybe<Scalars['Float']['output']>;
  assigned_requests?: Maybe<Scalars['Float']['output']>;
  farmer_happiness_green?: Maybe<Scalars['Float']['output']>;
  farmer_happiness_red?: Maybe<Scalars['Float']['output']>;
  farmer_happiness_yellow?: Maybe<Scalars['Float']['output']>;
  live_field_partners?: Maybe<Scalars['Float']['output']>;
  missed_requests?: Maybe<Scalars['Float']['output']>;
  out_of_range_requests?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "service_request_dashboard" */
export type Service_Request_Dashboard_Stddev_Pop_Order_By = {
  active_requests?: InputMaybe<Order_By>;
  assigned_requests?: InputMaybe<Order_By>;
  farmer_happiness_green?: InputMaybe<Order_By>;
  farmer_happiness_red?: InputMaybe<Order_By>;
  farmer_happiness_yellow?: InputMaybe<Order_By>;
  live_field_partners?: InputMaybe<Order_By>;
  missed_requests?: InputMaybe<Order_By>;
  out_of_range_requests?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Service_Request_Dashboard_Stddev_Samp_Fields = {
  __typename?: 'service_request_dashboard_stddev_samp_fields';
  active_requests?: Maybe<Scalars['Float']['output']>;
  assigned_requests?: Maybe<Scalars['Float']['output']>;
  farmer_happiness_green?: Maybe<Scalars['Float']['output']>;
  farmer_happiness_red?: Maybe<Scalars['Float']['output']>;
  farmer_happiness_yellow?: Maybe<Scalars['Float']['output']>;
  live_field_partners?: Maybe<Scalars['Float']['output']>;
  missed_requests?: Maybe<Scalars['Float']['output']>;
  out_of_range_requests?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "service_request_dashboard" */
export type Service_Request_Dashboard_Stddev_Samp_Order_By = {
  active_requests?: InputMaybe<Order_By>;
  assigned_requests?: InputMaybe<Order_By>;
  farmer_happiness_green?: InputMaybe<Order_By>;
  farmer_happiness_red?: InputMaybe<Order_By>;
  farmer_happiness_yellow?: InputMaybe<Order_By>;
  live_field_partners?: InputMaybe<Order_By>;
  missed_requests?: InputMaybe<Order_By>;
  out_of_range_requests?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "service_request_dashboard" */
export type Service_Request_Dashboard_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Service_Request_Dashboard_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Service_Request_Dashboard_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  active_requests?: InputMaybe<Scalars['Int']['input']>;
  assigned_requests?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer_happiness_green?: InputMaybe<Scalars['float8']['input']>;
  farmer_happiness_red?: InputMaybe<Scalars['float8']['input']>;
  farmer_happiness_yellow?: InputMaybe<Scalars['float8']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  live_field_partners?: InputMaybe<Scalars['Int']['input']>;
  missed_requests?: InputMaybe<Scalars['Int']['input']>;
  out_of_range_requests?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Service_Request_Dashboard_Sum_Fields = {
  __typename?: 'service_request_dashboard_sum_fields';
  active_requests?: Maybe<Scalars['Int']['output']>;
  assigned_requests?: Maybe<Scalars['Int']['output']>;
  farmer_happiness_green?: Maybe<Scalars['float8']['output']>;
  farmer_happiness_red?: Maybe<Scalars['float8']['output']>;
  farmer_happiness_yellow?: Maybe<Scalars['float8']['output']>;
  live_field_partners?: Maybe<Scalars['Int']['output']>;
  missed_requests?: Maybe<Scalars['Int']['output']>;
  out_of_range_requests?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "service_request_dashboard" */
export type Service_Request_Dashboard_Sum_Order_By = {
  active_requests?: InputMaybe<Order_By>;
  assigned_requests?: InputMaybe<Order_By>;
  farmer_happiness_green?: InputMaybe<Order_By>;
  farmer_happiness_red?: InputMaybe<Order_By>;
  farmer_happiness_yellow?: InputMaybe<Order_By>;
  live_field_partners?: InputMaybe<Order_By>;
  missed_requests?: InputMaybe<Order_By>;
  out_of_range_requests?: InputMaybe<Order_By>;
};

/** update columns of table "service_request_dashboard" */
export enum Service_Request_Dashboard_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  ActiveRequests = 'active_requests',
  /** column name */
  AssignedRequests = 'assigned_requests',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FarmerHappinessGreen = 'farmer_happiness_green',
  /** column name */
  FarmerHappinessRed = 'farmer_happiness_red',
  /** column name */
  FarmerHappinessYellow = 'farmer_happiness_yellow',
  /** column name */
  Id = 'id',
  /** column name */
  LiveFieldPartners = 'live_field_partners',
  /** column name */
  MissedRequests = 'missed_requests',
  /** column name */
  OutOfRangeRequests = 'out_of_range_requests',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Service_Request_Dashboard_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Service_Request_Dashboard_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Service_Request_Dashboard_Set_Input>;
  /** filter the rows which have to be updated */
  where: Service_Request_Dashboard_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Service_Request_Dashboard_Var_Pop_Fields = {
  __typename?: 'service_request_dashboard_var_pop_fields';
  active_requests?: Maybe<Scalars['Float']['output']>;
  assigned_requests?: Maybe<Scalars['Float']['output']>;
  farmer_happiness_green?: Maybe<Scalars['Float']['output']>;
  farmer_happiness_red?: Maybe<Scalars['Float']['output']>;
  farmer_happiness_yellow?: Maybe<Scalars['Float']['output']>;
  live_field_partners?: Maybe<Scalars['Float']['output']>;
  missed_requests?: Maybe<Scalars['Float']['output']>;
  out_of_range_requests?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "service_request_dashboard" */
export type Service_Request_Dashboard_Var_Pop_Order_By = {
  active_requests?: InputMaybe<Order_By>;
  assigned_requests?: InputMaybe<Order_By>;
  farmer_happiness_green?: InputMaybe<Order_By>;
  farmer_happiness_red?: InputMaybe<Order_By>;
  farmer_happiness_yellow?: InputMaybe<Order_By>;
  live_field_partners?: InputMaybe<Order_By>;
  missed_requests?: InputMaybe<Order_By>;
  out_of_range_requests?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Service_Request_Dashboard_Var_Samp_Fields = {
  __typename?: 'service_request_dashboard_var_samp_fields';
  active_requests?: Maybe<Scalars['Float']['output']>;
  assigned_requests?: Maybe<Scalars['Float']['output']>;
  farmer_happiness_green?: Maybe<Scalars['Float']['output']>;
  farmer_happiness_red?: Maybe<Scalars['Float']['output']>;
  farmer_happiness_yellow?: Maybe<Scalars['Float']['output']>;
  live_field_partners?: Maybe<Scalars['Float']['output']>;
  missed_requests?: Maybe<Scalars['Float']['output']>;
  out_of_range_requests?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "service_request_dashboard" */
export type Service_Request_Dashboard_Var_Samp_Order_By = {
  active_requests?: InputMaybe<Order_By>;
  assigned_requests?: InputMaybe<Order_By>;
  farmer_happiness_green?: InputMaybe<Order_By>;
  farmer_happiness_red?: InputMaybe<Order_By>;
  farmer_happiness_yellow?: InputMaybe<Order_By>;
  live_field_partners?: InputMaybe<Order_By>;
  missed_requests?: InputMaybe<Order_By>;
  out_of_range_requests?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Service_Request_Dashboard_Variance_Fields = {
  __typename?: 'service_request_dashboard_variance_fields';
  active_requests?: Maybe<Scalars['Float']['output']>;
  assigned_requests?: Maybe<Scalars['Float']['output']>;
  farmer_happiness_green?: Maybe<Scalars['Float']['output']>;
  farmer_happiness_red?: Maybe<Scalars['Float']['output']>;
  farmer_happiness_yellow?: Maybe<Scalars['Float']['output']>;
  live_field_partners?: Maybe<Scalars['Float']['output']>;
  missed_requests?: Maybe<Scalars['Float']['output']>;
  out_of_range_requests?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "service_request_dashboard" */
export type Service_Request_Dashboard_Variance_Order_By = {
  active_requests?: InputMaybe<Order_By>;
  assigned_requests?: InputMaybe<Order_By>;
  farmer_happiness_green?: InputMaybe<Order_By>;
  farmer_happiness_red?: InputMaybe<Order_By>;
  farmer_happiness_yellow?: InputMaybe<Order_By>;
  live_field_partners?: InputMaybe<Order_By>;
  missed_requests?: InputMaybe<Order_By>;
  out_of_range_requests?: InputMaybe<Order_By>;
};

/** columns and relationships of "service_request_recommendations" */
export type Service_Request_Recommendations = {
  __typename?: 'service_request_recommendations';
  /** An object relationship */
  account?: Maybe<Accounts>;
  account_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  data?: Maybe<Scalars['json']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  farmer?: Maybe<Users>;
  farmer_user_id?: Maybe<Scalars['bpchar']['output']>;
  /** An object relationship */
  field_partner?: Maybe<Users>;
  /** An object relationship */
  field_partner_response?: Maybe<Field_Partner_Responses>;
  field_partner_user_id?: Maybe<Scalars['bpchar']['output']>;
  fpr_id?: Maybe<Scalars['bpchar']['output']>;
  id: Scalars['bpchar']['output'];
  request_id?: Maybe<Scalars['bpchar']['output']>;
  /** An object relationship */
  retailer?: Maybe<Retailers>;
  retailer_id?: Maybe<Scalars['bpchar']['output']>;
  /** An object relationship */
  retailer_user?: Maybe<Users>;
  retailer_user_id?: Maybe<Scalars['bpchar']['output']>;
  /** An object relationship */
  service_request?: Maybe<Service_Requests>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "service_request_recommendations" */
export type Service_Request_RecommendationsDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "service_request_recommendations" */
export type Service_Request_Recommendations_Aggregate = {
  __typename?: 'service_request_recommendations_aggregate';
  aggregate?: Maybe<Service_Request_Recommendations_Aggregate_Fields>;
  nodes: Array<Service_Request_Recommendations>;
};

export type Service_Request_Recommendations_Aggregate_Bool_Exp = {
  count?: InputMaybe<Service_Request_Recommendations_Aggregate_Bool_Exp_Count>;
};

export type Service_Request_Recommendations_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Service_Request_Recommendations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Service_Request_Recommendations_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "service_request_recommendations" */
export type Service_Request_Recommendations_Aggregate_Fields = {
  __typename?: 'service_request_recommendations_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Service_Request_Recommendations_Max_Fields>;
  min?: Maybe<Service_Request_Recommendations_Min_Fields>;
};


/** aggregate fields of "service_request_recommendations" */
export type Service_Request_Recommendations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Service_Request_Recommendations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "service_request_recommendations" */
export type Service_Request_Recommendations_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Service_Request_Recommendations_Max_Order_By>;
  min?: InputMaybe<Service_Request_Recommendations_Min_Order_By>;
};

/** input type for inserting array relation for remote table "service_request_recommendations" */
export type Service_Request_Recommendations_Arr_Rel_Insert_Input = {
  data: Array<Service_Request_Recommendations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Service_Request_Recommendations_On_Conflict>;
};

/** Boolean expression to filter rows from the table "service_request_recommendations". All fields are combined with a logical 'AND'. */
export type Service_Request_Recommendations_Bool_Exp = {
  _and?: InputMaybe<Array<Service_Request_Recommendations_Bool_Exp>>;
  _not?: InputMaybe<Service_Request_Recommendations_Bool_Exp>;
  _or?: InputMaybe<Array<Service_Request_Recommendations_Bool_Exp>>;
  account?: InputMaybe<Accounts_Bool_Exp>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Json_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  farmer?: InputMaybe<Users_Bool_Exp>;
  farmer_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  field_partner?: InputMaybe<Users_Bool_Exp>;
  field_partner_response?: InputMaybe<Field_Partner_Responses_Bool_Exp>;
  field_partner_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  fpr_id?: InputMaybe<Bpchar_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  request_id?: InputMaybe<Bpchar_Comparison_Exp>;
  retailer?: InputMaybe<Retailers_Bool_Exp>;
  retailer_id?: InputMaybe<Bpchar_Comparison_Exp>;
  retailer_user?: InputMaybe<Users_Bool_Exp>;
  retailer_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  service_request?: InputMaybe<Service_Requests_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "service_request_recommendations" */
export enum Service_Request_Recommendations_Constraint {
  /** unique or primary key constraint on columns "id" */
  ServiceRequestRecommendationsPkey = 'service_request_recommendations_pkey'
}

/** input type for inserting data into table "service_request_recommendations" */
export type Service_Request_Recommendations_Insert_Input = {
  account?: InputMaybe<Accounts_Obj_Rel_Insert_Input>;
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  farmer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  field_partner?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  field_partner_response?: InputMaybe<Field_Partner_Responses_Obj_Rel_Insert_Input>;
  field_partner_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  fpr_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  request_id?: InputMaybe<Scalars['bpchar']['input']>;
  retailer?: InputMaybe<Retailers_Obj_Rel_Insert_Input>;
  retailer_id?: InputMaybe<Scalars['bpchar']['input']>;
  retailer_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  retailer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  service_request?: InputMaybe<Service_Requests_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Service_Request_Recommendations_Max_Fields = {
  __typename?: 'service_request_recommendations_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  farmer_user_id?: Maybe<Scalars['bpchar']['output']>;
  field_partner_user_id?: Maybe<Scalars['bpchar']['output']>;
  fpr_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  request_id?: Maybe<Scalars['bpchar']['output']>;
  retailer_id?: Maybe<Scalars['bpchar']['output']>;
  retailer_user_id?: Maybe<Scalars['bpchar']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "service_request_recommendations" */
export type Service_Request_Recommendations_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  farmer_user_id?: InputMaybe<Order_By>;
  field_partner_user_id?: InputMaybe<Order_By>;
  fpr_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  retailer_id?: InputMaybe<Order_By>;
  retailer_user_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Service_Request_Recommendations_Min_Fields = {
  __typename?: 'service_request_recommendations_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  farmer_user_id?: Maybe<Scalars['bpchar']['output']>;
  field_partner_user_id?: Maybe<Scalars['bpchar']['output']>;
  fpr_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  request_id?: Maybe<Scalars['bpchar']['output']>;
  retailer_id?: Maybe<Scalars['bpchar']['output']>;
  retailer_user_id?: Maybe<Scalars['bpchar']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "service_request_recommendations" */
export type Service_Request_Recommendations_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  farmer_user_id?: InputMaybe<Order_By>;
  field_partner_user_id?: InputMaybe<Order_By>;
  fpr_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  retailer_id?: InputMaybe<Order_By>;
  retailer_user_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "service_request_recommendations" */
export type Service_Request_Recommendations_Mutation_Response = {
  __typename?: 'service_request_recommendations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Service_Request_Recommendations>;
};

/** on_conflict condition type for table "service_request_recommendations" */
export type Service_Request_Recommendations_On_Conflict = {
  constraint: Service_Request_Recommendations_Constraint;
  update_columns?: Array<Service_Request_Recommendations_Update_Column>;
  where?: InputMaybe<Service_Request_Recommendations_Bool_Exp>;
};

/** Ordering options when selecting data from "service_request_recommendations". */
export type Service_Request_Recommendations_Order_By = {
  account?: InputMaybe<Accounts_Order_By>;
  account_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  farmer?: InputMaybe<Users_Order_By>;
  farmer_user_id?: InputMaybe<Order_By>;
  field_partner?: InputMaybe<Users_Order_By>;
  field_partner_response?: InputMaybe<Field_Partner_Responses_Order_By>;
  field_partner_user_id?: InputMaybe<Order_By>;
  fpr_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  retailer?: InputMaybe<Retailers_Order_By>;
  retailer_id?: InputMaybe<Order_By>;
  retailer_user?: InputMaybe<Users_Order_By>;
  retailer_user_id?: InputMaybe<Order_By>;
  service_request?: InputMaybe<Service_Requests_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: service_request_recommendations */
export type Service_Request_Recommendations_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** select columns of table "service_request_recommendations" */
export enum Service_Request_Recommendations_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FarmerUserId = 'farmer_user_id',
  /** column name */
  FieldPartnerUserId = 'field_partner_user_id',
  /** column name */
  FprId = 'fpr_id',
  /** column name */
  Id = 'id',
  /** column name */
  RequestId = 'request_id',
  /** column name */
  RetailerId = 'retailer_id',
  /** column name */
  RetailerUserId = 'retailer_user_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "service_request_recommendations" */
export type Service_Request_Recommendations_Set_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  field_partner_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  fpr_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  request_id?: InputMaybe<Scalars['bpchar']['input']>;
  retailer_id?: InputMaybe<Scalars['bpchar']['input']>;
  retailer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "service_request_recommendations" */
export type Service_Request_Recommendations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Service_Request_Recommendations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Service_Request_Recommendations_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  farmer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  field_partner_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  fpr_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  request_id?: InputMaybe<Scalars['bpchar']['input']>;
  retailer_id?: InputMaybe<Scalars['bpchar']['input']>;
  retailer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "service_request_recommendations" */
export enum Service_Request_Recommendations_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FarmerUserId = 'farmer_user_id',
  /** column name */
  FieldPartnerUserId = 'field_partner_user_id',
  /** column name */
  FprId = 'fpr_id',
  /** column name */
  Id = 'id',
  /** column name */
  RequestId = 'request_id',
  /** column name */
  RetailerId = 'retailer_id',
  /** column name */
  RetailerUserId = 'retailer_user_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Service_Request_Recommendations_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Service_Request_Recommendations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Service_Request_Recommendations_Bool_Exp;
};

/** columns and relationships of "service_request_retailer" */
export type Service_Request_Retailer = {
  __typename?: 'service_request_retailer';
  id: Scalars['bigint']['output'];
  request_id?: Maybe<Scalars['bpchar']['output']>;
  retailer_id?: Maybe<Scalars['bpchar']['output']>;
};

/** aggregated selection of "service_request_retailer" */
export type Service_Request_Retailer_Aggregate = {
  __typename?: 'service_request_retailer_aggregate';
  aggregate?: Maybe<Service_Request_Retailer_Aggregate_Fields>;
  nodes: Array<Service_Request_Retailer>;
};

export type Service_Request_Retailer_Aggregate_Bool_Exp = {
  count?: InputMaybe<Service_Request_Retailer_Aggregate_Bool_Exp_Count>;
};

export type Service_Request_Retailer_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Service_Request_Retailer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Service_Request_Retailer_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "service_request_retailer" */
export type Service_Request_Retailer_Aggregate_Fields = {
  __typename?: 'service_request_retailer_aggregate_fields';
  avg?: Maybe<Service_Request_Retailer_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Service_Request_Retailer_Max_Fields>;
  min?: Maybe<Service_Request_Retailer_Min_Fields>;
  stddev?: Maybe<Service_Request_Retailer_Stddev_Fields>;
  stddev_pop?: Maybe<Service_Request_Retailer_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Service_Request_Retailer_Stddev_Samp_Fields>;
  sum?: Maybe<Service_Request_Retailer_Sum_Fields>;
  var_pop?: Maybe<Service_Request_Retailer_Var_Pop_Fields>;
  var_samp?: Maybe<Service_Request_Retailer_Var_Samp_Fields>;
  variance?: Maybe<Service_Request_Retailer_Variance_Fields>;
};


/** aggregate fields of "service_request_retailer" */
export type Service_Request_Retailer_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Service_Request_Retailer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "service_request_retailer" */
export type Service_Request_Retailer_Aggregate_Order_By = {
  avg?: InputMaybe<Service_Request_Retailer_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Service_Request_Retailer_Max_Order_By>;
  min?: InputMaybe<Service_Request_Retailer_Min_Order_By>;
  stddev?: InputMaybe<Service_Request_Retailer_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Service_Request_Retailer_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Service_Request_Retailer_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Service_Request_Retailer_Sum_Order_By>;
  var_pop?: InputMaybe<Service_Request_Retailer_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Service_Request_Retailer_Var_Samp_Order_By>;
  variance?: InputMaybe<Service_Request_Retailer_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "service_request_retailer" */
export type Service_Request_Retailer_Arr_Rel_Insert_Input = {
  data: Array<Service_Request_Retailer_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Service_Request_Retailer_On_Conflict>;
};

/** aggregate avg on columns */
export type Service_Request_Retailer_Avg_Fields = {
  __typename?: 'service_request_retailer_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "service_request_retailer" */
export type Service_Request_Retailer_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "service_request_retailer". All fields are combined with a logical 'AND'. */
export type Service_Request_Retailer_Bool_Exp = {
  _and?: InputMaybe<Array<Service_Request_Retailer_Bool_Exp>>;
  _not?: InputMaybe<Service_Request_Retailer_Bool_Exp>;
  _or?: InputMaybe<Array<Service_Request_Retailer_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  request_id?: InputMaybe<Bpchar_Comparison_Exp>;
  retailer_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "service_request_retailer" */
export enum Service_Request_Retailer_Constraint {
  /** unique or primary key constraint on columns "id" */
  ServiceRequestRetailerPkey = 'service_request_retailer_pkey'
}

/** input type for incrementing numeric columns in table "service_request_retailer" */
export type Service_Request_Retailer_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "service_request_retailer" */
export type Service_Request_Retailer_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  request_id?: InputMaybe<Scalars['bpchar']['input']>;
  retailer_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Service_Request_Retailer_Max_Fields = {
  __typename?: 'service_request_retailer_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  request_id?: Maybe<Scalars['bpchar']['output']>;
  retailer_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by max() on columns of table "service_request_retailer" */
export type Service_Request_Retailer_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  retailer_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Service_Request_Retailer_Min_Fields = {
  __typename?: 'service_request_retailer_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  request_id?: Maybe<Scalars['bpchar']['output']>;
  retailer_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by min() on columns of table "service_request_retailer" */
export type Service_Request_Retailer_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  retailer_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "service_request_retailer" */
export type Service_Request_Retailer_Mutation_Response = {
  __typename?: 'service_request_retailer_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Service_Request_Retailer>;
};

/** on_conflict condition type for table "service_request_retailer" */
export type Service_Request_Retailer_On_Conflict = {
  constraint: Service_Request_Retailer_Constraint;
  update_columns?: Array<Service_Request_Retailer_Update_Column>;
  where?: InputMaybe<Service_Request_Retailer_Bool_Exp>;
};

/** Ordering options when selecting data from "service_request_retailer". */
export type Service_Request_Retailer_Order_By = {
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  retailer_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: service_request_retailer */
export type Service_Request_Retailer_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "service_request_retailer" */
export enum Service_Request_Retailer_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  RequestId = 'request_id',
  /** column name */
  RetailerId = 'retailer_id'
}

/** input type for updating data in table "service_request_retailer" */
export type Service_Request_Retailer_Set_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  request_id?: InputMaybe<Scalars['bpchar']['input']>;
  retailer_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate stddev on columns */
export type Service_Request_Retailer_Stddev_Fields = {
  __typename?: 'service_request_retailer_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "service_request_retailer" */
export type Service_Request_Retailer_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Service_Request_Retailer_Stddev_Pop_Fields = {
  __typename?: 'service_request_retailer_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "service_request_retailer" */
export type Service_Request_Retailer_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Service_Request_Retailer_Stddev_Samp_Fields = {
  __typename?: 'service_request_retailer_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "service_request_retailer" */
export type Service_Request_Retailer_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "service_request_retailer" */
export type Service_Request_Retailer_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Service_Request_Retailer_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Service_Request_Retailer_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  request_id?: InputMaybe<Scalars['bpchar']['input']>;
  retailer_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate sum on columns */
export type Service_Request_Retailer_Sum_Fields = {
  __typename?: 'service_request_retailer_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "service_request_retailer" */
export type Service_Request_Retailer_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "service_request_retailer" */
export enum Service_Request_Retailer_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  RequestId = 'request_id',
  /** column name */
  RetailerId = 'retailer_id'
}

export type Service_Request_Retailer_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Service_Request_Retailer_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Service_Request_Retailer_Set_Input>;
  /** filter the rows which have to be updated */
  where: Service_Request_Retailer_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Service_Request_Retailer_Var_Pop_Fields = {
  __typename?: 'service_request_retailer_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "service_request_retailer" */
export type Service_Request_Retailer_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Service_Request_Retailer_Var_Samp_Fields = {
  __typename?: 'service_request_retailer_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "service_request_retailer" */
export type Service_Request_Retailer_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Service_Request_Retailer_Variance_Fields = {
  __typename?: 'service_request_retailer_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "service_request_retailer" */
export type Service_Request_Retailer_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "service_requests" */
export type Service_Requests = {
  __typename?: 'service_requests';
  address?: Maybe<Scalars['String']['output']>;
  address_components?: Maybe<Scalars['json']['output']>;
  assets: Scalars['jsonb']['output'];
  canceled_at?: Maybe<Scalars['timestamptz']['output']>;
  canceled_by?: Maybe<Scalars['bpchar']['output']>;
  channel?: Maybe<Scalars['String']['output']>;
  closed_at?: Maybe<Scalars['timestamptz']['output']>;
  closed_by?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crop: Scalars['String']['output'];
  crop_id: Scalars['bpchar']['output'];
  date_of_sowing: Scalars['date']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  external_source?: Maybe<Scalars['String']['output']>;
  farmer_user_id: Scalars['bpchar']['output'];
  /** An array relationship */
  field_partner_response_events: Array<Field_Partner_Response_Events>;
  /** An aggregate relationship */
  field_partner_response_events_aggregate: Field_Partner_Response_Events_Aggregate;
  /** An array relationship */
  field_partner_response_messages: Array<Field_Partner_Response_Messages>;
  /** An aggregate relationship */
  field_partner_response_messages_aggregate: Field_Partner_Response_Messages_Aggregate;
  /** An array relationship */
  field_partner_responses: Array<Field_Partner_Responses>;
  /** An aggregate relationship */
  field_partner_responses_aggregate: Field_Partner_Responses_Aggregate;
  /** An array relationship */
  field_scheduled_visits: Array<Field_Scheduled_Visits>;
  /** An aggregate relationship */
  field_scheduled_visits_aggregate: Field_Scheduled_Visits_Aggregate;
  id: Scalars['bpchar']['output'];
  is_recurring?: Maybe<Scalars['Boolean']['output']>;
  is_recurring_active?: Maybe<Scalars['Boolean']['output']>;
  is_request_closed: Scalars['Boolean']['output'];
  is_test?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  last_known_locations: Array<Last_Known_Locations>;
  /** An aggregate relationship */
  last_known_locations_aggregate: Last_Known_Locations_Aggregate;
  lat: Scalars['float8']['output'];
  lng: Scalars['float8']['output'];
  /** An object relationship */
  master_crop: Master_Crops;
  parent_request_id?: Maybe<Scalars['String']['output']>;
  recurring_schedule?: Maybe<Scalars['jsonb']['output']>;
  /** An array relationship */
  service_request_recommendations: Array<Service_Request_Recommendations>;
  /** An aggregate relationship */
  service_request_recommendations_aggregate: Service_Request_Recommendations_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user: Users;
  /** An array relationship */
  user_feedbacks: Array<User_Feedbacks>;
  /** An aggregate relationship */
  user_feedbacks_aggregate: User_Feedbacks_Aggregate;
};


/** columns and relationships of "service_requests" */
export type Service_RequestsAddress_ComponentsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "service_requests" */
export type Service_RequestsAssetsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "service_requests" */
export type Service_RequestsField_Partner_Response_EventsArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Response_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Response_Events_Order_By>>;
  where?: InputMaybe<Field_Partner_Response_Events_Bool_Exp>;
};


/** columns and relationships of "service_requests" */
export type Service_RequestsField_Partner_Response_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Response_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Response_Events_Order_By>>;
  where?: InputMaybe<Field_Partner_Response_Events_Bool_Exp>;
};


/** columns and relationships of "service_requests" */
export type Service_RequestsField_Partner_Response_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Response_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Response_Messages_Order_By>>;
  where?: InputMaybe<Field_Partner_Response_Messages_Bool_Exp>;
};


/** columns and relationships of "service_requests" */
export type Service_RequestsField_Partner_Response_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Response_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Response_Messages_Order_By>>;
  where?: InputMaybe<Field_Partner_Response_Messages_Bool_Exp>;
};


/** columns and relationships of "service_requests" */
export type Service_RequestsField_Partner_ResponsesArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Responses_Order_By>>;
  where?: InputMaybe<Field_Partner_Responses_Bool_Exp>;
};


/** columns and relationships of "service_requests" */
export type Service_RequestsField_Partner_Responses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Responses_Order_By>>;
  where?: InputMaybe<Field_Partner_Responses_Bool_Exp>;
};


/** columns and relationships of "service_requests" */
export type Service_RequestsField_Scheduled_VisitsArgs = {
  distinct_on?: InputMaybe<Array<Field_Scheduled_Visits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Scheduled_Visits_Order_By>>;
  where?: InputMaybe<Field_Scheduled_Visits_Bool_Exp>;
};


/** columns and relationships of "service_requests" */
export type Service_RequestsField_Scheduled_Visits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Scheduled_Visits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Scheduled_Visits_Order_By>>;
  where?: InputMaybe<Field_Scheduled_Visits_Bool_Exp>;
};


/** columns and relationships of "service_requests" */
export type Service_RequestsLast_Known_LocationsArgs = {
  distinct_on?: InputMaybe<Array<Last_Known_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Last_Known_Locations_Order_By>>;
  where?: InputMaybe<Last_Known_Locations_Bool_Exp>;
};


/** columns and relationships of "service_requests" */
export type Service_RequestsLast_Known_Locations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Last_Known_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Last_Known_Locations_Order_By>>;
  where?: InputMaybe<Last_Known_Locations_Bool_Exp>;
};


/** columns and relationships of "service_requests" */
export type Service_RequestsRecurring_ScheduleArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "service_requests" */
export type Service_RequestsService_Request_RecommendationsArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Recommendations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Recommendations_Order_By>>;
  where?: InputMaybe<Service_Request_Recommendations_Bool_Exp>;
};


/** columns and relationships of "service_requests" */
export type Service_RequestsService_Request_Recommendations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Recommendations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Recommendations_Order_By>>;
  where?: InputMaybe<Service_Request_Recommendations_Bool_Exp>;
};


/** columns and relationships of "service_requests" */
export type Service_RequestsUser_FeedbacksArgs = {
  distinct_on?: InputMaybe<Array<User_Feedbacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Feedbacks_Order_By>>;
  where?: InputMaybe<User_Feedbacks_Bool_Exp>;
};


/** columns and relationships of "service_requests" */
export type Service_RequestsUser_Feedbacks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Feedbacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Feedbacks_Order_By>>;
  where?: InputMaybe<User_Feedbacks_Bool_Exp>;
};

/** aggregated selection of "service_requests" */
export type Service_Requests_Aggregate = {
  __typename?: 'service_requests_aggregate';
  aggregate?: Maybe<Service_Requests_Aggregate_Fields>;
  nodes: Array<Service_Requests>;
};

export type Service_Requests_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Service_Requests_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Service_Requests_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Service_Requests_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Service_Requests_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Service_Requests_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Service_Requests_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Service_Requests_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Service_Requests_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Service_Requests_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Service_Requests_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Service_Requests_Aggregate_Bool_Exp_Var_Samp>;
};

export type Service_Requests_Aggregate_Bool_Exp_Avg = {
  arguments: Service_Requests_Select_Column_Service_Requests_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Service_Requests_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Service_Requests_Aggregate_Bool_Exp_Bool_And = {
  arguments: Service_Requests_Select_Column_Service_Requests_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Service_Requests_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Service_Requests_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Service_Requests_Select_Column_Service_Requests_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Service_Requests_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Service_Requests_Aggregate_Bool_Exp_Corr = {
  arguments: Service_Requests_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Service_Requests_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Service_Requests_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Service_Requests_Select_Column_Service_Requests_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Service_Requests_Select_Column_Service_Requests_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Service_Requests_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Service_Requests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Service_Requests_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Service_Requests_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Service_Requests_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Service_Requests_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Service_Requests_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Service_Requests_Select_Column_Service_Requests_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Service_Requests_Select_Column_Service_Requests_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Service_Requests_Aggregate_Bool_Exp_Max = {
  arguments: Service_Requests_Select_Column_Service_Requests_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Service_Requests_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Service_Requests_Aggregate_Bool_Exp_Min = {
  arguments: Service_Requests_Select_Column_Service_Requests_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Service_Requests_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Service_Requests_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Service_Requests_Select_Column_Service_Requests_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Service_Requests_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Service_Requests_Aggregate_Bool_Exp_Sum = {
  arguments: Service_Requests_Select_Column_Service_Requests_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Service_Requests_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Service_Requests_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Service_Requests_Select_Column_Service_Requests_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Service_Requests_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "service_requests" */
export type Service_Requests_Aggregate_Fields = {
  __typename?: 'service_requests_aggregate_fields';
  avg?: Maybe<Service_Requests_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Service_Requests_Max_Fields>;
  min?: Maybe<Service_Requests_Min_Fields>;
  stddev?: Maybe<Service_Requests_Stddev_Fields>;
  stddev_pop?: Maybe<Service_Requests_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Service_Requests_Stddev_Samp_Fields>;
  sum?: Maybe<Service_Requests_Sum_Fields>;
  var_pop?: Maybe<Service_Requests_Var_Pop_Fields>;
  var_samp?: Maybe<Service_Requests_Var_Samp_Fields>;
  variance?: Maybe<Service_Requests_Variance_Fields>;
};


/** aggregate fields of "service_requests" */
export type Service_Requests_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Service_Requests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "service_requests" */
export type Service_Requests_Aggregate_Order_By = {
  avg?: InputMaybe<Service_Requests_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Service_Requests_Max_Order_By>;
  min?: InputMaybe<Service_Requests_Min_Order_By>;
  stddev?: InputMaybe<Service_Requests_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Service_Requests_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Service_Requests_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Service_Requests_Sum_Order_By>;
  var_pop?: InputMaybe<Service_Requests_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Service_Requests_Var_Samp_Order_By>;
  variance?: InputMaybe<Service_Requests_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Service_Requests_Append_Input = {
  assets?: InputMaybe<Scalars['jsonb']['input']>;
  recurring_schedule?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "service_requests" */
export type Service_Requests_Arr_Rel_Insert_Input = {
  data: Array<Service_Requests_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Service_Requests_On_Conflict>;
};

/** aggregate avg on columns */
export type Service_Requests_Avg_Fields = {
  __typename?: 'service_requests_avg_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "service_requests" */
export type Service_Requests_Avg_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "service_requests". All fields are combined with a logical 'AND'. */
export type Service_Requests_Bool_Exp = {
  _and?: InputMaybe<Array<Service_Requests_Bool_Exp>>;
  _not?: InputMaybe<Service_Requests_Bool_Exp>;
  _or?: InputMaybe<Array<Service_Requests_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  address_components?: InputMaybe<Json_Comparison_Exp>;
  assets?: InputMaybe<Jsonb_Comparison_Exp>;
  canceled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  canceled_by?: InputMaybe<Bpchar_Comparison_Exp>;
  channel?: InputMaybe<String_Comparison_Exp>;
  closed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  closed_by?: InputMaybe<Bpchar_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  crop?: InputMaybe<String_Comparison_Exp>;
  crop_id?: InputMaybe<Bpchar_Comparison_Exp>;
  date_of_sowing?: InputMaybe<Date_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  external_source?: InputMaybe<String_Comparison_Exp>;
  farmer_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  field_partner_response_events?: InputMaybe<Field_Partner_Response_Events_Bool_Exp>;
  field_partner_response_events_aggregate?: InputMaybe<Field_Partner_Response_Events_Aggregate_Bool_Exp>;
  field_partner_response_messages?: InputMaybe<Field_Partner_Response_Messages_Bool_Exp>;
  field_partner_response_messages_aggregate?: InputMaybe<Field_Partner_Response_Messages_Aggregate_Bool_Exp>;
  field_partner_responses?: InputMaybe<Field_Partner_Responses_Bool_Exp>;
  field_partner_responses_aggregate?: InputMaybe<Field_Partner_Responses_Aggregate_Bool_Exp>;
  field_scheduled_visits?: InputMaybe<Field_Scheduled_Visits_Bool_Exp>;
  field_scheduled_visits_aggregate?: InputMaybe<Field_Scheduled_Visits_Aggregate_Bool_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  is_recurring?: InputMaybe<Boolean_Comparison_Exp>;
  is_recurring_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_request_closed?: InputMaybe<Boolean_Comparison_Exp>;
  is_test?: InputMaybe<Boolean_Comparison_Exp>;
  last_known_locations?: InputMaybe<Last_Known_Locations_Bool_Exp>;
  last_known_locations_aggregate?: InputMaybe<Last_Known_Locations_Aggregate_Bool_Exp>;
  lat?: InputMaybe<Float8_Comparison_Exp>;
  lng?: InputMaybe<Float8_Comparison_Exp>;
  master_crop?: InputMaybe<Master_Crops_Bool_Exp>;
  parent_request_id?: InputMaybe<String_Comparison_Exp>;
  recurring_schedule?: InputMaybe<Jsonb_Comparison_Exp>;
  service_request_recommendations?: InputMaybe<Service_Request_Recommendations_Bool_Exp>;
  service_request_recommendations_aggregate?: InputMaybe<Service_Request_Recommendations_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_feedbacks?: InputMaybe<User_Feedbacks_Bool_Exp>;
  user_feedbacks_aggregate?: InputMaybe<User_Feedbacks_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "service_requests" */
export enum Service_Requests_Constraint {
  /** unique or primary key constraint on columns "id" */
  ServiceRequestsPkey = 'service_requests_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Service_Requests_Delete_At_Path_Input = {
  assets?: InputMaybe<Array<Scalars['String']['input']>>;
  recurring_schedule?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Service_Requests_Delete_Elem_Input = {
  assets?: InputMaybe<Scalars['Int']['input']>;
  recurring_schedule?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Service_Requests_Delete_Key_Input = {
  assets?: InputMaybe<Scalars['String']['input']>;
  recurring_schedule?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "service_requests" */
export type Service_Requests_Inc_Input = {
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "service_requests" */
export type Service_Requests_Insert_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  address_components?: InputMaybe<Scalars['json']['input']>;
  assets?: InputMaybe<Scalars['jsonb']['input']>;
  canceled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  canceled_by?: InputMaybe<Scalars['bpchar']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  closed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  closed_by?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crop?: InputMaybe<Scalars['String']['input']>;
  crop_id?: InputMaybe<Scalars['bpchar']['input']>;
  date_of_sowing?: InputMaybe<Scalars['date']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_source?: InputMaybe<Scalars['String']['input']>;
  farmer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  field_partner_response_events?: InputMaybe<Field_Partner_Response_Events_Arr_Rel_Insert_Input>;
  field_partner_response_messages?: InputMaybe<Field_Partner_Response_Messages_Arr_Rel_Insert_Input>;
  field_partner_responses?: InputMaybe<Field_Partner_Responses_Arr_Rel_Insert_Input>;
  field_scheduled_visits?: InputMaybe<Field_Scheduled_Visits_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  is_recurring?: InputMaybe<Scalars['Boolean']['input']>;
  is_recurring_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_request_closed?: InputMaybe<Scalars['Boolean']['input']>;
  is_test?: InputMaybe<Scalars['Boolean']['input']>;
  last_known_locations?: InputMaybe<Last_Known_Locations_Arr_Rel_Insert_Input>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  master_crop?: InputMaybe<Master_Crops_Obj_Rel_Insert_Input>;
  parent_request_id?: InputMaybe<Scalars['String']['input']>;
  recurring_schedule?: InputMaybe<Scalars['jsonb']['input']>;
  service_request_recommendations?: InputMaybe<Service_Request_Recommendations_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_feedbacks?: InputMaybe<User_Feedbacks_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Service_Requests_Max_Fields = {
  __typename?: 'service_requests_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  canceled_at?: Maybe<Scalars['timestamptz']['output']>;
  canceled_by?: Maybe<Scalars['bpchar']['output']>;
  channel?: Maybe<Scalars['String']['output']>;
  closed_at?: Maybe<Scalars['timestamptz']['output']>;
  closed_by?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crop?: Maybe<Scalars['String']['output']>;
  crop_id?: Maybe<Scalars['bpchar']['output']>;
  date_of_sowing?: Maybe<Scalars['date']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  external_source?: Maybe<Scalars['String']['output']>;
  farmer_user_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  parent_request_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "service_requests" */
export type Service_Requests_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  canceled_by?: InputMaybe<Order_By>;
  channel?: InputMaybe<Order_By>;
  closed_at?: InputMaybe<Order_By>;
  closed_by?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crop?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  date_of_sowing?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  external_source?: InputMaybe<Order_By>;
  farmer_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  parent_request_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Service_Requests_Min_Fields = {
  __typename?: 'service_requests_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  canceled_at?: Maybe<Scalars['timestamptz']['output']>;
  canceled_by?: Maybe<Scalars['bpchar']['output']>;
  channel?: Maybe<Scalars['String']['output']>;
  closed_at?: Maybe<Scalars['timestamptz']['output']>;
  closed_by?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crop?: Maybe<Scalars['String']['output']>;
  crop_id?: Maybe<Scalars['bpchar']['output']>;
  date_of_sowing?: Maybe<Scalars['date']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  external_source?: Maybe<Scalars['String']['output']>;
  farmer_user_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  parent_request_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "service_requests" */
export type Service_Requests_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  canceled_by?: InputMaybe<Order_By>;
  channel?: InputMaybe<Order_By>;
  closed_at?: InputMaybe<Order_By>;
  closed_by?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crop?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  date_of_sowing?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  external_source?: InputMaybe<Order_By>;
  farmer_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  parent_request_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "service_requests" */
export type Service_Requests_Mutation_Response = {
  __typename?: 'service_requests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Service_Requests>;
};

/** input type for inserting object relation for remote table "service_requests" */
export type Service_Requests_Obj_Rel_Insert_Input = {
  data: Service_Requests_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Service_Requests_On_Conflict>;
};

/** on_conflict condition type for table "service_requests" */
export type Service_Requests_On_Conflict = {
  constraint: Service_Requests_Constraint;
  update_columns?: Array<Service_Requests_Update_Column>;
  where?: InputMaybe<Service_Requests_Bool_Exp>;
};

/** Ordering options when selecting data from "service_requests". */
export type Service_Requests_Order_By = {
  address?: InputMaybe<Order_By>;
  address_components?: InputMaybe<Order_By>;
  assets?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  canceled_by?: InputMaybe<Order_By>;
  channel?: InputMaybe<Order_By>;
  closed_at?: InputMaybe<Order_By>;
  closed_by?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crop?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  date_of_sowing?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  external_source?: InputMaybe<Order_By>;
  farmer_user_id?: InputMaybe<Order_By>;
  field_partner_response_events_aggregate?: InputMaybe<Field_Partner_Response_Events_Aggregate_Order_By>;
  field_partner_response_messages_aggregate?: InputMaybe<Field_Partner_Response_Messages_Aggregate_Order_By>;
  field_partner_responses_aggregate?: InputMaybe<Field_Partner_Responses_Aggregate_Order_By>;
  field_scheduled_visits_aggregate?: InputMaybe<Field_Scheduled_Visits_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_recurring?: InputMaybe<Order_By>;
  is_recurring_active?: InputMaybe<Order_By>;
  is_request_closed?: InputMaybe<Order_By>;
  is_test?: InputMaybe<Order_By>;
  last_known_locations_aggregate?: InputMaybe<Last_Known_Locations_Aggregate_Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  master_crop?: InputMaybe<Master_Crops_Order_By>;
  parent_request_id?: InputMaybe<Order_By>;
  recurring_schedule?: InputMaybe<Order_By>;
  service_request_recommendations_aggregate?: InputMaybe<Service_Request_Recommendations_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_feedbacks_aggregate?: InputMaybe<User_Feedbacks_Aggregate_Order_By>;
};

/** primary key columns input for table: service_requests */
export type Service_Requests_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Service_Requests_Prepend_Input = {
  assets?: InputMaybe<Scalars['jsonb']['input']>;
  recurring_schedule?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "service_requests" */
export enum Service_Requests_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AddressComponents = 'address_components',
  /** column name */
  Assets = 'assets',
  /** column name */
  CanceledAt = 'canceled_at',
  /** column name */
  CanceledBy = 'canceled_by',
  /** column name */
  Channel = 'channel',
  /** column name */
  ClosedAt = 'closed_at',
  /** column name */
  ClosedBy = 'closed_by',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Crop = 'crop',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  DateOfSowing = 'date_of_sowing',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  ExternalSource = 'external_source',
  /** column name */
  FarmerUserId = 'farmer_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsRecurring = 'is_recurring',
  /** column name */
  IsRecurringActive = 'is_recurring_active',
  /** column name */
  IsRequestClosed = 'is_request_closed',
  /** column name */
  IsTest = 'is_test',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  ParentRequestId = 'parent_request_id',
  /** column name */
  RecurringSchedule = 'recurring_schedule',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "service_requests_aggregate_bool_exp_avg_arguments_columns" columns of table "service_requests" */
export enum Service_Requests_Select_Column_Service_Requests_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "service_requests_aggregate_bool_exp_bool_and_arguments_columns" columns of table "service_requests" */
export enum Service_Requests_Select_Column_Service_Requests_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsRecurring = 'is_recurring',
  /** column name */
  IsRecurringActive = 'is_recurring_active',
  /** column name */
  IsRequestClosed = 'is_request_closed',
  /** column name */
  IsTest = 'is_test'
}

/** select "service_requests_aggregate_bool_exp_bool_or_arguments_columns" columns of table "service_requests" */
export enum Service_Requests_Select_Column_Service_Requests_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsRecurring = 'is_recurring',
  /** column name */
  IsRecurringActive = 'is_recurring_active',
  /** column name */
  IsRequestClosed = 'is_request_closed',
  /** column name */
  IsTest = 'is_test'
}

/** select "service_requests_aggregate_bool_exp_corr_arguments_columns" columns of table "service_requests" */
export enum Service_Requests_Select_Column_Service_Requests_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "service_requests_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "service_requests" */
export enum Service_Requests_Select_Column_Service_Requests_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "service_requests_aggregate_bool_exp_max_arguments_columns" columns of table "service_requests" */
export enum Service_Requests_Select_Column_Service_Requests_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "service_requests_aggregate_bool_exp_min_arguments_columns" columns of table "service_requests" */
export enum Service_Requests_Select_Column_Service_Requests_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "service_requests_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "service_requests" */
export enum Service_Requests_Select_Column_Service_Requests_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "service_requests_aggregate_bool_exp_sum_arguments_columns" columns of table "service_requests" */
export enum Service_Requests_Select_Column_Service_Requests_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "service_requests_aggregate_bool_exp_var_samp_arguments_columns" columns of table "service_requests" */
export enum Service_Requests_Select_Column_Service_Requests_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** input type for updating data in table "service_requests" */
export type Service_Requests_Set_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  address_components?: InputMaybe<Scalars['json']['input']>;
  assets?: InputMaybe<Scalars['jsonb']['input']>;
  canceled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  canceled_by?: InputMaybe<Scalars['bpchar']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  closed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  closed_by?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crop?: InputMaybe<Scalars['String']['input']>;
  crop_id?: InputMaybe<Scalars['bpchar']['input']>;
  date_of_sowing?: InputMaybe<Scalars['date']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_source?: InputMaybe<Scalars['String']['input']>;
  farmer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  is_recurring?: InputMaybe<Scalars['Boolean']['input']>;
  is_recurring_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_request_closed?: InputMaybe<Scalars['Boolean']['input']>;
  is_test?: InputMaybe<Scalars['Boolean']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  parent_request_id?: InputMaybe<Scalars['String']['input']>;
  recurring_schedule?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Service_Requests_Stddev_Fields = {
  __typename?: 'service_requests_stddev_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "service_requests" */
export type Service_Requests_Stddev_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Service_Requests_Stddev_Pop_Fields = {
  __typename?: 'service_requests_stddev_pop_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "service_requests" */
export type Service_Requests_Stddev_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Service_Requests_Stddev_Samp_Fields = {
  __typename?: 'service_requests_stddev_samp_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "service_requests" */
export type Service_Requests_Stddev_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "service_requests" */
export type Service_Requests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Service_Requests_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Service_Requests_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  address_components?: InputMaybe<Scalars['json']['input']>;
  assets?: InputMaybe<Scalars['jsonb']['input']>;
  canceled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  canceled_by?: InputMaybe<Scalars['bpchar']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  closed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  closed_by?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crop?: InputMaybe<Scalars['String']['input']>;
  crop_id?: InputMaybe<Scalars['bpchar']['input']>;
  date_of_sowing?: InputMaybe<Scalars['date']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_source?: InputMaybe<Scalars['String']['input']>;
  farmer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  is_recurring?: InputMaybe<Scalars['Boolean']['input']>;
  is_recurring_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_request_closed?: InputMaybe<Scalars['Boolean']['input']>;
  is_test?: InputMaybe<Scalars['Boolean']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  parent_request_id?: InputMaybe<Scalars['String']['input']>;
  recurring_schedule?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Service_Requests_Sum_Fields = {
  __typename?: 'service_requests_sum_fields';
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "service_requests" */
export type Service_Requests_Sum_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** update columns of table "service_requests" */
export enum Service_Requests_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AddressComponents = 'address_components',
  /** column name */
  Assets = 'assets',
  /** column name */
  CanceledAt = 'canceled_at',
  /** column name */
  CanceledBy = 'canceled_by',
  /** column name */
  Channel = 'channel',
  /** column name */
  ClosedAt = 'closed_at',
  /** column name */
  ClosedBy = 'closed_by',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Crop = 'crop',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  DateOfSowing = 'date_of_sowing',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  ExternalSource = 'external_source',
  /** column name */
  FarmerUserId = 'farmer_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsRecurring = 'is_recurring',
  /** column name */
  IsRecurringActive = 'is_recurring_active',
  /** column name */
  IsRequestClosed = 'is_request_closed',
  /** column name */
  IsTest = 'is_test',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  ParentRequestId = 'parent_request_id',
  /** column name */
  RecurringSchedule = 'recurring_schedule',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Service_Requests_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Service_Requests_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Service_Requests_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Service_Requests_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Service_Requests_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Service_Requests_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Service_Requests_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Service_Requests_Set_Input>;
  /** filter the rows which have to be updated */
  where: Service_Requests_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Service_Requests_Var_Pop_Fields = {
  __typename?: 'service_requests_var_pop_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "service_requests" */
export type Service_Requests_Var_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Service_Requests_Var_Samp_Fields = {
  __typename?: 'service_requests_var_samp_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "service_requests" */
export type Service_Requests_Var_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Service_Requests_Variance_Fields = {
  __typename?: 'service_requests_variance_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "service_requests" */
export type Service_Requests_Variance_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "smallint". All fields are combined with logical 'AND'. */
export type Smallint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['smallint']['input']>;
  _gt?: InputMaybe<Scalars['smallint']['input']>;
  _gte?: InputMaybe<Scalars['smallint']['input']>;
  _in?: InputMaybe<Array<Scalars['smallint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['smallint']['input']>;
  _lte?: InputMaybe<Scalars['smallint']['input']>;
  _neq?: InputMaybe<Scalars['smallint']['input']>;
  _nin?: InputMaybe<Array<Scalars['smallint']['input']>>;
};

/** columns and relationships of "snapshots" */
export type Snapshots = {
  __typename?: 'snapshots';
  aggregate_uuid: Scalars['bpchar']['output'];
  aggregate_version: Scalars['Int']['output'];
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['bigint']['output'];
  state: Scalars['jsonb']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};


/** columns and relationships of "snapshots" */
export type SnapshotsStateArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "snapshots" */
export type Snapshots_Aggregate = {
  __typename?: 'snapshots_aggregate';
  aggregate?: Maybe<Snapshots_Aggregate_Fields>;
  nodes: Array<Snapshots>;
};

/** aggregate fields of "snapshots" */
export type Snapshots_Aggregate_Fields = {
  __typename?: 'snapshots_aggregate_fields';
  avg?: Maybe<Snapshots_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Snapshots_Max_Fields>;
  min?: Maybe<Snapshots_Min_Fields>;
  stddev?: Maybe<Snapshots_Stddev_Fields>;
  stddev_pop?: Maybe<Snapshots_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Snapshots_Stddev_Samp_Fields>;
  sum?: Maybe<Snapshots_Sum_Fields>;
  var_pop?: Maybe<Snapshots_Var_Pop_Fields>;
  var_samp?: Maybe<Snapshots_Var_Samp_Fields>;
  variance?: Maybe<Snapshots_Variance_Fields>;
};


/** aggregate fields of "snapshots" */
export type Snapshots_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Snapshots_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Snapshots_Append_Input = {
  state?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Snapshots_Avg_Fields = {
  __typename?: 'snapshots_avg_fields';
  aggregate_version?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "snapshots". All fields are combined with a logical 'AND'. */
export type Snapshots_Bool_Exp = {
  _and?: InputMaybe<Array<Snapshots_Bool_Exp>>;
  _not?: InputMaybe<Snapshots_Bool_Exp>;
  _or?: InputMaybe<Array<Snapshots_Bool_Exp>>;
  aggregate_uuid?: InputMaybe<Bpchar_Comparison_Exp>;
  aggregate_version?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  state?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "snapshots" */
export enum Snapshots_Constraint {
  /** unique or primary key constraint on columns "id" */
  SnapshotsPkey = 'snapshots_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Snapshots_Delete_At_Path_Input = {
  state?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Snapshots_Delete_Elem_Input = {
  state?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Snapshots_Delete_Key_Input = {
  state?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "snapshots" */
export type Snapshots_Inc_Input = {
  aggregate_version?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "snapshots" */
export type Snapshots_Insert_Input = {
  aggregate_uuid?: InputMaybe<Scalars['bpchar']['input']>;
  aggregate_version?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  state?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Snapshots_Max_Fields = {
  __typename?: 'snapshots_max_fields';
  aggregate_uuid?: Maybe<Scalars['bpchar']['output']>;
  aggregate_version?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Snapshots_Min_Fields = {
  __typename?: 'snapshots_min_fields';
  aggregate_uuid?: Maybe<Scalars['bpchar']['output']>;
  aggregate_version?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "snapshots" */
export type Snapshots_Mutation_Response = {
  __typename?: 'snapshots_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Snapshots>;
};

/** on_conflict condition type for table "snapshots" */
export type Snapshots_On_Conflict = {
  constraint: Snapshots_Constraint;
  update_columns?: Array<Snapshots_Update_Column>;
  where?: InputMaybe<Snapshots_Bool_Exp>;
};

/** Ordering options when selecting data from "snapshots". */
export type Snapshots_Order_By = {
  aggregate_uuid?: InputMaybe<Order_By>;
  aggregate_version?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: snapshots */
export type Snapshots_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Snapshots_Prepend_Input = {
  state?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "snapshots" */
export enum Snapshots_Select_Column {
  /** column name */
  AggregateUuid = 'aggregate_uuid',
  /** column name */
  AggregateVersion = 'aggregate_version',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "snapshots" */
export type Snapshots_Set_Input = {
  aggregate_uuid?: InputMaybe<Scalars['bpchar']['input']>;
  aggregate_version?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  state?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Snapshots_Stddev_Fields = {
  __typename?: 'snapshots_stddev_fields';
  aggregate_version?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Snapshots_Stddev_Pop_Fields = {
  __typename?: 'snapshots_stddev_pop_fields';
  aggregate_version?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Snapshots_Stddev_Samp_Fields = {
  __typename?: 'snapshots_stddev_samp_fields';
  aggregate_version?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "snapshots" */
export type Snapshots_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Snapshots_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Snapshots_Stream_Cursor_Value_Input = {
  aggregate_uuid?: InputMaybe<Scalars['bpchar']['input']>;
  aggregate_version?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  state?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Snapshots_Sum_Fields = {
  __typename?: 'snapshots_sum_fields';
  aggregate_version?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "snapshots" */
export enum Snapshots_Update_Column {
  /** column name */
  AggregateUuid = 'aggregate_uuid',
  /** column name */
  AggregateVersion = 'aggregate_version',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Snapshots_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Snapshots_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Snapshots_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Snapshots_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Snapshots_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Snapshots_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Snapshots_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Snapshots_Set_Input>;
  /** filter the rows which have to be updated */
  where: Snapshots_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Snapshots_Var_Pop_Fields = {
  __typename?: 'snapshots_var_pop_fields';
  aggregate_version?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Snapshots_Var_Samp_Fields = {
  __typename?: 'snapshots_var_samp_fields';
  aggregate_version?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Snapshots_Variance_Fields = {
  __typename?: 'snapshots_variance_fields';
  aggregate_version?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "spatial_ref_sys" */
export type Spatial_Ref_Sys = {
  __typename?: 'spatial_ref_sys';
  auth_name?: Maybe<Scalars['String']['output']>;
  auth_srid?: Maybe<Scalars['Int']['output']>;
  proj4text?: Maybe<Scalars['String']['output']>;
  srid: Scalars['Int']['output'];
  srtext?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "spatial_ref_sys" */
export type Spatial_Ref_Sys_Aggregate = {
  __typename?: 'spatial_ref_sys_aggregate';
  aggregate?: Maybe<Spatial_Ref_Sys_Aggregate_Fields>;
  nodes: Array<Spatial_Ref_Sys>;
};

/** aggregate fields of "spatial_ref_sys" */
export type Spatial_Ref_Sys_Aggregate_Fields = {
  __typename?: 'spatial_ref_sys_aggregate_fields';
  avg?: Maybe<Spatial_Ref_Sys_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Spatial_Ref_Sys_Max_Fields>;
  min?: Maybe<Spatial_Ref_Sys_Min_Fields>;
  stddev?: Maybe<Spatial_Ref_Sys_Stddev_Fields>;
  stddev_pop?: Maybe<Spatial_Ref_Sys_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Spatial_Ref_Sys_Stddev_Samp_Fields>;
  sum?: Maybe<Spatial_Ref_Sys_Sum_Fields>;
  var_pop?: Maybe<Spatial_Ref_Sys_Var_Pop_Fields>;
  var_samp?: Maybe<Spatial_Ref_Sys_Var_Samp_Fields>;
  variance?: Maybe<Spatial_Ref_Sys_Variance_Fields>;
};


/** aggregate fields of "spatial_ref_sys" */
export type Spatial_Ref_Sys_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Spatial_Ref_Sys_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Spatial_Ref_Sys_Avg_Fields = {
  __typename?: 'spatial_ref_sys_avg_fields';
  auth_srid?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "spatial_ref_sys". All fields are combined with a logical 'AND'. */
export type Spatial_Ref_Sys_Bool_Exp = {
  _and?: InputMaybe<Array<Spatial_Ref_Sys_Bool_Exp>>;
  _not?: InputMaybe<Spatial_Ref_Sys_Bool_Exp>;
  _or?: InputMaybe<Array<Spatial_Ref_Sys_Bool_Exp>>;
  auth_name?: InputMaybe<String_Comparison_Exp>;
  auth_srid?: InputMaybe<Int_Comparison_Exp>;
  proj4text?: InputMaybe<String_Comparison_Exp>;
  srid?: InputMaybe<Int_Comparison_Exp>;
  srtext?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "spatial_ref_sys" */
export enum Spatial_Ref_Sys_Constraint {
  /** unique or primary key constraint on columns "srid" */
  SpatialRefSysPkey = 'spatial_ref_sys_pkey'
}

/** input type for incrementing numeric columns in table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Inc_Input = {
  auth_srid?: InputMaybe<Scalars['Int']['input']>;
  srid?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Insert_Input = {
  auth_name?: InputMaybe<Scalars['String']['input']>;
  auth_srid?: InputMaybe<Scalars['Int']['input']>;
  proj4text?: InputMaybe<Scalars['String']['input']>;
  srid?: InputMaybe<Scalars['Int']['input']>;
  srtext?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Spatial_Ref_Sys_Max_Fields = {
  __typename?: 'spatial_ref_sys_max_fields';
  auth_name?: Maybe<Scalars['String']['output']>;
  auth_srid?: Maybe<Scalars['Int']['output']>;
  proj4text?: Maybe<Scalars['String']['output']>;
  srid?: Maybe<Scalars['Int']['output']>;
  srtext?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Spatial_Ref_Sys_Min_Fields = {
  __typename?: 'spatial_ref_sys_min_fields';
  auth_name?: Maybe<Scalars['String']['output']>;
  auth_srid?: Maybe<Scalars['Int']['output']>;
  proj4text?: Maybe<Scalars['String']['output']>;
  srid?: Maybe<Scalars['Int']['output']>;
  srtext?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Mutation_Response = {
  __typename?: 'spatial_ref_sys_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Spatial_Ref_Sys>;
};

/** on_conflict condition type for table "spatial_ref_sys" */
export type Spatial_Ref_Sys_On_Conflict = {
  constraint: Spatial_Ref_Sys_Constraint;
  update_columns?: Array<Spatial_Ref_Sys_Update_Column>;
  where?: InputMaybe<Spatial_Ref_Sys_Bool_Exp>;
};

/** Ordering options when selecting data from "spatial_ref_sys". */
export type Spatial_Ref_Sys_Order_By = {
  auth_name?: InputMaybe<Order_By>;
  auth_srid?: InputMaybe<Order_By>;
  proj4text?: InputMaybe<Order_By>;
  srid?: InputMaybe<Order_By>;
  srtext?: InputMaybe<Order_By>;
};

/** primary key columns input for table: spatial_ref_sys */
export type Spatial_Ref_Sys_Pk_Columns_Input = {
  srid: Scalars['Int']['input'];
};

/** select columns of table "spatial_ref_sys" */
export enum Spatial_Ref_Sys_Select_Column {
  /** column name */
  AuthName = 'auth_name',
  /** column name */
  AuthSrid = 'auth_srid',
  /** column name */
  Proj4text = 'proj4text',
  /** column name */
  Srid = 'srid',
  /** column name */
  Srtext = 'srtext'
}

/** input type for updating data in table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Set_Input = {
  auth_name?: InputMaybe<Scalars['String']['input']>;
  auth_srid?: InputMaybe<Scalars['Int']['input']>;
  proj4text?: InputMaybe<Scalars['String']['input']>;
  srid?: InputMaybe<Scalars['Int']['input']>;
  srtext?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Spatial_Ref_Sys_Stddev_Fields = {
  __typename?: 'spatial_ref_sys_stddev_fields';
  auth_srid?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Spatial_Ref_Sys_Stddev_Pop_Fields = {
  __typename?: 'spatial_ref_sys_stddev_pop_fields';
  auth_srid?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Spatial_Ref_Sys_Stddev_Samp_Fields = {
  __typename?: 'spatial_ref_sys_stddev_samp_fields';
  auth_srid?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Spatial_Ref_Sys_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Spatial_Ref_Sys_Stream_Cursor_Value_Input = {
  auth_name?: InputMaybe<Scalars['String']['input']>;
  auth_srid?: InputMaybe<Scalars['Int']['input']>;
  proj4text?: InputMaybe<Scalars['String']['input']>;
  srid?: InputMaybe<Scalars['Int']['input']>;
  srtext?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Spatial_Ref_Sys_Sum_Fields = {
  __typename?: 'spatial_ref_sys_sum_fields';
  auth_srid?: Maybe<Scalars['Int']['output']>;
  srid?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "spatial_ref_sys" */
export enum Spatial_Ref_Sys_Update_Column {
  /** column name */
  AuthName = 'auth_name',
  /** column name */
  AuthSrid = 'auth_srid',
  /** column name */
  Proj4text = 'proj4text',
  /** column name */
  Srid = 'srid',
  /** column name */
  Srtext = 'srtext'
}

export type Spatial_Ref_Sys_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Spatial_Ref_Sys_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Spatial_Ref_Sys_Set_Input>;
  /** filter the rows which have to be updated */
  where: Spatial_Ref_Sys_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Spatial_Ref_Sys_Var_Pop_Fields = {
  __typename?: 'spatial_ref_sys_var_pop_fields';
  auth_srid?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Spatial_Ref_Sys_Var_Samp_Fields = {
  __typename?: 'spatial_ref_sys_var_samp_fields';
  auth_srid?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Spatial_Ref_Sys_Variance_Fields = {
  __typename?: 'spatial_ref_sys_variance_fields';
  auth_srid?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

export type St_D_Within_Geography_Input = {
  distance: Scalars['Float']['input'];
  from: Scalars['geography']['input'];
  use_spheroid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type St_D_Within_Input = {
  distance: Scalars['Float']['input'];
  from: Scalars['geometry']['input'];
};

/** columns and relationships of "stored_events" */
export type Stored_Events = {
  __typename?: 'stored_events';
  aggregate_uuid?: Maybe<Scalars['bpchar']['output']>;
  aggregate_version?: Maybe<Scalars['bigint']['output']>;
  created_at: Scalars['timestamp']['output'];
  event_class: Scalars['String']['output'];
  event_properties: Scalars['jsonb']['output'];
  event_version: Scalars['smallint']['output'];
  id: Scalars['bigint']['output'];
  meta_data: Scalars['jsonb']['output'];
};


/** columns and relationships of "stored_events" */
export type Stored_EventsEvent_PropertiesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "stored_events" */
export type Stored_EventsMeta_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "stored_events" */
export type Stored_Events_Aggregate = {
  __typename?: 'stored_events_aggregate';
  aggregate?: Maybe<Stored_Events_Aggregate_Fields>;
  nodes: Array<Stored_Events>;
};

/** aggregate fields of "stored_events" */
export type Stored_Events_Aggregate_Fields = {
  __typename?: 'stored_events_aggregate_fields';
  avg?: Maybe<Stored_Events_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Stored_Events_Max_Fields>;
  min?: Maybe<Stored_Events_Min_Fields>;
  stddev?: Maybe<Stored_Events_Stddev_Fields>;
  stddev_pop?: Maybe<Stored_Events_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Stored_Events_Stddev_Samp_Fields>;
  sum?: Maybe<Stored_Events_Sum_Fields>;
  var_pop?: Maybe<Stored_Events_Var_Pop_Fields>;
  var_samp?: Maybe<Stored_Events_Var_Samp_Fields>;
  variance?: Maybe<Stored_Events_Variance_Fields>;
};


/** aggregate fields of "stored_events" */
export type Stored_Events_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Stored_Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Stored_Events_Append_Input = {
  event_properties?: InputMaybe<Scalars['jsonb']['input']>;
  meta_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Stored_Events_Avg_Fields = {
  __typename?: 'stored_events_avg_fields';
  aggregate_version?: Maybe<Scalars['Float']['output']>;
  event_version?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "stored_events". All fields are combined with a logical 'AND'. */
export type Stored_Events_Bool_Exp = {
  _and?: InputMaybe<Array<Stored_Events_Bool_Exp>>;
  _not?: InputMaybe<Stored_Events_Bool_Exp>;
  _or?: InputMaybe<Array<Stored_Events_Bool_Exp>>;
  aggregate_uuid?: InputMaybe<Bpchar_Comparison_Exp>;
  aggregate_version?: InputMaybe<Bigint_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  event_class?: InputMaybe<String_Comparison_Exp>;
  event_properties?: InputMaybe<Jsonb_Comparison_Exp>;
  event_version?: InputMaybe<Smallint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  meta_data?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "stored_events" */
export enum Stored_Events_Constraint {
  /** unique or primary key constraint on columns "aggregate_uuid", "aggregate_version" */
  StoredEventsAggregateUuidAggregateVersionUnique = 'stored_events_aggregate_uuid_aggregate_version_unique',
  /** unique or primary key constraint on columns "id" */
  StoredEventsPkey = 'stored_events_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Stored_Events_Delete_At_Path_Input = {
  event_properties?: InputMaybe<Array<Scalars['String']['input']>>;
  meta_data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Stored_Events_Delete_Elem_Input = {
  event_properties?: InputMaybe<Scalars['Int']['input']>;
  meta_data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Stored_Events_Delete_Key_Input = {
  event_properties?: InputMaybe<Scalars['String']['input']>;
  meta_data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "stored_events" */
export type Stored_Events_Inc_Input = {
  aggregate_version?: InputMaybe<Scalars['bigint']['input']>;
  event_version?: InputMaybe<Scalars['smallint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "stored_events" */
export type Stored_Events_Insert_Input = {
  aggregate_uuid?: InputMaybe<Scalars['bpchar']['input']>;
  aggregate_version?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  event_class?: InputMaybe<Scalars['String']['input']>;
  event_properties?: InputMaybe<Scalars['jsonb']['input']>;
  event_version?: InputMaybe<Scalars['smallint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  meta_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type Stored_Events_Max_Fields = {
  __typename?: 'stored_events_max_fields';
  aggregate_uuid?: Maybe<Scalars['bpchar']['output']>;
  aggregate_version?: Maybe<Scalars['bigint']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  event_class?: Maybe<Scalars['String']['output']>;
  event_version?: Maybe<Scalars['smallint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Stored_Events_Min_Fields = {
  __typename?: 'stored_events_min_fields';
  aggregate_uuid?: Maybe<Scalars['bpchar']['output']>;
  aggregate_version?: Maybe<Scalars['bigint']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  event_class?: Maybe<Scalars['String']['output']>;
  event_version?: Maybe<Scalars['smallint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "stored_events" */
export type Stored_Events_Mutation_Response = {
  __typename?: 'stored_events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Stored_Events>;
};

/** on_conflict condition type for table "stored_events" */
export type Stored_Events_On_Conflict = {
  constraint: Stored_Events_Constraint;
  update_columns?: Array<Stored_Events_Update_Column>;
  where?: InputMaybe<Stored_Events_Bool_Exp>;
};

/** Ordering options when selecting data from "stored_events". */
export type Stored_Events_Order_By = {
  aggregate_uuid?: InputMaybe<Order_By>;
  aggregate_version?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event_class?: InputMaybe<Order_By>;
  event_properties?: InputMaybe<Order_By>;
  event_version?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meta_data?: InputMaybe<Order_By>;
};

/** primary key columns input for table: stored_events */
export type Stored_Events_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Stored_Events_Prepend_Input = {
  event_properties?: InputMaybe<Scalars['jsonb']['input']>;
  meta_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "stored_events" */
export enum Stored_Events_Select_Column {
  /** column name */
  AggregateUuid = 'aggregate_uuid',
  /** column name */
  AggregateVersion = 'aggregate_version',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventClass = 'event_class',
  /** column name */
  EventProperties = 'event_properties',
  /** column name */
  EventVersion = 'event_version',
  /** column name */
  Id = 'id',
  /** column name */
  MetaData = 'meta_data'
}

/** input type for updating data in table "stored_events" */
export type Stored_Events_Set_Input = {
  aggregate_uuid?: InputMaybe<Scalars['bpchar']['input']>;
  aggregate_version?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  event_class?: InputMaybe<Scalars['String']['input']>;
  event_properties?: InputMaybe<Scalars['jsonb']['input']>;
  event_version?: InputMaybe<Scalars['smallint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  meta_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate stddev on columns */
export type Stored_Events_Stddev_Fields = {
  __typename?: 'stored_events_stddev_fields';
  aggregate_version?: Maybe<Scalars['Float']['output']>;
  event_version?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Stored_Events_Stddev_Pop_Fields = {
  __typename?: 'stored_events_stddev_pop_fields';
  aggregate_version?: Maybe<Scalars['Float']['output']>;
  event_version?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Stored_Events_Stddev_Samp_Fields = {
  __typename?: 'stored_events_stddev_samp_fields';
  aggregate_version?: Maybe<Scalars['Float']['output']>;
  event_version?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "stored_events" */
export type Stored_Events_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Stored_Events_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Stored_Events_Stream_Cursor_Value_Input = {
  aggregate_uuid?: InputMaybe<Scalars['bpchar']['input']>;
  aggregate_version?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  event_class?: InputMaybe<Scalars['String']['input']>;
  event_properties?: InputMaybe<Scalars['jsonb']['input']>;
  event_version?: InputMaybe<Scalars['smallint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  meta_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate sum on columns */
export type Stored_Events_Sum_Fields = {
  __typename?: 'stored_events_sum_fields';
  aggregate_version?: Maybe<Scalars['bigint']['output']>;
  event_version?: Maybe<Scalars['smallint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "stored_events" */
export enum Stored_Events_Update_Column {
  /** column name */
  AggregateUuid = 'aggregate_uuid',
  /** column name */
  AggregateVersion = 'aggregate_version',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventClass = 'event_class',
  /** column name */
  EventProperties = 'event_properties',
  /** column name */
  EventVersion = 'event_version',
  /** column name */
  Id = 'id',
  /** column name */
  MetaData = 'meta_data'
}

export type Stored_Events_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Stored_Events_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Stored_Events_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Stored_Events_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Stored_Events_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Stored_Events_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Stored_Events_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Stored_Events_Set_Input>;
  /** filter the rows which have to be updated */
  where: Stored_Events_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Stored_Events_Var_Pop_Fields = {
  __typename?: 'stored_events_var_pop_fields';
  aggregate_version?: Maybe<Scalars['Float']['output']>;
  event_version?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Stored_Events_Var_Samp_Fields = {
  __typename?: 'stored_events_var_samp_fields';
  aggregate_version?: Maybe<Scalars['Float']['output']>;
  event_version?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Stored_Events_Variance_Fields = {
  __typename?: 'stored_events_variance_fields';
  aggregate_version?: Maybe<Scalars['Float']['output']>;
  event_version?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "account_auth_key" */
  account_auth_key: Array<Account_Auth_Key>;
  /** fetch aggregated fields from the table: "account_auth_key" */
  account_auth_key_aggregate: Account_Auth_Key_Aggregate;
  /** fetch data from the table: "account_auth_key" using primary key columns */
  account_auth_key_by_pk?: Maybe<Account_Auth_Key>;
  /** fetch data from the table in a streaming manner: "account_auth_key" */
  account_auth_key_stream: Array<Account_Auth_Key>;
  /** fetch data from the table: "account_crop" */
  account_crop: Array<Account_Crop>;
  /** fetch aggregated fields from the table: "account_crop" */
  account_crop_aggregate: Account_Crop_Aggregate;
  /** fetch data from the table: "account_crop" using primary key columns */
  account_crop_by_pk?: Maybe<Account_Crop>;
  /** fetch data from the table in a streaming manner: "account_crop" */
  account_crop_stream: Array<Account_Crop>;
  /** fetch data from the table: "account_segment" */
  account_segment: Array<Account_Segment>;
  /** fetch aggregated fields from the table: "account_segment" */
  account_segment_aggregate: Account_Segment_Aggregate;
  /** fetch data from the table: "account_segment" using primary key columns */
  account_segment_by_pk?: Maybe<Account_Segment>;
  /** fetch data from the table in a streaming manner: "account_segment" */
  account_segment_stream: Array<Account_Segment>;
  /** fetch data from the table: "account_user" */
  account_user: Array<Account_User>;
  /** fetch aggregated fields from the table: "account_user" */
  account_user_aggregate: Account_User_Aggregate;
  /** fetch data from the table: "account_user" using primary key columns */
  account_user_by_pk?: Maybe<Account_User>;
  /** fetch data from the table in a streaming manner: "account_user" */
  account_user_stream: Array<Account_User>;
  /** An array relationship */
  accounts: Array<Accounts>;
  /** An aggregate relationship */
  accounts_aggregate: Accounts_Aggregate;
  /** fetch data from the table: "accounts" using primary key columns */
  accounts_by_pk?: Maybe<Accounts>;
  /** fetch data from the table in a streaming manner: "accounts" */
  accounts_stream: Array<Accounts>;
  /** fetch data from the table: "action_events" */
  action_events: Array<Action_Events>;
  /** fetch aggregated fields from the table: "action_events" */
  action_events_aggregate: Action_Events_Aggregate;
  /** fetch data from the table: "action_events" using primary key columns */
  action_events_by_pk?: Maybe<Action_Events>;
  /** fetch data from the table in a streaming manner: "action_events" */
  action_events_stream: Array<Action_Events>;
  /** fetch data from the table: "balances" */
  balances: Array<Balances>;
  /** fetch aggregated fields from the table: "balances" */
  balances_aggregate: Balances_Aggregate;
  /** fetch data from the table: "balances" using primary key columns */
  balances_by_pk?: Maybe<Balances>;
  /** fetch data from the table in a streaming manner: "balances" */
  balances_stream: Array<Balances>;
  /** An array relationship */
  channel_links: Array<Channel_Links>;
  /** An aggregate relationship */
  channel_links_aggregate: Channel_Links_Aggregate;
  /** fetch data from the table: "channel_links" using primary key columns */
  channel_links_by_pk?: Maybe<Channel_Links>;
  /** fetch data from the table in a streaming manner: "channel_links" */
  channel_links_stream: Array<Channel_Links>;
  /** fetch data from the table: "channels" */
  channels: Array<Channels>;
  /** fetch aggregated fields from the table: "channels" */
  channels_aggregate: Channels_Aggregate;
  /** fetch data from the table: "channels" using primary key columns */
  channels_by_pk?: Maybe<Channels>;
  /** fetch data from the table in a streaming manner: "channels" */
  channels_stream: Array<Channels>;
  /** fetch data from the table: "chat_messages" */
  chat_messages: Array<Chat_Messages>;
  /** fetch aggregated fields from the table: "chat_messages" */
  chat_messages_aggregate: Chat_Messages_Aggregate;
  /** fetch data from the table: "chat_messages" using primary key columns */
  chat_messages_by_pk?: Maybe<Chat_Messages>;
  /** fetch data from the table in a streaming manner: "chat_messages" */
  chat_messages_stream: Array<Chat_Messages>;
  /** An array relationship */
  chat_participants: Array<Chat_Participants>;
  /** An aggregate relationship */
  chat_participants_aggregate: Chat_Participants_Aggregate;
  /** fetch data from the table: "chat_participants" using primary key columns */
  chat_participants_by_pk?: Maybe<Chat_Participants>;
  /** fetch data from the table in a streaming manner: "chat_participants" */
  chat_participants_stream: Array<Chat_Participants>;
  /** fetch data from the table: "chat_threads" */
  chat_threads: Array<Chat_Threads>;
  /** fetch aggregated fields from the table: "chat_threads" */
  chat_threads_aggregate: Chat_Threads_Aggregate;
  /** fetch data from the table: "chat_threads" using primary key columns */
  chat_threads_by_pk?: Maybe<Chat_Threads>;
  /** fetch data from the table in a streaming manner: "chat_threads" */
  chat_threads_stream: Array<Chat_Threads>;
  /** An array relationship */
  companies: Array<Companies>;
  /** An aggregate relationship */
  companies_aggregate: Companies_Aggregate;
  /** fetch data from the table: "companies" using primary key columns */
  companies_by_pk?: Maybe<Companies>;
  /** fetch data from the table in a streaming manner: "companies" */
  companies_stream: Array<Companies>;
  /** fetch data from the table: "creator_onboarding" */
  creator_onboarding: Array<Creator_Onboarding>;
  /** fetch aggregated fields from the table: "creator_onboarding" */
  creator_onboarding_aggregate: Creator_Onboarding_Aggregate;
  /** fetch data from the table: "creator_onboarding" using primary key columns */
  creator_onboarding_by_pk?: Maybe<Creator_Onboarding>;
  /** fetch data from the table in a streaming manner: "creator_onboarding" */
  creator_onboarding_stream: Array<Creator_Onboarding>;
  /** fetch data from the table: "crm_account_channel_crop_prospects" */
  crm_account_channel_crop_prospects: Array<Crm_Account_Channel_Crop_Prospects>;
  /** fetch aggregated fields from the table: "crm_account_channel_crop_prospects" */
  crm_account_channel_crop_prospects_aggregate: Crm_Account_Channel_Crop_Prospects_Aggregate;
  /** fetch data from the table in a streaming manner: "crm_account_channel_crop_prospects" */
  crm_account_channel_crop_prospects_stream: Array<Crm_Account_Channel_Crop_Prospects>;
  /** fetch data from the table: "crm_account_crop_wise_counts" */
  crm_account_crop_wise_counts: Array<Crm_Account_Crop_Wise_Counts>;
  /** fetch aggregated fields from the table: "crm_account_crop_wise_counts" */
  crm_account_crop_wise_counts_aggregate: Crm_Account_Crop_Wise_Counts_Aggregate;
  /** fetch data from the table in a streaming manner: "crm_account_crop_wise_counts" */
  crm_account_crop_wise_counts_stream: Array<Crm_Account_Crop_Wise_Counts>;
  /** fetch data from the table: "crm_account_interaction_type_pending_counts" */
  crm_account_interaction_type_pending_counts: Array<Crm_Account_Interaction_Type_Pending_Counts>;
  /** fetch aggregated fields from the table: "crm_account_interaction_type_pending_counts" */
  crm_account_interaction_type_pending_counts_aggregate: Crm_Account_Interaction_Type_Pending_Counts_Aggregate;
  /** fetch data from the table in a streaming manner: "crm_account_interaction_type_pending_counts" */
  crm_account_interaction_type_pending_counts_stream: Array<Crm_Account_Interaction_Type_Pending_Counts>;
  /** fetch data from the table: "crm_segments" */
  crm_segments: Array<Crm_Segments>;
  /** fetch aggregated fields from the table: "crm_segments" */
  crm_segments_aggregate: Crm_Segments_Aggregate;
  /** fetch data from the table: "crm_segments" using primary key columns */
  crm_segments_by_pk?: Maybe<Crm_Segments>;
  /** fetch data from the table in a streaming manner: "crm_segments" */
  crm_segments_stream: Array<Crm_Segments>;
  /** fetch data from the table: "crop_user" */
  crop_user: Array<Crop_User>;
  /** fetch aggregated fields from the table: "crop_user" */
  crop_user_aggregate: Crop_User_Aggregate;
  /** fetch data from the table: "crop_user" using primary key columns */
  crop_user_by_pk?: Maybe<Crop_User>;
  /** fetch data from the table in a streaming manner: "crop_user" */
  crop_user_stream: Array<Crop_User>;
  /** fetch data from the table: "failed_jobs" */
  failed_jobs: Array<Failed_Jobs>;
  /** fetch aggregated fields from the table: "failed_jobs" */
  failed_jobs_aggregate: Failed_Jobs_Aggregate;
  /** fetch data from the table: "failed_jobs" using primary key columns */
  failed_jobs_by_pk?: Maybe<Failed_Jobs>;
  /** fetch data from the table in a streaming manner: "failed_jobs" */
  failed_jobs_stream: Array<Failed_Jobs>;
  /** fetch data from the table: "farmer_account_locations" */
  farmer_account_locations: Array<Farmer_Account_Locations>;
  /** fetch aggregated fields from the table: "farmer_account_locations" */
  farmer_account_locations_aggregate: Farmer_Account_Locations_Aggregate;
  /** fetch data from the table: "farmer_account_locations" using primary key columns */
  farmer_account_locations_by_pk?: Maybe<Farmer_Account_Locations>;
  /** fetch data from the table in a streaming manner: "farmer_account_locations" */
  farmer_account_locations_stream: Array<Farmer_Account_Locations>;
  /** fetch data from the table: "farmer_accounts" */
  farmer_accounts: Array<Farmer_Accounts>;
  /** fetch aggregated fields from the table: "farmer_accounts" */
  farmer_accounts_aggregate: Farmer_Accounts_Aggregate;
  /** fetch data from the table: "farmer_accounts" using primary key columns */
  farmer_accounts_by_pk?: Maybe<Farmer_Accounts>;
  /** fetch data from the table in a streaming manner: "farmer_accounts" */
  farmer_accounts_stream: Array<Farmer_Accounts>;
  /** fetch data from the table: "farmer_actions" */
  farmer_actions: Array<Farmer_Actions>;
  /** fetch aggregated fields from the table: "farmer_actions" */
  farmer_actions_aggregate: Farmer_Actions_Aggregate;
  /** fetch data from the table: "farmer_actions" using primary key columns */
  farmer_actions_by_pk?: Maybe<Farmer_Actions>;
  /** fetch data from the table in a streaming manner: "farmer_actions" */
  farmer_actions_stream: Array<Farmer_Actions>;
  /** fetch data from the table: "farmer_fields" */
  farmer_fields: Array<Farmer_Fields>;
  /** fetch aggregated fields from the table: "farmer_fields" */
  farmer_fields_aggregate: Farmer_Fields_Aggregate;
  /** fetch data from the table: "farmer_fields" using primary key columns */
  farmer_fields_by_pk?: Maybe<Farmer_Fields>;
  /** fetch data from the table: "farmer_fields_latest" */
  farmer_fields_latest: Array<Farmer_Fields_Latest>;
  /** fetch aggregated fields from the table: "farmer_fields_latest" */
  farmer_fields_latest_aggregate: Farmer_Fields_Latest_Aggregate;
  /** fetch data from the table in a streaming manner: "farmer_fields_latest" */
  farmer_fields_latest_stream: Array<Farmer_Fields_Latest>;
  /** fetch data from the table in a streaming manner: "farmer_fields" */
  farmer_fields_stream: Array<Farmer_Fields>;
  /** fetch data from the table: "farmer_master" */
  farmer_master: Array<Farmer_Master>;
  /** fetch aggregated fields from the table: "farmer_master" */
  farmer_master_aggregate: Farmer_Master_Aggregate;
  /** fetch data from the table: "farmer_master" using primary key columns */
  farmer_master_by_pk?: Maybe<Farmer_Master>;
  /** fetch data from the table in a streaming manner: "farmer_master" */
  farmer_master_stream: Array<Farmer_Master>;
  /** fetch data from the table: "farmer_nearby_field_force" */
  farmer_nearby_field_force: Array<Farmer_Nearby_Field_Force>;
  /** fetch aggregated fields from the table: "farmer_nearby_field_force" */
  farmer_nearby_field_force_aggregate: Farmer_Nearby_Field_Force_Aggregate;
  /** fetch data from the table: "farmer_nearby_field_force" using primary key columns */
  farmer_nearby_field_force_by_pk?: Maybe<Farmer_Nearby_Field_Force>;
  /** fetch data from the table in a streaming manner: "farmer_nearby_field_force" */
  farmer_nearby_field_force_stream: Array<Farmer_Nearby_Field_Force>;
  /** An array relationship */
  farmer_plots: Array<Farmer_Plots>;
  /** An aggregate relationship */
  farmer_plots_aggregate: Farmer_Plots_Aggregate;
  /** fetch data from the table: "farmer_plots" using primary key columns */
  farmer_plots_by_pk?: Maybe<Farmer_Plots>;
  /** fetch data from the table in a streaming manner: "farmer_plots" */
  farmer_plots_stream: Array<Farmer_Plots>;
  /** fetch data from the table: "farminsta_links" */
  farminsta_links: Array<Farminsta_Links>;
  /** fetch aggregated fields from the table: "farminsta_links" */
  farminsta_links_aggregate: Farminsta_Links_Aggregate;
  /** fetch data from the table: "farminsta_links" using primary key columns */
  farminsta_links_by_pk?: Maybe<Farminsta_Links>;
  /** fetch data from the table in a streaming manner: "farminsta_links" */
  farminsta_links_stream: Array<Farminsta_Links>;
  /** fetch data from the table: "features" */
  features: Array<Features>;
  /** fetch aggregated fields from the table: "features" */
  features_aggregate: Features_Aggregate;
  /** fetch data from the table: "features" using primary key columns */
  features_by_pk?: Maybe<Features>;
  /** fetch data from the table in a streaming manner: "features" */
  features_stream: Array<Features>;
  /** fetch data from the table: "dbt.channel_analytics" */
  fich_farminsta_replica_channel_analytics: Array<Fich_Farminsta_Replica_Channel_Analytics>;
  /** fetch aggregated fields from the table: "dbt.channel_analytics" */
  fich_farminsta_replica_channel_analytics_aggregate: Fich_Farminsta_Replica_Channel_Analytics_Aggregate;
  /** fetch data from the table in a streaming manner: "dbt.channel_analytics" */
  fich_farminsta_replica_channel_analytics_stream: Array<Fich_Farminsta_Replica_Channel_Analytics>;
  /** fetch data from the table: "dbt.leads" */
  fich_farminsta_replica_leads: Array<Fich_Farminsta_Replica_Leads>;
  /** fetch aggregated fields from the table: "dbt.leads" */
  fich_farminsta_replica_leads_aggregate: Fich_Farminsta_Replica_Leads_Aggregate;
  /** fetch data from the table in a streaming manner: "dbt.leads" */
  fich_farminsta_replica_leads_stream: Array<Fich_Farminsta_Replica_Leads>;
  /** fetch data from the table: "dbt.reel_lead_info" */
  fich_farminsta_replica_reel_lead_info: Array<Fich_Farminsta_Replica_Reel_Lead_Info>;
  /** fetch aggregated fields from the table: "dbt.reel_lead_info" */
  fich_farminsta_replica_reel_lead_info_aggregate: Fich_Farminsta_Replica_Reel_Lead_Info_Aggregate;
  /** fetch data from the table in a streaming manner: "dbt.reel_lead_info" */
  fich_farminsta_replica_reel_lead_info_stream: Array<Fich_Farminsta_Replica_Reel_Lead_Info>;
  /** fetch data from the table: "dbt.reels_flat" */
  fich_farminsta_replica_reels_flat: Array<Fich_Farminsta_Replica_Reels_Flat>;
  /** fetch aggregated fields from the table: "dbt.reels_flat" */
  fich_farminsta_replica_reels_flat_aggregate: Fich_Farminsta_Replica_Reels_Flat_Aggregate;
  /** fetch data from the table in a streaming manner: "dbt.reels_flat" */
  fich_farminsta_replica_reels_flat_stream: Array<Fich_Farminsta_Replica_Reels_Flat>;
  /** An array relationship */
  field_partner_response_events: Array<Field_Partner_Response_Events>;
  /** An aggregate relationship */
  field_partner_response_events_aggregate: Field_Partner_Response_Events_Aggregate;
  /** fetch data from the table: "field_partner_response_events" using primary key columns */
  field_partner_response_events_by_pk?: Maybe<Field_Partner_Response_Events>;
  /** fetch data from the table in a streaming manner: "field_partner_response_events" */
  field_partner_response_events_stream: Array<Field_Partner_Response_Events>;
  /** An array relationship */
  field_partner_response_messages: Array<Field_Partner_Response_Messages>;
  /** An aggregate relationship */
  field_partner_response_messages_aggregate: Field_Partner_Response_Messages_Aggregate;
  /** fetch data from the table: "field_partner_response_messages" using primary key columns */
  field_partner_response_messages_by_pk?: Maybe<Field_Partner_Response_Messages>;
  /** fetch data from the table in a streaming manner: "field_partner_response_messages" */
  field_partner_response_messages_stream: Array<Field_Partner_Response_Messages>;
  /** An array relationship */
  field_partner_responses: Array<Field_Partner_Responses>;
  /** An aggregate relationship */
  field_partner_responses_aggregate: Field_Partner_Responses_Aggregate;
  /** fetch data from the table: "field_partner_responses" using primary key columns */
  field_partner_responses_by_pk?: Maybe<Field_Partner_Responses>;
  /** fetch data from the table in a streaming manner: "field_partner_responses" */
  field_partner_responses_stream: Array<Field_Partner_Responses>;
  /** An array relationship */
  field_scheduled_visits: Array<Field_Scheduled_Visits>;
  /** An aggregate relationship */
  field_scheduled_visits_aggregate: Field_Scheduled_Visits_Aggregate;
  /** fetch data from the table: "field_scheduled_visits" using primary key columns */
  field_scheduled_visits_by_pk?: Maybe<Field_Scheduled_Visits>;
  /** fetch data from the table in a streaming manner: "field_scheduled_visits" */
  field_scheduled_visits_stream: Array<Field_Scheduled_Visits>;
  /** fetch data from the table: "fo_reels_staging" */
  fo_reels_staging: Array<Fo_Reels_Staging>;
  /** fetch aggregated fields from the table: "fo_reels_staging" */
  fo_reels_staging_aggregate: Fo_Reels_Staging_Aggregate;
  /** fetch data from the table: "fo_reels_staging" using primary key columns */
  fo_reels_staging_by_pk?: Maybe<Fo_Reels_Staging>;
  /** fetch data from the table in a streaming manner: "fo_reels_staging" */
  fo_reels_staging_stream: Array<Fo_Reels_Staging>;
  /** fetch data from the table: "follows" */
  follows: Array<Follows>;
  /** fetch aggregated fields from the table: "follows" */
  follows_aggregate: Follows_Aggregate;
  /** fetch data from the table: "follows" using primary key columns */
  follows_by_pk?: Maybe<Follows>;
  /** fetch data from the table in a streaming manner: "follows" */
  follows_stream: Array<Follows>;
  /** fetch data from the table: "geography_columns" */
  geography_columns: Array<Geography_Columns>;
  /** fetch aggregated fields from the table: "geography_columns" */
  geography_columns_aggregate: Geography_Columns_Aggregate;
  /** fetch data from the table in a streaming manner: "geography_columns" */
  geography_columns_stream: Array<Geography_Columns>;
  /** fetch data from the table: "geometry_columns" */
  geometry_columns: Array<Geometry_Columns>;
  /** fetch aggregated fields from the table: "geometry_columns" */
  geometry_columns_aggregate: Geometry_Columns_Aggregate;
  /** fetch data from the table in a streaming manner: "geometry_columns" */
  geometry_columns_stream: Array<Geometry_Columns>;
  /** execute function "get_reel_with_related" which returns "reels_with_distance" */
  get_reel_with_related: Array<Reels_With_Distance>;
  /** execute function "get_reel_with_related" and query aggregates on result of table type "reels_with_distance" */
  get_reel_with_related_aggregate: Reels_With_Distance_Aggregate;
  /** execute function "get_reels" which returns "reels_with_distance" */
  get_reels: Array<Reels_With_Distance>;
  /** execute function "get_reels" and query aggregates on result of table type "reels_with_distance" */
  get_reels_aggregate: Reels_With_Distance_Aggregate;
  /** fetch data from the table: "gig_faqs" */
  gig_faqs: Array<Gig_Faqs>;
  /** fetch aggregated fields from the table: "gig_faqs" */
  gig_faqs_aggregate: Gig_Faqs_Aggregate;
  /** fetch data from the table: "gig_faqs" using primary key columns */
  gig_faqs_by_pk?: Maybe<Gig_Faqs>;
  /** fetch data from the table in a streaming manner: "gig_faqs" */
  gig_faqs_stream: Array<Gig_Faqs>;
  /** fetch data from the table: "gig_promos" */
  gig_promos: Array<Gig_Promos>;
  /** fetch aggregated fields from the table: "gig_promos" */
  gig_promos_aggregate: Gig_Promos_Aggregate;
  /** fetch data from the table: "gig_promos" using primary key columns */
  gig_promos_by_pk?: Maybe<Gig_Promos>;
  /** fetch data from the table in a streaming manner: "gig_promos" */
  gig_promos_stream: Array<Gig_Promos>;
  /** fetch data from the table: "gig_variants" */
  gig_variants: Array<Gig_Variants>;
  /** fetch aggregated fields from the table: "gig_variants" */
  gig_variants_aggregate: Gig_Variants_Aggregate;
  /** fetch data from the table: "gig_variants" using primary key columns */
  gig_variants_by_pk?: Maybe<Gig_Variants>;
  /** fetch data from the table in a streaming manner: "gig_variants" */
  gig_variants_stream: Array<Gig_Variants>;
  /** fetch data from the table: "gigs" */
  gigs: Array<Gigs>;
  /** fetch aggregated fields from the table: "gigs" */
  gigs_aggregate: Gigs_Aggregate;
  /** fetch data from the table: "gigs" using primary key columns */
  gigs_by_pk?: Maybe<Gigs>;
  /** fetch data from the table in a streaming manner: "gigs" */
  gigs_stream: Array<Gigs>;
  /** fetch data from the table: "gis.districts" */
  gis_districts: Array<Gis_Districts>;
  /** fetch aggregated fields from the table: "gis.districts" */
  gis_districts_aggregate: Gis_Districts_Aggregate;
  /** fetch data from the table: "gis.districts" using primary key columns */
  gis_districts_by_pk?: Maybe<Gis_Districts>;
  /** fetch data from the table in a streaming manner: "gis.districts" */
  gis_districts_stream: Array<Gis_Districts>;
  /** fetch data from the table: "gis.states" */
  gis_states: Array<Gis_States>;
  /** fetch aggregated fields from the table: "gis.states" */
  gis_states_aggregate: Gis_States_Aggregate;
  /** fetch data from the table: "gis.states" using primary key columns */
  gis_states_by_pk?: Maybe<Gis_States>;
  /** fetch data from the table in a streaming manner: "gis.states" */
  gis_states_stream: Array<Gis_States>;
  /** An array relationship */
  last_known_locations: Array<Last_Known_Locations>;
  /** An aggregate relationship */
  last_known_locations_aggregate: Last_Known_Locations_Aggregate;
  /** fetch data from the table: "last_known_locations" using primary key columns */
  last_known_locations_by_pk?: Maybe<Last_Known_Locations>;
  /** fetch data from the table in a streaming manner: "last_known_locations" */
  last_known_locations_stream: Array<Last_Known_Locations>;
  /** fetch data from the table: "master_crops" */
  master_crops: Array<Master_Crops>;
  /** fetch aggregated fields from the table: "master_crops" */
  master_crops_aggregate: Master_Crops_Aggregate;
  /** fetch data from the table: "master_crops" using primary key columns */
  master_crops_by_pk?: Maybe<Master_Crops>;
  /** fetch data from the table in a streaming manner: "master_crops" */
  master_crops_stream: Array<Master_Crops>;
  /** fetch data from the table: "master_segments" */
  master_segments: Array<Master_Segments>;
  /** fetch aggregated fields from the table: "master_segments" */
  master_segments_aggregate: Master_Segments_Aggregate;
  /** fetch data from the table: "master_segments" using primary key columns */
  master_segments_by_pk?: Maybe<Master_Segments>;
  /** fetch data from the table in a streaming manner: "master_segments" */
  master_segments_stream: Array<Master_Segments>;
  /** fetch data from the table: "messaging_campaign_recipients" */
  messaging_campaign_recipients: Array<Messaging_Campaign_Recipients>;
  /** fetch aggregated fields from the table: "messaging_campaign_recipients" */
  messaging_campaign_recipients_aggregate: Messaging_Campaign_Recipients_Aggregate;
  /** fetch data from the table: "messaging_campaign_recipients" using primary key columns */
  messaging_campaign_recipients_by_pk?: Maybe<Messaging_Campaign_Recipients>;
  /** fetch data from the table in a streaming manner: "messaging_campaign_recipients" */
  messaging_campaign_recipients_stream: Array<Messaging_Campaign_Recipients>;
  /** fetch data from the table: "messaging_campaign_segments" */
  messaging_campaign_segments: Array<Messaging_Campaign_Segments>;
  /** fetch aggregated fields from the table: "messaging_campaign_segments" */
  messaging_campaign_segments_aggregate: Messaging_Campaign_Segments_Aggregate;
  /** fetch data from the table: "messaging_campaign_segments" using primary key columns */
  messaging_campaign_segments_by_pk?: Maybe<Messaging_Campaign_Segments>;
  /** fetch data from the table in a streaming manner: "messaging_campaign_segments" */
  messaging_campaign_segments_stream: Array<Messaging_Campaign_Segments>;
  /** fetch data from the table: "messaging_campaigns" */
  messaging_campaigns: Array<Messaging_Campaigns>;
  /** fetch aggregated fields from the table: "messaging_campaigns" */
  messaging_campaigns_aggregate: Messaging_Campaigns_Aggregate;
  /** fetch data from the table: "messaging_campaigns" using primary key columns */
  messaging_campaigns_by_pk?: Maybe<Messaging_Campaigns>;
  /** fetch data from the table in a streaming manner: "messaging_campaigns" */
  messaging_campaigns_stream: Array<Messaging_Campaigns>;
  /** fetch data from the table: "messaging_templates" */
  messaging_templates: Array<Messaging_Templates>;
  /** fetch aggregated fields from the table: "messaging_templates" */
  messaging_templates_aggregate: Messaging_Templates_Aggregate;
  /** fetch data from the table: "messaging_templates" using primary key columns */
  messaging_templates_by_pk?: Maybe<Messaging_Templates>;
  /** fetch data from the table in a streaming manner: "messaging_templates" */
  messaging_templates_stream: Array<Messaging_Templates>;
  /** fetch data from the table: "migrations" */
  migrations: Array<Migrations>;
  /** fetch aggregated fields from the table: "migrations" */
  migrations_aggregate: Migrations_Aggregate;
  /** fetch data from the table: "migrations" using primary key columns */
  migrations_by_pk?: Maybe<Migrations>;
  /** fetch data from the table in a streaming manner: "migrations" */
  migrations_stream: Array<Migrations>;
  /** fetch data from the table: "missed_call_number_pool" */
  missed_call_number_pool: Array<Missed_Call_Number_Pool>;
  /** fetch aggregated fields from the table: "missed_call_number_pool" */
  missed_call_number_pool_aggregate: Missed_Call_Number_Pool_Aggregate;
  /** fetch data from the table: "missed_call_number_pool" using primary key columns */
  missed_call_number_pool_by_pk?: Maybe<Missed_Call_Number_Pool>;
  /** fetch data from the table in a streaming manner: "missed_call_number_pool" */
  missed_call_number_pool_stream: Array<Missed_Call_Number_Pool>;
  /** fetch data from the table: "missed_calls" */
  missed_calls: Array<Missed_Calls>;
  /** fetch aggregated fields from the table: "missed_calls" */
  missed_calls_aggregate: Missed_Calls_Aggregate;
  /** fetch data from the table: "missed_calls" using primary key columns */
  missed_calls_by_pk?: Maybe<Missed_Calls>;
  /** fetch data from the table in a streaming manner: "missed_calls" */
  missed_calls_stream: Array<Missed_Calls>;
  /** An array relationship */
  model_has_permissions: Array<Model_Has_Permissions>;
  /** An aggregate relationship */
  model_has_permissions_aggregate: Model_Has_Permissions_Aggregate;
  /** fetch data from the table: "model_has_permissions" using primary key columns */
  model_has_permissions_by_pk?: Maybe<Model_Has_Permissions>;
  /** fetch data from the table in a streaming manner: "model_has_permissions" */
  model_has_permissions_stream: Array<Model_Has_Permissions>;
  /** An array relationship */
  model_has_roles: Array<Model_Has_Roles>;
  /** An aggregate relationship */
  model_has_roles_aggregate: Model_Has_Roles_Aggregate;
  /** fetch data from the table: "model_has_roles" using primary key columns */
  model_has_roles_by_pk?: Maybe<Model_Has_Roles>;
  /** fetch data from the table in a streaming manner: "model_has_roles" */
  model_has_roles_stream: Array<Model_Has_Roles>;
  /** fetch data from the table: "notifications" */
  notifications: Array<Notifications>;
  /** fetch aggregated fields from the table: "notifications" */
  notifications_aggregate: Notifications_Aggregate;
  /** fetch data from the table: "notifications" using primary key columns */
  notifications_by_pk?: Maybe<Notifications>;
  /** fetch data from the table in a streaming manner: "notifications" */
  notifications_stream: Array<Notifications>;
  /** fetch data from the table: "nova_field_attachments" */
  nova_field_attachments: Array<Nova_Field_Attachments>;
  /** fetch aggregated fields from the table: "nova_field_attachments" */
  nova_field_attachments_aggregate: Nova_Field_Attachments_Aggregate;
  /** fetch data from the table: "nova_field_attachments" using primary key columns */
  nova_field_attachments_by_pk?: Maybe<Nova_Field_Attachments>;
  /** fetch data from the table in a streaming manner: "nova_field_attachments" */
  nova_field_attachments_stream: Array<Nova_Field_Attachments>;
  /** fetch data from the table: "nova_notifications" */
  nova_notifications: Array<Nova_Notifications>;
  /** fetch aggregated fields from the table: "nova_notifications" */
  nova_notifications_aggregate: Nova_Notifications_Aggregate;
  /** fetch data from the table: "nova_notifications" using primary key columns */
  nova_notifications_by_pk?: Maybe<Nova_Notifications>;
  /** fetch data from the table in a streaming manner: "nova_notifications" */
  nova_notifications_stream: Array<Nova_Notifications>;
  /** fetch data from the table: "nova_pending_field_attachments" */
  nova_pending_field_attachments: Array<Nova_Pending_Field_Attachments>;
  /** fetch aggregated fields from the table: "nova_pending_field_attachments" */
  nova_pending_field_attachments_aggregate: Nova_Pending_Field_Attachments_Aggregate;
  /** fetch data from the table: "nova_pending_field_attachments" using primary key columns */
  nova_pending_field_attachments_by_pk?: Maybe<Nova_Pending_Field_Attachments>;
  /** fetch data from the table in a streaming manner: "nova_pending_field_attachments" */
  nova_pending_field_attachments_stream: Array<Nova_Pending_Field_Attachments>;
  /** fetch data from the table: "nova_twofa" */
  nova_twofa: Array<Nova_Twofa>;
  /** fetch aggregated fields from the table: "nova_twofa" */
  nova_twofa_aggregate: Nova_Twofa_Aggregate;
  /** fetch data from the table: "nova_twofa" using primary key columns */
  nova_twofa_by_pk?: Maybe<Nova_Twofa>;
  /** fetch data from the table in a streaming manner: "nova_twofa" */
  nova_twofa_stream: Array<Nova_Twofa>;
  /** fetch data from the table: "pairing_codes" */
  pairing_codes: Array<Pairing_Codes>;
  /** fetch aggregated fields from the table: "pairing_codes" */
  pairing_codes_aggregate: Pairing_Codes_Aggregate;
  /** fetch data from the table: "pairing_codes" using primary key columns */
  pairing_codes_by_pk?: Maybe<Pairing_Codes>;
  /** fetch data from the table in a streaming manner: "pairing_codes" */
  pairing_codes_stream: Array<Pairing_Codes>;
  /** fetch data from the table: "password_reset_tokens" */
  password_reset_tokens: Array<Password_Reset_Tokens>;
  /** fetch aggregated fields from the table: "password_reset_tokens" */
  password_reset_tokens_aggregate: Password_Reset_Tokens_Aggregate;
  /** fetch data from the table: "password_reset_tokens" using primary key columns */
  password_reset_tokens_by_pk?: Maybe<Password_Reset_Tokens>;
  /** fetch data from the table in a streaming manner: "password_reset_tokens" */
  password_reset_tokens_stream: Array<Password_Reset_Tokens>;
  /** fetch data from the table: "permissions" */
  permissions: Array<Permissions>;
  /** fetch aggregated fields from the table: "permissions" */
  permissions_aggregate: Permissions_Aggregate;
  /** fetch data from the table: "permissions" using primary key columns */
  permissions_by_pk?: Maybe<Permissions>;
  /** fetch data from the table in a streaming manner: "permissions" */
  permissions_stream: Array<Permissions>;
  /** fetch data from the table: "personal_access_tokens" */
  personal_access_tokens: Array<Personal_Access_Tokens>;
  /** fetch aggregated fields from the table: "personal_access_tokens" */
  personal_access_tokens_aggregate: Personal_Access_Tokens_Aggregate;
  /** fetch data from the table: "personal_access_tokens" using primary key columns */
  personal_access_tokens_by_pk?: Maybe<Personal_Access_Tokens>;
  /** fetch data from the table in a streaming manner: "personal_access_tokens" */
  personal_access_tokens_stream: Array<Personal_Access_Tokens>;
  /** fetch data from the table: "personal_dashboard" */
  personal_dashboard: Array<Personal_Dashboard>;
  /** fetch aggregated fields from the table: "personal_dashboard" */
  personal_dashboard_aggregate: Personal_Dashboard_Aggregate;
  /** fetch data from the table: "personal_dashboard" using primary key columns */
  personal_dashboard_by_pk?: Maybe<Personal_Dashboard>;
  /** fetch data from the table in a streaming manner: "personal_dashboard" */
  personal_dashboard_stream: Array<Personal_Dashboard>;
  /** fetch data from the table: "runpando_pro.crops" */
  pf_fcm_crops: Array<Pf_Fcm_Crops>;
  /** fetch aggregated fields from the table: "runpando_pro.crops" */
  pf_fcm_crops_aggregate: Pf_Fcm_Crops_Aggregate;
  /** fetch data from the table: "runpando_pro.crops" using primary key columns */
  pf_fcm_crops_by_pk?: Maybe<Pf_Fcm_Crops>;
  /** fetch data from the table in a streaming manner: "runpando_pro.crops" */
  pf_fcm_crops_stream: Array<Pf_Fcm_Crops>;
  /** fetch data from the table: "runpando_pro.products" */
  pf_fcm_products: Array<Pf_Fcm_Products>;
  /** fetch aggregated fields from the table: "runpando_pro.products" */
  pf_fcm_products_aggregate: Pf_Fcm_Products_Aggregate;
  /** fetch data from the table: "runpando_pro.products" using primary key columns */
  pf_fcm_products_by_pk?: Maybe<Pf_Fcm_Products>;
  /** fetch data from the table in a streaming manner: "runpando_pro.products" */
  pf_fcm_products_stream: Array<Pf_Fcm_Products>;
  /** fetch data from the table: "runpando_pro.plan_cards" */
  pf_plan_cards: Array<Pf_Plan_Cards>;
  pf_plan_cards_aggregate: Pf_Plan_Cards_Aggregate;
  /** fetch data from the table: "runpando_pro.plan_cards" using primary key columns */
  pf_plan_cards_by_pk?: Maybe<Pf_Plan_Cards>;
  /** fetch data from the table in a streaming manner: "runpando_pro.plan_cards" */
  pf_plan_cards_stream: Array<Pf_Plan_Cards>;
  /** fetch data from the table: "runpando_pro.products" */
  pf_products: Array<Pf_Products>;
  /** fetch aggregated fields from the table: "runpando_pro.products" */
  pf_products_aggregate: Pf_Products_Aggregate;
  /** fetch data from the table: "runpando_pro.products" using primary key columns */
  pf_products_by_pk?: Maybe<Pf_Products>;
  /** fetch data from the table in a streaming manner: "runpando_pro.products" */
  pf_products_stream: Array<Pf_Products>;
  /** fetch data from the table: "runpando_pro.activity_coins_feedback" */
  pf_runpando_pro_activity_coins_feedback: Array<Pf_Runpando_Pro_Activity_Coins_Feedback>;
  /** fetch aggregated fields from the table: "runpando_pro.activity_coins_feedback" */
  pf_runpando_pro_activity_coins_feedback_aggregate: Pf_Runpando_Pro_Activity_Coins_Feedback_Aggregate;
  /** fetch data from the table: "runpando_pro.activity_coins_feedback" using primary key columns */
  pf_runpando_pro_activity_coins_feedback_by_pk?: Maybe<Pf_Runpando_Pro_Activity_Coins_Feedback>;
  /** fetch data from the table in a streaming manner: "runpando_pro.activity_coins_feedback" */
  pf_runpando_pro_activity_coins_feedback_stream: Array<Pf_Runpando_Pro_Activity_Coins_Feedback>;
  /** fetch data from the table: "runpando_pro.all_state_data" */
  pf_runpando_pro_all_state_data: Array<Pf_Runpando_Pro_All_State_Data>;
  /** fetch aggregated fields from the table: "runpando_pro.all_state_data" */
  pf_runpando_pro_all_state_data_aggregate: Pf_Runpando_Pro_All_State_Data_Aggregate;
  /** fetch data from the table: "runpando_pro.all_state_data" using primary key columns */
  pf_runpando_pro_all_state_data_by_pk?: Maybe<Pf_Runpando_Pro_All_State_Data>;
  /** fetch data from the table in a streaming manner: "runpando_pro.all_state_data" */
  pf_runpando_pro_all_state_data_stream: Array<Pf_Runpando_Pro_All_State_Data>;
  /** fetch data from the table: "runpando_pro.campaign_card_activities" */
  pf_runpando_pro_campaign_card_activities: Array<Pf_Runpando_Pro_Campaign_Card_Activities>;
  /** fetch aggregated fields from the table: "runpando_pro.campaign_card_activities" */
  pf_runpando_pro_campaign_card_activities_aggregate: Pf_Runpando_Pro_Campaign_Card_Activities_Aggregate;
  /** fetch data from the table: "runpando_pro.campaign_card_activities" using primary key columns */
  pf_runpando_pro_campaign_card_activities_by_pk?: Maybe<Pf_Runpando_Pro_Campaign_Card_Activities>;
  /** fetch data from the table in a streaming manner: "runpando_pro.campaign_card_activities" */
  pf_runpando_pro_campaign_card_activities_stream: Array<Pf_Runpando_Pro_Campaign_Card_Activities>;
  /** fetch data from the table: "runpando_pro.channel_card_images" */
  pf_runpando_pro_channel_card_images: Array<Pf_Runpando_Pro_Channel_Card_Images>;
  /** fetch aggregated fields from the table: "runpando_pro.channel_card_images" */
  pf_runpando_pro_channel_card_images_aggregate: Pf_Runpando_Pro_Channel_Card_Images_Aggregate;
  /** fetch data from the table: "runpando_pro.channel_card_images" using primary key columns */
  pf_runpando_pro_channel_card_images_by_pk?: Maybe<Pf_Runpando_Pro_Channel_Card_Images>;
  /** fetch data from the table in a streaming manner: "runpando_pro.channel_card_images" */
  pf_runpando_pro_channel_card_images_stream: Array<Pf_Runpando_Pro_Channel_Card_Images>;
  /** fetch data from the table: "runpando_pro.users_locations" */
  pf_runpando_pro_users_locations: Array<Pf_Runpando_Pro_Users_Locations>;
  /** fetch aggregated fields from the table: "runpando_pro.users_locations" */
  pf_runpando_pro_users_locations_aggregate: Pf_Runpando_Pro_Users_Locations_Aggregate;
  /** fetch data from the table: "runpando_pro.users_locations" using primary key columns */
  pf_runpando_pro_users_locations_by_pk?: Maybe<Pf_Runpando_Pro_Users_Locations>;
  /** fetch data from the table in a streaming manner: "runpando_pro.users_locations" */
  pf_runpando_pro_users_locations_stream: Array<Pf_Runpando_Pro_Users_Locations>;
  /** fetch data from the table: "runpando_pro.user_travellog" */
  pf_user_travellog: Array<Pf_User_Travellog>;
  /** fetch aggregated fields from the table: "runpando_pro.user_travellog" */
  pf_user_travellog_aggregate: Pf_User_Travellog_Aggregate;
  /** fetch data from the table: "runpando_pro.user_travellog" using primary key columns */
  pf_user_travellog_by_pk?: Maybe<Pf_User_Travellog>;
  /** fetch data from the table in a streaming manner: "runpando_pro.user_travellog" */
  pf_user_travellog_stream: Array<Pf_User_Travellog>;
  /** fetch data from the table: "runpando_pro.users" */
  pf_users: Array<Pf_Users>;
  /** fetch aggregated fields from the table: "runpando_pro.users" */
  pf_users_aggregate: Pf_Users_Aggregate;
  /** fetch data from the table: "runpando_pro.users" using primary key columns */
  pf_users_by_pk?: Maybe<Pf_Users>;
  /** fetch data from the table in a streaming manner: "runpando_pro.users" */
  pf_users_stream: Array<Pf_Users>;
  /** fetch data from the table: "product_pop_media" */
  product_pop_media: Array<Product_Pop_Media>;
  /** fetch aggregated fields from the table: "product_pop_media" */
  product_pop_media_aggregate: Product_Pop_Media_Aggregate;
  /** fetch data from the table: "product_pop_media" using primary key columns */
  product_pop_media_by_pk?: Maybe<Product_Pop_Media>;
  /** fetch data from the table in a streaming manner: "product_pop_media" */
  product_pop_media_stream: Array<Product_Pop_Media>;
  /** fetch data from the table: "product_pops" */
  product_pops: Array<Product_Pops>;
  /** fetch aggregated fields from the table: "product_pops" */
  product_pops_aggregate: Product_Pops_Aggregate;
  /** fetch data from the table: "product_pops" using primary key columns */
  product_pops_by_pk?: Maybe<Product_Pops>;
  /** fetch data from the table in a streaming manner: "product_pops" */
  product_pops_stream: Array<Product_Pops>;
  /** fetch data from the table: "prospect_crops" */
  prospect_crops: Array<Prospect_Crops>;
  /** fetch aggregated fields from the table: "prospect_crops" */
  prospect_crops_aggregate: Prospect_Crops_Aggregate;
  /** fetch data from the table: "prospect_crops" using primary key columns */
  prospect_crops_by_pk?: Maybe<Prospect_Crops>;
  /** fetch data from the table in a streaming manner: "prospect_crops" */
  prospect_crops_stream: Array<Prospect_Crops>;
  /** fetch data from the table: "prospect_messages" */
  prospect_messages: Array<Prospect_Messages>;
  /** fetch aggregated fields from the table: "prospect_messages" */
  prospect_messages_aggregate: Prospect_Messages_Aggregate;
  /** fetch data from the table: "prospect_messages" using primary key columns */
  prospect_messages_by_pk?: Maybe<Prospect_Messages>;
  /** fetch data from the table in a streaming manner: "prospect_messages" */
  prospect_messages_stream: Array<Prospect_Messages>;
  /** fetch data from the table: "prospect_user" */
  prospect_user: Array<Prospect_User>;
  /** fetch aggregated fields from the table: "prospect_user" */
  prospect_user_aggregate: Prospect_User_Aggregate;
  /** fetch data from the table: "prospect_user" using primary key columns */
  prospect_user_by_pk?: Maybe<Prospect_User>;
  /** fetch data from the table in a streaming manner: "prospect_user" */
  prospect_user_stream: Array<Prospect_User>;
  /** fetch data from the table: "prospects" */
  prospects: Array<Prospects>;
  /** fetch aggregated fields from the table: "prospects" */
  prospects_aggregate: Prospects_Aggregate;
  /** fetch data from the table: "prospects" using primary key columns */
  prospects_by_pk?: Maybe<Prospects>;
  /** fetch data from the table in a streaming manner: "prospects" */
  prospects_stream: Array<Prospects>;
  /** fetch data from the table: "reel_category" */
  reel_category: Array<Reel_Category>;
  /** fetch aggregated fields from the table: "reel_category" */
  reel_category_aggregate: Reel_Category_Aggregate;
  /** fetch data from the table: "reel_category" using primary key columns */
  reel_category_by_pk?: Maybe<Reel_Category>;
  /** fetch data from the table in a streaming manner: "reel_category" */
  reel_category_stream: Array<Reel_Category>;
  /** An array relationship */
  reel_comments: Array<Reel_Comments>;
  /** An aggregate relationship */
  reel_comments_aggregate: Reel_Comments_Aggregate;
  /** fetch data from the table: "reel_comments" using primary key columns */
  reel_comments_by_pk?: Maybe<Reel_Comments>;
  /** fetch data from the table in a streaming manner: "reel_comments" */
  reel_comments_stream: Array<Reel_Comments>;
  /** fetch data from the table: "reel_interactions" */
  reel_interactions: Array<Reel_Interactions>;
  /** fetch aggregated fields from the table: "reel_interactions" */
  reel_interactions_aggregate: Reel_Interactions_Aggregate;
  /** fetch data from the table: "reel_interactions" using primary key columns */
  reel_interactions_by_pk?: Maybe<Reel_Interactions>;
  /** fetch data from the table in a streaming manner: "reel_interactions" */
  reel_interactions_stream: Array<Reel_Interactions>;
  /** fetch data from the table: "reel_stats" */
  reel_stats: Array<Reel_Stats>;
  /** fetch aggregated fields from the table: "reel_stats" */
  reel_stats_aggregate: Reel_Stats_Aggregate;
  /** fetch data from the table: "reel_stats" using primary key columns */
  reel_stats_by_pk?: Maybe<Reel_Stats>;
  /** fetch data from the table in a streaming manner: "reel_stats" */
  reel_stats_stream: Array<Reel_Stats>;
  /** fetch data from the table: "reel_user_reports" */
  reel_user_reports: Array<Reel_User_Reports>;
  /** fetch aggregated fields from the table: "reel_user_reports" */
  reel_user_reports_aggregate: Reel_User_Reports_Aggregate;
  /** fetch data from the table: "reel_user_reports" using primary key columns */
  reel_user_reports_by_pk?: Maybe<Reel_User_Reports>;
  /** fetch data from the table in a streaming manner: "reel_user_reports" */
  reel_user_reports_stream: Array<Reel_User_Reports>;
  /** An array relationship */
  reels: Array<Reels>;
  /** An aggregate relationship */
  reels_aggregate: Reels_Aggregate;
  /** fetch data from the table: "reels" using primary key columns */
  reels_by_pk?: Maybe<Reels>;
  /** fetch data from the table in a streaming manner: "reels" */
  reels_stream: Array<Reels>;
  /** fetch data from the table: "reels_with_distance" */
  reels_with_distance: Array<Reels_With_Distance>;
  /** fetch aggregated fields from the table: "reels_with_distance" */
  reels_with_distance_aggregate: Reels_With_Distance_Aggregate;
  /** fetch data from the table in a streaming manner: "reels_with_distance" */
  reels_with_distance_stream: Array<Reels_With_Distance>;
  /** fetch data from the table: "retailer_establishments" */
  retailer_establishments: Array<Retailer_Establishments>;
  /** fetch aggregated fields from the table: "retailer_establishments" */
  retailer_establishments_aggregate: Retailer_Establishments_Aggregate;
  /** fetch data from the table: "retailer_establishments" using primary key columns */
  retailer_establishments_by_pk?: Maybe<Retailer_Establishments>;
  /** fetch data from the table in a streaming manner: "retailer_establishments" */
  retailer_establishments_stream: Array<Retailer_Establishments>;
  /** fetch data from the table: "retailers" */
  retailers: Array<Retailers>;
  /** fetch aggregated fields from the table: "retailers" */
  retailers_aggregate: Retailers_Aggregate;
  /** fetch data from the table: "retailers" using primary key columns */
  retailers_by_pk?: Maybe<Retailers>;
  /** fetch data from the table in a streaming manner: "retailers" */
  retailers_stream: Array<Retailers>;
  /** An array relationship */
  role_has_permissions: Array<Role_Has_Permissions>;
  /** An aggregate relationship */
  role_has_permissions_aggregate: Role_Has_Permissions_Aggregate;
  /** fetch data from the table: "role_has_permissions" using primary key columns */
  role_has_permissions_by_pk?: Maybe<Role_Has_Permissions>;
  /** fetch data from the table in a streaming manner: "role_has_permissions" */
  role_has_permissions_stream: Array<Role_Has_Permissions>;
  /** fetch data from the table: "roles" */
  roles: Array<Roles>;
  /** fetch aggregated fields from the table: "roles" */
  roles_aggregate: Roles_Aggregate;
  /** fetch data from the table: "roles" using primary key columns */
  roles_by_pk?: Maybe<Roles>;
  /** fetch data from the table in a streaming manner: "roles" */
  roles_stream: Array<Roles>;
  /** fetch data from the table: "runpando_pro.all_state_data" */
  runpando_pro_all_state_data: Array<Runpando_Pro_All_State_Data>;
  /** fetch aggregated fields from the table: "runpando_pro.all_state_data" */
  runpando_pro_all_state_data_aggregate: Runpando_Pro_All_State_Data_Aggregate;
  /** fetch data from the table: "runpando_pro.all_state_data" using primary key columns */
  runpando_pro_all_state_data_by_pk?: Maybe<Runpando_Pro_All_State_Data>;
  /** fetch data from the table in a streaming manner: "runpando_pro.all_state_data" */
  runpando_pro_all_state_data_stream: Array<Runpando_Pro_All_State_Data>;
  /** fetch data from the table: "runpando_pro.users" */
  runpando_pro_users: Array<Runpando_Pro_Users>;
  /** fetch aggregated fields from the table: "runpando_pro.users" */
  runpando_pro_users_aggregate: Runpando_Pro_Users_Aggregate;
  /** fetch data from the table: "runpando_pro.users" using primary key columns */
  runpando_pro_users_by_pk?: Maybe<Runpando_Pro_Users>;
  /** fetch data from the table: "runpando_pro.users_locations" */
  runpando_pro_users_locations: Array<Runpando_Pro_Users_Locations>;
  /** fetch aggregated fields from the table: "runpando_pro.users_locations" */
  runpando_pro_users_locations_aggregate: Runpando_Pro_Users_Locations_Aggregate;
  /** fetch data from the table: "runpando_pro.users_locations" using primary key columns */
  runpando_pro_users_locations_by_pk?: Maybe<Runpando_Pro_Users_Locations>;
  /** fetch data from the table in a streaming manner: "runpando_pro.users_locations" */
  runpando_pro_users_locations_stream: Array<Runpando_Pro_Users_Locations>;
  /** fetch data from the table in a streaming manner: "runpando_pro.users" */
  runpando_pro_users_stream: Array<Runpando_Pro_Users>;
  /** An array relationship */
  sale_items: Array<Sale_Items>;
  /** An aggregate relationship */
  sale_items_aggregate: Sale_Items_Aggregate;
  /** fetch data from the table: "sale_items" using primary key columns */
  sale_items_by_pk?: Maybe<Sale_Items>;
  /** fetch data from the table in a streaming manner: "sale_items" */
  sale_items_stream: Array<Sale_Items>;
  /** fetch data from the table: "sale_payments" */
  sale_payments: Array<Sale_Payments>;
  /** fetch aggregated fields from the table: "sale_payments" */
  sale_payments_aggregate: Sale_Payments_Aggregate;
  /** fetch data from the table: "sale_payments" using primary key columns */
  sale_payments_by_pk?: Maybe<Sale_Payments>;
  /** fetch data from the table in a streaming manner: "sale_payments" */
  sale_payments_stream: Array<Sale_Payments>;
  /** fetch data from the table: "sale_proof_events" */
  sale_proof_events: Array<Sale_Proof_Events>;
  /** fetch aggregated fields from the table: "sale_proof_events" */
  sale_proof_events_aggregate: Sale_Proof_Events_Aggregate;
  /** fetch data from the table: "sale_proof_events" using primary key columns */
  sale_proof_events_by_pk?: Maybe<Sale_Proof_Events>;
  /** fetch data from the table in a streaming manner: "sale_proof_events" */
  sale_proof_events_stream: Array<Sale_Proof_Events>;
  /** fetch data from the table: "sale_proof_types" */
  sale_proof_types: Array<Sale_Proof_Types>;
  /** fetch aggregated fields from the table: "sale_proof_types" */
  sale_proof_types_aggregate: Sale_Proof_Types_Aggregate;
  /** fetch data from the table: "sale_proof_types" using primary key columns */
  sale_proof_types_by_pk?: Maybe<Sale_Proof_Types>;
  /** fetch data from the table in a streaming manner: "sale_proof_types" */
  sale_proof_types_stream: Array<Sale_Proof_Types>;
  /** An array relationship */
  sale_proofs: Array<Sale_Proofs>;
  /** An aggregate relationship */
  sale_proofs_aggregate: Sale_Proofs_Aggregate;
  /** fetch data from the table: "sale_proofs" using primary key columns */
  sale_proofs_by_pk?: Maybe<Sale_Proofs>;
  /** fetch data from the table in a streaming manner: "sale_proofs" */
  sale_proofs_stream: Array<Sale_Proofs>;
  /** fetch data from the table: "sales" */
  sales: Array<Sales>;
  /** fetch aggregated fields from the table: "sales" */
  sales_aggregate: Sales_Aggregate;
  /** fetch data from the table: "sales" using primary key columns */
  sales_by_pk?: Maybe<Sales>;
  /** fetch data from the table in a streaming manner: "sales" */
  sales_stream: Array<Sales>;
  /** fetch data from the table: "saved_reels" */
  saved_reels: Array<Saved_Reels>;
  /** fetch aggregated fields from the table: "saved_reels" */
  saved_reels_aggregate: Saved_Reels_Aggregate;
  /** fetch data from the table: "saved_reels" using primary key columns */
  saved_reels_by_pk?: Maybe<Saved_Reels>;
  /** fetch data from the table in a streaming manner: "saved_reels" */
  saved_reels_stream: Array<Saved_Reels>;
  /** execute function "search_field_force_near_farmer" which returns "last_known_locations" */
  search_field_force_near_farmer: Array<Last_Known_Locations>;
  /** execute function "search_field_force_near_farmer" and query aggregates on result of table type "last_known_locations" */
  search_field_force_near_farmer_aggregate: Last_Known_Locations_Aggregate;
  /** fetch data from the table: "segment_user" */
  segment_user: Array<Segment_User>;
  /** fetch aggregated fields from the table: "segment_user" */
  segment_user_aggregate: Segment_User_Aggregate;
  /** fetch data from the table: "segment_user" using primary key columns */
  segment_user_by_pk?: Maybe<Segment_User>;
  /** fetch data from the table in a streaming manner: "segment_user" */
  segment_user_stream: Array<Segment_User>;
  /** fetch data from the table: "service_request_dashboard" */
  service_request_dashboard: Array<Service_Request_Dashboard>;
  /** fetch aggregated fields from the table: "service_request_dashboard" */
  service_request_dashboard_aggregate: Service_Request_Dashboard_Aggregate;
  /** fetch data from the table: "service_request_dashboard" using primary key columns */
  service_request_dashboard_by_pk?: Maybe<Service_Request_Dashboard>;
  /** fetch data from the table in a streaming manner: "service_request_dashboard" */
  service_request_dashboard_stream: Array<Service_Request_Dashboard>;
  /** An array relationship */
  service_request_recommendations: Array<Service_Request_Recommendations>;
  /** An aggregate relationship */
  service_request_recommendations_aggregate: Service_Request_Recommendations_Aggregate;
  /** fetch data from the table: "service_request_recommendations" using primary key columns */
  service_request_recommendations_by_pk?: Maybe<Service_Request_Recommendations>;
  /** fetch data from the table in a streaming manner: "service_request_recommendations" */
  service_request_recommendations_stream: Array<Service_Request_Recommendations>;
  /** fetch data from the table: "service_request_retailer" */
  service_request_retailer: Array<Service_Request_Retailer>;
  /** fetch aggregated fields from the table: "service_request_retailer" */
  service_request_retailer_aggregate: Service_Request_Retailer_Aggregate;
  /** fetch data from the table: "service_request_retailer" using primary key columns */
  service_request_retailer_by_pk?: Maybe<Service_Request_Retailer>;
  /** fetch data from the table in a streaming manner: "service_request_retailer" */
  service_request_retailer_stream: Array<Service_Request_Retailer>;
  /** An array relationship */
  service_requests: Array<Service_Requests>;
  /** An aggregate relationship */
  service_requests_aggregate: Service_Requests_Aggregate;
  /** fetch data from the table: "service_requests" using primary key columns */
  service_requests_by_pk?: Maybe<Service_Requests>;
  /** fetch data from the table in a streaming manner: "service_requests" */
  service_requests_stream: Array<Service_Requests>;
  /** fetch data from the table: "snapshots" */
  snapshots: Array<Snapshots>;
  /** fetch aggregated fields from the table: "snapshots" */
  snapshots_aggregate: Snapshots_Aggregate;
  /** fetch data from the table: "snapshots" using primary key columns */
  snapshots_by_pk?: Maybe<Snapshots>;
  /** fetch data from the table in a streaming manner: "snapshots" */
  snapshots_stream: Array<Snapshots>;
  /** fetch data from the table: "spatial_ref_sys" */
  spatial_ref_sys: Array<Spatial_Ref_Sys>;
  /** fetch aggregated fields from the table: "spatial_ref_sys" */
  spatial_ref_sys_aggregate: Spatial_Ref_Sys_Aggregate;
  /** fetch data from the table: "spatial_ref_sys" using primary key columns */
  spatial_ref_sys_by_pk?: Maybe<Spatial_Ref_Sys>;
  /** fetch data from the table in a streaming manner: "spatial_ref_sys" */
  spatial_ref_sys_stream: Array<Spatial_Ref_Sys>;
  /** fetch data from the table: "stored_events" */
  stored_events: Array<Stored_Events>;
  /** fetch aggregated fields from the table: "stored_events" */
  stored_events_aggregate: Stored_Events_Aggregate;
  /** fetch data from the table: "stored_events" using primary key columns */
  stored_events_by_pk?: Maybe<Stored_Events>;
  /** fetch data from the table in a streaming manner: "stored_events" */
  stored_events_stream: Array<Stored_Events>;
  /** fetch data from the table: "taggables" */
  taggables: Array<Taggables>;
  /** fetch aggregated fields from the table: "taggables" */
  taggables_aggregate: Taggables_Aggregate;
  /** fetch data from the table: "taggables" using primary key columns */
  taggables_by_pk?: Maybe<Taggables>;
  /** fetch data from the table in a streaming manner: "taggables" */
  taggables_stream: Array<Taggables>;
  /** fetch data from the table: "tags" */
  tags: Array<Tags>;
  /** fetch aggregated fields from the table: "tags" */
  tags_aggregate: Tags_Aggregate;
  /** fetch data from the table: "tags" using primary key columns */
  tags_by_pk?: Maybe<Tags>;
  /** fetch data from the table in a streaming manner: "tags" */
  tags_stream: Array<Tags>;
  /** fetch data from the table: "user_device" */
  user_device: Array<User_Device>;
  /** fetch aggregated fields from the table: "user_device" */
  user_device_aggregate: User_Device_Aggregate;
  /** fetch data from the table: "user_device" using primary key columns */
  user_device_by_pk?: Maybe<User_Device>;
  /** fetch data from the table in a streaming manner: "user_device" */
  user_device_stream: Array<User_Device>;
  /** An array relationship */
  user_feedbacks: Array<User_Feedbacks>;
  /** An aggregate relationship */
  user_feedbacks_aggregate: User_Feedbacks_Aggregate;
  /** fetch data from the table: "user_feedbacks" using primary key columns */
  user_feedbacks_by_pk?: Maybe<User_Feedbacks>;
  /** fetch data from the table in a streaming manner: "user_feedbacks" */
  user_feedbacks_stream: Array<User_Feedbacks>;
  /** fetch data from the table: "user_follows_channel" */
  user_follows_channel: Array<User_Follows_Channel>;
  /** fetch aggregated fields from the table: "user_follows_channel" */
  user_follows_channel_aggregate: User_Follows_Channel_Aggregate;
  /** fetch data from the table: "user_follows_channel" using primary key columns */
  user_follows_channel_by_pk?: Maybe<User_Follows_Channel>;
  /** fetch data from the table in a streaming manner: "user_follows_channel" */
  user_follows_channel_stream: Array<User_Follows_Channel>;
  /** An array relationship */
  user_location_logs: Array<User_Location_Logs>;
  /** An aggregate relationship */
  user_location_logs_aggregate: User_Location_Logs_Aggregate;
  /** fetch data from the table: "user_location_logs" using primary key columns */
  user_location_logs_by_pk?: Maybe<User_Location_Logs>;
  /** fetch data from the table in a streaming manner: "user_location_logs" */
  user_location_logs_stream: Array<User_Location_Logs>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table in a streaming manner: "users" */
  users_stream: Array<Users>;
  /** fetch data from the table: "wallets" */
  wallets: Array<Wallets>;
  /** fetch aggregated fields from the table: "wallets" */
  wallets_aggregate: Wallets_Aggregate;
  /** fetch data from the table: "wallets" using primary key columns */
  wallets_by_pk?: Maybe<Wallets>;
  /** fetch data from the table in a streaming manner: "wallets" */
  wallets_stream: Array<Wallets>;
  /** fetch data from the table: "whatsauth_logins" */
  whatsauth_logins: Array<Whatsauth_Logins>;
  /** fetch aggregated fields from the table: "whatsauth_logins" */
  whatsauth_logins_aggregate: Whatsauth_Logins_Aggregate;
  /** fetch data from the table: "whatsauth_logins" using primary key columns */
  whatsauth_logins_by_pk?: Maybe<Whatsauth_Logins>;
  /** fetch data from the table in a streaming manner: "whatsauth_logins" */
  whatsauth_logins_stream: Array<Whatsauth_Logins>;
  /** fetch data from the table: "work_order_checklist_items" */
  work_order_checklist_items: Array<Work_Order_Checklist_Items>;
  /** fetch aggregated fields from the table: "work_order_checklist_items" */
  work_order_checklist_items_aggregate: Work_Order_Checklist_Items_Aggregate;
  /** fetch data from the table: "work_order_checklist_items" using primary key columns */
  work_order_checklist_items_by_pk?: Maybe<Work_Order_Checklist_Items>;
  /** fetch data from the table in a streaming manner: "work_order_checklist_items" */
  work_order_checklist_items_stream: Array<Work_Order_Checklist_Items>;
  /** fetch data from the table: "work_order_messages" */
  work_order_messages: Array<Work_Order_Messages>;
  /** fetch aggregated fields from the table: "work_order_messages" */
  work_order_messages_aggregate: Work_Order_Messages_Aggregate;
  /** fetch data from the table: "work_order_messages" using primary key columns */
  work_order_messages_by_pk?: Maybe<Work_Order_Messages>;
  /** fetch data from the table in a streaming manner: "work_order_messages" */
  work_order_messages_stream: Array<Work_Order_Messages>;
  /** fetch data from the table: "work_order_outputs" */
  work_order_outputs: Array<Work_Order_Outputs>;
  /** fetch aggregated fields from the table: "work_order_outputs" */
  work_order_outputs_aggregate: Work_Order_Outputs_Aggregate;
  /** fetch data from the table: "work_order_outputs" using primary key columns */
  work_order_outputs_by_pk?: Maybe<Work_Order_Outputs>;
  /** fetch data from the table in a streaming manner: "work_order_outputs" */
  work_order_outputs_stream: Array<Work_Order_Outputs>;
  /** fetch data from the table: "work_order_requests" */
  work_order_requests: Array<Work_Order_Requests>;
  /** fetch aggregated fields from the table: "work_order_requests" */
  work_order_requests_aggregate: Work_Order_Requests_Aggregate;
  /** fetch data from the table: "work_order_requests" using primary key columns */
  work_order_requests_by_pk?: Maybe<Work_Order_Requests>;
  /** fetch data from the table in a streaming manner: "work_order_requests" */
  work_order_requests_stream: Array<Work_Order_Requests>;
  /** fetch data from the table: "work_order_reviews" */
  work_order_reviews: Array<Work_Order_Reviews>;
  /** fetch aggregated fields from the table: "work_order_reviews" */
  work_order_reviews_aggregate: Work_Order_Reviews_Aggregate;
  /** fetch data from the table: "work_order_reviews" using primary key columns */
  work_order_reviews_by_pk?: Maybe<Work_Order_Reviews>;
  /** fetch data from the table in a streaming manner: "work_order_reviews" */
  work_order_reviews_stream: Array<Work_Order_Reviews>;
  /** An array relationship */
  work_orders: Array<Work_Orders>;
  /** An aggregate relationship */
  work_orders_aggregate: Work_Orders_Aggregate;
  /** fetch data from the table: "work_orders" using primary key columns */
  work_orders_by_pk?: Maybe<Work_Orders>;
  /** fetch data from the table in a streaming manner: "work_orders" */
  work_orders_stream: Array<Work_Orders>;
};


export type Subscription_RootAccount_Auth_KeyArgs = {
  distinct_on?: InputMaybe<Array<Account_Auth_Key_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Auth_Key_Order_By>>;
  where?: InputMaybe<Account_Auth_Key_Bool_Exp>;
};


export type Subscription_RootAccount_Auth_Key_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Auth_Key_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Auth_Key_Order_By>>;
  where?: InputMaybe<Account_Auth_Key_Bool_Exp>;
};


export type Subscription_RootAccount_Auth_Key_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootAccount_Auth_Key_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Account_Auth_Key_Stream_Cursor_Input>>;
  where?: InputMaybe<Account_Auth_Key_Bool_Exp>;
};


export type Subscription_RootAccount_CropArgs = {
  distinct_on?: InputMaybe<Array<Account_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Crop_Order_By>>;
  where?: InputMaybe<Account_Crop_Bool_Exp>;
};


export type Subscription_RootAccount_Crop_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Crop_Order_By>>;
  where?: InputMaybe<Account_Crop_Bool_Exp>;
};


export type Subscription_RootAccount_Crop_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootAccount_Crop_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Account_Crop_Stream_Cursor_Input>>;
  where?: InputMaybe<Account_Crop_Bool_Exp>;
};


export type Subscription_RootAccount_SegmentArgs = {
  distinct_on?: InputMaybe<Array<Account_Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Segment_Order_By>>;
  where?: InputMaybe<Account_Segment_Bool_Exp>;
};


export type Subscription_RootAccount_Segment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Segment_Order_By>>;
  where?: InputMaybe<Account_Segment_Bool_Exp>;
};


export type Subscription_RootAccount_Segment_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootAccount_Segment_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Account_Segment_Stream_Cursor_Input>>;
  where?: InputMaybe<Account_Segment_Bool_Exp>;
};


export type Subscription_RootAccount_UserArgs = {
  distinct_on?: InputMaybe<Array<Account_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_User_Order_By>>;
  where?: InputMaybe<Account_User_Bool_Exp>;
};


export type Subscription_RootAccount_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_User_Order_By>>;
  where?: InputMaybe<Account_User_Bool_Exp>;
};


export type Subscription_RootAccount_User_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootAccount_User_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Account_User_Stream_Cursor_Input>>;
  where?: InputMaybe<Account_User_Bool_Exp>;
};


export type Subscription_RootAccountsArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Accounts_Order_By>>;
  where?: InputMaybe<Accounts_Bool_Exp>;
};


export type Subscription_RootAccounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Accounts_Order_By>>;
  where?: InputMaybe<Accounts_Bool_Exp>;
};


export type Subscription_RootAccounts_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootAccounts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Accounts_Stream_Cursor_Input>>;
  where?: InputMaybe<Accounts_Bool_Exp>;
};


export type Subscription_RootAction_EventsArgs = {
  distinct_on?: InputMaybe<Array<Action_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Events_Order_By>>;
  where?: InputMaybe<Action_Events_Bool_Exp>;
};


export type Subscription_RootAction_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Action_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Events_Order_By>>;
  where?: InputMaybe<Action_Events_Bool_Exp>;
};


export type Subscription_RootAction_Events_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootAction_Events_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Action_Events_Stream_Cursor_Input>>;
  where?: InputMaybe<Action_Events_Bool_Exp>;
};


export type Subscription_RootBalancesArgs = {
  distinct_on?: InputMaybe<Array<Balances_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Balances_Order_By>>;
  where?: InputMaybe<Balances_Bool_Exp>;
};


export type Subscription_RootBalances_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Balances_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Balances_Order_By>>;
  where?: InputMaybe<Balances_Bool_Exp>;
};


export type Subscription_RootBalances_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootBalances_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Balances_Stream_Cursor_Input>>;
  where?: InputMaybe<Balances_Bool_Exp>;
};


export type Subscription_RootChannel_LinksArgs = {
  distinct_on?: InputMaybe<Array<Channel_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Channel_Links_Order_By>>;
  where?: InputMaybe<Channel_Links_Bool_Exp>;
};


export type Subscription_RootChannel_Links_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Channel_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Channel_Links_Order_By>>;
  where?: InputMaybe<Channel_Links_Bool_Exp>;
};


export type Subscription_RootChannel_Links_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootChannel_Links_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Channel_Links_Stream_Cursor_Input>>;
  where?: InputMaybe<Channel_Links_Bool_Exp>;
};


export type Subscription_RootChannelsArgs = {
  distinct_on?: InputMaybe<Array<Channels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Channels_Order_By>>;
  where?: InputMaybe<Channels_Bool_Exp>;
};


export type Subscription_RootChannels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Channels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Channels_Order_By>>;
  where?: InputMaybe<Channels_Bool_Exp>;
};


export type Subscription_RootChannels_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootChannels_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Channels_Stream_Cursor_Input>>;
  where?: InputMaybe<Channels_Bool_Exp>;
};


export type Subscription_RootChat_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Chat_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Messages_Order_By>>;
  where?: InputMaybe<Chat_Messages_Bool_Exp>;
};


export type Subscription_RootChat_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Messages_Order_By>>;
  where?: InputMaybe<Chat_Messages_Bool_Exp>;
};


export type Subscription_RootChat_Messages_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootChat_Messages_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Chat_Messages_Stream_Cursor_Input>>;
  where?: InputMaybe<Chat_Messages_Bool_Exp>;
};


export type Subscription_RootChat_ParticipantsArgs = {
  distinct_on?: InputMaybe<Array<Chat_Participants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Participants_Order_By>>;
  where?: InputMaybe<Chat_Participants_Bool_Exp>;
};


export type Subscription_RootChat_Participants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Participants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Participants_Order_By>>;
  where?: InputMaybe<Chat_Participants_Bool_Exp>;
};


export type Subscription_RootChat_Participants_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootChat_Participants_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Chat_Participants_Stream_Cursor_Input>>;
  where?: InputMaybe<Chat_Participants_Bool_Exp>;
};


export type Subscription_RootChat_ThreadsArgs = {
  distinct_on?: InputMaybe<Array<Chat_Threads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Threads_Order_By>>;
  where?: InputMaybe<Chat_Threads_Bool_Exp>;
};


export type Subscription_RootChat_Threads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Threads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Threads_Order_By>>;
  where?: InputMaybe<Chat_Threads_Bool_Exp>;
};


export type Subscription_RootChat_Threads_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootChat_Threads_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Chat_Threads_Stream_Cursor_Input>>;
  where?: InputMaybe<Chat_Threads_Bool_Exp>;
};


export type Subscription_RootCompaniesArgs = {
  distinct_on?: InputMaybe<Array<Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Companies_Order_By>>;
  where?: InputMaybe<Companies_Bool_Exp>;
};


export type Subscription_RootCompanies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Companies_Order_By>>;
  where?: InputMaybe<Companies_Bool_Exp>;
};


export type Subscription_RootCompanies_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootCompanies_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Companies_Stream_Cursor_Input>>;
  where?: InputMaybe<Companies_Bool_Exp>;
};


export type Subscription_RootCreator_OnboardingArgs = {
  distinct_on?: InputMaybe<Array<Creator_Onboarding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Creator_Onboarding_Order_By>>;
  where?: InputMaybe<Creator_Onboarding_Bool_Exp>;
};


export type Subscription_RootCreator_Onboarding_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Creator_Onboarding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Creator_Onboarding_Order_By>>;
  where?: InputMaybe<Creator_Onboarding_Bool_Exp>;
};


export type Subscription_RootCreator_Onboarding_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootCreator_Onboarding_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Creator_Onboarding_Stream_Cursor_Input>>;
  where?: InputMaybe<Creator_Onboarding_Bool_Exp>;
};


export type Subscription_RootCrm_Account_Channel_Crop_ProspectsArgs = {
  distinct_on?: InputMaybe<Array<Crm_Account_Channel_Crop_Prospects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Account_Channel_Crop_Prospects_Order_By>>;
  where?: InputMaybe<Crm_Account_Channel_Crop_Prospects_Bool_Exp>;
};


export type Subscription_RootCrm_Account_Channel_Crop_Prospects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crm_Account_Channel_Crop_Prospects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Account_Channel_Crop_Prospects_Order_By>>;
  where?: InputMaybe<Crm_Account_Channel_Crop_Prospects_Bool_Exp>;
};


export type Subscription_RootCrm_Account_Channel_Crop_Prospects_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Crm_Account_Channel_Crop_Prospects_Stream_Cursor_Input>>;
  where?: InputMaybe<Crm_Account_Channel_Crop_Prospects_Bool_Exp>;
};


export type Subscription_RootCrm_Account_Crop_Wise_CountsArgs = {
  distinct_on?: InputMaybe<Array<Crm_Account_Crop_Wise_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Account_Crop_Wise_Counts_Order_By>>;
  where?: InputMaybe<Crm_Account_Crop_Wise_Counts_Bool_Exp>;
};


export type Subscription_RootCrm_Account_Crop_Wise_Counts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crm_Account_Crop_Wise_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Account_Crop_Wise_Counts_Order_By>>;
  where?: InputMaybe<Crm_Account_Crop_Wise_Counts_Bool_Exp>;
};


export type Subscription_RootCrm_Account_Crop_Wise_Counts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Crm_Account_Crop_Wise_Counts_Stream_Cursor_Input>>;
  where?: InputMaybe<Crm_Account_Crop_Wise_Counts_Bool_Exp>;
};


export type Subscription_RootCrm_Account_Interaction_Type_Pending_CountsArgs = {
  distinct_on?: InputMaybe<Array<Crm_Account_Interaction_Type_Pending_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Account_Interaction_Type_Pending_Counts_Order_By>>;
  where?: InputMaybe<Crm_Account_Interaction_Type_Pending_Counts_Bool_Exp>;
};


export type Subscription_RootCrm_Account_Interaction_Type_Pending_Counts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crm_Account_Interaction_Type_Pending_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Account_Interaction_Type_Pending_Counts_Order_By>>;
  where?: InputMaybe<Crm_Account_Interaction_Type_Pending_Counts_Bool_Exp>;
};


export type Subscription_RootCrm_Account_Interaction_Type_Pending_Counts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Crm_Account_Interaction_Type_Pending_Counts_Stream_Cursor_Input>>;
  where?: InputMaybe<Crm_Account_Interaction_Type_Pending_Counts_Bool_Exp>;
};


export type Subscription_RootCrm_SegmentsArgs = {
  distinct_on?: InputMaybe<Array<Crm_Segments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Segments_Order_By>>;
  where?: InputMaybe<Crm_Segments_Bool_Exp>;
};


export type Subscription_RootCrm_Segments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crm_Segments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Segments_Order_By>>;
  where?: InputMaybe<Crm_Segments_Bool_Exp>;
};


export type Subscription_RootCrm_Segments_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootCrm_Segments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Crm_Segments_Stream_Cursor_Input>>;
  where?: InputMaybe<Crm_Segments_Bool_Exp>;
};


export type Subscription_RootCrop_UserArgs = {
  distinct_on?: InputMaybe<Array<Crop_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crop_User_Order_By>>;
  where?: InputMaybe<Crop_User_Bool_Exp>;
};


export type Subscription_RootCrop_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crop_User_Order_By>>;
  where?: InputMaybe<Crop_User_Bool_Exp>;
};


export type Subscription_RootCrop_User_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootCrop_User_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Crop_User_Stream_Cursor_Input>>;
  where?: InputMaybe<Crop_User_Bool_Exp>;
};


export type Subscription_RootFailed_JobsArgs = {
  distinct_on?: InputMaybe<Array<Failed_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Failed_Jobs_Order_By>>;
  where?: InputMaybe<Failed_Jobs_Bool_Exp>;
};


export type Subscription_RootFailed_Jobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Failed_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Failed_Jobs_Order_By>>;
  where?: InputMaybe<Failed_Jobs_Bool_Exp>;
};


export type Subscription_RootFailed_Jobs_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootFailed_Jobs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Failed_Jobs_Stream_Cursor_Input>>;
  where?: InputMaybe<Failed_Jobs_Bool_Exp>;
};


export type Subscription_RootFarmer_Account_LocationsArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Account_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Account_Locations_Order_By>>;
  where?: InputMaybe<Farmer_Account_Locations_Bool_Exp>;
};


export type Subscription_RootFarmer_Account_Locations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Account_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Account_Locations_Order_By>>;
  where?: InputMaybe<Farmer_Account_Locations_Bool_Exp>;
};


export type Subscription_RootFarmer_Account_Locations_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootFarmer_Account_Locations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Farmer_Account_Locations_Stream_Cursor_Input>>;
  where?: InputMaybe<Farmer_Account_Locations_Bool_Exp>;
};


export type Subscription_RootFarmer_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Accounts_Order_By>>;
  where?: InputMaybe<Farmer_Accounts_Bool_Exp>;
};


export type Subscription_RootFarmer_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Accounts_Order_By>>;
  where?: InputMaybe<Farmer_Accounts_Bool_Exp>;
};


export type Subscription_RootFarmer_Accounts_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootFarmer_Accounts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Farmer_Accounts_Stream_Cursor_Input>>;
  where?: InputMaybe<Farmer_Accounts_Bool_Exp>;
};


export type Subscription_RootFarmer_ActionsArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Actions_Order_By>>;
  where?: InputMaybe<Farmer_Actions_Bool_Exp>;
};


export type Subscription_RootFarmer_Actions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Actions_Order_By>>;
  where?: InputMaybe<Farmer_Actions_Bool_Exp>;
};


export type Subscription_RootFarmer_Actions_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootFarmer_Actions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Farmer_Actions_Stream_Cursor_Input>>;
  where?: InputMaybe<Farmer_Actions_Bool_Exp>;
};


export type Subscription_RootFarmer_FieldsArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Fields_Order_By>>;
  where?: InputMaybe<Farmer_Fields_Bool_Exp>;
};


export type Subscription_RootFarmer_Fields_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Fields_Order_By>>;
  where?: InputMaybe<Farmer_Fields_Bool_Exp>;
};


export type Subscription_RootFarmer_Fields_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootFarmer_Fields_LatestArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Fields_Latest_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Fields_Latest_Order_By>>;
  where?: InputMaybe<Farmer_Fields_Latest_Bool_Exp>;
};


export type Subscription_RootFarmer_Fields_Latest_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Fields_Latest_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Fields_Latest_Order_By>>;
  where?: InputMaybe<Farmer_Fields_Latest_Bool_Exp>;
};


export type Subscription_RootFarmer_Fields_Latest_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Farmer_Fields_Latest_Stream_Cursor_Input>>;
  where?: InputMaybe<Farmer_Fields_Latest_Bool_Exp>;
};


export type Subscription_RootFarmer_Fields_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Farmer_Fields_Stream_Cursor_Input>>;
  where?: InputMaybe<Farmer_Fields_Bool_Exp>;
};


export type Subscription_RootFarmer_MasterArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Master_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Master_Order_By>>;
  where?: InputMaybe<Farmer_Master_Bool_Exp>;
};


export type Subscription_RootFarmer_Master_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Master_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Master_Order_By>>;
  where?: InputMaybe<Farmer_Master_Bool_Exp>;
};


export type Subscription_RootFarmer_Master_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootFarmer_Master_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Farmer_Master_Stream_Cursor_Input>>;
  where?: InputMaybe<Farmer_Master_Bool_Exp>;
};


export type Subscription_RootFarmer_Nearby_Field_ForceArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Nearby_Field_Force_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Nearby_Field_Force_Order_By>>;
  where?: InputMaybe<Farmer_Nearby_Field_Force_Bool_Exp>;
};


export type Subscription_RootFarmer_Nearby_Field_Force_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Nearby_Field_Force_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Nearby_Field_Force_Order_By>>;
  where?: InputMaybe<Farmer_Nearby_Field_Force_Bool_Exp>;
};


export type Subscription_RootFarmer_Nearby_Field_Force_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootFarmer_Nearby_Field_Force_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Farmer_Nearby_Field_Force_Stream_Cursor_Input>>;
  where?: InputMaybe<Farmer_Nearby_Field_Force_Bool_Exp>;
};


export type Subscription_RootFarmer_PlotsArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Plots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Plots_Order_By>>;
  where?: InputMaybe<Farmer_Plots_Bool_Exp>;
};


export type Subscription_RootFarmer_Plots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Plots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Plots_Order_By>>;
  where?: InputMaybe<Farmer_Plots_Bool_Exp>;
};


export type Subscription_RootFarmer_Plots_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootFarmer_Plots_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Farmer_Plots_Stream_Cursor_Input>>;
  where?: InputMaybe<Farmer_Plots_Bool_Exp>;
};


export type Subscription_RootFarminsta_LinksArgs = {
  distinct_on?: InputMaybe<Array<Farminsta_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farminsta_Links_Order_By>>;
  where?: InputMaybe<Farminsta_Links_Bool_Exp>;
};


export type Subscription_RootFarminsta_Links_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farminsta_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farminsta_Links_Order_By>>;
  where?: InputMaybe<Farminsta_Links_Bool_Exp>;
};


export type Subscription_RootFarminsta_Links_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootFarminsta_Links_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Farminsta_Links_Stream_Cursor_Input>>;
  where?: InputMaybe<Farminsta_Links_Bool_Exp>;
};


export type Subscription_RootFeaturesArgs = {
  distinct_on?: InputMaybe<Array<Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Features_Order_By>>;
  where?: InputMaybe<Features_Bool_Exp>;
};


export type Subscription_RootFeatures_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Features_Order_By>>;
  where?: InputMaybe<Features_Bool_Exp>;
};


export type Subscription_RootFeatures_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootFeatures_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Features_Stream_Cursor_Input>>;
  where?: InputMaybe<Features_Bool_Exp>;
};


export type Subscription_RootFich_Farminsta_Replica_Channel_AnalyticsArgs = {
  distinct_on?: InputMaybe<Array<Fich_Farminsta_Replica_Channel_Analytics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fich_Farminsta_Replica_Channel_Analytics_Order_By>>;
  where?: InputMaybe<Fich_Farminsta_Replica_Channel_Analytics_Bool_Exp>;
};


export type Subscription_RootFich_Farminsta_Replica_Channel_Analytics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fich_Farminsta_Replica_Channel_Analytics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fich_Farminsta_Replica_Channel_Analytics_Order_By>>;
  where?: InputMaybe<Fich_Farminsta_Replica_Channel_Analytics_Bool_Exp>;
};


export type Subscription_RootFich_Farminsta_Replica_Channel_Analytics_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Fich_Farminsta_Replica_Channel_Analytics_Stream_Cursor_Input>>;
  where?: InputMaybe<Fich_Farminsta_Replica_Channel_Analytics_Bool_Exp>;
};


export type Subscription_RootFich_Farminsta_Replica_LeadsArgs = {
  distinct_on?: InputMaybe<Array<Fich_Farminsta_Replica_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fich_Farminsta_Replica_Leads_Order_By>>;
  where?: InputMaybe<Fich_Farminsta_Replica_Leads_Bool_Exp>;
};


export type Subscription_RootFich_Farminsta_Replica_Leads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fich_Farminsta_Replica_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fich_Farminsta_Replica_Leads_Order_By>>;
  where?: InputMaybe<Fich_Farminsta_Replica_Leads_Bool_Exp>;
};


export type Subscription_RootFich_Farminsta_Replica_Leads_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Fich_Farminsta_Replica_Leads_Stream_Cursor_Input>>;
  where?: InputMaybe<Fich_Farminsta_Replica_Leads_Bool_Exp>;
};


export type Subscription_RootFich_Farminsta_Replica_Reel_Lead_InfoArgs = {
  distinct_on?: InputMaybe<Array<Fich_Farminsta_Replica_Reel_Lead_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fich_Farminsta_Replica_Reel_Lead_Info_Order_By>>;
  where?: InputMaybe<Fich_Farminsta_Replica_Reel_Lead_Info_Bool_Exp>;
};


export type Subscription_RootFich_Farminsta_Replica_Reel_Lead_Info_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fich_Farminsta_Replica_Reel_Lead_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fich_Farminsta_Replica_Reel_Lead_Info_Order_By>>;
  where?: InputMaybe<Fich_Farminsta_Replica_Reel_Lead_Info_Bool_Exp>;
};


export type Subscription_RootFich_Farminsta_Replica_Reel_Lead_Info_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Fich_Farminsta_Replica_Reel_Lead_Info_Stream_Cursor_Input>>;
  where?: InputMaybe<Fich_Farminsta_Replica_Reel_Lead_Info_Bool_Exp>;
};


export type Subscription_RootFich_Farminsta_Replica_Reels_FlatArgs = {
  distinct_on?: InputMaybe<Array<Fich_Farminsta_Replica_Reels_Flat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fich_Farminsta_Replica_Reels_Flat_Order_By>>;
  where?: InputMaybe<Fich_Farminsta_Replica_Reels_Flat_Bool_Exp>;
};


export type Subscription_RootFich_Farminsta_Replica_Reels_Flat_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fich_Farminsta_Replica_Reels_Flat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fich_Farminsta_Replica_Reels_Flat_Order_By>>;
  where?: InputMaybe<Fich_Farminsta_Replica_Reels_Flat_Bool_Exp>;
};


export type Subscription_RootFich_Farminsta_Replica_Reels_Flat_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Fich_Farminsta_Replica_Reels_Flat_Stream_Cursor_Input>>;
  where?: InputMaybe<Fich_Farminsta_Replica_Reels_Flat_Bool_Exp>;
};


export type Subscription_RootField_Partner_Response_EventsArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Response_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Response_Events_Order_By>>;
  where?: InputMaybe<Field_Partner_Response_Events_Bool_Exp>;
};


export type Subscription_RootField_Partner_Response_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Response_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Response_Events_Order_By>>;
  where?: InputMaybe<Field_Partner_Response_Events_Bool_Exp>;
};


export type Subscription_RootField_Partner_Response_Events_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootField_Partner_Response_Events_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Field_Partner_Response_Events_Stream_Cursor_Input>>;
  where?: InputMaybe<Field_Partner_Response_Events_Bool_Exp>;
};


export type Subscription_RootField_Partner_Response_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Response_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Response_Messages_Order_By>>;
  where?: InputMaybe<Field_Partner_Response_Messages_Bool_Exp>;
};


export type Subscription_RootField_Partner_Response_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Response_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Response_Messages_Order_By>>;
  where?: InputMaybe<Field_Partner_Response_Messages_Bool_Exp>;
};


export type Subscription_RootField_Partner_Response_Messages_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootField_Partner_Response_Messages_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Field_Partner_Response_Messages_Stream_Cursor_Input>>;
  where?: InputMaybe<Field_Partner_Response_Messages_Bool_Exp>;
};


export type Subscription_RootField_Partner_ResponsesArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Responses_Order_By>>;
  where?: InputMaybe<Field_Partner_Responses_Bool_Exp>;
};


export type Subscription_RootField_Partner_Responses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Responses_Order_By>>;
  where?: InputMaybe<Field_Partner_Responses_Bool_Exp>;
};


export type Subscription_RootField_Partner_Responses_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootField_Partner_Responses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Field_Partner_Responses_Stream_Cursor_Input>>;
  where?: InputMaybe<Field_Partner_Responses_Bool_Exp>;
};


export type Subscription_RootField_Scheduled_VisitsArgs = {
  distinct_on?: InputMaybe<Array<Field_Scheduled_Visits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Scheduled_Visits_Order_By>>;
  where?: InputMaybe<Field_Scheduled_Visits_Bool_Exp>;
};


export type Subscription_RootField_Scheduled_Visits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Scheduled_Visits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Scheduled_Visits_Order_By>>;
  where?: InputMaybe<Field_Scheduled_Visits_Bool_Exp>;
};


export type Subscription_RootField_Scheduled_Visits_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootField_Scheduled_Visits_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Field_Scheduled_Visits_Stream_Cursor_Input>>;
  where?: InputMaybe<Field_Scheduled_Visits_Bool_Exp>;
};


export type Subscription_RootFo_Reels_StagingArgs = {
  distinct_on?: InputMaybe<Array<Fo_Reels_Staging_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fo_Reels_Staging_Order_By>>;
  where?: InputMaybe<Fo_Reels_Staging_Bool_Exp>;
};


export type Subscription_RootFo_Reels_Staging_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fo_Reels_Staging_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fo_Reels_Staging_Order_By>>;
  where?: InputMaybe<Fo_Reels_Staging_Bool_Exp>;
};


export type Subscription_RootFo_Reels_Staging_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootFo_Reels_Staging_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Fo_Reels_Staging_Stream_Cursor_Input>>;
  where?: InputMaybe<Fo_Reels_Staging_Bool_Exp>;
};


export type Subscription_RootFollowsArgs = {
  distinct_on?: InputMaybe<Array<Follows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Follows_Order_By>>;
  where?: InputMaybe<Follows_Bool_Exp>;
};


export type Subscription_RootFollows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Follows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Follows_Order_By>>;
  where?: InputMaybe<Follows_Bool_Exp>;
};


export type Subscription_RootFollows_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootFollows_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Follows_Stream_Cursor_Input>>;
  where?: InputMaybe<Follows_Bool_Exp>;
};


export type Subscription_RootGeography_ColumnsArgs = {
  distinct_on?: InputMaybe<Array<Geography_Columns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Geography_Columns_Order_By>>;
  where?: InputMaybe<Geography_Columns_Bool_Exp>;
};


export type Subscription_RootGeography_Columns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Geography_Columns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Geography_Columns_Order_By>>;
  where?: InputMaybe<Geography_Columns_Bool_Exp>;
};


export type Subscription_RootGeography_Columns_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Geography_Columns_Stream_Cursor_Input>>;
  where?: InputMaybe<Geography_Columns_Bool_Exp>;
};


export type Subscription_RootGeometry_ColumnsArgs = {
  distinct_on?: InputMaybe<Array<Geometry_Columns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Geometry_Columns_Order_By>>;
  where?: InputMaybe<Geometry_Columns_Bool_Exp>;
};


export type Subscription_RootGeometry_Columns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Geometry_Columns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Geometry_Columns_Order_By>>;
  where?: InputMaybe<Geometry_Columns_Bool_Exp>;
};


export type Subscription_RootGeometry_Columns_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Geometry_Columns_Stream_Cursor_Input>>;
  where?: InputMaybe<Geometry_Columns_Bool_Exp>;
};


export type Subscription_RootGet_Reel_With_RelatedArgs = {
  args: Get_Reel_With_Related_Args;
  distinct_on?: InputMaybe<Array<Reels_With_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reels_With_Distance_Order_By>>;
  where?: InputMaybe<Reels_With_Distance_Bool_Exp>;
};


export type Subscription_RootGet_Reel_With_Related_AggregateArgs = {
  args: Get_Reel_With_Related_Args;
  distinct_on?: InputMaybe<Array<Reels_With_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reels_With_Distance_Order_By>>;
  where?: InputMaybe<Reels_With_Distance_Bool_Exp>;
};


export type Subscription_RootGet_ReelsArgs = {
  args: Get_Reels_Args;
  distinct_on?: InputMaybe<Array<Reels_With_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reels_With_Distance_Order_By>>;
  where?: InputMaybe<Reels_With_Distance_Bool_Exp>;
};


export type Subscription_RootGet_Reels_AggregateArgs = {
  args: Get_Reels_Args;
  distinct_on?: InputMaybe<Array<Reels_With_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reels_With_Distance_Order_By>>;
  where?: InputMaybe<Reels_With_Distance_Bool_Exp>;
};


export type Subscription_RootGig_FaqsArgs = {
  distinct_on?: InputMaybe<Array<Gig_Faqs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gig_Faqs_Order_By>>;
  where?: InputMaybe<Gig_Faqs_Bool_Exp>;
};


export type Subscription_RootGig_Faqs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gig_Faqs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gig_Faqs_Order_By>>;
  where?: InputMaybe<Gig_Faqs_Bool_Exp>;
};


export type Subscription_RootGig_Faqs_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootGig_Faqs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Gig_Faqs_Stream_Cursor_Input>>;
  where?: InputMaybe<Gig_Faqs_Bool_Exp>;
};


export type Subscription_RootGig_PromosArgs = {
  distinct_on?: InputMaybe<Array<Gig_Promos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gig_Promos_Order_By>>;
  where?: InputMaybe<Gig_Promos_Bool_Exp>;
};


export type Subscription_RootGig_Promos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gig_Promos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gig_Promos_Order_By>>;
  where?: InputMaybe<Gig_Promos_Bool_Exp>;
};


export type Subscription_RootGig_Promos_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootGig_Promos_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Gig_Promos_Stream_Cursor_Input>>;
  where?: InputMaybe<Gig_Promos_Bool_Exp>;
};


export type Subscription_RootGig_VariantsArgs = {
  distinct_on?: InputMaybe<Array<Gig_Variants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gig_Variants_Order_By>>;
  where?: InputMaybe<Gig_Variants_Bool_Exp>;
};


export type Subscription_RootGig_Variants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gig_Variants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gig_Variants_Order_By>>;
  where?: InputMaybe<Gig_Variants_Bool_Exp>;
};


export type Subscription_RootGig_Variants_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootGig_Variants_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Gig_Variants_Stream_Cursor_Input>>;
  where?: InputMaybe<Gig_Variants_Bool_Exp>;
};


export type Subscription_RootGigsArgs = {
  distinct_on?: InputMaybe<Array<Gigs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gigs_Order_By>>;
  where?: InputMaybe<Gigs_Bool_Exp>;
};


export type Subscription_RootGigs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gigs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gigs_Order_By>>;
  where?: InputMaybe<Gigs_Bool_Exp>;
};


export type Subscription_RootGigs_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootGigs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Gigs_Stream_Cursor_Input>>;
  where?: InputMaybe<Gigs_Bool_Exp>;
};


export type Subscription_RootGis_DistrictsArgs = {
  distinct_on?: InputMaybe<Array<Gis_Districts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gis_Districts_Order_By>>;
  where?: InputMaybe<Gis_Districts_Bool_Exp>;
};


export type Subscription_RootGis_Districts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gis_Districts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gis_Districts_Order_By>>;
  where?: InputMaybe<Gis_Districts_Bool_Exp>;
};


export type Subscription_RootGis_Districts_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootGis_Districts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Gis_Districts_Stream_Cursor_Input>>;
  where?: InputMaybe<Gis_Districts_Bool_Exp>;
};


export type Subscription_RootGis_StatesArgs = {
  distinct_on?: InputMaybe<Array<Gis_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gis_States_Order_By>>;
  where?: InputMaybe<Gis_States_Bool_Exp>;
};


export type Subscription_RootGis_States_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gis_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gis_States_Order_By>>;
  where?: InputMaybe<Gis_States_Bool_Exp>;
};


export type Subscription_RootGis_States_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootGis_States_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Gis_States_Stream_Cursor_Input>>;
  where?: InputMaybe<Gis_States_Bool_Exp>;
};


export type Subscription_RootLast_Known_LocationsArgs = {
  distinct_on?: InputMaybe<Array<Last_Known_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Last_Known_Locations_Order_By>>;
  where?: InputMaybe<Last_Known_Locations_Bool_Exp>;
};


export type Subscription_RootLast_Known_Locations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Last_Known_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Last_Known_Locations_Order_By>>;
  where?: InputMaybe<Last_Known_Locations_Bool_Exp>;
};


export type Subscription_RootLast_Known_Locations_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootLast_Known_Locations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Last_Known_Locations_Stream_Cursor_Input>>;
  where?: InputMaybe<Last_Known_Locations_Bool_Exp>;
};


export type Subscription_RootMaster_CropsArgs = {
  distinct_on?: InputMaybe<Array<Master_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Crops_Order_By>>;
  where?: InputMaybe<Master_Crops_Bool_Exp>;
};


export type Subscription_RootMaster_Crops_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Master_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Crops_Order_By>>;
  where?: InputMaybe<Master_Crops_Bool_Exp>;
};


export type Subscription_RootMaster_Crops_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootMaster_Crops_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Master_Crops_Stream_Cursor_Input>>;
  where?: InputMaybe<Master_Crops_Bool_Exp>;
};


export type Subscription_RootMaster_SegmentsArgs = {
  distinct_on?: InputMaybe<Array<Master_Segments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Segments_Order_By>>;
  where?: InputMaybe<Master_Segments_Bool_Exp>;
};


export type Subscription_RootMaster_Segments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Master_Segments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Segments_Order_By>>;
  where?: InputMaybe<Master_Segments_Bool_Exp>;
};


export type Subscription_RootMaster_Segments_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootMaster_Segments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Master_Segments_Stream_Cursor_Input>>;
  where?: InputMaybe<Master_Segments_Bool_Exp>;
};


export type Subscription_RootMessaging_Campaign_RecipientsArgs = {
  distinct_on?: InputMaybe<Array<Messaging_Campaign_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messaging_Campaign_Recipients_Order_By>>;
  where?: InputMaybe<Messaging_Campaign_Recipients_Bool_Exp>;
};


export type Subscription_RootMessaging_Campaign_Recipients_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Messaging_Campaign_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messaging_Campaign_Recipients_Order_By>>;
  where?: InputMaybe<Messaging_Campaign_Recipients_Bool_Exp>;
};


export type Subscription_RootMessaging_Campaign_Recipients_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootMessaging_Campaign_Recipients_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Messaging_Campaign_Recipients_Stream_Cursor_Input>>;
  where?: InputMaybe<Messaging_Campaign_Recipients_Bool_Exp>;
};


export type Subscription_RootMessaging_Campaign_SegmentsArgs = {
  distinct_on?: InputMaybe<Array<Messaging_Campaign_Segments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messaging_Campaign_Segments_Order_By>>;
  where?: InputMaybe<Messaging_Campaign_Segments_Bool_Exp>;
};


export type Subscription_RootMessaging_Campaign_Segments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Messaging_Campaign_Segments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messaging_Campaign_Segments_Order_By>>;
  where?: InputMaybe<Messaging_Campaign_Segments_Bool_Exp>;
};


export type Subscription_RootMessaging_Campaign_Segments_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootMessaging_Campaign_Segments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Messaging_Campaign_Segments_Stream_Cursor_Input>>;
  where?: InputMaybe<Messaging_Campaign_Segments_Bool_Exp>;
};


export type Subscription_RootMessaging_CampaignsArgs = {
  distinct_on?: InputMaybe<Array<Messaging_Campaigns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messaging_Campaigns_Order_By>>;
  where?: InputMaybe<Messaging_Campaigns_Bool_Exp>;
};


export type Subscription_RootMessaging_Campaigns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Messaging_Campaigns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messaging_Campaigns_Order_By>>;
  where?: InputMaybe<Messaging_Campaigns_Bool_Exp>;
};


export type Subscription_RootMessaging_Campaigns_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootMessaging_Campaigns_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Messaging_Campaigns_Stream_Cursor_Input>>;
  where?: InputMaybe<Messaging_Campaigns_Bool_Exp>;
};


export type Subscription_RootMessaging_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Messaging_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messaging_Templates_Order_By>>;
  where?: InputMaybe<Messaging_Templates_Bool_Exp>;
};


export type Subscription_RootMessaging_Templates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Messaging_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messaging_Templates_Order_By>>;
  where?: InputMaybe<Messaging_Templates_Bool_Exp>;
};


export type Subscription_RootMessaging_Templates_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootMessaging_Templates_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Messaging_Templates_Stream_Cursor_Input>>;
  where?: InputMaybe<Messaging_Templates_Bool_Exp>;
};


export type Subscription_RootMigrationsArgs = {
  distinct_on?: InputMaybe<Array<Migrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Migrations_Order_By>>;
  where?: InputMaybe<Migrations_Bool_Exp>;
};


export type Subscription_RootMigrations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Migrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Migrations_Order_By>>;
  where?: InputMaybe<Migrations_Bool_Exp>;
};


export type Subscription_RootMigrations_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootMigrations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Migrations_Stream_Cursor_Input>>;
  where?: InputMaybe<Migrations_Bool_Exp>;
};


export type Subscription_RootMissed_Call_Number_PoolArgs = {
  distinct_on?: InputMaybe<Array<Missed_Call_Number_Pool_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Missed_Call_Number_Pool_Order_By>>;
  where?: InputMaybe<Missed_Call_Number_Pool_Bool_Exp>;
};


export type Subscription_RootMissed_Call_Number_Pool_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Missed_Call_Number_Pool_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Missed_Call_Number_Pool_Order_By>>;
  where?: InputMaybe<Missed_Call_Number_Pool_Bool_Exp>;
};


export type Subscription_RootMissed_Call_Number_Pool_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootMissed_Call_Number_Pool_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Missed_Call_Number_Pool_Stream_Cursor_Input>>;
  where?: InputMaybe<Missed_Call_Number_Pool_Bool_Exp>;
};


export type Subscription_RootMissed_CallsArgs = {
  distinct_on?: InputMaybe<Array<Missed_Calls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Missed_Calls_Order_By>>;
  where?: InputMaybe<Missed_Calls_Bool_Exp>;
};


export type Subscription_RootMissed_Calls_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Missed_Calls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Missed_Calls_Order_By>>;
  where?: InputMaybe<Missed_Calls_Bool_Exp>;
};


export type Subscription_RootMissed_Calls_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootMissed_Calls_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Missed_Calls_Stream_Cursor_Input>>;
  where?: InputMaybe<Missed_Calls_Bool_Exp>;
};


export type Subscription_RootModel_Has_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Model_Has_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Has_Permissions_Order_By>>;
  where?: InputMaybe<Model_Has_Permissions_Bool_Exp>;
};


export type Subscription_RootModel_Has_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Model_Has_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Has_Permissions_Order_By>>;
  where?: InputMaybe<Model_Has_Permissions_Bool_Exp>;
};


export type Subscription_RootModel_Has_Permissions_By_PkArgs = {
  model_id: Scalars['String']['input'];
  model_type: Scalars['String']['input'];
  permission_id: Scalars['bigint']['input'];
};


export type Subscription_RootModel_Has_Permissions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Model_Has_Permissions_Stream_Cursor_Input>>;
  where?: InputMaybe<Model_Has_Permissions_Bool_Exp>;
};


export type Subscription_RootModel_Has_RolesArgs = {
  distinct_on?: InputMaybe<Array<Model_Has_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Has_Roles_Order_By>>;
  where?: InputMaybe<Model_Has_Roles_Bool_Exp>;
};


export type Subscription_RootModel_Has_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Model_Has_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Has_Roles_Order_By>>;
  where?: InputMaybe<Model_Has_Roles_Bool_Exp>;
};


export type Subscription_RootModel_Has_Roles_By_PkArgs = {
  model_id: Scalars['String']['input'];
  model_type: Scalars['String']['input'];
  role_id: Scalars['bigint']['input'];
};


export type Subscription_RootModel_Has_Roles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Model_Has_Roles_Stream_Cursor_Input>>;
  where?: InputMaybe<Model_Has_Roles_Bool_Exp>;
};


export type Subscription_RootNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Subscription_RootNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Subscription_RootNotifications_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootNotifications_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Notifications_Stream_Cursor_Input>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Subscription_RootNova_Field_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Nova_Field_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nova_Field_Attachments_Order_By>>;
  where?: InputMaybe<Nova_Field_Attachments_Bool_Exp>;
};


export type Subscription_RootNova_Field_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nova_Field_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nova_Field_Attachments_Order_By>>;
  where?: InputMaybe<Nova_Field_Attachments_Bool_Exp>;
};


export type Subscription_RootNova_Field_Attachments_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootNova_Field_Attachments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Nova_Field_Attachments_Stream_Cursor_Input>>;
  where?: InputMaybe<Nova_Field_Attachments_Bool_Exp>;
};


export type Subscription_RootNova_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Nova_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nova_Notifications_Order_By>>;
  where?: InputMaybe<Nova_Notifications_Bool_Exp>;
};


export type Subscription_RootNova_Notifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nova_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nova_Notifications_Order_By>>;
  where?: InputMaybe<Nova_Notifications_Bool_Exp>;
};


export type Subscription_RootNova_Notifications_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootNova_Notifications_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Nova_Notifications_Stream_Cursor_Input>>;
  where?: InputMaybe<Nova_Notifications_Bool_Exp>;
};


export type Subscription_RootNova_Pending_Field_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Nova_Pending_Field_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nova_Pending_Field_Attachments_Order_By>>;
  where?: InputMaybe<Nova_Pending_Field_Attachments_Bool_Exp>;
};


export type Subscription_RootNova_Pending_Field_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nova_Pending_Field_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nova_Pending_Field_Attachments_Order_By>>;
  where?: InputMaybe<Nova_Pending_Field_Attachments_Bool_Exp>;
};


export type Subscription_RootNova_Pending_Field_Attachments_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootNova_Pending_Field_Attachments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Nova_Pending_Field_Attachments_Stream_Cursor_Input>>;
  where?: InputMaybe<Nova_Pending_Field_Attachments_Bool_Exp>;
};


export type Subscription_RootNova_TwofaArgs = {
  distinct_on?: InputMaybe<Array<Nova_Twofa_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nova_Twofa_Order_By>>;
  where?: InputMaybe<Nova_Twofa_Bool_Exp>;
};


export type Subscription_RootNova_Twofa_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nova_Twofa_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nova_Twofa_Order_By>>;
  where?: InputMaybe<Nova_Twofa_Bool_Exp>;
};


export type Subscription_RootNova_Twofa_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootNova_Twofa_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Nova_Twofa_Stream_Cursor_Input>>;
  where?: InputMaybe<Nova_Twofa_Bool_Exp>;
};


export type Subscription_RootPairing_CodesArgs = {
  distinct_on?: InputMaybe<Array<Pairing_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pairing_Codes_Order_By>>;
  where?: InputMaybe<Pairing_Codes_Bool_Exp>;
};


export type Subscription_RootPairing_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pairing_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pairing_Codes_Order_By>>;
  where?: InputMaybe<Pairing_Codes_Bool_Exp>;
};


export type Subscription_RootPairing_Codes_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootPairing_Codes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Pairing_Codes_Stream_Cursor_Input>>;
  where?: InputMaybe<Pairing_Codes_Bool_Exp>;
};


export type Subscription_RootPassword_Reset_TokensArgs = {
  distinct_on?: InputMaybe<Array<Password_Reset_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Password_Reset_Tokens_Order_By>>;
  where?: InputMaybe<Password_Reset_Tokens_Bool_Exp>;
};


export type Subscription_RootPassword_Reset_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Password_Reset_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Password_Reset_Tokens_Order_By>>;
  where?: InputMaybe<Password_Reset_Tokens_Bool_Exp>;
};


export type Subscription_RootPassword_Reset_Tokens_By_PkArgs = {
  email: Scalars['String']['input'];
};


export type Subscription_RootPassword_Reset_Tokens_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Password_Reset_Tokens_Stream_Cursor_Input>>;
  where?: InputMaybe<Password_Reset_Tokens_Bool_Exp>;
};


export type Subscription_RootPermissionsArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissions_Order_By>>;
  where?: InputMaybe<Permissions_Bool_Exp>;
};


export type Subscription_RootPermissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissions_Order_By>>;
  where?: InputMaybe<Permissions_Bool_Exp>;
};


export type Subscription_RootPermissions_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootPermissions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Permissions_Stream_Cursor_Input>>;
  where?: InputMaybe<Permissions_Bool_Exp>;
};


export type Subscription_RootPersonal_Access_TokensArgs = {
  distinct_on?: InputMaybe<Array<Personal_Access_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Personal_Access_Tokens_Order_By>>;
  where?: InputMaybe<Personal_Access_Tokens_Bool_Exp>;
};


export type Subscription_RootPersonal_Access_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Personal_Access_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Personal_Access_Tokens_Order_By>>;
  where?: InputMaybe<Personal_Access_Tokens_Bool_Exp>;
};


export type Subscription_RootPersonal_Access_Tokens_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootPersonal_Access_Tokens_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Personal_Access_Tokens_Stream_Cursor_Input>>;
  where?: InputMaybe<Personal_Access_Tokens_Bool_Exp>;
};


export type Subscription_RootPersonal_DashboardArgs = {
  distinct_on?: InputMaybe<Array<Personal_Dashboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Personal_Dashboard_Order_By>>;
  where?: InputMaybe<Personal_Dashboard_Bool_Exp>;
};


export type Subscription_RootPersonal_Dashboard_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Personal_Dashboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Personal_Dashboard_Order_By>>;
  where?: InputMaybe<Personal_Dashboard_Bool_Exp>;
};


export type Subscription_RootPersonal_Dashboard_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootPersonal_Dashboard_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Personal_Dashboard_Stream_Cursor_Input>>;
  where?: InputMaybe<Personal_Dashboard_Bool_Exp>;
};


export type Subscription_RootPf_Fcm_CropsArgs = {
  distinct_on?: InputMaybe<Array<Pf_Fcm_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Fcm_Crops_Order_By>>;
  where?: InputMaybe<Pf_Fcm_Crops_Bool_Exp>;
};


export type Subscription_RootPf_Fcm_Crops_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pf_Fcm_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Fcm_Crops_Order_By>>;
  where?: InputMaybe<Pf_Fcm_Crops_Bool_Exp>;
};


export type Subscription_RootPf_Fcm_Crops_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootPf_Fcm_Crops_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Pf_Fcm_Crops_Stream_Cursor_Input>>;
  where?: InputMaybe<Pf_Fcm_Crops_Bool_Exp>;
};


export type Subscription_RootPf_Fcm_ProductsArgs = {
  distinct_on?: InputMaybe<Array<Pf_Fcm_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Fcm_Products_Order_By>>;
  where?: InputMaybe<Pf_Fcm_Products_Bool_Exp>;
};


export type Subscription_RootPf_Fcm_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pf_Fcm_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Fcm_Products_Order_By>>;
  where?: InputMaybe<Pf_Fcm_Products_Bool_Exp>;
};


export type Subscription_RootPf_Fcm_Products_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootPf_Fcm_Products_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Pf_Fcm_Products_Stream_Cursor_Input>>;
  where?: InputMaybe<Pf_Fcm_Products_Bool_Exp>;
};


export type Subscription_RootPf_Plan_CardsArgs = {
  distinct_on?: InputMaybe<Array<Pf_Plan_Cards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Plan_Cards_Order_By>>;
  where?: InputMaybe<Pf_Plan_Cards_Bool_Exp>;
};


export type Subscription_RootPf_Plan_Cards_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pf_Plan_Cards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Plan_Cards_Order_By>>;
  where?: InputMaybe<Pf_Plan_Cards_Bool_Exp>;
};


export type Subscription_RootPf_Plan_Cards_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootPf_Plan_Cards_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Pf_Plan_Cards_Stream_Cursor_Input>>;
  where?: InputMaybe<Pf_Plan_Cards_Bool_Exp>;
};


export type Subscription_RootPf_ProductsArgs = {
  distinct_on?: InputMaybe<Array<Pf_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Products_Order_By>>;
  where?: InputMaybe<Pf_Products_Bool_Exp>;
};


export type Subscription_RootPf_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pf_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Products_Order_By>>;
  where?: InputMaybe<Pf_Products_Bool_Exp>;
};


export type Subscription_RootPf_Products_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootPf_Products_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Pf_Products_Stream_Cursor_Input>>;
  where?: InputMaybe<Pf_Products_Bool_Exp>;
};


export type Subscription_RootPf_Runpando_Pro_Activity_Coins_FeedbackArgs = {
  distinct_on?: InputMaybe<Array<Pf_Runpando_Pro_Activity_Coins_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Runpando_Pro_Activity_Coins_Feedback_Order_By>>;
  where?: InputMaybe<Pf_Runpando_Pro_Activity_Coins_Feedback_Bool_Exp>;
};


export type Subscription_RootPf_Runpando_Pro_Activity_Coins_Feedback_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pf_Runpando_Pro_Activity_Coins_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Runpando_Pro_Activity_Coins_Feedback_Order_By>>;
  where?: InputMaybe<Pf_Runpando_Pro_Activity_Coins_Feedback_Bool_Exp>;
};


export type Subscription_RootPf_Runpando_Pro_Activity_Coins_Feedback_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootPf_Runpando_Pro_Activity_Coins_Feedback_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Pf_Runpando_Pro_Activity_Coins_Feedback_Stream_Cursor_Input>>;
  where?: InputMaybe<Pf_Runpando_Pro_Activity_Coins_Feedback_Bool_Exp>;
};


export type Subscription_RootPf_Runpando_Pro_All_State_DataArgs = {
  distinct_on?: InputMaybe<Array<Pf_Runpando_Pro_All_State_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Runpando_Pro_All_State_Data_Order_By>>;
  where?: InputMaybe<Pf_Runpando_Pro_All_State_Data_Bool_Exp>;
};


export type Subscription_RootPf_Runpando_Pro_All_State_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pf_Runpando_Pro_All_State_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Runpando_Pro_All_State_Data_Order_By>>;
  where?: InputMaybe<Pf_Runpando_Pro_All_State_Data_Bool_Exp>;
};


export type Subscription_RootPf_Runpando_Pro_All_State_Data_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootPf_Runpando_Pro_All_State_Data_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Pf_Runpando_Pro_All_State_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<Pf_Runpando_Pro_All_State_Data_Bool_Exp>;
};


export type Subscription_RootPf_Runpando_Pro_Campaign_Card_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<Pf_Runpando_Pro_Campaign_Card_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Runpando_Pro_Campaign_Card_Activities_Order_By>>;
  where?: InputMaybe<Pf_Runpando_Pro_Campaign_Card_Activities_Bool_Exp>;
};


export type Subscription_RootPf_Runpando_Pro_Campaign_Card_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pf_Runpando_Pro_Campaign_Card_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Runpando_Pro_Campaign_Card_Activities_Order_By>>;
  where?: InputMaybe<Pf_Runpando_Pro_Campaign_Card_Activities_Bool_Exp>;
};


export type Subscription_RootPf_Runpando_Pro_Campaign_Card_Activities_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootPf_Runpando_Pro_Campaign_Card_Activities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Pf_Runpando_Pro_Campaign_Card_Activities_Stream_Cursor_Input>>;
  where?: InputMaybe<Pf_Runpando_Pro_Campaign_Card_Activities_Bool_Exp>;
};


export type Subscription_RootPf_Runpando_Pro_Channel_Card_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Pf_Runpando_Pro_Channel_Card_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Runpando_Pro_Channel_Card_Images_Order_By>>;
  where?: InputMaybe<Pf_Runpando_Pro_Channel_Card_Images_Bool_Exp>;
};


export type Subscription_RootPf_Runpando_Pro_Channel_Card_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pf_Runpando_Pro_Channel_Card_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Runpando_Pro_Channel_Card_Images_Order_By>>;
  where?: InputMaybe<Pf_Runpando_Pro_Channel_Card_Images_Bool_Exp>;
};


export type Subscription_RootPf_Runpando_Pro_Channel_Card_Images_By_PkArgs = {
  channel_card_image_id: Scalars['bigint']['input'];
};


export type Subscription_RootPf_Runpando_Pro_Channel_Card_Images_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Pf_Runpando_Pro_Channel_Card_Images_Stream_Cursor_Input>>;
  where?: InputMaybe<Pf_Runpando_Pro_Channel_Card_Images_Bool_Exp>;
};


export type Subscription_RootPf_Runpando_Pro_Users_LocationsArgs = {
  distinct_on?: InputMaybe<Array<Pf_Runpando_Pro_Users_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Runpando_Pro_Users_Locations_Order_By>>;
  where?: InputMaybe<Pf_Runpando_Pro_Users_Locations_Bool_Exp>;
};


export type Subscription_RootPf_Runpando_Pro_Users_Locations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pf_Runpando_Pro_Users_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Runpando_Pro_Users_Locations_Order_By>>;
  where?: InputMaybe<Pf_Runpando_Pro_Users_Locations_Bool_Exp>;
};


export type Subscription_RootPf_Runpando_Pro_Users_Locations_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootPf_Runpando_Pro_Users_Locations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Pf_Runpando_Pro_Users_Locations_Stream_Cursor_Input>>;
  where?: InputMaybe<Pf_Runpando_Pro_Users_Locations_Bool_Exp>;
};


export type Subscription_RootPf_User_TravellogArgs = {
  distinct_on?: InputMaybe<Array<Pf_User_Travellog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_User_Travellog_Order_By>>;
  where?: InputMaybe<Pf_User_Travellog_Bool_Exp>;
};


export type Subscription_RootPf_User_Travellog_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pf_User_Travellog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_User_Travellog_Order_By>>;
  where?: InputMaybe<Pf_User_Travellog_Bool_Exp>;
};


export type Subscription_RootPf_User_Travellog_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootPf_User_Travellog_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Pf_User_Travellog_Stream_Cursor_Input>>;
  where?: InputMaybe<Pf_User_Travellog_Bool_Exp>;
};


export type Subscription_RootPf_UsersArgs = {
  distinct_on?: InputMaybe<Array<Pf_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Users_Order_By>>;
  where?: InputMaybe<Pf_Users_Bool_Exp>;
};


export type Subscription_RootPf_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pf_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pf_Users_Order_By>>;
  where?: InputMaybe<Pf_Users_Bool_Exp>;
};


export type Subscription_RootPf_Users_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootPf_Users_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Pf_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Pf_Users_Bool_Exp>;
};


export type Subscription_RootProduct_Pop_MediaArgs = {
  distinct_on?: InputMaybe<Array<Product_Pop_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Pop_Media_Order_By>>;
  where?: InputMaybe<Product_Pop_Media_Bool_Exp>;
};


export type Subscription_RootProduct_Pop_Media_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Pop_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Pop_Media_Order_By>>;
  where?: InputMaybe<Product_Pop_Media_Bool_Exp>;
};


export type Subscription_RootProduct_Pop_Media_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootProduct_Pop_Media_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Product_Pop_Media_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Pop_Media_Bool_Exp>;
};


export type Subscription_RootProduct_PopsArgs = {
  distinct_on?: InputMaybe<Array<Product_Pops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Pops_Order_By>>;
  where?: InputMaybe<Product_Pops_Bool_Exp>;
};


export type Subscription_RootProduct_Pops_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Pops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Pops_Order_By>>;
  where?: InputMaybe<Product_Pops_Bool_Exp>;
};


export type Subscription_RootProduct_Pops_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootProduct_Pops_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Product_Pops_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Pops_Bool_Exp>;
};


export type Subscription_RootProspect_CropsArgs = {
  distinct_on?: InputMaybe<Array<Prospect_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospect_Crops_Order_By>>;
  where?: InputMaybe<Prospect_Crops_Bool_Exp>;
};


export type Subscription_RootProspect_Crops_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prospect_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospect_Crops_Order_By>>;
  where?: InputMaybe<Prospect_Crops_Bool_Exp>;
};


export type Subscription_RootProspect_Crops_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootProspect_Crops_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Prospect_Crops_Stream_Cursor_Input>>;
  where?: InputMaybe<Prospect_Crops_Bool_Exp>;
};


export type Subscription_RootProspect_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Prospect_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospect_Messages_Order_By>>;
  where?: InputMaybe<Prospect_Messages_Bool_Exp>;
};


export type Subscription_RootProspect_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prospect_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospect_Messages_Order_By>>;
  where?: InputMaybe<Prospect_Messages_Bool_Exp>;
};


export type Subscription_RootProspect_Messages_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootProspect_Messages_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Prospect_Messages_Stream_Cursor_Input>>;
  where?: InputMaybe<Prospect_Messages_Bool_Exp>;
};


export type Subscription_RootProspect_UserArgs = {
  distinct_on?: InputMaybe<Array<Prospect_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospect_User_Order_By>>;
  where?: InputMaybe<Prospect_User_Bool_Exp>;
};


export type Subscription_RootProspect_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prospect_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospect_User_Order_By>>;
  where?: InputMaybe<Prospect_User_Bool_Exp>;
};


export type Subscription_RootProspect_User_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootProspect_User_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Prospect_User_Stream_Cursor_Input>>;
  where?: InputMaybe<Prospect_User_Bool_Exp>;
};


export type Subscription_RootProspectsArgs = {
  distinct_on?: InputMaybe<Array<Prospects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospects_Order_By>>;
  where?: InputMaybe<Prospects_Bool_Exp>;
};


export type Subscription_RootProspects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prospects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospects_Order_By>>;
  where?: InputMaybe<Prospects_Bool_Exp>;
};


export type Subscription_RootProspects_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootProspects_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Prospects_Stream_Cursor_Input>>;
  where?: InputMaybe<Prospects_Bool_Exp>;
};


export type Subscription_RootReel_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Reel_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_Category_Order_By>>;
  where?: InputMaybe<Reel_Category_Bool_Exp>;
};


export type Subscription_RootReel_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reel_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_Category_Order_By>>;
  where?: InputMaybe<Reel_Category_Bool_Exp>;
};


export type Subscription_RootReel_Category_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootReel_Category_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Reel_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Reel_Category_Bool_Exp>;
};


export type Subscription_RootReel_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Reel_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_Comments_Order_By>>;
  where?: InputMaybe<Reel_Comments_Bool_Exp>;
};


export type Subscription_RootReel_Comments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reel_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_Comments_Order_By>>;
  where?: InputMaybe<Reel_Comments_Bool_Exp>;
};


export type Subscription_RootReel_Comments_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootReel_Comments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Reel_Comments_Stream_Cursor_Input>>;
  where?: InputMaybe<Reel_Comments_Bool_Exp>;
};


export type Subscription_RootReel_InteractionsArgs = {
  distinct_on?: InputMaybe<Array<Reel_Interactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_Interactions_Order_By>>;
  where?: InputMaybe<Reel_Interactions_Bool_Exp>;
};


export type Subscription_RootReel_Interactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reel_Interactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_Interactions_Order_By>>;
  where?: InputMaybe<Reel_Interactions_Bool_Exp>;
};


export type Subscription_RootReel_Interactions_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootReel_Interactions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Reel_Interactions_Stream_Cursor_Input>>;
  where?: InputMaybe<Reel_Interactions_Bool_Exp>;
};


export type Subscription_RootReel_StatsArgs = {
  distinct_on?: InputMaybe<Array<Reel_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_Stats_Order_By>>;
  where?: InputMaybe<Reel_Stats_Bool_Exp>;
};


export type Subscription_RootReel_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reel_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_Stats_Order_By>>;
  where?: InputMaybe<Reel_Stats_Bool_Exp>;
};


export type Subscription_RootReel_Stats_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootReel_Stats_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Reel_Stats_Stream_Cursor_Input>>;
  where?: InputMaybe<Reel_Stats_Bool_Exp>;
};


export type Subscription_RootReel_User_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Reel_User_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_User_Reports_Order_By>>;
  where?: InputMaybe<Reel_User_Reports_Bool_Exp>;
};


export type Subscription_RootReel_User_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reel_User_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_User_Reports_Order_By>>;
  where?: InputMaybe<Reel_User_Reports_Bool_Exp>;
};


export type Subscription_RootReel_User_Reports_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootReel_User_Reports_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Reel_User_Reports_Stream_Cursor_Input>>;
  where?: InputMaybe<Reel_User_Reports_Bool_Exp>;
};


export type Subscription_RootReelsArgs = {
  distinct_on?: InputMaybe<Array<Reels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reels_Order_By>>;
  where?: InputMaybe<Reels_Bool_Exp>;
};


export type Subscription_RootReels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reels_Order_By>>;
  where?: InputMaybe<Reels_Bool_Exp>;
};


export type Subscription_RootReels_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootReels_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Reels_Stream_Cursor_Input>>;
  where?: InputMaybe<Reels_Bool_Exp>;
};


export type Subscription_RootReels_With_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Reels_With_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reels_With_Distance_Order_By>>;
  where?: InputMaybe<Reels_With_Distance_Bool_Exp>;
};


export type Subscription_RootReels_With_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reels_With_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reels_With_Distance_Order_By>>;
  where?: InputMaybe<Reels_With_Distance_Bool_Exp>;
};


export type Subscription_RootReels_With_Distance_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Reels_With_Distance_Stream_Cursor_Input>>;
  where?: InputMaybe<Reels_With_Distance_Bool_Exp>;
};


export type Subscription_RootRetailer_EstablishmentsArgs = {
  distinct_on?: InputMaybe<Array<Retailer_Establishments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Retailer_Establishments_Order_By>>;
  where?: InputMaybe<Retailer_Establishments_Bool_Exp>;
};


export type Subscription_RootRetailer_Establishments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Retailer_Establishments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Retailer_Establishments_Order_By>>;
  where?: InputMaybe<Retailer_Establishments_Bool_Exp>;
};


export type Subscription_RootRetailer_Establishments_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootRetailer_Establishments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Retailer_Establishments_Stream_Cursor_Input>>;
  where?: InputMaybe<Retailer_Establishments_Bool_Exp>;
};


export type Subscription_RootRetailersArgs = {
  distinct_on?: InputMaybe<Array<Retailers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Retailers_Order_By>>;
  where?: InputMaybe<Retailers_Bool_Exp>;
};


export type Subscription_RootRetailers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Retailers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Retailers_Order_By>>;
  where?: InputMaybe<Retailers_Bool_Exp>;
};


export type Subscription_RootRetailers_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootRetailers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Retailers_Stream_Cursor_Input>>;
  where?: InputMaybe<Retailers_Bool_Exp>;
};


export type Subscription_RootRole_Has_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Role_Has_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_Has_Permissions_Order_By>>;
  where?: InputMaybe<Role_Has_Permissions_Bool_Exp>;
};


export type Subscription_RootRole_Has_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_Has_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_Has_Permissions_Order_By>>;
  where?: InputMaybe<Role_Has_Permissions_Bool_Exp>;
};


export type Subscription_RootRole_Has_Permissions_By_PkArgs = {
  permission_id: Scalars['bigint']['input'];
  role_id: Scalars['bigint']['input'];
};


export type Subscription_RootRole_Has_Permissions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Role_Has_Permissions_Stream_Cursor_Input>>;
  where?: InputMaybe<Role_Has_Permissions_Bool_Exp>;
};


export type Subscription_RootRolesArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Subscription_RootRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Subscription_RootRoles_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootRoles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Roles_Stream_Cursor_Input>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Subscription_RootRunpando_Pro_All_State_DataArgs = {
  distinct_on?: InputMaybe<Array<Runpando_Pro_All_State_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Runpando_Pro_All_State_Data_Order_By>>;
  where?: InputMaybe<Runpando_Pro_All_State_Data_Bool_Exp>;
};


export type Subscription_RootRunpando_Pro_All_State_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Runpando_Pro_All_State_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Runpando_Pro_All_State_Data_Order_By>>;
  where?: InputMaybe<Runpando_Pro_All_State_Data_Bool_Exp>;
};


export type Subscription_RootRunpando_Pro_All_State_Data_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootRunpando_Pro_All_State_Data_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Runpando_Pro_All_State_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<Runpando_Pro_All_State_Data_Bool_Exp>;
};


export type Subscription_RootRunpando_Pro_UsersArgs = {
  distinct_on?: InputMaybe<Array<Runpando_Pro_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Runpando_Pro_Users_Order_By>>;
  where?: InputMaybe<Runpando_Pro_Users_Bool_Exp>;
};


export type Subscription_RootRunpando_Pro_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Runpando_Pro_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Runpando_Pro_Users_Order_By>>;
  where?: InputMaybe<Runpando_Pro_Users_Bool_Exp>;
};


export type Subscription_RootRunpando_Pro_Users_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootRunpando_Pro_Users_LocationsArgs = {
  distinct_on?: InputMaybe<Array<Runpando_Pro_Users_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Runpando_Pro_Users_Locations_Order_By>>;
  where?: InputMaybe<Runpando_Pro_Users_Locations_Bool_Exp>;
};


export type Subscription_RootRunpando_Pro_Users_Locations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Runpando_Pro_Users_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Runpando_Pro_Users_Locations_Order_By>>;
  where?: InputMaybe<Runpando_Pro_Users_Locations_Bool_Exp>;
};


export type Subscription_RootRunpando_Pro_Users_Locations_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootRunpando_Pro_Users_Locations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Runpando_Pro_Users_Locations_Stream_Cursor_Input>>;
  where?: InputMaybe<Runpando_Pro_Users_Locations_Bool_Exp>;
};


export type Subscription_RootRunpando_Pro_Users_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Runpando_Pro_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Runpando_Pro_Users_Bool_Exp>;
};


export type Subscription_RootSale_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Sale_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sale_Items_Order_By>>;
  where?: InputMaybe<Sale_Items_Bool_Exp>;
};


export type Subscription_RootSale_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sale_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sale_Items_Order_By>>;
  where?: InputMaybe<Sale_Items_Bool_Exp>;
};


export type Subscription_RootSale_Items_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootSale_Items_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sale_Items_Stream_Cursor_Input>>;
  where?: InputMaybe<Sale_Items_Bool_Exp>;
};


export type Subscription_RootSale_PaymentsArgs = {
  distinct_on?: InputMaybe<Array<Sale_Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sale_Payments_Order_By>>;
  where?: InputMaybe<Sale_Payments_Bool_Exp>;
};


export type Subscription_RootSale_Payments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sale_Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sale_Payments_Order_By>>;
  where?: InputMaybe<Sale_Payments_Bool_Exp>;
};


export type Subscription_RootSale_Payments_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootSale_Payments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sale_Payments_Stream_Cursor_Input>>;
  where?: InputMaybe<Sale_Payments_Bool_Exp>;
};


export type Subscription_RootSale_Proof_EventsArgs = {
  distinct_on?: InputMaybe<Array<Sale_Proof_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sale_Proof_Events_Order_By>>;
  where?: InputMaybe<Sale_Proof_Events_Bool_Exp>;
};


export type Subscription_RootSale_Proof_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sale_Proof_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sale_Proof_Events_Order_By>>;
  where?: InputMaybe<Sale_Proof_Events_Bool_Exp>;
};


export type Subscription_RootSale_Proof_Events_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootSale_Proof_Events_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sale_Proof_Events_Stream_Cursor_Input>>;
  where?: InputMaybe<Sale_Proof_Events_Bool_Exp>;
};


export type Subscription_RootSale_Proof_TypesArgs = {
  distinct_on?: InputMaybe<Array<Sale_Proof_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sale_Proof_Types_Order_By>>;
  where?: InputMaybe<Sale_Proof_Types_Bool_Exp>;
};


export type Subscription_RootSale_Proof_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sale_Proof_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sale_Proof_Types_Order_By>>;
  where?: InputMaybe<Sale_Proof_Types_Bool_Exp>;
};


export type Subscription_RootSale_Proof_Types_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootSale_Proof_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sale_Proof_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Sale_Proof_Types_Bool_Exp>;
};


export type Subscription_RootSale_ProofsArgs = {
  distinct_on?: InputMaybe<Array<Sale_Proofs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sale_Proofs_Order_By>>;
  where?: InputMaybe<Sale_Proofs_Bool_Exp>;
};


export type Subscription_RootSale_Proofs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sale_Proofs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sale_Proofs_Order_By>>;
  where?: InputMaybe<Sale_Proofs_Bool_Exp>;
};


export type Subscription_RootSale_Proofs_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootSale_Proofs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sale_Proofs_Stream_Cursor_Input>>;
  where?: InputMaybe<Sale_Proofs_Bool_Exp>;
};


export type Subscription_RootSalesArgs = {
  distinct_on?: InputMaybe<Array<Sales_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sales_Order_By>>;
  where?: InputMaybe<Sales_Bool_Exp>;
};


export type Subscription_RootSales_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sales_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sales_Order_By>>;
  where?: InputMaybe<Sales_Bool_Exp>;
};


export type Subscription_RootSales_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootSales_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sales_Stream_Cursor_Input>>;
  where?: InputMaybe<Sales_Bool_Exp>;
};


export type Subscription_RootSaved_ReelsArgs = {
  distinct_on?: InputMaybe<Array<Saved_Reels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Saved_Reels_Order_By>>;
  where?: InputMaybe<Saved_Reels_Bool_Exp>;
};


export type Subscription_RootSaved_Reels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Saved_Reels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Saved_Reels_Order_By>>;
  where?: InputMaybe<Saved_Reels_Bool_Exp>;
};


export type Subscription_RootSaved_Reels_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootSaved_Reels_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Saved_Reels_Stream_Cursor_Input>>;
  where?: InputMaybe<Saved_Reels_Bool_Exp>;
};


export type Subscription_RootSearch_Field_Force_Near_FarmerArgs = {
  args: Search_Field_Force_Near_Farmer_Args;
  distinct_on?: InputMaybe<Array<Last_Known_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Last_Known_Locations_Order_By>>;
  where?: InputMaybe<Last_Known_Locations_Bool_Exp>;
};


export type Subscription_RootSearch_Field_Force_Near_Farmer_AggregateArgs = {
  args: Search_Field_Force_Near_Farmer_Args;
  distinct_on?: InputMaybe<Array<Last_Known_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Last_Known_Locations_Order_By>>;
  where?: InputMaybe<Last_Known_Locations_Bool_Exp>;
};


export type Subscription_RootSegment_UserArgs = {
  distinct_on?: InputMaybe<Array<Segment_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Segment_User_Order_By>>;
  where?: InputMaybe<Segment_User_Bool_Exp>;
};


export type Subscription_RootSegment_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Segment_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Segment_User_Order_By>>;
  where?: InputMaybe<Segment_User_Bool_Exp>;
};


export type Subscription_RootSegment_User_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootSegment_User_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Segment_User_Stream_Cursor_Input>>;
  where?: InputMaybe<Segment_User_Bool_Exp>;
};


export type Subscription_RootService_Request_DashboardArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Dashboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Dashboard_Order_By>>;
  where?: InputMaybe<Service_Request_Dashboard_Bool_Exp>;
};


export type Subscription_RootService_Request_Dashboard_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Dashboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Dashboard_Order_By>>;
  where?: InputMaybe<Service_Request_Dashboard_Bool_Exp>;
};


export type Subscription_RootService_Request_Dashboard_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootService_Request_Dashboard_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Service_Request_Dashboard_Stream_Cursor_Input>>;
  where?: InputMaybe<Service_Request_Dashboard_Bool_Exp>;
};


export type Subscription_RootService_Request_RecommendationsArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Recommendations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Recommendations_Order_By>>;
  where?: InputMaybe<Service_Request_Recommendations_Bool_Exp>;
};


export type Subscription_RootService_Request_Recommendations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Recommendations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Recommendations_Order_By>>;
  where?: InputMaybe<Service_Request_Recommendations_Bool_Exp>;
};


export type Subscription_RootService_Request_Recommendations_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootService_Request_Recommendations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Service_Request_Recommendations_Stream_Cursor_Input>>;
  where?: InputMaybe<Service_Request_Recommendations_Bool_Exp>;
};


export type Subscription_RootService_Request_RetailerArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Retailer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Retailer_Order_By>>;
  where?: InputMaybe<Service_Request_Retailer_Bool_Exp>;
};


export type Subscription_RootService_Request_Retailer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Retailer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Retailer_Order_By>>;
  where?: InputMaybe<Service_Request_Retailer_Bool_Exp>;
};


export type Subscription_RootService_Request_Retailer_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootService_Request_Retailer_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Service_Request_Retailer_Stream_Cursor_Input>>;
  where?: InputMaybe<Service_Request_Retailer_Bool_Exp>;
};


export type Subscription_RootService_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Service_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Requests_Order_By>>;
  where?: InputMaybe<Service_Requests_Bool_Exp>;
};


export type Subscription_RootService_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Requests_Order_By>>;
  where?: InputMaybe<Service_Requests_Bool_Exp>;
};


export type Subscription_RootService_Requests_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootService_Requests_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Service_Requests_Stream_Cursor_Input>>;
  where?: InputMaybe<Service_Requests_Bool_Exp>;
};


export type Subscription_RootSnapshotsArgs = {
  distinct_on?: InputMaybe<Array<Snapshots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Snapshots_Order_By>>;
  where?: InputMaybe<Snapshots_Bool_Exp>;
};


export type Subscription_RootSnapshots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Snapshots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Snapshots_Order_By>>;
  where?: InputMaybe<Snapshots_Bool_Exp>;
};


export type Subscription_RootSnapshots_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootSnapshots_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Snapshots_Stream_Cursor_Input>>;
  where?: InputMaybe<Snapshots_Bool_Exp>;
};


export type Subscription_RootSpatial_Ref_SysArgs = {
  distinct_on?: InputMaybe<Array<Spatial_Ref_Sys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spatial_Ref_Sys_Order_By>>;
  where?: InputMaybe<Spatial_Ref_Sys_Bool_Exp>;
};


export type Subscription_RootSpatial_Ref_Sys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spatial_Ref_Sys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spatial_Ref_Sys_Order_By>>;
  where?: InputMaybe<Spatial_Ref_Sys_Bool_Exp>;
};


export type Subscription_RootSpatial_Ref_Sys_By_PkArgs = {
  srid: Scalars['Int']['input'];
};


export type Subscription_RootSpatial_Ref_Sys_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Spatial_Ref_Sys_Stream_Cursor_Input>>;
  where?: InputMaybe<Spatial_Ref_Sys_Bool_Exp>;
};


export type Subscription_RootStored_EventsArgs = {
  distinct_on?: InputMaybe<Array<Stored_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Stored_Events_Order_By>>;
  where?: InputMaybe<Stored_Events_Bool_Exp>;
};


export type Subscription_RootStored_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stored_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Stored_Events_Order_By>>;
  where?: InputMaybe<Stored_Events_Bool_Exp>;
};


export type Subscription_RootStored_Events_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootStored_Events_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Stored_Events_Stream_Cursor_Input>>;
  where?: InputMaybe<Stored_Events_Bool_Exp>;
};


export type Subscription_RootTaggablesArgs = {
  distinct_on?: InputMaybe<Array<Taggables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taggables_Order_By>>;
  where?: InputMaybe<Taggables_Bool_Exp>;
};


export type Subscription_RootTaggables_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Taggables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taggables_Order_By>>;
  where?: InputMaybe<Taggables_Bool_Exp>;
};


export type Subscription_RootTaggables_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootTaggables_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Taggables_Stream_Cursor_Input>>;
  where?: InputMaybe<Taggables_Bool_Exp>;
};


export type Subscription_RootTagsArgs = {
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Subscription_RootTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Subscription_RootTags_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootTags_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tags_Stream_Cursor_Input>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Subscription_RootUser_DeviceArgs = {
  distinct_on?: InputMaybe<Array<User_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Device_Order_By>>;
  where?: InputMaybe<User_Device_Bool_Exp>;
};


export type Subscription_RootUser_Device_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Device_Order_By>>;
  where?: InputMaybe<User_Device_Bool_Exp>;
};


export type Subscription_RootUser_Device_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUser_Device_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Device_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Device_Bool_Exp>;
};


export type Subscription_RootUser_FeedbacksArgs = {
  distinct_on?: InputMaybe<Array<User_Feedbacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Feedbacks_Order_By>>;
  where?: InputMaybe<User_Feedbacks_Bool_Exp>;
};


export type Subscription_RootUser_Feedbacks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Feedbacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Feedbacks_Order_By>>;
  where?: InputMaybe<User_Feedbacks_Bool_Exp>;
};


export type Subscription_RootUser_Feedbacks_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootUser_Feedbacks_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Feedbacks_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Feedbacks_Bool_Exp>;
};


export type Subscription_RootUser_Follows_ChannelArgs = {
  distinct_on?: InputMaybe<Array<User_Follows_Channel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Follows_Channel_Order_By>>;
  where?: InputMaybe<User_Follows_Channel_Bool_Exp>;
};


export type Subscription_RootUser_Follows_Channel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Follows_Channel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Follows_Channel_Order_By>>;
  where?: InputMaybe<User_Follows_Channel_Bool_Exp>;
};


export type Subscription_RootUser_Follows_Channel_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUser_Follows_Channel_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Follows_Channel_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Follows_Channel_Bool_Exp>;
};


export type Subscription_RootUser_Location_LogsArgs = {
  distinct_on?: InputMaybe<Array<User_Location_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Location_Logs_Order_By>>;
  where?: InputMaybe<User_Location_Logs_Bool_Exp>;
};


export type Subscription_RootUser_Location_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Location_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Location_Logs_Order_By>>;
  where?: InputMaybe<User_Location_Logs_Bool_Exp>;
};


export type Subscription_RootUser_Location_Logs_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootUser_Location_Logs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Location_Logs_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Location_Logs_Bool_Exp>;
};


export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootWalletsArgs = {
  distinct_on?: InputMaybe<Array<Wallets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallets_Order_By>>;
  where?: InputMaybe<Wallets_Bool_Exp>;
};


export type Subscription_RootWallets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wallets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallets_Order_By>>;
  where?: InputMaybe<Wallets_Bool_Exp>;
};


export type Subscription_RootWallets_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootWallets_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Wallets_Stream_Cursor_Input>>;
  where?: InputMaybe<Wallets_Bool_Exp>;
};


export type Subscription_RootWhatsauth_LoginsArgs = {
  distinct_on?: InputMaybe<Array<Whatsauth_Logins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsauth_Logins_Order_By>>;
  where?: InputMaybe<Whatsauth_Logins_Bool_Exp>;
};


export type Subscription_RootWhatsauth_Logins_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Whatsauth_Logins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsauth_Logins_Order_By>>;
  where?: InputMaybe<Whatsauth_Logins_Bool_Exp>;
};


export type Subscription_RootWhatsauth_Logins_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootWhatsauth_Logins_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Whatsauth_Logins_Stream_Cursor_Input>>;
  where?: InputMaybe<Whatsauth_Logins_Bool_Exp>;
};


export type Subscription_RootWork_Order_Checklist_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Work_Order_Checklist_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Work_Order_Checklist_Items_Order_By>>;
  where?: InputMaybe<Work_Order_Checklist_Items_Bool_Exp>;
};


export type Subscription_RootWork_Order_Checklist_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Work_Order_Checklist_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Work_Order_Checklist_Items_Order_By>>;
  where?: InputMaybe<Work_Order_Checklist_Items_Bool_Exp>;
};


export type Subscription_RootWork_Order_Checklist_Items_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootWork_Order_Checklist_Items_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Work_Order_Checklist_Items_Stream_Cursor_Input>>;
  where?: InputMaybe<Work_Order_Checklist_Items_Bool_Exp>;
};


export type Subscription_RootWork_Order_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Work_Order_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Work_Order_Messages_Order_By>>;
  where?: InputMaybe<Work_Order_Messages_Bool_Exp>;
};


export type Subscription_RootWork_Order_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Work_Order_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Work_Order_Messages_Order_By>>;
  where?: InputMaybe<Work_Order_Messages_Bool_Exp>;
};


export type Subscription_RootWork_Order_Messages_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootWork_Order_Messages_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Work_Order_Messages_Stream_Cursor_Input>>;
  where?: InputMaybe<Work_Order_Messages_Bool_Exp>;
};


export type Subscription_RootWork_Order_OutputsArgs = {
  distinct_on?: InputMaybe<Array<Work_Order_Outputs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Work_Order_Outputs_Order_By>>;
  where?: InputMaybe<Work_Order_Outputs_Bool_Exp>;
};


export type Subscription_RootWork_Order_Outputs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Work_Order_Outputs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Work_Order_Outputs_Order_By>>;
  where?: InputMaybe<Work_Order_Outputs_Bool_Exp>;
};


export type Subscription_RootWork_Order_Outputs_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootWork_Order_Outputs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Work_Order_Outputs_Stream_Cursor_Input>>;
  where?: InputMaybe<Work_Order_Outputs_Bool_Exp>;
};


export type Subscription_RootWork_Order_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Work_Order_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Work_Order_Requests_Order_By>>;
  where?: InputMaybe<Work_Order_Requests_Bool_Exp>;
};


export type Subscription_RootWork_Order_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Work_Order_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Work_Order_Requests_Order_By>>;
  where?: InputMaybe<Work_Order_Requests_Bool_Exp>;
};


export type Subscription_RootWork_Order_Requests_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootWork_Order_Requests_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Work_Order_Requests_Stream_Cursor_Input>>;
  where?: InputMaybe<Work_Order_Requests_Bool_Exp>;
};


export type Subscription_RootWork_Order_ReviewsArgs = {
  distinct_on?: InputMaybe<Array<Work_Order_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Work_Order_Reviews_Order_By>>;
  where?: InputMaybe<Work_Order_Reviews_Bool_Exp>;
};


export type Subscription_RootWork_Order_Reviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Work_Order_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Work_Order_Reviews_Order_By>>;
  where?: InputMaybe<Work_Order_Reviews_Bool_Exp>;
};


export type Subscription_RootWork_Order_Reviews_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootWork_Order_Reviews_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Work_Order_Reviews_Stream_Cursor_Input>>;
  where?: InputMaybe<Work_Order_Reviews_Bool_Exp>;
};


export type Subscription_RootWork_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Work_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Work_Orders_Order_By>>;
  where?: InputMaybe<Work_Orders_Bool_Exp>;
};


export type Subscription_RootWork_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Work_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Work_Orders_Order_By>>;
  where?: InputMaybe<Work_Orders_Bool_Exp>;
};


export type Subscription_RootWork_Orders_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootWork_Orders_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Work_Orders_Stream_Cursor_Input>>;
  where?: InputMaybe<Work_Orders_Bool_Exp>;
};

/** columns and relationships of "taggables" */
export type Taggables = {
  __typename?: 'taggables';
  id: Scalars['bigint']['output'];
  tag_id: Scalars['bigint']['output'];
  taggable_id: Scalars['bigint']['output'];
  taggable_type: Scalars['String']['output'];
  /** An object relationship */
  taggables_reel: Reels;
  /** An object relationship */
  taggables_tag: Tags;
};

/** aggregated selection of "taggables" */
export type Taggables_Aggregate = {
  __typename?: 'taggables_aggregate';
  aggregate?: Maybe<Taggables_Aggregate_Fields>;
  nodes: Array<Taggables>;
};

export type Taggables_Aggregate_Bool_Exp = {
  count?: InputMaybe<Taggables_Aggregate_Bool_Exp_Count>;
};

export type Taggables_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Taggables_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Taggables_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "taggables" */
export type Taggables_Aggregate_Fields = {
  __typename?: 'taggables_aggregate_fields';
  avg?: Maybe<Taggables_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Taggables_Max_Fields>;
  min?: Maybe<Taggables_Min_Fields>;
  stddev?: Maybe<Taggables_Stddev_Fields>;
  stddev_pop?: Maybe<Taggables_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Taggables_Stddev_Samp_Fields>;
  sum?: Maybe<Taggables_Sum_Fields>;
  var_pop?: Maybe<Taggables_Var_Pop_Fields>;
  var_samp?: Maybe<Taggables_Var_Samp_Fields>;
  variance?: Maybe<Taggables_Variance_Fields>;
};


/** aggregate fields of "taggables" */
export type Taggables_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Taggables_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "taggables" */
export type Taggables_Aggregate_Order_By = {
  avg?: InputMaybe<Taggables_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Taggables_Max_Order_By>;
  min?: InputMaybe<Taggables_Min_Order_By>;
  stddev?: InputMaybe<Taggables_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Taggables_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Taggables_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Taggables_Sum_Order_By>;
  var_pop?: InputMaybe<Taggables_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Taggables_Var_Samp_Order_By>;
  variance?: InputMaybe<Taggables_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "taggables" */
export type Taggables_Arr_Rel_Insert_Input = {
  data: Array<Taggables_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Taggables_On_Conflict>;
};

/** aggregate avg on columns */
export type Taggables_Avg_Fields = {
  __typename?: 'taggables_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  tag_id?: Maybe<Scalars['Float']['output']>;
  taggable_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "taggables" */
export type Taggables_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  taggable_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "taggables". All fields are combined with a logical 'AND'. */
export type Taggables_Bool_Exp = {
  _and?: InputMaybe<Array<Taggables_Bool_Exp>>;
  _not?: InputMaybe<Taggables_Bool_Exp>;
  _or?: InputMaybe<Array<Taggables_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  tag_id?: InputMaybe<Bigint_Comparison_Exp>;
  taggable_id?: InputMaybe<Bigint_Comparison_Exp>;
  taggable_type?: InputMaybe<String_Comparison_Exp>;
  taggables_reel?: InputMaybe<Reels_Bool_Exp>;
  taggables_tag?: InputMaybe<Tags_Bool_Exp>;
};

/** unique or primary key constraints on table "taggables" */
export enum Taggables_Constraint {
  /** unique or primary key constraint on columns "id" */
  TaggablesPk = 'taggables_pk',
  /** unique or primary key constraint on columns "tag_id", "taggable_id", "taggable_type" */
  TaggablesTagIdTaggableIdTaggableTypeUnique = 'taggables_tag_id_taggable_id_taggable_type_unique'
}

/** input type for incrementing numeric columns in table "taggables" */
export type Taggables_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  tag_id?: InputMaybe<Scalars['bigint']['input']>;
  taggable_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "taggables" */
export type Taggables_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  tag_id?: InputMaybe<Scalars['bigint']['input']>;
  taggable_id?: InputMaybe<Scalars['bigint']['input']>;
  taggable_type?: InputMaybe<Scalars['String']['input']>;
  taggables_reel?: InputMaybe<Reels_Obj_Rel_Insert_Input>;
  taggables_tag?: InputMaybe<Tags_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Taggables_Max_Fields = {
  __typename?: 'taggables_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  tag_id?: Maybe<Scalars['bigint']['output']>;
  taggable_id?: Maybe<Scalars['bigint']['output']>;
  taggable_type?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "taggables" */
export type Taggables_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  taggable_id?: InputMaybe<Order_By>;
  taggable_type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Taggables_Min_Fields = {
  __typename?: 'taggables_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  tag_id?: Maybe<Scalars['bigint']['output']>;
  taggable_id?: Maybe<Scalars['bigint']['output']>;
  taggable_type?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "taggables" */
export type Taggables_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  taggable_id?: InputMaybe<Order_By>;
  taggable_type?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "taggables" */
export type Taggables_Mutation_Response = {
  __typename?: 'taggables_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Taggables>;
};

/** on_conflict condition type for table "taggables" */
export type Taggables_On_Conflict = {
  constraint: Taggables_Constraint;
  update_columns?: Array<Taggables_Update_Column>;
  where?: InputMaybe<Taggables_Bool_Exp>;
};

/** Ordering options when selecting data from "taggables". */
export type Taggables_Order_By = {
  id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  taggable_id?: InputMaybe<Order_By>;
  taggable_type?: InputMaybe<Order_By>;
  taggables_reel?: InputMaybe<Reels_Order_By>;
  taggables_tag?: InputMaybe<Tags_Order_By>;
};

/** primary key columns input for table: taggables */
export type Taggables_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "taggables" */
export enum Taggables_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  TagId = 'tag_id',
  /** column name */
  TaggableId = 'taggable_id',
  /** column name */
  TaggableType = 'taggable_type'
}

/** input type for updating data in table "taggables" */
export type Taggables_Set_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  tag_id?: InputMaybe<Scalars['bigint']['input']>;
  taggable_id?: InputMaybe<Scalars['bigint']['input']>;
  taggable_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Taggables_Stddev_Fields = {
  __typename?: 'taggables_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  tag_id?: Maybe<Scalars['Float']['output']>;
  taggable_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "taggables" */
export type Taggables_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  taggable_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Taggables_Stddev_Pop_Fields = {
  __typename?: 'taggables_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  tag_id?: Maybe<Scalars['Float']['output']>;
  taggable_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "taggables" */
export type Taggables_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  taggable_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Taggables_Stddev_Samp_Fields = {
  __typename?: 'taggables_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  tag_id?: Maybe<Scalars['Float']['output']>;
  taggable_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "taggables" */
export type Taggables_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  taggable_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "taggables" */
export type Taggables_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Taggables_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Taggables_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  tag_id?: InputMaybe<Scalars['bigint']['input']>;
  taggable_id?: InputMaybe<Scalars['bigint']['input']>;
  taggable_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Taggables_Sum_Fields = {
  __typename?: 'taggables_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  tag_id?: Maybe<Scalars['bigint']['output']>;
  taggable_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "taggables" */
export type Taggables_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  taggable_id?: InputMaybe<Order_By>;
};

/** update columns of table "taggables" */
export enum Taggables_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  TagId = 'tag_id',
  /** column name */
  TaggableId = 'taggable_id',
  /** column name */
  TaggableType = 'taggable_type'
}

export type Taggables_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Taggables_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Taggables_Set_Input>;
  /** filter the rows which have to be updated */
  where: Taggables_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Taggables_Var_Pop_Fields = {
  __typename?: 'taggables_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  tag_id?: Maybe<Scalars['Float']['output']>;
  taggable_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "taggables" */
export type Taggables_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  taggable_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Taggables_Var_Samp_Fields = {
  __typename?: 'taggables_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  tag_id?: Maybe<Scalars['Float']['output']>;
  taggable_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "taggables" */
export type Taggables_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  taggable_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Taggables_Variance_Fields = {
  __typename?: 'taggables_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  tag_id?: Maybe<Scalars['Float']['output']>;
  taggable_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "taggables" */
export type Taggables_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  taggable_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "tags" */
export type Tags = {
  __typename?: 'tags';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['bigint']['output'];
  name: Scalars['json']['output'];
  order_column?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['json']['output']>;
  /** An array relationship */
  tags_taggables: Array<Taggables>;
  /** An aggregate relationship */
  tags_taggables_aggregate: Taggables_Aggregate;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};


/** columns and relationships of "tags" */
export type TagsNameArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "tags" */
export type TagsSlugArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "tags" */
export type TagsTags_TaggablesArgs = {
  distinct_on?: InputMaybe<Array<Taggables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taggables_Order_By>>;
  where?: InputMaybe<Taggables_Bool_Exp>;
};


/** columns and relationships of "tags" */
export type TagsTags_Taggables_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Taggables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taggables_Order_By>>;
  where?: InputMaybe<Taggables_Bool_Exp>;
};

/** aggregated selection of "tags" */
export type Tags_Aggregate = {
  __typename?: 'tags_aggregate';
  aggregate?: Maybe<Tags_Aggregate_Fields>;
  nodes: Array<Tags>;
};

/** aggregate fields of "tags" */
export type Tags_Aggregate_Fields = {
  __typename?: 'tags_aggregate_fields';
  avg?: Maybe<Tags_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Tags_Max_Fields>;
  min?: Maybe<Tags_Min_Fields>;
  stddev?: Maybe<Tags_Stddev_Fields>;
  stddev_pop?: Maybe<Tags_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tags_Stddev_Samp_Fields>;
  sum?: Maybe<Tags_Sum_Fields>;
  var_pop?: Maybe<Tags_Var_Pop_Fields>;
  var_samp?: Maybe<Tags_Var_Samp_Fields>;
  variance?: Maybe<Tags_Variance_Fields>;
};


/** aggregate fields of "tags" */
export type Tags_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Tags_Avg_Fields = {
  __typename?: 'tags_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order_column?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "tags". All fields are combined with a logical 'AND'. */
export type Tags_Bool_Exp = {
  _and?: InputMaybe<Array<Tags_Bool_Exp>>;
  _not?: InputMaybe<Tags_Bool_Exp>;
  _or?: InputMaybe<Array<Tags_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<Json_Comparison_Exp>;
  order_column?: InputMaybe<Int_Comparison_Exp>;
  slug?: InputMaybe<Json_Comparison_Exp>;
  tags_taggables?: InputMaybe<Taggables_Bool_Exp>;
  tags_taggables_aggregate?: InputMaybe<Taggables_Aggregate_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "tags" */
export enum Tags_Constraint {
  /** unique or primary key constraint on columns "id" */
  TagsPkey = 'tags_pkey'
}

/** input type for incrementing numeric columns in table "tags" */
export type Tags_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  order_column?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "tags" */
export type Tags_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['json']['input']>;
  order_column?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['json']['input']>;
  tags_taggables?: InputMaybe<Taggables_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Tags_Max_Fields = {
  __typename?: 'tags_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  order_column?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Tags_Min_Fields = {
  __typename?: 'tags_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  order_column?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "tags" */
export type Tags_Mutation_Response = {
  __typename?: 'tags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tags>;
};

/** input type for inserting object relation for remote table "tags" */
export type Tags_Obj_Rel_Insert_Input = {
  data: Tags_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tags_On_Conflict>;
};

/** on_conflict condition type for table "tags" */
export type Tags_On_Conflict = {
  constraint: Tags_Constraint;
  update_columns?: Array<Tags_Update_Column>;
  where?: InputMaybe<Tags_Bool_Exp>;
};

/** Ordering options when selecting data from "tags". */
export type Tags_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_column?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  tags_taggables_aggregate?: InputMaybe<Taggables_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tags */
export type Tags_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "tags" */
export enum Tags_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrderColumn = 'order_column',
  /** column name */
  Slug = 'slug',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "tags" */
export type Tags_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['json']['input']>;
  order_column?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['json']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Tags_Stddev_Fields = {
  __typename?: 'tags_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order_column?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Tags_Stddev_Pop_Fields = {
  __typename?: 'tags_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order_column?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Tags_Stddev_Samp_Fields = {
  __typename?: 'tags_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order_column?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "tags" */
export type Tags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tags_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['json']['input']>;
  order_column?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['json']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Tags_Sum_Fields = {
  __typename?: 'tags_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  order_column?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "tags" */
export enum Tags_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrderColumn = 'order_column',
  /** column name */
  Slug = 'slug',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Tags_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tags_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tags_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tags_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tags_Var_Pop_Fields = {
  __typename?: 'tags_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order_column?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Tags_Var_Samp_Fields = {
  __typename?: 'tags_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order_column?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Tags_Variance_Fields = {
  __typename?: 'tags_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order_column?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** columns and relationships of "user_device" */
export type User_Device = {
  __typename?: 'user_device';
  app_build_number?: Maybe<Scalars['String']['output']>;
  app_version?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  device_brand?: Maybe<Scalars['String']['output']>;
  device_installation_id?: Maybe<Scalars['String']['output']>;
  device_manufacturer?: Maybe<Scalars['String']['output']>;
  device_model?: Maybe<Scalars['String']['output']>;
  device_name?: Maybe<Scalars['String']['output']>;
  device_os?: Maybe<Scalars['String']['output']>;
  device_os_version?: Maybe<Scalars['String']['output']>;
  device_token?: Maybe<Scalars['String']['output']>;
  device_type?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  is_logged_in: Scalars['Boolean']['output'];
  jwt?: Maybe<Scalars['String']['output']>;
  native_push_token?: Maybe<Scalars['String']['output']>;
  release_channel?: Maybe<Scalars['String']['output']>;
  runtime_version?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id: Scalars['bpchar']['output'];
};

/** aggregated selection of "user_device" */
export type User_Device_Aggregate = {
  __typename?: 'user_device_aggregate';
  aggregate?: Maybe<User_Device_Aggregate_Fields>;
  nodes: Array<User_Device>;
};

/** aggregate fields of "user_device" */
export type User_Device_Aggregate_Fields = {
  __typename?: 'user_device_aggregate_fields';
  avg?: Maybe<User_Device_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Device_Max_Fields>;
  min?: Maybe<User_Device_Min_Fields>;
  stddev?: Maybe<User_Device_Stddev_Fields>;
  stddev_pop?: Maybe<User_Device_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Device_Stddev_Samp_Fields>;
  sum?: Maybe<User_Device_Sum_Fields>;
  var_pop?: Maybe<User_Device_Var_Pop_Fields>;
  var_samp?: Maybe<User_Device_Var_Samp_Fields>;
  variance?: Maybe<User_Device_Variance_Fields>;
};


/** aggregate fields of "user_device" */
export type User_Device_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Device_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type User_Device_Avg_Fields = {
  __typename?: 'user_device_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "user_device". All fields are combined with a logical 'AND'. */
export type User_Device_Bool_Exp = {
  _and?: InputMaybe<Array<User_Device_Bool_Exp>>;
  _not?: InputMaybe<User_Device_Bool_Exp>;
  _or?: InputMaybe<Array<User_Device_Bool_Exp>>;
  app_build_number?: InputMaybe<String_Comparison_Exp>;
  app_version?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  device_brand?: InputMaybe<String_Comparison_Exp>;
  device_installation_id?: InputMaybe<String_Comparison_Exp>;
  device_manufacturer?: InputMaybe<String_Comparison_Exp>;
  device_model?: InputMaybe<String_Comparison_Exp>;
  device_name?: InputMaybe<String_Comparison_Exp>;
  device_os?: InputMaybe<String_Comparison_Exp>;
  device_os_version?: InputMaybe<String_Comparison_Exp>;
  device_token?: InputMaybe<String_Comparison_Exp>;
  device_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_logged_in?: InputMaybe<Boolean_Comparison_Exp>;
  jwt?: InputMaybe<String_Comparison_Exp>;
  native_push_token?: InputMaybe<String_Comparison_Exp>;
  release_channel?: InputMaybe<String_Comparison_Exp>;
  runtime_version?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_device" */
export enum User_Device_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserDevicePkey = 'user_device_pkey'
}

/** input type for incrementing numeric columns in table "user_device" */
export type User_Device_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "user_device" */
export type User_Device_Insert_Input = {
  app_build_number?: InputMaybe<Scalars['String']['input']>;
  app_version?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  device_brand?: InputMaybe<Scalars['String']['input']>;
  device_installation_id?: InputMaybe<Scalars['String']['input']>;
  device_manufacturer?: InputMaybe<Scalars['String']['input']>;
  device_model?: InputMaybe<Scalars['String']['input']>;
  device_name?: InputMaybe<Scalars['String']['input']>;
  device_os?: InputMaybe<Scalars['String']['input']>;
  device_os_version?: InputMaybe<Scalars['String']['input']>;
  device_token?: InputMaybe<Scalars['String']['input']>;
  device_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_logged_in?: InputMaybe<Scalars['Boolean']['input']>;
  jwt?: InputMaybe<Scalars['String']['input']>;
  native_push_token?: InputMaybe<Scalars['String']['input']>;
  release_channel?: InputMaybe<Scalars['String']['input']>;
  runtime_version?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type User_Device_Max_Fields = {
  __typename?: 'user_device_max_fields';
  app_build_number?: Maybe<Scalars['String']['output']>;
  app_version?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  device_brand?: Maybe<Scalars['String']['output']>;
  device_installation_id?: Maybe<Scalars['String']['output']>;
  device_manufacturer?: Maybe<Scalars['String']['output']>;
  device_model?: Maybe<Scalars['String']['output']>;
  device_name?: Maybe<Scalars['String']['output']>;
  device_os?: Maybe<Scalars['String']['output']>;
  device_os_version?: Maybe<Scalars['String']['output']>;
  device_token?: Maybe<Scalars['String']['output']>;
  device_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  jwt?: Maybe<Scalars['String']['output']>;
  native_push_token?: Maybe<Scalars['String']['output']>;
  release_channel?: Maybe<Scalars['String']['output']>;
  runtime_version?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** aggregate min on columns */
export type User_Device_Min_Fields = {
  __typename?: 'user_device_min_fields';
  app_build_number?: Maybe<Scalars['String']['output']>;
  app_version?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  device_brand?: Maybe<Scalars['String']['output']>;
  device_installation_id?: Maybe<Scalars['String']['output']>;
  device_manufacturer?: Maybe<Scalars['String']['output']>;
  device_model?: Maybe<Scalars['String']['output']>;
  device_name?: Maybe<Scalars['String']['output']>;
  device_os?: Maybe<Scalars['String']['output']>;
  device_os_version?: Maybe<Scalars['String']['output']>;
  device_token?: Maybe<Scalars['String']['output']>;
  device_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  jwt?: Maybe<Scalars['String']['output']>;
  native_push_token?: Maybe<Scalars['String']['output']>;
  release_channel?: Maybe<Scalars['String']['output']>;
  runtime_version?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** response of any mutation on the table "user_device" */
export type User_Device_Mutation_Response = {
  __typename?: 'user_device_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Device>;
};

/** on_conflict condition type for table "user_device" */
export type User_Device_On_Conflict = {
  constraint: User_Device_Constraint;
  update_columns?: Array<User_Device_Update_Column>;
  where?: InputMaybe<User_Device_Bool_Exp>;
};

/** Ordering options when selecting data from "user_device". */
export type User_Device_Order_By = {
  app_build_number?: InputMaybe<Order_By>;
  app_version?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  device_brand?: InputMaybe<Order_By>;
  device_installation_id?: InputMaybe<Order_By>;
  device_manufacturer?: InputMaybe<Order_By>;
  device_model?: InputMaybe<Order_By>;
  device_name?: InputMaybe<Order_By>;
  device_os?: InputMaybe<Order_By>;
  device_os_version?: InputMaybe<Order_By>;
  device_token?: InputMaybe<Order_By>;
  device_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_logged_in?: InputMaybe<Order_By>;
  jwt?: InputMaybe<Order_By>;
  native_push_token?: InputMaybe<Order_By>;
  release_channel?: InputMaybe<Order_By>;
  runtime_version?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_device */
export type User_Device_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "user_device" */
export enum User_Device_Select_Column {
  /** column name */
  AppBuildNumber = 'app_build_number',
  /** column name */
  AppVersion = 'app_version',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeviceBrand = 'device_brand',
  /** column name */
  DeviceInstallationId = 'device_installation_id',
  /** column name */
  DeviceManufacturer = 'device_manufacturer',
  /** column name */
  DeviceModel = 'device_model',
  /** column name */
  DeviceName = 'device_name',
  /** column name */
  DeviceOs = 'device_os',
  /** column name */
  DeviceOsVersion = 'device_os_version',
  /** column name */
  DeviceToken = 'device_token',
  /** column name */
  DeviceType = 'device_type',
  /** column name */
  Id = 'id',
  /** column name */
  IsLoggedIn = 'is_logged_in',
  /** column name */
  Jwt = 'jwt',
  /** column name */
  NativePushToken = 'native_push_token',
  /** column name */
  ReleaseChannel = 'release_channel',
  /** column name */
  RuntimeVersion = 'runtime_version',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_device" */
export type User_Device_Set_Input = {
  app_build_number?: InputMaybe<Scalars['String']['input']>;
  app_version?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  device_brand?: InputMaybe<Scalars['String']['input']>;
  device_installation_id?: InputMaybe<Scalars['String']['input']>;
  device_manufacturer?: InputMaybe<Scalars['String']['input']>;
  device_model?: InputMaybe<Scalars['String']['input']>;
  device_name?: InputMaybe<Scalars['String']['input']>;
  device_os?: InputMaybe<Scalars['String']['input']>;
  device_os_version?: InputMaybe<Scalars['String']['input']>;
  device_token?: InputMaybe<Scalars['String']['input']>;
  device_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_logged_in?: InputMaybe<Scalars['Boolean']['input']>;
  jwt?: InputMaybe<Scalars['String']['input']>;
  native_push_token?: InputMaybe<Scalars['String']['input']>;
  release_channel?: InputMaybe<Scalars['String']['input']>;
  runtime_version?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate stddev on columns */
export type User_Device_Stddev_Fields = {
  __typename?: 'user_device_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type User_Device_Stddev_Pop_Fields = {
  __typename?: 'user_device_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type User_Device_Stddev_Samp_Fields = {
  __typename?: 'user_device_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "user_device" */
export type User_Device_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Device_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Device_Stream_Cursor_Value_Input = {
  app_build_number?: InputMaybe<Scalars['String']['input']>;
  app_version?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  device_brand?: InputMaybe<Scalars['String']['input']>;
  device_installation_id?: InputMaybe<Scalars['String']['input']>;
  device_manufacturer?: InputMaybe<Scalars['String']['input']>;
  device_model?: InputMaybe<Scalars['String']['input']>;
  device_name?: InputMaybe<Scalars['String']['input']>;
  device_os?: InputMaybe<Scalars['String']['input']>;
  device_os_version?: InputMaybe<Scalars['String']['input']>;
  device_token?: InputMaybe<Scalars['String']['input']>;
  device_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_logged_in?: InputMaybe<Scalars['Boolean']['input']>;
  jwt?: InputMaybe<Scalars['String']['input']>;
  native_push_token?: InputMaybe<Scalars['String']['input']>;
  release_channel?: InputMaybe<Scalars['String']['input']>;
  runtime_version?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate sum on columns */
export type User_Device_Sum_Fields = {
  __typename?: 'user_device_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "user_device" */
export enum User_Device_Update_Column {
  /** column name */
  AppBuildNumber = 'app_build_number',
  /** column name */
  AppVersion = 'app_version',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeviceBrand = 'device_brand',
  /** column name */
  DeviceInstallationId = 'device_installation_id',
  /** column name */
  DeviceManufacturer = 'device_manufacturer',
  /** column name */
  DeviceModel = 'device_model',
  /** column name */
  DeviceName = 'device_name',
  /** column name */
  DeviceOs = 'device_os',
  /** column name */
  DeviceOsVersion = 'device_os_version',
  /** column name */
  DeviceToken = 'device_token',
  /** column name */
  DeviceType = 'device_type',
  /** column name */
  Id = 'id',
  /** column name */
  IsLoggedIn = 'is_logged_in',
  /** column name */
  Jwt = 'jwt',
  /** column name */
  NativePushToken = 'native_push_token',
  /** column name */
  ReleaseChannel = 'release_channel',
  /** column name */
  RuntimeVersion = 'runtime_version',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Device_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Device_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Device_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Device_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Device_Var_Pop_Fields = {
  __typename?: 'user_device_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type User_Device_Var_Samp_Fields = {
  __typename?: 'user_device_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type User_Device_Variance_Fields = {
  __typename?: 'user_device_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "user_feedbacks" */
export type User_Feedbacks = {
  __typename?: 'user_feedbacks';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  feedback: Scalars['String']['output'];
  from_user_id?: Maybe<Scalars['bpchar']['output']>;
  id: Scalars['bpchar']['output'];
  rating: Scalars['Int']['output'];
  /** An object relationship */
  service_request: Service_Requests;
  service_request_id: Scalars['bpchar']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['bpchar']['output'];
};

/** aggregated selection of "user_feedbacks" */
export type User_Feedbacks_Aggregate = {
  __typename?: 'user_feedbacks_aggregate';
  aggregate?: Maybe<User_Feedbacks_Aggregate_Fields>;
  nodes: Array<User_Feedbacks>;
};

export type User_Feedbacks_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Feedbacks_Aggregate_Bool_Exp_Count>;
};

export type User_Feedbacks_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Feedbacks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Feedbacks_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_feedbacks" */
export type User_Feedbacks_Aggregate_Fields = {
  __typename?: 'user_feedbacks_aggregate_fields';
  avg?: Maybe<User_Feedbacks_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Feedbacks_Max_Fields>;
  min?: Maybe<User_Feedbacks_Min_Fields>;
  stddev?: Maybe<User_Feedbacks_Stddev_Fields>;
  stddev_pop?: Maybe<User_Feedbacks_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Feedbacks_Stddev_Samp_Fields>;
  sum?: Maybe<User_Feedbacks_Sum_Fields>;
  var_pop?: Maybe<User_Feedbacks_Var_Pop_Fields>;
  var_samp?: Maybe<User_Feedbacks_Var_Samp_Fields>;
  variance?: Maybe<User_Feedbacks_Variance_Fields>;
};


/** aggregate fields of "user_feedbacks" */
export type User_Feedbacks_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Feedbacks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_feedbacks" */
export type User_Feedbacks_Aggregate_Order_By = {
  avg?: InputMaybe<User_Feedbacks_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Feedbacks_Max_Order_By>;
  min?: InputMaybe<User_Feedbacks_Min_Order_By>;
  stddev?: InputMaybe<User_Feedbacks_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Feedbacks_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Feedbacks_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Feedbacks_Sum_Order_By>;
  var_pop?: InputMaybe<User_Feedbacks_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Feedbacks_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Feedbacks_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_feedbacks" */
export type User_Feedbacks_Arr_Rel_Insert_Input = {
  data: Array<User_Feedbacks_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Feedbacks_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Feedbacks_Avg_Fields = {
  __typename?: 'user_feedbacks_avg_fields';
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_feedbacks" */
export type User_Feedbacks_Avg_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_feedbacks". All fields are combined with a logical 'AND'. */
export type User_Feedbacks_Bool_Exp = {
  _and?: InputMaybe<Array<User_Feedbacks_Bool_Exp>>;
  _not?: InputMaybe<User_Feedbacks_Bool_Exp>;
  _or?: InputMaybe<Array<User_Feedbacks_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  feedback?: InputMaybe<String_Comparison_Exp>;
  from_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  rating?: InputMaybe<Int_Comparison_Exp>;
  service_request?: InputMaybe<Service_Requests_Bool_Exp>;
  service_request_id?: InputMaybe<Bpchar_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_feedbacks" */
export enum User_Feedbacks_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserFeedbacksPkey = 'user_feedbacks_pkey'
}

/** input type for incrementing numeric columns in table "user_feedbacks" */
export type User_Feedbacks_Inc_Input = {
  rating?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_feedbacks" */
export type User_Feedbacks_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  from_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  service_request?: InputMaybe<Service_Requests_Obj_Rel_Insert_Input>;
  service_request_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type User_Feedbacks_Max_Fields = {
  __typename?: 'user_feedbacks_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  feedback?: Maybe<Scalars['String']['output']>;
  from_user_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  service_request_id?: Maybe<Scalars['bpchar']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by max() on columns of table "user_feedbacks" */
export type User_Feedbacks_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  feedback?: InputMaybe<Order_By>;
  from_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  service_request_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Feedbacks_Min_Fields = {
  __typename?: 'user_feedbacks_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  feedback?: Maybe<Scalars['String']['output']>;
  from_user_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  service_request_id?: Maybe<Scalars['bpchar']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by min() on columns of table "user_feedbacks" */
export type User_Feedbacks_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  feedback?: InputMaybe<Order_By>;
  from_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  service_request_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_feedbacks" */
export type User_Feedbacks_Mutation_Response = {
  __typename?: 'user_feedbacks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Feedbacks>;
};

/** on_conflict condition type for table "user_feedbacks" */
export type User_Feedbacks_On_Conflict = {
  constraint: User_Feedbacks_Constraint;
  update_columns?: Array<User_Feedbacks_Update_Column>;
  where?: InputMaybe<User_Feedbacks_Bool_Exp>;
};

/** Ordering options when selecting data from "user_feedbacks". */
export type User_Feedbacks_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  feedback?: InputMaybe<Order_By>;
  from_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  service_request?: InputMaybe<Service_Requests_Order_By>;
  service_request_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_feedbacks */
export type User_Feedbacks_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** select columns of table "user_feedbacks" */
export enum User_Feedbacks_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Feedback = 'feedback',
  /** column name */
  FromUserId = 'from_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  Rating = 'rating',
  /** column name */
  ServiceRequestId = 'service_request_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_feedbacks" */
export type User_Feedbacks_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  from_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  service_request_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate stddev on columns */
export type User_Feedbacks_Stddev_Fields = {
  __typename?: 'user_feedbacks_stddev_fields';
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_feedbacks" */
export type User_Feedbacks_Stddev_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Feedbacks_Stddev_Pop_Fields = {
  __typename?: 'user_feedbacks_stddev_pop_fields';
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_feedbacks" */
export type User_Feedbacks_Stddev_Pop_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Feedbacks_Stddev_Samp_Fields = {
  __typename?: 'user_feedbacks_stddev_samp_fields';
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_feedbacks" */
export type User_Feedbacks_Stddev_Samp_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_feedbacks" */
export type User_Feedbacks_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Feedbacks_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Feedbacks_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  from_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  service_request_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate sum on columns */
export type User_Feedbacks_Sum_Fields = {
  __typename?: 'user_feedbacks_sum_fields';
  rating?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "user_feedbacks" */
export type User_Feedbacks_Sum_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** update columns of table "user_feedbacks" */
export enum User_Feedbacks_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Feedback = 'feedback',
  /** column name */
  FromUserId = 'from_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  Rating = 'rating',
  /** column name */
  ServiceRequestId = 'service_request_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Feedbacks_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Feedbacks_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Feedbacks_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Feedbacks_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Feedbacks_Var_Pop_Fields = {
  __typename?: 'user_feedbacks_var_pop_fields';
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_feedbacks" */
export type User_Feedbacks_Var_Pop_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Feedbacks_Var_Samp_Fields = {
  __typename?: 'user_feedbacks_var_samp_fields';
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_feedbacks" */
export type User_Feedbacks_Var_Samp_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Feedbacks_Variance_Fields = {
  __typename?: 'user_feedbacks_variance_fields';
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_feedbacks" */
export type User_Feedbacks_Variance_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_follows_channel" */
export type User_Follows_Channel = {
  __typename?: 'user_follows_channel';
  channel_id: Scalars['bigint']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['bigint']['output'];
  reel_id?: Maybe<Scalars['bigint']['output']>;
  reel_watch_duration_ms?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['bpchar']['output'];
};

/** aggregated selection of "user_follows_channel" */
export type User_Follows_Channel_Aggregate = {
  __typename?: 'user_follows_channel_aggregate';
  aggregate?: Maybe<User_Follows_Channel_Aggregate_Fields>;
  nodes: Array<User_Follows_Channel>;
};

export type User_Follows_Channel_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Follows_Channel_Aggregate_Bool_Exp_Count>;
};

export type User_Follows_Channel_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Follows_Channel_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Follows_Channel_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_follows_channel" */
export type User_Follows_Channel_Aggregate_Fields = {
  __typename?: 'user_follows_channel_aggregate_fields';
  avg?: Maybe<User_Follows_Channel_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Follows_Channel_Max_Fields>;
  min?: Maybe<User_Follows_Channel_Min_Fields>;
  stddev?: Maybe<User_Follows_Channel_Stddev_Fields>;
  stddev_pop?: Maybe<User_Follows_Channel_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Follows_Channel_Stddev_Samp_Fields>;
  sum?: Maybe<User_Follows_Channel_Sum_Fields>;
  var_pop?: Maybe<User_Follows_Channel_Var_Pop_Fields>;
  var_samp?: Maybe<User_Follows_Channel_Var_Samp_Fields>;
  variance?: Maybe<User_Follows_Channel_Variance_Fields>;
};


/** aggregate fields of "user_follows_channel" */
export type User_Follows_Channel_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Follows_Channel_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_follows_channel" */
export type User_Follows_Channel_Aggregate_Order_By = {
  avg?: InputMaybe<User_Follows_Channel_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Follows_Channel_Max_Order_By>;
  min?: InputMaybe<User_Follows_Channel_Min_Order_By>;
  stddev?: InputMaybe<User_Follows_Channel_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Follows_Channel_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Follows_Channel_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Follows_Channel_Sum_Order_By>;
  var_pop?: InputMaybe<User_Follows_Channel_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Follows_Channel_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Follows_Channel_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_follows_channel" */
export type User_Follows_Channel_Arr_Rel_Insert_Input = {
  data: Array<User_Follows_Channel_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Follows_Channel_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Follows_Channel_Avg_Fields = {
  __typename?: 'user_follows_channel_avg_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
  reel_watch_duration_ms?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_follows_channel" */
export type User_Follows_Channel_Avg_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
  reel_watch_duration_ms?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_follows_channel". All fields are combined with a logical 'AND'. */
export type User_Follows_Channel_Bool_Exp = {
  _and?: InputMaybe<Array<User_Follows_Channel_Bool_Exp>>;
  _not?: InputMaybe<User_Follows_Channel_Bool_Exp>;
  _or?: InputMaybe<Array<User_Follows_Channel_Bool_Exp>>;
  channel_id?: InputMaybe<Bigint_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  reel_id?: InputMaybe<Bigint_Comparison_Exp>;
  reel_watch_duration_ms?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_follows_channel" */
export enum User_Follows_Channel_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserFollowsChannelPkey = 'user_follows_channel_pkey',
  /** unique or primary key constraint on columns "user_id", "deleted_at", "channel_id" */
  UserFollowsChannelUserIdIdx = 'user_follows_channel_user_id_idx'
}

/** input type for incrementing numeric columns in table "user_follows_channel" */
export type User_Follows_Channel_Inc_Input = {
  channel_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  reel_id?: InputMaybe<Scalars['bigint']['input']>;
  reel_watch_duration_ms?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_follows_channel" */
export type User_Follows_Channel_Insert_Input = {
  channel_id?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  reel_id?: InputMaybe<Scalars['bigint']['input']>;
  reel_watch_duration_ms?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type User_Follows_Channel_Max_Fields = {
  __typename?: 'user_follows_channel_max_fields';
  channel_id?: Maybe<Scalars['bigint']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  reel_id?: Maybe<Scalars['bigint']['output']>;
  reel_watch_duration_ms?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by max() on columns of table "user_follows_channel" */
export type User_Follows_Channel_Max_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
  reel_watch_duration_ms?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Follows_Channel_Min_Fields = {
  __typename?: 'user_follows_channel_min_fields';
  channel_id?: Maybe<Scalars['bigint']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  reel_id?: Maybe<Scalars['bigint']['output']>;
  reel_watch_duration_ms?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by min() on columns of table "user_follows_channel" */
export type User_Follows_Channel_Min_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
  reel_watch_duration_ms?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_follows_channel" */
export type User_Follows_Channel_Mutation_Response = {
  __typename?: 'user_follows_channel_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Follows_Channel>;
};

/** on_conflict condition type for table "user_follows_channel" */
export type User_Follows_Channel_On_Conflict = {
  constraint: User_Follows_Channel_Constraint;
  update_columns?: Array<User_Follows_Channel_Update_Column>;
  where?: InputMaybe<User_Follows_Channel_Bool_Exp>;
};

/** Ordering options when selecting data from "user_follows_channel". */
export type User_Follows_Channel_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
  reel_watch_duration_ms?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_follows_channel */
export type User_Follows_Channel_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "user_follows_channel" */
export enum User_Follows_Channel_Select_Column {
  /** column name */
  ChannelId = 'channel_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ReelId = 'reel_id',
  /** column name */
  ReelWatchDurationMs = 'reel_watch_duration_ms',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_follows_channel" */
export type User_Follows_Channel_Set_Input = {
  channel_id?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  reel_id?: InputMaybe<Scalars['bigint']['input']>;
  reel_watch_duration_ms?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate stddev on columns */
export type User_Follows_Channel_Stddev_Fields = {
  __typename?: 'user_follows_channel_stddev_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
  reel_watch_duration_ms?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_follows_channel" */
export type User_Follows_Channel_Stddev_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
  reel_watch_duration_ms?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Follows_Channel_Stddev_Pop_Fields = {
  __typename?: 'user_follows_channel_stddev_pop_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
  reel_watch_duration_ms?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_follows_channel" */
export type User_Follows_Channel_Stddev_Pop_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
  reel_watch_duration_ms?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Follows_Channel_Stddev_Samp_Fields = {
  __typename?: 'user_follows_channel_stddev_samp_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
  reel_watch_duration_ms?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_follows_channel" */
export type User_Follows_Channel_Stddev_Samp_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
  reel_watch_duration_ms?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_follows_channel" */
export type User_Follows_Channel_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Follows_Channel_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Follows_Channel_Stream_Cursor_Value_Input = {
  channel_id?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  reel_id?: InputMaybe<Scalars['bigint']['input']>;
  reel_watch_duration_ms?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate sum on columns */
export type User_Follows_Channel_Sum_Fields = {
  __typename?: 'user_follows_channel_sum_fields';
  channel_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  reel_id?: Maybe<Scalars['bigint']['output']>;
  reel_watch_duration_ms?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "user_follows_channel" */
export type User_Follows_Channel_Sum_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
  reel_watch_duration_ms?: InputMaybe<Order_By>;
};

/** update columns of table "user_follows_channel" */
export enum User_Follows_Channel_Update_Column {
  /** column name */
  ChannelId = 'channel_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ReelId = 'reel_id',
  /** column name */
  ReelWatchDurationMs = 'reel_watch_duration_ms',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Follows_Channel_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Follows_Channel_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Follows_Channel_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Follows_Channel_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Follows_Channel_Var_Pop_Fields = {
  __typename?: 'user_follows_channel_var_pop_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
  reel_watch_duration_ms?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_follows_channel" */
export type User_Follows_Channel_Var_Pop_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
  reel_watch_duration_ms?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Follows_Channel_Var_Samp_Fields = {
  __typename?: 'user_follows_channel_var_samp_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
  reel_watch_duration_ms?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_follows_channel" */
export type User_Follows_Channel_Var_Samp_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
  reel_watch_duration_ms?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Follows_Channel_Variance_Fields = {
  __typename?: 'user_follows_channel_variance_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  reel_id?: Maybe<Scalars['Float']['output']>;
  reel_watch_duration_ms?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_follows_channel" */
export type User_Follows_Channel_Variance_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reel_id?: InputMaybe<Order_By>;
  reel_watch_duration_ms?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_location_logs" */
export type User_Location_Logs = {
  __typename?: 'user_location_logs';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['bpchar']['output'];
  lat: Scalars['float8']['output'];
  lng: Scalars['float8']['output'];
  location?: Maybe<Scalars['geography']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['bpchar']['output'];
};

/** aggregated selection of "user_location_logs" */
export type User_Location_Logs_Aggregate = {
  __typename?: 'user_location_logs_aggregate';
  aggregate?: Maybe<User_Location_Logs_Aggregate_Fields>;
  nodes: Array<User_Location_Logs>;
};

export type User_Location_Logs_Aggregate_Bool_Exp = {
  avg?: InputMaybe<User_Location_Logs_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<User_Location_Logs_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<User_Location_Logs_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<User_Location_Logs_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<User_Location_Logs_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<User_Location_Logs_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<User_Location_Logs_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<User_Location_Logs_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<User_Location_Logs_Aggregate_Bool_Exp_Var_Samp>;
};

export type User_Location_Logs_Aggregate_Bool_Exp_Avg = {
  arguments: User_Location_Logs_Select_Column_User_Location_Logs_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Location_Logs_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Location_Logs_Aggregate_Bool_Exp_Corr = {
  arguments: User_Location_Logs_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Location_Logs_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Location_Logs_Aggregate_Bool_Exp_Corr_Arguments = {
  X: User_Location_Logs_Select_Column_User_Location_Logs_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: User_Location_Logs_Select_Column_User_Location_Logs_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type User_Location_Logs_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Location_Logs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Location_Logs_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type User_Location_Logs_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: User_Location_Logs_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Location_Logs_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Location_Logs_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: User_Location_Logs_Select_Column_User_Location_Logs_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: User_Location_Logs_Select_Column_User_Location_Logs_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type User_Location_Logs_Aggregate_Bool_Exp_Max = {
  arguments: User_Location_Logs_Select_Column_User_Location_Logs_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Location_Logs_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Location_Logs_Aggregate_Bool_Exp_Min = {
  arguments: User_Location_Logs_Select_Column_User_Location_Logs_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Location_Logs_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Location_Logs_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: User_Location_Logs_Select_Column_User_Location_Logs_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Location_Logs_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Location_Logs_Aggregate_Bool_Exp_Sum = {
  arguments: User_Location_Logs_Select_Column_User_Location_Logs_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Location_Logs_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Location_Logs_Aggregate_Bool_Exp_Var_Samp = {
  arguments: User_Location_Logs_Select_Column_User_Location_Logs_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Location_Logs_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "user_location_logs" */
export type User_Location_Logs_Aggregate_Fields = {
  __typename?: 'user_location_logs_aggregate_fields';
  avg?: Maybe<User_Location_Logs_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Location_Logs_Max_Fields>;
  min?: Maybe<User_Location_Logs_Min_Fields>;
  stddev?: Maybe<User_Location_Logs_Stddev_Fields>;
  stddev_pop?: Maybe<User_Location_Logs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Location_Logs_Stddev_Samp_Fields>;
  sum?: Maybe<User_Location_Logs_Sum_Fields>;
  var_pop?: Maybe<User_Location_Logs_Var_Pop_Fields>;
  var_samp?: Maybe<User_Location_Logs_Var_Samp_Fields>;
  variance?: Maybe<User_Location_Logs_Variance_Fields>;
};


/** aggregate fields of "user_location_logs" */
export type User_Location_Logs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Location_Logs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_location_logs" */
export type User_Location_Logs_Aggregate_Order_By = {
  avg?: InputMaybe<User_Location_Logs_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Location_Logs_Max_Order_By>;
  min?: InputMaybe<User_Location_Logs_Min_Order_By>;
  stddev?: InputMaybe<User_Location_Logs_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Location_Logs_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Location_Logs_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Location_Logs_Sum_Order_By>;
  var_pop?: InputMaybe<User_Location_Logs_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Location_Logs_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Location_Logs_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_location_logs" */
export type User_Location_Logs_Arr_Rel_Insert_Input = {
  data: Array<User_Location_Logs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Location_Logs_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Location_Logs_Avg_Fields = {
  __typename?: 'user_location_logs_avg_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_location_logs" */
export type User_Location_Logs_Avg_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_location_logs". All fields are combined with a logical 'AND'. */
export type User_Location_Logs_Bool_Exp = {
  _and?: InputMaybe<Array<User_Location_Logs_Bool_Exp>>;
  _not?: InputMaybe<User_Location_Logs_Bool_Exp>;
  _or?: InputMaybe<Array<User_Location_Logs_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  lat?: InputMaybe<Float8_Comparison_Exp>;
  lng?: InputMaybe<Float8_Comparison_Exp>;
  location?: InputMaybe<Geography_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_location_logs" */
export enum User_Location_Logs_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserLocationLogsPkey = 'user_location_logs_pkey'
}

/** input type for incrementing numeric columns in table "user_location_logs" */
export type User_Location_Logs_Inc_Input = {
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "user_location_logs" */
export type User_Location_Logs_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  location?: InputMaybe<Scalars['geography']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type User_Location_Logs_Max_Fields = {
  __typename?: 'user_location_logs_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by max() on columns of table "user_location_logs" */
export type User_Location_Logs_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Location_Logs_Min_Fields = {
  __typename?: 'user_location_logs_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by min() on columns of table "user_location_logs" */
export type User_Location_Logs_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_location_logs" */
export type User_Location_Logs_Mutation_Response = {
  __typename?: 'user_location_logs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Location_Logs>;
};

/** on_conflict condition type for table "user_location_logs" */
export type User_Location_Logs_On_Conflict = {
  constraint: User_Location_Logs_Constraint;
  update_columns?: Array<User_Location_Logs_Update_Column>;
  where?: InputMaybe<User_Location_Logs_Bool_Exp>;
};

/** Ordering options when selecting data from "user_location_logs". */
export type User_Location_Logs_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_location_logs */
export type User_Location_Logs_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** select columns of table "user_location_logs" */
export enum User_Location_Logs_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  Location = 'location',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "user_location_logs_aggregate_bool_exp_avg_arguments_columns" columns of table "user_location_logs" */
export enum User_Location_Logs_Select_Column_User_Location_Logs_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "user_location_logs_aggregate_bool_exp_corr_arguments_columns" columns of table "user_location_logs" */
export enum User_Location_Logs_Select_Column_User_Location_Logs_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "user_location_logs_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "user_location_logs" */
export enum User_Location_Logs_Select_Column_User_Location_Logs_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "user_location_logs_aggregate_bool_exp_max_arguments_columns" columns of table "user_location_logs" */
export enum User_Location_Logs_Select_Column_User_Location_Logs_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "user_location_logs_aggregate_bool_exp_min_arguments_columns" columns of table "user_location_logs" */
export enum User_Location_Logs_Select_Column_User_Location_Logs_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "user_location_logs_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "user_location_logs" */
export enum User_Location_Logs_Select_Column_User_Location_Logs_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "user_location_logs_aggregate_bool_exp_sum_arguments_columns" columns of table "user_location_logs" */
export enum User_Location_Logs_Select_Column_User_Location_Logs_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "user_location_logs_aggregate_bool_exp_var_samp_arguments_columns" columns of table "user_location_logs" */
export enum User_Location_Logs_Select_Column_User_Location_Logs_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** input type for updating data in table "user_location_logs" */
export type User_Location_Logs_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  location?: InputMaybe<Scalars['geography']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate stddev on columns */
export type User_Location_Logs_Stddev_Fields = {
  __typename?: 'user_location_logs_stddev_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_location_logs" */
export type User_Location_Logs_Stddev_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Location_Logs_Stddev_Pop_Fields = {
  __typename?: 'user_location_logs_stddev_pop_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_location_logs" */
export type User_Location_Logs_Stddev_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Location_Logs_Stddev_Samp_Fields = {
  __typename?: 'user_location_logs_stddev_samp_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_location_logs" */
export type User_Location_Logs_Stddev_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_location_logs" */
export type User_Location_Logs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Location_Logs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Location_Logs_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  location?: InputMaybe<Scalars['geography']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate sum on columns */
export type User_Location_Logs_Sum_Fields = {
  __typename?: 'user_location_logs_sum_fields';
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "user_location_logs" */
export type User_Location_Logs_Sum_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** update columns of table "user_location_logs" */
export enum User_Location_Logs_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  Location = 'location',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Location_Logs_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Location_Logs_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Location_Logs_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Location_Logs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Location_Logs_Var_Pop_Fields = {
  __typename?: 'user_location_logs_var_pop_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_location_logs" */
export type User_Location_Logs_Var_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Location_Logs_Var_Samp_Fields = {
  __typename?: 'user_location_logs_var_samp_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_location_logs" */
export type User_Location_Logs_Var_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Location_Logs_Variance_Fields = {
  __typename?: 'user_location_logs_variance_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_location_logs" */
export type User_Location_Logs_Variance_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  /** An array relationship */
  account_users: Array<Account_User>;
  /** An aggregate relationship */
  account_users_aggregate: Account_User_Aggregate;
  /** An array relationship */
  accounts: Array<Accounts>;
  /** An aggregate relationship */
  accounts_aggregate: Accounts_Aggregate;
  /** An array relationship */
  companies: Array<Companies>;
  /** An aggregate relationship */
  companies_aggregate: Companies_Aggregate;
  content_languages?: Maybe<Scalars['json']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  crop_users: Array<Crop_User>;
  /** An aggregate relationship */
  crop_users_aggregate: Crop_User_Aggregate;
  date_of_birth?: Maybe<Scalars['String']['output']>;
  default_role?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  email_verified_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  farmer_plots: Array<Farmer_Plots>;
  /** An aggregate relationship */
  farmer_plots_aggregate: Farmer_Plots_Aggregate;
  /** An array relationship */
  fieldPartnerResponseEventsByFieldPartnerUserId: Array<Field_Partner_Response_Events>;
  /** An aggregate relationship */
  fieldPartnerResponseEventsByFieldPartnerUserId_aggregate: Field_Partner_Response_Events_Aggregate;
  /** An array relationship */
  fieldPartnerResponseMessagesByFieldPartnerUserId: Array<Field_Partner_Response_Messages>;
  /** An aggregate relationship */
  fieldPartnerResponseMessagesByFieldPartnerUserId_aggregate: Field_Partner_Response_Messages_Aggregate;
  /** An array relationship */
  fieldPartnerResponseMessagesByFromUserId: Array<Field_Partner_Response_Messages>;
  /** An aggregate relationship */
  fieldPartnerResponseMessagesByFromUserId_aggregate: Field_Partner_Response_Messages_Aggregate;
  /** An array relationship */
  fieldPartnerResponseMessagesByToUserId: Array<Field_Partner_Response_Messages>;
  /** An aggregate relationship */
  fieldPartnerResponseMessagesByToUserId_aggregate: Field_Partner_Response_Messages_Aggregate;
  /** An array relationship */
  fieldPartnerResponsesByFieldPartnerUserId: Array<Field_Partner_Responses>;
  /** An aggregate relationship */
  fieldPartnerResponsesByFieldPartnerUserId_aggregate: Field_Partner_Responses_Aggregate;
  /** An array relationship */
  fieldScheduledVisitsByFieldPartnerUserId: Array<Field_Scheduled_Visits>;
  /** An aggregate relationship */
  fieldScheduledVisitsByFieldPartnerUserId_aggregate: Field_Scheduled_Visits_Aggregate;
  /** An array relationship */
  field_partner_response_events: Array<Field_Partner_Response_Events>;
  /** An aggregate relationship */
  field_partner_response_events_aggregate: Field_Partner_Response_Events_Aggregate;
  /** An array relationship */
  field_partner_response_messages: Array<Field_Partner_Response_Messages>;
  /** An aggregate relationship */
  field_partner_response_messages_aggregate: Field_Partner_Response_Messages_Aggregate;
  /** An array relationship */
  field_partner_responses: Array<Field_Partner_Responses>;
  /** An aggregate relationship */
  field_partner_responses_aggregate: Field_Partner_Responses_Aggregate;
  /** An array relationship */
  field_scheduled_visits: Array<Field_Scheduled_Visits>;
  /** An aggregate relationship */
  field_scheduled_visits_aggregate: Field_Scheduled_Visits_Aggregate;
  follower_count: Scalars['Int']['output'];
  /** An array relationship */
  follows_channels: Array<User_Follows_Channel>;
  /** An aggregate relationship */
  follows_channels_aggregate: User_Follows_Channel_Aggregate;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['bpchar']['output'];
  is_test?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  lastKnownLocationsByRequestFarmerId: Array<Last_Known_Locations>;
  /** An aggregate relationship */
  lastKnownLocationsByRequestFarmerId_aggregate: Last_Known_Locations_Aggregate;
  /** An array relationship */
  last_known_locations: Array<Last_Known_Locations>;
  /** An aggregate relationship */
  last_known_locations_aggregate: Last_Known_Locations_Aggregate;
  locale?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  market?: Maybe<Runpando_Pro_Users>;
  /** An array relationship */
  model_has_roles: Array<Model_Has_Roles>;
  /** An aggregate relationship */
  model_has_roles_aggregate: Model_Has_Roles_Aggregate;
  name: Scalars['String']['output'];
  /** An array relationship */
  nova_twofas: Array<Nova_Twofa>;
  /** An aggregate relationship */
  nova_twofas_aggregate: Nova_Twofa_Aggregate;
  password?: Maybe<Scalars['String']['output']>;
  phone_number: Scalars['String']['output'];
  profile_image_url?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  reel_comments: Array<Reel_Comments>;
  /** An aggregate relationship */
  reel_comments_aggregate: Reel_Comments_Aggregate;
  remember_token?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  segment_users: Array<Segment_User>;
  /** An aggregate relationship */
  segment_users_aggregate: Segment_User_Aggregate;
  /** An array relationship */
  service_requests: Array<Service_Requests>;
  /** An aggregate relationship */
  service_requests_aggregate: Service_Requests_Aggregate;
  socialite?: Maybe<Scalars['jsonb']['output']>;
  total_watch_time_secs: Scalars['bigint']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  user_feedbacks: Array<User_Feedbacks>;
  /** An aggregate relationship */
  user_feedbacks_aggregate: User_Feedbacks_Aggregate;
  /** An array relationship */
  user_location_logs: Array<User_Location_Logs>;
  /** An aggregate relationship */
  user_location_logs_aggregate: User_Location_Logs_Aggregate;
  /** An array relationship */
  user_wallets: Array<Wallets>;
  /** An aggregate relationship */
  user_wallets_aggregate: Wallets_Aggregate;
  /** An array relationship */
  users_follows_to: Array<Follows>;
  /** An aggregate relationship */
  users_follows_to_aggregate: Follows_Aggregate;
  /** An array relationship */
  users_prospect_messages_from: Array<Prospect_Messages>;
  /** An aggregate relationship */
  users_prospect_messages_from_aggregate: Prospect_Messages_Aggregate;
  /** An array relationship */
  users_prospect_messages_to: Array<Prospect_Messages>;
  /** An aggregate relationship */
  users_prospect_messages_to_aggregate: Prospect_Messages_Aggregate;
  /** An array relationship */
  users_reel_interactions: Array<Reel_Interactions>;
  /** An aggregate relationship */
  users_reel_interactions_aggregate: Reel_Interactions_Aggregate;
};


/** columns and relationships of "users" */
export type UsersAccount_UsersArgs = {
  distinct_on?: InputMaybe<Array<Account_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_User_Order_By>>;
  where?: InputMaybe<Account_User_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersAccount_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_User_Order_By>>;
  where?: InputMaybe<Account_User_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersAccountsArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Accounts_Order_By>>;
  where?: InputMaybe<Accounts_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersAccounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Accounts_Order_By>>;
  where?: InputMaybe<Accounts_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCompaniesArgs = {
  distinct_on?: InputMaybe<Array<Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Companies_Order_By>>;
  where?: InputMaybe<Companies_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCompanies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Companies_Order_By>>;
  where?: InputMaybe<Companies_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersContent_LanguagesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "users" */
export type UsersCrop_UsersArgs = {
  distinct_on?: InputMaybe<Array<Crop_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crop_User_Order_By>>;
  where?: InputMaybe<Crop_User_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCrop_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crop_User_Order_By>>;
  where?: InputMaybe<Crop_User_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFarmer_PlotsArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Plots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Plots_Order_By>>;
  where?: InputMaybe<Farmer_Plots_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFarmer_Plots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farmer_Plots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farmer_Plots_Order_By>>;
  where?: InputMaybe<Farmer_Plots_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFieldPartnerResponseEventsByFieldPartnerUserIdArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Response_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Response_Events_Order_By>>;
  where?: InputMaybe<Field_Partner_Response_Events_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFieldPartnerResponseEventsByFieldPartnerUserId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Response_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Response_Events_Order_By>>;
  where?: InputMaybe<Field_Partner_Response_Events_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFieldPartnerResponseMessagesByFieldPartnerUserIdArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Response_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Response_Messages_Order_By>>;
  where?: InputMaybe<Field_Partner_Response_Messages_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFieldPartnerResponseMessagesByFieldPartnerUserId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Response_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Response_Messages_Order_By>>;
  where?: InputMaybe<Field_Partner_Response_Messages_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFieldPartnerResponseMessagesByFromUserIdArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Response_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Response_Messages_Order_By>>;
  where?: InputMaybe<Field_Partner_Response_Messages_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFieldPartnerResponseMessagesByFromUserId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Response_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Response_Messages_Order_By>>;
  where?: InputMaybe<Field_Partner_Response_Messages_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFieldPartnerResponseMessagesByToUserIdArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Response_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Response_Messages_Order_By>>;
  where?: InputMaybe<Field_Partner_Response_Messages_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFieldPartnerResponseMessagesByToUserId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Response_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Response_Messages_Order_By>>;
  where?: InputMaybe<Field_Partner_Response_Messages_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFieldPartnerResponsesByFieldPartnerUserIdArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Responses_Order_By>>;
  where?: InputMaybe<Field_Partner_Responses_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFieldPartnerResponsesByFieldPartnerUserId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Responses_Order_By>>;
  where?: InputMaybe<Field_Partner_Responses_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFieldScheduledVisitsByFieldPartnerUserIdArgs = {
  distinct_on?: InputMaybe<Array<Field_Scheduled_Visits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Scheduled_Visits_Order_By>>;
  where?: InputMaybe<Field_Scheduled_Visits_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFieldScheduledVisitsByFieldPartnerUserId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Scheduled_Visits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Scheduled_Visits_Order_By>>;
  where?: InputMaybe<Field_Scheduled_Visits_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersField_Partner_Response_EventsArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Response_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Response_Events_Order_By>>;
  where?: InputMaybe<Field_Partner_Response_Events_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersField_Partner_Response_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Response_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Response_Events_Order_By>>;
  where?: InputMaybe<Field_Partner_Response_Events_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersField_Partner_Response_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Response_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Response_Messages_Order_By>>;
  where?: InputMaybe<Field_Partner_Response_Messages_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersField_Partner_Response_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Response_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Response_Messages_Order_By>>;
  where?: InputMaybe<Field_Partner_Response_Messages_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersField_Partner_ResponsesArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Responses_Order_By>>;
  where?: InputMaybe<Field_Partner_Responses_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersField_Partner_Responses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Partner_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Partner_Responses_Order_By>>;
  where?: InputMaybe<Field_Partner_Responses_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersField_Scheduled_VisitsArgs = {
  distinct_on?: InputMaybe<Array<Field_Scheduled_Visits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Scheduled_Visits_Order_By>>;
  where?: InputMaybe<Field_Scheduled_Visits_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersField_Scheduled_Visits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Scheduled_Visits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Field_Scheduled_Visits_Order_By>>;
  where?: InputMaybe<Field_Scheduled_Visits_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFollows_ChannelsArgs = {
  distinct_on?: InputMaybe<Array<User_Follows_Channel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Follows_Channel_Order_By>>;
  where?: InputMaybe<User_Follows_Channel_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFollows_Channels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Follows_Channel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Follows_Channel_Order_By>>;
  where?: InputMaybe<User_Follows_Channel_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLastKnownLocationsByRequestFarmerIdArgs = {
  distinct_on?: InputMaybe<Array<Last_Known_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Last_Known_Locations_Order_By>>;
  where?: InputMaybe<Last_Known_Locations_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLastKnownLocationsByRequestFarmerId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Last_Known_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Last_Known_Locations_Order_By>>;
  where?: InputMaybe<Last_Known_Locations_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLast_Known_LocationsArgs = {
  distinct_on?: InputMaybe<Array<Last_Known_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Last_Known_Locations_Order_By>>;
  where?: InputMaybe<Last_Known_Locations_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLast_Known_Locations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Last_Known_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Last_Known_Locations_Order_By>>;
  where?: InputMaybe<Last_Known_Locations_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersModel_Has_RolesArgs = {
  distinct_on?: InputMaybe<Array<Model_Has_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Has_Roles_Order_By>>;
  where?: InputMaybe<Model_Has_Roles_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersModel_Has_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Model_Has_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Has_Roles_Order_By>>;
  where?: InputMaybe<Model_Has_Roles_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersNova_TwofasArgs = {
  distinct_on?: InputMaybe<Array<Nova_Twofa_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nova_Twofa_Order_By>>;
  where?: InputMaybe<Nova_Twofa_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersNova_Twofas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nova_Twofa_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nova_Twofa_Order_By>>;
  where?: InputMaybe<Nova_Twofa_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersReel_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Reel_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_Comments_Order_By>>;
  where?: InputMaybe<Reel_Comments_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersReel_Comments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reel_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_Comments_Order_By>>;
  where?: InputMaybe<Reel_Comments_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSegment_UsersArgs = {
  distinct_on?: InputMaybe<Array<Segment_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Segment_User_Order_By>>;
  where?: InputMaybe<Segment_User_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSegment_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Segment_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Segment_User_Order_By>>;
  where?: InputMaybe<Segment_User_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersService_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Service_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Requests_Order_By>>;
  where?: InputMaybe<Service_Requests_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersService_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Requests_Order_By>>;
  where?: InputMaybe<Service_Requests_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSocialiteArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "users" */
export type UsersUser_FeedbacksArgs = {
  distinct_on?: InputMaybe<Array<User_Feedbacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Feedbacks_Order_By>>;
  where?: InputMaybe<User_Feedbacks_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_Feedbacks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Feedbacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Feedbacks_Order_By>>;
  where?: InputMaybe<User_Feedbacks_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_Location_LogsArgs = {
  distinct_on?: InputMaybe<Array<User_Location_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Location_Logs_Order_By>>;
  where?: InputMaybe<User_Location_Logs_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_Location_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Location_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Location_Logs_Order_By>>;
  where?: InputMaybe<User_Location_Logs_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_WalletsArgs = {
  distinct_on?: InputMaybe<Array<Wallets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallets_Order_By>>;
  where?: InputMaybe<Wallets_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_Wallets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wallets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallets_Order_By>>;
  where?: InputMaybe<Wallets_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsers_Follows_ToArgs = {
  distinct_on?: InputMaybe<Array<Follows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Follows_Order_By>>;
  where?: InputMaybe<Follows_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsers_Follows_To_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Follows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Follows_Order_By>>;
  where?: InputMaybe<Follows_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsers_Prospect_Messages_FromArgs = {
  distinct_on?: InputMaybe<Array<Prospect_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospect_Messages_Order_By>>;
  where?: InputMaybe<Prospect_Messages_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsers_Prospect_Messages_From_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prospect_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospect_Messages_Order_By>>;
  where?: InputMaybe<Prospect_Messages_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsers_Prospect_Messages_ToArgs = {
  distinct_on?: InputMaybe<Array<Prospect_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospect_Messages_Order_By>>;
  where?: InputMaybe<Prospect_Messages_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsers_Prospect_Messages_To_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prospect_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospect_Messages_Order_By>>;
  where?: InputMaybe<Prospect_Messages_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsers_Reel_InteractionsArgs = {
  distinct_on?: InputMaybe<Array<Reel_Interactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_Interactions_Order_By>>;
  where?: InputMaybe<Reel_Interactions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsers_Reel_Interactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reel_Interactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reel_Interactions_Order_By>>;
  where?: InputMaybe<Reel_Interactions_Bool_Exp>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  avg?: Maybe<Users_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
  stddev?: Maybe<Users_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Sum_Fields>;
  var_pop?: Maybe<Users_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Var_Samp_Fields>;
  variance?: Maybe<Users_Variance_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Users_Append_Input = {
  socialite?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Users_Avg_Fields = {
  __typename?: 'users_avg_fields';
  follower_count?: Maybe<Scalars['Float']['output']>;
  total_watch_time_secs?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  account_users?: InputMaybe<Account_User_Bool_Exp>;
  account_users_aggregate?: InputMaybe<Account_User_Aggregate_Bool_Exp>;
  accounts?: InputMaybe<Accounts_Bool_Exp>;
  accounts_aggregate?: InputMaybe<Accounts_Aggregate_Bool_Exp>;
  companies?: InputMaybe<Companies_Bool_Exp>;
  companies_aggregate?: InputMaybe<Companies_Aggregate_Bool_Exp>;
  content_languages?: InputMaybe<Json_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  crop_users?: InputMaybe<Crop_User_Bool_Exp>;
  crop_users_aggregate?: InputMaybe<Crop_User_Aggregate_Bool_Exp>;
  date_of_birth?: InputMaybe<String_Comparison_Exp>;
  default_role?: InputMaybe<String_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  email_verified_at?: InputMaybe<Timestamp_Comparison_Exp>;
  farmer_plots?: InputMaybe<Farmer_Plots_Bool_Exp>;
  farmer_plots_aggregate?: InputMaybe<Farmer_Plots_Aggregate_Bool_Exp>;
  fieldPartnerResponseEventsByFieldPartnerUserId?: InputMaybe<Field_Partner_Response_Events_Bool_Exp>;
  fieldPartnerResponseEventsByFieldPartnerUserId_aggregate?: InputMaybe<Field_Partner_Response_Events_Aggregate_Bool_Exp>;
  fieldPartnerResponseMessagesByFieldPartnerUserId?: InputMaybe<Field_Partner_Response_Messages_Bool_Exp>;
  fieldPartnerResponseMessagesByFieldPartnerUserId_aggregate?: InputMaybe<Field_Partner_Response_Messages_Aggregate_Bool_Exp>;
  fieldPartnerResponseMessagesByFromUserId?: InputMaybe<Field_Partner_Response_Messages_Bool_Exp>;
  fieldPartnerResponseMessagesByFromUserId_aggregate?: InputMaybe<Field_Partner_Response_Messages_Aggregate_Bool_Exp>;
  fieldPartnerResponseMessagesByToUserId?: InputMaybe<Field_Partner_Response_Messages_Bool_Exp>;
  fieldPartnerResponseMessagesByToUserId_aggregate?: InputMaybe<Field_Partner_Response_Messages_Aggregate_Bool_Exp>;
  fieldPartnerResponsesByFieldPartnerUserId?: InputMaybe<Field_Partner_Responses_Bool_Exp>;
  fieldPartnerResponsesByFieldPartnerUserId_aggregate?: InputMaybe<Field_Partner_Responses_Aggregate_Bool_Exp>;
  fieldScheduledVisitsByFieldPartnerUserId?: InputMaybe<Field_Scheduled_Visits_Bool_Exp>;
  fieldScheduledVisitsByFieldPartnerUserId_aggregate?: InputMaybe<Field_Scheduled_Visits_Aggregate_Bool_Exp>;
  field_partner_response_events?: InputMaybe<Field_Partner_Response_Events_Bool_Exp>;
  field_partner_response_events_aggregate?: InputMaybe<Field_Partner_Response_Events_Aggregate_Bool_Exp>;
  field_partner_response_messages?: InputMaybe<Field_Partner_Response_Messages_Bool_Exp>;
  field_partner_response_messages_aggregate?: InputMaybe<Field_Partner_Response_Messages_Aggregate_Bool_Exp>;
  field_partner_responses?: InputMaybe<Field_Partner_Responses_Bool_Exp>;
  field_partner_responses_aggregate?: InputMaybe<Field_Partner_Responses_Aggregate_Bool_Exp>;
  field_scheduled_visits?: InputMaybe<Field_Scheduled_Visits_Bool_Exp>;
  field_scheduled_visits_aggregate?: InputMaybe<Field_Scheduled_Visits_Aggregate_Bool_Exp>;
  follower_count?: InputMaybe<Int_Comparison_Exp>;
  follows_channels?: InputMaybe<User_Follows_Channel_Bool_Exp>;
  follows_channels_aggregate?: InputMaybe<User_Follows_Channel_Aggregate_Bool_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  is_test?: InputMaybe<Boolean_Comparison_Exp>;
  lastKnownLocationsByRequestFarmerId?: InputMaybe<Last_Known_Locations_Bool_Exp>;
  lastKnownLocationsByRequestFarmerId_aggregate?: InputMaybe<Last_Known_Locations_Aggregate_Bool_Exp>;
  last_known_locations?: InputMaybe<Last_Known_Locations_Bool_Exp>;
  last_known_locations_aggregate?: InputMaybe<Last_Known_Locations_Aggregate_Bool_Exp>;
  locale?: InputMaybe<String_Comparison_Exp>;
  market?: InputMaybe<Runpando_Pro_Users_Bool_Exp>;
  model_has_roles?: InputMaybe<Model_Has_Roles_Bool_Exp>;
  model_has_roles_aggregate?: InputMaybe<Model_Has_Roles_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  nova_twofas?: InputMaybe<Nova_Twofa_Bool_Exp>;
  nova_twofas_aggregate?: InputMaybe<Nova_Twofa_Aggregate_Bool_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  profile_image_url?: InputMaybe<String_Comparison_Exp>;
  reel_comments?: InputMaybe<Reel_Comments_Bool_Exp>;
  reel_comments_aggregate?: InputMaybe<Reel_Comments_Aggregate_Bool_Exp>;
  remember_token?: InputMaybe<String_Comparison_Exp>;
  segment_users?: InputMaybe<Segment_User_Bool_Exp>;
  segment_users_aggregate?: InputMaybe<Segment_User_Aggregate_Bool_Exp>;
  service_requests?: InputMaybe<Service_Requests_Bool_Exp>;
  service_requests_aggregate?: InputMaybe<Service_Requests_Aggregate_Bool_Exp>;
  socialite?: InputMaybe<Jsonb_Comparison_Exp>;
  total_watch_time_secs?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_feedbacks?: InputMaybe<User_Feedbacks_Bool_Exp>;
  user_feedbacks_aggregate?: InputMaybe<User_Feedbacks_Aggregate_Bool_Exp>;
  user_location_logs?: InputMaybe<User_Location_Logs_Bool_Exp>;
  user_location_logs_aggregate?: InputMaybe<User_Location_Logs_Aggregate_Bool_Exp>;
  user_wallets?: InputMaybe<Wallets_Bool_Exp>;
  user_wallets_aggregate?: InputMaybe<Wallets_Aggregate_Bool_Exp>;
  users_follows_to?: InputMaybe<Follows_Bool_Exp>;
  users_follows_to_aggregate?: InputMaybe<Follows_Aggregate_Bool_Exp>;
  users_prospect_messages_from?: InputMaybe<Prospect_Messages_Bool_Exp>;
  users_prospect_messages_from_aggregate?: InputMaybe<Prospect_Messages_Aggregate_Bool_Exp>;
  users_prospect_messages_to?: InputMaybe<Prospect_Messages_Bool_Exp>;
  users_prospect_messages_to_aggregate?: InputMaybe<Prospect_Messages_Aggregate_Bool_Exp>;
  users_reel_interactions?: InputMaybe<Reel_Interactions_Bool_Exp>;
  users_reel_interactions_aggregate?: InputMaybe<Reel_Interactions_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "deleted_at", "phone_number" */
  UsersPhoneNumberIdx = 'users_phone_number_idx',
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Users_Delete_At_Path_Input = {
  socialite?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Users_Delete_Elem_Input = {
  socialite?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Users_Delete_Key_Input = {
  socialite?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "users" */
export type Users_Inc_Input = {
  follower_count?: InputMaybe<Scalars['Int']['input']>;
  total_watch_time_secs?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  account_users?: InputMaybe<Account_User_Arr_Rel_Insert_Input>;
  accounts?: InputMaybe<Accounts_Arr_Rel_Insert_Input>;
  companies?: InputMaybe<Companies_Arr_Rel_Insert_Input>;
  content_languages?: InputMaybe<Scalars['json']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crop_users?: InputMaybe<Crop_User_Arr_Rel_Insert_Input>;
  date_of_birth?: InputMaybe<Scalars['String']['input']>;
  default_role?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_verified_at?: InputMaybe<Scalars['timestamp']['input']>;
  farmer_plots?: InputMaybe<Farmer_Plots_Arr_Rel_Insert_Input>;
  fieldPartnerResponseEventsByFieldPartnerUserId?: InputMaybe<Field_Partner_Response_Events_Arr_Rel_Insert_Input>;
  fieldPartnerResponseMessagesByFieldPartnerUserId?: InputMaybe<Field_Partner_Response_Messages_Arr_Rel_Insert_Input>;
  fieldPartnerResponseMessagesByFromUserId?: InputMaybe<Field_Partner_Response_Messages_Arr_Rel_Insert_Input>;
  fieldPartnerResponseMessagesByToUserId?: InputMaybe<Field_Partner_Response_Messages_Arr_Rel_Insert_Input>;
  fieldPartnerResponsesByFieldPartnerUserId?: InputMaybe<Field_Partner_Responses_Arr_Rel_Insert_Input>;
  fieldScheduledVisitsByFieldPartnerUserId?: InputMaybe<Field_Scheduled_Visits_Arr_Rel_Insert_Input>;
  field_partner_response_events?: InputMaybe<Field_Partner_Response_Events_Arr_Rel_Insert_Input>;
  field_partner_response_messages?: InputMaybe<Field_Partner_Response_Messages_Arr_Rel_Insert_Input>;
  field_partner_responses?: InputMaybe<Field_Partner_Responses_Arr_Rel_Insert_Input>;
  field_scheduled_visits?: InputMaybe<Field_Scheduled_Visits_Arr_Rel_Insert_Input>;
  follower_count?: InputMaybe<Scalars['Int']['input']>;
  follows_channels?: InputMaybe<User_Follows_Channel_Arr_Rel_Insert_Input>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  is_test?: InputMaybe<Scalars['Boolean']['input']>;
  lastKnownLocationsByRequestFarmerId?: InputMaybe<Last_Known_Locations_Arr_Rel_Insert_Input>;
  last_known_locations?: InputMaybe<Last_Known_Locations_Arr_Rel_Insert_Input>;
  locale?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Runpando_Pro_Users_Obj_Rel_Insert_Input>;
  model_has_roles?: InputMaybe<Model_Has_Roles_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  nova_twofas?: InputMaybe<Nova_Twofa_Arr_Rel_Insert_Input>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  profile_image_url?: InputMaybe<Scalars['String']['input']>;
  reel_comments?: InputMaybe<Reel_Comments_Arr_Rel_Insert_Input>;
  remember_token?: InputMaybe<Scalars['String']['input']>;
  segment_users?: InputMaybe<Segment_User_Arr_Rel_Insert_Input>;
  service_requests?: InputMaybe<Service_Requests_Arr_Rel_Insert_Input>;
  socialite?: InputMaybe<Scalars['jsonb']['input']>;
  total_watch_time_secs?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_feedbacks?: InputMaybe<User_Feedbacks_Arr_Rel_Insert_Input>;
  user_location_logs?: InputMaybe<User_Location_Logs_Arr_Rel_Insert_Input>;
  user_wallets?: InputMaybe<Wallets_Arr_Rel_Insert_Input>;
  users_follows_to?: InputMaybe<Follows_Arr_Rel_Insert_Input>;
  users_prospect_messages_from?: InputMaybe<Prospect_Messages_Arr_Rel_Insert_Input>;
  users_prospect_messages_to?: InputMaybe<Prospect_Messages_Arr_Rel_Insert_Input>;
  users_reel_interactions?: InputMaybe<Reel_Interactions_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  date_of_birth?: Maybe<Scalars['String']['output']>;
  default_role?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  email_verified_at?: Maybe<Scalars['timestamp']['output']>;
  follower_count?: Maybe<Scalars['Int']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  profile_image_url?: Maybe<Scalars['String']['output']>;
  remember_token?: Maybe<Scalars['String']['output']>;
  total_watch_time_secs?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  date_of_birth?: Maybe<Scalars['String']['output']>;
  default_role?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  email_verified_at?: Maybe<Scalars['timestamp']['output']>;
  follower_count?: Maybe<Scalars['Int']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  profile_image_url?: Maybe<Scalars['String']['output']>;
  remember_token?: Maybe<Scalars['String']['output']>;
  total_watch_time_secs?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** on_conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  account_users_aggregate?: InputMaybe<Account_User_Aggregate_Order_By>;
  accounts_aggregate?: InputMaybe<Accounts_Aggregate_Order_By>;
  companies_aggregate?: InputMaybe<Companies_Aggregate_Order_By>;
  content_languages?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crop_users_aggregate?: InputMaybe<Crop_User_Aggregate_Order_By>;
  date_of_birth?: InputMaybe<Order_By>;
  default_role?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  email_verified_at?: InputMaybe<Order_By>;
  farmer_plots_aggregate?: InputMaybe<Farmer_Plots_Aggregate_Order_By>;
  fieldPartnerResponseEventsByFieldPartnerUserId_aggregate?: InputMaybe<Field_Partner_Response_Events_Aggregate_Order_By>;
  fieldPartnerResponseMessagesByFieldPartnerUserId_aggregate?: InputMaybe<Field_Partner_Response_Messages_Aggregate_Order_By>;
  fieldPartnerResponseMessagesByFromUserId_aggregate?: InputMaybe<Field_Partner_Response_Messages_Aggregate_Order_By>;
  fieldPartnerResponseMessagesByToUserId_aggregate?: InputMaybe<Field_Partner_Response_Messages_Aggregate_Order_By>;
  fieldPartnerResponsesByFieldPartnerUserId_aggregate?: InputMaybe<Field_Partner_Responses_Aggregate_Order_By>;
  fieldScheduledVisitsByFieldPartnerUserId_aggregate?: InputMaybe<Field_Scheduled_Visits_Aggregate_Order_By>;
  field_partner_response_events_aggregate?: InputMaybe<Field_Partner_Response_Events_Aggregate_Order_By>;
  field_partner_response_messages_aggregate?: InputMaybe<Field_Partner_Response_Messages_Aggregate_Order_By>;
  field_partner_responses_aggregate?: InputMaybe<Field_Partner_Responses_Aggregate_Order_By>;
  field_scheduled_visits_aggregate?: InputMaybe<Field_Scheduled_Visits_Aggregate_Order_By>;
  follower_count?: InputMaybe<Order_By>;
  follows_channels_aggregate?: InputMaybe<User_Follows_Channel_Aggregate_Order_By>;
  gender?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_test?: InputMaybe<Order_By>;
  lastKnownLocationsByRequestFarmerId_aggregate?: InputMaybe<Last_Known_Locations_Aggregate_Order_By>;
  last_known_locations_aggregate?: InputMaybe<Last_Known_Locations_Aggregate_Order_By>;
  locale?: InputMaybe<Order_By>;
  market?: InputMaybe<Runpando_Pro_Users_Order_By>;
  model_has_roles_aggregate?: InputMaybe<Model_Has_Roles_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  nova_twofas_aggregate?: InputMaybe<Nova_Twofa_Aggregate_Order_By>;
  password?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  profile_image_url?: InputMaybe<Order_By>;
  reel_comments_aggregate?: InputMaybe<Reel_Comments_Aggregate_Order_By>;
  remember_token?: InputMaybe<Order_By>;
  segment_users_aggregate?: InputMaybe<Segment_User_Aggregate_Order_By>;
  service_requests_aggregate?: InputMaybe<Service_Requests_Aggregate_Order_By>;
  socialite?: InputMaybe<Order_By>;
  total_watch_time_secs?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_feedbacks_aggregate?: InputMaybe<User_Feedbacks_Aggregate_Order_By>;
  user_location_logs_aggregate?: InputMaybe<User_Location_Logs_Aggregate_Order_By>;
  user_wallets_aggregate?: InputMaybe<Wallets_Aggregate_Order_By>;
  users_follows_to_aggregate?: InputMaybe<Follows_Aggregate_Order_By>;
  users_prospect_messages_from_aggregate?: InputMaybe<Prospect_Messages_Aggregate_Order_By>;
  users_prospect_messages_to_aggregate?: InputMaybe<Prospect_Messages_Aggregate_Order_By>;
  users_reel_interactions_aggregate?: InputMaybe<Reel_Interactions_Aggregate_Order_By>;
};

/** primary key columns input for table: users */
export type Users_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Users_Prepend_Input = {
  socialite?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  ContentLanguages = 'content_languages',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateOfBirth = 'date_of_birth',
  /** column name */
  DefaultRole = 'default_role',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Email = 'email',
  /** column name */
  EmailVerifiedAt = 'email_verified_at',
  /** column name */
  FollowerCount = 'follower_count',
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  IsTest = 'is_test',
  /** column name */
  Locale = 'locale',
  /** column name */
  Name = 'name',
  /** column name */
  Password = 'password',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  ProfileImageUrl = 'profile_image_url',
  /** column name */
  RememberToken = 'remember_token',
  /** column name */
  Socialite = 'socialite',
  /** column name */
  TotalWatchTimeSecs = 'total_watch_time_secs',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  content_languages?: InputMaybe<Scalars['json']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date_of_birth?: InputMaybe<Scalars['String']['input']>;
  default_role?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_verified_at?: InputMaybe<Scalars['timestamp']['input']>;
  follower_count?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  is_test?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  profile_image_url?: InputMaybe<Scalars['String']['input']>;
  remember_token?: InputMaybe<Scalars['String']['input']>;
  socialite?: InputMaybe<Scalars['jsonb']['input']>;
  total_watch_time_secs?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Users_Stddev_Fields = {
  __typename?: 'users_stddev_fields';
  follower_count?: Maybe<Scalars['Float']['output']>;
  total_watch_time_secs?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Users_Stddev_Pop_Fields = {
  __typename?: 'users_stddev_pop_fields';
  follower_count?: Maybe<Scalars['Float']['output']>;
  total_watch_time_secs?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Users_Stddev_Samp_Fields = {
  __typename?: 'users_stddev_samp_fields';
  follower_count?: Maybe<Scalars['Float']['output']>;
  total_watch_time_secs?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  content_languages?: InputMaybe<Scalars['json']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date_of_birth?: InputMaybe<Scalars['String']['input']>;
  default_role?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_verified_at?: InputMaybe<Scalars['timestamp']['input']>;
  follower_count?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  is_test?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  profile_image_url?: InputMaybe<Scalars['String']['input']>;
  remember_token?: InputMaybe<Scalars['String']['input']>;
  socialite?: InputMaybe<Scalars['jsonb']['input']>;
  total_watch_time_secs?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Users_Sum_Fields = {
  __typename?: 'users_sum_fields';
  follower_count?: Maybe<Scalars['Int']['output']>;
  total_watch_time_secs?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "users" */
export enum Users_Update_Column {
  /** column name */
  ContentLanguages = 'content_languages',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateOfBirth = 'date_of_birth',
  /** column name */
  DefaultRole = 'default_role',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Email = 'email',
  /** column name */
  EmailVerifiedAt = 'email_verified_at',
  /** column name */
  FollowerCount = 'follower_count',
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  IsTest = 'is_test',
  /** column name */
  Locale = 'locale',
  /** column name */
  Name = 'name',
  /** column name */
  Password = 'password',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  ProfileImageUrl = 'profile_image_url',
  /** column name */
  RememberToken = 'remember_token',
  /** column name */
  Socialite = 'socialite',
  /** column name */
  TotalWatchTimeSecs = 'total_watch_time_secs',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Users_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Users_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Users_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Users_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Users_Var_Pop_Fields = {
  __typename?: 'users_var_pop_fields';
  follower_count?: Maybe<Scalars['Float']['output']>;
  total_watch_time_secs?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Users_Var_Samp_Fields = {
  __typename?: 'users_var_samp_fields';
  follower_count?: Maybe<Scalars['Float']['output']>;
  total_watch_time_secs?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Users_Variance_Fields = {
  __typename?: 'users_variance_fields';
  follower_count?: Maybe<Scalars['Float']['output']>;
  total_watch_time_secs?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** columns and relationships of "wallets" */
export type Wallets = {
  __typename?: 'wallets';
  balance: Scalars['numeric']['output'];
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['bigint']['output'];
  owner_id: Scalars['bpchar']['output'];
  owner_type: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregated selection of "wallets" */
export type Wallets_Aggregate = {
  __typename?: 'wallets_aggregate';
  aggregate?: Maybe<Wallets_Aggregate_Fields>;
  nodes: Array<Wallets>;
};

export type Wallets_Aggregate_Bool_Exp = {
  count?: InputMaybe<Wallets_Aggregate_Bool_Exp_Count>;
};

export type Wallets_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Wallets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Wallets_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "wallets" */
export type Wallets_Aggregate_Fields = {
  __typename?: 'wallets_aggregate_fields';
  avg?: Maybe<Wallets_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Wallets_Max_Fields>;
  min?: Maybe<Wallets_Min_Fields>;
  stddev?: Maybe<Wallets_Stddev_Fields>;
  stddev_pop?: Maybe<Wallets_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Wallets_Stddev_Samp_Fields>;
  sum?: Maybe<Wallets_Sum_Fields>;
  var_pop?: Maybe<Wallets_Var_Pop_Fields>;
  var_samp?: Maybe<Wallets_Var_Samp_Fields>;
  variance?: Maybe<Wallets_Variance_Fields>;
};


/** aggregate fields of "wallets" */
export type Wallets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Wallets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "wallets" */
export type Wallets_Aggregate_Order_By = {
  avg?: InputMaybe<Wallets_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Wallets_Max_Order_By>;
  min?: InputMaybe<Wallets_Min_Order_By>;
  stddev?: InputMaybe<Wallets_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Wallets_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Wallets_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Wallets_Sum_Order_By>;
  var_pop?: InputMaybe<Wallets_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Wallets_Var_Samp_Order_By>;
  variance?: InputMaybe<Wallets_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "wallets" */
export type Wallets_Arr_Rel_Insert_Input = {
  data: Array<Wallets_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Wallets_On_Conflict>;
};

/** aggregate avg on columns */
export type Wallets_Avg_Fields = {
  __typename?: 'wallets_avg_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "wallets" */
export type Wallets_Avg_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "wallets". All fields are combined with a logical 'AND'. */
export type Wallets_Bool_Exp = {
  _and?: InputMaybe<Array<Wallets_Bool_Exp>>;
  _not?: InputMaybe<Wallets_Bool_Exp>;
  _or?: InputMaybe<Array<Wallets_Bool_Exp>>;
  balance?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  owner_id?: InputMaybe<Bpchar_Comparison_Exp>;
  owner_type?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "wallets" */
export enum Wallets_Constraint {
  /** unique or primary key constraint on columns "id" */
  WalletsPkey = 'wallets_pkey'
}

/** input type for incrementing numeric columns in table "wallets" */
export type Wallets_Inc_Input = {
  balance?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "wallets" */
export type Wallets_Insert_Input = {
  balance?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  owner_id?: InputMaybe<Scalars['bpchar']['input']>;
  owner_type?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Wallets_Max_Fields = {
  __typename?: 'wallets_max_fields';
  balance?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  owner_id?: Maybe<Scalars['bpchar']['output']>;
  owner_type?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "wallets" */
export type Wallets_Max_Order_By = {
  balance?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  owner_type?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Wallets_Min_Fields = {
  __typename?: 'wallets_min_fields';
  balance?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  owner_id?: Maybe<Scalars['bpchar']['output']>;
  owner_type?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "wallets" */
export type Wallets_Min_Order_By = {
  balance?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  owner_type?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "wallets" */
export type Wallets_Mutation_Response = {
  __typename?: 'wallets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Wallets>;
};

/** on_conflict condition type for table "wallets" */
export type Wallets_On_Conflict = {
  constraint: Wallets_Constraint;
  update_columns?: Array<Wallets_Update_Column>;
  where?: InputMaybe<Wallets_Bool_Exp>;
};

/** Ordering options when selecting data from "wallets". */
export type Wallets_Order_By = {
  balance?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  owner_type?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: wallets */
export type Wallets_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "wallets" */
export enum Wallets_Select_Column {
  /** column name */
  Balance = 'balance',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  OwnerType = 'owner_type',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "wallets" */
export type Wallets_Set_Input = {
  balance?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  owner_id?: InputMaybe<Scalars['bpchar']['input']>;
  owner_type?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Wallets_Stddev_Fields = {
  __typename?: 'wallets_stddev_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "wallets" */
export type Wallets_Stddev_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Wallets_Stddev_Pop_Fields = {
  __typename?: 'wallets_stddev_pop_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "wallets" */
export type Wallets_Stddev_Pop_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Wallets_Stddev_Samp_Fields = {
  __typename?: 'wallets_stddev_samp_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "wallets" */
export type Wallets_Stddev_Samp_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "wallets" */
export type Wallets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Wallets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Wallets_Stream_Cursor_Value_Input = {
  balance?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  owner_id?: InputMaybe<Scalars['bpchar']['input']>;
  owner_type?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Wallets_Sum_Fields = {
  __typename?: 'wallets_sum_fields';
  balance?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "wallets" */
export type Wallets_Sum_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "wallets" */
export enum Wallets_Update_Column {
  /** column name */
  Balance = 'balance',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  OwnerType = 'owner_type',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Wallets_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Wallets_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Wallets_Set_Input>;
  /** filter the rows which have to be updated */
  where: Wallets_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Wallets_Var_Pop_Fields = {
  __typename?: 'wallets_var_pop_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "wallets" */
export type Wallets_Var_Pop_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Wallets_Var_Samp_Fields = {
  __typename?: 'wallets_var_samp_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "wallets" */
export type Wallets_Var_Samp_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Wallets_Variance_Fields = {
  __typename?: 'wallets_variance_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "wallets" */
export type Wallets_Variance_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "whatsauth_logins" */
export type Whatsauth_Logins = {
  __typename?: 'whatsauth_logins';
  code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  expires_at?: Maybe<Scalars['String']['output']>;
  fi_session_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  phone_number?: Maybe<Scalars['String']['output']>;
  profile_name?: Maybe<Scalars['String']['output']>;
  referrer_url?: Maybe<Scalars['String']['output']>;
  requested_at?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  validated_at?: Maybe<Scalars['String']['output']>;
  verification_code?: Maybe<Scalars['String']['output']>;
  whatsauth_id?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "whatsauth_logins" */
export type Whatsauth_Logins_Aggregate = {
  __typename?: 'whatsauth_logins_aggregate';
  aggregate?: Maybe<Whatsauth_Logins_Aggregate_Fields>;
  nodes: Array<Whatsauth_Logins>;
};

/** aggregate fields of "whatsauth_logins" */
export type Whatsauth_Logins_Aggregate_Fields = {
  __typename?: 'whatsauth_logins_aggregate_fields';
  avg?: Maybe<Whatsauth_Logins_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Whatsauth_Logins_Max_Fields>;
  min?: Maybe<Whatsauth_Logins_Min_Fields>;
  stddev?: Maybe<Whatsauth_Logins_Stddev_Fields>;
  stddev_pop?: Maybe<Whatsauth_Logins_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Whatsauth_Logins_Stddev_Samp_Fields>;
  sum?: Maybe<Whatsauth_Logins_Sum_Fields>;
  var_pop?: Maybe<Whatsauth_Logins_Var_Pop_Fields>;
  var_samp?: Maybe<Whatsauth_Logins_Var_Samp_Fields>;
  variance?: Maybe<Whatsauth_Logins_Variance_Fields>;
};


/** aggregate fields of "whatsauth_logins" */
export type Whatsauth_Logins_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Whatsauth_Logins_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Whatsauth_Logins_Avg_Fields = {
  __typename?: 'whatsauth_logins_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "whatsauth_logins". All fields are combined with a logical 'AND'. */
export type Whatsauth_Logins_Bool_Exp = {
  _and?: InputMaybe<Array<Whatsauth_Logins_Bool_Exp>>;
  _not?: InputMaybe<Whatsauth_Logins_Bool_Exp>;
  _or?: InputMaybe<Array<Whatsauth_Logins_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  expires_at?: InputMaybe<String_Comparison_Exp>;
  fi_session_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  profile_name?: InputMaybe<String_Comparison_Exp>;
  referrer_url?: InputMaybe<String_Comparison_Exp>;
  requested_at?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  validated_at?: InputMaybe<String_Comparison_Exp>;
  verification_code?: InputMaybe<String_Comparison_Exp>;
  whatsauth_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "whatsauth_logins" */
export enum Whatsauth_Logins_Constraint {
  /** unique or primary key constraint on columns "id" */
  WhatsauthLoginsPkey = 'whatsauth_logins_pkey'
}

/** input type for incrementing numeric columns in table "whatsauth_logins" */
export type Whatsauth_Logins_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "whatsauth_logins" */
export type Whatsauth_Logins_Insert_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  expires_at?: InputMaybe<Scalars['String']['input']>;
  fi_session_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  profile_name?: InputMaybe<Scalars['String']['input']>;
  referrer_url?: InputMaybe<Scalars['String']['input']>;
  requested_at?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  validated_at?: InputMaybe<Scalars['String']['input']>;
  verification_code?: InputMaybe<Scalars['String']['input']>;
  whatsauth_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Whatsauth_Logins_Max_Fields = {
  __typename?: 'whatsauth_logins_max_fields';
  code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  expires_at?: Maybe<Scalars['String']['output']>;
  fi_session_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  profile_name?: Maybe<Scalars['String']['output']>;
  referrer_url?: Maybe<Scalars['String']['output']>;
  requested_at?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  validated_at?: Maybe<Scalars['String']['output']>;
  verification_code?: Maybe<Scalars['String']['output']>;
  whatsauth_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Whatsauth_Logins_Min_Fields = {
  __typename?: 'whatsauth_logins_min_fields';
  code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  expires_at?: Maybe<Scalars['String']['output']>;
  fi_session_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  profile_name?: Maybe<Scalars['String']['output']>;
  referrer_url?: Maybe<Scalars['String']['output']>;
  requested_at?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  validated_at?: Maybe<Scalars['String']['output']>;
  verification_code?: Maybe<Scalars['String']['output']>;
  whatsauth_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "whatsauth_logins" */
export type Whatsauth_Logins_Mutation_Response = {
  __typename?: 'whatsauth_logins_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Whatsauth_Logins>;
};

/** on_conflict condition type for table "whatsauth_logins" */
export type Whatsauth_Logins_On_Conflict = {
  constraint: Whatsauth_Logins_Constraint;
  update_columns?: Array<Whatsauth_Logins_Update_Column>;
  where?: InputMaybe<Whatsauth_Logins_Bool_Exp>;
};

/** Ordering options when selecting data from "whatsauth_logins". */
export type Whatsauth_Logins_Order_By = {
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  fi_session_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  profile_name?: InputMaybe<Order_By>;
  referrer_url?: InputMaybe<Order_By>;
  requested_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  validated_at?: InputMaybe<Order_By>;
  verification_code?: InputMaybe<Order_By>;
  whatsauth_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: whatsauth_logins */
export type Whatsauth_Logins_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "whatsauth_logins" */
export enum Whatsauth_Logins_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  FiSessionId = 'fi_session_id',
  /** column name */
  Id = 'id',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  ProfileName = 'profile_name',
  /** column name */
  ReferrerUrl = 'referrer_url',
  /** column name */
  RequestedAt = 'requested_at',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValidatedAt = 'validated_at',
  /** column name */
  VerificationCode = 'verification_code',
  /** column name */
  WhatsauthId = 'whatsauth_id'
}

/** input type for updating data in table "whatsauth_logins" */
export type Whatsauth_Logins_Set_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  expires_at?: InputMaybe<Scalars['String']['input']>;
  fi_session_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  profile_name?: InputMaybe<Scalars['String']['input']>;
  referrer_url?: InputMaybe<Scalars['String']['input']>;
  requested_at?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  validated_at?: InputMaybe<Scalars['String']['input']>;
  verification_code?: InputMaybe<Scalars['String']['input']>;
  whatsauth_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Whatsauth_Logins_Stddev_Fields = {
  __typename?: 'whatsauth_logins_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Whatsauth_Logins_Stddev_Pop_Fields = {
  __typename?: 'whatsauth_logins_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Whatsauth_Logins_Stddev_Samp_Fields = {
  __typename?: 'whatsauth_logins_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "whatsauth_logins" */
export type Whatsauth_Logins_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Whatsauth_Logins_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Whatsauth_Logins_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  expires_at?: InputMaybe<Scalars['String']['input']>;
  fi_session_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  profile_name?: InputMaybe<Scalars['String']['input']>;
  referrer_url?: InputMaybe<Scalars['String']['input']>;
  requested_at?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  validated_at?: InputMaybe<Scalars['String']['input']>;
  verification_code?: InputMaybe<Scalars['String']['input']>;
  whatsauth_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Whatsauth_Logins_Sum_Fields = {
  __typename?: 'whatsauth_logins_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "whatsauth_logins" */
export enum Whatsauth_Logins_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  FiSessionId = 'fi_session_id',
  /** column name */
  Id = 'id',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  ProfileName = 'profile_name',
  /** column name */
  ReferrerUrl = 'referrer_url',
  /** column name */
  RequestedAt = 'requested_at',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValidatedAt = 'validated_at',
  /** column name */
  VerificationCode = 'verification_code',
  /** column name */
  WhatsauthId = 'whatsauth_id'
}

export type Whatsauth_Logins_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Whatsauth_Logins_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Whatsauth_Logins_Set_Input>;
  /** filter the rows which have to be updated */
  where: Whatsauth_Logins_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Whatsauth_Logins_Var_Pop_Fields = {
  __typename?: 'whatsauth_logins_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Whatsauth_Logins_Var_Samp_Fields = {
  __typename?: 'whatsauth_logins_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Whatsauth_Logins_Variance_Fields = {
  __typename?: 'whatsauth_logins_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "work_order_checklist_items" */
export type Work_Order_Checklist_Items = {
  __typename?: 'work_order_checklist_items';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  data?: Maybe<Scalars['jsonb']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['bpchar']['output'];
  item_name: Scalars['String']['output'];
  item_type: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  work_order_id: Scalars['bpchar']['output'];
};


/** columns and relationships of "work_order_checklist_items" */
export type Work_Order_Checklist_ItemsDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "work_order_checklist_items" */
export type Work_Order_Checklist_Items_Aggregate = {
  __typename?: 'work_order_checklist_items_aggregate';
  aggregate?: Maybe<Work_Order_Checklist_Items_Aggregate_Fields>;
  nodes: Array<Work_Order_Checklist_Items>;
};

/** aggregate fields of "work_order_checklist_items" */
export type Work_Order_Checklist_Items_Aggregate_Fields = {
  __typename?: 'work_order_checklist_items_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Work_Order_Checklist_Items_Max_Fields>;
  min?: Maybe<Work_Order_Checklist_Items_Min_Fields>;
};


/** aggregate fields of "work_order_checklist_items" */
export type Work_Order_Checklist_Items_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Work_Order_Checklist_Items_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Work_Order_Checklist_Items_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "work_order_checklist_items". All fields are combined with a logical 'AND'. */
export type Work_Order_Checklist_Items_Bool_Exp = {
  _and?: InputMaybe<Array<Work_Order_Checklist_Items_Bool_Exp>>;
  _not?: InputMaybe<Work_Order_Checklist_Items_Bool_Exp>;
  _or?: InputMaybe<Array<Work_Order_Checklist_Items_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  item_name?: InputMaybe<String_Comparison_Exp>;
  item_type?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  work_order_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "work_order_checklist_items" */
export enum Work_Order_Checklist_Items_Constraint {
  /** unique or primary key constraint on columns "id" */
  WorkOrderChecklistItemsPkey = 'work_order_checklist_items_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Work_Order_Checklist_Items_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Work_Order_Checklist_Items_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Work_Order_Checklist_Items_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "work_order_checklist_items" */
export type Work_Order_Checklist_Items_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  item_name?: InputMaybe<Scalars['String']['input']>;
  item_type?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  work_order_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Work_Order_Checklist_Items_Max_Fields = {
  __typename?: 'work_order_checklist_items_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  item_type?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  work_order_id?: Maybe<Scalars['bpchar']['output']>;
};

/** aggregate min on columns */
export type Work_Order_Checklist_Items_Min_Fields = {
  __typename?: 'work_order_checklist_items_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  item_type?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  work_order_id?: Maybe<Scalars['bpchar']['output']>;
};

/** response of any mutation on the table "work_order_checklist_items" */
export type Work_Order_Checklist_Items_Mutation_Response = {
  __typename?: 'work_order_checklist_items_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Work_Order_Checklist_Items>;
};

/** on_conflict condition type for table "work_order_checklist_items" */
export type Work_Order_Checklist_Items_On_Conflict = {
  constraint: Work_Order_Checklist_Items_Constraint;
  update_columns?: Array<Work_Order_Checklist_Items_Update_Column>;
  where?: InputMaybe<Work_Order_Checklist_Items_Bool_Exp>;
};

/** Ordering options when selecting data from "work_order_checklist_items". */
export type Work_Order_Checklist_Items_Order_By = {
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  item_name?: InputMaybe<Order_By>;
  item_type?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  work_order_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: work_order_checklist_items */
export type Work_Order_Checklist_Items_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Work_Order_Checklist_Items_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "work_order_checklist_items" */
export enum Work_Order_Checklist_Items_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ItemName = 'item_name',
  /** column name */
  ItemType = 'item_type',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkOrderId = 'work_order_id'
}

/** input type for updating data in table "work_order_checklist_items" */
export type Work_Order_Checklist_Items_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  item_name?: InputMaybe<Scalars['String']['input']>;
  item_type?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  work_order_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** Streaming cursor of the table "work_order_checklist_items" */
export type Work_Order_Checklist_Items_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Work_Order_Checklist_Items_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Work_Order_Checklist_Items_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  item_name?: InputMaybe<Scalars['String']['input']>;
  item_type?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  work_order_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** update columns of table "work_order_checklist_items" */
export enum Work_Order_Checklist_Items_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ItemName = 'item_name',
  /** column name */
  ItemType = 'item_type',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkOrderId = 'work_order_id'
}

export type Work_Order_Checklist_Items_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Work_Order_Checklist_Items_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Work_Order_Checklist_Items_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Work_Order_Checklist_Items_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Work_Order_Checklist_Items_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Work_Order_Checklist_Items_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Work_Order_Checklist_Items_Set_Input>;
  /** filter the rows which have to be updated */
  where: Work_Order_Checklist_Items_Bool_Exp;
};

/** columns and relationships of "work_order_messages" */
export type Work_Order_Messages = {
  __typename?: 'work_order_messages';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  delivered_at?: Maybe<Scalars['timestamptz']['output']>;
  from_user_id: Scalars['bpchar']['output'];
  id: Scalars['bpchar']['output'];
  message?: Maybe<Scalars['String']['output']>;
  message_data?: Maybe<Scalars['jsonb']['output']>;
  message_type: Scalars['String']['output'];
  seen_at?: Maybe<Scalars['timestamptz']['output']>;
  to_user_id: Scalars['bpchar']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  work_order_id: Scalars['bpchar']['output'];
};


/** columns and relationships of "work_order_messages" */
export type Work_Order_MessagesMessage_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "work_order_messages" */
export type Work_Order_Messages_Aggregate = {
  __typename?: 'work_order_messages_aggregate';
  aggregate?: Maybe<Work_Order_Messages_Aggregate_Fields>;
  nodes: Array<Work_Order_Messages>;
};

/** aggregate fields of "work_order_messages" */
export type Work_Order_Messages_Aggregate_Fields = {
  __typename?: 'work_order_messages_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Work_Order_Messages_Max_Fields>;
  min?: Maybe<Work_Order_Messages_Min_Fields>;
};


/** aggregate fields of "work_order_messages" */
export type Work_Order_Messages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Work_Order_Messages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Work_Order_Messages_Append_Input = {
  message_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "work_order_messages". All fields are combined with a logical 'AND'. */
export type Work_Order_Messages_Bool_Exp = {
  _and?: InputMaybe<Array<Work_Order_Messages_Bool_Exp>>;
  _not?: InputMaybe<Work_Order_Messages_Bool_Exp>;
  _or?: InputMaybe<Array<Work_Order_Messages_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  delivered_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  from_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  message_data?: InputMaybe<Jsonb_Comparison_Exp>;
  message_type?: InputMaybe<String_Comparison_Exp>;
  seen_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  to_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  work_order_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "work_order_messages" */
export enum Work_Order_Messages_Constraint {
  /** unique or primary key constraint on columns "id" */
  WorkOrderMessagesPkey = 'work_order_messages_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Work_Order_Messages_Delete_At_Path_Input = {
  message_data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Work_Order_Messages_Delete_Elem_Input = {
  message_data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Work_Order_Messages_Delete_Key_Input = {
  message_data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "work_order_messages" */
export type Work_Order_Messages_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  delivered_at?: InputMaybe<Scalars['timestamptz']['input']>;
  from_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  message_data?: InputMaybe<Scalars['jsonb']['input']>;
  message_type?: InputMaybe<Scalars['String']['input']>;
  seen_at?: InputMaybe<Scalars['timestamptz']['input']>;
  to_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  work_order_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Work_Order_Messages_Max_Fields = {
  __typename?: 'work_order_messages_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  delivered_at?: Maybe<Scalars['timestamptz']['output']>;
  from_user_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  message_type?: Maybe<Scalars['String']['output']>;
  seen_at?: Maybe<Scalars['timestamptz']['output']>;
  to_user_id?: Maybe<Scalars['bpchar']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  work_order_id?: Maybe<Scalars['bpchar']['output']>;
};

/** aggregate min on columns */
export type Work_Order_Messages_Min_Fields = {
  __typename?: 'work_order_messages_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  delivered_at?: Maybe<Scalars['timestamptz']['output']>;
  from_user_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  message_type?: Maybe<Scalars['String']['output']>;
  seen_at?: Maybe<Scalars['timestamptz']['output']>;
  to_user_id?: Maybe<Scalars['bpchar']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  work_order_id?: Maybe<Scalars['bpchar']['output']>;
};

/** response of any mutation on the table "work_order_messages" */
export type Work_Order_Messages_Mutation_Response = {
  __typename?: 'work_order_messages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Work_Order_Messages>;
};

/** on_conflict condition type for table "work_order_messages" */
export type Work_Order_Messages_On_Conflict = {
  constraint: Work_Order_Messages_Constraint;
  update_columns?: Array<Work_Order_Messages_Update_Column>;
  where?: InputMaybe<Work_Order_Messages_Bool_Exp>;
};

/** Ordering options when selecting data from "work_order_messages". */
export type Work_Order_Messages_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  delivered_at?: InputMaybe<Order_By>;
  from_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  message_data?: InputMaybe<Order_By>;
  message_type?: InputMaybe<Order_By>;
  seen_at?: InputMaybe<Order_By>;
  to_user_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  work_order_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: work_order_messages */
export type Work_Order_Messages_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Work_Order_Messages_Prepend_Input = {
  message_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "work_order_messages" */
export enum Work_Order_Messages_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeliveredAt = 'delivered_at',
  /** column name */
  FromUserId = 'from_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  MessageData = 'message_data',
  /** column name */
  MessageType = 'message_type',
  /** column name */
  SeenAt = 'seen_at',
  /** column name */
  ToUserId = 'to_user_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkOrderId = 'work_order_id'
}

/** input type for updating data in table "work_order_messages" */
export type Work_Order_Messages_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  delivered_at?: InputMaybe<Scalars['timestamptz']['input']>;
  from_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  message_data?: InputMaybe<Scalars['jsonb']['input']>;
  message_type?: InputMaybe<Scalars['String']['input']>;
  seen_at?: InputMaybe<Scalars['timestamptz']['input']>;
  to_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  work_order_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** Streaming cursor of the table "work_order_messages" */
export type Work_Order_Messages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Work_Order_Messages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Work_Order_Messages_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  delivered_at?: InputMaybe<Scalars['timestamptz']['input']>;
  from_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  message_data?: InputMaybe<Scalars['jsonb']['input']>;
  message_type?: InputMaybe<Scalars['String']['input']>;
  seen_at?: InputMaybe<Scalars['timestamptz']['input']>;
  to_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  work_order_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** update columns of table "work_order_messages" */
export enum Work_Order_Messages_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeliveredAt = 'delivered_at',
  /** column name */
  FromUserId = 'from_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  MessageData = 'message_data',
  /** column name */
  MessageType = 'message_type',
  /** column name */
  SeenAt = 'seen_at',
  /** column name */
  ToUserId = 'to_user_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkOrderId = 'work_order_id'
}

export type Work_Order_Messages_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Work_Order_Messages_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Work_Order_Messages_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Work_Order_Messages_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Work_Order_Messages_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Work_Order_Messages_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Work_Order_Messages_Set_Input>;
  /** filter the rows which have to be updated */
  where: Work_Order_Messages_Bool_Exp;
};

/** columns and relationships of "work_order_outputs" */
export type Work_Order_Outputs = {
  __typename?: 'work_order_outputs';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  data?: Maybe<Scalars['jsonb']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['bpchar']['output'];
  mixpost_post_id?: Maybe<Scalars['bigint']['output']>;
  output_type: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  work_order_id: Scalars['bpchar']['output'];
};


/** columns and relationships of "work_order_outputs" */
export type Work_Order_OutputsDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "work_order_outputs" */
export type Work_Order_Outputs_Aggregate = {
  __typename?: 'work_order_outputs_aggregate';
  aggregate?: Maybe<Work_Order_Outputs_Aggregate_Fields>;
  nodes: Array<Work_Order_Outputs>;
};

/** aggregate fields of "work_order_outputs" */
export type Work_Order_Outputs_Aggregate_Fields = {
  __typename?: 'work_order_outputs_aggregate_fields';
  avg?: Maybe<Work_Order_Outputs_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Work_Order_Outputs_Max_Fields>;
  min?: Maybe<Work_Order_Outputs_Min_Fields>;
  stddev?: Maybe<Work_Order_Outputs_Stddev_Fields>;
  stddev_pop?: Maybe<Work_Order_Outputs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Work_Order_Outputs_Stddev_Samp_Fields>;
  sum?: Maybe<Work_Order_Outputs_Sum_Fields>;
  var_pop?: Maybe<Work_Order_Outputs_Var_Pop_Fields>;
  var_samp?: Maybe<Work_Order_Outputs_Var_Samp_Fields>;
  variance?: Maybe<Work_Order_Outputs_Variance_Fields>;
};


/** aggregate fields of "work_order_outputs" */
export type Work_Order_Outputs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Work_Order_Outputs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Work_Order_Outputs_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Work_Order_Outputs_Avg_Fields = {
  __typename?: 'work_order_outputs_avg_fields';
  mixpost_post_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "work_order_outputs". All fields are combined with a logical 'AND'. */
export type Work_Order_Outputs_Bool_Exp = {
  _and?: InputMaybe<Array<Work_Order_Outputs_Bool_Exp>>;
  _not?: InputMaybe<Work_Order_Outputs_Bool_Exp>;
  _or?: InputMaybe<Array<Work_Order_Outputs_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  mixpost_post_id?: InputMaybe<Bigint_Comparison_Exp>;
  output_type?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  work_order_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "work_order_outputs" */
export enum Work_Order_Outputs_Constraint {
  /** unique or primary key constraint on columns "id" */
  WorkOrderOutputsPkey = 'work_order_outputs_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Work_Order_Outputs_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Work_Order_Outputs_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Work_Order_Outputs_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "work_order_outputs" */
export type Work_Order_Outputs_Inc_Input = {
  mixpost_post_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "work_order_outputs" */
export type Work_Order_Outputs_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  mixpost_post_id?: InputMaybe<Scalars['bigint']['input']>;
  output_type?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  work_order_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Work_Order_Outputs_Max_Fields = {
  __typename?: 'work_order_outputs_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  mixpost_post_id?: Maybe<Scalars['bigint']['output']>;
  output_type?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  work_order_id?: Maybe<Scalars['bpchar']['output']>;
};

/** aggregate min on columns */
export type Work_Order_Outputs_Min_Fields = {
  __typename?: 'work_order_outputs_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  mixpost_post_id?: Maybe<Scalars['bigint']['output']>;
  output_type?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  work_order_id?: Maybe<Scalars['bpchar']['output']>;
};

/** response of any mutation on the table "work_order_outputs" */
export type Work_Order_Outputs_Mutation_Response = {
  __typename?: 'work_order_outputs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Work_Order_Outputs>;
};

/** on_conflict condition type for table "work_order_outputs" */
export type Work_Order_Outputs_On_Conflict = {
  constraint: Work_Order_Outputs_Constraint;
  update_columns?: Array<Work_Order_Outputs_Update_Column>;
  where?: InputMaybe<Work_Order_Outputs_Bool_Exp>;
};

/** Ordering options when selecting data from "work_order_outputs". */
export type Work_Order_Outputs_Order_By = {
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mixpost_post_id?: InputMaybe<Order_By>;
  output_type?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  work_order_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: work_order_outputs */
export type Work_Order_Outputs_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Work_Order_Outputs_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "work_order_outputs" */
export enum Work_Order_Outputs_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  MixpostPostId = 'mixpost_post_id',
  /** column name */
  OutputType = 'output_type',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url',
  /** column name */
  WorkOrderId = 'work_order_id'
}

/** input type for updating data in table "work_order_outputs" */
export type Work_Order_Outputs_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  mixpost_post_id?: InputMaybe<Scalars['bigint']['input']>;
  output_type?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  work_order_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate stddev on columns */
export type Work_Order_Outputs_Stddev_Fields = {
  __typename?: 'work_order_outputs_stddev_fields';
  mixpost_post_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Work_Order_Outputs_Stddev_Pop_Fields = {
  __typename?: 'work_order_outputs_stddev_pop_fields';
  mixpost_post_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Work_Order_Outputs_Stddev_Samp_Fields = {
  __typename?: 'work_order_outputs_stddev_samp_fields';
  mixpost_post_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "work_order_outputs" */
export type Work_Order_Outputs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Work_Order_Outputs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Work_Order_Outputs_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  mixpost_post_id?: InputMaybe<Scalars['bigint']['input']>;
  output_type?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  work_order_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate sum on columns */
export type Work_Order_Outputs_Sum_Fields = {
  __typename?: 'work_order_outputs_sum_fields';
  mixpost_post_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "work_order_outputs" */
export enum Work_Order_Outputs_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  MixpostPostId = 'mixpost_post_id',
  /** column name */
  OutputType = 'output_type',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url',
  /** column name */
  WorkOrderId = 'work_order_id'
}

export type Work_Order_Outputs_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Work_Order_Outputs_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Work_Order_Outputs_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Work_Order_Outputs_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Work_Order_Outputs_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Work_Order_Outputs_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Work_Order_Outputs_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Work_Order_Outputs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Work_Order_Outputs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Work_Order_Outputs_Var_Pop_Fields = {
  __typename?: 'work_order_outputs_var_pop_fields';
  mixpost_post_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Work_Order_Outputs_Var_Samp_Fields = {
  __typename?: 'work_order_outputs_var_samp_fields';
  mixpost_post_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Work_Order_Outputs_Variance_Fields = {
  __typename?: 'work_order_outputs_variance_fields';
  mixpost_post_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "work_order_requests" */
export type Work_Order_Requests = {
  __typename?: 'work_order_requests';
  bid_price: Scalars['float8']['output'];
  /** An object relationship */
  chat_thread?: Maybe<Chat_Threads>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by: Scalars['bpchar']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  delivery_days: Scalars['Int']['output'];
  /** An object relationship */
  gig: Gigs;
  gig_id: Scalars['bpchar']['output'];
  id: Scalars['bpchar']['output'];
  /** An object relationship */
  influencer_user: Users;
  influencer_user_id: Scalars['bpchar']['output'];
  status: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  work_order_id: Scalars['bpchar']['output'];
};

/** aggregated selection of "work_order_requests" */
export type Work_Order_Requests_Aggregate = {
  __typename?: 'work_order_requests_aggregate';
  aggregate?: Maybe<Work_Order_Requests_Aggregate_Fields>;
  nodes: Array<Work_Order_Requests>;
};

export type Work_Order_Requests_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Work_Order_Requests_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Work_Order_Requests_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Work_Order_Requests_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Work_Order_Requests_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Work_Order_Requests_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Work_Order_Requests_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Work_Order_Requests_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Work_Order_Requests_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Work_Order_Requests_Aggregate_Bool_Exp_Var_Samp>;
};

export type Work_Order_Requests_Aggregate_Bool_Exp_Avg = {
  arguments: Work_Order_Requests_Select_Column_Work_Order_Requests_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Work_Order_Requests_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Work_Order_Requests_Aggregate_Bool_Exp_Corr = {
  arguments: Work_Order_Requests_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Work_Order_Requests_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Work_Order_Requests_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Work_Order_Requests_Select_Column_Work_Order_Requests_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Work_Order_Requests_Select_Column_Work_Order_Requests_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Work_Order_Requests_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Work_Order_Requests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Work_Order_Requests_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Work_Order_Requests_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Work_Order_Requests_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Work_Order_Requests_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Work_Order_Requests_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Work_Order_Requests_Select_Column_Work_Order_Requests_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Work_Order_Requests_Select_Column_Work_Order_Requests_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Work_Order_Requests_Aggregate_Bool_Exp_Max = {
  arguments: Work_Order_Requests_Select_Column_Work_Order_Requests_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Work_Order_Requests_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Work_Order_Requests_Aggregate_Bool_Exp_Min = {
  arguments: Work_Order_Requests_Select_Column_Work_Order_Requests_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Work_Order_Requests_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Work_Order_Requests_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Work_Order_Requests_Select_Column_Work_Order_Requests_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Work_Order_Requests_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Work_Order_Requests_Aggregate_Bool_Exp_Sum = {
  arguments: Work_Order_Requests_Select_Column_Work_Order_Requests_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Work_Order_Requests_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Work_Order_Requests_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Work_Order_Requests_Select_Column_Work_Order_Requests_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Work_Order_Requests_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "work_order_requests" */
export type Work_Order_Requests_Aggregate_Fields = {
  __typename?: 'work_order_requests_aggregate_fields';
  avg?: Maybe<Work_Order_Requests_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Work_Order_Requests_Max_Fields>;
  min?: Maybe<Work_Order_Requests_Min_Fields>;
  stddev?: Maybe<Work_Order_Requests_Stddev_Fields>;
  stddev_pop?: Maybe<Work_Order_Requests_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Work_Order_Requests_Stddev_Samp_Fields>;
  sum?: Maybe<Work_Order_Requests_Sum_Fields>;
  var_pop?: Maybe<Work_Order_Requests_Var_Pop_Fields>;
  var_samp?: Maybe<Work_Order_Requests_Var_Samp_Fields>;
  variance?: Maybe<Work_Order_Requests_Variance_Fields>;
};


/** aggregate fields of "work_order_requests" */
export type Work_Order_Requests_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Work_Order_Requests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "work_order_requests" */
export type Work_Order_Requests_Aggregate_Order_By = {
  avg?: InputMaybe<Work_Order_Requests_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Work_Order_Requests_Max_Order_By>;
  min?: InputMaybe<Work_Order_Requests_Min_Order_By>;
  stddev?: InputMaybe<Work_Order_Requests_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Work_Order_Requests_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Work_Order_Requests_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Work_Order_Requests_Sum_Order_By>;
  var_pop?: InputMaybe<Work_Order_Requests_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Work_Order_Requests_Var_Samp_Order_By>;
  variance?: InputMaybe<Work_Order_Requests_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "work_order_requests" */
export type Work_Order_Requests_Arr_Rel_Insert_Input = {
  data: Array<Work_Order_Requests_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Work_Order_Requests_On_Conflict>;
};

/** aggregate avg on columns */
export type Work_Order_Requests_Avg_Fields = {
  __typename?: 'work_order_requests_avg_fields';
  bid_price?: Maybe<Scalars['Float']['output']>;
  delivery_days?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "work_order_requests" */
export type Work_Order_Requests_Avg_Order_By = {
  bid_price?: InputMaybe<Order_By>;
  delivery_days?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "work_order_requests". All fields are combined with a logical 'AND'. */
export type Work_Order_Requests_Bool_Exp = {
  _and?: InputMaybe<Array<Work_Order_Requests_Bool_Exp>>;
  _not?: InputMaybe<Work_Order_Requests_Bool_Exp>;
  _or?: InputMaybe<Array<Work_Order_Requests_Bool_Exp>>;
  bid_price?: InputMaybe<Float8_Comparison_Exp>;
  chat_thread?: InputMaybe<Chat_Threads_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Bpchar_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  delivery_days?: InputMaybe<Int_Comparison_Exp>;
  gig?: InputMaybe<Gigs_Bool_Exp>;
  gig_id?: InputMaybe<Bpchar_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  influencer_user?: InputMaybe<Users_Bool_Exp>;
  influencer_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  work_order_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "work_order_requests" */
export enum Work_Order_Requests_Constraint {
  /** unique or primary key constraint on columns "id" */
  WorkOrderRequestsPkey = 'work_order_requests_pkey'
}

/** input type for incrementing numeric columns in table "work_order_requests" */
export type Work_Order_Requests_Inc_Input = {
  bid_price?: InputMaybe<Scalars['float8']['input']>;
  delivery_days?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "work_order_requests" */
export type Work_Order_Requests_Insert_Input = {
  bid_price?: InputMaybe<Scalars['float8']['input']>;
  chat_thread?: InputMaybe<Chat_Threads_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['bpchar']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  delivery_days?: InputMaybe<Scalars['Int']['input']>;
  gig?: InputMaybe<Gigs_Obj_Rel_Insert_Input>;
  gig_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  influencer_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  influencer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  work_order_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Work_Order_Requests_Max_Fields = {
  __typename?: 'work_order_requests_max_fields';
  bid_price?: Maybe<Scalars['float8']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['bpchar']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  delivery_days?: Maybe<Scalars['Int']['output']>;
  gig_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  influencer_user_id?: Maybe<Scalars['bpchar']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  work_order_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by max() on columns of table "work_order_requests" */
export type Work_Order_Requests_Max_Order_By = {
  bid_price?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  delivery_days?: InputMaybe<Order_By>;
  gig_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  influencer_user_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  work_order_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Work_Order_Requests_Min_Fields = {
  __typename?: 'work_order_requests_min_fields';
  bid_price?: Maybe<Scalars['float8']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['bpchar']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  delivery_days?: Maybe<Scalars['Int']['output']>;
  gig_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  influencer_user_id?: Maybe<Scalars['bpchar']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  work_order_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by min() on columns of table "work_order_requests" */
export type Work_Order_Requests_Min_Order_By = {
  bid_price?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  delivery_days?: InputMaybe<Order_By>;
  gig_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  influencer_user_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  work_order_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "work_order_requests" */
export type Work_Order_Requests_Mutation_Response = {
  __typename?: 'work_order_requests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Work_Order_Requests>;
};

/** on_conflict condition type for table "work_order_requests" */
export type Work_Order_Requests_On_Conflict = {
  constraint: Work_Order_Requests_Constraint;
  update_columns?: Array<Work_Order_Requests_Update_Column>;
  where?: InputMaybe<Work_Order_Requests_Bool_Exp>;
};

/** Ordering options when selecting data from "work_order_requests". */
export type Work_Order_Requests_Order_By = {
  bid_price?: InputMaybe<Order_By>;
  chat_thread?: InputMaybe<Chat_Threads_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  delivery_days?: InputMaybe<Order_By>;
  gig?: InputMaybe<Gigs_Order_By>;
  gig_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  influencer_user?: InputMaybe<Users_Order_By>;
  influencer_user_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  work_order_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: work_order_requests */
export type Work_Order_Requests_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** select columns of table "work_order_requests" */
export enum Work_Order_Requests_Select_Column {
  /** column name */
  BidPrice = 'bid_price',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeliveryDays = 'delivery_days',
  /** column name */
  GigId = 'gig_id',
  /** column name */
  Id = 'id',
  /** column name */
  InfluencerUserId = 'influencer_user_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkOrderId = 'work_order_id'
}

/** select "work_order_requests_aggregate_bool_exp_avg_arguments_columns" columns of table "work_order_requests" */
export enum Work_Order_Requests_Select_Column_Work_Order_Requests_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  BidPrice = 'bid_price'
}

/** select "work_order_requests_aggregate_bool_exp_corr_arguments_columns" columns of table "work_order_requests" */
export enum Work_Order_Requests_Select_Column_Work_Order_Requests_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  BidPrice = 'bid_price'
}

/** select "work_order_requests_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "work_order_requests" */
export enum Work_Order_Requests_Select_Column_Work_Order_Requests_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  BidPrice = 'bid_price'
}

/** select "work_order_requests_aggregate_bool_exp_max_arguments_columns" columns of table "work_order_requests" */
export enum Work_Order_Requests_Select_Column_Work_Order_Requests_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  BidPrice = 'bid_price'
}

/** select "work_order_requests_aggregate_bool_exp_min_arguments_columns" columns of table "work_order_requests" */
export enum Work_Order_Requests_Select_Column_Work_Order_Requests_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  BidPrice = 'bid_price'
}

/** select "work_order_requests_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "work_order_requests" */
export enum Work_Order_Requests_Select_Column_Work_Order_Requests_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  BidPrice = 'bid_price'
}

/** select "work_order_requests_aggregate_bool_exp_sum_arguments_columns" columns of table "work_order_requests" */
export enum Work_Order_Requests_Select_Column_Work_Order_Requests_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  BidPrice = 'bid_price'
}

/** select "work_order_requests_aggregate_bool_exp_var_samp_arguments_columns" columns of table "work_order_requests" */
export enum Work_Order_Requests_Select_Column_Work_Order_Requests_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  BidPrice = 'bid_price'
}

/** input type for updating data in table "work_order_requests" */
export type Work_Order_Requests_Set_Input = {
  bid_price?: InputMaybe<Scalars['float8']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['bpchar']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  delivery_days?: InputMaybe<Scalars['Int']['input']>;
  gig_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  influencer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  work_order_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate stddev on columns */
export type Work_Order_Requests_Stddev_Fields = {
  __typename?: 'work_order_requests_stddev_fields';
  bid_price?: Maybe<Scalars['Float']['output']>;
  delivery_days?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "work_order_requests" */
export type Work_Order_Requests_Stddev_Order_By = {
  bid_price?: InputMaybe<Order_By>;
  delivery_days?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Work_Order_Requests_Stddev_Pop_Fields = {
  __typename?: 'work_order_requests_stddev_pop_fields';
  bid_price?: Maybe<Scalars['Float']['output']>;
  delivery_days?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "work_order_requests" */
export type Work_Order_Requests_Stddev_Pop_Order_By = {
  bid_price?: InputMaybe<Order_By>;
  delivery_days?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Work_Order_Requests_Stddev_Samp_Fields = {
  __typename?: 'work_order_requests_stddev_samp_fields';
  bid_price?: Maybe<Scalars['Float']['output']>;
  delivery_days?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "work_order_requests" */
export type Work_Order_Requests_Stddev_Samp_Order_By = {
  bid_price?: InputMaybe<Order_By>;
  delivery_days?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "work_order_requests" */
export type Work_Order_Requests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Work_Order_Requests_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Work_Order_Requests_Stream_Cursor_Value_Input = {
  bid_price?: InputMaybe<Scalars['float8']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['bpchar']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  delivery_days?: InputMaybe<Scalars['Int']['input']>;
  gig_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  influencer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  work_order_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate sum on columns */
export type Work_Order_Requests_Sum_Fields = {
  __typename?: 'work_order_requests_sum_fields';
  bid_price?: Maybe<Scalars['float8']['output']>;
  delivery_days?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "work_order_requests" */
export type Work_Order_Requests_Sum_Order_By = {
  bid_price?: InputMaybe<Order_By>;
  delivery_days?: InputMaybe<Order_By>;
};

/** update columns of table "work_order_requests" */
export enum Work_Order_Requests_Update_Column {
  /** column name */
  BidPrice = 'bid_price',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeliveryDays = 'delivery_days',
  /** column name */
  GigId = 'gig_id',
  /** column name */
  Id = 'id',
  /** column name */
  InfluencerUserId = 'influencer_user_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkOrderId = 'work_order_id'
}

export type Work_Order_Requests_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Work_Order_Requests_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Work_Order_Requests_Set_Input>;
  /** filter the rows which have to be updated */
  where: Work_Order_Requests_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Work_Order_Requests_Var_Pop_Fields = {
  __typename?: 'work_order_requests_var_pop_fields';
  bid_price?: Maybe<Scalars['Float']['output']>;
  delivery_days?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "work_order_requests" */
export type Work_Order_Requests_Var_Pop_Order_By = {
  bid_price?: InputMaybe<Order_By>;
  delivery_days?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Work_Order_Requests_Var_Samp_Fields = {
  __typename?: 'work_order_requests_var_samp_fields';
  bid_price?: Maybe<Scalars['Float']['output']>;
  delivery_days?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "work_order_requests" */
export type Work_Order_Requests_Var_Samp_Order_By = {
  bid_price?: InputMaybe<Order_By>;
  delivery_days?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Work_Order_Requests_Variance_Fields = {
  __typename?: 'work_order_requests_variance_fields';
  bid_price?: Maybe<Scalars['Float']['output']>;
  delivery_days?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "work_order_requests" */
export type Work_Order_Requests_Variance_Order_By = {
  bid_price?: InputMaybe<Order_By>;
  delivery_days?: InputMaybe<Order_By>;
};

/** columns and relationships of "work_order_reviews" */
export type Work_Order_Reviews = {
  __typename?: 'work_order_reviews';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  customer_given_rating?: Maybe<Scalars['String']['output']>;
  customer_given_rating_1?: Maybe<Scalars['float8']['output']>;
  customer_given_rating_2?: Maybe<Scalars['float8']['output']>;
  customer_given_review?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  customer_user: Users;
  customer_user_id: Scalars['bpchar']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['bpchar']['output'];
  influencer_given_rating?: Maybe<Scalars['String']['output']>;
  influencer_given_rating_1?: Maybe<Scalars['float8']['output']>;
  influencer_given_rating_2?: Maybe<Scalars['float8']['output']>;
  influencer_given_review?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  influencer_user: Users;
  influencer_user_id: Scalars['bpchar']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  work_order_id: Scalars['bpchar']['output'];
};

/** aggregated selection of "work_order_reviews" */
export type Work_Order_Reviews_Aggregate = {
  __typename?: 'work_order_reviews_aggregate';
  aggregate?: Maybe<Work_Order_Reviews_Aggregate_Fields>;
  nodes: Array<Work_Order_Reviews>;
};

/** aggregate fields of "work_order_reviews" */
export type Work_Order_Reviews_Aggregate_Fields = {
  __typename?: 'work_order_reviews_aggregate_fields';
  avg?: Maybe<Work_Order_Reviews_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Work_Order_Reviews_Max_Fields>;
  min?: Maybe<Work_Order_Reviews_Min_Fields>;
  stddev?: Maybe<Work_Order_Reviews_Stddev_Fields>;
  stddev_pop?: Maybe<Work_Order_Reviews_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Work_Order_Reviews_Stddev_Samp_Fields>;
  sum?: Maybe<Work_Order_Reviews_Sum_Fields>;
  var_pop?: Maybe<Work_Order_Reviews_Var_Pop_Fields>;
  var_samp?: Maybe<Work_Order_Reviews_Var_Samp_Fields>;
  variance?: Maybe<Work_Order_Reviews_Variance_Fields>;
};


/** aggregate fields of "work_order_reviews" */
export type Work_Order_Reviews_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Work_Order_Reviews_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Work_Order_Reviews_Avg_Fields = {
  __typename?: 'work_order_reviews_avg_fields';
  customer_given_rating_1?: Maybe<Scalars['Float']['output']>;
  customer_given_rating_2?: Maybe<Scalars['Float']['output']>;
  influencer_given_rating_1?: Maybe<Scalars['Float']['output']>;
  influencer_given_rating_2?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "work_order_reviews". All fields are combined with a logical 'AND'. */
export type Work_Order_Reviews_Bool_Exp = {
  _and?: InputMaybe<Array<Work_Order_Reviews_Bool_Exp>>;
  _not?: InputMaybe<Work_Order_Reviews_Bool_Exp>;
  _or?: InputMaybe<Array<Work_Order_Reviews_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  customer_given_rating?: InputMaybe<String_Comparison_Exp>;
  customer_given_rating_1?: InputMaybe<Float8_Comparison_Exp>;
  customer_given_rating_2?: InputMaybe<Float8_Comparison_Exp>;
  customer_given_review?: InputMaybe<String_Comparison_Exp>;
  customer_user?: InputMaybe<Users_Bool_Exp>;
  customer_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  influencer_given_rating?: InputMaybe<String_Comparison_Exp>;
  influencer_given_rating_1?: InputMaybe<Float8_Comparison_Exp>;
  influencer_given_rating_2?: InputMaybe<Float8_Comparison_Exp>;
  influencer_given_review?: InputMaybe<String_Comparison_Exp>;
  influencer_user?: InputMaybe<Users_Bool_Exp>;
  influencer_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  work_order_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "work_order_reviews" */
export enum Work_Order_Reviews_Constraint {
  /** unique or primary key constraint on columns "id" */
  WorkOrderReviewsPkey = 'work_order_reviews_pkey'
}

/** input type for incrementing numeric columns in table "work_order_reviews" */
export type Work_Order_Reviews_Inc_Input = {
  customer_given_rating_1?: InputMaybe<Scalars['float8']['input']>;
  customer_given_rating_2?: InputMaybe<Scalars['float8']['input']>;
  influencer_given_rating_1?: InputMaybe<Scalars['float8']['input']>;
  influencer_given_rating_2?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "work_order_reviews" */
export type Work_Order_Reviews_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  customer_given_rating?: InputMaybe<Scalars['String']['input']>;
  customer_given_rating_1?: InputMaybe<Scalars['float8']['input']>;
  customer_given_rating_2?: InputMaybe<Scalars['float8']['input']>;
  customer_given_review?: InputMaybe<Scalars['String']['input']>;
  customer_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  customer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  influencer_given_rating?: InputMaybe<Scalars['String']['input']>;
  influencer_given_rating_1?: InputMaybe<Scalars['float8']['input']>;
  influencer_given_rating_2?: InputMaybe<Scalars['float8']['input']>;
  influencer_given_review?: InputMaybe<Scalars['String']['input']>;
  influencer_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  influencer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  work_order_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Work_Order_Reviews_Max_Fields = {
  __typename?: 'work_order_reviews_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  customer_given_rating?: Maybe<Scalars['String']['output']>;
  customer_given_rating_1?: Maybe<Scalars['float8']['output']>;
  customer_given_rating_2?: Maybe<Scalars['float8']['output']>;
  customer_given_review?: Maybe<Scalars['String']['output']>;
  customer_user_id?: Maybe<Scalars['bpchar']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  influencer_given_rating?: Maybe<Scalars['String']['output']>;
  influencer_given_rating_1?: Maybe<Scalars['float8']['output']>;
  influencer_given_rating_2?: Maybe<Scalars['float8']['output']>;
  influencer_given_review?: Maybe<Scalars['String']['output']>;
  influencer_user_id?: Maybe<Scalars['bpchar']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  work_order_id?: Maybe<Scalars['bpchar']['output']>;
};

/** aggregate min on columns */
export type Work_Order_Reviews_Min_Fields = {
  __typename?: 'work_order_reviews_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  customer_given_rating?: Maybe<Scalars['String']['output']>;
  customer_given_rating_1?: Maybe<Scalars['float8']['output']>;
  customer_given_rating_2?: Maybe<Scalars['float8']['output']>;
  customer_given_review?: Maybe<Scalars['String']['output']>;
  customer_user_id?: Maybe<Scalars['bpchar']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  influencer_given_rating?: Maybe<Scalars['String']['output']>;
  influencer_given_rating_1?: Maybe<Scalars['float8']['output']>;
  influencer_given_rating_2?: Maybe<Scalars['float8']['output']>;
  influencer_given_review?: Maybe<Scalars['String']['output']>;
  influencer_user_id?: Maybe<Scalars['bpchar']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  work_order_id?: Maybe<Scalars['bpchar']['output']>;
};

/** response of any mutation on the table "work_order_reviews" */
export type Work_Order_Reviews_Mutation_Response = {
  __typename?: 'work_order_reviews_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Work_Order_Reviews>;
};

/** on_conflict condition type for table "work_order_reviews" */
export type Work_Order_Reviews_On_Conflict = {
  constraint: Work_Order_Reviews_Constraint;
  update_columns?: Array<Work_Order_Reviews_Update_Column>;
  where?: InputMaybe<Work_Order_Reviews_Bool_Exp>;
};

/** Ordering options when selecting data from "work_order_reviews". */
export type Work_Order_Reviews_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_given_rating?: InputMaybe<Order_By>;
  customer_given_rating_1?: InputMaybe<Order_By>;
  customer_given_rating_2?: InputMaybe<Order_By>;
  customer_given_review?: InputMaybe<Order_By>;
  customer_user?: InputMaybe<Users_Order_By>;
  customer_user_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  influencer_given_rating?: InputMaybe<Order_By>;
  influencer_given_rating_1?: InputMaybe<Order_By>;
  influencer_given_rating_2?: InputMaybe<Order_By>;
  influencer_given_review?: InputMaybe<Order_By>;
  influencer_user?: InputMaybe<Users_Order_By>;
  influencer_user_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  work_order_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: work_order_reviews */
export type Work_Order_Reviews_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** select columns of table "work_order_reviews" */
export enum Work_Order_Reviews_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerGivenRating = 'customer_given_rating',
  /** column name */
  CustomerGivenRating_1 = 'customer_given_rating_1',
  /** column name */
  CustomerGivenRating_2 = 'customer_given_rating_2',
  /** column name */
  CustomerGivenReview = 'customer_given_review',
  /** column name */
  CustomerUserId = 'customer_user_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  InfluencerGivenRating = 'influencer_given_rating',
  /** column name */
  InfluencerGivenRating_1 = 'influencer_given_rating_1',
  /** column name */
  InfluencerGivenRating_2 = 'influencer_given_rating_2',
  /** column name */
  InfluencerGivenReview = 'influencer_given_review',
  /** column name */
  InfluencerUserId = 'influencer_user_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkOrderId = 'work_order_id'
}

/** input type for updating data in table "work_order_reviews" */
export type Work_Order_Reviews_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  customer_given_rating?: InputMaybe<Scalars['String']['input']>;
  customer_given_rating_1?: InputMaybe<Scalars['float8']['input']>;
  customer_given_rating_2?: InputMaybe<Scalars['float8']['input']>;
  customer_given_review?: InputMaybe<Scalars['String']['input']>;
  customer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  influencer_given_rating?: InputMaybe<Scalars['String']['input']>;
  influencer_given_rating_1?: InputMaybe<Scalars['float8']['input']>;
  influencer_given_rating_2?: InputMaybe<Scalars['float8']['input']>;
  influencer_given_review?: InputMaybe<Scalars['String']['input']>;
  influencer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  work_order_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate stddev on columns */
export type Work_Order_Reviews_Stddev_Fields = {
  __typename?: 'work_order_reviews_stddev_fields';
  customer_given_rating_1?: Maybe<Scalars['Float']['output']>;
  customer_given_rating_2?: Maybe<Scalars['Float']['output']>;
  influencer_given_rating_1?: Maybe<Scalars['Float']['output']>;
  influencer_given_rating_2?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Work_Order_Reviews_Stddev_Pop_Fields = {
  __typename?: 'work_order_reviews_stddev_pop_fields';
  customer_given_rating_1?: Maybe<Scalars['Float']['output']>;
  customer_given_rating_2?: Maybe<Scalars['Float']['output']>;
  influencer_given_rating_1?: Maybe<Scalars['Float']['output']>;
  influencer_given_rating_2?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Work_Order_Reviews_Stddev_Samp_Fields = {
  __typename?: 'work_order_reviews_stddev_samp_fields';
  customer_given_rating_1?: Maybe<Scalars['Float']['output']>;
  customer_given_rating_2?: Maybe<Scalars['Float']['output']>;
  influencer_given_rating_1?: Maybe<Scalars['Float']['output']>;
  influencer_given_rating_2?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "work_order_reviews" */
export type Work_Order_Reviews_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Work_Order_Reviews_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Work_Order_Reviews_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  customer_given_rating?: InputMaybe<Scalars['String']['input']>;
  customer_given_rating_1?: InputMaybe<Scalars['float8']['input']>;
  customer_given_rating_2?: InputMaybe<Scalars['float8']['input']>;
  customer_given_review?: InputMaybe<Scalars['String']['input']>;
  customer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  influencer_given_rating?: InputMaybe<Scalars['String']['input']>;
  influencer_given_rating_1?: InputMaybe<Scalars['float8']['input']>;
  influencer_given_rating_2?: InputMaybe<Scalars['float8']['input']>;
  influencer_given_review?: InputMaybe<Scalars['String']['input']>;
  influencer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  work_order_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate sum on columns */
export type Work_Order_Reviews_Sum_Fields = {
  __typename?: 'work_order_reviews_sum_fields';
  customer_given_rating_1?: Maybe<Scalars['float8']['output']>;
  customer_given_rating_2?: Maybe<Scalars['float8']['output']>;
  influencer_given_rating_1?: Maybe<Scalars['float8']['output']>;
  influencer_given_rating_2?: Maybe<Scalars['float8']['output']>;
};

/** update columns of table "work_order_reviews" */
export enum Work_Order_Reviews_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerGivenRating = 'customer_given_rating',
  /** column name */
  CustomerGivenRating_1 = 'customer_given_rating_1',
  /** column name */
  CustomerGivenRating_2 = 'customer_given_rating_2',
  /** column name */
  CustomerGivenReview = 'customer_given_review',
  /** column name */
  CustomerUserId = 'customer_user_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  InfluencerGivenRating = 'influencer_given_rating',
  /** column name */
  InfluencerGivenRating_1 = 'influencer_given_rating_1',
  /** column name */
  InfluencerGivenRating_2 = 'influencer_given_rating_2',
  /** column name */
  InfluencerGivenReview = 'influencer_given_review',
  /** column name */
  InfluencerUserId = 'influencer_user_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkOrderId = 'work_order_id'
}

export type Work_Order_Reviews_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Work_Order_Reviews_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Work_Order_Reviews_Set_Input>;
  /** filter the rows which have to be updated */
  where: Work_Order_Reviews_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Work_Order_Reviews_Var_Pop_Fields = {
  __typename?: 'work_order_reviews_var_pop_fields';
  customer_given_rating_1?: Maybe<Scalars['Float']['output']>;
  customer_given_rating_2?: Maybe<Scalars['Float']['output']>;
  influencer_given_rating_1?: Maybe<Scalars['Float']['output']>;
  influencer_given_rating_2?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Work_Order_Reviews_Var_Samp_Fields = {
  __typename?: 'work_order_reviews_var_samp_fields';
  customer_given_rating_1?: Maybe<Scalars['Float']['output']>;
  customer_given_rating_2?: Maybe<Scalars['Float']['output']>;
  influencer_given_rating_1?: Maybe<Scalars['Float']['output']>;
  influencer_given_rating_2?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Work_Order_Reviews_Variance_Fields = {
  __typename?: 'work_order_reviews_variance_fields';
  customer_given_rating_1?: Maybe<Scalars['Float']['output']>;
  customer_given_rating_2?: Maybe<Scalars['Float']['output']>;
  influencer_given_rating_1?: Maybe<Scalars['Float']['output']>;
  influencer_given_rating_2?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "work_orders" */
export type Work_Orders = {
  __typename?: 'work_orders';
  /** An object relationship */
  account?: Maybe<Accounts>;
  account_id?: Maybe<Scalars['bpchar']['output']>;
  budget_max?: Maybe<Scalars['Int']['output']>;
  budget_min?: Maybe<Scalars['Int']['output']>;
  closed_at?: Maybe<Scalars['timestamptz']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  crops?: Maybe<Scalars['String']['output']>;
  cta_id?: Maybe<Scalars['String']['output']>;
  cta_link?: Maybe<Scalars['String']['output']>;
  cta_type?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expected_date?: Maybe<Scalars['date']['output']>;
  farminsta_cost_inr?: Maybe<Scalars['float8']['output']>;
  generation_type: Scalars['bpchar']['output'];
  /** An object relationship */
  gig?: Maybe<Gigs>;
  gig_id?: Maybe<Scalars['bpchar']['output']>;
  gig_type: Scalars['String']['output'];
  /** An object relationship */
  gig_variant?: Maybe<Gig_Variants>;
  gig_variant_id?: Maybe<Scalars['bpchar']['output']>;
  id: Scalars['bpchar']['output'];
  influencer_cost_inr?: Maybe<Scalars['float8']['output']>;
  /** An object relationship */
  influencer_user?: Maybe<Users>;
  influencer_user_id?: Maybe<Scalars['bpchar']['output']>;
  is_open_to_new_influencers?: Maybe<Scalars['Boolean']['output']>;
  languages?: Maybe<Scalars['String']['output']>;
  no_of_influencers?: Maybe<Scalars['Int']['output']>;
  objectives?: Maybe<Scalars['jsonb']['output']>;
  payment_status?: Maybe<Scalars['String']['output']>;
  product_id?: Maybe<Scalars['bpchar']['output']>;
  product_name?: Maybe<Scalars['String']['output']>;
  published_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  requests: Array<Work_Order_Requests>;
  /** An aggregate relationship */
  requests_aggregate: Work_Order_Requests_Aggregate;
  states?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  total_cost_inr?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
  variant_type?: Maybe<Scalars['String']['output']>;
  work_order_public_id?: Maybe<Scalars['String']['output']>;
  work_order_stage?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "work_orders" */
export type Work_OrdersObjectivesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "work_orders" */
export type Work_OrdersRequestsArgs = {
  distinct_on?: InputMaybe<Array<Work_Order_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Work_Order_Requests_Order_By>>;
  where?: InputMaybe<Work_Order_Requests_Bool_Exp>;
};


/** columns and relationships of "work_orders" */
export type Work_OrdersRequests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Work_Order_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Work_Order_Requests_Order_By>>;
  where?: InputMaybe<Work_Order_Requests_Bool_Exp>;
};

/** aggregated selection of "work_orders" */
export type Work_Orders_Aggregate = {
  __typename?: 'work_orders_aggregate';
  aggregate?: Maybe<Work_Orders_Aggregate_Fields>;
  nodes: Array<Work_Orders>;
};

export type Work_Orders_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Work_Orders_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Work_Orders_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Work_Orders_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Work_Orders_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Work_Orders_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Work_Orders_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Work_Orders_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Work_Orders_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Work_Orders_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Work_Orders_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Work_Orders_Aggregate_Bool_Exp_Var_Samp>;
};

export type Work_Orders_Aggregate_Bool_Exp_Avg = {
  arguments: Work_Orders_Select_Column_Work_Orders_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Work_Orders_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Work_Orders_Aggregate_Bool_Exp_Bool_And = {
  arguments: Work_Orders_Select_Column_Work_Orders_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Work_Orders_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Work_Orders_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Work_Orders_Select_Column_Work_Orders_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Work_Orders_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Work_Orders_Aggregate_Bool_Exp_Corr = {
  arguments: Work_Orders_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Work_Orders_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Work_Orders_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Work_Orders_Select_Column_Work_Orders_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Work_Orders_Select_Column_Work_Orders_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Work_Orders_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Work_Orders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Work_Orders_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Work_Orders_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Work_Orders_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Work_Orders_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Work_Orders_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Work_Orders_Select_Column_Work_Orders_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Work_Orders_Select_Column_Work_Orders_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Work_Orders_Aggregate_Bool_Exp_Max = {
  arguments: Work_Orders_Select_Column_Work_Orders_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Work_Orders_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Work_Orders_Aggregate_Bool_Exp_Min = {
  arguments: Work_Orders_Select_Column_Work_Orders_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Work_Orders_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Work_Orders_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Work_Orders_Select_Column_Work_Orders_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Work_Orders_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Work_Orders_Aggregate_Bool_Exp_Sum = {
  arguments: Work_Orders_Select_Column_Work_Orders_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Work_Orders_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Work_Orders_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Work_Orders_Select_Column_Work_Orders_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Work_Orders_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "work_orders" */
export type Work_Orders_Aggregate_Fields = {
  __typename?: 'work_orders_aggregate_fields';
  avg?: Maybe<Work_Orders_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Work_Orders_Max_Fields>;
  min?: Maybe<Work_Orders_Min_Fields>;
  stddev?: Maybe<Work_Orders_Stddev_Fields>;
  stddev_pop?: Maybe<Work_Orders_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Work_Orders_Stddev_Samp_Fields>;
  sum?: Maybe<Work_Orders_Sum_Fields>;
  var_pop?: Maybe<Work_Orders_Var_Pop_Fields>;
  var_samp?: Maybe<Work_Orders_Var_Samp_Fields>;
  variance?: Maybe<Work_Orders_Variance_Fields>;
};


/** aggregate fields of "work_orders" */
export type Work_Orders_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Work_Orders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "work_orders" */
export type Work_Orders_Aggregate_Order_By = {
  avg?: InputMaybe<Work_Orders_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Work_Orders_Max_Order_By>;
  min?: InputMaybe<Work_Orders_Min_Order_By>;
  stddev?: InputMaybe<Work_Orders_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Work_Orders_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Work_Orders_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Work_Orders_Sum_Order_By>;
  var_pop?: InputMaybe<Work_Orders_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Work_Orders_Var_Samp_Order_By>;
  variance?: InputMaybe<Work_Orders_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Work_Orders_Append_Input = {
  objectives?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "work_orders" */
export type Work_Orders_Arr_Rel_Insert_Input = {
  data: Array<Work_Orders_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Work_Orders_On_Conflict>;
};

/** aggregate avg on columns */
export type Work_Orders_Avg_Fields = {
  __typename?: 'work_orders_avg_fields';
  budget_max?: Maybe<Scalars['Float']['output']>;
  budget_min?: Maybe<Scalars['Float']['output']>;
  farminsta_cost_inr?: Maybe<Scalars['Float']['output']>;
  influencer_cost_inr?: Maybe<Scalars['Float']['output']>;
  no_of_influencers?: Maybe<Scalars['Float']['output']>;
  total_cost_inr?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "work_orders" */
export type Work_Orders_Avg_Order_By = {
  budget_max?: InputMaybe<Order_By>;
  budget_min?: InputMaybe<Order_By>;
  farminsta_cost_inr?: InputMaybe<Order_By>;
  influencer_cost_inr?: InputMaybe<Order_By>;
  no_of_influencers?: InputMaybe<Order_By>;
  total_cost_inr?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "work_orders". All fields are combined with a logical 'AND'. */
export type Work_Orders_Bool_Exp = {
  _and?: InputMaybe<Array<Work_Orders_Bool_Exp>>;
  _not?: InputMaybe<Work_Orders_Bool_Exp>;
  _or?: InputMaybe<Array<Work_Orders_Bool_Exp>>;
  account?: InputMaybe<Accounts_Bool_Exp>;
  account_id?: InputMaybe<Bpchar_Comparison_Exp>;
  budget_max?: InputMaybe<Int_Comparison_Exp>;
  budget_min?: InputMaybe<Int_Comparison_Exp>;
  closed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  company_id?: InputMaybe<Bpchar_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_user?: InputMaybe<Users_Bool_Exp>;
  crops?: InputMaybe<String_Comparison_Exp>;
  cta_id?: InputMaybe<String_Comparison_Exp>;
  cta_link?: InputMaybe<String_Comparison_Exp>;
  cta_type?: InputMaybe<String_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  expected_date?: InputMaybe<Date_Comparison_Exp>;
  farminsta_cost_inr?: InputMaybe<Float8_Comparison_Exp>;
  generation_type?: InputMaybe<Bpchar_Comparison_Exp>;
  gig?: InputMaybe<Gigs_Bool_Exp>;
  gig_id?: InputMaybe<Bpchar_Comparison_Exp>;
  gig_type?: InputMaybe<String_Comparison_Exp>;
  gig_variant?: InputMaybe<Gig_Variants_Bool_Exp>;
  gig_variant_id?: InputMaybe<Bpchar_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  influencer_cost_inr?: InputMaybe<Float8_Comparison_Exp>;
  influencer_user?: InputMaybe<Users_Bool_Exp>;
  influencer_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  is_open_to_new_influencers?: InputMaybe<Boolean_Comparison_Exp>;
  languages?: InputMaybe<String_Comparison_Exp>;
  no_of_influencers?: InputMaybe<Int_Comparison_Exp>;
  objectives?: InputMaybe<Jsonb_Comparison_Exp>;
  payment_status?: InputMaybe<String_Comparison_Exp>;
  product_id?: InputMaybe<Bpchar_Comparison_Exp>;
  product_name?: InputMaybe<String_Comparison_Exp>;
  published_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  requests?: InputMaybe<Work_Order_Requests_Bool_Exp>;
  requests_aggregate?: InputMaybe<Work_Order_Requests_Aggregate_Bool_Exp>;
  states?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  total_cost_inr?: InputMaybe<Float8_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  variant_type?: InputMaybe<String_Comparison_Exp>;
  work_order_public_id?: InputMaybe<String_Comparison_Exp>;
  work_order_stage?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "work_orders" */
export enum Work_Orders_Constraint {
  /** unique or primary key constraint on columns "id" */
  WorkOrdersPkey = 'work_orders_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Work_Orders_Delete_At_Path_Input = {
  objectives?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Work_Orders_Delete_Elem_Input = {
  objectives?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Work_Orders_Delete_Key_Input = {
  objectives?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "work_orders" */
export type Work_Orders_Inc_Input = {
  budget_max?: InputMaybe<Scalars['Int']['input']>;
  budget_min?: InputMaybe<Scalars['Int']['input']>;
  farminsta_cost_inr?: InputMaybe<Scalars['float8']['input']>;
  influencer_cost_inr?: InputMaybe<Scalars['float8']['input']>;
  no_of_influencers?: InputMaybe<Scalars['Int']['input']>;
  total_cost_inr?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "work_orders" */
export type Work_Orders_Insert_Input = {
  account?: InputMaybe<Accounts_Obj_Rel_Insert_Input>;
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  budget_max?: InputMaybe<Scalars['Int']['input']>;
  budget_min?: InputMaybe<Scalars['Int']['input']>;
  closed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  crops?: InputMaybe<Scalars['String']['input']>;
  cta_id?: InputMaybe<Scalars['String']['input']>;
  cta_link?: InputMaybe<Scalars['String']['input']>;
  cta_type?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expected_date?: InputMaybe<Scalars['date']['input']>;
  farminsta_cost_inr?: InputMaybe<Scalars['float8']['input']>;
  generation_type?: InputMaybe<Scalars['bpchar']['input']>;
  gig?: InputMaybe<Gigs_Obj_Rel_Insert_Input>;
  gig_id?: InputMaybe<Scalars['bpchar']['input']>;
  gig_type?: InputMaybe<Scalars['String']['input']>;
  gig_variant?: InputMaybe<Gig_Variants_Obj_Rel_Insert_Input>;
  gig_variant_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  influencer_cost_inr?: InputMaybe<Scalars['float8']['input']>;
  influencer_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  influencer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  is_open_to_new_influencers?: InputMaybe<Scalars['Boolean']['input']>;
  languages?: InputMaybe<Scalars['String']['input']>;
  no_of_influencers?: InputMaybe<Scalars['Int']['input']>;
  objectives?: InputMaybe<Scalars['jsonb']['input']>;
  payment_status?: InputMaybe<Scalars['String']['input']>;
  product_id?: InputMaybe<Scalars['bpchar']['input']>;
  product_name?: InputMaybe<Scalars['String']['input']>;
  published_at?: InputMaybe<Scalars['timestamptz']['input']>;
  requests?: InputMaybe<Work_Order_Requests_Arr_Rel_Insert_Input>;
  states?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  total_cost_inr?: InputMaybe<Scalars['float8']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
  variant_type?: InputMaybe<Scalars['String']['input']>;
  work_order_public_id?: InputMaybe<Scalars['String']['input']>;
  work_order_stage?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Work_Orders_Max_Fields = {
  __typename?: 'work_orders_max_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  budget_max?: Maybe<Scalars['Int']['output']>;
  budget_min?: Maybe<Scalars['Int']['output']>;
  closed_at?: Maybe<Scalars['timestamptz']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crops?: Maybe<Scalars['String']['output']>;
  cta_id?: Maybe<Scalars['String']['output']>;
  cta_link?: Maybe<Scalars['String']['output']>;
  cta_type?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expected_date?: Maybe<Scalars['date']['output']>;
  farminsta_cost_inr?: Maybe<Scalars['float8']['output']>;
  generation_type?: Maybe<Scalars['bpchar']['output']>;
  gig_id?: Maybe<Scalars['bpchar']['output']>;
  gig_type?: Maybe<Scalars['String']['output']>;
  gig_variant_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  influencer_cost_inr?: Maybe<Scalars['float8']['output']>;
  influencer_user_id?: Maybe<Scalars['bpchar']['output']>;
  languages?: Maybe<Scalars['String']['output']>;
  no_of_influencers?: Maybe<Scalars['Int']['output']>;
  payment_status?: Maybe<Scalars['String']['output']>;
  product_id?: Maybe<Scalars['bpchar']['output']>;
  product_name?: Maybe<Scalars['String']['output']>;
  published_at?: Maybe<Scalars['timestamptz']['output']>;
  states?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total_cost_inr?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
  variant_type?: Maybe<Scalars['String']['output']>;
  work_order_public_id?: Maybe<Scalars['String']['output']>;
  work_order_stage?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "work_orders" */
export type Work_Orders_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  budget_max?: InputMaybe<Order_By>;
  budget_min?: InputMaybe<Order_By>;
  closed_at?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crops?: InputMaybe<Order_By>;
  cta_id?: InputMaybe<Order_By>;
  cta_link?: InputMaybe<Order_By>;
  cta_type?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  expected_date?: InputMaybe<Order_By>;
  farminsta_cost_inr?: InputMaybe<Order_By>;
  generation_type?: InputMaybe<Order_By>;
  gig_id?: InputMaybe<Order_By>;
  gig_type?: InputMaybe<Order_By>;
  gig_variant_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  influencer_cost_inr?: InputMaybe<Order_By>;
  influencer_user_id?: InputMaybe<Order_By>;
  languages?: InputMaybe<Order_By>;
  no_of_influencers?: InputMaybe<Order_By>;
  payment_status?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  product_name?: InputMaybe<Order_By>;
  published_at?: InputMaybe<Order_By>;
  states?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  total_cost_inr?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  variant_type?: InputMaybe<Order_By>;
  work_order_public_id?: InputMaybe<Order_By>;
  work_order_stage?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Work_Orders_Min_Fields = {
  __typename?: 'work_orders_min_fields';
  account_id?: Maybe<Scalars['bpchar']['output']>;
  budget_max?: Maybe<Scalars['Int']['output']>;
  budget_min?: Maybe<Scalars['Int']['output']>;
  closed_at?: Maybe<Scalars['timestamptz']['output']>;
  company_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crops?: Maybe<Scalars['String']['output']>;
  cta_id?: Maybe<Scalars['String']['output']>;
  cta_link?: Maybe<Scalars['String']['output']>;
  cta_type?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expected_date?: Maybe<Scalars['date']['output']>;
  farminsta_cost_inr?: Maybe<Scalars['float8']['output']>;
  generation_type?: Maybe<Scalars['bpchar']['output']>;
  gig_id?: Maybe<Scalars['bpchar']['output']>;
  gig_type?: Maybe<Scalars['String']['output']>;
  gig_variant_id?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  influencer_cost_inr?: Maybe<Scalars['float8']['output']>;
  influencer_user_id?: Maybe<Scalars['bpchar']['output']>;
  languages?: Maybe<Scalars['String']['output']>;
  no_of_influencers?: Maybe<Scalars['Int']['output']>;
  payment_status?: Maybe<Scalars['String']['output']>;
  product_id?: Maybe<Scalars['bpchar']['output']>;
  product_name?: Maybe<Scalars['String']['output']>;
  published_at?: Maybe<Scalars['timestamptz']['output']>;
  states?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total_cost_inr?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
  variant_type?: Maybe<Scalars['String']['output']>;
  work_order_public_id?: Maybe<Scalars['String']['output']>;
  work_order_stage?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "work_orders" */
export type Work_Orders_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  budget_max?: InputMaybe<Order_By>;
  budget_min?: InputMaybe<Order_By>;
  closed_at?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crops?: InputMaybe<Order_By>;
  cta_id?: InputMaybe<Order_By>;
  cta_link?: InputMaybe<Order_By>;
  cta_type?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  expected_date?: InputMaybe<Order_By>;
  farminsta_cost_inr?: InputMaybe<Order_By>;
  generation_type?: InputMaybe<Order_By>;
  gig_id?: InputMaybe<Order_By>;
  gig_type?: InputMaybe<Order_By>;
  gig_variant_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  influencer_cost_inr?: InputMaybe<Order_By>;
  influencer_user_id?: InputMaybe<Order_By>;
  languages?: InputMaybe<Order_By>;
  no_of_influencers?: InputMaybe<Order_By>;
  payment_status?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  product_name?: InputMaybe<Order_By>;
  published_at?: InputMaybe<Order_By>;
  states?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  total_cost_inr?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  variant_type?: InputMaybe<Order_By>;
  work_order_public_id?: InputMaybe<Order_By>;
  work_order_stage?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "work_orders" */
export type Work_Orders_Mutation_Response = {
  __typename?: 'work_orders_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Work_Orders>;
};

/** on_conflict condition type for table "work_orders" */
export type Work_Orders_On_Conflict = {
  constraint: Work_Orders_Constraint;
  update_columns?: Array<Work_Orders_Update_Column>;
  where?: InputMaybe<Work_Orders_Bool_Exp>;
};

/** Ordering options when selecting data from "work_orders". */
export type Work_Orders_Order_By = {
  account?: InputMaybe<Accounts_Order_By>;
  account_id?: InputMaybe<Order_By>;
  budget_max?: InputMaybe<Order_By>;
  budget_min?: InputMaybe<Order_By>;
  closed_at?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<Users_Order_By>;
  crops?: InputMaybe<Order_By>;
  cta_id?: InputMaybe<Order_By>;
  cta_link?: InputMaybe<Order_By>;
  cta_type?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  expected_date?: InputMaybe<Order_By>;
  farminsta_cost_inr?: InputMaybe<Order_By>;
  generation_type?: InputMaybe<Order_By>;
  gig?: InputMaybe<Gigs_Order_By>;
  gig_id?: InputMaybe<Order_By>;
  gig_type?: InputMaybe<Order_By>;
  gig_variant?: InputMaybe<Gig_Variants_Order_By>;
  gig_variant_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  influencer_cost_inr?: InputMaybe<Order_By>;
  influencer_user?: InputMaybe<Users_Order_By>;
  influencer_user_id?: InputMaybe<Order_By>;
  is_open_to_new_influencers?: InputMaybe<Order_By>;
  languages?: InputMaybe<Order_By>;
  no_of_influencers?: InputMaybe<Order_By>;
  objectives?: InputMaybe<Order_By>;
  payment_status?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  product_name?: InputMaybe<Order_By>;
  published_at?: InputMaybe<Order_By>;
  requests_aggregate?: InputMaybe<Work_Order_Requests_Aggregate_Order_By>;
  states?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  total_cost_inr?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  variant_type?: InputMaybe<Order_By>;
  work_order_public_id?: InputMaybe<Order_By>;
  work_order_stage?: InputMaybe<Order_By>;
};

/** primary key columns input for table: work_orders */
export type Work_Orders_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Work_Orders_Prepend_Input = {
  objectives?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "work_orders" */
export enum Work_Orders_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  BudgetMax = 'budget_max',
  /** column name */
  BudgetMin = 'budget_min',
  /** column name */
  ClosedAt = 'closed_at',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Crops = 'crops',
  /** column name */
  CtaId = 'cta_id',
  /** column name */
  CtaLink = 'cta_link',
  /** column name */
  CtaType = 'cta_type',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  ExpectedDate = 'expected_date',
  /** column name */
  FarminstaCostInr = 'farminsta_cost_inr',
  /** column name */
  GenerationType = 'generation_type',
  /** column name */
  GigId = 'gig_id',
  /** column name */
  GigType = 'gig_type',
  /** column name */
  GigVariantId = 'gig_variant_id',
  /** column name */
  Id = 'id',
  /** column name */
  InfluencerCostInr = 'influencer_cost_inr',
  /** column name */
  InfluencerUserId = 'influencer_user_id',
  /** column name */
  IsOpenToNewInfluencers = 'is_open_to_new_influencers',
  /** column name */
  Languages = 'languages',
  /** column name */
  NoOfInfluencers = 'no_of_influencers',
  /** column name */
  Objectives = 'objectives',
  /** column name */
  PaymentStatus = 'payment_status',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  ProductName = 'product_name',
  /** column name */
  PublishedAt = 'published_at',
  /** column name */
  States = 'states',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title',
  /** column name */
  TotalCostInr = 'total_cost_inr',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VariantType = 'variant_type',
  /** column name */
  WorkOrderPublicId = 'work_order_public_id',
  /** column name */
  WorkOrderStage = 'work_order_stage'
}

/** select "work_orders_aggregate_bool_exp_avg_arguments_columns" columns of table "work_orders" */
export enum Work_Orders_Select_Column_Work_Orders_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  FarminstaCostInr = 'farminsta_cost_inr',
  /** column name */
  InfluencerCostInr = 'influencer_cost_inr',
  /** column name */
  TotalCostInr = 'total_cost_inr'
}

/** select "work_orders_aggregate_bool_exp_bool_and_arguments_columns" columns of table "work_orders" */
export enum Work_Orders_Select_Column_Work_Orders_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsOpenToNewInfluencers = 'is_open_to_new_influencers'
}

/** select "work_orders_aggregate_bool_exp_bool_or_arguments_columns" columns of table "work_orders" */
export enum Work_Orders_Select_Column_Work_Orders_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsOpenToNewInfluencers = 'is_open_to_new_influencers'
}

/** select "work_orders_aggregate_bool_exp_corr_arguments_columns" columns of table "work_orders" */
export enum Work_Orders_Select_Column_Work_Orders_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  FarminstaCostInr = 'farminsta_cost_inr',
  /** column name */
  InfluencerCostInr = 'influencer_cost_inr',
  /** column name */
  TotalCostInr = 'total_cost_inr'
}

/** select "work_orders_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "work_orders" */
export enum Work_Orders_Select_Column_Work_Orders_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  FarminstaCostInr = 'farminsta_cost_inr',
  /** column name */
  InfluencerCostInr = 'influencer_cost_inr',
  /** column name */
  TotalCostInr = 'total_cost_inr'
}

/** select "work_orders_aggregate_bool_exp_max_arguments_columns" columns of table "work_orders" */
export enum Work_Orders_Select_Column_Work_Orders_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  FarminstaCostInr = 'farminsta_cost_inr',
  /** column name */
  InfluencerCostInr = 'influencer_cost_inr',
  /** column name */
  TotalCostInr = 'total_cost_inr'
}

/** select "work_orders_aggregate_bool_exp_min_arguments_columns" columns of table "work_orders" */
export enum Work_Orders_Select_Column_Work_Orders_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  FarminstaCostInr = 'farminsta_cost_inr',
  /** column name */
  InfluencerCostInr = 'influencer_cost_inr',
  /** column name */
  TotalCostInr = 'total_cost_inr'
}

/** select "work_orders_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "work_orders" */
export enum Work_Orders_Select_Column_Work_Orders_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  FarminstaCostInr = 'farminsta_cost_inr',
  /** column name */
  InfluencerCostInr = 'influencer_cost_inr',
  /** column name */
  TotalCostInr = 'total_cost_inr'
}

/** select "work_orders_aggregate_bool_exp_sum_arguments_columns" columns of table "work_orders" */
export enum Work_Orders_Select_Column_Work_Orders_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  FarminstaCostInr = 'farminsta_cost_inr',
  /** column name */
  InfluencerCostInr = 'influencer_cost_inr',
  /** column name */
  TotalCostInr = 'total_cost_inr'
}

/** select "work_orders_aggregate_bool_exp_var_samp_arguments_columns" columns of table "work_orders" */
export enum Work_Orders_Select_Column_Work_Orders_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  FarminstaCostInr = 'farminsta_cost_inr',
  /** column name */
  InfluencerCostInr = 'influencer_cost_inr',
  /** column name */
  TotalCostInr = 'total_cost_inr'
}

/** input type for updating data in table "work_orders" */
export type Work_Orders_Set_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  budget_max?: InputMaybe<Scalars['Int']['input']>;
  budget_min?: InputMaybe<Scalars['Int']['input']>;
  closed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crops?: InputMaybe<Scalars['String']['input']>;
  cta_id?: InputMaybe<Scalars['String']['input']>;
  cta_link?: InputMaybe<Scalars['String']['input']>;
  cta_type?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expected_date?: InputMaybe<Scalars['date']['input']>;
  farminsta_cost_inr?: InputMaybe<Scalars['float8']['input']>;
  generation_type?: InputMaybe<Scalars['bpchar']['input']>;
  gig_id?: InputMaybe<Scalars['bpchar']['input']>;
  gig_type?: InputMaybe<Scalars['String']['input']>;
  gig_variant_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  influencer_cost_inr?: InputMaybe<Scalars['float8']['input']>;
  influencer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  is_open_to_new_influencers?: InputMaybe<Scalars['Boolean']['input']>;
  languages?: InputMaybe<Scalars['String']['input']>;
  no_of_influencers?: InputMaybe<Scalars['Int']['input']>;
  objectives?: InputMaybe<Scalars['jsonb']['input']>;
  payment_status?: InputMaybe<Scalars['String']['input']>;
  product_id?: InputMaybe<Scalars['bpchar']['input']>;
  product_name?: InputMaybe<Scalars['String']['input']>;
  published_at?: InputMaybe<Scalars['timestamptz']['input']>;
  states?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  total_cost_inr?: InputMaybe<Scalars['float8']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
  variant_type?: InputMaybe<Scalars['String']['input']>;
  work_order_public_id?: InputMaybe<Scalars['String']['input']>;
  work_order_stage?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Work_Orders_Stddev_Fields = {
  __typename?: 'work_orders_stddev_fields';
  budget_max?: Maybe<Scalars['Float']['output']>;
  budget_min?: Maybe<Scalars['Float']['output']>;
  farminsta_cost_inr?: Maybe<Scalars['Float']['output']>;
  influencer_cost_inr?: Maybe<Scalars['Float']['output']>;
  no_of_influencers?: Maybe<Scalars['Float']['output']>;
  total_cost_inr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "work_orders" */
export type Work_Orders_Stddev_Order_By = {
  budget_max?: InputMaybe<Order_By>;
  budget_min?: InputMaybe<Order_By>;
  farminsta_cost_inr?: InputMaybe<Order_By>;
  influencer_cost_inr?: InputMaybe<Order_By>;
  no_of_influencers?: InputMaybe<Order_By>;
  total_cost_inr?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Work_Orders_Stddev_Pop_Fields = {
  __typename?: 'work_orders_stddev_pop_fields';
  budget_max?: Maybe<Scalars['Float']['output']>;
  budget_min?: Maybe<Scalars['Float']['output']>;
  farminsta_cost_inr?: Maybe<Scalars['Float']['output']>;
  influencer_cost_inr?: Maybe<Scalars['Float']['output']>;
  no_of_influencers?: Maybe<Scalars['Float']['output']>;
  total_cost_inr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "work_orders" */
export type Work_Orders_Stddev_Pop_Order_By = {
  budget_max?: InputMaybe<Order_By>;
  budget_min?: InputMaybe<Order_By>;
  farminsta_cost_inr?: InputMaybe<Order_By>;
  influencer_cost_inr?: InputMaybe<Order_By>;
  no_of_influencers?: InputMaybe<Order_By>;
  total_cost_inr?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Work_Orders_Stddev_Samp_Fields = {
  __typename?: 'work_orders_stddev_samp_fields';
  budget_max?: Maybe<Scalars['Float']['output']>;
  budget_min?: Maybe<Scalars['Float']['output']>;
  farminsta_cost_inr?: Maybe<Scalars['Float']['output']>;
  influencer_cost_inr?: Maybe<Scalars['Float']['output']>;
  no_of_influencers?: Maybe<Scalars['Float']['output']>;
  total_cost_inr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "work_orders" */
export type Work_Orders_Stddev_Samp_Order_By = {
  budget_max?: InputMaybe<Order_By>;
  budget_min?: InputMaybe<Order_By>;
  farminsta_cost_inr?: InputMaybe<Order_By>;
  influencer_cost_inr?: InputMaybe<Order_By>;
  no_of_influencers?: InputMaybe<Order_By>;
  total_cost_inr?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "work_orders" */
export type Work_Orders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Work_Orders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Work_Orders_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
  budget_max?: InputMaybe<Scalars['Int']['input']>;
  budget_min?: InputMaybe<Scalars['Int']['input']>;
  closed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  company_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crops?: InputMaybe<Scalars['String']['input']>;
  cta_id?: InputMaybe<Scalars['String']['input']>;
  cta_link?: InputMaybe<Scalars['String']['input']>;
  cta_type?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expected_date?: InputMaybe<Scalars['date']['input']>;
  farminsta_cost_inr?: InputMaybe<Scalars['float8']['input']>;
  generation_type?: InputMaybe<Scalars['bpchar']['input']>;
  gig_id?: InputMaybe<Scalars['bpchar']['input']>;
  gig_type?: InputMaybe<Scalars['String']['input']>;
  gig_variant_id?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  influencer_cost_inr?: InputMaybe<Scalars['float8']['input']>;
  influencer_user_id?: InputMaybe<Scalars['bpchar']['input']>;
  is_open_to_new_influencers?: InputMaybe<Scalars['Boolean']['input']>;
  languages?: InputMaybe<Scalars['String']['input']>;
  no_of_influencers?: InputMaybe<Scalars['Int']['input']>;
  objectives?: InputMaybe<Scalars['jsonb']['input']>;
  payment_status?: InputMaybe<Scalars['String']['input']>;
  product_id?: InputMaybe<Scalars['bpchar']['input']>;
  product_name?: InputMaybe<Scalars['String']['input']>;
  published_at?: InputMaybe<Scalars['timestamptz']['input']>;
  states?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  total_cost_inr?: InputMaybe<Scalars['float8']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
  variant_type?: InputMaybe<Scalars['String']['input']>;
  work_order_public_id?: InputMaybe<Scalars['String']['input']>;
  work_order_stage?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Work_Orders_Sum_Fields = {
  __typename?: 'work_orders_sum_fields';
  budget_max?: Maybe<Scalars['Int']['output']>;
  budget_min?: Maybe<Scalars['Int']['output']>;
  farminsta_cost_inr?: Maybe<Scalars['float8']['output']>;
  influencer_cost_inr?: Maybe<Scalars['float8']['output']>;
  no_of_influencers?: Maybe<Scalars['Int']['output']>;
  total_cost_inr?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "work_orders" */
export type Work_Orders_Sum_Order_By = {
  budget_max?: InputMaybe<Order_By>;
  budget_min?: InputMaybe<Order_By>;
  farminsta_cost_inr?: InputMaybe<Order_By>;
  influencer_cost_inr?: InputMaybe<Order_By>;
  no_of_influencers?: InputMaybe<Order_By>;
  total_cost_inr?: InputMaybe<Order_By>;
};

/** update columns of table "work_orders" */
export enum Work_Orders_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  BudgetMax = 'budget_max',
  /** column name */
  BudgetMin = 'budget_min',
  /** column name */
  ClosedAt = 'closed_at',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Crops = 'crops',
  /** column name */
  CtaId = 'cta_id',
  /** column name */
  CtaLink = 'cta_link',
  /** column name */
  CtaType = 'cta_type',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  ExpectedDate = 'expected_date',
  /** column name */
  FarminstaCostInr = 'farminsta_cost_inr',
  /** column name */
  GenerationType = 'generation_type',
  /** column name */
  GigId = 'gig_id',
  /** column name */
  GigType = 'gig_type',
  /** column name */
  GigVariantId = 'gig_variant_id',
  /** column name */
  Id = 'id',
  /** column name */
  InfluencerCostInr = 'influencer_cost_inr',
  /** column name */
  InfluencerUserId = 'influencer_user_id',
  /** column name */
  IsOpenToNewInfluencers = 'is_open_to_new_influencers',
  /** column name */
  Languages = 'languages',
  /** column name */
  NoOfInfluencers = 'no_of_influencers',
  /** column name */
  Objectives = 'objectives',
  /** column name */
  PaymentStatus = 'payment_status',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  ProductName = 'product_name',
  /** column name */
  PublishedAt = 'published_at',
  /** column name */
  States = 'states',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title',
  /** column name */
  TotalCostInr = 'total_cost_inr',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VariantType = 'variant_type',
  /** column name */
  WorkOrderPublicId = 'work_order_public_id',
  /** column name */
  WorkOrderStage = 'work_order_stage'
}

export type Work_Orders_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Work_Orders_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Work_Orders_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Work_Orders_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Work_Orders_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Work_Orders_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Work_Orders_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Work_Orders_Set_Input>;
  /** filter the rows which have to be updated */
  where: Work_Orders_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Work_Orders_Var_Pop_Fields = {
  __typename?: 'work_orders_var_pop_fields';
  budget_max?: Maybe<Scalars['Float']['output']>;
  budget_min?: Maybe<Scalars['Float']['output']>;
  farminsta_cost_inr?: Maybe<Scalars['Float']['output']>;
  influencer_cost_inr?: Maybe<Scalars['Float']['output']>;
  no_of_influencers?: Maybe<Scalars['Float']['output']>;
  total_cost_inr?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "work_orders" */
export type Work_Orders_Var_Pop_Order_By = {
  budget_max?: InputMaybe<Order_By>;
  budget_min?: InputMaybe<Order_By>;
  farminsta_cost_inr?: InputMaybe<Order_By>;
  influencer_cost_inr?: InputMaybe<Order_By>;
  no_of_influencers?: InputMaybe<Order_By>;
  total_cost_inr?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Work_Orders_Var_Samp_Fields = {
  __typename?: 'work_orders_var_samp_fields';
  budget_max?: Maybe<Scalars['Float']['output']>;
  budget_min?: Maybe<Scalars['Float']['output']>;
  farminsta_cost_inr?: Maybe<Scalars['Float']['output']>;
  influencer_cost_inr?: Maybe<Scalars['Float']['output']>;
  no_of_influencers?: Maybe<Scalars['Float']['output']>;
  total_cost_inr?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "work_orders" */
export type Work_Orders_Var_Samp_Order_By = {
  budget_max?: InputMaybe<Order_By>;
  budget_min?: InputMaybe<Order_By>;
  farminsta_cost_inr?: InputMaybe<Order_By>;
  influencer_cost_inr?: InputMaybe<Order_By>;
  no_of_influencers?: InputMaybe<Order_By>;
  total_cost_inr?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Work_Orders_Variance_Fields = {
  __typename?: 'work_orders_variance_fields';
  budget_max?: Maybe<Scalars['Float']['output']>;
  budget_min?: Maybe<Scalars['Float']['output']>;
  farminsta_cost_inr?: Maybe<Scalars['Float']['output']>;
  influencer_cost_inr?: Maybe<Scalars['Float']['output']>;
  no_of_influencers?: Maybe<Scalars['Float']['output']>;
  total_cost_inr?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "work_orders" */
export type Work_Orders_Variance_Order_By = {
  budget_max?: InputMaybe<Order_By>;
  budget_min?: InputMaybe<Order_By>;
  farminsta_cost_inr?: InputMaybe<Order_By>;
  influencer_cost_inr?: InputMaybe<Order_By>;
  no_of_influencers?: InputMaybe<Order_By>;
  total_cost_inr?: InputMaybe<Order_By>;
};

export type CreateShopifyUserAccountMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type CreateShopifyUserAccountMutation = { __typename?: 'mutation_root', createShopifyUserAccount?: { __typename?: 'ShopifyUserToken', id: string, accessToken: string, expiresAt?: any | null } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'query_root', me: { __typename?: 'User', id: string, account_id?: string | null, company_id?: string | null, name?: string | null, email?: string | null, locale?: string | null, contentLanguages: Array<string>, phoneNumber: string, profile_image_url?: string | null, roles: Array<string>, account?: { __typename?: 'Account', accountName?: string | null, accountType?: string | null, features?: Array<string | null> | null, id?: string | null } | null, market?: { __typename?: 'PandoforceUser', id?: number | null, designation?: string | null, hq?: string | null, reportingUser?: { __typename?: 'PandoforceUser', designation?: string | null } | null } | null, last_known_location?: { __typename?: 'UserLastKnownLocation', is_active: boolean, address: string, lat: number, lng: number, state_name: string } | null } };

export type ChannelAndReelAnalyticsQueryVariables = Exact<{
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
}>;


export type ChannelAndReelAnalyticsQuery = { __typename?: 'query_root', channels: Array<{ __typename?: 'channels', id: any, name?: string | null, description?: string | null, logo_image_url?: string | null, content_languages?: any | null, channel_links: Array<{ __typename?: 'channel_links', id: any, link_url: string, link_type?: string | null, follower_count: number }> }> };

export type ReelCommentsSubscriptionVariables = Exact<{
  channelId?: InputMaybe<Scalars['bigint']['input']>;
  reelId?: InputMaybe<Scalars['bigint']['input']>;
}>;


export type ReelCommentsSubscription = { __typename?: 'subscription_root', reel_interactions: Array<{ __typename?: 'reel_comments', id: any, user_id: any, comment: string, parent_id?: any | null, created_at?: any | null, reel: { __typename?: 'reels', id: any, thumbnail_url?: string | null, cloudflare_thumbnail_url?: string | null, title?: string | null }, user: { __typename?: 'users', name: string, profile_image_url?: string | null, last_known_locations: Array<{ __typename?: 'last_known_locations', id: any, address?: string | null }> }, reel_interactions_user: { __typename?: 'users', name: string, profile_image_url?: string | null, last_known_locations: Array<{ __typename?: 'last_known_locations', id: any, address?: string | null }> } }> };

export type AnalyticsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
  channelIdInt?: InputMaybe<Scalars['bigint']['input']>;
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type AnalyticsQuery = { __typename?: 'query_root', reel_stats_aggregate: { __typename?: 'reel_stats_aggregate', aggregate?: { __typename?: 'reel_stats_aggregate_fields', sum?: { __typename?: 'reel_stats_sum_fields', total_watch_time_ms?: any | null, playback_count?: any | null, avg_watch_time_ms?: any | null, reel_id?: any | null, view_count?: any | null } | null } | null }, channelAnalytics: { __typename?: 'GetChannelAnalyticsOutput', userId: string, companyId: string, accountId: string, channelName?: string | null, accountName: string, channelDescription?: string | null, channelLogoImageUrl?: string | null, followerCount: number, fullyViewedCount: number, sharesCount: number, commentsCount: number, likesCount: number, reels: number, watchTimeInMinutes: number, reelsAnalyticsOutput?: Array<{ __typename?: 'BasicReelAnalyticsOutput', reelId: number, title: string, createdAt: any, comments: number, thumbnailUrl: string, likes: number, shares: number, views: number, stats?: { __typename?: 'ReelStats', avgWatchTimeMs?: number | null, playbackCount?: number | null, viewCount?: number | null, totalWatchTimeMs?: number | null } | null, locationWiseViews: { __typename?: 'DataTable', headers?: Array<string | null> | null, rows?: Array<{ __typename?: 'DataRow', cells?: Array<string | null> | null } | null> | null } } | null> | null } };

export type CampaignSummaryQueryVariables = Exact<{
  account_id: Scalars['String']['input'];
  campaign_id: Scalars['String']['input'];
}>;


export type CampaignSummaryQuery = { __typename?: 'query_root', campaignWiseSummary?: Array<{ __typename?: 'CampaignWiseSummaryResponse', channel?: string | null, status: string, message_count: string } | null> | null };

export type CampaignRecipientsQueryVariables = Exact<{
  campaignId: Scalars['bpchar']['input'];
}>;


export type CampaignRecipientsQuery = { __typename?: 'query_root', messaging_campaign_recipients: Array<{ __typename?: 'messaging_campaign_recipients', id: any, phone?: string | null, content?: string | null, status: string, scheduled_at?: any | null, farmer_master?: { __typename?: 'farmer_master', id: any, name: string, phone_number: string } | null }> };

export type CampaignQueryVariables = Exact<{
  accountId: Scalars['bpchar']['input'];
}>;


export type CampaignQuery = { __typename?: 'query_root', messaging_campaigns: Array<{ __typename?: 'messaging_campaigns', id: any, status?: string | null, name?: string | null, description?: string | null, campaign_public_id?: string | null, created_at?: any | null, executed_at?: any | null, scheduled_at?: any | null, template_data?: any | null, template: { __typename?: 'messaging_templates', id: any, type: string, channels: any, content: string }, recipients_aggregate: { __typename?: 'messaging_campaign_recipients_aggregate', aggregate?: { __typename?: 'messaging_campaign_recipients_aggregate_fields', count: number } | null }, user: { __typename?: 'users', id: any, name: string, profile_image_url?: string | null }, segments: Array<{ __typename?: 'messaging_campaign_segments', id: any, segment: { __typename?: 'crm_segments', id: any, name?: string | null, matching_count?: number | null } }> }> };

export type AccountSummaryQueryVariables = Exact<{
  account_id: Scalars['String']['input'];
}>;


export type AccountSummaryQuery = { __typename?: 'query_root', accountsWiseCampaignSummary?: Array<{ __typename?: 'AccountsWiseCampaignSummaryResponse', channel?: string | null, status: string, message_count: string } | null> | null };

export type SalesDataQueryVariables = Exact<{
  accountId: Scalars['bpchar']['input'];
}>;


export type SalesDataQuery = { __typename?: 'query_root', pf_fcm_products: Array<{ __typename: 'pf_fcm_products', id: any, product_id?: any | null, product_name: string, shopify_product_id?: string | null, name: string }> };

export type ContentReelsQueryVariables = Exact<{
  channelId?: InputMaybe<Scalars['bigint']['input']>;
}>;


export type ContentReelsQuery = { __typename?: 'query_root', fich_farminsta_replica_reels_flat: Array<{ __typename?: 'fich_farminsta_replica_reels_flat', id?: any | null, title?: string | null, thumbnail_url?: string | null, description?: string | null, created_at?: any | null, playback_count?: any | null, avg_watch_duration_percent?: any | null, view_count?: any | null, react_count?: any | null, share_count?: any | null, comment_count?: any | null, duration_ms?: any | null, lead_count?: any | null, user_name?: string | null, user_id?: any | null, uploader_type?: string | null, active_lead_count?: any | null, tws?: any | null }> };

export type GetCrmTemplatesQueryVariables = Exact<{
  accountId: Scalars['bpchar']['input'];
}>;


export type GetCrmTemplatesQuery = { __typename?: 'query_root', messaging_templates: Array<{ __typename?: 'messaging_templates', id: any, name: string, content: string, data: any, created_at?: any | null, channels: any, type: string }> };

export type CreateMessageCampaignMutationVariables = Exact<{
  templateId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  templateData: Scalars['String']['input'];
  segmentIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  customRecipients: Scalars['String']['input'];
  scheduledAt: Scalars['DateTime']['input'];
}>;


export type CreateMessageCampaignMutation = { __typename?: 'mutation_root', createMessageCampaign: { __typename?: 'MessagingCampaign', id: string, createdAt?: any | null, name?: string | null, templateId: string, templateData?: string | null, status?: string | null, scheduledAt?: any | null, executedAt?: any | null } };

export type CrmSchemaQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
}>;


export type CrmSchemaQuery = { __typename?: 'query_root', cRMSchema?: Array<{ __typename?: 'FormBuilder', dataType?: string | null, fieldSeq?: number | null, id: number, label?: string | null, mandatory?: number | null, validationType?: string | null, valueType?: string | null, viewConfig?: any | null, formValues?: Array<{ __typename?: 'FormValue', dataType?: string | null, id: number, value?: string | null } | null> | null } | null> | null };

export type CRmItemsQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
  filterJson: Scalars['String']['input'];
  orderBy?: InputMaybe<Scalars['String']['input']>;
  dir?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CRmItemsQuery = { __typename?: 'query_root', searchCRMItems: { __typename?: 'CRMItemWithDataPaginatedResponse', totalCount: number, totalPages: number, pageSize: number, items?: Array<{ __typename?: 'CRMItemWithData', id: string, farmerId?: string | null, farmerName?: string | null, phoneNumber?: string | null, farmerAccountId?: string | null, locationId?: string | null, lat?: string | null, lng?: string | null, data?: any | null } | null> | null } };

export type IcCompanyCropProductsQueryVariables = Exact<{
  icCompanyId: Scalars['bigint']['input'];
}>;


export type IcCompanyCropProductsQuery = { __typename?: 'query_root', pf_fcm_crops: Array<{ __typename?: 'pf_fcm_crops', id: any, crop_name: string, segment_name?: string | null }>, pf_fcm_products: Array<{ __typename?: 'pf_fcm_products', id: any, product_name: string, crop_id: any }> };

export type SearchCrmItemsQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
  filterJson: Scalars['String']['input'];
  orderBy?: InputMaybe<Scalars['String']['input']>;
  dir?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchCrmItemsQuery = { __typename?: 'query_root', searchCRMItems: { __typename?: 'CRMItemWithDataPaginatedResponse', totalCount: number, totalPages: number, pageSize: number, items?: Array<{ __typename?: 'CRMItemWithData', id: string, farmerId?: string | null, farmerName?: string | null, phoneNumber?: string | null, farmerAccountId?: string | null, locationId?: string | null, lat?: string | null, lng?: string | null, data?: any | null } | null> | null } };

export type CreateSegmentMutationVariables = Exact<{
  name: Scalars['String']['input'];
  crmType: Scalars['String']['input'];
  filterData: Scalars['String']['input'];
}>;


export type CreateSegmentMutation = { __typename?: 'mutation_root', createCRMSegment: { __typename?: 'CRMSegment', id: string, name: string, crmType: string, filterData?: string | null } };

export type GetCrmSegmentsQueryVariables = Exact<{
  accountId: Scalars['bpchar']['input'];
}>;


export type GetCrmSegmentsQuery = { __typename?: 'query_root', crm_segments: Array<{ __typename?: 'crm_segments', id: any, name?: string | null, filter_data?: any | null, matching_count?: number | null }> };

export type GetStatsQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
}>;


export type GetStatsQuery = { __typename?: 'query_root', globalStats: { __typename?: 'GlobalStatsResponse', total_count: number, fo_farmers: number, reel_farmers: number, ffo_farmers: number, influencer_farmers: number, service_request_farmers: number } };

export type PfUsersQueryVariables = Exact<{
  icCompanyId: Scalars['bigint']['input'];
}>;


export type PfUsersQuery = { __typename?: 'query_root', pf_users: Array<{ __typename?: 'pf_users', id: any, first_name?: string | null, last_name?: string | null, head_quarters?: string | null, input_company_id: any }> };

export type Messaging_ConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type Messaging_ConfigQuery = { __typename?: 'query_root', account_auth_key: Array<{ __typename?: 'account_auth_key', id: any, user_id: string }> };

export type CompanyAssignsFoMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['String']['input']>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  farmerPhone?: InputMaybe<Scalars['String']['input']>;
  prospectId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CompanyAssignsFoMutation = { __typename?: 'mutation_root', companyAssignsFO?: { __typename?: 'Prospect', id?: string | null, threadId?: string | null, status?: string | null } | null };

export type CompanyRespondsToServiceRequestMutationVariables = Exact<{
  action: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type CompanyRespondsToServiceRequestMutation = { __typename?: 'mutation_root', fieldPartnerRespondsToRequest: { __typename?: 'DefaultCommandOutput', error?: Array<string | null> | null, data: { __typename?: 'CommandOutputDataWithValues', status: string } | { __typename?: 'DefaultCommandOutputData', status: string } } };

export type CrmItemFragmentFragment = { __typename?: 'CRMItem', id: string, data?: string | null };

export type GetTravelLogQueryVariables = Exact<{
  marketId: Scalars['bigint']['input'];
  from: Scalars['timestamptz']['input'];
  end: Scalars['timestamptz']['input'];
}>;


export type GetTravelLogQuery = { __typename?: 'query_root', pf_user_travellog: Array<{ __typename?: 'pf_user_travellog', id: any, user_id: any, latitude_position: any, longitude_position: any, date_time?: any | null }> };

export type FfowoFieldsFragment = { __typename?: 'work_orders', id: any, title: string, description?: string | null, objectives?: any | null, languages?: string | null, variant_type?: string | null, product_name?: string | null, status?: string | null, states?: string | null, expected_date?: any | null, budget_max?: number | null, budget_min?: number | null, is_open_to_new_influencers?: boolean | null, account?: { __typename?: 'accounts', id: any, name: string } | null };

export type GetOpenWorkOrdersFfoQueryVariables = Exact<{
  influencerUserId: Scalars['bpchar']['input'];
}>;


export type GetOpenWorkOrdersFfoQuery = { __typename?: 'query_root', open_workorders: Array<{ __typename: 'work_orders', id: any, title: string, description?: string | null, objectives?: any | null, languages?: string | null, variant_type?: string | null, product_name?: string | null, status?: string | null, states?: string | null, expected_date?: any | null, budget_max?: number | null, budget_min?: number | null, is_open_to_new_influencers?: boolean | null, requests: Array<{ __typename: 'work_order_requests', id: any, influencer_user_id: any }>, account?: { __typename?: 'accounts', id: any, name: string } | null }>, incoming_requests: Array<{ __typename: 'work_orders', id: any, title: string, description?: string | null, objectives?: any | null, languages?: string | null, variant_type?: string | null, product_name?: string | null, status?: string | null, states?: string | null, expected_date?: any | null, budget_max?: number | null, budget_min?: number | null, is_open_to_new_influencers?: boolean | null, requests: Array<{ __typename: 'work_order_requests', id: any, gig_id: any, status: string, bid_price: any, delivery_days: number }>, account?: { __typename?: 'accounts', id: any, name: string } | null }> };

export type FfoBankKycMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  panKycStatus?: InputMaybe<Scalars['Boolean']['input']>;
  aadharKycStatus?: InputMaybe<Scalars['Boolean']['input']>;
  bankKycStatus?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FfoBankKycMutation = { __typename?: 'mutation_root', onRequestKYC: { __typename?: 'KYCTransaction', id: number, output?: any | null, input?: any | null, panKycStatus?: boolean | null, aadharKycStatus?: boolean | null, bankKycStatus?: boolean | null } };

export type GetKycTransactionQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetKycTransactionQuery = { __typename?: 'query_root', kYCStatus?: { __typename?: 'KYCTransaction', id: number, output?: any | null, bankKycName?: string | null, bankKycStatus?: boolean | null } | null };

export type RegisterFfoMutationVariables = Exact<{
  costOfGroupMeeting?: InputMaybe<Scalars['Float']['input']>;
  costOfMonthlyPartTime?: InputMaybe<Scalars['Float']['input']>;
  costOfProductDemo?: InputMaybe<Scalars['Float']['input']>;
  costOfSalesCommission?: InputMaybe<Scalars['Float']['input']>;
  costOfProductDemoForSeedProducts?: InputMaybe<Scalars['Float']['input']>;
  costOfProductDemoForChemicalProducts?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  districts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  experience_since: Scalars['Int']['input'];
  expertises?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  languages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  segments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  states?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  townName?: InputMaybe<Scalars['String']['input']>;
  villageName?: InputMaybe<Scalars['String']['input']>;
  travel_range: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
  userName?: InputMaybe<Scalars['String']['input']>;
  userPhone?: InputMaybe<Scalars['String']['input']>;
}>;


export type RegisterFfoMutation = { __typename?: 'mutation_root', registerFreelanceFieldOfficer: { __typename?: 'DefaultCommandOutput', error?: Array<string | null> | null, data: { __typename?: 'CommandOutputDataWithValues', status: string } | { __typename?: 'DefaultCommandOutputData', status: string } } };

export type FfoRegsiteredOrNotQueryVariables = Exact<{
  influencerUserId: Scalars['bpchar']['input'];
}>;


export type FfoRegsiteredOrNotQuery = { __typename?: 'query_root', gigs: Array<{ __typename?: 'gigs', id: any, title?: string | null, created_at?: any | null, approval_status: string, variants: Array<{ __typename?: 'gig_variants', id: any, cost: any, variant_type: string, duration_days: number }> }> };

export type InfluencerRejectsWorkOrderMutationVariables = Exact<{
  woId: Scalars['String']['input'];
  worId: Scalars['String']['input'];
}>;


export type InfluencerRejectsWorkOrderMutation = { __typename?: 'mutation_root', influencerRejectsWorkOrder?: { __typename?: 'WorkOrder', status?: string | null } | null };

export type CompanyAcceptsOrRejectsWoRequestMutationVariables = Exact<{
  woId: Scalars['String']['input'];
  woRequestId: Scalars['String']['input'];
  action: AcceptRejectEnum;
}>;


export type CompanyAcceptsOrRejectsWoRequestMutation = { __typename?: 'mutation_root', companyAcceptsOrRejectsWorkorderRequest: { __typename?: 'DefaultCommandOutput', error?: Array<string | null> | null, data: { __typename?: 'CommandOutputDataWithValues', status: string } | { __typename?: 'DefaultCommandOutputData', status: string } } };

export type MyGigsDetailsFfoEditProfileQueryVariables = Exact<{
  influencerUserId: Scalars['bpchar']['input'];
  gigType: Scalars['String']['input'];
}>;


export type MyGigsDetailsFfoEditProfileQuery = { __typename?: 'query_root', gigs: Array<{ __typename?: 'gigs', id: any, title?: string | null, created_at?: any | null, approval_status: string, gig_type: string, districts?: any | null, experience_since?: number | null, expertises?: any | null, segments?: any | null, metrics?: any | null, travel_range?: any | null, avg_rating?: any | null, is_verified: boolean, description?: string | null, rating: number, languages?: any | null, states?: any | null, location?: string | null, avg_work_order_duration_days: any, completed_work_orders: number, review_count: number, town_name?: string | null, village_name?: string | null, user: { __typename?: 'users', id: any, name: string, profile_image_url?: string | null, phone_number: string, email?: string | null }, district?: { __typename?: 'gis_districts', id: any, state?: string | null, district?: string | null } | null, variants: Array<{ __typename?: 'gig_variants', id: any, cost: any, qty: number, duration_days: number, variant_type: string, cost_seed_products?: any | null, cost_chemical_products?: any | null }> }> };

export type EditInfluencerGigProfileFfoMutationVariables = Exact<{
  costOfGroupMeeting?: InputMaybe<Scalars['Float']['input']>;
  costOfMonthlyPartTime?: InputMaybe<Scalars['Float']['input']>;
  costOfSalesCommission?: InputMaybe<Scalars['Float']['input']>;
  costOfProductDemoForChemicalProducts?: InputMaybe<Scalars['Float']['input']>;
  costOfProductDemoForSeedProducts?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  districts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  experience_since: Scalars['Int']['input'];
  expertises?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  languages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  segments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  states?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  travel_range: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
  userName?: InputMaybe<Scalars['String']['input']>;
  userPhone?: InputMaybe<Scalars['String']['input']>;
  profileImageUrl?: InputMaybe<Scalars['String']['input']>;
  villageName?: InputMaybe<Scalars['String']['input']>;
  townName?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditInfluencerGigProfileFfoMutation = { __typename?: 'mutation_root', registerFreelanceFieldOfficer: { __typename?: 'DefaultCommandOutput', error?: Array<string | null> | null, data: { __typename?: 'CommandOutputDataWithValues', status: string } | { __typename?: 'DefaultCommandOutputData', status: string } } };

export type AllStateQueryVariables = Exact<{ [key: string]: never; }>;


export type AllStateQuery = { __typename?: 'query_root', gis_districts: Array<{ __typename?: 'gis_districts', id: any, state?: string | null, state_code?: number | null, district?: string | null, district_code?: number | null }> };

export type RequestKycMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type RequestKycMutation = { __typename?: 'mutation_root', onRequestKYC: { __typename?: 'KYCTransaction', id: number } };

export type LeadsInboxQueryVariables = Exact<{
  accountId: Scalars['bpchar']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LeadsInboxQuery = { __typename?: 'query_root', ActiveUsers: Array<{ __typename?: 'prospects', id: any, status: string, source_interaction_type?: string | null, user: { __typename?: 'users', id: any, name: string, phone_number: string, profile_image_url?: string | null, locale?: string | null, last_known_locations: Array<{ __typename?: 'last_known_locations', id: any, address?: string | null }> }, prospects_crop?: { __typename?: 'master_crops', id: any, name: string, image_url?: string | null } | null, messages: Array<{ __typename?: 'prospect_messages', id: any, message: string, created_at?: any | null }> }> };

export type DcmContactsQueryVariables = Exact<{
  accountId?: InputMaybe<Scalars['bpchar']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DcmContactsQuery = { __typename?: 'query_root', contacts: Array<{ __typename?: 'fich_farminsta_replica_leads', id?: any | null, farmer_name?: string | null, farmer_phone?: string | null, farmer_user_id?: any | null, farmer_profile_image_url?: string | null, owner_name?: string | null, owner_phone?: string | null, owner_user_id?: any | null, owner_profile_image_url?: string | null, state?: string | null, district?: string | null, taluk?: string | null, created_at?: any | null, address?: string | null, status?: string | null, lat?: any | null, lng?: any | null, source_interaction_ts?: any | null, source_interaction_type?: string | null, source_name?: string | null, source_reel_id?: any | null, source_reel_interaction_id?: any | null, source_service_request_id?: any | null, crop_names?: string | null }> };

export type ServiceRequestInboxQueryVariables = Exact<{
  accountId: Scalars['bpchar']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ServiceRequestInboxQuery = { __typename?: 'query_root', service_requests: Array<{ __typename?: 'service_requests', id: any, created_at?: any | null, is_request_closed: boolean, address?: string | null, assets: any, date_of_sowing: any, lat: any, lng: any, farmer: { __typename?: 'users', id: any, name: string, phone_number: string, profile_image_url?: string | null, crop_users: Array<{ __typename?: 'crop_user', id: any, master_crop: { __typename?: 'master_crops', id: any, name: string } }> }, crop: { __typename?: 'master_crops', id: any, name: string, image_url?: string | null }, field_partner_responses: Array<{ __typename?: 'field_partner_responses', id: any, field_partner_user_id: any, response_action?: string | null, created_at?: any | null, field_partner_rating?: number | null, field_partner_rated_at?: any | null }> }> };

export type GetServiceRequestByIdQueryVariables = Exact<{
  accountId: Scalars['bpchar']['input'];
  id: Scalars['bpchar']['input'];
}>;


export type GetServiceRequestByIdQuery = { __typename?: 'query_root', service_requests: Array<{ __typename?: 'service_requests', id: any, created_at?: any | null, deleted_at?: any | null, is_request_closed: boolean, address?: string | null, assets: any, date_of_sowing: any, lat: any, lng: any, farmer: { __typename?: 'users', id: any, name: string, phone_number: string, profile_image_url?: string | null, crop_users: Array<{ __typename?: 'crop_user', id: any, master_crop: { __typename?: 'master_crops', id: any, name: string } }> }, crop: { __typename?: 'master_crops', id: any, name: string, image_url?: string | null }, field_partner_responses: Array<{ __typename?: 'field_partner_responses', id: any, field_partner_user_id: any, response_action?: string | null, created_at?: any | null, field_partner_rating?: number | null, field_partner_rated_at?: any | null }> }> };

export type GetThreadByThreadableIdQueryVariables = Exact<{
  threadableId?: InputMaybe<Scalars['bpchar']['input']>;
}>;


export type GetThreadByThreadableIdQuery = { __typename?: 'query_root', chat_threads: Array<{ __typename?: 'chat_threads', id: any }> };

export type GetChatThreadMessagesQueryVariables = Exact<{
  threadId: Scalars['bpchar']['input'];
}>;


export type GetChatThreadMessagesQuery = { __typename?: 'query_root', chatThreadParticipants: Array<{ __typename?: 'chat_participants', id: any, lastReadAt?: any | null, lastActiveAt?: any | null, user: { __typename?: 'users', id: any, name: string, profile_image_url?: string | null } }>, chatThreadMessages: Array<{ __typename?: 'chat_messages', id: any, content?: string | null, data?: any | null, messageType: string, createdAt?: any | null, sender?: { __typename?: 'users', id: any, name: string, profile_image_url?: string | null } | null }> };

export type SendMessageOnThreadHereMutationVariables = Exact<{
  threadId: Scalars['String']['input'];
  textMessage: Scalars['String']['input'];
}>;


export type SendMessageOnThreadHereMutation = { __typename?: 'mutation_root', sendChatTextMessage: { __typename?: 'ChatMessage', id: string, messageType: string, content?: string | null, createdAt: any, sender?: { __typename?: 'User', id: string, name?: string | null, profile_image_url?: string | null } | null, thread: { __typename?: 'ChatThread', id: string } } };

export type GetMyChatThreadsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyChatThreadsQuery = { __typename?: 'query_root', userChatThreads: Array<{ __typename?: 'ChatThread', id: string, threadableType: string, archived: boolean, unreadCount: number, lastMessage?: { __typename?: 'ChatMessage', id: string, content?: string | null, createdAt: any } | null, participants?: Array<{ __typename?: 'ChatParticipant', id: string, muted: boolean, lastReadAt?: any | null, user?: { __typename?: 'User', id: string, name?: string | null, profile_image_url?: string | null } | null } | null> | null }> };

export type ChatThreadsByIdsQueryVariables = Exact<{
  threadIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ChatThreadsByIdsQuery = { __typename?: 'query_root', threadsByIds: Array<{ __typename?: 'ChatThread', id: string, archived: boolean, threadableType: string, unreadCount: number, lastMessage?: { __typename?: 'ChatMessage', id: string, content?: string | null, createdAt: any } | null, participants?: Array<{ __typename?: 'ChatParticipant', id: string, muted: boolean, lastReadAt?: any | null, user?: { __typename?: 'User', id: string, name?: string | null, profile_image_url?: string | null } | null } | null> | null }> };

export type CompanyWorkorderFeedbackMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  workorderId: Scalars['String']['input'];
  review?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Float']['input']>;
  rating1?: InputMaybe<Scalars['Float']['input']>;
  rating2?: InputMaybe<Scalars['Float']['input']>;
  farminstaRating?: InputMaybe<Scalars['Float']['input']>;
  farminstaRating1?: InputMaybe<Scalars['Float']['input']>;
  farminstaRating2?: InputMaybe<Scalars['Float']['input']>;
  farminstaReview?: InputMaybe<Scalars['String']['input']>;
}>;


export type CompanyWorkorderFeedbackMutation = { __typename?: 'mutation_root', companyWorkorderFeedback: { __typename?: 'DefaultCommandOutput', error?: Array<string | null> | null, data: { __typename?: 'CommandOutputDataWithValues', status: string } | { __typename?: 'DefaultCommandOutputData', status: string } } };

export type GetChatThreadQueryVariables = Exact<{
  threadId: Scalars['bpchar']['input'];
}>;


export type GetChatThreadQuery = { __typename?: 'query_root', thread?: { __typename?: 'chat_threads', id: any, threadable_type?: string | null, threadable_id?: any | null } | null };

export type WorkOrderRequestQueryVariables = Exact<{
  requestId: Scalars['bpchar']['input'];
}>;


export type WorkOrderRequestQuery = { __typename?: 'query_root', wor?: { __typename?: 'work_order_requests', id: any, work_order_id: any, status: string } | null };

export type InfluencerWorkorderFeedbackMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  workorderId: Scalars['String']['input'];
  review?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Float']['input']>;
  rating1?: InputMaybe<Scalars['Float']['input']>;
  rating2?: InputMaybe<Scalars['Float']['input']>;
  farminstaRating?: InputMaybe<Scalars['Float']['input']>;
  farminstaRating1?: InputMaybe<Scalars['Float']['input']>;
  farminstaRating2?: InputMaybe<Scalars['Float']['input']>;
  farminstaReview?: InputMaybe<Scalars['String']['input']>;
}>;


export type InfluencerWorkorderFeedbackMutation = { __typename?: 'mutation_root', influencerWorkorderFeedback: { __typename?: 'DefaultCommandOutput', error?: Array<string | null> | null, data: { __typename?: 'CommandOutputDataWithValues', status: string } | { __typename?: 'DefaultCommandOutputData', status: string } } };

export type InfluencerAppliesForWoMutationVariables = Exact<{
  woId: Scalars['String']['input'];
  influencerUserId: Scalars['String']['input'];
  bidPrice?: InputMaybe<Scalars['Float']['input']>;
  durationDays?: InputMaybe<Scalars['Int']['input']>;
}>;


export type InfluencerAppliesForWoMutation = { __typename?: 'mutation_root', influencerAppliesForWorkOrder: { __typename?: 'DefaultCommandOutput', error?: Array<string | null> | null, data: { __typename?: 'CommandOutputDataWithValues', status: string } | { __typename?: 'DefaultCommandOutputData', status: string } } };

export type InfluencerWorkOrdersQueryVariables = Exact<{
  influencerUserId?: InputMaybe<Scalars['bpchar']['input']>;
}>;


export type InfluencerWorkOrdersQuery = { __typename?: 'query_root', work_orders: Array<{ __typename?: 'work_orders', id: any, account_id?: any | null, company_id?: any | null, crops?: string | null, cta_id?: string | null, cta_link?: string | null, cta_type?: string | null, gig_id?: any | null, influencer_user_id?: any | null, description?: string | null, farminsta_cost_inr?: any | null, influencer_cost_inr?: any | null, work_order_public_id?: string | null, work_order_stage?: string | null, total_cost_inr?: any | null, title: string, states?: string | null, payment_status?: string | null, is_open_to_new_influencers?: boolean | null, created_at?: any | null, product_name?: string | null, languages?: string | null, expected_date?: any | null, published_at?: any | null, status?: string | null, account?: { __typename?: 'accounts', id: any, name: string } | null, influencer_user?: { __typename?: 'users', id: any, name: string, profile_image_url?: string | null } | null, created_by_user?: { __typename?: 'users', id: any, name: string, profile_image_url?: string | null } | null, gig?: { __typename?: 'gigs', id: any, channel?: { __typename?: 'channels', id: any, logo_image_url?: string | null, name?: string | null } | null } | null, gig_variant?: { __typename?: 'gig_variants', id: any, title?: string | null, variant_type: string, cost: any } | null, requests: Array<{ __typename: 'work_order_requests', id: any, influencer_user_id: any, status: string, bid_price: any, delivery_days: number }> }> };

export type RegisterInfluencerMutationVariables = Exact<{
  channelName: Scalars['String']['input'];
  costOfReel: Scalars['Float']['input'];
  costOfVideo: Scalars['Float']['input'];
  days?: InputMaybe<Scalars['Int']['input']>;
  email: Scalars['String']['input'];
  fbUrl: Scalars['String']['input'];
  instaUrl: Scalars['String']['input'];
  languages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  otherUrl: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  profileImageUrl?: InputMaybe<Scalars['String']['input']>;
  reelDays?: InputMaybe<Scalars['Int']['input']>;
  segments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  states?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  userId: Scalars['String']['input'];
  userName: Scalars['String']['input'];
  userPhone: Scalars['String']['input'];
  videoDays?: InputMaybe<Scalars['Int']['input']>;
  ytUrl: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type RegisterInfluencerMutation = { __typename?: 'mutation_root', registerInfluencer: { __typename?: 'DefaultCommandOutput', error?: Array<string | null> | null, data: { __typename?: 'CommandOutputDataWithValues', status: string } | { __typename?: 'DefaultCommandOutputData', status: string } } };

export type WoFieldsFragment = { __typename?: 'work_orders', id: any, title: string, description?: string | null, objectives?: any | null, languages?: string | null, variant_type?: string | null, product_name?: string | null, status?: string | null, states?: string | null, expected_date?: any | null, budget_max?: number | null, budget_min?: number | null, is_open_to_new_influencers?: boolean | null, account?: { __typename?: 'accounts', id: any, name: string } | null };

export type GetOpenWorkOrdersQueryVariables = Exact<{
  influencerUserId: Scalars['bpchar']['input'];
}>;


export type GetOpenWorkOrdersQuery = { __typename?: 'query_root', open_workorders: Array<{ __typename: 'work_orders', id: any, title: string, description?: string | null, objectives?: any | null, languages?: string | null, variant_type?: string | null, product_name?: string | null, status?: string | null, states?: string | null, expected_date?: any | null, budget_max?: number | null, budget_min?: number | null, is_open_to_new_influencers?: boolean | null, requests: Array<{ __typename: 'work_order_requests', id: any, influencer_user_id: any }>, account?: { __typename?: 'accounts', id: any, name: string } | null }>, incoming_requests: Array<{ __typename: 'work_orders', id: any, title: string, description?: string | null, objectives?: any | null, languages?: string | null, variant_type?: string | null, product_name?: string | null, status?: string | null, states?: string | null, expected_date?: any | null, budget_max?: number | null, budget_min?: number | null, is_open_to_new_influencers?: boolean | null, requests: Array<{ __typename: 'work_order_requests', id: any, gig_id: any, status: string, bid_price: any, delivery_days: number }>, account?: { __typename?: 'accounts', id: any, name: string } | null }> };

export type MyGigsQueryVariables = Exact<{
  influencerUserId: Scalars['bpchar']['input'];
}>;


export type MyGigsQuery = { __typename?: 'query_root', gigs: Array<{ __typename?: 'gigs', id: any, title?: string | null, created_at?: any | null, approval_status: string, description?: string | null, rating: number, languages?: any | null, states?: any | null, location?: string | null, avg_work_order_duration_days: any, completed_work_orders: number, segments?: any | null, review_count: number, user: { __typename?: 'users', id: any, name: string, profile_image_url?: string | null, phone_number: string }, district?: { __typename?: 'gis_districts', id: any, state?: string | null, district?: string | null } | null, variants: Array<{ __typename?: 'gig_variants', id: any, cost: any, qty: number, duration_days: number, variant_type: string }>, channel?: { __typename?: 'channels', id: any, name?: string | null, description?: string | null, logo_image_url?: string | null, content_languages?: any | null, channel_links: Array<{ __typename?: 'channel_links', id: any, link_url: string, follower_count: number, impressions_count?: number | null, engagement_rate?: any | null, link_type?: string | null }>, channel_links_aggregate: { __typename?: 'channel_links_aggregate', aggregate?: { __typename?: 'channel_links_aggregate_fields', sum?: { __typename?: 'channel_links_sum_fields', follower_count?: number | null, impressions_count?: number | null } | null } | null } } | null }> };

export type WoLeadsQueryVariables = Exact<{
  filterjson: Scalars['String']['input'];
  accountId: Scalars['String']['input'];
}>;


export type WoLeadsQuery = { __typename?: 'query_root', searchCRMItems: { __typename?: 'CRMItemWithDataPaginatedResponse', items?: Array<{ __typename?: 'CRMItemWithData', id: string, data?: any | null } | null> | null } };

export type MyAccountQueryVariables = Exact<{
  accountId: Scalars['bpchar']['input'];
}>;


export type MyAccountQuery = { __typename?: 'query_root', accounts_by_pk?: { __typename?: 'accounts', id: any, account_type: string, name: string, pandoforce_input_company_id?: any | null } | null };

export type CropProductsQueryVariables = Exact<{
  icCompId?: InputMaybe<Scalars['bigint']['input']>;
}>;


export type CropProductsQuery = { __typename?: 'query_root', crops: Array<{ __typename?: 'master_crops', id: any, name: string }>, fcm_products: Array<{ __typename?: 'pf_fcm_products', id: any, product_name: string }> };

export type CompanyWorkOrdersQueryVariables = Exact<{
  accountId?: InputMaybe<Scalars['bpchar']['input']>;
  gigType?: InputMaybe<Scalars['String']['input']>;
}>;


export type CompanyWorkOrdersQuery = { __typename?: 'query_root', work_orders: Array<{ __typename?: 'work_orders', id: any, account_id?: any | null, company_id?: any | null, crops?: string | null, cta_id?: string | null, cta_link?: string | null, cta_type?: string | null, gig_type: string, description?: string | null, farminsta_cost_inr?: any | null, influencer_cost_inr?: any | null, work_order_public_id?: string | null, work_order_stage?: string | null, total_cost_inr?: any | null, title: string, states?: string | null, payment_status?: string | null, is_open_to_new_influencers?: boolean | null, created_at?: any | null, product_name?: string | null, languages?: string | null, expected_date?: any | null, published_at?: any | null, status?: string | null, requests: Array<{ __typename?: 'work_order_requests', work_order_id: any, id: any, chat_thread?: { __typename?: 'chat_threads', id: any } | null }>, influencer_user?: { __typename?: 'users', id: any, name: string, profile_image_url?: string | null } | null, created_by_user?: { __typename?: 'users', id: any, name: string, profile_image_url?: string | null } | null, gig?: { __typename?: 'gigs', id: any, channel?: { __typename?: 'channels', id: any, logo_image_url?: string | null, name?: string | null } | null, user: { __typename?: 'users', id: any, name: string, profile_image_url?: string | null, phone_number: string, email?: string | null } } | null, gig_variant?: { __typename?: 'gig_variants', id: any, title?: string | null, variant_type: string, cost: any } | null }> };

export type GetFeedbackQueryVariables = Exact<{
  workOrderId: Scalars['bpchar']['input'];
}>;


export type GetFeedbackQuery = { __typename?: 'query_root', work_order_reviews: Array<{ __typename?: 'work_order_reviews', id: any, work_order_id: any, influencer_user_id: any, influencer_given_rating?: string | null, influencer_given_review?: string | null, influencer_given_rating_1?: any | null, influencer_given_rating_2?: any | null, customer_user_id: any, customer_given_review?: string | null, customer_given_rating?: string | null, customer_given_rating_1?: any | null, customer_given_rating_2?: any | null, created_at?: any | null, updated_at?: any | null, customer_user: { __typename?: 'users', id: any, name: string }, influencer_user: { __typename?: 'users', id: any, name: string } }> };

export type WorkOrderQueryVariables = Exact<{
  woId: Scalars['bpchar']['input'];
}>;


export type WorkOrderQuery = { __typename?: 'query_root', work_orders_by_pk?: { __typename?: 'work_orders', gig_type: string, id: any, work_order_public_id?: string | null, product_name?: string | null, crops?: string | null, status?: string | null, variant_type?: string | null, cta_id?: string | null, cta_link?: string | null, cta_type?: string | null, created_at?: any | null, payment_status?: string | null, states?: string | null, languages?: string | null, objectives?: any | null, title: string, description?: string | null, published_at?: any | null, account?: { __typename?: 'accounts', id: any, name: string } | null, influencer_user?: { __typename?: 'users', id: any, name: string, profile_image_url?: string | null } | null, requests: Array<{ __typename?: 'work_order_requests', work_order_id: any, id: any, bid_price: any, delivery_days: number, status: string, chat_thread?: { __typename?: 'chat_threads', id: any } | null, gig: { __typename?: 'gigs', id: any, title?: string | null, languages?: any | null, rating: number, completed_work_orders: number, states?: any | null, is_verified: boolean, expertises?: any | null, channel_links: Array<{ __typename?: 'channel_links', engagement_rate?: any | null, follower_count: number, id: any, impressions_count?: number | null, link_type?: string | null, link_url: string }>, user: { __typename?: 'users', id: any, name: string, profile_image_url?: string | null, email?: string | null, phone_number: string }, channel?: { __typename?: 'channels', id: any, logo_image_url?: string | null, name?: string | null } | null, channel_links_aggregate: { __typename?: 'channel_links_aggregate', aggregate?: { __typename?: 'channel_links_aggregate_fields', sum?: { __typename?: 'channel_links_sum_fields', follower_count?: number | null } | null } | null }, variants: Array<{ __typename?: 'gig_variants', id: any, cost: any, variant_type: string }> }, influencer_user: { __typename?: 'users', id: any, name: string, profile_image_url?: string | null } }> } | null };

export type GetGigReviewProfileQueryVariables = Exact<{
  userId: Scalars['bpchar']['input'];
}>;


export type GetGigReviewProfileQuery = { __typename?: 'query_root', work_order_reviews_aggregate: { __typename?: 'work_order_reviews_aggregate', aggregate?: { __typename?: 'work_order_reviews_aggregate_fields', count: number, sum?: { __typename?: 'work_order_reviews_sum_fields', customer_given_rating_1?: any | null, customer_given_rating_2?: any | null } | null } | null, nodes: Array<{ __typename?: 'work_order_reviews', id: any, customer_given_review?: string | null, customer_given_rating?: string | null, created_at?: any | null, work_order_id: any, customer_user: { __typename?: 'users', id: any, name: string, profile_image_url?: string | null } }> } };

export type EditInfluencerGigProfileMutationVariables = Exact<{
  profileImageUrl?: InputMaybe<Scalars['String']['input']>;
  channelName: Scalars['String']['input'];
  costOfReel: Scalars['Float']['input'];
  costOfVideo: Scalars['Float']['input'];
  days?: InputMaybe<Scalars['Int']['input']>;
  description: Scalars['String']['input'];
  email: Scalars['String']['input'];
  fbUrl: Scalars['String']['input'];
  instaUrl: Scalars['String']['input'];
  languages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  otherUrl: Scalars['String']['input'];
  reelDays: Scalars['Int']['input'];
  segments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  states?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  userId: Scalars['String']['input'];
  userName: Scalars['String']['input'];
  userPhone: Scalars['String']['input'];
  videoDays: Scalars['Int']['input'];
  ytUrl: Scalars['String']['input'];
}>;


export type EditInfluencerGigProfileMutation = { __typename?: 'mutation_root', editInfluencerGigProfile: { __typename?: 'DefaultCommandOutput', error?: Array<string | null> | null, data: { __typename?: 'CommandOutputDataWithValues', status: string } | { __typename?: 'DefaultCommandOutputData', status: string } } };

export type ReelwiseProspectsQueryVariables = Exact<{
  reelId?: InputMaybe<Scalars['bigint']['input']>;
  accountId?: InputMaybe<Scalars['bpchar']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ReelwiseProspectsQuery = { __typename?: 'query_root', fich_farminsta_replica_reel_lead_info: Array<{ __typename?: 'fich_farminsta_replica_reel_lead_info', id?: any | null, reel_id?: any | null, prospect_id?: any | null, farmer_name?: string | null, farmer_phone?: string | null, farmer_user_id?: any | null, farmer_profile_image_url?: string | null, owner_name?: string | null, owner_phone?: string | null, owner_user_id?: any | null, owner_profile_image_url?: string | null, state?: string | null, district?: string | null, taluk?: string | null, address?: string | null, status?: string | null, lat?: any | null, lng?: any | null, created_at?: any | null, source_interaction_ts?: any | null, source_interaction_type?: string | null, source_name?: string | null, source_reel_id?: any | null, source_reel_interaction_id?: any | null, source_service_request_id?: any | null, crop_names?: string | null }> };

export type ChannelLeadsQueryVariables = Exact<{
  accountId?: InputMaybe<Scalars['bpchar']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ChannelLeadsQuery = { __typename?: 'query_root', fich_farminsta_replica_leads: Array<{ __typename?: 'fich_farminsta_replica_leads', id?: any | null, farmer_name?: string | null, farmer_phone?: string | null, farmer_user_id?: any | null, farmer_profile_image_url?: string | null, owner_name?: string | null, owner_phone?: string | null, owner_user_id?: any | null, owner_profile_image_url?: string | null, state?: string | null, district?: string | null, taluk?: string | null, created_at?: any | null, address?: string | null, status?: string | null, lat?: any | null, lng?: any | null, source_interaction_ts?: any | null, source_interaction_type?: string | null, source_name?: string | null, source_reel_id?: any | null, source_reel_interaction_id?: any | null, source_service_request_id?: any | null, crop_names?: string | null, deleted_at?: any | null }> };

export type GetchannelLeadQueryVariables = Exact<{
  id?: InputMaybe<Scalars['bpchar']['input']>;
}>;


export type GetchannelLeadQuery = { __typename?: 'query_root', fich_farminsta_replica_leads: Array<{ __typename?: 'fich_farminsta_replica_leads', id?: any | null, status?: string | null }> };

export type GetConsoleProductPopBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetConsoleProductPopBySlugQuery = { __typename?: 'query_root', productPop?: { __typename?: 'ProductPop', id: string, productName: string, itemCode?: string | null, slug: string, description?: string | null, popContent?: string | null, imageUrl?: Array<string | null> | null, popUrl?: string | null, createdAt: string, updatedAt: string, crop?: { __typename?: 'Crop', id: string, name: string } | null, media?: Array<{ __typename?: 'ProductPopMedia', id: string, mediaType: string, mediaId?: string | null, youtubeUrl?: string | null, uploadedUrl?: string | null, fileSize?: number | null, duration?: number | null, fileName?: string | null, sortOrder: number, reel: boolean } | null> | null } | null };

export type GetConsoleProductPopsQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
}>;


export type GetConsoleProductPopsQuery = { __typename?: 'query_root', productPops?: any | null };

export type CreateProductPopMutationVariables = Exact<{
  input: CreateProductPopInput;
}>;


export type CreateProductPopMutation = { __typename?: 'mutation_root', createProductPop: { __typename?: 'ProductPopResult', success: boolean, productPop?: { __typename?: 'ProductPop', id: string, productName: string, itemCode?: string | null, slug: string, description?: string | null, popContent?: string | null, imageUrl?: Array<string | null> | null, popUrl?: string | null, createdAt: string, updatedAt: string, crop?: { __typename?: 'Crop', id: string, name: string } | null, media?: Array<{ __typename?: 'ProductPopMedia', id: string, mediaType: string, mediaId?: string | null, youtubeUrl?: string | null, uploadedUrl?: string | null, fileSize?: number | null, duration?: number | null, fileName?: string | null, sortOrder: number, reel: boolean } | null> | null } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } };

export type UpdateProductPopMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateProductPopInput;
}>;


export type UpdateProductPopMutation = { __typename?: 'mutation_root', updateProductPop: { __typename?: 'ProductPopResult', success: boolean, productPop?: { __typename?: 'ProductPop', id: string, productName: string, itemCode?: string | null, slug: string, description?: string | null, popContent?: string | null, imageUrl?: Array<string | null> | null, createdAt: string, updatedAt: string, crop?: { __typename?: 'Crop', id: string, name: string } | null, media?: Array<{ __typename?: 'ProductPopMedia', id: string, mediaType: string, mediaId?: string | null, youtubeUrl?: string | null, uploadedUrl?: string | null, fileSize?: number | null, duration?: number | null, fileName?: string | null, sortOrder: number, reel: boolean } | null> | null } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } };

export type DeleteProductPopMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteProductPopMutation = { __typename?: 'mutation_root', deleteProductPop: { __typename?: 'DeleteResult', success: boolean, message: string } };

export type S3UploadDataMutationVariables = Exact<{
  key: Scalars['String']['input'];
  expiresInSeconds?: InputMaybe<Scalars['Int']['input']>;
}>;


export type S3UploadDataMutation = { __typename?: 'mutation_root', s3UploadData: Array<string> };

export type CfUploadDataMutationVariables = Exact<{
  type: Scalars['String']['input'];
  expiresInSeconds?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CfUploadDataMutation = { __typename?: 'mutation_root', cfUploadData: Array<string> };

export type CreateTrackableLinkForPopMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  goUrl: Scalars['String']['input'];
  type: Scalars['String']['input'];
  reelId: Scalars['Int']['input'];
  popId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateTrackableLinkForPopMutation = { __typename?: 'mutation_root', createTrackableLink: { __typename?: 'GoLink', idAsString: string, fullUrl: string } };

export type ChannelAnalyticsforprofileQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
  channelIdInt: Scalars['bigint']['input'];
}>;


export type ChannelAnalyticsforprofileQuery = { __typename?: 'query_root', reel_stats_aggregate: { __typename?: 'reel_stats_aggregate', aggregate?: { __typename?: 'reel_stats_aggregate_fields', sum?: { __typename?: 'reel_stats_sum_fields', total_watch_time_ms?: any | null, playback_count?: any | null, avg_watch_time_ms?: any | null, reel_id?: any | null, view_count?: any | null } | null } | null }, channelAnalytics: { __typename?: 'GetChannelAnalyticsOutput', channelName?: string | null, channelDescription?: string | null, channelLogoImageUrl?: string | null, followerCount: number, fullyViewedCount: number, sharesCount: number, commentsCount: number, likesCount: number, reels: number, watchTimeInMinutes: number }, channel?: { __typename?: 'channels', id: any, account?: { __typename?: 'accounts', id: any, website_url?: string | null, name: string } | null } | null, channel_links: Array<{ __typename?: 'channel_links', id: any, link_url: string, link_type?: string | null, impressions_count?: number | null, engagement_rate?: any | null, created_at?: any | null, follower_count: number, link_data?: any | null, post_count?: number | null }> };

export type UserReactedReelMutationVariables = Exact<{
  reelId: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
}>;


export type UserReactedReelMutation = { __typename?: 'mutation_root', userLikedReel: { __typename?: 'DefaultCommandOutput', error?: Array<string | null> | null, data: { __typename?: 'CommandOutputDataWithValues', status: string } | { __typename?: 'DefaultCommandOutputData', status: string } } };

export type CreateTrackableLinkMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  goUrl: Scalars['String']['input'];
  type: Scalars['String']['input'];
  reelId: Scalars['Int']['input'];
}>;


export type CreateTrackableLinkMutation = { __typename?: 'mutation_root', createTrackableLink: { __typename?: 'GoLink', idAsString: string, fullUrl: string } };

export type ContentDetailsQueryVariables = Exact<{
  channelId?: InputMaybe<Scalars['bigint']['input']>;
  reelId?: InputMaybe<Scalars['bigint']['input']>;
}>;


export type ContentDetailsQuery = { __typename?: 'query_root', fich_farminsta_replica_reels_flat: Array<{ __typename?: 'fich_farminsta_replica_reels_flat', id?: any | null, title?: string | null, thumbnail_url?: string | null, description?: string | null, crop_id?: any | null, category_id?: any | null, created_at?: any | null, playback_count?: any | null, avg_watch_duration_percent?: any | null, view_count?: any | null, language?: string | null, cloudflare_id?: string | null, react_count?: any | null, share_count?: any | null, comment_count?: any | null, duration_ms?: any | null, lead_count?: any | null, user_name?: string | null, user_id?: any | null, uploader_type?: string | null, active_lead_count?: any | null, s3_path?: string | null, approved_by_user_name?: string | null, updated_at?: any | null, tws?: any | null }> };

export type ContentQueryVariables = Exact<{
  channelId?: InputMaybe<Scalars['bigint']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ContentQuery = { __typename?: 'query_root', fich_farminsta_replica_reels_flat: Array<{ __typename?: 'fich_farminsta_replica_reels_flat', id?: any | null, title?: string | null, thumbnail_url?: string | null, description?: string | null, created_at?: any | null, playback_count?: any | null, avg_watch_duration_percent?: any | null, view_count?: any | null, react_count?: any | null, share_count?: any | null, comment_count?: any | null, duration_ms?: any | null, lead_count?: any | null, user_name?: string | null, user_id?: any | null, uploader_type?: string | null, active_lead_count?: any | null, s3_path?: string | null, tws?: any | null }> };

export type ContentSummeryQueryVariables = Exact<{
  channelId?: InputMaybe<Scalars['bigint']['input']>;
}>;


export type ContentSummeryQuery = { __typename?: 'query_root', fich_farminsta_replica_channel_analytics: Array<{ __typename?: 'fich_farminsta_replica_channel_analytics', id?: any | null, account_id?: any | null, reel_count?: any | null, lead_count?: any | null, active_lead_count?: any | null, name?: string | null, description?: string | null, logo_image_url?: string | null, crop_count?: any | null, total_playback_count?: any | null, total_view_count?: any | null, total_react_count?: any | null, total_share_count?: any | null, total_comment_count?: any | null, total_watch_time_secs?: any | null, total_engagement_count?: any | null, follower_count?: any | null, missed_requests?: any | null, open_requests?: any | null, new_requests?: any | null, total_requests?: any | null, delayed_requests?: any | null, closed_requests?: any | null }> };

export type FoReelsForManagerQueryVariables = Exact<{
  accountId: Scalars['bpchar']['input'];
}>;


export type FoReelsForManagerQuery = { __typename?: 'query_root', fo_reels_staging: Array<{ __typename?: 'fo_reels_staging', id: any, user_id: any, status: string, created_at?: any | null, cf_data?: any | null, event: any, user: { __typename?: 'users', id: any, name: string, profile_image_url?: string | null } }> };

export type FopendingreelDetailsQueryVariables = Exact<{
  accountId: Scalars['bpchar']['input'];
  reelId?: InputMaybe<Scalars['bigint']['input']>;
}>;


export type FopendingreelDetailsQuery = { __typename?: 'query_root', fo_reels_staging: Array<{ __typename?: 'fo_reels_staging', id: any, status: string, created_at?: any | null, cf_data?: any | null, event: any, user: { __typename?: 'users', id: any, name: string, profile_image_url?: string | null } }> };

export type UserUpdatesDeviceInfoMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  deviceToken?: InputMaybe<Scalars['String']['input']>;
  deviceInstallationId: Scalars['String']['input'];
  deviceType?: InputMaybe<Scalars['String']['input']>;
  appVersion?: InputMaybe<Scalars['String']['input']>;
  osVersion?: InputMaybe<Scalars['String']['input']>;
  deviceModel?: InputMaybe<Scalars['String']['input']>;
  deviceName?: InputMaybe<Scalars['String']['input']>;
  appBuildNumber?: InputMaybe<Scalars['String']['input']>;
  deviceBrand?: InputMaybe<Scalars['String']['input']>;
  deviceManufacturer?: InputMaybe<Scalars['String']['input']>;
  deviceOsVersion?: InputMaybe<Scalars['String']['input']>;
  nativePushToken?: InputMaybe<Scalars['String']['input']>;
  releaseChannel?: InputMaybe<Scalars['String']['input']>;
  runtimeVersion?: InputMaybe<Scalars['String']['input']>;
  installReferrer?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserUpdatesDeviceInfoMutation = { __typename?: 'mutation_root', userUpdatesHisDeviceInfo: { __typename?: 'DefaultCommandOutput', error?: Array<string | null> | null, data: { __typename?: 'CommandOutputDataWithValues', status: string } | { __typename?: 'DefaultCommandOutputData', status: string } } };

export type GetProductPopBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetProductPopBySlugQuery = { __typename?: 'query_root', productPop?: { __typename: 'ProductPop', id: string, productName: string, itemCode?: string | null, slug: string, description?: string | null, imageUrl?: Array<string | null> | null, popContent?: string | null, createdAt: string, updatedAt: string, crop?: { __typename: 'Crop', id: string, name: string } | null, media?: Array<{ __typename: 'ProductPopMedia', id: string, mediaType: string, mediaId?: string | null, uploadedUrl?: string | null, duration?: number | null, fileSize?: number | null, fileName?: string | null, youtubeUrl?: string | null, sortOrder: number, reel: boolean } | null> | null } | null };

export type GetProductPopsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductPopsQuery = { __typename?: 'query_root', productPops?: any | null };

export type UserFollowesChannelSubscriptionVariables = Exact<{
  channelId?: InputMaybe<Scalars['bigint']['input']>;
}>;


export type UserFollowesChannelSubscription = { __typename?: 'subscription_root', reel_interactions: Array<{ __typename?: 'user_follows_channel', id: any, user_id: any, reel_interactions_user: { __typename?: 'users', id: any, name: string, last_known_locations: Array<{ __typename?: 'last_known_locations', id: any, address?: string | null }> } }> };

export type ReelUploadDataQueryVariables = Exact<{ [key: string]: never; }>;


export type ReelUploadDataQuery = { __typename?: 'query_root', master_crops: Array<{ __typename?: 'master_crops', id: any, name: string, image_url?: string | null }>, reel_category: Array<{ __typename?: 'reel_category', id: any, name: string }>, gis_districts: Array<{ __typename?: 'gis_districts', id: any, state?: string | null, district?: string | null }> };

export type CreateReelMutationVariables = Exact<{
  url: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  title: Scalars['String']['input'];
  description: Scalars['String']['input'];
  category_id?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  google_places_id?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
  allow_comments?: InputMaybe<Scalars['Boolean']['input']>;
  allow_likes?: InputMaybe<Scalars['Boolean']['input']>;
  allow_shares?: InputMaybe<Scalars['Boolean']['input']>;
  allow_downloads?: InputMaybe<Scalars['Boolean']['input']>;
  allow_reports?: InputMaybe<Scalars['Boolean']['input']>;
  allow_reactions?: InputMaybe<Scalars['Boolean']['input']>;
  channelId?: InputMaybe<Scalars['Int']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  tags: Scalars['String']['input'];
  crop_id: Scalars['String']['input'];
  districtIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
  targeted_area?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateReelMutation = { __typename?: 'mutation_root', createReel: { __typename?: 'DefaultCommandOutput', error?: Array<string | null> | null, data: { __typename?: 'CommandOutputDataWithValues', status: string } | { __typename?: 'DefaultCommandOutputData', status: string } } };

export type MenuLayoutQueryVariables = Exact<{ [key: string]: never; }>;


export type MenuLayoutQuery = { __typename?: 'query_root', consoleMenuLayout: { __typename?: 'MenuStructure', userMenuItems?: Array<string | null> | null, mainMenuItems?: Array<string | null> | null } };

export type S3DataMutationVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type S3DataMutation = { __typename?: 'mutation_root', s3UploadData: Array<string> };

export type MyChannelsQueryVariables = Exact<{
  account_id?: InputMaybe<Scalars['bpchar']['input']>;
}>;


export type MyChannelsQuery = { __typename?: 'query_root', channels: Array<{ __typename?: 'channels', id: any, name?: string | null, account_id: any, company_id: any, followers_count: number, description?: string | null, banner_image_url?: string | null, logo_image_url?: string | null, content_languages?: any | null, channel_links: Array<{ __typename?: 'channel_links', id: any, link_url: string, link_type?: string | null, follower_count: number }> }> };

export type UserUpdatesMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserUpdatesMutation = { __typename?: 'mutation_root', userUpdatesHisProfile: { __typename?: 'DefaultCommandOutput', error?: Array<string | null> | null, data: { __typename?: 'CommandOutputDataWithValues', status: string } | { __typename?: 'DefaultCommandOutputData', status: string } } };

export type UpdateChannelDetailsMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  channelId: Scalars['Int']['input'];
  channelName: Scalars['String']['input'];
  channelDescription?: InputMaybe<Scalars['String']['input']>;
  logo_image_url?: InputMaybe<Scalars['String']['input']>;
  banner_image_url?: InputMaybe<Scalars['String']['input']>;
  contentLanguagesList?: InputMaybe<Scalars['String']['input']>;
  channelLinks?: InputMaybe<Array<InputMaybe<ChannelLinksInput>> | InputMaybe<ChannelLinksInput>>;
}>;


export type UpdateChannelDetailsMutation = { __typename?: 'mutation_root', updateChannelDetails?: { __typename?: 'Channel', id: number, account_id: string, name: string, description?: string | null, logo_image_url?: string | null, banner_image_url?: string | null } | null };

export type UserDetailSubscriptionVariables = Exact<{
  userId: Scalars['bpchar']['input'];
}>;


export type UserDetailSubscription = { __typename?: 'subscription_root', users_by_pk?: { __typename?: 'users', id: any, name: string, gender?: string | null, date_of_birth?: string | null, profile_image_url?: string | null, email?: string | null, phone_number: string, model_has_roles: Array<{ __typename?: 'model_has_roles', role_id: any }>, last_known_locations: Array<{ __typename?: 'last_known_locations', id: any, is_active?: boolean | null, address?: string | null }>, crop_users: Array<{ __typename?: 'crop_user', id: any, master_crop: { __typename?: 'master_crops', id: any, name: string } }>, segment_users: Array<{ __typename?: 'segment_user', id: any, master_segment: { __typename?: 'master_segments', id: any, name: string } }> } | null };

export type GetCfDataMutationVariables = Exact<{
  type: Scalars['String']['input'];
}>;


export type GetCfDataMutation = { __typename?: 'mutation_root', cfUploadData: Array<string> };

export type FeaturesQueryVariables = Exact<{
  accountId?: InputMaybe<Scalars['String']['input']>;
}>;


export type FeaturesQuery = { __typename?: 'query_root', features: Array<{ __typename?: 'features', id: any, scope: string, name: string, value: string }> };

export type ReelDetailsViewQueryVariables = Exact<{
  reelId: Scalars['bigint']['input'];
}>;


export type ReelDetailsViewQuery = { __typename?: 'query_root', reels_by_pk?: { __typename?: 'reels', id: any, cloudflare_thumbnail_url?: string | null, cloudflare_playback_url?: string | null, cloudflare_id?: string | null, thumbnail_url?: string | null, title?: string | null, created_at?: any | null, description?: string | null, reactions_count?: number | null, shares?: number | null, views?: number | null, channel?: { __typename?: 'channels', id: any, name?: string | null, logo_image_url?: string | null } | null, reel_comments_aggregate: { __typename?: 'reel_comments_aggregate', aggregate?: { __typename?: 'reel_comments_aggregate_fields', count: number } | null }, reel_comments: Array<{ __typename?: 'reel_comments', id: any, comment: string, user_id: any, created_at?: any | null, parent_id?: any | null, user: { __typename?: 'users', id: any, name: string, profile_image_url?: string | null } }> } | null };

export type CreateReelCommentMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  reelId: Scalars['String']['input'];
  comment: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateReelCommentMutation = { __typename?: 'mutation_root', createReelComment: { __typename?: 'DefaultCommandOutput', error?: Array<string | null> | null, data: { __typename?: 'CommandOutputDataWithValues', status: string } | { __typename?: 'DefaultCommandOutputData', status: string } } };

export type UserDeletesReelCommentMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  commentId: Scalars['Int']['input'];
  reelId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UserDeletesReelCommentMutation = { __typename?: 'mutation_root', deleteReelComment: { __typename?: 'DefaultCommandOutput', error?: Array<string | null> | null, data: { __typename?: 'CommandOutputDataWithValues', status: string } | { __typename?: 'DefaultCommandOutputData', status: string } } };

export type ReelReactionsSubscriptionVariables = Exact<{
  reelId: Scalars['bigint']['input'];
  currentUserId: Scalars['bpchar']['input'];
}>;


export type ReelReactionsSubscription = { __typename?: 'subscription_root', reels: Array<{ __typename?: 'reels', id: any, likes?: number | null, shares?: number | null, views?: number | null, user_id?: any | null, channel_id?: any | null, reactions_count?: number | null, reactions?: any | null, allow_comments: boolean, allow_likes: boolean, allow_reactions: boolean, allow_shares: boolean, allow_reports: boolean, reel_comments: Array<{ __typename?: 'reel_comments', id: any, user_id: any, comment: string, parent_id?: any | null, created_at?: any | null, user: { __typename?: 'users', id: any, name: string, profile_image_url?: string | null }, reports_aggregate: { __typename?: 'reel_user_reports_aggregate', aggregate?: { __typename?: 'reel_user_reports_aggregate_fields', count: number } | null } }>, reels_saved_reels_aggregate: { __typename?: 'saved_reels_aggregate', aggregate?: { __typename?: 'saved_reels_aggregate_fields', count: number } | null }, total_likes: { __typename?: 'reel_interactions_aggregate', aggregate?: { __typename?: 'reel_interactions_aggregate_fields', count: number } | null }, current_user_likes: { __typename?: 'reel_interactions_aggregate', aggregate?: { __typename?: 'reel_interactions_aggregate_fields', count: number } | null }, channel?: { __typename?: 'channels', id: any, name?: string | null, logo_image_url?: string | null, followers_count: number, currentUserFollows: Array<{ __typename?: 'user_follows_channel', id: any, user_id: any }> } | null, reels_reel_stats: Array<{ __typename?: 'reel_stats', id: any, playback_count?: any | null }> }> };

export type AllServiceRequestsSubscriptionVariables = Exact<{
  accountId: Scalars['bpchar']['input'];
}>;


export type AllServiceRequestsSubscription = { __typename?: 'subscription_root', service_requests: Array<{ __typename?: 'service_requests', id: any, created_at?: any | null, is_request_closed: boolean, address?: string | null, assets: any, date_of_sowing: any, lat: any, lng: any, farmer: { __typename?: 'users', id: any, name: string, phone_number: string, profile_image_url?: string | null, crop_users: Array<{ __typename?: 'crop_user', id: any, master_crop: { __typename?: 'master_crops', id: any, name: string } }> }, crop: { __typename?: 'master_crops', id: any, name: string, image_url?: string | null }, field_partner_responses: Array<{ __typename?: 'field_partner_responses', id: any, field_partner_user_id: any, response_action?: string | null, created_at?: any | null, field_partner_rating?: number | null, field_partner_rated_at?: any | null }> }> };

export type FarmerMessagesSubscriptionVariables = Exact<{
  requestId: Scalars['bpchar']['input'];
}>;


export type FarmerMessagesSubscription = { __typename?: 'subscription_root', field_partner_responses: Array<{ __typename?: 'field_partner_responses', id: any, response_action?: string | null, is_response_closed: boolean, farmer_rating?: number | null, field_partner_feedback?: string | null, closed_by?: any | null, farmer_feedback?: string | null, field_partner_rating?: number | null, closed_at?: any | null, service_request: { __typename?: 'service_requests', id: any, farmer: { __typename?: 'users', id: any, name: string, phone_number: string, profile_image_url?: string | null } }, field_partner: { __typename?: 'users', id: any, name: string, phone_number: string, profile_image_url?: string | null }, field_partner_response_messages: Array<{ __typename?: 'field_partner_response_messages', id: any, message: string, from_user_id: any, to_user_id: any, created_at?: any | null }> }> };

export type FfRespondsToRequestMutationVariables = Exact<{
  serviceRequestId: Scalars['String']['input'];
  fieldPartnerUserId: Scalars['String']['input'];
  action: Scalars['String']['input'];
}>;


export type FfRespondsToRequestMutation = { __typename?: 'mutation_root', fieldPartnerRespondsToRequest: { __typename?: 'DefaultCommandOutput', error?: Array<string | null> | null, data: { __typename?: 'CommandOutputDataWithValues', status: string } | { __typename?: 'DefaultCommandOutputData', status: string } } };

export type SendMessageOnServiceRequestMutationVariables = Exact<{
  farmerUserId: Scalars['String']['input'];
  fieldPartnerUserId: Scalars['String']['input'];
  message: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
  senderUserId: Scalars['String']['input'];
}>;


export type SendMessageOnServiceRequestMutation = { __typename?: 'mutation_root', sendMessageOnServiceRequest: { __typename?: 'DefaultCommandOutput', error?: Array<string | null> | null, data: { __typename?: 'CommandOutputDataWithValues', status: string } | { __typename?: 'DefaultCommandOutputData', status: string } } };

export type MessageOnServiceRequestsSubscriptionVariables = Exact<{
  fprId: Scalars['bpchar']['input'];
}>;


export type MessageOnServiceRequestsSubscription = { __typename?: 'subscription_root', field_partner_responses: Array<{ __typename?: 'field_partner_responses', id: any, field_partner_user_id: any, field_partner_rating?: number | null, farmer_user_id: any, request_id: any, updated_at?: any | null, created_at?: any | null, response_action?: string | null, farmer_rating?: number | null, farmer_feedback?: string | null, field_partner_feedback?: string | null, is_response_closed: boolean, field_partner_rated_at?: any | null, farmer_rated_at?: any | null, service_request: { __typename?: 'service_requests', id: any, crop: string, date_of_sowing: any, is_request_closed: boolean, created_at?: any | null, assets: any, address?: string | null, lat: any, lng: any, farmer: { __typename?: 'users', id: any, name: string, phone_number: string, profile_image_url?: string | null, user_feedbacks_aggregate: { __typename?: 'user_feedbacks_aggregate', aggregate?: { __typename?: 'user_feedbacks_aggregate_fields', avg?: { __typename?: 'user_feedbacks_avg_fields', rating?: number | null } | null } | null } } }, fieldPartner: { __typename?: 'users', id: any, name: string, phone_number: string, profile_image_url?: string | null, email?: string | null, user_feedbacks_aggregate: { __typename?: 'user_feedbacks_aggregate', aggregate?: { __typename?: 'user_feedbacks_aggregate_fields', avg?: { __typename?: 'user_feedbacks_avg_fields', rating?: number | null } | null } | null }, related_accounts: Array<{ __typename?: 'account_user', id: any, account: { __typename?: 'accounts', id: any, name: string } }> }, messages: Array<{ __typename?: 'field_partner_response_messages', id: any, message: string, from_user_id: any, to_user_id: any, created_at?: any | null, assets: any }> }> };

export type FieldPartnerClosesRequestFeedbackMutationVariables = Exact<{
  farmerUserId: Scalars['String']['input'];
  feedback: Scalars['String']['input'];
  fieldPartnerUserId: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
  rating: Scalars['String']['input'];
}>;


export type FieldPartnerClosesRequestFeedbackMutation = { __typename?: 'mutation_root', fieldPartnerClosesRequest: { __typename?: 'DefaultCommandOutput', error?: Array<string | null> | null, data: { __typename?: 'CommandOutputDataWithValues', status: string } | { __typename?: 'DefaultCommandOutputData', status: string } }, fieldPartnerRatesAndReviewsFarmer: { __typename?: 'DefaultCommandOutput', error?: Array<string | null> | null, data: { __typename?: 'CommandOutputDataWithValues', status: string } | { __typename?: 'DefaultCommandOutputData', status: string } } };

export type MyProspectsSubscriptionVariables = Exact<{
  accountId: Scalars['bpchar']['input'];
  channelId: Scalars['bigint']['input'];
}>;


export type MyProspectsSubscription = { __typename?: 'subscription_root', crm_account_channel_crop_prospects: Array<{ __typename?: 'crm_account_channel_crop_prospects', interaction_type?: string | null, channel_id?: any | null, crop_id?: any | null, prospect_id?: any | null, reel_comment?: { __typename?: 'reel_comments', id: any, comment: string } | null, prospect?: { __typename?: 'prospects', id: any, crop_id?: any | null, account_id: any, source_interaction_type?: string | null, status: string, source_reel_id?: any | null, source_interaction_ts?: any | null, created_at?: any | null, prospects_reel_comment?: { __typename?: 'reel_comments', id: any, comment: string, created_at?: any | null } | null, prospects_farmer_user: { __typename?: 'users', id: any, name: string, locale?: string | null, phone_number: string, email?: string | null, profile_image_url?: string | null, last_known_locations: Array<{ __typename?: 'last_known_locations', id: any, address?: string | null }> }, prospects_crop?: { __typename?: 'master_crops', id: any, name: string, image_url?: string | null } | null, prospects_reel?: { __typename?: 'reels', id: any, thumbnail_url?: string | null, title?: string | null, cloudflare_thumbnail_url?: string | null } | null } | null }> };

export type GetReelRecommendationsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetReelRecommendationsQuery = { __typename?: 'query_root', getReelRecommendations?: { __typename?: 'RecommendedReelIds', response: Array<string> } | null };

export type ReelsFarmerByIdsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['bigint']['input']> | Scalars['bigint']['input']>;
}>;


export type ReelsFarmerByIdsQuery = { __typename?: 'query_root', reels: Array<{ __typename?: 'reels', id: any, channel_id?: any | null, cloudflare_playback_url?: string | null, cloudflare_thumbnail_url?: string | null, cloudflare_id?: string | null, thumbnail_url?: string | null, title?: string | null, description?: string | null, channel?: { __typename?: 'channels', id: any, name?: string | null, logo_image_url?: string | null } | null, reels_user?: { __typename?: 'users', id: any, name: string, profile_image_url?: string | null } | null, reels_taggables: Array<{ __typename?: 'taggables', id: any, taggable_type: string, taggables_tag: { __typename?: 'tags', id: any, name: any } }> }> };

export type ChannelwisereelsSubscriptionVariables = Exact<{
  channelId?: InputMaybe<Scalars['bigint']['input']>;
}>;


export type ChannelwisereelsSubscription = { __typename?: 'subscription_root', reels: Array<{ __typename?: 'reels', id: any, channel_id?: any | null, user_id?: any | null, cloudflare_playback_url?: string | null, cloudflare_thumbnail_url?: string | null, cloudflare_id?: string | null, thumbnail_url?: string | null, title?: string | null, description?: string | null, channel?: { __typename?: 'channels', id: any, name?: string | null, logo_image_url?: string | null, followers_count: number } | null, reels_user?: { __typename?: 'users', id: any, name: string, profile_image_url?: string | null } | null, reels_taggables: Array<{ __typename?: 'taggables', id: any, taggable_type: string, taggables_tag: { __typename?: 'tags', id: any, name: any } }> }> };

export type CrmQueryVariables = Exact<{
  channelId: Scalars['bigint']['input'];
}>;


export type CrmQuery = { __typename?: 'query_root', crm_account_crop_wise_counts: Array<{ __typename?: 'crm_account_crop_wise_counts', account_id?: any | null, channel_id?: any | null, crop_id?: any | null, crop_name?: string | null, crop_image_url?: string | null, prospect_count?: any | null }> };

export type ChannelAnalyticsHomeQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
  channelIdInt?: InputMaybe<Scalars['bigint']['input']>;
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type ChannelAnalyticsHomeQuery = { __typename?: 'query_root', reel_stats_aggregate: { __typename?: 'reel_stats_aggregate', aggregate?: { __typename?: 'reel_stats_aggregate_fields', sum?: { __typename?: 'reel_stats_sum_fields', total_watch_time_ms?: any | null, playback_count?: any | null, avg_watch_time_ms?: any | null, reel_id?: any | null, view_count?: any | null } | null } | null }, channelAnalytics: { __typename?: 'GetChannelAnalyticsOutput', userId: string, companyId: string, accountId: string, channelName?: string | null, accountName: string, channelDescription?: string | null, channelLogoImageUrl?: string | null, followerCount: number, fullyViewedCount: number, sharesCount: number, commentsCount: number, likesCount: number, reels: number, watchTimeInMinutes: number } };

export type MasterCropsDistrictsQueryVariables = Exact<{ [key: string]: never; }>;


export type MasterCropsDistrictsQuery = { __typename?: 'query_root', master_crops: Array<{ __typename?: 'master_crops', id: any, name: string, image_url?: string | null }>, gis_districts: Array<{ __typename?: 'gis_districts', id: any, state?: string | null, district?: string | null }> };

export type RequestOtpunusedMutationVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  hashKey: Scalars['String']['input'];
}>;


export type RequestOtpunusedMutation = { __typename?: 'mutation_root', requestOtpCommand: { __typename?: 'RequestOTPOutput', encrypted: string, nonce: string, exists?: boolean | null, otp: string, phoneNumber: string } };

export type VerifyOtpMutationVariables = Exact<{
  encrypted: Scalars['String']['input'];
  nonce: Scalars['String']['input'];
  otp: Scalars['String']['input'];
  phone_number: Scalars['String']['input'];
  roleName: Scalars['String']['input'];
  checkPandoforce: Scalars['Boolean']['input'];
}>;


export type VerifyOtpMutation = { __typename?: 'mutation_root', verifyOtpCommand: { __typename?: 'VerifyOTPOutput', is_verified: boolean, token?: string | null, pfUserJSON?: string | null, envName?: string | null, hubUrl?: string | null, hubToken?: string | null, features?: Array<string> | null, user?: { __typename?: 'User', id: string, name?: string | null, roles: Array<string>, phoneNumber: string, locale?: string | null, contentLanguages: Array<string>, account_id?: string | null, last_known_location?: { __typename?: 'UserLastKnownLocation', address: string, state_name: string } | null, account?: { __typename?: 'Account', clientAccess?: any | null, id?: string | null } | null } | null } };

export type CrmProspectsQueryVariables = Exact<{
  cropId: Scalars['bpchar']['input'];
  channelId: Scalars['bigint']['input'];
}>;


export type CrmProspectsQuery = { __typename?: 'query_root', crm_account_channel_crop_prospects: Array<{ __typename?: 'crm_account_channel_crop_prospects', interaction_type?: string | null, reel_comment?: { __typename?: 'reel_comments', id: any, comment: string, created_at?: any | null } | null, prospect?: { __typename?: 'prospects', id: any, crop_id?: any | null, account_id: any, source_interaction_type?: string | null, status: string, source_reel_id?: any | null, source_interaction_ts?: any | null, created_at?: any | null, prospects_reel_comment?: { __typename?: 'reel_comments', id: any, comment: string, created_at?: any | null } | null, prospects_farmer_user: { __typename?: 'users', id: any, name: string, profile_image_url?: string | null, locale?: string | null, last_known_locations: Array<{ __typename?: 'last_known_locations', id: any, address?: string | null }> }, prospects_crop?: { __typename?: 'master_crops', id: any, name: string, image_url?: string | null } | null, prospects_reel?: { __typename?: 'reels', id: any, thumbnail_url?: string | null, title?: string | null, cloudflare_thumbnail_url?: string | null } | null } | null }> };

export type MyLeadsSubscriptionVariables = Exact<{
  channelId: Scalars['bigint']['input'];
}>;


export type MyLeadsSubscription = { __typename?: 'subscription_root', crm_account_channel_crop_prospects: Array<{ __typename?: 'crm_account_channel_crop_prospects', interaction_type?: string | null, prospect_id?: any | null, reel_comment?: { __typename?: 'reel_comments', id: any, comment: string, created_at?: any | null } | null, prospect?: { __typename?: 'prospects', id: any, crop_id?: any | null, account_id: any, source_interaction_type?: string | null, status: string, source_reel_id?: any | null, source_interaction_ts?: any | null, created_at?: any | null, prospects_reel_comment?: { __typename?: 'reel_comments', id: any, comment: string, created_at?: any | null } | null, prospects_farmer_user: { __typename?: 'users', id: any, name: string, profile_image_url?: string | null, phone_number: string, locale?: string | null, last_known_locations: Array<{ __typename?: 'last_known_locations', id: any, address?: string | null }> }, prospects_crop?: { __typename?: 'master_crops', id: any, name: string, image_url?: string | null } | null, prospects_reel?: { __typename?: 'reels', id: any, thumbnail_url?: string | null, title?: string | null, cloudflare_thumbnail_url?: string | null } | null } | null }> };

export type MyReelIntractionLeadsQueryVariables = Exact<{
  channelId: Scalars['bigint']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MyReelIntractionLeadsQuery = { __typename?: 'query_root', crm_account_channel_crop_prospects: Array<{ __typename?: 'crm_account_channel_crop_prospects', interaction_type?: string | null, prospect_id?: any | null, reel_comment?: { __typename?: 'reel_comments', id: any, comment: string, created_at?: any | null } | null, prospect?: { __typename?: 'prospects', id: any, crop_id?: any | null, created_at?: any | null, account_id: any, owner_user_id?: any | null, source_interaction_type?: string | null, status: string, source_reel_id?: any | null, source_interaction_ts?: any | null, prospects_owner?: { __typename?: 'users', id: any, name: string, phone_number: string, profile_image_url?: string | null } | null, farmer_location?: { __typename?: 'last_known_locations', id: any, lat: any, lng: any, address_components?: any | null } | null, prospects_reel_comment?: { __typename?: 'reel_comments', id: any, comment: string, created_at?: any | null } | null, prospects_farmer_user: { __typename?: 'users', id: any, name: string, profile_image_url?: string | null, phone_number: string, locale?: string | null, last_known_locations: Array<{ __typename?: 'last_known_locations', id: any, address?: string | null }> }, prospects_crop?: { __typename?: 'master_crops', id: any, name: string, image_url?: string | null } | null, prospects_reel?: { __typename?: 'reels', id: any, thumbnail_url?: string | null, title?: string | null, cloudflare_thumbnail_url?: string | null } | null } | null }> };

export type SubTabsReactionsCountsSubscriptionVariables = Exact<{
  cropId: Scalars['bpchar']['input'];
  channelId: Scalars['bigint']['input'];
}>;


export type SubTabsReactionsCountsSubscription = { __typename?: 'subscription_root', crm_account_interaction_type_pending_counts: Array<{ __typename?: 'crm_account_interaction_type_pending_counts', account_id?: any | null, channel_id?: any | null, crop_id?: any | null, interaction_type?: string | null, pending_count?: any | null }> };

export type CompanySendsConnectionRequestMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  farmerPhone?: InputMaybe<Scalars['String']['input']>;
}>;


export type CompanySendsConnectionRequestMutation = { __typename?: 'mutation_root', companySendsConnectionRequest?: { __typename?: 'Prospect', id?: string | null, threadId?: string | null, status?: string | null } | null };

export type ConnectionMessagesSubscriptionVariables = Exact<{
  prospectId: Scalars['bpchar']['input'];
  accountId: Scalars['bpchar']['input'];
}>;


export type ConnectionMessagesSubscription = { __typename?: 'subscription_root', prospect_messages: Array<{ __typename?: 'prospect_messages', id: any, prospect_id?: any | null, from_user_id: any, created_at?: any | null, to_user_id: any, message: string, channel?: { __typename?: 'channels', id: any, name?: string | null, logo_image_url?: string | null } | null }> };

export type AccountUserMessagesOnProspectMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  prospectId: Scalars['String']['input'];
  message: Scalars['String']['input'];
  channelId: Scalars['Int']['input'];
}>;


export type AccountUserMessagesOnProspectMutation = { __typename?: 'mutation_root', accountUserMessagesOnProspect: { __typename?: 'DefaultCommandOutput', error?: Array<string | null> | null, data: { __typename?: 'CommandOutputDataWithValues', status: string } | { __typename?: 'DefaultCommandOutputData', status: string } } };

export type CompanyConnectionsSubscriptionVariables = Exact<{
  accountId: Scalars['bpchar']['input'];
}>;


export type CompanyConnectionsSubscription = { __typename?: 'subscription_root', ActiveUsers: Array<{ __typename?: 'prospects', id: any, status: string, source_interaction_type?: string | null, user: { __typename?: 'users', id: any, name: string, phone_number: string, profile_image_url?: string | null, locale?: string | null, last_known_locations: Array<{ __typename?: 'last_known_locations', id: any, address?: string | null }> }, prospects_crop?: { __typename?: 'master_crops', id: any, name: string, image_url?: string | null } | null, messages: Array<{ __typename?: 'prospect_messages', id: any, message: string, created_at?: any | null }> }> };

export type MyinteractionsQueryVariables = Exact<{
  userId: Scalars['bpchar']['input'];
  channelID: Scalars['bigint']['input'];
}>;


export type MyinteractionsQuery = { __typename?: 'query_root', users_by_pk?: { __typename?: 'users', id: any, name: string, phone_number: string, profile_image_url?: string | null, content_languages?: any | null, locale?: string | null, last_known_locations: Array<{ __typename?: 'last_known_locations', id: any, address?: string | null }>, follows_channels_aggregate: { __typename?: 'user_follows_channel_aggregate', aggregate?: { __typename?: 'user_follows_channel_aggregate_fields', count: number } | null }, crop_users: Array<{ __typename?: 'crop_user', id: any, master_crop: { __typename?: 'master_crops', id: any, name: string, image_url?: string | null } }> } | null, reel_interactions: Array<{ __typename?: 'reel_interactions', id: any, interaction_type?: string | null, created_at?: any | null, reel: { __typename?: 'reels', id: any, title?: string | null, reactions_count?: number | null, shares?: number | null, views?: number | null, cloudflare_playback_url?: string | null, cloudflare_thumbnail_url?: string | null, thumbnail_url?: string | null, channel?: { __typename?: 'channels', id: any, name?: string | null, logo_image_url?: string | null } | null } }>, reel_comments: Array<{ __typename?: 'reel_comments', id: any, comment: string, created_at?: any | null, reel: { __typename?: 'reels', id: any, title?: string | null, reactions_count?: number | null, shares?: number | null, views?: number | null, cloudflare_playback_url?: string | null, cloudflare_thumbnail_url?: string | null, thumbnail_url?: string | null, channel?: { __typename?: 'channels', id: any, name?: string | null, logo_image_url?: string | null } | null } }> };

export type FarmersCrmQueryVariables = Exact<{ [key: string]: never; }>;


export type FarmersCrmQuery = { __typename?: 'query_root', farmer_fields_latest: Array<{ __typename?: 'farmer_fields_latest', id?: any | null, account_id?: any | null, farmer?: { __typename?: 'farmer_master', id: any, name: string, phone_number: string, created_at?: any | null } | null, account_location?: { __typename?: 'farmer_account_locations', district_name?: string | null, location?: any | null, state_name?: string | null, taluk_name?: string | null, village_name?: string | null } | null }> };

export type ContactsQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactsQuery = { __typename?: 'query_root', farmer_master: Array<{ __typename?: 'farmer_master', id: any, created_at?: any | null, name: string, phone_number: string, account_location: Array<{ __typename?: 'farmer_account_locations', id: any, account_id?: any | null, state_name?: string | null, district_name?: string | null, taluk_name?: string | null, village_name?: string | null }> }> };

export type GigFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type GigFiltersQuery = { __typename?: 'query_root', gis_states: Array<{ __typename?: 'gis_states', id: number, state?: string | null, state_code?: number | null }> };

export type CreateWorkOrderMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  gigId?: InputMaybe<Scalars['String']['input']>;
  variantId?: InputMaybe<Scalars['String']['input']>;
  gigRequests?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  budgetMax?: InputMaybe<Scalars['Int']['input']>;
  budgetMin?: InputMaybe<Scalars['Int']['input']>;
  cropId?: InputMaybe<Scalars['String']['input']>;
  stateName?: InputMaybe<Scalars['String']['input']>;
  expectedLaunch?: InputMaybe<Scalars['DateTime']['input']>;
  noOfInfluencers?: InputMaybe<Scalars['Int']['input']>;
  isOpenForInfluencers?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  variantType?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateWorkOrderMutation = { __typename?: 'mutation_root', createWorkOrder: { __typename?: 'CreateWorkOrderResponse', workOrderId: string } };

export type GetChannelReelsQueryVariables = Exact<{
  channelId: Scalars['bigint']['input'];
}>;


export type GetChannelReelsQuery = { __typename?: 'query_root', reels: Array<{ __typename?: 'reels', id: any, title?: string | null, thumbnail_url?: string | null, cloudflare_playback_url?: string | null, cloudflare_thumbnail_url?: string | null, views?: number | null, shares?: number | null, reactions_count?: number | null, s3_path?: string | null }> };

export type AllGigsQueryVariables = Exact<{
  gigType: Scalars['String']['input'];
}>;


export type AllGigsQuery = { __typename?: 'query_root', gigs: Array<{ __typename?: 'gigs', id: any, gig_type: string, districts?: any | null, experience_since?: number | null, expertises?: any | null, segments?: any | null, metrics?: any | null, travel_range?: any | null, avg_rating?: any | null, is_verified: boolean, title?: string | null, description?: string | null, created_at?: any | null, rating: number, languages?: any | null, states?: any | null, location?: string | null, avg_work_order_duration_days: any, completed_work_orders: number, review_count: number, approval_status: string, town_name?: string | null, village_name?: string | null, user: { __typename?: 'users', id: any, name: string, profile_image_url?: string | null, phone_number: string, email?: string | null }, district?: { __typename?: 'gis_districts', id: any, state?: string | null, district?: string | null } | null, variants: Array<{ __typename?: 'gig_variants', id: any, cost: any, qty: number, duration_days: number, variant_type: string }>, channel?: { __typename?: 'channels', id: any, name?: string | null, description?: string | null, logo_image_url?: string | null, content_languages?: any | null, channel_links: Array<{ __typename?: 'channel_links', id: any, link_url: string, follower_count: number, impressions_count?: number | null, engagement_rate?: any | null, link_type?: string | null }>, channel_links_aggregate: { __typename?: 'channel_links_aggregate', aggregate?: { __typename?: 'channel_links_aggregate_fields', sum?: { __typename?: 'channel_links_sum_fields', follower_count?: number | null, impressions_count?: number | null } | null } | null } } | null }> };

export type AllServiceCallsQueryVariables = Exact<{
  accountId: Scalars['bpchar']['input'];
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AllServiceCallsQuery = { __typename?: 'query_root', service_requests: Array<{ __typename?: 'service_requests', id: any, created_at?: any | null, is_request_closed: boolean, address?: string | null, assets: any, date_of_sowing: any, lat: any, lng: any, farmer: { __typename?: 'users', id: any, locale?: string | null, name: string, phone_number: string, follower_count: number, profile_image_url?: string | null, crop_users: Array<{ __typename?: 'crop_user', id: any, master_crop: { __typename?: 'master_crops', id: any, name: string } }> }, crop: { __typename?: 'master_crops', id: any, name: string, image_url?: string | null }, field_partner_responses: Array<{ __typename?: 'field_partner_responses', id: any, field_partner_user_id: any, response_action?: string | null, created_at?: any | null, field_partner_feedback?: string | null, field_partner_rating?: number | null, field_partner_rated_at?: any | null, closed_at?: any | null, closed_by?: any | null, farmer_feedback?: string | null, farmer_rating?: number | null, farmer_rated_at?: any | null, userByFieldPartnerUserId: { __typename?: 'users', id: any, name: string, phone_number: string, profile_image_url?: string | null } }>, last_known_locations: Array<{ __typename?: 'last_known_locations', lat: any, lng: any, address_components?: any | null }> }> };

export type ProspectServiceRequestsQueryVariables = Exact<{
  accountId: Scalars['bpchar']['input'];
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  farmerUserId?: InputMaybe<Scalars['bpchar']['input']>;
}>;


export type ProspectServiceRequestsQuery = { __typename?: 'query_root', service_requests: Array<{ __typename?: 'service_requests', id: any, created_at?: any | null, is_request_closed: boolean, address?: string | null, assets: any, date_of_sowing: any, lat: any, lng: any, farmer: { __typename?: 'users', id: any, locale?: string | null, name: string, phone_number: string, follower_count: number, profile_image_url?: string | null, crop_users: Array<{ __typename?: 'crop_user', id: any, master_crop: { __typename?: 'master_crops', id: any, name: string } }> }, crop: { __typename?: 'master_crops', id: any, name: string, image_url?: string | null }, field_partner_responses: Array<{ __typename?: 'field_partner_responses', id: any, field_partner_user_id: any, response_action?: string | null, created_at?: any | null, field_partner_rating?: number | null, field_partner_rated_at?: any | null, userByFieldPartnerUserId: { __typename?: 'users', id: any, name: string, phone_number: string, profile_image_url?: string | null } }>, last_known_locations: Array<{ __typename?: 'last_known_locations', lat: any, lng: any, address_components?: any | null }> }> };

export type ServiceRequestDetailsQueryVariables = Exact<{
  serviceRequestId?: InputMaybe<Scalars['bpchar']['input']>;
  accountId?: InputMaybe<Scalars['bpchar']['input']>;
}>;


export type ServiceRequestDetailsQuery = { __typename?: 'query_root', service_requests: Array<{ __typename?: 'service_requests', id: any, created_at?: any | null, is_request_closed: boolean, address?: string | null, assets: any, date_of_sowing: any, lat: any, lng: any, farmer: { __typename?: 'users', id: any, locale?: string | null, name: string, phone_number: string, profile_image_url?: string | null, crop_users: Array<{ __typename?: 'crop_user', id: any, master_crop: { __typename?: 'master_crops', id: any, name: string } }> }, crop: { __typename?: 'master_crops', id: any, name: string, image_url?: string | null }, field_partner_responses: Array<{ __typename?: 'field_partner_responses', id: any, field_partner_user_id: any, response_action?: string | null, created_at?: any | null, field_partner_feedback?: string | null, field_partner_rating?: number | null, field_partner_rated_at?: any | null, closed_at?: any | null, closed_by?: any | null, farmer_feedback?: string | null, farmer_rating?: number | null, farmer_rated_at?: any | null, userByFieldPartnerUserId: { __typename?: 'users', id: any, name: string, phone_number: string, profile_image_url?: string | null } }>, last_known_locations: Array<{ __typename?: 'last_known_locations', lat: any, lng: any, address_components?: any | null }> }> };

export type IndividualreelanalyticsQueryVariables = Exact<{
  reelId: Scalars['bigint']['input'];
}>;


export type IndividualreelanalyticsQuery = { __typename?: 'query_root', reels_by_pk?: { __typename?: 'reels', id: any, cloudflare_thumbnail_url?: string | null, cloudflare_playback_url?: string | null, cloudflare_id?: string | null, thumbnail_url?: string | null, title?: string | null, created_at?: any | null, description?: string | null, reactions_count?: number | null, shares?: number | null, views?: number | null, likes?: number | null, channel?: { __typename?: 'channels', id: any, name?: string | null, logo_image_url?: string | null } | null, reels_reel_stats: Array<{ __typename?: 'reel_stats', view_count?: any | null, playback_count?: any | null, avg_watch_time_ms?: any | null }>, reel_comments_aggregate: { __typename?: 'reel_comments_aggregate', aggregate?: { __typename?: 'reel_comments_aggregate_fields', count: number } | null }, reel_comments: Array<{ __typename?: 'reel_comments', id: any, comment: string, user_id: any, created_at?: any | null, parent_id?: any | null, user: { __typename?: 'users', id: any, name: string, profile_image_url?: string | null } }> } | null };

export type LeadDetailsQueryVariables = Exact<{
  channelId: Scalars['bigint']['input'];
  prospectID?: InputMaybe<Scalars['bpchar']['input']>;
}>;


export type LeadDetailsQuery = { __typename?: 'query_root', crm_account_channel_crop_prospects: Array<{ __typename?: 'crm_account_channel_crop_prospects', interaction_type?: string | null, prospect_id?: any | null, reel_comment?: { __typename?: 'reel_comments', id: any, comment: string, created_at?: any | null } | null, prospect?: { __typename?: 'prospects', id: any, crop_id?: any | null, created_at?: any | null, account_id: any, owner_user_id?: any | null, source_interaction_type?: string | null, status: string, source_reel_id?: any | null, source_interaction_ts?: any | null, prospects_owner?: { __typename?: 'users', id: any, name: string, phone_number: string, profile_image_url?: string | null } | null, farmer_location?: { __typename?: 'last_known_locations', id: any, lat: any, lng: any, address_components?: any | null } | null, prospects_reel_comment?: { __typename?: 'reel_comments', id: any, comment: string, created_at?: any | null } | null, prospects_farmer_user: { __typename?: 'users', id: any, name: string, follower_count: number, profile_image_url?: string | null, phone_number: string, locale?: string | null, last_known_locations: Array<{ __typename?: 'last_known_locations', id: any, address?: string | null }> }, prospects_crop?: { __typename?: 'master_crops', id: any, name: string, image_url?: string | null } | null, prospects_reel?: { __typename?: 'reels', id: any, thumbnail_url?: string | null, title?: string | null, cloudflare_thumbnail_url?: string | null } | null } | null }> };

export type ApproveReelMutationVariables = Exact<{
  foReelStagingId: Scalars['Int']['input'];
}>;


export type ApproveReelMutation = { __typename?: 'mutation_root', managerApprovesFoReel: { __typename?: 'DefaultCommandOutput', error?: Array<string | null> | null, data: { __typename?: 'CommandOutputDataWithValues', status: string } | { __typename?: 'DefaultCommandOutputData', status: string } } };

export type RejectsMutationVariables = Exact<{
  foReelStagingId: Scalars['Int']['input'];
}>;


export type RejectsMutation = { __typename?: 'mutation_root', managerRejectsFoReel: { __typename?: 'DefaultCommandOutput', error?: Array<string | null> | null, data: { __typename?: 'CommandOutputDataWithValues', status: string } | { __typename?: 'DefaultCommandOutputData', status: string } } };

export type RegisterFreeTrialMutationVariables = Exact<{
  channelName: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  spocDesignation: Scalars['String']['input'];
  spocName: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type RegisterFreeTrialMutation = { __typename?: 'mutation_root', registerFreeTrial: { __typename?: 'VerifyOTPOutput', is_verified: boolean, pfUserJSON?: string | null, token?: string | null, features?: Array<string> | null, user?: { __typename?: 'User', account_id?: string | null, company_id?: string | null, email?: string | null, id: string, name?: string | null, phoneNumber: string, profile_image_url?: string | null, roles: Array<string> } | null } };

export const CrmItemFragmentFragmentDoc = gql`
    fragment CRMItemFragment on CRMItem {
  id
  data
}
    `;
export const FfowoFieldsFragmentDoc = gql`
    fragment ffowoFields on work_orders {
  id
  title
  description
  objectives
  languages
  variant_type
  product_name
  status
  account {
    id
    name
  }
  states
  expected_date
  budget_max
  budget_min
  is_open_to_new_influencers
}
    `;
export const WoFieldsFragmentDoc = gql`
    fragment woFields on work_orders {
  id
  title
  description
  objectives
  languages
  variant_type
  product_name
  status
  account {
    id
    name
  }
  states
  expected_date
  budget_max
  budget_min
  is_open_to_new_influencers
}
    `;
export const CreateShopifyUserAccountDocument = gql`
    mutation createShopifyUserAccount($userId: String!) {
  createShopifyUserAccount(userId: $userId) {
    id
    accessToken
    expiresAt
  }
}
    `;
export type CreateShopifyUserAccountMutationFn = Apollo.MutationFunction<CreateShopifyUserAccountMutation, CreateShopifyUserAccountMutationVariables>;

/**
 * __useCreateShopifyUserAccountMutation__
 *
 * To run a mutation, you first call `useCreateShopifyUserAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShopifyUserAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShopifyUserAccountMutation, { data, loading, error }] = useCreateShopifyUserAccountMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCreateShopifyUserAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateShopifyUserAccountMutation, CreateShopifyUserAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateShopifyUserAccountMutation, CreateShopifyUserAccountMutationVariables>(CreateShopifyUserAccountDocument, options);
      }
export type CreateShopifyUserAccountMutationHookResult = ReturnType<typeof useCreateShopifyUserAccountMutation>;
export type CreateShopifyUserAccountMutationResult = Apollo.MutationResult<CreateShopifyUserAccountMutation>;
export type CreateShopifyUserAccountMutationOptions = Apollo.BaseMutationOptions<CreateShopifyUserAccountMutation, CreateShopifyUserAccountMutationVariables>;
export const MeDocument = gql`
    query me {
  me {
    id
    account {
      id: accountId
      accountName
      accountType
      features
    }
    account_id
    company_id
    name
    email
    locale
    market {
      id
      designation
      hq
      reportingUser {
        designation
      }
    }
    last_known_location {
      is_active
      address
      lat
      lng
      state_name
    }
    contentLanguages
    phoneNumber
    profile_image_url
    roles
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export function useMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const ChannelAndReelAnalyticsDocument = gql`
    query channelAndReelAnalytics($account_id: bpchar) {
  channels(where: {account_id: {_eq: $account_id}, deleted_at: {_is_null: true}}) {
    id
    name
    description
    logo_image_url
    content_languages
    channel_links {
      id
      link_url
      link_type
      follower_count
    }
  }
}
    `;

/**
 * __useChannelAndReelAnalyticsQuery__
 *
 * To run a query within a React component, call `useChannelAndReelAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelAndReelAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelAndReelAnalyticsQuery({
 *   variables: {
 *      account_id: // value for 'account_id'
 *   },
 * });
 */
export function useChannelAndReelAnalyticsQuery(baseOptions?: Apollo.QueryHookOptions<ChannelAndReelAnalyticsQuery, ChannelAndReelAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChannelAndReelAnalyticsQuery, ChannelAndReelAnalyticsQueryVariables>(ChannelAndReelAnalyticsDocument, options);
      }
export function useChannelAndReelAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChannelAndReelAnalyticsQuery, ChannelAndReelAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChannelAndReelAnalyticsQuery, ChannelAndReelAnalyticsQueryVariables>(ChannelAndReelAnalyticsDocument, options);
        }
export function useChannelAndReelAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChannelAndReelAnalyticsQuery, ChannelAndReelAnalyticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChannelAndReelAnalyticsQuery, ChannelAndReelAnalyticsQueryVariables>(ChannelAndReelAnalyticsDocument, options);
        }
export type ChannelAndReelAnalyticsQueryHookResult = ReturnType<typeof useChannelAndReelAnalyticsQuery>;
export type ChannelAndReelAnalyticsLazyQueryHookResult = ReturnType<typeof useChannelAndReelAnalyticsLazyQuery>;
export type ChannelAndReelAnalyticsSuspenseQueryHookResult = ReturnType<typeof useChannelAndReelAnalyticsSuspenseQuery>;
export type ChannelAndReelAnalyticsQueryResult = Apollo.QueryResult<ChannelAndReelAnalyticsQuery, ChannelAndReelAnalyticsQueryVariables>;
export const ReelCommentsDocument = gql`
    subscription reelComments($channelId: bigint, $reelId: bigint) {
  reel_interactions: reel_comments(
    where: {reel: {channel_id: {_eq: $channelId}}, deleted_at: {_is_null: true}, reel_id: {_eq: $reelId}}
  ) {
    id
    user_id
    comment
    parent_id
    created_at
    reel {
      id
      thumbnail_url
      cloudflare_thumbnail_url
      title
    }
    user {
      name
      profile_image_url
      last_known_locations {
        id
        address
      }
    }
    reel_interactions_user: user {
      name
      profile_image_url
      last_known_locations {
        id
        address
      }
    }
  }
}
    `;

/**
 * __useReelCommentsSubscription__
 *
 * To run a query within a React component, call `useReelCommentsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useReelCommentsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReelCommentsSubscription({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      reelId: // value for 'reelId'
 *   },
 * });
 */
export function useReelCommentsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ReelCommentsSubscription, ReelCommentsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ReelCommentsSubscription, ReelCommentsSubscriptionVariables>(ReelCommentsDocument, options);
      }
export type ReelCommentsSubscriptionHookResult = ReturnType<typeof useReelCommentsSubscription>;
export type ReelCommentsSubscriptionResult = Apollo.SubscriptionResult<ReelCommentsSubscription>;
export const AnalyticsDocument = gql`
    query analytics($userId: String!, $channelId: String!, $channelIdInt: bigint, $offset: Int!, $limit: Int!) {
  reel_stats_aggregate(where: {channel_id: {_eq: $channelIdInt}}) {
    aggregate {
      sum {
        total_watch_time_ms
        playback_count
        avg_watch_time_ms
        reel_id
        view_count
      }
    }
  }
  channelAnalytics(
    request: {userId: $userId, channelId: $channelId, limit: $limit, offset: $offset}
  ) {
    userId
    companyId
    accountId
    channelName
    accountName
    channelDescription
    channelLogoImageUrl
    followerCount
    fullyViewedCount
    sharesCount
    commentsCount
    likesCount
    reels
    watchTimeInMinutes
    reelsAnalyticsOutput {
      reelId
      title
      createdAt
      comments
      thumbnailUrl
      likes
      shares
      views
      stats {
        avgWatchTimeMs
        playbackCount
        viewCount
        totalWatchTimeMs
      }
      locationWiseViews {
        headers
        rows {
          cells
        }
      }
    }
  }
}
    `;

/**
 * __useAnalyticsQuery__
 *
 * To run a query within a React component, call `useAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      channelId: // value for 'channelId'
 *      channelIdInt: // value for 'channelIdInt'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<AnalyticsQuery, AnalyticsQueryVariables> & ({ variables: AnalyticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsQuery, AnalyticsQueryVariables>(AnalyticsDocument, options);
      }
export function useAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsQuery, AnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsQuery, AnalyticsQueryVariables>(AnalyticsDocument, options);
        }
export function useAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsQuery, AnalyticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsQuery, AnalyticsQueryVariables>(AnalyticsDocument, options);
        }
export type AnalyticsQueryHookResult = ReturnType<typeof useAnalyticsQuery>;
export type AnalyticsLazyQueryHookResult = ReturnType<typeof useAnalyticsLazyQuery>;
export type AnalyticsSuspenseQueryHookResult = ReturnType<typeof useAnalyticsSuspenseQuery>;
export type AnalyticsQueryResult = Apollo.QueryResult<AnalyticsQuery, AnalyticsQueryVariables>;
export const CampaignSummaryDocument = gql`
    query CampaignSummary($account_id: String!, $campaign_id: String!) {
  campaignWiseSummary(account_id: $account_id, campaign_id: $campaign_id) {
    channel
    status
    message_count
  }
}
    `;

/**
 * __useCampaignSummaryQuery__
 *
 * To run a query within a React component, call `useCampaignSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignSummaryQuery({
 *   variables: {
 *      account_id: // value for 'account_id'
 *      campaign_id: // value for 'campaign_id'
 *   },
 * });
 */
export function useCampaignSummaryQuery(baseOptions: Apollo.QueryHookOptions<CampaignSummaryQuery, CampaignSummaryQueryVariables> & ({ variables: CampaignSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignSummaryQuery, CampaignSummaryQueryVariables>(CampaignSummaryDocument, options);
      }
export function useCampaignSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignSummaryQuery, CampaignSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignSummaryQuery, CampaignSummaryQueryVariables>(CampaignSummaryDocument, options);
        }
export function useCampaignSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignSummaryQuery, CampaignSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignSummaryQuery, CampaignSummaryQueryVariables>(CampaignSummaryDocument, options);
        }
export type CampaignSummaryQueryHookResult = ReturnType<typeof useCampaignSummaryQuery>;
export type CampaignSummaryLazyQueryHookResult = ReturnType<typeof useCampaignSummaryLazyQuery>;
export type CampaignSummarySuspenseQueryHookResult = ReturnType<typeof useCampaignSummarySuspenseQuery>;
export type CampaignSummaryQueryResult = Apollo.QueryResult<CampaignSummaryQuery, CampaignSummaryQueryVariables>;
export const CampaignRecipientsDocument = gql`
    query campaignRecipients($campaignId: bpchar!) {
  messaging_campaign_recipients(where: {campaign_id: {_eq: $campaignId}}) {
    id
    phone
    content
    status
    scheduled_at
    farmer_master {
      id
      name
      phone_number
    }
  }
}
    `;

/**
 * __useCampaignRecipientsQuery__
 *
 * To run a query within a React component, call `useCampaignRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignRecipientsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignRecipientsQuery(baseOptions: Apollo.QueryHookOptions<CampaignRecipientsQuery, CampaignRecipientsQueryVariables> & ({ variables: CampaignRecipientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignRecipientsQuery, CampaignRecipientsQueryVariables>(CampaignRecipientsDocument, options);
      }
export function useCampaignRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignRecipientsQuery, CampaignRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignRecipientsQuery, CampaignRecipientsQueryVariables>(CampaignRecipientsDocument, options);
        }
export function useCampaignRecipientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignRecipientsQuery, CampaignRecipientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignRecipientsQuery, CampaignRecipientsQueryVariables>(CampaignRecipientsDocument, options);
        }
export type CampaignRecipientsQueryHookResult = ReturnType<typeof useCampaignRecipientsQuery>;
export type CampaignRecipientsLazyQueryHookResult = ReturnType<typeof useCampaignRecipientsLazyQuery>;
export type CampaignRecipientsSuspenseQueryHookResult = ReturnType<typeof useCampaignRecipientsSuspenseQuery>;
export type CampaignRecipientsQueryResult = Apollo.QueryResult<CampaignRecipientsQuery, CampaignRecipientsQueryVariables>;
export const CampaignDocument = gql`
    query campaign($accountId: bpchar!) {
  messaging_campaigns(
    where: {account_id: {_eq: $accountId}}
    order_by: {id: desc}
  ) {
    id
    status
    name
    description
    campaign_public_id
    created_at
    executed_at
    scheduled_at
    template {
      id
      type
      channels
    }
    recipients_aggregate {
      aggregate {
        count
      }
    }
    user {
      id
      name
      profile_image_url
    }
    template {
      id
      content
    }
    template_data
    segments {
      id
      segment {
        id
        name
        matching_count
      }
    }
  }
}
    `;

/**
 * __useCampaignQuery__
 *
 * To run a query within a React component, call `useCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useCampaignQuery(baseOptions: Apollo.QueryHookOptions<CampaignQuery, CampaignQueryVariables> & ({ variables: CampaignQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignQuery, CampaignQueryVariables>(CampaignDocument, options);
      }
export function useCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignQuery, CampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignQuery, CampaignQueryVariables>(CampaignDocument, options);
        }
export function useCampaignSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignQuery, CampaignQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignQuery, CampaignQueryVariables>(CampaignDocument, options);
        }
export type CampaignQueryHookResult = ReturnType<typeof useCampaignQuery>;
export type CampaignLazyQueryHookResult = ReturnType<typeof useCampaignLazyQuery>;
export type CampaignSuspenseQueryHookResult = ReturnType<typeof useCampaignSuspenseQuery>;
export type CampaignQueryResult = Apollo.QueryResult<CampaignQuery, CampaignQueryVariables>;
export const AccountSummaryDocument = gql`
    query AccountSummary($account_id: String!) {
  accountsWiseCampaignSummary(account_id: $account_id) {
    channel
    status
    message_count
  }
}
    `;

/**
 * __useAccountSummaryQuery__
 *
 * To run a query within a React component, call `useAccountSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountSummaryQuery({
 *   variables: {
 *      account_id: // value for 'account_id'
 *   },
 * });
 */
export function useAccountSummaryQuery(baseOptions: Apollo.QueryHookOptions<AccountSummaryQuery, AccountSummaryQueryVariables> & ({ variables: AccountSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountSummaryQuery, AccountSummaryQueryVariables>(AccountSummaryDocument, options);
      }
export function useAccountSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountSummaryQuery, AccountSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountSummaryQuery, AccountSummaryQueryVariables>(AccountSummaryDocument, options);
        }
export function useAccountSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountSummaryQuery, AccountSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountSummaryQuery, AccountSummaryQueryVariables>(AccountSummaryDocument, options);
        }
export type AccountSummaryQueryHookResult = ReturnType<typeof useAccountSummaryQuery>;
export type AccountSummaryLazyQueryHookResult = ReturnType<typeof useAccountSummaryLazyQuery>;
export type AccountSummarySuspenseQueryHookResult = ReturnType<typeof useAccountSummarySuspenseQuery>;
export type AccountSummaryQueryResult = Apollo.QueryResult<AccountSummaryQuery, AccountSummaryQueryVariables>;
export const SalesDataDocument = gql`
    query salesData($accountId: bpchar!) {
  pf_fcm_products(where: {account_id: {_eq: $accountId}}) {
    __typename
    id
    product_id
    product_name
    name: product_name
    shopify_product_id
  }
}
    `;

/**
 * __useSalesDataQuery__
 *
 * To run a query within a React component, call `useSalesDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesDataQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useSalesDataQuery(baseOptions: Apollo.QueryHookOptions<SalesDataQuery, SalesDataQueryVariables> & ({ variables: SalesDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesDataQuery, SalesDataQueryVariables>(SalesDataDocument, options);
      }
export function useSalesDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesDataQuery, SalesDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesDataQuery, SalesDataQueryVariables>(SalesDataDocument, options);
        }
export function useSalesDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SalesDataQuery, SalesDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SalesDataQuery, SalesDataQueryVariables>(SalesDataDocument, options);
        }
export type SalesDataQueryHookResult = ReturnType<typeof useSalesDataQuery>;
export type SalesDataLazyQueryHookResult = ReturnType<typeof useSalesDataLazyQuery>;
export type SalesDataSuspenseQueryHookResult = ReturnType<typeof useSalesDataSuspenseQuery>;
export type SalesDataQueryResult = Apollo.QueryResult<SalesDataQuery, SalesDataQueryVariables>;
export const ContentReelsDocument = gql`
    query contentReels($channelId: bigint) {
  fich_farminsta_replica_reels_flat(
    where: {channel_id: {_eq: $channelId}}
    order_by: {created_at: desc}
  ) {
    id
    title
    thumbnail_url
    description
    created_at
    playback_count
    tws: total_watch_time_secs
    avg_watch_duration_percent
    playback_count
    view_count
    react_count
    share_count
    comment_count
    duration_ms
    lead_count
    user_name
    user_id
    uploader_type
    active_lead_count
  }
}
    `;

/**
 * __useContentReelsQuery__
 *
 * To run a query within a React component, call `useContentReelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentReelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentReelsQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useContentReelsQuery(baseOptions?: Apollo.QueryHookOptions<ContentReelsQuery, ContentReelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentReelsQuery, ContentReelsQueryVariables>(ContentReelsDocument, options);
      }
export function useContentReelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentReelsQuery, ContentReelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentReelsQuery, ContentReelsQueryVariables>(ContentReelsDocument, options);
        }
export function useContentReelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentReelsQuery, ContentReelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentReelsQuery, ContentReelsQueryVariables>(ContentReelsDocument, options);
        }
export type ContentReelsQueryHookResult = ReturnType<typeof useContentReelsQuery>;
export type ContentReelsLazyQueryHookResult = ReturnType<typeof useContentReelsLazyQuery>;
export type ContentReelsSuspenseQueryHookResult = ReturnType<typeof useContentReelsSuspenseQuery>;
export type ContentReelsQueryResult = Apollo.QueryResult<ContentReelsQuery, ContentReelsQueryVariables>;
export const GetCrmTemplatesDocument = gql`
    query getCRMTemplates($accountId: bpchar!) {
  messaging_templates(where: {account_id: {_eq: $accountId}}) {
    id
    name
    content
    data
    created_at
    channels
    type
  }
}
    `;

/**
 * __useGetCrmTemplatesQuery__
 *
 * To run a query within a React component, call `useGetCrmTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrmTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrmTemplatesQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetCrmTemplatesQuery(baseOptions: Apollo.QueryHookOptions<GetCrmTemplatesQuery, GetCrmTemplatesQueryVariables> & ({ variables: GetCrmTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCrmTemplatesQuery, GetCrmTemplatesQueryVariables>(GetCrmTemplatesDocument, options);
      }
export function useGetCrmTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCrmTemplatesQuery, GetCrmTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCrmTemplatesQuery, GetCrmTemplatesQueryVariables>(GetCrmTemplatesDocument, options);
        }
export function useGetCrmTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCrmTemplatesQuery, GetCrmTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCrmTemplatesQuery, GetCrmTemplatesQueryVariables>(GetCrmTemplatesDocument, options);
        }
export type GetCrmTemplatesQueryHookResult = ReturnType<typeof useGetCrmTemplatesQuery>;
export type GetCrmTemplatesLazyQueryHookResult = ReturnType<typeof useGetCrmTemplatesLazyQuery>;
export type GetCrmTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetCrmTemplatesSuspenseQuery>;
export type GetCrmTemplatesQueryResult = Apollo.QueryResult<GetCrmTemplatesQuery, GetCrmTemplatesQueryVariables>;
export const CreateMessageCampaignDocument = gql`
    mutation createMessageCampaign($templateId: String!, $name: String!, $templateData: String!, $segmentIds: [String!]!, $customRecipients: String!, $scheduledAt: DateTime!) {
  createMessageCampaign(
    dto: {templateId: $templateId, name: $name, templateData: $templateData, segmentIds: $segmentIds, customRecipients: $customRecipients, scheduledAt: $scheduledAt}
  ) {
    id
    createdAt
    name
    templateId
    templateData
    status
    scheduledAt
    executedAt
  }
}
    `;
export type CreateMessageCampaignMutationFn = Apollo.MutationFunction<CreateMessageCampaignMutation, CreateMessageCampaignMutationVariables>;

/**
 * __useCreateMessageCampaignMutation__
 *
 * To run a mutation, you first call `useCreateMessageCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessageCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMessageCampaignMutation, { data, loading, error }] = useCreateMessageCampaignMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      name: // value for 'name'
 *      templateData: // value for 'templateData'
 *      segmentIds: // value for 'segmentIds'
 *      customRecipients: // value for 'customRecipients'
 *      scheduledAt: // value for 'scheduledAt'
 *   },
 * });
 */
export function useCreateMessageCampaignMutation(baseOptions?: Apollo.MutationHookOptions<CreateMessageCampaignMutation, CreateMessageCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMessageCampaignMutation, CreateMessageCampaignMutationVariables>(CreateMessageCampaignDocument, options);
      }
export type CreateMessageCampaignMutationHookResult = ReturnType<typeof useCreateMessageCampaignMutation>;
export type CreateMessageCampaignMutationResult = Apollo.MutationResult<CreateMessageCampaignMutation>;
export type CreateMessageCampaignMutationOptions = Apollo.BaseMutationOptions<CreateMessageCampaignMutation, CreateMessageCampaignMutationVariables>;
export const CrmSchemaDocument = gql`
    query crmSchema($accountId: String!) {
  cRMSchema(accountId: $accountId) {
    dataType
    fieldSeq
    id
    formValues {
      dataType
      id
      value
    }
    label
    mandatory
    validationType
    valueType
    viewConfig
  }
}
    `;

/**
 * __useCrmSchemaQuery__
 *
 * To run a query within a React component, call `useCrmSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmSchemaQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useCrmSchemaQuery(baseOptions: Apollo.QueryHookOptions<CrmSchemaQuery, CrmSchemaQueryVariables> & ({ variables: CrmSchemaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CrmSchemaQuery, CrmSchemaQueryVariables>(CrmSchemaDocument, options);
      }
export function useCrmSchemaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrmSchemaQuery, CrmSchemaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CrmSchemaQuery, CrmSchemaQueryVariables>(CrmSchemaDocument, options);
        }
export function useCrmSchemaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CrmSchemaQuery, CrmSchemaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CrmSchemaQuery, CrmSchemaQueryVariables>(CrmSchemaDocument, options);
        }
export type CrmSchemaQueryHookResult = ReturnType<typeof useCrmSchemaQuery>;
export type CrmSchemaLazyQueryHookResult = ReturnType<typeof useCrmSchemaLazyQuery>;
export type CrmSchemaSuspenseQueryHookResult = ReturnType<typeof useCrmSchemaSuspenseQuery>;
export type CrmSchemaQueryResult = Apollo.QueryResult<CrmSchemaQuery, CrmSchemaQueryVariables>;
export const CRmItemsDocument = gql`
    query cRMItems($accountId: String!, $filterJson: String!, $orderBy: String, $dir: String, $page: Int, $size: Int) {
  searchCRMItems(
    accountId: $accountId
    filtersJson: $filterJson
    order_by: $orderBy
    dir: $dir
    page: $page
    size: $size
  ) {
    items {
      id
      farmerId
      farmerName
      phoneNumber
      farmerAccountId
      locationId
      lat
      lng
      data
    }
    totalCount
    totalPages
    pageSize
  }
}
    `;

/**
 * __useCRmItemsQuery__
 *
 * To run a query within a React component, call `useCRmItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCRmItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCRmItemsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      filterJson: // value for 'filterJson'
 *      orderBy: // value for 'orderBy'
 *      dir: // value for 'dir'
 *      page: // value for 'page'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useCRmItemsQuery(baseOptions: Apollo.QueryHookOptions<CRmItemsQuery, CRmItemsQueryVariables> & ({ variables: CRmItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CRmItemsQuery, CRmItemsQueryVariables>(CRmItemsDocument, options);
      }
export function useCRmItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CRmItemsQuery, CRmItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CRmItemsQuery, CRmItemsQueryVariables>(CRmItemsDocument, options);
        }
export function useCRmItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CRmItemsQuery, CRmItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CRmItemsQuery, CRmItemsQueryVariables>(CRmItemsDocument, options);
        }
export type CRmItemsQueryHookResult = ReturnType<typeof useCRmItemsQuery>;
export type CRmItemsLazyQueryHookResult = ReturnType<typeof useCRmItemsLazyQuery>;
export type CRmItemsSuspenseQueryHookResult = ReturnType<typeof useCRmItemsSuspenseQuery>;
export type CRmItemsQueryResult = Apollo.QueryResult<CRmItemsQuery, CRmItemsQueryVariables>;
export const IcCompanyCropProductsDocument = gql`
    query icCompanyCropProducts($icCompanyId: bigint!) {
  pf_fcm_crops(where: {comp_id: {_eq: $icCompanyId}}) {
    id
    crop_name
    segment_name
  }
  pf_fcm_products(where: {comp_id: {_eq: $icCompanyId}}) {
    id
    product_name
    crop_id
  }
}
    `;

/**
 * __useIcCompanyCropProductsQuery__
 *
 * To run a query within a React component, call `useIcCompanyCropProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIcCompanyCropProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIcCompanyCropProductsQuery({
 *   variables: {
 *      icCompanyId: // value for 'icCompanyId'
 *   },
 * });
 */
export function useIcCompanyCropProductsQuery(baseOptions: Apollo.QueryHookOptions<IcCompanyCropProductsQuery, IcCompanyCropProductsQueryVariables> & ({ variables: IcCompanyCropProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IcCompanyCropProductsQuery, IcCompanyCropProductsQueryVariables>(IcCompanyCropProductsDocument, options);
      }
export function useIcCompanyCropProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IcCompanyCropProductsQuery, IcCompanyCropProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IcCompanyCropProductsQuery, IcCompanyCropProductsQueryVariables>(IcCompanyCropProductsDocument, options);
        }
export function useIcCompanyCropProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IcCompanyCropProductsQuery, IcCompanyCropProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IcCompanyCropProductsQuery, IcCompanyCropProductsQueryVariables>(IcCompanyCropProductsDocument, options);
        }
export type IcCompanyCropProductsQueryHookResult = ReturnType<typeof useIcCompanyCropProductsQuery>;
export type IcCompanyCropProductsLazyQueryHookResult = ReturnType<typeof useIcCompanyCropProductsLazyQuery>;
export type IcCompanyCropProductsSuspenseQueryHookResult = ReturnType<typeof useIcCompanyCropProductsSuspenseQuery>;
export type IcCompanyCropProductsQueryResult = Apollo.QueryResult<IcCompanyCropProductsQuery, IcCompanyCropProductsQueryVariables>;
export const SearchCrmItemsDocument = gql`
    query searchCRMItems($accountId: String!, $filterJson: String!, $orderBy: String, $dir: String, $page: Int, $size: Int) {
  searchCRMItems(
    accountId: $accountId
    filtersJson: $filterJson
    order_by: $orderBy
    dir: $dir
    page: $page
    size: $size
  ) {
    items {
      id
      farmerId
      farmerName
      phoneNumber
      farmerAccountId
      locationId
      lat
      lng
      data
    }
    totalCount
    totalPages
    pageSize
  }
}
    `;

/**
 * __useSearchCrmItemsQuery__
 *
 * To run a query within a React component, call `useSearchCrmItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCrmItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCrmItemsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      filterJson: // value for 'filterJson'
 *      orderBy: // value for 'orderBy'
 *      dir: // value for 'dir'
 *      page: // value for 'page'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useSearchCrmItemsQuery(baseOptions: Apollo.QueryHookOptions<SearchCrmItemsQuery, SearchCrmItemsQueryVariables> & ({ variables: SearchCrmItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCrmItemsQuery, SearchCrmItemsQueryVariables>(SearchCrmItemsDocument, options);
      }
export function useSearchCrmItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCrmItemsQuery, SearchCrmItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCrmItemsQuery, SearchCrmItemsQueryVariables>(SearchCrmItemsDocument, options);
        }
export function useSearchCrmItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchCrmItemsQuery, SearchCrmItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchCrmItemsQuery, SearchCrmItemsQueryVariables>(SearchCrmItemsDocument, options);
        }
export type SearchCrmItemsQueryHookResult = ReturnType<typeof useSearchCrmItemsQuery>;
export type SearchCrmItemsLazyQueryHookResult = ReturnType<typeof useSearchCrmItemsLazyQuery>;
export type SearchCrmItemsSuspenseQueryHookResult = ReturnType<typeof useSearchCrmItemsSuspenseQuery>;
export type SearchCrmItemsQueryResult = Apollo.QueryResult<SearchCrmItemsQuery, SearchCrmItemsQueryVariables>;
export const CreateSegmentDocument = gql`
    mutation createSegment($name: String!, $crmType: String!, $filterData: String!) {
  createCRMSegment(dto: {name: $name, crmType: $crmType, filterData: $filterData}) {
    id
    name
    crmType
    filterData
  }
}
    `;
export type CreateSegmentMutationFn = Apollo.MutationFunction<CreateSegmentMutation, CreateSegmentMutationVariables>;

/**
 * __useCreateSegmentMutation__
 *
 * To run a mutation, you first call `useCreateSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSegmentMutation, { data, loading, error }] = useCreateSegmentMutation({
 *   variables: {
 *      name: // value for 'name'
 *      crmType: // value for 'crmType'
 *      filterData: // value for 'filterData'
 *   },
 * });
 */
export function useCreateSegmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateSegmentMutation, CreateSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSegmentMutation, CreateSegmentMutationVariables>(CreateSegmentDocument, options);
      }
export type CreateSegmentMutationHookResult = ReturnType<typeof useCreateSegmentMutation>;
export type CreateSegmentMutationResult = Apollo.MutationResult<CreateSegmentMutation>;
export type CreateSegmentMutationOptions = Apollo.BaseMutationOptions<CreateSegmentMutation, CreateSegmentMutationVariables>;
export const GetCrmSegmentsDocument = gql`
    query getCRMSegments($accountId: bpchar!) {
  crm_segments(
    where: {account_id: {_eq: $accountId}, deleted_at: {_is_null: true}}
  ) {
    id
    name
    filter_data
    matching_count
  }
}
    `;

/**
 * __useGetCrmSegmentsQuery__
 *
 * To run a query within a React component, call `useGetCrmSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrmSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrmSegmentsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetCrmSegmentsQuery(baseOptions: Apollo.QueryHookOptions<GetCrmSegmentsQuery, GetCrmSegmentsQueryVariables> & ({ variables: GetCrmSegmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCrmSegmentsQuery, GetCrmSegmentsQueryVariables>(GetCrmSegmentsDocument, options);
      }
export function useGetCrmSegmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCrmSegmentsQuery, GetCrmSegmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCrmSegmentsQuery, GetCrmSegmentsQueryVariables>(GetCrmSegmentsDocument, options);
        }
export function useGetCrmSegmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCrmSegmentsQuery, GetCrmSegmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCrmSegmentsQuery, GetCrmSegmentsQueryVariables>(GetCrmSegmentsDocument, options);
        }
export type GetCrmSegmentsQueryHookResult = ReturnType<typeof useGetCrmSegmentsQuery>;
export type GetCrmSegmentsLazyQueryHookResult = ReturnType<typeof useGetCrmSegmentsLazyQuery>;
export type GetCrmSegmentsSuspenseQueryHookResult = ReturnType<typeof useGetCrmSegmentsSuspenseQuery>;
export type GetCrmSegmentsQueryResult = Apollo.QueryResult<GetCrmSegmentsQuery, GetCrmSegmentsQueryVariables>;
export const GetStatsDocument = gql`
    query getStats($accountId: String!) {
  globalStats(accountId: $accountId) {
    total_count
    fo_farmers
    reel_farmers
    ffo_farmers
    influencer_farmers
    service_request_farmers
  }
}
    `;

/**
 * __useGetStatsQuery__
 *
 * To run a query within a React component, call `useGetStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetStatsQuery(baseOptions: Apollo.QueryHookOptions<GetStatsQuery, GetStatsQueryVariables> & ({ variables: GetStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStatsQuery, GetStatsQueryVariables>(GetStatsDocument, options);
      }
export function useGetStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStatsQuery, GetStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStatsQuery, GetStatsQueryVariables>(GetStatsDocument, options);
        }
export function useGetStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStatsQuery, GetStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStatsQuery, GetStatsQueryVariables>(GetStatsDocument, options);
        }
export type GetStatsQueryHookResult = ReturnType<typeof useGetStatsQuery>;
export type GetStatsLazyQueryHookResult = ReturnType<typeof useGetStatsLazyQuery>;
export type GetStatsSuspenseQueryHookResult = ReturnType<typeof useGetStatsSuspenseQuery>;
export type GetStatsQueryResult = Apollo.QueryResult<GetStatsQuery, GetStatsQueryVariables>;
export const PfUsersDocument = gql`
    query pfUsers($icCompanyId: bigint!) {
  pf_users(
    where: {input_company_id: {_eq: $icCompanyId}, roleid: {_in: [4]}, status: {_eq: "active"}}
  ) {
    id
    first_name
    last_name
    head_quarters
    input_company_id
  }
}
    `;

/**
 * __usePfUsersQuery__
 *
 * To run a query within a React component, call `usePfUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePfUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePfUsersQuery({
 *   variables: {
 *      icCompanyId: // value for 'icCompanyId'
 *   },
 * });
 */
export function usePfUsersQuery(baseOptions: Apollo.QueryHookOptions<PfUsersQuery, PfUsersQueryVariables> & ({ variables: PfUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PfUsersQuery, PfUsersQueryVariables>(PfUsersDocument, options);
      }
export function usePfUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PfUsersQuery, PfUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PfUsersQuery, PfUsersQueryVariables>(PfUsersDocument, options);
        }
export function usePfUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PfUsersQuery, PfUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PfUsersQuery, PfUsersQueryVariables>(PfUsersDocument, options);
        }
export type PfUsersQueryHookResult = ReturnType<typeof usePfUsersQuery>;
export type PfUsersLazyQueryHookResult = ReturnType<typeof usePfUsersLazyQuery>;
export type PfUsersSuspenseQueryHookResult = ReturnType<typeof usePfUsersSuspenseQuery>;
export type PfUsersQueryResult = Apollo.QueryResult<PfUsersQuery, PfUsersQueryVariables>;
export const Messaging_ConfigDocument = gql`
    query messaging_config {
  account_auth_key {
    id
    user_id
  }
}
    `;

/**
 * __useMessaging_ConfigQuery__
 *
 * To run a query within a React component, call `useMessaging_ConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessaging_ConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessaging_ConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useMessaging_ConfigQuery(baseOptions?: Apollo.QueryHookOptions<Messaging_ConfigQuery, Messaging_ConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Messaging_ConfigQuery, Messaging_ConfigQueryVariables>(Messaging_ConfigDocument, options);
      }
export function useMessaging_ConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Messaging_ConfigQuery, Messaging_ConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Messaging_ConfigQuery, Messaging_ConfigQueryVariables>(Messaging_ConfigDocument, options);
        }
export function useMessaging_ConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Messaging_ConfigQuery, Messaging_ConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Messaging_ConfigQuery, Messaging_ConfigQueryVariables>(Messaging_ConfigDocument, options);
        }
export type Messaging_ConfigQueryHookResult = ReturnType<typeof useMessaging_ConfigQuery>;
export type Messaging_ConfigLazyQueryHookResult = ReturnType<typeof useMessaging_ConfigLazyQuery>;
export type Messaging_ConfigSuspenseQueryHookResult = ReturnType<typeof useMessaging_ConfigSuspenseQuery>;
export type Messaging_ConfigQueryResult = Apollo.QueryResult<Messaging_ConfigQuery, Messaging_ConfigQueryVariables>;
export const CompanyAssignsFoDocument = gql`
    mutation companyAssignsFO($userId: String, $marketId: Int, $farmerPhone: String, $prospectId: String) {
  companyAssignsFO(
    request: {userId: $userId, userMarketId: $marketId, farmerPhone: $farmerPhone, prospectId: $prospectId}
  ) {
    id
    threadId
    status
  }
}
    `;
export type CompanyAssignsFoMutationFn = Apollo.MutationFunction<CompanyAssignsFoMutation, CompanyAssignsFoMutationVariables>;

/**
 * __useCompanyAssignsFoMutation__
 *
 * To run a mutation, you first call `useCompanyAssignsFoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyAssignsFoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyAssignsFoMutation, { data, loading, error }] = useCompanyAssignsFoMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      marketId: // value for 'marketId'
 *      farmerPhone: // value for 'farmerPhone'
 *      prospectId: // value for 'prospectId'
 *   },
 * });
 */
export function useCompanyAssignsFoMutation(baseOptions?: Apollo.MutationHookOptions<CompanyAssignsFoMutation, CompanyAssignsFoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanyAssignsFoMutation, CompanyAssignsFoMutationVariables>(CompanyAssignsFoDocument, options);
      }
export type CompanyAssignsFoMutationHookResult = ReturnType<typeof useCompanyAssignsFoMutation>;
export type CompanyAssignsFoMutationResult = Apollo.MutationResult<CompanyAssignsFoMutation>;
export type CompanyAssignsFoMutationOptions = Apollo.BaseMutationOptions<CompanyAssignsFoMutation, CompanyAssignsFoMutationVariables>;
export const CompanyRespondsToServiceRequestDocument = gql`
    mutation companyRespondsToServiceRequest($action: String!, $requestId: String!, $userId: String!) {
  fieldPartnerRespondsToRequest(
    command: {action: $action, requestId: $requestId, fieldPartnerUserId: $userId}
  ) {
    data {
      status
    }
    error
  }
}
    `;
export type CompanyRespondsToServiceRequestMutationFn = Apollo.MutationFunction<CompanyRespondsToServiceRequestMutation, CompanyRespondsToServiceRequestMutationVariables>;

/**
 * __useCompanyRespondsToServiceRequestMutation__
 *
 * To run a mutation, you first call `useCompanyRespondsToServiceRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyRespondsToServiceRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyRespondsToServiceRequestMutation, { data, loading, error }] = useCompanyRespondsToServiceRequestMutation({
 *   variables: {
 *      action: // value for 'action'
 *      requestId: // value for 'requestId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCompanyRespondsToServiceRequestMutation(baseOptions?: Apollo.MutationHookOptions<CompanyRespondsToServiceRequestMutation, CompanyRespondsToServiceRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanyRespondsToServiceRequestMutation, CompanyRespondsToServiceRequestMutationVariables>(CompanyRespondsToServiceRequestDocument, options);
      }
export type CompanyRespondsToServiceRequestMutationHookResult = ReturnType<typeof useCompanyRespondsToServiceRequestMutation>;
export type CompanyRespondsToServiceRequestMutationResult = Apollo.MutationResult<CompanyRespondsToServiceRequestMutation>;
export type CompanyRespondsToServiceRequestMutationOptions = Apollo.BaseMutationOptions<CompanyRespondsToServiceRequestMutation, CompanyRespondsToServiceRequestMutationVariables>;
export const GetTravelLogDocument = gql`
    query getTravelLog($marketId: bigint!, $from: timestamptz!, $end: timestamptz!) {
  pf_user_travellog(
    where: {user_id: {_eq: $marketId}, date_time: {_gte: $from, _lte: $end}}
    order_by: {date_time: asc}
  ) {
    id
    user_id
    latitude_position
    longitude_position
    date_time
  }
}
    `;

/**
 * __useGetTravelLogQuery__
 *
 * To run a query within a React component, call `useGetTravelLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTravelLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTravelLogQuery({
 *   variables: {
 *      marketId: // value for 'marketId'
 *      from: // value for 'from'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useGetTravelLogQuery(baseOptions: Apollo.QueryHookOptions<GetTravelLogQuery, GetTravelLogQueryVariables> & ({ variables: GetTravelLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTravelLogQuery, GetTravelLogQueryVariables>(GetTravelLogDocument, options);
      }
export function useGetTravelLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTravelLogQuery, GetTravelLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTravelLogQuery, GetTravelLogQueryVariables>(GetTravelLogDocument, options);
        }
export function useGetTravelLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTravelLogQuery, GetTravelLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTravelLogQuery, GetTravelLogQueryVariables>(GetTravelLogDocument, options);
        }
export type GetTravelLogQueryHookResult = ReturnType<typeof useGetTravelLogQuery>;
export type GetTravelLogLazyQueryHookResult = ReturnType<typeof useGetTravelLogLazyQuery>;
export type GetTravelLogSuspenseQueryHookResult = ReturnType<typeof useGetTravelLogSuspenseQuery>;
export type GetTravelLogQueryResult = Apollo.QueryResult<GetTravelLogQuery, GetTravelLogQueryVariables>;
export const GetOpenWorkOrdersFfoDocument = gql`
    query getOpenWorkOrdersFFO($influencerUserId: bpchar!) {
  open_workorders: work_orders(
    where: {gig_type: {_eq: "fcm"}, is_open_to_new_influencers: {_eq: true}, deleted_at: {_is_null: true}, _not: {requests: {status: {_eq: "rejected"}, influencer_user_id: {_eq: $influencerUserId}}}}
  ) {
    ...ffowoFields
    requests {
      id
      influencer_user_id
      __typename
    }
    __typename
  }
  incoming_requests: work_orders(
    where: {requests: {status: {_neq: "rejected"}, influencer_user_id: {_eq: $influencerUserId}}, deleted_at: {_is_null: true}}
    order_by: {updated_at: desc}
  ) {
    ...ffowoFields
    requests(where: {influencer_user_id: {_eq: $influencerUserId}}) {
      id
      gig_id
      status
      bid_price
      delivery_days
      __typename
    }
    __typename
  }
}
    ${FfowoFieldsFragmentDoc}`;

/**
 * __useGetOpenWorkOrdersFfoQuery__
 *
 * To run a query within a React component, call `useGetOpenWorkOrdersFfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpenWorkOrdersFfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpenWorkOrdersFfoQuery({
 *   variables: {
 *      influencerUserId: // value for 'influencerUserId'
 *   },
 * });
 */
export function useGetOpenWorkOrdersFfoQuery(baseOptions: Apollo.QueryHookOptions<GetOpenWorkOrdersFfoQuery, GetOpenWorkOrdersFfoQueryVariables> & ({ variables: GetOpenWorkOrdersFfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOpenWorkOrdersFfoQuery, GetOpenWorkOrdersFfoQueryVariables>(GetOpenWorkOrdersFfoDocument, options);
      }
export function useGetOpenWorkOrdersFfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOpenWorkOrdersFfoQuery, GetOpenWorkOrdersFfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOpenWorkOrdersFfoQuery, GetOpenWorkOrdersFfoQueryVariables>(GetOpenWorkOrdersFfoDocument, options);
        }
export function useGetOpenWorkOrdersFfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOpenWorkOrdersFfoQuery, GetOpenWorkOrdersFfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOpenWorkOrdersFfoQuery, GetOpenWorkOrdersFfoQueryVariables>(GetOpenWorkOrdersFfoDocument, options);
        }
export type GetOpenWorkOrdersFfoQueryHookResult = ReturnType<typeof useGetOpenWorkOrdersFfoQuery>;
export type GetOpenWorkOrdersFfoLazyQueryHookResult = ReturnType<typeof useGetOpenWorkOrdersFfoLazyQuery>;
export type GetOpenWorkOrdersFfoSuspenseQueryHookResult = ReturnType<typeof useGetOpenWorkOrdersFfoSuspenseQuery>;
export type GetOpenWorkOrdersFfoQueryResult = Apollo.QueryResult<GetOpenWorkOrdersFfoQuery, GetOpenWorkOrdersFfoQueryVariables>;
export const FfoBankKycDocument = gql`
    mutation ffoBankKYC($userId: String!, $panKycStatus: Boolean, $aadharKycStatus: Boolean, $bankKycStatus: Boolean) {
  onRequestKYC(
    userId: $userId
    pan: $panKycStatus
    aadhar: $aadharKycStatus
    bank: $bankKycStatus
  ) {
    id
    output
    input
    panKycStatus
    aadharKycStatus
    bankKycStatus
  }
}
    `;
export type FfoBankKycMutationFn = Apollo.MutationFunction<FfoBankKycMutation, FfoBankKycMutationVariables>;

/**
 * __useFfoBankKycMutation__
 *
 * To run a mutation, you first call `useFfoBankKycMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFfoBankKycMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ffoBankKycMutation, { data, loading, error }] = useFfoBankKycMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      panKycStatus: // value for 'panKycStatus'
 *      aadharKycStatus: // value for 'aadharKycStatus'
 *      bankKycStatus: // value for 'bankKycStatus'
 *   },
 * });
 */
export function useFfoBankKycMutation(baseOptions?: Apollo.MutationHookOptions<FfoBankKycMutation, FfoBankKycMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FfoBankKycMutation, FfoBankKycMutationVariables>(FfoBankKycDocument, options);
      }
export type FfoBankKycMutationHookResult = ReturnType<typeof useFfoBankKycMutation>;
export type FfoBankKycMutationResult = Apollo.MutationResult<FfoBankKycMutation>;
export type FfoBankKycMutationOptions = Apollo.BaseMutationOptions<FfoBankKycMutation, FfoBankKycMutationVariables>;
export const GetKycTransactionDocument = gql`
    query getKycTransaction($userId: String!) {
  kYCStatus(userId: $userId) {
    id
    output
    bankKycName
    bankKycStatus
  }
}
    `;

/**
 * __useGetKycTransactionQuery__
 *
 * To run a query within a React component, call `useGetKycTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKycTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKycTransactionQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetKycTransactionQuery(baseOptions: Apollo.QueryHookOptions<GetKycTransactionQuery, GetKycTransactionQueryVariables> & ({ variables: GetKycTransactionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKycTransactionQuery, GetKycTransactionQueryVariables>(GetKycTransactionDocument, options);
      }
export function useGetKycTransactionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKycTransactionQuery, GetKycTransactionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKycTransactionQuery, GetKycTransactionQueryVariables>(GetKycTransactionDocument, options);
        }
export function useGetKycTransactionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKycTransactionQuery, GetKycTransactionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetKycTransactionQuery, GetKycTransactionQueryVariables>(GetKycTransactionDocument, options);
        }
export type GetKycTransactionQueryHookResult = ReturnType<typeof useGetKycTransactionQuery>;
export type GetKycTransactionLazyQueryHookResult = ReturnType<typeof useGetKycTransactionLazyQuery>;
export type GetKycTransactionSuspenseQueryHookResult = ReturnType<typeof useGetKycTransactionSuspenseQuery>;
export type GetKycTransactionQueryResult = Apollo.QueryResult<GetKycTransactionQuery, GetKycTransactionQueryVariables>;
export const RegisterFfoDocument = gql`
    mutation registerFFO($costOfGroupMeeting: Float, $costOfMonthlyPartTime: Float, $costOfProductDemo: Float, $costOfSalesCommission: Float, $costOfProductDemoForSeedProducts: Float, $costOfProductDemoForChemicalProducts: Float, $description: String, $districts: [String], $email: String, $experience_since: Int!, $expertises: [String], $languages: [String], $segments: [String], $states: [String], $townName: String, $villageName: String, $travel_range: Int!, $userId: String!, $userName: String, $userPhone: String) {
  registerFreelanceFieldOfficer(
    request: {costOfGroupMeeting: $costOfGroupMeeting, costOfMonthlyPartTime: $costOfMonthlyPartTime, costOfProductDemo: $costOfProductDemo, costOfSalesCommission: $costOfSalesCommission, costOfProductDemoForSeedProducts: $costOfProductDemoForSeedProducts, costOfProductDemoForChemicalProducts: $costOfProductDemoForChemicalProducts, description: $description, districts: $districts, email: $email, experience_since: $experience_since, expertises: $expertises, languages: $languages, segments: $segments, states: $states, townName: $townName, villageName: $villageName, travel_range: $travel_range, userId: $userId, userName: $userName, userPhone: $userPhone}
  ) {
    data {
      status
    }
    error
  }
}
    `;
export type RegisterFfoMutationFn = Apollo.MutationFunction<RegisterFfoMutation, RegisterFfoMutationVariables>;

/**
 * __useRegisterFfoMutation__
 *
 * To run a mutation, you first call `useRegisterFfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterFfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerFfoMutation, { data, loading, error }] = useRegisterFfoMutation({
 *   variables: {
 *      costOfGroupMeeting: // value for 'costOfGroupMeeting'
 *      costOfMonthlyPartTime: // value for 'costOfMonthlyPartTime'
 *      costOfProductDemo: // value for 'costOfProductDemo'
 *      costOfSalesCommission: // value for 'costOfSalesCommission'
 *      costOfProductDemoForSeedProducts: // value for 'costOfProductDemoForSeedProducts'
 *      costOfProductDemoForChemicalProducts: // value for 'costOfProductDemoForChemicalProducts'
 *      description: // value for 'description'
 *      districts: // value for 'districts'
 *      email: // value for 'email'
 *      experience_since: // value for 'experience_since'
 *      expertises: // value for 'expertises'
 *      languages: // value for 'languages'
 *      segments: // value for 'segments'
 *      states: // value for 'states'
 *      townName: // value for 'townName'
 *      villageName: // value for 'villageName'
 *      travel_range: // value for 'travel_range'
 *      userId: // value for 'userId'
 *      userName: // value for 'userName'
 *      userPhone: // value for 'userPhone'
 *   },
 * });
 */
export function useRegisterFfoMutation(baseOptions?: Apollo.MutationHookOptions<RegisterFfoMutation, RegisterFfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterFfoMutation, RegisterFfoMutationVariables>(RegisterFfoDocument, options);
      }
export type RegisterFfoMutationHookResult = ReturnType<typeof useRegisterFfoMutation>;
export type RegisterFfoMutationResult = Apollo.MutationResult<RegisterFfoMutation>;
export type RegisterFfoMutationOptions = Apollo.BaseMutationOptions<RegisterFfoMutation, RegisterFfoMutationVariables>;
export const FfoRegsiteredOrNotDocument = gql`
    query ffoRegsiteredOrNot($influencerUserId: bpchar!) {
  gigs(where: {user_id: {_eq: $influencerUserId}}) {
    id
    title
    created_at
    approval_status
    variants {
      id
      cost
      variant_type
      duration_days
    }
  }
}
    `;

/**
 * __useFfoRegsiteredOrNotQuery__
 *
 * To run a query within a React component, call `useFfoRegsiteredOrNotQuery` and pass it any options that fit your needs.
 * When your component renders, `useFfoRegsiteredOrNotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFfoRegsiteredOrNotQuery({
 *   variables: {
 *      influencerUserId: // value for 'influencerUserId'
 *   },
 * });
 */
export function useFfoRegsiteredOrNotQuery(baseOptions: Apollo.QueryHookOptions<FfoRegsiteredOrNotQuery, FfoRegsiteredOrNotQueryVariables> & ({ variables: FfoRegsiteredOrNotQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FfoRegsiteredOrNotQuery, FfoRegsiteredOrNotQueryVariables>(FfoRegsiteredOrNotDocument, options);
      }
export function useFfoRegsiteredOrNotLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FfoRegsiteredOrNotQuery, FfoRegsiteredOrNotQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FfoRegsiteredOrNotQuery, FfoRegsiteredOrNotQueryVariables>(FfoRegsiteredOrNotDocument, options);
        }
export function useFfoRegsiteredOrNotSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FfoRegsiteredOrNotQuery, FfoRegsiteredOrNotQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FfoRegsiteredOrNotQuery, FfoRegsiteredOrNotQueryVariables>(FfoRegsiteredOrNotDocument, options);
        }
export type FfoRegsiteredOrNotQueryHookResult = ReturnType<typeof useFfoRegsiteredOrNotQuery>;
export type FfoRegsiteredOrNotLazyQueryHookResult = ReturnType<typeof useFfoRegsiteredOrNotLazyQuery>;
export type FfoRegsiteredOrNotSuspenseQueryHookResult = ReturnType<typeof useFfoRegsiteredOrNotSuspenseQuery>;
export type FfoRegsiteredOrNotQueryResult = Apollo.QueryResult<FfoRegsiteredOrNotQuery, FfoRegsiteredOrNotQueryVariables>;
export const InfluencerRejectsWorkOrderDocument = gql`
    mutation influencerRejectsWorkOrder($woId: String!, $worId: String!) {
  influencerRejectsWorkOrder(woId: $woId, worId: $worId) {
    status
  }
}
    `;
export type InfluencerRejectsWorkOrderMutationFn = Apollo.MutationFunction<InfluencerRejectsWorkOrderMutation, InfluencerRejectsWorkOrderMutationVariables>;

/**
 * __useInfluencerRejectsWorkOrderMutation__
 *
 * To run a mutation, you first call `useInfluencerRejectsWorkOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInfluencerRejectsWorkOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [influencerRejectsWorkOrderMutation, { data, loading, error }] = useInfluencerRejectsWorkOrderMutation({
 *   variables: {
 *      woId: // value for 'woId'
 *      worId: // value for 'worId'
 *   },
 * });
 */
export function useInfluencerRejectsWorkOrderMutation(baseOptions?: Apollo.MutationHookOptions<InfluencerRejectsWorkOrderMutation, InfluencerRejectsWorkOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InfluencerRejectsWorkOrderMutation, InfluencerRejectsWorkOrderMutationVariables>(InfluencerRejectsWorkOrderDocument, options);
      }
export type InfluencerRejectsWorkOrderMutationHookResult = ReturnType<typeof useInfluencerRejectsWorkOrderMutation>;
export type InfluencerRejectsWorkOrderMutationResult = Apollo.MutationResult<InfluencerRejectsWorkOrderMutation>;
export type InfluencerRejectsWorkOrderMutationOptions = Apollo.BaseMutationOptions<InfluencerRejectsWorkOrderMutation, InfluencerRejectsWorkOrderMutationVariables>;
export const CompanyAcceptsOrRejectsWoRequestDocument = gql`
    mutation companyAcceptsOrRejectsWORequest($woId: String!, $woRequestId: String!, $action: AcceptRejectEnum!) {
  companyAcceptsOrRejectsWorkorderRequest(
    request: {woId: $woId, woRequestId: $woRequestId, action: $action}
  ) {
    data {
      status
    }
    error
  }
}
    `;
export type CompanyAcceptsOrRejectsWoRequestMutationFn = Apollo.MutationFunction<CompanyAcceptsOrRejectsWoRequestMutation, CompanyAcceptsOrRejectsWoRequestMutationVariables>;

/**
 * __useCompanyAcceptsOrRejectsWoRequestMutation__
 *
 * To run a mutation, you first call `useCompanyAcceptsOrRejectsWoRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyAcceptsOrRejectsWoRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyAcceptsOrRejectsWoRequestMutation, { data, loading, error }] = useCompanyAcceptsOrRejectsWoRequestMutation({
 *   variables: {
 *      woId: // value for 'woId'
 *      woRequestId: // value for 'woRequestId'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useCompanyAcceptsOrRejectsWoRequestMutation(baseOptions?: Apollo.MutationHookOptions<CompanyAcceptsOrRejectsWoRequestMutation, CompanyAcceptsOrRejectsWoRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanyAcceptsOrRejectsWoRequestMutation, CompanyAcceptsOrRejectsWoRequestMutationVariables>(CompanyAcceptsOrRejectsWoRequestDocument, options);
      }
export type CompanyAcceptsOrRejectsWoRequestMutationHookResult = ReturnType<typeof useCompanyAcceptsOrRejectsWoRequestMutation>;
export type CompanyAcceptsOrRejectsWoRequestMutationResult = Apollo.MutationResult<CompanyAcceptsOrRejectsWoRequestMutation>;
export type CompanyAcceptsOrRejectsWoRequestMutationOptions = Apollo.BaseMutationOptions<CompanyAcceptsOrRejectsWoRequestMutation, CompanyAcceptsOrRejectsWoRequestMutationVariables>;
export const MyGigsDetailsFfoEditProfileDocument = gql`
    query myGigsDetailsFfoEditProfile($influencerUserId: bpchar!, $gigType: String!) {
  gigs(where: {gig_type: {_eq: $gigType}, user_id: {_eq: $influencerUserId}}) {
    id
    title
    created_at
    approval_status
    gig_type
    districts
    experience_since
    expertises
    segments
    metrics
    travel_range
    avg_rating
    is_verified
    description
    rating
    languages
    states
    location
    avg_work_order_duration_days
    completed_work_orders
    review_count
    town_name
    village_name
    user {
      id
      name
      profile_image_url
      phone_number
      email
    }
    district {
      id
      state
      district
    }
    variants {
      id
      cost
      qty
      duration_days
      variant_type
      cost_seed_products
      cost_chemical_products
    }
  }
}
    `;

/**
 * __useMyGigsDetailsFfoEditProfileQuery__
 *
 * To run a query within a React component, call `useMyGigsDetailsFfoEditProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyGigsDetailsFfoEditProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyGigsDetailsFfoEditProfileQuery({
 *   variables: {
 *      influencerUserId: // value for 'influencerUserId'
 *      gigType: // value for 'gigType'
 *   },
 * });
 */
export function useMyGigsDetailsFfoEditProfileQuery(baseOptions: Apollo.QueryHookOptions<MyGigsDetailsFfoEditProfileQuery, MyGigsDetailsFfoEditProfileQueryVariables> & ({ variables: MyGigsDetailsFfoEditProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyGigsDetailsFfoEditProfileQuery, MyGigsDetailsFfoEditProfileQueryVariables>(MyGigsDetailsFfoEditProfileDocument, options);
      }
export function useMyGigsDetailsFfoEditProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyGigsDetailsFfoEditProfileQuery, MyGigsDetailsFfoEditProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyGigsDetailsFfoEditProfileQuery, MyGigsDetailsFfoEditProfileQueryVariables>(MyGigsDetailsFfoEditProfileDocument, options);
        }
export function useMyGigsDetailsFfoEditProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyGigsDetailsFfoEditProfileQuery, MyGigsDetailsFfoEditProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyGigsDetailsFfoEditProfileQuery, MyGigsDetailsFfoEditProfileQueryVariables>(MyGigsDetailsFfoEditProfileDocument, options);
        }
export type MyGigsDetailsFfoEditProfileQueryHookResult = ReturnType<typeof useMyGigsDetailsFfoEditProfileQuery>;
export type MyGigsDetailsFfoEditProfileLazyQueryHookResult = ReturnType<typeof useMyGigsDetailsFfoEditProfileLazyQuery>;
export type MyGigsDetailsFfoEditProfileSuspenseQueryHookResult = ReturnType<typeof useMyGigsDetailsFfoEditProfileSuspenseQuery>;
export type MyGigsDetailsFfoEditProfileQueryResult = Apollo.QueryResult<MyGigsDetailsFfoEditProfileQuery, MyGigsDetailsFfoEditProfileQueryVariables>;
export const EditInfluencerGigProfileFfoDocument = gql`
    mutation editInfluencerGigProfileFfo($costOfGroupMeeting: Float, $costOfMonthlyPartTime: Float, $costOfSalesCommission: Float, $costOfProductDemoForChemicalProducts: Float, $costOfProductDemoForSeedProducts: Float, $description: String, $districts: [String], $email: String, $experience_since: Int!, $expertises: [String], $languages: [String], $segments: [String], $states: [String], $travel_range: Int!, $userId: String!, $userName: String, $userPhone: String, $profileImageUrl: String, $villageName: String, $townName: String) {
  registerFreelanceFieldOfficer(
    request: {costOfGroupMeeting: $costOfGroupMeeting, costOfMonthlyPartTime: $costOfMonthlyPartTime, costOfSalesCommission: $costOfSalesCommission, costOfProductDemoForChemicalProducts: $costOfProductDemoForChemicalProducts, costOfProductDemoForSeedProducts: $costOfProductDemoForSeedProducts, description: $description, districts: $districts, email: $email, experience_since: $experience_since, expertises: $expertises, languages: $languages, segments: $segments, states: $states, travel_range: $travel_range, userId: $userId, userName: $userName, userPhone: $userPhone, profileImageUrl: $profileImageUrl, villageName: $villageName, townName: $townName}
  ) {
    data {
      status
    }
    error
  }
}
    `;
export type EditInfluencerGigProfileFfoMutationFn = Apollo.MutationFunction<EditInfluencerGigProfileFfoMutation, EditInfluencerGigProfileFfoMutationVariables>;

/**
 * __useEditInfluencerGigProfileFfoMutation__
 *
 * To run a mutation, you first call `useEditInfluencerGigProfileFfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditInfluencerGigProfileFfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editInfluencerGigProfileFfoMutation, { data, loading, error }] = useEditInfluencerGigProfileFfoMutation({
 *   variables: {
 *      costOfGroupMeeting: // value for 'costOfGroupMeeting'
 *      costOfMonthlyPartTime: // value for 'costOfMonthlyPartTime'
 *      costOfSalesCommission: // value for 'costOfSalesCommission'
 *      costOfProductDemoForChemicalProducts: // value for 'costOfProductDemoForChemicalProducts'
 *      costOfProductDemoForSeedProducts: // value for 'costOfProductDemoForSeedProducts'
 *      description: // value for 'description'
 *      districts: // value for 'districts'
 *      email: // value for 'email'
 *      experience_since: // value for 'experience_since'
 *      expertises: // value for 'expertises'
 *      languages: // value for 'languages'
 *      segments: // value for 'segments'
 *      states: // value for 'states'
 *      travel_range: // value for 'travel_range'
 *      userId: // value for 'userId'
 *      userName: // value for 'userName'
 *      userPhone: // value for 'userPhone'
 *      profileImageUrl: // value for 'profileImageUrl'
 *      villageName: // value for 'villageName'
 *      townName: // value for 'townName'
 *   },
 * });
 */
export function useEditInfluencerGigProfileFfoMutation(baseOptions?: Apollo.MutationHookOptions<EditInfluencerGigProfileFfoMutation, EditInfluencerGigProfileFfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditInfluencerGigProfileFfoMutation, EditInfluencerGigProfileFfoMutationVariables>(EditInfluencerGigProfileFfoDocument, options);
      }
export type EditInfluencerGigProfileFfoMutationHookResult = ReturnType<typeof useEditInfluencerGigProfileFfoMutation>;
export type EditInfluencerGigProfileFfoMutationResult = Apollo.MutationResult<EditInfluencerGigProfileFfoMutation>;
export type EditInfluencerGigProfileFfoMutationOptions = Apollo.BaseMutationOptions<EditInfluencerGigProfileFfoMutation, EditInfluencerGigProfileFfoMutationVariables>;
export const AllStateDocument = gql`
    query allState {
  gis_districts(order_by: {state: asc}) {
    id
    state
    state_code
    district
    district_code
  }
}
    `;

/**
 * __useAllStateQuery__
 *
 * To run a query within a React component, call `useAllStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllStateQuery(baseOptions?: Apollo.QueryHookOptions<AllStateQuery, AllStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllStateQuery, AllStateQueryVariables>(AllStateDocument, options);
      }
export function useAllStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllStateQuery, AllStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllStateQuery, AllStateQueryVariables>(AllStateDocument, options);
        }
export function useAllStateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllStateQuery, AllStateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllStateQuery, AllStateQueryVariables>(AllStateDocument, options);
        }
export type AllStateQueryHookResult = ReturnType<typeof useAllStateQuery>;
export type AllStateLazyQueryHookResult = ReturnType<typeof useAllStateLazyQuery>;
export type AllStateSuspenseQueryHookResult = ReturnType<typeof useAllStateSuspenseQuery>;
export type AllStateQueryResult = Apollo.QueryResult<AllStateQuery, AllStateQueryVariables>;
export const RequestKycDocument = gql`
    mutation requestKYC($userId: String!) {
  onRequestKYC(userId: $userId, force: true) {
    id
  }
}
    `;
export type RequestKycMutationFn = Apollo.MutationFunction<RequestKycMutation, RequestKycMutationVariables>;

/**
 * __useRequestKycMutation__
 *
 * To run a mutation, you first call `useRequestKycMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestKycMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestKycMutation, { data, loading, error }] = useRequestKycMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRequestKycMutation(baseOptions?: Apollo.MutationHookOptions<RequestKycMutation, RequestKycMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestKycMutation, RequestKycMutationVariables>(RequestKycDocument, options);
      }
export type RequestKycMutationHookResult = ReturnType<typeof useRequestKycMutation>;
export type RequestKycMutationResult = Apollo.MutationResult<RequestKycMutation>;
export type RequestKycMutationOptions = Apollo.BaseMutationOptions<RequestKycMutation, RequestKycMutationVariables>;
export const LeadsInboxDocument = gql`
    query LeadsInbox($accountId: bpchar!, $limit: Int, $offset: Int) {
  ActiveUsers: prospects(
    where: {prospects_prospect_messages: {id: {_is_null: false}}, account_id: {_eq: $accountId}, status: {_in: ["active"]}, deleted_at: {_is_null: true}}
    offset: $offset
    limit: $limit
  ) {
    id
    status
    source_interaction_type
    user: prospects_farmer_user {
      id
      name
      phone_number
      profile_image_url
      locale
      last_known_locations {
        id
        address
      }
    }
    prospects_crop {
      id
      name
      image_url
    }
    messages: prospects_prospect_messages(order_by: {id: desc}, limit: 1) {
      id
      message
      created_at
    }
  }
}
    `;

/**
 * __useLeadsInboxQuery__
 *
 * To run a query within a React component, call `useLeadsInboxQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadsInboxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadsInboxQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useLeadsInboxQuery(baseOptions: Apollo.QueryHookOptions<LeadsInboxQuery, LeadsInboxQueryVariables> & ({ variables: LeadsInboxQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeadsInboxQuery, LeadsInboxQueryVariables>(LeadsInboxDocument, options);
      }
export function useLeadsInboxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeadsInboxQuery, LeadsInboxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeadsInboxQuery, LeadsInboxQueryVariables>(LeadsInboxDocument, options);
        }
export function useLeadsInboxSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LeadsInboxQuery, LeadsInboxQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LeadsInboxQuery, LeadsInboxQueryVariables>(LeadsInboxDocument, options);
        }
export type LeadsInboxQueryHookResult = ReturnType<typeof useLeadsInboxQuery>;
export type LeadsInboxLazyQueryHookResult = ReturnType<typeof useLeadsInboxLazyQuery>;
export type LeadsInboxSuspenseQueryHookResult = ReturnType<typeof useLeadsInboxSuspenseQuery>;
export type LeadsInboxQueryResult = Apollo.QueryResult<LeadsInboxQuery, LeadsInboxQueryVariables>;
export const DcmContactsDocument = gql`
    query dcmContacts($accountId: bpchar, $limit: Int, $offset: Int) {
  contacts: fich_farminsta_replica_leads(
    where: {account_id: {_eq: $accountId}, status: {_eq: "active"}}
    offset: $offset
    limit: $limit
    order_by: {created_at: desc}
  ) {
    id
    farmer_name
    farmer_phone
    farmer_user_id
    farmer_profile_image_url
    owner_name
    owner_phone
    owner_user_id
    owner_profile_image_url
    state
    district
    taluk
    created_at
    address
    status
    lat
    lng
    source_interaction_ts
    source_interaction_type
    source_name
    source_reel_id
    source_reel_interaction_id
    source_service_request_id
    crop_names
  }
}
    `;

/**
 * __useDcmContactsQuery__
 *
 * To run a query within a React component, call `useDcmContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDcmContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDcmContactsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useDcmContactsQuery(baseOptions?: Apollo.QueryHookOptions<DcmContactsQuery, DcmContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DcmContactsQuery, DcmContactsQueryVariables>(DcmContactsDocument, options);
      }
export function useDcmContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DcmContactsQuery, DcmContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DcmContactsQuery, DcmContactsQueryVariables>(DcmContactsDocument, options);
        }
export function useDcmContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DcmContactsQuery, DcmContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DcmContactsQuery, DcmContactsQueryVariables>(DcmContactsDocument, options);
        }
export type DcmContactsQueryHookResult = ReturnType<typeof useDcmContactsQuery>;
export type DcmContactsLazyQueryHookResult = ReturnType<typeof useDcmContactsLazyQuery>;
export type DcmContactsSuspenseQueryHookResult = ReturnType<typeof useDcmContactsSuspenseQuery>;
export type DcmContactsQueryResult = Apollo.QueryResult<DcmContactsQuery, DcmContactsQueryVariables>;
export const ServiceRequestInboxDocument = gql`
    query serviceRequestInbox($accountId: bpchar!, $limit: Int, $offset: Int) {
  service_requests(
    where: {deleted_at: {_is_null: true}, _or: [{field_partner_responses: {account_id: {_eq: $accountId}, response_action: {_eq: "accept"}}}]}
    order_by: {id: desc}
    limit: $limit
    offset: $offset
  ) {
    id
    created_at
    is_request_closed
    address
    farmer: user {
      id
      name
      phone_number
      profile_image_url
      crop_users {
        id
        master_crop {
          id
          name
        }
      }
    }
    crop: master_crop {
      id
      name
      image_url
    }
    assets
    date_of_sowing
    lat
    lng
    address
    field_partner_responses(where: {account_id: {_eq: $accountId}}) {
      id
      field_partner_user_id
      response_action
      created_at
      field_partner_rating
      field_partner_rated_at
    }
  }
}
    `;

/**
 * __useServiceRequestInboxQuery__
 *
 * To run a query within a React component, call `useServiceRequestInboxQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceRequestInboxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceRequestInboxQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useServiceRequestInboxQuery(baseOptions: Apollo.QueryHookOptions<ServiceRequestInboxQuery, ServiceRequestInboxQueryVariables> & ({ variables: ServiceRequestInboxQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceRequestInboxQuery, ServiceRequestInboxQueryVariables>(ServiceRequestInboxDocument, options);
      }
export function useServiceRequestInboxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceRequestInboxQuery, ServiceRequestInboxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceRequestInboxQuery, ServiceRequestInboxQueryVariables>(ServiceRequestInboxDocument, options);
        }
export function useServiceRequestInboxSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ServiceRequestInboxQuery, ServiceRequestInboxQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ServiceRequestInboxQuery, ServiceRequestInboxQueryVariables>(ServiceRequestInboxDocument, options);
        }
export type ServiceRequestInboxQueryHookResult = ReturnType<typeof useServiceRequestInboxQuery>;
export type ServiceRequestInboxLazyQueryHookResult = ReturnType<typeof useServiceRequestInboxLazyQuery>;
export type ServiceRequestInboxSuspenseQueryHookResult = ReturnType<typeof useServiceRequestInboxSuspenseQuery>;
export type ServiceRequestInboxQueryResult = Apollo.QueryResult<ServiceRequestInboxQuery, ServiceRequestInboxQueryVariables>;
export const GetServiceRequestByIdDocument = gql`
    query GetServiceRequestById($accountId: bpchar!, $id: bpchar!) {
  service_requests(
    where: {id: {_eq: $id}, deleted_at: {_is_null: true}, field_partner_responses: {account_id: {_eq: $accountId}}}
  ) {
    id
    created_at
    deleted_at
    is_request_closed
    address
    farmer: user {
      id
      name
      phone_number
      profile_image_url
      crop_users {
        id
        master_crop {
          id
          name
        }
      }
    }
    crop: master_crop {
      id
      name
      image_url
    }
    assets
    date_of_sowing
    lat
    lng
    field_partner_responses(where: {account_id: {_eq: $accountId}}) {
      id
      field_partner_user_id
      response_action
      created_at
      field_partner_rating
      field_partner_rated_at
    }
  }
}
    `;

/**
 * __useGetServiceRequestByIdQuery__
 *
 * To run a query within a React component, call `useGetServiceRequestByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceRequestByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceRequestByIdQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetServiceRequestByIdQuery(baseOptions: Apollo.QueryHookOptions<GetServiceRequestByIdQuery, GetServiceRequestByIdQueryVariables> & ({ variables: GetServiceRequestByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceRequestByIdQuery, GetServiceRequestByIdQueryVariables>(GetServiceRequestByIdDocument, options);
      }
export function useGetServiceRequestByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceRequestByIdQuery, GetServiceRequestByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceRequestByIdQuery, GetServiceRequestByIdQueryVariables>(GetServiceRequestByIdDocument, options);
        }
export function useGetServiceRequestByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceRequestByIdQuery, GetServiceRequestByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceRequestByIdQuery, GetServiceRequestByIdQueryVariables>(GetServiceRequestByIdDocument, options);
        }
export type GetServiceRequestByIdQueryHookResult = ReturnType<typeof useGetServiceRequestByIdQuery>;
export type GetServiceRequestByIdLazyQueryHookResult = ReturnType<typeof useGetServiceRequestByIdLazyQuery>;
export type GetServiceRequestByIdSuspenseQueryHookResult = ReturnType<typeof useGetServiceRequestByIdSuspenseQuery>;
export type GetServiceRequestByIdQueryResult = Apollo.QueryResult<GetServiceRequestByIdQuery, GetServiceRequestByIdQueryVariables>;
export const GetThreadByThreadableIdDocument = gql`
    query getThreadByThreadableId($threadableId: bpchar) {
  chat_threads(where: {threadable_id: {_eq: $threadableId}}) {
    id
  }
}
    `;

/**
 * __useGetThreadByThreadableIdQuery__
 *
 * To run a query within a React component, call `useGetThreadByThreadableIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThreadByThreadableIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThreadByThreadableIdQuery({
 *   variables: {
 *      threadableId: // value for 'threadableId'
 *   },
 * });
 */
export function useGetThreadByThreadableIdQuery(baseOptions?: Apollo.QueryHookOptions<GetThreadByThreadableIdQuery, GetThreadByThreadableIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetThreadByThreadableIdQuery, GetThreadByThreadableIdQueryVariables>(GetThreadByThreadableIdDocument, options);
      }
export function useGetThreadByThreadableIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetThreadByThreadableIdQuery, GetThreadByThreadableIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetThreadByThreadableIdQuery, GetThreadByThreadableIdQueryVariables>(GetThreadByThreadableIdDocument, options);
        }
export function useGetThreadByThreadableIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetThreadByThreadableIdQuery, GetThreadByThreadableIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetThreadByThreadableIdQuery, GetThreadByThreadableIdQueryVariables>(GetThreadByThreadableIdDocument, options);
        }
export type GetThreadByThreadableIdQueryHookResult = ReturnType<typeof useGetThreadByThreadableIdQuery>;
export type GetThreadByThreadableIdLazyQueryHookResult = ReturnType<typeof useGetThreadByThreadableIdLazyQuery>;
export type GetThreadByThreadableIdSuspenseQueryHookResult = ReturnType<typeof useGetThreadByThreadableIdSuspenseQuery>;
export type GetThreadByThreadableIdQueryResult = Apollo.QueryResult<GetThreadByThreadableIdQuery, GetThreadByThreadableIdQueryVariables>;
export const GetChatThreadMessagesDocument = gql`
    query getChatThreadMessages($threadId: bpchar!) {
  chatThreadParticipants: chat_participants(
    where: {chat_thread_id: {_eq: $threadId}}
  ) {
    id
    user {
      id
      name
      profile_image_url
    }
    lastReadAt: last_read_at
    lastActiveAt: last_active_at
  }
  chatThreadMessages: chat_messages(where: {chat_thread_id: {_eq: $threadId}}) {
    id
    messageType: message_type
    content
    data
    createdAt: created_at
    sender {
      id
      name
      profile_image_url
    }
  }
}
    `;

/**
 * __useGetChatThreadMessagesQuery__
 *
 * To run a query within a React component, call `useGetChatThreadMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatThreadMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatThreadMessagesQuery({
 *   variables: {
 *      threadId: // value for 'threadId'
 *   },
 * });
 */
export function useGetChatThreadMessagesQuery(baseOptions: Apollo.QueryHookOptions<GetChatThreadMessagesQuery, GetChatThreadMessagesQueryVariables> & ({ variables: GetChatThreadMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatThreadMessagesQuery, GetChatThreadMessagesQueryVariables>(GetChatThreadMessagesDocument, options);
      }
export function useGetChatThreadMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatThreadMessagesQuery, GetChatThreadMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatThreadMessagesQuery, GetChatThreadMessagesQueryVariables>(GetChatThreadMessagesDocument, options);
        }
export function useGetChatThreadMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChatThreadMessagesQuery, GetChatThreadMessagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChatThreadMessagesQuery, GetChatThreadMessagesQueryVariables>(GetChatThreadMessagesDocument, options);
        }
export type GetChatThreadMessagesQueryHookResult = ReturnType<typeof useGetChatThreadMessagesQuery>;
export type GetChatThreadMessagesLazyQueryHookResult = ReturnType<typeof useGetChatThreadMessagesLazyQuery>;
export type GetChatThreadMessagesSuspenseQueryHookResult = ReturnType<typeof useGetChatThreadMessagesSuspenseQuery>;
export type GetChatThreadMessagesQueryResult = Apollo.QueryResult<GetChatThreadMessagesQuery, GetChatThreadMessagesQueryVariables>;
export const SendMessageOnThreadHereDocument = gql`
    mutation sendMessageOnThreadHere($threadId: String!, $textMessage: String!) {
  sendChatTextMessage(threadId: $threadId, content: $textMessage, messageId: "") {
    id
    messageType
    content
    createdAt
    sender {
      id
      name
      profile_image_url
    }
    thread {
      id
    }
  }
}
    `;
export type SendMessageOnThreadHereMutationFn = Apollo.MutationFunction<SendMessageOnThreadHereMutation, SendMessageOnThreadHereMutationVariables>;

/**
 * __useSendMessageOnThreadHereMutation__
 *
 * To run a mutation, you first call `useSendMessageOnThreadHereMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageOnThreadHereMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageOnThreadHereMutation, { data, loading, error }] = useSendMessageOnThreadHereMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *      textMessage: // value for 'textMessage'
 *   },
 * });
 */
export function useSendMessageOnThreadHereMutation(baseOptions?: Apollo.MutationHookOptions<SendMessageOnThreadHereMutation, SendMessageOnThreadHereMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMessageOnThreadHereMutation, SendMessageOnThreadHereMutationVariables>(SendMessageOnThreadHereDocument, options);
      }
export type SendMessageOnThreadHereMutationHookResult = ReturnType<typeof useSendMessageOnThreadHereMutation>;
export type SendMessageOnThreadHereMutationResult = Apollo.MutationResult<SendMessageOnThreadHereMutation>;
export type SendMessageOnThreadHereMutationOptions = Apollo.BaseMutationOptions<SendMessageOnThreadHereMutation, SendMessageOnThreadHereMutationVariables>;
export const GetMyChatThreadsDocument = gql`
    query getMyChatThreads {
  userChatThreads {
    id
    threadableType
    lastMessage {
      id
      content
      createdAt
    }
    archived
    unreadCount
    participants {
      id
      user {
        id
        name
        profile_image_url
      }
      muted
      lastReadAt
    }
  }
}
    `;

/**
 * __useGetMyChatThreadsQuery__
 *
 * To run a query within a React component, call `useGetMyChatThreadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyChatThreadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyChatThreadsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyChatThreadsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyChatThreadsQuery, GetMyChatThreadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyChatThreadsQuery, GetMyChatThreadsQueryVariables>(GetMyChatThreadsDocument, options);
      }
export function useGetMyChatThreadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyChatThreadsQuery, GetMyChatThreadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyChatThreadsQuery, GetMyChatThreadsQueryVariables>(GetMyChatThreadsDocument, options);
        }
export function useGetMyChatThreadsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyChatThreadsQuery, GetMyChatThreadsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyChatThreadsQuery, GetMyChatThreadsQueryVariables>(GetMyChatThreadsDocument, options);
        }
export type GetMyChatThreadsQueryHookResult = ReturnType<typeof useGetMyChatThreadsQuery>;
export type GetMyChatThreadsLazyQueryHookResult = ReturnType<typeof useGetMyChatThreadsLazyQuery>;
export type GetMyChatThreadsSuspenseQueryHookResult = ReturnType<typeof useGetMyChatThreadsSuspenseQuery>;
export type GetMyChatThreadsQueryResult = Apollo.QueryResult<GetMyChatThreadsQuery, GetMyChatThreadsQueryVariables>;
export const ChatThreadsByIdsDocument = gql`
    query chatThreadsByIds($threadIds: [String!]!) {
  threadsByIds(threadIds: $threadIds) {
    id
    lastMessage {
      id
      content
      createdAt
    }
    archived
    threadableType
    unreadCount
    participants {
      id
      user {
        id
        name
        profile_image_url
      }
      muted
      lastReadAt
    }
  }
}
    `;

/**
 * __useChatThreadsByIdsQuery__
 *
 * To run a query within a React component, call `useChatThreadsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatThreadsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatThreadsByIdsQuery({
 *   variables: {
 *      threadIds: // value for 'threadIds'
 *   },
 * });
 */
export function useChatThreadsByIdsQuery(baseOptions: Apollo.QueryHookOptions<ChatThreadsByIdsQuery, ChatThreadsByIdsQueryVariables> & ({ variables: ChatThreadsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatThreadsByIdsQuery, ChatThreadsByIdsQueryVariables>(ChatThreadsByIdsDocument, options);
      }
export function useChatThreadsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatThreadsByIdsQuery, ChatThreadsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatThreadsByIdsQuery, ChatThreadsByIdsQueryVariables>(ChatThreadsByIdsDocument, options);
        }
export function useChatThreadsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChatThreadsByIdsQuery, ChatThreadsByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChatThreadsByIdsQuery, ChatThreadsByIdsQueryVariables>(ChatThreadsByIdsDocument, options);
        }
export type ChatThreadsByIdsQueryHookResult = ReturnType<typeof useChatThreadsByIdsQuery>;
export type ChatThreadsByIdsLazyQueryHookResult = ReturnType<typeof useChatThreadsByIdsLazyQuery>;
export type ChatThreadsByIdsSuspenseQueryHookResult = ReturnType<typeof useChatThreadsByIdsSuspenseQuery>;
export type ChatThreadsByIdsQueryResult = Apollo.QueryResult<ChatThreadsByIdsQuery, ChatThreadsByIdsQueryVariables>;
export const CompanyWorkorderFeedbackDocument = gql`
    mutation companyWorkorderFeedback($userId: String!, $workorderId: String!, $review: String, $rating: Float, $rating1: Float, $rating2: Float, $farminstaRating: Float, $farminstaRating1: Float, $farminstaRating2: Float, $farminstaReview: String) {
  companyWorkorderFeedback(
    request: {userId: $userId, workorderId: $workorderId, review: $review, rating: $rating, rating1: $rating1, rating2: $rating2, farminstaRating: $farminstaRating, farminstaRating1: $farminstaRating1, farminstaRating2: $farminstaRating2, farminstaReview: $farminstaReview}
  ) {
    data {
      status
    }
    error
  }
}
    `;
export type CompanyWorkorderFeedbackMutationFn = Apollo.MutationFunction<CompanyWorkorderFeedbackMutation, CompanyWorkorderFeedbackMutationVariables>;

/**
 * __useCompanyWorkorderFeedbackMutation__
 *
 * To run a mutation, you first call `useCompanyWorkorderFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyWorkorderFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyWorkorderFeedbackMutation, { data, loading, error }] = useCompanyWorkorderFeedbackMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      workorderId: // value for 'workorderId'
 *      review: // value for 'review'
 *      rating: // value for 'rating'
 *      rating1: // value for 'rating1'
 *      rating2: // value for 'rating2'
 *      farminstaRating: // value for 'farminstaRating'
 *      farminstaRating1: // value for 'farminstaRating1'
 *      farminstaRating2: // value for 'farminstaRating2'
 *      farminstaReview: // value for 'farminstaReview'
 *   },
 * });
 */
export function useCompanyWorkorderFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<CompanyWorkorderFeedbackMutation, CompanyWorkorderFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanyWorkorderFeedbackMutation, CompanyWorkorderFeedbackMutationVariables>(CompanyWorkorderFeedbackDocument, options);
      }
export type CompanyWorkorderFeedbackMutationHookResult = ReturnType<typeof useCompanyWorkorderFeedbackMutation>;
export type CompanyWorkorderFeedbackMutationResult = Apollo.MutationResult<CompanyWorkorderFeedbackMutation>;
export type CompanyWorkorderFeedbackMutationOptions = Apollo.BaseMutationOptions<CompanyWorkorderFeedbackMutation, CompanyWorkorderFeedbackMutationVariables>;
export const GetChatThreadDocument = gql`
    query getChatThread($threadId: bpchar!) {
  thread: chat_threads_by_pk(id: $threadId) {
    id
    threadable_type
    threadable_id
  }
}
    `;

/**
 * __useGetChatThreadQuery__
 *
 * To run a query within a React component, call `useGetChatThreadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatThreadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatThreadQuery({
 *   variables: {
 *      threadId: // value for 'threadId'
 *   },
 * });
 */
export function useGetChatThreadQuery(baseOptions: Apollo.QueryHookOptions<GetChatThreadQuery, GetChatThreadQueryVariables> & ({ variables: GetChatThreadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatThreadQuery, GetChatThreadQueryVariables>(GetChatThreadDocument, options);
      }
export function useGetChatThreadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatThreadQuery, GetChatThreadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatThreadQuery, GetChatThreadQueryVariables>(GetChatThreadDocument, options);
        }
export function useGetChatThreadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChatThreadQuery, GetChatThreadQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChatThreadQuery, GetChatThreadQueryVariables>(GetChatThreadDocument, options);
        }
export type GetChatThreadQueryHookResult = ReturnType<typeof useGetChatThreadQuery>;
export type GetChatThreadLazyQueryHookResult = ReturnType<typeof useGetChatThreadLazyQuery>;
export type GetChatThreadSuspenseQueryHookResult = ReturnType<typeof useGetChatThreadSuspenseQuery>;
export type GetChatThreadQueryResult = Apollo.QueryResult<GetChatThreadQuery, GetChatThreadQueryVariables>;
export const WorkOrderRequestDocument = gql`
    query workOrderRequest($requestId: bpchar!) {
  wor: work_order_requests_by_pk(id: $requestId) {
    id
    work_order_id
    status
  }
}
    `;

/**
 * __useWorkOrderRequestQuery__
 *
 * To run a query within a React component, call `useWorkOrderRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkOrderRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkOrderRequestQuery({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useWorkOrderRequestQuery(baseOptions: Apollo.QueryHookOptions<WorkOrderRequestQuery, WorkOrderRequestQueryVariables> & ({ variables: WorkOrderRequestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkOrderRequestQuery, WorkOrderRequestQueryVariables>(WorkOrderRequestDocument, options);
      }
export function useWorkOrderRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkOrderRequestQuery, WorkOrderRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkOrderRequestQuery, WorkOrderRequestQueryVariables>(WorkOrderRequestDocument, options);
        }
export function useWorkOrderRequestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkOrderRequestQuery, WorkOrderRequestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkOrderRequestQuery, WorkOrderRequestQueryVariables>(WorkOrderRequestDocument, options);
        }
export type WorkOrderRequestQueryHookResult = ReturnType<typeof useWorkOrderRequestQuery>;
export type WorkOrderRequestLazyQueryHookResult = ReturnType<typeof useWorkOrderRequestLazyQuery>;
export type WorkOrderRequestSuspenseQueryHookResult = ReturnType<typeof useWorkOrderRequestSuspenseQuery>;
export type WorkOrderRequestQueryResult = Apollo.QueryResult<WorkOrderRequestQuery, WorkOrderRequestQueryVariables>;
export const InfluencerWorkorderFeedbackDocument = gql`
    mutation influencerWorkorderFeedback($userId: String!, $workorderId: String!, $review: String, $rating: Float, $rating1: Float, $rating2: Float, $farminstaRating: Float, $farminstaRating1: Float, $farminstaRating2: Float, $farminstaReview: String) {
  influencerWorkorderFeedback(
    request: {userId: $userId, workorderId: $workorderId, review: $review, rating: $rating, rating1: $rating1, rating2: $rating2, farminstaRating: $farminstaRating, farminstaRating1: $farminstaRating1, farminstaRating2: $farminstaRating2, farminstaReview: $farminstaReview}
  ) {
    data {
      status
    }
    error
  }
}
    `;
export type InfluencerWorkorderFeedbackMutationFn = Apollo.MutationFunction<InfluencerWorkorderFeedbackMutation, InfluencerWorkorderFeedbackMutationVariables>;

/**
 * __useInfluencerWorkorderFeedbackMutation__
 *
 * To run a mutation, you first call `useInfluencerWorkorderFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInfluencerWorkorderFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [influencerWorkorderFeedbackMutation, { data, loading, error }] = useInfluencerWorkorderFeedbackMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      workorderId: // value for 'workorderId'
 *      review: // value for 'review'
 *      rating: // value for 'rating'
 *      rating1: // value for 'rating1'
 *      rating2: // value for 'rating2'
 *      farminstaRating: // value for 'farminstaRating'
 *      farminstaRating1: // value for 'farminstaRating1'
 *      farminstaRating2: // value for 'farminstaRating2'
 *      farminstaReview: // value for 'farminstaReview'
 *   },
 * });
 */
export function useInfluencerWorkorderFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<InfluencerWorkorderFeedbackMutation, InfluencerWorkorderFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InfluencerWorkorderFeedbackMutation, InfluencerWorkorderFeedbackMutationVariables>(InfluencerWorkorderFeedbackDocument, options);
      }
export type InfluencerWorkorderFeedbackMutationHookResult = ReturnType<typeof useInfluencerWorkorderFeedbackMutation>;
export type InfluencerWorkorderFeedbackMutationResult = Apollo.MutationResult<InfluencerWorkorderFeedbackMutation>;
export type InfluencerWorkorderFeedbackMutationOptions = Apollo.BaseMutationOptions<InfluencerWorkorderFeedbackMutation, InfluencerWorkorderFeedbackMutationVariables>;
export const InfluencerAppliesForWoDocument = gql`
    mutation influencerAppliesForWO($woId: String!, $influencerUserId: String!, $bidPrice: Float, $durationDays: Int) {
  influencerAppliesForWorkOrder(
    request: {woId: $woId, influencerUserId: $influencerUserId, bidPrice: $bidPrice, durationDays: $durationDays}
  ) {
    data {
      status
    }
    error
  }
}
    `;
export type InfluencerAppliesForWoMutationFn = Apollo.MutationFunction<InfluencerAppliesForWoMutation, InfluencerAppliesForWoMutationVariables>;

/**
 * __useInfluencerAppliesForWoMutation__
 *
 * To run a mutation, you first call `useInfluencerAppliesForWoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInfluencerAppliesForWoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [influencerAppliesForWoMutation, { data, loading, error }] = useInfluencerAppliesForWoMutation({
 *   variables: {
 *      woId: // value for 'woId'
 *      influencerUserId: // value for 'influencerUserId'
 *      bidPrice: // value for 'bidPrice'
 *      durationDays: // value for 'durationDays'
 *   },
 * });
 */
export function useInfluencerAppliesForWoMutation(baseOptions?: Apollo.MutationHookOptions<InfluencerAppliesForWoMutation, InfluencerAppliesForWoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InfluencerAppliesForWoMutation, InfluencerAppliesForWoMutationVariables>(InfluencerAppliesForWoDocument, options);
      }
export type InfluencerAppliesForWoMutationHookResult = ReturnType<typeof useInfluencerAppliesForWoMutation>;
export type InfluencerAppliesForWoMutationResult = Apollo.MutationResult<InfluencerAppliesForWoMutation>;
export type InfluencerAppliesForWoMutationOptions = Apollo.BaseMutationOptions<InfluencerAppliesForWoMutation, InfluencerAppliesForWoMutationVariables>;
export const InfluencerWorkOrdersDocument = gql`
    query influencerWorkOrders($influencerUserId: bpchar) {
  work_orders(
    where: {deleted_at: {_is_null: true}, influencer_user_id: {_eq: $influencerUserId}}
    order_by: {id: desc}
  ) {
    id
    account_id
    company_id
    crops
    cta_id
    cta_link
    cta_type
    gig_id
    account {
      id
      name
    }
    influencer_user_id
    influencer_user {
      id
      name
      profile_image_url
    }
    created_by_user {
      id
      name
      profile_image_url
    }
    description
    farminsta_cost_inr
    gig {
      id
      channel {
        id
        logo_image_url
        name
      }
    }
    influencer_cost_inr
    gig_variant {
      id
      title
      variant_type
      cost
    }
    work_order_public_id
    work_order_stage
    total_cost_inr
    title
    states
    payment_status
    is_open_to_new_influencers
    created_at
    product_name
    languages
    expected_date
    published_at
    status
    requests {
      id
      influencer_user_id
      status
      bid_price
      delivery_days
      __typename
    }
  }
}
    `;

/**
 * __useInfluencerWorkOrdersQuery__
 *
 * To run a query within a React component, call `useInfluencerWorkOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfluencerWorkOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfluencerWorkOrdersQuery({
 *   variables: {
 *      influencerUserId: // value for 'influencerUserId'
 *   },
 * });
 */
export function useInfluencerWorkOrdersQuery(baseOptions?: Apollo.QueryHookOptions<InfluencerWorkOrdersQuery, InfluencerWorkOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfluencerWorkOrdersQuery, InfluencerWorkOrdersQueryVariables>(InfluencerWorkOrdersDocument, options);
      }
export function useInfluencerWorkOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfluencerWorkOrdersQuery, InfluencerWorkOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfluencerWorkOrdersQuery, InfluencerWorkOrdersQueryVariables>(InfluencerWorkOrdersDocument, options);
        }
export function useInfluencerWorkOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InfluencerWorkOrdersQuery, InfluencerWorkOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InfluencerWorkOrdersQuery, InfluencerWorkOrdersQueryVariables>(InfluencerWorkOrdersDocument, options);
        }
export type InfluencerWorkOrdersQueryHookResult = ReturnType<typeof useInfluencerWorkOrdersQuery>;
export type InfluencerWorkOrdersLazyQueryHookResult = ReturnType<typeof useInfluencerWorkOrdersLazyQuery>;
export type InfluencerWorkOrdersSuspenseQueryHookResult = ReturnType<typeof useInfluencerWorkOrdersSuspenseQuery>;
export type InfluencerWorkOrdersQueryResult = Apollo.QueryResult<InfluencerWorkOrdersQuery, InfluencerWorkOrdersQueryVariables>;
export const RegisterInfluencerDocument = gql`
    mutation registerInfluencer($channelName: String!, $costOfReel: Float!, $costOfVideo: Float!, $days: Int, $email: String!, $fbUrl: String!, $instaUrl: String!, $languages: [String], $otherUrl: String!, $password: String, $profileImageUrl: String, $reelDays: Int, $segments: [String], $states: [String], $userId: String!, $userName: String!, $userPhone: String!, $videoDays: Int, $ytUrl: String!, $description: String) {
  registerInfluencer(
    request: {channelName: $channelName, costOfReel: $costOfReel, costOfVideo: $costOfVideo, days: $days, email: $email, fbUrl: $fbUrl, instaUrl: $instaUrl, languages: $languages, otherUrl: $otherUrl, password: $password, profileImageUrl: $profileImageUrl, reelDays: $reelDays, segments: $segments, states: $states, userId: $userId, userName: $userName, userPhone: $userPhone, videoDays: $videoDays, ytUrl: $ytUrl, description: $description}
  ) {
    data {
      status
    }
    error
  }
}
    `;
export type RegisterInfluencerMutationFn = Apollo.MutationFunction<RegisterInfluencerMutation, RegisterInfluencerMutationVariables>;

/**
 * __useRegisterInfluencerMutation__
 *
 * To run a mutation, you first call `useRegisterInfluencerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterInfluencerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerInfluencerMutation, { data, loading, error }] = useRegisterInfluencerMutation({
 *   variables: {
 *      channelName: // value for 'channelName'
 *      costOfReel: // value for 'costOfReel'
 *      costOfVideo: // value for 'costOfVideo'
 *      days: // value for 'days'
 *      email: // value for 'email'
 *      fbUrl: // value for 'fbUrl'
 *      instaUrl: // value for 'instaUrl'
 *      languages: // value for 'languages'
 *      otherUrl: // value for 'otherUrl'
 *      password: // value for 'password'
 *      profileImageUrl: // value for 'profileImageUrl'
 *      reelDays: // value for 'reelDays'
 *      segments: // value for 'segments'
 *      states: // value for 'states'
 *      userId: // value for 'userId'
 *      userName: // value for 'userName'
 *      userPhone: // value for 'userPhone'
 *      videoDays: // value for 'videoDays'
 *      ytUrl: // value for 'ytUrl'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useRegisterInfluencerMutation(baseOptions?: Apollo.MutationHookOptions<RegisterInfluencerMutation, RegisterInfluencerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterInfluencerMutation, RegisterInfluencerMutationVariables>(RegisterInfluencerDocument, options);
      }
export type RegisterInfluencerMutationHookResult = ReturnType<typeof useRegisterInfluencerMutation>;
export type RegisterInfluencerMutationResult = Apollo.MutationResult<RegisterInfluencerMutation>;
export type RegisterInfluencerMutationOptions = Apollo.BaseMutationOptions<RegisterInfluencerMutation, RegisterInfluencerMutationVariables>;
export const GetOpenWorkOrdersDocument = gql`
    query getOpenWorkOrders($influencerUserId: bpchar!) {
  open_workorders: work_orders(
    where: {gig_type: {_eq: "dcm"}, is_open_to_new_influencers: {_eq: true}, deleted_at: {_is_null: true}, _not: {requests: {_or: [{status: {_eq: "rejected"}}, {influencer_user_id: {_eq: $influencerUserId}}]}}}
  ) {
    ...woFields
    requests {
      id
      influencer_user_id
      __typename
    }
    __typename
  }
  incoming_requests: work_orders(
    where: {requests: {status: {_neq: "rejected"}, influencer_user_id: {_eq: $influencerUserId}}, deleted_at: {_is_null: true}}
    order_by: {updated_at: desc}
  ) {
    ...woFields
    requests(where: {influencer_user_id: {_eq: $influencerUserId}}) {
      id
      gig_id
      status
      bid_price
      delivery_days
      __typename
    }
    __typename
  }
}
    ${WoFieldsFragmentDoc}`;

/**
 * __useGetOpenWorkOrdersQuery__
 *
 * To run a query within a React component, call `useGetOpenWorkOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpenWorkOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpenWorkOrdersQuery({
 *   variables: {
 *      influencerUserId: // value for 'influencerUserId'
 *   },
 * });
 */
export function useGetOpenWorkOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetOpenWorkOrdersQuery, GetOpenWorkOrdersQueryVariables> & ({ variables: GetOpenWorkOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOpenWorkOrdersQuery, GetOpenWorkOrdersQueryVariables>(GetOpenWorkOrdersDocument, options);
      }
export function useGetOpenWorkOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOpenWorkOrdersQuery, GetOpenWorkOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOpenWorkOrdersQuery, GetOpenWorkOrdersQueryVariables>(GetOpenWorkOrdersDocument, options);
        }
export function useGetOpenWorkOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOpenWorkOrdersQuery, GetOpenWorkOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOpenWorkOrdersQuery, GetOpenWorkOrdersQueryVariables>(GetOpenWorkOrdersDocument, options);
        }
export type GetOpenWorkOrdersQueryHookResult = ReturnType<typeof useGetOpenWorkOrdersQuery>;
export type GetOpenWorkOrdersLazyQueryHookResult = ReturnType<typeof useGetOpenWorkOrdersLazyQuery>;
export type GetOpenWorkOrdersSuspenseQueryHookResult = ReturnType<typeof useGetOpenWorkOrdersSuspenseQuery>;
export type GetOpenWorkOrdersQueryResult = Apollo.QueryResult<GetOpenWorkOrdersQuery, GetOpenWorkOrdersQueryVariables>;
export const MyGigsDocument = gql`
    query myGigs($influencerUserId: bpchar!) {
  gigs(where: {user_id: {_eq: $influencerUserId}}) {
    id
    title
    created_at
    approval_status
    title
    description
    created_at
    rating
    languages
    states
    location
    avg_work_order_duration_days
    completed_work_orders
    segments
    review_count
    user {
      id
      name
      profile_image_url
      phone_number
    }
    district {
      id
      state
      district
    }
    variants {
      id
      cost
      qty
      duration_days
      variant_type
    }
    channel {
      id
      name
      description
      logo_image_url
      content_languages
      channel_links {
        id
        link_url
        follower_count
        impressions_count
        engagement_rate
        link_type
      }
      channel_links_aggregate {
        aggregate {
          sum {
            follower_count
            impressions_count
          }
        }
      }
    }
  }
}
    `;

/**
 * __useMyGigsQuery__
 *
 * To run a query within a React component, call `useMyGigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyGigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyGigsQuery({
 *   variables: {
 *      influencerUserId: // value for 'influencerUserId'
 *   },
 * });
 */
export function useMyGigsQuery(baseOptions: Apollo.QueryHookOptions<MyGigsQuery, MyGigsQueryVariables> & ({ variables: MyGigsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyGigsQuery, MyGigsQueryVariables>(MyGigsDocument, options);
      }
export function useMyGigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyGigsQuery, MyGigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyGigsQuery, MyGigsQueryVariables>(MyGigsDocument, options);
        }
export function useMyGigsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyGigsQuery, MyGigsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyGigsQuery, MyGigsQueryVariables>(MyGigsDocument, options);
        }
export type MyGigsQueryHookResult = ReturnType<typeof useMyGigsQuery>;
export type MyGigsLazyQueryHookResult = ReturnType<typeof useMyGigsLazyQuery>;
export type MyGigsSuspenseQueryHookResult = ReturnType<typeof useMyGigsSuspenseQuery>;
export type MyGigsQueryResult = Apollo.QueryResult<MyGigsQuery, MyGigsQueryVariables>;
export const WoLeadsDocument = gql`
    query woLeads($filterjson: String!, $accountId: String!) {
  searchCRMItems(filtersJson: $filterjson, accountId: $accountId) {
    items {
      id
      data
    }
  }
}
    `;

/**
 * __useWoLeadsQuery__
 *
 * To run a query within a React component, call `useWoLeadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWoLeadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWoLeadsQuery({
 *   variables: {
 *      filterjson: // value for 'filterjson'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useWoLeadsQuery(baseOptions: Apollo.QueryHookOptions<WoLeadsQuery, WoLeadsQueryVariables> & ({ variables: WoLeadsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WoLeadsQuery, WoLeadsQueryVariables>(WoLeadsDocument, options);
      }
export function useWoLeadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WoLeadsQuery, WoLeadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WoLeadsQuery, WoLeadsQueryVariables>(WoLeadsDocument, options);
        }
export function useWoLeadsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WoLeadsQuery, WoLeadsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WoLeadsQuery, WoLeadsQueryVariables>(WoLeadsDocument, options);
        }
export type WoLeadsQueryHookResult = ReturnType<typeof useWoLeadsQuery>;
export type WoLeadsLazyQueryHookResult = ReturnType<typeof useWoLeadsLazyQuery>;
export type WoLeadsSuspenseQueryHookResult = ReturnType<typeof useWoLeadsSuspenseQuery>;
export type WoLeadsQueryResult = Apollo.QueryResult<WoLeadsQuery, WoLeadsQueryVariables>;
export const MyAccountDocument = gql`
    query myAccount($accountId: bpchar!) {
  accounts_by_pk(id: $accountId) {
    id
    account_type
    name
    pandoforce_input_company_id
  }
}
    `;

/**
 * __useMyAccountQuery__
 *
 * To run a query within a React component, call `useMyAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useMyAccountQuery(baseOptions: Apollo.QueryHookOptions<MyAccountQuery, MyAccountQueryVariables> & ({ variables: MyAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyAccountQuery, MyAccountQueryVariables>(MyAccountDocument, options);
      }
export function useMyAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyAccountQuery, MyAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyAccountQuery, MyAccountQueryVariables>(MyAccountDocument, options);
        }
export function useMyAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyAccountQuery, MyAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyAccountQuery, MyAccountQueryVariables>(MyAccountDocument, options);
        }
export type MyAccountQueryHookResult = ReturnType<typeof useMyAccountQuery>;
export type MyAccountLazyQueryHookResult = ReturnType<typeof useMyAccountLazyQuery>;
export type MyAccountSuspenseQueryHookResult = ReturnType<typeof useMyAccountSuspenseQuery>;
export type MyAccountQueryResult = Apollo.QueryResult<MyAccountQuery, MyAccountQueryVariables>;
export const CropProductsDocument = gql`
    query cropProducts($icCompId: bigint) {
  crops: master_crops {
    id
    name
  }
  fcm_products: pf_fcm_products(
    where: {is_deleted: {_eq: false}, comp_id: {_eq: $icCompId}}
  ) {
    id
    product_name
  }
}
    `;

/**
 * __useCropProductsQuery__
 *
 * To run a query within a React component, call `useCropProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCropProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCropProductsQuery({
 *   variables: {
 *      icCompId: // value for 'icCompId'
 *   },
 * });
 */
export function useCropProductsQuery(baseOptions?: Apollo.QueryHookOptions<CropProductsQuery, CropProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CropProductsQuery, CropProductsQueryVariables>(CropProductsDocument, options);
      }
export function useCropProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CropProductsQuery, CropProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CropProductsQuery, CropProductsQueryVariables>(CropProductsDocument, options);
        }
export function useCropProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CropProductsQuery, CropProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CropProductsQuery, CropProductsQueryVariables>(CropProductsDocument, options);
        }
export type CropProductsQueryHookResult = ReturnType<typeof useCropProductsQuery>;
export type CropProductsLazyQueryHookResult = ReturnType<typeof useCropProductsLazyQuery>;
export type CropProductsSuspenseQueryHookResult = ReturnType<typeof useCropProductsSuspenseQuery>;
export type CropProductsQueryResult = Apollo.QueryResult<CropProductsQuery, CropProductsQueryVariables>;
export const CompanyWorkOrdersDocument = gql`
    query companyWorkOrders($accountId: bpchar, $gigType: String) {
  work_orders(
    where: {deleted_at: {_is_null: true}, gig_type: {_eq: $gigType}, account_id: {_eq: $accountId}}
    order_by: {id: desc}
  ) {
    id
    account_id
    company_id
    crops
    cta_id
    cta_link
    cta_type
    gig_type
    requests {
      work_order_id
      id
      chat_thread {
        id
      }
    }
    influencer_user {
      id
      name
      profile_image_url
    }
    created_by_user {
      id
      name
      profile_image_url
    }
    description
    farminsta_cost_inr
    gig {
      id
      channel {
        id
        logo_image_url
        name
      }
      user {
        id
        name
        profile_image_url
        phone_number
        email
      }
    }
    influencer_cost_inr
    gig_variant {
      id
      title
      variant_type
      cost
    }
    work_order_public_id
    work_order_stage
    total_cost_inr
    title
    states
    payment_status
    is_open_to_new_influencers
    created_at
    product_name
    languages
    expected_date
    published_at
    status
  }
}
    `;

/**
 * __useCompanyWorkOrdersQuery__
 *
 * To run a query within a React component, call `useCompanyWorkOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyWorkOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyWorkOrdersQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      gigType: // value for 'gigType'
 *   },
 * });
 */
export function useCompanyWorkOrdersQuery(baseOptions?: Apollo.QueryHookOptions<CompanyWorkOrdersQuery, CompanyWorkOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyWorkOrdersQuery, CompanyWorkOrdersQueryVariables>(CompanyWorkOrdersDocument, options);
      }
export function useCompanyWorkOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyWorkOrdersQuery, CompanyWorkOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyWorkOrdersQuery, CompanyWorkOrdersQueryVariables>(CompanyWorkOrdersDocument, options);
        }
export function useCompanyWorkOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyWorkOrdersQuery, CompanyWorkOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyWorkOrdersQuery, CompanyWorkOrdersQueryVariables>(CompanyWorkOrdersDocument, options);
        }
export type CompanyWorkOrdersQueryHookResult = ReturnType<typeof useCompanyWorkOrdersQuery>;
export type CompanyWorkOrdersLazyQueryHookResult = ReturnType<typeof useCompanyWorkOrdersLazyQuery>;
export type CompanyWorkOrdersSuspenseQueryHookResult = ReturnType<typeof useCompanyWorkOrdersSuspenseQuery>;
export type CompanyWorkOrdersQueryResult = Apollo.QueryResult<CompanyWorkOrdersQuery, CompanyWorkOrdersQueryVariables>;
export const GetFeedbackDocument = gql`
    query getFeedback($workOrderId: bpchar!) {
  work_order_reviews(where: {work_order_id: {_eq: $workOrderId}}) {
    id
    work_order_id
    influencer_user_id
    influencer_given_rating
    influencer_given_review
    influencer_given_rating_1
    influencer_given_rating_2
    customer_user_id
    customer_given_review
    customer_given_rating
    customer_given_rating_1
    customer_given_rating_2
    created_at
    updated_at
    customer_user {
      id
      name
    }
    influencer_user {
      id
      name
    }
  }
}
    `;

/**
 * __useGetFeedbackQuery__
 *
 * To run a query within a React component, call `useGetFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedbackQuery({
 *   variables: {
 *      workOrderId: // value for 'workOrderId'
 *   },
 * });
 */
export function useGetFeedbackQuery(baseOptions: Apollo.QueryHookOptions<GetFeedbackQuery, GetFeedbackQueryVariables> & ({ variables: GetFeedbackQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeedbackQuery, GetFeedbackQueryVariables>(GetFeedbackDocument, options);
      }
export function useGetFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeedbackQuery, GetFeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeedbackQuery, GetFeedbackQueryVariables>(GetFeedbackDocument, options);
        }
export function useGetFeedbackSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFeedbackQuery, GetFeedbackQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFeedbackQuery, GetFeedbackQueryVariables>(GetFeedbackDocument, options);
        }
export type GetFeedbackQueryHookResult = ReturnType<typeof useGetFeedbackQuery>;
export type GetFeedbackLazyQueryHookResult = ReturnType<typeof useGetFeedbackLazyQuery>;
export type GetFeedbackSuspenseQueryHookResult = ReturnType<typeof useGetFeedbackSuspenseQuery>;
export type GetFeedbackQueryResult = Apollo.QueryResult<GetFeedbackQuery, GetFeedbackQueryVariables>;
export const WorkOrderDocument = gql`
    query workOrder($woId: bpchar!) {
  work_orders_by_pk(id: $woId) {
    gig_type
    account {
      id
      name
    }
    id
    work_order_public_id
    product_name
    crops
    influencer_user {
      id
      name
      profile_image_url
    }
    requests {
      work_order_id
      id
      chat_thread {
        id
      }
      gig {
        id
        title
        languages
        rating
        completed_work_orders
        states
        is_verified
        expertises
        channel_links {
          engagement_rate
          follower_count
          id
          impressions_count
          link_type
          link_url
        }
        user {
          id
          name
          profile_image_url
          email
          phone_number
        }
        channel {
          id
          logo_image_url
          name
        }
        channel_links_aggregate {
          aggregate {
            sum {
              follower_count
            }
          }
        }
        variants {
          id
          cost
          variant_type
        }
      }
      influencer_user {
        id
        name
        profile_image_url
      }
      bid_price
      delivery_days
      status
    }
    status
    work_order_public_id
    variant_type
    cta_id
    cta_link
    cta_type
    created_at
    crops
    payment_status
    states
    status
    languages
    objectives
    title
    description
    published_at
  }
}
    `;

/**
 * __useWorkOrderQuery__
 *
 * To run a query within a React component, call `useWorkOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkOrderQuery({
 *   variables: {
 *      woId: // value for 'woId'
 *   },
 * });
 */
export function useWorkOrderQuery(baseOptions: Apollo.QueryHookOptions<WorkOrderQuery, WorkOrderQueryVariables> & ({ variables: WorkOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkOrderQuery, WorkOrderQueryVariables>(WorkOrderDocument, options);
      }
export function useWorkOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkOrderQuery, WorkOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkOrderQuery, WorkOrderQueryVariables>(WorkOrderDocument, options);
        }
export function useWorkOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkOrderQuery, WorkOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkOrderQuery, WorkOrderQueryVariables>(WorkOrderDocument, options);
        }
export type WorkOrderQueryHookResult = ReturnType<typeof useWorkOrderQuery>;
export type WorkOrderLazyQueryHookResult = ReturnType<typeof useWorkOrderLazyQuery>;
export type WorkOrderSuspenseQueryHookResult = ReturnType<typeof useWorkOrderSuspenseQuery>;
export type WorkOrderQueryResult = Apollo.QueryResult<WorkOrderQuery, WorkOrderQueryVariables>;
export const GetGigReviewProfileDocument = gql`
    query getGigReviewProfile($userId: bpchar!) {
  work_order_reviews_aggregate(where: {influencer_user_id: {_eq: $userId}}) {
    aggregate {
      sum {
        customer_given_rating_1
        customer_given_rating_2
      }
      count(columns: [customer_given_rating])
    }
    nodes {
      id
      customer_given_review
      customer_given_rating
      created_at
      work_order_id
      customer_user {
        id
        name
        profile_image_url
      }
    }
  }
}
    `;

/**
 * __useGetGigReviewProfileQuery__
 *
 * To run a query within a React component, call `useGetGigReviewProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGigReviewProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGigReviewProfileQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetGigReviewProfileQuery(baseOptions: Apollo.QueryHookOptions<GetGigReviewProfileQuery, GetGigReviewProfileQueryVariables> & ({ variables: GetGigReviewProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGigReviewProfileQuery, GetGigReviewProfileQueryVariables>(GetGigReviewProfileDocument, options);
      }
export function useGetGigReviewProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGigReviewProfileQuery, GetGigReviewProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGigReviewProfileQuery, GetGigReviewProfileQueryVariables>(GetGigReviewProfileDocument, options);
        }
export function useGetGigReviewProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGigReviewProfileQuery, GetGigReviewProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGigReviewProfileQuery, GetGigReviewProfileQueryVariables>(GetGigReviewProfileDocument, options);
        }
export type GetGigReviewProfileQueryHookResult = ReturnType<typeof useGetGigReviewProfileQuery>;
export type GetGigReviewProfileLazyQueryHookResult = ReturnType<typeof useGetGigReviewProfileLazyQuery>;
export type GetGigReviewProfileSuspenseQueryHookResult = ReturnType<typeof useGetGigReviewProfileSuspenseQuery>;
export type GetGigReviewProfileQueryResult = Apollo.QueryResult<GetGigReviewProfileQuery, GetGigReviewProfileQueryVariables>;
export const EditInfluencerGigProfileDocument = gql`
    mutation editInfluencerGigProfile($profileImageUrl: String, $channelName: String!, $costOfReel: Float!, $costOfVideo: Float!, $days: Int, $description: String!, $email: String!, $fbUrl: String!, $instaUrl: String!, $languages: [String], $otherUrl: String!, $reelDays: Int!, $segments: [String], $states: [String], $userId: String!, $userName: String!, $userPhone: String!, $videoDays: Int!, $ytUrl: String!) {
  editInfluencerGigProfile(
    request: {profileImageUrl: $profileImageUrl, channelName: $channelName, costOfReel: $costOfReel, costOfVideo: $costOfVideo, days: $days, description: $description, email: $email, fbUrl: $fbUrl, instaUrl: $instaUrl, languages: $languages, otherUrl: $otherUrl, reelDays: $reelDays, segments: $segments, states: $states, userId: $userId, userName: $userName, userPhone: $userPhone, videoDays: $videoDays, ytUrl: $ytUrl}
  ) {
    data {
      status
    }
    error
  }
}
    `;
export type EditInfluencerGigProfileMutationFn = Apollo.MutationFunction<EditInfluencerGigProfileMutation, EditInfluencerGigProfileMutationVariables>;

/**
 * __useEditInfluencerGigProfileMutation__
 *
 * To run a mutation, you first call `useEditInfluencerGigProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditInfluencerGigProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editInfluencerGigProfileMutation, { data, loading, error }] = useEditInfluencerGigProfileMutation({
 *   variables: {
 *      profileImageUrl: // value for 'profileImageUrl'
 *      channelName: // value for 'channelName'
 *      costOfReel: // value for 'costOfReel'
 *      costOfVideo: // value for 'costOfVideo'
 *      days: // value for 'days'
 *      description: // value for 'description'
 *      email: // value for 'email'
 *      fbUrl: // value for 'fbUrl'
 *      instaUrl: // value for 'instaUrl'
 *      languages: // value for 'languages'
 *      otherUrl: // value for 'otherUrl'
 *      reelDays: // value for 'reelDays'
 *      segments: // value for 'segments'
 *      states: // value for 'states'
 *      userId: // value for 'userId'
 *      userName: // value for 'userName'
 *      userPhone: // value for 'userPhone'
 *      videoDays: // value for 'videoDays'
 *      ytUrl: // value for 'ytUrl'
 *   },
 * });
 */
export function useEditInfluencerGigProfileMutation(baseOptions?: Apollo.MutationHookOptions<EditInfluencerGigProfileMutation, EditInfluencerGigProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditInfluencerGigProfileMutation, EditInfluencerGigProfileMutationVariables>(EditInfluencerGigProfileDocument, options);
      }
export type EditInfluencerGigProfileMutationHookResult = ReturnType<typeof useEditInfluencerGigProfileMutation>;
export type EditInfluencerGigProfileMutationResult = Apollo.MutationResult<EditInfluencerGigProfileMutation>;
export type EditInfluencerGigProfileMutationOptions = Apollo.BaseMutationOptions<EditInfluencerGigProfileMutation, EditInfluencerGigProfileMutationVariables>;
export const ReelwiseProspectsDocument = gql`
    query reelwiseProspects($reelId: bigint, $accountId: bpchar, $limit: Int, $offset: Int) {
  fich_farminsta_replica_reel_lead_info(
    where: {reel_id: {_eq: $reelId}, account_id: {_eq: $accountId}}
    offset: $offset
    limit: $limit
    order_by: {created_at: desc}
  ) {
    id
    reel_id
    prospect_id
    farmer_name
    farmer_phone
    farmer_user_id
    farmer_profile_image_url
    owner_name
    owner_phone
    owner_user_id
    owner_profile_image_url
    state
    district
    taluk
    address
    status
    lat
    lng
    created_at
    source_interaction_ts
    source_interaction_type
    source_name
    source_reel_id
    source_reel_interaction_id
    source_service_request_id
    crop_names
  }
}
    `;

/**
 * __useReelwiseProspectsQuery__
 *
 * To run a query within a React component, call `useReelwiseProspectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReelwiseProspectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReelwiseProspectsQuery({
 *   variables: {
 *      reelId: // value for 'reelId'
 *      accountId: // value for 'accountId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useReelwiseProspectsQuery(baseOptions?: Apollo.QueryHookOptions<ReelwiseProspectsQuery, ReelwiseProspectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReelwiseProspectsQuery, ReelwiseProspectsQueryVariables>(ReelwiseProspectsDocument, options);
      }
export function useReelwiseProspectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReelwiseProspectsQuery, ReelwiseProspectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReelwiseProspectsQuery, ReelwiseProspectsQueryVariables>(ReelwiseProspectsDocument, options);
        }
export function useReelwiseProspectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReelwiseProspectsQuery, ReelwiseProspectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReelwiseProspectsQuery, ReelwiseProspectsQueryVariables>(ReelwiseProspectsDocument, options);
        }
export type ReelwiseProspectsQueryHookResult = ReturnType<typeof useReelwiseProspectsQuery>;
export type ReelwiseProspectsLazyQueryHookResult = ReturnType<typeof useReelwiseProspectsLazyQuery>;
export type ReelwiseProspectsSuspenseQueryHookResult = ReturnType<typeof useReelwiseProspectsSuspenseQuery>;
export type ReelwiseProspectsQueryResult = Apollo.QueryResult<ReelwiseProspectsQuery, ReelwiseProspectsQueryVariables>;
export const ChannelLeadsDocument = gql`
    query channelLeads($accountId: bpchar, $limit: Int, $offset: Int) {
  fich_farminsta_replica_leads(
    where: {account_id: {_eq: $accountId}, deleted_at: {_is_null: true}}
    offset: $offset
    limit: $limit
    order_by: {id: desc}
  ) {
    id
    farmer_name
    farmer_phone
    farmer_user_id
    farmer_profile_image_url
    owner_name
    owner_phone
    owner_user_id
    owner_profile_image_url
    state
    district
    taluk
    created_at
    address
    status
    lat
    lng
    source_interaction_ts
    source_interaction_type
    source_name
    source_reel_id
    source_reel_interaction_id
    source_service_request_id
    crop_names
    deleted_at
  }
}
    `;

/**
 * __useChannelLeadsQuery__
 *
 * To run a query within a React component, call `useChannelLeadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelLeadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelLeadsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useChannelLeadsQuery(baseOptions?: Apollo.QueryHookOptions<ChannelLeadsQuery, ChannelLeadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChannelLeadsQuery, ChannelLeadsQueryVariables>(ChannelLeadsDocument, options);
      }
export function useChannelLeadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChannelLeadsQuery, ChannelLeadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChannelLeadsQuery, ChannelLeadsQueryVariables>(ChannelLeadsDocument, options);
        }
export function useChannelLeadsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChannelLeadsQuery, ChannelLeadsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChannelLeadsQuery, ChannelLeadsQueryVariables>(ChannelLeadsDocument, options);
        }
export type ChannelLeadsQueryHookResult = ReturnType<typeof useChannelLeadsQuery>;
export type ChannelLeadsLazyQueryHookResult = ReturnType<typeof useChannelLeadsLazyQuery>;
export type ChannelLeadsSuspenseQueryHookResult = ReturnType<typeof useChannelLeadsSuspenseQuery>;
export type ChannelLeadsQueryResult = Apollo.QueryResult<ChannelLeadsQuery, ChannelLeadsQueryVariables>;
export const GetchannelLeadDocument = gql`
    query getchannelLead($id: bpchar) {
  fich_farminsta_replica_leads(where: {id: {_eq: $id}}) {
    id
    status
  }
}
    `;

/**
 * __useGetchannelLeadQuery__
 *
 * To run a query within a React component, call `useGetchannelLeadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetchannelLeadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetchannelLeadQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetchannelLeadQuery(baseOptions?: Apollo.QueryHookOptions<GetchannelLeadQuery, GetchannelLeadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetchannelLeadQuery, GetchannelLeadQueryVariables>(GetchannelLeadDocument, options);
      }
export function useGetchannelLeadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetchannelLeadQuery, GetchannelLeadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetchannelLeadQuery, GetchannelLeadQueryVariables>(GetchannelLeadDocument, options);
        }
export function useGetchannelLeadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetchannelLeadQuery, GetchannelLeadQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetchannelLeadQuery, GetchannelLeadQueryVariables>(GetchannelLeadDocument, options);
        }
export type GetchannelLeadQueryHookResult = ReturnType<typeof useGetchannelLeadQuery>;
export type GetchannelLeadLazyQueryHookResult = ReturnType<typeof useGetchannelLeadLazyQuery>;
export type GetchannelLeadSuspenseQueryHookResult = ReturnType<typeof useGetchannelLeadSuspenseQuery>;
export type GetchannelLeadQueryResult = Apollo.QueryResult<GetchannelLeadQuery, GetchannelLeadQueryVariables>;
export const GetConsoleProductPopBySlugDocument = gql`
    query GetConsoleProductPopBySlug($slug: String!) {
  productPop(slug: $slug) {
    id
    productName
    itemCode
    slug
    description
    popContent
    imageUrl
    popUrl
    crop {
      id
      name
    }
    media {
      id
      mediaType
      mediaId
      youtubeUrl
      uploadedUrl
      fileSize
      duration
      fileName
      sortOrder
      reel
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetConsoleProductPopBySlugQuery__
 *
 * To run a query within a React component, call `useGetConsoleProductPopBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsoleProductPopBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsoleProductPopBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetConsoleProductPopBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetConsoleProductPopBySlugQuery, GetConsoleProductPopBySlugQueryVariables> & ({ variables: GetConsoleProductPopBySlugQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConsoleProductPopBySlugQuery, GetConsoleProductPopBySlugQueryVariables>(GetConsoleProductPopBySlugDocument, options);
      }
export function useGetConsoleProductPopBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConsoleProductPopBySlugQuery, GetConsoleProductPopBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConsoleProductPopBySlugQuery, GetConsoleProductPopBySlugQueryVariables>(GetConsoleProductPopBySlugDocument, options);
        }
export function useGetConsoleProductPopBySlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConsoleProductPopBySlugQuery, GetConsoleProductPopBySlugQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConsoleProductPopBySlugQuery, GetConsoleProductPopBySlugQueryVariables>(GetConsoleProductPopBySlugDocument, options);
        }
export type GetConsoleProductPopBySlugQueryHookResult = ReturnType<typeof useGetConsoleProductPopBySlugQuery>;
export type GetConsoleProductPopBySlugLazyQueryHookResult = ReturnType<typeof useGetConsoleProductPopBySlugLazyQuery>;
export type GetConsoleProductPopBySlugSuspenseQueryHookResult = ReturnType<typeof useGetConsoleProductPopBySlugSuspenseQuery>;
export type GetConsoleProductPopBySlugQueryResult = Apollo.QueryResult<GetConsoleProductPopBySlugQuery, GetConsoleProductPopBySlugQueryVariables>;
export const GetConsoleProductPopsDocument = gql`
    query GetConsoleProductPops($accountId: String!) {
  productPops(filter: {accountId: $accountId}, first: 1000)
}
    `;

/**
 * __useGetConsoleProductPopsQuery__
 *
 * To run a query within a React component, call `useGetConsoleProductPopsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsoleProductPopsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsoleProductPopsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetConsoleProductPopsQuery(baseOptions: Apollo.QueryHookOptions<GetConsoleProductPopsQuery, GetConsoleProductPopsQueryVariables> & ({ variables: GetConsoleProductPopsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConsoleProductPopsQuery, GetConsoleProductPopsQueryVariables>(GetConsoleProductPopsDocument, options);
      }
export function useGetConsoleProductPopsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConsoleProductPopsQuery, GetConsoleProductPopsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConsoleProductPopsQuery, GetConsoleProductPopsQueryVariables>(GetConsoleProductPopsDocument, options);
        }
export function useGetConsoleProductPopsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConsoleProductPopsQuery, GetConsoleProductPopsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConsoleProductPopsQuery, GetConsoleProductPopsQueryVariables>(GetConsoleProductPopsDocument, options);
        }
export type GetConsoleProductPopsQueryHookResult = ReturnType<typeof useGetConsoleProductPopsQuery>;
export type GetConsoleProductPopsLazyQueryHookResult = ReturnType<typeof useGetConsoleProductPopsLazyQuery>;
export type GetConsoleProductPopsSuspenseQueryHookResult = ReturnType<typeof useGetConsoleProductPopsSuspenseQuery>;
export type GetConsoleProductPopsQueryResult = Apollo.QueryResult<GetConsoleProductPopsQuery, GetConsoleProductPopsQueryVariables>;
export const CreateProductPopDocument = gql`
    mutation CreateProductPop($input: CreateProductPopInput!) {
  createProductPop(input: $input) {
    success
    productPop {
      id
      productName
      itemCode
      slug
      description
      popContent
      imageUrl
      popUrl
      crop {
        id
        name
      }
      media {
        id
        mediaType
        mediaId
        youtubeUrl
        uploadedUrl
        fileSize
        duration
        fileName
        sortOrder
        reel
      }
      createdAt
      updatedAt
    }
    errors {
      field
      message
    }
  }
}
    `;
export type CreateProductPopMutationFn = Apollo.MutationFunction<CreateProductPopMutation, CreateProductPopMutationVariables>;

/**
 * __useCreateProductPopMutation__
 *
 * To run a mutation, you first call `useCreateProductPopMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductPopMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductPopMutation, { data, loading, error }] = useCreateProductPopMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductPopMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductPopMutation, CreateProductPopMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductPopMutation, CreateProductPopMutationVariables>(CreateProductPopDocument, options);
      }
export type CreateProductPopMutationHookResult = ReturnType<typeof useCreateProductPopMutation>;
export type CreateProductPopMutationResult = Apollo.MutationResult<CreateProductPopMutation>;
export type CreateProductPopMutationOptions = Apollo.BaseMutationOptions<CreateProductPopMutation, CreateProductPopMutationVariables>;
export const UpdateProductPopDocument = gql`
    mutation UpdateProductPop($id: String!, $input: UpdateProductPopInput!) {
  updateProductPop(id: $id, input: $input) {
    success
    productPop {
      id
      productName
      itemCode
      slug
      description
      popContent
      imageUrl
      crop {
        id
        name
      }
      media {
        id
        mediaType
        mediaId
        youtubeUrl
        uploadedUrl
        fileSize
        duration
        fileName
        sortOrder
        reel
      }
      createdAt
      updatedAt
    }
    errors {
      field
      message
    }
  }
}
    `;
export type UpdateProductPopMutationFn = Apollo.MutationFunction<UpdateProductPopMutation, UpdateProductPopMutationVariables>;

/**
 * __useUpdateProductPopMutation__
 *
 * To run a mutation, you first call `useUpdateProductPopMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductPopMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductPopMutation, { data, loading, error }] = useUpdateProductPopMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductPopMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductPopMutation, UpdateProductPopMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductPopMutation, UpdateProductPopMutationVariables>(UpdateProductPopDocument, options);
      }
export type UpdateProductPopMutationHookResult = ReturnType<typeof useUpdateProductPopMutation>;
export type UpdateProductPopMutationResult = Apollo.MutationResult<UpdateProductPopMutation>;
export type UpdateProductPopMutationOptions = Apollo.BaseMutationOptions<UpdateProductPopMutation, UpdateProductPopMutationVariables>;
export const DeleteProductPopDocument = gql`
    mutation DeleteProductPop($id: String!) {
  deleteProductPop(id: $id) {
    success
    message
  }
}
    `;
export type DeleteProductPopMutationFn = Apollo.MutationFunction<DeleteProductPopMutation, DeleteProductPopMutationVariables>;

/**
 * __useDeleteProductPopMutation__
 *
 * To run a mutation, you first call `useDeleteProductPopMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductPopMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductPopMutation, { data, loading, error }] = useDeleteProductPopMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProductPopMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductPopMutation, DeleteProductPopMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProductPopMutation, DeleteProductPopMutationVariables>(DeleteProductPopDocument, options);
      }
export type DeleteProductPopMutationHookResult = ReturnType<typeof useDeleteProductPopMutation>;
export type DeleteProductPopMutationResult = Apollo.MutationResult<DeleteProductPopMutation>;
export type DeleteProductPopMutationOptions = Apollo.BaseMutationOptions<DeleteProductPopMutation, DeleteProductPopMutationVariables>;
export const S3UploadDataDocument = gql`
    mutation S3UploadData($key: String!, $expiresInSeconds: Int) {
  s3UploadData(key: $key, expiresInSeconds: $expiresInSeconds)
}
    `;
export type S3UploadDataMutationFn = Apollo.MutationFunction<S3UploadDataMutation, S3UploadDataMutationVariables>;

/**
 * __useS3UploadDataMutation__
 *
 * To run a mutation, you first call `useS3UploadDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useS3UploadDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [s3UploadDataMutation, { data, loading, error }] = useS3UploadDataMutation({
 *   variables: {
 *      key: // value for 'key'
 *      expiresInSeconds: // value for 'expiresInSeconds'
 *   },
 * });
 */
export function useS3UploadDataMutation(baseOptions?: Apollo.MutationHookOptions<S3UploadDataMutation, S3UploadDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<S3UploadDataMutation, S3UploadDataMutationVariables>(S3UploadDataDocument, options);
      }
export type S3UploadDataMutationHookResult = ReturnType<typeof useS3UploadDataMutation>;
export type S3UploadDataMutationResult = Apollo.MutationResult<S3UploadDataMutation>;
export type S3UploadDataMutationOptions = Apollo.BaseMutationOptions<S3UploadDataMutation, S3UploadDataMutationVariables>;
export const CfUploadDataDocument = gql`
    mutation CfUploadData($type: String!, $expiresInSeconds: Int) {
  cfUploadData(type: $type, expiresInSeconds: $expiresInSeconds)
}
    `;
export type CfUploadDataMutationFn = Apollo.MutationFunction<CfUploadDataMutation, CfUploadDataMutationVariables>;

/**
 * __useCfUploadDataMutation__
 *
 * To run a mutation, you first call `useCfUploadDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCfUploadDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cfUploadDataMutation, { data, loading, error }] = useCfUploadDataMutation({
 *   variables: {
 *      type: // value for 'type'
 *      expiresInSeconds: // value for 'expiresInSeconds'
 *   },
 * });
 */
export function useCfUploadDataMutation(baseOptions?: Apollo.MutationHookOptions<CfUploadDataMutation, CfUploadDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CfUploadDataMutation, CfUploadDataMutationVariables>(CfUploadDataDocument, options);
      }
export type CfUploadDataMutationHookResult = ReturnType<typeof useCfUploadDataMutation>;
export type CfUploadDataMutationResult = Apollo.MutationResult<CfUploadDataMutation>;
export type CfUploadDataMutationOptions = Apollo.BaseMutationOptions<CfUploadDataMutation, CfUploadDataMutationVariables>;
export const CreateTrackableLinkForPopDocument = gql`
    mutation createTrackableLinkForPop($userId: String!, $goUrl: String!, $type: String!, $reelId: Int!, $popId: String) {
  createTrackableLink(
    input: {userId: $userId, goUrl: $goUrl, type: $type, reelId: $reelId, popId: $popId}
  ) {
    idAsString
    fullUrl
  }
}
    `;
export type CreateTrackableLinkForPopMutationFn = Apollo.MutationFunction<CreateTrackableLinkForPopMutation, CreateTrackableLinkForPopMutationVariables>;

/**
 * __useCreateTrackableLinkForPopMutation__
 *
 * To run a mutation, you first call `useCreateTrackableLinkForPopMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTrackableLinkForPopMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTrackableLinkForPopMutation, { data, loading, error }] = useCreateTrackableLinkForPopMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      goUrl: // value for 'goUrl'
 *      type: // value for 'type'
 *      reelId: // value for 'reelId'
 *      popId: // value for 'popId'
 *   },
 * });
 */
export function useCreateTrackableLinkForPopMutation(baseOptions?: Apollo.MutationHookOptions<CreateTrackableLinkForPopMutation, CreateTrackableLinkForPopMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTrackableLinkForPopMutation, CreateTrackableLinkForPopMutationVariables>(CreateTrackableLinkForPopDocument, options);
      }
export type CreateTrackableLinkForPopMutationHookResult = ReturnType<typeof useCreateTrackableLinkForPopMutation>;
export type CreateTrackableLinkForPopMutationResult = Apollo.MutationResult<CreateTrackableLinkForPopMutation>;
export type CreateTrackableLinkForPopMutationOptions = Apollo.BaseMutationOptions<CreateTrackableLinkForPopMutation, CreateTrackableLinkForPopMutationVariables>;
export const ChannelAnalyticsforprofileDocument = gql`
    query channelAnalyticsforprofile($userId: String!, $channelId: String!, $channelIdInt: bigint!) {
  reel_stats_aggregate(where: {channel_id: {_eq: $channelIdInt}}) {
    aggregate {
      sum {
        total_watch_time_ms
        playback_count
        avg_watch_time_ms
        reel_id
        view_count
      }
    }
  }
  channelAnalytics(request: {userId: $userId, channelId: $channelId}) {
    channelName
    channelDescription
    channelLogoImageUrl
    followerCount
    fullyViewedCount
    sharesCount
    commentsCount
    likesCount
    reels
    watchTimeInMinutes
  }
  channel: channels_by_pk(id: $channelIdInt) {
    id
    account {
      id
      website_url
      name
    }
  }
  channel_links(where: {channel_id: {_eq: $channelIdInt}}) {
    id
    link_url
    link_type
    impressions_count
    engagement_rate
    created_at
    follower_count
    link_data
    post_count
  }
}
    `;

/**
 * __useChannelAnalyticsforprofileQuery__
 *
 * To run a query within a React component, call `useChannelAnalyticsforprofileQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelAnalyticsforprofileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelAnalyticsforprofileQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      channelId: // value for 'channelId'
 *      channelIdInt: // value for 'channelIdInt'
 *   },
 * });
 */
export function useChannelAnalyticsforprofileQuery(baseOptions: Apollo.QueryHookOptions<ChannelAnalyticsforprofileQuery, ChannelAnalyticsforprofileQueryVariables> & ({ variables: ChannelAnalyticsforprofileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChannelAnalyticsforprofileQuery, ChannelAnalyticsforprofileQueryVariables>(ChannelAnalyticsforprofileDocument, options);
      }
export function useChannelAnalyticsforprofileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChannelAnalyticsforprofileQuery, ChannelAnalyticsforprofileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChannelAnalyticsforprofileQuery, ChannelAnalyticsforprofileQueryVariables>(ChannelAnalyticsforprofileDocument, options);
        }
export function useChannelAnalyticsforprofileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChannelAnalyticsforprofileQuery, ChannelAnalyticsforprofileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChannelAnalyticsforprofileQuery, ChannelAnalyticsforprofileQueryVariables>(ChannelAnalyticsforprofileDocument, options);
        }
export type ChannelAnalyticsforprofileQueryHookResult = ReturnType<typeof useChannelAnalyticsforprofileQuery>;
export type ChannelAnalyticsforprofileLazyQueryHookResult = ReturnType<typeof useChannelAnalyticsforprofileLazyQuery>;
export type ChannelAnalyticsforprofileSuspenseQueryHookResult = ReturnType<typeof useChannelAnalyticsforprofileSuspenseQuery>;
export type ChannelAnalyticsforprofileQueryResult = Apollo.QueryResult<ChannelAnalyticsforprofileQuery, ChannelAnalyticsforprofileQueryVariables>;
export const UserReactedReelDocument = gql`
    mutation userReactedReel($reelId: Int!, $userId: String!) {
  userLikedReel(command: {reelId: $reelId, userId: $userId}) {
    data {
      status
    }
    error
  }
}
    `;
export type UserReactedReelMutationFn = Apollo.MutationFunction<UserReactedReelMutation, UserReactedReelMutationVariables>;

/**
 * __useUserReactedReelMutation__
 *
 * To run a mutation, you first call `useUserReactedReelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserReactedReelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userReactedReelMutation, { data, loading, error }] = useUserReactedReelMutation({
 *   variables: {
 *      reelId: // value for 'reelId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserReactedReelMutation(baseOptions?: Apollo.MutationHookOptions<UserReactedReelMutation, UserReactedReelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserReactedReelMutation, UserReactedReelMutationVariables>(UserReactedReelDocument, options);
      }
export type UserReactedReelMutationHookResult = ReturnType<typeof useUserReactedReelMutation>;
export type UserReactedReelMutationResult = Apollo.MutationResult<UserReactedReelMutation>;
export type UserReactedReelMutationOptions = Apollo.BaseMutationOptions<UserReactedReelMutation, UserReactedReelMutationVariables>;
export const CreateTrackableLinkDocument = gql`
    mutation createTrackableLink($userId: String!, $goUrl: String!, $type: String!, $reelId: Int!) {
  createTrackableLink(
    input: {userId: $userId, goUrl: $goUrl, type: $type, reelId: $reelId}
  ) {
    idAsString
    fullUrl
  }
}
    `;
export type CreateTrackableLinkMutationFn = Apollo.MutationFunction<CreateTrackableLinkMutation, CreateTrackableLinkMutationVariables>;

/**
 * __useCreateTrackableLinkMutation__
 *
 * To run a mutation, you first call `useCreateTrackableLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTrackableLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTrackableLinkMutation, { data, loading, error }] = useCreateTrackableLinkMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      goUrl: // value for 'goUrl'
 *      type: // value for 'type'
 *      reelId: // value for 'reelId'
 *   },
 * });
 */
export function useCreateTrackableLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateTrackableLinkMutation, CreateTrackableLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTrackableLinkMutation, CreateTrackableLinkMutationVariables>(CreateTrackableLinkDocument, options);
      }
export type CreateTrackableLinkMutationHookResult = ReturnType<typeof useCreateTrackableLinkMutation>;
export type CreateTrackableLinkMutationResult = Apollo.MutationResult<CreateTrackableLinkMutation>;
export type CreateTrackableLinkMutationOptions = Apollo.BaseMutationOptions<CreateTrackableLinkMutation, CreateTrackableLinkMutationVariables>;
export const ContentDetailsDocument = gql`
    query contentDetails($channelId: bigint, $reelId: bigint) {
  fich_farminsta_replica_reels_flat(
    where: {channel_id: {_eq: $channelId}, id: {_eq: $reelId}}
  ) {
    id
    title
    thumbnail_url
    description
    crop_id
    category_id
    created_at
    playback_count
    tws: total_watch_time_secs
    avg_watch_duration_percent
    playback_count
    view_count
    language
    cloudflare_id
    react_count
    share_count
    comment_count
    duration_ms
    lead_count
    user_name
    user_id
    uploader_type
    active_lead_count
    s3_path
    approved_by_user_name
    updated_at
  }
}
    `;

/**
 * __useContentDetailsQuery__
 *
 * To run a query within a React component, call `useContentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentDetailsQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      reelId: // value for 'reelId'
 *   },
 * });
 */
export function useContentDetailsQuery(baseOptions?: Apollo.QueryHookOptions<ContentDetailsQuery, ContentDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentDetailsQuery, ContentDetailsQueryVariables>(ContentDetailsDocument, options);
      }
export function useContentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentDetailsQuery, ContentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentDetailsQuery, ContentDetailsQueryVariables>(ContentDetailsDocument, options);
        }
export function useContentDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentDetailsQuery, ContentDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentDetailsQuery, ContentDetailsQueryVariables>(ContentDetailsDocument, options);
        }
export type ContentDetailsQueryHookResult = ReturnType<typeof useContentDetailsQuery>;
export type ContentDetailsLazyQueryHookResult = ReturnType<typeof useContentDetailsLazyQuery>;
export type ContentDetailsSuspenseQueryHookResult = ReturnType<typeof useContentDetailsSuspenseQuery>;
export type ContentDetailsQueryResult = Apollo.QueryResult<ContentDetailsQuery, ContentDetailsQueryVariables>;
export const ContentDocument = gql`
    query content($channelId: bigint, $limit: Int, $offset: Int) {
  fich_farminsta_replica_reels_flat(
    where: {channel_id: {_eq: $channelId}}
    limit: $limit
    offset: $offset
    order_by: {created_at: desc}
  ) {
    id
    title
    thumbnail_url
    description
    created_at
    playback_count
    tws: total_watch_time_secs
    avg_watch_duration_percent
    playback_count
    view_count
    react_count
    share_count
    comment_count
    duration_ms
    lead_count
    user_name
    user_id
    uploader_type
    active_lead_count
    s3_path
  }
}
    `;

/**
 * __useContentQuery__
 *
 * To run a query within a React component, call `useContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useContentQuery(baseOptions?: Apollo.QueryHookOptions<ContentQuery, ContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentQuery, ContentQueryVariables>(ContentDocument, options);
      }
export function useContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentQuery, ContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentQuery, ContentQueryVariables>(ContentDocument, options);
        }
export function useContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentQuery, ContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentQuery, ContentQueryVariables>(ContentDocument, options);
        }
export type ContentQueryHookResult = ReturnType<typeof useContentQuery>;
export type ContentLazyQueryHookResult = ReturnType<typeof useContentLazyQuery>;
export type ContentSuspenseQueryHookResult = ReturnType<typeof useContentSuspenseQuery>;
export type ContentQueryResult = Apollo.QueryResult<ContentQuery, ContentQueryVariables>;
export const ContentSummeryDocument = gql`
    query contentSummery($channelId: bigint) {
  fich_farminsta_replica_channel_analytics(where: {channel_id: {_eq: $channelId}}) {
    id
    account_id
    reel_count
    lead_count
    active_lead_count
    name
    description
    logo_image_url
    crop_count
    total_playback_count
    total_view_count
    total_react_count
    total_share_count
    total_comment_count
    total_watch_time_secs
    total_engagement_count
    follower_count
    missed_requests
    open_requests
    new_requests
    total_requests
    delayed_requests
    closed_requests
  }
}
    `;

/**
 * __useContentSummeryQuery__
 *
 * To run a query within a React component, call `useContentSummeryQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentSummeryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentSummeryQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useContentSummeryQuery(baseOptions?: Apollo.QueryHookOptions<ContentSummeryQuery, ContentSummeryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentSummeryQuery, ContentSummeryQueryVariables>(ContentSummeryDocument, options);
      }
export function useContentSummeryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentSummeryQuery, ContentSummeryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentSummeryQuery, ContentSummeryQueryVariables>(ContentSummeryDocument, options);
        }
export function useContentSummerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentSummeryQuery, ContentSummeryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentSummeryQuery, ContentSummeryQueryVariables>(ContentSummeryDocument, options);
        }
export type ContentSummeryQueryHookResult = ReturnType<typeof useContentSummeryQuery>;
export type ContentSummeryLazyQueryHookResult = ReturnType<typeof useContentSummeryLazyQuery>;
export type ContentSummerySuspenseQueryHookResult = ReturnType<typeof useContentSummerySuspenseQuery>;
export type ContentSummeryQueryResult = Apollo.QueryResult<ContentSummeryQuery, ContentSummeryQueryVariables>;
export const FoReelsForManagerDocument = gql`
    query foReelsForManager($accountId: bpchar!) {
  fo_reels_staging(
    where: {user: {account_users: {account_id: {_eq: $accountId}}}, status: {_eq: "pending"}}
    order_by: {created_at: desc}
  ) {
    id
    user_id
    user {
      id
      name
      profile_image_url
    }
    status
    created_at
    cf_data
    event
  }
}
    `;

/**
 * __useFoReelsForManagerQuery__
 *
 * To run a query within a React component, call `useFoReelsForManagerQuery` and pass it any options that fit your needs.
 * When your component renders, `useFoReelsForManagerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFoReelsForManagerQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useFoReelsForManagerQuery(baseOptions: Apollo.QueryHookOptions<FoReelsForManagerQuery, FoReelsForManagerQueryVariables> & ({ variables: FoReelsForManagerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FoReelsForManagerQuery, FoReelsForManagerQueryVariables>(FoReelsForManagerDocument, options);
      }
export function useFoReelsForManagerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FoReelsForManagerQuery, FoReelsForManagerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FoReelsForManagerQuery, FoReelsForManagerQueryVariables>(FoReelsForManagerDocument, options);
        }
export function useFoReelsForManagerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FoReelsForManagerQuery, FoReelsForManagerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FoReelsForManagerQuery, FoReelsForManagerQueryVariables>(FoReelsForManagerDocument, options);
        }
export type FoReelsForManagerQueryHookResult = ReturnType<typeof useFoReelsForManagerQuery>;
export type FoReelsForManagerLazyQueryHookResult = ReturnType<typeof useFoReelsForManagerLazyQuery>;
export type FoReelsForManagerSuspenseQueryHookResult = ReturnType<typeof useFoReelsForManagerSuspenseQuery>;
export type FoReelsForManagerQueryResult = Apollo.QueryResult<FoReelsForManagerQuery, FoReelsForManagerQueryVariables>;
export const FopendingreelDetailsDocument = gql`
    query fopendingreelDetails($accountId: bpchar!, $reelId: bigint) {
  fo_reels_staging(
    where: {user: {account_users: {account_id: {_eq: $accountId}}}, id: {_eq: $reelId}, status: {_eq: "pending"}}
  ) {
    id
    status
    created_at
    user {
      id
      name
      profile_image_url
    }
    cf_data
    event
  }
}
    `;

/**
 * __useFopendingreelDetailsQuery__
 *
 * To run a query within a React component, call `useFopendingreelDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFopendingreelDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFopendingreelDetailsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      reelId: // value for 'reelId'
 *   },
 * });
 */
export function useFopendingreelDetailsQuery(baseOptions: Apollo.QueryHookOptions<FopendingreelDetailsQuery, FopendingreelDetailsQueryVariables> & ({ variables: FopendingreelDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FopendingreelDetailsQuery, FopendingreelDetailsQueryVariables>(FopendingreelDetailsDocument, options);
      }
export function useFopendingreelDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FopendingreelDetailsQuery, FopendingreelDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FopendingreelDetailsQuery, FopendingreelDetailsQueryVariables>(FopendingreelDetailsDocument, options);
        }
export function useFopendingreelDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FopendingreelDetailsQuery, FopendingreelDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FopendingreelDetailsQuery, FopendingreelDetailsQueryVariables>(FopendingreelDetailsDocument, options);
        }
export type FopendingreelDetailsQueryHookResult = ReturnType<typeof useFopendingreelDetailsQuery>;
export type FopendingreelDetailsLazyQueryHookResult = ReturnType<typeof useFopendingreelDetailsLazyQuery>;
export type FopendingreelDetailsSuspenseQueryHookResult = ReturnType<typeof useFopendingreelDetailsSuspenseQuery>;
export type FopendingreelDetailsQueryResult = Apollo.QueryResult<FopendingreelDetailsQuery, FopendingreelDetailsQueryVariables>;
export const UserUpdatesDeviceInfoDocument = gql`
    mutation userUpdatesDeviceInfo($userId: String!, $deviceToken: String, $deviceInstallationId: String!, $deviceType: String, $appVersion: String, $osVersion: String, $deviceModel: String, $deviceName: String, $appBuildNumber: String, $deviceBrand: String, $deviceManufacturer: String, $deviceOsVersion: String, $nativePushToken: String, $releaseChannel: String, $runtimeVersion: String, $installReferrer: String) {
  userUpdatesHisDeviceInfo(
    command: {userId: $userId, deviceToken: $deviceToken, nativePushToken: $nativePushToken, deviceInstallationId: $deviceInstallationId, deviceType: $deviceType, appVersion: $appVersion, deviceOs: $osVersion, deviceModel: $deviceModel, deviceName: $deviceName, appBuildNumber: $appBuildNumber, deviceBrand: $deviceBrand, deviceManufacturer: $deviceManufacturer, deviceOsVersion: $deviceOsVersion, releaseChannel: $releaseChannel, runtimeVersion: $runtimeVersion, installReferrer: $installReferrer}
  ) {
    data {
      status
    }
    error
  }
}
    `;
export type UserUpdatesDeviceInfoMutationFn = Apollo.MutationFunction<UserUpdatesDeviceInfoMutation, UserUpdatesDeviceInfoMutationVariables>;

/**
 * __useUserUpdatesDeviceInfoMutation__
 *
 * To run a mutation, you first call `useUserUpdatesDeviceInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdatesDeviceInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdatesDeviceInfoMutation, { data, loading, error }] = useUserUpdatesDeviceInfoMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      deviceToken: // value for 'deviceToken'
 *      deviceInstallationId: // value for 'deviceInstallationId'
 *      deviceType: // value for 'deviceType'
 *      appVersion: // value for 'appVersion'
 *      osVersion: // value for 'osVersion'
 *      deviceModel: // value for 'deviceModel'
 *      deviceName: // value for 'deviceName'
 *      appBuildNumber: // value for 'appBuildNumber'
 *      deviceBrand: // value for 'deviceBrand'
 *      deviceManufacturer: // value for 'deviceManufacturer'
 *      deviceOsVersion: // value for 'deviceOsVersion'
 *      nativePushToken: // value for 'nativePushToken'
 *      releaseChannel: // value for 'releaseChannel'
 *      runtimeVersion: // value for 'runtimeVersion'
 *      installReferrer: // value for 'installReferrer'
 *   },
 * });
 */
export function useUserUpdatesDeviceInfoMutation(baseOptions?: Apollo.MutationHookOptions<UserUpdatesDeviceInfoMutation, UserUpdatesDeviceInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserUpdatesDeviceInfoMutation, UserUpdatesDeviceInfoMutationVariables>(UserUpdatesDeviceInfoDocument, options);
      }
export type UserUpdatesDeviceInfoMutationHookResult = ReturnType<typeof useUserUpdatesDeviceInfoMutation>;
export type UserUpdatesDeviceInfoMutationResult = Apollo.MutationResult<UserUpdatesDeviceInfoMutation>;
export type UserUpdatesDeviceInfoMutationOptions = Apollo.BaseMutationOptions<UserUpdatesDeviceInfoMutation, UserUpdatesDeviceInfoMutationVariables>;
export const GetProductPopBySlugDocument = gql`
    query GetProductPopBySlug($slug: String!) {
  productPop(slug: $slug) {
    id
    productName
    itemCode
    slug
    description
    imageUrl
    popContent
    crop {
      id
      name
      __typename
    }
    media {
      id
      mediaType
      mediaId
      uploadedUrl
      duration
      fileSize
      fileName
      youtubeUrl
      sortOrder
      reel
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
    `;

/**
 * __useGetProductPopBySlugQuery__
 *
 * To run a query within a React component, call `useGetProductPopBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductPopBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductPopBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetProductPopBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetProductPopBySlugQuery, GetProductPopBySlugQueryVariables> & ({ variables: GetProductPopBySlugQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductPopBySlugQuery, GetProductPopBySlugQueryVariables>(GetProductPopBySlugDocument, options);
      }
export function useGetProductPopBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductPopBySlugQuery, GetProductPopBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductPopBySlugQuery, GetProductPopBySlugQueryVariables>(GetProductPopBySlugDocument, options);
        }
export function useGetProductPopBySlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductPopBySlugQuery, GetProductPopBySlugQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductPopBySlugQuery, GetProductPopBySlugQueryVariables>(GetProductPopBySlugDocument, options);
        }
export type GetProductPopBySlugQueryHookResult = ReturnType<typeof useGetProductPopBySlugQuery>;
export type GetProductPopBySlugLazyQueryHookResult = ReturnType<typeof useGetProductPopBySlugLazyQuery>;
export type GetProductPopBySlugSuspenseQueryHookResult = ReturnType<typeof useGetProductPopBySlugSuspenseQuery>;
export type GetProductPopBySlugQueryResult = Apollo.QueryResult<GetProductPopBySlugQuery, GetProductPopBySlugQueryVariables>;
export const GetProductPopsDocument = gql`
    query GetProductPops {
  productPops
}
    `;

/**
 * __useGetProductPopsQuery__
 *
 * To run a query within a React component, call `useGetProductPopsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductPopsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductPopsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductPopsQuery(baseOptions?: Apollo.QueryHookOptions<GetProductPopsQuery, GetProductPopsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductPopsQuery, GetProductPopsQueryVariables>(GetProductPopsDocument, options);
      }
export function useGetProductPopsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductPopsQuery, GetProductPopsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductPopsQuery, GetProductPopsQueryVariables>(GetProductPopsDocument, options);
        }
export function useGetProductPopsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductPopsQuery, GetProductPopsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductPopsQuery, GetProductPopsQueryVariables>(GetProductPopsDocument, options);
        }
export type GetProductPopsQueryHookResult = ReturnType<typeof useGetProductPopsQuery>;
export type GetProductPopsLazyQueryHookResult = ReturnType<typeof useGetProductPopsLazyQuery>;
export type GetProductPopsSuspenseQueryHookResult = ReturnType<typeof useGetProductPopsSuspenseQuery>;
export type GetProductPopsQueryResult = Apollo.QueryResult<GetProductPopsQuery, GetProductPopsQueryVariables>;
export const UserFollowesChannelDocument = gql`
    subscription userFollowesChannel($channelId: bigint) {
  reel_interactions: user_follows_channel(
    where: {channel_id: {_eq: $channelId}, deleted_at: {_is_null: true}}
    order_by: {id: desc}
  ) {
    id
    user_id
    reel_interactions_user: user {
      id
      name
      last_known_locations {
        id
        address
      }
    }
  }
}
    `;

/**
 * __useUserFollowesChannelSubscription__
 *
 * To run a query within a React component, call `useUserFollowesChannelSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUserFollowesChannelSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFollowesChannelSubscription({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useUserFollowesChannelSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UserFollowesChannelSubscription, UserFollowesChannelSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UserFollowesChannelSubscription, UserFollowesChannelSubscriptionVariables>(UserFollowesChannelDocument, options);
      }
export type UserFollowesChannelSubscriptionHookResult = ReturnType<typeof useUserFollowesChannelSubscription>;
export type UserFollowesChannelSubscriptionResult = Apollo.SubscriptionResult<UserFollowesChannelSubscription>;
export const ReelUploadDataDocument = gql`
    query reelUploadData {
  master_crops(order_by: {name: asc}) {
    id
    name
    image_url
  }
  reel_category(order_by: {name: asc}) {
    id
    name
  }
  gis_districts(order_by: {state: asc}) {
    id
    state
    district
  }
}
    `;

/**
 * __useReelUploadDataQuery__
 *
 * To run a query within a React component, call `useReelUploadDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReelUploadDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReelUploadDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useReelUploadDataQuery(baseOptions?: Apollo.QueryHookOptions<ReelUploadDataQuery, ReelUploadDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReelUploadDataQuery, ReelUploadDataQueryVariables>(ReelUploadDataDocument, options);
      }
export function useReelUploadDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReelUploadDataQuery, ReelUploadDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReelUploadDataQuery, ReelUploadDataQueryVariables>(ReelUploadDataDocument, options);
        }
export function useReelUploadDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReelUploadDataQuery, ReelUploadDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReelUploadDataQuery, ReelUploadDataQueryVariables>(ReelUploadDataDocument, options);
        }
export type ReelUploadDataQueryHookResult = ReturnType<typeof useReelUploadDataQuery>;
export type ReelUploadDataLazyQueryHookResult = ReturnType<typeof useReelUploadDataLazyQuery>;
export type ReelUploadDataSuspenseQueryHookResult = ReturnType<typeof useReelUploadDataSuspenseQuery>;
export type ReelUploadDataQueryResult = Apollo.QueryResult<ReelUploadDataQuery, ReelUploadDataQueryVariables>;
export const CreateReelDocument = gql`
    mutation createReel($url: String!, $userId: String!, $title: String!, $description: String!, $category_id: Int, $thumbnail_url: String, $language: String, $google_places_id: String, $visibility: String, $allow_comments: Boolean, $allow_likes: Boolean, $allow_shares: Boolean, $allow_downloads: Boolean, $allow_reports: Boolean, $allow_reactions: Boolean, $channelId: Int, $lat: Float, $lng: Float, $tags: String!, $crop_id: String!, $districtIds: [Int]!, $targeted_area: String) {
  createReel(
    command: {title: $title, description: $description, url: $url, userId: $userId, tags: $tags, category_id: $category_id, thumbnail_url: $thumbnail_url, language: $language, google_places_id: $google_places_id, visibility: $visibility, allow_comments: $allow_comments, allow_likes: $allow_likes, allow_shares: $allow_shares, allow_downloads: $allow_downloads, allow_reports: $allow_reports, allow_reactions: $allow_reactions, lat: $lat, lng: $lng, districtIds: $districtIds, crop_id: $crop_id, targeted_area: $targeted_area, restrict_geo: false, channelId: $channelId}
  ) {
    data {
      status
    }
    error
  }
}
    `;
export type CreateReelMutationFn = Apollo.MutationFunction<CreateReelMutation, CreateReelMutationVariables>;

/**
 * __useCreateReelMutation__
 *
 * To run a mutation, you first call `useCreateReelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReelMutation, { data, loading, error }] = useCreateReelMutation({
 *   variables: {
 *      url: // value for 'url'
 *      userId: // value for 'userId'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      category_id: // value for 'category_id'
 *      thumbnail_url: // value for 'thumbnail_url'
 *      language: // value for 'language'
 *      google_places_id: // value for 'google_places_id'
 *      visibility: // value for 'visibility'
 *      allow_comments: // value for 'allow_comments'
 *      allow_likes: // value for 'allow_likes'
 *      allow_shares: // value for 'allow_shares'
 *      allow_downloads: // value for 'allow_downloads'
 *      allow_reports: // value for 'allow_reports'
 *      allow_reactions: // value for 'allow_reactions'
 *      channelId: // value for 'channelId'
 *      lat: // value for 'lat'
 *      lng: // value for 'lng'
 *      tags: // value for 'tags'
 *      crop_id: // value for 'crop_id'
 *      districtIds: // value for 'districtIds'
 *      targeted_area: // value for 'targeted_area'
 *   },
 * });
 */
export function useCreateReelMutation(baseOptions?: Apollo.MutationHookOptions<CreateReelMutation, CreateReelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReelMutation, CreateReelMutationVariables>(CreateReelDocument, options);
      }
export type CreateReelMutationHookResult = ReturnType<typeof useCreateReelMutation>;
export type CreateReelMutationResult = Apollo.MutationResult<CreateReelMutation>;
export type CreateReelMutationOptions = Apollo.BaseMutationOptions<CreateReelMutation, CreateReelMutationVariables>;
export const MenuLayoutDocument = gql`
    query menuLayout {
  consoleMenuLayout {
    userMenuItems
    mainMenuItems
  }
}
    `;

/**
 * __useMenuLayoutQuery__
 *
 * To run a query within a React component, call `useMenuLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useMenuLayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMenuLayoutQuery({
 *   variables: {
 *   },
 * });
 */
export function useMenuLayoutQuery(baseOptions?: Apollo.QueryHookOptions<MenuLayoutQuery, MenuLayoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MenuLayoutQuery, MenuLayoutQueryVariables>(MenuLayoutDocument, options);
      }
export function useMenuLayoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MenuLayoutQuery, MenuLayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MenuLayoutQuery, MenuLayoutQueryVariables>(MenuLayoutDocument, options);
        }
export function useMenuLayoutSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MenuLayoutQuery, MenuLayoutQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MenuLayoutQuery, MenuLayoutQueryVariables>(MenuLayoutDocument, options);
        }
export type MenuLayoutQueryHookResult = ReturnType<typeof useMenuLayoutQuery>;
export type MenuLayoutLazyQueryHookResult = ReturnType<typeof useMenuLayoutLazyQuery>;
export type MenuLayoutSuspenseQueryHookResult = ReturnType<typeof useMenuLayoutSuspenseQuery>;
export type MenuLayoutQueryResult = Apollo.QueryResult<MenuLayoutQuery, MenuLayoutQueryVariables>;
export const S3DataDocument = gql`
    mutation s3Data($key: String!) {
  s3UploadData(key: $key, expiresInSeconds: 300)
}
    `;
export type S3DataMutationFn = Apollo.MutationFunction<S3DataMutation, S3DataMutationVariables>;

/**
 * __useS3DataMutation__
 *
 * To run a mutation, you first call `useS3DataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useS3DataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [s3DataMutation, { data, loading, error }] = useS3DataMutation({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useS3DataMutation(baseOptions?: Apollo.MutationHookOptions<S3DataMutation, S3DataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<S3DataMutation, S3DataMutationVariables>(S3DataDocument, options);
      }
export type S3DataMutationHookResult = ReturnType<typeof useS3DataMutation>;
export type S3DataMutationResult = Apollo.MutationResult<S3DataMutation>;
export type S3DataMutationOptions = Apollo.BaseMutationOptions<S3DataMutation, S3DataMutationVariables>;
export const MyChannelsDocument = gql`
    query myChannels($account_id: bpchar) {
  channels(where: {account_id: {_eq: $account_id}, deleted_at: {_is_null: true}}) {
    id
    name
    account_id
    company_id
    followers_count
    description
    banner_image_url
    logo_image_url
    content_languages
    channel_links {
      id
      link_url
      link_type
      follower_count
    }
  }
}
    `;

/**
 * __useMyChannelsQuery__
 *
 * To run a query within a React component, call `useMyChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyChannelsQuery({
 *   variables: {
 *      account_id: // value for 'account_id'
 *   },
 * });
 */
export function useMyChannelsQuery(baseOptions?: Apollo.QueryHookOptions<MyChannelsQuery, MyChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyChannelsQuery, MyChannelsQueryVariables>(MyChannelsDocument, options);
      }
export function useMyChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyChannelsQuery, MyChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyChannelsQuery, MyChannelsQueryVariables>(MyChannelsDocument, options);
        }
export function useMyChannelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyChannelsQuery, MyChannelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyChannelsQuery, MyChannelsQueryVariables>(MyChannelsDocument, options);
        }
export type MyChannelsQueryHookResult = ReturnType<typeof useMyChannelsQuery>;
export type MyChannelsLazyQueryHookResult = ReturnType<typeof useMyChannelsLazyQuery>;
export type MyChannelsSuspenseQueryHookResult = ReturnType<typeof useMyChannelsSuspenseQuery>;
export type MyChannelsQueryResult = Apollo.QueryResult<MyChannelsQuery, MyChannelsQueryVariables>;
export const UserUpdatesDocument = gql`
    mutation userUpdates($userId: String!, $dateOfBirth: String, $name: String, $email: String, $gender: String, $phoneNumber: String, $imageUrl: String) {
  userUpdatesHisProfile(
    command: {dateOfBirth: $dateOfBirth, name: $name, email: $email, gender: $gender, phoneNumber: $phoneNumber, profileImageUrl: $imageUrl, userId: $userId}
  ) {
    data {
      status
    }
    error
  }
}
    `;
export type UserUpdatesMutationFn = Apollo.MutationFunction<UserUpdatesMutation, UserUpdatesMutationVariables>;

/**
 * __useUserUpdatesMutation__
 *
 * To run a mutation, you first call `useUserUpdatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdatesMutation, { data, loading, error }] = useUserUpdatesMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      dateOfBirth: // value for 'dateOfBirth'
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      gender: // value for 'gender'
 *      phoneNumber: // value for 'phoneNumber'
 *      imageUrl: // value for 'imageUrl'
 *   },
 * });
 */
export function useUserUpdatesMutation(baseOptions?: Apollo.MutationHookOptions<UserUpdatesMutation, UserUpdatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserUpdatesMutation, UserUpdatesMutationVariables>(UserUpdatesDocument, options);
      }
export type UserUpdatesMutationHookResult = ReturnType<typeof useUserUpdatesMutation>;
export type UserUpdatesMutationResult = Apollo.MutationResult<UserUpdatesMutation>;
export type UserUpdatesMutationOptions = Apollo.BaseMutationOptions<UserUpdatesMutation, UserUpdatesMutationVariables>;
export const UpdateChannelDetailsDocument = gql`
    mutation updateChannelDetails($userId: String!, $channelId: Int!, $channelName: String!, $channelDescription: String, $logo_image_url: String, $banner_image_url: String, $contentLanguagesList: String, $channelLinks: [ChannelLinksInput]) {
  updateChannelDetails(
    request: {userId: $userId, channelId: $channelId, channelName: $channelName, channelDescription: $channelDescription, channelLogoImageUrl: $logo_image_url, channelBannerImageUrl: $banner_image_url, contentLanguagesList: $contentLanguagesList, channelLinks: $channelLinks}
  ) {
    id
    account_id
    name
    description
    logo_image_url
    banner_image_url
  }
}
    `;
export type UpdateChannelDetailsMutationFn = Apollo.MutationFunction<UpdateChannelDetailsMutation, UpdateChannelDetailsMutationVariables>;

/**
 * __useUpdateChannelDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateChannelDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChannelDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChannelDetailsMutation, { data, loading, error }] = useUpdateChannelDetailsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      channelId: // value for 'channelId'
 *      channelName: // value for 'channelName'
 *      channelDescription: // value for 'channelDescription'
 *      logo_image_url: // value for 'logo_image_url'
 *      banner_image_url: // value for 'banner_image_url'
 *      contentLanguagesList: // value for 'contentLanguagesList'
 *      channelLinks: // value for 'channelLinks'
 *   },
 * });
 */
export function useUpdateChannelDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChannelDetailsMutation, UpdateChannelDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChannelDetailsMutation, UpdateChannelDetailsMutationVariables>(UpdateChannelDetailsDocument, options);
      }
export type UpdateChannelDetailsMutationHookResult = ReturnType<typeof useUpdateChannelDetailsMutation>;
export type UpdateChannelDetailsMutationResult = Apollo.MutationResult<UpdateChannelDetailsMutation>;
export type UpdateChannelDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateChannelDetailsMutation, UpdateChannelDetailsMutationVariables>;
export const UserDetailDocument = gql`
    subscription userDetail($userId: bpchar!) {
  users_by_pk(id: $userId) {
    id
    name
    gender
    date_of_birth
    profile_image_url
    email
    phone_number
    model_has_roles {
      role_id
    }
    last_known_locations {
      id
      is_active
      address
    }
    crop_users {
      id
      master_crop {
        id
        name
      }
    }
    segment_users {
      id
      master_segment {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useUserDetailSubscription__
 *
 * To run a query within a React component, call `useUserDetailSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUserDetailSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDetailSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserDetailSubscription(baseOptions: Apollo.SubscriptionHookOptions<UserDetailSubscription, UserDetailSubscriptionVariables> & ({ variables: UserDetailSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UserDetailSubscription, UserDetailSubscriptionVariables>(UserDetailDocument, options);
      }
export type UserDetailSubscriptionHookResult = ReturnType<typeof useUserDetailSubscription>;
export type UserDetailSubscriptionResult = Apollo.SubscriptionResult<UserDetailSubscription>;
export const GetCfDataDocument = gql`
    mutation getCfData($type: String!) {
  cfUploadData(type: $type, expiresInSeconds: 600)
}
    `;
export type GetCfDataMutationFn = Apollo.MutationFunction<GetCfDataMutation, GetCfDataMutationVariables>;

/**
 * __useGetCfDataMutation__
 *
 * To run a mutation, you first call `useGetCfDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetCfDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getCfDataMutation, { data, loading, error }] = useGetCfDataMutation({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetCfDataMutation(baseOptions?: Apollo.MutationHookOptions<GetCfDataMutation, GetCfDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetCfDataMutation, GetCfDataMutationVariables>(GetCfDataDocument, options);
      }
export type GetCfDataMutationHookResult = ReturnType<typeof useGetCfDataMutation>;
export type GetCfDataMutationResult = Apollo.MutationResult<GetCfDataMutation>;
export type GetCfDataMutationOptions = Apollo.BaseMutationOptions<GetCfDataMutation, GetCfDataMutationVariables>;
export const FeaturesDocument = gql`
    query features($accountId: String) {
  features(where: {scope: {_eq: $accountId}}) {
    id
    scope
    name
    value
  }
}
    `;

/**
 * __useFeaturesQuery__
 *
 * To run a query within a React component, call `useFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeaturesQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useFeaturesQuery(baseOptions?: Apollo.QueryHookOptions<FeaturesQuery, FeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeaturesQuery, FeaturesQueryVariables>(FeaturesDocument, options);
      }
export function useFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeaturesQuery, FeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeaturesQuery, FeaturesQueryVariables>(FeaturesDocument, options);
        }
export function useFeaturesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeaturesQuery, FeaturesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeaturesQuery, FeaturesQueryVariables>(FeaturesDocument, options);
        }
export type FeaturesQueryHookResult = ReturnType<typeof useFeaturesQuery>;
export type FeaturesLazyQueryHookResult = ReturnType<typeof useFeaturesLazyQuery>;
export type FeaturesSuspenseQueryHookResult = ReturnType<typeof useFeaturesSuspenseQuery>;
export type FeaturesQueryResult = Apollo.QueryResult<FeaturesQuery, FeaturesQueryVariables>;
export const ReelDetailsViewDocument = gql`
    query reelDetailsView($reelId: bigint!) {
  reels_by_pk(id: $reelId) {
    id
    channel: reels_channel {
      id
      name
      logo_image_url
    }
    cloudflare_thumbnail_url
    cloudflare_playback_url
    cloudflare_id
    thumbnail_url
    title
    created_at
    description
    reactions_count
    shares
    views
    reel_comments_aggregate(where: {deleted_at: {_is_null: true}}) {
      aggregate {
        count
      }
    }
    reel_comments(
      where: {deleted_at: {_is_null: true}}
      order_by: {created_at: desc}
    ) {
      id
      comment
      user_id
      created_at
      parent_id
      user {
        id
        name
        profile_image_url
      }
    }
  }
}
    `;

/**
 * __useReelDetailsViewQuery__
 *
 * To run a query within a React component, call `useReelDetailsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useReelDetailsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReelDetailsViewQuery({
 *   variables: {
 *      reelId: // value for 'reelId'
 *   },
 * });
 */
export function useReelDetailsViewQuery(baseOptions: Apollo.QueryHookOptions<ReelDetailsViewQuery, ReelDetailsViewQueryVariables> & ({ variables: ReelDetailsViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReelDetailsViewQuery, ReelDetailsViewQueryVariables>(ReelDetailsViewDocument, options);
      }
export function useReelDetailsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReelDetailsViewQuery, ReelDetailsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReelDetailsViewQuery, ReelDetailsViewQueryVariables>(ReelDetailsViewDocument, options);
        }
export function useReelDetailsViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReelDetailsViewQuery, ReelDetailsViewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReelDetailsViewQuery, ReelDetailsViewQueryVariables>(ReelDetailsViewDocument, options);
        }
export type ReelDetailsViewQueryHookResult = ReturnType<typeof useReelDetailsViewQuery>;
export type ReelDetailsViewLazyQueryHookResult = ReturnType<typeof useReelDetailsViewLazyQuery>;
export type ReelDetailsViewSuspenseQueryHookResult = ReturnType<typeof useReelDetailsViewSuspenseQuery>;
export type ReelDetailsViewQueryResult = Apollo.QueryResult<ReelDetailsViewQuery, ReelDetailsViewQueryVariables>;
export const CreateReelCommentDocument = gql`
    mutation createReelComment($userId: String!, $reelId: String!, $comment: String!, $parentId: Int) {
  createReelComment(
    command: {comment: $comment, userId: $userId, reelId: $reelId, parentId: $parentId}
  ) {
    data {
      status
    }
    error
  }
}
    `;
export type CreateReelCommentMutationFn = Apollo.MutationFunction<CreateReelCommentMutation, CreateReelCommentMutationVariables>;

/**
 * __useCreateReelCommentMutation__
 *
 * To run a mutation, you first call `useCreateReelCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReelCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReelCommentMutation, { data, loading, error }] = useCreateReelCommentMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      reelId: // value for 'reelId'
 *      comment: // value for 'comment'
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useCreateReelCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateReelCommentMutation, CreateReelCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReelCommentMutation, CreateReelCommentMutationVariables>(CreateReelCommentDocument, options);
      }
export type CreateReelCommentMutationHookResult = ReturnType<typeof useCreateReelCommentMutation>;
export type CreateReelCommentMutationResult = Apollo.MutationResult<CreateReelCommentMutation>;
export type CreateReelCommentMutationOptions = Apollo.BaseMutationOptions<CreateReelCommentMutation, CreateReelCommentMutationVariables>;
export const UserDeletesReelCommentDocument = gql`
    mutation userDeletesReelComment($userId: String!, $commentId: Int!, $reelId: Int) {
  deleteReelComment(
    command: {userId: $userId, commentId: $commentId, reelId: $reelId}
  ) {
    data {
      status
    }
    error
  }
}
    `;
export type UserDeletesReelCommentMutationFn = Apollo.MutationFunction<UserDeletesReelCommentMutation, UserDeletesReelCommentMutationVariables>;

/**
 * __useUserDeletesReelCommentMutation__
 *
 * To run a mutation, you first call `useUserDeletesReelCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserDeletesReelCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userDeletesReelCommentMutation, { data, loading, error }] = useUserDeletesReelCommentMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      commentId: // value for 'commentId'
 *      reelId: // value for 'reelId'
 *   },
 * });
 */
export function useUserDeletesReelCommentMutation(baseOptions?: Apollo.MutationHookOptions<UserDeletesReelCommentMutation, UserDeletesReelCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserDeletesReelCommentMutation, UserDeletesReelCommentMutationVariables>(UserDeletesReelCommentDocument, options);
      }
export type UserDeletesReelCommentMutationHookResult = ReturnType<typeof useUserDeletesReelCommentMutation>;
export type UserDeletesReelCommentMutationResult = Apollo.MutationResult<UserDeletesReelCommentMutation>;
export type UserDeletesReelCommentMutationOptions = Apollo.BaseMutationOptions<UserDeletesReelCommentMutation, UserDeletesReelCommentMutationVariables>;
export const ReelReactionsDocument = gql`
    subscription reelReactions($reelId: bigint!, $currentUserId: bpchar!) {
  reels(where: {id: {_eq: $reelId}, deleted_at: {_is_null: true}}) {
    id
    reel_comments(
      order_by: {created_at: desc}
      where: {deleted_at: {_is_null: true}}
    ) {
      id
      user_id
      user {
        id
        name
        profile_image_url
      }
      comment
      parent_id
      reports_aggregate {
        aggregate {
          count
        }
      }
      created_at
    }
    reels_saved_reels_aggregate(
      where: {user_id: {_eq: $currentUserId}, deleted_at: {_is_null: true}}
    ) {
      aggregate {
        count
      }
    }
    likes
    shares
    views
    total_likes: reels_reel_interactions_aggregate(
      where: {interaction_type: {_eq: "react"}, deleted_at: {_is_null: true}}
    ) {
      aggregate {
        count
      }
    }
    current_user_likes: reels_reel_interactions_aggregate(
      where: {interaction_type: {_eq: "react"}, user_id: {_eq: $currentUserId}, deleted_at: {_is_null: true}}
    ) {
      aggregate {
        count
      }
    }
    user_id
    channel_id
    channel: reels_channel {
      id
      name
      logo_image_url
      followers_count
      currentUserFollows: followers(
        where: {user_id: {_eq: $currentUserId}, deleted_at: {_is_null: true}}
      ) {
        id
        user_id
      }
    }
    reactions_count
    reactions
    allow_comments
    allow_likes
    allow_reactions
    allow_shares
    allow_reports
    reels_reel_stats {
      id
      playback_count
    }
  }
}
    `;

/**
 * __useReelReactionsSubscription__
 *
 * To run a query within a React component, call `useReelReactionsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useReelReactionsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReelReactionsSubscription({
 *   variables: {
 *      reelId: // value for 'reelId'
 *      currentUserId: // value for 'currentUserId'
 *   },
 * });
 */
export function useReelReactionsSubscription(baseOptions: Apollo.SubscriptionHookOptions<ReelReactionsSubscription, ReelReactionsSubscriptionVariables> & ({ variables: ReelReactionsSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ReelReactionsSubscription, ReelReactionsSubscriptionVariables>(ReelReactionsDocument, options);
      }
export type ReelReactionsSubscriptionHookResult = ReturnType<typeof useReelReactionsSubscription>;
export type ReelReactionsSubscriptionResult = Apollo.SubscriptionResult<ReelReactionsSubscription>;
export const AllServiceRequestsDocument = gql`
    subscription AllServiceRequests($accountId: bpchar!) {
  service_requests(
    where: {_or: [{field_partner_responses: {account_id: {_eq: $accountId}, response_action: {_eq: "accept"}}}]}
    order_by: {id: desc}
  ) {
    id
    created_at
    is_request_closed
    address
    farmer: user {
      id
      name
      phone_number
      profile_image_url
      crop_users {
        id
        master_crop {
          id
          name
        }
      }
    }
    crop: master_crop {
      id
      name
      image_url
    }
    assets
    date_of_sowing
    lat
    lng
    address
    field_partner_responses(where: {account_id: {_eq: $accountId}}) {
      id
      field_partner_user_id
      response_action
      created_at
      field_partner_rating
      field_partner_rated_at
    }
  }
}
    `;

/**
 * __useAllServiceRequestsSubscription__
 *
 * To run a query within a React component, call `useAllServiceRequestsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAllServiceRequestsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllServiceRequestsSubscription({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAllServiceRequestsSubscription(baseOptions: Apollo.SubscriptionHookOptions<AllServiceRequestsSubscription, AllServiceRequestsSubscriptionVariables> & ({ variables: AllServiceRequestsSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AllServiceRequestsSubscription, AllServiceRequestsSubscriptionVariables>(AllServiceRequestsDocument, options);
      }
export type AllServiceRequestsSubscriptionHookResult = ReturnType<typeof useAllServiceRequestsSubscription>;
export type AllServiceRequestsSubscriptionResult = Apollo.SubscriptionResult<AllServiceRequestsSubscription>;
export const FarmerMessagesDocument = gql`
    subscription FarmerMessages($requestId: bpchar!) {
  field_partner_responses(where: {request_id: {_eq: $requestId}}) {
    id
    response_action
    is_response_closed
    farmer_rating
    field_partner_feedback
    closed_by
    farmer_feedback
    field_partner_rating
    closed_at
    service_request {
      id
      farmer: user {
        id
        name
        phone_number
        profile_image_url
      }
    }
    field_partner: userByFieldPartnerUserId {
      id
      name
      phone_number
      profile_image_url
    }
    field_partner_response_messages {
      id
      message
      from_user_id
      to_user_id
      created_at
    }
  }
}
    `;

/**
 * __useFarmerMessagesSubscription__
 *
 * To run a query within a React component, call `useFarmerMessagesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useFarmerMessagesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFarmerMessagesSubscription({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useFarmerMessagesSubscription(baseOptions: Apollo.SubscriptionHookOptions<FarmerMessagesSubscription, FarmerMessagesSubscriptionVariables> & ({ variables: FarmerMessagesSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<FarmerMessagesSubscription, FarmerMessagesSubscriptionVariables>(FarmerMessagesDocument, options);
      }
export type FarmerMessagesSubscriptionHookResult = ReturnType<typeof useFarmerMessagesSubscription>;
export type FarmerMessagesSubscriptionResult = Apollo.SubscriptionResult<FarmerMessagesSubscription>;
export const FfRespondsToRequestDocument = gql`
    mutation FfRespondsToRequest($serviceRequestId: String!, $fieldPartnerUserId: String!, $action: String!) {
  fieldPartnerRespondsToRequest(
    command: {requestId: $serviceRequestId, fieldPartnerUserId: $fieldPartnerUserId, action: $action}
  ) {
    data {
      status
    }
    error
  }
}
    `;
export type FfRespondsToRequestMutationFn = Apollo.MutationFunction<FfRespondsToRequestMutation, FfRespondsToRequestMutationVariables>;

/**
 * __useFfRespondsToRequestMutation__
 *
 * To run a mutation, you first call `useFfRespondsToRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFfRespondsToRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ffRespondsToRequestMutation, { data, loading, error }] = useFfRespondsToRequestMutation({
 *   variables: {
 *      serviceRequestId: // value for 'serviceRequestId'
 *      fieldPartnerUserId: // value for 'fieldPartnerUserId'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useFfRespondsToRequestMutation(baseOptions?: Apollo.MutationHookOptions<FfRespondsToRequestMutation, FfRespondsToRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FfRespondsToRequestMutation, FfRespondsToRequestMutationVariables>(FfRespondsToRequestDocument, options);
      }
export type FfRespondsToRequestMutationHookResult = ReturnType<typeof useFfRespondsToRequestMutation>;
export type FfRespondsToRequestMutationResult = Apollo.MutationResult<FfRespondsToRequestMutation>;
export type FfRespondsToRequestMutationOptions = Apollo.BaseMutationOptions<FfRespondsToRequestMutation, FfRespondsToRequestMutationVariables>;
export const SendMessageOnServiceRequestDocument = gql`
    mutation sendMessageOnServiceRequest($farmerUserId: String!, $fieldPartnerUserId: String!, $message: String!, $requestId: String!, $senderUserId: String!) {
  sendMessageOnServiceRequest(
    command: {farmer_id: $farmerUserId, field_partner_id: $fieldPartnerUserId, message: $message, requestId: $requestId, sender_user_id: $senderUserId}
  ) {
    data {
      status
    }
    error
  }
}
    `;
export type SendMessageOnServiceRequestMutationFn = Apollo.MutationFunction<SendMessageOnServiceRequestMutation, SendMessageOnServiceRequestMutationVariables>;

/**
 * __useSendMessageOnServiceRequestMutation__
 *
 * To run a mutation, you first call `useSendMessageOnServiceRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageOnServiceRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageOnServiceRequestMutation, { data, loading, error }] = useSendMessageOnServiceRequestMutation({
 *   variables: {
 *      farmerUserId: // value for 'farmerUserId'
 *      fieldPartnerUserId: // value for 'fieldPartnerUserId'
 *      message: // value for 'message'
 *      requestId: // value for 'requestId'
 *      senderUserId: // value for 'senderUserId'
 *   },
 * });
 */
export function useSendMessageOnServiceRequestMutation(baseOptions?: Apollo.MutationHookOptions<SendMessageOnServiceRequestMutation, SendMessageOnServiceRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMessageOnServiceRequestMutation, SendMessageOnServiceRequestMutationVariables>(SendMessageOnServiceRequestDocument, options);
      }
export type SendMessageOnServiceRequestMutationHookResult = ReturnType<typeof useSendMessageOnServiceRequestMutation>;
export type SendMessageOnServiceRequestMutationResult = Apollo.MutationResult<SendMessageOnServiceRequestMutation>;
export type SendMessageOnServiceRequestMutationOptions = Apollo.BaseMutationOptions<SendMessageOnServiceRequestMutation, SendMessageOnServiceRequestMutationVariables>;
export const MessageOnServiceRequestsDocument = gql`
    subscription messageOnServiceRequests($fprId: bpchar!) {
  field_partner_responses(where: {id: {_eq: $fprId}}) {
    id
    field_partner_user_id
    field_partner_rating
    farmer_user_id
    request_id
    updated_at
    created_at
    response_action
    farmer_rating
    farmer_feedback
    field_partner_rating
    field_partner_feedback
    is_response_closed
    service_request {
      id
      crop
      date_of_sowing
      is_request_closed
      created_at
      assets
      address
      lat
      lng
      farmer: user {
        id
        name
        phone_number
        profile_image_url
        user_feedbacks_aggregate {
          aggregate {
            avg {
              rating
            }
          }
        }
      }
    }
    fieldPartner: userByFieldPartnerUserId {
      id
      name
      phone_number
      profile_image_url
      email
      user_feedbacks_aggregate {
        aggregate {
          avg {
            rating
          }
        }
      }
      related_accounts: account_users {
        id
        account {
          id
          name
        }
      }
    }
    messages: field_partner_response_messages {
      id
      message
      from_user_id
      to_user_id
      created_at
      assets
    }
    field_partner_rated_at
    farmer_rated_at
  }
}
    `;

/**
 * __useMessageOnServiceRequestsSubscription__
 *
 * To run a query within a React component, call `useMessageOnServiceRequestsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMessageOnServiceRequestsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageOnServiceRequestsSubscription({
 *   variables: {
 *      fprId: // value for 'fprId'
 *   },
 * });
 */
export function useMessageOnServiceRequestsSubscription(baseOptions: Apollo.SubscriptionHookOptions<MessageOnServiceRequestsSubscription, MessageOnServiceRequestsSubscriptionVariables> & ({ variables: MessageOnServiceRequestsSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<MessageOnServiceRequestsSubscription, MessageOnServiceRequestsSubscriptionVariables>(MessageOnServiceRequestsDocument, options);
      }
export type MessageOnServiceRequestsSubscriptionHookResult = ReturnType<typeof useMessageOnServiceRequestsSubscription>;
export type MessageOnServiceRequestsSubscriptionResult = Apollo.SubscriptionResult<MessageOnServiceRequestsSubscription>;
export const FieldPartnerClosesRequestFeedbackDocument = gql`
    mutation fieldPartnerClosesRequestFeedback($farmerUserId: String!, $feedback: String!, $fieldPartnerUserId: String!, $requestId: String!, $rating: String!) {
  fieldPartnerClosesRequest(
    command: {fieldPartnerUserId: $fieldPartnerUserId, requestId: $requestId}
  ) {
    data {
      status
    }
    error
  }
  fieldPartnerRatesAndReviewsFarmer(
    command: {farmer_id: $farmerUserId, feedback: $feedback, field_partner_id: $fieldPartnerUserId, id: $requestId, rating: $rating}
  ) {
    data {
      status
    }
    error
  }
}
    `;
export type FieldPartnerClosesRequestFeedbackMutationFn = Apollo.MutationFunction<FieldPartnerClosesRequestFeedbackMutation, FieldPartnerClosesRequestFeedbackMutationVariables>;

/**
 * __useFieldPartnerClosesRequestFeedbackMutation__
 *
 * To run a mutation, you first call `useFieldPartnerClosesRequestFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFieldPartnerClosesRequestFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fieldPartnerClosesRequestFeedbackMutation, { data, loading, error }] = useFieldPartnerClosesRequestFeedbackMutation({
 *   variables: {
 *      farmerUserId: // value for 'farmerUserId'
 *      feedback: // value for 'feedback'
 *      fieldPartnerUserId: // value for 'fieldPartnerUserId'
 *      requestId: // value for 'requestId'
 *      rating: // value for 'rating'
 *   },
 * });
 */
export function useFieldPartnerClosesRequestFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<FieldPartnerClosesRequestFeedbackMutation, FieldPartnerClosesRequestFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FieldPartnerClosesRequestFeedbackMutation, FieldPartnerClosesRequestFeedbackMutationVariables>(FieldPartnerClosesRequestFeedbackDocument, options);
      }
export type FieldPartnerClosesRequestFeedbackMutationHookResult = ReturnType<typeof useFieldPartnerClosesRequestFeedbackMutation>;
export type FieldPartnerClosesRequestFeedbackMutationResult = Apollo.MutationResult<FieldPartnerClosesRequestFeedbackMutation>;
export type FieldPartnerClosesRequestFeedbackMutationOptions = Apollo.BaseMutationOptions<FieldPartnerClosesRequestFeedbackMutation, FieldPartnerClosesRequestFeedbackMutationVariables>;
export const MyProspectsDocument = gql`
    subscription myProspects($accountId: bpchar!, $channelId: bigint!) {
  crm_account_channel_crop_prospects(
    where: {prospect: {status: {_eq: "active"}}, account_id: {_eq: $accountId}, channel_id: {_eq: $channelId}}
    order_by: {prospect_id: desc}
    distinct_on: [prospect_id]
  ) {
    interaction_type
    channel_id
    crop_id
    prospect_id
    reel_comment {
      id
      comment
    }
    prospect {
      id
      crop_id
      account_id
      prospects_reel_comment {
        id
        comment
        created_at
      }
      prospects_farmer_user {
        id
        name
        locale
        phone_number
        email
        profile_image_url
        last_known_locations {
          id
          address
        }
      }
      prospects_crop {
        id
        name
        image_url
      }
      source_interaction_type
      status
      source_reel_id
      source_interaction_ts
      created_at
      prospects_reel {
        id
        thumbnail_url
        title
        cloudflare_thumbnail_url
      }
    }
  }
}
    `;

/**
 * __useMyProspectsSubscription__
 *
 * To run a query within a React component, call `useMyProspectsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMyProspectsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyProspectsSubscription({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useMyProspectsSubscription(baseOptions: Apollo.SubscriptionHookOptions<MyProspectsSubscription, MyProspectsSubscriptionVariables> & ({ variables: MyProspectsSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<MyProspectsSubscription, MyProspectsSubscriptionVariables>(MyProspectsDocument, options);
      }
export type MyProspectsSubscriptionHookResult = ReturnType<typeof useMyProspectsSubscription>;
export type MyProspectsSubscriptionResult = Apollo.SubscriptionResult<MyProspectsSubscription>;
export const GetReelRecommendationsDocument = gql`
    query getReelRecommendations($userId: String!) {
  getReelRecommendations(userId: $userId) {
    response
  }
}
    `;

/**
 * __useGetReelRecommendationsQuery__
 *
 * To run a query within a React component, call `useGetReelRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReelRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReelRecommendationsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetReelRecommendationsQuery(baseOptions: Apollo.QueryHookOptions<GetReelRecommendationsQuery, GetReelRecommendationsQueryVariables> & ({ variables: GetReelRecommendationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReelRecommendationsQuery, GetReelRecommendationsQueryVariables>(GetReelRecommendationsDocument, options);
      }
export function useGetReelRecommendationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReelRecommendationsQuery, GetReelRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReelRecommendationsQuery, GetReelRecommendationsQueryVariables>(GetReelRecommendationsDocument, options);
        }
export function useGetReelRecommendationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReelRecommendationsQuery, GetReelRecommendationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReelRecommendationsQuery, GetReelRecommendationsQueryVariables>(GetReelRecommendationsDocument, options);
        }
export type GetReelRecommendationsQueryHookResult = ReturnType<typeof useGetReelRecommendationsQuery>;
export type GetReelRecommendationsLazyQueryHookResult = ReturnType<typeof useGetReelRecommendationsLazyQuery>;
export type GetReelRecommendationsSuspenseQueryHookResult = ReturnType<typeof useGetReelRecommendationsSuspenseQuery>;
export type GetReelRecommendationsQueryResult = Apollo.QueryResult<GetReelRecommendationsQuery, GetReelRecommendationsQueryVariables>;
export const ReelsFarmerByIdsDocument = gql`
    query reelsFarmerByIds($ids: [bigint!]) {
  reels(where: {id: {_in: $ids}, deleted_at: {_is_null: true}}) {
    id
    channel_id
    channel: reels_channel {
      id
      name
      logo_image_url
    }
    reels_user {
      id
      name
      profile_image_url
    }
    cloudflare_playback_url
    cloudflare_thumbnail_url
    cloudflare_id
    thumbnail_url
    title
    description
    reels_taggables {
      id
      taggable_type
      taggables_tag {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useReelsFarmerByIdsQuery__
 *
 * To run a query within a React component, call `useReelsFarmerByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReelsFarmerByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReelsFarmerByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useReelsFarmerByIdsQuery(baseOptions?: Apollo.QueryHookOptions<ReelsFarmerByIdsQuery, ReelsFarmerByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReelsFarmerByIdsQuery, ReelsFarmerByIdsQueryVariables>(ReelsFarmerByIdsDocument, options);
      }
export function useReelsFarmerByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReelsFarmerByIdsQuery, ReelsFarmerByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReelsFarmerByIdsQuery, ReelsFarmerByIdsQueryVariables>(ReelsFarmerByIdsDocument, options);
        }
export function useReelsFarmerByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReelsFarmerByIdsQuery, ReelsFarmerByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReelsFarmerByIdsQuery, ReelsFarmerByIdsQueryVariables>(ReelsFarmerByIdsDocument, options);
        }
export type ReelsFarmerByIdsQueryHookResult = ReturnType<typeof useReelsFarmerByIdsQuery>;
export type ReelsFarmerByIdsLazyQueryHookResult = ReturnType<typeof useReelsFarmerByIdsLazyQuery>;
export type ReelsFarmerByIdsSuspenseQueryHookResult = ReturnType<typeof useReelsFarmerByIdsSuspenseQuery>;
export type ReelsFarmerByIdsQueryResult = Apollo.QueryResult<ReelsFarmerByIdsQuery, ReelsFarmerByIdsQueryVariables>;
export const ChannelwisereelsDocument = gql`
    subscription channelwisereels($channelId: bigint) {
  reels(
    where: {deleted_at: {_is_null: true}, channel_id: {_eq: $channelId}}
    order_by: {created_at: desc}
    limit: 6
  ) {
    id
    channel_id
    channel: reels_channel {
      id
      name
      logo_image_url
      followers_count
    }
    user_id
    reels_user {
      id
      name
      profile_image_url
    }
    cloudflare_playback_url
    cloudflare_thumbnail_url
    cloudflare_id
    thumbnail_url
    title
    description
    reels_taggables {
      id
      taggable_type
      taggables_tag {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useChannelwisereelsSubscription__
 *
 * To run a query within a React component, call `useChannelwisereelsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useChannelwisereelsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelwisereelsSubscription({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useChannelwisereelsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ChannelwisereelsSubscription, ChannelwisereelsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ChannelwisereelsSubscription, ChannelwisereelsSubscriptionVariables>(ChannelwisereelsDocument, options);
      }
export type ChannelwisereelsSubscriptionHookResult = ReturnType<typeof useChannelwisereelsSubscription>;
export type ChannelwisereelsSubscriptionResult = Apollo.SubscriptionResult<ChannelwisereelsSubscription>;
export const CrmDocument = gql`
    query crm($channelId: bigint!) {
  crm_account_crop_wise_counts(where: {channel_id: {_eq: $channelId}}) {
    account_id
    channel_id
    crop_id
    crop_name
    crop_image_url
    prospect_count
  }
}
    `;

/**
 * __useCrmQuery__
 *
 * To run a query within a React component, call `useCrmQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useCrmQuery(baseOptions: Apollo.QueryHookOptions<CrmQuery, CrmQueryVariables> & ({ variables: CrmQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CrmQuery, CrmQueryVariables>(CrmDocument, options);
      }
export function useCrmLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrmQuery, CrmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CrmQuery, CrmQueryVariables>(CrmDocument, options);
        }
export function useCrmSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CrmQuery, CrmQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CrmQuery, CrmQueryVariables>(CrmDocument, options);
        }
export type CrmQueryHookResult = ReturnType<typeof useCrmQuery>;
export type CrmLazyQueryHookResult = ReturnType<typeof useCrmLazyQuery>;
export type CrmSuspenseQueryHookResult = ReturnType<typeof useCrmSuspenseQuery>;
export type CrmQueryResult = Apollo.QueryResult<CrmQuery, CrmQueryVariables>;
export const ChannelAnalyticsHomeDocument = gql`
    query channelAnalyticsHome($userId: String!, $channelId: String!, $channelIdInt: bigint, $offset: Int!, $limit: Int!) {
  reel_stats_aggregate(where: {channel_id: {_eq: $channelIdInt}}) {
    aggregate {
      sum {
        total_watch_time_ms
        playback_count
        avg_watch_time_ms
        reel_id
        view_count
      }
    }
  }
  channelAnalytics(
    request: {userId: $userId, channelId: $channelId, limit: $limit, offset: $offset}
  ) {
    userId
    companyId
    accountId
    channelName
    accountName
    channelDescription
    channelLogoImageUrl
    followerCount
    fullyViewedCount
    sharesCount
    commentsCount
    likesCount
    reels
    watchTimeInMinutes
  }
}
    `;

/**
 * __useChannelAnalyticsHomeQuery__
 *
 * To run a query within a React component, call `useChannelAnalyticsHomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelAnalyticsHomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelAnalyticsHomeQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      channelId: // value for 'channelId'
 *      channelIdInt: // value for 'channelIdInt'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useChannelAnalyticsHomeQuery(baseOptions: Apollo.QueryHookOptions<ChannelAnalyticsHomeQuery, ChannelAnalyticsHomeQueryVariables> & ({ variables: ChannelAnalyticsHomeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChannelAnalyticsHomeQuery, ChannelAnalyticsHomeQueryVariables>(ChannelAnalyticsHomeDocument, options);
      }
export function useChannelAnalyticsHomeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChannelAnalyticsHomeQuery, ChannelAnalyticsHomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChannelAnalyticsHomeQuery, ChannelAnalyticsHomeQueryVariables>(ChannelAnalyticsHomeDocument, options);
        }
export function useChannelAnalyticsHomeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChannelAnalyticsHomeQuery, ChannelAnalyticsHomeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChannelAnalyticsHomeQuery, ChannelAnalyticsHomeQueryVariables>(ChannelAnalyticsHomeDocument, options);
        }
export type ChannelAnalyticsHomeQueryHookResult = ReturnType<typeof useChannelAnalyticsHomeQuery>;
export type ChannelAnalyticsHomeLazyQueryHookResult = ReturnType<typeof useChannelAnalyticsHomeLazyQuery>;
export type ChannelAnalyticsHomeSuspenseQueryHookResult = ReturnType<typeof useChannelAnalyticsHomeSuspenseQuery>;
export type ChannelAnalyticsHomeQueryResult = Apollo.QueryResult<ChannelAnalyticsHomeQuery, ChannelAnalyticsHomeQueryVariables>;
export const MasterCropsDistrictsDocument = gql`
    query masterCropsDistricts {
  master_crops(order_by: {name: asc}) {
    id
    name
    image_url
  }
  gis_districts(order_by: {state: asc}) {
    id
    state
    district
  }
}
    `;

/**
 * __useMasterCropsDistrictsQuery__
 *
 * To run a query within a React component, call `useMasterCropsDistrictsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMasterCropsDistrictsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMasterCropsDistrictsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMasterCropsDistrictsQuery(baseOptions?: Apollo.QueryHookOptions<MasterCropsDistrictsQuery, MasterCropsDistrictsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MasterCropsDistrictsQuery, MasterCropsDistrictsQueryVariables>(MasterCropsDistrictsDocument, options);
      }
export function useMasterCropsDistrictsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MasterCropsDistrictsQuery, MasterCropsDistrictsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MasterCropsDistrictsQuery, MasterCropsDistrictsQueryVariables>(MasterCropsDistrictsDocument, options);
        }
export function useMasterCropsDistrictsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MasterCropsDistrictsQuery, MasterCropsDistrictsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MasterCropsDistrictsQuery, MasterCropsDistrictsQueryVariables>(MasterCropsDistrictsDocument, options);
        }
export type MasterCropsDistrictsQueryHookResult = ReturnType<typeof useMasterCropsDistrictsQuery>;
export type MasterCropsDistrictsLazyQueryHookResult = ReturnType<typeof useMasterCropsDistrictsLazyQuery>;
export type MasterCropsDistrictsSuspenseQueryHookResult = ReturnType<typeof useMasterCropsDistrictsSuspenseQuery>;
export type MasterCropsDistrictsQueryResult = Apollo.QueryResult<MasterCropsDistrictsQuery, MasterCropsDistrictsQueryVariables>;
export const RequestOtpunusedDocument = gql`
    mutation RequestOTPUNUSED($phoneNumber: String!, $countryCode: String!, $hashKey: String!) {
  requestOtpCommand(
    command: {phoneNumber: $phoneNumber, countryCode: $countryCode, hashKey: $hashKey}
  ) {
    encrypted
    nonce
    exists
    otp
    phoneNumber
  }
}
    `;
export type RequestOtpunusedMutationFn = Apollo.MutationFunction<RequestOtpunusedMutation, RequestOtpunusedMutationVariables>;

/**
 * __useRequestOtpunusedMutation__
 *
 * To run a mutation, you first call `useRequestOtpunusedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestOtpunusedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestOtpunusedMutation, { data, loading, error }] = useRequestOtpunusedMutation({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *      countryCode: // value for 'countryCode'
 *      hashKey: // value for 'hashKey'
 *   },
 * });
 */
export function useRequestOtpunusedMutation(baseOptions?: Apollo.MutationHookOptions<RequestOtpunusedMutation, RequestOtpunusedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestOtpunusedMutation, RequestOtpunusedMutationVariables>(RequestOtpunusedDocument, options);
      }
export type RequestOtpunusedMutationHookResult = ReturnType<typeof useRequestOtpunusedMutation>;
export type RequestOtpunusedMutationResult = Apollo.MutationResult<RequestOtpunusedMutation>;
export type RequestOtpunusedMutationOptions = Apollo.BaseMutationOptions<RequestOtpunusedMutation, RequestOtpunusedMutationVariables>;
export const VerifyOtpDocument = gql`
    mutation VerifyOTP($encrypted: String!, $nonce: String!, $otp: String!, $phone_number: String!, $roleName: String!, $checkPandoforce: Boolean!) {
  verifyOtpCommand(
    command: {encrypted: $encrypted, nonce: $nonce, otp: $otp, phoneNumber: $phone_number, roleName: $roleName, checkPandoforce: $checkPandoforce}
  ) {
    is_verified
    token
    user {
      id
      name
      roles
      phoneNumber
      locale
      last_known_location {
        address
        state_name
      }
      contentLanguages
      account_id
      account {
        id: accountId
        clientAccess
      }
    }
    pfUserJSON
    envName
    hubUrl
    hubToken
    features
  }
}
    `;
export type VerifyOtpMutationFn = Apollo.MutationFunction<VerifyOtpMutation, VerifyOtpMutationVariables>;

/**
 * __useVerifyOtpMutation__
 *
 * To run a mutation, you first call `useVerifyOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyOtpMutation, { data, loading, error }] = useVerifyOtpMutation({
 *   variables: {
 *      encrypted: // value for 'encrypted'
 *      nonce: // value for 'nonce'
 *      otp: // value for 'otp'
 *      phone_number: // value for 'phone_number'
 *      roleName: // value for 'roleName'
 *      checkPandoforce: // value for 'checkPandoforce'
 *   },
 * });
 */
export function useVerifyOtpMutation(baseOptions?: Apollo.MutationHookOptions<VerifyOtpMutation, VerifyOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyOtpMutation, VerifyOtpMutationVariables>(VerifyOtpDocument, options);
      }
export type VerifyOtpMutationHookResult = ReturnType<typeof useVerifyOtpMutation>;
export type VerifyOtpMutationResult = Apollo.MutationResult<VerifyOtpMutation>;
export type VerifyOtpMutationOptions = Apollo.BaseMutationOptions<VerifyOtpMutation, VerifyOtpMutationVariables>;
export const CrmProspectsDocument = gql`
    query crmProspects($cropId: bpchar!, $channelId: bigint!) {
  crm_account_channel_crop_prospects(
    where: {crop_id: {_eq: $cropId}, channel_id: {_eq: $channelId}}
    order_by: {latest_interaction_at: desc}
  ) {
    interaction_type
    reel_comment {
      id
      comment
      created_at
    }
    prospect {
      id
      crop_id
      account_id
      prospects_reel_comment {
        id
        comment
        created_at
      }
      prospects_farmer_user {
        id
        name
        profile_image_url
        locale
        last_known_locations {
          id
          address
        }
      }
      prospects_crop {
        id
        name
        image_url
      }
      source_interaction_type
      status
      source_reel_id
      source_interaction_ts
      created_at
      prospects_reel {
        id
        thumbnail_url
        title
        cloudflare_thumbnail_url
      }
    }
  }
}
    `;

/**
 * __useCrmProspectsQuery__
 *
 * To run a query within a React component, call `useCrmProspectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmProspectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmProspectsQuery({
 *   variables: {
 *      cropId: // value for 'cropId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useCrmProspectsQuery(baseOptions: Apollo.QueryHookOptions<CrmProspectsQuery, CrmProspectsQueryVariables> & ({ variables: CrmProspectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CrmProspectsQuery, CrmProspectsQueryVariables>(CrmProspectsDocument, options);
      }
export function useCrmProspectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrmProspectsQuery, CrmProspectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CrmProspectsQuery, CrmProspectsQueryVariables>(CrmProspectsDocument, options);
        }
export function useCrmProspectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CrmProspectsQuery, CrmProspectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CrmProspectsQuery, CrmProspectsQueryVariables>(CrmProspectsDocument, options);
        }
export type CrmProspectsQueryHookResult = ReturnType<typeof useCrmProspectsQuery>;
export type CrmProspectsLazyQueryHookResult = ReturnType<typeof useCrmProspectsLazyQuery>;
export type CrmProspectsSuspenseQueryHookResult = ReturnType<typeof useCrmProspectsSuspenseQuery>;
export type CrmProspectsQueryResult = Apollo.QueryResult<CrmProspectsQuery, CrmProspectsQueryVariables>;
export const MyLeadsDocument = gql`
    subscription myLeads($channelId: bigint!) {
  crm_account_channel_crop_prospects(
    where: {channel_id: {_eq: $channelId}}
    order_by: {prospect_id: desc}
    distinct_on: [prospect_id]
  ) {
    interaction_type
    prospect_id
    reel_comment {
      id
      comment
      created_at
    }
    prospect {
      id
      crop_id
      account_id
      prospects_reel_comment {
        id
        comment
        created_at
      }
      prospects_farmer_user {
        id
        name
        profile_image_url
        phone_number
        locale
        last_known_locations {
          id
          address
        }
      }
      prospects_crop {
        id
        name
        image_url
      }
      source_interaction_type
      status
      source_reel_id
      source_interaction_ts
      created_at
      prospects_reel {
        id
        thumbnail_url
        title
        cloudflare_thumbnail_url
      }
    }
  }
}
    `;

/**
 * __useMyLeadsSubscription__
 *
 * To run a query within a React component, call `useMyLeadsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMyLeadsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyLeadsSubscription({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useMyLeadsSubscription(baseOptions: Apollo.SubscriptionHookOptions<MyLeadsSubscription, MyLeadsSubscriptionVariables> & ({ variables: MyLeadsSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<MyLeadsSubscription, MyLeadsSubscriptionVariables>(MyLeadsDocument, options);
      }
export type MyLeadsSubscriptionHookResult = ReturnType<typeof useMyLeadsSubscription>;
export type MyLeadsSubscriptionResult = Apollo.SubscriptionResult<MyLeadsSubscription>;
export const MyReelIntractionLeadsDocument = gql`
    query MyReelIntractionLeads($channelId: bigint!, $limit: Int, $offset: Int) {
  crm_account_channel_crop_prospects(
    where: {channel_id: {_eq: $channelId}}
    order_by: {prospect_id: desc}
    distinct_on: [prospect_id]
    limit: $limit
    offset: $offset
  ) {
    interaction_type
    prospect_id
    reel_comment {
      id
      comment
      created_at
    }
    prospect {
      id
      crop_id
      created_at
      account_id
      owner_user_id
      prospects_owner {
        id
        name
        phone_number
        profile_image_url
      }
      farmer_location {
        id
        lat
        lng
        address_components(path: "$.components")
      }
      prospects_reel_comment {
        id
        comment
        created_at
      }
      prospects_farmer_user {
        id
        name
        profile_image_url
        phone_number
        locale
        last_known_locations {
          id
          address
        }
      }
      prospects_crop {
        id
        name
        image_url
      }
      source_interaction_type
      status
      source_reel_id
      source_interaction_ts
      created_at
      prospects_reel {
        id
        thumbnail_url
        title
        cloudflare_thumbnail_url
      }
    }
  }
}
    `;

/**
 * __useMyReelIntractionLeadsQuery__
 *
 * To run a query within a React component, call `useMyReelIntractionLeadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyReelIntractionLeadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyReelIntractionLeadsQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useMyReelIntractionLeadsQuery(baseOptions: Apollo.QueryHookOptions<MyReelIntractionLeadsQuery, MyReelIntractionLeadsQueryVariables> & ({ variables: MyReelIntractionLeadsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyReelIntractionLeadsQuery, MyReelIntractionLeadsQueryVariables>(MyReelIntractionLeadsDocument, options);
      }
export function useMyReelIntractionLeadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyReelIntractionLeadsQuery, MyReelIntractionLeadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyReelIntractionLeadsQuery, MyReelIntractionLeadsQueryVariables>(MyReelIntractionLeadsDocument, options);
        }
export function useMyReelIntractionLeadsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyReelIntractionLeadsQuery, MyReelIntractionLeadsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyReelIntractionLeadsQuery, MyReelIntractionLeadsQueryVariables>(MyReelIntractionLeadsDocument, options);
        }
export type MyReelIntractionLeadsQueryHookResult = ReturnType<typeof useMyReelIntractionLeadsQuery>;
export type MyReelIntractionLeadsLazyQueryHookResult = ReturnType<typeof useMyReelIntractionLeadsLazyQuery>;
export type MyReelIntractionLeadsSuspenseQueryHookResult = ReturnType<typeof useMyReelIntractionLeadsSuspenseQuery>;
export type MyReelIntractionLeadsQueryResult = Apollo.QueryResult<MyReelIntractionLeadsQuery, MyReelIntractionLeadsQueryVariables>;
export const SubTabsReactionsCountsDocument = gql`
    subscription subTabsReactionsCounts($cropId: bpchar!, $channelId: bigint!) {
  crm_account_interaction_type_pending_counts(
    where: {crop_id: {_eq: $cropId}, channel_id: {_eq: $channelId}}
  ) {
    account_id
    channel_id
    crop_id
    interaction_type
    pending_count
  }
}
    `;

/**
 * __useSubTabsReactionsCountsSubscription__
 *
 * To run a query within a React component, call `useSubTabsReactionsCountsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubTabsReactionsCountsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubTabsReactionsCountsSubscription({
 *   variables: {
 *      cropId: // value for 'cropId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useSubTabsReactionsCountsSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubTabsReactionsCountsSubscription, SubTabsReactionsCountsSubscriptionVariables> & ({ variables: SubTabsReactionsCountsSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubTabsReactionsCountsSubscription, SubTabsReactionsCountsSubscriptionVariables>(SubTabsReactionsCountsDocument, options);
      }
export type SubTabsReactionsCountsSubscriptionHookResult = ReturnType<typeof useSubTabsReactionsCountsSubscription>;
export type SubTabsReactionsCountsSubscriptionResult = Apollo.SubscriptionResult<SubTabsReactionsCountsSubscription>;
export const CompanySendsConnectionRequestDocument = gql`
    mutation companySendsConnectionRequest($userId: String!, $farmerPhone: String) {
  companySendsConnectionRequest(
    request: {userId: $userId, farmerPhone: $farmerPhone, prospectId: ""}
  ) {
    id
    threadId
    status
  }
}
    `;
export type CompanySendsConnectionRequestMutationFn = Apollo.MutationFunction<CompanySendsConnectionRequestMutation, CompanySendsConnectionRequestMutationVariables>;

/**
 * __useCompanySendsConnectionRequestMutation__
 *
 * To run a mutation, you first call `useCompanySendsConnectionRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanySendsConnectionRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companySendsConnectionRequestMutation, { data, loading, error }] = useCompanySendsConnectionRequestMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      farmerPhone: // value for 'farmerPhone'
 *   },
 * });
 */
export function useCompanySendsConnectionRequestMutation(baseOptions?: Apollo.MutationHookOptions<CompanySendsConnectionRequestMutation, CompanySendsConnectionRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanySendsConnectionRequestMutation, CompanySendsConnectionRequestMutationVariables>(CompanySendsConnectionRequestDocument, options);
      }
export type CompanySendsConnectionRequestMutationHookResult = ReturnType<typeof useCompanySendsConnectionRequestMutation>;
export type CompanySendsConnectionRequestMutationResult = Apollo.MutationResult<CompanySendsConnectionRequestMutation>;
export type CompanySendsConnectionRequestMutationOptions = Apollo.BaseMutationOptions<CompanySendsConnectionRequestMutation, CompanySendsConnectionRequestMutationVariables>;
export const ConnectionMessagesDocument = gql`
    subscription connectionMessages($prospectId: bpchar!, $accountId: bpchar!) {
  prospect_messages(
    where: {prospect_id: {_eq: $prospectId}, deleted_at: {_is_null: true}, account_id: {_eq: $accountId}}
    order_by: {created_at: asc}
  ) {
    id
    prospect_id
    from_user_id
    created_at
    to_user_id
    message
    channel: prospect_channel {
      id
      name
      logo_image_url
    }
  }
}
    `;

/**
 * __useConnectionMessagesSubscription__
 *
 * To run a query within a React component, call `useConnectionMessagesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useConnectionMessagesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectionMessagesSubscription({
 *   variables: {
 *      prospectId: // value for 'prospectId'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useConnectionMessagesSubscription(baseOptions: Apollo.SubscriptionHookOptions<ConnectionMessagesSubscription, ConnectionMessagesSubscriptionVariables> & ({ variables: ConnectionMessagesSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ConnectionMessagesSubscription, ConnectionMessagesSubscriptionVariables>(ConnectionMessagesDocument, options);
      }
export type ConnectionMessagesSubscriptionHookResult = ReturnType<typeof useConnectionMessagesSubscription>;
export type ConnectionMessagesSubscriptionResult = Apollo.SubscriptionResult<ConnectionMessagesSubscription>;
export const AccountUserMessagesOnProspectDocument = gql`
    mutation accountUserMessagesOnProspect($userId: String!, $prospectId: String!, $message: String!, $channelId: Int!) {
  accountUserMessagesOnProspect(
    request: {userId: $userId, prospectId: $prospectId, message: $message, channelId: $channelId}
  ) {
    data {
      status
    }
    error
  }
}
    `;
export type AccountUserMessagesOnProspectMutationFn = Apollo.MutationFunction<AccountUserMessagesOnProspectMutation, AccountUserMessagesOnProspectMutationVariables>;

/**
 * __useAccountUserMessagesOnProspectMutation__
 *
 * To run a mutation, you first call `useAccountUserMessagesOnProspectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUserMessagesOnProspectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUserMessagesOnProspectMutation, { data, loading, error }] = useAccountUserMessagesOnProspectMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      prospectId: // value for 'prospectId'
 *      message: // value for 'message'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useAccountUserMessagesOnProspectMutation(baseOptions?: Apollo.MutationHookOptions<AccountUserMessagesOnProspectMutation, AccountUserMessagesOnProspectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountUserMessagesOnProspectMutation, AccountUserMessagesOnProspectMutationVariables>(AccountUserMessagesOnProspectDocument, options);
      }
export type AccountUserMessagesOnProspectMutationHookResult = ReturnType<typeof useAccountUserMessagesOnProspectMutation>;
export type AccountUserMessagesOnProspectMutationResult = Apollo.MutationResult<AccountUserMessagesOnProspectMutation>;
export type AccountUserMessagesOnProspectMutationOptions = Apollo.BaseMutationOptions<AccountUserMessagesOnProspectMutation, AccountUserMessagesOnProspectMutationVariables>;
export const CompanyConnectionsDocument = gql`
    subscription CompanyConnections($accountId: bpchar!) {
  ActiveUsers: prospects(
    where: {prospects_prospect_messages: {id: {_is_null: false}}, account_id: {_eq: $accountId}, status: {_in: ["active"]}, deleted_at: {_is_null: true}}
  ) {
    id
    status
    source_interaction_type
    user: prospects_farmer_user {
      id
      name
      phone_number
      profile_image_url
      locale
      last_known_locations {
        id
        address
      }
    }
    prospects_crop {
      id
      name
      image_url
    }
    messages: prospects_prospect_messages(order_by: {id: desc}, limit: 1) {
      id
      message
      created_at
    }
  }
}
    `;

/**
 * __useCompanyConnectionsSubscription__
 *
 * To run a query within a React component, call `useCompanyConnectionsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCompanyConnectionsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyConnectionsSubscription({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useCompanyConnectionsSubscription(baseOptions: Apollo.SubscriptionHookOptions<CompanyConnectionsSubscription, CompanyConnectionsSubscriptionVariables> & ({ variables: CompanyConnectionsSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CompanyConnectionsSubscription, CompanyConnectionsSubscriptionVariables>(CompanyConnectionsDocument, options);
      }
export type CompanyConnectionsSubscriptionHookResult = ReturnType<typeof useCompanyConnectionsSubscription>;
export type CompanyConnectionsSubscriptionResult = Apollo.SubscriptionResult<CompanyConnectionsSubscription>;
export const MyinteractionsDocument = gql`
    query myinteractions($userId: bpchar!, $channelID: bigint!) {
  users_by_pk(id: $userId) {
    id
    name
    phone_number
    profile_image_url
    content_languages
    last_known_locations {
      id
      address
    }
    locale
    follows_channels_aggregate {
      aggregate {
        count
      }
    }
    crop_users {
      id
      master_crop {
        id
        name
        image_url
      }
    }
  }
  reel_interactions(
    where: {deleted_at: {_is_null: true}, interaction_type: {_neq: "view"}, user_id: {_eq: $userId}, reel_interactions_reel: {channel_id: {_eq: $channelID}}}
  ) {
    id
    interaction_type
    created_at
    reel: reel_interactions_reel {
      id
      title
      reactions_count
      shares
      views
      cloudflare_playback_url
      cloudflare_thumbnail_url
      thumbnail_url
      channel: reels_channel {
        id
        name
        logo_image_url
      }
    }
  }
  reel_comments(where: {deleted_at: {_is_null: true}, user_id: {_eq: $userId}}) {
    id
    comment
    created_at
    reel {
      id
      title
      reactions_count
      shares
      views
      cloudflare_playback_url
      cloudflare_thumbnail_url
      thumbnail_url
      channel: reels_channel {
        id
        name
        logo_image_url
      }
    }
  }
}
    `;

/**
 * __useMyinteractionsQuery__
 *
 * To run a query within a React component, call `useMyinteractionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyinteractionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyinteractionsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      channelID: // value for 'channelID'
 *   },
 * });
 */
export function useMyinteractionsQuery(baseOptions: Apollo.QueryHookOptions<MyinteractionsQuery, MyinteractionsQueryVariables> & ({ variables: MyinteractionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyinteractionsQuery, MyinteractionsQueryVariables>(MyinteractionsDocument, options);
      }
export function useMyinteractionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyinteractionsQuery, MyinteractionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyinteractionsQuery, MyinteractionsQueryVariables>(MyinteractionsDocument, options);
        }
export function useMyinteractionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyinteractionsQuery, MyinteractionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyinteractionsQuery, MyinteractionsQueryVariables>(MyinteractionsDocument, options);
        }
export type MyinteractionsQueryHookResult = ReturnType<typeof useMyinteractionsQuery>;
export type MyinteractionsLazyQueryHookResult = ReturnType<typeof useMyinteractionsLazyQuery>;
export type MyinteractionsSuspenseQueryHookResult = ReturnType<typeof useMyinteractionsSuspenseQuery>;
export type MyinteractionsQueryResult = Apollo.QueryResult<MyinteractionsQuery, MyinteractionsQueryVariables>;
export const FarmersCrmDocument = gql`
    query farmersCrm {
  farmer_fields_latest(
    where: {account_location: {state_name: {_eq: "UTTAR PRADESH"}}}
  ) {
    id
    account_id
    farmer {
      id
      name
      phone_number
      created_at
    }
    account_location {
      district_name
      location
      state_name
      taluk_name
      village_name
    }
  }
}
    `;

/**
 * __useFarmersCrmQuery__
 *
 * To run a query within a React component, call `useFarmersCrmQuery` and pass it any options that fit your needs.
 * When your component renders, `useFarmersCrmQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFarmersCrmQuery({
 *   variables: {
 *   },
 * });
 */
export function useFarmersCrmQuery(baseOptions?: Apollo.QueryHookOptions<FarmersCrmQuery, FarmersCrmQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FarmersCrmQuery, FarmersCrmQueryVariables>(FarmersCrmDocument, options);
      }
export function useFarmersCrmLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FarmersCrmQuery, FarmersCrmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FarmersCrmQuery, FarmersCrmQueryVariables>(FarmersCrmDocument, options);
        }
export function useFarmersCrmSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FarmersCrmQuery, FarmersCrmQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FarmersCrmQuery, FarmersCrmQueryVariables>(FarmersCrmDocument, options);
        }
export type FarmersCrmQueryHookResult = ReturnType<typeof useFarmersCrmQuery>;
export type FarmersCrmLazyQueryHookResult = ReturnType<typeof useFarmersCrmLazyQuery>;
export type FarmersCrmSuspenseQueryHookResult = ReturnType<typeof useFarmersCrmSuspenseQuery>;
export type FarmersCrmQueryResult = Apollo.QueryResult<FarmersCrmQuery, FarmersCrmQueryVariables>;
export const ContactsDocument = gql`
    query Contacts {
  farmer_master {
    id
    created_at
    name
    phone_number
    account_location {
      id
      account_id
      state_name
      district_name
      taluk_name
      village_name
    }
  }
}
    `;

/**
 * __useContactsQuery__
 *
 * To run a query within a React component, call `useContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsQuery({
 *   variables: {
 *   },
 * });
 */
export function useContactsQuery(baseOptions?: Apollo.QueryHookOptions<ContactsQuery, ContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactsQuery, ContactsQueryVariables>(ContactsDocument, options);
      }
export function useContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactsQuery, ContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactsQuery, ContactsQueryVariables>(ContactsDocument, options);
        }
export function useContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactsQuery, ContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactsQuery, ContactsQueryVariables>(ContactsDocument, options);
        }
export type ContactsQueryHookResult = ReturnType<typeof useContactsQuery>;
export type ContactsLazyQueryHookResult = ReturnType<typeof useContactsLazyQuery>;
export type ContactsSuspenseQueryHookResult = ReturnType<typeof useContactsSuspenseQuery>;
export type ContactsQueryResult = Apollo.QueryResult<ContactsQuery, ContactsQueryVariables>;
export const GigFiltersDocument = gql`
    query gigFilters {
  gis_states(where: {state_code: {_neq: 0}}) {
    id
    state
    state_code
  }
}
    `;

/**
 * __useGigFiltersQuery__
 *
 * To run a query within a React component, call `useGigFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGigFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGigFiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGigFiltersQuery(baseOptions?: Apollo.QueryHookOptions<GigFiltersQuery, GigFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GigFiltersQuery, GigFiltersQueryVariables>(GigFiltersDocument, options);
      }
export function useGigFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GigFiltersQuery, GigFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GigFiltersQuery, GigFiltersQueryVariables>(GigFiltersDocument, options);
        }
export function useGigFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GigFiltersQuery, GigFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GigFiltersQuery, GigFiltersQueryVariables>(GigFiltersDocument, options);
        }
export type GigFiltersQueryHookResult = ReturnType<typeof useGigFiltersQuery>;
export type GigFiltersLazyQueryHookResult = ReturnType<typeof useGigFiltersLazyQuery>;
export type GigFiltersSuspenseQueryHookResult = ReturnType<typeof useGigFiltersSuspenseQuery>;
export type GigFiltersQueryResult = Apollo.QueryResult<GigFiltersQuery, GigFiltersQueryVariables>;
export const CreateWorkOrderDocument = gql`
    mutation createWorkOrder($userId: String!, $gigId: String, $variantId: String, $gigRequests: [String], $productId: Int, $productName: String, $budgetMax: Int, $budgetMin: Int, $cropId: String, $stateName: String, $expectedLaunch: DateTime, $noOfInfluencers: Int, $isOpenForInfluencers: Boolean, $title: String, $language: String, $variantType: String) {
  createWorkOrder(
    request: {userId: $userId, gigId: $gigId, variantId: $variantId, gigRequests: $gigRequests, product_id: $productId, product_name: $productName, budget_max: $budgetMax, budget_min: $budgetMin, crop_id: $cropId, stateName: $stateName, expected_launch: $expectedLaunch, no_of_influencers: $noOfInfluencers, isOpenForInfluencers: $isOpenForInfluencers, title: $title, language: $language, variantType: $variantType}
  ) {
    workOrderId
  }
}
    `;
export type CreateWorkOrderMutationFn = Apollo.MutationFunction<CreateWorkOrderMutation, CreateWorkOrderMutationVariables>;

/**
 * __useCreateWorkOrderMutation__
 *
 * To run a mutation, you first call `useCreateWorkOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkOrderMutation, { data, loading, error }] = useCreateWorkOrderMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      gigId: // value for 'gigId'
 *      variantId: // value for 'variantId'
 *      gigRequests: // value for 'gigRequests'
 *      productId: // value for 'productId'
 *      productName: // value for 'productName'
 *      budgetMax: // value for 'budgetMax'
 *      budgetMin: // value for 'budgetMin'
 *      cropId: // value for 'cropId'
 *      stateName: // value for 'stateName'
 *      expectedLaunch: // value for 'expectedLaunch'
 *      noOfInfluencers: // value for 'noOfInfluencers'
 *      isOpenForInfluencers: // value for 'isOpenForInfluencers'
 *      title: // value for 'title'
 *      language: // value for 'language'
 *      variantType: // value for 'variantType'
 *   },
 * });
 */
export function useCreateWorkOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkOrderMutation, CreateWorkOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkOrderMutation, CreateWorkOrderMutationVariables>(CreateWorkOrderDocument, options);
      }
export type CreateWorkOrderMutationHookResult = ReturnType<typeof useCreateWorkOrderMutation>;
export type CreateWorkOrderMutationResult = Apollo.MutationResult<CreateWorkOrderMutation>;
export type CreateWorkOrderMutationOptions = Apollo.BaseMutationOptions<CreateWorkOrderMutation, CreateWorkOrderMutationVariables>;
export const GetChannelReelsDocument = gql`
    query getChannelReels($channelId: bigint!) {
  reels(
    where: {channel_id: {_eq: $channelId}}
    order_by: {created_at: desc}
    limit: 6
  ) {
    id
    title
    thumbnail_url
    cloudflare_playback_url
    cloudflare_thumbnail_url
    views
    shares
    reactions_count
    s3_path
  }
}
    `;

/**
 * __useGetChannelReelsQuery__
 *
 * To run a query within a React component, call `useGetChannelReelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelReelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelReelsQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetChannelReelsQuery(baseOptions: Apollo.QueryHookOptions<GetChannelReelsQuery, GetChannelReelsQueryVariables> & ({ variables: GetChannelReelsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelReelsQuery, GetChannelReelsQueryVariables>(GetChannelReelsDocument, options);
      }
export function useGetChannelReelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelReelsQuery, GetChannelReelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelReelsQuery, GetChannelReelsQueryVariables>(GetChannelReelsDocument, options);
        }
export function useGetChannelReelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChannelReelsQuery, GetChannelReelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChannelReelsQuery, GetChannelReelsQueryVariables>(GetChannelReelsDocument, options);
        }
export type GetChannelReelsQueryHookResult = ReturnType<typeof useGetChannelReelsQuery>;
export type GetChannelReelsLazyQueryHookResult = ReturnType<typeof useGetChannelReelsLazyQuery>;
export type GetChannelReelsSuspenseQueryHookResult = ReturnType<typeof useGetChannelReelsSuspenseQuery>;
export type GetChannelReelsQueryResult = Apollo.QueryResult<GetChannelReelsQuery, GetChannelReelsQueryVariables>;
export const AllGigsDocument = gql`
    query AllGigs($gigType: String!) {
  gigs(
    where: {gig_type: {_eq: $gigType}, approval_status: {_eq: "approved"}}
    order_by: {created_at: desc}
  ) {
    id
    gig_type
    districts
    experience_since
    expertises
    segments
    metrics
    travel_range
    avg_rating
    is_verified
    title
    description
    created_at
    rating
    languages
    states
    location
    avg_work_order_duration_days
    completed_work_orders
    review_count
    user {
      id
      name
      profile_image_url
      phone_number
      email
    }
    district {
      id
      state
      district
    }
    approval_status
    variants {
      id
      cost
      qty
      duration_days
      variant_type
    }
    channel {
      id
      name
      description
      logo_image_url
      content_languages
      channel_links {
        id
        link_url
        follower_count
        impressions_count
        engagement_rate
        link_type
      }
      channel_links_aggregate {
        aggregate {
          sum {
            follower_count
            impressions_count
          }
        }
      }
    }
    town_name
    village_name
  }
}
    `;

/**
 * __useAllGigsQuery__
 *
 * To run a query within a React component, call `useAllGigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllGigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllGigsQuery({
 *   variables: {
 *      gigType: // value for 'gigType'
 *   },
 * });
 */
export function useAllGigsQuery(baseOptions: Apollo.QueryHookOptions<AllGigsQuery, AllGigsQueryVariables> & ({ variables: AllGigsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllGigsQuery, AllGigsQueryVariables>(AllGigsDocument, options);
      }
export function useAllGigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllGigsQuery, AllGigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllGigsQuery, AllGigsQueryVariables>(AllGigsDocument, options);
        }
export function useAllGigsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllGigsQuery, AllGigsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllGigsQuery, AllGigsQueryVariables>(AllGigsDocument, options);
        }
export type AllGigsQueryHookResult = ReturnType<typeof useAllGigsQuery>;
export type AllGigsLazyQueryHookResult = ReturnType<typeof useAllGigsLazyQuery>;
export type AllGigsSuspenseQueryHookResult = ReturnType<typeof useAllGigsSuspenseQuery>;
export type AllGigsQueryResult = Apollo.QueryResult<AllGigsQuery, AllGigsQueryVariables>;
export const AllServiceCallsDocument = gql`
    query AllServiceCalls($accountId: bpchar!, $date: timestamptz, $offset: Int, $limit: Int) {
  service_requests(
    where: {_or: [{created_at: {_gt: $date}}, {field_partner_responses: {account_id: {_eq: $accountId}, response_action: {_eq: "accept"}}}], deleted_at: {_is_null: true}}
    order_by: {id: desc}
    limit: $limit
    offset: $offset
  ) {
    id
    created_at
    is_request_closed
    address
    farmer: user {
      id
      locale
      name
      phone_number
      follower_count
      profile_image_url
      crop_users {
        id
        master_crop {
          id
          name
        }
      }
    }
    crop: master_crop {
      id
      name
      image_url
    }
    assets
    date_of_sowing
    lat
    lng
    address
    field_partner_responses(where: {account_id: {_eq: $accountId}}) {
      id
      field_partner_user_id
      userByFieldPartnerUserId {
        id
        name
        phone_number
        profile_image_url
      }
      response_action
      created_at
      field_partner_feedback
      field_partner_rating
      field_partner_rated_at
      closed_at
      closed_by
      farmer_feedback
      farmer_rating
      farmer_rated_at
    }
    last_known_locations {
      lat
      lng
      address_components(path: "$.components")
    }
  }
}
    `;

/**
 * __useAllServiceCallsQuery__
 *
 * To run a query within a React component, call `useAllServiceCallsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllServiceCallsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllServiceCallsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      date: // value for 'date'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAllServiceCallsQuery(baseOptions: Apollo.QueryHookOptions<AllServiceCallsQuery, AllServiceCallsQueryVariables> & ({ variables: AllServiceCallsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllServiceCallsQuery, AllServiceCallsQueryVariables>(AllServiceCallsDocument, options);
      }
export function useAllServiceCallsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllServiceCallsQuery, AllServiceCallsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllServiceCallsQuery, AllServiceCallsQueryVariables>(AllServiceCallsDocument, options);
        }
export function useAllServiceCallsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllServiceCallsQuery, AllServiceCallsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllServiceCallsQuery, AllServiceCallsQueryVariables>(AllServiceCallsDocument, options);
        }
export type AllServiceCallsQueryHookResult = ReturnType<typeof useAllServiceCallsQuery>;
export type AllServiceCallsLazyQueryHookResult = ReturnType<typeof useAllServiceCallsLazyQuery>;
export type AllServiceCallsSuspenseQueryHookResult = ReturnType<typeof useAllServiceCallsSuspenseQuery>;
export type AllServiceCallsQueryResult = Apollo.QueryResult<AllServiceCallsQuery, AllServiceCallsQueryVariables>;
export const ProspectServiceRequestsDocument = gql`
    query prospectServiceRequests($accountId: bpchar!, $date: timestamptz, $offset: Int, $limit: Int, $farmerUserId: bpchar) {
  service_requests(
    where: {_or: [{created_at: {_gt: $date}}, {field_partner_responses: {account_id: {_eq: $accountId}, response_action: {_eq: "accept"}}}], farmer_user_id: {_eq: $farmerUserId}}
    order_by: {id: desc}
    limit: $limit
    offset: $offset
  ) {
    id
    created_at
    is_request_closed
    address
    farmer: user {
      id
      locale
      name
      phone_number
      follower_count
      profile_image_url
      crop_users {
        id
        master_crop {
          id
          name
        }
      }
    }
    crop: master_crop {
      id
      name
      image_url
    }
    assets
    date_of_sowing
    lat
    lng
    address
    field_partner_responses(where: {account_id: {_eq: $accountId}}) {
      id
      field_partner_user_id
      userByFieldPartnerUserId {
        id
        name
        phone_number
        profile_image_url
      }
      response_action
      created_at
      field_partner_rating
      field_partner_rated_at
    }
    last_known_locations {
      lat
      lng
      address_components(path: "$.components")
    }
  }
}
    `;

/**
 * __useProspectServiceRequestsQuery__
 *
 * To run a query within a React component, call `useProspectServiceRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProspectServiceRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProspectServiceRequestsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      date: // value for 'date'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      farmerUserId: // value for 'farmerUserId'
 *   },
 * });
 */
export function useProspectServiceRequestsQuery(baseOptions: Apollo.QueryHookOptions<ProspectServiceRequestsQuery, ProspectServiceRequestsQueryVariables> & ({ variables: ProspectServiceRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProspectServiceRequestsQuery, ProspectServiceRequestsQueryVariables>(ProspectServiceRequestsDocument, options);
      }
export function useProspectServiceRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProspectServiceRequestsQuery, ProspectServiceRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProspectServiceRequestsQuery, ProspectServiceRequestsQueryVariables>(ProspectServiceRequestsDocument, options);
        }
export function useProspectServiceRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProspectServiceRequestsQuery, ProspectServiceRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProspectServiceRequestsQuery, ProspectServiceRequestsQueryVariables>(ProspectServiceRequestsDocument, options);
        }
export type ProspectServiceRequestsQueryHookResult = ReturnType<typeof useProspectServiceRequestsQuery>;
export type ProspectServiceRequestsLazyQueryHookResult = ReturnType<typeof useProspectServiceRequestsLazyQuery>;
export type ProspectServiceRequestsSuspenseQueryHookResult = ReturnType<typeof useProspectServiceRequestsSuspenseQuery>;
export type ProspectServiceRequestsQueryResult = Apollo.QueryResult<ProspectServiceRequestsQuery, ProspectServiceRequestsQueryVariables>;
export const ServiceRequestDetailsDocument = gql`
    query serviceRequestDetails($serviceRequestId: bpchar, $accountId: bpchar) {
  service_requests(where: {id: {_eq: $serviceRequestId}}) {
    id
    created_at
    is_request_closed
    address
    farmer: user {
      id
      locale
      name
      phone_number
      profile_image_url
      crop_users {
        id
        master_crop {
          id
          name
        }
      }
    }
    crop: master_crop {
      id
      name
      image_url
    }
    assets
    date_of_sowing
    lat
    lng
    address
    field_partner_responses(where: {account_id: {_eq: $accountId}}) {
      id
      field_partner_user_id
      userByFieldPartnerUserId {
        id
        name
        phone_number
        profile_image_url
      }
      response_action
      created_at
      field_partner_feedback
      field_partner_rating
      field_partner_rated_at
      closed_at
      closed_by
      farmer_feedback
      farmer_rating
      farmer_rated_at
    }
    last_known_locations {
      lat
      lng
      address_components(path: "$.components")
    }
  }
}
    `;

/**
 * __useServiceRequestDetailsQuery__
 *
 * To run a query within a React component, call `useServiceRequestDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceRequestDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceRequestDetailsQuery({
 *   variables: {
 *      serviceRequestId: // value for 'serviceRequestId'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useServiceRequestDetailsQuery(baseOptions?: Apollo.QueryHookOptions<ServiceRequestDetailsQuery, ServiceRequestDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceRequestDetailsQuery, ServiceRequestDetailsQueryVariables>(ServiceRequestDetailsDocument, options);
      }
export function useServiceRequestDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceRequestDetailsQuery, ServiceRequestDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceRequestDetailsQuery, ServiceRequestDetailsQueryVariables>(ServiceRequestDetailsDocument, options);
        }
export function useServiceRequestDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ServiceRequestDetailsQuery, ServiceRequestDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ServiceRequestDetailsQuery, ServiceRequestDetailsQueryVariables>(ServiceRequestDetailsDocument, options);
        }
export type ServiceRequestDetailsQueryHookResult = ReturnType<typeof useServiceRequestDetailsQuery>;
export type ServiceRequestDetailsLazyQueryHookResult = ReturnType<typeof useServiceRequestDetailsLazyQuery>;
export type ServiceRequestDetailsSuspenseQueryHookResult = ReturnType<typeof useServiceRequestDetailsSuspenseQuery>;
export type ServiceRequestDetailsQueryResult = Apollo.QueryResult<ServiceRequestDetailsQuery, ServiceRequestDetailsQueryVariables>;
export const IndividualreelanalyticsDocument = gql`
    query individualreelanalytics($reelId: bigint!) {
  reels_by_pk(id: $reelId) {
    id
    channel: reels_channel {
      id
      name
      logo_image_url
    }
    cloudflare_thumbnail_url
    cloudflare_playback_url
    cloudflare_id
    thumbnail_url
    title
    created_at
    description
    reactions_count
    shares
    views
    likes
    reels_reel_stats {
      view_count
      playback_count
      avg_watch_time_ms
    }
    reel_comments_aggregate(where: {deleted_at: {_is_null: true}}) {
      aggregate {
        count
      }
    }
    reel_comments(
      where: {deleted_at: {_is_null: true}}
      order_by: {created_at: desc}
    ) {
      id
      comment
      user_id
      created_at
      parent_id
      user {
        id
        name
        profile_image_url
      }
    }
  }
}
    `;

/**
 * __useIndividualreelanalyticsQuery__
 *
 * To run a query within a React component, call `useIndividualreelanalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndividualreelanalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndividualreelanalyticsQuery({
 *   variables: {
 *      reelId: // value for 'reelId'
 *   },
 * });
 */
export function useIndividualreelanalyticsQuery(baseOptions: Apollo.QueryHookOptions<IndividualreelanalyticsQuery, IndividualreelanalyticsQueryVariables> & ({ variables: IndividualreelanalyticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IndividualreelanalyticsQuery, IndividualreelanalyticsQueryVariables>(IndividualreelanalyticsDocument, options);
      }
export function useIndividualreelanalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IndividualreelanalyticsQuery, IndividualreelanalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IndividualreelanalyticsQuery, IndividualreelanalyticsQueryVariables>(IndividualreelanalyticsDocument, options);
        }
export function useIndividualreelanalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IndividualreelanalyticsQuery, IndividualreelanalyticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IndividualreelanalyticsQuery, IndividualreelanalyticsQueryVariables>(IndividualreelanalyticsDocument, options);
        }
export type IndividualreelanalyticsQueryHookResult = ReturnType<typeof useIndividualreelanalyticsQuery>;
export type IndividualreelanalyticsLazyQueryHookResult = ReturnType<typeof useIndividualreelanalyticsLazyQuery>;
export type IndividualreelanalyticsSuspenseQueryHookResult = ReturnType<typeof useIndividualreelanalyticsSuspenseQuery>;
export type IndividualreelanalyticsQueryResult = Apollo.QueryResult<IndividualreelanalyticsQuery, IndividualreelanalyticsQueryVariables>;
export const LeadDetailsDocument = gql`
    query LeadDetails($channelId: bigint!, $prospectID: bpchar) {
  crm_account_channel_crop_prospects(
    where: {channel_id: {_eq: $channelId}, prospect_id: {_eq: $prospectID}}
  ) {
    interaction_type
    prospect_id
    reel_comment {
      id
      comment
      created_at
    }
    prospect {
      id
      crop_id
      created_at
      account_id
      owner_user_id
      prospects_owner {
        id
        name
        phone_number
        profile_image_url
      }
      farmer_location {
        id
        lat
        lng
        address_components(path: "$.components")
      }
      prospects_reel_comment {
        id
        comment
        created_at
      }
      prospects_farmer_user {
        id
        name
        follower_count
        profile_image_url
        phone_number
        locale
        last_known_locations {
          id
          address
        }
      }
      prospects_crop {
        id
        name
        image_url
      }
      source_interaction_type
      status
      source_reel_id
      source_interaction_ts
      created_at
      prospects_reel {
        id
        thumbnail_url
        title
        cloudflare_thumbnail_url
      }
    }
  }
}
    `;

/**
 * __useLeadDetailsQuery__
 *
 * To run a query within a React component, call `useLeadDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadDetailsQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      prospectID: // value for 'prospectID'
 *   },
 * });
 */
export function useLeadDetailsQuery(baseOptions: Apollo.QueryHookOptions<LeadDetailsQuery, LeadDetailsQueryVariables> & ({ variables: LeadDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeadDetailsQuery, LeadDetailsQueryVariables>(LeadDetailsDocument, options);
      }
export function useLeadDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeadDetailsQuery, LeadDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeadDetailsQuery, LeadDetailsQueryVariables>(LeadDetailsDocument, options);
        }
export function useLeadDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LeadDetailsQuery, LeadDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LeadDetailsQuery, LeadDetailsQueryVariables>(LeadDetailsDocument, options);
        }
export type LeadDetailsQueryHookResult = ReturnType<typeof useLeadDetailsQuery>;
export type LeadDetailsLazyQueryHookResult = ReturnType<typeof useLeadDetailsLazyQuery>;
export type LeadDetailsSuspenseQueryHookResult = ReturnType<typeof useLeadDetailsSuspenseQuery>;
export type LeadDetailsQueryResult = Apollo.QueryResult<LeadDetailsQuery, LeadDetailsQueryVariables>;
export const ApproveReelDocument = gql`
    mutation approveReel($foReelStagingId: Int!) {
  managerApprovesFoReel(foReelStagingId: $foReelStagingId) {
    data {
      status
    }
    error
  }
}
    `;
export type ApproveReelMutationFn = Apollo.MutationFunction<ApproveReelMutation, ApproveReelMutationVariables>;

/**
 * __useApproveReelMutation__
 *
 * To run a mutation, you first call `useApproveReelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveReelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveReelMutation, { data, loading, error }] = useApproveReelMutation({
 *   variables: {
 *      foReelStagingId: // value for 'foReelStagingId'
 *   },
 * });
 */
export function useApproveReelMutation(baseOptions?: Apollo.MutationHookOptions<ApproveReelMutation, ApproveReelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveReelMutation, ApproveReelMutationVariables>(ApproveReelDocument, options);
      }
export type ApproveReelMutationHookResult = ReturnType<typeof useApproveReelMutation>;
export type ApproveReelMutationResult = Apollo.MutationResult<ApproveReelMutation>;
export type ApproveReelMutationOptions = Apollo.BaseMutationOptions<ApproveReelMutation, ApproveReelMutationVariables>;
export const RejectsDocument = gql`
    mutation rejects($foReelStagingId: Int!) {
  managerRejectsFoReel(foReelStagingId: $foReelStagingId) {
    data {
      status
    }
    error
  }
}
    `;
export type RejectsMutationFn = Apollo.MutationFunction<RejectsMutation, RejectsMutationVariables>;

/**
 * __useRejectsMutation__
 *
 * To run a mutation, you first call `useRejectsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectsMutation, { data, loading, error }] = useRejectsMutation({
 *   variables: {
 *      foReelStagingId: // value for 'foReelStagingId'
 *   },
 * });
 */
export function useRejectsMutation(baseOptions?: Apollo.MutationHookOptions<RejectsMutation, RejectsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectsMutation, RejectsMutationVariables>(RejectsDocument, options);
      }
export type RejectsMutationHookResult = ReturnType<typeof useRejectsMutation>;
export type RejectsMutationResult = Apollo.MutationResult<RejectsMutation>;
export type RejectsMutationOptions = Apollo.BaseMutationOptions<RejectsMutation, RejectsMutationVariables>;
export const RegisterFreeTrialDocument = gql`
    mutation registerFreeTrial($channelName: String!, $companyName: String!, $email: String!, $phoneNumber: String!, $spocDesignation: String!, $spocName: String!, $password: String!) {
  registerFreeTrial(
    request: {channelName: $channelName, companyName: $companyName, email: $email, phoneNumber: $phoneNumber, spocDesignation: $spocDesignation, spocName: $spocName, password: $password}
  ) {
    is_verified
    pfUserJSON
    token
    user {
      account_id
      company_id
      email
      id
      name
      phoneNumber
      profile_image_url
      roles
    }
    features
  }
}
    `;
export type RegisterFreeTrialMutationFn = Apollo.MutationFunction<RegisterFreeTrialMutation, RegisterFreeTrialMutationVariables>;

/**
 * __useRegisterFreeTrialMutation__
 *
 * To run a mutation, you first call `useRegisterFreeTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterFreeTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerFreeTrialMutation, { data, loading, error }] = useRegisterFreeTrialMutation({
 *   variables: {
 *      channelName: // value for 'channelName'
 *      companyName: // value for 'companyName'
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *      spocDesignation: // value for 'spocDesignation'
 *      spocName: // value for 'spocName'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useRegisterFreeTrialMutation(baseOptions?: Apollo.MutationHookOptions<RegisterFreeTrialMutation, RegisterFreeTrialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterFreeTrialMutation, RegisterFreeTrialMutationVariables>(RegisterFreeTrialDocument, options);
      }
export type RegisterFreeTrialMutationHookResult = ReturnType<typeof useRegisterFreeTrialMutation>;
export type RegisterFreeTrialMutationResult = Apollo.MutationResult<RegisterFreeTrialMutation>;
export type RegisterFreeTrialMutationOptions = Apollo.BaseMutationOptions<RegisterFreeTrialMutation, RegisterFreeTrialMutationVariables>;